import React from "react";

export const AD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs54" />
    <path
       fill="#41479b"
       d="M 170.667,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#ffe15a"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.448 H 341.333 V 0 H 503.172 C 508.047,0 512,3.953 512,8.828 V 326.62 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <path
       fill="#dcbe82"
       d="m 316.022,196.415 c 0,-2.562 -2.077,-4.64 -4.64,-4.64 -0.556,0 -1.082,0.114 -1.577,0.294 -2.296,-2.042 -6.457,-7.109 -2.282,-14.264 0.564,0.439 1.265,0.711 2.035,0.711 1.841,0 3.332,-1.492 3.332,-3.332 0,-1.454 -0.937,-2.678 -2.236,-3.133 3.431,-1.75 8.324,-5.465 8.072,-12.412 -0.359,-9.852 -8.429,-15.29 -13.38,-13.116 0.018,-0.138 0.042,-0.274 0.042,-0.416 0,-1.815 -1.471,-3.286 -3.286,-3.286 -1.116,0 -2.098,0.559 -2.691,1.409 -0.202,-0.985 -0.178,-2.814 2.112,-4.791 4.253,-3.673 9.086,-12.469 0.29,-18.655 -4.871,-3.425 -14.181,-5.066 -17.301,-0.386 -1.353,2.029 -0.268,4.945 1.277,5.6 -2.489,1.388 -7.211,3.471 -10.942,1.843 -5.316,-2.319 -2.246,-6.926 -1.063,-8.989 2.078,-3.625 0.774,-9.569 -6.186,-9.569 -4.64,0 -6.959,4.64 -11.598,4.64 -4.639,0 -6.959,-4.64 -11.598,-4.64 -6.959,0 -8.264,5.944 -6.186,9.569 1.183,2.062 4.253,6.669 -1.063,8.989 -3.731,1.629 -8.452,-0.455 -10.942,-1.843 1.544,-0.654 2.63,-3.57 1.277,-5.6 -3.119,-4.679 -12.43,-3.039 -17.301,0.386 -8.796,6.186 -3.962,14.981 0.29,18.655 2.29,1.977 2.314,3.807 2.112,4.791 -0.594,-0.85 -1.576,-1.409 -2.691,-1.409 -1.815,0 -3.286,1.471 -3.286,3.286 0,0.142 0.024,0.279 0.042,0.416 -4.951,-2.175 -13.022,3.264 -13.38,13.116 -0.253,6.946 4.641,10.661 8.072,12.412 -1.299,0.456 -2.236,1.679 -2.236,3.133 0,1.841 1.492,3.332 3.332,3.332 0.77,0 1.47,-0.271 2.035,-0.711 4.175,7.155 0.015,12.222 -2.282,14.264 -0.494,-0.18 -1.021,-0.294 -1.577,-0.294 -2.562,0 -4.64,2.077 -4.64,4.64 0,2.405 1.837,4.36 4.182,4.594 -3.198,3.285 -6.067,10.525 0.168,18.749 6.814,8.989 23.052,8.264 30.881,8.554 4.964,0.184 8.698,2.754 10.771,4.613 -1.325,0.817 -2.217,2.269 -2.217,3.94 0,2.343 1.743,4.26 4,4.575 0.82,1.312 2.265,2.191 3.926,2.191 1.856,0 3.445,-1.097 4.188,-2.673 2.45,2.019 4.125,2.866 4.125,2.866 0,0 1.675,-0.846 4.125,-2.866 0.742,1.575 2.332,2.673 4.188,2.673 1.661,0 3.106,-0.879 3.926,-2.191 2.257,-0.315 4,-2.232 4,-4.575 0,-1.672 -0.892,-3.124 -2.217,-3.94 2.072,-1.859 5.806,-4.43 10.771,-4.613 7.829,-0.29 24.067,0.435 30.881,-8.554 6.234,-8.224 3.366,-15.465 0.168,-18.749 2.341,-0.235 4.178,-2.189 4.178,-4.594 z"
       id="path3" />
    <path
       fill="#d2aa73"
       d="m 214.245,136.826 v 67.273 c 0,7.687 6.231,13.919 13.919,13.919 h 18.558 c 6.959,0 9.279,4.64 9.279,4.64 0,0 2.319,-4.64 9.279,-4.64 h 18.558 c 7.687,0 13.919,-6.231 13.919,-13.919 v -67.273 c 0,-1.281 -1.038,-2.319 -2.319,-2.319 h -78.871 c -1.284,0 -2.322,1.038 -2.322,2.319 z"
       id="path4" />
    <g
       id="g5"
       transform="translate(0,-88.273)">
    	<rect
       x="218.88"
       y="227.41701"
       fill="#ff4b55"
       width="34.796001"
       height="34.796001"
       id="rect4" />
    	<path
       fill="#ff4b55"
       d="m 253.68,301.651 v 0 c -19.218,0 -34.796,-15.578 -34.796,-34.796 v 0 h 34.796 z"
       id="path5" />
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    	<path
       fill="#ffe15a"
       d="m 258.32,301.651 v 0 -34.796 h 34.796 v 0 c -10e-4,19.216 -15.58,34.796 -34.796,34.796 z"
       id="path6" />
    	<rect
       x="258.32001"
       y="227.41701"
       fill="#ffe15a"
       width="4.9710002"
       height="34.796001"
       id="rect6" />
    </g>
    <rect
       x="263.29001"
       y="139.14401"
       fill="#ff4b55"
       width="4.9710002"
       height="34.796001"
       id="rect7" />
    <rect
       x="268.26001"
       y="139.14401"
       fill="#ffe15a"
       width="4.9710002"
       height="34.796001"
       id="rect8" />
    <rect
       x="273.23999"
       y="139.14401"
       fill="#ff4b55"
       width="4.9710002"
       height="34.796001"
       id="rect9" />
    <g
       id="g11"
       transform="translate(0,-88.273)">
    	<rect
       x="278.20001"
       y="227.41701"
       fill="#ffe15a"
       width="4.9710002"
       height="34.796001"
       id="rect10" />
    	<rect
       x="288.14001"
       y="227.41701"
       fill="#ffe15a"
       width="4.9710002"
       height="34.796001"
       id="rect11" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    	<rect
       x="283.17999"
       y="227.41701"
       fill="#ff4b55"
       width="4.9710002"
       height="34.796001"
       id="rect12" />
    	<rect
       x="230.48"
       y="266.85699"
       fill="#ff4b55"
       width="3.8659999"
       height="34.796001"
       id="rect13" />
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    	<rect
       x="234.35001"
       y="266.85699"
       fill="#ffe15a"
       width="3.8659999"
       height="34.796001"
       id="rect14" />
    	<rect
       x="242.09"
       y="266.85699"
       fill="#ffe15a"
       width="3.8659999"
       height="34.796001"
       id="rect15" />
    </g>
    <rect
       x="238.21001"
       y="178.584"
       fill="#ff4b55"
       width="3.8659999"
       height="34.796001"
       id="rect16" />
    <rect
       x="249.81"
       y="178.584"
       fill="#ffe15a"
       width="3.8659999"
       height="34.796001"
       id="rect17" />
    <rect
       x="245.95"
       y="178.584"
       fill="#ff4b55"
       width="3.8659999"
       height="34.796001"
       id="rect18" />
    <path
       fill="#ffe15a"
       d="m 222.75,211.608 v -33.026 h -3.866 v 25.517 c 0,3.097 1.533,5.823 3.866,7.509 z"
       id="path18" />
    <path
       fill="#ff4b55"
       d="m 226.617,213.222 v -34.641 h -3.866 v 33.026 c 1.126,0.814 2.437,1.374 3.866,1.615 z"
       id="path19" />
    <path
       fill="#ffe15a"
       d="m 226.617,178.582 v 34.641 c 0.505,0.085 1.016,0.156 1.547,0.156 h 2.319 v -34.796 h -3.866 z"
       id="path20" />
    <g
       id="g22"
       transform="translate(0,-88.273)">
    	<path
       fill="#f5f5f5"
       d="m 224.07,260.24 c -0.173,0 -0.348,-0.049 -0.503,-0.151 -2.281,-1.51 -2.414,-3.082 -2.29,-3.884 0.167,-1.084 0.973,-1.983 2.054,-2.292 1.028,-0.289 2.053,0.014 2.746,0.819 1.44,1.674 2.927,2.333 4.179,1.87 0.991,-0.367 1.582,-1.344 1.582,-2.074 0,-0.505 0.408,-0.914 0.914,-0.914 0.506,0 0.914,0.408 0.914,0.914 0,1.598 -1.166,3.191 -2.774,3.787 -1.175,0.434 -3.538,0.702 -6.2,-2.391 -0.286,-0.33 -0.622,-0.32 -0.86,-0.254 -0.324,0.093 -0.683,0.381 -0.749,0.812 -0.097,0.63 0.447,1.388 1.492,2.081 0.422,0.278 0.536,0.846 0.258,1.267 -0.176,0.264 -0.466,0.41 -0.763,0.41 z"
       id="path21" />
    	<path
       fill="#f5f5f5"
       d="m 248.603,260.24 c -0.296,0 -0.587,-0.145 -0.762,-0.408 -0.278,-0.422 -0.163,-0.989 0.258,-1.267 1.045,-0.693 1.589,-1.451 1.492,-2.081 -0.067,-0.431 -0.425,-0.719 -0.749,-0.812 -0.238,-0.066 -0.575,-0.077 -0.86,0.254 -2.662,3.095 -5.026,2.827 -6.2,2.391 -1.608,-0.596 -2.774,-2.19 -2.774,-3.787 0,-0.505 0.408,-0.914 0.914,-0.914 0.505,0 0.914,0.408 0.914,0.914 0,0.73 0.591,1.706 1.582,2.074 1.252,0.465 2.74,-0.196 4.179,-1.87 0.693,-0.809 1.719,-1.11 2.746,-0.819 1.08,0.309 1.887,1.208 2.054,2.292 0.124,0.801 -0.009,2.374 -2.29,3.884 -0.155,0.098 -0.331,0.149 -0.504,0.149 z"
       id="path22" />
    </g>
    <g
       id="g23"
       transform="translate(0,-88.273)">
    	<path
       fill="#ffe15a"
       d="m 223.567,261.324 c -0.193,0 -0.387,-0.061 -0.553,-0.185 -0.402,-0.307 -0.479,-0.879 -0.174,-1.281 l 19.864,-26.119 c 0.19,-0.343 0.262,-0.818 0.344,-1.365 0.153,-1.026 0.345,-2.303 1.911,-3.245 1.021,-0.612 2.232,-0.595 3.245,0.052 1.118,0.714 1.777,2.044 1.641,3.309 -0.082,0.769 -0.531,2.172 -2.612,2.943 -0.476,0.177 -1,-0.067 -1.174,-0.538 -0.175,-0.473 0.066,-1 0.538,-1.174 0.607,-0.225 1.348,-0.655 1.43,-1.425 0.063,-0.584 -0.269,-1.229 -0.808,-1.575 -0.301,-0.193 -0.774,-0.358 -1.319,-0.025 -0.829,0.498 -0.911,1.044 -1.047,1.949 -0.096,0.641 -0.205,1.367 -0.633,2.106 l -19.927,26.213 c -0.177,0.236 -0.45,0.36 -0.726,0.36 z"
       id="path23" />
    	<polygon
       fill="#ffe15a"
       points="230.925,254.528 241.891,254.528 245.546,243.562 236.408,232.596 227.27,243.562 "
       id="polygon23" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 236.408,142.895 -10.166,12.199 4.024,12.074 h 12.282 l 4.024,-12.074 z m -8.111,12.588 7.197,-8.636 v 18.493 h -3.911 z m 12.935,9.858 h -3.911 v -18.493 l 7.197,8.636 z"
       id="path24" />
    <path
       fill="#ff4b55"
       d="m 284.561,189.568 0.138,-2.027 c 0,0 1.798,-1.29 0.921,-2.488 -0.875,-1.198 -1.889,-1.429 -4.009,-1.152 -2.12,0.277 -5.438,0.231 -6.866,0.322 -1.429,0.093 -2.166,0.875 -4.424,0.231 l 0.599,-1.383 c 0,0 -1.059,0.093 -1.705,0.415 -0.352,0.177 -1.198,-0.968 -2.027,-0.783 -0.826,0.183 -1.658,1.889 -2.95,2.765 l 0.691,1.383 c 0,0 0.783,-0.369 1.383,0.046 0.599,0.415 0.783,0.691 1.798,0.691 l 0.646,0.277 c 0,0 -0.231,1.474 0.737,2.166 0,0 -1.106,1.429 -0.968,1.658 0.138,0.231 1.059,1.982 1.429,2.995 l 0.83,-1.567 c 0,0 -1.245,-1.106 -1.014,-1.245 0.231,-0.138 1.059,-0.322 0.921,-0.691 -0.138,-0.369 0.646,0.046 1.521,0.184 0,0 0.046,1.383 0.231,1.567 0.185,0.184 0.461,0.921 0.415,1.705 -0.046,0.783 -0.737,1.014 -0.737,1.014 l 1.245,0.369 c 0,0 0.322,-0.461 0.553,-0.415 0,0 -0.093,-3.825 0.415,-4.424 0,0 2.995,0.599 4.377,-0.138 0,0 0.177,0.223 0.522,0.435 -0.138,0.321 -0.255,0.641 -0.203,0.735 0.116,0.209 0.486,0.185 0.578,-0.046 0.035,-0.087 0.089,-0.266 0.143,-0.451 0.167,0.055 0.35,0.098 0.559,0.119 -0.02,0.291 -0.022,0.559 0.045,0.621 0.174,0.161 0.519,0.024 0.535,-0.225 0.006,-0.081 0.002,-0.234 -0.002,-0.398 0.238,-0.02 0.492,-0.062 0.772,-0.145 l -1.567,2.581 -0.783,0.322 1.014,0.507 0.921,-0.369 c 0,0 0.875,-2.212 2.304,-2.857 0,0 0.968,2.304 -0.231,3.549 l 1.059,0.599 0.507,-1.06 c 0,0 -0.184,-2.073 0.507,-3.41 z"
       id="path25" />
    <g
       id="g32"
       transform="translate(0,-88.273)">
    	<path
       fill="#4173cd"
       d="m 267.208,271.255 c 0,0 -0.462,-0.439 -0.578,-1.017 -0.116,-0.578 -0.255,-0.833 -0.764,-0.994 0,0 0.323,0.37 0.278,0.948 -0.046,0.578 0,1.365 0.323,1.619 z"
       id="path26" />
    	<path
       fill="#4173cd"
       d="m 271.233,272.886 c 0,0 -0.629,2.138 -2.477,3.25 l -0.644,-0.277 c 0,0 1.973,-1.686 2.212,-3.134 z"
       id="path27" />
    	<path
       fill="#4173cd"
       d="m 268.087,271.764 c -0.066,-0.068 0.81,-0.323 0.601,-1.017 -0.209,-0.694 -0.209,-1.203 0.209,-1.526 0,0 0.046,0.578 0.37,0.948 0.323,0.37 0.509,1.295 -0.023,1.827 0,0 -0.533,0.416 -1.157,-0.232 z"
       id="path28" />
    	<path
       fill="#4173cd"
       d="m 268.187,278.07 v 0 c -0.11,-0.054 -0.157,-0.189 -0.102,-0.299 l 0.279,-0.568 c 0.163,-0.333 0.055,-0.747 -0.266,-0.932 -0.353,-0.203 -0.797,-0.063 -0.973,0.296 l -0.29,0.59 c -0.054,0.11 -0.189,0.157 -0.299,0.102 l -0.174,0.354 c 0,0 0.256,0.126 0.566,0.278 l -0.007,0.013 c -0.071,0.143 -0.011,0.317 0.132,0.387 0.143,0.071 0.317,0.011 0.387,-0.132 l 0.007,-0.013 c 0.31,0.152 0.566,0.278 0.566,0.278 z"
       id="path29" />
    	<polygon
       fill="#4173cd"
       points="270.538,283.884 269.954,282.955 270.424,281.964 271.117,282.103 "
       id="polygon29" />
    	<polygon
       fill="#4173cd"
       points="273.361,284.671 273.364,284.292 272.12,283.923 271.696,284.671 "
       id="polygon30" />
    	<polygon
       fill="#4173cd"
       points="278.432,283.815 279.346,282.901 280.322,283.37 280.322,283.815 "
       id="polygon31" />
    	<polygon
       fill="#4173cd"
       points="284.348,284.627 284.377,284.292 283.317,283.692 282.384,284.627 "
       id="polygon32" />
    </g>
    <path
       fill="#ff4b55"
       d="m 284.561,204.006 0.138,-2.027 c 0,0 1.798,-1.29 0.921,-2.488 -0.875,-1.198 -1.889,-1.429 -4.009,-1.152 -2.12,0.277 -5.438,0.231 -6.866,0.322 -1.429,0.093 -2.166,0.875 -4.424,0.231 l 0.599,-1.383 c 0,0 -1.059,0.093 -1.705,0.415 -0.352,0.177 -1.198,-0.968 -2.027,-0.783 -0.826,0.183 -1.658,1.889 -2.95,2.765 l 0.691,1.383 c 0,0 0.783,-0.369 1.383,0.046 0.599,0.415 0.783,0.691 1.798,0.691 l 0.646,0.277 c 0,0 -0.231,1.474 0.737,2.166 0,0 -1.106,1.429 -0.968,1.658 0.138,0.231 1.059,1.982 1.429,2.995 l 0.83,-1.567 c 0,0 -1.245,-1.106 -1.014,-1.245 0.231,-0.138 1.059,-0.322 0.921,-0.691 -0.138,-0.369 0.646,0.046 1.521,0.184 0,0 0.046,1.383 0.231,1.567 0.185,0.184 0.461,0.921 0.415,1.705 -0.046,0.783 -0.737,1.014 -0.737,1.014 l 1.245,0.369 c 0,0 0.322,-0.461 0.553,-0.415 0,0 -0.093,-3.825 0.415,-4.424 0,0 2.995,0.599 4.377,-0.138 0,0 0.177,0.223 0.522,0.435 -0.138,0.321 -0.255,0.641 -0.203,0.735 0.116,0.209 0.486,0.185 0.578,-0.046 0.035,-0.087 0.089,-0.266 0.143,-0.451 0.167,0.055 0.35,0.098 0.559,0.119 -0.02,0.291 -0.022,0.559 0.045,0.621 0.174,0.161 0.519,0.024 0.535,-0.225 0.006,-0.081 0.002,-0.234 -0.002,-0.398 0.238,-0.02 0.492,-0.062 0.772,-0.145 l -1.567,2.581 -0.783,0.322 1.014,0.507 0.921,-0.369 c 0,0 0.875,-2.212 2.304,-2.857 0,0 0.968,2.304 -0.231,3.549 l 1.059,0.599 0.507,-1.06 c 0,0 -0.184,-2.073 0.507,-3.41 z"
       id="path32" />
    <g
       id="g39"
       transform="translate(0,-88.273)">
    	<path
       fill="#4173cd"
       d="m 267.208,285.694 c 0,0 -0.462,-0.439 -0.578,-1.017 -0.116,-0.578 -0.255,-0.833 -0.764,-0.994 0,0 0.323,0.37 0.278,0.948 -0.046,0.578 0,1.365 0.323,1.619 z"
       id="path33" />
    	<path
       fill="#4173cd"
       d="m 271.233,287.325 c 0,0 -0.629,2.138 -2.477,3.25 l -0.646,-0.277 c 0,0 1.973,-1.686 2.212,-3.134 z"
       id="path34" />
    	<path
       fill="#4173cd"
       d="m 268.087,286.203 c -0.066,-0.068 0.81,-0.323 0.601,-1.017 -0.209,-0.694 -0.209,-1.203 0.209,-1.526 0,0 0.046,0.578 0.37,0.948 0.323,0.37 0.509,1.295 -0.023,1.827 0,0 -0.533,0.415 -1.157,-0.232 z"
       id="path35" />
    	<path
       fill="#4173cd"
       d="m 268.187,292.509 v 0 c -0.11,-0.054 -0.157,-0.189 -0.102,-0.299 l 0.279,-0.568 c 0.163,-0.333 0.055,-0.747 -0.266,-0.932 -0.353,-0.203 -0.797,-0.063 -0.973,0.296 l -0.29,0.59 c -0.054,0.11 -0.189,0.157 -0.299,0.102 l -0.174,0.354 c 0,0 0.256,0.126 0.566,0.278 l -0.007,0.013 c -0.071,0.143 -0.011,0.317 0.132,0.387 0.143,0.071 0.317,0.011 0.387,-0.132 l 0.007,-0.013 c 0.31,0.152 0.566,0.278 0.566,0.278 z"
       id="path36" />
    	<polygon
       fill="#4173cd"
       points="270.538,298.323 269.954,297.394 270.424,296.403 271.117,296.542 "
       id="polygon36" />
    	<polygon
       fill="#4173cd"
       points="273.361,299.11 273.364,298.73 272.12,298.362 271.696,299.11 "
       id="polygon37" />
    	<polygon
       fill="#4173cd"
       points="278.432,298.254 279.346,297.34 280.322,297.809 280.322,298.254 "
       id="polygon38" />
    	<polygon
       fill="#4173cd"
       points="284.348,299.066 284.377,298.73 283.317,298.131 282.384,299.066 "
       id="polygon39" />
    </g>
    <g
       id="g40"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const AE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#73af00"
       d="M 512,111.817 H 158.897 V 0.001 h 344.276 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#464655"
       d="M 503.172,335.449 H 158.897 V 223.633 H 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       x="158.89999"
       y="111.815"
       fill="#f5f5f5"
       width="353.10001"
       height="111.81"
       id="rect2" />
    <path
       fill="#ff4b55"
       d="M 158.897,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 150.069 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AF = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs42" />
    <path
       fill="#464655"
       d="M 170.667,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#ff4b55"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 341.333 V 0 H 503.172 C 508.047,0 512,3.953 512,8.828 V 326.62 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <g
       id="g27"
       transform="translate(0,-88.273)">
    	<polygon
       fill="#f5f5f5"
       points="235.522,268.185 276.477,268.185 279.037,273.305 232.962,273.305 "
       id="polygon2" />
    	<polygon
       fill="#f5f5f5"
       points="235.522,237.468 276.477,237.468 279.037,232.348 232.962,232.348 "
       id="polygon3" />
    	<polygon
       fill="#f5f5f5"
       points="248.321,229.789 263.679,229.789 268.798,234.908 243.201,234.908 "
       id="polygon4" />
    	<rect
       x="235.52"
       y="260.50699"
       fill="#f5f5f5"
       width="7.6789999"
       height="5.1199999"
       id="rect4" />
    	<rect
       x="235.52"
       y="252.827"
       fill="#f5f5f5"
       width="7.6789999"
       height="5.1199999"
       id="rect5" />
    	<rect
       x="235.52"
       y="240.02699"
       fill="#f5f5f5"
       width="7.6789999"
       height="5.1199999"
       id="rect6" />
    	<rect
       x="235.52"
       y="247.707"
       fill="#f5f5f5"
       width="7.6789999"
       height="2.5599999"
       id="rect7" />
    	<rect
       x="268.79999"
       y="260.50699"
       fill="#f5f5f5"
       width="7.6789999"
       height="5.1199999"
       id="rect8" />
    	<rect
       x="268.79999"
       y="252.827"
       fill="#f5f5f5"
       width="7.6789999"
       height="5.1199999"
       id="rect9" />
    	<rect
       x="268.79999"
       y="240.02699"
       fill="#f5f5f5"
       width="7.6789999"
       height="5.1199999"
       id="rect10" />
    	<rect
       x="268.79999"
       y="247.707"
       fill="#f5f5f5"
       width="7.6789999"
       height="2.5599999"
       id="rect11" />
    	<rect
       x="238.08"
       y="219.547"
       fill="#f5f5f5"
       width="5.1199999"
       height="10.239"
       id="rect12" />
    	<path
       fill="#f5f5f5"
       d="m 243.201,216.99 h -5.12 v -2.56 c 0,-1.414 1.146,-2.56 2.56,-2.56 v 0 c 1.414,0 2.56,1.146 2.56,2.56 z"
       id="path12" />
    	<rect
       x="268.79999"
       y="219.547"
       fill="#f5f5f5"
       width="5.1199999"
       height="10.239"
       id="rect13" />
    	<path
       fill="#f5f5f5"
       d="m 273.918,216.99 h -5.12 v -2.56 c 0,-1.414 1.146,-2.56 2.56,-2.56 v 0 c 1.414,0 2.56,1.146 2.56,2.56 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 255.999,240.028 v 0 c -5.655,0 -10.239,4.584 -10.239,10.239 v 15.359 h 20.478 v -15.359 c 0,-5.655 -4.583,-10.239 -10.239,-10.239 z"
       id="path14" />
    	<path
       fill="#f5f5f5"
       d="m 239.053,256.154 -13.937,-16.259 c 0.09,-0.263 0.167,-0.533 0.167,-0.826 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,1.414 1.146,2.56 2.56,2.56 0.154,0 0.288,-0.062 0.434,-0.087 l 1.442,1.683 -6.996,16.323 7.679,7.679 6.631,-15.47 5.197,6.063 z m -12.453,5.347 -6.127,-6.127 2.764,-6.451 6.127,6.127 z"
       id="path15" />
    	<path
       fill="#f5f5f5"
       d="m 274.953,257.818 5.197,-6.063 6.631,15.47 7.679,-7.679 -6.996,-16.323 1.442,-1.683 c 0.147,0.026 0.28,0.087 0.434,0.087 1.414,0 2.56,-1.146 2.56,-2.56 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,0.294 0.076,0.564 0.167,0.826 l -13.937,16.259 z m 7.745,-2.768 6.127,-6.127 2.764,6.451 -6.127,6.127 z"
       id="path16" />
    	<path
       fill="#f5f5f5"
       d="m 258.897,214.876 c -0.804,-0.237 -1.522,-0.676 -1.976,-1.38 -0.303,-0.471 -0.612,-1.006 -0.921,-1.625 -0.309,0.619 -0.618,1.154 -0.921,1.625 -0.455,0.705 -1.172,1.144 -1.976,1.38 -4.241,1.249 -7.342,5.148 -7.342,9.793 0,0.889 0.149,1.737 0.362,2.56 h 19.754 c 0.213,-0.823 0.362,-1.671 0.362,-2.56 -10e-4,-4.645 -3.101,-8.544 -7.342,-9.793 z"
       id="path17" />
    	<path
       fill="#f5f5f5"
       d="m 197.339,252.526 c -0.13,-1.591 -0.214,-3.194 -0.214,-4.819 0,-3.288 0.298,-6.522 0.826,-9.695 0.738,0.511 1.511,1.073 2.314,1.704 -0.375,2.625 -0.581,5.291 -0.581,7.991 0,1.892 0.097,3.763 0.28,5.608 l 5.411,1.625 c -0.338,-2.37 -0.572,-4.772 -0.572,-7.233 0,-1.224 0.073,-2.433 0.17,-3.638 2.826,3.134 5.056,6.92 5.056,11.104 0,0.107 8.213,-12.159 -6.719,-25.704 l -0.107,5.759 -8.6,-0.09 c -0.775,-0.008 -1.457,0.542 -1.592,1.305 -0.654,3.679 -1.006,7.441 -1.006,11.264 0,1.087 0.029,2.167 0.082,3.241 z"
       id="path18" />
    	<path
       fill="#f5f5f5"
       d="m 220.052,201.096 c 1.119,-0.863 1.325,-2.47 0.461,-3.59 -0.866,-1.12 -2.472,-1.322 -3.591,-0.46 -11.585,8.947 -19.535,21.239 -22.978,35.008 l 5.276,0.068 c 3.321,-12.186 10.505,-23.049 20.832,-31.026 z"
       id="path19" />
    	<path
       fill="#f5f5f5"
       d="m 216.623,207.481 c -5.567,5.452 -9.781,11.869 -12.648,18.839 1.583,1.301 2.88,2.615 3.957,3.922 2.58,-7.107 6.689,-13.632 12.274,-19.101 1.01,-0.99 1.027,-2.61 0.038,-3.619 -0.993,-1.013 -2.611,-1.031 -3.621,-0.041 z"
       id="path20" />
    	<path
       fill="#f5f5f5"
       d="m 207.727,281.267 c -3.796,-5.447 -6.697,-11.555 -8.498,-18.116 l 2.976,1.094 c 1.859,5.987 4.68,11.555 8.292,16.516 l 5.65,-1.034 c -3.19,-3.965 -5.812,-8.404 -7.727,-13.198 l 3.34,1.227 c 1.906,4.185 4.346,8.033 7.255,11.447 l 5.879,-1.077 c -2.312,-2.36 -4.334,-5.017 -6.076,-7.883 l -3.406,-6.812 c -1.052,-2.104 -2.925,-3.68 -5.178,-4.355 l -8.058,-2.422 -1.863,-0.559 -2.682,-0.807 -5.335,-1.603 -2.848,-0.856 1.762,5.288 c 0.387,1.161 1.17,2.13 2.188,2.766 1.629,7.735 4.65,14.962 8.8,21.399 z"
       id="path21" />
    	<path
       fill="#f5f5f5"
       d="m 308.794,235.228 -0.107,-5.759 c -14.932,13.545 -6.719,25.811 -6.719,25.704 0,-4.184 2.23,-7.97 5.056,-11.104 0.097,1.205 0.17,2.415 0.17,3.638 0,2.462 -0.234,4.864 -0.572,7.233 l 5.411,-1.625 c 0.183,-1.845 0.28,-3.715 0.28,-5.608 0,-2.701 -0.206,-5.367 -0.582,-7.991 0.803,-0.63 1.577,-1.193 2.314,-1.704 0.529,3.172 0.826,6.408 0.826,9.695 0,1.624 -0.084,3.228 -0.214,4.819 l 5.251,-1.578 c 0.054,-1.074 0.082,-2.154 0.082,-3.241 0,-3.823 -0.353,-7.585 -1.006,-11.264 -0.136,-0.764 -0.818,-1.313 -1.592,-1.305 z"
       id="path22" />
    	<path
       fill="#f5f5f5"
       d="m 312.779,232.123 5.276,-0.068 c -3.444,-13.769 -11.393,-26.061 -22.978,-35.008 -1.119,-0.863 -2.724,-0.66 -3.591,0.46 -0.864,1.12 -0.658,2.728 0.461,3.59 10.327,7.976 17.511,18.839 20.832,31.026 z"
       id="path23" />
    	<path
       fill="#f5f5f5"
       d="m 308.025,226.32 c -2.868,-6.97 -7.081,-13.387 -12.648,-18.839 -1.01,-0.99 -2.628,-0.972 -3.619,0.04 -0.99,1.01 -0.972,2.63 0.038,3.619 5.585,5.469 9.694,11.993 12.274,19.101 1.075,-1.306 2.371,-2.62 3.955,-3.921 z"
       id="path24" />
    	<path
       fill="#f5f5f5"
       d="m 319.705,253.682 -5.335,1.603 -2.682,0.807 -1.863,0.559 -8.058,2.422 c -2.253,0.676 -4.127,2.252 -5.178,4.355 l -3.406,6.812 c -1.741,2.866 -3.764,5.523 -6.076,7.883 l 5.879,1.077 c 2.909,-3.414 5.35,-7.261 7.255,-11.447 l 3.34,-1.227 c -1.916,4.794 -4.538,9.234 -7.727,13.198 l 5.65,1.034 c 3.614,-4.962 6.433,-10.529 8.292,-16.516 l 2.976,-1.094 c -1.801,6.561 -4.702,12.67 -8.498,18.116 l 5.529,1.012 c 4.15,-6.439 7.17,-13.665 8.8,-21.399 1.018,-0.637 1.801,-1.606 2.188,-2.766 l 1.762,-5.288 z"
       id="path25" />
    	<path
       fill="#f5f5f5"
       d="m 282.677,281.983 -0.132,0.117 c -7.447,5.748 -16.696,9.122 -26.544,9.122 -9.848,0 -19.097,-3.374 -26.544,-9.122 l -0.132,-0.117 c -0.967,-1.063 -2.42,-1.539 -3.828,-1.255 l -25.81,5.375 5.727,5.02 c 1.532,1.343 3.5,1.969 5.457,1.854 4.609,4.59 9.902,8.491 15.723,11.522 l -1.677,3.095 c 9.247,5.028 19.838,7.887 31.084,7.887 11.246,0 21.836,-2.859 31.084,-7.887 l -1.677,-3.095 c 5.821,-3.031 11.114,-6.933 15.723,-11.522 1.957,0.115 3.926,-0.512 5.458,-1.854 l 5.727,-5.02 -25.81,-5.375 c -1.409,-0.284 -2.863,0.193 -3.829,1.255 z M 229.04,299.98 c -4.64,-2.414 -8.888,-5.463 -12.711,-8.97 l 2.485,-1.185 c 3.471,3.072 7.289,5.762 11.438,7.915 z m 66.629,-8.968 c -3.822,3.506 -8.071,6.554 -12.711,8.97 l -1.213,-2.239 c 4.149,-2.153 7.966,-4.843 11.438,-7.915 z m -39.67,7.889 c -12.192,0 -23.363,-4.326 -32.159,-11.473 l 2.554,-1.218 c 8.305,6.397 18.625,10.131 29.603,10.131 10.978,0 21.299,-3.734 29.603,-10.131 l 2.554,1.218 c -8.79,7.149 -19.963,11.473 -32.155,11.473 z"
       id="path26" />
    	<path
       fill="#f5f5f5"
       d="m 227.911,278.355 c 1.099,0.93 2.239,1.81 3.427,2.628 h 49.322 c 1.188,-0.819 2.328,-1.698 3.427,-2.628 l -2.49,-2.49 h -51.194 z"
       id="path27" />
    </g>
    <g
       id="g28"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const AG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#464655"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 512,3.953 508.047,0 503.172,0 Z"
       id="path1" />
    <polygon
       fill="#ffe15a"
       points="299.915,114.667 287.878,172.981 337.146,139.543 303.709,188.812 362.023,176.774 312.276,209.496 370.758,220.69 312.276,231.884 362.023,264.606 303.709,252.568 337.146,301.836 287.878,268.399 299.915,326.714 267.194,276.967 255.999,335.448 244.806,276.967 212.083,326.714 224.122,268.399 174.853,301.836 208.291,252.568 149.977,264.606 199.723,231.884 141.241,220.69 199.723,209.496 149.977,176.774 208.291,188.812 174.853,139.543 224.122,172.981 212.083,114.667 244.806,164.413 255.999,105.931 267.194,164.413 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 0,97.104 v 317.792 c 0,4.875 3.953,8.828 8.828,8.828 H 256 L 2.298,91.289 C 0.91,92.848 0,94.852 0,97.104 Z"
       id="path2" />
    	<path
       fill="#ff4b55"
       d="m 255.999,423.724 h 247.172 c 4.875,0 8.828,-3.953 8.828,-8.828 V 97.104 c 0,-2.252 -0.91,-4.256 -2.298,-5.816 z"
       id="path3" />
    </g>
    <polygon
       fill="#4173cd"
       points="410.946,220.69 101.052,220.69 154.947,291.31 357.052,291.31 "
       id="polygon3"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#f5f5f5"
       points="357.052,291.31 154.947,291.31 255.999,423.724 "
       id="polygon4"
       transform="translate(0,-88.276)" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs26" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path6" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 328.608,104.387 c -1.184,15.778 -6.08,116.046 57.536,138.712 63.639,-22.672 58.722,-122.936 57.536,-138.712 -7.708,3.021 -35.609,12.179 -57.536,-3.427 -21.925,15.604 -49.823,6.452 -57.536,3.427 z"
       id="path7" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffa028"
       d="m 417.403,212.893 c -3.488,-2.712 -9.945,2.325 -17.18,1.809 -6.709,-0.479 -14.977,-7.273 -25.724,-4.344 -2.969,-2.734 -1.532,-9.089 -1.532,-9.089 -7.461,4.823 -7.996,11.425 -7.527,15.006 -5.32,7.03 -4.961,17.758 -3.969,21.032 1.291,4.263 3.746,4.779 4.134,9.558 0.387,4.779 2.196,3.1 2.196,3.1 3.736,-2.095 4.279,-6.048 5.85,-12.516 6.07,0.775 10.037,-4.662 10.037,-4.662 -3.982,1.249 -6.494,-0.946 -7.863,-2.879 0.214,-0.639 0.385,-1.228 0.63,-1.9 4.521,-12.401 26.154,-8.991 28.159,-5.555 3.617,6.2 8.396,8.525 8.396,8.525 0,-6.464 -4.779,-12.141 -4.779,-12.141 7.234,-1.294 9.172,-5.944 9.172,-5.944 z m -52.054,26.608 c -0.714,0 -1.292,-0.578 -1.292,-1.291 0,-0.713 0.578,-1.291 1.292,-1.291 0.713,0 1.291,0.578 1.291,1.291 0,0.713 -0.578,1.291 -1.291,1.291 z"
       id="path8" />
    	<path
       fill="#ffa028"
       d="m 396.102,292.24 c 4.212,-1.333 3.729,-9.509 8.258,-15.172 4.201,-5.252 14.486,-8.206 18.172,-18.718 3.936,-0.894 8.353,3.895 8.353,3.895 0.262,-8.881 -4.872,-13.066 -8.087,-14.712 -2.771,-8.37 -11.808,-14.161 -15.068,-15.201 -4.243,-1.355 -6.06,0.373 -10.216,-2.019 -4.156,-2.392 -3.799,0.05 -3.799,0.05 -0.394,4.266 2.552,6.955 6.988,11.919 -4.082,4.558 -1.855,10.911 -1.855,10.911 1.23,-3.989 4.463,-4.811 6.833,-4.842 0.405,0.538 0.793,1.014 1.207,1.597 7.647,10.757 -7.434,26.638 -11.402,26.339 -7.158,-0.54 -11.784,2.078 -11.784,2.078 5.323,3.667 12.71,2.953 12.71,2.953 -3.04,6.689 -0.31,10.922 -0.31,10.922 z m 7.621,-57.962 c 0.405,-0.587 1.209,-0.736 1.796,-0.331 0.587,0.405 0.736,1.209 0.331,1.796 -0.405,0.587 -1.209,0.736 -1.796,0.331 -0.588,-0.405 -0.736,-1.208 -0.331,-1.796 z"
       id="path9" />
    	<path
       fill="#ffa028"
       d="m 339.154,234.826 c -0.564,4.382 7.058,7.383 10.289,13.876 2.997,6.02 1.348,16.595 9.333,24.361 -0.845,3.947 -7.049,5.939 -7.049,5.939 7.946,3.975 13.903,1.079 16.749,-1.145 8.759,1.009 17.815,-4.753 20.13,-7.272 3.015,-3.278 2.212,-5.655 6.131,-8.418 3.919,-2.763 1.554,-3.467 1.554,-3.467 -3.704,-2.153 -7.383,-0.611 -13.753,1.323 -2.418,-5.621 -9.117,-6.274 -9.117,-6.274 3.101,2.795 2.486,6.073 1.517,8.235 -0.659,0.14 -1.254,0.292 -1.956,0.424 -12.977,2.409 -21.036,-17.954 -19.095,-21.427 3.501,-6.266 3.074,-11.564 3.074,-11.564 -5.567,3.285 -8.028,10.287 -8.028,10.287 -4.789,-5.573 -9.779,-4.878 -9.779,-4.878 z m 49.373,31.306 c 0.363,0.615 0.159,1.407 -0.456,1.769 -0.615,0.363 -1.406,0.159 -1.769,-0.456 -0.363,-0.615 -0.159,-1.406 0.456,-1.769 0.614,-0.363 1.407,-0.159 1.769,0.456 z"
       id="path10" />
    </g>
    <path
       fill="#cdce0c"
       d="m 386.144,246.384 -0.509,-0.175 C 314.001,221.291 325.577,103.172 325.701,101.979 l 0.224,-2.134 1.958,0.887 c 0.338,0.154 33.572,14.894 57.331,-2.931 l 0.929,-0.696 0.929,0.696 c 23.794,17.849 56.999,3.082 57.33,2.931 l 1.959,-0.89 0.224,2.137 c 0.126,1.193 11.701,119.312 -59.934,144.23 z M 328.608,104.387 c -1.184,15.778 -6.08,116.046 57.536,138.712 63.639,-22.672 58.722,-122.936 57.536,-138.712 -7.708,3.021 -35.609,12.179 -57.536,-3.427 -21.925,15.604 -49.823,6.452 -57.536,3.427 z"
       id="path11" />
    <path
       fill="#82afff"
       d="m 346.246,207.543 c 8.689,15.757 21.374,28.957 39.898,35.556 18.529,-6.601 31.218,-19.8 39.907,-35.556 z"
       id="path12" />
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#464655"
       d="m 352.551,209.517 c -4.828,-3.034 -7.724,1.793 -7.724,1.793 l -14.069,1.655 7.034,-5.931 c 5.103,0.414 5.793,-1.103 7.172,-3.172 1.379,-2.069 7.172,-1.103 7.172,-1.103 -0.828,-6.345 -8.828,-2.759 -8.828,-2.759 -6.483,-0.69 -7.586,4.552 -7.586,4.552 l -10.069,7.724 -22.159,-6.566 c 2.298,-2.532 4.103,-5.027 4.366,-6.538 0.441,-2.537 -16.367,-6.805 -21.517,-12.138 -5.149,-5.334 -6.988,-13.793 -4.597,-16 2.39,-2.207 4.414,4.045 6.988,9.195 2.574,5.15 7.357,9.195 10.483,6.621 3.126,-2.574 -3.31,-6.436 -6.253,-11.954 -2.942,-5.517 2.207,-7.541 4.598,-6.989 2.391,0.552 3.862,11.955 9.564,17.839 5.7,5.885 10.85,4.781 11.402,1.103 0.552,-3.678 -9.409,-8.21 -11.433,-11.337 -2.023,-3.126 -2.545,-9.261 0.766,-9.444 3.31,-0.184 15.448,17.906 25.748,24.828 11.218,7.54 20.229,-1.288 18.759,-4.966 -1.471,-3.679 -8.276,-2.207 -16.184,-4.231 -7.908,-2.023 -16,-12.69 -18.391,-18.574 -2.391,-5.885 -0.414,-5.885 0.966,-5.333 1.379,0.552 6.621,8.276 16.69,14.207 10.069,5.931 17.103,0.276 17.931,-1.103 0.828,-1.379 4.009,-7.571 -6.345,-6.115 -11.769,1.655 -18.483,-5.333 -23.31,-9.057 -4.828,-3.724 -6.759,-8.828 -4.552,-10.897 2.207,-2.069 9.471,7.264 20.505,10.207 10.136,2.702 14.253,-1.655 13.976,-5.655 -0.276,-4 -2.621,-2.345 -14.069,-3.448 -11.448,-1.103 -19.448,-11.862 -19.862,-12.552 -0.414,-0.69 -0.276,-4.552 5.517,-0.828 5.793,3.724 16.138,5.931 22.207,5.655 6.069,-0.276 7.31,-8.414 4.414,-9.793 -2.896,-1.379 -3.586,0.69 -10.207,2.069 -6.621,1.379 -19.034,-5.379 -22.069,-8.552 -3.035,-3.173 0.276,-5.241 1.793,-4.966 1.517,0.275 11.448,6.069 20.276,5.793 8.828,-0.276 12.552,-8.414 12.276,-10.897 -0.276,-2.483 -2.759,-4.552 -6.483,-2.069 -3.724,2.483 -8.69,5.379 -16.965,4 -8.276,-1.379 -12.138,-6.897 -11.034,-8.965 1.103,-2.069 9.103,1.517 21.793,0.138 12.69,-1.379 13.241,-12.552 12,-14.759 -1.241,-2.207 -4.276,-1.517 -8.552,2.483 -4.276,4 -12.552,4.828 -19.034,4.828 -6.483,0 -6.621,-3.172 -5.655,-5.379 0.966,-2.207 7.862,-1.655 17.517,-4.69 9.655,-3.034 15.172,-10.759 16.69,-15.586 1.518,-4.827 -2.207,-8.552 -3.724,-8.552 -1.517,0 -0.552,-2.207 -7.172,7.31 -6.621,9.517 -24,13.241 -24,13.241 -1.241,-2.345 -3.172,-3.172 -3.172,-3.172 -11.724,2.345 -25.866,12.468 -25.866,12.468 0,0 2.493,7.996 -0.622,14.228 -4.011,8.022 -17.759,3.011 -14.02,-9.658 3.113,-10.55 15.162,-16.928 25.341,-18.071 10.178,-1.142 10.697,-4.985 10.697,-4.985 0,0 -10.688,3.48 -10.879,-1.297 2.207,0.448 5.46,0.643 10.983,0.154 8.205,-0.726 12.775,-6.543 9.14,-7.789 -3.635,-1.246 -2.077,2.493 -8.309,5.401 -4.445,2.074 -9.11,1.14 -11.445,0.431 2.157,-4.71 11.237,-2.301 11.237,-2.301 0.104,-8.205 -10.783,-5.27 -10.783,-5.27 -4.781,-10.3 -32.736,1.655 -32.736,1.655 l 6.621,5.333 c -16.184,9.011 -19.495,26.114 -19.495,26.114 0,0 -3.31,-17.103 -19.495,-26.115 l 6.621,-5.333 c 0,0 -27.955,-11.955 -32.736,-1.655 0,0 -10.888,-2.934 -10.783,5.27 0,0 9.08,-2.409 11.238,2.301 -2.335,0.71 -7,1.643 -11.445,-0.431 -6.231,-2.909 -4.673,-6.646 -8.309,-5.401 -3.635,1.246 0.935,7.062 9.14,7.789 5.523,0.489 8.776,0.295 10.983,-0.154 -0.191,4.777 -10.879,1.297 -10.879,1.297 0,0 0.52,3.842 10.697,4.985 10.178,1.143 22.228,7.521 25.341,18.071 3.738,12.67 -10.009,17.679 -14.02,9.658 -3.116,-6.231 -0.622,-14.228 -0.622,-14.228 0,0 -14.142,-10.123 -25.866,-12.468 0,0 -1.931,0.828 -3.172,3.172 0,0 -17.379,-3.724 -24,-13.241 -6.621,-9.517 -5.655,-7.31 -7.172,-7.31 -1.517,0 -5.241,3.724 -3.724,8.552 1.517,4.828 7.034,12.552 16.69,15.586 9.656,3.034 16.552,2.483 17.517,4.69 0.966,2.207 0.828,5.379 -5.655,5.379 -6.483,0 -14.759,-0.828 -19.034,-4.828 -4.276,-4 -7.31,-4.69 -8.552,-2.483 -1.241,2.207 -0.69,13.379 12,14.759 12.69,1.379 20.69,-2.207 21.793,-0.138 1.103,2.069 -2.759,7.586 -11.034,8.965 -8.276,1.379 -13.241,-1.517 -16.965,-4 -3.724,-2.483 -6.207,-0.414 -6.483,2.069 -0.276,2.483 3.448,10.621 12.276,10.897 8.828,0.276 18.759,-5.517 20.276,-5.793 1.517,-0.276 4.828,1.793 1.793,4.965 -3.034,3.172 -15.448,9.931 -22.069,8.552 -6.621,-1.379 -7.31,-3.448 -10.207,-2.069 -2.897,1.379 -1.655,9.517 4.414,9.793 6.069,0.276 16.414,-1.931 22.207,-5.655 5.793,-3.724 5.931,0.138 5.517,0.828 -0.414,0.69 -8.414,11.448 -19.862,12.552 -11.448,1.103 -13.793,-0.552 -14.069,3.448 -0.276,4 3.841,8.358 13.977,5.655 11.034,-2.943 18.3,-12.276 20.506,-10.207 2.207,2.069 0.276,7.172 -4.552,10.897 -4.828,3.724 -11.541,10.712 -23.31,9.057 -10.354,-1.455 -7.172,4.736 -6.345,6.115 0.827,1.379 7.862,7.034 17.931,1.103 10.069,-5.931 15.31,-13.655 16.69,-14.207 1.379,-0.552 3.357,-0.552 0.966,5.333 -2.391,5.885 -10.483,16.552 -18.391,18.574 -7.908,2.024 -14.713,0.552 -16.184,4.231 -1.471,3.678 7.54,12.505 18.759,4.965 10.3,-6.922 22.437,-25.012 25.748,-24.828 3.31,0.183 2.788,6.318 0.766,9.444 -2.024,3.127 -11.985,7.659 -11.433,11.337 0.552,3.678 5.7,4.781 11.402,-1.103 5.701,-5.885 7.172,-17.288 9.564,-17.839 2.39,-0.552 7.54,1.472 4.597,6.989 -2.942,5.517 -9.379,9.379 -6.252,11.954 3.126,2.574 7.908,-1.471 10.483,-6.621 2.574,-5.15 4.597,-11.402 6.988,-9.195 2.391,2.207 0.552,10.666 -4.598,16 -5.149,5.333 -21.959,9.601 -21.517,12.138 0.263,1.511 2.067,4.005 4.366,6.538 l -22.159,6.565 -10.069,-7.724 c 0,0 -1.103,-5.241 -7.586,-4.552 0,0 -8,-3.586 -8.828,2.759 0,0 5.793,-0.966 7.172,1.103 1.379,2.069 2.069,3.586 7.172,3.172 l 7.033,5.932 -14.069,-1.655 c 0,0 -2.897,-4.828 -7.724,-1.793 0,0 -6.069,-1.931 -7.586,3.862 0,0 5.241,-0.966 6.621,-0.276 0,0 2.069,4.69 8.69,1.931 l 13.931,0.69 -7.862,3.862 c 0,0 -9.931,-3.172 -9.517,5.103 0,0 -2.897,3.31 -0.276,6.621 0,0 0.552,-3.586 3.172,-5.103 0,0 5.103,2.069 8.414,-4 l 10.069,-6.069 9.931,4.828 c 0,0 -0.276,5.379 7.034,3.172 0,0 2.483,1.655 3.172,3.862 0,0 3.172,-3.448 -1.931,-7.448 0,0 -1.241,-4.69 -7.31,-2.897 l -5.655,-2.897 20.925,-6.209 c 3.623,3.45 7.532,6.279 8.9,5.805 2.7,-0.935 4.778,-3.738 6.646,-7.685 1.869,-3.947 10.282,-17.655 14.436,-17.55 4.154,0.104 6.024,3.426 4.985,9.347 -1.038,5.919 -9.134,17.259 -14.376,19.604 -5.241,2.345 -6.069,3.448 -10.897,3.034 -4.828,-0.414 -6.483,1.655 -5.379,4.414 1.103,2.759 6.534,4.513 11.862,2.483 5.793,-2.207 8,-5.241 10.207,-3.448 2.207,1.793 -2.345,8.276 -8.552,10.207 -6.207,1.931 -10.897,0.69 -9.931,4.552 0.966,3.862 7.586,4.138 11.862,1.655 4.276,-2.483 9.103,-9.379 10.345,-7.172 1.241,2.207 0.414,7.862 -3.724,10.897 -4.138,3.034 -8.845,1.249 -9.793,4 -1.379,4 3.448,6.621 7.172,5.103 3.724,-1.517 8,-6.207 9.931,-10.345 1.931,-4.138 5.517,-0.552 4.414,3.31 -1.103,3.862 -0.184,7.034 -8.093,13.103 l 14.713,22.62 14.713,-22.621 c -7.908,-6.069 -6.988,-9.241 -8.093,-13.103 -1.103,-3.862 2.483,-7.448 4.414,-3.31 1.931,4.138 6.207,8.828 9.931,10.345 3.724,1.517 8.552,-1.103 7.172,-5.103 -0.948,-2.751 -5.655,-0.966 -9.793,-4 -4.138,-3.034 -4.966,-8.69 -3.724,-10.897 1.241,-2.207 6.069,4.69 10.345,7.172 4.276,2.483 10.897,2.207 11.862,-1.655 0.965,-3.862 -3.724,-2.621 -9.931,-4.552 -6.207,-1.931 -10.759,-8.414 -8.552,-10.207 2.207,-1.793 4.414,1.241 10.207,3.448 5.329,2.03 10.759,0.276 11.862,-2.483 1.103,-2.759 -0.552,-4.828 -5.379,-4.414 -4.828,0.414 -5.655,-0.69 -10.897,-3.034 -5.242,-2.344 -13.337,-13.684 -14.376,-19.604 -1.039,-5.92 0.831,-9.244 4.985,-9.347 4.154,-0.105 12.566,13.603 14.436,17.55 1.869,3.947 3.946,6.751 6.646,7.686 1.369,0.474 5.279,-2.355 8.9,-5.805 l 20.925,6.209 -5.655,2.897 c -6.069,-1.793 -7.31,2.897 -7.31,2.897 -5.103,4 -1.931,7.448 -1.931,7.448 0.69,-2.207 3.172,-3.862 3.172,-3.862 7.31,2.207 7.034,-3.172 7.034,-3.172 l 9.931,-4.828 10.069,6.069 c 3.31,6.069 8.414,4 8.414,4 2.621,1.517 3.172,5.103 3.172,5.103 2.621,-3.31 -0.276,-6.621 -0.276,-6.621 0.414,-8.275 -9.517,-5.102 -9.517,-5.102 l -7.866,-3.86 13.931,-0.69 c 6.621,2.759 8.69,-1.931 8.69,-1.931 1.379,-0.69 6.621,0.276 6.621,0.276 -1.518,-5.793 -7.587,-3.862 -7.587,-3.862 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ffb400"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#41479b"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs22" />
    <path
       fill="#ff4b55"
       d="M 512,167.724 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#464655"
       d="M 0,167.724 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path2" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 235.903,182.293 6.036,18.096 19.076,0.148 c 1.478,0.011 2.091,1.898 0.902,2.775 l -15.346,11.332 5.754,18.188 c 0.446,1.409 -1.159,2.574 -2.361,1.716 l -15.52,-11.093 -15.52,11.093 c -1.203,0.86 -2.807,-0.307 -2.361,-1.716 l 5.754,-18.188 -15.346,-11.332 c -1.188,-0.878 -0.576,-2.764 0.902,-2.775 l 19.076,-0.148 6.036,-18.096 c 0.468,-1.401 2.451,-1.401 2.918,0 z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 317.487,335.944 c 0,0 -109.206,-82.384 -112.43,-85.092 -4.983,-4.185 -8.828,-11.586 -9.012,-20.598 0,0 -11.777,12.064 -9.471,24.552 2.667,14.436 10.943,19.586 21.61,26.574 7.496,4.911 67.087,42.495 101.875,64.419 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 350.161,360.091 c -1.423,-1.016 -12.861,-9.47 -28.73,-21.227 l -5.759,10.472 c 11.651,7.341 19.409,12.227 19.409,12.227 0,0 1.103,14.345 12.69,11.954 4.176,-0.862 7.539,-9.747 2.39,-13.426 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 255.863,322.053 c -8.256,2.905 -17.097,4.567 -26.346,4.567 -23.442,0 -44.445,-10.212 -58.987,-26.36 l -12.928,11.635 c 4.333,4.812 8.96,9.347 14.175,13.217 l -2.574,4.459 19.112,11.034 2.53,-4.383 c 8.634,3.755 17.916,6.282 27.638,7.383 v 5.084 h 22.069 v -5.084 c 9.722,-1.101 19.004,-3.628 27.638,-7.383 l 2.53,4.383 7.595,-4.385 c -7.417,-4.677 -15.015,-9.47 -22.452,-14.167 z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="m 325.95,236.138 c -1.101,-9.722 -3.628,-19.004 -7.383,-27.637 l 4.383,-2.53 -11.034,-19.113 -4.459,2.574 c -5.708,-7.691 -12.509,-14.492 -20.201,-20.2 l 2.574,-4.459 -19.112,-11.034 -2.53,4.383 c -7.162,-3.115 -14.788,-5.327 -22.723,-6.639 l -2.9,17.404 c 37.656,6.237 66.4,38.862 66.4,78.286 0,21.228 -8.377,40.464 -21.942,54.717 4.692,3.543 9.349,7.059 13.953,10.535 2.23,-2.442 4.504,-4.847 6.482,-7.511 l 4.459,2.574 11.034,-19.112 -4.383,-2.53 c 3.755,-8.634 6.282,-17.916 7.383,-27.637 h 5.082 V 236.14 h -5.084 z"
       id="path7" />
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="M 512,200.093 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#82afff"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 V 311.909 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#f09146"
       d="m 300.138,165.518 h -31.784 c 0.593,-0.45 1.062,-0.893 1.486,-1.311 0.776,-0.759 1.393,-1.362 3.03,-2.035 1.646,-0.69 2.508,-0.698 3.599,-0.715 1.314,-0.009 2.802,-0.034 5.233,-1.035 2.427,-1.009 3.487,-2.044 4.423,-2.957 0.776,-0.759 1.393,-1.362 3.034,-2.044 1.633,-0.681 2.492,-0.69 3.577,-0.698 1.311,-0.018 2.797,-0.034 5.228,-1.043 l -1.698,-4.07 c -1.633,0.681 -2.492,0.69 -3.577,0.698 -1.311,0.018 -2.797,0.034 -5.224,1.035 -2.426,1.009 -3.487,2.044 -4.423,2.957 -0.776,0.759 -1.393,1.362 -3.03,2.035 -1.646,0.69 -2.508,0.698 -3.599,0.715 -1.314,0.009 -2.802,0.034 -5.233,1.043 -2.426,1 -3.487,2.044 -4.423,2.957 -0.764,0.743 -1.395,1.338 -2.966,2.002 l 24.98,-24.977 -3.121,-3.121 -22.485,22.483 c 0.099,-0.735 0.126,-1.389 0.132,-1.982 0.013,-1.095 0.022,-1.949 0.703,-3.595 0.681,-1.646 1.284,-2.259 2.044,-3.034 0.922,-0.94 1.961,-2.008 2.969,-4.439 1.004,-2.431 1.022,-3.914 1.035,-5.224 0.013,-1.086 0.022,-1.949 0.698,-3.586 0.681,-1.638 1.28,-2.25 2.039,-3.026 0.918,-0.94 1.956,-2.001 2.962,-4.423 l -4.077,-1.689 c -0.681,1.638 -1.28,2.25 -2.039,3.026 -0.918,0.94 -1.956,2.001 -2.962,4.423 -1.004,2.431 -1.022,3.914 -1.035,5.224 -0.013,1.086 -0.022,1.949 -0.698,3.586 -0.681,1.646 -1.284,2.259 -2.044,3.034 -0.922,0.94 -1.961,2.008 -2.969,4.439 -1.004,2.431 -1.022,3.923 -1.038,5.233 -0.009,1.063 -0.039,1.922 -0.676,3.5 v -35.318 h -4.414 v 31.783 c -0.45,-0.589 -0.892,-1.057 -1.306,-1.481 -0.762,-0.776 -1.362,-1.397 -2.044,-3.034 -0.681,-1.646 -0.694,-2.508 -0.707,-3.604 -0.013,-1.311 -0.03,-2.802 -1.038,-5.233 -1.004,-2.422 -2.044,-3.482 -2.962,-4.423 -0.759,-0.776 -1.357,-1.388 -2.039,-3.026 -0.676,-1.638 -0.685,-2.5 -0.698,-3.586 -0.013,-1.311 -0.03,-2.793 -1.035,-5.216 l -4.077,1.689 c 0.676,1.638 0.685,2.492 0.698,3.577 0.013,1.311 0.03,2.793 1.035,5.224 1.004,2.422 2.044,3.482 2.962,4.423 0.759,0.776 1.357,1.388 2.039,3.026 0.681,1.646 0.694,2.508 0.707,3.604 0.013,1.311 0.03,2.802 1.038,5.233 1.004,2.431 2.044,3.491 2.962,4.431 0.748,0.76 1.34,1.395 2.004,2.962 l -24.982,-24.979 -3.121,3.121 24.943,24.94 c -1.368,-0.621 -2.028,-1.192 -2.745,-1.888 -0.943,-0.922 -2.008,-1.965 -4.448,-2.974 -2.431,-1 -3.918,-1.026 -5.233,-1.043 -1.095,-0.009 -1.956,-0.025 -3.616,-0.715 -1.66,-0.681 -2.28,-1.284 -3.069,-2.051 -0.943,-0.914 -2.013,-1.956 -4.457,-2.974 -2.44,-1.009 -3.932,-1.026 -5.25,-1.043 -1.099,-0.018 -1.965,-0.034 -3.625,-0.724 l -1.689,4.086 c 2.44,1.009 3.932,1.026 5.25,1.043 1.099,0.018 1.965,0.034 3.625,0.724 1.664,0.681 2.284,1.284 3.073,2.051 0.943,0.922 2.013,1.956 4.452,2.966 2.44,1.017 3.932,1.035 5.246,1.052 1.095,0.018 1.956,0.025 3.608,0.715 1.651,0.681 2.268,1.284 3.048,2.044 0.401,0.393 0.849,0.809 1.391,1.233 H 211.86 v 4.414 h 35.254 c -1.393,0.53 -2.264,0.597 -3.263,0.612 -1.314,0.009 -2.802,0.034 -5.237,1.035 -2.435,1.009 -3.505,2.051 -4.448,2.966 -0.785,0.767 -1.401,1.37 -3.052,2.051 -1.66,0.69 -2.526,0.707 -3.625,0.724 -1.319,0.018 -2.81,0.034 -5.25,1.043 -2.444,1.017 -3.513,2.051 -4.457,2.974 -0.789,0.767 -1.409,1.37 -3.069,2.051 l 1.689,4.086 c 2.44,-1.017 3.509,-2.051 4.452,-2.974 0.789,-0.767 1.409,-1.37 3.073,-2.051 1.66,-0.69 2.526,-0.707 3.625,-0.724 1.319,-0.018 2.81,-0.034 5.255,-1.052 2.431,-1.009 3.496,-2.044 4.439,-2.966 0.78,-0.759 1.401,-1.362 3.057,-2.044 1.646,-0.69 2.513,-0.698 3.604,-0.715 0.558,-0.003 1.187,-0.04 1.868,-0.124 l -22.549,22.546 3.121,3.121 24.931,-24.927 c -0.614,1.362 -1.181,2.019 -1.879,2.738 -0.918,0.94 -1.956,2.008 -2.966,4.439 -1.01,2.431 -1.031,3.932 -1.043,5.241 -0.018,1.095 -0.025,1.956 -0.712,3.612 -0.685,1.664 -1.293,2.284 -2.056,3.069 -0.922,0.94 -1.961,2.017 -2.974,4.457 -1.013,2.44 -1.031,3.932 -1.047,5.25 -0.018,1.095 -0.03,1.965 -0.715,3.62 l 4.077,1.689 c 1.013,-2.44 1.031,-3.932 1.047,-5.25 0.018,-1.095 0.03,-1.965 0.715,-3.62 0.685,-1.664 1.293,-2.284 2.056,-3.069 0.922,-0.94 1.961,-2.017 2.974,-4.457 1.009,-2.431 1.031,-3.932 1.043,-5.241 0.018,-1.095 0.025,-1.956 0.712,-3.612 0.681,-1.655 1.284,-2.268 2.047,-3.052 0.392,-0.402 0.809,-0.851 1.233,-1.395 v 31.878 h 4.414 V 176.61 c 0.526,1.39 0.593,2.259 0.608,3.261 0.013,1.311 0.034,2.802 1.043,5.233 1.004,2.44 2.047,3.509 2.966,4.448 0.762,0.785 1.366,1.405 2.051,3.06 0.685,1.655 0.698,2.526 0.715,3.62 0.018,1.319 0.034,2.81 1.047,5.25 1.013,2.44 2.051,3.518 2.974,4.457 0.762,0.785 1.37,1.405 2.056,3.069 l 4.077,-1.689 c -1.013,-2.44 -2.051,-3.518 -2.974,-4.457 -0.762,-0.785 -1.37,-1.405 -2.056,-3.069 -0.685,-1.655 -0.698,-2.526 -0.715,-3.62 -0.018,-1.319 -0.034,-2.81 -1.047,-5.25 -1.009,-2.44 -2.047,-3.509 -2.966,-4.448 -0.762,-0.785 -1.366,-1.405 -2.051,-3.06 -0.685,-1.646 -0.694,-2.508 -0.712,-3.604 -0.006,-0.557 -0.042,-1.187 -0.126,-1.868 l 22.552,22.55 3.121,-3.121 -22.482,-22.478 c 0.73,0.097 1.384,0.126 1.973,0.134 1.09,0.009 1.949,0.018 3.595,0.698 1.646,0.69 2.263,1.284 3.043,2.051 0.94,0.914 2.004,1.956 4.436,2.966 2.427,1 3.914,1.017 5.224,1.026 1.086,0.018 1.944,0.025 3.582,0.707 1.638,0.672 2.25,1.276 3.026,2.035 0.94,0.914 2.001,1.956 4.427,2.966 l 1.689,-4.086 c -1.638,-0.672 -2.25,-1.276 -3.026,-2.035 -0.94,-0.914 -2.001,-1.956 -4.427,-2.966 -2.426,-1 -3.914,-1.017 -5.224,-1.026 -1.086,-0.018 -1.944,-0.025 -3.582,-0.707 -1.646,-0.681 -2.263,-1.276 -3.043,-2.044 -0.94,-0.914 -2.004,-1.956 -4.436,-2.957 -2.431,-1.017 -3.918,-1.035 -5.233,-1.043 -1.07,-0.018 -1.937,-0.038 -3.524,-0.681 h 35.35 v -4.414 z"
       id="path3" />
    <circle
       fill="#ffe15a"
       cx="256"
       cy="167.72501"
       r="22.07"
       id="circle3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs29" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 512,326.62 v -9.751 L 56.713,167.724 512,18.579 V 8.828 c 0,-3.192 -1.783,-5.861 -4.321,-7.412 L 0,167.724 507.679,334.032 c 2.538,-1.55 4.321,-4.219 4.321,-7.412 z"
       id="path2" />
    <polygon
       fill="#f5f5f5"
       points="512,106.855 56.713,256 512,405.145 "
       id="polygon2"
       transform="translate(0,-88.276)" />
    <path
       fill="#fff5dc"
       d="m 458.102,124.28 c 0,0 30.229,1.281 33.047,-1.025 2.818,-2.305 3.33,-17.676 -6.66,-19.981 -9.99,-2.305 -37.145,12.553 -37.145,12.553 z"
       id="path3" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#d27d69"
       d="m 398.925,236.381 c 0,0 -0.342,0.854 -0.512,4.611 -0.171,3.757 0.512,13.492 12.297,17.761 l -2.732,11.443 12.467,7.514 c 0,0 9.223,-13.663 9.735,-25.106 0.511,-11.441 -31.255,-16.223 -31.255,-16.223 z"
       id="path4" />
    	<path
       fill="#d27d69"
       d="m 361.524,228.695 4.867,-4.867 c 0,0 -9.964,6.079 -13.748,0.598 -4.952,-7.172 1.708,-14.687 8.625,-18.018 6.916,-3.33 20.75,-0.768 20.75,-0.768 l 8.71,22.287 -26.386,16.651 z"
       id="path5" />
    	<path
       fill="#d27d69"
       d="m 443.244,186.171 23.569,-2.818 c 0,0 -6.916,9.991 -20.494,17.42 0,0 14.09,0 18.188,4.867 4.099,4.867 -4.099,9.479 -7.172,11.016 -3.074,1.537 -29.716,17.932 -29.716,17.932 l -23.824,-2.818 z"
       id="path6" />
    	<path
       fill="#d27d69"
       d="m 460.749,168.068 c 0,0 5.123,-11.955 4.952,-20.323 L 448.452,159.7 c 0,0 3.928,-1.878 2.562,-8.71 l -56.358,30.57 -11.443,20.323 34.84,10.76 z"
       id="path7" />
    </g>
    <path
       fill="#ffe15a"
       d="m 418.267,172.954 -5.892,9.351 c 0,0 -10.504,-2.305 -14.09,0.256 -3.586,2.562 -3.97,12.169 2.305,12.937 0,0 4.355,2.69 6.916,0.512 0,0 5.251,2.049 6.148,-1.281 0.897,-3.33 -0.256,-6.148 -0.256,-6.148 h 3.714 l 6.532,-11.656 z"
       id="path8" />
    <path
       fill="#b95546"
       d="m 365.623,152.716 c 0,0 16.395,-8.197 16.395,-20.494 0,-12.297 -15.2,-12.98 -27.496,-8.881 0,0 -7.343,-5.806 -1.195,-11.614 8.428,-7.96 45.087,-24.592 45.087,-24.592 l -4.099,20.494 c 0,0 14.602,7.685 20.494,4.099 4.951,-3.014 53.284,-40.988 53.284,-40.988 0,0 -4.099,20.494 -32.79,40.988 l -3.04,15.201 c -0.668,3.34 -2.84,6.184 -5.887,7.706 l -11.567,5.783 c 0,0 32.79,4.099 32.79,8.197 0,4.098 -8.197,24.593 -24.592,32.79 l -8.198,-8.197 4.099,-12.297 c 0,0 -12.297,-4.099 -20.494,-8.198 0,0 -12.297,4.099 -20.494,4.099 -8.197,0 -12.297,-4.096 -12.297,-4.096 z"
       id="path9" />
    <path
       fill="#fff5dc"
       d="m 341.031,173.21 v -8.516 c 0,-2.42 0.961,-4.742 2.673,-6.453 l 17.822,-17.822 4.099,8.197 h 16.395 l -4.099,4.099 v 4.099 l -20.494,12.297 z"
       id="path10" />
    <g
       id="g14"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 349.229,257.387 h -8.198 c 0,0 -8.197,12.297 0,12.297 0,0 12.297,-8.198 16.395,-12.297 0,0 0,-4.098 -8.197,0 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 449.21,275.57 h -56.663 c -0.467,-0.503 -1.12,-0.828 -1.86,-0.828 0,0 -9.925,-4.114 -11.337,-4.114 h -1.163 c -1.411,0 -2.556,1.144 -2.556,2.556 v 2.386 h -12.953 v -2.386 c 0,-1.411 -1.144,-2.556 -2.556,-2.556 h -1.163 c -1.411,0 -2.556,1.144 -2.556,2.556 v 0.043 c -5.551,-0.226 -17.42,-0.934 -23.569,-2.983 l -32.79,8.198 32.79,8.197 c 6.147,-2.049 18.016,-2.758 23.569,-2.984 v 0.043 c 0,1.411 1.144,2.556 2.556,2.556 h 1.163 c 1.411,0 2.556,-1.144 2.556,-2.556 v -2.386 h 12.953 v 2.386 c 0,1.411 1.144,2.556 2.556,2.556 h 1.163 c 1.411,0 11.337,-4.114 11.337,-4.114 0.74,0 1.394,-0.324 1.86,-0.828 h 56.663 c 1.587,0 2.872,-1.287 2.872,-2.872 0,-1.585 -1.286,-2.87 -2.872,-2.87 z"
       id="path12" />
    	<path
       fill="#ffe15a"
       d="m 446.746,286.591 c -3.416,-0.683 -42.525,6.148 -42.525,6.148 0,0 -2.391,-2.391 4.781,-9.052 l -3.415,-0.854 c 0,0 -7.514,5.294 -10.589,5.977 -2.647,0.588 -8.562,3.464 -9.833,7.303 l -23.812,3.969 0.512,2.049 23.357,-2.738 c 1.114,3.588 4.786,4.32 7.384,3.25 0,0 3.416,1.366 6.49,-1.025 0,0 6.148,1.025 6.489,-4.611 l 42.867,-6.49 c 10e-4,0.003 1.709,-3.243 -1.706,-3.926 z"
       id="path13" />
    	<path
       fill="#ffe15a"
       d="m 422.494,315.454 c 0,0 -3.245,4.269 -11.272,0.512 -8.026,-3.757 -17.42,0.342 -22.543,-0.854 -5.123,-1.196 -12.809,-4.269 -19.981,-1.537 -7.172,2.732 -11.101,2.562 -9.564,-0.854 1.537,-3.415 2.391,-5.977 0,-7.172 l 2.732,-3.416 -0.512,-2.049 c 0,0 -13.663,-5.294 -22.884,2.049 -9.223,7.343 -6.489,24.081 8.881,25.276 0,0 4.782,5.977 16.566,4.269 0,0 7.685,5.294 20.835,2.903 0,0 0.512,1.537 9.052,0.854 8.54,-0.683 18.103,0.342 16.395,6.148 0,0 6.319,-1.195 2.562,-7.002 0,0 7.514,-0.342 12.638,4.099 0,0 0.342,-5.123 -4.611,-7.857 0,0 8.369,-2.903 12.98,0 0,0 -3.074,-6.489 -11.272,-5.636 0,0 5.977,-4.782 8.71,-3.586 0,0 -2.562,-3.074 -10.077,0 -0.001,10e-4 4.781,-2.902 1.365,-6.147 z"
       id="path14" />
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="M 512,200.093 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#ff4b55"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 V 311.909 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AU = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs27" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0.001 h -15.334 l -81.77,53.574 V 0.001 H 105.93 V 53.575 L 24.16,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.002 c 0,4.875 3.953,8.828 8.828,8.828 h 15.334 l 81.77,-53.574 v 53.574 h 44.138 v -53.574 l 81.769,53.574 h 15.334 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 L 185.846,105.932 H 256 V 61.794 H 185.845 L 256,15.831 V 8.829 c 0,-4.876 -3.953,-8.828 -8.828,-8.828 z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.277 114.759,88.277 114.759,158.898 0,158.898 0,185.38 114.759,185.38 114.759,256.001 141.241,256.001 141.241,185.38 256,185.38 256,158.898 141.241,158.898 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.07 4.207,89.769 C 1.735,91.333 0,93.962 0,97.104 v 0.458 l 80.889,52.508 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.07 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.208 1.269,251.464 c 1.521,2.662 4.273,4.537 7.559,4.537 h 1.665 l 95.196,-61.793 H 89.474 Z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.86,247.866 173.194,194.208 H 156.98 l 93.874,60.935 c 2.812,-1.305 4.741,-4.04 5.006,-7.277 z"
       id="path6" />
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 130.671,304.131 6.663,21.997 21.353,-8.505 c 1.822,-0.726 3.478,1.352 2.366,2.966 l -13.044,18.924 19.962,11.391 c 1.703,0.972 1.112,3.562 -0.844,3.699 l -22.929,1.601 3.541,22.71 c 0.302,1.938 -2.092,3.091 -3.418,1.646 l -15.548,-16.928 -15.548,16.928 c -1.326,1.444 -3.72,0.291 -3.418,-1.646 l 3.541,-22.71 -22.929,-1.601 c -1.956,-0.137 -2.547,-2.727 -0.844,-3.699 l 19.962,-11.391 -13.044,-18.924 c -1.112,-1.614 0.544,-3.692 2.366,-2.966 l 21.353,8.505 6.663,-21.997 c 0.571,-1.877 3.228,-1.877 3.796,0 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 393.279,147.73 3.255,10.745 10.43,-4.154 c 0.889,-0.354 1.699,0.66 1.155,1.449 l -6.371,9.245 9.751,5.565 c 0.832,0.474 0.543,1.74 -0.413,1.806 l -11.2,0.782 1.729,11.093 c 0.148,0.947 -1.022,1.51 -1.67,0.804 l -7.595,-8.269 -7.595,8.269 c -0.648,0.705 -1.817,0.142 -1.67,-0.804 l 1.729,-11.093 -11.2,-0.782 c -0.956,-0.066 -1.245,-1.332 -0.413,-1.806 l 9.751,-5.565 -6.371,-9.245 c -0.544,-0.789 0.266,-1.803 1.155,-1.449 l 10.43,4.154 3.255,-10.745 c 0.282,-0.917 1.581,-0.917 1.858,0 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 320.702,230.206 3.255,10.745 10.43,-4.154 c 0.889,-0.354 1.699,0.66 1.155,1.449 l -6.371,9.245 9.751,5.565 c 0.832,0.474 0.543,1.74 -0.413,1.806 l -11.2,0.782 1.729,11.093 c 0.148,0.947 -1.022,1.51 -1.67,0.804 l -7.595,-8.269 -7.595,8.269 c -0.648,0.705 -1.817,0.142 -1.67,-0.804 l 1.729,-11.093 -11.2,-0.782 c -0.956,-0.066 -1.245,-1.332 -0.413,-1.806 l 9.751,-5.565 -6.371,-9.245 c -0.544,-0.789 0.266,-1.803 1.155,-1.449 l 10.43,4.154 3.255,-10.745 c 0.282,-0.917 1.58,-0.917 1.858,0 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 461.943,194.895 3.255,10.745 10.43,-4.154 c 0.889,-0.354 1.699,0.66 1.155,1.449 l -6.371,9.245 9.751,5.565 c 0.832,0.474 0.543,1.74 -0.413,1.806 l -11.2,0.782 1.729,11.093 c 0.148,0.947 -1.022,1.51 -1.669,0.804 l -7.595,-8.269 -7.595,8.269 c -0.648,0.705 -1.817,0.142 -1.67,-0.804 l 1.729,-11.093 -11.2,-0.782 c -0.956,-0.066 -1.245,-1.332 -0.413,-1.806 l 9.751,-5.565 -6.371,-9.245 c -0.544,-0.789 0.266,-1.803 1.155,-1.449 l 10.43,4.154 3.255,-10.745 c 0.281,-0.917 1.579,-0.917 1.857,0 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 393.279,336.137 3.255,10.745 10.43,-4.155 c 0.889,-0.354 1.699,0.66 1.155,1.449 l -6.371,9.245 9.751,5.565 c 0.832,0.474 0.543,1.74 -0.413,1.806 l -11.2,0.782 1.729,11.093 c 0.148,0.947 -1.022,1.51 -1.67,0.804 l -7.595,-8.269 -7.595,8.269 c -0.648,0.705 -1.817,0.142 -1.67,-0.804 l 1.729,-11.093 -11.2,-0.782 c -0.956,-0.066 -1.245,-1.332 -0.413,-1.806 l 9.751,-5.565 -6.371,-9.245 c -0.544,-0.789 0.266,-1.803 1.155,-1.449 l 10.43,4.155 3.255,-10.745 c 0.282,-0.917 1.581,-0.917 1.858,0 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 418.461,249.514 -2.613,7.836 -8.259,0.064 c -1.069,0.009 -1.513,1.373 -0.652,2.008 l 6.644,4.907 -2.492,7.875 c -0.322,1.02 0.839,1.863 1.708,1.241 l 6.72,-4.803 6.72,4.803 c 0.87,0.622 2.03,-0.222 1.708,-1.241 l -2.492,-7.875 6.644,-4.907 c 0.861,-0.636 0.417,-1.999 -0.652,-2.008 l -8.259,-0.064 -2.613,-7.836 c -0.339,-1.015 -1.774,-1.015 -2.112,0 z"
       id="path12" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#4173cd"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<rect
       y="317.79001"
       fill="#ffe15a"
       width="512"
       height="17.655001"
       id="rect1"
       x="0" />
    	<rect
       y="353.10001"
       fill="#ffe15a"
       width="512"
       height="17.655001"
       id="rect2"
       x="0" />
    </g>
    <polygon
       fill="#ff4b55"
       points="65.232,153.509 76.449,120.665 87.665,153.509 120.513,164.725 87.665,175.942 76.449,208.787 65.232,175.942 32.384,164.725 "
       id="polygon2"
       transform="translate(0,-88.276)" />
    <path
       fill="#f5f5f5"
       d="m 76.449,38.291 9.714,28.445 28.445,9.714 -28.445,9.714 -9.714,28.445 L 66.735,86.164 38.29,76.45 66.735,66.736 76.449,38.291 m 0,-11.808 -3.612,10.574 -9.108,26.673 -26.672,9.108 -10.574,3.612 10.574,3.61 26.672,9.108 9.108,26.672 3.612,10.574 3.612,-10.574 9.108,-26.672 26.672,-9.108 10.574,-3.61 L 115.841,72.84 89.169,63.732 80.061,37.06 Z"
       id="path2" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AX = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#4173cd"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#ffe15a"
       points="229.517,88.276 141.241,88.276 141.241,211.862 0,211.862 0,300.138 141.241,300.138 141.241,423.724 229.517,423.724 229.517,300.138 512,300.138 512,211.862 229.517,211.862 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ff4b55"
       points="203.034,88.276 167.724,88.276 167.724,238.345 0,238.345 0,273.655 167.724,273.655 167.724,423.724 203.034,423.724 203.034,273.655 512,273.655 512,238.345 203.034,238.345 "
       id="polygon2"
       transform="translate(0,-88.276)" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const AZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#73af00"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#82afff"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#ff4b55"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 268.04,292.608 c -19.81,0 -35.881,-16.071 -35.881,-35.898 0,-19.792 16.071,-35.898 35.881,-35.898 7.371,0 14.168,2.266 19.832,6.103 0.867,0.588 1.857,-0.553 1.131,-1.308 -8.466,-8.801 -20.448,-14.172 -33.732,-13.718 -22.824,0.779 -41.718,19.077 -43.177,41.868 -1.671,26.104 18.999,47.798 44.735,47.798 12.676,0 24.069,-5.3 32.206,-13.773 0.718,-0.748 -0.274,-1.871 -1.132,-1.289 -5.67,3.846 -12.479,6.115 -19.863,6.115 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 299.452,234.611 3.723,10.467 10.034,-4.769 c 0.756,-0.36 1.545,0.429 1.185,1.185 l -4.769,10.034 10.467,3.723 c 0.789,0.28 0.789,1.396 0,1.676 l -10.467,3.723 4.769,10.034 c 0.36,0.756 -0.429,1.545 -1.185,1.185 l -10.034,-4.769 -3.723,10.467 c -0.28,0.789 -1.396,0.789 -1.676,0 l -3.723,-10.467 -10.034,4.769 c -0.756,0.36 -1.545,-0.429 -1.185,-1.185 l 4.769,-10.034 -10.467,-3.723 c -0.789,-0.28 -0.789,-1.396 0,-1.676 l 10.467,-3.723 -4.769,-10.034 c -0.36,-0.756 0.429,-1.545 1.185,-1.185 l 10.034,4.769 3.723,-10.467 c 0.281,-0.788 1.396,-0.788 1.676,0 z"
       id="path4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs26" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#ffe15a"
       points="105.931,88.276 441.378,88.276 441.378,423.724 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <g
       id="g11"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 207.353,213.176 5.088,15.254 16.079,0.125 c 1.246,0.01 1.762,1.599 0.76,2.339 l -12.936,9.553 4.851,15.331 c 0.376,1.187 -0.977,2.17 -1.991,1.446 l -13.082,-9.351 -13.082,9.351 c -1.013,0.724 -2.366,-0.258 -1.991,-1.446 l 4.851,-15.331 -12.936,-9.553 c -1.002,-0.74 -0.486,-2.329 0.76,-2.339 l 16.079,-0.125 5.088,-15.254 c 0.396,-1.181 2.067,-1.181 2.462,0 z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 170.571,176.395 5.088,15.254 16.079,0.125 c 1.246,0.01 1.762,1.6 0.76,2.339 l -12.936,9.553 4.851,15.331 c 0.376,1.187 -0.977,2.17 -1.991,1.446 l -13.082,-9.351 -13.082,9.351 c -1.013,0.725 -2.366,-0.258 -1.991,-1.446 l 4.851,-15.331 -12.936,-9.553 c -1.002,-0.74 -0.486,-2.329 0.76,-2.339 l 16.079,-0.125 5.088,-15.254 c 0.396,-1.182 2.068,-1.182 2.462,0 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 133.79,139.613 5.088,15.254 16.079,0.125 c 1.246,0.01 1.762,1.599 0.76,2.339 l -12.936,9.553 4.851,15.331 c 0.376,1.187 -0.977,2.17 -1.991,1.446 l -13.082,-9.351 -13.082,9.351 c -1.013,0.725 -2.366,-0.258 -1.991,-1.446 l 4.851,-15.331 -12.936,-9.553 c -1.002,-0.74 -0.486,-2.329 0.76,-2.339 l 16.079,-0.125 5.088,-15.254 c 0.396,-1.182 2.068,-1.182 2.462,0 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 97.008,102.832 5.088,15.254 16.079,0.125 c 1.246,0.01 1.762,1.599 0.76,2.339 l -12.935,9.552 4.851,15.331 c 0.376,1.187 -0.977,2.17 -1.991,1.446 l -13.082,-9.351 -13.082,9.351 c -1.013,0.724 -2.366,-0.258 -1.991,-1.446 L 85.556,130.102 72.62,120.55 c -1.002,-0.74 -0.486,-2.329 0.76,-2.339 l 16.079,-0.125 5.088,-15.254 c 0.395,-1.182 2.066,-1.182 2.461,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 354.479,360.303 5.088,15.254 16.079,0.125 c 1.246,0.01 1.762,1.599 0.76,2.339 l -12.936,9.553 4.851,15.331 c 0.376,1.187 -0.977,2.171 -1.99,1.446 L 353.249,395 l -13.082,9.351 c -1.013,0.725 -2.366,-0.258 -1.991,-1.446 l 4.851,-15.331 -12.936,-9.553 c -1.002,-0.74 -0.486,-2.329 0.76,-2.339 l 16.079,-0.125 5.088,-15.254 c 0.395,-1.182 2.067,-1.182 2.461,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 317.698,323.521 5.088,15.254 16.079,0.125 c 1.246,0.01 1.762,1.599 0.76,2.339 l -12.936,9.553 4.851,15.331 c 0.376,1.187 -0.977,2.171 -1.99,1.446 l -13.082,-9.351 -13.082,9.351 c -1.013,0.724 -2.366,-0.258 -1.991,-1.446 l 4.851,-15.331 -12.936,-9.553 c -1.002,-0.74 -0.486,-2.329 0.76,-2.339 l 16.079,-0.125 5.088,-15.254 c 0.395,-1.182 2.067,-1.182 2.461,0 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 280.915,286.74 5.088,15.254 16.079,0.125 c 1.246,0.01 1.762,1.599 0.76,2.339 l -12.936,9.553 4.851,15.331 c 0.376,1.187 -0.977,2.171 -1.991,1.445 l -13.082,-9.351 -13.082,9.351 c -1.013,0.724 -2.366,-0.258 -1.991,-1.445 l 4.851,-15.331 -12.936,-9.553 c -1.002,-0.74 -0.486,-2.329 0.76,-2.339 l 16.079,-0.125 5.088,-15.254 c 0.397,-1.181 2.068,-1.181 2.462,0 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 244.134,249.958 5.088,15.254 16.079,0.125 c 1.246,0.01 1.762,1.599 0.76,2.339 l -12.936,9.553 4.851,15.331 c 0.376,1.187 -0.977,2.171 -1.991,1.446 l -13.082,-9.351 -13.082,9.351 c -1.013,0.724 -2.366,-0.258 -1.991,-1.446 l 4.851,-15.331 -12.936,-9.553 c -1.002,-0.74 -0.486,-2.329 0.76,-2.339 l 16.079,-0.125 5.088,-15.254 c 0.396,-1.182 2.068,-1.182 2.462,0 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 41.944,88.276 6.83,5.044 -4.851,15.331 c -0.375,1.187 0.977,2.17 1.991,1.447 l 13.081,-9.351 13.082,9.351 c 1.013,0.724 2.366,-0.258 1.99,-1.447 L 69.217,93.32 76.05,88.276 Z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 412.427,412.464 -16.079,-0.125 -5.087,-15.254 c -0.394,-1.182 -2.066,-1.182 -2.46,0 l -5.087,15.254 -16.079,0.125 c -1.246,0.01 -1.762,1.6 -0.76,2.339 l 12.083,8.921 h 22.151 l 12.082,-8.921 c 0.998,-0.74 0.482,-2.33 -0.764,-2.339 z"
       id="path11" />
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BB = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#41479b"
       d="M 170.667,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#ffe15a"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 341.333 V 0 H 503.172 C 508.047,0 512,3.953 512,8.828 V 326.62 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <path
       fill="#464655"
       d="m 326.62,118.98 c 0,0 -24.564,0 -42.987,18.423 h 12.281 c 0,0 -11.898,21.493 -18.039,58.339 L 265.21,193.674 V 137.22 l 12.281,4.021 -21.492,-52.965 -21.493,52.965 12.281,-4.095 v 56.527 l -12.665,2.068 c -6.141,-36.845 -18.039,-58.339 -18.039,-58.339 h 12.281 C 209.942,118.98 185.378,118.98 185.378,118.98 c 30.704,36.845 30.704,98.255 30.704,98.255 l 30.704,-5.117 v 41.963 h 18.423 v -41.963 l 30.704,5.117 c 0.002,10e-4 0.002,-61.408 30.707,-98.255 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const BD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs15" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <circle
       fill="#ff4b55"
       cx="220.69"
       cy="167.724"
       r="114.76"
       id="circle1" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#464655"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#ffe15a"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const BF = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ff4b55"
       d="M 512,167.724 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 0,167.724 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path2" />
    <path
       fill="#ffe15a"
       d="m 258.685,119.58 11.106,33.3 35.102,0.273 c 2.72,0.021 3.847,3.491 1.66,5.107 l -28.238,20.853 10.589,33.469 c 0.82,2.593 -2.132,4.738 -4.344,3.156 l -28.559,-20.413 -28.558,20.413 c -2.212,1.581 -5.165,-0.564 -4.344,-3.156 L 233.688,179.113 205.45,158.26 c -2.188,-1.615 -1.06,-5.086 1.66,-5.107 l 35.102,-0.273 11.106,-33.3 c 0.857,-2.58 4.507,-2.58 5.367,0 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#73af00"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BH = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 511.999 335.448" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#f5f5f5"
       d="M 211.862,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 203.034 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 141.241,0.001 70.621,20.965 -70.621,20.965 70.621,20.965 -70.621,20.965 70.621,20.965 -70.621,20.965 70.621,20.965 -70.621,20.965 70.621,20.965 -70.621,20.965 70.621,20.965 -70.621,20.965 70.621,20.965 -70.621,20.965 70.621,20.965 -70.621,20.965 h 361.93 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 511.999,3.953 508.046,0 503.171,0 h -361.93 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.55" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#73af00"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 512,3.953 508.047,0 503.172,0 Z"
       id="path1" />
    <g
       id="g2"
       transform="translate(0,-88.225)">
    	<polygon
       fill="#ff4b55"
       points="471.733,88.225 40.266,88.225 255.999,229.568 "
       id="polygon1" />
    	<polygon
       fill="#ff4b55"
       points="40.266,423.775 471.733,423.775 255.999,282.432 "
       id="polygon2" />
    </g>
    <path
       fill="#f5f5f5"
       d="M 512,8.828 C 512,3.953 508.047,0 503.172,0 H 471.734 L 307.696,107.473 C 293.796,95.536 275.76,88.277 256,88.277 c -19.76,0 -37.796,7.258 -51.696,19.196 L 40.266,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 26.382 L 180.058,144.35 c -2.272,7.391 -3.507,15.239 -3.507,23.374 0,8.136 1.235,15.982 3.507,23.374 L 0,309.067 v 17.554 c 0,4.875 3.953,8.828 8.828,8.828 H 40.266 L 204.303,227.977 c 13.9,11.937 31.936,19.197 51.696,19.197 19.76,0 37.796,-7.258 51.696,-19.197 l 164.037,107.472 h 31.438 c 4.875,0 8.828,-3.953 8.828,-8.828 V 309.067 L 331.941,191.099 c 2.272,-7.391 3.507,-15.239 3.507,-23.374 0,-8.136 -1.235,-15.982 -3.507,-23.374 L 511.999,26.383 Z"
       id="path2" />
    <polygon
       fill="#ff4b55"
       points="244.56,220.639 238.31,210.424 250.28,210.734 255.999,200.209 261.72,210.734 273.69,210.424 267.439,220.639 273.69,230.855 261.72,230.545 255.999,241.07 250.28,230.545 238.31,230.855 "
       id="polygon3"
       transform="translate(0,-88.225)" />
    <path
       fill="#73af00"
       d="m 255.999,114.759 4.943,9.092 10.346,-0.265 -5.402,8.828 5.402,8.828 -10.346,-0.265 -4.943,9.092 -4.943,-9.092 -10.346,0.265 5.402,-8.828 -5.402,-8.828 10.346,0.265 4.943,-9.092 m 0,-5.544 -2.327,4.279 -4.169,7.669 -8.726,-0.224 -4.869,-0.125 2.542,4.156 4.557,7.445 -4.557,7.445 -2.542,4.156 4.869,-0.125 8.726,-0.224 4.169,7.669 2.327,4.279 2.327,-4.279 4.169,-7.669 8.726,0.224 4.87,0.125 -2.542,-4.156 -4.557,-7.445 4.557,-7.445 2.542,-4.156 -4.87,0.125 -8.726,0.224 -4.169,-7.669 z"
       id="path3" />
    <polygon
       fill="#ff4b55"
       points="211.686,279.149 205.436,268.934 217.406,269.244 223.126,258.718 228.846,269.244 240.815,268.934 234.565,279.149 240.815,289.365 228.846,289.054 223.126,299.579 217.406,289.054 205.436,289.365 "
       id="polygon4"
       transform="translate(0,-88.225)" />
    <path
       fill="#73af00"
       d="m 223.126,173.269 4.943,9.092 10.346,-0.265 -5.402,8.828 5.402,8.828 -10.346,-0.265 -4.943,9.092 -4.943,-9.092 -10.346,0.265 5.402,-8.828 -5.402,-8.828 10.346,0.265 4.943,-9.092 m 0,-5.545 -2.327,4.279 -4.169,7.669 -8.726,-0.224 -4.87,-0.125 2.542,4.156 4.557,7.445 -4.557,7.445 -2.542,4.156 4.87,-0.125 8.726,-0.224 4.169,7.669 2.327,4.279 2.327,-4.279 4.169,-7.669 8.726,0.224 4.87,0.125 -2.542,-4.156 -4.557,-7.445 4.557,-7.445 2.542,-4.156 -4.87,0.125 -8.726,0.224 -4.169,-7.669 z"
       id="path4" />
    <polygon
       fill="#ff4b55"
       points="277.434,279.149 271.184,268.934 283.154,269.244 288.873,258.718 294.594,269.244 306.564,268.934 300.314,279.149 306.564,289.365 294.594,289.054 288.873,299.579 283.154,289.054 271.184,289.365 "
       id="polygon5"
       transform="translate(0,-88.225)" />
    <path
       fill="#73af00"
       d="m 288.873,173.269 4.943,9.092 10.346,-0.265 -5.402,8.828 5.402,8.828 -10.346,-0.265 -4.943,9.092 -4.943,-9.092 -10.346,0.265 5.402,-8.828 -5.402,-8.828 10.346,0.265 4.943,-9.092 m 0,-5.545 -2.327,4.279 -4.169,7.669 -8.726,-0.224 -4.87,-0.125 2.542,4.156 4.557,7.445 -4.557,7.445 -2.542,4.156 4.87,-0.125 8.726,-0.224 4.169,7.669 2.327,4.279 2.327,-4.279 4.169,-7.669 8.726,0.224 4.87,0.125 -2.542,-4.156 -4.557,-7.445 4.557,-7.445 2.542,-4.156 -4.87,0.125 -8.726,0.224 -4.169,-7.669 z"
       id="path5" />
    <g
       id="g5"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.225)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.225)">
    </g>
  </svg>
);

export const BJ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45403" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ffe15a"
       d="M 512,167.73 H 0 V 8.834 C 0,3.959 3.953,0.006 8.828,0.006 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 0,167.73 h 512 v 158.896 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.454 0,331.501 0,326.626 Z"
       id="path2" />
    <path
       fill="#73af00"
       d="M 170.667,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const BL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs39" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffecd7"
       d="m 208.865,322.147 c -20.38,-4.652 -38.549,-15.174 -52.606,-29.714 v 31.097 c 15.339,11.188 33.236,19.028 52.606,22.613 z"
       id="path2" />
    	<path
       fill="#ffecd7"
       d="m 303.085,322.147 c 20.38,-4.652 38.549,-15.174 52.606,-29.714 v 31.097 c -15.339,11.188 -33.236,19.028 -52.606,22.613 z"
       id="path3" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 199.836,254.745 c -0.981,0.196 -2.356,2.748 -2.748,7.066 -0.393,4.319 -3.14,22.573 -9.03,20.61 -5.889,-1.963 -9.814,-10.6 -9.814,-10.6 L 170,283.795 c 0,0 5.496,-2.159 11.189,0.393 5.693,2.552 7.066,3.926 8.637,2.356 1.57,-1.57 5.3,-6.281 8.244,-5.889 l 3.337,-23.752 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 167.252,293.807 c 0,0 -1.374,11.385 -0.589,12.759 0.786,1.374 22.377,6.477 22.377,6.477 0,0 -6.281,5.103 -6.477,7.852 0,0 -7.656,1.374 -10.403,3.73 l -10.207,-16.881 -0.393,-13.937 h 5.692 z"
       id="path5" />
    </g>
    <path
       fill="#ffecd7"
       d="m 160.43,101.988 0.147,-5.889 c 0,0 -6.92,-0.736 -7.802,14.869 l -2.503,-6.92 c 0,0 -5.153,6.92 -2.061,18.108 l -1.325,1.031 c 0,0 -6.772,-8.98 -10.894,-20.61 0,0 -6.92,5.447 1.177,20.905 l -10.01,-12.661 c 0,0 -5.005,10.6 10.01,23.261 l -14.133,-10.01 c 0,0 -0.883,11.484 12.808,18.844 l -13.692,-7.361 c 0,0 0.441,11.041 16.341,16.489 l -15.017,-2.797 c 0,0 3.802,9.027 14.906,11.463 -2.332,2.603 -4.486,6.101 -5.043,10.62 l 11.189,-6.184 c 0,0 -5.3,5.447 -3.828,12.956 l 17.225,-17.225 -2.354,-1.053 c 13.031,-2.444 10.304,-3.364 10.304,-3.364 0,0 -9.619,-24.733 -3.14,-41.81 6.477,-17.077 12.17,-19.433 12.17,-20.218 0.001,-0.787 -6.967,-1.719 -14.475,7.556 z"
       id="path6" />
    <path
       fill="#ffe15a"
       d="m 173.729,111.9 c 0,0 22.377,23.555 22.77,25.715 0.393,2.159 -2.356,1.767 -2.356,1.767 0,0 -5.496,-7.066 -12.956,-9.814 -7.459,-2.748 -12.366,-11.385 -15.31,-13.347 -2.944,-1.965 7.852,-4.321 7.852,-4.321 z"
       id="path7" />
    <path
       fill="#fff5e1"
       d="m 166.27,117.593 c 2.944,0.981 9.619,-0.393 9.422,-6.477 -0.196,-6.086 -6.281,-8.44 -10.796,-7.066 -4.514,1.374 -12.956,7.656 -7.656,19.826 5.3,12.17 13.152,16.685 14.722,27.089 0,0 -7.066,1.079 -10.796,0.196 -3.206,-0.759 -8.637,-3.337 -7.459,-10.403 1.177,-7.066 3.926,-11.189 1.57,-15.115 -2.356,-3.926 -9.814,-10.796 -9.814,-10.796 0,0 -16.096,41.221 12.956,52.018 0,0 -13.74,13.152 -20.61,25.91 l 4.122,1.177 c 0,0 -7.263,7.852 -11.385,10.796 0,0 13.544,4.711 26.892,-10.6 0,0 3.337,5.496 4.122,11.385 h 5.693 c 0,0 1.963,-9.422 10.993,-17.273 9.03,-7.852 18.194,-19.048 17.273,-29.248 -1.079,-11.974 -10.097,-17.361 -19.482,-24.782 -12.663,-10.012 -9.767,-16.637 -9.767,-16.637 z"
       id="path8" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 312.164,254.745 c 0.981,0.196 2.356,2.748 2.748,7.066 0.393,4.319 3.14,22.573 9.03,20.61 5.889,-1.963 9.815,-10.6 9.815,-10.6 l 8.244,11.974 c 0,0 -5.496,-2.159 -11.189,0.393 -5.693,2.552 -7.066,3.926 -8.637,2.356 -1.57,-1.57 -5.3,-6.281 -8.244,-5.889 l -3.337,-23.752 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="m 344.748,293.807 c 0,0 1.374,11.385 0.589,12.759 -0.786,1.374 -22.377,6.477 -22.377,6.477 0,0 6.281,5.103 6.477,7.852 0,0 7.656,1.374 10.403,3.73 l 10.207,-16.881 0.393,-13.937 h -5.693 v 0 z"
       id="path10" />
    </g>
    <path
       fill="#ffecd7"
       d="m 351.57,101.988 -0.147,-5.889 c 0,0 6.92,-0.736 7.802,14.869 l 2.503,-6.92 c 0,0 5.153,6.92 2.061,18.108 l 1.325,1.031 c 0,0 6.772,-8.98 10.894,-20.61 0,0 6.92,5.447 -1.177,20.905 l 10.01,-12.661 c 0,0 5.005,10.6 -10.01,23.261 l 14.133,-10.01 c 0,0 0.884,11.484 -12.808,18.844 l 13.692,-7.361 c 0,0 -0.441,11.041 -16.341,16.489 l 15.017,-2.797 c 0,0 -3.802,9.027 -14.906,11.463 2.332,2.603 4.486,6.101 5.043,10.62 l -11.189,-6.184 c 0,0 5.3,5.447 3.828,12.956 l -17.225,-17.225 2.354,-1.053 c -13.032,-2.444 -10.304,-3.364 -10.304,-3.364 0,0 9.619,-24.733 3.14,-41.81 -6.478,-17.077 -12.17,-19.433 -12.17,-20.218 -0.001,-0.787 6.967,-1.719 14.475,7.556 z"
       id="path11" />
    <path
       fill="#ffe15a"
       d="m 338.271,111.9 c 0,0 -22.377,23.555 -22.77,25.715 -0.393,2.159 2.356,1.767 2.356,1.767 0,0 5.496,-7.066 12.956,-9.814 7.459,-2.748 12.366,-11.385 15.31,-13.347 2.944,-1.962 -7.852,-4.321 -7.852,-4.321 z"
       id="path12" />
    <path
       fill="#fff5e1"
       d="m 345.73,117.593 c -2.944,0.981 -9.619,-0.393 -9.422,-6.477 0.196,-6.086 6.281,-8.44 10.796,-7.066 4.514,1.374 12.956,7.656 7.656,19.826 -5.3,12.17 -13.152,16.685 -14.722,27.089 0,0 7.066,1.079 10.796,0.196 3.206,-0.759 8.637,-3.337 7.459,-10.403 -1.177,-7.066 -3.926,-11.189 -1.57,-15.115 2.356,-3.926 9.814,-10.796 9.814,-10.796 0,0 16.096,41.221 -12.956,52.018 0,0 13.74,13.152 20.61,25.91 l -4.122,1.177 c 0,0 7.263,7.852 11.385,10.796 0,0 -13.544,4.711 -26.892,-10.6 0,0 -3.337,5.496 -4.122,11.385 h -5.693 c 0,0 -1.963,-9.422 -10.993,-17.273 -9.03,-7.852 -18.194,-19.048 -17.273,-29.248 1.079,-11.974 10.097,-17.361 19.482,-24.782 12.663,-10.012 9.767,-16.637 9.767,-16.637 z"
       id="path13" />
    <rect
       x="199.45"
       y="77.755005"
       fill="#464655"
       width="113.06"
       height="22.77"
       id="rect13" />
    <path
       fill="#41479b"
       d="m 255.976,95.804 h -56.532 c 0,0 0,61.244 0,75.377 0,14.133 9.422,51.821 56.532,65.954 47.11,-14.133 56.532,-51.821 56.532,-65.954 0,-14.133 0,-75.377 0,-75.377 z"
       id="path14" />
    <path
       fill="#ff4b55"
       d="m 199.444,171.181 c 0,3.502 0.585,8.456 2.172,14.133 h 108.721 c 1.587,-5.677 2.172,-10.631 2.172,-14.133 V 142.915 H 199.444 Z"
       id="path15" />
    <g
       id="g18"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#f5f5f5"
       points="255.976,265.581 262.571,268.878 255.976,252.391 249.38,268.878 "
       id="polygon15" />
    	<polygon
       fill="#f5f5f5"
       points="255.976,239.199 249.38,235.902 255.976,252.391 262.571,235.902 "
       id="polygon16" />
    	<polygon
       fill="#f5f5f5"
       points="242.785,252.391 239.487,258.986 255.976,252.391 239.487,245.794 "
       id="polygon17" />
    	<polygon
       fill="#f5f5f5"
       points="269.166,252.391 272.463,245.794 255.976,252.391 272.463,258.986 "
       id="polygon18" />
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 263.382,200.738 c -1.1,0.177 -2.067,0.317 -2.941,0.776 0.992,-2.479 1.692,-4.806 1.076,-6.435 -1.505,-3.985 -4.399,-3.272 -5.514,-6.177 v -0.11 c -0.008,0.022 -0.02,0.034 -0.028,0.055 -0.008,-0.022 -0.02,-0.034 -0.028,-0.055 v 0.11 c -1.114,2.905 -4.009,2.193 -5.514,6.177 -0.616,1.63 0.084,3.955 1.076,6.435 -0.873,-0.459 -1.841,-0.6 -2.942,-0.776 -2.246,-0.36 -5.658,1.976 -4.94,6.467 0.718,4.491 5.928,4.851 5.928,4.851 -0.718,-0.718 -1.347,-1.886 -0.988,-3.144 0.359,-1.258 2.964,-2.335 4.311,1.886 1.347,4.222 -3.233,10.24 -3.233,10.24 1.568,-0.083 2.713,-0.572 3.54,-1.067 -1.087,3.545 2.47,6.289 2.761,6.504 v 0.042 l 0.028,-0.021 c 0.003,0.002 0.028,0.021 0.028,0.021 v -0.042 c 0.291,-0.215 3.848,-2.958 2.761,-6.503 0.826,0.495 1.972,0.983 3.54,1.066 0,0 -4.58,-6.018 -3.233,-10.24 1.347,-4.222 3.953,-3.144 4.311,-1.886 0.36,1.258 -0.269,2.425 -0.988,3.144 0,0 5.209,-0.36 5.928,-4.851 0.72,-4.492 -2.693,-6.827 -4.939,-6.467 z"
       id="path18" />
    	<path
       fill="#ffe15a"
       d="m 298.048,200.738 c -1.1,0.177 -2.067,0.317 -2.941,0.776 0.992,-2.479 1.692,-4.806 1.076,-6.435 -1.505,-3.985 -4.399,-3.272 -5.514,-6.177 v -0.11 c -0.008,0.022 -0.02,0.034 -0.028,0.055 -0.008,-0.022 -0.02,-0.034 -0.028,-0.055 v 0.11 c -1.114,2.905 -4.009,2.193 -5.514,6.177 -0.616,1.63 0.084,3.955 1.076,6.435 -0.873,-0.459 -1.841,-0.6 -2.942,-0.776 -2.246,-0.36 -5.658,1.976 -4.94,6.467 0.718,4.491 5.928,4.851 5.928,4.851 -0.718,-0.718 -1.347,-1.886 -0.988,-3.144 0.36,-1.258 2.964,-2.335 4.311,1.886 1.347,4.221 -3.233,10.24 -3.233,10.24 1.568,-0.083 2.713,-0.572 3.54,-1.067 -1.087,3.545 2.47,6.289 2.761,6.504 v 0.042 l 0.028,-0.021 c 0.003,0.002 0.028,0.021 0.028,0.021 v -0.042 c 0.291,-0.215 3.848,-2.958 2.761,-6.503 0.826,0.495 1.972,0.983 3.54,1.066 0,0 -4.58,-6.018 -3.233,-10.24 1.347,-4.222 3.953,-3.144 4.311,-1.886 0.36,1.258 -0.269,2.425 -0.988,3.144 0,0 5.209,-0.36 5.928,-4.851 0.719,-4.492 -2.693,-6.827 -4.939,-6.467 z"
       id="path19" />
    	<path
       fill="#ffe15a"
       d="m 228.716,200.738 c -1.1,0.177 -2.067,0.317 -2.941,0.776 0.992,-2.479 1.692,-4.806 1.076,-6.435 -1.505,-3.985 -4.399,-3.272 -5.514,-6.177 v -0.11 c -0.008,0.022 -0.02,0.034 -0.028,0.055 -0.008,-0.022 -0.02,-0.034 -0.028,-0.055 v 0.11 c -1.114,2.905 -4.009,2.193 -5.514,6.177 -0.616,1.63 0.084,3.955 1.076,6.435 -0.873,-0.459 -1.841,-0.6 -2.942,-0.776 -2.246,-0.36 -5.658,1.976 -4.94,6.467 0.718,4.491 5.928,4.851 5.928,4.851 -0.718,-0.718 -1.347,-1.886 -0.988,-3.144 0.36,-1.258 2.964,-2.335 4.311,1.886 1.347,4.221 -3.233,10.24 -3.233,10.24 1.568,-0.083 2.713,-0.572 3.54,-1.067 -1.087,3.545 2.47,6.289 2.761,6.504 v 0.042 l 0.028,-0.021 c 0.003,0.002 0.028,0.021 0.028,0.021 v -0.042 c 0.291,-0.215 3.848,-2.958 2.761,-6.503 0.826,0.495 1.972,0.983 3.54,1.066 0,0 -4.58,-6.018 -3.233,-10.24 1.347,-4.222 3.953,-3.144 4.311,-1.886 0.36,1.258 -0.269,2.425 -0.988,3.144 0,0 5.209,-0.36 5.928,-4.851 0.72,-4.492 -2.693,-6.827 -4.939,-6.467 z"
       id="path20" />
    	<path
       fill="#ffe15a"
       d="m 267.032,297.804 c 0,0 -2.519,-0.395 -2.72,2.143 0,0 0,0.29 -0.012,0.693 -0.311,-0.147 -0.65,-0.244 -1.017,-0.244 -1.331,0 -2.41,1.079 -2.41,2.411 0,1.331 1.079,2.41 2.41,2.41 0.106,0 0.196,-0.047 0.298,-0.061 -0.359,1.149 -0.929,2.195 -1.73,2.951 h -3.218 c -0.846,-0.937 -1.103,-2.771 -1.159,-4.099 0.052,0.003 0.092,0.04 0.145,0.04 1.092,0 1.977,-0.886 1.977,-1.977 0,-1.079 -0.866,-1.949 -1.94,-1.97 0.171,-0.292 0.296,-0.615 0.296,-0.978 0,-1.092 -0.885,-1.977 -1.977,-1.977 -1.092,0 -1.977,0.886 -1.977,1.977 0,0.363 0.125,0.685 0.296,0.978 -1.074,0.022 -1.94,0.892 -1.94,1.97 0,1.092 0.886,1.977 1.977,1.977 0.053,0 0.093,-0.035 0.145,-0.04 -0.054,1.329 -0.312,3.162 -1.159,4.099 h -3.218 c -0.801,-0.756 -1.372,-1.803 -1.73,-2.951 0.103,0.013 0.192,0.061 0.298,0.061 1.331,0 2.41,-1.079 2.41,-2.41 0,-1.331 -1.079,-2.411 -2.41,-2.411 -0.367,0 -0.706,0.096 -1.017,0.244 -0.012,-0.403 -0.012,-0.693 -0.012,-0.693 -0.201,-2.538 -2.72,-2.143 -2.72,-2.143 1.566,4.78 1.154,10.304 1.154,10.304 v 4.86 h 19.778 v -4.849 l 0.029,-0.011 c 0,0 -0.413,-5.525 1.153,-10.304 z"
       id="path21" />
    	<path
       fill="#ffe15a"
       d="m 243.919,278.959 c 0,0 -2.519,-0.395 -2.72,2.143 0,0 0,0.29 -0.012,0.693 -0.311,-0.147 -0.65,-0.244 -1.017,-0.244 -1.331,0 -2.41,1.079 -2.41,2.41 0,1.331 1.079,2.411 2.41,2.411 0.106,0 0.196,-0.047 0.298,-0.061 -0.359,1.149 -0.929,2.195 -1.73,2.951 h -3.218 c -0.846,-0.937 -1.103,-2.771 -1.159,-4.099 0.052,0.004 0.092,0.04 0.145,0.04 1.092,0 1.977,-0.886 1.977,-1.977 0,-1.079 -0.866,-1.949 -1.94,-1.97 0.171,-0.292 0.296,-0.615 0.296,-0.978 0,-1.092 -0.885,-1.977 -1.977,-1.977 -1.092,0 -1.977,0.886 -1.977,1.977 0,0.363 0.125,0.685 0.296,0.978 -1.074,0.022 -1.94,0.892 -1.94,1.97 0,1.092 0.886,1.977 1.977,1.977 0.053,0 0.093,-0.035 0.145,-0.04 -0.054,1.329 -0.312,3.162 -1.159,4.099 h -3.218 c -0.801,-0.756 -1.372,-1.803 -1.73,-2.951 0.103,0.013 0.192,0.061 0.298,0.061 1.331,0 2.41,-1.079 2.41,-2.411 0,-1.331 -1.079,-2.41 -2.41,-2.41 -0.367,0 -0.706,0.096 -1.017,0.244 -0.012,-0.403 -0.012,-0.693 -0.012,-0.693 -0.201,-2.538 -2.72,-2.143 -2.72,-2.143 1.566,4.78 1.154,10.304 1.154,10.304 v 4.86 h 19.778 v -4.849 l 0.029,-0.011 c -0.001,0 -0.412,-5.524 1.153,-10.304 z"
       id="path22" />
    	<path
       fill="#ffe15a"
       d="m 290.146,278.959 c 0,0 -2.519,-0.395 -2.72,2.143 0,0 0,0.29 -0.012,0.693 -0.311,-0.147 -0.65,-0.244 -1.017,-0.244 -1.331,0 -2.411,1.079 -2.411,2.41 0,1.331 1.079,2.411 2.411,2.411 0.106,0 0.196,-0.047 0.298,-0.061 -0.359,1.149 -0.929,2.195 -1.73,2.951 h -3.218 c -0.846,-0.937 -1.103,-2.771 -1.159,-4.099 0.052,0.004 0.092,0.04 0.145,0.04 1.092,0 1.977,-0.886 1.977,-1.977 0,-1.079 -0.866,-1.949 -1.94,-1.97 0.171,-0.292 0.296,-0.615 0.296,-0.978 0,-1.092 -0.885,-1.977 -1.977,-1.977 -1.092,0 -1.977,0.886 -1.977,1.977 0,0.363 0.125,0.685 0.296,0.978 -1.074,0.022 -1.94,0.892 -1.94,1.97 0,1.092 0.886,1.977 1.977,1.977 0.053,0 0.093,-0.035 0.145,-0.04 -0.054,1.329 -0.312,3.162 -1.159,4.099 h -3.218 c -0.801,-0.756 -1.372,-1.803 -1.73,-2.951 0.103,0.013 0.192,0.061 0.298,0.061 1.331,0 2.41,-1.079 2.41,-2.411 0,-1.331 -1.079,-2.41 -2.41,-2.41 -0.367,0 -0.706,0.096 -1.017,0.244 -0.012,-0.403 -0.012,-0.693 -0.012,-0.693 -0.201,-2.538 -2.72,-2.143 -2.72,-2.143 1.566,4.78 1.154,10.304 1.154,10.304 v 4.86 h 19.778 v -4.849 l 0.029,-0.011 c -10e-4,0 -0.413,-5.524 1.153,-10.304 z"
       id="path23" />
    	<path
       fill="#ffe15a"
       d="m 329.138,155.193 c -2.711,-1.077 -5.441,-2.091 -8.185,-3.043 -0.768,2.226 -1.535,4.451 -2.303,6.678 -1.324,-0.458 -2.652,-0.905 -3.982,-1.334 0.719,-2.243 1.438,-4.484 2.157,-6.728 -2.76,-0.89 -5.535,-1.719 -8.322,-2.484 -0.621,2.272 -1.241,4.543 -1.862,6.815 -1.344,-0.37 -2.691,-0.724 -4.042,-1.064 0.572,-2.285 1.142,-4.569 1.714,-6.855 -2.799,-0.704 -5.611,-1.346 -8.431,-1.926 -0.942,4.615 -1.886,9.23 -2.829,13.845 1.747,0.36 3.49,0.744 5.229,1.154 -0.359,1.528 -0.717,3.057 -1.076,4.586 -10.166,-2.4 -20.491,-3.901 -30.855,-4.5 0.09,-1.568 0.181,-3.135 0.27,-4.704 1.772,0.103 3.544,0.232 5.313,0.385 0.406,-4.693 0.812,-9.386 1.217,-14.08 -2.857,-0.248 -5.718,-0.435 -8.582,-0.559 -0.102,2.354 -0.203,4.706 -0.305,7.06 -1.38,-0.06 -2.762,-0.105 -4.143,-0.135 0.051,-2.355 0.102,-4.711 0.152,-7.064 -2.865,-0.062 -5.73,-0.062 -8.595,0 0.051,2.355 0.102,4.71 0.152,7.064 -1.382,0.03 -2.763,0.075 -4.143,0.135 -0.102,-2.354 -0.203,-4.706 -0.305,-7.06 -2.863,0.124 -5.724,0.31 -8.582,0.559 0.406,4.693 0.812,9.387 1.217,14.08 1.77,-0.153 3.541,-0.282 5.313,-0.385 0.09,1.568 0.181,3.136 0.27,4.704 -10.365,0.6 -20.689,2.1 -30.855,4.5 -0.359,-1.528 -0.717,-3.057 -1.076,-4.586 1.739,-0.412 3.481,-0.796 5.229,-1.154 -0.943,-4.615 -1.886,-9.23 -2.829,-13.845 -2.82,0.579 -5.632,1.222 -8.431,1.926 0.572,2.285 1.142,4.57 1.714,6.855 -1.351,0.34 -2.698,0.694 -4.042,1.064 -0.62,-2.272 -1.241,-4.544 -1.862,-6.815 -2.787,0.767 -5.562,1.594 -8.322,2.484 0.719,2.243 1.438,4.484 2.157,6.728 -1.331,0.429 -2.658,0.875 -3.982,1.334 -0.768,-2.226 -1.535,-4.451 -2.303,-6.678 -2.745,0.953 -5.474,1.967 -8.185,3.043 1.729,4.38 3.458,8.76 5.187,13.141 1.679,-0.666 3.367,-1.309 5.06,-1.923 2.134,5.906 4.267,11.81 6.401,17.716 4.564,-1.66 9.183,-3.111 13.842,-4.354 1.554,-0.414 3.111,-0.808 4.672,-1.175 9.37,-2.211 18.887,-3.595 28.439,-4.148 6.368,-0.369 12.753,-0.367 19.121,0 9.553,0.552 19.069,1.935 28.439,4.148 1.561,0.37 3.119,0.76 4.672,1.175 4.66,1.245 9.278,2.696 13.842,4.354 2.134,-5.907 4.267,-11.81 6.401,-17.716 1.694,0.616 3.381,1.257 5.06,1.923 1.73,-4.38 3.46,-8.761 5.189,-13.141 z"
       id="path24" />
    </g>
    <path
       fill="#ffe1cd"
       d="m 255.976,291.311 c 28.104,0 54.123,-9.024 75.377,-24.286 v -30.834 c -19.23,19.47 -45.913,31.563 -75.377,31.563 -29.871,0 -56.876,-12.439 -76.161,-32.387 v 31.097 c 21.393,15.607 47.712,24.847 76.161,24.847 z"
       id="path25" />
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs57" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 247.172,167.724 H 8.828 C 3.953,167.724 0,163.771 0,158.896 V 8.828 C 0,3.953 3.953,0 8.828,0 H 247.172 C 252.047,0 256,3.953 256,8.828 v 150.069 c -0.001,4.876 -3.952,8.827 -8.828,8.827 z"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path3" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon3" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path6" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path7" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 320.945,85.753 c -1.741,0 -3.153,1.411 -3.153,3.153 v 116.65 c 0,9.458 6.305,40.985 66.207,50.443 59.902,-9.458 66.207,-40.985 66.207,-50.443 V 88.907 c 0,-1.741 -1.411,-3.153 -3.153,-3.153 z"
       id="path8" />
    <path
       fill="#73af00"
       d="m 383.999,256 c 50.004,-7.895 62.651,-31.16 65.469,-44.138 H 318.531 c 2.817,12.977 15.464,36.244 65.468,44.138 z"
       id="path9" />
    <path
       fill="#82afff"
       d="m 424.984,151.961 c 0,0 3.153,-3.153 0,-9.458 l -40.985,-1.834 -40.985,1.834 c -3.153,6.305 0,9.458 0,9.458 -3.153,3.153 -3.153,6.305 -3.153,6.305 h 6.305 l 6.831,11.297 31.001,17.077 31.002,-17.077 6.831,-11.297 h 6.305 c 10e-4,0 10e-4,-3.152 -3.152,-6.305 z"
       id="path10" />
    <path
       fill="#f5f5f5"
       d="m 415.002,169.563 c 0,0 -1.971,-4.335 -7.225,-3.809 0,0 -2.89,-3.809 -7.751,-2.759 0,0 -5.649,-3.284 -8.932,2.759 0,0 -10.444,-1.062 -11.002,6.891 0,0 16.256,24.504 16.651,24.767 0.394,0.263 19.442,0.131 19.442,0.131 l 8.802,-9.711 -8.671,-12.489 z"
       id="path11" />
    <path
       fill="#f0c850"
       d="m 384.394,177.314 c 0,0 -13.79,-22.528 -15.764,-24.434 -1.905,-1.839 -5.649,-3.546 -9.459,-0.394 0,0 -11.428,-0.919 -9.853,7.751 l 3.284,13.137 c 0,0 -2.89,9.064 -4.204,9.984 -1.313,0.919 -6.174,3.415 -6.174,3.415 l 2.759,10.903 36.781,-1.839 z"
       id="path12" />
    <path
       fill="#965032"
       d="m 400.288,167.461 -0.043,0.019 -1.017,-2.401 c -0.082,-0.194 -0.238,-0.348 -0.434,-0.425 -0.195,-0.077 -0.413,-0.074 -0.609,0.012 l -6.842,3.017 -8.138,-13.322 c 0.361,-0.31 0.518,-0.817 0.348,-1.289 -0.22,-0.616 -0.897,-0.936 -1.512,-0.717 l -1.814,0.649 -1.227,-3.626 c -0.14,-0.413 -0.585,-0.628 -0.999,-0.495 -0.413,0.141 -0.634,0.588 -0.494,1.001 l 1.236,3.654 -1.939,0.694 c -0.615,0.222 -0.935,0.899 -0.714,1.512 0.172,0.483 0.628,0.786 1.113,0.786 0.068,0 0.138,-0.023 0.207,-0.035 l 2.682,16.153 -1.73,0.762 c -0.377,0.167 -0.564,0.597 -0.424,0.985 l 0.981,2.732 c 0.024,0.46 0.022,1.236 -0.135,2.218 l -11.006,-18.879 c 0.462,-0.289 0.693,-0.851 0.502,-1.383 -0.222,-0.616 -0.893,-0.939 -1.512,-0.717 l -1.814,0.649 -1.227,-3.626 c -0.139,-0.413 -0.587,-0.634 -0.999,-0.495 -0.413,0.141 -0.634,0.588 -0.494,1.001 l 1.236,3.654 -1.939,0.694 c -0.615,0.222 -0.935,0.899 -0.714,1.512 0.158,0.441 0.559,0.701 0.995,0.748 l 4.777,29.814 c -0.617,0.259 -1.222,0.522 -1.901,0.764 0,0 -2.233,10.641 -0.525,11.166 1.708,0.525 19.31,5.911 19.31,5.911 0,0 24.302,-11.56 24.828,-11.822 0.525,-0.263 1.577,-7.882 1.577,-7.882 z m -1.491,0.641 -2.035,0.874 -0.674,-1.663 1.999,-0.882 z m -12.3,3.44 1.673,-0.737 0.643,1.585 -1.771,0.761 z m -0.909,2.232 -1.978,0.85 -0.622,-1.534 2.062,-0.909 z m 4.672,-2.006 -0.649,-1.599 1.788,-0.788 0.655,1.618 z m 2.58,-3.022 1.806,-0.797 0.669,1.649 -1.814,0.779 z m -11.104,-13.768 8.152,13.346 -3.897,1.718 -5.005,-14.796 z m -2.814,1.008 0.578,-0.207 5.042,14.904 -2.963,1.306 z m 2.624,17.741 0.617,1.521 -1.945,0.835 -0.548,-1.528 z m -15.251,-12.679 11.938,20.479 c -0.601,1.737 -1.735,3.753 -3.723,5.732 l -8.797,-26.004 z m -2.947,1.056 0.882,-0.316 9.009,26.632 c -1.366,1.133 -3.065,2.228 -5.156,3.231 z"
       id="path13" />
    <path
       fill="#ff4b55"
       d="m 427.842,137.725 c -0.837,-1.33 -3.524,-0.76 -3.524,-0.76 0,0 -0.767,-1.534 -2.794,-1.682 -2.027,-0.148 -2.399,1.657 -2.399,1.657 0,0 -0.38,-0.282 -2.613,-0.216 -2.233,0.066 -1.773,3.744 -1.773,3.744 0,0 -0.854,0 -3.744,-0.919 -2.89,-0.92 -4.794,-0.263 -4.794,-0.263 -0.131,-1.511 -0.919,-2.627 -0.919,-2.627 -2.43,0.985 -4.335,-0.131 -4.794,-0.985 -0.46,-0.854 0.723,-2.167 0.723,-3.284 0,-1.117 -1.544,-1.067 -2.086,-2.052 -0.542,-0.985 0,-1.527 1.429,-2.167 1.429,-0.64 2.759,-3.005 1.871,-4.926 -0.888,-1.921 -3.448,-1.577 -3.448,-1.577 0.887,0.148 1.625,1.823 0.198,2.167 -1.428,0.344 -2.709,-4.877 -2.709,-4.877 3.3,2.217 5.715,0.887 6.404,-1.035 0.69,-1.922 -1.133,-3.251 -1.133,-3.251 -1.429,2.315 -3.892,0.296 -2.561,-1.182 1.33,-1.478 1.444,-3.957 1.444,-3.957 -2.956,1.446 -4.794,-0.394 -4.794,-0.394 3.875,-2.692 2.759,-6.503 2.759,-6.503 -1.444,-0.657 -4.532,-0.131 -4.532,-0.131 0.657,-1.314 0.525,-3.679 0.525,-3.679 -1.642,-0.263 -3.481,0.788 -3.481,0.788 0.525,-1.838 -0.198,-5.057 -0.198,-5.057 -1.182,0.198 -3.415,0.854 -3.415,0.854 -0.919,-2.102 -3.481,-3.35 -3.481,-3.35 0,0 -2.561,1.248 -3.481,3.35 0,0 -2.233,-0.657 -3.415,-0.854 0,0 -0.723,3.219 -0.198,5.057 0,0 -1.839,-1.05 -3.481,-0.788 0,0 -0.131,2.365 0.525,3.679 0,0 -3.087,-0.525 -4.532,0.131 0,0 -1.117,3.809 2.759,6.503 0,0 -1.839,1.839 -4.794,0.394 0,0 0.115,2.479 1.444,3.957 1.33,1.478 -1.133,3.498 -2.561,1.182 0,0 -1.823,1.33 -1.133,3.251 0.69,1.921 3.104,3.251 6.404,1.035 0,0 -1.281,5.222 -2.709,4.877 -1.428,-0.344 -0.69,-2.019 0.198,-2.167 0,0 -2.561,-0.345 -3.448,1.577 -0.887,1.921 0.444,4.286 1.871,4.926 1.429,0.64 1.971,1.182 1.429,2.167 -0.542,0.985 -2.086,0.936 -2.086,2.052 0,1.117 1.182,2.43 0.723,3.284 -0.46,0.854 -2.365,1.971 -4.794,0.985 0,0 -0.788,1.117 -0.919,2.627 0,0 -1.905,-0.657 -4.794,0.263 -2.89,0.919 -3.744,0.919 -3.744,0.919 0,0 0.46,-3.678 -1.773,-3.744 -2.233,-0.066 -2.613,0.216 -2.613,0.216 0,0 -0.371,-1.805 -2.399,-1.657 -2.027,0.149 -2.794,1.682 -2.794,1.682 0,0 -2.687,-0.569 -3.524,0.76 -0.837,1.33 -0.936,3.35 0.64,4.188 1.577,0.838 5.763,4.335 5.763,4.335 l 5.911,2.561 20.69,-9.163 10.837,2.857 10.837,-2.857 20.69,9.163 5.911,-2.561 c 0,0 4.188,-3.498 5.763,-4.335 1.572,-0.839 1.474,-2.859 0.636,-4.188 z"
       id="path14" />
    <path
       fill="#f5f5f5"
       d="m 377.546,104.337 c 0,0 0.223,2.782 4.34,2.04 -0.001,0 -0.111,-2.893 -4.34,-2.04 z"
       id="path15" />
    <path
       fill="#ff4b55"
       d="m 362.313,214.227 c 0,0 -2.956,-0.098 -6.009,2.167 -3.054,2.266 -4.401,0.657 -7.455,0.657 -3.054,0 -3.777,3.186 -3.777,3.186 0,0 -5.911,1.478 -3.546,5.813 1.495,2.742 3.576,2.684 4.908,2.272 -0.067,1.842 0.352,3.866 2.481,4.231 4.04,0.69 5.813,-1.478 4.926,-4.828 0,0 0.492,3.448 3.153,3.35 2.66,-0.098 4.434,-1.577 4.138,-5.123 -0.296,-3.546 4.434,-1.379 8.078,-6.601 z"
       id="path16" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="m 345.039,315.179 c 0,0 -1.839,2.43 -1.313,4.794 0,0 -3.94,-1.248 -1.839,-7.094 -10e-4,10e-4 2.693,-0.721 3.152,2.3 z"
       id="path17" />
    	<path
       fill="#82afff"
       d="m 351.229,318.365 c 0,0 -1.084,3.054 0.394,5.763 0,0 -4.926,-0.148 -3.94,-6.207 0,0 1.576,-1.625 3.546,0.444 z"
       id="path18" />
    	<path
       fill="#82afff"
       d="m 356.156,318.069 c 0,0 0.887,2.561 0,5.025 0,0 4.04,-0.246 3.35,-6.059 -10e-4,0 -2.168,-0.788 -3.35,1.034 z"
       id="path19" />
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 352.56,259.154 c -0.373,-3.038 -19.409,-4.828 -18.227,11.166 0,0 -2.112,-0.039 -3.15,1.927 -1.038,1.966 -3.264,1.484 -3.932,0.779 0,0 0.148,3.561 4.562,3.412 0,0 -1.397,1.1 -1.199,2.708 0.198,1.608 1.359,3.635 1.286,5.02 -0.073,1.385 -1.385,3.314 -1.385,3.314 0,0 3.388,-1.162 3.61,-3.585 0.223,-2.423 -0.321,-4.451 0.346,-5.687 0,0 -0.321,1.706 1.187,3.858 1.508,2.152 1.582,4.772 0.964,6.404 0,0 3.758,-1.855 3.041,-5.44 -0.717,-3.585 -1.484,-3.264 -1.138,-5.267 0,0 3.907,3.981 3.24,7.369 0,0 1.249,-1.496 1.138,-4.314 -0.111,-2.819 -2.068,-4.715 -2.068,-4.715 0,0 13.005,-6.506 11.725,-16.949 z"
       id="path20" />
    	<path
       fill="#ff4b55"
       d="m 405.686,302.503 c 0,0 2.956,-0.098 6.009,2.167 3.054,2.266 4.401,0.657 7.455,0.657 3.054,0 3.777,3.186 3.777,3.186 0,0 5.911,1.478 3.546,5.813 -1.495,2.742 -3.576,2.684 -4.908,2.272 0.067,1.842 -0.352,3.866 -2.481,4.231 -4.04,0.69 -5.813,-1.478 -4.926,-4.828 0,0 -0.492,3.448 -3.153,3.35 -2.66,-0.098 -4.434,-1.577 -4.138,-5.123 0.296,-3.546 -4.434,-1.379 -8.078,-6.601 z"
       id="path21" />
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="m 422.961,315.179 c 0,0 1.839,2.43 1.313,4.794 0,0 3.94,-1.248 1.839,-7.094 0,10e-4 -2.693,-0.721 -3.152,2.3 z"
       id="path22" />
    	<path
       fill="#82afff"
       d="m 416.769,318.365 c 0,0 1.084,3.054 -0.394,5.763 0,0 4.926,-0.148 3.94,-6.207 0.002,0 -1.575,-1.625 -3.546,0.444 z"
       id="path23" />
    	<path
       fill="#82afff"
       d="m 411.844,318.069 c 0,0 -0.887,2.561 0,5.025 0,0 -4.04,-0.246 -3.35,-6.059 -0.001,0 2.168,-0.788 3.35,1.034 z"
       id="path24" />
    </g>
    <path
       fill="#ff4b55"
       d="m 415.44,170.878 c 0.373,-3.038 19.409,-4.828 18.227,11.166 0,0 2.112,-0.039 3.15,1.927 1.038,1.966 3.264,1.484 3.932,0.779 0,0 -0.148,3.561 -4.562,3.412 0,0 1.397,1.1 1.199,2.708 -0.198,1.608 -1.361,3.635 -1.286,5.02 0.074,1.385 1.385,3.314 1.385,3.314 0,0 -3.388,-1.162 -3.61,-3.585 -0.223,-2.423 0.321,-4.451 -0.346,-5.687 0,0 0.321,1.706 -1.187,3.858 -1.508,2.152 -1.582,4.772 -0.964,6.404 0,0 -3.758,-1.855 -3.041,-5.44 0.717,-3.585 1.484,-3.264 1.138,-5.267 0,0 -3.907,3.981 -3.24,7.369 0,0 -1.249,-1.496 -1.138,-4.314 0.111,-2.819 2.068,-4.715 2.068,-4.715 0,0 -13.006,-6.506 -11.725,-16.949 z"
       id="path25" />
    <path
       fill="#ffe15a"
       d="m 423.227,143.617 c -0.724,-0.487 -1.703,-0.284 -2.185,0.447 -0.997,1.505 -2.311,2.386 -4.014,2.691 -5.641,0.979 -13.773,-4.575 -16.135,-6.312 -3.423,-2.516 -7.651,-2.953 -10.458,-1.224 -1.12,0.371 -4.544,1.45 -6.434,1.45 -1.89,0 -5.314,-1.08 -6.434,-1.45 -2.807,-1.729 -7.036,-1.292 -10.458,1.224 -2.361,1.737 -10.494,7.29 -16.135,6.312 -1.704,-0.305 -3.017,-1.185 -4.014,-2.691 -0.482,-0.729 -1.461,-0.932 -2.185,-0.447 -0.726,0.48 -0.925,1.46 -0.445,2.183 1.478,2.236 3.527,3.599 6.091,4.057 0.648,0.117 1.31,0.169 1.984,0.169 6.016,0 12.823,-4.292 16.568,-7.041 2.785,-2.045 5.907,-2.041 7.313,-0.856 0.355,0.301 0.759,0.776 0.662,1.333 -0.052,0.305 -0.253,0.579 -0.587,0.81 0.081,-0.483 -0.066,-0.998 -0.439,-1.373 -0.616,-0.616 -1.613,-0.616 -2.229,0 -0.802,0.798 -0.889,2.093 -0.214,3.147 0.679,1.056 2.142,1.828 3.88,1.185 0.883,-0.329 1.589,-0.958 2.078,-1.728 2.396,-0.697 4.565,-0.702 4.565,-0.702 0,0 2.169,0.004 4.565,0.702 0.489,0.77 1.195,1.399 2.078,1.728 1.738,0.643 3.2,-0.129 3.88,-1.185 0.675,-1.053 0.588,-2.349 -0.214,-3.147 -0.616,-0.616 -1.613,-0.616 -2.229,0 -0.373,0.375 -0.519,0.889 -0.439,1.373 -0.334,-0.231 -0.534,-0.505 -0.587,-0.81 -0.097,-0.557 0.307,-1.032 0.662,-1.333 1.406,-1.185 4.527,-1.188 7.313,0.856 3.745,2.75 10.552,7.041 16.568,7.041 0.674,0 1.336,-0.052 1.984,-0.169 2.564,-0.459 4.613,-1.823 6.091,-4.057 0.478,-0.723 0.28,-1.703 -0.447,-2.183 z"
       id="path26" />
    <g
       id="g30"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="m 343.83,233.634 c 0,0 -0.259,-3.523 -0.371,-4.673 -0.112,-1.15 -2.262,-2.003 -3.079,-0.853 -0.816,1.15 -1.037,3.264 3.45,5.526 z"
       id="path27" />
    	<path
       fill="#82afff"
       d="m 344.591,232.503 c 0,0 3.104,-2.513 2.709,-3.842 -0.394,-1.33 -1.231,-2.019 -2.266,-1.625 -1.036,0.394 -1.527,2.807 -0.443,5.467 z"
       id="path28" />
    	<path
       fill="#82afff"
       d="m 350.65,230.532 c 0.446,-0.446 0.591,-2.611 -0.64,-2.857 -1.231,-0.246 -2.857,1.675 -2.759,4.04 0,-0.001 2.561,-0.345 3.399,-1.183 z"
       id="path29" />
    	<path
       fill="#82afff"
       d="m 349.369,231.764 c -1.429,0.457 -2.808,1.675 -2.808,1.675 0,0 2.561,1.871 4.335,1.281 1.774,-0.59 0.937,-3.744 -1.527,-2.956 z"
       id="path30" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 390.453,104.337 c 0,0 -0.223,2.782 -4.34,2.04 0,0 0.112,-2.893 4.34,-2.04 z"
       id="path31" />
    <g
       id="g35"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="m 424.169,233.634 c 0,0 0.259,-3.523 0.371,-4.673 0.111,-1.15 2.262,-2.003 3.079,-0.853 0.815,1.15 1.038,3.264 -3.45,5.526 z"
       id="path32" />
    	<path
       fill="#82afff"
       d="m 423.409,232.503 c 0,0 -3.104,-2.513 -2.709,-3.842 0.394,-1.33 1.231,-2.019 2.266,-1.625 1.035,0.394 1.526,2.807 0.443,5.467 z"
       id="path33" />
    	<path
       fill="#82afff"
       d="m 417.35,230.532 c -0.446,-0.446 -0.591,-2.611 0.64,-2.857 1.231,-0.246 2.857,1.675 2.759,4.04 -0.001,-0.001 -2.562,-0.345 -3.399,-1.183 z"
       id="path34" />
    	<path
       fill="#82afff"
       d="m 418.63,231.764 c 1.429,0.457 2.808,1.675 2.808,1.675 0,0 -2.561,1.871 -4.335,1.281 -1.775,-0.59 -0.936,-3.744 1.527,-2.956 z"
       id="path35" />
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    	<path
       fill="#464655"
       d="m 382.369,199.168 1.25,1.25 c 0.21,0.21 0.551,0.21 0.76,0 l 1.25,-1.25 c 0.339,-0.339 0.099,-0.918 -0.381,-0.918 h -2.5 c -0.478,0 -0.717,0.579 -0.379,0.918 z"
       id="path36" />
    	<path
       fill="#464655"
       d="m 381.715,204.295 c -0.927,0 -1.729,-0.332 -2.274,-0.946 -0.564,-0.638 -0.803,-1.515 -0.661,-2.408 0.051,-0.299 0.351,-0.48 0.632,-0.456 0.301,0.05 0.505,0.332 0.457,0.634 -0.09,0.564 0.054,1.108 0.397,1.496 0.354,0.397 0.895,0.582 1.559,0.573 1.386,-0.055 1.618,-1.41 1.628,-1.465 l -0.007,-2.473 c 0,-0.305 0.246,-0.551 0.551,-0.551 0.305,0 0.551,0.246 0.551,0.551 v 2.559 c -0.134,0.884 -0.856,2.408 -2.68,2.482 -0.049,0.004 -0.102,0.004 -0.153,0.004 z"
       id="path37" />
    	<path
       fill="#464655"
       d="m 386.284,204.295 c -0.051,0 -0.103,0 -0.156,-0.003 -1.824,-0.074 -2.546,-1.598 -2.674,-2.396 l -0.007,-2.645 c 0,-0.305 0.246,-0.551 0.551,-0.551 0.305,0 0.551,0.246 0.551,0.551 v 2.559 c 0.019,0.055 0.277,1.327 1.621,1.379 0.683,0.012 1.204,-0.169 1.559,-0.573 0.343,-0.388 0.488,-0.932 0.397,-1.496 -0.047,-0.301 0.156,-0.585 0.457,-0.634 0.288,-0.036 0.584,0.154 0.632,0.456 0.143,0.893 -0.097,1.77 -0.66,2.408 -0.543,0.613 -1.344,0.945 -2.271,0.945 z"
       id="path38" />
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 402.916,284.375 c 0,0 -3.94,-6.305 -8.538,-2.102 -4.598,4.204 -6.305,9.327 -11.56,8.932 -2.883,-0.216 -4.356,-1.533 -5.121,-2.684 1.396,-1.149 2.386,-2.894 1.312,-5.461 -2.365,-5.649 -11.034,-3.94 -13.399,2.233 0,0 2.759,-9.064 -6.831,-6.042 0,0 -1.182,-6.305 -6.699,-4.598 -3,0.929 -4.11,2.775 -4.522,4.279 -1.161,-0.27 -2.652,-0.262 -4.017,0.844 l 6.962,18.785 10.509,0.131 2.365,3.546 13.793,8.67 2.496,5.255 h 8.67 c 0,0 0.657,-5.386 5.255,-6.962 4.598,-1.577 12.085,-4.861 12.874,-7.751 0.788,-2.89 0.788,-2.89 0.788,-2.89 l 8.407,0.131 c 0.919,-0.657 7.094,-10.772 7.094,-10.772 l 2.866,-13.027 c -1.583,-0.227 -19.689,-2.576 -22.704,9.483 z"
       id="path39" />
    	<path
       fill="#f5f5f5"
       d="m 425.641,274.785 -0.024,0.109 c 0.073,0.01 0.156,0.023 0.156,0.023 z"
       id="path40" />
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 368.424,304.516 c -3.406,-1.373 -4.622,-3.297 -5.043,-4.322 -0.391,-0.948 -0.314,-1.62 -0.207,-1.866 0.217,-0.502 0.48,-0.822 0.725,-0.884 0.231,-0.055 0.523,0.077 0.576,0.11 0.11,0.126 0.169,0.526 0.063,0.625 -0.634,0.597 -0.663,1.594 -0.067,2.229 0.599,0.634 1.593,0.662 2.229,0.067 0.648,-0.609 1.02,-1.462 1.045,-2.401 0.03,-1.006 -0.339,-2.01 -0.982,-2.688 -0.646,-0.683 -1.971,-1.305 -3.383,-1.053 -0.291,0.051 -0.619,0.17 -0.954,0.332 0.221,-2.184 -0.621,-3.302 -1.239,-3.753 -1.039,-0.755 -2.518,-0.772 -3.763,-0.043 -1.273,0.748 -1.961,2.057 -1.793,3.412 0.108,0.865 0.975,1.383 1.821,1.266 0.864,-0.105 1.543,-0.997 1.437,-1.859 0.179,-0.163 0.414,-0.218 0.406,-0.256 0.003,0.003 0.211,0.348 -0.04,1.46 -0.393,1.742 -1.314,2.814 -2.74,3.19 -1.775,0.49 -4.049,-0.258 -5.393,-1.734 -1.869,-2.057 -5.781,-12.971 -8.107,-20.241 9.971,-4.729 11.196,-12.586 11.007,-16.964 -0.288,-6.669 -4.278,-13.492 -8.715,-14.899 -1.746,-0.551 -4.361,-0.665 -6.259,0.314 -1.075,0.561 -1.821,1.419 -2.157,2.487 -0.685,2.179 0.686,3.981 2.326,4.569 1.698,0.609 3.412,-0.124 4.071,-1.746 0.327,-0.807 -0.03,-1.73 -0.836,-2.057 -0.811,-0.335 -1.694,0.058 -2.019,0.862 -0.066,0.036 -0.285,-0.046 -0.448,-0.231 -0.118,-0.136 -0.143,-0.268 -0.085,-0.449 0.052,-0.167 0.171,-0.413 0.605,-0.638 1.03,-0.538 2.752,-0.456 3.852,-0.108 2.539,0.803 6.246,5.77 6.516,12.029 0.161,3.741 -0.974,10.598 -10.388,14.505 -0.755,0.314 -1.144,1.149 -0.9,1.928 0.615,1.967 6.098,19.341 9.204,22.755 1.671,1.838 4.196,2.906 6.611,2.906 0.654,0 1.301,-0.077 1.92,-0.241 1.053,-0.279 1.932,-0.822 2.697,-1.504 0.076,0.578 0.21,1.17 0.454,1.762 0.609,1.484 2.3,4.243 7.02,6.145 9.547,3.83 10.454,6.391 10.402,7.318 -0.029,0.508 -0.32,0.772 -0.557,0.905 -0.103,0.059 -0.205,0.095 -0.292,0.117 0.352,-0.483 0.416,-1.145 0.105,-1.703 -0.425,-0.76 -1.383,-1.032 -2.144,-0.607 -1.073,0.6 -1.821,2.014 -1.18,3.559 0.5,1.201 1.671,1.928 3.023,1.928 0.217,0 0.439,-0.019 0.663,-0.059 1.963,-0.332 3.413,-1.961 3.529,-3.959 0.27,-4.778 -6.937,-8.235 -12.616,-10.515 z"
       id="path41" />
    	<path
       fill="#ffe15a"
       d="m 399.575,304.516 c 3.406,-1.373 4.622,-3.297 5.043,-4.322 0.391,-0.948 0.314,-1.62 0.207,-1.866 -0.217,-0.502 -0.48,-0.822 -0.725,-0.884 -0.231,-0.055 -0.523,0.077 -0.576,0.11 -0.11,0.126 -0.169,0.526 -0.063,0.625 0.635,0.597 0.663,1.594 0.067,2.229 -0.599,0.634 -1.593,0.662 -2.229,0.067 -0.648,-0.609 -1.02,-1.462 -1.045,-2.401 -0.029,-1.006 0.339,-2.01 0.982,-2.688 0.646,-0.683 1.971,-1.305 3.383,-1.053 0.291,0.051 0.619,0.17 0.954,0.332 -0.221,-2.184 0.621,-3.302 1.239,-3.753 1.039,-0.755 2.518,-0.772 3.763,-0.043 1.273,0.748 1.961,2.057 1.793,3.412 -0.108,0.865 -0.975,1.383 -1.821,1.266 -0.864,-0.105 -1.543,-0.997 -1.437,-1.859 -0.179,-0.163 -0.414,-0.218 -0.406,-0.256 -0.003,0.003 -0.211,0.348 0.04,1.46 0.393,1.742 1.314,2.814 2.74,3.19 1.775,0.49 4.049,-0.258 5.393,-1.734 1.869,-2.057 5.781,-12.971 8.107,-20.241 -9.971,-4.729 -11.196,-12.586 -11.007,-16.964 0.288,-6.669 4.278,-13.492 8.715,-14.899 1.746,-0.551 4.361,-0.665 6.259,0.314 1.075,0.561 1.821,1.419 2.157,2.487 0.685,2.179 -0.686,3.981 -2.326,4.569 -1.698,0.609 -3.412,-0.124 -4.071,-1.746 -0.327,-0.807 0.03,-1.73 0.836,-2.057 0.811,-0.335 1.694,0.058 2.019,0.862 0.066,0.036 0.285,-0.046 0.448,-0.231 0.118,-0.136 0.143,-0.268 0.085,-0.449 -0.052,-0.167 -0.171,-0.413 -0.605,-0.638 -1.03,-0.538 -2.752,-0.456 -3.852,-0.108 -2.539,0.803 -6.246,5.77 -6.516,12.029 -0.161,3.741 0.974,10.598 10.388,14.505 0.755,0.314 1.144,1.149 0.9,1.928 -0.615,1.967 -6.098,19.341 -9.204,22.755 -1.671,1.838 -4.196,2.906 -6.611,2.906 -0.654,0 -1.301,-0.077 -1.92,-0.241 -1.053,-0.279 -1.932,-0.822 -2.697,-1.504 -0.076,0.578 -0.21,1.17 -0.454,1.762 -0.609,1.484 -2.3,4.243 -7.02,6.145 -9.547,3.83 -10.454,6.391 -10.402,7.318 0.03,0.508 0.32,0.772 0.557,0.905 0.103,0.059 0.205,0.095 0.292,0.117 -0.352,-0.483 -0.416,-1.145 -0.105,-1.703 0.425,-0.76 1.383,-1.032 2.144,-0.607 1.073,0.6 1.821,2.014 1.18,3.559 -0.5,1.201 -1.671,1.928 -3.023,1.928 -0.217,0 -0.439,-0.019 -0.663,-0.059 -1.963,-0.332 -3.413,-1.961 -3.529,-3.959 -0.271,-4.778 6.937,-8.235 12.616,-10.515 z"
       id="path42" />
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs24" />
    <path
       fill="#ffe15a"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="M 0,8.828 V 61.793 L 512,273.655 V 211.862 L 3.978,1.647 C 1.635,3.233 0,5.784 0,8.828 Z"
       id="path2" />
    <path
       fill="#464655"
       d="m 0,123.586 508.021,210.215 c 2.343,-1.587 3.978,-4.138 3.978,-7.181 V 273.655 L 0,61.793 Z"
       id="path3" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 305.588,240.326 0.007,-0.25 c 0,0 -0.117,-1.209 -0.338,-3.478 -0.067,-1.134 -0.328,-2.515 -0.672,-4.125 -0.266,-1.623 -0.78,-3.439 -1.44,-5.443 -1.326,-3.977 -3.367,-8.725 -6.891,-13.322 -0.426,-0.568 -0.93,-1.129 -1.394,-1.694 1.999,-2.292 3.949,-4.958 5.788,-8.175 0,0 -10.08,0.462 -21.401,-4.478 -3.737,-1.946 -7.796,-3.543 -12.248,-4.589 l -2.112,-8.447 c -0.452,-1.806 -2.076,-3.074 -3.937,-3.074 h -2.92 v -4.058 h 14.206 l -4.058,-8.118 4.058,-8.118 H 258.03 v -4.059 h -4.06 v 24.353 h -2.92 c -1.863,0 -3.486,1.268 -3.937,3.074 l -2.066,8.265 c -2.742,0.584 -5.473,1.325 -8.124,2.452 -2.169,0.868 -4.267,1.956 -6.315,3.174 -10.413,3.997 -19.257,3.624 -19.257,3.624 1.838,3.215 3.785,5.88 5.783,8.171 -0.405,0.492 -0.854,0.934 -1.246,1.44 -2.765,3.755 -4.973,7.977 -6.658,12.46 -1.603,4.353 -2.514,9.878 -2.819,13.917 l -0.008,3.905 c -0.041,1.226 0.099,2.441 0.228,3.66 0.16,2.457 0.703,4.855 1.215,7.271 1.266,4.758 3.118,9.387 5.643,13.637 5.054,8.513 12.762,15.224 21.405,19.385 4.465,1.967 8.683,3.466 13.716,4.181 2.681,0.499 4.351,0.491 6.337,0.664 l 0.361,0.026 0.181,0.013 0.589,0.015 0.845,-0.035 1.684,-0.076 c 1.118,-0.075 2.236,-0.061 3.331,-0.224 8.832,-0.969 16.793,-4.403 23.009,-8.862 6.215,-4.538 10.679,-10.073 13.737,-15.349 3.106,-5.281 4.708,-10.391 5.696,-14.577 0.472,-2.09 0.823,-4 0.951,-5.796 0.201,-1.778 0.318,-3.234 0.265,-4.185 -0.004,-2.058 -0.008,-3.155 -0.008,-3.155 z m -73.768,28.605 c -2.82,-2.198 -5.369,-4.818 -7.693,-7.708 -2.237,-2.959 -4.024,-6.297 -5.427,-9.846 -1.323,-3.473 -2.051,-7.648 -2.409,-11.051 -0.099,-4.723 0.122,-7.944 1.024,-11.971 0.983,-3.825 2.417,-7.569 4.412,-11.023 0.116,-0.2 0.273,-0.37 0.392,-0.567 9.227,7.208 18.969,6.695 25.763,3.197 v 7.938 c 2.241,0 4.058,4.543 4.058,10.147 0,5.604 -1.817,10.147 -4.058,10.147 v 4.058 c 7.613,10.149 4.12,18.713 -0.558,23.706 -2.123,-0.461 -4.326,-1.081 -6.386,-1.892 -3.195,-1.242 -6.23,-3.032 -9.118,-5.135 z m 63.883,-29.061 c -0.007,0.06 -0.115,1.103 -0.321,3.092 -0.062,1.109 -0.307,2.159 -0.59,3.322 -0.202,1.173 -0.631,2.593 -1.182,4.203 -1.099,3.154 -2.752,6.92 -5.626,10.528 -2.809,3.619 -6.598,7.193 -11.325,9.99 -3.594,2.133 -7.818,3.576 -12.281,4.601 -4.52,-5.037 -7.703,-13.428 -0.258,-23.353 v -4.058 c -2.241,0 -4.058,-4.543 -4.058,-10.147 0,-5.604 1.817,-10.147 4.058,-10.147 v -7.938 c 6.802,3.502 16.559,4.013 25.796,-3.221 0.158,0.266 0.351,0.536 0.5,0.8 2.456,4.292 3.67,8.42 4.431,11.781 0.363,1.697 0.63,3.211 0.693,4.556 0.14,1.331 0.242,2.457 0.184,3.384 -0.014,1.573 -0.02,2.37 -0.021,2.607 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="m 255.999,300.96 c -14.987,0 -28.581,-5.838 -38.727,-15.326 -1.863,-1.741 -4.81,-1.53 -6.47,0.406 l -15.542,18.133 c -1.652,1.928 -0.282,4.905 2.255,4.905 h 9.775 l 13.031,6.516 c 1.831,0.916 4.057,0.324 5.193,-1.379 l 4.194,-6.292 c 8.106,3.345 16.977,5.214 26.29,5.214 9.313,0 18.184,-1.869 26.29,-5.214 l 4.194,6.292 c 1.135,1.704 3.361,2.294 5.193,1.379 l 13.031,-6.516 h 9.775 c 2.538,0 3.908,-2.977 2.255,-4.905 L 301.194,286.04 c -1.66,-1.937 -4.607,-2.147 -6.47,-0.406 -10.143,9.488 -23.736,15.326 -38.725,15.326 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 199.175,284.724 H 178.88 l 4.058,-36.531 c 0,0 -14.207,-7.104 -12.719,-27.956 0.181,-2.536 2.325,-4.516 4.867,-4.516 h 3.464 c 2.392,0 4.397,1.734 4.793,4.093 0.854,5.091 3.511,13.448 11.772,16.202 z"
       id="path6" />
    	<path
       fill="#ff4b55"
       d="m 312.825,284.724 h 20.295 l -4.058,-36.531 c 0,0 14.207,-7.104 12.719,-27.956 -0.181,-2.536 -2.325,-4.516 -4.867,-4.516 h -3.464 c -2.392,0 -4.397,1.734 -4.793,4.093 -0.854,5.091 -3.511,13.448 -11.772,16.202 z"
       id="path7" />
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 201.205,288.783 h -24.353 c -1.121,0 -2.029,-0.908 -2.029,-2.029 v 0 c 0,-1.121 0.908,-2.029 2.029,-2.029 h 24.353 c 1.121,0 2.029,0.908 2.029,2.029 v 0 c 0,1.12 -0.909,2.029 -2.029,2.029 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 335.149,288.783 h -24.353 c -1.121,0 -2.029,-0.908 -2.029,-2.029 v 0 c 0,-1.121 0.908,-2.029 2.029,-2.029 h 24.353 c 1.121,0 2.029,0.908 2.029,2.029 v 0 c 0,1.12 -0.908,2.029 -2.029,2.029 z"
       id="path9" />
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs58" />
    <path
       fill="#73af00"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#ffe15a"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#73af00"
       d="m 244.598,117.681 c 0,0 -0.227,0.284 -0.653,0.817 -0.355,0.492 -0.888,1.248 -1.47,2.254 -1.145,1.999 -2.347,5.098 -2.38,8.792 -0.012,1.801 0.36,3.988 0.974,5.727 0.666,1.92 1.771,3.756 3.168,5.396 1.399,1.655 3.268,2.931 5.267,3.873 0.991,0.503 2.079,0.792 3.158,1.058 0.535,0.163 1.105,0.171 1.654,0.279 0.276,0.052 0.562,0.029 0.841,0.051 l 0.422,0.019 0.211,0.011 0.105,0.006 0.053,0.003 0.026,10e-4 c -0.085,0.003 0.227,-0.004 -0.184,0.007 0.684,-0.04 1.514,-0.045 2.078,-0.114 0.492,-0.115 0.906,-0.095 1.47,-0.262 1.08,-0.266 2.167,-0.555 3.158,-1.058 1.998,-0.942 3.868,-2.218 5.267,-3.873 1.397,-1.64 2.502,-3.476 3.168,-5.396 0.638,-1.953 0.979,-3.822 0.974,-5.736 -0.031,-3.678 -1.234,-6.788 -2.379,-8.785 -0.578,-1.002 -1.113,-1.763 -1.494,-2.276 -0.396,-0.505 -0.607,-0.776 -0.607,-0.776 l -0.053,-0.067 c -0.381,-0.486 -0.295,-1.187 0.191,-1.568 0.384,-0.3 0.904,-0.309 1.291,-0.061 0,0 0.326,0.209 0.937,0.6 0.578,0.434 1.474,1.047 2.439,2.039 1.937,1.918 4.451,5.334 5.358,10.298 0.449,2.376 0.498,5.25 -0.121,8.075 -0.6,2.854 -1.817,5.805 -3.782,8.387 -1.93,2.594 -4.523,4.888 -7.606,6.435 -1.521,0.811 -3.176,1.4 -4.874,1.81 -0.814,0.239 -1.847,0.338 -2.767,0.483 -0.862,0.095 -1.475,0.097 -2.226,0.15 l -0.292,0.001 -0.082,-0.004 -0.164,-0.008 -0.328,-0.017 -0.657,-0.035 c -0.437,-0.035 -0.876,-0.029 -1.309,-0.104 -0.863,-0.152 -1.741,-0.223 -2.583,-0.466 -1.698,-0.409 -3.354,-0.999 -4.874,-1.81 -3.083,-1.547 -5.676,-3.842 -7.606,-6.435 -1.964,-2.583 -3.181,-5.534 -3.782,-8.387 -0.642,-3.04 -0.562,-5.596 -0.12,-8.084 0.905,-4.949 3.421,-8.377 5.357,-10.291 0.961,-0.988 1.86,-1.607 2.463,-2.061 0.58,-0.364 0.89,-0.559 0.89,-0.559 0.526,-0.33 1.22,-0.172 1.55,0.354 0.26,0.418 0.213,0.943 -0.077,1.307 z"
       id="path3" />
    <path
       fill="#ff4b55"
       d="m 253.782,205.59 v 13.971 c 0,1.394 -1.685,2.092 -2.67,1.107 l -0.769,-0.769 c -0.639,-0.639 -0.998,-1.505 -0.998,-2.408 V 205.59 Z"
       id="path4" />
    <path
       fill="#ffe15a"
       d="m 247.126,203.372 v 10.141 c 0,0.609 0.242,1.194 0.673,1.625 l 1.545,1.545 v -13.311 z"
       id="path5" />
    <path
       fill="#73af00"
       d="m 244.908,203.372 v 5.442 c 0,0.777 0.309,1.522 0.857,2.071 l 1.361,1.361 v -8.874 z"
       id="path6" />
    <path
       fill="#ff4b55"
       d="m 258.218,205.59 v 13.971 c 0,1.394 1.685,2.092 2.67,1.107 l 0.769,-0.769 c 0.639,-0.639 0.998,-1.505 0.998,-2.408 V 205.59 Z"
       id="path7" />
    <path
       fill="#ffe15a"
       d="m 264.873,203.372 v 10.141 c 0,0.609 -0.242,1.194 -0.673,1.625 l -1.545,1.545 v -13.311 z"
       id="path8" />
    <path
       fill="#73af00"
       d="m 267.092,203.372 v 5.442 c 0,0.777 -0.309,1.522 -0.857,2.071 l -1.361,1.361 v -8.874 z"
       id="path9" />
    <path
       fill="#ff4b55"
       d="m 267.092,163.439 24.403,-17.748 v 36.498 c 0,10.474 -8.491,18.964 -18.964,18.964 v 0 c -3.554,0 -7.037,-0.999 -10.051,-2.882 l -13.135,-8.21 v -26.93 z"
       id="path10" />
    <path
       fill="#ffe15a"
       d="m 282.621,152.146 v 25.607 c 0,10.474 -8.491,18.964 -18.964,18.964 -1.575,0 -3.127,-0.227 -4.64,-0.61 l -9.673,-6.046 v -26.93 l 17.748,0.308 z"
       id="path11" />
    <path
       fill="#73af00"
       d="m 275.966,156.985 v 16.531 c 0,10.474 -8.491,18.964 -18.964,18.964 -1.575,0 -3.128,-0.227 -4.64,-0.61 l -3.018,-1.886 v -26.853 l 17.748,0.308 z"
       id="path12" />
    <polygon
       fill="#f5f5f5"
       points="295.488,233.967 291.495,233.967 292.826,229.974 302.588,225.094 "
       id="polygon12"
       transform="translate(0,-88.276)" />
    <path
       fill="#ff4b55"
       d="m 280.403,174.531 24.403,-17.748 v 36.498 c 0,10.474 -8.491,18.964 -18.964,18.964 v 0 c -3.554,0 -7.037,-0.999 -10.051,-2.882 l -13.135,-8.21 v -26.929 z"
       id="path13" />
    <path
       fill="#73af00"
       d="m 289.277,168.078 v 16.531 c 0,10.474 -8.491,18.964 -18.964,18.964 -1.575,0 -3.127,-0.227 -4.64,-0.61 l -3.018,-1.886 v -26.853 l 17.748,0.308 z"
       id="path14" />
    <polygon
       fill="#f5f5f5"
       points="308.799,245.059 304.806,245.059 306.137,241.066 315.899,236.185 "
       id="polygon14"
       transform="translate(0,-88.276)" />
    <path
       fill="#ff4b55"
       d="m 273.747,170.094 24.403,-17.748 v 36.498 c 0,10.474 -8.491,18.964 -18.964,18.964 v 0 c -3.554,0 -7.037,-0.999 -10.051,-2.882 L 256,196.716 v -26.93 z"
       id="path15" />
    <path
       fill="#ffe15a"
       d="m 289.277,158.8 v 25.607 c 0,10.474 -8.491,18.964 -18.964,18.964 -1.575,0 -3.127,-0.227 -4.64,-0.61 l -9.674,-6.045 v -26.93 l 17.748,0.308 z"
       id="path16" />
    <path
       fill="#73af00"
       d="m 282.621,163.641 v 16.531 c 0,10.474 -8.491,18.964 -18.964,18.964 -1.575,0 -3.127,-0.227 -4.64,-0.61 l -3.018,-1.885 v -26.853 l 17.748,0.308 z"
       id="path17" />
    <polygon
       fill="#f5f5f5"
       points="302.143,240.622 298.151,240.622 299.482,236.629 309.243,231.748 "
       id="polygon17"
       transform="translate(0,-88.276)" />
    <path
       fill="#ff4b55"
       d="m 244.908,163.439 -24.403,-17.748 v 36.498 c 0,10.474 8.491,18.964 18.964,18.964 v 0 c 3.554,0 7.037,-0.999 10.051,-2.882 l 13.135,-8.21 v -26.93 z"
       id="path18" />
    <path
       fill="#ffe15a"
       d="m 229.378,152.146 v 25.607 c 0,10.474 8.491,18.964 18.964,18.964 1.575,0 3.127,-0.227 4.64,-0.61 l 9.673,-6.046 v -26.93 l -17.748,0.308 z"
       id="path19" />
    <path
       fill="#73af00"
       d="m 236.034,156.985 v 16.531 c 0,10.474 8.491,18.964 18.964,18.964 1.575,0 3.128,-0.227 4.64,-0.61 l 3.018,-1.886 v -26.853 l -17.748,0.308 z"
       id="path20" />
    <polygon
       fill="#f5f5f5"
       points="216.512,233.967 220.504,233.967 219.173,229.974 209.412,225.094 "
       id="polygon20"
       transform="translate(0,-88.276)" />
    <path
       fill="#ff4b55"
       d="m 231.597,174.531 -24.403,-17.748 v 36.498 c 0,10.474 8.491,18.964 18.964,18.964 v 0 c 3.554,0 7.037,-0.999 10.051,-2.882 l 13.135,-8.21 v -26.929 z"
       id="path21" />
    <path
       fill="#73af00"
       d="m 222.723,168.078 v 16.531 c 0,10.474 8.491,18.964 18.964,18.964 1.575,0 3.127,-0.227 4.64,-0.61 l 3.018,-1.886 v -26.853 l -17.748,0.308 z"
       id="path22" />
    <polygon
       fill="#f5f5f5"
       points="203.201,245.059 207.193,245.059 205.862,241.066 196.101,236.185 "
       id="polygon22"
       transform="translate(0,-88.276)" />
    <path
       fill="#ff4b55"
       d="m 238.252,170.094 -24.403,-17.748 v 36.498 c 0,10.474 8.491,18.964 18.964,18.964 v 0 c 3.554,0 7.037,-0.999 10.051,-2.882 l 13.135,-8.21 v -26.93 z"
       id="path23" />
    <path
       fill="#ffe15a"
       d="m 222.723,158.8 v 25.607 c 0,10.474 8.491,18.964 18.964,18.964 1.575,0 3.127,-0.227 4.64,-0.61 L 256,196.715 v -26.93 l -17.748,0.308 z"
       id="path24" />
    <path
       fill="#73af00"
       d="m 229.378,163.641 v 16.531 c 0,10.474 8.491,18.964 18.964,18.964 1.575,0 3.127,-0.227 4.64,-0.61 L 256,196.64 v -26.853 l -17.748,0.308 z"
       id="path25" />
    <g
       id="g26"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffbe5a"
       d="m 226.947,291.354 -2.925,-2.925 c -1.773,-1.773 -1.726,-4.664 0.106,-6.378 l 48.417,-45.496 6.275,6.275 -45.496,48.417 c -1.713,1.833 -4.603,1.882 -6.377,0.107 z"
       id="path26" />
    	<circle
       fill="#ffbe5a"
       cx="225.49001"
       cy="289.89099"
       r="2.2179999"
       id="circle26" />
    </g>
    <ellipse
       transform="rotate(-135)"
       fill="#f5f5f5"
       cx="-302.01108"
       cy="87.86734"
       rx="4.4359574"
       ry="2.2179787"
       id="ellipse26" />
    <g
       id="g27"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffbe5a"
       d="m 285.052,291.354 2.925,-2.925 c 1.773,-1.773 1.726,-4.664 -0.106,-6.378 l -48.417,-45.496 -6.275,6.275 45.496,48.417 c 1.714,1.833 4.604,1.882 6.377,0.107 z"
       id="path27" />
    	<circle
       fill="#ffbe5a"
       cx="286.51001"
       cy="289.89099"
       r="2.2179999"
       id="circle27" />
    </g>
    <ellipse
       transform="rotate(-45)"
       fill="#f5f5f5"
       cx="60.032261"
       cy="274.17978"
       rx="4.4359574"
       ry="2.2179787"
       id="ellipse27" />
    <ellipse
       fill="#ffbe5a"
       cx="256"
       cy="177.86499"
       rx="19.615999"
       ry="23.294001"
       id="ellipse28" />
    <polygon
       fill="#ff4b55"
       points="259.428,245.602 259.021,250.222 262.52,247.178 260.706,251.446 264.974,249.632 261.929,253.131 266.549,252.724 262.573,255.111 267.092,256.152 262.573,257.193 266.549,259.58 261.929,259.174 264.974,262.671 260.706,260.858 262.52,265.126 259.021,262.082 259.428,266.701 257.041,262.725 255.999,267.244 254.959,262.725 252.572,266.701 252.978,262.082 249.48,265.126 251.293,260.858 247.026,262.671 250.07,259.174 245.451,259.58 249.426,257.193 244.908,256.152 249.426,255.111 245.451,252.724 250.07,253.131 247.026,249.632 251.293,251.446 249.48,247.178 252.978,250.222 252.572,245.602 254.959,249.579 255.999,245.059 257.041,249.579 "
       id="polygon28"
       transform="translate(0,-88.276)" />
    <path
       fill="#73af00"
       d="m 280.541,177.443 c 0,0 -7.349,1.941 -12.132,-2.08 -5.316,-4.469 -9.302,-6.579 -11.01,-7.371 -0.585,-0.271 -1.239,-0.271 -1.825,-10e-4 -1.224,0.565 -3.476,1.736 -5.468,3.49 -2.912,2.566 -11.855,7.626 -13.657,7.626 v 11.029 l 14.073,12.196 16.639,-0.486 z"
       id="path28" />
    <path
       fill="#3cc8ff"
       d="m 255.999,206.699 c -14.068,0 -25.513,-12.938 -25.513,-28.84 0,-15.902 11.444,-28.84 25.513,-28.84 14.069,0 25.513,12.938 25.513,28.84 0,15.902 -11.445,28.84 -25.513,28.84 z m 0,-51.025 c -10.398,0 -18.857,9.953 -18.857,22.185 0,12.232 8.459,22.185 18.857,22.185 10.398,0 18.857,-9.953 18.857,-22.185 0,-12.232 -8.459,-22.185 -18.857,-22.185 z"
       id="path29" />
    <g
       id="g39"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffbe5a"
       d="m 252.177,288.947 0.489,1.465 1.545,0.012 c 0.2,0.001 0.282,0.257 0.122,0.375 l -1.242,0.918 0.466,1.473 c 0.061,0.191 -0.157,0.349 -0.32,0.232 l -1.257,-0.898 -1.257,0.898 c -0.162,0.116 -0.38,-0.042 -0.32,-0.232 l 0.466,-1.473 -1.242,-0.918 c -0.161,-0.119 -0.078,-0.374 0.122,-0.375 l 1.545,-0.012 0.489,-1.465 c 0.063,-0.19 0.331,-0.19 0.394,0 z"
       id="path30" />
    	<path
       fill="#ffbe5a"
       d="m 245.242,285.965 0.489,1.465 1.545,0.012 c 0.2,10e-4 0.282,0.257 0.122,0.375 l -1.242,0.918 0.466,1.473 c 0.061,0.191 -0.157,0.349 -0.32,0.232 l -1.257,-0.898 -1.257,0.898 c -0.162,0.116 -0.38,-0.042 -0.32,-0.232 l 0.466,-1.473 -1.242,-0.918 c -0.161,-0.119 -0.078,-0.374 0.122,-0.375 l 1.545,-0.012 0.489,-1.465 c 0.063,-0.19 0.331,-0.19 0.394,0 z"
       id="path31" />
    	<path
       fill="#ffbe5a"
       d="m 239.673,280.904 0.489,1.465 1.545,0.012 c 0.2,0.001 0.282,0.257 0.122,0.375 l -1.242,0.918 0.466,1.473 c 0.061,0.191 -0.157,0.349 -0.32,0.232 l -1.257,-0.898 -1.257,0.898 c -0.162,0.116 -0.38,-0.042 -0.32,-0.232 l 0.466,-1.473 -1.242,-0.918 c -0.161,-0.119 -0.078,-0.374 0.122,-0.375 l 1.545,-0.012 0.489,-1.465 c 0.063,-0.19 0.331,-0.19 0.394,0 z"
       id="path32" />
    	<path
       fill="#ffbe5a"
       d="m 235.875,274.167 0.489,1.465 1.545,0.012 c 0.2,10e-4 0.282,0.257 0.122,0.375 l -1.242,0.918 0.466,1.473 c 0.061,0.191 -0.157,0.349 -0.32,0.232 l -1.257,-0.898 -1.257,0.898 c -0.162,0.116 -0.38,-0.042 -0.32,-0.232 l 0.466,-1.473 -1.242,-0.918 c -0.161,-0.119 -0.078,-0.374 0.122,-0.375 l 1.545,-0.012 0.489,-1.465 c 0.063,-0.19 0.331,-0.19 0.394,0 z"
       id="path33" />
    	<path
       fill="#ffbe5a"
       d="m 234.199,266.335 0.489,1.465 1.545,0.012 c 0.2,10e-4 0.282,0.257 0.122,0.375 l -1.242,0.918 0.466,1.473 c 0.061,0.191 -0.157,0.349 -0.32,0.232 l -1.257,-0.898 -1.257,0.898 c -0.162,0.116 -0.38,-0.042 -0.32,-0.232 l 0.466,-1.473 -1.242,-0.918 c -0.161,-0.119 -0.078,-0.374 0.122,-0.375 l 1.545,-0.012 0.489,-1.465 c 0.062,-0.19 0.331,-0.19 0.394,0 z"
       id="path34" />
    	<path
       fill="#ffbe5a"
       d="m 259.812,288.947 -0.489,1.465 -1.545,0.012 c -0.2,0.001 -0.283,0.257 -0.122,0.375 l 1.242,0.918 -0.466,1.473 c -0.061,0.191 0.157,0.349 0.32,0.232 l 1.257,-0.898 1.257,0.898 c 0.162,0.116 0.38,-0.042 0.32,-0.232 l -0.466,-1.473 1.242,-0.918 c 0.161,-0.119 0.078,-0.374 -0.122,-0.375 l -1.545,-0.012 -0.489,-1.465 c -0.063,-0.19 -0.331,-0.19 -0.394,0 z"
       id="path35" />
    	<path
       fill="#ffbe5a"
       d="m 266.747,285.965 -0.489,1.465 -1.545,0.012 c -0.2,10e-4 -0.282,0.257 -0.122,0.375 l 1.242,0.918 -0.466,1.473 c -0.061,0.191 0.157,0.349 0.32,0.232 l 1.257,-0.898 1.257,0.898 c 0.162,0.116 0.38,-0.042 0.32,-0.232 l -0.466,-1.473 1.242,-0.918 c 0.161,-0.119 0.078,-0.374 -0.122,-0.375 l -1.545,-0.012 -0.489,-1.465 c -0.063,-0.19 -0.331,-0.19 -0.394,0 z"
       id="path36" />
    	<path
       fill="#ffbe5a"
       d="m 272.316,280.904 -0.489,1.465 -1.545,0.012 c -0.2,0.001 -0.282,0.257 -0.122,0.375 l 1.242,0.918 -0.466,1.473 c -0.061,0.191 0.157,0.349 0.32,0.232 l 1.257,-0.898 1.257,0.898 c 0.162,0.116 0.38,-0.042 0.32,-0.232 l -0.466,-1.473 1.242,-0.918 c 0.161,-0.119 0.078,-0.374 -0.122,-0.375 l -1.545,-0.012 -0.489,-1.465 c -0.062,-0.19 -0.331,-0.19 -0.394,0 z"
       id="path37" />
    	<path
       fill="#ffbe5a"
       d="m 276.114,274.167 -0.489,1.465 -1.545,0.012 c -0.2,10e-4 -0.282,0.257 -0.122,0.375 l 1.242,0.918 -0.466,1.473 c -0.061,0.191 0.157,0.349 0.32,0.232 l 1.257,-0.898 1.257,0.898 c 0.162,0.116 0.38,-0.042 0.32,-0.232 l -0.466,-1.473 1.242,-0.918 c 0.161,-0.119 0.078,-0.374 -0.122,-0.375 l -1.545,-0.012 -0.489,-1.465 c -0.063,-0.19 -0.331,-0.19 -0.394,0 z"
       id="path38" />
    	<path
       fill="#ffbe5a"
       d="m 277.79,266.335 -0.489,1.465 -1.545,0.012 c -0.2,10e-4 -0.282,0.257 -0.122,0.375 l 1.242,0.918 -0.466,1.473 c -0.061,0.191 0.157,0.349 0.32,0.232 l 1.257,-0.898 1.257,0.898 c 0.162,0.116 0.38,-0.042 0.32,-0.232 l -0.466,-1.473 1.242,-0.918 c 0.161,-0.119 0.078,-0.374 -0.122,-0.375 l -1.545,-0.012 -0.489,-1.465 c -0.062,-0.19 -0.33,-0.19 -0.394,0 z"
       id="path39" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 246.361,192.081 0.737,3.526 h 0.318 v -2.406 c 0,0 0.524,1.678 1.266,2.406 h 0.6 c -0.287,-0.369 -0.803,-1.134 -0.803,-1.927 0,-1.091 0.868,-1.24 0.868,-2.407 h 0.744 v 4.333 h 0.435 l 0.806,-3.861 c 0,0 0.664,2.415 1.914,3.861 h 0.556 c -0.401,-0.589 -1.234,-2.109 -1.081,-4.407 0,0 1.191,-0.596 1.191,-2.208 v -2.294 c 0,-0.429 0.349,-0.778 0.778,-0.778 h 0.535 c 0,0 -0.796,-1.544 -1.647,-1.768 v -0.968 l -0.641,0.969 c -0.612,0.132 -0.973,0.698 -0.973,1.304 v 1.397 c 0,0.429 -0.348,0.778 -0.778,0.778 h -2.781 c -0.823,0 -2.142,0.823 -2.142,1.878 0,1.055 0.791,1.747 0.791,1.747 z"
       id="path40" />
    <path
       fill="#ffbe5a"
       d="m 258.819,188.568 h -0.255 c -2.016,0.11 -3.142,1.436 -3.142,1.436 l 2.045,2.045 v 3.848 h 2.447 v -3.848 l 2.045,-2.045 c 10e-4,-0.001 -1.124,-1.326 -3.14,-1.436 z"
       id="path41" />
    <g
       id="g42"
       transform="translate(0,-88.276)">
    	<rect
       x="263.12"
       y="270.54999"
       fill="#f5f5f5"
       width="0.73900002"
       height="13.634"
       id="rect41" />
    	<path
       fill="#f5f5f5"
       d="m 263.511,270.445 -3.987,4.819 c 0,0 -0.52,-2.323 1.803,-4.61 l -5.13,0.936 c 0,0 1.56,-2.912 5.65,-2.6 l -4.194,-3.501 c 0,0 3.605,-0.207 5.442,2.496 0,0 1.039,-3.119 3.951,-3.258 l -2.403,3.651 c 0,0 2.403,-1.225 5.731,-0.15 l -4.957,1.318 c 0,0 2.773,0.277 3.917,4.333 l -4.298,-2.946 c 0,0 1.318,1.56 0.832,4.61 z"
       id="path42" />
    	<polygon
       fill="#f5f5f5"
       points="209.856,240.622 213.849,240.622 212.518,236.629 202.756,231.748 "
       id="polygon42" />
    </g>
    <path
       fill="#825546"
       d="m 262.94,142.702 26.337,-8.104 -13.981,-5.242 c -2.49,-0.935 -5.129,-1.412 -7.789,-1.412 h -2.633 c -1.225,0 -2.218,0.993 -2.218,2.218 v 2.218 h -6.657 -6.655 v -2.218 c 0,-1.225 -0.993,-2.218 -2.218,-2.218 h -2.633 c -2.66,0 -5.299,0.479 -7.789,1.412 l -13.981,5.242 26.337,8.104 c 1.31,0.403 1.944,1.886 1.332,3.113 l -3.266,6.531 h 17.748 l -3.266,-6.531 c -0.613,-1.226 0.021,-2.709 1.332,-3.113 z"
       id="path43" />
    <circle
       fill="#f5f5f5"
       cx="256"
       cy="134.59399"
       r="4.4359999"
       id="circle43" />
    <path
       fill="#ffbe5a"
       d="m 258.218,134.599 v 0 c 0,1.225 -0.993,2.218 -2.218,2.218 h -8.874 l 3.787,-3.787 c 0.416,-0.416 0.98,-0.65 1.569,-0.65 h 3.517 c 1.226,0.001 2.219,0.994 2.219,2.219 z"
       id="path44" />
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g58"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BQ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs29" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 251.41,46.933 65.354,160.184 c -5.651,3.439 -5.651,11.641 0,15.081 L 251.41,288.517 c 2.819,1.716 6.36,1.716 9.18,0 L 446.647,175.266 c 5.651,-3.439 5.651,-11.641 0,-15.081 L 260.59,46.933 c -2.819,-1.716 -6.361,-1.716 -9.18,0 z"
       id="path2" />
    <circle
       fill="#41479b"
       cx="256"
       cy="167.72501"
       r="70.620003"
       id="circle2" />
    <g
       id="g14"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 195.401,219.874 c -3.332,5.578 -5.905,11.64 -7.605,18.077 39.149,-2.946 97.062,8.006 133.922,43.773 2.406,-6.141 3.994,-12.683 4.59,-19.522 -38.061,-32.033 -90.68,-43.424 -130.907,-42.328 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 258.925,280.1 1.88,5.638 5.943,0.046 c 0.769,0.006 1.088,0.988 0.47,1.445 l -4.781,3.531 1.793,5.666 c 0.232,0.734 -0.604,1.341 -1.229,0.893 l -4.835,-3.456 -4.835,3.456 c -0.626,0.448 -1.461,-0.159 -1.229,-0.893 l 1.793,-5.666 -4.781,-3.531 c -0.619,-0.457 -0.3,-1.439 0.469,-1.445 l 5.943,-0.046 1.88,-5.638 c 0.243,-0.73 1.275,-0.73 1.519,0 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 282.024,294.685 0.809,2.426 2.558,0.02 c 0.331,0.002 0.469,0.425 0.202,0.622 l -2.058,1.519 0.771,2.439 c 0.1,0.316 -0.259,0.577 -0.529,0.384 l -2.081,-1.487 -2.081,1.487 c -0.269,0.193 -0.629,-0.068 -0.529,-0.384 l 0.771,-2.439 -2.058,-1.519 c -0.266,-0.196 -0.129,-0.619 0.202,-0.622 l 2.558,-0.02 0.809,-2.426 c 0.106,-0.315 0.551,-0.315 0.656,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 248.938,269.39 0.809,2.426 2.558,0.02 c 0.331,0.002 0.469,0.425 0.202,0.622 l -2.058,1.519 0.771,2.439 c 0.1,0.316 -0.259,0.577 -0.529,0.384 l -2.081,-1.487 -2.081,1.487 c -0.269,0.193 -0.629,-0.068 -0.529,-0.384 l 0.771,-2.439 -2.058,-1.519 c -0.266,-0.196 -0.129,-0.619 0.202,-0.622 l 2.558,-0.02 0.809,-2.426 c 0.106,-0.314 0.551,-0.314 0.656,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 204.13,266.448 0.809,2.426 2.558,0.02 c 0.331,0.002 0.469,0.425 0.202,0.622 l -2.058,1.519 0.771,2.439 c 0.1,0.316 -0.259,0.577 -0.529,0.384 l -2.081,-1.487 -2.081,1.487 c -0.269,0.193 -0.629,-0.068 -0.529,-0.384 l 0.771,-2.439 -2.058,-1.519 c -0.266,-0.196 -0.129,-0.619 0.202,-0.622 l 2.558,-0.02 0.809,-2.426 c 0.107,-0.314 0.551,-0.314 0.656,0 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 241.614,293.847 0.809,2.426 2.558,0.02 c 0.331,0.002 0.469,0.425 0.202,0.622 l -2.058,1.519 0.771,2.439 c 0.1,0.316 -0.259,0.577 -0.529,0.384 l -2.081,-1.487 -2.081,1.487 c -0.269,0.193 -0.629,-0.068 -0.529,-0.384 l 0.771,-2.439 -2.058,-1.519 c -0.266,-0.196 -0.129,-0.619 0.202,-0.622 l 2.558,-0.02 0.809,-2.426 c 0.107,-0.313 0.552,-0.313 0.656,0 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 220.99,264.755 0.662,1.984 2.092,0.017 c 0.27,0.002 0.383,0.348 0.166,0.509 l -1.683,1.242 0.631,1.994 c 0.082,0.258 -0.212,0.472 -0.433,0.314 l -1.702,-1.216 -1.702,1.216 c -0.221,0.158 -0.514,-0.056 -0.433,-0.314 l 0.631,-1.994 -1.683,-1.242 c -0.217,-0.161 -0.106,-0.507 0.166,-0.509 l 2.092,-0.017 0.662,-1.984 c 0.085,-0.257 0.448,-0.257 0.534,0 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 283.819,223.794 0.828,2.482 2.616,0.02 c 0.339,0.002 0.479,0.435 0.206,0.636 l -2.104,1.554 0.789,2.495 c 0.103,0.323 -0.266,0.59 -0.541,0.393 l -2.129,-1.522 -2.129,1.522 c -0.276,0.198 -0.643,-0.071 -0.541,-0.393 l 0.789,-2.495 -2.104,-1.554 c -0.273,-0.201 -0.132,-0.633 0.206,-0.636 l 2.616,-0.02 0.828,-2.482 c 0.108,-0.322 0.563,-0.322 0.67,0 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 207.012,252.617 0.662,1.984 2.092,0.017 c 0.27,0.002 0.383,0.348 0.166,0.509 l -1.683,1.242 0.631,1.994 c 0.082,0.258 -0.212,0.472 -0.433,0.314 l -1.702,-1.216 -1.702,1.216 c -0.221,0.158 -0.514,-0.056 -0.433,-0.314 l 0.631,-1.994 -1.683,-1.242 c -0.217,-0.161 -0.106,-0.506 0.166,-0.509 l 2.092,-0.017 0.662,-1.984 c 0.085,-0.257 0.448,-0.257 0.534,0 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 217.112,280.581 1.002,3.006 3.168,0.024 c 0.41,0.003 0.58,0.526 0.25,0.77 l -2.549,1.882 0.956,3.02 c 0.124,0.391 -0.321,0.715 -0.655,0.476 l -2.578,-1.842 -2.578,1.842 c -0.333,0.238 -0.779,-0.085 -0.655,-0.476 l 0.956,-3.02 -2.549,-1.882 c -0.33,-0.244 -0.16,-0.767 0.25,-0.77 l 3.168,-0.024 1.002,-3.006 c 0.133,-0.388 0.683,-0.388 0.812,0 z"
       id="path12" />
    	<path
       fill="#f5f5f5"
       d="m 294.903,295.315 0.63,1.891 1.993,0.015 c 0.258,0.002 0.365,0.331 0.158,0.484 l -1.603,1.184 0.601,1.9 c 0.078,0.246 -0.202,0.449 -0.413,0.299 l -1.621,-1.159 -1.622,1.159 c -0.21,0.15 -0.49,-0.053 -0.413,-0.299 l 0.601,-1.9 -1.603,-1.184 c -0.207,-0.153 -0.1,-0.482 0.158,-0.484 l 1.993,-0.015 0.63,-1.891 c 0.083,-0.245 0.43,-0.245 0.511,0 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 301.877,280.885 0.809,2.426 2.558,0.02 c 0.331,0.002 0.469,0.425 0.202,0.622 l -2.058,1.519 0.771,2.439 c 0.1,0.316 -0.259,0.577 -0.529,0.384 l -2.081,-1.487 -2.081,1.487 c -0.269,0.193 -0.629,-0.068 -0.529,-0.384 l 0.771,-2.439 -2.058,-1.519 c -0.266,-0.196 -0.129,-0.619 0.202,-0.622 l 2.558,-0.02 0.809,-2.426 c 0.106,-0.315 0.551,-0.315 0.656,0 z"
       id="path14" />
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="M 512,200.093 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#82afff"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 V 311.909 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="111.815"
       fill="#ffe15a"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#464655"
       d="M 3.256,333.315 206.097,172.3 c 2.946,-2.338 2.946,-6.812 0,-9.151 L 3.256,2.135 C 1.311,3.754 0,6.1 0,8.828 v 317.793 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs39" />
    <path
       fill="#ff6e55"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 512,3.953 508.047,0 503.172,0 Z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 3.256,333.315 508.743,2.134 C 507.213,0.861 505.318,0 503.172,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 326.62 c 0,2.729 1.311,5.076 3.256,6.695 z"
       id="path2" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#fff5dc"
       d="m 281.52,178.026 c -4.436,0.95 -11.405,-1.426 -11.405,-1.426 1.436,2.473 5.276,4.138 8.739,5.186 -2.796,0.279 -5.985,0.437 -9.532,0.359 -14.257,-0.318 -20.909,9.029 -20.909,9.029 5.069,-3.169 10.296,-3.169 18.058,-2.059 7.762,1.109 24.236,-3.801 24.236,-3.801 l 1.426,-6.336 c 0,-0.001 -6.177,-1.902 -10.613,-0.952 z"
       id="path3" />
    	<path
       fill="#fff5dc"
       d="m 296.173,148.326 c 0,0 7.371,1.562 14.852,5.855 -0.45,0.236 -0.881,0.525 -1.291,0.864 -2.418,-1.202 -5.339,-2.175 -9.127,-2.561 0,0 3.921,1.02 7.688,3.97 -0.975,1.149 -1.779,2.456 -2.398,3.618 -8.287,-8.886 -17.249,-2.955 -17.249,-2.955 11.117,-0.845 13.74,6.298 14.366,9.748 -2.153,-1.439 -4.181,-2.625 -6.083,-3.59 0.279,-0.209 0.42,-0.397 0.747,-0.612 0,0 -0.696,0.028 -1.662,0.172 -14.188,-6.819 -21.149,-1.44 -21.149,-1.44 6.301,-0.77 12.124,0.868 16.744,2.908 -2.03,1.169 -3.405,3.228 -2.271,6.728 -7.957,-2.165 -17.957,-4.298 -22.869,-2.983 -8.871,2.376 -6.019,10.613 -6.019,10.613 0,0 0.159,-5.544 6.178,-6.812 4.506,-0.949 26.928,6.178 26.928,6.178 l 7.286,-3.485 -3.009,-2.535 c 0,0 -5.784,-2.322 -3.304,-6.312 4.147,2.211 6.788,4.41 6.788,4.41 l 1.783,-2.605 c 0.087,0.674 0.118,1.18 0.118,1.18 l 5.069,-2.217 1.109,-1.585 c 0.444,-2.404 1.178,-4.114 2.023,-5.394 1.466,1.843 2.679,4.119 3.284,6.937 l 4.594,0.476 c 0,0 -0.746,-5.31 -5.886,-9.533 0.456,-0.324 0.906,-0.593 1.349,-0.772 3.385,2.429 6.542,5.466 8.734,9.276 l 8.474,-0.119 c 0.002,0.002 -13.938,-15.522 -35.797,-17.423 z"
       id="path4" />
    	<circle
       fill="#fff5dc"
       cx="377.04001"
       cy="223.17"
       r="10.613"
       id="circle4" />
    	<circle
       fill="#fff5dc"
       cx="352.26001"
       cy="312.5"
       r="14.238"
       id="circle5" />
    	<circle
       fill="#fff5dc"
       cx="243.72"
       cy="305.60001"
       r="11.285"
       id="circle6" />
    	<circle
       fill="#fff5dc"
       cx="217.75999"
       cy="359.19"
       r="13.03"
       id="circle7" />
    	<path
       fill="#fff5dc"
       d="m 341.872,195.452 c 0,0 24.402,8.696 30.294,11.642 8.317,4.158 21.385,-7.96 30.532,1.426 0,0 -1.585,-6.257 -9.187,-6.732 0,0 0.159,-6.178 -6.969,-5.86 0,0 5.227,3.801 2.218,6.495 0,0 -2.059,-4.594 -7.921,-3.801 0,0 4.435,1.742 3.327,4.435 0,0 -7.049,3.405 -10.217,1.188 -3.168,-2.218 -28.195,-15.722 -36.116,-16.039 z"
       id="path7" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 335.614,114.778 c 0,0 5.227,1.545 12.831,9.504 3.523,3.689 12.592,3.921 11.167,-3.208 -1.426,-7.128 -19.008,-11.523 -20.909,-11.523 -1.9,0 -3.089,5.227 -3.089,5.227 z"
       id="path8" />
    <g
       id="g15"
       transform="translate(0,-88.276)">
    	<path
       fill="#fff5dc"
       d="m 373.711,187.373 -9.98,3.327 c 0,0 1.109,6.772 -4.594,9.742 -3.512,1.83 -5.86,6.573 -5.703,10.058 0,0 3.327,-4.594 8.078,-7.128 1.119,-0.597 2.151,-1.12 3.091,-1.651 -0.189,2.375 -0.239,4.868 0.078,7.037 0.95,6.494 -1.109,8.712 -1.109,8.712 0,0 5.545,-4.277 4.91,-11.246 -0.244,-2.678 0.195,-4.575 0.877,-6.015 0.491,4.853 3.082,7.125 3.082,7.125 -1.901,-3.801 2.059,-7.921 3.644,-11.247 1.586,-3.329 -2.374,-8.714 -2.374,-8.714 z"
       id="path9" />
    	<path
       fill="#fff5dc"
       d="m 398.936,173.592 c -3.929,-1.336 -7.722,1.069 -9.98,3.089 -0.961,0.86 -3.493,1.297 -6.084,1.532 1.73,-1.224 3.572,-2.669 4.541,-3.907 2.138,-2.732 6.059,-3.208 9.385,-4.277 3.327,-1.069 4.753,-5.346 4.753,-5.346 0,0 -1.782,2.614 -6.772,2.376 -4.99,-0.238 -6.653,-0.476 -9.98,3.089 -1.023,1.096 -2.455,1.943 -3.94,2.624 0.032,-1.557 0.167,-3.538 0.613,-4.881 0.832,-2.495 4.633,-4.514 4.871,-9.504 0.237,-4.99 0.476,-4.514 3.327,-7.485 2.851,-2.97 3.683,-8.554 2.851,-6.772 -0.832,1.782 -4.633,3.921 -7.841,6.891 -3.208,2.97 -0.95,6.296 -2.614,8.91 -1.663,2.614 -5.583,3.208 -5.822,8.078 -0.237,4.871 -3.683,7.722 -3.683,7.722 0,0 -8.435,4.633 1.663,8.317 10.099,3.683 18.268,-6.563 23.285,-6.296 11.167,0.594 14.137,-3.089 14.137,-3.089 -1.899,-0.001 -6.77,0.949 -12.71,-1.071 z"
       id="path10" />
    	<path
       fill="#fff5dc"
       d="m 276.451,251.843 c -0.633,-0.476 -11.563,-12.514 -15.207,-14.257 l 0.792,3.01 c 0,0 -2.376,-0.159 -6.653,-5.386 -4.277,-5.227 -7.445,-6.653 -7.445,-6.653 0,0 3.01,4.753 2.851,7.762 0,0 -6.495,-0.476 -13.464,2.851 0,0 -3.168,-6.178 -5.86,-7.286 0,0 0.95,6.495 -1.267,8.078 -2.218,1.585 20.909,12.514 24.077,12.831 3.168,0.317 22.176,-0.95 22.176,-0.95 z"
       id="path11" />
    	<path
       fill="#fff5dc"
       d="m 290.866,228.241 c -0.225,-0.056 -1.394,0.766 -2.902,1.843 -0.666,-3.847 -2.008,-11.624 -2.008,-11.981 0,-0.476 -10.772,-15.523 -11.089,-16.157 -0.006,-0.011 -0.041,-0.012 -0.049,-0.022 1.046,-2.53 2.173,-6.838 -4.228,-3.463 -8.713,4.595 -12.197,15.207 -12.197,15.207 1.986,-2.072 5.452,-3.654 8.218,-4.682 0.057,1.292 0.067,2.826 -1.724,5.474 -3.644,5.385 -1.585,7.445 -1.585,7.445 2.851,-4.91 9.187,-5.386 9.187,-5.386 -0.95,5.861 2.376,9.187 2.376,9.187 l 2.692,-3.168 c -0.332,4.535 2.095,9.401 3.604,11.958 -0.596,0.288 -1.14,0.509 -1.544,0.555 -2.694,0.318 -6.969,2.376 -6.969,2.376 0,0 3.466,-0.739 5.434,0.781 1.967,1.521 5.099,2.684 6.798,2.326 0,0 -0.806,4.115 0.089,5.635 0,0 -2.237,-0.628 -4.831,-0.537 -2.594,0.09 -4.482,-1.71 -4.482,-1.71 0,0 4.753,6.81 8.237,8.236 3.484,1.426 9.504,-3.801 9.504,-3.801 0,0 -1.897,-19.959 -2.531,-20.116 z"
       id="path12" />
    	<path
       fill="#fff5dc"
       d="m 208.972,327.56 c 0,0 -3.01,0.317 -5.86,4.594 l -1.267,-4.435 c 0,0 -3.485,2.535 -7.286,0.95 0,0 3.485,-0.792 4.118,-3.96 0.633,-3.168 1.901,-3.485 1.901,-3.485 0,0 -2.376,-2.535 -4.91,-2.376 0,0 6.969,-3.644 10.772,-0.159 3.798,3.485 2.532,8.871 2.532,8.871 z"
       id="path13" />
    	<path
       fill="#fff5dc"
       d="m 292.766,292.553 c 0,0 -3.01,0.317 -5.86,4.594 l -1.267,-4.436 c 0,0 -3.485,2.535 -7.286,0.95 0,0 3.485,-0.792 4.118,-3.96 0.633,-3.168 1.901,-3.485 1.901,-3.485 0,0 -2.376,-2.535 -4.91,-2.376 0,0 6.969,-3.644 10.772,-0.159 3.8,3.486 2.532,8.872 2.532,8.872 z"
       id="path14" />
    	<path
       fill="#fff5dc"
       d="m 344.146,247.488 c 0,0 -1.47,2.646 0.394,7.436 l -4.359,-1.511 c 0,0 0.073,4.309 -3.407,6.51 0,0 1.353,-3.307 -0.876,-5.646 -2.229,-2.339 -1.761,-3.558 -1.761,-3.558 0,0 -3.439,0.489 -4.766,2.655 0,0 1.021,-7.798 6.057,-8.908 5.037,-1.109 8.718,3.022 8.718,3.022 z"
       id="path15" />
    </g>
    <path
       fill="#ff6e55"
       d="m 359.398,212.745 3.066,1.828 c -0.892,-0.767 -1.951,-1.342 -3.066,-1.828 z"
       id="path16" />
    <path
       fill="#fff5dc"
       d="m 186.478,228.037 c 0,0 -14.098,19.8 -30.255,24.077 l 5.703,-7.286 c 0,0 -7.604,6.653 -16.157,8.078 l 10.296,-11.88 c 0,0 -22.968,21.385 -52.431,25.82 0,0 22.81,-14.414 27.404,-19.484 0,0 -11.089,4.436 -21.068,4.594 0,0 28.671,-11.089 33.423,-15.523 0,0 -11.405,2.535 -18.533,0.159 0,0 24.711,-7.128 28.195,-6.178 0,0 -14.257,-5.703 -22.81,-5.069 0,0 14.573,-3.485 31.522,0 l -3.644,-3.96 c 0,0 9.663,-2.535 19.167,-3.168 9.504,-0.633 4.753,-1.426 4.753,-1.426 l 1.109,-3.168 c 0,0 -6.178,0.792 -11.246,0 0,0 15.207,-8.554 19.484,-12.355 4.277,-3.801 1.426,-2.059 1.426,-2.059 0,0 -7.921,2.692 -10.772,3.168 0,0 7.128,-8.237 9.346,-13.623 0,0 -6.495,2.535 -12.039,0 0,0 6.653,-1.901 9.98,-5.227 3.327,-3.327 8.237,-11.603 8.237,-11.603 l -5.703,2.495 c 0,0 4.99,-8.554 9.386,-10.692 0,0 -7.485,0.594 -9.86,-1.188 0,0 7.96,-1.901 10.336,-3.801 2.376,-1.901 7.604,-6.891 12.949,-4.99 0,0 7.485,-6.891 4.99,-11.405 0,0 4.871,0.356 7.366,3.327 2.495,2.97 6.415,5.465 6.415,5.465 l -20.355,15.919 -15.523,50.372 z"
       id="path17" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 385.907,221.27 c 5.862,9.504 -1.426,10.455 -1.426,10.455 -1.109,-9.029 -8.712,-7.919 -8.712,-7.919 l 2.059,6.653 c -12.672,1.585 -11.722,-11.089 -11.722,-11.089 -1.901,1.585 -5.069,8.078 -5.069,8.078 0,0 -34.215,11.405 -57.342,-22.493 0,0 -0.633,-6.02 1.268,-8.872 l -14.257,-10.771 -18.375,2.535 c 0,0 -7.286,16.473 1.585,26.612 8.871,10.137 19.325,24.394 17.424,31.047 -1.127,3.944 -4.48,5.549 -9.135,5.214 -3.199,-0.231 -7.011,-1.378 -11.139,-3.313 -10.138,-4.753 -34.849,-14.889 -52.59,-6.653 -17.741,8.237 -19.666,22.49 -23.127,33.582 -3.064,9.818 -9.863,34.884 -58.299,57.753 -2.314,1.092 -1.137,4.609 1.346,3.992 20.996,-5.22 49.621,-13.918 58.457,-24.203 l 7.128,0.237 -2.614,10.93 c 0,0 9.267,2.851 10.692,16.395 0,0 -16.236,4.435 -7.049,18.375 0,0 1.426,-10.138 12.672,-10.613 0,0 2.535,3.327 8.078,3.801 0,0 2.851,4.595 1.426,8.396 0,0 11.246,-3.485 1.742,-16.95 0,0 10.613,-2.534 12.039,10.772 0,0 6.812,-21.543 -17.503,-19.959 0,0 0,-3.801 -6.415,-10.692 0,0 -1.583,-3.882 0,-9.267 0.477,-1.621 0.908,-3.303 1.268,-5.017 1.321,0.733 3.352,1.599 6.018,1.692 0,0 3.96,6.494 15.682,5.385 0,0 -8.554,-3.959 -7.762,-11.563 0.792,-7.604 10.772,-11.722 15.049,-8.713 0,0 -1.109,-9.98 -16.632,-3.485 0,0 0,-7.445 8.237,-7.919 0,0 -13.305,-10.138 -16.316,9.187 l -5.506,1.376 c -2.69,-7.457 -6.098,-24.771 8.991,-31.077 15.919,-6.653 32.552,8.317 62.015,9.742 0,0 -2.851,17.345 6.653,21.622 9.504,4.277 32.789,8.317 32.789,8.317 -0.237,25.027 17.978,21.7 17.978,21.7 -8.841,-5.298 -8.841,-15.406 -3.384,-21.31 7.437,-8.046 20.333,-0.392 20.333,-0.392 -0.182,-12.182 -17.266,-10.297 -17.266,-10.297 2.692,-7.919 13.305,-9.98 13.305,-9.98 -14.731,-5.385 -26.928,10.535 -26.928,10.535 l -24.949,-7.128 c 0,0 -0.95,-4.99 4.99,-11.642 5.94,-6.652 10.93,-17.821 9.267,-29.7 0,0 6.891,-4.832 15.444,-0.079 8.554,4.753 26.928,-5.703 26.928,-5.703 7.921,10.137 26.77,8.237 29.304,-3.959 2.538,-12.199 -6.65,-13.625 -6.65,-13.625 z"
       id="path18" />
    	<path
       fill="#f5f5f5"
       d="m 359.771,192.125 c -4.712,-2.749 -13.148,-5.069 -15.999,1.267 -2.851,6.336 -6.019,12.672 -15.84,12.355 -9.821,-0.317 -14.257,8.078 -21.068,5.703 0,0 6.336,-2.059 7.604,-5.069 1.267,-3.01 6.336,-8.554 6.336,-8.554 l -0.633,-5.703 c 0,0 -11.722,0.632 -15.207,3.959 -3.485,3.327 -16.632,-2.85 -16.632,-2.85 l 1.585,-13.781 c 0,0 10.137,-15.523 24.236,-14.414 14.098,1.109 16.474,-2.535 23.285,-2.059 6.812,0.476 10.296,7.445 17.582,9.029 7.286,1.585 21.859,-1.426 23.76,3.01 1.901,4.435 -3.644,6.178 -5.069,12.355 -1.426,6.177 -4.436,10.297 -13.94,4.752 z"
       id="path19" />
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    	<path
       fill="#fff5dc"
       d="m 318.587,188.165 c 0,0 -6.812,4.594 -12.514,2.692 -5.703,-1.901 -10.772,-1.267 -16.632,0.633 0,0 10.772,-1.267 15.207,2.851 4.435,4.118 15.682,1.426 16.474,-0.317 z"
       id="path20" />
    	<path
       fill="#fff5dc"
       d="m 322.072,198.777 c 0,0 -6.653,4.753 -13.305,3.485 -6.653,-1.267 -12.672,1.426 -12.672,1.426 0,0 4.91,-5.386 11.563,-4.435 6.653,0.95 9.028,-5.544 9.028,-5.544 l 4.436,0.317 z"
       id="path21" />
    	<circle
       fill="#fff5dc"
       cx="327.45999"
       cy="192.92"
       r="8.8719997"
       id="circle21" />
    	<path
       fill="#fff5dc"
       d="m 322.229,186.264 c 0,0 -3.485,-4.435 -12.197,-2.692 -8.712,1.742 -10.772,-1.426 -10.772,-1.426 0,0 4.118,6.336 10.613,5.544 6.495,-0.792 9.187,3.644 9.187,3.644 z"
       id="path22" />
    	<path
       fill="#fff5dc"
       d="m 351.538,175.173 c 0.783,-1.079 1.768,-2.108 3.114,-2.891 0.794,-0.462 1.611,-0.754 2.42,-0.994 0.18,-1.203 0.003,-2.5 -0.683,-3.678 -1.497,-2.57 -4.61,-3.546 -6.954,-2.18 -2.343,1.365 -3.029,4.555 -1.532,7.125 0.841,1.442 2.197,2.311 3.635,2.618 z"
       id="path23" />
    	<path
       fill="#fff5dc"
       d="m 343.757,185.377 c 0.446,-1.257 1.099,-2.521 2.168,-3.655 0.631,-0.668 1.332,-1.178 2.039,-1.638 -0.168,-1.204 -0.704,-2.399 -1.696,-3.335 -2.163,-2.041 -5.426,-2.097 -7.287,-0.125 -1.862,1.972 -1.617,5.226 0.547,7.267 1.217,1.15 2.763,1.6 4.229,1.486 z"
       id="path24" />
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#82afff"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <rect
       y="141.244"
       fill="#464655"
       width="512"
       height="52.965"
       id="rect1"
       x="0" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<rect
       y="211.86"
       fill="#f5f5f5"
       width="512"
       height="17.655001"
       id="rect2"
       x="0" />
    	<rect
       y="282.48001"
       fill="#f5f5f5"
       width="512"
       height="17.655001"
       id="rect3"
       x="0" />
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BY = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.448" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 v -79.448 h 512 v 79.448 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 247.172 H 512 V 8.828 C 512,3.953 508.047,0 503.172,0 Z"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="M 70.621,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 61.793 z"
       id="path3" />
    <path
       fill="#ff4b55"
       d="m 8.833,320.787 h 3.122 v -8.75 H 8.833 Z m 24.918,0 h 3.123 v -8.75 h -3.123 z m 24.934,0 h 3.108 v -8.75 h -3.108 z m -37.377,-23.46 h 3.091 v -7.292 h -3.091 z m 24.933,0 h 3.108 v -7.292 H 46.241 Z M 8.833,278.305 h 3.122 v -8.75 H 8.833 Z m 24.918,0 h 3.123 v -8.75 h -3.123 z m 24.934,0 h 3.108 v -8.75 h -3.108 z m -43.591,11.73 h 3.091 v -7.357 h 3.123 v -7.292 h 3.091 v 7.292 h 3.139 v 7.357 h 3.091 v 7.292 h -3.091 v 7.354 h -3.139 v 7.354 h -3.091 v -7.354 h -3.123 v -7.354 h -3.091 z m 24.919,0 h 3.122 v -7.357 h 3.107 v -7.292 h 3.108 v 7.292 h 3.107 v 7.357 h 3.122 v 7.292 h -3.122 v 7.354 H 49.35 v 7.354 h -3.108 v -7.354 h -3.107 v -7.354 h -3.122 z m 6.228,-29.294 v 7.292 h -3.137 v 7.354 h -3.091 v 7.292 h -3.139 v 7.357 h -3.123 v -7.357 h -3.123 v -7.292 h -3.091 v -7.354 h -3.139 v -7.292 h -3.091 v 7.292 h -3.123 v 7.354 h -3.091 v 7.292 h -3.139 v 7.357 H 8.833 v 7.292 h 3.122 v 7.354 h 3.139 v 7.354 h 3.091 v 7.292 h 3.123 v 7.293 h 3.123 v -7.293 h 3.107 v -7.292 h 3.091 v -7.354 h 3.123 v -7.354 h 3.123 v 7.354 h 3.139 v 7.354 h 3.122 v 7.292 h 3.107 v 7.293 h 3.108 v -7.293 h 3.107 v -7.292 h 3.122 v -7.354 h 3.123 v -7.354 h 3.091 v -7.292 h -3.108 v -7.357 H 55.58 v -7.292 h -3.122 v -7.354 h -3.107 v -7.292 z m 7.72,-7.29 h 1.554 v -2.916 h 1.569 v 2.916 h 1.569 v 2.915 h -1.569 v 2.98 h -1.569 v -2.98 h -1.554 z m 0,-10.21 v 4.313 h -1.537 v 4.438 h -1.569 v 5.834 h 1.569 v 4.374 h 1.537 v 4.374 h 4.693 V 262.2 h 1.554 v -4.374 h 1.537 v -5.834 h -1.537 v -4.438 h -1.554 v -4.313 z m -42.006,10.145 h 1.569 v -2.915 h 1.569 v 2.915 h 1.521 v 2.98 h -1.521 v 2.916 h -1.569 v -2.916 h -1.569 z m 0,-10.209 v 4.376 h -1.554 v 4.374 H 8.833 v 5.897 h 1.568 v 4.374 h 1.554 v 4.374 h 4.66 v -4.374 h 1.569 v -4.374 h 1.523 v -5.897 h -1.523 v -4.374 h -1.569 v -4.376 z m 17.135,10.209 h 1.537 v -2.915 h 1.586 v 2.915 h 1.537 v 2.98 h -1.537 v 2.916 h -1.586 v -2.916 H 29.09 Z m 7.784,0 h 1.569 v -2.915 h 1.569 v 2.915 h 1.537 v 2.98 h -1.537 v 2.916 h -1.569 v -2.916 h -1.569 z m 0,-10.209 v 4.376 h -3.123 v -4.376 h -4.66 v 4.376 h -1.554 v 4.374 h -1.569 v 5.897 h 1.569 v 4.374 h 1.554 v 4.374 h 4.66 v -4.374 h 3.123 v 4.374 h 4.676 v -4.374 h 1.585 v -4.374 h 1.523 v -5.897 h -1.523 v -4.374 H 41.55 v -4.376 z m -28.041,-2.98 h 3.122 v -8.749 H 8.833 Z m 24.918,0 h 3.123 v -8.749 h -3.123 z m 24.934,0 h 3.108 v -8.749 H 58.685 Z M 8.833,203.611 h 3.122 v -5.832 H 8.833 Z m 49.852,0 h 3.108 v -5.832 h -3.108 z m -24.934,-20.48 h 3.123 v -7.292 H 33.751 Z M 8.833,163.35 v 4.374 0.063 4.374 h 3.122 v -4.374 -0.063 -4.374 z m 17.134,0 v 4.374 0.063 4.374 h 3.123 v -4.374 -0.063 -4.374 z m 15.583,0 v 4.374 0.063 4.374 h 3.107 v -4.374 -0.063 -4.374 z m 17.135,0 v 4.374 0.063 4.374 h 3.108 v -4.374 -0.063 -4.374 z m -20.242,-5.135 v 2.916 h -1.569 v 2.219 h -3.123 v -2.219 h -1.537 v -2.916 h -3.123 v 4.374 h 1.537 v 2.219 h 1.586 v 2.916 0.063 2.854 h -1.586 v 2.219 h -1.537 v 4.374 h 3.123 v -2.915 h 1.537 v -2.157 h 3.123 v 2.157 h 1.569 v 2.915 h 3.107 v -4.374 h -1.537 v -2.219 h -1.569 v -2.854 -0.063 -2.916 h 1.569 v -2.219 h 1.537 v -4.374 z m -4.692,1.456 h 3.123 v -7.292 H 33.751 Z M 8.833,137.732 h 3.122 V 131.9 H 8.833 Z m 49.852,0 h 3.108 V 131.9 H 58.685 Z M 8.833,104.064 h 3.122 V 95.252 H 8.833 Z m 24.918,0 h 3.123 v -8.812 h -3.123 z m 24.934,0 h 3.108 v -8.812 h -3.108 z m -37.377,63.787 v -0.19 0 -2.854 h 3.091 v -5.073 h 3.139 v -5.897 h 4.676 v -6.91 h 1.537 v -3.361 h 1.57 1.553 v 3.297 h 1.569 v 6.975 h 4.691 v 2.916 2.98 h 3.107 v 5.073 h 3.108 v 2.917 2.916 h -3.108 v 5.199 h -3.107 v 2.916 2.916 h -4.691 v 6.912 h -1.569 v 3.297 h -1.553 -1.57 v -3.297 h -1.537 v -6.912 h -4.676 v -5.834 h -3.139 v -5.199 H 21.308 Z M 46.241,86.438 v 7.354 h -3.137 v 7.292 h -3.091 v 7.357 h -3.139 v 5.832 1.459 h -3.123 v -7.292 h -3.123 v -7.357 h -3.091 v -7.292 h -3.139 v -7.354 h -3.091 v 7.354 h -3.123 v 7.292 h -3.123 v 7.357 h -3.107 v 5.832 1.459 H 8.833 v 7.354 h 3.122 v 7.354 h 3.107 v 7.292 h 3.123 v 7.293 h 3.123 v -7.293 h 3.091 v -7.292 h 3.139 v -7.354 h -3.139 v -8.814 h 3.139 v 1.459 4.438 h 3.091 v 11.731 h 1.586 v 7.228 l -4.676,0.063 v 5.834 H 24.4 v 4.374 h -3.091 v 7.354 h -3.123 v -7.354 h -3.123 v -4.374 h -3.107 v -4.376 H 8.833 v 13.188 h 3.122 v 5.897 h 3.107 v 5.073 h 3.123 v 2.918 0.063 2.854 h -3.123 v 5.199 h -3.107 v 5.834 H 8.833 v 13.188 h 3.122 v -4.439 h 3.107 v -4.374 h 3.123 v -7.292 h 3.123 v 7.292 h 3.091 v 4.374 h 3.139 v 5.897 l 4.676,0.063 v 7.228 h -1.586 v 11.731 h -3.091 v 4.374 1.523 h -3.139 v -8.877 h 3.139 v -7.292 h -3.139 v -7.292 h -3.091 v -7.357 h -3.123 v 7.357 h -3.123 v 7.292 h -3.107 v 7.292 H 8.833 v 7.354 h 3.122 v 1.523 5.769 h 3.139 v 7.357 h 3.091 v 7.354 h 3.123 v 7.292 0 0 h 3.091 v -7.292 h 3.139 v -7.354 h 3.091 v -7.357 h 3.123 v -7.292 h 3.123 v 1.523 5.769 h 3.139 v 7.357 h 3.122 v 7.354 h 3.107 v 7.292 h 3.108 v -7.292 h 3.107 v -7.354 h 3.122 v -7.357 h 3.106 v -7.292 h 3.107 v -7.354 h -3.108 v -7.292 h -3.106 v -7.292 h -3.122 v -7.357 H 49.35 v 7.357 h -3.108 v 7.292 h -3.137 v 7.292 h 3.137 v 7.354 1.523 h -3.137 v -1.523 -4.374 h -3.091 v -11.731 h -0.445 -1.124 v -7.292 h 1.124 0.841 1.141 1.585 v -5.897 h 3.107 v -4.374 h 3.108 v -7.292 h 3.107 v 7.292 h 3.122 v 4.374 h 3.123 v 4.439 h 3.091 v -13.188 h -3.092 v -5.834 h -3.123 v -5.199 h -3.122 v -2.853 -0.063 -2.916 h 3.122 v -5.073 h 3.123 v -5.897 h 3.092 V 140.65 h -3.092 v 4.376 h -3.123 v 4.374 h -3.122 v 7.354 H 49.35 V 149.4 h -3.108 v -4.374 h -3.107 v -5.834 H 41.55 40.409 39.568 38.444 V 131.9 h 1.124 0.445 v -11.731 h 3.091 v -4.438 -1.459 h 3.137 v 1.459 7.354 h -3.137 v 7.354 h 3.137 v 7.292 h 3.108 v 7.293 h 3.107 v -7.293 h 3.122 v -7.292 h 3.106 v -7.354 h 3.11 v -7.354 h -3.108 v -7.292 H 55.58 v -7.357 H 52.458 V 93.79 h -3.107 v -7.354 h -3.11 z M 11.955,79.146 h 1.539 V 76.23 h 1.6 v 2.916 h 1.521 v 2.916 h -1.521 v 2.98 h -1.6 v -2.98 h -1.539 z m 0,-5.897 h -1.554 v 4.438 H 8.833 v 5.834 h 1.568 v 4.438 h 1.554 v 4.376 h 4.66 v -4.376 h 1.569 v -4.438 h 1.523 v -5.834 h -1.523 v -4.438 h -1.569 v -4.311 h -4.66 c 0,0 0,4.311 0,4.311 z m 17.135,5.897 h 1.537 V 76.23 h 1.586 v 2.916 h 1.537 v 2.916 h -1.537 v 2.98 h -1.586 v -2.98 H 29.09 Z m 7.784,0 h 1.569 V 76.23 h 1.569 v 2.916 h 1.537 v 2.916 h -1.537 v 2.98 h -1.569 v -2.98 H 36.874 Z M 29.09,73.249 h -1.554 v 4.438 h -1.569 v 5.834 h 1.569 v 4.438 h 1.554 v 4.376 h 4.66 v -4.376 h 3.123 v 4.376 h 4.676 v -4.376 h 1.585 v -4.438 h 1.523 v -5.834 h -1.523 v -4.438 h -1.585 v -4.311 h -4.676 v 4.311 H 33.75 v -4.311 h -4.66 z m 24.871,5.834 h 1.554 v -2.854 h 1.569 v 2.854 h 1.569 v 2.98 h -1.569 v 2.915 h -1.569 v -2.915 h -1.554 z m 0,-10.208 v 4.374 h -1.537 v 4.438 h -1.569 v 5.834 h 1.569 v 4.374 h 1.537 v 4.376 h 4.693 v -4.376 h 1.554 v -4.374 h 1.537 V 77.687 H 60.208 V 73.249 H 58.654 V 68.875 Z M 8.833,65.958 h 3.122 v -8.75 H 8.833 Z m 24.918,0 h 3.123 v -8.75 h -3.123 z m 24.934,0 h 3.108 v -8.75 H 58.685 Z M 21.308,45.478 h 3.091 v -7.357 h -3.091 z m 24.933,0 h 3.108 V 38.121 H 46.241 Z M 8.833,23.476 h 3.122 v -8.75 H 8.833 Z m 24.918,0 h 3.123 v -8.75 h -3.123 z m 24.934,0 h 3.108 v -8.75 H 58.685 Z M 15.094,38.122 h 3.091 V 30.83 h 3.123 v -7.354 h 3.091 v 7.354 h 3.139 v 7.292 h 3.091 v 7.357 h -3.091 v 7.292 h -3.139 v 7.354 h -3.091 v -7.354 h -3.123 v -7.292 h -3.091 z m 24.919,0 h 3.122 V 30.83 h 3.107 v -7.354 h 3.108 v 7.354 h 3.107 v 7.292 h 3.122 v 7.357 h -3.122 v 7.292 H 49.35 v 7.354 H 46.242 V 52.771 H 43.135 V 45.479 H 40.013 Z M 46.241,8.828 v 7.357 h -3.107 v 7.292 h -3.122 v 7.354 h -3.139 v 7.292 H 33.75 V 30.831 H 30.627 V 23.477 H 27.536 V 16.185 H 24.43 V 8.828 h -3.123 v 7.357 h -3.123 v 7.292 h -3.091 v 7.354 h -3.139 v 7.292 H 8.833 v 7.357 h 3.122 v 7.292 h 3.139 v 7.354 h 3.091 v 7.354 h 3.123 v 7.292 h 3.091 V 67.48 h 3.139 v -7.354 h 3.091 v -7.354 h 3.123 V 45.48 h 3.123 v 7.292 h 3.139 v 7.354 h 3.091 v 7.354 h 3.137 v 7.292 H 49.35 V 67.48 h 3.107 v -7.354 h 3.122 v -7.354 h 3.106 V 45.48 h 3.108 V 38.123 H 58.701 V 30.831 H 55.578 V 23.477 H 52.456 V 16.185 H 49.349 V 8.828 Z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const BZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs139" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="M 512,123.586 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#ff4b55"
       d="m 0,388.414 h 512 v 26.483 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,423.725 0,419.772 0,414.897 Z"
       id="path2" />
    </g>
    <rect
       y="35.313995"
       fill="#41479b"
       width="512"
       height="264.82999"
       id="rect2"
       x="0" />
    <circle
       fill="#f5f5f5"
       cx="256"
       cy="167.724"
       r="114.76"
       id="circle2" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="m 233.979,316.344 -17.704,2.951 c -2.231,0.372 -4.263,-1.348 -4.263,-3.612 v -6.661 h 21.966 z"
       id="path3" />
    	<path
       fill="#82afff"
       d="m 277.913,316.344 17.704,2.951 c 2.231,0.372 4.263,-1.348 4.263,-3.612 v -6.661 h -21.966 v 7.322 z"
       id="path4" />
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#965032"
       d="m 252.285,197.248 h -1.53 c -1.837,0 -3.489,-1.023 -4.312,-2.664 l -2.708,-5.417 2.456,-1.23 2.708,5.417 c 0.354,0.708 1.066,1.148 1.856,1.148 h 1.53 z"
       id="path5" />
    	
    		<rect
       x="219.894"
       y="195.37601"
       transform="matrix(0.4472,0.8944,-0.8944,0.4472,300.3374,-92.4574)"
       fill="#965032"
       width="10.149"
       height="2.7460001"
       id="rect5" />
    	<path
       fill="#965032"
       d="m 260.98,239.462 -7.502,-7.501 c -1.63,-1.63 -2.566,-3.886 -2.566,-6.193 v -2.525 c 0,-0.926 -0.22,-1.856 -0.634,-2.685 l -1.87,-3.74 c -0.39,-0.779 -1.174,-1.266 -2.047,-1.266 h -6.457 c -1.92,0 -3.645,-1.066 -4.503,-2.782 l -2.649,-5.299 2.456,-1.23 2.649,5.299 c 0.39,0.779 1.174,1.266 2.047,1.266 h 6.457 c 1.92,0 3.645,1.066 4.503,2.782 l 1.87,3.74 c 0.605,1.212 0.925,2.563 0.925,3.915 v 2.525 c 0,1.583 0.642,3.132 1.761,4.247 l 2.816,2.817 V 220.04 c 0,-3.468 -1.194,-6.868 -3.361,-9.578 -2.554,-3.197 -3.961,-7.204 -3.961,-11.294 v -10.615 h 2.745 v 10.615 c 0,3.468 1.194,6.868 3.361,9.578 2.555,3.197 3.961,7.204 3.961,11.294 v 19.422 z"
       id="path6" />
    	<path
       fill="#965032"
       d="m 254.448,232.361 h -4.076 c -2.514,0 -4.789,-1.583 -5.665,-3.936 l -1.032,-2.782 2.574,-0.958 1.032,2.782 c 0.478,1.287 1.719,2.148 3.091,2.148 h 4.076 z"
       id="path7" />
    	
    		<rect
       x="257.83701"
       y="183.25999"
       transform="matrix(0.915,0.4035,-0.4035,0.915,103.7082,-87.3814)"
       fill="#965032"
       width="2.747"
       height="38.300999"
       id="rect7" />
    	<polygon
       fill="#965032"
       points="258.692,212.808 269.218,212.808 269.218,199.537 271.963,199.537 271.963,215.553 258.692,215.553 "
       id="polygon7" />
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="M 246.793,228.825 H 235.81 c -3.033,0 -5.492,-2.458 -5.492,-5.492 v 0 c 0,-3.033 2.458,-5.492 5.492,-5.492 h 10.984 c 3.033,0 5.492,2.458 5.492,5.492 v 0 c -0.001,3.034 -2.46,5.492 -5.493,5.492 z"
       id="path8" />
    	<path
       fill="#73af00"
       d="m 272.421,228.825 h -10.984 c -3.033,0 -5.492,-2.458 -5.492,-5.492 v 0 c 0,-3.033 2.458,-5.492 5.492,-5.492 h 10.984 c 3.033,0 5.492,2.458 5.492,5.492 v 0 c 0,3.034 -2.46,5.492 -5.492,5.492 z"
       id="path9" />
    	<path
       fill="#73af00"
       d="M 283.404,217.842 H 268.76 c -3.033,0 -5.492,-2.458 -5.492,-5.492 v 0 c 0,-3.033 2.458,-5.492 5.492,-5.492 h 14.644 c 3.033,0 5.492,2.458 5.492,5.492 v 0 c -0.001,3.033 -2.459,5.492 -5.492,5.492 z"
       id="path10" />
    	<path
       fill="#73af00"
       d="m 287.065,203.198 h -25.628 c -3.033,0 -5.492,-2.458 -5.492,-5.492 v 0 c 0,-3.033 2.458,-5.492 5.492,-5.492 h 25.628 c 3.033,0 5.492,2.458 5.492,5.492 v 0 c 0,3.032 -2.459,5.492 -5.492,5.492 z"
       id="path11" />
    	<path
       fill="#73af00"
       d="m 272.421,188.553 h -7.322 c -3.033,0 -5.492,-2.458 -5.492,-5.492 v 0 c 0,-3.033 2.458,-5.492 5.492,-5.492 h 7.322 c 3.033,0 5.492,2.458 5.492,5.492 v 0 c 0,3.033 -2.46,5.492 -5.492,5.492 z"
       id="path12" />
    	<path
       fill="#73af00"
       d="m 224.827,195.875 h -3.661 c -3.033,0 -5.492,-2.458 -5.492,-5.492 v 0 c 0,-3.033 2.458,-5.492 5.492,-5.492 h 3.661 c 3.033,0 5.492,2.458 5.492,5.492 v 0 c -10e-4,3.034 -2.46,5.492 -5.492,5.492 z"
       id="path13" />
    	<path
       fill="#73af00"
       d="m 250.455,192.214 h -10.984 c -3.033,0 -5.492,-2.458 -5.492,-5.492 v 0 c 0,-3.033 2.458,-5.492 5.492,-5.492 h 10.984 c 3.033,0 5.492,2.458 5.492,5.492 v 0 c -0.002,3.034 -2.46,5.492 -5.492,5.492 z"
       id="path14" />
    	<path
       fill="#73af00"
       d="m 246.793,210.519 h -21.966 c -3.033,0 -5.492,-2.458 -5.492,-5.492 v 0 c 0,-3.033 2.458,-5.492 5.492,-5.492 h 21.966 c 3.033,0 5.492,2.458 5.492,5.492 v 0 c 0,3.034 -2.459,5.492 -5.492,5.492 z"
       id="path15" />
    	<path
       fill="#73af00"
       d="M 310.862,287.055 H 201.029 c -4.044,0 -7.322,3.278 -7.322,7.322 0,4.044 3.278,7.322 7.322,7.322 h 29.289 c 0,4.044 3.278,7.322 7.322,7.322 h 36.611 c 4.044,0 7.322,-3.278 7.322,-7.322 h 29.289 c 4.044,0 7.322,-3.278 7.322,-7.322 0,-4.043 -3.278,-7.322 -7.322,-7.322 z"
       id="path16" />
    </g>
    <path
       fill="#be7855"
       d="m 328.938,133.795 c -0.274,-0.55 -1.701,0.103 -2.593,-0.228 -11.06,-4.111 -25.91,-11.601 -35.616,-16.707 l -1.949,-3.085 -18.398,-8.941 c -1.171,-0.569 -2.582,-0.131 -3.225,1 l -0.907,1.594 c -0.692,1.217 -0.235,2.765 1.006,3.411 l 17.518,9.114 4.95,-0.366 19.241,9.892 c 0,0 13.073,6.687 13.768,7.178 0.695,0.491 1.094,3.242 2.39,3.012 0.93,-0.165 4.999,-3.495 3.815,-5.874 z"
       id="path17" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffbe3c"
       d="m 207.589,292.547 c 0,0 1.22,5.416 0.076,6.026 -1.144,0.61 -7.246,0.61 -7.093,-0.686 0.152,-1.297 0.992,-5.873 0.992,-5.873 z"
       id="path18" />
    	<path
       fill="#ffbe3c"
       d="m 217.733,289.648 c 0,0 -0.992,4.042 0.992,4.195 1.983,0.152 13.195,0.076 13.501,-0.228 0.306,-0.304 0.686,-1.068 0.686,-1.068 l -10.374,-2.899 z"
       id="path19" />
    </g>
    <path
       fill="#eaf3f5"
       d="m 206.35,150.957 c 0,0 -2.727,6.483 -3.719,28.946 -0.264,5.976 0.458,4.576 -2.517,23.797 l 3.53,1.843 c 1.028,0.536 2.262,0.498 3.254,-0.104 l 3.436,-2.082 c 0,0 -1.678,-21.508 3.814,-33.865 0,0 2.899,5.34 2.899,9.305 0,3.966 -0.152,23.034 -0.152,23.034 0,0 6.407,1.068 9.305,0.763 0,0 -1.831,-41.378 -3.661,-51.122 z"
       id="path20" />
    <g
       id="g22"
       transform="translate(0,-88.276)">
    	<path
       fill="#965032"
       d="m 206.864,236.487 c 0,0 -1.087,0.801 -0.515,2.745 0,0 8.352,3.604 16.189,0.515 0,0 0.858,-1.259 -0.228,-2.803 z"
       id="path21" />
    	<path
       fill="#965032"
       d="m 195.691,216.657 c -4.753,1.767 -11.975,6.178 -11.517,9.687 0.458,3.509 2.944,2.653 3.72,1.791 0.776,-0.862 3.002,-3.626 3.698,-4.117 0.696,-0.491 11.937,-6.263 11.937,-6.263 l 29.765,-15.304 c 0,0 0.228,-1.487 -1.545,-2.689 -0.001,0 -18.21,10.259 -36.058,16.895 z"
       id="path22" />
    </g>
    <path
       fill="#ffbe3c"
       d="m 209.724,111.143 -0.172,1.259 c 0,0 -0.458,8.066 2.174,10.24 0,0 0.572,1.658 -0.343,2.46 -0.915,0.802 -9.953,5.377 -9.953,5.377 0,0 -2.346,4.863 -2.289,7.608 0,0 -2.231,-0.858 -2.002,-1.945 0.228,-1.087 1.545,-3.947 1.144,-5.32 -0.401,-1.373 -1.888,-0.972 -1.888,-0.972 0,0 -0.744,0.801 0.458,1.315 l -0.401,1.716 -4.863,2.86 1.087,1.315 c 0,0 0.057,10.068 6.006,11.383 0,0 3.146,0.228 6.865,-6.865 0,0 2.002,3.546 1.315,6.636 0,0 6.521,3.546 15.445,0.458 l 0.115,-6.178 c 0,0 1.373,9.496 6.063,8.58 0,0 12.994,-5.002 10.83,-6.903 -5.034,-4.424 -11.113,-0.685 -11.113,-0.685 -0.295,-6.426 -0.832,-14.738 -1.663,-15.637 -1.373,-1.487 -5.606,-0.686 -6.445,-2.593 -0.839,-1.907 -0.61,-5.262 0.305,-9.153 0.915,-3.89 -3.737,-6.636 -3.737,-6.636 z"
       id="path23" />
    <path
       fill="#464655"
       d="m 209.553,112.401 c 0,0 4.672,1.182 8.333,-0.267 l 1.602,3.966 h 0.915 c 0,0 2.206,-7.34 -0.723,-7.254 0,0 -0.011,-2.383 -5.126,-2.283 -4.393,0.086 -5.916,2.94 -5.001,5.838 z"
       id="path24" />
    <g
       id="g26"
       transform="translate(0,-88.276)">
    	<path
       fill="#965032"
       d="m 304.906,292.547 c 0,0 -1.22,5.416 -0.076,6.026 1.144,0.61 7.246,0.61 7.093,-0.686 -0.153,-1.296 -0.992,-5.873 -0.992,-5.873 z"
       id="path25" />
    	<path
       fill="#965032"
       d="m 294.762,289.648 c 0,0 0.992,4.042 -0.992,4.195 -1.983,0.152 -13.195,0.076 -13.501,-0.228 -0.306,-0.305 -0.686,-1.068 -0.686,-1.068 l 10.374,-2.899 z"
       id="path26" />
    </g>
    <path
       fill="#eaf3f5"
       d="m 306.146,150.957 c 0,0 2.727,6.483 3.719,28.946 0.264,5.976 -0.458,4.576 2.517,23.797 l -3.53,1.843 c -1.028,0.536 -2.262,0.498 -3.254,-0.104 l -3.436,-2.082 c 0,0 1.678,-21.508 -3.814,-33.865 0,0 -2.899,5.34 -2.899,9.305 0,3.966 0.152,23.034 0.152,23.034 0,0 -6.407,1.068 -9.305,0.763 0,0 1.831,-41.378 3.661,-51.122 z"
       id="path27" />
    <path
       fill="#be7855"
       d="m 305.631,148.211 c 0,0 1.087,0.801 0.515,2.745 0,0 -8.352,3.604 -16.189,0.515 0,0 -0.858,-1.259 0.228,-2.803 z"
       id="path28" />
    <path
       fill="#965032"
       d="m 302.771,111.143 0.172,1.259 c 0,0 0.458,8.066 -2.174,10.24 0,0 -0.572,1.658 0.343,2.46 0.915,0.802 9.953,5.377 9.953,5.377 0,0 2.345,4.863 2.289,7.608 0,0 2.231,-0.858 2.002,-1.945 -0.228,-1.087 -1.545,-3.947 -1.144,-5.32 0.401,-1.373 1.888,-0.972 1.888,-0.972 0,0 0.744,0.801 -0.458,1.315 l 0.401,1.716 4.863,2.86 -1.087,1.315 c 0,0 -0.057,10.068 -6.006,11.383 0,0 -3.146,0.228 -6.865,-6.865 0,0 -2.002,3.546 -1.315,6.636 0,0 -6.521,3.546 -15.445,0.458 l -0.115,-6.178 c 0,0 -1.373,9.496 -6.063,8.58 0,0 -12.994,-5.002 -10.83,-6.903 5.034,-4.424 11.113,-0.685 11.113,-0.685 0.295,-6.426 0.832,-14.738 1.663,-15.637 1.373,-1.487 5.605,-0.686 6.445,-2.593 0.84,-1.907 0.61,-5.262 -0.305,-9.153 -0.915,-3.89 3.737,-6.636 3.737,-6.636 z"
       id="path29" />
    <path
       fill="#464655"
       d="m 302.942,112.401 c 0,0 -4.672,1.182 -8.333,-0.267 l -1.602,3.966 h -0.915 c 0,0 -2.206,-7.34 0.723,-7.254 0,0 0.011,-2.383 5.125,-2.283 4.394,0.086 5.918,2.94 5.002,5.838 z"
       id="path30" />
    <path
       fill="#eaf3f5"
       d="m 224.461,115.458 c -0.382,-0.929 0.258,-1.184 0.258,-1.184 0,0 4.63,-2.541 5.169,-2.498 0.89,0.072 1.982,1.636 1.982,2.972 0,1.335 1.739,4.801 5.314,5.663 0,0 -4.462,6.063 -10.655,5.235 0,-0.002 0.415,-4.15 -2.068,-10.188 z"
       id="path31" />
    <path
       fill="#82afff"
       d="m 230.95,143.863 c -1.372,0 -2.484,1.186 -2.484,2.649 v 30.3 c 0,7.322 3.433,32.95 27.458,40.271 24.025,-7.322 27.458,-32.95 27.458,-40.271 v -30.3 c 0,-1.463 -1.112,-2.649 -2.484,-2.649 z"
       id="path32" />
    <path
       fill="#ffe15a"
       d="m 283.383,176.813 v -30.3 c 0,-1.463 -1.112,-2.649 -2.484,-2.649 h -24.974 v 25.628 l 24.135,24.135 c 2.672,-7.054 3.323,-13.647 3.323,-16.814 z"
       id="path33" />
    <path
       fill="#eaf3f5"
       d="m 228.466,176.813 v -30.3 c 0,-1.463 1.112,-2.649 2.484,-2.649 h 24.974 v 25.628 l -24.135,24.135 c -2.672,-7.054 -3.323,-13.647 -3.323,-16.814 z"
       id="path34" />
    <polygon
       fill="#8c5a28"
       points="263.781,287.837 267.532,283.029 263.217,284.755 248.916,284.755 239.732,281.118 246.085,287.837 "
       id="polygon34"
       transform="translate(0,-88.276)" />
    <path
       fill="#f5f5f5"
       d="m 246.575,184.172 -0.97,9.78 -4.414,-1.685 c 0,0 2.031,-4.714 5.384,-8.095 z"
       id="path35" />
    <g
       id="g37"
       transform="translate(0,-88.276)">
    	<rect
       x="255.28"
       y="268.57001"
       fill="#8c5a28"
       width="0.65200001"
       height="16.650999"
       id="rect35" />
    	<rect
       x="261.32001"
       y="269.98001"
       fill="#8c5a28"
       width="0.65200001"
       height="15.245"
       id="rect36" />
    	<rect
       x="249.27"
       y="269.98001"
       fill="#8c5a28"
       width="0.65200001"
       height="15.245"
       id="rect37" />
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 257.814,283.646 h -4.403 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -2.43 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 4.403 c 0.299,0 0.542,0.243 0.542,0.542 v 2.43 c -10e-4,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path37" />
    	<path
       fill="#f5f5f5"
       d="m 257.814,278.961 h -4.403 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -2.43 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 4.403 c 0.299,0 0.542,0.243 0.542,0.542 v 2.43 c -10e-4,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path38" />
    	<path
       fill="#f5f5f5"
       d="m 257.814,274.646 h -4.403 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -2.43 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 4.403 c 0.299,0 0.542,0.243 0.542,0.542 v 2.43 c -10e-4,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path39" />
    	<path
       fill="#f5f5f5"
       d="m 263.479,283.646 h -3.662 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -2.43 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 3.662 c 0.299,0 0.542,0.243 0.542,0.542 v 2.43 c -0.001,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path40" />
    	<path
       fill="#f5f5f5"
       d="m 263.479,279.332 h -3.662 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.879 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 3.662 c 0.299,0 0.542,0.243 0.542,0.542 v 1.879 c -0.001,0.3 -0.243,0.542 -0.542,0.542 z"
       id="path41" />
    	<path
       fill="#f5f5f5"
       d="m 263.479,275.057 h -3.662 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.404 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 3.662 c 0.299,0 0.542,0.243 0.542,0.542 v 1.404 c -0.001,0.3 -0.243,0.542 -0.542,0.542 z"
       id="path42" />
    	<path
       fill="#f5f5f5"
       d="m 251.427,283.646 h -3.662 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -2.43 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 3.662 c 0.299,0 0.542,0.243 0.542,0.542 v 2.43 c 0,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path43" />
    	<path
       fill="#f5f5f5"
       d="m 251.427,279.332 h -3.662 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.879 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 3.662 c 0.299,0 0.542,0.243 0.542,0.542 v 1.879 c 0,0.3 -0.243,0.542 -0.542,0.542 z"
       id="path44" />
    	<path
       fill="#f5f5f5"
       d="m 251.427,275.057 h -3.662 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.404 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 3.662 c 0.299,0 0.542,0.243 0.542,0.542 v 1.404 c 0,0.3 -0.243,0.542 -0.542,0.542 z"
       id="path45" />
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="258.418,270.951 261.318,269.984 261.318,271.954 "
       id="polygon45" />
    	<polygon
       fill="#ff4b55"
       points="246.375,270.951 249.274,269.984 249.274,271.954 "
       id="polygon46" />
    	<polygon
       fill="#ff4b55"
       points="252.408,269.535 255.308,268.568 255.308,270.538 "
       id="polygon47" />
    </g>
    <path
       fill="#4173cd"
       d="m 277.716,198.779 h -43.584 c 0.649,1.235 1.361,2.457 2.159,3.661 h 39.264 c 0.801,-1.203 1.511,-2.426 2.161,-3.661 z"
       id="path47" />
    <path
       fill="#73af00"
       d="m 275.557,202.441 h -39.265 v 0 c 1.734,2.61 3.86,5.089 6.408,7.322 h 26.447 c 2.55,-2.233 4.675,-4.713 6.41,-7.322 z"
       id="path48" />
    <path
       fill="#ffe15a"
       d="m 242.701,209.763 c 3.513,3.079 7.826,5.676 13.224,7.322 5.399,-1.645 9.71,-4.244 13.224,-7.322 z"
       id="path49" />
    <path
       fill="#be7855"
       d="m 251.222,171.642 c 0,0 -0.268,0.094 -0.556,0.061 -0.223,-0.096 -0.679,-0.11 -0.404,-0.956 0.134,-0.419 0.414,-1.011 0.211,-1.163 -0.164,-0.191 -0.342,-0.397 -0.533,-0.617 -0.381,-0.44 -0.809,-0.938 -1.278,-1.48 -0.962,-1.06 -2.102,-2.279 -3.432,-3.48 -0.663,-0.602 -1.348,-1.225 -2.046,-1.857 -0.722,-0.608 -1.388,-1.29 -2.174,-1.856 -0.445,-0.234 -1.01,-0.351 -1.504,-0.534 -0.482,-0.194 -0.785,-0.561 -1.138,-0.872 -0.691,-0.638 -1.37,-1.266 -2.028,-1.874 -1.336,-1.196 -2.509,-2.382 -3.512,-3.402 -0.973,-0.973 -1.76,-1.818 -2.314,-2.435 -0.529,-0.587 -0.495,-1.48 0.073,-2.028 l 1.626,-1.569 c 0.568,-0.548 1.462,-0.55 2.029,-0.001 0.596,0.576 1.414,1.393 2.35,2.4 0.983,1.039 2.127,2.254 3.274,3.631 0.584,0.68 1.186,1.382 1.8,2.094 0.298,0.364 0.653,0.679 0.831,1.167 0.166,0.5 0.263,1.069 0.48,1.522 0.538,0.806 1.195,1.496 1.778,2.24 0.607,0.718 1.204,1.426 1.782,2.11 1.153,1.372 2.33,2.554 3.356,3.553 0.525,0.488 1.006,0.934 1.433,1.33 0.213,0.198 0.413,0.383 0.598,0.555 0.146,0.209 0.747,-0.051 1.17,-0.169 0.855,-0.245 0.853,0.212 0.941,0.438 0.022,0.289 -0.081,0.554 -0.081,0.554 z"
       id="path50" />
    <path
       fill="#965032"
       d="m 233.292,174.525 c -0.282,0 -0.567,-0.086 -0.813,-0.268 -0.609,-0.45 -0.74,-1.309 -0.289,-1.92 l 13.043,-17.694 c 0.449,-0.608 1.303,-0.744 1.92,-0.289 0.609,0.45 0.74,1.309 0.289,1.92 l -13.043,17.694 c -0.27,0.363 -0.686,0.557 -1.107,0.557 z"
       id="path51" />
    <polygon
       fill="#f5f5f5"
       points="253.428,242.207 247.098,237.097 243.742,241.75 250.531,246.25 "
       id="polygon51"
       transform="translate(0,-88.276)" />
    <path
       fill="#965032"
       d="m 261.781,151.734 17.396,21.452 c 0,0 2.445,0.111 2.112,-1.834 l -18.007,-21.119 z"
       id="path52" />
    <path
       fill="#eaf3f5"
       d="m 257.891,154.679 c 0,0 4.891,-0.889 6.947,-3.946 l 2.779,3.279 c 0,0 -4.557,3.223 -5.002,6.724 0,0.001 -3.723,-0.999 -4.724,-6.057 z"
       id="path53" />
    <g
       id="g55"
       transform="translate(0,-88.276)">
    	<path
       fill="#965032"
       d="m 276.676,240.843 c -0.32,0 -0.627,-0.173 -0.787,-0.476 -0.495,-0.938 -0.58,-1.785 -0.254,-2.521 0.457,-1.032 1.532,-1.334 1.652,-1.365 0.484,-0.108 0.96,0.167 1.084,0.639 0.121,0.472 -0.16,0.956 -0.63,1.08 -0.099,0.031 -0.391,0.16 -0.483,0.372 -0.087,0.209 -0.014,0.553 0.205,0.969 0.229,0.434 0.063,0.972 -0.373,1.202 -0.133,0.069 -0.274,0.1 -0.414,0.1 z"
       id="path54" />
    	<path
       fill="#965032"
       d="m 262.384,254.079 c 0,-0.32 -0.173,-0.627 -0.476,-0.787 -0.938,-0.495 -1.785,-0.58 -2.521,-0.254 -1.032,0.457 -1.334,1.532 -1.365,1.652 -0.108,0.484 0.167,0.96 0.639,1.084 0.472,0.121 0.956,-0.16 1.08,-0.63 0.031,-0.099 0.16,-0.391 0.372,-0.483 0.209,-0.087 0.553,-0.014 0.969,0.205 0.434,0.23 0.972,0.063 1.202,-0.373 0.069,-0.133 0.1,-0.274 0.1,-0.414 z"
       id="path55" />
    </g>
    <polygon
       fill="#eaf3f5"
       points="264.745,259.221 280.751,243.067 277.268,238.843 260.892,254.923 "
       id="polygon55"
       transform="translate(0,-88.276)" />
    <path
       fill="#ffbe3c"
       d="m 194.088,127.389 c 1.097,-0.254 2.059,1.22 1.068,2.289 -0.992,1.068 -3.857,2.997 -4.729,2.823 -1.525,-0.307 -2.593,-3.664 3.661,-5.112 z"
       id="path56" />
    <path
       fill="#965032"
       d="m 318.343,128.933 c -1.017,-0.254 -1.909,1.22 -0.99,2.289 0.919,1.068 3.576,2.997 4.385,2.823 1.414,-0.307 2.405,-3.663 -3.395,-5.112 z"
       id="path57" />
    <path
       fill="#464655"
       d="m 280.899,143.863 c 1.372,0 2.484,1.186 2.484,2.649 v 30.3 c 0,7.322 -3.433,32.95 -27.458,40.271 -24.025,-7.322 -27.458,-32.95 -27.458,-40.271 v -30.3 c 0,-1.463 1.112,-2.649 2.484,-2.649 h 49.948 m 0,-1.831 h -49.947 c -2.379,0 -4.314,2.009 -4.314,4.48 v 30.3 c 0,1.749 0.236,10.979 4.893,20.914 4.951,10.561 13.203,17.86 23.863,21.11 l 0.534,0.162 0.534,-0.162 c 10.66,-3.249 18.912,-10.549 23.863,-21.11 4.657,-9.934 4.893,-19.164 4.893,-20.914 v -30.3 c -0.005,-2.469 -1.94,-4.48 -4.319,-4.48 z"
       id="path58" />
    <path
       fill="#eaf3f5"
       d="m 299.879,217.514 c -7.779,-2.607 -16.126,-1.405 -23.998,3.847 -10.061,6.707 -16.73,6.707 -19.936,6.707 -3.206,0 -9.875,0 -19.936,-6.707 -7.87,-5.248 -16.22,-6.453 -23.998,-3.848 v 7.848 c 4.902,-2.343 11.811,-3.324 19.936,2.091 11.906,7.937 20.38,7.937 23.998,7.937 3.618,0 12.092,0 23.998,-7.937 8.125,-5.42 15.034,-4.437 19.936,-2.092 z"
       id="path59" />
    <path
       fill="#965032"
       d="m 255.945,259.188 c -51.477,0 -93.357,-41.881 -93.357,-93.357 0,-51.476 41.881,-93.357 93.357,-93.357 51.476,0 93.357,41.881 93.357,93.357 0,51.476 -41.88,93.357 -93.357,93.357 z m 0,-183.054 c -49.459,0 -89.697,40.236 -89.697,89.697 0,49.461 40.238,89.697 89.697,89.697 49.459,0 89.697,-40.236 89.697,-89.697 0,-49.461 -40.238,-89.697 -89.697,-89.697 z"
       id="path60" />
    <g
       id="g124"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 153.817,261.886 c 0,0 -0.382,-11.441 10.602,-11.441 0,0 0.228,4.5 -3.737,6.483 -3.207,1.603 -6.865,4.958 -6.865,4.958 z"
       id="path61" />
    	<path
       fill="#73af00"
       d="m 175.023,261.886 c 0,0 0.382,-11.441 -10.602,-11.441 0,0 -0.228,4.5 3.737,6.483 3.208,1.603 6.865,4.958 6.865,4.958 z"
       id="path62" />
    	<path
       fill="#73af00"
       d="m 357.999,250.445 c 0,0 0.382,11.441 -10.602,11.441 0,0 -0.228,-4.5 3.737,-6.483 3.207,-1.604 6.865,-4.958 6.865,-4.958 z"
       id="path63" />
    	<path
       fill="#73af00"
       d="m 336.793,250.445 c 0,0 -0.382,11.441 10.602,11.441 0,0 0.228,-4.5 -3.737,-6.483 -3.209,-1.604 -6.865,-4.958 -6.865,-4.958 z"
       id="path64" />
    	<path
       fill="#73af00"
       d="m 261.628,358.256 c 0,0 -11.441,0.382 -11.441,-10.602 0,0 4.5,-0.228 6.483,3.737 1.604,3.207 4.958,6.865 4.958,6.865 z"
       id="path65" />
    	<path
       fill="#73af00"
       d="m 261.628,337.05 c 0,0 -11.441,-0.382 -11.441,10.602 0,0 4.5,0.228 6.483,-3.737 1.604,-3.208 4.958,-6.865 4.958,-6.865 z"
       id="path66" />
    	<path
       fill="#73af00"
       d="m 250.188,154.075 c 0,0 11.441,-0.382 11.441,10.602 0,0 -4.5,0.228 -6.483,-3.737 -1.605,-3.208 -4.958,-6.865 -4.958,-6.865 z"
       id="path67" />
    	<path
       fill="#73af00"
       d="m 250.188,175.281 c 0,0 11.441,0.382 11.441,-10.602 0,0 -4.5,-0.228 -6.483,3.737 -1.605,3.207 -4.958,6.865 -4.958,6.865 z"
       id="path68" />
    	<path
       fill="#73af00"
       d="m 187.763,332.399 c 0,0 -8.36,-7.82 -0.594,-15.586 0,0 3.343,3.02 1.942,7.226 -1.132,3.402 -1.348,8.36 -1.348,8.36 z"
       id="path69" />
    	<path
       fill="#73af00"
       d="m 202.759,317.405 c 0,0 -7.82,-8.36 -15.586,-0.594 0,0 3.02,3.343 7.226,1.942 3.401,-1.134 8.36,-1.348 8.36,-1.348 z"
       id="path70" />
    	<path
       fill="#73af00"
       d="m 324.052,179.932 c 0,0 8.36,7.82 0.594,15.586 0,0 -3.343,-3.02 -1.942,-7.226 1.133,-3.402 1.348,-8.36 1.348,-8.36 z"
       id="path71" />
    	<path
       fill="#73af00"
       d="m 309.056,194.926 c 0,0 7.82,8.36 15.586,0.594 0,0 -3.02,-3.343 -7.226,-1.942 -3.401,1.133 -8.36,1.348 -8.36,1.348 z"
       id="path72" />
    	<path
       fill="#73af00"
       d="m 332.142,324.309 c 0,0 -7.82,8.36 -15.586,0.594 0,0 3.02,-3.343 7.226,-1.942 3.402,1.134 8.36,1.348 8.36,1.348 z"
       id="path73" />
    	<path
       fill="#73af00"
       d="m 317.147,309.314 c 0,0 -8.36,7.82 -0.594,15.586 0,0 3.343,-3.02 1.942,-7.226 -1.134,-3.402 -1.348,-8.36 -1.348,-8.36 z"
       id="path74" />
    	<path
       fill="#73af00"
       d="m 179.674,188.021 c 0,0 7.82,-8.36 15.586,-0.594 0,0 -3.02,3.343 -7.226,1.942 -3.402,-1.134 -8.36,-1.348 -8.36,-1.348 z"
       id="path75" />
    	<path
       fill="#73af00"
       d="m 194.669,203.016 c 0,0 8.36,-7.82 0.594,-15.586 0,0 -3.343,3.02 -1.942,7.226 1.134,3.402 1.348,8.36 1.348,8.36 z"
       id="path76" />
    	<path
       fill="#73af00"
       d="m 163.778,300.519 c 0,0 -4.73,-10.424 5.417,-14.627 0,0 1.933,4.069 -0.972,7.42 -2.35,2.708 -4.445,7.207 -4.445,7.207 z"
       id="path77" />
    	<path
       fill="#73af00"
       d="m 183.37,292.404 c 0,0 -4.025,-10.716 -14.173,-6.513 0,0 1.511,4.245 5.934,4.559 3.575,0.254 8.239,1.954 8.239,1.954 z"
       id="path78" />
    	<path
       fill="#73af00"
       d="m 348.038,211.811 c 0,0 4.73,10.424 -5.417,14.627 0,0 -1.933,-4.07 0.972,-7.42 2.349,-2.708 4.445,-7.207 4.445,-7.207 z"
       id="path79" />
    	<path
       fill="#73af00"
       d="m 328.446,219.927 c 0,0 4.025,10.716 14.173,6.513 0,0 -1.511,-4.245 -5.934,-4.559 -3.576,-0.254 -8.239,-1.954 -8.239,-1.954 z"
       id="path80" />
    	<path
       fill="#73af00"
       d="m 300.261,348.296 c 0,0 -10.424,4.73 -14.627,-5.417 0,0 4.069,-1.933 7.42,0.972 2.709,2.349 7.207,4.445 7.207,4.445 z"
       id="path81" />
    	<path
       fill="#73af00"
       d="m 292.146,328.704 c 0,0 -10.716,4.025 -6.513,14.173 0,0 4.245,-1.511 4.559,-5.934 0.255,-3.577 1.954,-8.239 1.954,-8.239 z"
       id="path82" />
    	<path
       fill="#73af00"
       d="m 211.555,164.034 c 0,0 10.424,-4.73 14.627,5.417 0,0 -4.07,1.933 -7.42,-0.972 -2.709,-2.349 -7.207,-4.445 -7.207,-4.445 z"
       id="path83" />
    	<path
       fill="#73af00"
       d="m 219.67,183.627 c 0,0 10.716,-4.025 6.513,-14.173 0,0 -4.245,1.511 -4.559,5.934 -0.255,3.576 -1.954,8.239 -1.954,8.239 z"
       id="path84" />
    	<path
       fill="#73af00"
       d="m 222.125,352.674 c 0,0 -10.716,-4.025 -6.513,-14.173 0,0 4.245,1.511 4.559,5.934 0.254,3.576 1.954,8.239 1.954,8.239 z"
       id="path85" />
    	<path
       fill="#73af00"
       d="m 230.24,333.082 c 0,0 -10.424,-4.73 -14.627,5.417 0,0 4.07,1.933 7.42,-0.972 2.708,-2.349 7.207,-4.445 7.207,-4.445 z"
       id="path86" />
    	<path
       fill="#73af00"
       d="m 289.691,159.657 c 0,0 10.716,4.025 6.513,14.173 0,0 -4.245,-1.511 -4.559,-5.934 -0.255,-3.577 -1.954,-8.239 -1.954,-8.239 z"
       id="path87" />
    	<path
       fill="#73af00"
       d="m 281.576,179.249 c 0,0 10.424,4.73 14.627,-5.417 0,0 -4.069,-1.933 -7.42,0.972 -2.708,2.349 -7.207,4.445 -7.207,4.445 z"
       id="path88" />
    	<path
       fill="#73af00"
       d="m 352.416,289.949 c 0,0 -4.025,10.716 -14.173,6.513 0,0 1.511,-4.245 5.934,-4.559 3.577,-0.255 8.239,-1.954 8.239,-1.954 z"
       id="path89" />
    	<path
       fill="#73af00"
       d="m 332.825,281.834 c 0,0 -4.73,10.424 5.417,14.627 0,0 1.933,-4.069 -0.972,-7.42 -2.35,-2.709 -4.445,-7.207 -4.445,-7.207 z"
       id="path90" />
    	<path
       fill="#73af00"
       d="m 159.399,222.381 c 0,0 4.025,-10.716 14.173,-6.513 0,0 -1.511,4.245 -5.934,4.559 -3.577,0.256 -8.239,1.954 -8.239,1.954 z"
       id="path91" />
    	<path
       fill="#73af00"
       d="m 178.991,230.497 c 0,0 4.73,-10.424 -5.417,-14.627 0,0 -1.933,4.07 0.972,7.42 2.35,2.708 4.445,7.207 4.445,7.207 z"
       id="path92" />
    	<path
       fill="#73af00"
       d="m 156.895,281.693 c 0,0 -2.606,-11.147 8.167,-13.29 0,0 1.102,4.369 -2.401,7.087 -2.833,2.199 -5.766,6.203 -5.766,6.203 z"
       id="path93" />
    	<path
       fill="#73af00"
       d="m 177.693,277.556 c 0,0 -1.858,-11.296 -12.63,-9.153 0,0 0.653,4.458 4.93,5.63 3.459,0.946 7.7,3.523 7.7,3.523 z"
       id="path94" />
    	<path
       fill="#73af00"
       d="m 354.921,230.637 c 0,0 2.606,11.147 -8.167,13.29 0,0 -1.102,-4.369 2.401,-7.087 2.833,-2.199 5.766,-6.203 5.766,-6.203 z"
       id="path95" />
    	<path
       fill="#73af00"
       d="m 334.122,234.775 c 0,0 1.858,11.296 12.63,9.153 0,0 -0.653,-4.458 -4.93,-5.63 -3.458,-0.947 -7.7,-3.523 -7.7,-3.523 z"
       id="path96" />
    	<path
       fill="#73af00"
       d="m 281.435,355.179 c 0,0 -11.147,2.606 -13.29,-8.167 0,0 4.369,-1.102 7.087,2.401 2.2,2.833 6.203,5.766 6.203,5.766 z"
       id="path97" />
    	<path
       fill="#73af00"
       d="m 277.298,334.38 c 0,0 -11.296,1.858 -9.153,12.63 0,0 4.458,-0.653 5.63,-4.93 0.947,-3.458 3.523,-7.7 3.523,-7.7 z"
       id="path98" />
    	<path
       fill="#73af00"
       d="m 230.381,157.152 c 0,0 11.147,-2.606 13.29,8.167 0,0 -4.369,1.102 -7.087,-2.401 -2.2,-2.833 -6.203,-5.766 -6.203,-5.766 z"
       id="path99" />
    	<path
       fill="#73af00"
       d="m 234.518,177.951 c 0,0 11.296,-1.858 9.153,-12.63 0,0 -4.458,0.653 -5.63,4.93 -0.947,3.458 -3.523,7.7 -3.523,7.7 z"
       id="path100" />
    	<path
       fill="#73af00"
       d="m 203.945,344.228 c 0,0 -9.725,-6.039 -3.623,-15.171 0,0 3.869,2.31 3.314,6.709 -0.447,3.559 0.309,8.462 0.309,8.462 z"
       id="path101" />
    	<path
       fill="#73af00"
       d="m 215.727,326.596 c 0,0 -9.301,-6.674 -15.403,2.458 0,0 3.615,2.69 7.467,0.494 3.115,-1.774 7.936,-2.952 7.936,-2.952 z"
       id="path102" />
    	<path
       fill="#73af00"
       d="m 307.87,168.102 c 0,0 9.725,6.039 3.623,15.171 0,0 -3.869,-2.31 -3.314,-6.709 0.448,-3.557 -0.309,-8.462 -0.309,-8.462 z"
       id="path103" />
    	<path
       fill="#73af00"
       d="m 296.089,185.734 c 0,0 9.301,6.674 15.403,-2.458 0,0 -3.615,-2.69 -7.467,-0.494 -3.115,1.774 -7.936,2.952 -7.936,2.952 z"
       id="path104" />
    	<path
       fill="#73af00"
       d="m 343.972,308.128 c 0,0 -6.039,9.725 -15.171,3.623 0,0 2.309,-3.869 6.709,-3.314 3.557,0.448 8.462,-0.309 8.462,-0.309 z"
       id="path105" />
    	<path
       fill="#73af00"
       d="m 326.339,296.346 c 0,0 -6.674,9.301 2.458,15.403 0,0 2.69,-3.615 0.494,-7.467 -1.775,-3.116 -2.952,-7.936 -2.952,-7.936 z"
       id="path106" />
    	<path
       fill="#73af00"
       d="m 167.844,204.203 c 0,0 6.039,-9.725 15.171,-3.623 0,0 -2.31,3.869 -6.709,3.314 -3.557,-0.448 -8.462,0.309 -8.462,0.309 z"
       id="path107" />
    	<path
       fill="#73af00"
       d="m 185.477,215.985 c 0,0 6.674,-9.301 -2.458,-15.403 0,0 -2.69,3.615 -0.494,7.467 1.774,3.115 2.952,7.936 2.952,7.936 z"
       id="path108" />
    	<path
       fill="#73af00"
       d="m 174.201,317.641 c 0,0 -6.674,-9.301 2.458,-15.403 0,0 2.69,3.615 0.494,7.467 -1.775,3.115 -2.952,7.936 -2.952,7.936 z"
       id="path109" />
    	<path
       fill="#73af00"
       d="m 191.833,305.859 c 0,0 -6.039,-9.725 -15.171,-3.623 0,0 2.31,3.869 6.709,3.314 3.557,-0.448 8.462,0.309 8.462,0.309 z"
       id="path110" />
    	<path
       fill="#73af00"
       d="m 337.615,194.69 c 0,0 6.674,9.301 -2.458,15.403 0,0 -2.69,-3.615 -0.494,-7.467 1.774,-3.115 2.952,-7.936 2.952,-7.936 z"
       id="path111" />
    	<path
       fill="#73af00"
       d="m 319.983,206.472 c 0,0 6.039,9.725 15.171,3.623 0,0 -2.31,-3.869 -6.709,-3.314 -3.557,0.448 -8.462,-0.309 -8.462,-0.309 z"
       id="path112" />
    	<path
       fill="#73af00"
       d="m 317.383,337.872 c 0,0 -9.301,6.674 -15.403,-2.458 0,0 3.615,-2.69 7.467,-0.494 3.115,1.775 7.936,2.952 7.936,2.952 z"
       id="path113" />
    	<path
       fill="#73af00"
       d="m 305.602,320.24 c 0,0 -9.725,6.039 -3.623,15.171 0,0 3.869,-2.31 3.315,-6.709 -0.449,-3.557 0.308,-8.462 0.308,-8.462 z"
       id="path114" />
    	<path
       fill="#73af00"
       d="m 194.433,174.458 c 0,0 9.301,-6.674 15.403,2.458 0,0 -3.615,2.69 -7.467,0.494 -3.115,-1.774 -7.936,-2.952 -7.936,-2.952 z"
       id="path115" />
    	<path
       fill="#73af00"
       d="m 206.214,192.091 c 0,0 9.725,-6.039 3.623,-15.171 0,0 -3.869,2.31 -3.314,6.709 0.448,3.557 -0.309,8.462 -0.309,8.462 z"
       id="path116" />
    	<path
       fill="#73af00"
       d="m 241.602,357.41 c 0,0 -11.296,-1.858 -9.153,-12.63 0,0 4.458,0.653 5.63,4.93 0.946,3.458 3.523,7.7 3.523,7.7 z"
       id="path117" />
    	<path
       fill="#73af00"
       d="m 245.739,336.611 c 0,0 -11.147,-2.606 -13.29,8.167 0,0 4.369,1.102 7.087,-2.401 2.199,-2.833 6.203,-5.766 6.203,-5.766 z"
       id="path118" />
    	<path
       fill="#73af00"
       d="m 270.214,154.92 c 0,0 11.296,1.858 9.153,12.63 0,0 -4.458,-0.653 -5.63,-4.93 -0.946,-3.458 -3.523,-7.7 -3.523,-7.7 z"
       id="path119" />
    	<path
       fill="#73af00"
       d="m 266.077,175.719 c 0,0 11.147,2.606 13.29,-8.167 0,0 -4.369,-1.102 -7.087,2.401 -2.199,2.833 -6.203,5.766 -6.203,5.766 z"
       id="path120" />
    	<path
       fill="#73af00"
       d="m 357.153,270.472 c 0,0 -1.858,11.296 -12.63,9.153 0,0 0.653,-4.458 4.93,-5.63 3.459,-0.947 7.7,-3.523 7.7,-3.523 z"
       id="path121" />
    	<path
       fill="#73af00"
       d="m 336.355,266.335 c 0,0 -2.606,11.147 8.167,13.29 0,0 1.102,-4.369 -2.401,-7.087 -2.835,-2.2 -5.766,-6.203 -5.766,-6.203 z"
       id="path122" />
    	<path
       fill="#73af00"
       d="m 154.662,241.859 c 0,0 1.858,-11.296 12.63,-9.153 0,0 -0.653,4.458 -4.93,5.63 -3.458,0.947 -7.7,3.523 -7.7,3.523 z"
       id="path123" />
    	<path
       fill="#73af00"
       d="m 175.461,245.996 c 0,0 2.606,-11.147 -8.167,-13.29 0,0 -1.102,4.369 2.401,7.087 2.833,2.2 5.766,6.203 5.766,6.203 z"
       id="path124" />
    </g>
    <g
       id="g125"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g126"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g127"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g128"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g129"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g130"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g131"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g132"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g133"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g134"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g135"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g136"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g137"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g138"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g139"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45503" {...props}>
    <defs
       id="defs19" />
    <g
       id="g1"
       transform="translate(0,-88.273)">
    	<path
       fill="#f5f5f5"
       d="M 503.172,423.722 H 8.828 C 3.953,423.722 0,419.769 0,414.894 V 97.101 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    	<rect
       x="114.76"
       y="88.278"
       fill="#f5f5f5"
       width="282.48001"
       height="335.45001"
       id="rect1" />
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    	<path
       fill="#ff4b55"
       d="M 8.828,88.274 C 3.953,88.274 0,92.226 0,97.101 v 317.793 c 0,4.875 3.953,8.828 8.828,8.828 H 114.759 V 88.274 Z"
       id="path2" />
    	<path
       fill="#ff4b55"
       d="M 503.172,88.274 H 397.241 v 335.448 h 105.931 c 4.875,0 8.828,-3.953 8.828,-8.828 V 97.101 c 0,-4.875 -3.953,-8.827 -8.828,-8.827 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 309.569,294.758 52.383,-29.932 -12.02,-6.01 c -3.371,-1.686 -5.301,-5.326 -4.802,-9.063 l 3.911,-29.322 -22.177,6.452 c -4.899,1.426 -9.983,-1.588 -11.085,-6.569 l -2.124,-9.6 -20.823,24.37 c -2.887,3.378 -8.386,0.798 -7.633,-3.582 l 8.893,-51.708 -13.615,3.724 c -3.977,1.088 -8.177,-0.722 -10.116,-4.36 l -14.337,-26.871 v -0.04 l -0.01,0.02 -0.011,-0.02 v 0.04 l -14.337,26.871 c -1.941,3.637 -6.141,5.447 -10.118,4.36 l -13.616,-3.724 8.893,51.708 c 0.753,4.378 -4.747,6.959 -7.634,3.582 l -20.823,-24.37 -2.124,9.6 c -1.102,4.982 -6.186,7.994 -11.085,6.569 l -22.177,-6.452 3.911,29.322 c 0.499,3.736 -1.431,7.377 -4.802,9.063 l -12.02,6.01 52.383,29.933 c 5.426,3.101 7.804,9.677 5.615,15.53 l -4.478,11.977 44.885,-3.832 c 2.484,-0.212 4.598,1.788 4.525,4.279 l -1.414,48.044 h 8.828 L 259,322.711 c -0.073,-2.492 2.041,-4.491 4.525,-4.279 l 44.906,3.834 -4.478,-11.977 c -2.187,-5.854 0.19,-12.431 5.616,-15.531 z"
       id="path4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const CC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs23" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 283.615,307.645 c -28.522,0 -51.645,-23.122 -51.645,-51.645 0,-28.523 23.122,-51.645 51.645,-51.645 3.785,0 7.452,0.454 10.987,1.265 1.409,0.323 2.156,-1.568 0.927,-2.329 -10.816,-6.706 -23.841,-10.184 -37.744,-9.053 -30.263,2.462 -54.593,27.134 -56.653,57.428 -2.462,36.189 26.164,66.308 61.826,66.308 11.955,0 23.109,-3.396 32.574,-9.265 1.229,-0.762 0.486,-2.654 -0.925,-2.329 -3.537,0.811 -7.206,1.265 -10.992,1.265 z"
       id="path2" />
    	<path
       fill="#ffe15a"
       d="m 328.629,212.272 3.879,9.824 10.099,-3.093 c 0.561,-0.172 1.043,0.433 0.75,0.941 l -5.262,9.158 8.715,5.967 c 0.484,0.331 0.312,1.085 -0.268,1.173 l -10.441,1.596 0.768,10.533 c 0.043,0.585 -0.653,0.92 -1.084,0.522 l -7.756,-7.168 -7.756,7.168 c -0.431,0.398 -1.127,0.063 -1.084,-0.522 l 0.768,-10.533 -10.441,-1.596 c -0.58,-0.088 -0.751,-0.842 -0.268,-1.173 l 8.715,-5.967 -5.262,-9.158 c -0.292,-0.509 0.189,-1.112 0.75,-0.941 l 10.099,3.093 3.879,-9.824 c 0.213,-0.546 0.985,-0.546 1.2,0 z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 469.87,185.789 3.879,9.824 10.099,-3.093 c 0.561,-0.172 1.043,0.433 0.75,0.941 l -5.262,9.158 8.715,5.967 c 0.484,0.331 0.312,1.085 -0.268,1.173 l -10.441,1.596 0.768,10.534 c 0.043,0.585 -0.653,0.92 -1.084,0.522 l -7.756,-7.168 -7.756,7.168 c -0.431,0.398 -1.127,0.063 -1.084,-0.522 l 0.768,-10.534 -10.441,-1.596 c -0.58,-0.088 -0.751,-0.842 -0.268,-1.173 l 8.715,-5.967 -5.262,-9.158 c -0.292,-0.509 0.189,-1.112 0.75,-0.941 l 10.099,3.093 3.879,-9.824 c 0.213,-0.545 0.985,-0.545 1.2,0 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 399.25,122.103 3.879,9.824 10.099,-3.093 c 0.561,-0.172 1.043,0.433 0.75,0.941 l -5.262,9.158 8.715,5.967 c 0.484,0.331 0.312,1.085 -0.268,1.173 l -10.441,1.596 0.768,10.533 c 0.043,0.585 -0.653,0.92 -1.084,0.522 l -7.756,-7.168 -7.756,7.168 c -0.431,0.398 -1.127,0.063 -1.084,-0.522 l 0.768,-10.533 -10.441,-1.596 c -0.58,-0.088 -0.751,-0.842 -0.268,-1.173 l 8.715,-5.967 -5.262,-9.158 c -0.292,-0.509 0.19,-1.112 0.75,-0.941 l 10.099,3.093 3.879,-9.824 c 0.212,-0.546 0.985,-0.546 1.2,0 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 399.25,353.513 3.879,9.824 10.099,-3.093 c 0.561,-0.172 1.043,0.433 0.75,0.941 l -5.262,9.158 8.715,5.967 c 0.484,0.331 0.312,1.085 -0.268,1.173 l -10.441,1.596 0.768,10.533 c 0.043,0.585 -0.653,0.92 -1.084,0.522 l -7.756,-7.168 -7.756,7.168 c -0.431,0.398 -1.127,0.063 -1.084,-0.522 l 0.768,-10.533 -10.441,-1.596 c -0.58,-0.088 -0.751,-0.842 -0.268,-1.173 l 8.715,-5.967 -5.262,-9.158 c -0.292,-0.509 0.19,-1.112 0.75,-0.941 l 10.099,3.093 3.879,-9.824 c 0.212,-0.545 0.985,-0.545 1.2,0 z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="m 428.157,221.162 2.708,8.118 8.557,0.066 c 0.663,0.006 0.938,0.851 0.405,1.245 l -6.884,5.084 2.581,8.159 c 0.2,0.632 -0.52,1.155 -1.059,0.769 l -6.963,-4.977 -6.963,4.977 c -0.54,0.385 -1.259,-0.137 -1.059,-0.769 l 2.581,-8.159 -6.884,-5.084 c -0.533,-0.394 -0.258,-1.24 0.405,-1.245 l 8.557,-0.066 2.708,-8.118 c 0.21,-0.629 1.099,-0.629 1.31,0 z"
       id="path7" />
    	<circle
       fill="#ffe15a"
       cx="92.690002"
       cy="180.97"
       r="57.380001"
       id="circle7" />
    </g>
    <path
       fill="#964b50"
       d="m 86.788,137.394 h 15.496 c 0,0 8.804,-39.444 0.704,-53.531 l -4.93,3.169 c 0,0 8.1,27.117 -11.27,50.362 z"
       id="path8" />
    <path
       fill="#73af00"
       d="m 87.375,85.623 c 0,0 -8.921,6.104 -6.104,24.183 0,0 6.808,-5.635 10.565,-18.079 0,0 -5.4,10.33 2.113,18.548 0,0 7.982,-11.27 6.808,-21.131 0,0 26.539,27.714 20.896,20.661 -0.939,-1.174 1.409,-12.914 -7.748,-22.539 0,0 15.027,3.756 20.661,2.348 0,0 0.47,-11.975 -13.853,-14.088 L 124,66.135 c 0,0 -11.034,-0.704 -16.905,4.93 0,0 -1.409,-14.557 4.461,-21.6 0,0 -17.374,-2.583 -18.079,20.192 0,0 -6.339,-14.557 -25.826,-11.034 0,0 11.034,7.982 12.914,11.505 0,0 -15.496,-10.565 -22.774,4.226 0,0 12.444,-3.287 16.905,2.583 0,0 -19.957,-2.113 -21.6,15.027 0.001,-0.001 18.549,-8.689 34.279,-6.341 z"
       id="path9" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#82afff"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="M 503.172,88.277 H 477.867 L 0,335.449 v 17.655 L 508.367,90.156 c -1.474,-1.103 -3.212,-1.879 -5.195,-1.879 z"
       id="path2" />
    	<path
       fill="#ffe15a"
       d="M 8.828,423.725 H 34.133 L 512,176.553 V 158.898 L 3.633,421.846 c 1.474,1.103 3.212,1.879 5.195,1.879 z"
       id="path3" />
    </g>
    <path
       fill="#ff4b55"
       d="M 508.367,1.88 0,264.828 v 61.793 c 0,2.893 1.483,5.339 3.633,6.948 L 512,70.622 V 8.828 C 512,5.935 510.517,3.49 508.367,1.88 Z"
       id="path4" />
    <path
       fill="#ffe15a"
       d="m 92.619,34.703 12.718,38.135 40.199,0.311 c 2.248,0.018 3.18,2.886 1.372,4.222 l -32.339,23.881 12.126,38.328 c 0.678,2.143 -1.762,3.916 -3.591,2.609 L 90.399,118.812 57.694,142.189 c -1.828,1.308 -4.269,-0.466 -3.591,-2.609 L 66.229,101.252 33.89,77.371 c -1.809,-1.335 -0.876,-4.204 1.372,-4.222 L 75.461,72.838 88.179,34.703 c 0.713,-2.132 3.728,-2.132 4.44,0 z"
       id="path5" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CF = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45403" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ffe15a"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 v -75.034 h 512 v 75.034 c 0,4.877 -3.953,8.828 -8.828,8.828 z"
       id="path1" />
    <rect
       y="167.724"
       fill="#73af00"
       width="512"
       height="83.860001"
       id="rect1"
       x="0" />
    <rect
       y="83.863991"
       fill="#f5f5f5"
       width="512"
       height="83.860001"
       id="rect2"
       x="0" />
    <path
       fill="#41479b"
       d="M 512,83.862 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path2" />
    <rect
       x="214.07001"
       y="0.0040004272"
       fill="#ff4b55"
       width="83.860001"
       height="335.45001"
       id="rect3" />
    <path
       fill="#ffe15a"
       d="m 76.5,11.298 7.366,22.087 23.282,0.181 c 1.804,0.014 2.551,2.316 1.1,3.388 l -18.73,13.83 7.022,22.198 c 0.544,1.719 -1.414,3.143 -2.881,2.093 L 74.718,61.537 55.777,75.075 c -1.468,1.049 -3.425,-0.374 -2.881,-2.093 L 59.918,50.784 41.191,36.954 c -1.451,-1.071 -0.703,-3.373 1.1,-3.388 l 23.282,-0.181 7.366,-22.087 c 0.57,-1.711 2.99,-1.711 3.561,0 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const CG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.448" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ffe15a"
       d="M 503.172,0 H 361.931 L 2.703,332.942 c 1.589,1.539 3.737,2.506 6.124,2.506 H 150.068 L 509.297,2.506 C 507.708,0.966 505.559,0 503.172,0 Z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 361.931,0 H 8.828 C 3.953,0 0,3.952 0,8.827 V 326.62 c 0,2.488 1.047,4.717 2.703,6.322 z"
       id="path2" />
    <path
       fill="#ff4b55"
       d="M 509.297,2.506 150.069,335.448 h 353.103 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.827 c 0,-2.489 -1.047,-4.717 -2.703,-6.321 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CH = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="M 353.103,132.415 H 291.31 V 70.622 c 0,-4.875 -3.953,-8.828 -8.828,-8.828 h -52.966 c -4.875,0 -8.828,3.953 -8.828,8.828 v 61.793 h -61.793 c -4.875,0 -8.828,3.953 -8.828,8.828 v 52.966 c 0,4.875 3.953,8.828 8.828,8.828 h 61.793 v 61.793 c 0,4.875 3.953,8.828 8.828,8.828 h 52.966 c 4.875,0 8.828,-3.953 8.828,-8.828 v -61.795 h 61.793 c 4.875,0 8.828,-3.953 8.828,-8.828 v -52.966 c 0,-4.874 -3.953,-8.826 -8.828,-8.826 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#73af00"
       d="M 341.333,0 H 503.172 C 508.047,0 512,3.953 512,8.828 v 317.793 c 0,4.875 -3.953,8.828 -8.828,8.828 H 341.333 Z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff9b55"
       d="M 8.828,0 H 170.667 V 335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const CK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs37" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path6" />
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 377.128,150.113 3.237,9.708 10.233,0.079 c 0.792,0.007 1.121,1.017 0.483,1.489 l -8.232,6.079 3.086,9.757 c 0.239,0.756 -0.621,1.382 -1.267,0.92 l -8.326,-5.951 -8.326,5.951 c -0.646,0.461 -1.505,-0.164 -1.267,-0.92 l 3.086,-9.757 -8.232,-6.079 c -0.638,-0.471 -0.309,-1.483 0.483,-1.489 l 10.233,-0.079 3.237,-9.708 c 0.258,-0.752 1.322,-0.752 1.572,0 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 333.616,162.054 6.906,7.552 9.38,-4.089 c 0.727,-0.317 1.439,0.473 1.047,1.163 l -5.048,8.901 6.788,7.658 c 0.526,0.594 -0.006,1.515 -0.782,1.356 l -10.026,-2.05 -5.185,8.822 c -0.402,0.683 -1.442,0.462 -1.532,-0.326 l -1.149,-10.168 -9.993,-2.205 c -0.775,-0.171 -0.885,-1.229 -0.163,-1.557 l 9.316,-4.235 -0.991,-10.185 c -0.075,-0.79 0.897,-1.223 1.432,-0.637 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 298.722,190.659 9.38,4.089 6.906,-7.552 c 0.535,-0.585 1.507,-0.152 1.43,0.637 l -0.991,10.185 9.316,4.235 c 0.722,0.328 0.61,1.386 -0.163,1.557 l -9.993,2.205 -1.149,10.168 c -0.089,0.788 -1.13,1.009 -1.532,0.326 l -5.185,-8.822 -10.026,2.05 c -0.777,0.159 -1.309,-0.762 -0.782,-1.356 l 6.788,-7.658 -5.048,-8.901 c -0.39,-0.689 0.321,-1.479 1.049,-1.163 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 278.479,230.985 10.233,-0.079 3.238,-9.708 c 0.25,-0.753 1.314,-0.753 1.566,0 l 3.237,9.708 10.233,0.079 c 0.792,0.007 1.121,1.017 0.483,1.489 l -8.232,6.079 3.086,9.757 c 0.239,0.756 -0.621,1.382 -1.267,0.92 l -8.326,-5.951 -8.326,5.951 c -0.646,0.461 -1.505,-0.164 -1.267,-0.92 l 3.086,-9.757 -8.232,-6.079 c -0.633,-0.472 -0.304,-1.484 0.488,-1.489 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 276.389,276.057 9.316,-4.235 -0.991,-10.185 c -0.077,-0.789 0.895,-1.221 1.43,-0.637 l 6.906,7.552 9.38,-4.089 c 0.727,-0.317 1.439,0.473 1.047,1.163 l -5.048,8.902 6.788,7.658 c 0.526,0.594 -0.006,1.515 -0.782,1.356 l -10.026,-2.05 -5.185,8.822 c -0.402,0.683 -1.442,0.462 -1.532,-0.326 l -1.149,-10.168 -9.993,-2.205 c -0.772,-0.172 -0.883,-1.23 -0.161,-1.558 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 292.811,318.083 6.788,-7.658 -5.048,-8.901 c -0.391,-0.69 0.321,-1.48 1.047,-1.163 l 9.38,4.089 6.906,-7.552 c 0.535,-0.585 1.507,-0.152 1.43,0.637 l -0.991,10.185 9.316,4.235 c 0.722,0.328 0.61,1.386 -0.163,1.557 l -9.993,2.205 -1.149,10.168 c -0.089,0.788 -1.13,1.009 -1.532,0.326 l -5.185,-8.822 -10.026,2.05 c -0.774,0.158 -1.306,-0.762 -0.78,-1.356 z"
       id="path12" />
    	<path
       fill="#f5f5f5"
       d="m 324.907,349.796 3.086,-9.757 -8.232,-6.079 c -0.638,-0.471 -0.309,-1.483 0.483,-1.489 l 10.233,-0.079 3.238,-9.708 c 0.25,-0.753 1.314,-0.753 1.566,0 l 3.237,9.708 10.233,0.079 c 0.792,0.007 1.121,1.017 0.483,1.489 l -8.232,6.079 3.086,9.757 c 0.239,0.756 -0.621,1.382 -1.267,0.92 l -8.326,-5.951 -8.326,5.951 c -0.639,0.461 -1.5,-0.164 -1.262,-0.92 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 367.129,365.712 -1.149,-10.168 -9.993,-2.205 c -0.775,-0.171 -0.885,-1.229 -0.163,-1.557 l 9.316,-4.235 -0.991,-10.185 c -0.077,-0.789 0.895,-1.222 1.43,-0.637 l 6.906,7.552 9.38,-4.089 c 0.727,-0.317 1.439,0.473 1.047,1.163 l -5.048,8.901 6.788,7.658 c 0.526,0.594 -0.006,1.515 -0.782,1.356 l -10.026,-2.05 -5.185,8.822 c -0.402,0.683 -1.442,0.462 -1.53,-0.326 z"
       id="path14" />
    	<path
       fill="#f5f5f5"
       d="m 412.172,363.081 -5.185,-8.822 -10.026,2.05 c -0.777,0.159 -1.309,-0.762 -0.782,-1.356 l 6.788,-7.658 -5.048,-8.901 c -0.391,-0.69 0.321,-1.48 1.047,-1.163 l 9.38,4.089 6.906,-7.552 c 0.535,-0.585 1.507,-0.152 1.43,0.637 l -0.991,10.185 9.316,4.235 c 0.722,0.328 0.61,1.386 -0.163,1.557 l -9.993,2.205 -1.149,10.168 c -0.087,0.788 -1.128,1.009 -1.53,0.326 z"
       id="path15" />
    	<path
       fill="#f5f5f5"
       d="m 452.252,342.355 -8.326,-5.951 -8.326,5.951 c -0.646,0.461 -1.505,-0.164 -1.267,-0.92 l 3.086,-9.757 -8.232,-6.079 c -0.638,-0.471 -0.309,-1.483 0.483,-1.489 l 10.233,-0.079 3.238,-9.708 c 0.25,-0.753 1.314,-0.753 1.566,0 l 3.237,9.708 10.233,0.079 c 0.792,0.007 1.121,1.017 0.483,1.489 l -8.232,6.079 3.086,9.757 c 0.243,0.755 -0.618,1.381 -1.262,0.92 z"
       id="path16" />
    	<path
       fill="#f5f5f5"
       d="m 480.436,307.118 -10.026,-2.05 -5.185,8.822 c -0.402,0.683 -1.442,0.462 -1.532,-0.326 l -1.149,-10.168 -9.993,-2.205 c -0.775,-0.171 -0.885,-1.229 -0.163,-1.557 l 9.316,-4.235 -0.991,-10.185 c -0.077,-0.789 0.895,-1.221 1.43,-0.637 l 6.906,7.552 9.38,-4.089 c 0.727,-0.317 1.439,0.473 1.047,1.163 l -5.048,8.901 6.788,7.658 c 0.529,0.594 -0.003,1.515 -0.78,1.356 z"
       id="path17" />
    	<path
       fill="#f5f5f5"
       d="m 491.852,263.466 -9.993,2.205 -1.149,10.168 c -0.089,0.788 -1.13,1.009 -1.532,0.326 l -5.185,-8.822 -10.026,2.05 c -0.777,0.159 -1.309,-0.762 -0.782,-1.356 l 6.788,-7.658 -5.048,-8.902 c -0.391,-0.69 0.321,-1.48 1.047,-1.163 l 9.38,4.089 6.906,-7.552 c 0.535,-0.585 1.507,-0.152 1.43,0.637 l -0.991,10.185 9.316,4.235 c 0.724,0.329 0.613,1.388 -0.161,1.558 z"
       id="path18" />
    	<path
       fill="#f5f5f5"
       d="m 484.525,218.944 -8.232,6.079 3.086,9.757 c 0.239,0.756 -0.621,1.382 -1.267,0.92 l -8.326,-5.951 -8.326,5.951 c -0.646,0.461 -1.505,-0.164 -1.267,-0.92 l 3.086,-9.757 -8.232,-6.079 c -0.638,-0.471 -0.309,-1.483 0.483,-1.489 l 10.233,-0.079 3.238,-9.708 c 0.25,-0.753 1.314,-0.753 1.566,0 l 3.237,9.708 10.233,0.079 c 0.797,0.006 1.126,1.018 0.488,1.489 z"
       id="path19" />
    	<path
       fill="#f5f5f5"
       d="m 459.724,181.25 -5.048,8.902 6.788,7.658 c 0.526,0.594 -0.006,1.515 -0.782,1.356 l -10.026,-2.05 -5.185,8.822 c -0.402,0.683 -1.442,0.462 -1.532,-0.326 l -1.149,-10.168 -9.993,-2.205 c -0.775,-0.171 -0.885,-1.229 -0.163,-1.557 l 9.316,-4.235 -0.991,-10.185 c -0.077,-0.789 0.895,-1.222 1.43,-0.637 l 6.906,7.552 9.38,-4.089 c 0.728,-0.317 1.44,0.473 1.049,1.162 z"
       id="path20" />
    	<path
       fill="#f5f5f5"
       d="m 421.735,156.904 -0.991,10.185 9.316,4.235 c 0.722,0.328 0.61,1.386 -0.163,1.557 l -9.993,2.205 -1.149,10.168 c -0.089,0.788 -1.13,1.009 -1.532,0.326 l -5.185,-8.822 -10.026,2.05 c -0.777,0.159 -1.309,-0.762 -0.782,-1.356 l 6.788,-7.658 -5.048,-8.902 c -0.391,-0.69 0.321,-1.48 1.047,-1.163 l 9.38,4.089 6.906,-7.552 c 0.537,-0.584 1.509,-0.151 1.432,0.638 z"
       id="path21" />
    	<path
       fill="#f5f5f5"
       d="m 377.128,150.113 3.237,9.708 10.233,0.079 c 0.792,0.007 1.121,1.017 0.483,1.489 l -8.232,6.079 3.086,9.757 c 0.239,0.756 -0.621,1.382 -1.267,0.92 l -8.326,-5.951 -8.326,5.951 c -0.646,0.461 -1.505,-0.164 -1.267,-0.92 l 3.086,-9.757 -8.232,-6.079 c -0.638,-0.471 -0.309,-1.483 0.483,-1.489 l 10.233,-0.079 3.237,-9.708 c 0.258,-0.752 1.322,-0.752 1.572,0 z"
       id="path22" />
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#f5f5f5"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 17.655,167.725 v -8.828 H 0 v 8.828 8.828 150.069 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 167.725 Z"
       id="path2" />
    <path
       fill="#41479b"
       d="M 158.897,167.725 H 8.828 C 3.953,167.725 0,163.772 0,158.897 V 8.828 C 0,3.953 3.953,0 8.828,0 h 150.069 c 4.875,0 8.828,3.953 8.828,8.828 v 150.069 c -0.001,4.875 -3.953,8.828 -8.828,8.828 z"
       id="path3" />
    <path
       fill="#f5f5f5"
       d="m 87.262,46.212 8.416,25.234 26.6,0.206 c 3.444,0.026 4.872,4.422 2.101,6.467 l -21.398,15.801 8.023,25.362 c 1.038,3.284 -2.7,5.999 -5.502,3.997 L 83.862,107.812 62.221,123.28 c -2.802,2.003 -6.54,-0.714 -5.502,-3.997 L 64.742,93.921 43.344,78.12 c -2.771,-2.046 -1.343,-6.441 2.101,-6.467 l 26.6,-0.206 8.416,-25.234 c 1.09,-3.268 5.712,-3.268 6.801,-10e-4 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const CM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#73af00"
       d="M 170.667,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#ff4b55"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <g
       id="g3"
       transform="translate(0,-88.273)">
    	<path
       fill="#ffe15a"
       d="M 503.172,423.721 H 341.333 V 88.273 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.792 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    	<path
       fill="#ffe15a"
       d="m 257.833,223.641 7.584,22.741 23.971,0.185 c 1.857,0.014 2.627,2.385 1.133,3.488 l -19.284,14.24 7.231,22.856 c 0.561,1.771 -1.455,3.235 -2.967,2.155 l -19.502,-13.939 -19.502,13.94 c -1.511,1.08 -3.527,-0.385 -2.967,-2.155 l 7.231,-22.856 -19.284,-14.24 c -1.494,-1.103 -0.724,-3.474 1.133,-3.488 l 23.971,-0.185 7.584,-22.741 c 0.589,-1.762 3.08,-1.762 3.668,-0.001 z"
       id="path3" />
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const CN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs21" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 85.007,140.733 8.416,25.234 26.6,0.206 c 3.444,0.026 4.872,4.422 2.101,6.467 l -21.398,15.801 8.023,25.362 c 1.038,3.284 -2.7,5.999 -5.502,3.997 l -21.64,-15.469 -21.64,15.468 c -2.802,2.003 -6.54,-0.714 -5.502,-3.997 L 62.488,188.44 41.09,172.64 c -2.771,-2.046 -1.343,-6.441 2.101,-6.467 l 26.6,-0.206 8.416,-25.234 c 1.09,-3.268 5.711,-3.268 6.8,0 z"
       id="path2" />
    	<path
       fill="#ffe15a"
       d="m 181.599,146.951 6.035,8.23 9.739,-3.046 c 1.261,-0.394 2.298,1.044 1.526,2.115 l -5.962,8.281 5.906,8.321 c 0.765,1.077 -0.282,2.508 -1.54,2.105 l -9.719,-3.111 -6.089,8.189 c -0.788,1.06 -2.473,0.506 -2.478,-0.814 l -0.045,-10.205 -9.67,-3.261 c -1.251,-0.423 -1.246,-2.195 0.009,-2.609 l 9.69,-3.196 0.114,-10.204 c 0.014,-1.319 1.703,-1.86 2.484,-0.795 z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 144.857,122.421 10.145,1.102 4.328,-9.241 c 0.561,-1.196 2.321,-0.991 2.591,0.302 l 2.086,9.988 10.126,1.26 c 1.311,0.163 1.66,1.901 0.513,2.558 l -8.855,5.07 1.931,10.02 c 0.25,1.298 -1.295,2.166 -2.274,1.279 l -7.559,-6.855 -8.932,4.932 c -1.156,0.639 -2.461,-0.563 -1.919,-1.768 l 4.183,-9.308 -7.452,-6.972 c -0.964,-0.898 -0.225,-2.509 1.088,-2.367 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 160.895,221.314 -6.035,8.23 -9.739,-3.046 c -1.261,-0.394 -2.298,1.044 -1.526,2.115 l 5.962,8.281 -5.906,8.321 c -0.765,1.077 0.282,2.508 1.54,2.105 l 9.719,-3.111 6.089,8.189 c 0.788,1.06 2.473,0.506 2.478,-0.814 l 0.045,-10.205 9.67,-3.261 c 1.252,-0.423 1.246,-2.195 -0.009,-2.609 l -9.69,-3.196 -0.114,-10.204 c -0.016,-1.318 -1.703,-1.861 -2.484,-0.795 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 197.635,198.263 -10.145,1.102 -4.328,-9.241 c -0.561,-1.196 -2.321,-0.991 -2.591,0.302 l -2.087,9.988 -10.126,1.26 c -1.311,0.163 -1.66,1.901 -0.513,2.558 l 8.855,5.07 -1.931,10.02 c -0.25,1.298 1.295,2.166 2.274,1.279 l 7.559,-6.855 8.932,4.932 c 1.156,0.639 2.461,-0.563 1.919,-1.768 l -4.183,-9.308 7.452,-6.972 c 0.967,-0.898 0.228,-2.509 -1.087,-2.367 z"
       id="path6" />
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 512,251.587 H 0 v 75.034 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path2" />
    <rect
       y="167.72501"
       fill="#41479b"
       width="512"
       height="83.860001"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs62" />
    <rect
       y="114.754"
       fill="#ff4b55"
       width="512"
       height="105.93"
       id="rect1"
       x="0" />
    <path
       fill="#41479b"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 57.38 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 Z"
       id="path1" />
    <rect
       y="57.384003"
       fill="#f5f5f5"
       width="512"
       height="57.380001"
       id="rect2"
       x="0" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 v -48.552 h 512 v 48.552 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<rect
       y="308.95999"
       fill="#f5f5f5"
       width="512"
       height="57.380001"
       id="rect3"
       x="0" />
    	<ellipse
       fill="#f5f5f5"
       cx="138.39"
       cy="256"
       rx="41.290001"
       ry="44.139999"
       id="ellipse3" />
    </g>
    <rect
       x="117.03"
       y="150.644"
       fill="#3cc8ff"
       width="42.714001"
       height="21.357"
       id="rect4" />
    <polygon
       fill="#ffe15a"
       points="125.138,251.441 124.146,256.072 127.31,252.546 124.934,256.645 129.033,254.27 125.508,257.434 130.139,256.441 125.809,258.36 130.521,258.848 125.809,259.336 130.139,261.255 125.508,260.263 129.033,263.426 124.934,261.05 127.31,265.149 124.146,261.624 125.138,266.255 123.22,261.926 122.732,266.636 122.244,261.926 120.325,266.255 121.317,261.624 118.154,265.149 120.528,261.05 116.43,263.426 119.956,260.263 115.324,261.255 119.654,259.336 114.943,258.848 119.654,258.36 115.324,256.441 119.956,257.434 116.43,254.27 120.528,256.645 118.154,252.546 121.317,256.072 120.325,251.441 122.244,255.77 122.732,251.059 123.22,255.77 "
       id="polygon4"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#41479b"
       points="114.189,277.357 114.189,258.848 164.022,258.848 164.022,277.357 146.936,290.172 129.851,290.172 "
       id="polygon5"
       transform="translate(0,-88.276)" />
    <path
       fill="#73af00"
       d="m 155.479,164.877 h -0.001 c -0.004,-0.39 -0.32,-0.704 -0.711,-0.704 -0.391,0 -0.705,0.314 -0.711,0.704 h -0.002 c 0,2.471 -1.432,5.889 -3.188,8.337 -2.452,-3.096 -3.374,-6.686 -3.722,-8.947 -0.166,-1.078 -1.331,-1.676 -2.307,-1.188 -0.47,0.235 -0.787,0.694 -0.867,1.213 -1.09,6.983 -4.382,9.95 -6.514,11.17 -3.191,-3.085 -4.243,-8.078 -4.589,-11.03 -0.135,-1.148 -1.363,-1.806 -2.397,-1.29 -0.398,0.199 -0.693,0.558 -0.832,0.981 -4.466,13.613 -16.875,14.993 -16.875,14.993 v 4.271 h 49.833 v -1.423 -1.423 -1.423 -1.423 -1.423 c -5.693,-1.429 -7.117,-11.395 -7.117,-11.395 z"
       id="path5" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#f0aa00"
       d="m 162.598,240.339 c -5.695,-2.848 -5.695,-5.695 -5.695,-5.695 0,0 -7.119,-2.848 -12.814,-2.848 0,0 1.423,-2.848 -1.423,-2.848 -2.848,0 -4.271,0 -4.271,0 0,0 -1.423,0 -4.271,0 -2.848,0 -1.423,2.848 -1.423,2.848 -5.695,0 -12.814,2.848 -12.814,2.848 0,0 0,2.848 -5.695,5.695 -5.695,2.848 -5.695,9.255 -5.695,9.255 0,1.18 0.957,2.135 2.135,2.135 1.18,0 2.135,-0.957 2.135,-2.135 0,-0.244 -0.05,-0.473 -0.125,-0.691 l 0.125,-0.021 14.238,-9.966 h 11.391 11.391 l 14.238,9.966 0.125,0.021 c -0.075,0.217 -0.125,0.448 -0.125,0.691 0,1.18 0.957,2.135 2.135,2.135 1.178,0 2.135,-0.957 2.135,-2.135 -0.002,-0.001 -0.002,-6.408 -5.697,-9.255 z"
       id="path6" />
    	<path
       fill="#f0aa00"
       d="m 166.87,257.425 c -1.423,0 -5.695,0 -5.695,-4.271 0,-4.271 5.695,-4.271 5.695,-4.271 l -8.543,-2.848 c -2.848,9.966 2.848,9.966 2.848,22.781 0,11.479 -12.814,18.509 -17.086,18.509 -4.271,0 -5.695,2.848 -5.695,2.848 0,0 -1.423,-2.848 -5.695,-2.848 -4.271,0 -17.086,-7.03 -17.086,-18.509 0,-12.814 5.695,-12.814 2.848,-22.781 l -8.543,2.848 c 0,0 5.695,0 5.695,4.271 0,4.271 -4.271,4.271 -5.695,4.271 -1.424,0 -7.119,0 -7.119,7.119 0,7.119 7.119,15.662 17.086,21.357 9.966,5.695 5.695,11.391 18.509,11.391 12.814,0 8.543,-5.695 18.509,-11.391 9.966,-5.695 17.086,-14.238 17.086,-21.357 0,-7.119 -5.696,-7.119 -7.119,-7.119 z"
       id="path7" />
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 135.546,235.138 -3.444,-1.548 c -0.572,-0.257 -1.206,-0.317 -1.816,-0.175 -2.22,0.513 -7.727,2.2 -11.826,6.923 l 4.271,1.423 z"
       id="path8" />
    	<path
       fill="#73af00"
       d="m 141.241,235.138 3.444,-1.548 c 0.572,-0.257 1.206,-0.317 1.816,-0.175 2.22,0.513 7.727,2.2 11.826,6.923 l -4.271,1.423 z"
       id="path9" />
    	<path
       fill="#73af00"
       d="m 138.897,236.067 2.596,-2.596 c 0.139,-0.139 0.139,-0.364 0,-0.503 -0.139,-0.139 -0.364,-0.139 -0.503,0 l -2.596,2.596 -2.596,-2.596 c -0.139,-0.139 -0.364,-0.139 -0.503,0 -0.139,0.139 -0.139,0.364 0,0.503 l 2.596,2.596 -2.596,2.596 c -0.139,0.139 -0.139,0.364 0,0.503 0.07,0.07 0.161,0.105 0.252,0.105 0.09,0 0.182,-0.035 0.252,-0.105 l 2.596,-2.596 2.596,2.596 c 0.07,0.07 0.161,0.105 0.252,0.105 0.092,0 0.182,-0.035 0.252,-0.105 0.139,-0.139 0.139,-0.364 0,-0.503 z"
       id="path10" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 166.87,160.606 c 0,-2.422 -2.289,-3.469 -4.271,-3.924 v -1.128 c -2.68,-0.252 -4.177,-1.258 -6.775,-3.029 -1.001,-0.683 -2.136,-1.455 -3.507,-2.289 -5.006,-3.041 -8.854,-3.48 -11.075,-3.374 v 2.353 h -5.695 v -2.353 c -2.221,-0.106 -6.069,0.333 -11.075,3.374 -1.37,0.833 -2.506,1.606 -3.507,2.289 -2.599,1.77 -4.094,2.777 -6.775,3.029 v 1.128 c -1.983,0.454 -4.271,1.501 -4.271,3.924 l 4.271,-1.423 v 0.649 c 4.041,-0.298 6.351,-1.848 9.18,-3.775 0.959,-0.653 2.045,-1.394 3.319,-2.167 3.252,-1.976 5.779,-2.588 7.434,-2.732 v 2.33 h 8.543 v -2.33 c 1.655,0.145 4.182,0.756 7.434,2.732 1.276,0.775 2.361,1.514 3.319,2.167 2.828,1.927 5.139,3.478 9.18,3.775 v -0.649 z"
       id="path11" />
    <path
       fill="#3cc8ff"
       d="m 155.479,138.163 v -1.762 h -3.966 c 0.693,-0.595 1.119,-1.295 1.119,-2.135 0,-3.934 -8.95,-4.983 -14.238,-4.983 -5.288,0 -14.238,1.049 -14.238,4.983 0,0.84 0.426,1.54 1.119,2.135 h -3.966 v 1.762 c -3.486,0.778 -6.335,2.648 -6.485,2.749 l 1.579,2.369 c 0.039,-0.026 3.957,-2.609 7.753,-2.609 v -1.423 h 28.476 v 1.423 c 3.797,0 7.714,2.582 7.753,2.609 l 1.579,-2.369 c -0.149,-0.101 -2.999,-1.971 -6.485,-2.749 z m -11.39,-2.156 v -1.081 c 0,-0.697 -0.655,-1.208 -1.331,-1.039 l -4.364,1.091 -4.364,-1.091 c -0.676,-0.169 -1.331,0.342 -1.331,1.039 v 1.081 c -3.199,-0.47 -5.09,-1.252 -5.606,-1.741 0.77,-0.732 4.543,-2.135 11.3,-2.135 6.757,0 10.53,1.405 11.3,2.135 -0.514,0.488 -2.406,1.27 -5.604,1.741 z"
       id="path12" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 138.572,242.3 0.361,1.081 1.14,0.009 c 0.148,0.001 0.209,0.19 0.09,0.277 l -0.917,0.678 0.344,1.087 c 0.044,0.141 -0.116,0.257 -0.236,0.171 l -0.928,-0.663 -0.928,0.663 c -0.12,0.086 -0.28,-0.031 -0.236,-0.171 l 0.344,-1.087 -0.917,-0.678 c -0.119,-0.087 -0.057,-0.276 0.09,-0.277 l 1.14,-0.009 0.361,-1.081 c 0.047,-0.141 0.244,-0.141 0.292,0 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 132.99,242.665 0.472,1.038 1.135,-0.11 c 0.147,-0.014 0.227,0.167 0.119,0.266 l -0.841,0.77 0.456,1.045 c 0.06,0.136 -0.088,0.268 -0.216,0.195 l -0.992,-0.562 -0.853,0.757 c -0.11,0.098 -0.282,-0.001 -0.253,-0.146 l 0.228,-1.118 -0.983,-0.577 c -0.127,-0.075 -0.086,-0.268 0.061,-0.285 l 1.133,-0.128 0.245,-1.113 c 0.03,-0.146 0.228,-0.167 0.289,-0.032 z"
       id="path14" />
    	<path
       fill="#f5f5f5"
       d="m 127.258,244.191 0.686,0.911 1.084,-0.354 c 0.14,-0.046 0.258,0.114 0.173,0.234 l -0.654,0.934 0.672,0.921 c 0.087,0.119 -0.028,0.28 -0.169,0.237 l -1.09,-0.334 -0.669,0.924 c -0.086,0.119 -0.276,0.06 -0.278,-0.087 l -0.02,-1.14 -1.085,-0.351 c -0.14,-0.045 -0.142,-0.244 -0.002,-0.291 l 1.078,-0.371 -0.002,-1.14 c -0.001,-0.147 0.188,-0.211 0.276,-0.093 z"
       id="path15" />
    	<path
       fill="#f5f5f5"
       d="m 121.514,246.613 0.8,0.812 1.027,-0.494 c 0.134,-0.064 0.271,0.078 0.203,0.21 l -0.525,1.012 0.788,0.824 c 0.102,0.107 0.01,0.281 -0.136,0.258 l -1.126,-0.186 -0.541,1.004 c -0.07,0.13 -0.265,0.096 -0.287,-0.05 l -0.17,-1.128 -1.122,-0.204 c -0.146,-0.026 -0.173,-0.223 -0.041,-0.289 l 1.02,-0.51 -0.152,-1.13 c -0.02,-0.147 0.158,-0.234 0.262,-0.129 z"
       id="path16" />
    	<path
       fill="#f5f5f5"
       d="m 143.862,242.665 -0.472,1.038 -1.135,-0.11 c -0.147,-0.014 -0.227,0.167 -0.119,0.266 l 0.841,0.77 -0.456,1.045 c -0.06,0.136 0.088,0.268 0.216,0.195 l 0.992,-0.562 0.853,0.757 c 0.11,0.098 0.282,-0.001 0.253,-0.146 l -0.228,-1.118 0.983,-0.577 c 0.127,-0.075 0.086,-0.268 -0.061,-0.285 l -1.133,-0.128 -0.245,-1.113 c -0.031,-0.146 -0.229,-0.167 -0.289,-0.032 z"
       id="path17" />
    	<path
       fill="#f5f5f5"
       d="m 149.593,244.191 -0.686,0.911 -1.084,-0.354 c -0.14,-0.046 -0.258,0.114 -0.173,0.234 l 0.654,0.934 -0.672,0.921 c -0.087,0.119 0.028,0.28 0.169,0.237 l 1.09,-0.334 0.669,0.924 c 0.086,0.119 0.276,0.06 0.278,-0.087 l 0.02,-1.14 1.085,-0.351 c 0.14,-0.045 0.142,-0.244 0.002,-0.291 l -1.078,-0.371 0.002,-1.14 c 0.001,-0.147 -0.188,-0.211 -0.276,-0.093 z"
       id="path18" />
    	<path
       fill="#f5f5f5"
       d="m 155.338,246.613 -0.8,0.812 -1.027,-0.494 c -0.134,-0.064 -0.271,0.078 -0.203,0.21 l 0.525,1.012 -0.788,0.824 c -0.102,0.107 -0.01,0.281 0.136,0.258 l 1.126,-0.186 0.541,1.004 c 0.07,0.13 0.265,0.096 0.287,-0.05 l 0.17,-1.128 1.122,-0.204 c 0.146,-0.026 0.173,-0.223 0.041,-0.289 l -1.02,-0.51 0.152,-1.13 c 0.019,-0.147 -0.159,-0.234 -0.262,-0.129 z"
       id="path19" />
    </g>
    <polygon
       fill="#8c5a28"
       points="144.578,281.317 148.628,277.847 145.513,279.093 135.19,279.093 128.56,276.468 135.813,281.317 "
       id="polygon19"
       transform="translate(0,-88.276)" />
    <path
       fill="#f5f5f5"
       d="m 133.499,181.934 -0.7,7.06 -3.186,-1.216 c 0,-0.002 1.466,-3.404 3.886,-5.844 z"
       id="path20" />
    <g
       id="g22"
       transform="translate(0,-88.276)">
    	<rect
       x="139.78"
       y="267.41"
       fill="#8c5a28"
       width="0.47099999"
       height="12.02"
       id="rect20" />
    	<rect
       x="144.14"
       y="268.42999"
       fill="#8c5a28"
       width="0.47099999"
       height="11.01"
       id="rect21" />
    	<rect
       x="135.45"
       y="268.42999"
       fill="#8c5a28"
       width="0.47099999"
       height="11.01"
       id="rect22" />
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 141.462,278.292 h -2.877 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.453 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 2.877 c 0.299,0 0.542,0.243 0.542,0.542 v 1.453 c 0,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path22" />
    	<path
       fill="#f5f5f5"
       d="m 141.462,274.91 h -2.877 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.453 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 2.877 c 0.299,0 0.542,0.243 0.542,0.542 v 1.453 c 0,0.3 -0.243,0.542 -0.542,0.542 z"
       id="path23" />
    	<path
       fill="#f5f5f5"
       d="m 141.462,271.796 h -2.877 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.453 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 2.877 c 0.299,0 0.542,0.243 0.542,0.542 v 1.453 c 0,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path24" />
    	<path
       fill="#f5f5f5"
       d="m 145.551,278.292 h -2.343 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.453 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 2.343 c 0.299,0 0.542,0.243 0.542,0.542 v 1.453 c 0,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path25" />
    	<path
       fill="#f5f5f5"
       d="m 145.551,275.179 h -2.343 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.055 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 2.343 c 0.299,0 0.542,0.243 0.542,0.542 v 1.055 c 0,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path26" />
    	<path
       fill="#f5f5f5"
       d="m 145.551,272.093 h -2.343 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -0.712 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 2.343 c 0.299,0 0.542,0.243 0.542,0.542 v 0.712 c 0,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path27" />
    	<path
       fill="#f5f5f5"
       d="m 136.852,278.292 h -2.343 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.453 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 2.343 c 0.299,0 0.542,0.243 0.542,0.542 v 1.453 c -0.001,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path28" />
    	<path
       fill="#f5f5f5"
       d="m 136.852,275.179 h -2.343 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -1.055 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 2.343 c 0.299,0 0.542,0.243 0.542,0.542 v 1.055 c -0.001,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path29" />
    	<path
       fill="#f5f5f5"
       d="m 136.852,272.093 h -2.343 c -0.299,0 -0.542,-0.243 -0.542,-0.542 v -0.712 c 0,-0.299 0.243,-0.542 0.542,-0.542 h 2.343 c 0.299,0 0.542,0.243 0.542,0.542 v 0.712 c -0.001,0.299 -0.243,0.542 -0.542,0.542 z"
       id="path30" />
    	<polygon
       fill="#f5f5f5"
       points="138.008,269.128 135.915,268.43 135.915,269.853 "
       id="polygon30" />
    	<polygon
       fill="#f5f5f5"
       points="146.702,269.128 144.609,268.43 144.609,269.853 "
       id="polygon31" />
    	<polygon
       fill="#f5f5f5"
       points="142.347,268.106 140.253,267.409 140.253,268.831 "
       id="polygon32" />
    </g>
    <polygon
       fill="#8c5a28"
       points="140.258,259.486 141.665,258.28 140.582,258.712 136.996,258.712 134.693,257.801 137.212,259.486 "
       id="polygon33"
       transform="translate(0,-88.276)" />
    <path
       fill="#f5f5f5"
       d="m 136.409,167.35 -0.243,2.453 -1.107,-0.423 c -0.001,0 0.509,-1.182 1.35,-2.03 z"
       id="path33" />
    <g
       id="g35"
       transform="translate(0,-88.276)">
    	<rect
       x="138.59"
       y="254.64999"
       fill="#8c5a28"
       width="0.163"
       height="4.177"
       id="rect33" />
    	<rect
       x="140.10001"
       y="255.00999"
       fill="#8c5a28"
       width="0.163"
       height="3.823"
       id="rect34" />
    	<rect
       x="137.08"
       y="255.00999"
       fill="#8c5a28"
       width="0.163"
       height="3.823"
       id="rect35" />
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 139.174,258.434 h -1 c -0.104,0 -0.189,-0.084 -0.189,-0.189 v -0.504 c 0,-0.104 0.084,-0.189 0.189,-0.189 h 1 c 0.104,0 0.189,0.084 0.189,0.189 v 0.504 c 0,0.105 -0.084,0.189 -0.189,0.189 z"
       id="path35" />
    	<path
       fill="#f5f5f5"
       d="m 139.174,257.26 h -1 c -0.104,0 -0.189,-0.084 -0.189,-0.189 v -0.504 c 0,-0.104 0.084,-0.189 0.189,-0.189 h 1 c 0.104,0 0.189,0.084 0.189,0.189 v 0.504 c 0,0.104 -0.084,0.189 -0.189,0.189 z"
       id="path36" />
    	<path
       fill="#f5f5f5"
       d="m 139.174,256.178 h -1 c -0.104,0 -0.189,-0.084 -0.189,-0.189 v -0.504 c 0,-0.104 0.084,-0.189 0.189,-0.189 h 1 c 0.104,0 0.189,0.084 0.189,0.189 v 0.504 c 0,0.105 -0.084,0.189 -0.189,0.189 z"
       id="path37" />
    	<path
       fill="#f5f5f5"
       d="m 140.596,258.434 h -0.814 c -0.104,0 -0.189,-0.084 -0.189,-0.189 v -0.504 c 0,-0.104 0.084,-0.189 0.189,-0.189 h 0.814 c 0.104,0 0.189,0.084 0.189,0.189 v 0.504 c -0.001,0.105 -0.086,0.189 -0.189,0.189 z"
       id="path38" />
    	<path
       fill="#f5f5f5"
       d="m 140.596,257.353 h -0.814 c -0.104,0 -0.189,-0.084 -0.189,-0.189 v -0.366 c 0,-0.104 0.084,-0.189 0.189,-0.189 h 0.814 c 0.104,0 0.189,0.084 0.189,0.189 v 0.366 c -0.001,0.106 -0.086,0.189 -0.189,0.189 z"
       id="path39" />
    	<path
       fill="#f5f5f5"
       d="m 140.596,256.28 h -0.814 c -0.104,0 -0.189,-0.084 -0.189,-0.189 v -0.247 c 0,-0.104 0.084,-0.189 0.189,-0.189 h 0.814 c 0.104,0 0.189,0.084 0.189,0.189 v 0.247 c -0.001,0.106 -0.086,0.189 -0.189,0.189 z"
       id="path40" />
    	<path
       fill="#f5f5f5"
       d="m 137.573,258.434 h -0.814 c -0.104,0 -0.189,-0.084 -0.189,-0.189 v -0.504 c 0,-0.104 0.084,-0.189 0.189,-0.189 h 0.814 c 0.104,0 0.189,0.084 0.189,0.189 v 0.504 c -0.001,0.105 -0.085,0.189 -0.189,0.189 z"
       id="path41" />
    	<path
       fill="#f5f5f5"
       d="m 137.573,257.353 h -0.814 c -0.104,0 -0.189,-0.084 -0.189,-0.189 v -0.366 c 0,-0.104 0.084,-0.189 0.189,-0.189 h 0.814 c 0.104,0 0.189,0.084 0.189,0.189 v 0.366 c -0.001,0.106 -0.085,0.189 -0.189,0.189 z"
       id="path42" />
    	<path
       fill="#f5f5f5"
       d="m 137.573,256.28 h -0.814 c -0.104,0 -0.189,-0.084 -0.189,-0.189 v -0.247 c 0,-0.104 0.084,-0.189 0.189,-0.189 h 0.814 c 0.104,0 0.189,0.084 0.189,0.189 v 0.247 c -0.001,0.106 -0.085,0.189 -0.189,0.189 z"
       id="path43" />
    	<polygon
       fill="#f5f5f5"
       points="137.975,255.251 137.248,255.008 137.248,255.502 "
       id="polygon43" />
    	<polygon
       fill="#f5f5f5"
       points="140.995,255.251 140.268,255.008 140.268,255.502 "
       id="polygon44" />
    	<polygon
       fill="#f5f5f5"
       points="139.482,254.895 138.755,254.654 138.755,255.147 "
       id="polygon45" />
    	<path
       fill="#f5f5f5"
       d="m 132.91,250.305 h -1.848 c -0.666,0 -1.212,-0.545 -1.212,-1.212 v 0 c 0,-0.666 0.545,-1.212 1.212,-1.212 h 1.848 c 0.666,0 1.212,0.545 1.212,1.212 v 0 c 10e-4,0.667 -0.545,1.212 -1.212,1.212 z"
       id="path45" />
    	<path
       fill="#f5f5f5"
       d="m 146.965,250.305 h -1.219 c -0.669,0 -1.212,-0.543 -1.212,-1.212 v 0 c 0,-0.669 0.543,-1.212 1.212,-1.212 h 1.219 c 0.669,0 1.212,0.543 1.212,1.212 v 0 c -0.001,0.669 -0.544,1.212 -1.212,1.212 z"
       id="path46" />
    	<path
       fill="#f5f5f5"
       d="m 155.621,252.129 h -1.074 c -0.383,0 -0.693,-0.31 -0.693,-0.693 v -0.115 c 0,-0.383 0.31,-0.693 0.693,-0.693 h 1.074 c 0.383,0 0.693,0.31 0.693,0.693 v 0.115 c 0,0.383 -0.31,0.693 -0.693,0.693 z"
       id="path47" />
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g58"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g59"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g60"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g61"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g62"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CU = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs19" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="M 512,155.366 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#41479b"
       d="M 503.172,423.724 H 8.828 C 3.953,423.724 0,419.771 0,414.896 v -58.262 h 512 v 58.262 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="67.093994"
       fill="#f5f5f5"
       width="512"
       height="67.089996"
       id="rect2"
       x="0" />
    <rect
       y="134.18401"
       fill="#41479b"
       width="512"
       height="67.089996"
       id="rect3"
       x="0" />
    <rect
       y="201.27399"
       fill="#f5f5f5"
       width="512"
       height="67.089996"
       id="rect4"
       x="0" />
    <path
       fill="#ff4b55"
       d="M 3.31,333.352 258.712,171.598 c 2.841,-1.8 2.841,-5.945 0,-7.745 L 3.31,2.097 C 1.335,3.716 0,6.075 0,8.828 V 326.62 c 0,2.753 1.336,5.112 3.31,6.732 z"
       id="path4" />
    <path
       fill="#f5f5f5"
       d="m 88.526,125.165 9.064,27.176 28.647,0.222 c 2.219,0.018 3.139,2.849 1.354,4.168 l -23.045,17.018 8.641,27.313 c 0.67,2.116 -1.74,3.866 -3.545,2.575 L 86.336,186.979 63.03,203.638 c -1.805,1.291 -4.215,-0.46 -3.545,-2.575 L 68.126,173.751 45.08,156.733 c -1.785,-1.319 -0.865,-4.151 1.354,-4.168 l 28.647,-0.222 9.064,-27.176 c 0.701,-2.107 3.679,-2.107 4.381,-0.002 z"
       id="path5" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CV = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs27" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<rect
       y="282.48001"
       fill="#f5f5f5"
       width="512"
       height="23.540001"
       id="rect1"
       x="0" />
    	<rect
       y="329.57001"
       fill="#f5f5f5"
       width="512"
       height="23.540001"
       id="rect2"
       x="0" />
    </g>
    <rect
       y="217.74399"
       fill="#ff4b55"
       width="512"
       height="23.540001"
       id="rect3"
       x="0" />
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 169.649,234.664 2.708,8.118 8.557,0.066 c 0.663,0.006 0.938,0.851 0.405,1.245 l -6.884,5.084 2.581,8.159 c 0.2,0.632 -0.52,1.155 -1.059,0.769 l -6.963,-4.977 -6.963,4.977 c -0.54,0.385 -1.259,-0.137 -1.059,-0.769 l 2.581,-8.159 -6.884,-5.084 c -0.533,-0.394 -0.258,-1.24 0.405,-1.245 l 8.557,-0.066 2.708,-8.118 c 0.21,-0.629 1.101,-0.629 1.31,0 z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 169.649,377.322 2.708,8.118 8.557,0.066 c 0.663,0.006 0.938,0.851 0.405,1.245 l -6.884,5.084 2.581,8.159 c 0.2,0.632 -0.52,1.155 -1.059,0.769 l -6.963,-4.977 -6.963,4.977 c -0.54,0.385 -1.259,-0.137 -1.059,-0.769 l 2.581,-8.159 -6.884,-5.084 c -0.533,-0.394 -0.258,-1.24 0.405,-1.245 l 8.557,-0.066 2.708,-8.118 c 0.21,-0.629 1.101,-0.629 1.31,0 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 123.342,385.293 6.881,-5.088 7.041,4.864 c 0.545,0.376 1.257,-0.158 1.047,-0.787 l -2.712,-8.117 6.802,-5.194 c 0.527,-0.403 0.238,-1.244 -0.425,-1.238 l -8.557,0.071 -2.838,-8.074 c -0.22,-0.626 -1.109,-0.611 -1.309,0.021 l -2.577,8.161 -8.555,0.204 c -0.663,0.015 -0.924,0.866 -0.384,1.251 l 6.965,4.972 -2.45,8.2 c -0.19,0.637 0.537,1.149 1.071,0.754 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 137.104,269.322 -6.987,-4.941 -6.937,5.012 c -0.537,0.388 -1.26,-0.131 -1.063,-0.765 l 2.54,-8.172 -6.91,-5.049 c -0.535,-0.391 -0.265,-1.238 0.398,-1.247 l 8.557,-0.109 2.667,-8.131 c 0.206,-0.63 1.096,-0.634 1.309,-0.007 l 2.749,8.105 8.558,0.023 c 0.663,0.002 0.942,0.846 0.41,1.242 l -6.859,5.118 2.623,8.147 c 0.204,0.629 -0.513,1.156 -1.055,0.774 z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="m 201.552,269.427 6.881,-5.088 7.041,4.864 c 0.545,0.376 1.257,-0.158 1.047,-0.787 l -2.712,-8.117 6.802,-5.194 c 0.527,-0.403 0.238,-1.244 -0.425,-1.238 l -8.557,0.071 -2.838,-8.074 c -0.22,-0.626 -1.109,-0.611 -1.309,0.021 l -2.577,8.161 -8.555,0.204 c -0.663,0.015 -0.924,0.866 -0.384,1.251 l 6.965,4.972 -2.45,8.2 c -0.19,0.636 0.538,1.149 1.071,0.754 z"
       id="path7" />
    	<path
       fill="#ffe15a"
       d="m 215.315,385.188 -6.987,-4.941 -6.937,5.012 c -0.537,0.388 -1.26,-0.131 -1.063,-0.765 l 2.54,-8.172 -6.91,-5.049 c -0.535,-0.391 -0.265,-1.238 0.398,-1.247 l 8.557,-0.109 2.667,-8.131 c 0.206,-0.63 1.096,-0.634 1.309,-0.007 l 2.749,8.105 8.558,0.023 c 0.663,0.002 0.942,0.846 0.41,1.242 l -6.859,5.118 2.623,8.147 c 0.203,0.632 -0.514,1.158 -1.055,0.774 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 113.107,335.327 -8.557,0.056 -2.824,-8.078 c -0.218,-0.626 -1.108,-0.613 -1.309,0.019 l -2.591,8.157 -8.556,0.19 c -0.663,0.014 -0.926,0.865 -0.386,1.251 l 6.957,4.984 -2.464,8.195 c -0.191,0.634 0.536,1.148 1.07,0.754 l 6.89,-5.076 7.033,4.876 c 0.545,0.377 1.257,-0.156 1.048,-0.785 l -2.699,-8.121 6.81,-5.182 c 0.528,-0.403 0.241,-1.245 -0.422,-1.24 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="m 89.271,291.342 8.556,-0.161 2.617,-8.148 c 0.203,-0.631 1.092,-0.641 1.309,-0.014 l 2.798,8.087 8.558,-0.029 c 0.663,-0.002 0.948,0.841 0.418,1.24 l -6.827,5.16 2.673,8.13 c 0.207,0.63 -0.506,1.161 -1.05,0.781 l -7.017,-4.898 -6.906,5.054 c -0.535,0.392 -1.26,-0.124 -1.068,-0.758 l 2.49,-8.188 -6.941,-5.006 c -0.538,-0.388 -0.272,-1.238 0.39,-1.25 z"
       id="path10" />
    	<path
       fill="#ffe15a"
       d="m 248.699,291.027 -8.557,0.056 -2.824,-8.078 c -0.218,-0.626 -1.108,-0.614 -1.309,0.019 l -2.591,8.157 -8.556,0.19 c -0.663,0.014 -0.926,0.865 -0.386,1.251 l 6.957,4.984 -2.464,8.195 c -0.191,0.634 0.536,1.148 1.07,0.755 l 6.89,-5.076 7.033,4.876 c 0.545,0.377 1.257,-0.156 1.048,-0.785 l -2.698,-8.121 6.81,-5.182 c 0.527,-0.403 0.24,-1.246 -0.423,-1.241 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 224.864,335.642 8.556,-0.161 2.617,-8.148 c 0.203,-0.631 1.092,-0.641 1.309,-0.014 l 2.798,8.087 8.558,-0.029 c 0.663,-0.002 0.948,0.841 0.418,1.24 l -6.827,5.16 2.673,8.13 c 0.207,0.63 -0.506,1.161 -1.05,0.781 l -7.017,-4.898 -6.906,5.054 c -0.535,0.392 -1.26,-0.124 -1.068,-0.758 l 2.49,-8.188 -6.941,-5.006 c -0.538,-0.388 -0.273,-1.236 0.39,-1.25 z"
       id="path12" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <rect
       y="229.51498"
       fill="#ffe15a"
       width="512"
       height="44.139999"
       id="rect1"
       x="0" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 118.945,170.868 -8.683,26.034 -27.443,0.213 c -2.632,0.02 -3.723,3.379 -1.606,4.942 l 22.077,16.302 -8.278,26.165 c -0.793,2.509 2.063,4.585 4.204,3.054 l 22.327,-15.958 22.327,15.958 c 2.141,1.53 4.998,-0.545 4.204,-3.054 l -8.278,-26.165 22.077,-16.302 c 2.118,-1.564 1.026,-4.921 -1.606,-4.942 l -27.443,-0.213 -8.683,-26.034 c -0.832,-2.497 -4.363,-2.497 -5.196,0 z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 56.393,122.826 -5.025,15.069 -15.884,0.124 c -1.523,0.012 -2.155,1.955 -0.929,2.86 l 12.778,9.436 -4.791,15.145 c -0.459,1.452 1.194,2.654 2.433,1.768 l 12.922,-9.237 12.922,9.237 c 1.239,0.886 2.893,-0.316 2.433,-1.768 l -4.791,-15.145 12.778,-9.436 c 1.225,-0.905 0.594,-2.849 -0.929,-2.86 l -15.884,-0.124 -5.025,-15.069 c -0.482,-1.445 -2.526,-1.445 -3.008,0 z"
       id="path3" />
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CX = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs23" />
    <path
       fill="#41479b"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 Z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 508.743,333.315 3.256,2.134 C 4.786,0.86 6.681,0 8.827,0 H 503.172 C 508.047,0 512,3.953 512,8.828 V 326.62 c 0,2.729 -1.311,5.076 -3.257,6.695 z"
       id="path2" />
    <circle
       fill="#ffe15a"
       cx="256"
       cy="167.724"
       r="52.965"
       id="circle2" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 38.615,256.597 3.064,7.761 7.978,-2.443 c 0.444,-0.136 0.823,0.341 0.593,0.744 l -4.158,7.234 6.884,4.714 c 0.383,0.262 0.247,0.856 -0.212,0.927 l -8.248,1.26 0.607,8.321 c 0.034,0.462 -0.516,0.727 -0.856,0.413 l -6.127,-5.663 -6.127,5.663 c -0.34,0.314 -0.89,0.05 -0.856,-0.413 l 0.607,-8.321 -8.248,-1.26 c -0.458,-0.07 -0.594,-0.665 -0.212,-0.927 l 6.884,-4.714 -4.158,-7.234 c -0.231,-0.402 0.149,-0.879 0.593,-0.744 l 7.978,2.443 3.064,-7.761 c 0.169,-0.43 0.779,-0.43 0.95,0 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 150.192,235.677 3.064,7.761 7.978,-2.443 c 0.444,-0.136 0.823,0.341 0.593,0.744 l -4.158,7.234 6.884,4.714 c 0.383,0.262 0.247,0.856 -0.212,0.927 l -8.248,1.26 0.607,8.321 c 0.034,0.462 -0.516,0.727 -0.856,0.413 l -6.127,-5.663 -6.127,5.663 c -0.341,0.314 -0.89,0.05 -0.856,-0.413 l 0.607,-8.321 -8.248,-1.26 c -0.458,-0.07 -0.594,-0.665 -0.212,-0.927 l 6.884,-4.714 -4.158,-7.234 c -0.231,-0.402 0.149,-0.879 0.593,-0.744 l 7.978,2.443 3.064,-7.761 c 0.17,-0.432 0.78,-0.432 0.95,0 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 94.403,185.366 3.064,7.761 7.978,-2.443 c 0.444,-0.136 0.823,0.341 0.593,0.744 l -4.158,7.234 6.884,4.714 c 0.383,0.262 0.247,0.856 -0.212,0.927 l -8.248,1.26 0.607,8.321 c 0.034,0.462 -0.516,0.727 -0.856,0.413 l -6.127,-5.663 -6.127,5.663 c -0.34,0.314 -0.89,0.05 -0.856,-0.413 l 0.607,-8.321 -8.248,-1.26 c -0.458,-0.07 -0.594,-0.665 -0.212,-0.927 l 6.884,-4.714 -4.158,-7.234 c -0.231,-0.402 0.149,-0.879 0.593,-0.744 l 7.978,2.443 3.064,-7.761 c 0.17,-0.431 0.78,-0.431 0.95,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 94.403,368.175 3.064,7.761 7.978,-2.443 c 0.444,-0.136 0.823,0.341 0.593,0.744 l -4.158,7.234 6.884,4.714 c 0.383,0.262 0.247,0.856 -0.212,0.927 l -8.248,1.26 0.607,8.321 c 0.034,0.462 -0.516,0.727 -0.856,0.413 l -6.127,-5.663 -6.127,5.663 c -0.34,0.314 -0.89,0.05 -0.856,-0.413 l 0.607,-8.321 -8.248,-1.26 c -0.458,-0.07 -0.594,-0.665 -0.212,-0.927 l 6.884,-4.714 -4.158,-7.234 c -0.231,-0.402 0.149,-0.879 0.593,-0.744 l 7.978,2.443 3.064,-7.761 c 0.17,-0.431 0.78,-0.431 0.95,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 117.239,263.62 2.138,6.413 6.761,0.052 c 0.524,0.004 0.74,0.672 0.32,0.983 l -5.439,4.017 2.039,6.445 c 0.158,0.5 -0.41,0.913 -0.836,0.608 l -5.5,-3.932 -5.5,3.932 c -0.426,0.305 -0.994,-0.108 -0.836,-0.608 l 2.039,-6.445 -5.439,-4.017 c -0.422,-0.311 -0.204,-0.98 0.32,-0.983 l 6.761,-0.052 2.138,-6.413 c 0.166,-0.496 0.868,-0.496 1.034,0 z"
       id="path7" />
    </g>
    <path
       fill="#73af00"
       d="m 224.574,144.94 c -2.166,-0.505 -4.343,5.067 -1.93,6.997 2.413,1.93 6.756,5.549 4.102,7.721 -2.654,2.172 -3.619,2.413 -4.102,5.067 -0.482,2.654 0,3.137 -2.172,4.343 -2.172,1.206 -7.239,3.619 -5.067,6.033 2.172,2.414 5.067,0.966 6.997,-2.895 0,0 13.512,-0.482 13.995,0.482 0.482,0.966 1.689,4.585 4.585,3.619 2.895,-0.966 2.895,-0.966 2.895,-0.966 0,0 1.689,-0.724 2.895,0.724 1.206,1.448 4.102,1.93 7.48,1.93 3.378,0 6.273,1.93 6.033,6.515 -0.154,2.937 -0.904,9.043 -1.421,13.052 -0.277,2.146 1.195,4.122 3.33,4.478 l 6.178,1.03 c 1.625,0.27 3.136,-0.889 3.281,-2.53 0.29,-3.3 0.711,-8.137 0.697,-8.308 -0.139,-1.735 3.378,-10.616 3.137,-14.719 -0.242,-4.102 -0.242,-4.102 -0.242,-4.102 0,0 3.619,-0.482 5.067,-2.895 1.448,-2.413 4.585,-8.445 10.858,-10.616 l 1.689,-4.102 c 0,0 -4.825,-2.172 -3.861,-3.619 0.966,-1.448 1.448,-5.309 0.724,-8.445 -0.724,-3.136 -0.966,-7.48 -0.966,-7.48 0,0 -1.72,-0.727 -2.083,0.273 -0.363,1 -0.727,1.544 -1.635,1.363 -0.908,-0.182 -2.271,-0.273 -2.634,-1.09 -0.363,-0.818 -1.363,-1.635 -2.271,-1.181 -0.908,0.455 -2.453,6.54 -4.632,7.176 0,0 -0.182,-2.634 -1.544,-2.089 -1.362,0.545 -1.272,1.816 -1.453,4.087 -0.181,2.271 -15.443,17.622 -28.796,13.535 0,0 -1.453,-2.906 -4.451,-2.634 -2.998,0.273 -5.905,0.182 -7.63,-1.908 -1.727,-2.09 -4.476,-8.243 -7.053,-8.846 z"
       id="path8" />
    <path
       fill="#ffe15a"
       d="m 322.836,170.181 c 4.024,4.276 48.239,16.317 92.932,-7.094 44.693,-23.411 71.295,-30.149 71.295,-30.149 0,0 0.354,-6.03 5.853,-6.916 5.497,-0.887 2.838,-3.192 1.419,-4.965 -1.419,-1.773 -8.335,-6.562 -17.736,-2.483 0,0 -10.936,0.414 -12.591,-14.72 -1.655,-15.134 -2.365,-30.505 -6.148,-37.125 -3.784,-6.621 -34.997,-39.726 -38.781,-37.125 -3.784,2.601 9.459,35.47 21.756,47.058 0,0 2.838,20.337 -0.71,21.282 -3.548,0.946 -23.173,-17.026 -58.171,-21.282 0,0 14.898,20.337 33.106,28.85 18.208,8.513 23.173,16.317 22.701,19.627 -0.473,3.31 -6.621,19.154 -16.789,26.485 -10.168,7.33 -35.706,27.193 -93.642,16.789 -10e-4,-0.005 -6.385,-0.241 -4.494,1.768 z"
       id="path9" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const CY = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
         id="defs39" /><path
         fill="#ffffff"
         d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
         id="path2" /><g
         id="g6"
         transform="translate(0,-88.276)" /><g
         id="g8"
         transform="translate(0,-88.276)" /><g
         id="g10"
         transform="translate(0,-88.276)" /><g
         id="g12"
         transform="translate(0,-88.276)" /><g
         id="g14"
         transform="translate(0,-88.276)" /><g
         id="g16"
         transform="translate(0,-88.276)" /><g
         id="g18"
         transform="translate(0,-88.276)" /><g
         id="g20"
         transform="translate(0,-88.276)" /><g
         id="g22"
         transform="translate(0,-88.276)" /><g
         id="g24"
         transform="translate(0,-88.276)" /><g
         id="g26"
         transform="translate(0,-88.276)" /><g
         id="g28"
         transform="translate(0,-88.276)" /><g
         id="g30"
         transform="translate(0,-88.276)" /><g
         id="g32"
         transform="translate(0,-88.276)" /><g
         id="g34"
         transform="translate(0,-88.276)" /><path
         d="m 245.8999,278.61916 c -0.0991,-0.0474 -0.12004,-0.0672 -0.19106,-0.1349 l -0.0688,-0.0644 c -0.1784,-0.16353 -0.47407,-0.4526 -0.87106,-0.90465 -0.73341,-0.83307 -1.71734,-2.05266 -2.58234,-3.1302 -1.71514,-2.13801 -3.13241,-3.97978 -3.39945,-4.32667 l -0.43663,-0.56822 -4.27656,-1.31871 -3.12249,-1.4558 1.66833,-1.87537 5.73072,2.45351 4.27656,0.87766 7.90836,5.81661 -0.006,0.005 c -0.016,0.0132 -1.15022,0.95695 -2.27731,1.98163 -0.50271,0.45701 -1.13645,1.04395 -1.5841,1.53234 -0.20647,0.22465 -0.38817,0.44764 -0.51206,0.62769 -0.076,0.11067 -0.11838,0.21088 -0.13875,0.25934 l 0.49114,-0.30559 0.53243,0.41406 -1.08359,0.10131 -0.0496,0.011 z m -29.36936,-8.82072 c -3.73146,-5.5e-4 -7.41723,-1.03184 -10.95432,-3.06523 l -0.004,-0.002 0.002,-0.004 c 0,0 0.46251,-0.88152 1.58465,-1.70468 1.06873,-0.78461 2.9964,-1.72229 6.11173,-1.73441 h 0.0644 c 3.68961,0 8.20459,1.25428 13.41993,3.72816 -0.17619,0.11673 -4.2705,2.78277 -10.22256,2.78277 l 0.005,0.006 z m -16.17132,-3.58445 c -0.68991,0 -1.30989,-0.26099 -1.74542,-0.73396 -0.35735,-0.38873 -0.61338,-0.9063 -0.78297,-1.58465 -0.2775,-1.11112 -0.20097,-2.21619 -0.19326,-2.32191 0.28962,-0.12168 0.58474,-0.1883 0.86005,-0.19491 l 0.0617,-10e-4 c 1.38257,0 2.47222,1.19922 2.93913,2.38798 0.26485,0.67559 0.31605,1.24382 0.15087,1.68871 -0.16518,0.44599 -0.68275,0.75433 -1.28842,0.75433 z m 28.45535,-3.29814 c -9.55798,-1.36495 -13.60934,-4.82056 -15.32503,-7.47889 -1.82967,-2.83507 -1.45416,-5.45761 -1.4503,-5.48404 l 0.002,-0.008 0.007,-0.002 c 0.003,0 0.58419,-0.15692 1.46351,-0.16133 2.5427,0 9.04647,1.27906 15.30576,13.12757 l 0.004,0.008 -0.011,-0.005 z m -19.59058,-1.89408 c -4.0833,-5.5e-4 -7.19203,-0.70478 -9.24029,-2.09451 -1.17719,-0.79838 -1.75313,-1.6755 -2.02953,-2.27125 -0.25879,-0.55832 -0.3177,-1.02193 -0.32706,-1.11388 0.10792,-0.0496 1.77956,-0.79177 4.27546,-0.9085 0.21088,-0.01 0.42342,-0.016 0.64641,-0.0165 3.15608,0 7.95517,1.02963 13.01965,5.93554 l 0.005,0.005 -0.006,5.6e-4 c -2.31255,0.30283 -4.44891,0.46251 -6.3485,0.46251 z m -19.77229,-0.75984 c -4.30574,0 -10.22091,-1.31485 -13.90998,-5.00336 l -0.004,-0.004 0.011,-0.003 c 0.0385,-0.01 4.04256,-1.02578 8.54707,-1.13535 0.2687,-0.007 0.53904,-0.0105 0.81214,-0.0105 4.03705,0 7.12706,0.78296 9.18522,2.32631 0.71855,0.53904 1.11113,1.04065 1.19923,1.53234 0.0738,0.41075 -0.14316,0.85344 -0.58144,1.1838 -0.92668,0.69982 -2.58345,1.07313 -4.92518,1.11058 l -0.33037,0.011 z m -13.95237,-7.15789 c -0.53024,0 -1.02799,-0.23456 -1.36496,-0.64256 -0.2786,-0.33807 -0.47242,-0.77965 -0.61007,-1.38863 -0.23015,-1.01752 -0.16078,-2.01301 -0.16023,-2.02292 l 5.6e-4,-0.01 c 0.20042,-0.0947 0.42451,-0.14536 0.67008,-0.15141 h 0.002 c 0.63705,0 1.12268,0.34688 1.42552,0.6376 0.40359,0.38818 0.73396,0.90575 0.92942,1.45635 0.20097,0.56713 0.23346,1.04175 0.0991,1.45085 -0.11012,0.32486 -0.48453,0.66624 -0.99109,0.66624 z m 32.22701,-0.7268 c -0.68991,0 -1.3099,-0.26099 -1.74543,-0.73396 -0.35734,-0.38873 -0.61337,-0.9063 -0.78296,-1.58464 -0.27751,-1.11113 -0.20097,-2.21619 -0.19326,-2.32191 0.28962,-0.12169 0.58474,-0.18831 0.86004,-0.19492 l 0.0617,-0.001 c 1.38258,0 2.47223,1.19922 2.93914,2.38798 0.26484,0.6756 0.31605,1.24382 0.15087,1.68871 -0.16518,0.4515 -0.68826,0.75434 -1.28842,0.75434 z m -15.6978,-0.64971 c -8.6649,-0.30504 -13.1617,-2.7679 -15.40818,-4.78092 -1.26474,-1.13315 -1.96787,-2.25639 -2.33457,-2.99916 -0.34578,-0.70147 -0.47682,-1.23831 -0.49995,-1.34238 l 0.0116,-0.005 c 0.002,0 0.81986,-0.29292 2.13911,-0.3188 l 0.20262,-0.002 c 2.92207,0 8.87083,1.2273 15.88611,9.44455 v 0.006 z m 9.40987,-0.87547 c -6.97123,-1.06157 -10.92073,-4.05412 -13.00643,-6.37878 -2.18646,-2.43643 -2.84113,-4.70548 -2.87032,-4.8112 0.0127,-0.004 0.86446,-0.22575 2.14737,-0.25823 0.093,-0.003 0.18996,-0.004 0.28852,-0.004 0.0997,0 0.20097,0.001 0.30448,0.004 3.50627,0.0765 9.87458,1.66448 13.13473,11.44436 h 0.006 z m -35.78944,-3.34769 c -2.28446,0 -4.50065,-0.26429 -6.58635,-0.78571 -3.64997,-0.91291 -5.2159,-2.30649 -5.88654,-3.31521 -0.38102,-0.57263 -0.51922,-1.07478 -0.56767,-1.39523 -0.0468,-0.30614 -0.022,-0.55006 -0.0171,-0.5908 l 0.0171,-0.006 c 0.009,-0.002 2.42267,-0.68 5.76154,-0.73121 0.1316,-0.002 0.2643,-0.003 0.39919,-0.003 1.61163,0 3.19793,0.15362 4.7154,0.457 5.80119,1.16013 8.80971,5.53911 8.83889,5.58316 l 0.003,0.005 -0.007,0.002 c -0.033,0.006 -2.79708,0.78186 -6.67335,0.78186 z m 16.18233,-5.88048 c -0.69872,0 -1.3187,-0.25493 -1.74652,-0.71799 -0.35184,-0.38047 -0.60787,-0.90464 -0.78186,-1.60116 -0.27861,-1.10947 -0.20097,-2.20353 -0.19326,-2.30429 0.28961,-0.12168 0.58474,-0.18831 0.86004,-0.19492 l 0.0617,-0.001 c 1.37982,0 2.47112,1.19978 2.93969,2.38853 0.25768,0.65413 0.30283,1.21574 0.1338,1.67055 -0.17069,0.46251 -0.67174,0.75983 -1.2719,0.75983 z m -12.1684,-1.66833 c -0.0523,-0.0127 -3.29098,-0.84574 -6.58911,-2.87692 -3.05257,-1.87923 -6.78678,-5.20324 -7.24213,-10.36793 v -0.003 l 0.008,-0.002 c 5.5e-4,0 0.28411,-0.0688 0.70367,-0.0848 0.0578,-0.002 0.11948,-0.003 0.1839,-0.003 0.91181,0 2.77837,0.25658 5.0364,1.97337 2.87417,2.19142 5.52809,6.01263 7.90121,11.37003 z m 7.94525,-0.29183 c -0.0204,-0.008 -2.32851,-0.93217 -5.21369,-3.34989 -2.68807,-2.25308 -6.46743,-6.30995 -9.20394,-12.84565 0.002,-5.5e-4 0.62879,-0.33477 1.58905,-0.39534 0.0556,-0.004 0.11177,-0.005 0.16848,-0.005 0.0826,0 0.16794,0.003 0.25493,0.005 1.32752,0.0374 3.34934,0.58915 5.59086,3.00797 2.57464,2.77891 4.87287,7.34509 6.82973,13.573 l 0.006,0.0176 -0.0165,-0.005 z m -20.58718,-0.60016 c -2.65448,0 -3.56298,-1.43983 -3.83057,-2.05927 -0.43939,-1.01807 -0.30614,-2.03118 -0.30504,-2.0411 l 0.002,-0.011 c 0.42948,-0.10737 0.88373,-0.16683 1.32036,-0.17289 l 0.0908,-5.5e-4 c 2.09175,0 3.74302,1.06212 4.4511,2.11488 0.14041,0.20868 0.57098,0.93273 0.21474,1.4982 -0.28632,0.44599 -0.93603,0.67174 -1.94364,0.67174 z m -5.88048,-7.41667 c -1.48223,0 -3.75018,-0.0909 -6.13431,-0.52418 -2.36431,-0.43002 -3.70448,-2.44029 -4.41201,-4.05026 -0.7703,-1.75368 -0.98779,-3.42642 -0.98999,-3.44349 h 0.007 c 7.31316,0.21473 10.76712,2.35164 12.37654,4.10587 1.66173,1.8115 1.76029,3.69237 1.76525,3.8113 l -0.005,5.5e-4 c -0.011,0 -1.04065,0.0991 -2.60987,0.0991 z m 7.61489,-7.60938 c -0.01,-0.0121 -0.84518,-1.04506 -1.66999,-2.32797 -0.86611,-1.34623 -1.66724,-2.75083 -1.66724,-3.9005 0,-1.11002 -0.26099,-3.4501 -0.41681,-4.74568 -0.19711,-1.64356 -0.39643,-3.05036 -0.41295,-3.16984 l 0.007,0.002 c 0.18555,0.0677 4.57444,1.71459 4.57444,5.83148 0,4.12349 -0.40635,8.26681 -0.41021,8.3081 l -5.5e-4,0.006 h -0.006 z m -5.68777,-0.39093 c -0.0463,0 -0.0919,-0.004 -0.13765,-0.0116 -1.29723,-0.21639 -3.57674,-1.20803 -6.09687,-2.65282 -2.79818,-1.60447 -5.07053,-3.32346 -6.39805,-4.84038 -1.21023,-1.38313 -1.92877,-3.55527 -2.13635,-6.45642 -0.14701,-2.05872 0.0292,-3.77386 0.0479,-3.94399 0.22685,-0.0754 0.46802,-0.11233 0.72405,-0.11233 0.97127,0.016 2.00806,0.45315 3.4077,1.41727 1.09076,0.75157 2.29328,1.7735 3.57344,3.03604 2.20904,2.17875 3.94675,4.36741 3.96382,4.38889 l 0.0176,0.022 c 0.14591,0.26154 1.39689,2.51682 2.37146,4.71209 0.61888,1.39414 0.97292,2.399 1.11443,3.16379 0.0809,0.43553 0.10461,0.72129 -0.002,0.98063 -0.0446,0.10737 -0.1294,0.20703 -0.21199,0.24667 -0.0771,0.033 -0.15417,0.0496 -0.24226,0.0496 z"
         id="branch"
         fill="#435125" /><use
         id="use5"
         transform="matrix(-1,0,0,1,476.70106,-2e-6)"
         x="0"
         y="0"
         width="100%"
         height="100%" /><path
         id="path7"
         d="m 391.27658,56.8491 -1.29668,0.51647 -0.50821,0.20263 -1.57143,-0.0865 -1.47178,0.70643 -2.60987,1.78341 -0.11508,0.0826 -0.97292,0.25383 -0.90355,-0.38983 -0.51316,0.23346 -0.17675,1.05717 -0.48838,0.75928 -0.60127,0.42232 -2.08294,0.21308 -1.75644,0.90575 -2.28501,-0.61172 -1.06157,0.41571 -2.25694,2.03284 -1.15352,0.5462 -0.40305,-0.0231 -1.52958,-0.0787 -0.64586,0.21144 -0.96467,0.93217 -1.82526,0.14206 -0.56877,0.39369 -0.89089,1.79497 -0.96521,0.9955 -0.55226,0.11673 -0.59851,-0.21914 -0.44984,0.0793 -0.20373,1.14857 -0.43663,0.48123 -1.22179,0.42066 -0.97623,0.81325 -0.85674,0.43993 -1.14747,-0.0286 h -0.26374 l -1.14306,0.631 -2.15012,0.18831 -0.89418,0.85289 -0.19712,0.18225 -0.41736,0.25217 -0.68275,0.40745 -0.16739,0.10131 -0.82315,-0.14701 -0.96357,0.38157 -0.38982,-0.59961 -0.66679,0.40029 -0.88317,0.038 -1.10011,-0.48949 -0.83803,-0.37332 -0.61282,0.0887 -0.21309,1.06818 -0.0215,0.11342 -0.64421,0.8573 -1.20253,0.72845 -0.16353,0.21309 -1.36825,1.76634 -2.59997,2.73431 -2.19857,1.11664 -2.27896,0.69321 -1.59511,1.31044 -4.18406,2.07414 -6.60398,3.28547 -1.35063,0.43278 -1.93814,0.30944 -3.45671,1.273 -3.04981,0.92006 -0.16959,0.0518 -0.60346,0.1828 -4.30024,1.30109 -2.00145,-0.21144 -1.18546,0.43058 -3.08615,-0.34248 -2.14571,0.0424 -1.35835,0.28246 -2.55316,1.22455 -4.3096,2.07138 -1.42387,1.30273 -2.21729,1.15683 -2.59612,0.82206 0.006,-1.09076 -0.0154,-0.0463 -0.90079,0.28467 -0.65026,0.20537 -2.10608,0.32486 h -1.17169 l -0.72735,-0.21143 -0.11232,0.038 -4.30464,1.41836 -4.80074,0.46361 -2.4023,0.7703 -1.79498,-0.0286 -1.12213,0.33422 -2.19968,0.26869 -0.78626,-0.20978 -0.1773,-0.0485 -6.46963,0.28081 -2.95786,-0.33422 -1.41175,0.321 -2.36541,-0.79562 -3.45175,-0.40029 -0.80664,-0.24172 -1.81425,-0.53849 -0.82095,0.47297 -0.61448,0.0655 -1.46847,-0.53244 -0.52858,-0.0138 -1.21244,0.43828 -0.69762,-0.17895 -0.64806,-0.51646 -1.52023,-0.2263 -0.92612,-0.77856 -5.1768,0.68605 -1.4046,-0.41295 -4.70989,-1.37211 -0.74937,0.038 -0.93383,0.69982 -1.40295,0.51151 -1.21794,0.3166 -1.65843,0.0578 -1.92547,-0.50546 -1.98549,-0.96246 -0.73395,-0.17454 -1.63751,0.16518 -0.50105,0.0457 -3.00962,-1.61438 -3.87737,-2.42487 -2.6308,-1.26419 -0.98779,-0.16023 -0.13269,0.46967 0.49004,1.54445 0.16683,1.52738 -0.0501,1.41121 -0.027,0.87381 0.24557,0.78461 0.94979,1.05276 0.39589,1.05717 0.28962,2.9094 -0.003,2.95236 -0.46196,4.70823 -0.15583,0.71689 -0.55115,2.43919 -0.50326,2.24042 -1.95245,5.96472 -0.53629,0.73947 -1.3165,0.89804 -2.98374,2.03063 -2.19692,1.26695 -0.69541,0.28797 -1.78342,0.1349 -1.11112,-0.0578 -1.38368,-0.74937 -1.35834,-0.34964 -1.77957,-1.27961 -1.97943,-0.40965 -2.16994,-1.25428 -0.56492,-0.6789 -1.1816,-0.11122 -1.63861,-0.49169 0.001,-0.003 -0.60181,-0.18005 -0.41571,-0.12113 v -5.5e-4 l -2.0901,-0.0573 -1.94915,-0.89969 -1.02633,-0.24778 -1.40239,-0.071 -1.46792,0.68221 -5.5e-4,-0.002 -0.74387,0.34634 -0.93989,-0.37332 -0.68,0.0424 -0.77029,1.16453 -0.11508,0.1806 -0.53079,0.28081 -0.66072,-0.009 -0.51702,-0.0138 -0.55942,0.24447 -0.75323,0.32651 v 0.002 l -0.66513,0.29017 -0.32486,0.1404 -0.006,-0.006 -0.19987,0.0402 -0.35514,0.0617 -0.44048,0.0842 -0.77636,-0.4537 -0.41295,-0.24337 -0.69212,-0.14095 -0.37276,0.26924 -0.0732,1.26695 -0.34027,0.75874 -1.07974,0.95475 -1.09736,0.96631 -0.7648,1.1271 -2.02403,4.61959 -1.26804,1.8638 -0.39369,0.43443 -1.32586,1.46241 -1.17609,0.91235 -2.71009,2.10057 -2.56528,0.9586 -2.20958,0.4515 -1.07423,0.004 -2.03504,-0.2709 -1.82967,-0.56162 -2.00971,-1.25648 -2.20408,-1.77131 -3.19022,-3.15167 -0.4515,-0.27145 -0.0941,-0.0628 -1.00486,-0.64256 -0.74552,0.0193 -0.29182,0.48123 -0.15968,0.69541 -0.13489,0.61668 -0.36561,3.50571 0.027,0.20318 0.19216,1.44369 2.42322,3.38623 0.74773,1.79883 0.12278,0.20538 0.49995,0.83967 0.38047,0.64036 0.038,0.065 0.82811,2.47112 -0.58199,1.39524 0.29402,0.93438 -0.73561,0.57098 -0.1349,0.80664 2.17545,2.72715 0.47462,1.20308 -0.53023,1.66779 -0.84573,0.92006 -0.23622,0.25163 0.11894,0.70477 1.001,0.90025 1.70082,1.51416 0.90685,2.24978 0.68991,0.60347 0.80169,-0.17069 0.44599,0.34027 0.67614,-0.0116 0.66513,0.66513 0.43058,0.20868 0.68055,0.33918 0.53794,0.70037 0.11893,2.15342 1.00321,2.67595 0.0154,1.45085 0.006,0.20593 0.62439,1.07258 0.19601,0.84683 -0.33256,2.24042 0.79562,0.71909 0.8628,-0.17619 0.55722,0.0881 0.89529,0.74552 1.08414,1.65237 1.06047,-0.15527 0.67284,0.3243 3.24968,2.93694 0.73726,0.37221 0.0407,0.0231 0.53023,0.26594 0.65908,0.66513 1.02192,-0.67835 0.11343,-0.0116 1.11112,-0.098 0.48784,0.32871 0.93823,0.63265 1.23006,-0.016 2.66714,0.81766 1.16673,0.29897 2.34614,1.45801 0.99715,0.61668 0.59025,0.47958 0.78406,0.63925 1.56648,0.67395 1.34348,0.32155 0.7279,0.17289 0.54785,0.21143 0.0138,-0.0341 0.008,0.002 -0.0132,0.0347 2.90941,1.11387 1.57583,0.36781 1.45801,0.53684 1.06102,0.38708 0.77856,0.0127 1.10121,-0.92612 1.06653,-0.0617 0.88592,0.2208 0.86446,-0.14481 1.36825,-0.84298 0.26705,-0.39589 0.97017,-0.46196 3.2728,-0.40635 0.95641,0.31055 2.4557,-1.06818 1.64521,0.45755 1.45636,-0.51646 3.18195,0.70697 0.84574,0.59521 0.94539,1.08194 0.11563,0.005 1.05276,0.0204 -0.43994,0.73286 1.38918,1.45745 1.25483,1.89684 0.0848,0.25053 0.91235,2.67815 0.67835,0.9487 0.47462,1.3242 0.0231,0.86336 -0.73781,0.56272 -0.12114,0.321 -0.0418,0.11893 0.14976,0.36065 0.27861,-0.15197 0.53023,-0.29347 0.64201,-0.0997 1.13755,0.12113 0.75103,0.0787 1.18601,-0.5886 0.78571,-0.39093 1.26254,0.54345 1.38753,-0.0154 0.58254,0.25934 1.64907,0.74772 0.84188,0.0793 0.31109,-0.20428 0.19822,-0.47132 -0.10186,-0.5484 -0.63045,-0.72845 -1.39358,-1.61769 -0.57043,-0.83141 -0.43443,-1.20363 -0.1349,-1.53839 -0.0958,-1.0379 0.17289,-1.36385 0.37441,-0.48674 0.2753,-1.08359 h 0.005 l 0.071,-0.28356 0.77415,-1.02743 2.05046,-1.31761 2.20243,-1.97227 1.74101,-1.14801 1.79498,-0.77746 0.0479,-0.21804 0.19987,0.0804 4.56564,-1.55216 0.0754,-0.009 2.03284,-0.35404 13.72112,0.96631 0.50876,-0.15362 0.002,-0.003 0.457,-1.28291 0.24612,-0.23787 0.16353,-0.15527 1.50867,-0.66403 0.70532,-0.10076 1.95796,0.48343 0.80168,0.19767 1.28402,-0.71964 0.9107,0.0154 1.88143,-1.02743 1.16233,0.0292 0.44213,-0.17674 2.2641,-1.62704 2.18095,-0.62494 0.56713,-0.30173 0.19987,-0.10958 2.23546,-1.1805 1.42001,-1.09075 1.22565,-0.65137 1.34238,-0.34633 3.51287,-0.24722 0.70643,-1.1772 1.51087,-0.20152 0.91235,-1.02963 1.04395,-0.42452 0.74828,-1.07809 0.62714,-0.90354 0.87601,-0.50711 2.8081,-0.1762 3.32841,0.41241 0.43994,-0.26705 0.75213,-2.6842 0.78737,-0.50381 2.12038,-3.09 0.007,-1.12599 0.002,-0.94044 0.34854,-1.33908 -0.23676,-2.41771 0.2808,-2.448 1.31816,-3.11093 1.16123,-1.25483 1.87261,-1.26694 0.952,-0.41461 1.34843,-0.22685 v -0.003 l 0.19822,-0.0336 0.34358,-0.0589 4.64327,-0.0639 c 0.0644,-0.0479 1.68871,-0.0231 1.68871,-0.0231 l 1.5483,-0.0209 3.91702,0.69706 0.27861,0.0485 1.32421,0.42892 1.52738,1.18766 1.61658,1.57914 0.30338,0.29457 1.04726,0.44104 0.3166,0.1382 0.865,-0.1382 1.23171,-0.64146 0.92942,-0.78571 1.26695,-0.69212 0.0308,-0.044 0.71304,-1.07258 0.0215,-0.022 0.0154,0.004 0.002,-0.006 -0.0121,-0.003 0.28136,-0.42672 2.44854,-0.9542 2.87968,-0.16738 0.32375,-0.1751 0.18005,-0.0964 0.76094,-0.89364 0.71304,-0.006 1.72615,0.62438 1.21353,-0.24061 0.96357,0.38487 0.74882,-0.0886 1.41231,-0.16739 1.51637,1.06708 0.88372,0.11287 3.11533,1.82251 0.16188,0.0264 0.0837,0.0154 0.17839,0.0292 0.36946,-0.10957 0.5495,-0.15913 0.0727,-0.0215 0.0694,0.0958 0.35404,0.4994 0.48564,0.0694 0.57483,-0.76699 -0.2285,-0.34799 -0.0864,-0.12664 -1.11277,-0.2263 -0.99935,-1.70853 0.95144,-1.02468 -1.49269,-1.83132 -0.24777,-0.30338 -0.0842,-0.12884 -0.51592,-0.78352 -2.61317,-3.98363 -3.40386,-2.71725 -0.001,0.002 -1.19206,-0.95365 -0.008,-0.006 -0.41736,-0.32816 -1.8181,-1.84894 -1.29833,-1.7234 -0.17014,-0.37111 -0.26814,-0.58474 -0.77801,-1.69477 -1.3556,-1.04395 -1.10451,-1.20638 -0.054,-0.071 -2.27951,-3.09771 -0.37442,-0.51922 -0.53849,-0.3111 -1.13755,-0.008 -0.10737,-0.10791 -0.0639,-0.0666 0.0385,-0.0407 0.54565,-0.54235 0.60842,-0.15307 0.26209,-0.59961 -1.16068,-3.3609 -0.008,-0.11728 -0.0864,-1.07369 0.94594,-4.87562 0.12113,-0.5941 1.61218,-3.28052 0.9988,-0.8182 1.0902,-2.14296 0.93383,-1.36991 0.89474,-0.87106 0.15637,-0.0925 1.61548,-0.97788 1.35724,-0.19106 1.29283,-0.18225 2.25694,0.69597 2.14791,-0.0419 0.41901,-0.0446 0.97458,-0.11177 1.60281,-0.50491 0.75654,-0.46691 0.39258,-0.60181 0.81875,-2.74588 0.26319,-0.87381 0.50491,-0.94925 2.92152,-3.3631 2.20848,-2.04275 4.96592,-3.64117 2.43093,-1.45305 1.24107,-0.74166 11.08151,-4.92573 2.87967,-2.91932 1.5004,-1.51802 2.65448,-1.78122 3.10597,-1.27245 2.67265,-2.11543 0.58364,-0.73451 0.73561,-2.36926 0.61283,-0.14811 0.55335,-1.19702 0.15748,-0.34028 2.18095,-1.53729 0.24667,-0.12278 8.47274,-4.24518 1.23116,0.16903 0.65907,-0.98723 2.46507,-0.41351 0.4537,-0.0771 0.60787,-0.30339 0.51702,-0.88042 V 62.8812 l 0.071,-2.35274 0.52638,-0.63595 0.28687,-1.55051 0.27035,-0.3579 0.28246,-0.37221 0.69817,-0.49059 -0.12113,-0.29237 z"
         fill="#d47600" />
  </svg>
);

export const CZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.448" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#41479b"
       d="M 3.256,333.314 256,167.724 3.256,2.134 C 1.311,3.753 0,6.099 0,8.827 V 326.62 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 3.256,333.314 c 1.53,1.274 3.425,2.134 5.571,2.134 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 167.724 H 256 Z"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="M 3.256,2.134 C 4.786,0.86 6.681,0 8.827,0 H 503.172 C 508.047,0 512,3.953 512,8.828 V 167.724 H 256 Z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const DE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#464655"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#ff4b55"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const DJ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.448" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#f5f5f5"
       d="M 3.256,333.314 256,167.724 3.256,2.134 C 1.311,3.753 0,6.099 0,8.827 V 326.62 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path1" />
    <path
       fill="#73af00"
       d="m 3.256,333.314 c 1.53,1.274 3.425,2.134 5.571,2.134 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 167.724 H 256 Z"
       id="path2" />
    <path
       fill="#82afff"
       d="M 3.256,2.134 C 4.786,0.86 6.681,0 8.827,0 H 503.172 C 508.047,0 512,3.953 512,8.828 V 167.724 H 256 Z"
       id="path3" />
    <path
       fill="#ff4b55"
       d="m 91.766,127.859 -8.94,26.806 -28.257,0.22 c -1.549,0.012 -2.191,1.99 -0.946,2.91 l 22.732,16.787 -8.523,26.942 c -0.467,1.478 1.215,2.699 2.475,1.798 l 22.989,-16.431 22.989,16.431 c 1.26,0.9 2.942,-0.321 2.475,-1.798 l -8.523,-26.942 22.729,-16.788 c 1.246,-0.92 0.604,-2.898 -0.946,-2.91 l -28.257,-0.22 -8.94,-26.806 c -0.488,-1.469 -2.567,-1.469 -3.057,10e-4 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const DK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs15" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#f5f5f5"
       points="211.862,88.277 158.897,88.277 158.897,229.518 0,229.518 0,282.484 158.897,282.484 158.897,423.725 211.862,423.725 211.862,282.484 512,282.484 512,229.518 211.862,229.518 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const DM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45403" {...props}>
    <defs
       id="defs41" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.877 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <rect
       y="132.414"
       fill="#ffe15a"
       width="512"
       height="23.540001"
       id="rect1"
       x="0" />
    <rect
       y="155.95401"
       fill="#464655"
       width="512"
       height="23.540001"
       id="rect2"
       x="0" />
    <rect
       y="179.494"
       fill="#f5f5f5"
       width="512"
       height="23.540001"
       id="rect3"
       x="0" />
    <rect
       x="220.69"
       y="0.0040004272"
       fill="#ffe15a"
       width="23.540001"
       height="335.45001"
       id="rect4" />
    <rect
       x="244.23"
       y="0.0040004272"
       fill="#464655"
       width="23.540001"
       height="335.45001"
       id="rect5" />
    <rect
       x="267.76999"
       y="0.0040004272"
       fill="#f5f5f5"
       width="23.540001"
       height="335.45001"
       id="rect6" />
    <circle
       fill="#ff4b55"
       cx="256"
       cy="167.724"
       r="88.279999"
       id="circle6" />
    <path
       fill="#73af00"
       d="m 248.421,182.909 c 0,0 -1.031,7.217 5.98,17.938 h 13.608 l -3.093,-12.989 z"
       id="path6" />
    <path
       fill="#a561cd"
       d="m 247.459,134.595 c 0,0 -22.266,36.425 10.446,58.142 l 3.436,-20.618 2.199,-26.666 -3.436,-11.409 z"
       id="path7" />
    <path
       fill="#73af00"
       d="m 247.459,134.594 c 0,0 -2.545,4.237 -4.653,10.612 2.866,2.996 10.701,6.708 20.335,5.08 l 0.399,-4.834 -3.437,-11.409 z"
       id="path8" />
    <path
       fill="#a561cd"
       d="m 243.197,129.372 c 0,0 0.274,-7.285 7.423,-7.285 8.935,0 16.22,2.061 27.765,25.978 0,0 -10.269,10.08 -16.769,-3.849 -1.924,-4.124 -2.612,-9.071 -2.612,-9.071 0,0 -7.972,2.749 -13.47,-0.413 z"
       id="path9" />
    <path
       fill="#ffe15a"
       d="m 246.771,132.808 -1.65,-4.398 c 0,0 -9.209,-1.512 -5.361,9.622 0,0 0.275,-2.199 2.612,-1.924 2.338,0.274 4.811,-1.513 4.399,-3.3 z"
       id="path10" />
    <g
       id="g12"
       transform="translate(0,-88.273)">
    	<path
       fill="#73af00"
       d="m 262.165,262.866 c 0,0 -9.689,7.593 -4.26,25.428 2.887,9.484 14.432,19.896 14.432,19.896 0,0 8.556,-22.37 5.773,-31.029 -1.638,-5.097 -15.945,-14.295 -15.945,-14.295 z"
       id="path11" />
    	<path
       fill="#73af00"
       d="m 280.584,291.594 c 0,0 -25.016,-23.848 -26.666,-42.61 -1.65,-18.762 9.169,-15.784 11.134,-14.57 4.673,2.886 16.494,14.982 15.532,57.18 z"
       id="path12" />
    </g>
    <path
       fill="#b34900"
       d="m 277.48,208.784 h -41.418 c -0.861,0 -1.558,-0.697 -1.558,-1.558 v -3.07 c 0,-0.861 0.697,-1.558 1.558,-1.558 h 41.418 c 0.861,0 1.558,0.697 1.558,1.558 v 3.07 c -0.001,0.86 -0.698,1.558 -1.558,1.558 z"
       id="path13" />
    <path
       fill="#ffe15a"
       d="m 267.389,202.908 c -1.442,0.599 -4.33,1.341 -3.608,3.917 0.553,1.974 4.33,1.752 3.608,4.021 -0.488,1.533 -8.159,1.674 -11.134,1.237 -1.822,-0.268 -5.773,-1.341 -5.223,-5.876 0.55,-4.536 2.199,-5.234 4.262,-6.048 2.045,-0.808 10.99,-0.629 12.302,0.481 0.669,0.567 0.885,1.815 -0.207,2.268 z"
       id="path14" />
    <g
       id="g26"
       transform="translate(0,-88.273)">
    	<path
       fill="#73af00"
       d="m 256.812,177.134 2.009,6.025 6.35,0.05 c 0.822,0.007 1.163,1.056 0.502,1.544 l -5.109,3.773 1.916,6.055 c 0.248,0.783 -0.644,1.432 -1.313,0.954 l -5.167,-3.693 -5.166,3.693 c -0.669,0.478 -1.561,-0.17 -1.313,-0.954 l 1.916,-6.055 -5.109,-3.773 c -0.661,-0.489 -0.32,-1.538 0.502,-1.544 l 6.35,-0.05 2.009,-6.025 c 0.259,-0.78 1.362,-0.78 1.623,0 z"
       id="path15" />
    	<path
       fill="#73af00"
       d="m 256.812,317.987 2.009,6.025 6.35,0.05 c 0.822,0.007 1.163,1.056 0.502,1.544 l -5.109,3.773 1.916,6.055 c 0.248,0.783 -0.644,1.432 -1.313,0.954 l -5.167,-3.693 -5.166,3.693 c -0.669,0.478 -1.561,-0.17 -1.313,-0.954 l 1.916,-6.055 -5.109,-3.773 c -0.661,-0.489 -0.32,-1.538 0.502,-1.544 l 6.35,-0.05 2.009,-6.025 c 0.259,-0.78 1.362,-0.78 1.623,0 z"
       id="path16" />
    	<path
       fill="#73af00"
       d="m 256.812,177.134 2.009,6.025 6.35,0.05 c 0.822,0.007 1.163,1.056 0.502,1.544 l -5.109,3.773 1.916,6.055 c 0.248,0.783 -0.644,1.432 -1.313,0.954 l -5.167,-3.693 -5.166,3.693 c -0.669,0.478 -1.561,-0.17 -1.313,-0.954 l 1.916,-6.055 -5.109,-3.773 c -0.661,-0.489 -0.32,-1.538 0.502,-1.544 l 6.35,-0.05 2.009,-6.025 c 0.259,-0.78 1.362,-0.78 1.623,0 z"
       id="path17" />
    	<path
       fill="#73af00"
       d="m 256.812,317.987 2.009,6.025 6.35,0.05 c 0.822,0.007 1.163,1.056 0.502,1.544 l -5.109,3.773 1.916,6.055 c 0.248,0.783 -0.644,1.432 -1.313,0.954 l -5.167,-3.693 -5.166,3.693 c -0.669,0.478 -1.561,-0.17 -1.313,-0.954 l 1.916,-6.055 -5.109,-3.773 c -0.661,-0.489 -0.32,-1.538 0.502,-1.544 l 6.35,-0.05 2.009,-6.025 c 0.259,-0.78 1.362,-0.78 1.623,0 z"
       id="path18" />
    	<path
       fill="#73af00"
       d="m 207.734,191.589 1.76,6.102 -5.204,3.64 c -0.674,0.471 -0.36,1.529 0.462,1.556 l 6.347,0.212 1.855,6.074 c 0.241,0.787 1.343,0.814 1.623,0.042 l 2.163,-5.971 6.35,0.114 c 0.822,0.014 1.19,-1.025 0.541,-1.53 l -5.011,-3.902 2.069,-6.006 c 0.268,-0.777 -0.608,-1.449 -1.289,-0.988 l -5.259,3.56 -5.07,-3.823 c -0.657,-0.496 -1.566,0.13 -1.337,0.92 z"
       id="path19" />
    	<path
       fill="#73af00"
       d="m 287.582,307.621 1.76,6.102 -5.204,3.64 c -0.674,0.471 -0.36,1.529 0.462,1.556 l 6.347,0.212 1.855,6.074 c 0.241,0.787 1.343,0.814 1.623,0.042 l 2.163,-5.971 6.35,0.114 c 0.822,0.014 1.19,-1.025 0.541,-1.53 l -5.011,-3.902 2.07,-6.004 c 0.268,-0.777 -0.608,-1.449 -1.289,-0.988 l -5.259,3.56 -5.07,-3.823 c -0.656,-0.497 -1.565,0.129 -1.338,0.918 z"
       id="path20" />
    	<path
       fill="#73af00"
       d="m 177.885,232.025 5.07,3.823 -1.976,6.036 c -0.256,0.781 0.63,1.439 1.304,0.968 l 5.204,-3.641 5.13,3.744 c 0.664,0.484 1.564,-0.154 1.323,-0.941 l -1.855,-6.073 5.146,-3.721 c 0.666,-0.482 0.335,-1.535 -0.487,-1.549 l -6.35,-0.113 -1.949,-6.045 c -0.253,-0.782 -1.355,-0.793 -1.623,-0.017 l -2.069,6.004 -6.35,-0.014 c -0.823,-0.003 -1.174,1.043 -0.518,1.539 z"
       id="path21" />
    	<path
       fill="#73af00"
       d="m 311.401,276.887 5.07,3.823 -1.976,6.036 c -0.256,0.781 0.63,1.439 1.304,0.968 l 5.204,-3.641 5.13,3.744 c 0.664,0.484 1.564,-0.155 1.323,-0.941 l -1.855,-6.073 5.146,-3.721 c 0.666,-0.482 0.335,-1.535 -0.487,-1.549 l -6.35,-0.113 -1.949,-6.045 c -0.253,-0.782 -1.355,-0.793 -1.623,-0.017 l -2.069,6.004 -6.35,-0.014 c -0.822,-0.002 -1.174,1.044 -0.518,1.539 z"
       id="path22" />
    	<path
       fill="#73af00"
       d="m 300.912,191.589 -1.76,6.102 5.204,3.64 c 0.674,0.471 0.36,1.529 -0.462,1.556 l -6.347,0.212 -1.855,6.074 c -0.241,0.787 -1.343,0.814 -1.623,0.042 l -2.163,-5.971 -6.35,0.114 c -0.822,0.014 -1.19,-1.025 -0.541,-1.53 l 5.011,-3.902 -2.07,-6.004 c -0.268,-0.777 0.608,-1.449 1.289,-0.988 l 5.259,3.56 5.07,-3.823 c 0.657,-0.498 1.566,0.128 1.338,0.918 z"
       id="path23" />
    	<path
       fill="#73af00"
       d="m 221.063,307.621 -1.76,6.102 5.204,3.64 c 0.674,0.471 0.36,1.529 -0.462,1.556 l -6.347,0.212 -1.855,6.074 c -0.241,0.787 -1.343,0.814 -1.623,0.042 l -2.163,-5.971 -6.35,0.114 c -0.822,0.014 -1.19,-1.025 -0.541,-1.53 l 5.011,-3.902 -2.07,-6.004 c -0.268,-0.777 0.608,-1.449 1.289,-0.988 l 5.259,3.56 5.07,-3.823 c 0.657,-0.497 1.566,0.129 1.338,0.918 z"
       id="path24" />
    	<path
       fill="#73af00"
       d="m 330.761,232.025 -5.07,3.823 1.976,6.036 c 0.256,0.781 -0.63,1.439 -1.304,0.968 l -5.204,-3.641 -5.13,3.744 c -0.664,0.484 -1.564,-0.154 -1.323,-0.941 l 1.855,-6.073 -5.146,-3.721 c -0.666,-0.482 -0.335,-1.535 0.487,-1.549 l 6.35,-0.113 1.949,-6.045 c 0.253,-0.782 1.355,-0.793 1.623,-0.017 l 2.069,6.004 6.35,-0.014 c 0.823,-0.003 1.175,1.043 0.518,1.539 z"
       id="path25" />
    	<path
       fill="#73af00"
       d="m 197.244,276.887 -5.07,3.823 1.976,6.036 c 0.256,0.781 -0.63,1.439 -1.304,0.968 l -5.204,-3.641 -5.13,3.744 c -0.664,0.484 -1.564,-0.155 -1.323,-0.941 l 1.855,-6.073 -5.146,-3.721 c -0.666,-0.482 -0.335,-1.535 0.487,-1.549 l 6.35,-0.113 1.949,-6.045 c 0.253,-0.782 1.355,-0.793 1.623,-0.017 l 2.069,6.004 6.35,-0.014 c 0.824,-0.002 1.175,1.044 0.518,1.539 z"
       id="path26" />
    </g>
    <g
       id="g27"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const DO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs54" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="M 211.862,220.691 H 8.828 C 3.953,220.691 0,216.738 0,211.863 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 203.034 c 4.875,0 8.828,3.953 8.828,8.828 v 114.759 c 0,4.875 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    	<path
       fill="#41479b"
       d="M 503.172,423.725 H 300.138 c -4.875,0 -8.828,-3.953 -8.828,-8.828 V 300.139 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 203.034 c 4.875,0 8.828,3.953 8.828,8.828 v 114.759 c 0,4.875 -3.953,8.827 -8.828,8.827 z"
       id="path3" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="M 503.172,220.691 H 300.138 c -4.875,0 -8.828,-3.953 -8.828,-8.828 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 203.034 c 4.875,0 8.828,3.953 8.828,8.828 v 114.759 c 0,4.875 -3.953,8.828 -8.828,8.828 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 211.862,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 V 300.139 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 203.034 c 4.875,0 8.828,3.953 8.828,8.828 v 114.759 c 0,4.875 -3.953,8.827 -8.828,8.827 z"
       id="path5" />
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    	<path
       fill="#64b496"
       d="m 250.932,281.172 c 0,0 5.274,1.931 4.586,8.552 l 2.132,-0.04 c 0,0 -1.345,-7.651 -2.457,-8.568 -1.112,-0.917 -4.261,0.056 -4.261,0.056 z"
       id="path6" />
    	<path
       fill="#64b496"
       d="m 256.218,280.15 c -2.237,0 -6.147,-0.003 -10.259,-1.113 0.917,-0.954 2.184,-2.876 2.184,-6.227 0,-5.248 -3.616,-1.9 -3.616,-1.9 0,0 -2.378,2.001 -0.94,7.35 -1.402,-0.535 -2.793,-1.225 -4.119,-2.109 0.825,-1.036 2.471,-3.45 3.427,-7.278 0,0 -6.026,-1.191 -7.674,3.347 -1.01,-1.281 -1.874,-2.722 -2.595,-4.317 1.549,0.019 3.71,-1.003 3.71,-6.901 0,0 -3.935,0.007 -4.986,3.42 -0.414,-1.427 -0.729,-2.956 -0.961,-4.572 1.571,0.456 5.633,0.783 5.633,-8.032 0,0 -4.877,0.009 -6.006,4.329 -0.062,-1.105 -0.086,-2.247 -0.075,-3.425 2.368,-1.238 5.636,-3.965 5.297,-9.56 0,0 -2.249,0.51 -4.311,2.239 0.406,-2.121 0.238,-5.226 -3.015,-7.817 0,0 -2.989,5.29 1.377,9.585 -0.38,0.534 -0.711,1.142 -0.984,1.817 -0.981,-1.494 -2.554,-2.883 -5.088,-3.727 0,0 -1.166,7.085 5.449,10.049 0.157,4.138 0.804,7.794 1.916,10.973 -1.895,-1.669 -3.428,-3.967 -3.428,-3.967 0,-7.872 -6.453,-8.071 -6.453,-8.071 -1.205,8.985 5.439,9.348 5.439,9.348 l 3.638,3.97 c -7.872,-1.312 -7.872,5.248 -7.872,5.248 5.248,1.312 7.872,-1.312 7.872,-1.312 l 2.838,1.459 c -5.034,0.147 -6.774,5.101 -6.774,5.101 6.327,1.055 10.953,-0.433 12.526,-1.057 6.372,4.455 14.226,4.461 17.852,4.461 v -1.311 z"
       id="path7" />
    	<path
       fill="#64b496"
       d="m 255.772,280.15 c 2.237,0 6.147,-0.003 10.259,-1.113 -0.917,-0.954 -2.184,-2.876 -2.184,-6.227 0,-5.248 3.616,-1.9 3.616,-1.9 0,0 2.378,2.001 0.94,7.35 1.402,-0.535 2.793,-1.225 4.119,-2.109 -0.825,-1.036 -2.471,-3.45 -3.427,-7.278 0,0 6.026,-1.191 7.674,3.347 1.01,-1.281 1.874,-2.722 2.595,-4.317 -1.549,0.019 -3.71,-1.003 -3.71,-6.901 0,0 3.935,0.007 4.988,3.42 0.414,-1.427 0.729,-2.956 0.961,-4.572 -1.571,0.456 -5.633,0.783 -5.633,-8.032 0,0 4.877,0.009 6.006,4.329 0.062,-1.105 0.086,-2.247 0.075,-3.425 -2.368,-1.238 -5.636,-3.965 -5.297,-9.56 0,0 2.249,0.51 4.311,2.239 -0.406,-2.121 -0.238,-5.226 3.015,-7.817 0,0 2.989,5.29 -1.377,9.585 0.38,0.534 0.711,1.142 0.984,1.817 0.981,-1.494 2.554,-2.883 5.088,-3.727 0,0 1.166,7.085 -5.449,10.049 -0.157,4.138 -0.804,7.794 -1.916,10.973 1.895,-1.669 3.428,-3.967 3.428,-3.967 0,-7.872 6.453,-8.071 6.453,-8.071 1.205,8.985 -5.439,9.348 -5.439,9.348 l -3.638,3.97 c 7.872,-1.312 7.872,5.248 7.872,5.248 -5.248,1.312 -7.872,-1.312 -7.872,-1.312 l -2.838,1.459 c 5.034,0.147 6.774,5.101 6.774,5.101 -6.327,1.055 -10.953,-0.433 -12.526,-1.057 -6.372,4.455 -14.226,4.461 -17.852,4.461 v -1.311 z"
       id="path8" />
    </g>
    <path
       fill="#41479b"
       d="m 233.863,134.68 c -4.614,2.957 -8.681,6.722 -11.958,11.167 1.408,1.038 2.816,2.077 4.224,3.115 2.892,-3.923 6.481,-7.245 10.551,-9.856 z"
       id="path9" />
    <path
       fill="#ff6b71"
       d="m 256.014,168.791 h 18.367 v 10.496 c 0,2.899 -2.349,5.248 -5.248,5.248 h -7.872 c -2.156,0 -4.052,1.054 -5.248,2.66 z"
       id="path10" />
    <polygon
       fill="#5f64b9"
       points="279.63,230.827 274.382,236.075 274.382,250.507 259.95,250.507 259.95,245.259 259.95,230.827 "
       id="polygon10"
       transform="translate(0,-88.276)" />
    <rect
       x="267.82001"
       y="162.22501"
       fill="#f5f5f5"
       width="6.5599999"
       height="6.5599999"
       id="rect10" />
    <path
       fill="#ff6b71"
       d="m 256.014,168.791 h -18.367 v 10.496 c 0,2.899 2.349,5.248 5.248,5.248 h 7.872 c 2.156,0 4.052,1.054 5.248,2.66 z"
       id="path11" />
    <path
       fill="#f5f5f5"
       d="m 252.735,184.851 c 1.309,0.418 2.439,1.233 3.25,2.307 h 0.061 c 0.812,-1.075 1.941,-1.888 3.25,-2.307 v -10.813 h -6.56 z"
       id="path12" />
    <polygon
       fill="#5f64b9"
       points="232.399,230.827 237.647,236.075 237.647,250.507 252.079,250.507 252.079,245.259 252.079,230.827 "
       id="polygon12"
       transform="translate(0,-88.276)" />
    <rect
       x="237.64999"
       y="162.22501"
       fill="#f5f5f5"
       width="6.5599999"
       height="6.5599999"
       id="rect12" />
    <polygon
       fill="#41479b"
       points="248.143,243.947 248.143,241.323 244.207,237.387 244.207,241.323 "
       id="polygon13"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#f5f5f5"
       points="253.391,247.883 253.391,246.571 248.143,241.323 248.143,245.259 "
       id="polygon14"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#41479b"
       points="263.886,243.947 263.886,241.323 267.822,237.387 267.822,241.323 "
       id="polygon15"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#f5f5f5"
       points="258.638,247.883 258.638,246.571 263.886,241.323 263.886,245.259 "
       id="polygon16"
       transform="translate(0,-88.276)" />
    <path
       fill="#ff4b55"
       d="m 263.932,177.974 h -15.829 c -3.598,0 -6.515,-2.937 -6.515,-6.56 v -20.291 l 14.525,9.795 14.333,-9.795 v 20.291 c 0,3.624 -2.916,6.56 -6.514,6.56 z"
       id="path16" />
    <g
       id="g18"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#41479b"
       points="241.583,253.131 246.831,255.755 246.831,242.635 241.583,238.699 "
       id="polygon17" />
    	<polygon
       fill="#41479b"
       points="270.446,253.131 265.198,255.755 265.198,242.635 270.446,238.699 "
       id="polygon18" />
    	<rect
       x="248.14"
       y="255.761"
       fill="#41479b"
       width="15.744"
       height="6.5599999"
       id="rect18" />
    </g>
    <polygon
       fill="#ff4b55"
       points="263.886,243.947 263.886,255.755 248.143,255.755 248.143,243.947 256.014,247.883 "
       id="polygon19"
       transform="translate(0,-88.276)" />
    <g
       id="g20"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 261.919,245.187 v 13.192 c 0,1.085 -0.883,1.967 -1.967,1.967 h -7.872 c -1.085,0 -1.967,-0.883 -1.967,-1.967 v -13.138 l -3.936,-2.636 v 15.774 c 0,3.255 2.648,5.903 5.903,5.903 h 7.872 c 3.255,0 5.903,-2.648 5.903,-5.903 v -15.863 z"
       id="path19" />
    	<path
       fill="#f5f5f5"
       d="m 263.293,254.351 c -2.21,0.199 -4.697,0.422 -7.278,1.32 -2.58,-0.898 -5.068,-1.121 -7.278,-1.32 -3.698,-0.332 -5.892,-0.655 -7.148,-2.886 v 3.787 c 1.929,1.254 4.372,1.484 6.913,1.713 2.281,0.205 4.639,0.416 7.049,1.329 l 0.465,0.175 0.465,-0.175 c 2.409,-0.913 4.767,-1.123 7.049,-1.329 2.543,-0.228 4.99,-0.455 6.919,-1.711 v -3.798 c -1.257,2.24 -3.453,2.563 -7.156,2.895 z"
       id="path20" />
    </g>
    <polygon
       fill="#ffe15a"
       points="256.671,240.011 255.359,240.011 255.359,241.979 253.391,241.979 253.391,243.291 255.359,243.291 255.359,249.195 256.671,249.195 256.671,243.291 258.638,243.291 258.638,241.979 256.671,241.979 "
       id="polygon20"
       transform="translate(0,-88.276)" />
    <rect
       x="66.900032"
       y="276.86893"
       transform="rotate(-45)"
       fill="#464655"
       width="1.0179902"
       height="16.303844"
       id="rect20" />
    <polygon
       fill="#ffe15a"
       points="244.16,235.662 241.278,234.221 242.719,237.103 "
       id="polygon21"
       transform="translate(0,-88.276)" />
    <rect
       x="112.28936"
       y="263.02155"
       transform="rotate(-36.071182)"
       fill="#464655"
       width="1.0190176"
       height="16.305281"
       id="rect21" />
    <polygon
       fill="#ffe15a"
       points="246.851,233.855 244.227,231.984 245.204,235.055 "
       id="polygon22"
       transform="translate(0,-88.276)" />
    <rect
       x="14.132957"
       y="283.98032"
       transform="rotate(-55.075102)"
       fill="#464655"
       width="1.0179961"
       height="16.303938"
       id="rect22" />
    <polygon
       fill="#ffe15a"
       points="241.8,238.024 238.71,237.109 240.633,239.694 "
       id="polygon23"
       transform="translate(0,-88.276)" />
    <rect
       x="-295.151"
       y="68.890594"
       transform="rotate(-135)"
       fill="#464655"
       width="1.0179902"
       height="16.303844"
       id="rect23" />
    <polygon
       fill="#ffe15a"
       points="267.863,235.662 270.745,234.221 269.304,237.103 "
       id="polygon24"
       transform="translate(0,-88.276)" />
    <rect
       x="-301.57458"
       y="22.163242"
       transform="rotate(-143.92882)"
       fill="#464655"
       width="1.0190176"
       height="16.305281"
       id="rect24" />
    <polygon
       fill="#ffe15a"
       points="265.173,233.855 267.796,231.984 266.819,235.055 "
       id="polygon25"
       transform="translate(0,-88.276)" />
    <rect
       x="-279.02292"
       y="119.53119"
       transform="rotate(-124.9249)"
       fill="#464655"
       width="1.0179961"
       height="16.303938"
       id="rect25" />
    <polygon
       fill="#ffe15a"
       points="270.223,238.024 273.313,237.109 271.39,239.694 "
       id="polygon26"
       transform="translate(0,-88.276)" />
    <path
       fill="#f5f5f5"
       d="m 255.349,184.161 c 0,0 -5.074,-5.449 -4.089,-10.451 0.791,-4.023 3.192,-8.458 5.071,-9.537 0,0 2.657,-0.164 1.991,2.144 -0.666,2.308 -1.478,2.903 -1.24,5.178 0.409,3.938 1.044,8.604 -1.733,12.666 z"
       id="path26" />
    <path
       fill="#41479b"
       d="m 256.888,164.202 c -0.317,-0.042 -0.558,-0.028 -0.558,-0.028 -1.879,1.079 -4.28,5.514 -5.071,9.537 -0.448,2.275 0.361,4.638 1.373,6.543 -0.641,-8.248 1.767,-11.174 4.256,-16.052 z"
       id="path27" />
    <path
       fill="#ff4b55"
       d="m 257.08,171.497 c -0.237,-2.275 0.574,-2.87 1.24,-5.178 0.467,-1.615 -0.693,-2.019 -1.432,-2.116 0,0 -1.694,3.892 -1.803,6.503 -0.096,2.297 0.492,11.644 0.264,13.458 2.777,-4.065 2.142,-8.731 1.731,-12.667 z"
       id="path28" />
    <path
       fill="#f5f0f0"
       d="m 253.639,166.148 c 1.057,-1.031 2.543,-1.492 3.999,-1.242 -0.69,-2.221 -1.38,-4.442 -2.07,-6.664 -1.454,-0.249 -2.941,0.212 -3.999,1.242 0.689,2.222 1.38,4.443 2.07,6.664 z"
       id="path29" />
    <path
       fill="#f5f5f5"
       d="m 257.638,164.906 c 1.057,-1.031 2.543,-1.492 3.999,-1.242 -0.69,-2.221 -1.38,-4.442 -2.07,-6.664 -1.454,-0.249 -2.941,0.212 -3.999,1.242 0.689,2.221 1.379,4.442 2.07,6.664 z"
       id="path30" />
    <path
       fill="#5f64b9"
       d="m 250.022,136.079 c -7.122,-0.164 -14.156,1.587 -20.37,5.07 -0.855,-1.526 -1.711,-3.052 -2.567,-4.577 7.033,-3.944 14.996,-5.926 23.058,-5.74 -0.041,1.749 -0.082,3.498 -0.121,5.247 z"
       id="path31" />
    <path
       fill="#41479b"
       d="m 278.167,134.68 c 4.614,2.957 8.681,6.722 11.958,11.167 -1.408,1.038 -2.816,2.077 -4.224,3.115 -2.892,-3.923 -6.481,-7.245 -10.551,-9.856 z"
       id="path32" />
    <path
       fill="#5f64b9"
       d="m 262.008,136.079 c 7.122,-0.164 14.156,1.587 20.37,5.07 0.855,-1.526 1.711,-3.052 2.567,-4.577 -7.033,-3.944 -14.996,-5.926 -23.058,-5.74 0.041,1.749 0.082,3.498 0.121,5.247 z"
       id="path33" />
    <path
       fill="#41479b"
       d="m 266.51,134.68 c -6.871,-1.88 -14.121,-1.88 -20.991,0 -0.461,-1.687 -0.924,-3.374 -1.385,-5.062 7.777,-2.127 15.983,-2.127 23.761,0 -0.461,1.687 -0.923,3.374 -1.385,5.062 z"
       id="path34" />
    <g
       id="g36"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff6b71"
       d="m 238.432,281.758 c -5.663,1.479 -11.199,3.474 -16.529,5.985 0.746,1.582 1.492,3.165 2.237,4.747 5.143,-2.424 10.489,-4.337 15.96,-5.742 z"
       id="path35" />
    	<path
       fill="#ff6b71"
       d="m 273.598,281.758 c 5.663,1.479 11.199,3.474 16.529,5.985 -0.746,1.582 -1.492,3.165 -2.237,4.747 -5.143,-2.424 -10.489,-4.337 -15.96,-5.742 z"
       id="path36" />
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 277.119,285.816 c -13.799,-3.313 -28.184,-3.313 -41.983,0 -0.408,-1.702 -0.817,-3.402 -1.225,-5.102 14.603,-3.506 29.83,-3.506 44.433,0 -0.407,1.7 -0.816,3.402 -1.225,5.102 z"
       id="path37" />
    	<path
       fill="#ff4b55"
       d="m 256.014,287.242 -3.618,0.905 c -0.828,0.207 -1.63,-0.419 -1.63,-1.272 v -1.887 c 0,-0.853 0.802,-1.48 1.63,-1.272 l 3.618,0.905 z"
       id="path38" />
    	<path
       fill="#ff4b55"
       d="m 256.014,284.618 3.618,-0.905 c 0.828,-0.207 1.63,0.419 1.63,1.272 v 1.887 c 0,0.853 -0.802,1.48 -1.63,1.272 l -3.618,-0.905 z"
       id="path39" />
    </g>
    <path
       fill="#ff6b71"
       d="m 256.296,198.966 h -0.563 c -0.569,0 -1.031,-0.461 -1.031,-1.031 v -0.563 c 0,-0.569 0.461,-1.031 1.031,-1.031 h 0.563 c 0.569,0 1.031,0.461 1.031,1.031 v 0.563 c -10e-4,0.57 -0.462,1.031 -1.031,1.031 z"
       id="path40" />
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const DZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 511.999 335.44901" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#73af00"
       d="M 255.999,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 H 256 v 335.448 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 255.999,0.001 h 247.172 c 4.875,0 8.828,3.953 8.828,8.828 v 317.792 c 0,4.875 -3.953,8.828 -8.828,8.828 H 255.999 Z"
       id="path2" />
    <g
       id="g4"
       transform="translate(0,-88.275)">
    	<path
       fill="#ff4b55"
       d="m 298.608,223.906 -15.305,20.021 -23.897,-7.999 c -1.336,-0.447 -2.473,1.064 -1.673,2.223 l 14.312,20.743 -14.993,20.256 c -0.839,1.132 0.247,2.68 1.598,2.277 l 24.15,-7.202 14.632,20.519 c 0.818,1.148 2.626,0.593 2.66,-0.815 l 0.613,-25.194 24.035,-7.575 c 1.344,-0.424 1.375,-2.314 0.046,-2.782 l -23.77,-8.369 0.223,-25.201 c 0.013,-1.408 -1.776,-2.021 -2.631,-0.902 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 271.866,316.629 c -33.459,0 -60.6,-27.141 -60.6,-60.63 0,-33.428 27.141,-60.63 60.6,-60.63 12.448,0 23.928,3.829 33.495,10.308 1.465,0.992 3.137,-0.932 1.91,-2.208 -14.298,-14.866 -34.535,-23.934 -56.971,-23.168 -38.548,1.315 -70.459,32.222 -72.922,70.713 -2.822,44.089 32.089,80.728 75.554,80.728 21.41,0 40.652,-8.951 54.393,-23.262 1.214,-1.265 -0.462,-3.16 -1.912,-2.177 -9.578,6.493 -21.077,10.326 -33.547,10.326 z"
       id="path4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const EC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs51" />
    <path
       fill="#ff4b55"
       d="M 512,251.587 H 0 v 75.034 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path2" />
    <rect
       y="167.72501"
       fill="#41479b"
       width="512"
       height="83.860001"
       id="rect2"
       x="0" />
    <path
       fill="#ffe15a"
       d="m 246.788,172.678 64.48,-55.268 v 79.987 c 0,13.481 -10.929,24.408 -24.408,24.408 v 0 c -6.03,0 -11.847,-2.232 -16.329,-6.265 l -23.743,-21.368 z"
       id="path3" />
    <path
       fill="#ff4b55"
       d="m 280.801,204.129 -18.66,-16.794 V 159.52 l 33.775,-28.95 v 20.221 46.607 c 0,4.993 -4.063,9.056 -9.056,9.056 -2.241,0 -4.393,-0.826 -6.059,-2.325 z"
       id="path4" />
    <path
       fill="#41479b"
       d="m 271.352,151.625 v 31.617 l 15.352,13.862 v -46.505 -12.132 l 9.212,-7.896 v 20.221 46.607 c 0,4.993 -4.063,9.056 -9.056,9.056 -2.241,0 -4.393,-0.825 -6.059,-2.325 l -18.66,-16.794 v -27.815 z"
       id="path5" />
    <path
       fill="#ffe15a"
       d="m 265.212,172.678 -64.48,-55.268 v 79.987 c 0,13.481 10.929,24.408 24.408,24.408 v 0 c 6.03,0 11.847,-2.232 16.329,-6.265 l 23.743,-21.368 z"
       id="path6" />
    <path
       fill="#ff4b55"
       d="m 231.199,204.129 18.66,-16.794 V 159.52 l -33.775,-28.95 v 20.221 46.607 c 0,4.993 4.063,9.056 9.056,9.056 2.241,0 4.393,-0.826 6.059,-2.325 z"
       id="path7" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 240.648,239.901 v 31.617 l -15.352,13.862 v -46.505 -12.132 l -9.212,-7.896 v 20.221 46.607 c 0,4.993 4.063,9.056 9.056,9.056 2.241,0 4.393,-0.825 6.059,-2.325 l 18.66,-16.794 v -27.815 z"
       id="path8" />
    	<rect
       x="309.04001"
       y="205.961"
       fill="#41479b"
       width="4.414"
       height="26.448999"
       id="rect8" />
    	<rect
       x="198.50999"
       y="205.961"
       fill="#41479b"
       width="4.414"
       height="26.448999"
       id="rect9" />
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    	<path
       fill="#5a4646"
       d="m 246.788,193.405 c 0,0 6.141,-29.17 -15.352,-25.332 -21.493,3.838 -21.493,9.978 -46.057,22.261 0,0 27.634,6.141 39.916,3.071 0,0 9.212,12.281 18.423,15.352 h 9.212 z"
       id="path9" />
    	<path
       fill="#5a4646"
       d="m 265.212,193.405 c 0,0 -6.141,-29.17 15.352,-25.332 21.493,3.838 21.493,9.978 46.057,22.261 0,0 -27.634,6.141 -39.916,3.071 0,0 -9.212,12.281 -18.423,15.352 h -9.212 z"
       id="path10" />
    	<path
       fill="#5a4646"
       d="m 265.212,208.757 h -18.423 v -15.466 c 0,-5.025 4.073,-9.098 9.098,-9.098 h 0.227 c 5.025,0 9.098,4.073 9.098,9.098 z"
       id="path11" />
    </g>
    <circle
       fill="#e6e1cd"
       cx="256"
       cy="105.125"
       r="6.1409998"
       id="circle11" />
    <path
       fill="#ffd0af"
       d="m 242.823,101.163 11.546,6.166 c 0.969,0.518 2.162,0.34 2.937,-0.437 v 0 c 0.974,-0.974 0.974,-2.552 0,-3.527 l -7.448,-7.448 h -1.791 c -2.896,0 -5.244,2.348 -5.244,5.246 z"
       id="path12" />
    <path
       fill="#ffaf94"
       d="m 246.827,102.058 h -9.249 l 4.047,-4.738 c 0.76,-0.889 1.871,-1.402 3.042,-1.402 h 5.192 v 3.108 c 0,1.674 -1.358,3.032 -3.032,3.032 z"
       id="path13" />
    <g
       id="g15"
       transform="translate(0,-88.276)">
    	<path
       fill="#8cb400"
       d="m 282.186,208.765 c -2.072,-2.458 -2.514,-5.717 -1.504,-8.541 2.954,-0.516 6.091,0.471 8.162,2.931 1.77,2.101 2.283,4.772 1.784,7.272 0.614,1.042 1.364,2.382 2.189,3.964 0.041,-0.225 0.032,-0.448 0.096,-0.673 0.724,-2.546 2.743,-4.348 5.135,-4.958 1.713,1.778 2.483,4.373 1.759,6.918 -0.622,2.19 -2.228,3.777 -4.18,4.581 0.771,1.769 1.534,3.677 2.247,5.69 0.041,-0.118 0.044,-0.238 0.092,-0.355 1,-2.451 3.206,-4.019 5.65,-4.362 1.506,1.955 1.986,4.619 0.987,7.07 -0.875,2.144 -2.69,3.558 -4.764,4.121 1.068,4.213 1.775,8.683 1.775,13.183 h -3.071 c 0,-3.922 -0.602,-7.85 -1.511,-11.608 -1.895,0.612 -4.012,0.481 -5.845,-0.641 -2.236,-1.37 -3.416,-3.778 -3.361,-6.223 2.154,-1.16 4.835,-1.203 7.071,0.168 0.081,0.049 0.135,0.121 0.213,0.173 -0.658,-1.89 -1.358,-3.683 -2.077,-5.365 -1.843,0.871 -4.012,1.005 -6.002,0.071 -2.374,-1.116 -3.811,-3.379 -4.026,-5.815 2.006,-1.386 4.657,-1.721 7.023,-0.62 -0.845,-1.625 -1.608,-2.986 -2.206,-4.002 -2.115,-0.244 -4.152,-1.218 -5.636,-2.979 z"
       id="path14" />
    	<path
       fill="#8cb400"
       d="m 229.814,208.765 c 2.072,-2.458 2.514,-5.717 1.504,-8.541 -2.954,-0.516 -6.091,0.471 -8.162,2.931 -1.77,2.101 -2.283,4.772 -1.784,7.272 -0.614,1.042 -1.364,2.382 -2.189,3.964 -0.041,-0.225 -0.032,-0.448 -0.096,-0.673 -0.724,-2.546 -2.743,-4.348 -5.135,-4.958 -1.713,1.778 -2.483,4.373 -1.759,6.918 0.622,2.19 2.228,3.777 4.18,4.581 -0.771,1.769 -1.534,3.677 -2.247,5.69 -0.041,-0.118 -0.044,-0.238 -0.092,-0.355 -1,-2.451 -3.206,-4.019 -5.65,-4.362 -1.506,1.955 -1.986,4.619 -0.986,7.07 0.875,2.144 2.69,3.558 4.764,4.121 -1.068,4.213 -1.775,8.683 -1.775,13.183 h 3.071 c 0,-3.922 0.602,-7.85 1.511,-11.608 1.895,0.612 4.012,0.481 5.845,-0.641 2.237,-1.37 3.416,-3.778 3.361,-6.223 -2.154,-1.16 -4.835,-1.203 -7.071,0.168 -0.081,0.049 -0.135,0.121 -0.213,0.173 0.658,-1.89 1.358,-3.683 2.077,-5.365 1.843,0.871 4.012,1.005 6.002,0.071 2.374,-1.116 3.811,-3.379 4.026,-5.815 -2.006,-1.386 -4.657,-1.721 -7.023,-0.62 0.845,-1.625 1.608,-2.986 2.206,-4.002 2.114,-0.244 4.151,-1.218 5.635,-2.979 z"
       id="path15" />
    </g>
    <path
       fill="#ffe15a"
       d="m 256,188.031 -64.48,-55.268 v 79.987 c 0,13.481 10.929,24.408 24.408,24.408 v 0 c 6.03,0 11.847,-2.232 16.329,-6.265 L 256,209.525 Z"
       id="path16" />
    <path
       fill="#ff4b55"
       d="m 221.987,219.481 18.66,-16.794 v -27.815 l -33.775,-28.95 v 20.221 46.607 c 0,4.993 4.063,9.056 9.056,9.056 2.242,0 4.393,-0.825 6.059,-2.325 z"
       id="path17" />
    <path
       fill="#41479b"
       d="m 231.436,166.977 v 31.617 l -15.352,13.862 v -46.505 -12.132 l -9.212,-7.896 v 20.221 46.607 c 0,4.993 4.063,9.056 9.056,9.056 2.241,0 4.393,-0.825 6.059,-2.325 l 18.66,-16.794 v -27.815 z"
       id="path18" />
    <path
       fill="#ffe15a"
       d="m 256,188.031 64.48,-55.268 v 79.987 c 0,13.481 -10.929,24.408 -24.408,24.408 v 0 c -6.03,0 -11.847,-2.232 -16.329,-6.265 L 256,209.525 Z"
       id="path19" />
    <path
       fill="#ff4b55"
       d="m 290.013,219.481 -18.66,-16.794 v -27.815 l 33.775,-28.95 v 20.221 46.607 c 0,4.993 -4.063,9.056 -9.056,9.056 -2.243,0 -4.393,-0.825 -6.059,-2.325 z"
       id="path20" />
    <path
       fill="#41479b"
       d="m 280.564,166.977 v 31.617 l 15.352,13.862 v -46.505 -12.132 l 9.212,-7.896 v 20.221 46.607 c 0,4.993 -4.063,9.056 -9.056,9.056 -2.241,0 -4.393,-0.825 -6.059,-2.325 l -18.66,-16.794 v -27.815 z"
       id="path21" />
    <ellipse
       fill="#69c3ff"
       cx="256"
       cy="166.535"
       rx="30.705"
       ry="46.060001"
       id="ellipse21" />
    <path
       fill="#009b64"
       d="m 228.366,178.82 h 55.268 l 3.071,-12.281 -13.993,2.333 c -2.807,0.468 -5.678,-0.332 -7.839,-2.184 l -15.884,-13.615 c -1.419,-1.217 -3.228,-1.886 -5.097,-1.886 v 0 c -2.077,0 -4.07,0.825 -5.538,2.294 l -9.988,9.988 z"
       id="path22" />
    <path
       fill="#f5f5f5"
       d="m 253.087,164.475 5.274,-3.37 -9.374,-8.034 c -1.419,-1.217 -3.228,-1.886 -5.097,-1.886 v 0 c -2.077,0 -4.07,0.825 -5.538,2.294 l -9.988,9.988 v 3.071 l 15.352,-3.071 2.714,1.357 c 2.128,1.064 4.655,0.93 6.657,-0.349 z"
       id="path23" />
    <polygon
       fill="#5aa0e6"
       points="246.788,300.871 256,300.871 268.281,297.801 280.564,285.518 283.634,267.096 228.366,267.096 231.436,285.518 "
       id="polygon23"
       transform="translate(0,-88.276)" />
    <path
       fill="#ffc88c"
       d="m 256,215.665 c -18.624,0 -33.775,-22.039 -33.775,-49.128 0,-27.089 15.151,-49.128 33.775,-49.128 18.624,0 33.775,22.039 33.775,49.128 0,27.089 -15.151,49.128 -33.775,49.128 z m 0,-92.113 c -15.236,0 -27.634,19.284 -27.634,42.987 0,23.703 12.397,42.987 27.634,42.987 15.237,0 27.634,-19.284 27.634,-42.987 0,-23.703 -12.398,-42.987 -27.634,-42.987 z"
       id="path24" />
    <g
       id="g26"
       transform="translate(0,-88.276)">
    	<path
       fill="#e1e1e1"
       d="m 234.339,300.595 c -2.574,-3.554 -6.406,-5.865 -10.746,-5.865 -4.34,0 -8.172,2.311 -10.746,5.865 4.39,1.217 7.982,4.781 9.683,9.479 0.685,1.892 1.064,3.968 1.064,6.15 -0.001,-7.596 4.588,-13.922 10.745,-15.629 z"
       id="path25" />
    	<path
       fill="#e1e1e1"
       d="m 226.031,310.282 c 0,0 -0.239,4.094 -2.339,6.013 l -0.088,-0.072 c -2.099,-1.919 -2.339,-6.013 -2.339,-6.013 z"
       id="path26" />
    </g>
    <path
       fill="#966446"
       d="m 294.4,223.341 h -76.8 c -0.838,0 -1.516,-0.679 -1.516,-1.516 v -0.038 c 0,-0.838 0.679,-1.516 1.516,-1.516 h 76.8 c 0.838,0 1.516,0.679 1.516,1.516 v 0.038 c 0,0.837 -0.678,1.516 -1.516,1.516 z"
       id="path27" />
    <path
       fill="#be915a"
       d="m 271.428,227.947 h -30.856 c -3.35,0 -6.066,-2.716 -6.066,-6.066 v -0.151 c 0,-3.35 2.716,-6.066 6.066,-6.066 h 30.856 c 3.35,0 6.066,2.716 6.066,6.066 v 0.151 c -0.001,3.35 -2.717,6.066 -6.066,6.066 z"
       id="path28" />
    <path
       fill="#b9b9b9"
       d="M 228.366,220.271 H 217.62 c -0.847,0 -1.535,0.687 -1.535,1.535 0,0.848 0.687,1.535 1.535,1.535 h 10.746 z"
       id="path29" />
    <polygon
       fill="#ff4b55"
       points="243.719,340.787 249.859,316.223 256,316.223 256,344.277 "
       id="polygon29"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#41479b"
       points="234.507,334.646 243.719,316.223 252.929,316.223 246.788,337.717 "
       id="polygon30"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="240.648,331.575 246.788,316.223 240.648,316.223 231.436,328.505 "
       id="polygon31"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ff4b55"
       points="268.281,340.787 262.141,316.223 256,316.223 256,344.277 "
       id="polygon32"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#41479b"
       points="277.493,334.646 268.281,316.223 259.071,316.223 265.212,337.717 "
       id="polygon33"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="271.352,331.575 265.212,316.223 271.352,316.223 280.564,328.505 "
       id="polygon34"
       transform="translate(0,-88.276)" />
    <g
       id="g36"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#41479b"
       points="189.314,221.036 193.728,221.036 193.728,247.483 189.314,243.035 "
       id="polygon35" />
    	<polygon
       fill="#41479b"
       points="318.232,221.036 322.646,221.036 322.646,243.035 318.232,247.483 "
       id="polygon36" />
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const EE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#4173cd"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#464655"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const EG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#464655"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#f0c727"
       d="m 284.186,150.295 c 0,-4.377 -4.289,-7.469 -8.441,-6.084 l -7.804,2.601 -1.895,-11.444 c -1.133,-6.826 -6.983,-11.78 -13.906,-11.78 h -7.299 l -7.634,9.396 h 10.109 l -2.829,13.972 -8.233,-2.744 c -4.153,-1.385 -8.441,1.707 -8.441,6.084 v 47.475 l 11.363,-11.363 -5.354,16.061 h -6.008 v 9.396 h 56.373 v -9.396 h -6.008 l -5.354,-16.061 11.363,11.363 v -47.476 z m -32.883,52.172 h -7.574 l 5.208,-13.909 2.366,3.021 z m 9.394,0 v -10.888 l 2.366,-3.021 5.208,13.909 z M 256,185.438 c 0,0 -14.534,-9.836 -13.946,-28.186 0,0 8.956,-1.468 13.946,-9.396 4.991,7.927 13.947,9.396 13.947,9.396 C 270.534,175.603 256,185.438 256,185.438 Z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const EH = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs20" />
    <path
       fill="#464655"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="M 3.256,421.591 206.097,260.576 c 2.946,-2.338 2.946,-6.812 0,-9.151 L 3.256,90.411 C 1.311,92.03 0,94.376 0,97.104 v 317.793 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 264.957,256.001 c 0,-20.136 13.151,-37.194 31.33,-43.068 1.045,-0.338 0.908,-1.867 -0.184,-1.974 -3.49,-0.343 -7.096,-0.289 -10.778,0.227 -21.354,2.997 -37.828,21.055 -38.858,42.593 -1.242,26.005 19.474,47.48 45.206,47.48 1.489,0 2.959,-0.074 4.41,-0.215 1.097,-0.107 1.24,-1.641 0.191,-1.98 -18.172,-5.878 -31.317,-22.933 -31.317,-43.063 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="m 303.384,226.265 -5.946,17.83 -18.795,0.146 c -2.433,0.019 -3.443,3.124 -1.485,4.569 l 15.119,11.165 -5.67,17.92 c -0.734,2.321 1.908,4.239 3.887,2.824 l 15.29,-10.93 15.29,10.93 c 1.98,1.415 4.621,-0.504 3.887,-2.824 l -5.67,-17.92 15.119,-11.165 c 1.958,-1.446 0.949,-4.551 -1.485,-4.569 l -18.795,-0.146 -5.946,-17.83 c -0.764,-2.308 -4.029,-2.308 -4.8,0 z"
       id="path5" />
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const ER = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#73af00"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#4173cd"
       d="m 0,167.725 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.45 0,331.497 0,326.622 Z"
       id="path2" />
    <path
       fill="#ff4b55"
       d="m 0,8.828 v 317.793 c 0,3.192 1.784,5.863 4.321,7.412 L 512,167.725 4.321,1.417 C 1.783,2.967 0,5.636 0,8.828 Z"
       id="path3" />
    <path
       fill="#ffe15a"
       d="m 188.808,218.116 c 0,0 24.862,-9.067 31.882,-36.269 0,0 -10.823,14.04 -18.428,18.135 0,0 16.672,-22.23 13.162,-43.874 0,0 -2.048,8.775 -6.143,12.285 0,0 7.313,-31.297 -2.048,-44.459 0,0 0.292,11.115 -3.802,22.23 0,0 1.56,-35.198 -14.43,-44.167 0,0 6.24,11.115 3.607,20.474 0,0 -4.387,-19.89 -24.765,-27.787 0,0 -1.268,1.462 -0.975,5.85 0,0 -5.557,-6.728 -19.305,-6.435 0,0 0.292,4.972 3.802,9.652 0,0 -5.557,2.925 -9.067,2.048 0,0 5.557,6.143 25.154,5.557 0,0 -2.633,2.34 -7.897,2.925 0,0 8.006,3.677 15.892,4.387 10.823,0.974 15.113,7.313 17.16,15.21 0,0 -8.482,-4.972 -11.7,-9.945 0,0 -0.585,8.482 15.502,24.862 l -8.19,-3.51 c 0,0 5.265,15.21 11.7,32.467 l -6.728,-7.313 c 0,0 -1.462,12.285 -2.633,35.1 l -4.68,-10.823 c 0,0 -8.19,26.91 -20.767,31.297 -9.846,3.435 -20.736,5.786 -25.015,6.649 -0.401,-15.055 6.003,-18.349 6.003,-18.349 11.407,0.585 14.04,-11.992 14.04,-11.992 -2.34,2.34 -6.728,2.34 -6.728,2.34 6.728,-7.02 6.728,-16.964 6.728,-16.964 -4.095,7.897 -10.53,9.067 -10.53,9.067 l 0.585,-7.897 c -11.897,8.652 -11.048,18.785 -10.851,20.27 -0.268,-1.894 -2.387,-16.713 -3.481,-20.27 -1.17,-3.802 1.462,-11.407 5.557,-10.238 13.255,3.787 16.38,-5.849 16.38,-5.849 -7.02,3.218 -11.115,0.877 -11.115,0.877 9.067,-8.775 5.265,-16.964 5.265,-16.964 -2.925,8.482 -11.115,9.945 -11.115,9.945 l -0.292,-9.359 c -3.802,2.048 -7.313,11.115 -7.313,11.115 0,0 -0.877,-7.313 1.754,-13.748 2.633,-6.435 9.359,-3.218 9.359,-3.218 11.992,2.34 15.795,-9.067 15.795,-9.067 l -7.897,1.17 c 8.775,-6.435 6.143,-14.333 6.143,-14.333 -2.048,4.972 -9.359,5.85 -9.359,5.85 l 3.51,-9.359 c -7.605,0 -11.992,9.945 -11.992,9.945 l -0.585,-9.652 c 3.51,-12.577 -4.68,-18.135 -4.68,-18.135 -1.754,2.34 -0.877,7.313 -0.877,7.313 -7.313,-6.435 -12.87,1.17 -12.87,1.17 5.557,5.85 10.823,5.265 10.823,5.265 -1.754,1.17 -8.19,1.754 -8.19,1.754 7.313,6.143 11.407,4.972 11.407,4.972 3.51,14.918 -5.85,21.645 -5.85,21.645 -1.754,-11.115 -8.482,-16.38 -8.482,-16.38 l 0.292,7.313 c -4.387,-2.633 -7.897,-10.53 -7.897,-10.53 -2.925,11.115 4.972,20.767 4.972,20.767 l -7.313,-0.585 c 6.435,14.918 16.672,10.238 16.672,10.238 -0.877,10.53 2.633,27.787 2.633,27.787 -1.462,-1.754 -16.964,-16.38 -16.964,-16.38 -0.585,5.849 4.972,13.454 4.972,13.454 -2.925,-0.585 -11.407,-7.02 -11.407,-7.02 0.877,9.359 13.162,15.502 13.162,15.502 -4.68,0.585 -13.748,-4.68 -13.748,-4.68 5.265,22.522 24.569,12.577 24.569,12.577 l 1.481,30.464 c -4.078,-0.979 -12.995,-3.252 -22.248,-6.479 -12.577,-4.387 -20.767,-31.297 -20.767,-31.297 l -4.68,10.823 c -1.17,-22.815 -2.633,-35.1 -2.633,-35.1 l -6.728,7.313 c 6.435,-17.257 11.7,-32.467 11.7,-32.467 l -8.19,3.51 c 16.093,-16.382 15.507,-24.864 15.507,-24.864 -3.218,4.972 -11.7,9.945 -11.7,9.945 2.048,-7.897 8.482,-16.087 16.38,-16.672 7.898,-0.585 16.672,-2.925 16.672,-2.925 -5.265,-0.585 -7.897,-2.925 -7.897,-2.925 22.815,-2.048 25.154,-8.19 25.154,-8.19 -3.51,0.877 -14.333,-0.292 -14.333,-0.292 9.067,-4.972 23.985,-9.652 23.985,-9.652 -18.428,-3.218 -34.222,7.313 -34.222,7.313 2.633,-4.972 7.313,-10.53 7.313,-10.53 -22.522,9.945 -33.053,32.467 -33.053,32.467 -2.633,-9.359 3.607,-20.475 3.607,-20.475 -15.99,8.97 -14.43,44.167 -14.43,44.167 -4.095,-11.115 -3.802,-22.23 -3.802,-22.23 -9.359,13.162 -2.048,44.459 -2.048,44.459 -4.095,-3.51 -6.143,-12.285 -6.143,-12.285 -3.51,21.645 13.162,43.874 13.162,43.874 -7.605,-4.095 -18.428,-18.135 -18.428,-18.135 7.02,27.202 31.882,36.269 31.882,36.269 -13.748,-5.265 -19.597,-0.877 -19.597,-0.877 9.652,2.048 19.012,7.897 26.617,13.454 7.605,5.557 17.843,6.728 26.91,7.897 3.746,0.483 6.85,1.113 9.254,1.689 -4.956,2.425 -8.376,7.502 -8.376,13.391 h 29.835 c 0,-5.667 -3.16,-10.596 -7.815,-13.121 2.996,-0.641 6.987,-1.4 11.325,-1.96 9.067,-1.17 18.54,-3.577 26.91,-7.897 9.067,-4.68 16.964,-11.407 26.617,-13.454 0.003,0.002 -5.848,-4.384 -19.594,0.879 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const ES = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs44" />
    <path
       fill="#c8414b"
       d="m 8.828,335.449 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 512.001,3.953 508.048,0 503.173,0 H 8.828 C 3.953,0.001 0,3.953 0,8.828 v 317.793 c 0,4.876 3.953,8.828 8.828,8.828 z"
       id="path1" />
    <rect
       y="70.625"
       fill="#ffd250"
       width="512"
       height="194.21001"
       id="rect1"
       x="0" />
    <path
       fill="#c8414b"
       d="m 216.276,167.725 7.485,-33.681 C 224.451,130.942 222.09,128 218.912,128 h -5.272 c -3.177,0 -5.537,2.942 -4.849,6.044 z"
       id="path2" />
    <rect
       x="207.45"
       y="150.065"
       fill="#f5f5f5"
       width="17.655001"
       height="75.029999"
       id="rect2" />
    <rect
       x="203.03"
       y="141.245"
       fill="#fab446"
       width="26.483"
       height="8.8280001"
       id="rect3" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<rect
       x="185.38"
       y="256.00101"
       fill="#c8414b"
       width="44.139999"
       height="8.8280001"
       id="rect4" />
    	<polygon
       fill="#c8414b"
       points="203.034,273.656 229.517,282.484 229.517,291.311 203.034,282.484 "
       id="polygon4" />
    	<path
       fill="#c8414b"
       d="m 83.862,256.001 7.485,-33.681 c 0.69,-3.102 -1.671,-6.044 -4.849,-6.044 h -5.272 c -3.177,0 -5.537,2.942 -4.849,6.044 z"
       id="path4" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 114.759,141.242 c -4.875,0 -8.828,3.953 -8.828,8.828 v 57.379 c 0,10.725 10.01,30.897 44.138,30.897 34.128,0 44.138,-20.171 44.138,-30.897 V 150.07 c 0,-4.875 -3.953,-8.828 -8.828,-8.828 z"
       id="path5" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#c8414b"
       d="m 150.069,273.656 h -44.138 v -35.31 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 35.31 z"
       id="path6" />
    	<path
       fill="#c8414b"
       d="m 150.069,273.656 h 44.138 v 22.069 c 0,12.189 -9.88,22.069 -22.069,22.069 v 0 c -12.189,0 -22.069,-9.88 -22.069,-22.069 z"
       id="path7" />
    </g>
    <path
       fill="#fab446"
       d="m 105.931,185.38 h 44.138 v 22.069 c 0,12.189 -9.88,22.069 -22.069,22.069 v 0 c -12.189,0 -22.069,-9.88 -22.069,-22.069 z"
       id="path8" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    	<path
       fill="#c8414b"
       d="m 141.241,313.281 v -39.625 h -8.828 v 43.693 c 3.284,-0.666 6.251,-2.12 8.828,-4.068 z"
       id="path9" />
    	<path
       fill="#c8414b"
       d="m 123.586,317.349 v -43.693 h -8.828 v 39.625 c 2.578,1.948 5.545,3.402 8.828,4.068 z"
       id="path10" />
    </g>
    <rect
       x="114.76"
       y="167.72501"
       fill="#ffb441"
       width="26.483"
       height="8.8280001"
       id="rect10" />
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<rect
       x="114.76"
       y="238.341"
       fill="#fab446"
       width="26.483"
       height="8.8280001"
       id="rect11" />
    	<rect
       x="119.17"
       y="243.591"
       fill="#fab446"
       width="17.655001"
       height="15.992"
       id="rect12" />
    </g>
    <rect
       x="75.029999"
       y="150.065"
       fill="#f5f5f5"
       width="17.655001"
       height="75.029999"
       id="rect13" />
    <g
       id="g15"
       transform="translate(0,-88.276)">
    	<rect
       x="70.620003"
       y="308.97101"
       fill="#fab446"
       width="26.483"
       height="8.8280001"
       id="rect14" />
    	<rect
       x="70.620003"
       y="229.521"
       fill="#fab446"
       width="26.483"
       height="8.8280001"
       id="rect15" />
    </g>
    <rect
       x="66.209999"
       y="229.51498"
       fill="#5064aa"
       width="35.310001"
       height="8.8280001"
       id="rect16" />
    <rect
       x="207.45"
       y="220.69501"
       fill="#fab446"
       width="26.483"
       height="8.8280001"
       id="rect17" />
    <rect
       x="198.62"
       y="229.51498"
       fill="#5064aa"
       width="35.310001"
       height="8.8280001"
       id="rect18" />
    <rect
       x="123.59"
       y="132.41499"
       fill="#fab446"
       width="52.966"
       height="8.8280001"
       id="rect19" />
    <rect
       x="145.66"
       y="105.935"
       fill="#ffb441"
       width="8.8280001"
       height="26.483"
       id="rect20" />
    <g
       id="g23"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 141.241,207.449 c -7.302,0 -13.241,-5.94 -13.241,-13.241 0,-7.302 5.94,-13.241 13.241,-13.241 7.302,0 13.241,5.94 13.241,13.241 0.001,7.301 -5.939,13.241 -13.241,13.241 z m 0,-17.655 c -2.435,0 -4.414,1.978 -4.414,4.414 0,2.435 1.978,4.414 4.414,4.414 2.436,0 4.414,-1.978 4.414,-4.414 0,-2.435 -1.978,-4.414 -4.414,-4.414 z"
       id="path20" />
    	<path
       fill="#f5f5f5"
       d="m 158.897,207.449 c -7.302,0 -13.241,-5.94 -13.241,-13.241 0,-7.302 5.94,-13.241 13.241,-13.241 7.302,0 13.241,5.94 13.241,13.241 0,7.301 -5.94,13.241 -13.241,13.241 z m 0,-17.655 c -2.435,0 -4.414,1.978 -4.414,4.414 0,2.435 1.978,4.414 4.414,4.414 2.435,0 4.414,-1.978 4.414,-4.414 -0.001,-2.435 -1.979,-4.414 -4.414,-4.414 z"
       id="path21" />
    	<path
       fill="#f5f5f5"
       d="m 176.552,216.277 c -7.302,0 -13.241,-5.94 -13.241,-13.241 0,-7.302 5.94,-13.241 13.241,-13.241 7.302,0 13.241,5.94 13.241,13.241 0,7.301 -5.94,13.241 -13.241,13.241 z m 0,-17.655 c -2.435,0 -4.414,1.978 -4.414,4.414 0,2.435 1.978,4.414 4.414,4.414 2.435,0 4.414,-1.978 4.414,-4.414 0,-2.436 -1.979,-4.414 -4.414,-4.414 z"
       id="path22" />
    	<path
       fill="#f5f5f5"
       d="m 123.586,216.277 c -7.302,0 -13.241,-5.94 -13.241,-13.241 0,-7.302 5.94,-13.241 13.241,-13.241 7.302,0 13.241,5.94 13.241,13.241 0.001,7.301 -5.939,13.241 -13.241,13.241 z m 0,-17.655 c -2.435,0 -4.414,1.978 -4.414,4.414 0,2.435 1.978,4.414 4.414,4.414 2.436,0 4.414,-1.979 4.414,-4.415 0,-2.435 -1.978,-4.413 -4.414,-4.413 z"
       id="path23" />
    </g>
    <path
       fill="#fab446"
       d="m 176.552,203.035 v 4.414 c 0,2.434 -1.98,4.414 -4.414,4.414 -2.434,0 -4.414,-1.98 -4.414,-4.414 v -4.414 h 8.828 m 8.827,-8.827 h -26.483 v 13.241 c 0,7.302 5.94,13.241 13.241,13.241 7.302,0 13.241,-5.94 13.241,-13.241 v -13.241 z"
       id="path24" />
    <path
       fill="#ffa0d2"
       d="m 172.138,176.553 v 0 c -4.875,0 -8.828,-3.953 -8.828,-8.828 v -8.828 c 0,-4.875 3.953,-8.828 8.828,-8.828 v 0 c 4.875,0 8.828,3.953 8.828,8.828 v 8.828 c 0,4.875 -3.953,8.828 -8.828,8.828 z"
       id="path25" />
    <circle
       fill="#5064aa"
       cx="150.07001"
       cy="185.375"
       r="13.241"
       id="circle25" />
    <rect
       x="145.66"
       y="88.274994"
       fill="#fab446"
       width="8.8280001"
       height="26.483"
       id="rect25" />
    <path
       fill="#c8414b"
       d="m 123.586,132.415 -8.828,-8.828 5.171,-5.171 c 7.993,-7.993 18.835,-12.484 30.14,-12.484 v 0 c 11.305,0 22.146,4.491 30.14,12.484 l 5.171,5.171 -8.828,8.828 z"
       id="path26" />
    <g
       id="g28"
       transform="translate(0,-88.276)">
    	<circle
       fill="#ffd250"
       cx="150.07001"
       cy="211.86099"
       r="4.414"
       id="circle26" />
    	<circle
       fill="#ffd250"
       cx="132.41"
       cy="211.86099"
       r="4.414"
       id="circle27" />
    	<circle
       fill="#ffd250"
       cx="167.72"
       cy="211.86099"
       r="4.414"
       id="circle28" />
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    	<rect
       x="70.620003"
       y="256.00101"
       fill="#c8414b"
       width="44.139999"
       height="8.8280001"
       id="rect28" />
    	<polygon
       fill="#c8414b"
       points="97.103,273.656 70.621,282.484 70.621,291.311 97.103,282.484 "
       id="polygon28" />
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const ET = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs20" />
    <path
       fill="#73af00"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#ffe15a"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#4173cd"
       d="m 361.945,167.823 c 0,58.426 -47.435,105.945 -105.945,105.945 -58.51,0 -105.945,-47.519 -105.945,-105.945 0,-58.594 47.435,-106.029 105.945,-106.029 58.51,0 105.945,47.435 105.945,106.029 z"
       id="path3" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#f2dd30"
       d="m 175.42,229.464 h 61.556 l 13.929,-42.867 3.699,11.498 -20.228,62.316 -6.026,-4.396 6.301,-19.362 h -49.506 z m 30.756,94.785 19.025,-58.51 -36.462,-26.551 h 12.026 l 52.995,38.473 -6.024,4.396 -16.509,-12.007 -15.325,47.181 z m 99.646,0 -49.822,-36.187 -36.442,26.464 3.721,-11.329 52.952,-38.558 2.262,7.102 -16.468,11.923 40.057,29.172 z m 30.756,-94.785 -49.781,36.274 13.931,42.869 -9.724,-7.104 -20.209,-62.316 h 7.399 l 6.298,19.448 40.079,-29.172 h 12.006 v 0.001 z M 256,170.954 l 19.025,58.51 h 45.088 l -9.745,7.189 h -65.487 l 2.305,-7.189 h 20.418 l -15.325,-47.096 z"
       id="path4" />
    	<path
       fill="#f2dd30"
       d="m 257.775,340.823 h -3.53 v -45.912 h 3.53 z m 78.276,-56.991 -43.651,-14.12 1.1,-3.297 43.672,14.12 z m -160.123,0 -1.1,-3.297 43.692,-14.12 1.08,3.297 z m 104.361,-58.173 -2.877,-2.028 26.995,-37.12 2.812,2.03 z m -48.513,0 -27.038,-37.118 2.855,-2.03 26.973,37.12 z"
       id="path5" />
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const FI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs15" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#41479b"
       points="211.862,88.277 158.897,88.277 158.897,229.518 0,229.518 0,282.484 158.897,282.484 158.897,423.725 211.862,423.725 211.862,282.484 512,282.484 512,229.518 211.862,229.518 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const FJ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs50" />
    <path
       fill="#82afff"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 247.172,167.725 H 8.828 C 3.953,167.725 0,163.772 0,158.897 V 8.828 C 0,3.953 3.953,0 8.828,0 h 238.345 c 4.875,0 8.828,3.953 8.828,8.828 v 150.069 c -10e-4,4.875 -3.954,8.828 -8.829,8.828 z"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0.001 h -15.334 l -81.77,53.574 V 0.001 H 105.93 V 53.575 L 24.16,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.002 c 0,4.875 3.953,8.828 8.828,8.828 h 15.334 l 81.77,-53.574 v 53.574 h 44.138 v -53.574 l 81.769,53.574 h 15.334 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 L 185.846,105.932 H 256 V 61.794 H 185.845 L 256,15.831 V 8.829 c 0,-4.876 -3.953,-8.828 -8.828,-8.828 z"
       id="path3" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.277 114.759,88.277 114.759,158.898 0,158.898 0,185.38 114.759,185.38 114.759,256.001 141.241,256.001 141.241,185.38 256,185.38 256,158.898 141.241,158.898 "
       id="polygon3" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.07 4.207,89.769 C 1.735,91.333 0,93.962 0,97.104 v 0.458 l 80.889,52.508 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.07 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.208 1.269,251.464 c 1.521,2.662 4.273,4.537 7.559,4.537 h 1.665 l 95.196,-61.793 H 89.474 Z"
       id="path6" />
    	<path
       fill="#ff4b55"
       d="M 255.86,247.866 173.194,194.208 H 156.98 l 93.874,60.935 c 2.812,-1.305 4.741,-4.04 5.006,-7.277 z"
       id="path7" />
    </g>
    <path
       fill="#f5f5f5"
       d="M 322.034,96.342 V 193.2 c 0,39.281 55.178,59.469 61.902,61.782 6.717,-2.313 61.902,-22.534 61.902,-61.782 V 96.342 Z"
       id="path8" />
    <polygon
       fill="#ff4b55"
       points="319.849,182.433 319.849,229.042 375.197,229.042 375.197,272.737 319.849,272.737 319.849,290.216 375.197,290.216 375.197,342.649 383.936,345.562 392.674,342.649 392.674,290.216 448.022,290.216 448.022,272.737 392.674,272.737 392.674,229.042 448.022,229.042 448.022,182.433 "
       id="polygon8"
       transform="translate(0,-88.276)" />
    <circle
       fill="#f5f5f5"
       cx="334.22"
       cy="122.58499"
       r="7.2930002"
       id="circle8" />
    <g
       id="g11"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 348.231,201 c -2.334,-1.283 -6.535,-4.726 -8.226,-4.142 -1.692,0.584 -2.07,1.78 -4.437,1.962 -2.306,0.178 -5.948,2.428 -4.43,4.922 1.973,3.246 8.149,0.722 8.557,-0.796 0,0 1.517,0.243 2.792,-0.061 0,0 2.537,3.54 5.687,3.307 3.15,-0.234 4.609,-4.142 3.91,-4.142 -0.699,0 -3.853,-1.05 -3.853,-1.05 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="m 357.916,216.46 c -0.525,0.962 -4.522,4.38 -11.202,5.951 -1.487,0.35 -1.225,2.1 -2.713,1.225 -1.487,-0.875 -5.601,-1.576 -9.277,-1.75 -3.676,-0.175 -4.041,-3.581 -3.413,-4.813 0.797,-1.565 6.665,-2.519 7.715,-0.594 1.05,1.926 1.837,1.524 4.45,2.081 1.619,0.346 1.663,1.138 1.663,1.138 0,0 2.976,-2.976 5.514,-3.851 2.538,-0.875 4.726,-2.801 5.163,-2.801 0.438,0 2.713,0.612 2.713,0.612 z"
       id="path10" />
    	<path
       fill="#ffe15a"
       d="m 367.63,206.133 c 3.851,1.4 15.228,0.962 27.392,-2.976 12.164,-3.938 15.666,-4.638 21.617,-2.451 5.951,2.187 8.527,-4.725 4.619,-5.894 -6.138,-1.837 -25.124,9.194 -38.871,3.004 0,0 -0.405,1.665 0.032,2.452 0,0 -9.976,0.35 -7.614,-9.976 0,0 0.68,3.77 5.397,3.337 8.921,-0.819 10.196,5.462 29.085,-0.362 10.487,-3.233 18.635,-1.646 18.707,3.456 0.087,6.143 -8.381,7.571 -8.381,7.571 0,0 3.296,6.739 9.948,3.763 6.652,-2.976 7.001,2.158 7.585,3.91 0.584,1.751 1.692,3.443 3.15,3.617 0,0 1.05,3.15 0.642,3.559 -0.408,0.408 -3.15,3.851 -5.892,3.851 -2.742,0 -8.693,0 -8.693,0 0,0 -1.576,-3.91 1.459,-3.967 3.033,-0.058 6.71,-0.291 6.243,-1.926 -0.467,-1.633 -2.859,-2.392 -2.801,-4.201 0,0 -7.06,5.134 -11.435,-0.934 l -0.117,2.859 c 0,0 -5.31,-0.992 -7.234,-5.251 0,0 0.525,4.785 -4.025,4.084 0,0 0.934,1.4 2.509,2.392 1.576,0.992 -0.059,3.15 -3.092,4.959 -3.033,1.809 -12.369,7.06 -16.628,1.692 -4.259,-5.367 0.934,-8.46 2.217,-8.11 1.283,0.35 4.959,6.009 7.468,5.251 2.509,-0.758 3.734,-3.326 1.633,-4.9 -2.101,-1.574 -3.673,-3.064 -2.349,-4.654 1.821,-2.185 8.534,-1.53 8.3,-2.988 -0.233,-1.459 -6.476,-1.05 -10.56,3.033 -4.084,4.084 -21.821,13.478 -28.881,7.527 -7.059,-5.951 -1.43,-11.727 -1.43,-11.727 z"
       id="path11" />
    </g>
    <path
       fill="#ffd25a"
       d="m 365.355,115.232 c 0,0 5.338,5.251 14.353,6.914 0,0 -1.663,2.538 -6.476,1.838 0,0 1.926,1.663 3.239,4.463 0,0 -3.063,0.7 -5.777,-0.788 0,0 0.35,2.275 1.663,4.114 0,0 -3.588,0 -6.652,-2.713 l -1.225,3.5 c 0,0 -2.1,-1.4 -3.413,-4.114 0,0 -2.451,1.926 -4.9,1.926 0,0 0.875,-2.625 0.875,-4.114 0,0 -3.5,2.1 -6.389,1.313 0,0 0.087,-3.676 1.05,-4.726 0,0 -2.275,0.263 -3.763,-0.525 0,0 0.875,-2.013 1.313,-3.326 0,0 -2.451,0.087 -3.938,-1.313 0,0 4.726,-1.838 5.777,-3.588 z"
       id="path12" />
    <path
       fill="#ffbe5a"
       d="m 356.749,100.529 c 1.05,0.584 2.742,1.867 3.443,4.025 0,0 1.926,-2.801 5.251,-3.326 0,0 1.459,1.633 1.05,5.892 0,0 3.676,-1.05 5.66,0.875 0,0 -3.91,0.875 -5.718,4.142 0,0 -0.702,3.338 0.524,5.322 0,0 -1.365,0.182 -2.741,-0.42 0,0 -0.7,3.326 0,4.376 0,0 -1.926,-0.234 -2.976,-2.275 0,0 -1.576,2.392 -1.459,3.851 0,0 -2.1,-1.225 -2.217,-3.033 0,0 -1.459,2.742 -3.033,2.976 0,0 -0.175,-3.851 -0.875,-5.31 0,0 -1.342,1.459 -3.092,1.4 0,0 0,-2.976 1.459,-4.376 0,0 -2.451,0.758 -3.793,-1.926 0,0 4.025,1.166 5.017,-1.283 0.992,-2.451 1.283,-3.209 2.684,-4.551 1.4,-1.341 0.816,-6.359 0.816,-6.359 z"
       id="path13" />
    <path
       fill="#ffe15a"
       d="m 365.355,111.819 c 0,0 -4.989,9.539 -9.539,6.652 -4.985,-3.165 1.225,-10.59 2.013,-11.377 -0.001,-10e-4 3.675,0.962 7.526,4.725 z"
       id="path14" />
    <path
       fill="#5abea0"
       d="m 347.363,160.677 c 0,0 -0.523,-6.851 -4.237,-8.828 -3.492,-1.858 -5.555,-2.787 -5.955,-5.169 0,0 3.034,1.394 6.241,2.265 2.898,0.787 5.726,5.692 4.867,11.209 z"
       id="path15" />
    <path
       fill="#b46446"
       d="m 335.639,166.31 0.472,0.871 0.343,1.873 -0.687,2.221 c 0,0 2.729,1.085 3.35,4.791 0.426,2.543 1.546,3.093 2.233,2.57 0.687,-0.523 1.103,-1.141 0.386,-3.921 -0.916,-3.549 -3.393,-6.925 -3.393,-6.925 l -1.932,-2.962 z"
       id="path16" />
    <g
       id="g20"
       transform="translate(0,-88.276)">
    	<path
       fill="#5abea0"
       d="m 338.345,256.067 c -2.49,-3.223 -9.277,-9.931 -10.564,-0.785 0,0 -2.66,-7.706 2.319,-7.405 5.754,0.35 8.245,8.19 8.245,8.19 z"
       id="path17" />
    	<path
       fill="#5abea0"
       d="m 336.111,255.458 c -2.147,-2.353 -2.835,-4.095 -3.951,-8.45 -1.117,-4.355 -1.46,-5.663 -2.749,-5.576 -1.289,0.087 -2.061,1.481 -2.061,4.268 0,0 -3.779,-3.398 -1.203,-6.098 2.577,-2.7 8.331,-1.219 8.675,3.572 0.343,4.791 0.258,8.014 1.975,12.022 z"
       id="path18" />
    	<path
       fill="#5abea0"
       d="m 336.713,253.367 c 0,0 -4.552,-10.018 8.246,-15.42 0,0 -11.338,-3.049 -9.963,13.067 z"
       id="path19" />
    	<path
       fill="#5abea0"
       d="m 338.174,256.939 c 0,0 -9.62,-3.659 -8.761,5.227 0,0 1.632,-4.182 6.356,-2.613 z"
       id="path20" />
    </g>
    <path
       fill="#b46446"
       d="m 349.081,165.148 c 0,2.599 1.022,10.14 -0.429,11.093 -0.73,0.479 -2.792,0.087 -2.62,-1.742 0.172,-1.829 0.988,-10.716 0.988,-12.893 0,-2.178 2.061,3.542 2.061,3.542 z"
       id="path21" />
    <g
       id="g24"
       transform="translate(0,-88.276)">
    	<path
       fill="#5abea0"
       d="m 342.955,259.465 c 1.661,-1.684 2.176,-5.517 1.603,-10.628 0,0 3.436,2.381 4.524,4.588 0,0 1.088,-5.053 -2.462,-6.389 -3.55,-1.336 -5.44,-0.58 -6.07,1.045 -0.63,1.626 1.085,3.445 1.833,6.098 0.686,2.44 0.572,5.286 0.572,5.286 z"
       id="path22" />
    	<path
       fill="#5abea0"
       d="m 348.853,252.089 c 0,0 0.573,-2.671 2.462,-3.775 0,0 3.894,2.73 3.607,6.389 0,0 1.031,-4.994 -1.088,-6.969 -2.119,-1.974 -4.524,-2.497 -5.726,-0.755 -1.203,1.741 0.745,5.11 0.745,5.11 z"
       id="path23" />
    	<path
       fill="#5abea0"
       d="m 349.769,246.978 c 0,0 1.203,-7.144 4.237,-8.712 3.034,-1.568 8.647,-3.02 8.99,-3.369 0,0 -6.699,0.349 -7.787,0.349 -1.088,0 -7.101,4.355 -7.101,10.803 0,6.446 0.573,2.033 0.745,1.974 0.171,-0.057 0.916,-1.045 0.916,-1.045 z"
       id="path24" />
    </g>
    <path
       fill="#b46446"
       d="m 352.561,177.592 c 0.687,1.438 2.319,1.785 2.663,1.045 0.343,-0.74 1.889,-6.403 1.889,-6.403 l -2.19,-1.045 z"
       id="path25" />
    <path
       fill="#5abea0"
       d="m 365.401,153.824 c 2.691,-1.568 4.467,3.079 4.467,3.079 0,-5.471 -1.718,-7.201 -6.013,-5.111 -1.293,0.63 -2.24,1.949 -2.936,3.479 -2.174,-6.247 -6.969,-6.151 -6.969,-6.151 l -1.088,0.755 c 3.926,0.755 6.175,5.46 7.126,8.026 -0.513,1.873 -0.761,3.689 -0.867,4.728 -2.573,2.667 -4.198,8.559 -4.198,8.559 0,0 1.847,1.089 2.19,1.045 0,0 1.203,-3.702 2.706,-3.615 1.503,0.087 3.264,2.483 3.307,4.008 0,0 2.233,-4.53 -0.429,-6.272 -1,-0.654 -1.8,-0.903 -2.446,-0.915 l 1.974,-2.221 c 3.221,0.61 5.454,3.659 5.454,3.659 0.065,-5.444 -2.339,-6.507 -4.874,-6.051 0.453,-2.192 1.45,-6.334 2.596,-7.002 z"
       id="path26" />
    <path
       fill="#b46446"
       d="m 418.42,161.363 c 0,4.566 0,14.692 0,15.439 0,0.747 -3.27,3.652 -3.27,3.652 h 8.693 c 0,0 -2.792,-3.238 -2.792,-3.652 0,-0.414 0.638,-14.278 0.638,-14.278 z"
       id="path27" />
    <g
       id="g29"
       transform="translate(0,-88.276)">
    	<path
       fill="#5abea0"
       d="m 418.978,251.216 c -2.073,-0.166 -7.816,4.566 -9.491,11.787 0,0 -5.105,-8.301 7.657,-15.191 0,0 -5.663,-1.661 -14.276,7.305 -0.465,0.484 -0.877,-13.53 14.595,-9.795 0,0 -5.902,-8.551 -18.025,-1.826 0,0 8.055,-14.444 19.939,-1.494 0,0 0.079,-11.207 0.16,-10.045 0.081,1.162 0.957,6.308 0.957,6.308 l 2.313,-4.067 -1.834,8.301 c 0,0 10.607,-14.112 19.62,0.582 0,0 -11.645,-4.814 -17.227,0.581 0,0 11.964,-3.238 11.006,10.625 0,0 -4.705,-8.218 -12.362,-7.139 0,0 9.013,4.15 6.141,15.357 -0.001,10e-4 -5.432,-10.99 -9.173,-11.289 z"
       id="path28" />
    	<path
       fill="#5abea0"
       d="m 342.815,301.103 c -0.444,-0.601 -1.066,-0.89 -1.676,-0.966 0.235,-0.81 0.392,-1.18 0.329,-1.77 0.186,0.046 0.364,0.13 0.555,0.153 l 0.082,-0.666 c -0.708,-0.085 -1.48,-0.403 -2.273,-0.887 0.489,-0.419 0.843,-1.063 0.843,-1.852 0,-0.857 -0.393,-1.575 -0.952,-1.982 -0.558,0.408 -0.952,1.126 -0.952,1.982 0,0.643 0.264,1.159 0.61,1.572 -0.295,-0.204 -0.593,-0.44 -0.892,-0.694 -0.077,-0.527 -0.279,-1.058 -0.747,-1.484 -0.633,-0.577 -1.428,-0.77 -2.106,-0.632 -0.075,0.687 0.191,1.461 0.824,2.039 0.489,0.446 1.065,0.598 1.618,0.61 0.126,0.107 0.258,0.214 0.397,0.323 -0.38,-0.046 -0.789,-0.007 -1.198,0.142 -0.806,0.294 -1.345,0.908 -1.537,1.572 0.575,0.385 1.383,0.51 2.188,0.216 0.703,-0.256 1.155,-0.771 1.399,-1.335 0.471,0.301 0.988,0.552 1.523,0.753 l -0.085,0.011 c -0.018,0.483 0.014,0.682 -0.226,1.58 -0.541,-0.351 -1.257,-0.509 -2.014,-0.286 -0.822,0.242 -1.399,0.822 -1.633,1.473 0.55,0.42 1.348,0.596 2.171,0.353 0.618,-0.182 1.037,-0.579 1.336,-1.03 -0.113,0.341 -0.255,0.693 -0.414,1.052 -0.483,0.223 -0.936,0.567 -1.213,1.137 -0.375,0.77 -0.335,1.588 -0.011,2.199 0.681,-0.122 1.348,-0.596 1.724,-1.366 0.289,-0.595 0.274,-1.19 0.128,-1.724 0.067,-0.151 0.132,-0.308 0.198,-0.472 0.063,0.377 0.216,0.759 0.474,1.109 0.509,0.69 1.25,1.034 1.942,1.031 0.206,-0.66 0.097,-1.471 -0.412,-2.161 z"
       id="path29" />
    </g>
    <path
       fill="#ffecde"
       d="m 338.874,210.676 c 2.911,0 6.719,-0.111 6.606,2.799 -0.111,2.911 -3.359,12.766 4.143,15.789 7.502,3.023 8.398,2.575 8.398,2.575 l 3.359,7.726 8.174,-2.911 -7.839,-6.271 c 0,0 -0.672,-4.255 -2.575,-7.167 0,0 4.815,-2.464 6.495,-4.591 l -3.359,-0.224 c 0,0 4.367,-2.799 6.382,-5.934 l -2.351,0.224 c 0,0 2.687,-2.688 3.359,-5.823 0,0 -4.367,4.367 -8.846,4.927 0,0 1.903,-4.927 2.351,-6.83 0,0 -3.359,2.127 -5.71,3.023 -2.351,0.896 -6.047,1.007 -4.367,8.622 0,0 -2.016,-1.679 -3.247,-5.263 -1.231,-3.583 -1.679,-4.927 -3.359,-4.927 -2.743,0 -3.807,2.464 -3.807,2.464 z"
       id="path30" />
    <path
       fill="#b46446"
       d="m 421.519,212.116 c 1.007,-1.343 3.022,-5.54 4.785,-4.449 1.763,1.091 4.114,3.777 5.54,2.518 1.426,-1.259 1.511,-2.854 -0.672,-3.609 -2.183,-0.755 -4.617,-2.015 -6.127,-1.511 -1.511,0.503 -6.127,5.289 -6.127,5.289 z"
       id="path31" />
    <path
       fill="#ffe15a"
       d="m 408.509,215.725 c -0.084,-1.931 1.219,-10.313 6.464,-9.234 2.854,0.588 4.258,3.613 7.975,5.036 3.945,1.511 6.464,2.434 5.708,5.036 -0.756,2.602 -2.183,5.708 -5.457,6.464 -3.274,0.757 -14.69,-7.302 -14.69,-7.302 z"
       id="path32" />
    <g
       id="g34"
       transform="translate(0,-88.276)">
    	<path
       fill="#5abea0"
       d="m 405.067,310.912 c -1.119,0.224 -5.26,6.268 -0.335,12.424 0,0 6.044,2.462 10.857,-1.343 4.813,-3.805 1.231,-5.708 1.231,-5.708 z"
       id="path33" />
    	<path
       fill="#5abea0"
       d="m 405.486,312.227 c -0.503,-0.756 -0.419,-1.315 -0.419,-1.315 0,0 -0.252,-8.674 3.358,-8.842 3.61,-0.168 16.62,8.394 16.62,9.821 0,1.427 -4.198,5.54 -7.723,6.379 -3.524,0.84 -11.836,-6.043 -11.836,-6.043 z"
       id="path34" />
    </g>
    <path
       fill="#b46446"
       d="m 396.589,244.937 c 0,0 11.466,-5.151 9.311,-9.342 -1.555,-3.023 -5.05,-1.086 -5.603,1.223 -0.691,2.881 -2.932,6.896 -3.708,8.119 z"
       id="path35" />
    <path
       fill="#464655"
       d="m 383.936,259.579 -0.663,-0.211 C 382.608,259.155 366.779,254.057 350.69,243.452 329.085,229.214 317.664,211.835 317.664,193.2 V 91.972 H 450.207 V 193.2 c 0,18.636 -11.421,36.014 -33.026,50.252 -16.088,10.605 -31.917,15.703 -32.583,15.916 z M 322.034,96.342 V 193.2 c 0,39.281 55.178,59.469 61.902,61.782 6.717,-2.313 61.902,-22.534 61.902,-61.782 V 96.342 Z"
       id="path36" />
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const FK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs44" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path6" />
    </g>
    <path
       fill="#e67346"
       d="m 330.706,264.116 -4.143,-9.669 2.071,4.835 -2.095,-4.823 c 0.873,-0.385 21.38,-9.741 21.38,-37.253 h 10.519 c 0,34.626 -26.599,46.423 -27.732,46.91 z"
       id="path7" />
    <path
       fill="#eb7d4b"
       d="m 334.819,240.591 -7.437,-7.437 c 14.219,-14.219 21.608,-18.119 22.404,-18.518 l 4.705,9.409 -2.353,-4.705 2.393,4.684 c -0.067,0.036 -6.727,3.582 -19.712,16.567 z"
       id="path8" />
    <path
       fill="#e67346"
       d="m 438.795,264.116 4.143,-9.669 -2.071,4.835 2.095,-4.823 c -0.873,-0.385 -21.38,-9.741 -21.38,-37.253 h -10.519 c 0,34.626 26.599,46.423 27.732,46.91 z"
       id="path9" />
    <path
       fill="#eb7d4b"
       d="m 434.683,240.591 7.437,-7.437 c -14.219,-14.219 -21.608,-18.119 -22.404,-18.518 l -4.705,9.409 2.353,-4.705 -2.393,4.684 c 0.066,0.036 6.726,3.582 19.712,16.567 z"
       id="path10" />
    <path
       fill="#4173cd"
       d="m 384.735,80.458 h -56.101 c 0,0 0,66.621 0,84.152 0,17.531 3.507,63.114 56.101,80.645 52.595,-17.532 56.101,-63.114 56.101,-80.645 0,-17.531 0,-84.152 0,-84.152 z"
       id="path11" />
    <path
       fill="#c8c8c8"
       d="m 409.279,101.496 h -30.144 c -3.185,0 -6.274,-1.084 -8.761,-3.073 l -11.769,-9.416 c -1.244,-0.994 -2.788,-1.537 -4.381,-1.537 h -1.046 c -3.873,0 -7.012,3.139 -7.012,7.012 h -5.259 c -2.904,0 -5.259,2.355 -5.259,5.259 0,2.904 2.355,5.259 5.259,5.259 h 5.259 c 1.937,0 3.507,1.57 3.507,3.507 v 17.532 c 0,6.528 4.48,11.966 10.519,13.529 v 11.015 h 7.012 l 2.63,-10.519 h 32.434 l 3.507,3.507 v 7.012 h 3.507 v -10.519 h 3.507 v 10.519 h 3.507 v -11.491 c 2.088,-1.215 3.507,-3.45 3.507,-6.04 v -21.038 c -0.005,-5.808 -4.714,-10.518 -10.524,-10.518 z"
       id="path12" />
    <polygon
       fill="#73af00"
       points="416.293,256.392 423.305,235.355 346.165,235.355 353.179,256.392 "
       id="polygon12"
       transform="translate(0,-88.276)" />
    <path
       fill="#f5f5f5"
       d="m 422.091,161.103 c -9.348,0 -9.348,7.012 -18.696,7.012 -9.345,0 -9.345,-7.012 -18.691,-7.012 -9.344,0 -9.344,7.012 -18.689,7.012 -9.347,0 -9.347,-7.012 -18.695,-7.012 -9.327,0 -9.351,6.98 -18.638,7.01 0.113,3.906 0.447,8.683 1.31,13.963 7.992,-0.653 8.466,-6.947 17.329,-6.947 9.347,0 9.347,7.012 18.695,7.012 9.344,0 9.344,-7.012 18.689,-7.012 9.345,0 9.345,7.012 18.691,7.012 9.348,0 9.348,-7.012 18.696,-7.012 8.887,0 9.354,6.307 17.385,6.948 0.862,-5.279 1.197,-10.057 1.31,-13.963 -9.331,-0.016 -9.343,-7.011 -18.696,-7.011 z"
       id="path13" />
    <path
       fill="#4173cd"
       d="m 422.091,175.129 c -9.348,0 -9.348,7.012 -18.696,7.012 -9.345,0 -9.345,-7.012 -18.691,-7.012 -9.344,0 -9.344,7.012 -18.689,7.012 -9.347,0 -9.347,-7.012 -18.695,-7.012 -8.863,0 -9.336,6.294 -17.329,6.947 0.686,4.202 1.717,8.722 3.225,13.367 5.114,-1.786 6.607,-6.29 14.103,-6.29 9.347,0 9.347,7.012 18.695,7.012 9.344,0 9.344,-7.012 18.689,-7.012 9.345,0 9.345,7.012 18.691,7.012 9.348,0 9.348,-7.012 18.696,-7.012 7.523,0 9.01,4.522 14.156,6.301 1.51,-4.649 2.541,-9.172 3.229,-13.377 -8.029,-0.642 -8.496,-6.948 -17.384,-6.948 z"
       id="path14" />
    <path
       fill="#f5f5f5"
       d="m 422.091,189.154 c -9.348,0 -9.348,7.012 -18.696,7.012 -9.345,0 -9.345,-7.012 -18.691,-7.012 -9.344,0 -9.344,7.012 -18.689,7.012 -9.347,0 -9.347,-7.012 -18.695,-7.012 -7.496,0 -8.989,4.503 -14.103,6.29 1.209,3.724 2.74,7.527 4.655,11.317 2.371,-1.778 4.707,-3.582 9.448,-3.582 9.347,0 9.347,7.012 18.695,7.012 9.344,0 9.344,-7.012 18.689,-7.012 9.345,0 9.345,7.012 18.691,7.012 9.348,0 9.348,-7.012 18.696,-7.012 4.768,0 7.109,1.818 9.494,3.604 1.919,-3.794 3.452,-7.601 4.662,-11.328 -5.146,-1.779 -6.632,-6.301 -14.156,-6.301 z"
       id="path15" />
    <path
       fill="#4173cd"
       d="m 422.091,203.18 c -9.348,0 -9.348,7.012 -18.696,7.012 -9.345,0 -9.345,-7.012 -18.691,-7.012 -9.344,0 -9.344,7.012 -18.689,7.012 -9.347,0 -9.347,-7.012 -18.695,-7.012 -4.74,0 -7.078,1.803 -9.448,3.582 1.825,3.612 4.007,7.206 6.613,10.705 0.847,-0.16 1.774,-0.26 2.835,-0.26 9.347,0 9.347,7.012 18.695,7.012 9.344,0 9.344,-7.012 18.689,-7.012 9.345,0 9.345,7.012 18.691,7.012 9.348,0 9.348,-7.012 18.696,-7.012 1.081,0 2.026,0.102 2.887,0.267 2.603,-3.493 4.783,-7.082 6.607,-10.689 -2.384,-1.787 -4.725,-3.605 -9.494,-3.605 z"
       id="path16" />
    <path
       fill="#f5f5f5"
       d="m 424.978,217.472 c -0.86,-0.165 -1.805,-0.267 -2.887,-0.267 -9.348,0 -9.348,7.012 -18.696,7.012 -9.345,0 -9.345,-7.012 -18.691,-7.012 -9.344,0 -9.344,7.012 -18.689,7.012 -9.347,0 -9.347,-7.012 -18.695,-7.012 -1.06,0 -1.987,0.1 -2.835,0.26 5.683,7.628 13.391,14.781 23.823,20.6 7.104,-1.048 7.894,-6.835 16.394,-6.835 8.52,0 9.294,5.812 16.442,6.841 10.438,-5.817 18.149,-12.969 23.834,-20.599 z"
       id="path17" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<rect
       x="382.98001"
       y="249.38"
       fill="#ff965a"
       width="3.507"
       height="59.610001"
       id="rect17" />
    	<rect
       x="374.20999"
       y="258.14099"
       fill="#ff965a"
       width="21.040001"
       height="3.507"
       id="rect18" />
    	<rect
       x="374.20999"
       y="279.17999"
       fill="#ff965a"
       width="21.040001"
       height="3.507"
       id="rect19" />
    </g>
    <rect
       x="374.20999"
       y="173.36499"
       fill="#ffe15a"
       width="21.040001"
       height="13.87"
       id="rect20" />
    <polygon
       fill="#ff4b55"
       points="372.463,252.886 382.982,249.379 382.982,256.392 "
       id="polygon20"
       transform="translate(0,-88.276)" />
    <g
       id="g23"
       transform="translate(0,-88.276)">
    	<rect
       x="406.35999"
       y="249.38"
       fill="#ff965a"
       width="3.507"
       height="41.200001"
       id="rect21" />
    	<rect
       x="397.59"
       y="258.14099"
       fill="#ff965a"
       width="21.040001"
       height="3.507"
       id="rect22" />
    	<rect
       x="397.59"
       y="279.17999"
       fill="#ff965a"
       width="21.040001"
       height="3.507"
       id="rect23" />
    </g>
    <rect
       x="397.59"
       y="173.36499"
       fill="#ffe15a"
       width="21.040001"
       height="13.87"
       id="rect24" />
    <polygon
       fill="#ff4b55"
       points="395.838,252.886 406.357,249.379 406.357,256.392 "
       id="polygon24"
       transform="translate(0,-88.276)" />
    <g
       id="g27"
       transform="translate(0,-88.276)">
    	<rect
       x="359.45999"
       y="249.38"
       fill="#ff965a"
       width="3.507"
       height="40.904999"
       id="rect25" />
    	<rect
       x="350.70001"
       y="258.14099"
       fill="#ff965a"
       width="21.040001"
       height="3.507"
       id="rect26" />
    	<rect
       x="350.70001"
       y="279.17999"
       fill="#ff965a"
       width="21.040001"
       height="3.507"
       id="rect27" />
    </g>
    <rect
       x="350.70001"
       y="173.36499"
       fill="#ffe15a"
       width="21.040001"
       height="13.87"
       id="rect28" />
    <polygon
       fill="#ff4b55"
       points="348.942,252.886 359.461,249.379 359.461,256.392 "
       id="polygon28"
       transform="translate(0,-88.276)" />
    <path
       fill="#ff965a"
       d="m 402.267,199.673 c 0,9.666 -7.865,17.532 -17.532,17.532 -9.667,0 -17.532,-7.865 -17.532,-17.532 h -3.507 -3.478 l -23.747,-5.363 -0.773,3.421 10.467,2.364 v 3.084 l 7.717,3.086 c 3.042,14.244 15.714,24.963 30.852,24.963 14.987,0 27.543,-10.513 30.744,-24.544 h 11.331 v -10.519 z"
       id="path28" />
    <path
       fill="#f5f5f5"
       d="m 440.837,80.458 c 0,0 0,66.621 0,84.152 0,17.531 -3.507,63.114 -56.102,80.645 -52.595,-17.532 -56.101,-63.114 -56.101,-80.645 0,-17.531 0,-84.152 0,-84.152 h 56.101 56.102 m 3.505,-3.506 h -3.507 -56.101 -56.101 -3.507 v 3.507 84.152 c 0,41.576 20.776,71.397 58.499,83.972 l 1.109,0.37 1.109,-0.37 c 37.724,-12.575 58.499,-42.397 58.499,-83.972 V 80.459 Z"
       id="path29" />
    <path
       fill="#ff965a"
       d="m 384.735,262.787 c -25.807,0 -49.741,-8.645 -64.021,-23.127 l 9.985,-9.848 c 11.702,11.864 31.903,18.949 54.037,18.949 22.134,0 42.335,-7.084 54.037,-18.949 l 9.985,9.848 c -14.282,14.481 -38.215,23.127 -64.023,23.127 z"
       id="path30" />
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const FM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs20" />
    <path
       fill="#82afff"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 254.837,136.57 -6.801,20.392 -21.495,0.167 c -1.178,0.009 -1.667,1.513 -0.719,2.214 l 17.292,12.769 -6.484,20.494 c -0.355,1.123 0.924,2.054 1.882,1.368 l 17.487,-12.5 17.489,12.5 c 0.959,0.685 2.238,-0.244 1.882,-1.368 l -6.484,-20.494 17.292,-12.769 c 0.948,-0.7 0.459,-2.204 -0.719,-2.214 l -21.495,-0.167 -6.801,-20.392 c -0.372,-1.117 -1.954,-1.117 -2.326,0 z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 254.837,318.633 -6.801,20.392 -21.495,0.167 c -1.178,0.009 -1.667,1.513 -0.719,2.214 l 17.292,12.769 -6.484,20.494 c -0.355,1.123 0.924,2.054 1.882,1.368 l 17.487,-12.5 17.489,12.5 c 0.959,0.685 2.238,-0.244 1.882,-1.368 l -6.484,-20.494 17.292,-12.769 c 0.948,-0.7 0.459,-2.204 -0.719,-2.214 l -21.495,-0.167 -6.801,-20.392 c -0.372,-1.118 -1.954,-1.118 -2.326,0 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 375.431,254.838 -20.392,-6.801 -0.167,-21.495 c -0.009,-1.178 -1.513,-1.667 -2.214,-0.719 l -12.769,17.292 -20.494,-6.484 c -1.123,-0.355 -2.053,0.924 -1.368,1.882 l 12.5,17.487 -12.5,17.489 c -0.685,0.959 0.244,2.238 1.368,1.882 l 20.494,-6.484 12.769,17.292 c 0.7,0.948 2.204,0.459 2.214,-0.719 l 0.167,-21.495 20.392,-6.801 c 1.117,-0.372 1.117,-1.954 0,-2.326 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 136.569,254.838 20.392,-6.801 0.167,-21.495 c 0.009,-1.178 1.513,-1.667 2.214,-0.719 l 12.769,17.292 20.494,-6.484 c 1.123,-0.355 2.054,0.924 1.368,1.882 l -12.5,17.488 12.5,17.489 c 0.685,0.959 -0.244,2.238 -1.368,1.882 l -20.494,-6.484 -12.769,17.292 c -0.7,0.948 -2.204,0.459 -2.214,-0.719 l -0.167,-21.495 -20.392,-6.801 c -1.117,-0.373 -1.117,-1.955 0,-2.327 z"
       id="path5" />
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const FO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.00198 335.44963" {...props}>
    <defs
         id="defs39" /><path
         fill="#ffffff"
         d="M 503.172,335.44961 H 8.828 c -4.875,0 -8.828,-3.953 -8.828,-8.828 V 8.828609 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62161 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
         id="path2" /><path
         fill="#3e64ff"
         d="M 142.39648,0 V 124.74219 H 0 v 85.9668 h 142.39648 v 124.74023 h 85.96485 V 210.70899 h 283.64062 v -85.9668 H 512 228.36133 V 0 Z m 33,16.501949 h 19.96485 V 157.74219 H 495.5 v 19.9668 H 195.36133 V 318.94922 H 175.39648 V 177.70899 H 16.5 v -19.9668 h 158.89648 z"
         id="polygon4" /><g
         id="g6"
         transform="translate(0,-88.275391)" /><g
         id="g8"
         transform="translate(0,-88.275391)" /><g
         id="g10"
         transform="translate(0,-88.275391)" /><g
         id="g12"
         transform="translate(0,-88.275391)" /><g
         id="g14"
         transform="translate(0,-88.275391)" /><g
         id="g16"
         transform="translate(0,-88.275391)" /><g
         id="g18"
         transform="translate(0,-88.275391)" /><g
         id="g20"
         transform="translate(0,-88.275391)" /><g
         id="g22"
         transform="translate(0,-88.275391)" /><g
         id="g24"
         transform="translate(0,-88.275391)" /><g
         id="g26"
         transform="translate(0,-88.275391)" /><g
         id="g28"
         transform="translate(0,-88.275391)" /><g
         id="g30"
         transform="translate(0,-88.275391)" /><g
         id="g32"
         transform="translate(0,-88.275391)" /><g
         id="g34"
         transform="translate(0,-88.275391)" /><polygon
         id="polygon848"
         points="211.862,88.277 158.897,88.277 158.897,229.518 0,229.518 0,282.484 158.897,282.484 158.897,423.725 211.862,423.725 211.862,282.484 512,282.484 512,229.518 211.862,229.518 "
         fill="#ff4b55"
         transform="translate(0,-88.275391)" />
  </svg>
);

export const FR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const GA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#4173cd"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#73af00"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#ffe15a"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GB = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.002 335.449" {...props}>
    <defs
       id="defs21" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.875 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="M 512,8.828 C 512,3.953 508.047,0 503.172,0 H 463.677 L 300.137,107.147 V 0 H 211.861 V 107.147 L 48.322,0 H 8.828 C 3.953,0 0,3.953 0,8.828 v 22.831 l 140.309,91.927 H 0 v 88.276 H 140.309 L 0,303.79 v 22.831 c 0,4.875 3.953,8.828 8.828,8.828 h 39.495 l 163.54,-107.147 v 107.147 h 88.276 V 228.302 l 163.54,107.147 h 39.495 c 4.875,0 8.828,-3.953 8.828,-8.828 V 303.79 L 371.693,211.863 H 512 V 123.587 H 371.691 L 512,31.659 Z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="282.483,88.276 229.517,88.276 229.517,229.518 0,229.518 0,282.483 229.517,282.483 229.517,423.725 282.483,423.725 282.483,282.483 512,282.483 512,229.518 282.483,229.518 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 178.948,300.138 0.25,416.135 c 0.625,4.263 4.14,7.59 8.577,7.59 h 12.159 l 190.39,-123.586 h -32.428 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="M 346.388,300.138 H 313.96 l 190.113,123.404 c 4.431,-0.472 7.928,-4.09 7.928,-8.646 v -7.258 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="m 0,106.849 161.779,105.014 h 32.428 L 5.143,89.137 C 2.123,90.54 0,93.555 0,97.104 Z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 332.566,211.863 511.693,95.586 c -0.744,-4.122 -4.184,-7.309 -8.521,-7.309 H 490.525 L 300.138,211.863 Z"
       id="path6" />
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs25" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 459.033,52.966 V 282.483 H 52.965 V 52.966 h 406.068"
       id="path2" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#73af00"
       points="52.965,370.758 52.965,141.242 255.999,256 "
       id="polygon2" />
    	<polygon
       fill="#73af00"
       points="459.033,370.758 459.033,141.242 255.999,256 "
       id="polygon3" />
    </g>
    <circle
       fill="#ff4b55"
       cx="256"
       cy="167.724"
       r="35.310001"
       id="circle3" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 258.231,230.129 5.523,16.558 17.454,0.136 c 2.26,0.018 3.197,2.901 1.379,4.244 l -14.041,10.369 5.266,16.642 c 0.682,2.155 -1.771,3.937 -3.611,2.623 L 256,270.55 241.8,280.701 c -1.838,1.314 -4.291,-0.468 -3.61,-2.623 l 5.266,-16.642 -14.041,-10.369 c -1.818,-1.343 -0.881,-4.226 1.379,-4.244 l 17.454,-0.136 5.523,-16.558 c 0.712,-2.144 3.745,-2.144 4.46,0 z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 257.318,99.993 3.263,9.783 10.313,0.079 c 1.335,0.01 1.889,1.715 0.814,2.507 l -8.297,6.126 3.111,9.833 c 0.403,1.273 -1.047,2.326 -2.133,1.549 l -8.389,-5.994 -8.391,5.997 c -1.086,0.777 -2.536,-0.277 -2.133,-1.549 l 3.111,-9.833 -8.297,-6.126 c -1.074,-0.793 -0.521,-2.497 0.814,-2.507 l 10.313,-0.079 3.263,-9.783 c 0.423,-1.27 2.215,-1.27 2.638,-0.003 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 373.456,99.993 3.263,9.783 10.313,0.079 c 1.335,0.01 1.889,1.715 0.814,2.507 l -8.297,6.126 3.111,9.833 c 0.403,1.273 -1.047,2.326 -2.133,1.549 l -8.391,-5.997 -8.391,5.997 c -1.086,0.777 -2.536,-0.277 -2.133,-1.549 l 3.111,-9.833 -8.297,-6.126 c -1.074,-0.793 -0.521,-2.497 0.814,-2.507 l 10.313,-0.079 3.263,-9.783 c 0.426,-1.267 2.217,-1.267 2.64,0 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 141.18,99.993 3.263,9.783 10.313,0.079 c 1.335,0.01 1.889,1.715 0.814,2.507 l -8.297,6.126 3.111,9.833 c 0.403,1.273 -1.047,2.326 -2.133,1.549 l -8.391,-5.997 -8.391,5.997 c -1.086,0.777 -2.536,-0.277 -2.133,-1.549 l 3.111,-9.833 -8.297,-6.126 c -1.074,-0.793 -0.521,-2.497 0.814,-2.507 l 10.313,-0.079 3.263,-9.783 c 0.426,-1.267 2.218,-1.267 2.64,0 z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="m 257.318,381.993 3.263,9.783 10.313,0.079 c 1.335,0.01 1.889,1.715 0.814,2.507 l -8.297,6.126 3.111,9.833 c 0.403,1.273 -1.047,2.326 -2.133,1.549 l -8.389,-5.994 -8.391,5.997 c -1.086,0.777 -2.536,-0.277 -2.133,-1.549 l 3.111,-9.833 -8.297,-6.126 c -1.074,-0.793 -0.521,-2.497 0.814,-2.507 l 10.313,-0.079 3.263,-9.783 c 0.423,-1.269 2.215,-1.269 2.638,-0.003 z"
       id="path7" />
    	<path
       fill="#ffe15a"
       d="m 373.456,381.993 3.263,9.783 10.313,0.079 c 1.335,0.01 1.889,1.715 0.814,2.507 l -8.297,6.126 3.111,9.833 c 0.403,1.273 -1.047,2.326 -2.133,1.549 l -8.391,-5.997 -8.391,5.997 c -1.086,0.777 -2.536,-0.277 -2.133,-1.549 l 3.111,-9.833 -8.297,-6.126 c -1.074,-0.793 -0.521,-2.497 0.814,-2.507 l 10.313,-0.079 3.263,-9.783 c 0.426,-1.266 2.217,-1.266 2.64,0 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 141.18,381.993 3.263,9.783 10.313,0.079 c 1.335,0.01 1.889,1.715 0.814,2.507 l -8.297,6.126 3.111,9.833 c 0.403,1.273 -1.047,2.326 -2.133,1.549 l -8.391,-5.997 -8.391,5.997 c -1.086,0.777 -2.536,-0.277 -2.133,-1.549 l 3.111,-9.833 -8.297,-6.126 c -1.074,-0.793 -0.521,-2.497 0.814,-2.507 l 10.313,-0.079 3.263,-9.783 c 0.426,-1.266 2.218,-1.266 2.64,0 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="M 118.069,233.931 H 96 V 256 c 0,12.189 9.88,22.069 22.069,22.069 12.189,0 22.069,-9.88 22.069,-22.069 0,-12.189 -9.881,-22.069 -22.069,-22.069 z"
       id="path10" />
    </g>
    <polygon
       fill="#ff4b55"
       points="118.069,256 137.786,265.939 140.138,278.069 128.006,275.717 "
       id="polygon10"
       transform="translate(0,-88.276)" />
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs20" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="282.483,88.277 229.517,88.277 229.517,229.518 0,229.518 0,282.484 229.517,282.484 229.517,423.725 282.483,423.725 282.483,282.484 512,282.484 512,229.518 282.483,229.518 "
       id="polygon1" />
    	<path
       fill="#ff4b55"
       d="m 150.069,146.834 c -8.744,0.879 -17.31,1.76 -25.888,2.642 0.882,-8.579 1.762,-17.145 2.643,-25.888 -8.019,1.037 -16.11,1.037 -24.129,0 0.879,8.743 1.76,17.31 2.643,25.888 -8.579,-0.881 -17.146,-1.762 -25.888,-2.642 1.037,8.018 1.037,16.11 0,24.128 8.744,-0.879 17.31,-1.76 25.888,-2.642 -0.882,8.579 -1.763,17.145 -2.643,25.888 8.019,-1.037 16.11,-1.037 24.129,0 -0.879,-8.743 -1.761,-17.31 -2.643,-25.888 8.579,0.881 17.145,1.762 25.888,2.642 -1.036,-8.018 -1.036,-16.111 0,-24.128 z"
       id="path2" />
    	<path
       fill="#ff4b55"
       d="m 432.552,146.834 c -8.744,0.879 -17.31,1.76 -25.888,2.642 0.882,-8.579 1.762,-17.145 2.643,-25.888 -8.019,1.037 -16.11,1.037 -24.129,0 0.879,8.743 1.76,17.31 2.643,25.888 -8.579,-0.881 -17.146,-1.762 -25.888,-2.642 1.037,8.018 1.037,16.11 0,24.128 8.744,-0.879 17.31,-1.76 25.888,-2.642 -0.882,8.579 -1.763,17.145 -2.643,25.888 8.019,-1.037 16.11,-1.037 24.129,0 -0.879,-8.743 -1.761,-17.31 -2.643,-25.888 8.579,0.881 17.145,1.762 25.888,2.642 -1.036,-8.018 -1.036,-16.111 0,-24.128 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 150.069,341.04 c -8.744,0.879 -17.31,1.76 -25.888,2.642 0.882,-8.579 1.762,-17.145 2.643,-25.888 -8.019,1.037 -16.11,1.037 -24.129,0 0.879,8.743 1.76,17.31 2.643,25.888 -8.579,-0.881 -17.146,-1.762 -25.888,-2.642 1.037,8.018 1.037,16.11 0,24.128 8.744,-0.879 17.31,-1.76 25.888,-2.642 -0.882,8.579 -1.763,17.145 -2.643,25.888 8.019,-1.037 16.11,-1.037 24.129,0 -0.879,-8.743 -1.761,-17.31 -2.643,-25.888 8.579,0.881 17.145,1.762 25.888,2.642 -1.036,-8.017 -1.036,-16.11 0,-24.128 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="m 432.552,341.04 c -8.744,0.879 -17.31,1.76 -25.888,2.642 0.882,-8.579 1.762,-17.145 2.643,-25.888 -8.019,1.037 -16.11,1.037 -24.129,0 0.879,8.743 1.76,17.31 2.643,25.888 -8.579,-0.881 -17.146,-1.762 -25.888,-2.642 1.037,8.018 1.037,16.11 0,24.128 8.744,-0.879 17.31,-1.76 25.888,-2.642 -0.882,8.579 -1.763,17.145 -2.643,25.888 8.019,-1.037 16.11,-1.037 24.129,0 -0.879,-8.743 -1.761,-17.31 -2.643,-25.888 8.579,0.881 17.145,1.762 25.888,2.642 -1.036,-8.017 -1.036,-16.11 0,-24.128 z"
       id="path5" />
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GF = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const GG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#ff4b55"
       points="291.31,88.276 220.689,88.276 220.689,220.69 0,220.69 0,291.31 220.689,291.31 220.689,423.724 291.31,423.724 291.31,291.31 512,291.31 512,220.69 291.31,220.69 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ffe15a"
       points="348.689,242.759 163.31,242.759 150.069,229.517 150.069,282.483 163.31,269.241 348.689,269.241 361.93,282.483 361.93,229.517 "
       id="polygon2" />
    	<polygon
       fill="#ffe15a"
       points="269.241,348.689 269.241,163.311 282.482,150.069 229.517,150.069 242.758,163.311 242.758,348.689 229.517,361.931 282.482,361.931 "
       id="polygon3" />
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GH = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#ffe15a"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#464655"
       d="m 259.722,125.634 9.213,27.623 29.118,0.226 c 3.769,0.029 5.333,4.84 2.301,7.08 l -23.424,17.298 8.783,27.763 c 1.138,3.594 -2.955,6.568 -6.023,4.375 L 256,193.065 232.31,209.997 c -3.066,2.193 -7.159,-0.781 -6.023,-4.375 l 8.783,-27.763 -23.424,-17.298 c -3.032,-2.24 -1.47,-7.05 2.301,-7.08 l 29.118,-0.226 9.213,-27.623 c 1.193,-3.574 6.251,-3.574 7.444,0.002 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs23" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="M 503.172,423.724 H 8.828 C 3.953,423.724 0,419.771 0,414.896 V 308.965 h 512 v 105.931 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    	<polygon
       fill="#ff4b55"
       points="335.448,194.207 335.448,150.069 344.275,150.069 344.275,132.414 291.31,132.414 291.31,150.069 300.137,150.069 300.137,194.207 273.655,194.207 273.655,132.414 282.482,132.414 282.482,114.759 229.517,114.759 229.517,132.414 238.344,132.414 238.344,194.207 211.862,194.207 211.862,150.069 220.689,150.069 220.689,132.414 167.724,132.414 167.724,150.069 176.551,150.069 176.551,194.207 158.896,194.207 158.896,211.862 167.724,211.862 167.724,282.483 158.896,282.483 158.896,300.138 353.103,300.138 353.103,282.483 344.275,282.483 344.275,211.862 353.103,211.862 353.103,194.207 "
       id="polygon2" />
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    	<path
       fill="#464655"
       d="m 273.655,291.31 h -35.31 V 256 c 0,-9.751 7.904,-17.655 17.655,-17.655 v 0 c 9.751,0 17.655,7.904 17.655,17.655 z"
       id="path3" />
    	<path
       fill="#464655"
       d="m 255.999,167.724 c -4.875,0 -8.828,3.953 -8.828,8.828 v 26.483 h 17.655 v -26.483 c 10e-4,-4.875 -3.952,-8.828 -8.827,-8.828 z"
       id="path4" />
    	<path
       fill="#464655"
       d="m 317.792,176.552 c -4.875,0 -8.828,3.953 -8.828,8.828 v 17.655 h 17.655 V 185.38 c 10e-4,-4.876 -3.95,-8.828 -8.827,-8.828 z"
       id="path5" />
    	<path
       fill="#464655"
       d="m 194.206,176.552 c -4.875,0 -8.828,3.953 -8.828,8.828 v 17.655 h 17.655 V 185.38 c 0.001,-4.876 -3.952,-8.828 -8.827,-8.828 z"
       id="path6" />
    	<path
       fill="#464655"
       d="m 326.62,291.31 h -35.31 v -26.483 c 0,-9.751 7.904,-17.655 17.655,-17.655 v 0 c 9.751,0 17.655,7.904 17.655,17.655 z"
       id="path7" />
    	<path
       fill="#464655"
       d="m 220.689,291.31 h -35.31 v -26.483 c 0,-9.751 7.904,-17.655 17.655,-17.655 v 0 c 9.751,0 17.655,7.904 17.655,17.655 z"
       id="path8" />
    </g>
    <path
       fill="#ffe15a"
       d="m 280.275,233.931 c 0,-1.474 -0.737,-2.854 -1.965,-3.672 l -17.897,-11.93 v -3.737 l 15.215,-7.608 c 2.182,-1.09 3.064,-3.742 1.974,-5.922 -1.095,-2.185 -3.737,-3.064 -5.922,-1.974 l -15.681,7.841 -15.681,-7.84 c -2.173,-1.09 -4.832,-0.211 -5.922,1.974 -1.09,2.182 -0.207,4.832 1.974,5.922 l 15.215,7.607 v 3.737 l -17.897,11.932 c -1.228,0.818 -1.965,2.197 -1.965,3.671 0,1.474 0.737,2.854 1.965,3.672 l 17.897,11.932 v 37.362 H 233.93 v 6.759 c 0,2.44 1.974,4.414 4.414,4.414 1.689,0 3.159,-0.948 3.901,-2.345 h 9.341 v 8.828 h -9.418 c -0.762,-1.319 -2.189,-2.207 -3.823,-2.207 -2.44,0 -4.414,1.974 -4.414,4.414 v 6.621 h 17.655 v 4.414 c 0,2.44 1.974,4.414 4.414,4.414 2.44,0 4.414,-1.974 4.414,-4.414 v -4.414 -26.483 -37.362 l 17.897,-11.932 c 1.227,-0.821 1.964,-2.2 1.964,-3.674 z m -24.276,7.936 -11.905,-7.936 11.905,-7.935 11.905,7.935 z"
       id="path9" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#f5f5f5"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <g
       id="g3"
       transform="translate(0,-88.275)">
    	<path
       fill="#ff4b55"
       d="m 0,256 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,423.725 0,419.772 0,414.897 Z"
       id="path2" />
    	<path
       fill="#ff4b55"
       d="m 176.552,141.241 c -63.38,0 -114.759,51.38 -114.759,114.759 H 291.31 c 0,-63.379 -51.378,-114.759 -114.758,-114.759 z"
       id="path3" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 176.552,282.484 c 63.38,0 114.759,-51.38 114.759,-114.759 H 61.793 c 0,63.38 51.38,114.759 114.759,114.759 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const GM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#73af00"
       d="m 0,220.69 h 512 v 105.931 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.449 0,331.496 0,326.621 Z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 114.759 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="114.754"
       fill="#41479b"
       width="512"
       height="105.93"
       id="rect2"
       x="0" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<rect
       y="203.03"
       fill="#f5f5f5"
       width="512"
       height="17.655001"
       id="rect3"
       x="0" />
    	<rect
       y="291.31"
       fill="#f5f5f5"
       width="512"
       height="17.655001"
       id="rect4"
       x="0" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#73af00"
       d="M 341.333,0 H 503.172 C 508.047,0 512,3.953 512,8.828 v 317.793 c 0,4.875 -3.953,8.828 -8.828,8.828 H 341.333 Z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#ffe15a"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 8.828,0 H 170.667 V 335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const GP = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const GQ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs27" />
    <path
       fill="#73af00"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#4173cd"
       d="m 128.095,173.195 c 2.532,-3.207 2.532,-7.733 0,-10.94 L 2.335,2.958 C 0.92,4.524 0,6.552 0,8.828 v 317.793 c 0,2.276 0.92,4.305 2.335,5.87 z"
       id="path3" />
    <path
       fill="#b46446"
       d="m 253.881,175.621 c 0,0.216 -0.071,20.968 -5.378,31.177 h 14.913 c -5.308,-10.208 -5.378,-30.961 -5.378,-31.177 0,-7.15 7.411,-12.832 7.486,-12.888 l -2.497,-3.322 c -0.194,0.146 -2.664,2.039 -4.988,5.114 v -5.53 h -4.157 v 5.53 c -2.324,-3.075 -4.793,-4.969 -4.988,-5.114 l -2.497,3.322 c 0.075,0.056 7.484,5.737 7.484,12.888 z"
       id="path4" />
    <path
       fill="#73af00"
       d="m 276.745,150.68 c -0.127,0 -0.244,0.033 -0.37,0.041 -0.847,-2.438 -3.14,-4.198 -5.866,-4.198 -0.983,0 -1.9,0.248 -2.727,0.653 -0.881,-1.619 -2.575,-2.731 -4.547,-2.731 -0.567,0 -1.102,0.114 -1.613,0.281 -1.106,-2.609 -3.689,-4.438 -6.7,-4.438 -3.701,0 -6.722,2.774 -7.181,6.349 -0.372,-0.058 -0.745,-0.114 -1.132,-0.114 -4.018,0 -7.275,3.257 -7.275,7.275 0,0.472 0.053,0.931 0.139,1.378 -1.841,0.606 -3.289,2.029 -3.925,3.855 -0.124,-0.011 -0.244,-0.038 -0.371,-0.038 -2.296,0 -4.157,1.862 -4.157,4.157 0,2.296 1.862,4.157 4.157,4.157 1.06,0 2.018,-0.409 2.752,-1.064 0.994,0.671 2.193,1.064 3.484,1.064 1.142,0 2.197,-0.329 3.117,-0.865 0.92,0.535 1.976,0.865 3.117,0.865 3.444,0 6.236,-2.792 6.236,-6.236 0,-0.264 -0.046,-0.514 -0.077,-0.769 0.968,0.477 2.042,0.769 3.196,0.769 1.446,0 2.784,-0.434 3.916,-1.161 1.063,1.922 3.085,3.239 5.437,3.239 0.505,0 0.991,-0.076 1.461,-0.19 1.144,1.375 2.846,2.269 4.774,2.269 1.863,0 3.517,-0.833 4.659,-2.129 3.204,-0.259 5.734,-2.913 5.734,-6.185 -0.003,-3.442 -2.794,-6.234 -6.238,-6.234 z"
       id="path5" />
    <path
       fill="#5fa000"
       d="m 270.509,155.876 c 0,-0.216 0.045,-0.42 0.064,-0.631 -1.112,1.028 -2.586,1.671 -4.221,1.671 -2.172,0 -4.079,-1.112 -5.196,-2.796 -1.117,1.684 -3.025,2.796 -5.196,2.796 -1.67,0 -3.177,-0.665 -4.297,-1.734 -0.648,3.354 -3.592,5.89 -7.135,5.89 -0.36,0 -0.704,-0.055 -1.049,-0.106 10e-4,0.036 0.011,0.07 0.011,0.106 0,2.718 -1.749,5.005 -4.175,5.859 0.657,0.235 1.358,0.376 2.097,0.376 1.142,0 2.197,-0.329 3.117,-0.865 0.92,0.535 1.976,0.865 3.117,0.865 3.444,0 6.236,-2.792 6.236,-6.236 0,-0.264 -0.046,-0.514 -0.077,-0.769 0.968,0.477 2.042,0.769 3.196,0.769 1.446,0 2.784,-0.434 3.916,-1.161 1.063,1.922 3.085,3.239 5.437,3.239 0.505,0 0.991,-0.076 1.461,-0.19 1.144,1.375 2.846,2.269 4.773,2.269 1.863,0 3.517,-0.833 4.659,-2.129 l 0.013,-0.002 c -3.769,-0.274 -6.751,-3.383 -6.751,-7.221 z"
       id="path6" />
    <path
       fill="#464655"
       d="m 255.96,220.046 c -0.334,0 -0.63,-0.213 -0.739,-0.527 -0.079,-0.234 -2.036,-5.706 -9.653,-5.706 h -10.392 c -6.161,0 -11.171,-5.012 -11.171,-11.171 v -68.588 c 0,-0.43 0.349,-0.779 0.779,-0.779 h 64.431 c 0.43,0 0.779,0.349 0.779,0.779 v 68.588 c 0,6.161 -5.012,11.171 -11.171,11.171 h -12.471 c -7.663,0 -9.634,5.644 -9.652,5.702 -0.107,0.319 -0.403,0.532 -0.738,0.532 z m -30.398,-85.215 v 67.809 c 0,5.3 4.312,9.613 9.613,9.613 h 10.392 c 6.169,0 9.155,3.313 10.392,5.303 1.237,-1.992 4.223,-5.303 10.392,-5.303 h 12.471 c 5.301,0 9.613,-4.313 9.613,-9.613 v -67.809 z"
       id="path7" />
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ffe15a"
       points="253.684,207.086 251.933,210.377 253.684,213.668 249.959,213.797 247.983,216.959 246.009,213.797 242.284,213.668 244.034,210.377 242.284,207.086 246.009,206.957 247.983,203.796 249.959,206.957 "
       id="polygon7" />
    	<polygon
       fill="#ffe15a"
       points="236.736,208.531 235.802,212.139 238.273,214.931 234.681,215.926 233.5,219.461 230.841,216.848 227.189,217.593 228.122,213.984 225.652,211.193 229.244,210.198 230.425,206.663 233.084,209.275 "
       id="polygon8" />
    	<polygon
       fill="#ffe15a"
       points="220.143,212.11 220.011,215.835 223.026,218.027 219.734,219.775 219.343,223.482 216.183,221.504 212.778,223.02 212.91,219.295 209.895,217.103 213.187,215.355 213.578,211.648 216.738,213.626 "
       id="polygon9" />
    	<polygon
       fill="#ffe15a"
       points="258.316,207.086 260.067,210.377 258.316,213.668 262.041,213.797 264.017,216.959 265.991,213.797 269.716,213.668 267.966,210.377 269.716,207.086 265.991,206.957 264.017,203.796 262.041,206.957 "
       id="polygon10" />
    	<polygon
       fill="#ffe15a"
       points="275.264,208.531 276.198,212.139 273.727,214.931 277.319,215.926 278.5,219.461 281.159,216.848 284.811,217.593 283.878,213.984 286.348,211.193 282.756,210.198 281.575,206.663 278.916,209.275 "
       id="polygon11" />
    	<polygon
       fill="#ffe15a"
       points="291.857,212.11 291.989,215.835 288.974,218.027 292.266,219.775 292.657,223.482 295.817,221.504 299.222,223.02 299.09,219.295 302.105,217.103 298.813,215.355 298.422,211.648 295.262,213.626 "
       id="polygon12" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs21" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<rect
       y="125.551"
       fill="#f5f5f5"
       width="512"
       height="37.27"
       id="rect1"
       x="0" />
    	<rect
       y="200.091"
       fill="#f5f5f5"
       width="512"
       height="37.27"
       id="rect2"
       x="0" />
    	<rect
       y="274.64099"
       fill="#f5f5f5"
       width="512"
       height="37.27"
       id="rect3"
       x="0" />
    </g>
    <rect
       y="223.63501"
       fill="#41479b"
       width="512"
       height="37.27"
       id="rect4"
       x="0" />
    <rect
       y="260.905"
       fill="#f5f5f5"
       width="512"
       height="37.27"
       id="rect5"
       x="0" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 8.828,423.725 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 386.452 H 0 v 28.445 c 0,4.876 3.953,8.828 8.828,8.828 z"
       id="path5" />
    	<path
       fill="#41479b"
       d="M 512,125.549 V 97.104 c 0,-4.875 -3.953,-8.828 -8.828,-8.828 H 8.828 C 3.953,88.277 0,92.229 0,97.104 v 65.717 37.271 74.545 H 512 V 237.365 H 176.552 V 200.093 H 512 V 162.821 H 176.552 v -37.272 z"
       id="path6" />
    </g>
    <polygon
       fill="#f5f5f5"
       points="106.912,88.277 69.64,88.277 69.64,162.821 0,162.821 0,200.093 69.64,200.093 69.64,274.637 106.912,274.637 106.912,200.093 176.552,200.093 176.552,162.821 106.912,162.821 "
       id="polygon6"
       transform="translate(0,-88.276)" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs77" />
    <path
       fill="#82afff"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#82afff"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <polygon
       fill="#ffc855"
       points="253.368,216.561 253.773,212.107 248.711,214.639 "
       id="polygon2"
       transform="translate(0,-88.272)" />
    <g
       id="g46"
       transform="translate(0,-88.272)">
    	<path
       fill="#73af00"
       d="m 256,305.65 c -28.135,0 -51.023,-22.89 -51.023,-51.023 0,-17.478 8.797,-33.548 23.531,-42.989 l 1.31,2.046 c -14.034,8.993 -22.411,24.299 -22.411,40.943 0,26.795 21.8,48.594 48.594,48.594 z"
       id="path3" />
    	<path
       fill="#73af00"
       d="m 226.798,308.833 c 1.944,0.396 4.943,-0.117 8.023,-1.551 3.081,-1.436 5.402,-3.402 6.349,-5.145 -1.944,-0.396 -4.943,0.117 -8.023,1.551 -3.079,1.437 -5.401,3.402 -6.349,5.145 z"
       id="path4" />
    	<path
       fill="#73af00"
       d="m 241.172,302.138 c 0.396,-1.944 -0.117,-4.943 -1.551,-8.023 -1.436,-3.081 -3.402,-5.402 -5.145,-6.349 -0.396,1.944 0.117,4.943 1.551,8.023 1.435,3.078 3.401,5.4 5.145,6.349 z"
       id="path5" />
    	<path
       fill="#73af00"
       d="m 216.633,302.594 c 1.865,0.678 4.907,0.61 8.164,-0.356 3.257,-0.967 5.843,-2.572 7.036,-4.157 -1.865,-0.678 -4.907,-0.61 -8.164,0.356 -3.257,0.967 -5.843,2.571 -7.036,4.157 z"
       id="path6" />
    	<path
       fill="#73af00"
       d="m 231.834,298.079 c 0.678,-1.865 0.61,-4.907 -0.356,-8.164 -0.968,-3.258 -2.572,-5.843 -4.157,-7.036 -0.678,1.865 -0.61,4.907 0.356,8.164 0.967,3.258 2.572,5.844 4.157,7.036 z"
       id="path7" />
    	<path
       fill="#73af00"
       d="m 207.231,294.086 c 1.713,1.001 4.717,1.482 8.096,1.116 3.379,-0.366 6.21,-1.481 7.668,-2.826 -1.713,-1.001 -4.717,-1.482 -8.096,-1.116 -3.379,0.366 -6.21,1.481 -7.668,2.826 z"
       id="path8" />
    	<path
       fill="#73af00"
       d="m 222.995,292.375 c 1.001,-1.713 1.482,-4.717 1.116,-8.096 -0.366,-3.379 -1.481,-6.21 -2.826,-7.668 -1.001,1.713 -1.482,4.717 -1.116,8.096 0.366,3.379 1.481,6.211 2.826,7.668 z"
       id="path9" />
    	<path
       fill="#73af00"
       d="m 199.458,282.336 c 1.508,1.289 4.38,2.294 7.77,2.531 3.39,0.237 6.375,-0.358 8.047,-1.423 -1.508,-1.289 -4.38,-2.294 -7.77,-2.531 -3.39,-0.237 -6.374,0.358 -8.047,1.423 z"
       id="path10" />
    	<path
       fill="#73af00"
       d="m 215.276,283.444 c 1.289,-1.508 2.294,-4.38 2.531,-7.77 0.237,-3.39 -0.358,-6.375 -1.423,-8.047 -1.289,1.508 -2.294,4.38 -2.531,7.77 -0.238,3.391 0.357,6.374 1.423,8.047 z"
       id="path11" />
    	<path
       fill="#73af00"
       d="m 194.908,269.395 c 1.204,1.577 3.799,3.164 7.064,4.109 3.265,0.945 6.306,0.991 8.167,0.301 -1.204,-1.577 -3.799,-3.164 -7.064,-4.109 -3.265,-0.945 -6.307,-0.992 -8.167,-0.301 z"
       id="path12" />
    	<path
       fill="#73af00"
       d="m 210.138,273.805 c 1.577,-1.204 3.164,-3.799 4.109,-7.064 0.946,-3.265 0.991,-6.306 0.301,-8.167 -1.577,1.204 -3.164,3.799 -4.109,7.064 -0.945,3.266 -0.99,6.306 -0.301,8.167 z"
       id="path13" />
    	<path
       fill="#73af00"
       d="m 192.982,254.283 c 0.758,1.834 2.858,4.034 5.77,5.788 2.912,1.753 5.839,2.58 7.815,2.391 -0.758,-1.834 -2.858,-4.034 -5.77,-5.788 -2.911,-1.753 -5.84,-2.578 -7.815,-2.391 z"
       id="path14" />
    	<path
       fill="#73af00"
       d="m 206.567,262.462 c 1.834,-0.758 4.034,-2.858 5.788,-5.77 1.753,-2.912 2.58,-5.839 2.391,-7.815 -1.834,0.758 -4.034,2.858 -5.788,5.77 -1.752,2.913 -2.58,5.84 -2.391,7.815 z"
       id="path15" />
    	<path
       fill="#73af00"
       d="m 194.807,240.016 c 0.356,1.952 1.949,4.544 4.428,6.869 2.479,2.325 5.17,3.746 7.139,3.977 -0.356,-1.952 -1.949,-4.544 -4.428,-6.869 -2.479,-2.324 -5.168,-3.747 -7.139,-3.977 z"
       id="path16" />
    	<path
       fill="#73af00"
       d="m 206.376,250.863 c 1.952,-0.356 4.544,-1.949 6.869,-4.428 2.325,-2.479 3.746,-5.17 3.977,-7.139 -1.952,0.356 -4.544,1.949 -6.869,4.428 -2.325,2.478 -3.748,5.167 -3.977,7.139 z"
       id="path17" />
    	<path
       fill="#73af00"
       d="m 201.975,224.579 c -0.408,1.941 0.085,4.943 1.501,8.033 1.416,3.09 3.368,5.423 5.105,6.382 0.408,-1.941 -0.085,-4.943 -1.501,-8.033 -1.416,-3.091 -3.368,-5.425 -5.105,-6.382 z"
       id="path18" />
    	<path
       fill="#73af00"
       d="m 208.58,238.994 c 1.941,0.408 4.943,-0.085 8.033,-1.501 3.09,-1.416 5.423,-3.368 6.382,-5.105 -1.941,-0.408 -4.943,0.085 -8.033,1.501 -3.09,1.416 -5.424,3.368 -6.382,5.105 z"
       id="path19" />
    	<path
       fill="#73af00"
       d="m 210.546,213.146 c -0.915,1.76 -1.247,4.785 -0.714,8.141 0.533,3.357 1.785,6.13 3.201,7.519 0.915,-1.76 1.247,-4.785 0.714,-8.141 -0.533,-3.356 -1.786,-6.129 -3.201,-7.519 z"
       id="path20" />
    	<path
       fill="#73af00"
       d="m 213.034,228.807 c 1.76,0.915 4.785,1.247 8.141,0.714 3.357,-0.533 6.13,-1.785 7.519,-3.201 -1.76,-0.915 -4.785,-1.247 -8.141,-0.714 -3.357,0.533 -6.13,1.785 -7.519,3.201 z"
       id="path21" />
    	<path
       fill="#73af00"
       d="m 218.951,205.189 c -1.164,1.607 -1.938,4.548 -1.905,7.947 0.033,3.399 0.864,6.325 2.059,7.908 1.164,-1.607 1.938,-4.548 1.905,-7.947 -0.033,-3.398 -0.863,-6.326 -2.059,-7.908 z"
       id="path22" />
    	<path
       fill="#73af00"
       d="m 219.105,221.044 c 1.607,1.164 4.548,1.938 7.947,1.905 3.399,-0.033 6.325,-0.864 7.908,-2.059 -1.607,-1.164 -4.548,-1.938 -7.947,-1.905 -3.398,0.033 -6.324,0.865 -7.908,2.059 z"
       id="path23" />
    	<path
       fill="#73af00"
       d="m 223.183,216.876 c 1.977,0.16 4.894,-0.707 7.78,-2.502 2.887,-1.794 4.956,-4.024 5.688,-5.868 -1.977,-0.16 -4.894,0.707 -7.78,2.502 -2.886,1.793 -4.955,4.023 -5.688,5.868 z"
       id="path24" />
    	<path
       fill="#73af00"
       d="m 256,305.65 v -2.43 c 26.794,0 48.594,-21.799 48.594,-48.594 0,-16.644 -8.378,-31.951 -22.411,-40.943 l 1.31,-2.046 c 14.734,9.441 23.531,25.512 23.531,42.989 -10e-4,28.133 -22.889,51.024 -51.024,51.024 z"
       id="path25" />
    	<path
       fill="#73af00"
       d="m 285.202,308.833 c -1.944,0.396 -4.943,-0.117 -8.023,-1.551 -3.081,-1.436 -5.402,-3.402 -6.349,-5.145 1.944,-0.396 4.943,0.117 8.023,1.551 3.079,1.437 5.401,3.402 6.349,5.145 z"
       id="path26" />
    	<path
       fill="#73af00"
       d="m 270.828,302.138 c -0.396,-1.944 0.117,-4.943 1.551,-8.023 1.436,-3.081 3.402,-5.402 5.145,-6.349 0.396,1.944 -0.117,4.943 -1.551,8.023 -1.435,3.078 -3.401,5.4 -5.145,6.349 z"
       id="path27" />
    	<path
       fill="#73af00"
       d="m 295.367,302.594 c -1.865,0.678 -4.907,0.61 -8.164,-0.356 -3.257,-0.967 -5.843,-2.572 -7.036,-4.157 1.865,-0.678 4.907,-0.61 8.164,0.356 3.257,0.967 5.843,2.571 7.036,4.157 z"
       id="path28" />
    	<path
       fill="#73af00"
       d="m 280.165,298.079 c -0.677,-1.865 -0.61,-4.907 0.356,-8.164 0.968,-3.258 2.572,-5.843 4.157,-7.036 0.678,1.865 0.61,4.907 -0.356,8.164 -0.966,3.258 -2.571,5.844 -4.157,7.036 z"
       id="path29" />
    	<path
       fill="#73af00"
       d="m 304.769,294.086 c -1.713,1.001 -4.717,1.482 -8.096,1.116 -3.379,-0.366 -6.21,-1.481 -7.668,-2.826 1.713,-1.001 4.717,-1.482 8.096,-1.116 3.379,0.366 6.21,1.481 7.668,2.826 z"
       id="path30" />
    	<path
       fill="#73af00"
       d="m 289.005,292.375 c -1.001,-1.713 -1.482,-4.717 -1.116,-8.096 0.366,-3.379 1.481,-6.21 2.826,-7.668 1.001,1.713 1.482,4.717 1.116,8.096 -0.366,3.379 -1.481,6.211 -2.826,7.668 z"
       id="path31" />
    	<path
       fill="#73af00"
       d="m 312.542,282.336 c -1.508,1.289 -4.38,2.294 -7.77,2.531 -3.39,0.237 -6.374,-0.358 -8.047,-1.423 1.508,-1.289 4.38,-2.294 7.77,-2.531 3.39,-0.237 6.374,0.358 8.047,1.423 z"
       id="path32" />
    	<path
       fill="#73af00"
       d="m 296.724,283.444 c -1.289,-1.508 -2.294,-4.38 -2.531,-7.77 -0.237,-3.39 0.358,-6.375 1.423,-8.047 1.289,1.508 2.294,4.38 2.531,7.77 0.238,3.391 -0.357,6.374 -1.423,8.047 z"
       id="path33" />
    	<path
       fill="#73af00"
       d="m 317.092,269.395 c -1.204,1.577 -3.799,3.164 -7.064,4.109 -3.264,0.946 -6.306,0.991 -8.167,0.301 1.204,-1.577 3.799,-3.164 7.064,-4.109 3.265,-0.945 6.307,-0.992 8.167,-0.301 z"
       id="path34" />
    	<path
       fill="#73af00"
       d="m 301.862,273.805 c -1.577,-1.204 -3.164,-3.799 -4.109,-7.064 -0.946,-3.265 -0.991,-6.306 -0.301,-8.167 1.577,1.204 3.164,3.799 4.109,7.064 0.945,3.266 0.99,6.306 0.301,8.167 z"
       id="path35" />
    	<path
       fill="#73af00"
       d="m 319.018,254.283 c -0.758,1.834 -2.858,4.034 -5.77,5.788 -2.912,1.753 -5.839,2.58 -7.815,2.391 0.758,-1.834 2.858,-4.034 5.77,-5.788 2.911,-1.753 5.84,-2.578 7.815,-2.391 z"
       id="path36" />
    	<path
       fill="#73af00"
       d="m 305.433,262.462 c -1.834,-0.758 -4.034,-2.858 -5.788,-5.77 -1.753,-2.912 -2.58,-5.839 -2.391,-7.815 1.834,0.758 4.034,2.858 5.788,5.77 1.754,2.913 2.58,5.84 2.391,7.815 z"
       id="path37" />
    	<path
       fill="#73af00"
       d="m 317.193,240.016 c -0.356,1.952 -1.949,4.544 -4.428,6.869 -2.479,2.325 -5.17,3.746 -7.139,3.977 0.356,-1.952 1.949,-4.544 4.428,-6.869 2.479,-2.325 5.168,-3.747 7.139,-3.977 z"
       id="path38" />
    	<path
       fill="#73af00"
       d="m 305.624,250.863 c -1.952,-0.356 -4.544,-1.949 -6.869,-4.428 -2.325,-2.479 -3.746,-5.17 -3.977,-7.139 1.952,0.356 4.544,1.949 6.869,4.428 2.325,2.478 3.748,5.167 3.977,7.139 z"
       id="path39" />
    	<path
       fill="#73af00"
       d="m 310.025,224.579 c 0.408,1.941 -0.085,4.943 -1.501,8.033 -1.416,3.09 -3.368,5.423 -5.105,6.382 -0.408,-1.941 0.085,-4.943 1.501,-8.033 1.416,-3.091 3.368,-5.425 5.105,-6.382 z"
       id="path40" />
    	<path
       fill="#73af00"
       d="m 303.42,238.994 c -1.941,0.408 -4.943,-0.085 -8.033,-1.501 -3.09,-1.416 -5.423,-3.368 -6.382,-5.105 1.941,-0.408 4.943,0.085 8.033,1.501 3.09,1.416 5.424,3.368 6.382,5.105 z"
       id="path41" />
    	<path
       fill="#73af00"
       d="m 301.454,213.146 c 0.915,1.76 1.247,4.785 0.714,8.141 -0.533,3.357 -1.785,6.13 -3.201,7.519 -0.915,-1.76 -1.247,-4.785 -0.714,-8.141 0.533,-3.356 1.786,-6.129 3.201,-7.519 z"
       id="path42" />
    	<path
       fill="#73af00"
       d="m 298.966,228.807 c -1.76,0.915 -4.785,1.247 -8.141,0.714 -3.357,-0.533 -6.13,-1.785 -7.519,-3.201 1.76,-0.915 4.785,-1.247 8.141,-0.714 3.357,0.533 6.13,1.785 7.519,3.201 z"
       id="path43" />
    	<path
       fill="#73af00"
       d="m 293.049,205.189 c 1.164,1.607 1.938,4.548 1.905,7.947 -0.033,3.399 -0.864,6.325 -2.059,7.908 -1.164,-1.607 -1.938,-4.548 -1.905,-7.947 0.033,-3.398 0.863,-6.326 2.059,-7.908 z"
       id="path44" />
    	<path
       fill="#73af00"
       d="m 292.895,221.044 c -1.607,1.164 -4.548,1.938 -7.947,1.905 -3.399,-0.033 -6.325,-0.864 -7.908,-2.059 1.607,-1.164 4.548,-1.938 7.947,-1.905 3.399,0.033 6.324,0.865 7.908,2.059 z"
       id="path45" />
    	<path
       fill="#73af00"
       d="m 288.817,216.876 c -1.977,0.16 -4.894,-0.707 -7.78,-2.502 -2.887,-1.794 -4.956,-4.024 -5.688,-5.868 1.977,-0.16 4.894,0.707 7.78,2.502 2.886,1.793 4.955,4.023 5.688,5.868 z"
       id="path46" />
    </g>
    <path
       fill="#966446"
       d="m 228.146,206.077 -8.844,8.844 -4.361,-8.723 13.084,-13.084 4.361,4.361 -1.26,3.779 c -0.606,1.818 -1.626,3.469 -2.98,4.823 z"
       id="path47" />
    <path
       fill="#b9b9b9"
       d="m 275.997,140.781 -47.972,47.972 c -1.204,1.204 -1.204,3.157 0,4.361 l 2.18,2.18 8.723,-8.723 34.889,-39.251 4.361,-4.361 z"
       id="path48" />
    <path
       fill="#966446"
       d="m 239.83,181.309 c -0.578,0.578 -0.904,1.363 -0.904,2.18 v 3.084 l 34.889,-39.251 z"
       id="path49" />
    <polygon
       fill="#a0a0a0"
       points="273.816,231.233 275.997,233.415 278.177,235.596 302.164,207.249 278.177,231.233 275.997,229.053 "
       id="polygon49"
       transform="translate(0,-88.272)" />
    <path
       fill="#966446"
       d="m 286.284,206.077 8.844,8.844 4.361,-8.723 -13.084,-13.084 -4.361,4.361 1.26,3.779 c 0.606,1.818 1.626,3.469 2.98,4.823 z"
       id="path50" />
    <path
       fill="#b9b9b9"
       d="m 238.433,140.781 47.972,47.972 c 1.204,1.204 1.204,3.157 0,4.361 l -2.18,2.18 -8.723,-8.723 -34.889,-39.251 -4.361,-4.361 z"
       id="path51" />
    <path
       fill="#966446"
       d="m 274.6,181.309 c 0.578,0.578 0.904,1.363 0.904,2.18 v 3.084 l -34.889,-39.251 z"
       id="path52" />
    <polygon
       fill="#a0a0a0"
       points="240.614,231.233 238.433,233.415 236.253,235.596 212.266,207.249 236.253,231.233 238.433,229.053 "
       id="polygon52"
       transform="translate(0,-88.272)" />
    <path
       fill="#b9b9b9"
       d="m 239.315,204.262 2.167,1.976 c 7.906,-8.668 21.741,-23.837 43.673,-43.529 0.001,0.001 -18.169,11.217 -45.84,41.553 z"
       id="path53" />
    <path
       fill="#ffe15a"
       d="m 233.184,213.159 v 0 c -0.778,-0.71 -0.833,-1.916 -0.124,-2.694 l 4.644,-5.092 c 0.71,-0.778 1.916,-0.833 2.694,-0.124 v 0 c 0.778,0.71 0.833,1.916 0.124,2.694 l -4.644,5.092 c -0.71,0.779 -1.916,0.835 -2.694,0.124 z"
       id="path54" />
    <path
       fill="#ffc855"
       d="m 237.556,202.659 -1.258,0.561 c -1.119,0.557 -4.063,2.222 -4.57,4.595 -0.242,1.124 0.099,2.219 0.972,3.255 0.083,-0.214 0.196,-0.422 0.361,-0.601 l 0.585,-0.641 c -0.395,-0.574 -0.605,-1.138 -0.486,-1.704 0.318,-1.484 2.298,-2.809 3.542,-3.466 l 5.564,5.075 1.384,-1.517 z"
       id="path55" />
    <path
       fill="#b9b9b9"
       d="m 275.093,206.662 -2.167,1.976 c -7.906,-8.668 -21.741,-23.837 -43.673,-43.529 -10e-4,0.001 18.169,11.215 45.84,41.553 z"
       id="path56" />
    <path
       fill="#ffe15a"
       d="m 281.224,215.56 v 0 c 0.778,-0.71 0.833,-1.916 0.124,-2.694 l -4.644,-5.092 c -0.71,-0.778 -1.916,-0.833 -2.694,-0.124 v 0 c -0.778,0.71 -0.833,1.916 -0.124,2.694 l 4.644,5.092 c 0.71,0.779 1.916,0.834 2.694,0.124 z"
       id="path57" />
    <path
       fill="#ffc855"
       d="m 276.852,205.057 1.258,0.561 c 1.119,0.557 4.063,2.222 4.57,4.595 0.242,1.124 -0.099,2.219 -0.972,3.255 -0.083,-0.214 -0.196,-0.421 -0.361,-0.601 l -0.585,-0.641 c 0.395,-0.574 0.605,-1.138 0.486,-1.704 -0.318,-1.484 -2.298,-2.809 -3.542,-3.466 l -5.564,5.075 -1.384,-1.517 z"
       id="path58" />
    <path
       fill="#69b469"
       d="m 258.161,126.412 c 0.17,-0.422 0.269,-0.879 0.269,-1.362 0,-2.013 -1.632,-3.645 -3.645,-3.645 -2.013,0 -3.645,1.632 -3.645,3.645 0,1.199 0.587,2.254 1.482,2.919 -1.318,10.585 9.119,11.394 13.096,12.874 6.034,2.244 13.603,6.787 13.127,19.484 -0.462,12.342 -8.267,24.251 -8.267,24.251 l 6.479,-8.808 c -2.369,10.02 -7.901,22.784 -21.057,37.963 0,0 8.995,-8.799 16.501,-20.146 -5.523,12.993 -11.642,25.005 -11.642,25.005 0,0 10.833,-14.072 19.59,-38.419 10.616,-29.518 -11.716,-47.252 -22.288,-53.761 z"
       id="path59" />
    <rect
       x="239"
       y="169.995"
       fill="#f4e08f"
       width="9.7189999"
       height="4.8600001"
       id="rect59" />
    <g
       id="g60"
       transform="translate(0,-88.272)">
    	<circle
       fill="#ecd077"
       cx="239"
       cy="263.12799"
       r="4.8600001"
       id="circle59" />
    	<circle
       fill="#ecd077"
       cx="239"
       cy="231.548"
       r="4.8600001"
       id="circle60" />
    </g>
    <path
       fill="#fcf0a8"
       d="m 268.148,148.132 c 2.684,0 4.86,-2.176 4.86,-4.86 0,-2.684 -2.176,-4.86 -4.86,-4.86 h -29.156 c 2.684,0 4.86,2.176 4.86,4.86 0,2.684 -2.176,4.86 -4.86,4.86 -2.684,0 -4.86,-2.176 -4.86,-4.86 0,8.157 6.826,18.019 9.027,26.727 0,0 0.692,2.176 0.692,4.86 0,2.684 -2.176,4.86 -4.86,4.86 h 29.156 c 2.684,0 4.86,-2.176 4.86,-4.86 0,-8.157 -6.826,-18.019 -9.027,-26.727 z"
       id="path60" />
    <g
       id="g62"
       transform="translate(0,-88.272)">
    	<path
       fill="#f4e08f"
       d="m 243.852,231.546 c 0,2.684 -2.176,4.86 -4.86,4.86 h 29.156 c 2.684,0 4.86,-2.176 4.86,-4.86 z"
       id="path61" />
    	<path
       fill="#f4e08f"
       d="m 243.852,263.13 c 0,2.684 -2.176,4.86 -4.86,4.86 h 29.156 c 2.684,0 4.86,-2.176 4.86,-4.86 z"
       id="path62" />
    </g>
    <g
       id="g63"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g64"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g65"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g66"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g67"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g68"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g69"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g70"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g71"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g72"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g73"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g74"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g75"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g76"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g77"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const GU = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs24" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#3cc8ff"
       d="m 255.999,79.448 c -33.549,17.651 -56.175,59.69 -56.175,88.276 0,28.586 22.626,70.626 56.175,88.276 33.549,-17.651 56.175,-59.69 56.175,-88.276 0,-28.586 -22.625,-70.625 -56.175,-88.276 z"
       id="path2" />
    <path
       fill="#73af00"
       d="m 263.244,137.497 c 5.42,-2.857 14.674,-6.001 25.189,-2.142 0,0 -10.127,-11.281 -24.181,-2.09 3.781,-4.585 9.459,-10.261 15.608,-11.842 0,0 -12.237,-4.57 -19.641,11.749 1.434,-8.231 1.173,-21.191 -12.094,-28.714 0,0 7.418,15.919 8.147,29.129 -0.431,-2.344 -1.294,-4.794 -3.572,-7.17 -7.015,-7.319 -13.114,-7.929 -13.114,-7.929 0,0 9.726,10.778 14.505,20.975 -2.753,-3.294 -7.605,-7.512 -15.42,-7.252 -18.3,0.61 -22.264,11.589 -22.264,11.589 7.586,-3.194 19.625,-4.785 28.958,-3.996 -12.049,2.123 -16.33,17.134 -16.33,17.134 9.675,-12.064 20.235,-14.024 24.451,-14.311 -7.702,6.371 -7.233,18.104 -7.233,18.104 1.79,-6.605 8.724,-14.133 12.103,-17.507 9.098,9.843 10.175,20.907 10.175,20.907 0,0 1.991,-3.329 1.073,-10.104 -0.868,-6.396 -4.882,-10.595 -7.945,-13.062 16.064,2.214 26.546,13.866 26.546,13.866 -5.255,-15.332 -18.408,-17.329 -24.961,-17.334 z"
       id="path3" />
    <path
       fill="#ff4b55"
       d="M 494.344,17.655 V 317.792 H 17.655 V 17.655 H 494.344 M 503.172,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 512,3.953 508.047,0 503.172,0 Z"
       id="path4" />
    <polygon
       fill="#ff965a"
       points="312.644,261.886 308.23,280.276 238.068,277.335 246.161,263.357 "
       id="polygon4"
       transform="translate(0,-88.276)" />
    <path
       fill="#4173cd"
       d="m 202.249,185.379 c 6.664,26.153 26.631,56.353 53.75,70.621 27.119,-14.268 47.086,-44.468 53.75,-70.621 z"
       id="path5" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 211.862,300.138 c 0,0 19.255,-0.953 30.823,3.797 2.89,1.186 3.264,5.09 0.654,6.807 -5.635,3.708 -13.822,10.09 -13.822,15.879 z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="m 245.701,335.448 c -0.736,-7.357 5.773,-12.707 14.712,-16.184 11.586,-4.505 5.241,-11.678 -0.552,-16.367 -6.909,-5.592 2.023,-7.172 39.54,-7.908 l -18.391,28.69 -25.011,20.598 z"
       id="path7" />
    </g>
    <path
       fill="#ff4b55"
       d="m 255.999,260.992 -2.056,-1.086 c -35.012,-18.414 -58.535,-62.534 -58.535,-92.181 0,-29.646 23.521,-73.768 58.535,-92.181 l 2.056,-1.086 2.056,1.086 c 35.013,18.414 58.534,62.534 58.534,92.181 0,29.646 -23.521,73.768 -58.534,92.181 z m 0,-176.517 c -31.056,17.535 -51.763,56.759 -51.763,83.249 0,26.49 20.707,65.716 51.763,83.249 31.056,-17.535 51.763,-56.759 51.763,-83.249 0,-26.49 -20.706,-65.715 -51.763,-83.249 z"
       id="path8" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    	<path
       fill="#a54b37"
       d="m 274.758,306.389 c -0.405,0 -0.81,-0.108 -1.173,-0.337 -11.996,-7.539 -18.874,-20.018 -18.874,-34.237 v -40.642 c 0,-1.219 0.988,-2.207 2.207,-2.207 1.219,0 2.207,0.988 2.207,2.207 v 40.642 c 0,12.668 6.125,23.785 16.805,30.496 1.035,0.651 1.345,2.013 0.698,3.043 -0.421,0.669 -1.137,1.035 -1.87,1.035 z"
       id="path9" />
    	<circle
       fill="#a54b37"
       cx="256.92001"
       cy="231.31"
       r="4.8280001"
       id="circle9" />
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const GW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.00198 335.44923" {...props}>
    <defs
         id="defs39"><clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath941"><g
             id="use943"><path
               fill="#435125"
               id="path964"
               d="m 301.50807,445.71112 c -0.18,-0.086 -0.218,-0.122 -0.347,-0.245 l -0.125,-0.117 c -0.324,-0.297 -0.861,-0.822 -1.582,-1.643 -1.332,-1.513 -3.119,-3.728 -4.69,-5.685 -3.115,-3.883 -5.689,-7.228 -6.174,-7.858 l -0.793,-1.032 -7.767,-2.395 -5.671,-2.644 3.03,-3.406 10.408,4.456 7.767,1.594 14.363,10.564 -0.011,0.009 c -0.029,0.024 -2.089,1.738 -4.136,3.599 -0.913,0.83 -2.064,1.896 -2.877,2.783 -0.375,0.408 -0.705,0.813 -0.93,1.14 -0.138,0.201 -0.215,0.383 -0.252,0.471 l 0.892,-0.555 0.967,0.752 -1.968,0.184 -0.09,0.02 z m -53.34,-16.02 c -6.777,-0.001 -13.471,-1.874 -19.895,-5.567 l -0.007,-0.004 0.003,-0.008 c 0,0 0.84,-1.601 2.878,-3.096 1.941,-1.425 5.442,-3.128 11.1,-3.15 h 0.117 c 6.701,0 14.901,2.278 24.373,6.771 -0.32,0.212 -7.756,5.054 -18.566,5.054 l 0.01,0.01 z m -29.37,-6.51 c -1.253,0 -2.379,-0.474 -3.17,-1.333 -0.649,-0.706 -1.114,-1.646 -1.422,-2.878 -0.504,-2.018 -0.365,-4.025 -0.351,-4.217 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.511,0 4.49,2.178 5.338,4.337 0.481,1.227 0.574,2.259 0.274,3.067 -0.3,0.81 -1.24,1.37 -2.34,1.37 z m 51.68,-5.99 c -17.359,-2.479 -24.717,-8.755 -27.833,-13.583 -3.323,-5.149 -2.641,-9.912 -2.634,-9.96 l 0.003,-0.014 0.013,-0.004 c 0.005,0 1.061,-0.285 2.658,-0.293 4.618,0 16.43,2.323 27.798,23.842 l 0.007,0.014 -0.02,-0.01 z m -35.58,-3.44 c -7.416,-0.001 -13.062,-1.28 -16.782,-3.804 -2.138,-1.45 -3.184,-3.043 -3.686,-4.125 -0.47,-1.014 -0.577,-1.856 -0.594,-2.023 0.196,-0.09 3.232,-1.438 7.765,-1.65 0.383,-0.018 0.769,-0.029 1.174,-0.03 5.732,0 14.448,1.87 23.646,10.78 l 0.009,0.009 -0.011,10e-4 c -4.2,0.55 -8.08,0.84 -11.53,0.84 z m -35.91,-1.38 c -7.82,0 -18.563,-2.388 -25.263,-9.087 l -0.007,-0.008 0.02,-0.005 c 0.07,-0.018 7.342,-1.863 15.523,-2.062 0.488,-0.012 0.979,-0.019 1.475,-0.019 7.332,0 12.944,1.422 16.682,4.225 1.305,0.979 2.018,1.89 2.178,2.783 0.134,0.746 -0.26,1.55 -1.056,2.15 -1.683,1.271 -4.692,1.949 -8.945,2.017 l -0.6,0.02 z m -25.34,-13 c -0.963,0 -1.867,-0.426 -2.479,-1.167 -0.506,-0.614 -0.858,-1.416 -1.108,-2.522 -0.418,-1.848 -0.292,-3.656 -0.291,-3.674 l 0.001,-0.018 c 0.364,-0.172 0.771,-0.264 1.217,-0.275 h 0.003 c 1.157,0 2.039,0.63 2.589,1.158 0.733,0.705 1.333,1.645 1.688,2.645 0.365,1.03 0.424,1.892 0.18,2.635 -0.2,0.59 -0.88,1.21 -1.8,1.21 z m 58.53,-1.32 c -1.253,0 -2.379,-0.474 -3.17,-1.333 -0.649,-0.706 -1.114,-1.646 -1.422,-2.878 -0.504,-2.018 -0.365,-4.025 -0.351,-4.217 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.511,0 4.49,2.178 5.338,4.337 0.481,1.227 0.574,2.259 0.274,3.067 -0.3,0.82 -1.25,1.37 -2.34,1.37 z m -28.51,-1.18 c -15.737,-0.554 -23.904,-5.027 -27.984,-8.683 -2.297,-2.058 -3.574,-4.098 -4.24,-5.447 -0.628,-1.274 -0.866,-2.249 -0.908,-2.438 l 0.021,-0.009 c 0.003,0 1.489,-0.532 3.885,-0.579 l 0.368,-0.004 c 5.307,0 16.111,2.229 28.852,17.153 v 0.01 z m 17.09,-1.59 c -12.661,-1.928 -19.834,-7.363 -23.622,-11.585 -3.971,-4.425 -5.16,-8.546 -5.213,-8.738 0.023,-0.007 1.57,-0.41 3.9,-0.469 0.169,-0.005 0.345,-0.007 0.524,-0.007 0.181,0 0.365,0.002 0.553,0.007 6.368,0.139 17.934,3.023 23.855,20.785 h 0.01 z m -65,-6.08 c -4.149,0 -8.174,-0.48 -11.962,-1.427 -6.629,-1.658 -9.473,-4.189 -10.691,-6.021 -0.692,-1.04 -0.943,-1.952 -1.031,-2.534 -0.085,-0.556 -0.04,-0.999 -0.031,-1.073 l 0.031,-0.011 c 0.017,-0.004 4.4,-1.235 10.464,-1.328 0.239,-0.004 0.48,-0.006 0.725,-0.006 2.927,0 5.808,0.279 8.564,0.83 10.536,2.107 16,10.06 16.053,10.14 l 0.005,0.009 -0.013,0.003 c -0.06,0.01 -5.08,1.42 -12.12,1.42 z m 29.39,-10.68 c -1.269,0 -2.395,-0.463 -3.172,-1.304 -0.639,-0.691 -1.104,-1.643 -1.42,-2.908 -0.506,-2.015 -0.365,-4.002 -0.351,-4.185 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.506,0 4.488,2.179 5.339,4.338 0.468,1.188 0.55,2.208 0.243,3.034 -0.31,0.84 -1.22,1.38 -2.31,1.38 z m -22.1,-3.03 c -0.095,-0.023 -5.977,-1.536 -11.967,-5.225 -5.544,-3.413 -12.326,-9.45 -13.153,-18.83 v -0.005 l 0.014,-0.004 c 0.001,0 0.516,-0.125 1.278,-0.154 0.105,-0.004 0.217,-0.006 0.334,-0.006 1.656,0 5.046,0.466 9.147,3.584 5.22,3.98 10.04,10.92 14.35,20.65 z m 14.43,-0.53 c -0.037,-0.015 -4.229,-1.693 -9.469,-6.084 -4.882,-4.092 -11.746,-11.46 -16.716,-23.33 0.003,-0.001 1.142,-0.608 2.886,-0.718 0.101,-0.007 0.203,-0.009 0.306,-0.009 0.15,0 0.305,0.005 0.463,0.009 2.411,0.068 6.083,1.07 10.154,5.463 4.676,5.047 8.85,13.34 12.404,24.651 l 0.01,0.032 -0.03,-0.01 z m -37.39,-1.09 c -4.821,0 -6.471,-2.615 -6.957,-3.74 -0.798,-1.849 -0.556,-3.689 -0.554,-3.707 l 0.003,-0.02 c 0.78,-0.195 1.605,-0.303 2.398,-0.314 l 0.165,-0.001 c 3.799,0 6.798,1.929 8.084,3.841 0.255,0.379 1.037,1.694 0.39,2.721 -0.52,0.81 -1.7,1.22 -3.53,1.22 z m -10.68,-13.47 c -2.692,0 -6.811,-0.165 -11.141,-0.952 -4.294,-0.781 -6.728,-4.432 -8.013,-7.356 -1.399,-3.185 -1.794,-6.223 -1.798,-6.254 h 0.012 c 13.282,0.39 19.555,4.271 22.478,7.457 3.018,3.29 3.197,6.706 3.206,6.922 l -0.009,10e-4 c -0.02,0 -1.89,0.18 -4.74,0.18 z m 13.83,-13.82 c -0.018,-0.022 -1.535,-1.898 -3.033,-4.228 -1.573,-2.445 -3.028,-4.996 -3.028,-7.084 0,-2.016 -0.474,-6.266 -0.757,-8.619 -0.358,-2.985 -0.72,-5.54 -0.75,-5.757 l 0.013,0.004 c 0.337,0.123 8.308,3.114 8.308,10.591 0,7.489 -0.738,15.014 -0.745,15.089 l -0.001,0.011 h -0.01 z m -10.33,-0.71 c -0.084,0 -0.167,-0.008 -0.25,-0.021 -2.356,-0.393 -6.496,-2.194 -11.073,-4.818 -5.082,-2.914 -9.209,-6.036 -11.62,-8.791 -2.198,-2.512 -3.503,-6.457 -3.88,-11.726 -0.267,-3.739 0.053,-6.854 0.087,-7.163 0.412,-0.137 0.85,-0.204 1.315,-0.204 1.764,0.029 3.647,0.823 6.189,2.574 1.981,1.365 4.165,3.221 6.49,5.514 4.012,3.957 7.168,7.932 7.199,7.971 l 0.032,0.04 c 0.265,0.475 2.537,4.571 4.307,8.558 1.124,2.532 1.767,4.357 2.024,5.746 0.147,0.791 0.19,1.31 -0.004,1.781 -0.081,0.195 -0.235,0.376 -0.385,0.448 -0.14,0.06 -0.28,0.09 -0.44,0.09 z" /><path
               fill="#435125"
               id="use966"
               d="m 274.08607,445.71112 c 0.18,-0.086 0.218,-0.122 0.347,-0.245 l 0.125,-0.117 c 0.324,-0.297 0.861,-0.822 1.582,-1.643 1.332,-1.513 3.119,-3.728 4.69,-5.685 3.115,-3.883 5.689,-7.228 6.174,-7.858 l 0.793,-1.032 7.767,-2.395 5.671,-2.644 -3.03,-3.406 -10.408,4.456 -7.767,1.594 -14.363,10.564 0.011,0.009 c 0.029,0.024 2.089,1.738 4.136,3.599 0.913,0.83 2.064,1.896 2.877,2.783 0.375,0.408 0.705,0.813 0.93,1.14 0.138,0.201 0.215,0.383 0.252,0.471 l -0.892,-0.555 -0.967,0.752 1.968,0.184 0.09,0.02 z m 53.34,-16.02 c 6.777,-0.001 13.471,-1.874 19.895,-5.567 l 0.007,-0.004 -0.003,-0.008 c 0,0 -0.84,-1.601 -2.878,-3.096 -1.941,-1.425 -5.442,-3.128 -11.1,-3.15 h -0.117 c -6.701,0 -14.901,2.278 -24.373,6.771 0.32,0.212 7.756,5.054 18.566,5.054 l -0.01,0.01 z m 29.37,-6.51 c 1.253,0 2.379,-0.474 3.17,-1.333 0.649,-0.706 1.114,-1.646 1.422,-2.878 0.504,-2.018 0.365,-4.025 0.351,-4.217 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.511,0 -4.49,2.178 -5.338,4.337 -0.481,1.227 -0.574,2.259 -0.274,3.067 0.3,0.81 1.24,1.37 2.34,1.37 z m -51.68,-5.99 c 17.359,-2.479 24.717,-8.755 27.833,-13.583 3.323,-5.149 2.641,-9.912 2.634,-9.96 l -0.003,-0.014 -0.013,-0.004 c -0.005,0 -1.061,-0.285 -2.658,-0.293 -4.618,0 -16.43,2.323 -27.798,23.842 l -0.007,0.014 0.02,-0.01 z m 35.58,-3.44 c 7.416,-0.001 13.062,-1.28 16.782,-3.804 2.138,-1.45 3.184,-3.043 3.686,-4.125 0.47,-1.014 0.577,-1.856 0.594,-2.023 -0.196,-0.09 -3.232,-1.438 -7.765,-1.65 -0.383,-0.018 -0.769,-0.029 -1.174,-0.03 -5.732,0 -14.448,1.87 -23.646,10.78 l -0.009,0.009 0.011,10e-4 c 4.2,0.55 8.08,0.84 11.53,0.84 z m 35.91,-1.38 c 7.82,0 18.563,-2.388 25.263,-9.087 l 0.007,-0.008 -0.02,-0.005 c -0.07,-0.018 -7.342,-1.863 -15.523,-2.062 -0.488,-0.012 -0.979,-0.019 -1.475,-0.019 -7.332,0 -12.944,1.422 -16.682,4.225 -1.305,0.979 -2.018,1.89 -2.178,2.783 -0.134,0.746 0.26,1.55 1.056,2.15 1.683,1.271 4.692,1.949 8.945,2.017 l 0.6,0.02 z m 25.34,-13 c 0.963,0 1.867,-0.426 2.479,-1.167 0.506,-0.614 0.858,-1.416 1.108,-2.522 0.418,-1.848 0.292,-3.656 0.291,-3.674 l -0.001,-0.018 c -0.364,-0.172 -0.771,-0.264 -1.217,-0.275 h -0.003 c -1.157,0 -2.039,0.63 -2.589,1.158 -0.733,0.705 -1.333,1.645 -1.688,2.645 -0.365,1.03 -0.424,1.892 -0.18,2.635 0.2,0.59 0.88,1.21 1.8,1.21 z m -58.53,-1.32 c 1.253,0 2.379,-0.474 3.17,-1.333 0.649,-0.706 1.114,-1.646 1.422,-2.878 0.504,-2.018 0.365,-4.025 0.351,-4.217 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.511,0 -4.49,2.178 -5.338,4.337 -0.481,1.227 -0.574,2.259 -0.274,3.067 0.3,0.82 1.25,1.37 2.34,1.37 z m 28.51,-1.18 c 15.737,-0.554 23.904,-5.027 27.984,-8.683 2.297,-2.058 3.574,-4.098 4.24,-5.447 0.628,-1.274 0.866,-2.249 0.908,-2.438 l -0.021,-0.009 c -0.003,0 -1.489,-0.532 -3.885,-0.579 l -0.368,-0.004 c -5.307,0 -16.111,2.229 -28.852,17.153 v 0.01 z m -17.09,-1.59 c 12.661,-1.928 19.834,-7.363 23.622,-11.585 3.971,-4.425 5.16,-8.546 5.213,-8.738 -0.023,-0.007 -1.57,-0.41 -3.9,-0.469 -0.169,-0.005 -0.345,-0.007 -0.524,-0.007 -0.181,0 -0.365,0.002 -0.553,0.007 -6.368,0.139 -17.934,3.023 -23.855,20.785 h -0.01 z m 65,-6.08 c 4.149,0 8.174,-0.48 11.962,-1.427 6.629,-1.658 9.473,-4.189 10.691,-6.021 0.692,-1.04 0.943,-1.952 1.031,-2.534 0.085,-0.556 0.04,-0.999 0.031,-1.073 l -0.031,-0.011 c -0.017,-0.004 -4.4,-1.235 -10.464,-1.328 -0.239,-0.004 -0.48,-0.006 -0.725,-0.006 -2.927,0 -5.808,0.279 -8.564,0.83 -10.536,2.107 -16,10.06 -16.053,10.14 l -0.005,0.009 0.013,0.003 c 0.06,0.01 5.08,1.42 12.12,1.42 z m -29.39,-10.68 c 1.269,0 2.395,-0.463 3.172,-1.304 0.639,-0.691 1.104,-1.643 1.42,-2.908 0.506,-2.015 0.365,-4.002 0.351,-4.185 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.506,0 -4.488,2.179 -5.339,4.338 -0.468,1.188 -0.55,2.208 -0.243,3.034 0.31,0.84 1.22,1.38 2.31,1.38 z m 22.1,-3.03 c 0.095,-0.023 5.977,-1.536 11.967,-5.225 5.544,-3.413 12.326,-9.45 13.153,-18.83 v -0.005 l -0.014,-0.004 c -10e-4,0 -0.516,-0.125 -1.278,-0.154 -0.105,-0.004 -0.217,-0.006 -0.334,-0.006 -1.656,0 -5.046,0.466 -9.147,3.584 -5.22,3.98 -10.04,10.92 -14.35,20.65 z m -14.43,-0.53 c 0.037,-0.015 4.229,-1.693 9.469,-6.084 4.882,-4.092 11.746,-11.46 16.716,-23.33 -0.003,-0.001 -1.142,-0.608 -2.886,-0.718 -0.101,-0.007 -0.203,-0.009 -0.306,-0.009 -0.15,0 -0.305,0.005 -0.463,0.009 -2.411,0.068 -6.083,1.07 -10.154,5.463 -4.676,5.047 -8.85,13.34 -12.404,24.651 l -0.01,0.032 0.03,-0.01 z m 37.39,-1.09 c 4.821,0 6.471,-2.615 6.957,-3.74 0.798,-1.849 0.556,-3.689 0.554,-3.707 l -0.003,-0.02 c -0.78,-0.195 -1.605,-0.303 -2.398,-0.314 l -0.165,-0.001 c -3.799,0 -6.798,1.929 -8.084,3.841 -0.255,0.379 -1.037,1.694 -0.39,2.721 0.52,0.81 1.7,1.22 3.53,1.22 z m 10.68,-13.47 c 2.692,0 6.811,-0.165 11.141,-0.952 4.294,-0.781 6.728,-4.432 8.013,-7.356 1.399,-3.185 1.794,-6.223 1.798,-6.254 h -0.012 c -13.282,0.39 -19.555,4.271 -22.478,7.457 -3.018,3.29 -3.197,6.706 -3.206,6.922 l 0.009,10e-4 c 0.02,0 1.89,0.18 4.74,0.18 z m -13.83,-13.82 c 0.018,-0.022 1.535,-1.898 3.033,-4.228 1.573,-2.445 3.028,-4.996 3.028,-7.084 0,-2.016 0.474,-6.266 0.757,-8.619 0.358,-2.985 0.72,-5.54 0.75,-5.757 l -0.013,0.004 c -0.337,0.123 -8.308,3.114 -8.308,10.591 0,7.489 0.738,15.014 0.745,15.089 l 10e-4,0.011 h 0.01 z m 10.33,-0.71 c 0.084,0 0.167,-0.008 0.25,-0.021 2.356,-0.393 6.496,-2.194 11.073,-4.818 5.082,-2.914 9.209,-6.036 11.62,-8.791 2.198,-2.512 3.503,-6.457 3.88,-11.726 0.267,-3.739 -0.053,-6.854 -0.087,-7.163 -0.412,-0.137 -0.85,-0.204 -1.315,-0.204 -1.764,0.029 -3.647,0.823 -6.189,2.574 -1.981,1.365 -4.165,3.221 -6.49,5.514 -4.012,3.957 -7.168,7.932 -7.199,7.971 l -0.032,0.04 c -0.265,0.475 -2.537,4.571 -4.307,8.558 -1.124,2.532 -1.767,4.357 -2.024,5.746 -0.147,0.791 -0.19,1.31 0.004,1.781 0.081,0.195 0.235,0.376 0.385,0.448 0.14,0.06 0.28,0.09 0.44,0.09 z" /><path
               fill="#d47600"
               d="m 565.53807,42.937117 -2.355,0.938 -0.923,0.368 -2.854,-0.157 -2.673,1.283 -4.74,3.239 -0.209,0.15 -1.767,0.461 -1.641,-0.708 -0.932,0.424 -0.321,1.92 -0.887,1.379 -1.092,0.767 -3.783,0.387 -3.19,1.645 -4.15,-1.111 -1.928,0.755 -4.099,3.692 -2.095,0.992 -0.732,-0.042 -2.778,-0.143 -1.173,0.384 -1.752,1.693 -3.315,0.258 -1.033,0.715 -1.618,3.26 -1.753,1.808 -1.003,0.212 -1.087,-0.398 -0.817,0.144 -0.37,2.086 -0.793,0.874 -2.219,0.764 -1.773,1.477 -1.556,0.799 -2.084,-0.052 h -0.479 l -2.076,1.146 -3.905,0.342 -1.624,1.549 -0.358,0.331 -0.758,0.458 -1.24,0.74 -0.304,0.184 -1.495,-0.267 -1.75,0.693 -0.708,-1.089 -1.211,0.727 -1.604,0.069 -1.998,-0.889 -1.522,-0.678 -1.113,0.161 -0.387,1.94 -0.039,0.206 -1.17,1.557 -2.184,1.323 -0.297,0.387 -2.485,3.208 -4.722,4.966 -3.993,2.028 -4.139,1.259 -2.897,2.38 -7.599,3.767 -11.994,5.967003 -2.453,0.786 -3.52,0.562 -6.278,2.312 -5.539,1.671 -0.308,0.094 -1.096,0.332 -7.81,2.363 -3.635,-0.384 -2.153,0.782 -5.605,-0.622 -3.897,0.077 -2.467,0.513 -4.637,2.224 -7.827,3.762 -2.586,2.366 -4.027,2.101 -4.715,1.493 0.011,-1.981 -0.028,-0.084 -1.636,0.517 -1.181,0.373 -3.825,0.59 h -2.128 l -1.321,-0.384 -0.204,0.069 -7.818,2.576 -8.719,0.842 -4.363,1.399 -3.26,-0.052 -2.038,0.607 -3.995,0.488 -1.428,-0.381 -0.322,-0.088 -11.75,0.51 -5.372,-0.607 -2.564,0.583 -4.296,-1.445 -6.269,-0.727 -1.465,-0.439 -3.295,-0.978 -1.491,0.859 -1.116,0.119 -2.667,-0.967 -0.96,-0.025 -2.202,0.796 -1.267,-0.325 -1.177,-0.938 -2.761,-0.411 -1.682,-1.414 -9.402,1.246 -2.551,-0.75 -8.554,-2.492 -1.361,0.069 -1.696,1.271 -2.548,0.929 -2.212,0.575 -3.012,0.105 -3.497,-0.918 -3.606,-1.748 -1.333,-0.317 -2.974,0.3 -0.91,0.083 -5.466,-2.932 -7.042,-4.404 -4.778,-2.296 -1.794,-0.291 -0.241,0.853 0.89,2.805 0.303,2.774 -0.091,2.563 -0.049,1.587 0.446,1.425 1.725,1.912 0.719,1.92 0.526,5.284 -0.006,5.362 -0.839,8.551 -0.283,1.302 -1.001,4.43 -0.914,4.069 -3.546,10.833 -0.974,1.343 -2.391,1.631 -5.419,3.688 -3.99,2.301 -1.263,0.523 -3.239,0.245 -2.018,-0.105 -2.513,-1.361 -2.467,-0.635 -3.232,-2.324 -3.595,-0.744 -3.941,-2.278 -1.026,-1.233 -2.146,-0.202 -2.976,-0.893 0.002,-0.005 -1.093,-0.327 -0.755,-0.22 v -0.001 l -3.796,-0.104 -3.54,-1.634 -1.864,-0.45 -2.547,-0.129 -2.666,1.239 -0.001,-0.004 -1.351,0.629 -1.707,-0.678 -1.235,0.077 -1.399,2.115 -0.209,0.328 -0.964,0.51 -1.2,-0.017 -0.939,-0.025 -1.016,0.444 -1.368,0.593 v 0.003 l -1.208,0.527 -0.59,0.255 -0.01,-0.01 -0.363,0.073 -0.645,0.112 -0.8,0.153 -1.41,-0.824 -0.75,-0.442 -1.257,-0.256 -0.677,0.489 -0.133,2.301 -0.618,1.378 -1.961,1.734 -1.993,1.755 -1.389,2.047 -3.676,8.39 -2.303,3.385 -0.715,0.789 -2.408,2.656 -2.136,1.657 -4.922,3.815 -4.659,1.741 -4.013,0.82 -1.951,0.008 -3.695998,-0.492 -3.323,-1.02 -3.65,-2.282 -4.003,-3.217 -5.794,-5.724 -0.82,-0.493 -0.171,-0.114 -1.825,-1.167 -1.354,0.035 -0.53,0.874 -0.29,1.263 -0.245,1.12 -0.664,6.367 0.049,0.369 0.349,2.622 4.401,6.15 1.358,3.267 0.223,0.373 0.908,1.525 0.691,1.163 0.069,0.118 1.504,4.488 -1.057,2.534 0.534,1.697 -1.336,1.037 -0.245,1.465 3.951,4.953 0.862,2.185 -0.963,3.029 -1.536,1.671 -0.429,0.457 0.216,1.28 1.818,1.635 3.089,2.75 1.647,4.086 1.253,1.096 1.456,-0.31 0.81,0.618 1.228,-0.021 1.208,1.208 0.782,0.379 1.236,0.616 0.977,1.272 0.216,3.911 1.821998,4.86 0.028,2.635 0.01,0.374 1.134,1.948 0.356,1.538 -0.604,4.069 1.445,1.306 1.567,-0.32 1.012,0.16 1.626,1.354 1.969,3.001 1.926,-0.282 1.222,0.589 5.902,5.334 1.339,0.676 0.074,0.042 0.963,0.483 1.197,1.208 1.856,-1.232 0.206,-0.021 2.018,-0.178 0.886,0.597 1.704,1.149 2.234,-0.029 4.844,1.485 2.119,0.543 4.261,2.648 1.811,1.12 1.072,0.871 1.424,1.161 2.845,1.224 2.44,0.584 1.322,0.314 0.995,0.384 0.025,-0.062 0.014,0.004 -0.024,0.063 5.284,2.023 2.862,0.668 2.648,0.975 1.927,0.703 1.414,0.023 2,-1.682 1.937,-0.112 1.609,0.401 1.57,-0.263 2.485,-1.531 0.485,-0.719 1.762,-0.839 5.944,-0.738 1.737,0.564 4.46,-1.94 2.988,0.831 2.645,-0.938 5.779,1.284 1.536,1.081 1.717,1.965 0.21,0.009 1.912,0.037 -0.799,1.331 2.523,2.647 2.279,3.445 0.154,0.455 1.657,4.864 1.232,1.723 0.862,2.405 0.042,1.568 -1.34,1.022 -0.22,0.583 -0.076,0.216 0.272,0.655 0.506,-0.276 0.963,-0.533 1.166,-0.181 2.066,0.22 1.364,0.143 2.154,-1.069 1.427,-0.71 2.293,0.987 2.52,-0.028 1.058,0.471 2.995,1.358 1.529,0.144 0.565,-0.371 0.36,-0.856 -0.185,-0.996 -1.145,-1.323 -2.531,-2.938 -1.036,-1.51 -0.789,-2.186 -0.245,-2.794 -0.174,-1.885 0.314,-2.477 0.68,-0.884 0.5,-1.968 h 0.009 l 0.129,-0.515 1.406,-1.866 3.724,-2.393 4,-3.582 3.162,-2.085 3.26,-1.412 0.087,-0.396 0.363,0.146 8.292,-2.819 0.137,-0.016 3.692,-0.643 24.92,1.755 0.924,-0.279 0.004,-0.006 0.83,-2.33 0.447,-0.432 0.297,-0.282 2.74,-1.206 1.281,-0.183 3.556,0.878 1.456,0.359 2.332,-1.307 1.654,0.028 3.417,-1.866 2.111,0.053 0.803,-0.321 4.112,-2.955 3.961,-1.135 1.03,-0.548 0.363,-0.199 4.06,-2.144 2.579,-1.981 2.226,-1.183 2.438,-0.629 6.38,-0.449 1.283,-2.138 2.744,-0.366 1.657,-1.87 1.896,-0.771 1.359,-1.958 1.139,-1.641 1.591,-0.921 5.1,-0.32 6.045,0.749 0.799,-0.485 1.366,-4.875 1.43,-0.915 3.851,-5.612 0.013,-2.045 0.004,-1.708 0.633,-2.432 -0.43,-4.391 0.51,-4.446 2.394,-5.65 2.109,-2.279 3.401,-2.301 1.729,-0.753 2.449,-0.412 v -0.006 l 0.36,-0.061 0.624,-0.107 8.433,-0.116 c 0.117,-0.087 3.067,-0.042 3.067,-0.042 l 2.812,-0.038 7.114,1.266 0.506,0.088 2.405,0.779 2.774,2.157 2.936,2.868 0.551,0.535 1.902,0.801 0.575,0.251 1.571,-0.251 2.237,-1.165 1.688,-1.427 2.301,-1.257 0.056,-0.08 1.295,-1.948 0.039,-0.04 0.028,0.007 0.003,-0.011 -0.022,-0.005 0.511,-0.775 4.447,-1.733 5.23,-0.304 0.588,-0.318 0.327,-0.175 1.382,-1.623 1.295,-0.011 3.135,1.134 2.204,-0.437 1.75,0.699 1.36,-0.161 2.565,-0.304 2.754,1.938 1.605,0.205 5.658,3.31 0.294,0.048 0.152,0.028 0.324,0.053 0.671,-0.199 0.998,-0.289 0.132,-0.039 0.126,0.174 0.643,0.907 0.882,0.126 1.044,-1.393 -0.415,-0.632 -0.157,-0.23 -2.021,-0.411 -1.815,-3.103 1.728,-1.861 -2.711,-3.326 -0.45,-0.551 -0.153,-0.234 -0.937,-1.423 -4.746,-7.235 -6.182,-4.935 -0.002,0.004 -2.165,-1.732 -0.014,-0.01 -0.758,-0.596 -3.302,-3.358 -2.358,-3.13 -0.309,-0.674 -0.487,-1.062 -1.413,-3.078 -2.462,-1.896 -2.006,-2.191 -0.098,-0.129 -4.14,-5.626 -0.68,-0.943 -0.978,-0.565 -2.066,-0.014 -0.195,-0.196 -0.116,-0.121 0.07,-0.074 0.991,-0.985 1.105,-0.278 0.476,-1.089 -2.108,-6.104 -0.014,-0.213 -0.157,-1.95 1.718,-8.855 0.22,-1.079 2.928,-5.958 1.814,-1.486 1.98,-3.892 1.696,-2.488 1.625,-1.582 0.284,-0.168 2.934,-1.776 2.465,-0.347 2.348,-0.331 4.099,1.264 3.901,-0.076 0.761,-0.081 1.77,-0.203 2.911,-0.917 1.374,-0.848 0.713,-1.093 1.487,-4.987 0.478,-1.587 0.917,-1.724 5.306,-6.108 4.011,-3.71 9.019,-6.613 4.415,-2.639 2.254,-1.347 20.126,-8.946003 5.23,-5.302 2.725,-2.757 4.821,-3.235 5.641,-2.311 4.854,-3.842 1.06,-1.334 1.336,-4.303 1.113,-0.269 1.005,-2.174 0.286,-0.618 3.961,-2.792 0.448,-0.223 15.388,-7.71 2.236,0.307 1.197,-1.793 4.477,-0.751 0.824,-0.14 1.104,-0.551 0.939,-1.599 v -0.316 l 0.129,-4.273 0.956,-1.155 0.521,-2.816 0.491,-0.65 0.513,-0.676 1.268,-0.891 -0.22,-0.531 z"
               id="path968" /></g></clipPath></defs><path
         fill="#ce1126"
         d="M 8.828125,0 C 3.953125,0 0,3.953125 0,8.828125 V 326.62109 c 0,4.875 3.953125,8.82813 8.828125,8.82813 H 176.78906 V 0 Z"
         id="rect2" /><path
         fill="#fcd116"
         d="M 176.78906,0 V 165.23633 H 512.00195 V 8.828125 C 512.00195,3.953125 508.04883,0 503.17383,0 Z"
         id="rect4" /><path
         fill="#009e49"
         d="m 176.78906,165.23633 v 170.21289 h 326.38282 c 4.87499,0 8.82907,-3.95213 8.83007,-8.82813 V 165.23633 Z"
         id="rect6" /><g
         id="g6"
         transform="translate(0,-88.275391)" /><g
         id="g8"
         transform="translate(0,-88.275391)" /><g
         id="g10"
         transform="translate(0,-88.275391)" /><g
         id="g12"
         transform="translate(0,-88.275391)" /><g
         id="g14"
         transform="translate(0,-88.275391)" /><g
         id="g16"
         transform="translate(0,-88.275391)" /><g
         id="g18"
         transform="translate(0,-88.275391)" /><g
         id="g20"
         transform="translate(0,-88.275391)" /><g
         id="g22"
         transform="translate(0,-88.275391)" /><g
         id="g24"
         transform="translate(0,-88.275391)" /><g
         id="g26"
         transform="translate(0,-88.275391)" /><g
         id="g28"
         transform="translate(0,-88.275391)" /><g
         id="g30"
         transform="translate(0,-88.275391)" /><g
         id="g32"
         transform="translate(0,-88.275391)" /><g
         id="g34"
         transform="translate(0,-88.275391)" /><g
         id="c"
         transform="matrix(49.967399,0,0,49.967399,88.394528,172.49606)"
         fill="#000000"><path
           transform="rotate(18,0,-1)"
           d="M 0,-1 V 0 H 0.5"
           id="t"
           fill="#000000" /><use
           id="use9"
           transform="scale(-1,1)"
           x="0"
           y="0"
           width="100%"
           height="100%"
           fill="#000000" /></g><use
         id="use12"
         transform="rotate(72,88.394524,172.49605)"
         x="0"
         y="0"
         width="100%"
         height="100%"
         fill="#000000" /><use
         id="use14"
         transform="rotate(144,88.394533,172.49605)"
         x="0"
         y="0"
         width="100%"
         height="100%"
         fill="#000000" /><use
         id="use16"
         transform="rotate(-144,88.394533,172.49605)"
         x="0"
         y="0"
         width="100%"
         height="100%"
         fill="#000000" /><use
         id="use18"
         transform="rotate(-72,88.394534,172.49605)"
         x="0"
         y="0"
         width="100%"
         height="100%"
         fill="#000000" />
  </svg>
);

export const GY = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.00198 335.17775" {...props}>
    <defs
         id="defs39"><clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath941"><g
             id="use943"><path
               fill="#435125"
               id="path1140"
               d="m 301.50807,445.71112 c -0.18,-0.086 -0.218,-0.122 -0.347,-0.245 l -0.125,-0.117 c -0.324,-0.297 -0.861,-0.822 -1.582,-1.643 -1.332,-1.513 -3.119,-3.728 -4.69,-5.685 -3.115,-3.883 -5.689,-7.228 -6.174,-7.858 l -0.793,-1.032 -7.767,-2.395 -5.671,-2.644 3.03,-3.406 10.408,4.456 7.767,1.594 14.363,10.564 -0.011,0.009 c -0.029,0.024 -2.089,1.738 -4.136,3.599 -0.913,0.83 -2.064,1.896 -2.877,2.783 -0.375,0.408 -0.705,0.813 -0.93,1.14 -0.138,0.201 -0.215,0.383 -0.252,0.471 l 0.892,-0.555 0.967,0.752 -1.968,0.184 -0.09,0.02 z m -53.34,-16.02 c -6.777,-0.001 -13.471,-1.874 -19.895,-5.567 l -0.007,-0.004 0.003,-0.008 c 0,0 0.84,-1.601 2.878,-3.096 1.941,-1.425 5.442,-3.128 11.1,-3.15 h 0.117 c 6.701,0 14.901,2.278 24.373,6.771 -0.32,0.212 -7.756,5.054 -18.566,5.054 l 0.01,0.01 z m -29.37,-6.51 c -1.253,0 -2.379,-0.474 -3.17,-1.333 -0.649,-0.706 -1.114,-1.646 -1.422,-2.878 -0.504,-2.018 -0.365,-4.025 -0.351,-4.217 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.511,0 4.49,2.178 5.338,4.337 0.481,1.227 0.574,2.259 0.274,3.067 -0.3,0.81 -1.24,1.37 -2.34,1.37 z m 51.68,-5.99 c -17.359,-2.479 -24.717,-8.755 -27.833,-13.583 -3.323,-5.149 -2.641,-9.912 -2.634,-9.96 l 0.003,-0.014 0.013,-0.004 c 0.005,0 1.061,-0.285 2.658,-0.293 4.618,0 16.43,2.323 27.798,23.842 l 0.007,0.014 -0.02,-0.01 z m -35.58,-3.44 c -7.416,-0.001 -13.062,-1.28 -16.782,-3.804 -2.138,-1.45 -3.184,-3.043 -3.686,-4.125 -0.47,-1.014 -0.577,-1.856 -0.594,-2.023 0.196,-0.09 3.232,-1.438 7.765,-1.65 0.383,-0.018 0.769,-0.029 1.174,-0.03 5.732,0 14.448,1.87 23.646,10.78 l 0.009,0.009 -0.011,10e-4 c -4.2,0.55 -8.08,0.84 -11.53,0.84 z m -35.91,-1.38 c -7.82,0 -18.563,-2.388 -25.263,-9.087 l -0.007,-0.008 0.02,-0.005 c 0.07,-0.018 7.342,-1.863 15.523,-2.062 0.488,-0.012 0.979,-0.019 1.475,-0.019 7.332,0 12.944,1.422 16.682,4.225 1.305,0.979 2.018,1.89 2.178,2.783 0.134,0.746 -0.26,1.55 -1.056,2.15 -1.683,1.271 -4.692,1.949 -8.945,2.017 l -0.6,0.02 z m -25.34,-13 c -0.963,0 -1.867,-0.426 -2.479,-1.167 -0.506,-0.614 -0.858,-1.416 -1.108,-2.522 -0.418,-1.848 -0.292,-3.656 -0.291,-3.674 l 0.001,-0.018 c 0.364,-0.172 0.771,-0.264 1.217,-0.275 h 0.003 c 1.157,0 2.039,0.63 2.589,1.158 0.733,0.705 1.333,1.645 1.688,2.645 0.365,1.03 0.424,1.892 0.18,2.635 -0.2,0.59 -0.88,1.21 -1.8,1.21 z m 58.53,-1.32 c -1.253,0 -2.379,-0.474 -3.17,-1.333 -0.649,-0.706 -1.114,-1.646 -1.422,-2.878 -0.504,-2.018 -0.365,-4.025 -0.351,-4.217 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.511,0 4.49,2.178 5.338,4.337 0.481,1.227 0.574,2.259 0.274,3.067 -0.3,0.82 -1.25,1.37 -2.34,1.37 z m -28.51,-1.18 c -15.737,-0.554 -23.904,-5.027 -27.984,-8.683 -2.297,-2.058 -3.574,-4.098 -4.24,-5.447 -0.628,-1.274 -0.866,-2.249 -0.908,-2.438 l 0.021,-0.009 c 0.003,0 1.489,-0.532 3.885,-0.579 l 0.368,-0.004 c 5.307,0 16.111,2.229 28.852,17.153 v 0.01 z m 17.09,-1.59 c -12.661,-1.928 -19.834,-7.363 -23.622,-11.585 -3.971,-4.425 -5.16,-8.546 -5.213,-8.738 0.023,-0.007 1.57,-0.41 3.9,-0.469 0.169,-0.005 0.345,-0.007 0.524,-0.007 0.181,0 0.365,0.002 0.553,0.007 6.368,0.139 17.934,3.023 23.855,20.785 h 0.01 z m -65,-6.08 c -4.149,0 -8.174,-0.48 -11.962,-1.427 -6.629,-1.658 -9.473,-4.189 -10.691,-6.021 -0.692,-1.04 -0.943,-1.952 -1.031,-2.534 -0.085,-0.556 -0.04,-0.999 -0.031,-1.073 l 0.031,-0.011 c 0.017,-0.004 4.4,-1.235 10.464,-1.328 0.239,-0.004 0.48,-0.006 0.725,-0.006 2.927,0 5.808,0.279 8.564,0.83 10.536,2.107 16,10.06 16.053,10.14 l 0.005,0.009 -0.013,0.003 c -0.06,0.01 -5.08,1.42 -12.12,1.42 z m 29.39,-10.68 c -1.269,0 -2.395,-0.463 -3.172,-1.304 -0.639,-0.691 -1.104,-1.643 -1.42,-2.908 -0.506,-2.015 -0.365,-4.002 -0.351,-4.185 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.506,0 4.488,2.179 5.339,4.338 0.468,1.188 0.55,2.208 0.243,3.034 -0.31,0.84 -1.22,1.38 -2.31,1.38 z m -22.1,-3.03 c -0.095,-0.023 -5.977,-1.536 -11.967,-5.225 -5.544,-3.413 -12.326,-9.45 -13.153,-18.83 v -0.005 l 0.014,-0.004 c 0.001,0 0.516,-0.125 1.278,-0.154 0.105,-0.004 0.217,-0.006 0.334,-0.006 1.656,0 5.046,0.466 9.147,3.584 5.22,3.98 10.04,10.92 14.35,20.65 z m 14.43,-0.53 c -0.037,-0.015 -4.229,-1.693 -9.469,-6.084 -4.882,-4.092 -11.746,-11.46 -16.716,-23.33 0.003,-0.001 1.142,-0.608 2.886,-0.718 0.101,-0.007 0.203,-0.009 0.306,-0.009 0.15,0 0.305,0.005 0.463,0.009 2.411,0.068 6.083,1.07 10.154,5.463 4.676,5.047 8.85,13.34 12.404,24.651 l 0.01,0.032 -0.03,-0.01 z m -37.39,-1.09 c -4.821,0 -6.471,-2.615 -6.957,-3.74 -0.798,-1.849 -0.556,-3.689 -0.554,-3.707 l 0.003,-0.02 c 0.78,-0.195 1.605,-0.303 2.398,-0.314 l 0.165,-0.001 c 3.799,0 6.798,1.929 8.084,3.841 0.255,0.379 1.037,1.694 0.39,2.721 -0.52,0.81 -1.7,1.22 -3.53,1.22 z m -10.68,-13.47 c -2.692,0 -6.811,-0.165 -11.141,-0.952 -4.294,-0.781 -6.728,-4.432 -8.013,-7.356 -1.399,-3.185 -1.794,-6.223 -1.798,-6.254 h 0.012 c 13.282,0.39 19.555,4.271 22.478,7.457 3.018,3.29 3.197,6.706 3.206,6.922 l -0.009,10e-4 c -0.02,0 -1.89,0.18 -4.74,0.18 z m 13.83,-13.82 c -0.018,-0.022 -1.535,-1.898 -3.033,-4.228 -1.573,-2.445 -3.028,-4.996 -3.028,-7.084 0,-2.016 -0.474,-6.266 -0.757,-8.619 -0.358,-2.985 -0.72,-5.54 -0.75,-5.757 l 0.013,0.004 c 0.337,0.123 8.308,3.114 8.308,10.591 0,7.489 -0.738,15.014 -0.745,15.089 l -0.001,0.011 h -0.01 z m -10.33,-0.71 c -0.084,0 -0.167,-0.008 -0.25,-0.021 -2.356,-0.393 -6.496,-2.194 -11.073,-4.818 -5.082,-2.914 -9.209,-6.036 -11.62,-8.791 -2.198,-2.512 -3.503,-6.457 -3.88,-11.726 -0.267,-3.739 0.053,-6.854 0.087,-7.163 0.412,-0.137 0.85,-0.204 1.315,-0.204 1.764,0.029 3.647,0.823 6.189,2.574 1.981,1.365 4.165,3.221 6.49,5.514 4.012,3.957 7.168,7.932 7.199,7.971 l 0.032,0.04 c 0.265,0.475 2.537,4.571 4.307,8.558 1.124,2.532 1.767,4.357 2.024,5.746 0.147,0.791 0.19,1.31 -0.004,1.781 -0.081,0.195 -0.235,0.376 -0.385,0.448 -0.14,0.06 -0.28,0.09 -0.44,0.09 z" /><path
               fill="#435125"
               id="use1142"
               d="m 274.08607,445.71112 c 0.18,-0.086 0.218,-0.122 0.347,-0.245 l 0.125,-0.117 c 0.324,-0.297 0.861,-0.822 1.582,-1.643 1.332,-1.513 3.119,-3.728 4.69,-5.685 3.115,-3.883 5.689,-7.228 6.174,-7.858 l 0.793,-1.032 7.767,-2.395 5.671,-2.644 -3.03,-3.406 -10.408,4.456 -7.767,1.594 -14.363,10.564 0.011,0.009 c 0.029,0.024 2.089,1.738 4.136,3.599 0.913,0.83 2.064,1.896 2.877,2.783 0.375,0.408 0.705,0.813 0.93,1.14 0.138,0.201 0.215,0.383 0.252,0.471 l -0.892,-0.555 -0.967,0.752 1.968,0.184 0.09,0.02 z m 53.34,-16.02 c 6.777,-0.001 13.471,-1.874 19.895,-5.567 l 0.007,-0.004 -0.003,-0.008 c 0,0 -0.84,-1.601 -2.878,-3.096 -1.941,-1.425 -5.442,-3.128 -11.1,-3.15 h -0.117 c -6.701,0 -14.901,2.278 -24.373,6.771 0.32,0.212 7.756,5.054 18.566,5.054 l -0.01,0.01 z m 29.37,-6.51 c 1.253,0 2.379,-0.474 3.17,-1.333 0.649,-0.706 1.114,-1.646 1.422,-2.878 0.504,-2.018 0.365,-4.025 0.351,-4.217 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.511,0 -4.49,2.178 -5.338,4.337 -0.481,1.227 -0.574,2.259 -0.274,3.067 0.3,0.81 1.24,1.37 2.34,1.37 z m -51.68,-5.99 c 17.359,-2.479 24.717,-8.755 27.833,-13.583 3.323,-5.149 2.641,-9.912 2.634,-9.96 l -0.003,-0.014 -0.013,-0.004 c -0.005,0 -1.061,-0.285 -2.658,-0.293 -4.618,0 -16.43,2.323 -27.798,23.842 l -0.007,0.014 0.02,-0.01 z m 35.58,-3.44 c 7.416,-0.001 13.062,-1.28 16.782,-3.804 2.138,-1.45 3.184,-3.043 3.686,-4.125 0.47,-1.014 0.577,-1.856 0.594,-2.023 -0.196,-0.09 -3.232,-1.438 -7.765,-1.65 -0.383,-0.018 -0.769,-0.029 -1.174,-0.03 -5.732,0 -14.448,1.87 -23.646,10.78 l -0.009,0.009 0.011,10e-4 c 4.2,0.55 8.08,0.84 11.53,0.84 z m 35.91,-1.38 c 7.82,0 18.563,-2.388 25.263,-9.087 l 0.007,-0.008 -0.02,-0.005 c -0.07,-0.018 -7.342,-1.863 -15.523,-2.062 -0.488,-0.012 -0.979,-0.019 -1.475,-0.019 -7.332,0 -12.944,1.422 -16.682,4.225 -1.305,0.979 -2.018,1.89 -2.178,2.783 -0.134,0.746 0.26,1.55 1.056,2.15 1.683,1.271 4.692,1.949 8.945,2.017 l 0.6,0.02 z m 25.34,-13 c 0.963,0 1.867,-0.426 2.479,-1.167 0.506,-0.614 0.858,-1.416 1.108,-2.522 0.418,-1.848 0.292,-3.656 0.291,-3.674 l -0.001,-0.018 c -0.364,-0.172 -0.771,-0.264 -1.217,-0.275 h -0.003 c -1.157,0 -2.039,0.63 -2.589,1.158 -0.733,0.705 -1.333,1.645 -1.688,2.645 -0.365,1.03 -0.424,1.892 -0.18,2.635 0.2,0.59 0.88,1.21 1.8,1.21 z m -58.53,-1.32 c 1.253,0 2.379,-0.474 3.17,-1.333 0.649,-0.706 1.114,-1.646 1.422,-2.878 0.504,-2.018 0.365,-4.025 0.351,-4.217 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.511,0 -4.49,2.178 -5.338,4.337 -0.481,1.227 -0.574,2.259 -0.274,3.067 0.3,0.82 1.25,1.37 2.34,1.37 z m 28.51,-1.18 c 15.737,-0.554 23.904,-5.027 27.984,-8.683 2.297,-2.058 3.574,-4.098 4.24,-5.447 0.628,-1.274 0.866,-2.249 0.908,-2.438 l -0.021,-0.009 c -0.003,0 -1.489,-0.532 -3.885,-0.579 l -0.368,-0.004 c -5.307,0 -16.111,2.229 -28.852,17.153 v 0.01 z m -17.09,-1.59 c 12.661,-1.928 19.834,-7.363 23.622,-11.585 3.971,-4.425 5.16,-8.546 5.213,-8.738 -0.023,-0.007 -1.57,-0.41 -3.9,-0.469 -0.169,-0.005 -0.345,-0.007 -0.524,-0.007 -0.181,0 -0.365,0.002 -0.553,0.007 -6.368,0.139 -17.934,3.023 -23.855,20.785 h -0.01 z m 65,-6.08 c 4.149,0 8.174,-0.48 11.962,-1.427 6.629,-1.658 9.473,-4.189 10.691,-6.021 0.692,-1.04 0.943,-1.952 1.031,-2.534 0.085,-0.556 0.04,-0.999 0.031,-1.073 l -0.031,-0.011 c -0.017,-0.004 -4.4,-1.235 -10.464,-1.328 -0.239,-0.004 -0.48,-0.006 -0.725,-0.006 -2.927,0 -5.808,0.279 -8.564,0.83 -10.536,2.107 -16,10.06 -16.053,10.14 l -0.005,0.009 0.013,0.003 c 0.06,0.01 5.08,1.42 12.12,1.42 z m -29.39,-10.68 c 1.269,0 2.395,-0.463 3.172,-1.304 0.639,-0.691 1.104,-1.643 1.42,-2.908 0.506,-2.015 0.365,-4.002 0.351,-4.185 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.506,0 -4.488,2.179 -5.339,4.338 -0.468,1.188 -0.55,2.208 -0.243,3.034 0.31,0.84 1.22,1.38 2.31,1.38 z m 22.1,-3.03 c 0.095,-0.023 5.977,-1.536 11.967,-5.225 5.544,-3.413 12.326,-9.45 13.153,-18.83 v -0.005 l -0.014,-0.004 c -10e-4,0 -0.516,-0.125 -1.278,-0.154 -0.105,-0.004 -0.217,-0.006 -0.334,-0.006 -1.656,0 -5.046,0.466 -9.147,3.584 -5.22,3.98 -10.04,10.92 -14.35,20.65 z m -14.43,-0.53 c 0.037,-0.015 4.229,-1.693 9.469,-6.084 4.882,-4.092 11.746,-11.46 16.716,-23.33 -0.003,-0.001 -1.142,-0.608 -2.886,-0.718 -0.101,-0.007 -0.203,-0.009 -0.306,-0.009 -0.15,0 -0.305,0.005 -0.463,0.009 -2.411,0.068 -6.083,1.07 -10.154,5.463 -4.676,5.047 -8.85,13.34 -12.404,24.651 l -0.01,0.032 0.03,-0.01 z m 37.39,-1.09 c 4.821,0 6.471,-2.615 6.957,-3.74 0.798,-1.849 0.556,-3.689 0.554,-3.707 l -0.003,-0.02 c -0.78,-0.195 -1.605,-0.303 -2.398,-0.314 l -0.165,-0.001 c -3.799,0 -6.798,1.929 -8.084,3.841 -0.255,0.379 -1.037,1.694 -0.39,2.721 0.52,0.81 1.7,1.22 3.53,1.22 z m 10.68,-13.47 c 2.692,0 6.811,-0.165 11.141,-0.952 4.294,-0.781 6.728,-4.432 8.013,-7.356 1.399,-3.185 1.794,-6.223 1.798,-6.254 h -0.012 c -13.282,0.39 -19.555,4.271 -22.478,7.457 -3.018,3.29 -3.197,6.706 -3.206,6.922 l 0.009,10e-4 c 0.02,0 1.89,0.18 4.74,0.18 z m -13.83,-13.82 c 0.018,-0.022 1.535,-1.898 3.033,-4.228 1.573,-2.445 3.028,-4.996 3.028,-7.084 0,-2.016 0.474,-6.266 0.757,-8.619 0.358,-2.985 0.72,-5.54 0.75,-5.757 l -0.013,0.004 c -0.337,0.123 -8.308,3.114 -8.308,10.591 0,7.489 0.738,15.014 0.745,15.089 l 10e-4,0.011 h 0.01 z m 10.33,-0.71 c 0.084,0 0.167,-0.008 0.25,-0.021 2.356,-0.393 6.496,-2.194 11.073,-4.818 5.082,-2.914 9.209,-6.036 11.62,-8.791 2.198,-2.512 3.503,-6.457 3.88,-11.726 0.267,-3.739 -0.053,-6.854 -0.087,-7.163 -0.412,-0.137 -0.85,-0.204 -1.315,-0.204 -1.764,0.029 -3.647,0.823 -6.189,2.574 -1.981,1.365 -4.165,3.221 -6.49,5.514 -4.012,3.957 -7.168,7.932 -7.199,7.971 l -0.032,0.04 c -0.265,0.475 -2.537,4.571 -4.307,8.558 -1.124,2.532 -1.767,4.357 -2.024,5.746 -0.147,0.791 -0.19,1.31 0.004,1.781 0.081,0.195 0.235,0.376 0.385,0.448 0.14,0.06 0.28,0.09 0.44,0.09 z" /><path
               fill="#d47600"
               d="m 565.53807,42.937117 -2.355,0.938 -0.923,0.368 -2.854,-0.157 -2.673,1.283 -4.74,3.239 -0.209,0.15 -1.767,0.461 -1.641,-0.708 -0.932,0.424 -0.321,1.92 -0.887,1.379 -1.092,0.767 -3.783,0.387 -3.19,1.645 -4.15,-1.111 -1.928,0.755 -4.099,3.692 -2.095,0.992 -0.732,-0.042 -2.778,-0.143 -1.173,0.384 -1.752,1.693 -3.315,0.258 -1.033,0.715 -1.618,3.26 -1.753,1.808 -1.003,0.212 -1.087,-0.398 -0.817,0.144 -0.37,2.086 -0.793,0.874 -2.219,0.764 -1.773,1.477 -1.556,0.799 -2.084,-0.052 h -0.479 l -2.076,1.146 -3.905,0.342 -1.624,1.549 -0.358,0.331 -0.758,0.458 -1.24,0.74 -0.304,0.184 -1.495,-0.267 -1.75,0.693 -0.708,-1.089 -1.211,0.727 -1.604,0.069 -1.998,-0.889 -1.522,-0.678 -1.113,0.161 -0.387,1.94 -0.039,0.206 -1.17,1.557 -2.184,1.323 -0.297,0.387 -2.485,3.208 -4.722,4.966 -3.993,2.028 -4.139,1.259 -2.897,2.38 -7.599,3.767 -11.994,5.967003 -2.453,0.786 -3.52,0.562 -6.278,2.312 -5.539,1.671 -0.308,0.094 -1.096,0.332 -7.81,2.363 -3.635,-0.384 -2.153,0.782 -5.605,-0.622 -3.897,0.077 -2.467,0.513 -4.637,2.224 -7.827,3.762 -2.586,2.366 -4.027,2.101 -4.715,1.493 0.011,-1.981 -0.028,-0.084 -1.636,0.517 -1.181,0.373 -3.825,0.59 h -2.128 l -1.321,-0.384 -0.204,0.069 -7.818,2.576 -8.719,0.842 -4.363,1.399 -3.26,-0.052 -2.038,0.607 -3.995,0.488 -1.428,-0.381 -0.322,-0.088 -11.75,0.51 -5.372,-0.607 -2.564,0.583 -4.296,-1.445 -6.269,-0.727 -1.465,-0.439 -3.295,-0.978 -1.491,0.859 -1.116,0.119 -2.667,-0.967 -0.96,-0.025 -2.202,0.796 -1.267,-0.325 -1.177,-0.938 -2.761,-0.411 -1.682,-1.414 -9.402,1.246 -2.551,-0.75 -8.554,-2.492 -1.361,0.069 -1.696,1.271 -2.548,0.929 -2.212,0.575 -3.012,0.105 -3.497,-0.918 -3.606,-1.748 -1.333,-0.317 -2.974,0.3 -0.91,0.083 -5.466,-2.932 -7.042,-4.404 -4.778,-2.296 -1.794,-0.291 -0.241,0.853 0.89,2.805 0.303,2.774 -0.091,2.563 -0.049,1.587 0.446,1.425 1.725,1.912 0.719,1.92 0.526,5.284 -0.006,5.362 -0.839,8.551 -0.283,1.302 -1.001,4.43 -0.914,4.069 -3.546,10.833 -0.974,1.343 -2.391,1.631 -5.419,3.688 -3.99,2.301 -1.263,0.523 -3.239,0.245 -2.018,-0.105 -2.513,-1.361 -2.467,-0.635 -3.232,-2.324 -3.595,-0.744 -3.941,-2.278 -1.026,-1.233 -2.146,-0.202 -2.976,-0.893 0.002,-0.005 -1.093,-0.327 -0.755,-0.22 v -0.001 l -3.796,-0.104 -3.54,-1.634 -1.864,-0.45 -2.547,-0.129 -2.666,1.239 -0.001,-0.004 -1.351,0.629 -1.707,-0.678 -1.235,0.077 -1.399,2.115 -0.209,0.328 -0.964,0.51 -1.2,-0.017 -0.939,-0.025 -1.016,0.444 -1.368,0.593 v 0.003 l -1.208,0.527 -0.59,0.255 -0.01,-0.01 -0.363,0.073 -0.645,0.112 -0.8,0.153 -1.41,-0.824 -0.75,-0.442 -1.257,-0.256 -0.677,0.489 -0.133,2.301 -0.618,1.378 -1.961,1.734 -1.993,1.755 -1.389,2.047 -3.676,8.39 -2.303,3.385 -0.715,0.789 -2.408,2.656 -2.136,1.657 -4.922,3.815 -4.659,1.741 -4.013,0.82 -1.951,0.008 -3.695998,-0.492 -3.323,-1.02 -3.65,-2.282 -4.003,-3.217 -5.794,-5.724 -0.82,-0.493 -0.171,-0.114 -1.825,-1.167 -1.354,0.035 -0.53,0.874 -0.29,1.263 -0.245,1.12 -0.664,6.367 0.049,0.369 0.349,2.622 4.401,6.15 1.358,3.267 0.223,0.373 0.908,1.525 0.691,1.163 0.069,0.118 1.504,4.488 -1.057,2.534 0.534,1.697 -1.336,1.037 -0.245,1.465 3.951,4.953 0.862,2.185 -0.963,3.029 -1.536,1.671 -0.429,0.457 0.216,1.28 1.818,1.635 3.089,2.75 1.647,4.086 1.253,1.096 1.456,-0.31 0.81,0.618 1.228,-0.021 1.208,1.208 0.782,0.379 1.236,0.616 0.977,1.272 0.216,3.911 1.821998,4.86 0.028,2.635 0.01,0.374 1.134,1.948 0.356,1.538 -0.604,4.069 1.445,1.306 1.567,-0.32 1.012,0.16 1.626,1.354 1.969,3.001 1.926,-0.282 1.222,0.589 5.902,5.334 1.339,0.676 0.074,0.042 0.963,0.483 1.197,1.208 1.856,-1.232 0.206,-0.021 2.018,-0.178 0.886,0.597 1.704,1.149 2.234,-0.029 4.844,1.485 2.119,0.543 4.261,2.648 1.811,1.12 1.072,0.871 1.424,1.161 2.845,1.224 2.44,0.584 1.322,0.314 0.995,0.384 0.025,-0.062 0.014,0.004 -0.024,0.063 5.284,2.023 2.862,0.668 2.648,0.975 1.927,0.703 1.414,0.023 2,-1.682 1.937,-0.112 1.609,0.401 1.57,-0.263 2.485,-1.531 0.485,-0.719 1.762,-0.839 5.944,-0.738 1.737,0.564 4.46,-1.94 2.988,0.831 2.645,-0.938 5.779,1.284 1.536,1.081 1.717,1.965 0.21,0.009 1.912,0.037 -0.799,1.331 2.523,2.647 2.279,3.445 0.154,0.455 1.657,4.864 1.232,1.723 0.862,2.405 0.042,1.568 -1.34,1.022 -0.22,0.583 -0.076,0.216 0.272,0.655 0.506,-0.276 0.963,-0.533 1.166,-0.181 2.066,0.22 1.364,0.143 2.154,-1.069 1.427,-0.71 2.293,0.987 2.52,-0.028 1.058,0.471 2.995,1.358 1.529,0.144 0.565,-0.371 0.36,-0.856 -0.185,-0.996 -1.145,-1.323 -2.531,-2.938 -1.036,-1.51 -0.789,-2.186 -0.245,-2.794 -0.174,-1.885 0.314,-2.477 0.68,-0.884 0.5,-1.968 h 0.009 l 0.129,-0.515 1.406,-1.866 3.724,-2.393 4,-3.582 3.162,-2.085 3.26,-1.412 0.087,-0.396 0.363,0.146 8.292,-2.819 0.137,-0.016 3.692,-0.643 24.92,1.755 0.924,-0.279 0.004,-0.006 0.83,-2.33 0.447,-0.432 0.297,-0.282 2.74,-1.206 1.281,-0.183 3.556,0.878 1.456,0.359 2.332,-1.307 1.654,0.028 3.417,-1.866 2.111,0.053 0.803,-0.321 4.112,-2.955 3.961,-1.135 1.03,-0.548 0.363,-0.199 4.06,-2.144 2.579,-1.981 2.226,-1.183 2.438,-0.629 6.38,-0.449 1.283,-2.138 2.744,-0.366 1.657,-1.87 1.896,-0.771 1.359,-1.958 1.139,-1.641 1.591,-0.921 5.1,-0.32 6.045,0.749 0.799,-0.485 1.366,-4.875 1.43,-0.915 3.851,-5.612 0.013,-2.045 0.004,-1.708 0.633,-2.432 -0.43,-4.391 0.51,-4.446 2.394,-5.65 2.109,-2.279 3.401,-2.301 1.729,-0.753 2.449,-0.412 v -0.006 l 0.36,-0.061 0.624,-0.107 8.433,-0.116 c 0.117,-0.087 3.067,-0.042 3.067,-0.042 l 2.812,-0.038 7.114,1.266 0.506,0.088 2.405,0.779 2.774,2.157 2.936,2.868 0.551,0.535 1.902,0.801 0.575,0.251 1.571,-0.251 2.237,-1.165 1.688,-1.427 2.301,-1.257 0.056,-0.08 1.295,-1.948 0.039,-0.04 0.028,0.007 0.003,-0.011 -0.022,-0.005 0.511,-0.775 4.447,-1.733 5.23,-0.304 0.588,-0.318 0.327,-0.175 1.382,-1.623 1.295,-0.011 3.135,1.134 2.204,-0.437 1.75,0.699 1.36,-0.161 2.565,-0.304 2.754,1.938 1.605,0.205 5.658,3.31 0.294,0.048 0.152,0.028 0.324,0.053 0.671,-0.199 0.998,-0.289 0.132,-0.039 0.126,0.174 0.643,0.907 0.882,0.126 1.044,-1.393 -0.415,-0.632 -0.157,-0.23 -2.021,-0.411 -1.815,-3.103 1.728,-1.861 -2.711,-3.326 -0.45,-0.551 -0.153,-0.234 -0.937,-1.423 -4.746,-7.235 -6.182,-4.935 -0.002,0.004 -2.165,-1.732 -0.014,-0.01 -0.758,-0.596 -3.302,-3.358 -2.358,-3.13 -0.309,-0.674 -0.487,-1.062 -1.413,-3.078 -2.462,-1.896 -2.006,-2.191 -0.098,-0.129 -4.14,-5.626 -0.68,-0.943 -0.978,-0.565 -2.066,-0.014 -0.195,-0.196 -0.116,-0.121 0.07,-0.074 0.991,-0.985 1.105,-0.278 0.476,-1.089 -2.108,-6.104 -0.014,-0.213 -0.157,-1.95 1.718,-8.855 0.22,-1.079 2.928,-5.958 1.814,-1.486 1.98,-3.892 1.696,-2.488 1.625,-1.582 0.284,-0.168 2.934,-1.776 2.465,-0.347 2.348,-0.331 4.099,1.264 3.901,-0.076 0.761,-0.081 1.77,-0.203 2.911,-0.917 1.374,-0.848 0.713,-1.093 1.487,-4.987 0.478,-1.587 0.917,-1.724 5.306,-6.108 4.011,-3.71 9.019,-6.613 4.415,-2.639 2.254,-1.347 20.126,-8.946003 5.23,-5.302 2.725,-2.757 4.821,-3.235 5.641,-2.311 4.854,-3.842 1.06,-1.334 1.336,-4.303 1.113,-0.269 1.005,-2.174 0.286,-0.618 3.961,-2.792 0.448,-0.223 15.388,-7.71 2.236,0.307 1.197,-1.793 4.477,-0.751 0.824,-0.14 1.104,-0.551 0.939,-1.599 v -0.316 l 0.129,-4.273 0.956,-1.155 0.521,-2.816 0.491,-0.65 0.513,-0.676 1.268,-0.891 -0.22,-0.531 z"
               id="path1144" /></g></clipPath></defs><g
         id="g6"
         transform="translate(0,-88.275391)" /><g
         id="g8"
         transform="translate(0,-88.275391)" /><g
         id="g10"
         transform="translate(0,-88.275391)" /><g
         id="g12"
         transform="translate(0,-88.275391)" /><g
         id="g14"
         transform="translate(0,-88.275391)" /><g
         id="g16"
         transform="translate(0,-88.275391)" /><g
         id="g18"
         transform="translate(0,-88.275391)" /><g
         id="g20"
         transform="translate(0,-88.275391)" /><g
         id="g22"
         transform="translate(0,-88.275391)" /><g
         id="g24"
         transform="translate(0,-88.275391)" /><g
         id="g26"
         transform="translate(0,-88.275391)" /><g
         id="g28"
         transform="translate(0,-88.275391)" /><g
         id="g30"
         transform="translate(0,-88.275391)" /><g
         id="g32"
         transform="translate(0,-88.275391)" /><g
         id="g34"
         transform="translate(0,-88.275391)" /><path
         fill="#009e49"
         d="M 8.828125,0 C 3.9531254,0 0,3.953125 0,8.828125 V 326.62109 c 0,4.13684 2.8504736,7.59977 6.6914062,8.55664 H 505.30859 c 3.84096,-0.95667 6.69251,-4.41895 6.69336,-8.55664 V 8.828125 C 512.00195,3.953125 508.04883,0 503.17383,0 Z"
         id="rect2" /><path
         fill="#ffffff"
         d="M 4.1289062,1.365234 C 1.6515258,2.928808 0,5.682524 0,8.828125 V 326.62109 c 0,2.65869 1.1811954,5.03769 3.0410156,6.65625 L 512.00195,167.625 v -0.96094 z"
         id="path4" /><path
         fill="#fcd116"
         d="M 0,14.640629 V 319.64844 L 468.04492,167.14453 Z"
         id="path6" /><path
         fill="#1a1a1a"
         d="M 2.5703125,2.603515 C 0.98244581,4.199807 0,6.399079 0,8.828125 V 326.62109 c 0,2.07572 0.72057079,3.98085 1.9199219,5.48829 L 255.3418,167.14453 Z"
         id="path2" /><path
         fill="#ce1126"
         d="M 0,20.533199 V 313.75586 L 225.24219,167.14453 Z"
         id="path10" />
  </svg>
);

export const HK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs21" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 224.477,268.923 c -11.128,0.115 -23.624,-3.449 -34.573,-15.518 -0.755,-0.832 -0.649,-2.143 0.209,-2.87 l 0.003,-0.003 c 0.832,-0.705 2.062,-0.596 2.797,0.211 16.69,18.327 37.376,15.118 49.735,10.69 -4.566,0.203 -10.303,-0.14 -13.993,-2.565 -15.415,-10.133 -8.433,-20.913 -18.671,-33.944 -10.173,-12.948 -19.327,-12.631 -33.741,-10.446 -14.27,2.162 -18.816,-8.305 -20.231,-14.114 -0.253,-1.041 -1.705,-1.106 -2.077,-0.103 -17.786,48.054 35.694,107.514 90.601,64.761 -5.418,1.995 -12.396,3.823 -20.059,3.901 z M 184.41,252.616 c -0.312,0.858 -1.537,0.824 -1.802,-0.05 l -2.048,-6.749 -7.049,-0.247 c -0.913,-0.032 -1.259,-1.207 -0.51,-1.729 l 5.786,-4.033 -1.943,-6.781 c -0.252,-0.877 0.759,-1.57 1.487,-1.02 l 5.624,4.256 5.848,-3.944 c 0.757,-0.511 1.729,0.236 1.429,1.099 l -2.31,6.664 5.558,4.343 c 0.719,0.563 0.309,1.717 -0.604,1.699 l -7.052,-0.138 z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 263.869,236.996 c 8.836,-6.765 20.972,-11.407 36.972,-8.317 1.103,0.213 1.805,1.325 1.555,2.421 l -0.001,0.004 c -0.243,1.064 -1.293,1.714 -2.365,1.508 -24.346,-4.657 -38.976,10.317 -46.209,21.272 3.532,-2.901 8.329,-6.067 12.736,-6.338 18.412,-1.137 19.289,11.678 35.298,15.965 15.905,4.259 23.04,-1.483 33.266,-11.876 10.122,-10.289 20.038,-4.639 24.653,-0.839 0.826,0.681 2.027,-0.137 1.723,-1.163 -14.586,-49.12 -93.042,-64.627 -111.339,2.513 3.137,-4.843 7.626,-10.491 13.711,-15.15 z m 41.842,-10.979 c -0.265,-0.874 0.736,-1.582 1.472,-1.042 l 5.686,4.172 5.789,-4.03 c 0.749,-0.522 1.731,0.211 1.446,1.078 l -2.211,6.698 5.621,4.26 c 0.728,0.552 0.334,1.713 -0.578,1.708 l -7.053,-0.033 -2.314,6.663 c -0.3,0.863 -1.525,0.847 -1.803,-0.022 l -2.148,-6.718 -7.052,-0.142 c -0.913,-0.019 -1.277,-1.188 -0.535,-1.721 l 5.726,-4.119 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 234.399,241.627 c -4.34,-10.248 -5.8,-23.159 1.195,-37.877 0.482,-1.015 1.735,-1.416 2.733,-0.899 l 0.004,0.002 c 0.969,0.501 1.335,1.681 0.87,2.667 -10.599,22.408 0.241,40.318 9.038,50.061 -1.926,-4.146 -3.79,-9.581 -2.952,-13.917 3.505,-18.111 16.131,-15.756 24.286,-30.184 8.103,-14.335 4.327,-22.679 -3.178,-35.178 -7.43,-12.374 0.521,-20.561 5.355,-24.079 0.865,-0.63 0.374,-1.997 -0.695,-1.959 -51.207,1.837 -85.845,73.92 -25.416,108.428 -3.905,-4.25 -8.251,-10.008 -11.24,-17.065 z m -0.165,-43.258 c -0.913,0.038 -1.347,-1.108 -0.64,-1.685 l 5.462,-4.462 -2.454,-6.613 c -0.318,-0.856 0.638,-1.624 1.405,-1.13 l 5.932,3.816 5.53,-4.377 c 0.716,-0.567 1.741,0.104 1.508,0.988 l -1.796,6.82 5.871,3.907 c 0.76,0.506 0.439,1.688 -0.472,1.74 l -7.042,0.399 -1.901,6.792 c -0.246,0.879 -1.47,0.939 -1.801,0.088 l -2.556,-6.573 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 274.297,264.88 c 9.198,6.264 17.418,16.328 19.508,32.489 0.145,1.115 -0.692,2.13 -1.811,2.237 h -0.006 c -1.086,0.104 -2.033,-0.69 -2.175,-1.771 -3.225,-24.577 -22.037,-33.763 -34.71,-37.19 3.863,2.442 8.375,6.002 10.018,10.101 6.862,17.123 -5.028,21.982 -4.071,38.527 0.951,16.438 8.646,21.408 21.724,27.852 12.947,6.379 10.698,17.566 8.538,23.143 -0.386,0.999 0.767,1.881 1.645,1.27 42.052,-29.276 32.134,-108.631 -37.355,-104.915 5.591,1.457 12.362,3.944 18.695,8.257 z m 23.567,36.276 c 0.747,-0.526 1.732,0.202 1.451,1.07 l -2.175,6.709 5.644,4.231 c 0.73,0.547 0.344,1.71 -0.569,1.711 l -7.053,0.004 -2.279,6.675 c -0.295,0.864 -1.521,0.855 -1.803,-0.013 l -2.184,-6.707 -7.052,-0.105 c -0.914,-0.013 -1.283,-1.182 -0.545,-1.719 l 5.704,-4.15 -2.08,-6.74 c -0.269,-0.873 0.727,-1.586 1.466,-1.049 l 5.709,4.142 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 251.292,284.823 c -3.168,10.668 -10.254,21.56 -25.013,28.469 -1.018,0.477 -2.239,-0.011 -2.681,-1.044 l -0.002,-0.004 c -0.429,-1.003 0.039,-2.146 1.025,-2.611 22.43,-10.551 25.457,-31.265 24.865,-44.38 -1.151,4.424 -3.169,9.804 -6.573,12.617 -14.223,11.747 -22.47,1.899 -37.939,7.846 -15.37,5.908 -17.763,14.75 -19.922,29.169 -2.136,14.274 -13.479,15.535 -19.447,15.176 -1.068,-0.064 -1.559,1.303 -0.71,1.954 40.684,31.15 113.258,-2.444 88.574,-67.507 0.314,5.762 0.005,12.968 -2.177,20.315 z m -27.386,33.486 c 0.728,0.552 0.335,1.711 -0.578,1.708 l -7.052,-0.031 -2.312,6.664 c -0.299,0.863 -1.525,0.847 -1.803,-0.022 l -2.151,-6.718 -7.052,-0.14 c -0.913,-0.018 -1.278,-1.188 -0.536,-1.721 l 5.724,-4.121 -2.046,-6.75 c -0.265,-0.874 0.735,-1.582 1.471,-1.042 l 5.688,4.17 5.788,-4.032 c 0.749,-0.522 1.731,0.211 1.446,1.078 l -2.208,6.698 z"
       id="path6" />
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const HN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs22" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#4173cd"
       d="M 512,200.093 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#4173cd"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 V 311.909 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#4173cd"
       d="m 257.277,241.579 3.159,9.473 9.985,0.077 c 1.293,0.01 1.828,1.66 0.789,2.428 l -8.033,5.932 3.012,9.521 c 0.389,1.233 -1.013,2.252 -2.066,1.501 l -8.123,-5.807 -8.124,5.806 c -1.052,0.751 -2.455,-0.268 -2.066,-1.501 l 3.012,-9.521 -8.033,-5.932 c -1.039,-0.768 -0.504,-2.418 0.789,-2.428 l 9.985,-0.077 3.159,-9.473 c 0.411,-1.225 2.145,-1.225 2.555,0.001 z"
       id="path3" />
    	<path
       fill="#4173cd"
       d="m 167.104,267.002 3.159,9.473 9.985,0.077 c 1.293,0.01 1.828,1.66 0.789,2.428 l -8.033,5.932 3.012,9.521 c 0.39,1.233 -1.013,2.252 -2.066,1.501 l -8.124,-5.806 -8.124,5.806 c -1.052,0.751 -2.455,-0.268 -2.066,-1.501 l 3.012,-9.521 -8.033,-5.932 c -1.039,-0.768 -0.504,-2.418 0.789,-2.428 l 9.985,-0.077 3.159,-9.473 c 0.412,-1.226 2.147,-1.226 2.556,0 z"
       id="path4" />
    	<path
       fill="#4173cd"
       d="m 167.104,216.155 3.159,9.473 9.985,0.077 c 1.293,0.01 1.828,1.66 0.789,2.428 l -8.033,5.932 3.012,9.521 c 0.39,1.233 -1.013,2.252 -2.066,1.501 l -8.124,-5.806 -8.124,5.806 c -1.052,0.751 -2.455,-0.268 -2.066,-1.501 l 3.012,-9.521 -8.033,-5.932 c -1.039,-0.768 -0.504,-2.418 0.789,-2.428 l 9.985,-0.077 3.159,-9.473 c 0.412,-1.225 2.147,-1.225 2.556,0 z"
       id="path5" />
    	<path
       fill="#4173cd"
       d="m 347.449,267.002 3.159,9.473 9.985,0.077 c 1.293,0.01 1.828,1.66 0.789,2.428 l -8.033,5.932 3.012,9.521 c 0.39,1.233 -1.013,2.252 -2.066,1.501 l -8.124,-5.806 -8.124,5.806 c -1.052,0.751 -2.455,-0.268 -2.066,-1.501 l 3.012,-9.521 -8.033,-5.932 c -1.041,-0.768 -0.504,-2.418 0.789,-2.428 l 9.985,-0.077 3.159,-9.473 c 0.412,-1.226 2.147,-1.226 2.556,0 z"
       id="path6" />
    	<path
       fill="#4173cd"
       d="m 347.449,216.155 3.159,9.473 9.985,0.077 c 1.293,0.01 1.828,1.66 0.789,2.428 l -8.033,5.932 3.012,9.521 c 0.39,1.233 -1.013,2.252 -2.066,1.501 l -8.124,-5.806 -8.124,5.806 c -1.052,0.751 -2.455,-0.268 -2.066,-1.501 l 3.012,-9.521 -8.033,-5.932 c -1.041,-0.768 -0.504,-2.418 0.789,-2.428 l 9.985,-0.077 3.159,-9.473 c 0.412,-1.225 2.147,-1.225 2.556,0 z"
       id="path7" />
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const HR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs56" />
    <path
       fill="#41479b"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<rect
       x="194.21001"
       y="203.03"
       fill="#ff4b55"
       width="24.716999"
       height="28.25"
       id="rect3" />
    	<rect
       x="243.64"
       y="203.03"
       fill="#ff4b55"
       width="24.716999"
       height="28.25"
       id="rect4" />
    	<rect
       x="218.92"
       y="231.28"
       fill="#ff4b55"
       width="24.716999"
       height="28.25"
       id="rect5" />
    	<rect
       x="293.07001"
       y="203.03"
       fill="#ff4b55"
       width="24.716999"
       height="28.25"
       id="rect6" />
    	<rect
       x="268.35999"
       y="231.28"
       fill="#ff4b55"
       width="24.716999"
       height="28.25"
       id="rect7" />
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<rect
       x="218.92"
       y="203.03"
       fill="#f5f5f5"
       width="24.716999"
       height="28.25"
       id="rect8" />
    	<rect
       x="268.35999"
       y="203.03"
       fill="#f5f5f5"
       width="24.716999"
       height="28.25"
       id="rect9" />
    	<rect
       x="194.21001"
       y="231.28"
       fill="#f5f5f5"
       width="24.716999"
       height="28.25"
       id="rect10" />
    	<rect
       x="243.64"
       y="231.28"
       fill="#f5f5f5"
       width="24.716999"
       height="28.25"
       id="rect11" />
    	<rect
       x="293.07001"
       y="231.28"
       fill="#f5f5f5"
       width="24.716999"
       height="28.25"
       id="rect12" />
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    	<rect
       x="243.64"
       y="259.53"
       fill="#ff4b55"
       width="24.716999"
       height="28.25"
       id="rect13" />
    	<rect
       x="218.92"
       y="287.78"
       fill="#ff4b55"
       width="24.716999"
       height="28.25"
       id="rect14" />
    	<rect
       x="268.35999"
       y="287.78"
       fill="#ff4b55"
       width="24.716999"
       height="28.25"
       id="rect15" />
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    	<rect
       x="218.92"
       y="259.53"
       fill="#f5f5f5"
       width="24.716999"
       height="28.25"
       id="rect16" />
    	<rect
       x="268.35999"
       y="259.53"
       fill="#f5f5f5"
       width="24.716999"
       height="28.25"
       id="rect17" />
    	<rect
       x="243.64"
       y="287.78"
       fill="#f5f5f5"
       width="24.716999"
       height="28.25"
       id="rect18" />
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 317.792,203.035 v 79.448 c 0,34.127 -27.666,61.793 -61.793,61.793 -34.127,0 -61.793,-27.666 -61.793,-61.793 v -79.448 h 123.586 m 4.414,-4.414 h -4.414 -123.586 -4.414 v 4.414 79.448 c 0,36.506 29.7,66.207 66.207,66.207 36.507,0 66.207,-29.7 66.207,-66.207 v -79.448 z"
       id="path18" />
    	<path
       fill="#ff4b55"
       d="m 218.924,287.779 v -28.248 h -24.717 v 22.952 c 0,1.789 0.118,3.546 0.267,5.297 h 24.45 z"
       id="path19" />
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 317.525,287.779 h -24.45 v 28.248 h 14.774 c 5.362,-8.269 8.795,-17.886 9.676,-28.248 z"
       id="path20" />
    	<path
       fill="#f5f5f5"
       d="m 204.15,316.027 h 14.774 V 287.78 h -24.45 c 0.881,10.361 4.315,19.978 9.676,28.247 z"
       id="path21" />
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 293.075,287.779 h 24.45 c 0.149,-1.749 0.267,-3.508 0.267,-5.297 V 259.53 h -24.717 z"
       id="path22" />
    	<path
       fill="#ff4b55"
       d="M 218.924,331.833 V 316.027 H 204.15 c 3.959,6.107 8.973,11.441 14.774,15.806 z"
       id="path23" />
    	<path
       fill="#ff4b55"
       d="m 307.849,316.027 h -14.774 v 15.806 c 5.802,-4.365 10.816,-9.699 14.774,-15.806 z"
       id="path24" />
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 218.924,331.833 c 7.194,5.415 15.567,9.345 24.717,11.202 v -27.008 h -24.717 z"
       id="path25" />
    	<path
       fill="#f5f5f5"
       d="m 268.358,343.035 c 9.15,-1.857 17.523,-5.788 24.717,-11.202 v -15.806 h -24.717 z"
       id="path26" />
    </g>
    <path
       fill="#ff4b55"
       d="m 268.358,227.751 h -24.717 v 27.008 c 3.993,0.811 8.126,1.241 12.359,1.241 4.233,0 8.365,-0.43 12.359,-1.241 v -27.008 z"
       id="path27" />
    <g
       id="g30"
       transform="translate(0,-88.276)">
    	<path
       fill="#4173cd"
       d="m 211.27,156.292 c -5.378,-0.832 -10.88,-1.432 -16.489,-1.779 -4.338,3.571 -8.473,7.294 -12.398,11.15 3.942,9.515 7.883,19.03 11.823,28.545 7.913,-3.277 16.021,-5.9 24.247,-7.866 -2.394,-10.017 -4.788,-20.034 -7.183,-30.05 z"
       id="path28" />
    	<path
       fill="#4173cd"
       d="m 271.003,151.605 c -4.833,-2.445 -9.837,-4.706 -15.002,-6.765 -5.165,2.06 -10.17,4.321 -15.002,6.765 0.803,10.266 1.607,20.534 2.41,30.803 8.382,-0.657 16.804,-0.657 25.186,0 0.801,-10.268 1.605,-20.535 2.408,-30.803 z"
       id="path29" />
    	<path
       fill="#4173cd"
       d="m 329.616,165.663 c -3.925,-3.855 -8.061,-7.578 -12.398,-11.15 -5.609,0.346 -11.111,0.947 -16.489,1.779 -2.394,10.017 -4.789,20.033 -7.183,30.049 8.226,1.967 16.334,4.589 24.247,7.866 3.941,-9.515 7.882,-19.03 11.823,-28.544 z"
       id="path30" />
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 240.997,151.605 c -5.154,-1.663 -10.456,-3.118 -15.894,-4.346 -4.798,2.841 -9.411,5.858 -13.832,9.033 2.394,10.017 4.789,20.033 7.185,30.049 8.226,-1.967 16.569,-3.277 24.952,-3.933 -0.804,-10.268 -1.608,-20.535 -2.411,-30.803 z"
       id="path31" />
    	<path
       fill="#41479b"
       d="m 300.729,156.292 c -4.421,-3.175 -9.035,-6.193 -13.832,-9.033 -5.438,1.228 -10.741,2.685 -15.894,4.346 -0.803,10.266 -1.607,20.534 -2.41,30.803 8.383,0.655 16.726,1.966 24.952,3.933 2.395,-10.016 4.79,-20.033 7.184,-30.049 z"
       id="path32" />
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 241.96,163.926 c -9.345,0.73 -18.646,2.191 -27.817,4.385 -0.479,-2.003 -0.958,-4.007 -1.437,-6.01 9.485,-2.266 19.105,-3.778 28.771,-4.535 0.162,2.054 0.323,4.107 0.483,6.16 z"
       id="path33" />
    	<path
       fill="#ff4b55"
       d="m 242.925,176.247 c -8.703,0.681 -17.366,2.042 -25.907,4.084 -0.48,-2.003 -0.958,-4.007 -1.437,-6.009 8.855,-2.118 17.838,-3.529 26.862,-4.234 0.161,2.051 0.321,4.106 0.482,6.159 z"
       id="path34" />
    </g>
    <path
       fill="#ffe15a"
       d="m 285.326,90.045 c -2.155,-0.383 -4.316,-0.724 -6.482,-1.022 -3.562,-0.492 -6.215,-3.516 -5.906,-6.915 v 0 c 0.308,-3.398 3.713,-5.863 7.59,-5.327 2.325,0.32 4.645,0.685 6.959,1.097 3.859,0.682 6.357,4.082 5.604,7.406 v 0 c -0.751,3.331 -4.217,5.386 -7.765,4.761 z"
       id="path35" />
    <path
       fill="#ff4b55"
       d="m 320.157,100.222 c -8.215,-3.403 -16.636,-6.125 -25.175,-8.168 0.48,-2.003 0.958,-4.007 1.437,-6.009 8.855,2.116 17.585,4.94 26.103,8.468 -0.788,1.903 -1.576,3.806 -2.365,5.709 z"
       id="path36" />
    <g
       id="g41"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 317.952,169.96 c -0.873,2.407 -3.817,3.552 -6.599,2.647 -2.781,-0.906 -4.483,-3.55 -3.779,-6.012 0.704,-2.462 3.686,-3.765 6.636,-2.806 2.953,0.957 4.615,3.764 3.742,6.171 z"
       id="path37" />
    	<path
       fill="#ffe15a"
       d="m 204.425,166.596 c 0.703,2.464 -1,5.109 -3.779,6.012 -2.781,0.9 -5.725,-0.245 -6.599,-2.647 -0.874,-2.408 0.79,-5.214 3.742,-6.17 2.949,-0.957 5.934,0.344 6.636,2.805 z"
       id="path38" />
    	<path
       fill="#ffe15a"
       d="m 254.59,162.549 c 0.006,2.047 -1.834,3.714 -4.114,3.784 -2.279,0.073 -4.222,-1.481 -4.342,-3.52 -0.119,-2.04 1.719,-3.806 4.111,-3.883 2.392,-0.075 4.335,1.572 4.345,3.619 z"
       id="path39" />
    	<path
       fill="#ffe15a"
       d="m 265.865,162.813 c -0.121,2.044 -2.065,3.593 -4.342,3.52 -2.279,-0.07 -4.119,-1.737 -4.114,-3.784 0.009,-2.045 1.953,-3.697 4.344,-3.619 2.393,0.072 4.23,1.842 4.112,3.883 z"
       id="path40" />
    	<path
       fill="#ffe15a"
       d="m 260.007,172.08 c -0.057,2.047 -1.85,3.657 -4.008,3.657 -2.156,-0.001 -3.949,-1.609 -4.008,-3.657 -0.056,-2.041 1.737,-3.755 4.008,-3.749 2.271,-0.005 4.064,1.707 4.008,3.749 z"
       id="path41" />
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const HT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#4173cd"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 0,167.725 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.45 0,331.497 0,326.622 Z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const HU = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const ID = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#c8414b"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 0,167.725 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.45 0,331.497 0,326.622 Z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const IE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#73af00"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff9b46"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const IL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <rect
       y="61.794998"
       fill="#f5f5f5"
       width="512"
       height="211.86"
       id="rect1"
       x="0" />
    <path
       fill="#41479b"
       d="m 301.869,167.725 22.933,-39.721 H 278.937 L 256,88.277 233.064,128.004 h -45.865 l 22.933,39.721 -22.933,39.721 h 45.865 L 256,247.173 278.936,207.446 h 45.865 z m 0.433,-26.73 -7.933,13.74 -7.933,-13.74 z m -15.433,26.73 -15.433,26.73 h -30.873 l -15.432,-26.73 15.433,-26.73 h 30.873 z M 256,114.259 l 7.936,13.746 h -15.872 z m -46.302,26.736 h 15.865 l -7.933,13.74 z m 0,53.46 7.933,-13.74 7.933,13.74 z M 256,221.191 248.064,207.445 h 15.872 z m 38.369,-40.476 7.933,13.74 h -15.865 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const IM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs65" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 257.266,256.382 -2.445,1.412 c -4.236,-6.1 -4.004,-21.02 -4.004,-21.19 0.044,-0.442 -0.221,-0.841 -0.619,-1.017 l -18.327,-8.021 0.105,-1.881 c 9.557,1.102 20.606,5.548 20.759,5.624 0.376,0.237 0.851,0.178 1.187,-0.099 l 15.208,-12.68 3.273,2.925 c -4.742,5.824 -16.279,13.869 -16.428,13.952 -0.408,0.177 -0.628,0.601 -0.589,1.035 z"
       id="path2" />
    	<path
       fill="#ffe15a"
       d="m 323.765,166.041 c 0.373,0.191 0.822,0.154 1.16,-0.096 l 3.974,-2.942 -1.262,3.668 c -0.141,0.417 -0.019,0.883 0.309,1.185 l 1.871,1.672 c -0.556,0.939 -0.776,2.094 -0.798,3.299 l -2.773,1.408 c -0.235,0.12 -0.42,0.32 -0.522,0.564 l -2.068,5.007 -1.133,-4.152 c -0.146,-0.547 -0.666,-0.881 -1.216,-0.806 l -4.99,0.682 4.051,-4.588 c 0.216,-0.246 0.312,-0.574 0.264,-0.895 l -0.903,-6.059 z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 278.562,329.545 c -0.348,0.233 -0.534,0.643 -0.48,1.06 l 0.643,4.901 -2.594,-2.884 c -0.296,-0.327 -0.762,-0.445 -1.186,-0.305 l -2.37,0.824 c -0.551,-0.941 -1.454,-1.695 -2.497,-2.298 l 0.115,-3.107 c 0.009,-0.264 -0.076,-0.523 -0.239,-0.73 l -3.374,-4.238 4.18,1.024 c 0.548,0.138 1.094,-0.156 1.294,-0.672 l 1.825,-4.694 2.046,5.768 c 0.11,0.309 0.35,0.551 0.654,0.665 l 5.736,2.152 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 157.188,214.6 c -0.053,-0.415 -0.338,-0.765 -0.735,-0.903 l -4.673,-1.614 3.74,-1.032 c 0.424,-0.119 0.739,-0.483 0.802,-0.925 l 0.321,-2.488 c 1.088,-0.072 2.166,-0.544 3.172,-1.207 l 2.729,1.492 c 0.232,0.126 0.501,0.166 0.76,0.111 l 5.3,-1.124 -2.784,3.282 c -0.369,0.429 -0.35,1.047 0.023,1.458 l 3.384,3.731 -6.074,-0.747 c -0.326,-0.04 -0.649,0.067 -0.888,0.288 l -4.488,4.17 z"
       id="path5" />
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 254.399,364.643 c -2.699,5.442 -8.538,9.954 -9.999,10.22 -0.266,0.044 -0.487,-0.044 -0.707,-0.266 -0.664,-0.753 -0.973,-2.787 -0.088,-5.486 0.088,-0.266 0.178,-0.619 0.31,-1.017 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 256.345,359.024 c -0.354,1.062 -0.664,2.123 -0.885,2.92 l -10.795,3.584 c 0.31,-0.973 0.619,-2.035 0.929,-3.186 z"
       id="path7" />
    </g>
    <path
       fill="#ffe15a"
       d="m 258.734,264.687 c -0.531,1.195 -1.017,2.345 -1.46,3.451 l -10.973,3.362 c 0.31,-1.194 0.664,-2.433 0.973,-3.672 z"
       id="path8" />
    <g
       id="g16"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 260.903,348.584 c -0.31,0.575 -0.619,1.151 -0.929,1.77 l -12.078,3.274 c 0.531,-2.079 0.973,-4.115 1.327,-5.884 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 264.309,343.982 c -0.707,0.664 -1.372,1.504 -2.035,2.477 l -12.697,-0.929 c 0.177,-1.151 0.309,-2.168 0.309,-2.92 0,-0.575 -0.044,-1.106 -0.088,-1.682 0.487,0.044 1.017,0.044 1.46,0.044 3.186,0 5.442,-0.575 7.079,-1.416 1.813,2.656 4.158,3.851 5.972,4.426 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 266.876,342.168 c -0.797,-0.088 -4.335,-0.442 -6.726,-3.893 1.195,-1.017 1.77,-2.123 2.035,-2.876 1.327,-3.716 -7.919,-9.512 -13.582,-12.609 -2.655,-1.46 -4.734,-4.335 -6.592,-7.654 0.221,0.044 0.398,0.044 0.619,0.044 2.831,0 5.088,-1.327 6.282,-2.345 1.062,1.77 2.035,3.406 2.92,4.822 4.026,6.814 5.885,9.91 10.176,12.919 0.132,0.088 0.309,0.177 0.487,0.177 2.079,0.266 8.096,1.592 8.45,4.247 0.488,3.628 -0.84,5.929 -4.069,7.168 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 260.106,334.647 c -0.487,1.416 -2.521,4.601 -10.574,4.071 -0.708,-4.601 -2.743,-7.875 -5.973,-9.379 -4.203,-1.991 -19.91,-13.228 -27.076,-19.91 1.416,-4.513 5.132,-8.184 10.397,-10.132 0.753,-0.31 1.416,-0.575 1.991,-0.885 1.416,1.151 2.699,2.433 3.761,3.893 1.638,2.301 3.053,5.22 4.557,8.318 2.787,5.663 5.663,11.548 10.353,14.113 8.671,4.779 12.962,8.894 12.564,9.911 z"
       id="path12" />
    	<path
       fill="#f5f5f5"
       d="m 247.719,310.933 c -0.841,0.841 -3.628,2.743 -6.99,1.77 -0.531,-1.017 -1.017,-2.035 -1.548,-3.052 -1.548,-3.186 -3.008,-6.194 -4.778,-8.628 -1.017,-1.46 -2.301,-2.743 -3.672,-3.893 1.991,-1.726 2.301,-3.584 2.389,-5.176 3.495,3.008 6.77,6.769 9.778,11.414 1.9,2.875 3.449,5.352 4.821,7.565 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 231.039,290.316 c -0.044,0.354 -0.088,0.753 -0.088,1.151 -0.088,1.504 -0.221,2.965 -1.991,4.291 -3.716,-2.655 -8.008,-4.469 -11.68,-5.663 1.682,-1.726 2.787,-3.451 3.318,-5.132 0,0 0,0 0.044,0 3.627,1.016 7.123,2.831 10.397,5.353 z"
       id="path14" />
    	<path
       fill="#f5f5f5"
       d="m 226.792,296.908 c -0.221,0.088 -0.398,0.221 -0.664,0.309 -5.53,2.035 -9.601,5.796 -11.414,10.442 -2.168,-2.168 -3.716,-4.115 -4.956,-5.663 -1.372,-1.77 -2.521,-3.142 -3.938,-4.115 3.981,-2.035 7.167,-4.071 9.601,-6.061 0.044,0 0.044,0 0.088,0 3.452,1.062 7.655,2.654 11.283,5.088 z"
       id="path15" />
    	<path
       fill="#f5f5f5"
       d="m 213.342,290.625 c -2.301,1.814 -5.53,3.849 -10.088,6.061 -1.062,-0.266 -2.123,-0.487 -3.008,-0.663 -2.168,-0.398 -3.584,-0.708 -4.69,-1.947 -0.664,-0.708 -1.947,-2.699 -3.186,-5.22 0.178,0.088 0.354,0.177 0.531,0.221 1.283,0.31 3.096,-0.266 5.353,-1.062 2.787,-0.929 6.194,-2.08 9.291,-1.682 2.787,0.354 3.54,1.46 4.424,2.699 0.4,0.531 0.798,1.106 1.373,1.593 z"
       id="path16" />
    </g>
    <path
       fill="#ffe15a"
       d="m 218.606,195.713 c -0.354,1.372 -1.327,3.097 -3.54,5.176 -0.531,-0.354 -0.885,-0.841 -1.283,-1.416 -0.973,-1.372 -2.212,-3.097 -5.929,-3.584 -3.584,-0.487 -7.3,0.753 -10.308,1.77 -1.682,0.575 -3.452,1.195 -4.159,1.017 -0.753,-0.178 -1.726,-1.372 -1.77,-2.567 -0.044,-1.372 1.195,-1.991 2.212,-2.301 2.301,-0.707 5.088,-0.177 7.831,0.31 2.787,0.531 5.442,1.017 7.565,0.177 1.46,-0.575 3.142,-2.389 5.176,-5 1.416,0.309 2.61,0.797 3.318,1.814 1.02,1.462 1.286,3.012 0.887,4.604 z"
       id="path17" />
    <g
       id="g22"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 211.838,277.264 c -1.372,1.682 -2.567,2.92 -3.45,3.274 -1.504,0.619 -3.849,0.177 -6.327,-0.31 -2.831,-0.531 -6.061,-1.106 -8.849,-0.266 -1.682,0.487 -2.61,1.327 -3.142,2.123 -0.487,-2.433 -0.487,-4.778 0.619,-6.636 1.106,-1.947 2.566,-3.584 4.071,-5.22 1.991,0.266 3.45,0.664 8.494,5.088 1.726,1.504 4.513,1.682 7.212,1.814 0.442,0.044 0.929,0.089 1.372,0.133 z"
       id="path18" />
    	<path
       fill="#f5f5f5"
       d="m 252.939,258.991 c -4.956,3.274 -27.032,17.785 -31.634,19.688 -0.221,0.088 -0.398,0.266 -0.531,0.442 -0.132,0.221 -0.221,0.398 -0.354,0.619 -0.221,-0.575 -0.531,-1.106 -0.885,-1.636 -0.885,-1.283 -2.212,-1.991 -3.672,-2.433 0.664,-0.841 1.327,-1.726 2.035,-2.699 3.186,-4.38 6.858,-9.291 11.061,-13.671 7.212,-7.521 16.856,-12.477 20.086,-13.981 0.488,4.69 1.549,10.221 3.894,13.671 z"
       id="path19" />
    	<path
       fill="#f5f5f5"
       d="m 248.824,242.976 c -2.301,1.017 -13.228,6.194 -21.458,14.777 -4.335,4.513 -8.185,9.689 -11.238,13.892 -0.929,1.239 -1.814,2.433 -2.655,3.54 -0.973,-0.088 -1.946,-0.177 -2.876,-0.221 -2.433,-0.177 -4.734,-0.31 -5.885,-1.327 -4.247,-3.716 -6.239,-4.822 -8.141,-5.309 0.178,-0.177 0.31,-0.354 0.487,-0.531 2.787,-2.831 5.707,-5.795 8.008,-9.91 3.981,-7.123 17.299,-22.653 25.971,-28.271 l 17.565,7.699 c 0,1.06 0.046,3.14 0.222,5.661 z"
       id="path20" />
    	<path
       fill="#f5f5f5"
       d="m 136.587,177.298 c -3.662,-4.846 -5.089,-12.087 -4.674,-13.512 0.079,-0.257 0.257,-0.416 0.554,-0.514 0.97,-0.257 2.929,0.375 4.948,2.372 0.198,0.198 0.474,0.435 0.771,0.732 z"
       id="path21" />
    	<path
       fill="#f5f5f5"
       d="m 140.744,181.55 c -0.791,-0.791 -1.603,-1.543 -2.217,-2.097 l 1.619,-11.258 c 0.733,0.712 1.544,1.463 2.434,2.254 z"
       id="path22" />
    </g>
    <path
       fill="#ffe15a"
       d="m 145.098,98.121 c -0.832,-1.009 -1.643,-1.958 -2.434,-2.848 l 1.896,-11.318 c 0.93,0.811 1.88,1.682 2.85,2.511 z"
       id="path23" />
    <g
       id="g31"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 148.047,190.293 c -0.376,-0.534 -0.753,-1.068 -1.167,-1.622 l 2.468,-12.268 c 1.623,1.404 3.246,2.709 4.671,3.817 z"
       id="path24" />
    	<path
       fill="#f5f5f5"
       d="m 150.642,195.396 c -0.277,-0.93 -0.733,-1.899 -1.308,-2.927 l 6.505,-10.944 c 0.95,0.672 1.801,1.246 2.474,1.582 0.514,0.257 1.01,0.455 1.544,0.672 -0.257,0.416 -0.494,0.89 -0.692,1.287 -1.423,2.85 -1.918,5.126 -1.897,6.966 -3.185,0.435 -5.301,1.999 -6.626,3.364 z"
       id="path25" />
    	<path
       fill="#f5f5f5"
       d="m 151.118,198.503 c 0.435,-0.673 2.333,-3.681 6.488,-4.276 0.376,1.524 1.109,2.532 1.663,3.106 2.731,2.848 12.049,-2.834 17.35,-6.516 2.493,-1.722 5.994,-2.297 9.793,-2.477 -0.138,0.178 -0.217,0.337 -0.317,0.534 -1.266,2.532 -1.086,5.144 -0.71,6.668 -2.058,0.159 -3.957,0.298 -5.619,0.457 -7.894,0.557 -11.496,0.835 -16.105,3.33 -0.139,0.079 -0.297,0.198 -0.375,0.356 -1.166,1.741 -5.043,6.531 -7.576,5.662 -3.462,-1.186 -4.927,-3.401 -4.592,-6.844 z"
       id="path26" />
    	<path
       fill="#f5f5f5"
       d="m 160.872,195.808 c -1.049,-1.068 -2.989,-4.312 1.084,-11.278 4.433,1.422 8.27,1.065 11.06,-1.152 3.659,-2.87 20.732,-11.9 29.91,-15.326 3.404,3.283 5.028,8.249 4.417,13.828 -0.058,0.811 -0.118,1.524 -0.098,2.176 -1.662,0.753 -3.383,1.327 -5.164,1.624 -2.79,0.436 -6.035,0.398 -9.478,0.36 -6.312,-0.038 -12.861,-0.094 -17.252,2.955 -8.149,5.624 -13.748,7.624 -14.479,6.813 z"
       id="path27" />
    	<path
       fill="#f5f5f5"
       d="m 187.622,195.323 c -0.376,-1.128 -0.833,-4.471 1.54,-7.044 1.148,-0.021 2.275,-0.001 3.423,-0.021 3.542,0.039 6.886,0.076 9.854,-0.419 1.761,-0.258 3.481,-0.832 5.124,-1.545 0.654,2.552 2.178,3.659 3.563,4.45 -4.254,1.782 -9.08,3.031 -14.581,3.646 -3.423,0.417 -6.331,0.695 -8.923,0.933 z"
       id="path28" />
    	<path
       fill="#f5f5f5"
       d="m 213.519,189.615 c -0.297,-0.198 -0.633,-0.415 -0.99,-0.594 -1.306,-0.751 -2.553,-1.523 -2.95,-3.699 4.035,-2.138 7.576,-5.167 10.286,-7.918 0.792,2.275 1.842,4.035 3.108,5.262 0,0 0,0 -0.02,0.04 -2.529,2.791 -5.715,5.107 -9.434,6.909 z"
       id="path29" />
    	<path
       fill="#f5f5f5"
       d="m 209.521,182.87 c 0.02,-0.237 -0.02,-0.455 0.02,-0.732 0.651,-5.857 -0.895,-11.179 -4.241,-14.878 2.909,-0.971 5.342,-1.486 7.281,-1.902 2.196,-0.436 3.937,-0.852 5.44,-1.684 0.042,4.471 0.438,8.231 1.132,11.297 -0.02,0.04 -0.02,0.04 -0.04,0.079 -2.492,2.614 -5.794,5.662 -9.592,7.82 z"
       id="path30" />
    	<path
       fill="#f5f5f5"
       d="m 221.151,173.645 c -0.595,-2.869 -0.972,-6.667 -0.915,-11.733 0.712,-0.831 1.385,-1.683 1.938,-2.394 1.325,-1.761 2.234,-2.89 3.837,-3.326 0.93,-0.277 3.284,-0.535 6.094,-0.516 -0.158,0.119 -0.317,0.237 -0.435,0.376 -0.851,1.01 -1.146,2.889 -1.442,5.263 -0.414,2.909 -0.908,6.471 -2.648,9.063 -1.562,2.335 -2.888,2.514 -4.392,2.752 -0.652,0.119 -1.344,0.218 -2.037,0.515 z"
       id="path31" />
    </g>
    <path
       fill="#ffe15a"
       d="m 224.735,93.045 c -1.069,-0.929 -2.177,-2.571 -3.049,-5.48 0.554,-0.317 1.148,-0.416 1.839,-0.515 1.662,-0.258 3.759,-0.595 5.855,-3.702 2.037,-2.988 2.59,-6.867 3.023,-10.013 0.237,-1.761 0.473,-3.622 0.948,-4.175 0.494,-0.594 1.998,-0.931 3.086,-0.437 1.247,0.574 1.247,1.959 1.069,3.007 -0.395,2.375 -2.115,4.631 -3.777,6.867 -1.72,2.257 -3.342,4.414 -3.539,6.689 -0.138,1.564 0.734,3.878 2.159,6.865 -0.909,1.128 -1.879,1.98 -3.105,2.158 -1.758,0.258 -3.262,-0.196 -4.509,-1.264 z"
       id="path32" />
    <g
       id="g37"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 233.777,178.271 c -0.892,-1.978 -1.465,-3.601 -1.387,-4.551 0.118,-1.623 1.562,-3.522 3.104,-5.522 1.74,-2.295 3.698,-4.928 4.192,-7.797 0.316,-1.721 -0.021,-2.929 -0.497,-3.759 2.394,0.652 4.492,1.7 5.66,3.52 1.247,1.859 2.059,3.897 2.851,5.974 -1.128,1.663 -2.136,2.791 -8.348,5.325 -2.116,0.872 -3.521,3.286 -4.845,5.641 -0.236,0.377 -0.493,0.793 -0.73,1.169 z"
       id="path33" />
    	<path
       fill="#f5f5f5"
       d="m 231.755,223.205 c -0.714,-5.896 -3.831,-32.131 -3.477,-37.097 0.02,-0.237 -0.06,-0.474 -0.159,-0.673 -0.139,-0.217 -0.257,-0.375 -0.396,-0.594 0.614,0.06 1.227,0.02 1.86,-0.06 1.544,-0.218 2.77,-1.089 3.818,-2.198 0.456,0.97 0.95,1.959 1.505,3.027 2.495,4.807 5.247,10.286 7.287,16.004 3.506,9.813 3.628,20.655 3.531,24.216 -4.333,-0.951 -9.352,-2.023 -13.969,-2.625 z"
       id="path34" />
    	<path
       fill="#f5f5f5"
       d="m 247.922,226.681 c 0.118,-2.513 0.371,-14.602 -3.63,-25.8 -2.1,-5.896 -5.01,-11.652 -7.406,-16.262 -0.693,-1.385 -1.366,-2.71 -1.98,-3.957 0.514,-0.831 1.028,-1.663 1.483,-2.474 1.246,-2.098 2.392,-4.097 3.817,-4.671 5.223,-2.138 7.102,-3.426 8.387,-4.91 0.079,0.237 0.179,0.435 0.257,0.673 1.288,3.758 2.634,7.695 5.287,11.593 4.594,6.745 12.534,25.598 13.686,35.866 l -14.735,12.273 c -0.951,-0.473 -2.831,-1.362 -5.166,-2.331 z"
       id="path35" />
    	<path
       fill="#f5f5f5"
       d="m 366.18,170.134 c 6.068,-0.281 12.847,2.635 13.789,3.783 0.168,0.211 0.198,0.447 0.111,0.748 -0.335,0.946 -1.964,2.204 -4.754,2.74 -0.275,0.052 -0.628,0.146 -1.039,0.223 z"
       id="path36" />
    	<path
       fill="#f5f5f5"
       d="m 360.323,171.159 c 1.1,-0.205 2.179,-0.45 2.983,-0.643 l 8.373,7.7 c -1.001,0.202 -2.08,0.446 -3.236,0.734 z"
       id="path37" />
    </g>
    <path
       fill="#ffe15a"
       d="m 353.864,83.736 c 1.302,-0.116 2.543,-0.248 3.725,-0.398 l 8.265,7.961 c -1.195,0.309 -2.45,0.6 -3.683,0.931 z"
       id="path38" />
    <g
       id="g46"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 348.982,172.243 c 0.653,-0.009 1.306,-0.017 1.998,-0.046 l 8.724,8.971 c -2.076,0.545 -4.07,1.146 -5.789,1.695 z"
       id="path39" />
    	<path
       fill="#f5f5f5"
       d="m 343.306,171.497 c 0.924,0.297 1.981,0.469 3.154,0.577 l 5.351,11.553 c -1.091,0.404 -2.046,0.781 -2.703,1.146 -0.503,0.279 -0.946,0.575 -1.427,0.893 -0.198,-0.447 -0.455,-0.911 -0.67,-1.298 -1.546,-2.785 -3.144,-4.479 -4.673,-5.502 1.439,-2.874 1.345,-5.504 0.968,-7.369 z"
       id="path40" />
    	<path
       fill="#f5f5f5"
       d="m 340.474,170.134 c 0.309,0.739 1.717,4.006 -0.14,7.769 -1.47,-0.551 -2.716,-0.516 -3.502,-0.384 -3.893,0.643 -4.473,11.541 -4.433,17.995 0.012,3.029 -1.493,6.243 -3.492,9.479 -0.068,-0.215 -0.154,-0.37 -0.262,-0.563 -1.374,-2.475 -3.63,-3.805 -5.099,-4.355 1.032,-1.788 1.991,-3.433 2.799,-4.894 4.003,-6.827 5.81,-9.954 6.357,-15.167 0.013,-0.159 0.004,-0.356 -0.082,-0.511 -0.777,-1.946 -2.537,-7.852 -0.387,-9.45 2.935,-2.187 5.591,-2.141 8.241,0.081 z"
       id="path41" />
    	<path
       fill="#f5f5f5"
       d="m 337.183,179.702 c 1.474,-0.262 5.247,-0.029 8.691,7.27 -3.679,2.852 -5.555,6.22 -5.302,9.774 0.299,4.641 -1.903,23.828 -4.267,33.336 -4.632,0.952 -9.647,-0.515 -13.905,-4.173 -0.636,-0.508 -1.19,-0.959 -1.74,-1.311 0.319,-1.796 0.818,-3.541 1.579,-5.177 1.217,-2.548 3.083,-5.203 5.06,-8.021 3.598,-5.185 7.348,-10.556 7.316,-15.902 -0.03,-9.901 1.485,-15.65 2.568,-15.796 z"
       id="path42" />
    	<path
       fill="#f5f5f5"
       d="m 322.462,202.042 c 1.143,0.327 4.159,1.841 4.94,5.252 -0.632,0.958 -1.286,1.877 -1.918,2.836 -2.034,2.9 -3.956,5.636 -5.224,8.365 -0.782,1.598 -1.282,3.342 -1.622,5.1 -2.475,-0.904 -4.249,-0.273 -5.685,0.424 0.935,-4.516 2.633,-9.204 5.235,-14.089 1.59,-3.059 3.005,-5.615 4.274,-7.888 z"
       id="path43" />
    	<path
       fill="#f5f5f5"
       d="m 312.53,226.632 c 0.331,-0.134 0.701,-0.288 1.048,-0.481 1.358,-0.652 2.699,-1.246 4.718,-0.342 -0.518,4.537 -0.021,9.171 0.717,12.961 -2.325,-0.632 -4.37,-0.762 -6.098,-0.41 0,0 0,0 -0.021,-0.039 -0.87,-3.666 -0.98,-7.602 -0.364,-11.689 z"
       id="path44" />
    	<path
       fill="#f5f5f5"
       d="m 320.355,227.146 c 0.184,0.15 0.386,0.241 0.593,0.43 4.463,3.848 9.727,5.581 14.669,4.913 -0.843,2.947 -1.794,5.247 -2.547,7.081 -0.882,2.058 -1.523,3.73 -1.686,5.44 -3.712,-2.494 -7.037,-4.291 -9.959,-5.452 -0.021,-0.039 -0.021,-0.039 -0.043,-0.077 -0.746,-3.534 -1.394,-7.982 -1.027,-12.335 z"
       id="path45" />
    	<path
       fill="#f5f5f5"
       d="m 321.389,241.955 c 2.702,1.131 6.049,2.967 10.195,5.878 0.284,1.057 0.605,2.093 0.879,2.953 0.704,2.089 1.12,3.477 0.574,5.045 -0.297,0.924 -1.415,3.011 -3.019,5.319 -0.009,-0.198 -0.018,-0.395 -0.064,-0.572 -0.352,-1.272 -1.735,-2.579 -3.527,-4.165 -2.165,-1.986 -4.824,-4.406 -5.98,-7.308 -1.043,-2.609 -0.441,-3.804 0.213,-5.178 0.274,-0.606 0.582,-1.234 0.729,-1.972 z"
       id="path46" />
    </g>
    <path
       fill="#ffe15a"
       d="m 313.032,152.297 c 1.371,-0.356 3.352,-0.342 6.244,0.583 -0.052,0.636 -0.306,1.182 -0.616,1.809 -0.727,1.516 -1.634,3.437 -0.256,6.923 1.313,3.37 4.201,6.017 6.55,8.154 1.319,1.191 2.719,2.438 2.909,3.143 0.211,0.744 -0.362,2.174 -1.385,2.793 -1.177,0.704 -2.321,-0.078 -3.085,-0.818 -1.736,-1.668 -2.624,-4.363 -3.53,-6.997 -0.888,-2.695 -1.751,-5.251 -3.517,-6.7 -1.212,-0.998 -3.614,-1.587 -6.883,-2.1 -0.417,-1.388 -0.57,-2.668 -0.024,-3.782 0.782,-1.6 2.007,-2.584 3.593,-3.008 z"
       id="path47" />
    <g
       id="g50"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 310.438,249.754 c 2.135,0.383 3.798,0.826 4.537,1.428 1.271,1.015 2.023,3.279 2.799,5.682 0.91,2.733 1.974,5.836 4.062,7.865 1.241,1.234 2.428,1.638 3.381,1.716 -1.891,1.607 -3.941,2.744 -6.103,2.679 -2.239,-0.022 -4.378,-0.504 -6.54,-1.025 -0.734,-1.869 -1.095,-3.339 0.327,-9.897 0.478,-2.239 -0.721,-4.761 -1.914,-7.186 -0.177,-0.406 -0.374,-0.853 -0.549,-1.262 z"
       id="path48" />
    	<path
       fill="#f5f5f5"
       d="m 274.514,222.686 c 5.268,2.743 28.67,15.004 32.566,18.103 0.184,0.15 0.425,0.22 0.644,0.249 0.258,0.009 0.456,0 0.714,0.009 -0.395,0.472 -0.71,1.001 -1.002,1.568 -0.693,1.397 -0.668,2.901 -0.345,4.392 -1.057,-0.172 -2.153,-0.323 -3.348,-0.47 -5.376,-0.66 -11.452,-1.486 -17.321,-3.036 -10.076,-2.655 -19.09,-8.683 -21.972,-10.777 3.181,-2.843 7.388,-6.529 10.064,-10.038 z"
       id="path49" />
    	<path
       fill="#f5f5f5"
       d="m 262.507,234.057 c 2.006,1.517 11.836,8.561 23.333,11.59 6.05,1.601 12.444,2.454 17.6,3.083 1.534,0.211 3.008,0.405 4.383,0.604 0.395,0.894 0.79,1.788 1.203,2.622 1.026,2.214 2.027,4.289 1.695,5.789 -1.188,5.517 -1.188,7.795 -0.691,9.695 -0.241,-0.07 -0.46,-0.099 -0.701,-0.168 -3.829,-1.063 -7.838,-2.177 -12.552,-2.193 -8.161,-0.024 -28.201,-4.131 -37.323,-8.986 L 257.661,237 c 0.931,-0.517 2.727,-1.565 4.846,-2.943 z"
       id="path50" />
    </g>
    <path
       fill="#464655"
       d="m 381.988,84.721 c -0.107,-0.193 -0.193,-0.348 -0.318,-0.481 -1.714,-2.084 -11.742,-5.93 -18.855,-4.158 -7.68,1.935 -18.135,2.425 -20.726,0.22 -3.319,-2.936 -7.006,-3.052 -10.65,-0.567 l -1.472,-1.314 2.183,-6.342 c 0.103,-0.305 0.068,-0.629 -0.081,-0.897 -0.076,-0.136 -0.18,-0.258 -0.313,-0.355 -0.392,-0.287 -0.922,-0.286 -1.313,0.002 l -6.287,4.653 -5.337,-2.712 c -0.369,-0.188 -0.812,-0.154 -1.146,0.088 -0.335,0.241 -0.509,0.651 -0.447,1.059 l 1.142,7.67 -5.678,6.432 c -0.306,0.348 -0.364,0.847 -0.146,1.255 0.22,0.266 0.666,0.636 1.124,0.574 l 6.976,-0.954 1.73,6.344 c 0.129,0.469 0.526,0.785 0.998,0.813 0.471,0.03 0.91,-0.243 1.092,-0.681 l 3.15,-7.624 1.598,-0.811 c 0.327,2.125 0.99,4.06 1.273,4.817 -0.534,4.598 -2.306,7.605 -6.008,14.062 -2.158,3.678 -4.794,8.227 -8.235,14.793 -5.728,10.921 -7.571,21.002 -5.482,29.963 -0.631,0.047 -1.581,0.067 -2.574,0.012 -5.28,-3.951 -32.545,-18.065 -33.7,-18.688 -0.064,-0.033 -4.499,-3.841 -4.499,-3.841 -1.229,-10.752 -9.248,-29.645 -13.99,-36.704 -2.514,-3.68 -3.801,-7.438 -5.049,-11.079 -1.188,-3.363 -2.259,-6.568 -4.218,-9.575 -4.355,-6.726 -17.987,-5.771 -21.272,-4.938 -2.335,0.615 -3.601,2.257 -5.044,4.157 -0.574,0.753 -1.226,1.564 -2.037,2.494 -1.345,1.504 -3.224,1.901 -6.252,2.516 -2.374,0.495 -5.362,1.13 -9.259,2.496 -9.14,3.247 -27.339,12.95 -31.217,15.959 -3.818,2.989 -9.378,0.953 -12.346,-0.53 -4.195,-2.095 -16.863,-13.666 -20.307,-17.067 -2.396,-2.334 -5.106,-3.441 -7.104,-2.905 -0.851,0.217 -1.524,0.772 -1.879,1.484 -0.099,0.198 -0.178,0.356 -0.217,0.534 -0.751,2.592 1.746,13.038 7.229,17.903 5.938,5.241 12.253,13.588 11.897,16.972 -0.546,4.397 1.443,7.505 5.554,9.107 l -0.252,1.956 -6.464,1.784 c -0.309,0.087 -0.557,0.299 -0.694,0.573 -0.07,0.139 -0.111,0.295 -0.116,0.459 -0.015,0.486 0.286,0.922 0.745,1.081 l 7.392,2.556 0.78,5.937 c 0.053,0.41 0.332,0.757 0.721,0.896 0.388,0.141 0.824,0.052 1.127,-0.23 l 5.682,-5.278 8.515,1.047 c 0.46,0.056 0.905,-0.179 1.118,-0.588 0.096,-0.332 0.148,-0.909 -0.162,-1.252 l -4.732,-5.215 4.255,-5.013 c 0.314,-0.372 0.35,-0.878 0.107,-1.282 -0.242,-0.406 -0.715,-0.614 -1.178,-0.516 l -8.071,1.711 -1.571,-0.86 c 1.569,-1.471 2.788,-3.111 3.254,-3.773 4.095,-2.158 7.577,-2.397 14.997,-2.994 4.254,-0.298 9.497,-0.696 16.857,-1.569 12.247,-1.449 21.604,-5.628 27.815,-12.416 0.396,0.494 0.95,1.266 1.464,2.116 -0.275,6.589 3.497,37.057 3.636,38.364 0.009,0.068 -0.065,3.292 -0.065,3.292 -9.067,5.931 -22.324,21.457 -26.511,28.838 -2.168,3.893 -4.956,6.724 -7.655,9.468 -2.477,2.567 -4.866,4.956 -6.68,8.052 -4.071,6.902 2.876,18.67 5.088,21.237 1.592,1.814 3.628,2.212 5.973,2.655 0.929,0.177 1.947,0.398 3.142,0.707 1.946,0.531 3.142,2.035 5.044,4.469 1.504,1.902 3.406,4.291 6.371,7.167 6.99,6.726 23.802,18.67 28.227,20.794 4.38,2.08 5.044,7.964 5.044,11.282 0,4.69 -4.69,21.193 -6.194,25.793 -1.017,3.186 -0.797,6.105 0.575,7.654 0.575,0.664 1.372,1.017 2.168,1.017 0.221,0 0.398,0 0.575,-0.044 2.655,-0.487 10.883,-7.389 12.787,-14.467 2.035,-7.654 6.68,-17.033 9.866,-18.228 4.178,-1.476 6.069,-4.644 5.665,-9.037 l 1.863,-0.649 4.484,4.987 c 0.216,0.237 0.516,0.365 0.823,0.365 0.156,0 0.313,-0.032 0.462,-0.102 0.44,-0.203 0.697,-0.668 0.636,-1.15 l -1.017,-7.755 4.962,-3.35 c 0.343,-0.231 0.53,-0.636 0.48,-1.046 -0.047,-0.411 -0.322,-0.76 -0.708,-0.905 l -7.261,-2.724 -2.869,-8.086 c -0.156,-0.436 -0.564,-0.73 -1.026,-0.737 -0.339,0.063 -0.879,0.275 -1.048,0.704 l -2.553,6.566 -6.386,-1.566 c -0.473,-0.115 -0.942,0.079 -1.195,0.478 -0.255,0.397 -0.229,0.914 0.065,1.286 l 5.138,6.455 -0.066,1.79 c -2.017,-0.746 -4.03,-1.105 -4.83,-1.225 -3.761,-2.699 -5.53,-5.707 -9.379,-12.078 -2.168,-3.672 -4.867,-8.185 -8.937,-14.379 -6.77,-10.308 -14.689,-16.812 -23.538,-19.335 0.266,-0.575 0.708,-1.416 1.239,-2.257 6.017,-2.699 31.59,-19.688 32.695,-20.396 0.015,-0.01 0.013,-0.035 0.028,-0.046 l 3.459,-1.998 c 9.589,5.048 29.634,9.096 38.119,9.175 4.456,0.007 8.285,1.069 11.992,2.098 3.446,0.92 6.695,1.85 10.283,1.933 8.01,0.209 14.929,-11.576 16.099,-14.755 0.813,-2.273 0.173,-4.246 -0.578,-6.51 -0.296,-0.898 -0.597,-1.896 -0.906,-3.091 -0.481,-1.96 0.255,-3.734 1.459,-6.579 0.934,-2.238 2.099,-5.062 3.175,-9.048 2.487,-9.376 4.772,-29.873 4.482,-34.772 -0.308,-4.839 4.515,-8.275 7.416,-9.885 4.1,-2.276 20.806,-6.185 25.558,-7.103 3.279,-0.657 5.725,-2.266 6.413,-4.217 0.298,-0.827 0.222,-1.695 -0.166,-2.392 z m -52.97,-0.168 -2.773,1.408 c -0.235,0.12 -0.42,0.32 -0.522,0.564 l -2.068,5.007 -1.133,-4.152 c -0.146,-0.547 -0.666,-0.881 -1.215,-0.806 l -4.991,0.682 4.051,-4.588 c 0.217,-0.246 0.312,-0.574 0.264,-0.895 l -0.903,-6.059 4.036,2.051 c 0.373,0.191 0.822,0.154 1.16,-0.095 l 3.974,-2.942 -1.262,3.668 c -0.141,0.417 -0.019,0.883 0.309,1.185 l 1.871,1.672 c -0.556,0.939 -0.775,2.095 -0.798,3.3 z m -2.673,22.352 c 4.003,-6.827 5.81,-9.954 6.357,-15.167 0.013,-0.159 0.004,-0.356 -0.082,-0.512 -0.777,-1.947 -2.537,-7.852 -0.387,-9.45 2.936,-2.187 5.591,-2.142 8.242,0.081 0.309,0.739 1.717,4.006 -0.14,7.769 -1.47,-0.551 -2.716,-0.516 -3.502,-0.384 -3.893,0.643 -4.473,11.541 -4.433,17.995 0.012,3.03 -1.493,6.243 -3.492,9.479 -0.068,-0.215 -0.154,-0.37 -0.262,-0.563 -1.374,-2.475 -3.63,-3.805 -5.099,-4.355 1.03,-1.787 1.989,-3.432 2.798,-4.893 z m -8.158,14.75 c 1.591,-3.059 3.006,-5.615 4.275,-7.889 1.143,0.327 4.159,1.841 4.94,5.254 -0.632,0.958 -1.286,1.878 -1.918,2.836 -2.034,2.9 -3.956,5.636 -5.225,8.365 -0.782,1.598 -1.282,3.342 -1.622,5.1 -2.475,-0.904 -4.249,-0.273 -5.685,0.424 0.934,-4.518 2.633,-9.205 5.235,-14.09 z m -5.657,16.701 c 0.331,-0.132 0.701,-0.288 1.048,-0.481 1.358,-0.652 2.699,-1.246 4.718,-0.342 -0.518,4.537 -0.021,9.171 0.717,12.961 -2.325,-0.632 -4.37,-0.762 -6.098,-0.41 0,0 0,0 -0.022,-0.039 -0.869,-3.666 -0.979,-7.602 -0.363,-11.689 z m -4.806,14.406 c 0.258,0.009 0.456,0 0.714,0.009 -0.396,0.472 -0.71,1.001 -1.002,1.568 -0.692,1.396 -0.668,2.901 -0.345,4.392 -1.057,-0.172 -2.153,-0.323 -3.348,-0.47 -5.376,-0.66 -11.452,-1.486 -17.321,-3.036 -10.077,-2.655 -19.09,-8.683 -21.972,-10.777 2.771,-2.641 6.781,-5.751 10.063,-10.039 5.268,2.743 28.67,15.004 32.566,18.103 0.186,0.152 0.427,0.22 0.645,0.25 z m -50.458,15.344 -2.445,1.412 c -4.236,-6.1 -4.004,-21.02 -4.004,-21.19 0.044,-0.442 -0.221,-0.841 -0.619,-1.017 l -18.327,-8.021 0.105,-1.881 c 9.557,1.102 20.606,5.548 20.759,5.624 0.376,0.237 0.851,0.178 1.187,-0.099 l 15.208,-12.68 3.273,2.925 c -4.742,5.824 -16.279,13.869 -16.428,13.952 -0.408,0.177 -0.628,0.601 -0.589,1.035 z m -8.673,-87.773 c 0.079,0.237 0.179,0.436 0.257,0.672 1.288,3.759 2.634,7.697 5.287,11.593 4.593,6.745 12.534,25.598 13.685,35.866 l -14.735,12.273 c -0.95,-0.474 -2.83,-1.364 -5.165,-2.333 0.118,-2.513 0.371,-14.602 -3.63,-25.8 -2.1,-5.896 -5.011,-11.652 -7.406,-16.262 -0.693,-1.385 -1.366,-2.71 -1.98,-3.957 0.514,-0.831 1.028,-1.663 1.483,-2.474 1.246,-2.098 2.392,-4.097 3.817,-4.671 5.222,-2.135 7.101,-3.423 8.387,-4.907 z m -3.743,-8.447 c 1.247,1.859 2.059,3.897 2.851,5.974 -1.127,1.663 -2.135,2.791 -8.348,5.325 -2.116,0.872 -3.521,3.286 -4.845,5.641 -0.237,0.376 -0.494,0.792 -0.732,1.167 -0.892,-1.978 -1.465,-3.601 -1.387,-4.551 0.118,-1.623 1.562,-3.522 3.105,-5.522 1.74,-2.295 3.698,-4.928 4.192,-7.797 0.317,-1.721 -0.021,-2.929 -0.497,-3.759 2.394,0.654 4.492,1.703 5.661,3.522 z m -22.675,-0.644 c 1.325,-1.761 2.234,-2.89 3.837,-3.326 0.93,-0.277 3.284,-0.535 6.094,-0.516 -0.158,0.119 -0.317,0.237 -0.435,0.376 -0.851,1.01 -1.146,2.889 -1.442,5.263 -0.415,2.909 -0.908,6.471 -2.648,9.064 -1.562,2.335 -2.888,2.514 -4.392,2.752 -0.653,0.119 -1.345,0.217 -2.038,0.515 -0.595,-2.869 -0.972,-6.667 -0.915,-11.733 0.712,-0.832 1.385,-1.682 1.939,-2.395 z m -9.595,5.84 c 2.196,-0.436 3.937,-0.853 5.441,-1.684 0.041,4.471 0.438,8.231 1.132,11.297 -0.02,0.04 -0.02,0.04 -0.04,0.079 -2.492,2.613 -5.795,5.661 -9.593,7.819 0.02,-0.237 -0.02,-0.456 0.02,-0.732 0.651,-5.857 -0.895,-11.179 -4.239,-14.878 2.906,-0.969 5.341,-1.485 7.279,-1.901 z m -39.565,18.02 c 3.659,-2.87 20.732,-11.9 29.91,-15.326 3.404,3.283 5.028,8.248 4.417,13.828 -0.058,0.811 -0.118,1.524 -0.098,2.176 -1.662,0.753 -3.383,1.327 -5.164,1.624 -2.79,0.436 -6.035,0.398 -9.478,0.36 -6.312,-0.038 -12.861,-0.094 -17.252,2.954 -8.15,5.622 -13.748,7.623 -14.481,6.812 -1.049,-1.068 -2.989,-4.312 1.085,-11.278 4.434,1.425 8.273,1.067 11.061,-1.15 z m -36.428,-6.08 c -3.662,-4.846 -5.089,-12.087 -4.674,-13.512 0.079,-0.257 0.257,-0.415 0.554,-0.514 0.97,-0.257 2.929,0.375 4.948,2.372 0.198,0.198 0.474,0.435 0.771,0.732 z m 4.157,4.252 c -0.792,-0.791 -1.603,-1.543 -2.217,-2.097 l 1.619,-11.258 c 0.732,0.712 1.544,1.463 2.434,2.254 z m 1.92,1.997 1.896,-11.318 c 0.93,0.811 1.88,1.682 2.85,2.511 l -2.311,11.655 c -0.832,-1.008 -1.643,-1.957 -2.435,-2.848 z m 5.383,6.746 c -0.376,-0.534 -0.753,-1.068 -1.167,-1.622 l 2.468,-12.268 c 1.623,1.405 3.246,2.709 4.671,3.817 z m 1.288,2.176 6.506,-10.944 c 0.95,0.672 1.801,1.246 2.474,1.582 0.514,0.257 1.01,0.455 1.544,0.672 -0.257,0.415 -0.494,0.89 -0.692,1.287 -1.423,2.85 -1.918,5.126 -1.897,6.965 -3.186,0.436 -5.302,2.001 -6.627,3.366 -0.278,-0.93 -0.734,-1.9 -1.308,-2.928 z m 13.211,15.451 c 0.232,0.126 0.502,0.167 0.76,0.111 l 5.3,-1.124 -2.784,3.282 c -0.369,0.429 -0.35,1.047 0.023,1.458 l 3.384,3.731 -6.074,-0.747 c -0.326,-0.04 -0.649,0.067 -0.887,0.288 l -4.488,4.17 -0.59,-4.489 c -0.053,-0.415 -0.338,-0.765 -0.735,-0.903 l -4.673,-1.614 3.74,-1.033 c 0.424,-0.119 0.739,-0.483 0.802,-0.925 l 0.321,-2.488 c 1.088,-0.072 2.166,-0.544 3.172,-1.207 z m 23.549,-19.046 c -1.266,2.532 -1.086,5.144 -0.71,6.668 -2.058,0.159 -3.957,0.298 -5.619,0.457 -7.894,0.557 -11.496,0.835 -16.105,3.33 -0.139,0.078 -0.297,0.198 -0.375,0.356 -1.166,1.741 -5.043,6.531 -7.576,5.662 -3.464,-1.186 -4.928,-3.402 -4.593,-6.845 0.435,-0.673 2.333,-3.681 6.488,-4.276 0.376,1.524 1.109,2.532 1.663,3.106 2.731,2.848 12.049,-2.834 17.35,-6.516 2.493,-1.722 5.994,-2.297 9.793,-2.477 -0.137,0.178 -0.216,0.336 -0.316,0.535 z m 10.45,5.516 c -3.423,0.417 -6.332,0.695 -8.924,0.934 -0.376,-1.128 -0.832,-4.471 1.54,-7.044 1.148,-0.021 2.275,-0.001 3.423,-0.021 3.542,0.039 6.886,0.077 9.854,-0.419 1.761,-0.257 3.482,-0.832 5.124,-1.545 0.654,2.552 2.178,3.659 3.563,4.45 -4.253,1.781 -9.08,3.029 -14.58,3.645 z m 26.41,-11.683 c -2.531,2.791 -5.716,5.107 -9.436,6.909 -0.297,-0.198 -0.633,-0.415 -0.99,-0.594 -1.306,-0.751 -2.553,-1.523 -2.95,-3.699 4.035,-2.138 7.576,-5.166 10.285,-7.918 0.792,2.275 1.842,4.035 3.108,5.262 0.003,0 0.003,0 -0.017,0.04 z m 1.78,-1.386 c -1.068,-0.93 -2.177,-2.571 -3.049,-5.48 0.554,-0.317 1.148,-0.416 1.839,-0.515 1.662,-0.258 3.759,-0.595 5.855,-3.702 2.037,-2.988 2.59,-6.867 3.023,-10.013 0.237,-1.761 0.473,-3.622 0.948,-4.175 0.494,-0.594 1.998,-0.931 3.086,-0.437 1.247,0.574 1.247,1.959 1.069,3.007 -0.395,2.375 -2.115,4.631 -3.776,6.867 -1.72,2.257 -3.342,4.414 -3.539,6.689 -0.138,1.564 0.734,3.878 2.159,6.866 -0.909,1.128 -1.879,1.98 -3.105,2.158 -1.759,0.257 -3.263,-0.197 -4.51,-1.265 z m 3.543,4.786 c 0.02,-0.237 -0.06,-0.474 -0.159,-0.673 -0.139,-0.217 -0.257,-0.375 -0.396,-0.594 0.614,0.06 1.227,0.02 1.859,-0.06 1.544,-0.218 2.77,-1.089 3.818,-2.198 0.456,0.97 0.95,1.959 1.505,3.027 2.495,4.808 5.247,10.286 7.287,16.004 3.506,9.813 3.628,20.655 3.531,24.217 -4.289,-0.931 -8.644,-1.899 -13.97,-2.626 -0.712,-5.895 -3.828,-32.13 -3.475,-37.097 z M 197.06,179.52 c 2.787,-2.831 5.707,-5.795 8.008,-9.91 3.981,-7.123 17.299,-22.653 25.971,-28.271 l 17.565,7.699 c 0,1.062 0.044,3.142 0.221,5.663 -2.301,1.017 -13.228,6.194 -21.458,14.777 -4.335,4.513 -8.185,9.689 -11.238,13.892 -0.929,1.239 -1.814,2.433 -2.655,3.54 -0.973,-0.088 -1.946,-0.177 -2.876,-0.221 -2.433,-0.177 -4.734,-0.31 -5.885,-1.327 -4.247,-3.716 -6.239,-4.822 -8.141,-5.309 0.178,-0.179 0.311,-0.356 0.488,-0.533 z m -6.99,14.291 c -0.487,-2.433 -0.487,-4.778 0.619,-6.636 1.106,-1.946 2.566,-3.584 4.071,-5.22 1.991,0.266 3.45,0.664 8.494,5.088 1.726,1.504 4.513,1.682 7.212,1.814 0.442,0.044 0.929,0.088 1.372,0.132 -1.372,1.682 -2.567,2.92 -3.45,3.274 -1.504,0.619 -3.849,0.177 -6.327,-0.31 -2.831,-0.531 -6.061,-1.106 -8.849,-0.266 -1.682,0.486 -2.611,1.327 -3.142,2.124 z m 3.761,0 c 2.301,-0.707 5.088,-0.177 7.831,0.31 2.787,0.531 5.442,1.017 7.565,0.177 1.46,-0.575 3.142,-2.389 5.176,-5 1.416,0.309 2.61,0.797 3.318,1.814 1.017,1.46 1.283,3.008 0.885,4.601 -0.354,1.372 -1.327,3.097 -3.54,5.176 -0.531,-0.354 -0.885,-0.841 -1.283,-1.416 -0.973,-1.372 -2.212,-3.097 -5.929,-3.584 -3.584,-0.487 -7.3,0.753 -10.308,1.77 -1.682,0.575 -3.452,1.195 -4.159,1.017 -0.753,-0.178 -1.726,-1.372 -1.77,-2.567 -0.043,-1.369 1.196,-1.988 2.214,-2.298 z m 9.423,14.599 c -1.062,-0.266 -2.123,-0.487 -3.008,-0.663 -2.168,-0.398 -3.584,-0.708 -4.69,-1.947 -0.664,-0.708 -1.947,-2.699 -3.186,-5.22 0.178,0.088 0.354,0.177 0.531,0.221 1.283,0.31 3.096,-0.266 5.353,-1.062 2.787,-0.929 6.194,-2.08 9.291,-1.682 2.787,0.354 3.54,1.46 4.424,2.699 0.398,0.531 0.797,1.106 1.372,1.592 -2.3,1.815 -5.53,3.85 -10.087,6.062 z m 6.504,5.31 c -1.372,-1.77 -2.521,-3.142 -3.938,-4.115 3.981,-2.035 7.167,-4.071 9.601,-6.061 0.044,0 0.044,0 0.088,0 3.45,1.062 7.654,2.655 11.282,5.088 -0.221,0.088 -0.398,0.221 -0.664,0.309 -5.53,2.035 -9.601,5.796 -11.414,10.442 -2.168,-2.168 -3.716,-4.115 -4.955,-5.663 z m 33.802,27.341 c -4.203,-1.991 -19.91,-13.228 -27.076,-19.91 1.416,-4.513 5.132,-8.184 10.397,-10.132 0.753,-0.31 1.416,-0.575 1.991,-0.885 1.416,1.151 2.699,2.433 3.761,3.893 1.638,2.301 3.053,5.22 4.557,8.318 2.787,5.663 5.663,11.548 10.353,14.113 8.672,4.778 12.963,8.893 12.565,9.91 -0.487,1.416 -2.521,4.601 -10.574,4.071 -0.71,-4.599 -2.744,-7.873 -5.974,-9.378 z m 0.839,45.526 c -0.266,0.044 -0.487,-0.044 -0.707,-0.266 -0.664,-0.753 -0.973,-2.787 -0.088,-5.486 0.088,-0.266 0.178,-0.619 0.31,-1.017 l 10.486,-3.451 c -2.7,5.442 -8.54,9.956 -10.001,10.22 z m 11.061,-12.919 -10.795,3.584 c 0.31,-0.973 0.619,-2.035 0.929,-3.186 l 10.751,-3.318 c -0.354,1.062 -0.663,2.125 -0.885,2.92 z m 1.814,-5.53 -10.973,3.362 c 0.31,-1.194 0.664,-2.433 0.973,-3.672 l 11.458,-3.142 c -0.528,1.196 -1.015,2.346 -1.458,3.452 z m 2.7,-6.062 -12.078,3.274 c 0.531,-2.079 0.973,-4.115 1.327,-5.884 l 11.68,0.841 c -0.31,0.576 -0.619,1.15 -0.929,1.769 z m 2.3,-3.893 -12.697,-0.929 c 0.177,-1.151 0.309,-2.168 0.309,-2.92 0,-0.575 -0.044,-1.106 -0.088,-1.682 0.487,0.044 1.017,0.044 1.46,0.044 3.186,0 5.442,-0.575 7.079,-1.416 1.814,2.655 4.159,3.849 5.973,4.424 -0.708,0.665 -1.373,1.506 -2.036,2.479 z m 4.306,-23.692 4.18,1.024 c 0.548,0.138 1.094,-0.156 1.294,-0.672 l 1.825,-4.694 2.046,5.768 c 0.11,0.309 0.35,0.551 0.654,0.665 l 5.736,2.152 -3.753,2.534 c -0.348,0.233 -0.534,0.643 -0.48,1.06 l 0.643,4.902 -2.594,-2.884 c -0.296,-0.327 -0.762,-0.445 -1.186,-0.305 l -2.37,0.824 c -0.551,-0.941 -1.454,-1.695 -2.497,-2.298 l 0.115,-3.107 c 0.009,-0.264 -0.076,-0.523 -0.239,-0.73 z m -14.748,-5.11 c 4.026,6.814 5.885,9.91 10.176,12.919 0.132,0.088 0.309,0.177 0.487,0.177 2.079,0.266 8.096,1.592 8.45,4.247 0.487,3.628 -0.841,5.929 -4.071,7.167 -0.797,-0.088 -4.335,-0.442 -6.725,-3.893 1.195,-1.017 1.77,-2.123 2.035,-2.876 1.327,-3.716 -7.919,-9.512 -13.582,-12.609 -2.655,-1.46 -4.734,-4.335 -6.592,-7.654 0.221,0.044 0.398,0.044 0.619,0.044 2.831,0 5.088,-1.327 6.282,-2.345 1.063,1.771 2.037,3.408 2.921,4.823 z m -8.937,-14.289 c 1.902,2.876 3.45,5.354 4.822,7.565 -0.841,0.841 -3.628,2.743 -6.99,1.77 -0.531,-1.017 -1.017,-2.035 -1.548,-3.052 -1.548,-3.186 -3.008,-6.194 -4.778,-8.628 -1.017,-1.46 -2.301,-2.743 -3.672,-3.893 1.991,-1.726 2.301,-3.584 2.389,-5.176 3.496,3.008 6.769,6.768 9.777,11.414 z M 231.039,202.04 c -0.044,0.354 -0.088,0.753 -0.088,1.151 -0.088,1.504 -0.221,2.965 -1.991,4.291 -3.716,-2.655 -8.008,-4.469 -11.68,-5.663 1.682,-1.726 2.787,-3.451 3.318,-5.132 0,0 0,0 0.044,0 3.627,1.016 7.123,2.831 10.397,5.353 z m -9.734,-11.636 c -0.221,0.088 -0.398,0.266 -0.531,0.442 -0.132,0.221 -0.221,0.398 -0.354,0.619 -0.221,-0.575 -0.531,-1.106 -0.885,-1.636 -0.885,-1.283 -2.212,-1.991 -3.672,-2.433 0.664,-0.841 1.327,-1.726 2.035,-2.699 3.186,-4.38 6.858,-9.291 11.061,-13.671 7.212,-7.521 16.856,-12.477 20.086,-13.981 0.487,4.69 1.548,10.22 3.893,13.671 -4.955,3.273 -27.031,17.785 -31.633,19.688 z m 89.417,-20.937 c -1.188,5.517 -1.19,7.795 -0.691,9.694 -0.241,-0.068 -0.46,-0.099 -0.701,-0.168 -3.829,-1.063 -7.838,-2.177 -12.552,-2.193 -8.16,-0.024 -28.201,-4.131 -37.323,-8.986 l -1.793,-19.093 c 0.928,-0.515 2.724,-1.564 4.844,-2.942 2.006,1.517 11.836,8.561 23.334,11.59 6.05,1.601 12.444,2.454 17.6,3.083 1.534,0.212 3.008,0.405 4.383,0.604 0.395,0.894 0.79,1.788 1.203,2.622 1.027,2.213 2.027,4.29 1.696,5.789 z m 8.393,11.382 c -2.239,-0.022 -4.378,-0.504 -6.54,-1.025 -0.734,-1.869 -1.095,-3.339 0.327,-9.897 0.478,-2.239 -0.721,-4.761 -1.914,-7.186 -0.177,-0.408 -0.374,-0.855 -0.549,-1.263 2.135,0.384 3.798,0.826 4.537,1.429 1.272,1.014 2.023,3.279 2.799,5.682 0.91,2.733 1.975,5.836 4.063,7.865 1.241,1.234 2.428,1.638 3.381,1.716 -1.892,1.607 -3.943,2.745 -6.104,2.679 z m 7.362,-5.149 c -1.177,0.704 -2.321,-0.078 -3.085,-0.818 -1.736,-1.668 -2.624,-4.363 -3.53,-6.997 -0.888,-2.695 -1.751,-5.252 -3.517,-6.7 -1.212,-0.998 -3.614,-1.587 -6.883,-2.1 -0.417,-1.388 -0.57,-2.669 -0.024,-3.782 0.782,-1.598 2.007,-2.582 3.593,-3.007 1.37,-0.356 3.352,-0.342 6.244,0.583 -0.052,0.636 -0.306,1.182 -0.615,1.809 -0.727,1.516 -1.634,3.437 -0.256,6.923 1.314,3.37 4.201,6.017 6.55,8.154 1.319,1.191 2.719,2.438 2.908,3.143 0.211,0.743 -0.361,2.174 -1.385,2.792 z m 6.561,-8.146 c -0.297,0.924 -1.415,3.012 -3.018,5.32 -0.009,-0.198 -0.017,-0.396 -0.064,-0.572 -0.352,-1.272 -1.735,-2.579 -3.527,-4.165 -2.165,-1.986 -4.824,-4.406 -5.98,-7.308 -1.043,-2.609 -0.441,-3.804 0.212,-5.178 0.271,-0.606 0.58,-1.234 0.727,-1.972 2.702,1.131 6.049,2.967 10.195,5.878 0.284,1.057 0.605,2.093 0.881,2.953 0.705,2.088 1.121,3.476 0.574,5.044 z m 0.032,-16.26 c -0.882,2.058 -1.523,3.73 -1.687,5.44 -3.712,-2.494 -7.037,-4.291 -9.959,-5.452 -0.021,-0.039 -0.021,-0.039 -0.043,-0.077 -0.746,-3.532 -1.394,-7.98 -1.026,-12.333 0.184,0.15 0.386,0.241 0.593,0.43 4.463,3.848 9.727,5.581 14.669,4.913 -0.844,2.945 -1.794,5.245 -2.547,7.079 z m 7.502,-42.823 c 0.299,4.641 -1.903,23.828 -4.267,33.336 -4.632,0.952 -9.647,-0.515 -13.905,-4.173 -0.636,-0.508 -1.19,-0.959 -1.74,-1.311 0.319,-1.796 0.818,-3.541 1.579,-5.177 1.217,-2.548 3.083,-5.203 5.06,-8.021 3.598,-5.185 7.348,-10.556 7.316,-15.902 -0.031,-9.901 1.484,-15.65 2.567,-15.796 1.474,-0.262 5.247,-0.029 8.691,7.27 -3.678,2.851 -5.553,6.22 -5.301,9.774 z m 8.535,-11.974 c -0.503,0.279 -0.946,0.575 -1.427,0.893 -0.198,-0.447 -0.455,-0.911 -0.67,-1.298 -1.546,-2.785 -3.144,-4.479 -4.673,-5.502 1.441,-2.874 1.347,-5.504 0.97,-7.369 0.924,0.297 1.981,0.469 3.154,0.577 l 5.351,11.553 c -1.094,0.403 -2.048,0.781 -2.705,1.146 z m 4.809,-1.911 -4.934,-10.621 c 0.653,-0.009 1.306,-0.017 1.998,-0.046 l 8.724,8.971 c -2.075,0.546 -4.069,1.148 -5.788,1.696 z m 8.256,-2.356 -8.308,-8.494 c 1.302,-0.116 2.545,-0.248 3.725,-0.398 l 8.265,7.961 c -1.194,0.309 -2.449,0.601 -3.682,0.931 z m 6.269,-1.557 -8.119,-7.789 c 1.1,-0.205 2.179,-0.45 2.983,-0.643 l 8.373,7.7 c -1.001,0.199 -2.08,0.444 -3.237,0.732 z m 6.885,-1.544 c -0.275,0.051 -0.627,0.146 -1.039,0.223 l -8.106,-7.494 c 6.068,-0.281 12.847,2.635 13.789,3.783 0.168,0.211 0.198,0.447 0.111,0.748 -0.336,0.945 -1.966,2.203 -4.755,2.74 z"
       id="path51" />
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g58"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g59"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g60"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g61"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g62"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g63"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g64"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g65"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const IN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs33" />
    <path
       fill="#fab446"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g18"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 256,303.449 c -26.164,0 -47.448,-21.284 -47.448,-47.448 0,-26.164 21.284,-47.448 47.448,-47.448 26.164,0 47.448,21.284 47.448,47.448 0,26.164 -21.284,47.448 -47.448,47.448 z m 0,-86.069 c -21.298,0 -38.621,17.323 -38.621,38.621 0,21.298 17.323,38.621 38.621,38.621 21.298,0 38.621,-17.323 38.621,-38.621 0,-21.298 -17.323,-38.621 -38.621,-38.621 z"
       id="path3" />
    	<circle
       fill="#41479b"
       cx="256"
       cy="256.00101"
       r="5.3790002"
       id="circle3" />
    	<polygon
       fill="#41479b"
       points="212.966,256.808 212.966,255.194 242.33,253.814 256,255.194 256,256.808 242.33,258.188 "
       id="polygon3" />
    	<polygon
       fill="#41479b"
       points="299.034,256.808 299.034,255.194 269.67,253.814 256,255.194 256,256.808 269.67,258.188 "
       id="polygon4" />
    	<polygon
       fill="#41479b"
       points="255.193,212.967 256.807,212.967 258.187,242.331 256.807,256.001 255.193,256.001 253.813,242.331 "
       id="polygon5" />
    	<polygon
       fill="#41479b"
       points="255.193,299.035 256.807,299.035 258.187,269.671 256.807,256.001 255.193,256.001 253.813,269.671 "
       id="polygon6" />
    	<polygon
       fill="#41479b"
       points="225,226.142 226.141,225.001 247.881,244.789 256.57,255.431 255.43,256.571 244.788,247.882 "
       id="polygon7" />
    	<polygon
       fill="#41479b"
       points="285.859,287.001 287,285.86 267.212,264.12 256.57,255.431 255.43,256.571 264.119,267.213 "
       id="polygon8" />
    	<polygon
       fill="#41479b"
       points="285.859,225.001 287,226.142 267.212,247.882 256.57,256.571 255.43,255.431 264.119,244.789 "
       id="polygon9" />
    	<polygon
       fill="#41479b"
       points="225,285.86 226.141,287.001 247.881,267.213 256.57,256.571 255.43,255.431 244.788,264.12 "
       id="polygon10" />
    	<polygon
       fill="#41479b"
       points="216.551,273.215 215.933,271.724 242.534,259.212 255.691,255.255 256.309,256.747 244.207,263.253 "
       id="polygon11" />
    	<polygon
       fill="#41479b"
       points="296.067,240.278 295.449,238.787 267.793,248.749 255.691,255.255 256.309,256.747 269.466,252.79 "
       id="polygon12" />
    	<polygon
       fill="#41479b"
       points="238.786,216.552 240.277,215.934 252.789,242.535 256.746,255.692 255.254,256.31 248.748,244.208 "
       id="polygon13" />
    	<polygon
       fill="#41479b"
       points="271.723,296.068 273.214,295.45 263.252,267.794 256.746,255.692 255.254,256.31 259.211,269.467 "
       id="polygon14" />
    	<polygon
       fill="#41479b"
       points="215.933,240.278 216.551,238.787 244.207,248.749 256.309,255.255 255.691,256.747 242.534,252.79 "
       id="polygon15" />
    	<polygon
       fill="#41479b"
       points="295.449,273.215 296.067,271.724 269.466,259.212 256.309,255.255 255.691,256.747 267.793,263.253 "
       id="polygon16" />
    	<polygon
       fill="#41479b"
       points="271.723,215.934 273.214,216.552 263.252,244.208 256.746,256.31 255.254,255.692 259.211,242.535 "
       id="polygon17" />
    	<polygon
       fill="#41479b"
       points="238.786,295.45 240.277,296.068 252.789,269.467 256.746,256.31 255.254,255.692 248.748,267.794 "
       id="polygon18" />
    </g>
    <circle
       fill="#f5f5f5"
       cx="256"
       cy="167.72501"
       r="7.256"
       id="circle18" />
    <circle
       fill="#41479b"
       cx="256"
       cy="167.72501"
       r="4.3509998"
       id="circle19" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const IO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs29" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g8"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 512,353.103 c -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.629,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.589,0 -25.589,8.828 -51.177,8.828 -25.602,0 -25.602,-8.828 -51.204,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.595,0 -25.596,-8.828 -51.19,-8.828 -25.594,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.168,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 V 326.62 c 25.571,0 25.571,-8.828 51.143,-8.828 25.584,0 25.584,8.828 51.168,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.596,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.602,0 25.602,8.828 51.204,8.828 25.589,0 25.589,-8.828 51.177,-8.828 25.611,0 25.611,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.629,0 25.629,8.828 51.256,8.828 z"
       id="path2" />
    	<path
       fill="#41479b"
       d="m 512,247.172 c -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.629,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.589,0 -25.589,8.828 -51.177,8.828 -25.602,0 -25.602,-8.828 -51.204,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.595,0 -25.596,-8.828 -51.19,-8.828 -25.594,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.168,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 V 220.69 c 25.571,0 25.571,-8.828 51.143,-8.828 25.584,0 25.584,8.828 51.168,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.596,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.602,0 25.602,8.828 51.204,8.828 25.589,0 25.589,-8.828 51.177,-8.828 25.611,0 25.611,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.629,0 25.629,8.828 51.256,8.828 z"
       id="path3" />
    	<path
       fill="#41479b"
       d="m 512,194.207 c -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.629,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.589,0 -25.589,8.828 -51.177,8.828 -25.602,0 -25.602,-8.828 -51.204,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.595,0 -25.596,-8.828 -51.19,-8.828 -25.594,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.168,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 v -26.483 c 25.571,0 25.571,-8.828 51.143,-8.828 25.584,0 25.584,8.828 51.168,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.596,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.602,0 25.602,8.828 51.204,8.828 25.589,0 25.589,-8.828 51.177,-8.828 25.611,0 25.611,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.629,0 25.629,8.828 51.256,8.828 z"
       id="path4" />
    	<path
       fill="#41479b"
       d="m 512,141.242 c -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.629,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.589,0 -25.589,8.828 -51.177,8.828 -25.602,0 -25.602,-8.828 -51.204,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.595,0 -25.596,-8.828 -51.19,-8.828 -25.594,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.168,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 v -26.483 c 25.571,0 25.571,-8.828 51.143,-8.828 25.584,0 25.584,8.828 51.168,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.596,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.602,0 25.602,8.828 51.204,8.828 25.589,0 25.589,-8.828 51.177,-8.828 25.611,0 25.611,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.629,0 25.629,8.828 51.256,8.828 z"
       id="path5" />
    	<path
       fill="#41479b"
       d="m 512,300.138 c -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.629,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.589,0 -25.589,8.828 -51.177,8.828 -25.602,0 -25.602,-8.828 -51.204,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.595,0 -25.596,-8.828 -51.19,-8.828 -25.594,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.168,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 v -26.483 c 25.571,0 25.571,-8.828 51.143,-8.828 25.584,0 25.584,8.828 51.168,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.596,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.602,0 25.602,8.828 51.204,8.828 25.589,0 25.589,-8.828 51.177,-8.828 25.611,0 25.611,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.629,0 25.629,8.828 51.256,8.828 z"
       id="path6" />
    	<path
       fill="#41479b"
       d="m 512,406.069 c -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.629,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.589,0 -25.589,8.828 -51.177,8.828 -25.602,0 -25.602,-8.828 -51.204,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.595,0 -25.596,-8.828 -51.19,-8.828 -25.594,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.168,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 v -26.483 c 25.571,0 25.571,-8.828 51.143,-8.828 25.584,0 25.584,8.828 51.168,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.596,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.602,0 25.602,8.828 51.204,8.828 25.589,0 25.589,-8.828 51.177,-8.828 25.611,0 25.611,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.629,0 25.629,8.828 51.256,8.828 z"
       id="path7" />
    	<path
       fill="#41479b"
       d="M 247.172,256 H 8.828 C 3.953,256 0,252.047 0,247.172 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 238.344 c 4.875,0 8.828,3.953 8.828,8.828 v 150.069 c -0.001,4.876 -3.952,8.827 -8.828,8.827 z"
       id="path8" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path9" />
    <g
       id="g13"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon9" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path10" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path11" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path12" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path13" />
    </g>
    <path
       fill="#965032"
       d="m 388.413,299.111 v 0 c -3.375,0 -6.111,-2.737 -6.111,-6.111 V 97.448 h 12.222 v 195.553 c 10e-4,3.375 -2.736,6.11 -6.111,6.11 z"
       id="path14" />
    <polygon
       fill="#73af00"
       points="416.746,198.432 444.588,162.635 448.909,149.671 435.946,153.993 400.149,181.834 394.525,136.836 388.413,124.613 382.302,136.836 376.678,181.834 340.881,153.993 327.918,149.671 332.239,162.635 360.081,198.432 315.081,204.056 302.859,210.167 315.081,216.278 360.081,221.904 332.239,257.699 327.918,270.664 340.881,266.343 379.771,236.095 388.413,222.39 397.055,236.095 435.946,266.343 448.909,270.664 444.588,257.699 416.746,221.904 461.746,216.278 473.968,210.167 461.746,204.056 "
       id="polygon14"
       transform="translate(0,-88.276)" />
    <path
       fill="#ffe15a"
       d="m 415.018,193.064 c -5.492,-5.482 -17.252,-3.467 -23.549,-1.877 v -5.129 c 0,-1.687 -1.368,-3.055 -3.055,-3.055 -1.687,0 -3.055,1.368 -3.055,3.055 v 5.128 c -6.296,-1.594 -18.055,-3.609 -23.549,1.878 -5.238,5.235 -1.443,17.858 2.161,26.634 v 8.126 c 0,2.247 1.821,4.066 4.066,4.066 h 40.756 c 2.246,0 4.066,-1.821 4.066,-4.066 v -8.126 c 3.602,-8.776 7.397,-21.4 2.159,-26.634 z m -4.321,4.321 c 2.333,2.335 -0.28,12.567 -4.49,22.284 h -14.739 v -22.17 c 6.861,-1.943 16.259,-3.091 19.229,-0.114 z m -44.567,0 c 2.968,-2.976 12.366,-1.828 19.229,0.114 v 22.169 H 370.62 c -4.21,-9.716 -6.823,-19.948 -4.49,-22.283 z"
       id="path15" />
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const IQ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs24" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#464655"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 308.065,233.526 c -0.928,-0.483 -2.027,-2.211 -1.684,-2.967 0.361,-0.793 -0.201,-0.725 1.696,-0.161 3.43,0.888 5.65,0.483 7.829,-1.372 l 1.937,-1.533 2.261,1.13 c 1.25,0.564 2.541,0.967 2.905,0.886 1.049,-0.242 3.069,-2.825 3.027,-3.713 -0.041,-1.208 0.847,-0.886 1.291,0.405 0.928,2.422 -0.779,6.599 -3.119,7.164 -1.128,0.322 -2.178,0.242 -3.955,-0.322 -2.098,-0.808 -2.422,-0.808 -3.55,0 -2.342,1.856 -5.692,2.019 -8.638,0.483"
       id="path3" />
    	<path
       fill="#73af00"
       d="m 316.9,224.183 c -1.132,-1.587 -2.493,-7.14 -2.095,-8.499 0.395,-1.248 0.792,-1.474 1.868,-1.134 1.927,0.679 2.382,1.927 2.153,6.462 -0.339,3.397 -0.791,4.532 -1.926,3.171"
       id="path4" />
    	<path
       fill="#73af00"
       d="m 241.005,248.731 c -4.651,2.646 -11.569,3.101 -11.569,10.434 -10.13,0.377 -22.076,0.831 -32.85,0.604 2.92,-3.772 21.401,-20.853 29.086,-27.623 1.272,-1.12 1.704,-3.288 0.964,-4.813 l -0.199,-0.41 c -1.108,-2.285 -4.122,-2.829 -5.958,-1.074 -7.658,7.326 -15.247,14.152 -16.483,15.322 -9.914,10.02 -12.822,12.94 -14.38,14.508 -1.109,1.117 -1.726,2.626 -1.718,4.2 v 0.103 c 0.018,3.27 2.673,5.911 5.942,5.911 h 43.381 c 2.458,0 -0.565,-8.543 2.609,-8.543 2.207,0 2.41,3.065 2.313,6.312 -0.074,2.47 -2.109,4.424 -4.579,4.427 -18.755,0.026 -38.279,0.205 -56.651,0.222 -1.517,0.001 -2.735,-1.23 -2.735,-2.748 v -3.305 c 0,-2.802 -3.112,-4.431 -5.454,-2.893 -0.086,0.056 -0.17,0.11 -0.254,0.162 -1.224,0.765 -1.85,2.263 -1.372,3.624 0.31,0.884 0.445,1.96 0.474,3.085 0.04,1.487 -1.171,2.713 -2.658,2.759 -6.076,0.186 -12.679,0.241 -14.554,-3.342 -1.058,-2.02 -3.309,-2.974 -5.35,-1.954 l -0.271,0.136 c -2.148,1.074 -3.008,3.731 -1.832,5.824 2.238,3.979 4.28,8.595 3.22,15.06 -0.864,2.037 -2.492,3.313 -4.256,4.461 -1.96,1.276 -0.73,4.262 1.569,3.837 5.574,-1.03 9.415,-5.442 10.59,-10.642 h 86.42 c 3.169,0 5.739,-2.57 5.739,-5.739 v -18.755 c -0.792,-5.596 -6.803,-5.369 -9.184,-9.15 z"
       id="path5" />
    	<path
       fill="#73af00"
       d="m 350.62,223.948 c 1.275,0.82 2.552,1.641 3.975,2.319 1.556,0.743 2.151,2.643 1.241,4.107 -0.241,0.387 -0.441,0.82 -0.556,1.346 v 37.197 c 2.542,0.529 4.001,0.028 5.16,-0.771 1.308,-0.902 3.076,-0.246 3.489,1.288 0.877,3.263 2.313,6.45 3.079,9.352 0.479,1.813 -0.883,3.588 -2.759,3.588 h -14.572 c -1.29,0 -2.336,-1.046 -2.336,-2.336 v -54.3 c -0.001,-1.683 1.863,-2.701 3.279,-1.79 z"
       id="path6" />
    	<path
       fill="#73af00"
       d="m 332.975,233.006 c 0.011,10.271 0.131,21.335 0.148,32.345 0.002,1.427 -1.155,2.583 -2.582,2.583 h -0.167 c -1.425,0 -2.58,-1.155 -2.58,-2.58 v -26.09 c 0,-1.42 -1.669,-2.179 -2.737,-1.245 l -3.42,2.955 c -0.7,0.604 -1.102,1.473 -1.105,2.397 -0.011,4.244 -0.049,16.6 -0.064,21.994 -0.004,1.421 -1.158,2.569 -2.58,2.569 h -0.234 c -1.418,0 -2.57,-1.139 -2.58,-2.557 -0.025,-3.591 -0.069,-10.246 -0.087,-15.238 -0.006,-1.436 -1.704,-2.186 -2.784,-1.24 -3.543,3.105 -4.361,3.807 -6.22,5.728 0.151,0.983 0.908,0 1.361,0.755 v 4.991 c -12.908,-2.43 -13.871,7.882 -13.388,18.946 0.073,1.663 1.438,2.978 3.102,2.978 h 40.526 c 1.503,0 2.721,-1.218 2.721,-2.721 v -50.381 c 0,-1.683 -1.997,-2.547 -3.239,-1.41 -0.99,0.906 -2.047,1.813 -2.955,2.634 -0.728,0.665 -1.137,1.599 -1.136,2.587 z m -29.825,34.551 c -0.793,-2.269 3.668,-3.101 4.196,-1.058 0.189,2.494 -3.212,2.57 -4.196,1.058 z"
       id="path7" />
    	<path
       fill="#73af00"
       d="m 169.295,286.381 c 1.55,0 2.797,1.286 2.797,2.797 0,1.589 -1.247,2.798 -2.797,2.798 -1.587,0 -2.874,-1.209 -2.874,-2.798 0.001,-1.511 1.288,-2.797 2.874,-2.797"
       id="path8" />
    	<path
       fill="#73af00"
       d="m 261.44,225.088 c 0.757,0.455 1.535,0.89 2.364,1.281 1.496,0.707 2.086,2.566 1.171,3.945 -0.275,0.415 -0.51,0.886 -0.648,1.482 v 37.121 c 2.694,0.599 4.167,0.012 5.342,-0.857 1.17,-0.865 2.854,-0.267 3.229,1.138 0.673,2.52 1.685,5.012 2.466,7.378 0.956,2.893 -1.19,5.874 -4.237,5.874 H 259.76 c -1.841,0 -3.333,-1.492 -3.333,-3.334 v -51.153 c 0,-2.572 2.807,-4.2 5.013,-2.875 z"
       id="path9" />
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const IR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs57" />
    <path
       fill="#73af00"
       d="M 512,111.816 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.875 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <g
       id="g38"
       transform="translate(0,-88.276)">
    	<rect
       y="200.088"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    	<path
       fill="#f5f5f5"
       d="m 1.389,194.176 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.008 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.827 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 11.502 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.938 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.79 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 2.935 c 0.767,0 1.389,0.621 1.389,1.389 v 0.151 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.792 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 1.389 C 0.622,185.46 0,186.081 0,186.849 v 5.938 c 0,0.766 0.621,1.389 1.389,1.389 z m 5.748,0 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 7.137 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.766 0.622,1.389 1.389,1.389 z M 1.389,182.531 h 34.423 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 1.389 C 0.622,179.601 0,180.222 0,180.99 v 0.152 c 0,0.768 0.621,1.389 1.389,1.389 z m 34.422,11.645 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -5.938 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 8.648 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.077 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.077 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.115 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.042 c 0.767,0 1.389,0.621 1.389,1.389 v 11.797 c 0,0.767 -0.621,1.389 -1.389,1.389 H 41.447 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.79 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.151 c 0,0.767 0.621,1.389 1.389,1.389 h 2.933 c 0.767,0 1.389,0.621 1.389,1.389 v 0.079 c 0,0.766 -0.623,1.389 -1.39,1.389 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 58.618,194.176 h 0.115 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.008 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.754 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 11.502 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.938 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.79 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 2.935 c 0.767,0 1.389,0.621 1.389,1.389 v 0.151 c 0,0.767 -0.621,1.389 -1.389,1.389 H 72.9 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 58.618 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.938 c 10e-4,0.766 0.623,1.389 1.389,1.389 z m 5.713,0 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 10e-4,0.766 0.622,1.389 1.389,1.389 z m -5.713,-11.645 h 34.388 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 58.618 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 10e-4,0.768 0.623,1.389 1.389,1.389 z m 34.388,11.645 h -5.827 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -5.938 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 8.648 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.115 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.115 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.042 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.115 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.077 c 0.767,0 1.389,0.621 1.389,1.389 v 11.797 c 0,0.767 -0.621,1.389 -1.389,1.389 H 98.607 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.754 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.151 c 0,0.767 0.621,1.389 1.389,1.389 h 2.935 c 0.767,0 1.389,0.621 1.389,1.389 v 0.079 c -0.005,0.766 -0.626,1.389 -1.393,1.389 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 115.814,194.176 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.008 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.792 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 11.538 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.938 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.79 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 2.935 c 0.767,0 1.389,0.621 1.389,1.389 v 0.151 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.827 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.502 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.938 c -0.002,0.766 0.621,1.389 1.388,1.389 z m 5.712,0 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.766 0.622,1.389 1.389,1.389 z m -5.712,-11.645 h 34.424 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -34.424 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c -10e-4,0.768 0.622,1.389 1.389,1.389 z m 34.424,11.645 h -5.827 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -5.938 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 8.646 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.079 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.115 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.115 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.042 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.077 c 0.767,0 1.389,0.621 1.389,1.389 v 11.797 c 0,0.767 -0.621,1.389 -1.389,1.389 h -11.54 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.79 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.151 c 0,0.767 0.621,1.389 1.389,1.389 h 2.973 c 0.767,0 1.389,0.621 1.389,1.389 v 0.079 c -0.002,0.766 -0.624,1.389 -1.391,1.389 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 173.007,194.176 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.008 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 11.54 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.938 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.827 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 2.935 c 0.767,0 1.389,0.621 1.389,1.389 v 0.151 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.502 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.938 c 0,0.766 0.622,1.389 1.388,1.389 z m 5.713,0 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0.001,0.766 0.622,1.389 1.389,1.389 z m -5.713,-11.645 h 34.388 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -34.388 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0.001,0.768 0.623,1.389 1.389,1.389 z m 34.388,11.645 h -5.827 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -5.938 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 8.721 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.077 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.042 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.115 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.077 c 0.767,0 1.389,0.621 1.389,1.389 v 11.797 c 0,0.767 -0.621,1.389 -1.389,1.389 h -11.507 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.827 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.151 c 0,0.767 0.621,1.389 1.389,1.389 h 2.935 c 0.767,0 1.389,0.621 1.389,1.389 v 0.079 c 0.002,0.766 -0.619,1.389 -1.386,1.389 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 230.2,194.176 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.008 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 11.54 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.938 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.827 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 2.97 c 0.767,0 1.389,0.621 1.389,1.389 v 0.151 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 230.2 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.938 c 0.001,0.766 0.622,1.389 1.389,1.389 z m 5.75,0 h 0.042 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.042 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.766 0.622,1.389 1.389,1.389 z m -5.75,-11.645 h 34.425 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 230.2 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0.001,0.768 0.622,1.389 1.389,1.389 z m 34.426,11.645 h -5.827 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -5.938 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 8.684 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.077 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.077 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.079 c 0.767,0 1.389,0.621 1.389,1.389 v 11.797 c 0,0.767 -0.621,1.389 -1.389,1.389 H 270.26 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.827 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.151 c 0,0.767 0.621,1.389 1.389,1.389 h 2.97 c 0.767,0 1.389,0.621 1.389,1.389 v 0.079 c 0,0.766 -0.621,1.389 -1.388,1.389 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 287.395,194.176 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.008 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 11.54 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.938 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.792 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 2.899 c 0.767,0 1.389,0.621 1.389,1.389 v 0.151 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.754 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.54 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.938 c 0,0.766 0.622,1.389 1.389,1.389 z m 5.749,0 h 0.042 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.042 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 10e-4,0.766 0.622,1.389 1.389,1.389 z m -5.749,-11.645 h 34.424 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -34.424 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.768 0.622,1.389 1.389,1.389 z m 34.425,11.645 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -5.938 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 8.646 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.079 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.079 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.079 c 0.767,0 1.389,0.621 1.389,1.389 v 11.797 c 0,0.767 -0.621,1.389 -1.389,1.389 h -11.505 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.826 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.151 c 0,0.767 0.621,1.389 1.389,1.389 h 2.97 c 0.767,0 1.389,0.621 1.389,1.389 v 0.079 c 0.002,0.766 -0.621,1.389 -1.387,1.389 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 344.589,194.176 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.008 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.826 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 11.505 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.938 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.792 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 2.973 c 0.767,0 1.389,0.621 1.389,1.389 v 0.151 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.865 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.502 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.938 c -10e-4,0.766 0.62,1.389 1.387,1.389 z m 5.713,0 h 0.115 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.115 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.766 0.622,1.389 1.389,1.389 z m -5.713,-11.645 h 34.424 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -34.424 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0.001,0.768 0.622,1.389 1.389,1.389 z m 34.426,11.645 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -5.938 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 8.646 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.079 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.079 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.115 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.04 c 0.767,0 1.389,0.621 1.389,1.389 v 11.797 c 0,0.767 -0.621,1.389 -1.389,1.389 h -11.502 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.754 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.151 c 0,0.767 0.621,1.389 1.389,1.389 h 2.899 c 0.767,0 1.389,0.621 1.389,1.389 v 0.079 c -0.002,0.766 -0.623,1.389 -1.39,1.389 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 401.82,194.176 h 0.042 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.008 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.792 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 11.538 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.938 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.752 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 2.933 c 0.767,0 1.389,0.621 1.389,1.389 v 0.151 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.826 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 401.82 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.938 c -10e-4,0.766 0.622,1.389 1.389,1.389 z m 5.712,0 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.766 0.622,1.389 1.389,1.389 z m -5.712,-11.645 h 34.462 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 401.82 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c -10e-4,0.768 0.622,1.389 1.389,1.389 z m 34.461,11.645 h -5.865 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -5.938 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 8.648 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.115 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.042 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.115 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.079 c 0.767,0 1.389,0.621 1.389,1.389 v 11.797 c 0,0.767 -0.621,1.389 -1.389,1.389 h -11.54 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.79 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.151 c 0,0.767 0.621,1.389 1.389,1.389 h 3.008 c 0.767,0 1.389,0.621 1.389,1.389 v 0.079 c 0,0.766 -0.623,1.389 -1.39,1.389 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 459.013,194.176 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.008 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 11.54 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.938 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.754 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 2.935 c 0.767,0 1.389,0.621 1.389,1.389 v 0.151 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.865 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.502 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.938 c 0,0.766 0.622,1.389 1.388,1.389 z m 5.713,0 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0.001,0.766 0.622,1.389 1.389,1.389 z m -5.713,-11.645 h 34.388 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -34.388 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 10e-4,0.768 0.623,1.389 1.389,1.389 z m 34.388,11.645 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -5.938 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 8.721 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.004 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.152 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.004 c 0.767,0 1.389,0.621 1.389,1.389 v 8.94 c 0,0.767 0.621,1.389 1.389,1.389 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -8.94 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 0.151 c 0.767,0 1.389,0.621 1.389,1.389 v 11.797 c 0,0.767 -0.621,1.389 -1.389,1.389 H 499.11 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -5.864 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.151 c 0,0.767 0.621,1.389 1.389,1.389 h 2.933 c 0.767,0 1.389,0.621 1.389,1.389 v 0.079 c 0,0.766 -0.622,1.389 -1.389,1.389 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 1.389,203.035 h 22.963 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 1.389 C 0.622,197.176 0,197.797 0,198.565 v 3.081 c 0,0.768 0.621,1.389 1.389,1.389 z m 28.633,0 h 22.927 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 30.022 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.768 0.622,1.389 1.389,1.389 z"
       id="path12" />
    	<path
       fill="#f5f5f5"
       d="m 58.618,203.035 h 22.927 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 58.618 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 10e-4,0.768 0.623,1.389 1.389,1.389 z m 28.561,0 h 23 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -23 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.768 0.622,1.389 1.389,1.389 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 115.814,203.035 h 22.963 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -22.963 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c -10e-4,0.768 0.622,1.389 1.389,1.389 z m 28.596,0 h 22.963 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 144.41 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0.001,0.768 0.623,1.389 1.389,1.389 z"
       id="path14" />
    	<path
       fill="#f5f5f5"
       d="m 173.007,203.035 h 22.963 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -22.963 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0.001,0.768 0.623,1.389 1.389,1.389 z m 28.561,0 h 23 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -23 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.768 0.621,1.389 1.389,1.389 z"
       id="path15" />
    	<path
       fill="#f5f5f5"
       d="m 230.2,203.035 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 230.2 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0.001,0.768 0.622,1.389 1.389,1.389 z m 28.597,0 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -22.965 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 10e-4,0.768 0.622,1.389 1.389,1.389 z"
       id="path16" />
    	<path
       fill="#f5f5f5"
       d="m 287.395,203.035 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -22.965 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.768 0.622,1.389 1.389,1.389 z m 28.635,0 h 22.927 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 316.03 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.768 0.622,1.389 1.389,1.389 z"
       id="path17" />
    	<path
       fill="#f5f5f5"
       d="m 344.589,203.035 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -22.965 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0.001,0.768 0.622,1.389 1.389,1.389 z m 28.635,0 h 22.925 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -22.925 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0.001,0.768 0.622,1.389 1.389,1.389 z"
       id="path18" />
    	<path
       fill="#f5f5f5"
       d="m 401.82,203.035 h 22.927 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 401.82 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c -10e-4,0.768 0.622,1.389 1.389,1.389 z m 28.597,0 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -22.965 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.768 0.622,1.389 1.389,1.389 z"
       id="path19" />
    	<path
       fill="#f5f5f5"
       d="m 459.013,203.035 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -22.965 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 10e-4,0.768 0.623,1.389 1.389,1.389 z m 28.599,0 h 23 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -23 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c -0.001,0.768 0.621,1.389 1.389,1.389 z"
       id="path20" />
    	<path
       fill="#f5f5f5"
       d="m 510.611,317.826 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.008 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.827 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.502 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.939 c 0,0.767 0.621,1.389 1.389,1.389 h 5.79 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.935 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.151 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.792 c 0.767,0 1.389,0.621 1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 11.538 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.939 c -10e-4,-0.767 -0.622,-1.389 -1.39,-1.389 z m -5.748,0 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.767 0.621,1.389 1.389,1.389 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.622,-1.389 -1.389,-1.389 z m 5.748,11.645 h -34.423 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 34.423 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.768 -0.621,-1.389 -1.389,-1.389 z m -34.422,-11.645 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 5.939 c 0,0.767 -0.621,1.389 -1.389,1.389 h -8.648 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.077 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.077 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.115 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.042 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -11.797 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 11.502 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 5.79 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.151 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.933 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.079 c 0,-0.768 0.623,-1.39 1.39,-1.39 z"
       id="path21" />
    	<path
       fill="#f5f5f5"
       d="m 453.382,317.826 h -0.115 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.008 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.754 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.502 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.939 c 0,0.767 0.621,1.389 1.389,1.389 h 5.79 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.935 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.151 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.792 c 0.767,0 1.389,0.621 1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 11.502 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.939 c -0.001,-0.767 -0.623,-1.389 -1.389,-1.389 z m -5.713,0 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.767 0.621,1.389 1.389,1.389 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c -10e-4,-0.767 -0.622,-1.389 -1.389,-1.389 z m 5.713,11.645 h -34.388 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 34.388 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c -0.001,-0.768 -0.623,-1.389 -1.389,-1.389 z m -34.388,-11.645 h 5.827 c 0.767,0 1.389,0.621 1.389,1.389 v 5.939 c 0,0.767 -0.621,1.389 -1.389,1.389 h -8.648 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.115 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.115 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.042 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.115 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.077 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -11.797 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 11.575 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 5.754 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.151 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.935 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.079 c 0.003,-0.768 0.625,-1.39 1.392,-1.39 z"
       id="path22" />
    	<path
       fill="#f5f5f5"
       d="m 396.186,317.826 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.008 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.792 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.538 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.939 c 0,0.767 0.621,1.389 1.389,1.389 h 5.79 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.935 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.151 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.827 c 0.767,0 1.389,0.621 1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 11.502 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.939 c 0.002,-0.767 -0.621,-1.389 -1.388,-1.389 z m -5.712,0 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.767 0.621,1.389 1.389,1.389 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.622,-1.389 -1.389,-1.389 z m 5.712,11.645 h -34.425 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 34.425 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0.001,-0.768 -0.622,-1.389 -1.389,-1.389 z m -34.424,-11.645 h 5.827 c 0.767,0 1.389,0.621 1.389,1.389 v 5.939 c 0,0.767 -0.621,1.389 -1.389,1.389 h -8.646 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.079 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.115 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 H 350.3 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.042 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.077 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -11.797 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 11.54 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 5.79 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.151 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.973 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.079 c 0.002,-0.768 0.624,-1.39 1.391,-1.39 z"
       id="path23" />
    	<path
       fill="#f5f5f5"
       d="m 338.993,317.826 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.008 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.54 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.939 c 0,0.767 0.621,1.389 1.389,1.389 h 5.827 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.935 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.151 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 11.502 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.939 c 0,-0.767 -0.622,-1.389 -1.388,-1.389 z m -5.713,0 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.767 0.621,1.389 1.389,1.389 h 0.077 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c -10e-4,-0.767 -0.622,-1.389 -1.389,-1.389 z m 5.713,11.645 h -34.388 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 34.388 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c -0.001,-0.768 -0.623,-1.389 -1.389,-1.389 z m -34.388,-11.645 h 5.827 c 0.767,0 1.389,0.621 1.389,1.389 v 5.939 c 0,0.767 -0.621,1.389 -1.389,1.389 h -8.721 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.077 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.042 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.115 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.077 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -11.797 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 11.502 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 5.827 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.151 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.935 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.079 c 0.003,-0.768 0.624,-1.39 1.391,-1.39 z"
       id="path24" />
    	<path
       fill="#f5f5f5"
       d="m 281.8,317.826 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.008 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.54 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.939 c 0,0.767 0.621,1.389 1.389,1.389 h 5.827 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.97 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.151 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 11.54 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.939 c -0.001,-0.767 -0.622,-1.389 -1.389,-1.389 z m -5.75,0 h -0.042 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.767 0.621,1.389 1.389,1.389 h 0.042 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.622,-1.389 -1.389,-1.389 z m 5.75,11.645 h -34.425 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 H 281.8 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c -0.001,-0.768 -0.622,-1.389 -1.389,-1.389 z m -34.426,-11.645 h 5.827 c 0.767,0 1.389,0.621 1.389,1.389 v 5.939 c 0,0.767 -0.621,1.389 -1.389,1.389 h -8.684 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.077 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.077 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.079 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -11.797 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 11.502 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 5.827 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.151 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.97 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.079 c 0,-0.768 0.621,-1.39 1.388,-1.39 z"
       id="path25" />
    	<path
       fill="#f5f5f5"
       d="m 224.605,317.826 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.008 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.54 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.939 c 0,0.767 0.621,1.389 1.389,1.389 h 5.792 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.899 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.151 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.754 c 0.767,0 1.389,0.621 1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 11.54 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.939 c 0,-0.767 -0.622,-1.389 -1.389,-1.389 z m -5.749,0 h -0.042 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.767 0.621,1.389 1.389,1.389 h 0.042 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c -0.001,-0.767 -0.622,-1.389 -1.389,-1.389 z m 5.749,11.645 H 190.18 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 34.424 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0.001,-0.768 -0.621,-1.389 -1.388,-1.389 z M 190.18,317.826 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 5.939 c 0,0.767 -0.621,1.389 -1.389,1.389 h -8.646 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.079 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.079 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 175.9 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.079 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -11.797 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 11.505 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 5.826 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.151 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.97 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.079 c -0.002,-0.768 0.621,-1.39 1.387,-1.39 z"
       id="path26" />
    	<path
       fill="#f5f5f5"
       d="m 167.411,317.826 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.008 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.826 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -11.505 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.939 c 0,0.767 0.621,1.389 1.389,1.389 h 5.792 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.973 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.151 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.865 c 0.767,0 1.389,0.621 1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 11.502 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.939 c 0.001,-0.767 -0.62,-1.389 -1.387,-1.389 z m -5.713,0 h -0.115 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.767 0.621,1.389 1.389,1.389 h 0.115 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.622,-1.389 -1.389,-1.389 z m 5.713,11.645 h -34.424 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 34.424 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c -0.001,-0.768 -0.622,-1.389 -1.389,-1.389 z m -34.426,-11.645 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 5.939 c 0,0.767 -0.621,1.389 -1.389,1.389 h -8.646 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.079 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.079 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.115 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.041 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -11.797 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 11.502 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 5.754 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.151 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.899 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.079 c 0.003,-0.768 0.624,-1.39 1.391,-1.39 z"
       id="path27" />
    	<path
       fill="#f5f5f5"
       d="m 110.18,317.826 h -0.042 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.008 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.792 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 87.254 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.939 c 0,0.767 0.621,1.389 1.389,1.389 h 5.752 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.933 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.151 c 0,-0.767 0.621,-1.389 1.389,-1.389 H 95.9 c 0.767,0 1.389,0.621 1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 11.505 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.939 c -0.002,-0.767 -0.625,-1.389 -1.392,-1.389 z m -5.712,0 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.767 0.621,1.389 1.389,1.389 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c 0,-0.767 -0.622,-1.389 -1.389,-1.389 z m 5.712,11.645 H 75.719 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 34.462 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.768 -0.623,-1.389 -1.39,-1.389 z M 75.719,317.826 h 5.865 c 0.767,0 1.389,0.621 1.389,1.389 v 5.939 c 0,0.767 -0.621,1.389 -1.389,1.389 h -8.648 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.115 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.077 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.042 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.115 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.079 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -11.797 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 11.54 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 5.79 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.151 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -3.005 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.079 c -0.003,-0.768 0.62,-1.39 1.387,-1.39 z"
       id="path28" />
    	<path
       fill="#f5f5f5"
       d="m 52.986,317.826 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.008 c 0,0.767 -0.621,1.389 -1.389,1.389 h -5.79 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -3.008 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 30.022 c -0.767,0 -1.389,0.621 -1.389,1.389 v 5.939 c 0,0.767 0.621,1.389 1.389,1.389 h 5.754 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -2.935 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.151 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 5.865 c 0.767,0 1.389,0.621 1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 11.502 c 0.767,0 1.389,-0.621 1.389,-1.389 v -5.939 c 0,-0.767 -0.622,-1.389 -1.389,-1.389 z m -5.712,0 h -0.079 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.079 c 0,0.767 0.621,1.389 1.389,1.389 h 0.079 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.079 c -10e-4,-0.767 -0.622,-1.389 -1.389,-1.389 z m 5.712,11.645 H 18.599 c -0.767,0 -1.389,0.621 -1.389,1.389 v 0.152 c 0,0.767 0.621,1.389 1.389,1.389 h 34.388 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.152 c -10e-4,-0.768 -0.623,-1.389 -1.39,-1.389 z M 18.599,317.826 h 5.79 c 0.767,0 1.389,0.621 1.389,1.389 v 5.939 c 0,0.767 -0.621,1.389 -1.389,1.389 H 15.67 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 -0.621,1.389 -1.389,1.389 h -0.004 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 9.956 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 H 7.175 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -8.94 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 h -0.08 c -0.767,0 -1.389,0.621 -1.389,1.389 v 8.94 c 0,0.767 -0.621,1.389 -1.389,1.389 H 1.389 C 0.622,332.402 0,331.781 0,331.013 v -11.797 c 0,-0.767 0.621,-1.389 1.389,-1.389 h 11.502 c 0.767,0 1.389,0.621 1.389,1.389 v 3.008 c 0,0.767 0.621,1.389 1.389,1.389 h 5.864 c 0.767,0 1.389,-0.621 1.389,-1.389 v -0.151 c 0,-0.767 -0.621,-1.389 -1.389,-1.389 H 18.6 c -0.767,0 -1.389,-0.621 -1.389,-1.389 v -0.079 c -10e-4,-0.768 0.621,-1.39 1.388,-1.39 z"
       id="path29" />
    	<path
       fill="#f5f5f5"
       d="m 510.611,308.966 h -22.963 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.963 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.621,-1.389 -1.389,-1.389 z m -28.633,0 h -22.927 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.927 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.622,-1.389 -1.389,-1.389 z"
       id="path30" />
    	<path
       fill="#f5f5f5"
       d="m 453.382,308.966 h -22.927 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.927 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c -0.001,-0.768 -0.623,-1.389 -1.389,-1.389 z m -28.561,0 h -23 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 23 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.621,-1.389 -1.389,-1.389 z"
       id="path31" />
    	<path
       fill="#f5f5f5"
       d="m 396.186,308.966 h -22.963 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.963 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0.001,-0.768 -0.622,-1.389 -1.389,-1.389 z m -28.596,0 h -22.963 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.963 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.623,-1.389 -1.389,-1.389 z"
       id="path32" />
    	<path
       fill="#f5f5f5"
       d="M 338.993,308.966 H 316.03 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.963 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c -0.001,-0.768 -0.623,-1.389 -1.389,-1.389 z m -28.561,0 h -23 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 23 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.621,-1.389 -1.389,-1.389 z"
       id="path33" />
    	<path
       fill="#f5f5f5"
       d="m 281.8,308.966 h -22.965 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 H 281.8 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c -0.001,-0.768 -0.622,-1.389 -1.389,-1.389 z m -28.597,0 h -22.965 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c -0.001,-0.768 -0.622,-1.389 -1.389,-1.389 z"
       id="path34" />
    	<path
       fill="#f5f5f5"
       d="M 224.605,308.966 H 201.64 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.622,-1.389 -1.389,-1.389 z m -28.635,0 h -22.927 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.927 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.622,-1.389 -1.389,-1.389 z"
       id="path35" />
    	<path
       fill="#f5f5f5"
       d="m 167.411,308.966 h -22.965 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c -0.001,-0.768 -0.622,-1.389 -1.389,-1.389 z m -28.635,0 h -22.925 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.925 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c -0.001,-0.768 -0.622,-1.389 -1.389,-1.389 z"
       id="path36" />
    	<path
       fill="#f5f5f5"
       d="M 110.18,308.966 H 87.254 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.927 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.623,-1.389 -1.39,-1.389 z m -28.597,0 H 58.618 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.622,-1.389 -1.389,-1.389 z"
       id="path37" />
    	<path
       fill="#f5f5f5"
       d="M 52.986,308.966 H 30.022 c -0.767,0 -1.389,0.621 -1.389,1.389 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 22.965 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c -10e-4,-0.768 -0.623,-1.389 -1.39,-1.389 z m -28.598,0 H 1.389 C 0.621,308.966 0,309.587 0,310.355 v 3.081 c 0,0.767 0.621,1.389 1.389,1.389 h 23 c 0.767,0 1.389,-0.621 1.389,-1.389 v -3.081 c 0,-0.768 -0.622,-1.389 -1.39,-1.389 z"
       id="path38" />
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 248.698,214.274 c 2.618,0.698 5.414,-0.071 7.334,-2.026 2.898,2.934 7.647,3.004 10.651,0.141 1.956,-1.886 2.759,-4.75 2.06,-7.334 -2.548,4.121 -7.925,5.448 -12.046,2.863 -0.21,-0.141 -0.489,-0.28 -0.663,-0.42 -3.875,2.863 -9.357,2.095 -12.291,-1.745 -0.106,-0.211 -0.314,-0.49 -0.455,-0.698 -1.049,4.053 1.395,8.241 5.41,9.219 z"
       id="path39" />
    	<path
       fill="#ff4b55"
       d="m 264.966,295.855 c 9.386,-5.153 17.219,-13.272 21.514,-23.966 7.314,-18.33 2.708,-39.02 -11.283,-52.44 -0.481,-0.461 -1.212,0.156 -0.863,0.724 13.799,22.503 8.363,52.074 -12.99,68.278 l 1.021,-65.367 c 0.014,-0.887 -0.382,-1.732 -1.071,-2.291 l -3.473,-2.807 c -1.064,-0.86 -2.584,-0.855 -3.642,0.01 l -3.422,2.797 c -0.683,0.558 -1.073,1.398 -1.059,2.28 l 0.992,65.413 c -21.356,-16.196 -26.804,-45.794 -13.026,-68.312 0.348,-0.568 -0.383,-1.185 -0.863,-0.723 -13.964,13.42 -18.599,34.109 -11.286,52.438 4.295,10.692 12.127,18.812 21.516,23.965 -5.975,2.048 -12.255,3.134 -18.605,2.952 -0.671,-0.019 -0.806,0.925 -0.163,1.119 8.068,2.449 16.366,2.617 24.168,0.868 l 3.063,5.943 c 0.212,0.41 0.799,0.412 1.012,0.001 l 3.084,-5.941 c 7.802,1.746 16.103,1.575 24.177,-0.874 0.642,-0.194 0.508,-1.138 -0.163,-1.119 -6.358,0.185 -12.653,-0.901 -18.638,-2.948 z"
       id="path40" />
    	<path
       fill="#ff4b55"
       d="m 303.171,235.086 c -4.804,-8.975 -12.782,-15.778 -22.279,-19.111 -0.595,-0.209 -1.059,0.577 -0.573,0.978 20.966,17.271 25.169,48.032 8.956,70.302 -0.839,1.118 -1.747,2.305 -2.62,3.281 19.905,-10.685 27.272,-35.546 16.516,-55.45 z"
       id="path41" />
    	<path
       fill="#ff4b55"
       d="m 222.755,287.255 c -16.214,-22.27 -12.044,-53.03 8.918,-70.301 0.487,-0.402 0.022,-1.186 -0.573,-0.978 -9.485,3.334 -17.408,10.135 -22.243,19.11 -10.824,19.904 -3.386,44.765 16.552,55.449 -0.942,-0.976 -1.85,-2.162 -2.654,-3.28 z"
       id="path42" />
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const IS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#f5f5f5"
       points="229.517,88.277 141.241,88.277 141.241,211.863 0,211.863 0,300.139 141.241,300.139 141.241,423.725 229.517,423.725 229.517,300.139 512,300.139 512,211.863 229.517,211.863 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ff4b55"
       points="211.862,88.277 158.897,88.277 158.897,229.518 0,229.518 0,282.484 158.897,282.484 158.897,423.725 211.862,423.725 211.862,282.484 512,282.484 512,229.518 211.862,229.518 "
       id="polygon2"
       transform="translate(0,-88.276)" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const IT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#73af00"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const JE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs63" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="M 512,8.828 C 512,3.953 508.047,0 503.172,0 H 479.783 L 256,146.618 32.216,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 V 21.107 L 223.784,167.725 0,314.342 v 12.279 c 0,4.875 3.953,8.828 8.828,8.828 H 32.217 L 256,188.832 479.784,335.449 h 23.389 c 4.875,0 8.828,-3.953 8.828,-8.828 V 314.342 L 288.216,167.725 512,21.108 Z"
       id="path2" />
    <path
       fill="#ffe15a"
       d="m 282.557,38.585 c 0,0 -2.795,-4.193 -6.988,-1.398 0,0 4.849,3.495 1.572,7.164 -3.467,3.883 -8.233,0.085 -8.532,-2.698 1.271,-0.097 2.276,-1.148 2.276,-2.444 0,-1.361 -1.102,-2.463 -2.463,-2.463 -1.361,0 -2.463,1.102 -2.463,2.463 0,1.062 0.676,1.959 1.618,2.305 -0.601,2.382 -6.849,4.205 -8.65,0.26 -2.028,-4.441 1.18,-8.212 5.504,-7.688 0,0 -0.83,-5.503 -6.682,-3.189 0,0 2.446,-6.29 -1.747,-10.483 -4.193,4.193 -1.747,10.483 -1.747,10.483 -5.853,-2.315 -6.682,3.189 -6.682,3.189 4.324,-0.524 7.531,3.245 5.504,7.688 -1.801,3.945 -8.049,2.122 -8.65,-0.26 0.942,-0.345 1.618,-1.242 1.618,-2.305 0,-1.361 -1.102,-2.463 -2.463,-2.463 -1.361,0 -2.463,1.102 -2.463,2.463 0,1.297 1.005,2.347 2.276,2.444 -0.299,2.783 -5.066,6.581 -8.532,2.698 -3.276,-3.669 1.572,-7.164 1.572,-7.164 -4.193,-2.795 -6.988,1.398 -6.988,1.398 -1.398,-5.591 -6.988,-4.193 -6.988,-4.193 5.591,6.988 9.702,21.404 9.702,21.404 h 47.687 c 0,0 4.11,-14.415 9.702,-21.404 -0.005,0 -5.596,-1.398 -6.993,4.193 z"
       id="path3" />
    <path
       fill="#ff4b55"
       d="M 279.843,55.796 C 272.129,53.077 264.064,51.718 256,51.718 c -8.064,0 -16.129,1.359 -23.843,4.078 -12.507,54.799 23.843,69.446 23.843,69.446 0,0 36.35,-14.647 23.843,-69.446 z"
       id="path4" />
    <g
       id="g16"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="m 238.561,163.568 c 0,0 -1.146,-0.216 -2.143,0.582 0,0 -0.349,-1.378 1.444,-1.71 1.795,-0.334 0.699,1.128 0.699,1.128 z"
       id="path5" />
    	<path
       fill="#82afff"
       d="m 237.181,161.825 c 0,0 -0.908,-0.732 -2.163,-0.5 0,0 0.344,-1.379 2.082,-0.824 1.738,0.554 0.081,1.324 0.081,1.324 z"
       id="path6" />
    	<path
       fill="#82afff"
       d="m 237.932,162.539 c 0,0 -1.252,-0.216 -2.342,0.582 0,0 -0.381,-1.378 1.579,-1.71 1.96,-0.333 0.763,1.128 0.763,1.128 z"
       id="path7" />
    	<path
       fill="#82afff"
       d="m 259.623,166.2 c 0,0 -1.165,0.055 -1.95,1.062 0,0 -0.658,-1.26 1.01,-1.998 1.667,-0.739 0.94,0.936 0.94,0.936 z"
       id="path8" />
    	<path
       fill="#82afff"
       d="m 257.914,164.698 c 0,0 -1.053,-0.502 -2.22,0.014 0,0 0.015,-1.422 1.834,-1.284 1.819,0.138 0.386,1.27 0.386,1.27 z"
       id="path9" />
    	<path
       fill="#82afff"
       d="m 258.773,165.344 c 0,0 -1.269,0.079 -2.144,1.107 0,0 -0.69,-1.252 1.141,-2.029 1.831,-0.777 1.003,0.922 1.003,0.922 z"
       id="path10" />
    	<path
       fill="#82afff"
       d="m 272.931,166.92 c 0,0 -0.436,0 -1.217,0.735 0,0 -0.559,-1.25 1.087,-1.864 1.648,-0.614 0.13,1.129 0.13,1.129 z"
       id="path11" />
    	<path
       fill="#82afff"
       d="m 272.095,165.203 c 0,0 -0.983,-0.544 -2.135,-0.116 0,0 0.097,-1.366 1.838,-1.129 1.741,0.239 0.297,1.245 0.297,1.245 z"
       id="path12" />
    	<path
       fill="#82afff"
       d="m 272.883,165.874 c 0,0 -1.225,0.003 -2.125,0.94 0,0 -0.59,-1.245 1.215,-1.886 1.805,-0.64 0.91,0.946 0.91,0.946 z"
       id="path13" />
    	<path
       fill="#82afff"
       d="m 236.644,154.92 c 0,0 -1.053,-0.7 -2.387,-0.329 0,0 0.238,-1.519 2.17,-1.091 1.933,0.428 0.217,1.42 0.217,1.42 z"
       id="path14" />
    	<path
       fill="#82afff"
       d="m 236.557,152.298 c 0,0 -0.68,-1.069 -2.131,-1.163 0,0 0.939,-1.441 2.588,-0.335 1.65,1.104 -0.457,1.498 -0.457,1.498 z"
       id="path15" />
    	<path
       fill="#82afff"
       d="m 236.563,153.69 c 0,0 -1.11,-0.82 -2.577,-0.518 0,0 0.33,-1.603 2.408,-1.011 2.079,0.594 0.169,1.529 0.169,1.529 z"
       id="path16" />
    </g>
    <path
       fill="#ffe15a"
       d="m 269.568,70.21 c 1.844,0.05 4.035,-0.681 4.384,-2.591 0.401,-2.195 -1.479,-3.305 -4.002,-3.206 -1.842,0.073 -6.507,1.131 -9.848,1.013 -3.305,-0.116 -3.395,-3.386 1.611,-3.039 7.424,0.515 8.603,-0.448 8.603,-0.448 -3.986,0.747 -5.58,-0.648 -9.815,-0.648 -4.235,0 -5.048,2.933 -3.338,4.534 1.916,1.794 8.868,0.598 10.712,0.249 1.844,-0.349 4.182,-0.367 4.367,0.93 0.165,1.163 -2.923,1.1 -5.111,1.016 -3.482,-0.134 -8.55,0.811 -13.058,1.044 -3.756,0.194 -4.279,-0.865 -5.134,-1.95 0.2,-0.361 0.314,-0.764 0.314,-1.19 0,-0.215 -0.034,-0.423 -0.088,-0.625 0.284,-0.311 0.582,-0.809 0.718,-1.618 0,0 -0.961,-0.169 -1.687,0.198 -0.582,-0.459 -1.353,-0.746 -2.206,-0.746 -0.854,0 -1.624,0.287 -2.206,0.746 -0.726,-0.366 -1.687,-0.198 -1.687,-0.198 0.137,0.81 0.435,1.306 0.718,1.618 -0.054,0.201 -0.088,0.408 -0.088,0.625 0,0.782 0.376,1.489 0.983,1.996 0.292,0.245 0.51,0.567 0.584,0.941 l 0.105,0.531 c 0.046,0.233 0.196,0.415 0.391,0.526 -3.096,-0.319 -4.562,-2.265 -5.314,-3.347 -0.849,-1.22 -1.378,-3.919 -2.674,-4.218 l -0.764,4.07 c 0,0 1.637,3.786 4.683,5.331 3.438,1.743 4.086,1.794 5.215,2.292 0.132,0.598 -2.126,0.963 -4.418,0.499 -1.6,-0.324 -3.756,-2.648 -4.984,-2.482 l 1.431,3.179 c 3.886,2.458 7.283,2.51 10.197,1.993 2.059,-0.365 2.842,-2.042 2.978,-2.76 0.841,-0.156 1.757,-0.33 4.595,-1.027 1.188,-0.292 2.557,-0.446 3.919,-0.51 0.384,0.876 1.262,1.998 4.285,2.104 0,0 0.73,1.163 -1.76,0.93 -2.492,-0.233 -3.13,-1.009 -4.593,-0.843 l 1.304,3.102 c 0,0 3.189,-1.096 7.108,-0.697 0,0 0.73,0.2 1.163,-0.431 0.431,-0.631 0.233,-0.996 -0.167,-1.561 -0.224,-0.318 -0.354,-1.348 -0.424,-2.191 1.436,0.361 5.841,-0.533 7.433,-0.399 1.594,0.132 1.827,1.993 1.461,2.624 -0.365,0.631 -3.703,0.092 -3.703,0.092 l 1.121,3.064 c 0,0 0.337,-0.162 1.187,-0.963 0.692,-0.651 3.521,-0.431 3.521,-0.93 v -5.676 c 0,-0.269 -0.234,-0.479 -0.502,-0.456 -6.242,0.544 -7.52,-0.497 -7.52,-0.497 z"
       id="path17" />
    <path
       fill="#ff4b55"
       d="m 244.679,68.193 c 0.094,0.183 0.163,0.382 0.201,0.593 l 0.094,0.531 c 0.033,0.186 0.18,0.321 0.35,0.321 h 1.448 c 0.17,0 0.317,-0.135 0.35,-0.321 l 0.094,-0.531 c 0.038,-0.211 0.107,-0.409 0.201,-0.593 z"
       id="path18" />
    <g
       id="g31"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="m 246.047,157.518 c -0.334,0 -0.595,0.041 -0.559,0.505 l 0.135,1.985 c 0.023,0.303 0.206,0.534 0.424,0.534 0.217,0 0.402,-0.231 0.424,-0.534 l 0.135,-1.985 c 0.035,-0.464 -0.226,-0.505 -0.559,-0.505 z"
       id="path19" />
    	<path
       fill="#82afff"
       d="m 241.736,183.172 c 0,0 -0.935,-0.177 -1.748,0.474 0,0 -0.285,-1.124 1.178,-1.396 1.465,-0.269 0.57,0.922 0.57,0.922 z"
       id="path20" />
    	<path
       fill="#82afff"
       d="m 240.61,181.751 c 0,0 -0.74,-0.597 -1.764,-0.408 0,0 0.28,-1.126 1.698,-0.673 1.418,0.452 0.066,1.081 0.066,1.081 z"
       id="path21" />
    	<path
       fill="#82afff"
       d="m 241.224,182.333 c 0,0 -1.022,-0.177 -1.91,0.474 0,0 -0.311,-1.124 1.288,-1.396 1.598,-0.27 0.622,0.922 0.622,0.922 z"
       id="path22" />
    	<path
       fill="#82afff"
       d="m 258.916,185.32 c 0,0 -0.95,0.045 -1.59,0.865 0,0 -0.537,-1.028 0.824,-1.63 1.362,-0.601 0.766,0.765 0.766,0.765 z"
       id="path23" />
    	<path
       fill="#82afff"
       d="m 257.523,184.095 c 0,0 -0.858,-0.409 -1.811,0.011 0,0 0.012,-1.16 1.496,-1.047 1.484,0.112 0.315,1.036 0.315,1.036 z"
       id="path24" />
    	<path
       fill="#82afff"
       d="m 258.222,184.621 c 0,0 -1.035,0.065 -1.749,0.903 0,0 -0.563,-1.022 0.93,-1.655 1.495,-0.634 0.819,0.752 0.819,0.752 z"
       id="path25" />
    	<path
       fill="#82afff"
       d="m 269.771,185.906 c 0,0 -0.355,0 -0.993,0.599 0,0 -0.457,-1.02 0.887,-1.519 1.344,-0.501 0.106,0.92 0.106,0.92 z"
       id="path26" />
    	<path
       fill="#82afff"
       d="m 269.09,184.506 c 0,0 -0.802,-0.444 -1.742,-0.094 0,0 0.079,-1.114 1.5,-0.92 1.42,0.193 0.242,1.014 0.242,1.014 z"
       id="path27" />
    	<path
       fill="#82afff"
       d="m 269.732,185.053 c 0,0 -0.999,0.002 -1.734,0.767 0,0 -0.482,-1.015 0.991,-1.538 1.473,-0.523 0.743,0.771 0.743,0.771 z"
       id="path28" />
    	<path
       fill="#82afff"
       d="m 240.172,176.118 c 0,0 -0.858,-0.57 -1.947,-0.268 0,0 0.194,-1.24 1.771,-0.89 1.576,0.35 0.176,1.158 0.176,1.158 z"
       id="path29" />
    	<path
       fill="#82afff"
       d="m 240.102,173.979 c 0,0 -0.555,-0.873 -1.738,-0.949 0,0 0.766,-1.175 2.111,-0.274 1.345,0.902 -0.373,1.223 -0.373,1.223 z"
       id="path30" />
    	<path
       fill="#82afff"
       d="m 240.107,175.115 c 0,0 -0.906,-0.669 -2.102,-0.422 0,0 0.269,-1.308 1.964,-0.824 1.696,0.483 0.138,1.246 0.138,1.246 z"
       id="path31" />
    </g>
    <path
       fill="#ffe15a"
       d="m 267.028,90.752 c 1.504,0.041 3.292,-0.555 3.576,-2.113 0.327,-1.79 -1.206,-2.696 -3.265,-2.614 -1.503,0.06 -5.308,0.922 -8.033,0.826 -2.696,-0.095 -2.77,-2.762 1.314,-2.479 6.056,0.42 7.017,-0.365 7.017,-0.365 -3.251,0.609 -4.552,-0.529 -8.007,-0.529 -3.455,0 -4.117,2.392 -2.723,3.699 1.563,1.463 7.234,0.488 8.738,0.203 1.504,-0.285 3.412,-0.3 3.563,0.759 0.136,0.948 -2.385,0.897 -4.169,0.829 -2.841,-0.109 -6.974,0.662 -10.652,0.851 -3.064,0.158 -3.49,-0.706 -4.188,-1.59 0.163,-0.295 0.256,-0.622 0.256,-0.97 0,-0.175 -0.029,-0.344 -0.073,-0.509 0.232,-0.254 0.474,-0.66 0.586,-1.32 0,0 -0.785,-0.138 -1.376,0.161 -0.474,-0.374 -1.103,-0.608 -1.8,-0.608 -0.697,0 -1.325,0.234 -1.8,0.608 -0.591,-0.299 -1.376,-0.161 -1.376,-0.161 0.111,0.66 0.354,1.066 0.586,1.32 -0.044,0.164 -0.073,0.333 -0.073,0.509 0,0.638 0.308,1.215 0.802,1.628 0.238,0.2 0.416,0.462 0.476,0.768 l 0.086,0.434 c 0.038,0.19 0.16,0.338 0.319,0.429 -2.526,-0.26 -3.721,-1.847 -4.334,-2.73 -0.692,-0.995 -1.124,-3.197 -2.182,-3.441 l -0.623,3.319 c 0,0 1.336,3.089 3.82,4.349 2.804,1.422 3.332,1.463 4.254,1.869 0.108,0.488 -1.734,0.786 -3.604,0.406 -1.305,-0.265 -3.063,-2.159 -4.066,-2.025 l 1.167,2.593 c 3.17,2.005 5.941,2.047 8.318,1.625 1.679,-0.298 2.318,-1.665 2.429,-2.251 0.685,-0.127 1.432,-0.269 3.748,-0.838 0.97,-0.238 2.086,-0.364 3.198,-0.416 0.313,0.715 1.03,1.631 3.495,1.716 0,0 0.596,0.948 -1.436,0.758 -2.033,-0.19 -2.553,-0.823 -3.746,-0.687 l 1.064,2.53 c 0,0 2.601,-0.894 5.799,-0.569 0,0 0.596,0.162 0.948,-0.352 0.352,-0.515 0.19,-0.813 -0.136,-1.273 -0.183,-0.259 -0.288,-1.1 -0.346,-1.788 1.171,0.295 4.765,-0.435 6.062,-0.327 1.301,0.108 1.49,1.625 1.192,2.141 -0.298,0.515 -3.021,0.075 -3.021,0.075 l 0.915,2.499 c 0,0 0.275,-0.132 0.969,-0.786 0.564,-0.531 2.872,-0.352 2.872,-0.758 v -4.63 c 0,-0.22 -0.191,-0.391 -0.409,-0.372 -5.088,0.445 -6.131,-0.403 -6.131,-0.403 z"
       id="path32" />
    <path
       fill="#ff4b55"
       d="m 246.727,89.105 c 0.076,0.15 0.134,0.312 0.163,0.483 l 0.076,0.434 c 0.026,0.152 0.147,0.262 0.285,0.262 h 1.181 c 0.138,0 0.258,-0.11 0.285,-0.262 l 0.076,-0.434 c 0.031,-0.171 0.087,-0.334 0.163,-0.483 z"
       id="path33" />
    <g
       id="g46"
       transform="translate(0,-88.276)">
    	<path
       fill="#82afff"
       d="m 247.842,178.238 c -0.273,0 -0.484,0.033 -0.456,0.413 l 0.11,1.619 c 0.019,0.248 0.168,0.436 0.346,0.436 0.179,0 0.328,-0.188 0.346,-0.436 l 0.11,-1.619 c 0.029,-0.38 -0.183,-0.413 -0.456,-0.413 z"
       id="path34" />
    	<path
       fill="#82afff"
       d="m 245.267,198.754 c 0,0 -0.7,-0.132 -1.309,0.355 0,0 -0.213,-0.842 0.883,-1.045 1.096,-0.203 0.426,0.69 0.426,0.69 z"
       id="path35" />
    	<path
       fill="#82afff"
       d="m 244.424,197.689 c 0,0 -0.555,-0.447 -1.321,-0.306 0,0 0.21,-0.843 1.271,-0.504 1.062,0.34 0.05,0.81 0.05,0.81 z"
       id="path36" />
    	<path
       fill="#82afff"
       d="m 244.883,198.125 c 0,0 -0.765,-0.132 -1.43,0.355 0,0 -0.233,-0.842 0.964,-1.045 1.197,-0.203 0.466,0.69 0.466,0.69 z"
       id="path37" />
    	<path
       fill="#82afff"
       d="m 258.13,200.362 c 0,0 -0.712,0.033 -1.191,0.648 0,0 -0.402,-0.77 0.617,-1.22 1.019,-0.451 0.574,0.572 0.574,0.572 z"
       id="path38" />
    	<path
       fill="#82afff"
       d="m 257.087,199.445 c 0,0 -0.643,-0.307 -1.356,0.009 0,0 0.01,-0.868 1.12,-0.785 1.112,0.084 0.236,0.776 0.236,0.776 z"
       id="path39" />
    	<path
       fill="#82afff"
       d="m 257.611,199.839 c 0,0 -0.775,0.049 -1.309,0.676 0,0 -0.422,-0.765 0.696,-1.239 1.118,-0.474 0.613,0.563 0.613,0.563 z"
       id="path40" />
    	<path
       fill="#82afff"
       d="m 266.259,200.801 c 0,0 -0.266,0 -0.744,0.449 0,0 -0.342,-0.764 0.664,-1.138 1.006,-0.375 0.08,0.689 0.08,0.689 z"
       id="path41" />
    	<path
       fill="#82afff"
       d="m 265.748,199.753 c 0,0 -0.6,-0.332 -1.304,-0.071 0,0 0.06,-0.834 1.123,-0.69 1.064,0.145 0.181,0.761 0.181,0.761 z"
       id="path42" />
    	<path
       fill="#82afff"
       d="m 266.229,200.162 c 0,0 -0.748,0.002 -1.299,0.575 0,0 -0.361,-0.76 0.742,-1.152 1.103,-0.392 0.557,0.577 0.557,0.577 z"
       id="path43" />
    	<path
       fill="#82afff"
       d="m 244.096,193.473 c 0,0 -0.643,-0.427 -1.458,-0.201 0,0 0.146,-0.928 1.326,-0.666 1.18,0.261 0.132,0.867 0.132,0.867 z"
       id="path44" />
    	<path
       fill="#82afff"
       d="m 244.043,191.871 c 0,0 -0.415,-0.653 -1.301,-0.711 0,0 0.574,-0.879 1.58,-0.205 1.008,0.675 -0.279,0.916 -0.279,0.916 z"
       id="path45" />
    	<path
       fill="#82afff"
       d="m 244.046,192.722 c 0,0 -0.679,-0.501 -1.574,-0.316 0,0 0.201,-0.979 1.471,-0.617 1.27,0.361 0.103,0.933 0.103,0.933 z"
       id="path46" />
    </g>
    <path
       fill="#ffe15a"
       d="m 264.204,107.374 c 1.126,0.031 2.465,-0.416 2.678,-1.582 0.245,-1.341 -0.903,-2.018 -2.444,-1.958 -1.126,0.044 -3.974,0.691 -6.015,0.619 -2.018,-0.071 -2.073,-2.068 0.984,-1.856 4.534,0.314 5.255,-0.274 5.255,-0.274 -2.434,0.457 -3.409,-0.396 -5.995,-0.396 -2.586,0 -3.083,1.791 -2.039,2.77 1.17,1.096 5.417,0.365 6.542,0.152 1.126,-0.213 2.554,-0.224 2.668,0.568 0.102,0.71 -1.785,0.672 -3.122,0.62 -2.127,-0.082 -5.221,0.495 -7.976,0.638 -2.294,0.118 -2.614,-0.529 -3.136,-1.191 0.122,-0.221 0.192,-0.466 0.192,-0.726 0,-0.131 -0.021,-0.258 -0.054,-0.381 0.173,-0.191 0.355,-0.494 0.439,-0.989 0,0 -0.587,-0.103 -1.031,0.12 -0.355,-0.28 -0.825,-0.456 -1.347,-0.456 -0.522,0 -0.992,0.175 -1.347,0.456 -0.444,-0.224 -1.031,-0.12 -1.031,-0.12 0.084,0.494 0.266,0.798 0.439,0.989 -0.033,0.122 -0.054,0.249 -0.054,0.381 0,0.478 0.231,0.909 0.6,1.219 0.179,0.149 0.311,0.346 0.356,0.575 l 0.064,0.324 c 0.028,0.142 0.12,0.253 0.238,0.321 -1.891,-0.195 -2.786,-1.384 -3.245,-2.044 -0.519,-0.745 -0.842,-2.393 -1.633,-2.577 l -0.467,2.485 c 0,0 1.001,2.313 2.86,3.256 2.1,1.065 2.495,1.096 3.185,1.4 0.082,0.365 -1.299,0.588 -2.698,0.305 -0.978,-0.199 -2.294,-1.618 -3.044,-1.516 l 0.874,1.942 c 2.374,1.501 4.448,1.533 6.228,1.217 1.258,-0.223 1.736,-1.247 1.818,-1.685 0.513,-0.095 1.073,-0.202 2.806,-0.628 0.726,-0.179 1.561,-0.273 2.394,-0.311 0.235,0.535 0.771,1.22 2.616,1.284 0,0 0.446,0.71 -1.075,0.568 -1.522,-0.142 -1.912,-0.616 -2.805,-0.515 l 0.797,1.895 c 0,0 1.948,-0.67 4.341,-0.426 0,0 0.446,0.121 0.71,-0.264 0.264,-0.385 0.142,-0.609 -0.102,-0.953 -0.137,-0.194 -0.216,-0.824 -0.259,-1.338 0.877,0.221 3.567,-0.326 4.54,-0.244 0.973,0.082 1.116,1.217 0.893,1.602 -0.223,0.385 -2.262,0.056 -2.262,0.056 l 0.684,1.871 c 0,0 0.205,-0.099 0.725,-0.588 0.423,-0.397 2.151,-0.264 2.151,-0.568 v -3.467 c 0,-0.164 -0.142,-0.292 -0.307,-0.278 -3.809,0.335 -4.589,-0.302 -4.589,-0.302 z"
       id="path47" />
    <path
       fill="#ff4b55"
       d="m 249.003,106.143 c 0.057,0.113 0.099,0.234 0.122,0.362 l 0.057,0.324 c 0.02,0.114 0.11,0.196 0.213,0.196 h 0.884 c 0.104,0 0.193,-0.083 0.213,-0.196 l 0.057,-0.324 c 0.023,-0.128 0.065,-0.25 0.122,-0.362 z"
       id="path48" />
    <path
       fill="#82afff"
       d="m 249.838,106.784 c -0.204,0 -0.363,0.024 -0.342,0.309 l 0.083,1.212 c 0.014,0.185 0.126,0.327 0.259,0.327 0.134,0 0.245,-0.141 0.259,-0.327 l 0.083,-1.212 c 0.021,-0.285 -0.138,-0.309 -0.342,-0.309 z"
       id="path49" />
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g58"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g59"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g60"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g61"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g62"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g63"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const JM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#73af00"
       d="M 503.172,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 v 317.793 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 512,3.953 508.047,0.001 503.172,0.001 Z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 512,8.828 C 512,3.953 508.047,0 503.172,0 H 463.671 L 256,136.062 48.329,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 V 31.664 L 207.671,167.725 0,303.786 v 22.836 c 0,4.875 3.953,8.828 8.828,8.828 H 48.329 L 256,199.388 463.671,335.449 h 39.501 c 4.875,0 8.828,-3.953 8.828,-8.828 V 303.785 L 304.329,167.725 512,31.664 Z"
       id="path2" />
    <g
       id="g3"
       transform="translate(0,-88.275)">
    	<polygon
       fill="#464655"
       points="304.329,256 512,119.939 512,392.061 "
       id="polygon2" />
    	<polygon
       fill="#464655"
       points="207.671,256 0,392.061 0,119.939 "
       id="polygon3" />
    </g>
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const JO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#464655"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#ff4b55"
       d="M 3.256,333.315 302.368,171.298 c 2.838,-1.537 2.838,-5.61 0,-7.147 L 3.256,2.135 C 1.311,3.754 0,6.1 0,8.828 v 317.793 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path3" />
    <path
       fill="#f5f5f5"
       d="m 95.399,144.889 5.247,11.381 12.169,-2.994 c 0.76,-0.186 1.389,0.602 1.038,1.302 l -5.626,11.198 9.928,7.648 c 0.62,0.478 0.395,1.462 -0.371,1.623 l -12.263,2.583 0.211,12.531 c 0.013,0.782 -0.897,1.22 -1.5,0.723 l -9.665,-7.977 -9.665,7.977 c -0.604,0.498 -1.513,0.06 -1.5,-0.723 L 83.613,177.63 71.35,175.047 c -0.766,-0.161 -0.99,-1.145 -0.371,-1.623 l 9.928,-7.648 -5.626,-11.198 c -0.351,-0.7 0.278,-1.489 1.038,-1.302 l 12.169,2.994 5.247,-11.381 c 0.326,-0.71 1.336,-0.71 1.664,0 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const JP = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs15" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <circle
       fill="#ff4b55"
       cx="256"
       cy="167.72501"
       r="97.099998"
       id="circle1" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs27" />
    <path
       fill="#73af00"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#464655"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#c8414b"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<rect
       y="194.21001"
       fill="#f5f5f5"
       width="512"
       height="17.655001"
       id="rect3"
       x="0" />
    	<rect
       y="300.14099"
       fill="#f5f5f5"
       width="512"
       height="17.655001"
       id="rect4"
       x="0" />
    	<path
       fill="#f5f5f5"
       d="m 303.268,181.618 c 7.108,-14.657 14.525,-48.61 14.525,-48.61 0,0 -22.072,26.845 -29.182,41.501 -1.49,3.072 -0.858,6.605 1.294,8.995 l -80.967,166.934 5.496,2.666 80.967,-166.934 c 3.212,0.211 6.378,-1.48 7.867,-4.552 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 208.732,181.618 c -7.108,-14.657 -14.525,-48.61 -14.525,-48.61 0,0 22.072,26.845 29.182,41.501 1.49,3.072 0.858,6.605 -1.294,8.995 l 80.967,166.934 -5.496,2.666 -80.967,-166.934 c -3.212,0.211 -6.378,-1.48 -7.867,-4.552 z"
       id="path5" />
    </g>
    <path
       fill="#c8414b"
       d="M 300.138,167.724 C 300.138,216.478 264.126,256 256,256 c -8.126,0 -44.138,-39.522 -44.138,-88.276 0,-48.754 36.012,-88.276 44.138,-88.276 8.126,0 44.138,39.522 44.138,88.276 z"
       id="path6" />
    <g
       id="g8"
       transform="translate(0,-88.276)">
    	<path
       fill="#464655"
       d="m 291.31,298.591 c 5.199,-12.631 8.828,-27.14 8.828,-42.591 0,-15.451 -3.628,-29.959 -8.828,-42.591 -5.199,12.631 -8.828,27.14 -8.828,42.591 0,15.451 3.629,29.96 8.828,42.591 z"
       id="path7" />
    	<path
       fill="#464655"
       d="m 220.69,213.409 c -5.199,12.631 -8.828,27.14 -8.828,42.591 0,15.451 3.628,29.959 8.828,42.591 5.199,-12.631 8.828,-27.14 8.828,-42.591 0,-15.451 -3.629,-29.959 -8.828,-42.591 z"
       id="path8" />
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<ellipse
       fill="#f5f5f5"
       cx="256"
       cy="256"
       rx="8.8280001"
       ry="13.241"
       id="ellipse8" />
    	<path
       fill="#f5f5f5"
       d="m 257.324,167.724 v 75.034 c 2.407,-5.01 6.676,-19.815 6.676,-37.517 0,-17.703 -4.269,-32.507 -6.676,-37.517 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 254.676,167.724 c -2.407,5.01 -6.676,19.814 -6.676,37.517 0,17.703 4.269,32.508 6.676,37.517 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 257.324,269.241 v 75.034 c 2.407,-5.01 6.676,-19.815 6.676,-37.517 0,-17.703 -4.269,-32.507 -6.676,-37.517 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 254.676,269.241 c -2.407,5.01 -6.676,19.814 -6.676,37.517 0,17.703 4.269,32.508 6.676,37.517 z"
       id="path12" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs33" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g18"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 349.373,282.328 c 0,0 -17.586,-2.932 -30.613,-13.735 -3.843,-3.187 -9.42,-5.622 -14.852,-7.422 4.367,-0.194 8.999,-0.072 13.376,0.813 18.132,3.666 35.713,-5.135 35.713,-5.135 0,0 -17.739,1.79 -33.145,-5.213 -4.167,-1.894 -9.571,-2.786 -14.846,-3.162 3.794,-1.091 7.82,-1.945 11.795,-2.165 18.471,-1.024 33.265,-13.973 33.265,-13.973 0,0 -16.714,6.204 -33.388,3.311 -4.856,-0.843 -10.817,-0.212 -16.364,0.903 3.649,-2.292 7.667,-4.434 11.836,-5.813 17.562,-5.811 28.462,-22.174 28.462,-22.174 0,0 -14.515,10.353 -31.366,11.914 -5.004,0.463 -10.703,2.71 -15.846,5.297 2.967,-3.253 6.354,-6.473 10.104,-8.961 15.413,-10.229 21.622,-28.884 21.622,-28.884 0,0 -11.277,13.809 -27.124,19.751 -4.32,1.62 -8.797,4.864 -12.818,8.36 1.922,-3.494 4.181,-6.989 6.865,-9.991 12.329,-13.791 13.622,-33.409 13.622,-33.409 0,0 -7.423,16.21 -21.253,25.963 -4.032,2.844 -7.8,7.512 -10.934,12.23 0.958,-4.206 2.281,-8.568 4.254,-12.499 8.299,-16.533 4.424,-35.808 4.424,-35.808 0,0 -2.932,17.586 -13.735,30.613 -3.187,3.843 -5.622,9.42 -7.422,14.854 -0.194,-4.367 -0.072,-8.999 0.813,-13.376 3.666,-18.132 -5.135,-35.713 -5.135,-35.713 0,0 1.79,17.739 -5.214,33.145 -1.894,4.167 -2.786,9.571 -3.162,14.846 -1.091,-3.794 -1.945,-7.82 -2.165,-11.795 -1.024,-18.471 -13.973,-33.265 -13.973,-33.265 0,0 6.204,16.714 3.311,33.388 -0.843,4.856 -0.212,10.817 0.903,16.365 -2.292,-3.649 -4.434,-7.667 -5.813,-11.837 -5.811,-17.562 -22.174,-28.462 -22.174,-28.462 0,0 10.353,14.515 11.914,31.366 0.463,5.004 2.71,10.705 5.298,15.847 -3.253,-2.967 -6.473,-6.354 -8.962,-10.105 -10.229,-15.413 -28.884,-21.621 -28.884,-21.621 0,0 13.809,11.277 19.751,27.124 1.62,4.32 4.864,8.798 8.36,12.818 -3.494,-1.922 -6.989,-4.181 -9.991,-6.865 -13.791,-12.329 -33.409,-13.622 -33.409,-13.622 0,0 16.21,7.423 25.963,21.254 2.842,4.031 7.511,7.8 12.227,10.934 -4.205,-0.958 -8.567,-2.281 -12.497,-4.254 -16.533,-8.299 -35.808,-4.424 -35.808,-4.424 0,0 17.586,2.932 30.613,13.735 3.843,3.187 9.42,5.622 14.854,7.422 -4.367,0.194 -8.999,0.072 -13.376,-0.813 -18.132,-3.666 -35.713,5.135 -35.713,5.135 0,0 17.739,-1.79 33.145,5.214 4.167,1.894 9.571,2.786 14.846,3.162 -3.794,1.091 -7.82,1.945 -11.795,2.165 -18.471,1.024 -33.265,13.973 -33.265,13.973 0,0 16.714,-6.204 33.388,-3.311 4.856,0.843 10.817,0.212 16.365,-0.903 -3.649,2.292 -7.667,4.434 -11.837,5.813 -17.562,5.811 -28.462,22.174 -28.462,22.174 0,0 14.515,-10.353 31.366,-11.914 5.004,-0.463 10.705,-2.71 15.847,-5.298 -2.967,3.253 -6.354,6.473 -10.105,8.962 -15.413,10.229 -21.622,28.884 -21.622,28.884 0,0 11.277,-13.809 27.124,-19.751 4.319,-1.62 8.797,-4.864 12.817,-8.36 -1.921,3.493 -4.181,6.989 -6.863,9.99 -12.329,13.791 -13.622,33.409 -13.622,33.409 0,0 7.423,-16.21 21.254,-25.963 4.032,-2.844 7.8,-7.512 10.934,-12.228 -0.958,4.206 -2.281,8.567 -4.254,12.498 -8.299,16.533 -4.424,35.808 -4.424,35.808 0,0 2.932,-17.586 13.735,-30.613 3.187,-3.843 5.622,-9.42 7.422,-14.854 0.194,4.369 0.072,9 -0.813,13.377 -3.666,18.132 5.135,35.712 5.135,35.712 0,0 -1.79,-17.738 5.214,-33.144 1.894,-4.167 2.786,-9.572 3.162,-14.846 1.091,3.794 1.945,7.82 2.165,11.795 1.024,18.471 13.973,33.265 13.973,33.265 0,0 -6.204,-16.715 -3.311,-33.388 0.843,-4.856 0.212,-10.817 -0.903,-16.364 2.292,3.649 4.434,7.666 5.813,11.836 5.811,17.562 22.174,28.462 22.174,28.462 0,0 -10.353,-14.515 -11.914,-31.367 -0.463,-5.004 -2.71,-10.705 -5.298,-15.847 3.253,2.967 6.473,6.354 8.962,10.105 10.229,15.413 28.884,21.622 28.884,21.622 0,0 -13.809,-11.277 -19.751,-27.124 -1.62,-4.319 -4.864,-8.797 -8.36,-12.817 3.493,1.921 6.988,4.181 9.99,6.863 13.791,12.329 33.409,13.622 33.409,13.622 0,0 -16.21,-7.423 -25.963,-21.254 -2.844,-4.032 -7.512,-7.801 -12.23,-10.934 4.206,0.958 8.567,2.281 12.498,4.254 16.532,8.298 35.807,4.423 35.807,4.423 z m -93.394,18.497 c -24.753,0 -44.819,-20.066 -44.819,-44.819 0,-24.753 20.066,-44.819 44.819,-44.819 24.753,0 44.819,20.066 44.819,44.819 0,24.753 -20.066,44.819 -44.819,44.819 z"
       id="path2" />
    	<path
       fill="#ffe15a"
       d="m 241.769,237.868 c 0.956,-0.746 1.907,-1.495 2.873,-2.161 -6.35,-2.888 -12.066,-4.275 -16.076,-4.896 -0.638,0.694 -1.214,1.439 -1.799,2.179 3.938,0.765 9.229,2.225 15.002,4.878 z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 230.494,228.833 c 4.309,0.487 10.547,1.77 17.468,4.747 1.16,-0.692 2.314,-1.304 3.47,-1.895 -7.473,-3.068 -14.219,-4.211 -18.862,-4.564 -0.698,0.566 -1.422,1.098 -2.076,1.712 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 252.932,249.607 c -0.894,-0.844 -1.799,-1.643 -2.712,-2.398 -8.391,7.986 -15.732,19.633 -19.046,36.532 1.205,1.078 2.401,2.168 3.738,3.085 2.435,-17.187 9.572,-29.05 18.02,-37.219 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 249.678,242.184 c 0.951,-0.765 1.901,-1.533 2.865,-2.217 -1.174,-0.749 -2.344,-1.407 -3.51,-2.048 -0.999,0.684 -1.999,1.346 -2.986,2.115 1.208,0.665 2.416,1.373 3.631,2.15 z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="m 272.866,240.02 c 7.194,6.319 13.77,15.217 18.449,27.553 1.201,-3.663 2.013,-7.503 2.013,-11.567 0,-7.716 -2.345,-14.883 -6.354,-20.835 -3.71,0.738 -8.691,2.18 -14.108,4.849 z"
       id="path7" />
    	<path
       fill="#ffe15a"
       d="m 253.202,244.585 c 0.937,0.696 1.855,1.482 2.777,2.255 0.921,-0.774 1.839,-1.559 2.777,-2.255 -0.922,-0.768 -1.842,-1.524 -2.777,-2.214 -0.935,0.691 -1.854,1.446 -2.777,2.214 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 255.979,233.77 c -1.173,0.595 -2.347,1.266 -3.527,1.964 1.174,0.617 2.346,1.279 3.527,2.004 1.181,-0.724 2.354,-1.386 3.527,-2.004 -1.18,-0.699 -2.354,-1.369 -3.527,-1.964 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="m 227.104,279.427 c 3.951,-16.135 11.399,-27.189 19.734,-34.793 -1.165,-0.823 -2.326,-1.578 -3.49,-2.276 -8.021,7.053 -15.279,17.245 -19.751,31.929 1.031,1.822 2.196,3.527 3.507,5.14 z"
       id="path10" />
    	<path
       fill="#ffe15a"
       d="m 239.092,240.02 c -5.417,-2.67 -10.398,-4.11 -14.109,-4.85 -4.009,5.952 -6.354,13.119 -6.354,20.835 0,4.064 0.812,7.904 2.013,11.567 4.68,-12.336 11.255,-21.233 18.45,-27.552 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 255.979,229.579 c 7.946,-3.283 15.276,-4.449 20.489,-4.757 -5.887,-3.876 -12.914,-6.165 -20.489,-6.165 -7.575,0 -14.602,2.29 -20.489,6.165 5.213,0.308 12.543,1.473 20.489,4.757 z"
       id="path12" />
    	<path
       fill="#ffe15a"
       d="m 255.979,252.766 c -7.449,8.255 -13.597,20.107 -15.592,37.081 4.758,2.198 10.007,3.508 15.592,3.508 5.586,0 10.834,-1.31 15.592,-3.508 -1.995,-16.973 -8.143,-28.826 -15.592,-37.081 z"
       id="path13" />
    	<path
       fill="#ffe15a"
       d="m 268.61,242.358 c -1.163,0.7 -2.324,1.453 -3.49,2.276 8.334,7.603 15.783,18.658 19.734,34.793 1.311,-1.614 2.476,-3.318 3.507,-5.14 -4.471,-14.683 -11.73,-24.876 -19.751,-31.929 z"
       id="path14" />
    	<path
       fill="#ffe15a"
       d="m 280.783,283.741 c -3.314,-16.899 -10.655,-28.545 -19.046,-36.532 -0.914,0.755 -1.818,1.554 -2.712,2.398 8.448,8.169 15.585,20.032 18.019,37.218 1.338,-0.916 2.534,-2.006 3.739,-3.084 z"
       id="path15" />
    	<path
       fill="#ffe15a"
       d="m 260.526,231.684 c 1.156,0.591 2.311,1.204 3.47,1.895 6.921,-2.977 13.159,-4.26 17.468,-4.747 -0.654,-0.614 -1.378,-1.146 -2.076,-1.713 -4.643,0.355 -11.389,1.498 -18.862,4.565 z"
       id="path16" />
    	<path
       fill="#ffe15a"
       d="m 262.28,242.184 c 1.215,-0.777 2.423,-1.484 3.631,-2.15 -0.986,-0.769 -1.987,-1.431 -2.986,-2.115 -1.166,0.642 -2.335,1.299 -3.51,2.048 0.963,0.684 1.914,1.453 2.865,2.217 z"
       id="path17" />
    	<path
       fill="#ffe15a"
       d="m 270.189,237.868 c 5.773,-2.653 11.064,-4.113 15,-4.877 -0.585,-0.74 -1.16,-1.486 -1.799,-2.179 -4.01,0.621 -9.726,2.007 -16.076,4.896 0.968,0.664 1.92,1.414 2.875,2.16 z"
       id="path18" />
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KH = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs15" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <rect
       y="79.444"
       fill="#ff4b55"
       width="512"
       height="176.55"
       id="rect1"
       x="0" />
    <polygon
       fill="#f5f5f5"
       points="368.644,310.416 368.644,302.072 364.471,302.072 364.471,293.729 360.299,293.729 360.299,285.385 347.783,285.385 347.783,260.353 347.782,260.353 351.955,256.181 351.955,243.665 347.783,243.665 347.783,235.321 343.611,235.321 343.611,222.805 339.44,222.805 339.44,214.461 335.268,214.461 335.268,206.117 331.096,206.117 331.096,201.945 322.751,201.945 322.751,206.117 318.579,206.117 318.579,214.461 314.407,214.461 314.407,222.805 310.236,222.805 310.236,235.321 306.064,235.321 306.064,243.665 281.031,243.665 281.031,231.149 276.86,231.149 276.86,218.633 272.688,218.633 272.688,206.117 268.516,206.117 268.516,197.773 264.344,197.773 264.344,189.429 260.172,189.429 260.172,185.257 258.086,185.257 258.086,181.085 253.914,181.085 253.914,185.257 251.827,185.257 251.827,189.429 247.656,189.429 247.656,197.773 243.484,197.773 243.484,206.117 239.312,206.117 239.312,218.633 235.14,218.633 235.14,231.149 230.968,231.149 230.968,243.665 205.936,243.665 205.936,235.321 201.764,235.321 201.764,222.805 197.592,222.805 197.592,214.461 193.42,214.461 193.42,206.117 189.248,206.117 189.248,201.945 180.904,201.945 180.904,206.117 176.732,206.117 176.732,214.461 172.56,214.461 172.56,222.805 168.388,222.805 168.388,235.321 164.216,235.321 164.216,243.665 160.044,243.665 160.044,256.181 164.214,260.353 164.216,260.353 164.216,285.385 151.701,285.385 151.701,293.729 147.529,293.729 147.529,302.072 143.356,302.072 143.356,310.416 139.184,310.416 139.184,322.934 135.012,322.934 135.012,335.448 376.987,335.448 376.987,322.934 372.816,322.934 372.816,310.416 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.002 335.449" {...props}>
    <defs
       id="defs24" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.877 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="m 305.466,170.504 c -2.239,-1.926 -4.779,-3.328 -7.328,-4.353 14.409,-2.841 25.997,-15.016 25.997,-15.016 -7.005,3.073 -10.261,3.695 -21.41,0.031 -2.805,-0.922 -5.688,-1.246 -8.435,-1.217 12.224,-8.14 18.272,-23.82 18.272,-23.82 -5.295,5.519 -8.066,7.341 -19.768,8.222 -2.945,0.222 -5.732,1.026 -8.26,2.104 8.18,-12.197 7.766,-29.001 7.766,-29.001 -2.78,7.126 -4.642,9.869 -15.117,15.16 -2.636,1.332 -4.904,3.143 -6.826,5.105 2.888,-14.399 -3.924,-29.763 -3.924,-29.763 0.159,7.647 -0.513,10.894 -8.164,19.792 -1.926,2.239 -3.328,4.779 -4.353,7.328 C 251.075,110.667 238.9,99.079 238.9,99.079 c 3.073,7.005 3.695,10.261 0.031,21.41 -0.922,2.805 -1.246,5.688 -1.217,8.435 -8.14,-12.224 -23.82,-18.272 -23.82,-18.272 5.519,5.295 7.341,8.066 8.222,19.768 0.222,2.945 1.026,5.732 2.103,8.259 -12.199,-8.179 -29,-7.765 -29,-7.765 7.126,2.78 9.869,4.642 15.16,15.117 1.332,2.636 3.143,4.903 5.106,6.826 -14.4,-2.889 -29.765,3.924 -29.765,3.924 7.648,-0.159 10.894,0.513 19.793,8.164 2.239,1.926 4.779,3.327 7.328,4.353 -14.409,2.841 -25.997,15.016 -25.997,15.016 7.005,-3.073 10.261,-3.695 21.41,-0.031 2.806,0.922 5.689,1.246 8.436,1.217 -12.224,8.139 -18.273,23.821 -18.273,23.821 5.295,-5.519 8.066,-7.341 19.768,-8.222 2.945,-0.222 5.732,-1.026 8.259,-2.103 -8.179,12.199 -7.765,29 -7.765,29 2.78,-7.127 4.642,-9.869 15.117,-15.161 2.636,-1.332 4.903,-3.143 6.826,-5.105 -2.889,14.4 3.924,29.764 3.924,29.764 -0.159,-7.648 0.513,-10.894 8.164,-19.793 1.926,-2.239 3.328,-4.779 4.353,-7.328 2.841,14.408 15.016,25.997 15.016,25.997 -3.073,-7.005 -3.695,-10.262 -0.031,-21.41 0.922,-2.805 1.246,-5.688 1.217,-8.435 8.14,12.224 23.82,18.272 23.82,18.272 -5.519,-5.295 -7.341,-8.066 -8.222,-19.768 -0.222,-2.944 -1.026,-5.732 -2.103,-8.259 12.197,8.179 29,7.765 29,7.765 -7.126,-2.781 -9.869,-4.642 -15.161,-15.117 -1.332,-2.636 -3.143,-4.904 -5.105,-6.826 14.4,2.888 29.764,-3.924 29.764,-3.924 -7.647,0.159 -10.894,-0.51 -19.792,-8.164 z"
       id="path2" />
    <path
       fill="#ffd25a"
       d="m 291.406,174.768 35.214,-7.043 -35.214,-7.043 29.839,-19.982 -35.229,6.968 19.921,-29.88 -29.88,19.921 6.969,-35.229 -19.982,29.838 -7.044,-35.212 -7.042,35.214 -19.982,-29.838 6.969,35.229 -29.88,-19.921 19.921,29.88 -35.229,-6.968 29.839,19.982 -35.216,7.042 35.214,7.043 -29.839,19.982 35.229,-6.969 -19.921,29.88 29.88,-19.921 -6.969,35.229 19.982,-29.838 7.044,35.213 7.043,-35.214 19.982,29.838 -6.969,-35.229 29.88,19.921 -19.921,-29.88 35.229,6.969 z"
       id="path3" />
    <circle
       fill="#ffe15a"
       cx="256"
       cy="167.724"
       r="35.310001"
       id="circle3" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 102.265,361.931 c 25.61,0 25.61,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.627,0 25.629,8.828 51.256,8.828 25.571,0 25.571,-8.828 51.143,-8.828 25.585,0 25.585,8.828 51.169,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.595,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.192,-8.828 0.041,0 0.075,0.002 0.116,0.002 V 335.45 c -0.041,0 -0.075,-0.002 -0.116,-0.002 -25.596,0 -25.596,8.828 -51.192,8.828 -25.594,0 -25.594,-8.828 -51.19,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.169,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.627,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.588,0 -25.588,8.828 -51.177,8.828 -25.561,0 -25.609,-8.797 -51.088,-8.825 v 26.483 c 25.48,0.029 25.527,8.825 51.088,8.825 25.589,0 25.589,-8.828 51.177,-8.828 z"
       id="path4" />
    	<path
       fill="#41479b"
       d="m 0,308.969 c 25.48,0.028 25.527,8.824 51.088,8.824 25.589,0 25.589,-8.828 51.177,-8.828 25.61,0 25.61,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.627,0 25.629,8.828 51.256,8.828 25.571,0 25.571,-8.828 51.143,-8.828 25.585,0 25.585,8.828 51.169,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.595,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.192,-8.828 0.041,0 0.075,0.002 0.116,0.002 v -26.483 c -0.041,0 -0.075,-0.002 -0.116,-0.002 -25.596,0 -25.596,8.828 -51.192,8.828 -25.594,0 -25.594,-8.828 -51.19,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.169,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.627,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.588,0 -25.588,8.828 -51.177,8.828 -25.561,0 -25.609,-8.797 -51.088,-8.825 z"
       id="path5" />
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 0,388.417 c 25.48,0.028 25.527,8.824 51.088,8.824 25.589,0 25.589,-8.828 51.177,-8.828 25.61,0 25.61,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.627,0 25.629,8.828 51.256,8.828 25.571,0 25.571,-8.828 51.143,-8.828 25.585,0 25.585,8.828 51.169,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.595,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.192,-8.828 0.041,0 0.075,0.002 0.116,0.002 v -26.483 c -0.041,0 -0.075,-0.002 -0.116,-0.002 -25.596,0 -25.596,8.828 -51.192,8.828 -25.594,0 -25.594,-8.828 -51.19,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.169,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.627,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.588,0 -25.588,8.828 -51.177,8.828 -25.561,0 -25.609,-8.797 -51.088,-8.825 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 0,335.452 c 25.48,0.028 25.527,8.824 51.088,8.824 25.589,0 25.589,-8.828 51.177,-8.828 25.61,0 25.61,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.627,0 25.629,8.828 51.256,8.828 25.571,0 25.571,-8.828 51.143,-8.828 25.585,0 25.585,8.828 51.169,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.595,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.192,-8.828 0.041,0 0.075,0.002 0.116,0.002 v -26.483 c -0.041,0 -0.075,-0.002 -0.116,-0.002 -25.596,0 -25.596,8.828 -51.192,8.828 -25.594,0 -25.594,-8.828 -51.19,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.169,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.627,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.588,0 -25.588,8.828 -51.177,8.828 -25.561,0 -25.609,-8.797 -51.088,-8.825 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 0,282.487 c 25.48,0.028 25.527,8.824 51.088,8.824 25.589,0 25.589,-8.828 51.177,-8.828 25.61,0 25.61,8.828 51.221,8.828 25.629,0 25.629,-8.828 51.256,-8.828 25.627,0 25.629,8.828 51.256,8.828 25.571,0 25.571,-8.828 51.143,-8.828 25.585,0 25.585,8.828 51.169,8.828 25.596,0 25.596,-8.828 51.191,-8.828 25.595,0 25.595,8.828 51.19,8.828 25.596,0 25.596,-8.828 51.192,-8.828 0.041,0 0.075,0.002 0.116,0.002 v -26.483 c -0.041,0 -0.075,-0.002 -0.116,-0.002 -25.596,0 -25.596,8.828 -51.192,8.828 -25.594,0 -25.594,-8.828 -51.19,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.169,-8.828 -25.571,0 -25.571,8.828 -51.143,8.828 -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.627,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.588,0 -25.588,8.828 -51.177,8.828 -25.561,0 -25.609,-8.797 -51.088,-8.825 z"
       id="path8" />
    </g>
    <path
       fill="#41479b"
       d="m 460.692,308.966 c -25.594,0 -25.594,-8.828 -51.19,-8.828 -25.596,0 -25.596,8.828 -51.191,8.828 -25.585,0 -25.585,-8.828 -51.169,-8.828 -25.571,0 -25.571,8.828 -51.142,8.828 -25.629,0 -25.629,-8.828 -51.256,-8.828 -25.627,0 -25.629,8.828 -51.256,8.828 -25.611,0 -25.611,-8.828 -51.221,-8.828 -25.588,0 -25.588,8.828 -51.177,8.828 -25.561,0 -25.609,-8.797 -51.088,-8.825 v 26.48 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.813,0 8.693,-3.863 8.792,-8.652 0.011,-15.532 0.023,-26.655 0.035,-26.655 v 0 c -0.041,0 -0.075,-0.002 -0.116,-0.002 -25.598,-0.002 -25.598,8.826 -51.194,8.826 z"
       id="path9" />
    <path
       fill="#ffe15a"
       d="m 274.38,46.889 c 42.927,-1.66 64.746,-20.396 64.746,-20.396 -3.083,1.185 -51.227,5.217 -64.983,6.403 -8.687,0.748 -19.524,10.653 -26.349,17.865 -1.838,-4.994 -5.431,-10.174 -12.546,-11.224 -14.467,-2.134 -52.888,-4.505 -62.374,-9.013 v 0 c 0,0 6.123,9.465 37.769,13.756 15.162,2.056 23.522,7.256 27.503,10.796 l -3.609,-0.124 c 0,0 0,0 -6.166,-3.084 -6.166,-3.083 -12.333,2.134 -12.333,2.134 h -9.822 c -1.23,0 -1.932,1.405 -1.194,2.388 l 0.945,1.26 c 0.964,1.287 2.479,2.044 4.087,2.044 h 10.015 c 3.558,6.166 17.076,12.57 28.223,12.57 11.146,0 45.299,-15.178 48.619,-15.178 l -30.894,-1.057 z"
       id="path10" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs23" />
    <path
       fill="#ffe15a"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 83.862 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 Z"
       id="path1" />
    <rect
       y="83.863998"
       fill="#f5f5f5"
       width="512"
       height="83.860001"
       id="rect1"
       x="0" />
    <rect
       y="167.724"
       fill="#ff4b55"
       width="512"
       height="83.860001"
       id="rect2"
       x="0" />
    <path
       fill="#4173cd"
       d="m 0,251.586 h 512 v 75.034 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path2" />
    <path
       fill="#73af00"
       d="M 3.256,333.315 250.639,171.236 c 2.53,-1.658 2.53,-5.366 0,-7.025 L 3.256,2.134 C 1.311,3.752 0,6.099 0,8.828 V 326.62 c 0,2.729 1.311,5.076 3.256,6.695 z"
       id="path3" />
    <g
       id="g8"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 48.833,256 c 0,-31.919 20.865,-58.927 49.689,-68.229 1.515,-0.489 1.304,-2.701 -0.275,-2.908 -2.967,-0.388 -5.99,-0.598 -9.064,-0.598 -39.618,0 -71.735,32.117 -71.735,71.735 0,39.618 32.117,71.735 71.735,71.735 3.074,0 6.097,-0.21 9.064,-0.598 1.579,-0.207 1.79,-2.419 0.275,-2.908 C 69.698,314.928 48.833,287.921 48.833,256 Z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 98.89,201.208 1.975,5.921 6.241,0.049 c 0.808,0.007 1.143,1.037 0.493,1.517 l -5.021,3.708 1.882,5.951 c 0.244,0.77 -0.633,1.408 -1.291,0.938 l -5.078,-3.629 -5.078,3.629 c -0.658,0.47 -1.535,-0.168 -1.291,-0.938 l 1.882,-5.951 -5.021,-3.708 c -0.65,-0.48 -0.314,-1.512 0.493,-1.517 l 6.241,-0.049 1.975,-5.921 c 0.257,-0.767 1.342,-0.767 1.598,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 98.89,231.214 1.975,5.921 6.241,0.049 c 0.808,0.007 1.143,1.037 0.493,1.517 l -5.021,3.708 1.882,5.951 c 0.244,0.77 -0.633,1.408 -1.291,0.938 l -5.078,-3.629 -5.078,3.629 c -0.658,0.47 -1.535,-0.168 -1.291,-0.938 l 1.882,-5.951 -5.021,-3.708 c -0.65,-0.48 -0.314,-1.512 0.493,-1.517 l 6.241,-0.049 1.975,-5.921 c 0.257,-0.766 1.342,-0.766 1.598,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 98.89,261.22 1.975,5.921 6.241,0.049 c 0.808,0.007 1.143,1.037 0.493,1.517 l -5.021,3.708 1.882,5.951 c 0.244,0.77 -0.633,1.408 -1.291,0.938 l -5.078,-3.629 -5.078,3.629 c -0.658,0.47 -1.535,-0.168 -1.291,-0.938 l 1.882,-5.951 -5.021,-3.708 c -0.65,-0.48 -0.314,-1.512 0.493,-1.517 l 6.241,-0.049 1.975,-5.921 c 0.257,-0.767 1.342,-0.767 1.598,0 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 98.89,291.227 1.975,5.921 6.241,0.049 c 0.808,0.007 1.143,1.037 0.493,1.517 l -5.021,3.708 1.882,5.951 c 0.244,0.77 -0.633,1.408 -1.291,0.938 l -5.078,-3.629 -5.078,3.629 c -0.658,0.47 -1.535,-0.168 -1.291,-0.938 l 1.882,-5.951 -5.021,-3.708 c -0.65,-0.48 -0.314,-1.512 0.493,-1.517 l 6.241,-0.049 1.975,-5.921 c 0.257,-0.767 1.342,-0.767 1.598,0 z"
       id="path8" />
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ffe15a"
       points="0,360.406 415.355,88.276 375.086,88.276 0,334.021 "
       id="polygon1" />
    	<polygon
       fill="#ffe15a"
       points="96.644,423.724 136.913,423.724 512,177.979 512,151.594 "
       id="polygon2" />
    </g>
    <path
       fill="#464655"
       d="M 512,63.318 V 8.828 C 512,3.953 508.047,0 503.172,0 H 415.355 L 0,272.13 v 54.49 c 0,4.875 3.953,8.828 8.828,8.828 h 87.817 z"
       id="path2" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 156.018,275.9 18.119,14.59 19.67,-12.42 c 2.547,-1.608 5.675,0.951 4.602,3.766 l -8.277,21.74 17.89,14.869 c 2.316,1.926 0.849,5.69 -2.159,5.542 l -23.234,-1.154 -8.613,21.61 c -1.116,2.797 -5.15,2.567 -5.938,-0.341 l -6.082,-22.454 -23.213,-1.514 c -3.006,-0.196 -4.032,-4.105 -1.511,-5.752 l 19.475,-12.724 -5.734,-22.546 c -0.74,-2.918 2.66,-5.102 5.005,-3.212 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 323.007,166.29 18.119,14.59 19.67,-12.42 c 2.547,-1.608 5.675,0.951 4.602,3.766 l -8.277,21.74 17.89,14.869 c 2.316,1.926 0.849,5.69 -2.159,5.542 l -23.234,-1.154 -8.613,21.61 c -1.116,2.797 -5.15,2.566 -5.938,-0.341 l -6.082,-22.454 -23.213,-1.514 c -3.006,-0.196 -4.032,-4.105 -1.511,-5.752 l 19.475,-12.724 -5.734,-22.546 c -0.741,-2.916 2.659,-5.101 5.005,-3.212 z"
       id="path4" />
    </g>
    <path
       fill="#ff4b55"
       d="M 512,326.62 V 89.703 L 136.913,335.448 h 366.258 c 4.876,0 8.829,-3.952 8.829,-8.828 z"
       id="path5" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KP = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<rect
       y="132.411"
       fill="#f5f5f5"
       width="512"
       height="17.655001"
       id="rect1"
       x="0" />
    	<rect
       y="361.931"
       fill="#f5f5f5"
       width="512"
       height="17.655001"
       id="rect2"
       x="0" />
    </g>
    <rect
       y="61.794998"
       fill="#ff4b55"
       width="512"
       height="211.86"
       id="rect3"
       x="0" />
    <circle
       fill="#f5f5f5"
       cx="141.24001"
       cy="167.72501"
       r="70.620003"
       id="circle3" />
    <path
       fill="#ff4b55"
       d="m 143.122,103.43 14.167,42.478 44.777,0.348 c 1.905,0.014 2.695,2.445 1.162,3.577 l -36.021,26.6 13.506,42.692 c 0.575,1.816 -1.493,3.318 -3.043,2.211 l -36.428,-26.039 -36.429,26.038 c -1.549,1.108 -3.617,-0.395 -3.043,-2.211 l 13.506,-42.692 -36.021,-26.6 c -1.533,-1.131 -0.743,-3.562 1.162,-3.577 l 44.777,-0.348 14.167,-42.478 c 0.603,-1.806 3.158,-1.806 3.761,0.001 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs36" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 305.009,94.257 c -40.563,-27.041 -95.35,-15.986 -122.374,24.506 -13.555,20.211 -8.045,47.674 12.235,61.195 20.265,13.521 47.64,8.03 61.161,-12.252 13.521,-20.281 40.914,-25.704 61.178,-12.254 20.298,13.521 25.757,40.984 12.217,61.195 27.042,-40.56 16.111,-95.348 -24.417,-122.39"
       id="path2" />
    <path
       fill="#41479b"
       d="m 182.634,118.764 c -13.555,20.211 -8.045,47.674 12.235,61.195 20.265,13.521 47.64,8.03 61.161,-12.252 13.521,-20.281 40.914,-25.704 61.178,-12.254 20.298,13.521 25.757,40.984 12.217,61.195 -27.006,40.632 -81.775,51.549 -122.338,24.507 -40.526,-27.04 -51.494,-81.828 -24.453,-122.391"
       id="path3" />
    <g
       id="g21"
       transform="translate(0,-88.276)">
    	<path
       fill="#464655"
       d="m 349.92,149.191 16.035,24.102 c 1.347,2.025 0.802,4.759 -1.219,6.112 l -4.066,2.723 c -2.029,1.358 -4.775,0.812 -6.129,-1.22 l -16.055,-24.096 c -1.351,-2.027 -0.803,-4.766 1.223,-6.119 l 4.086,-2.728 c 2.03,-1.355 4.773,-0.806 6.125,1.226 z"
       id="path4" />
    	<path
       fill="#464655"
       d="m 374.66,186.352 16.087,24.087 c 1.358,2.034 0.803,4.786 -1.237,6.134 l -4.084,2.699 c -2.026,1.34 -4.754,0.789 -6.103,-1.23 L 363.245,193.98 c -1.354,-2.026 -0.81,-4.767 1.217,-6.122 l 4.074,-2.724 c 2.027,-1.355 4.769,-0.81 6.124,1.218 z"
       id="path5" />
    	<path
       fill="#464655"
       d="m 367.089,137.733 40.829,61.273 c 1.352,2.028 0.803,4.768 -1.225,6.12 l -4.102,2.734 c -2.028,1.353 -4.769,0.804 -6.121,-1.224 l -40.843,-61.269 c -1.353,-2.029 -0.803,-4.771 1.227,-6.122 l 4.115,-2.739 c 2.029,-1.349 4.768,-0.801 6.12,1.227 z"
       id="path6" />
    	<path
       fill="#464655"
       d="m 384.211,126.293 16.07,24.149 c 1.354,2.034 0.798,4.78 -1.241,6.127 l -4.086,2.7 c -2.028,1.34 -4.757,0.789 -6.105,-1.234 l -16.082,-24.117 c -1.353,-2.028 -0.804,-4.769 1.224,-6.121 l 4.099,-2.732 c 2.027,-1.353 4.769,-0.804 6.121,1.228 z"
       id="path7" />
    	<path
       fill="#464655"
       d="m 408.967,163.532 16.045,24.099 c 1.35,2.026 0.803,4.762 -1.22,6.115 l -4.075,2.724 c -2.029,1.357 -4.775,0.809 -6.127,-1.223 l -16.045,-24.099 c -1.349,-2.026 -0.803,-4.762 1.22,-6.115 l 4.075,-2.724 c 2.028,-1.357 4.774,-0.81 6.127,1.223 z"
       id="path8" />
    	<path
       fill="#464655"
       d="m 132.721,293.983 40.824,61.207 c 1.352,2.027 0.806,4.767 -1.222,6.12 l -4.088,2.73 c -2.028,1.354 -4.769,0.807 -6.123,-1.222 l -40.824,-61.207 c -1.352,-2.027 -0.806,-4.767 1.222,-6.12 l 4.088,-2.73 c 2.028,-1.354 4.77,-0.806 6.123,1.222 z"
       id="path9" />
    	<path
       fill="#464655"
       d="m 115.582,305.432 16.028,24.041 c 1.351,2.026 0.806,4.761 -1.217,6.116 l -4.066,2.722 c -2.027,1.357 -4.771,0.812 -6.126,-1.217 l -16.047,-24.035 c -1.354,-2.027 -0.808,-4.768 1.22,-6.122 l 4.086,-2.728 c 2.027,-1.353 4.769,-0.806 6.122,1.223 z"
       id="path10" />
    	<path
       fill="#464655"
       d="m 140.351,342.606 16.046,24.102 c 1.35,2.026 0.803,4.763 -1.222,6.115 l -4.078,2.726 c -2.029,1.356 -4.772,0.809 -6.126,-1.221 l -16.056,-24.097 c -1.351,-2.027 -0.803,-4.766 1.222,-6.119 l 4.088,-2.73 c 2.03,-1.356 4.773,-0.807 6.126,1.224 z"
       id="path11" />
    	<path
       fill="#464655"
       d="m 98.442,316.877 40.798,61.21 c 1.351,2.026 0.804,4.764 -1.219,6.118 l -4.077,2.726 c -2.028,1.356 -4.771,0.81 -6.125,-1.22 L 86.997,324.509 c -1.353,-2.028 -0.804,-4.769 1.224,-6.122 l 4.102,-2.734 c 2.026,-1.352 4.767,-0.804 6.119,1.224 z"
       id="path12" />
    	<path
       fill="#464655"
       d="m 121.294,210.443 40.818,-61.257 c 1.353,-2.03 4.095,-2.578 6.124,-1.224 l 4.087,2.729 c 2.027,1.353 2.573,4.093 1.222,6.12 l -40.834,61.223 c -1.35,2.023 -4.081,2.573 -6.108,1.231 l -4.071,-2.695 c -2.038,-1.348 -2.592,-4.095 -1.238,-6.127 z"
       id="path13" />
    	<path
       fill="#464655"
       d="m 104.147,199.01 40.825,-61.269 c 1.353,-2.03 4.097,-2.578 6.126,-1.222 l 4.077,2.726 c 2.024,1.353 2.57,4.089 1.22,6.116 l -40.814,61.272 c -1.353,2.03 -4.095,2.579 -6.124,1.224 l -4.088,-2.729 c -2.026,-1.352 -2.573,-4.091 -1.222,-6.118 z"
       id="path14" />
    	<path
       fill="#464655"
       d="m 86.99,187.626 40.829,-61.33 c 1.353,-2.031 4.098,-2.58 6.127,-1.224 l 4.077,2.726 c 2.024,1.353 2.57,4.087 1.222,6.114 l -40.804,61.339 c -1.351,2.031 -4.094,2.581 -6.123,1.228 l -4.102,-2.734 c -2.027,-1.352 -2.575,-4.091 -1.226,-6.119 z"
       id="path15" />
    	<path
       fill="#464655"
       d="m 338.493,355.19 16.047,-24.035 c 1.355,-2.029 4.099,-2.574 6.126,-1.217 l 4.066,2.723 c 2.023,1.354 2.567,4.09 1.217,6.116 l -16.028,24.04 c -1.353,2.029 -4.095,2.577 -6.123,1.223 l -4.086,-2.728 c -2.027,-1.354 -2.573,-4.094 -1.219,-6.122 z"
       id="path16" />
    	<path
       fill="#464655"
       d="m 363.243,318.142 16.073,-24.154 c 1.352,-2.03 4.094,-2.58 6.123,-1.227 l 4.096,2.73 c 2.029,1.353 2.577,4.096 1.223,6.124 l -16.107,24.116 c -1.351,2.023 -4.082,2.571 -6.109,1.227 l -4.062,-2.692 c -2.035,-1.349 -2.589,-4.093 -1.237,-6.124 z"
       id="path17" />
    	<path
       fill="#464655"
       d="m 355.626,366.699 16.057,-24.098 c 1.352,-2.029 4.093,-2.578 6.122,-1.225 l 4.104,2.737 c 2.027,1.352 2.575,4.09 1.225,6.119 l -16.047,24.1 c -1.351,2.029 -4.09,2.579 -6.12,1.228 l -4.115,-2.739 c -2.028,-1.351 -2.578,-4.093 -1.226,-6.122 z"
       id="path18" />
    	<path
       fill="#464655"
       d="m 380.403,329.464 16.066,-24.042 c 1.354,-2.025 4.092,-2.571 6.119,-1.22 l 4.102,2.734 c 2.029,1.353 2.577,4.096 1.221,6.124 l -16.065,24.042 c -1.353,2.025 -4.092,2.571 -6.118,1.22 l -4.103,-2.734 c -2.031,-1.351 -2.578,-4.095 -1.222,-6.124 z"
       id="path19" />
    	<path
       fill="#464655"
       d="m 372.771,378.082 16.075,-24.056 c 1.35,-2.019 4.077,-2.569 6.103,-1.23 l 4.086,2.7 c 2.039,1.348 2.595,4.097 1.239,6.131 l -16.063,24.088 c -1.352,2.028 -4.093,2.575 -6.121,1.224 l -4.099,-2.732 c -2.029,-1.354 -2.576,-4.097 -1.22,-6.125 z"
       id="path20" />
    	<path
       fill="#464655"
       d="m 397.554,340.97 16.035,-24.085 c 1.353,-2.031 4.098,-2.58 6.127,-1.223 l 4.072,2.722 c 2.025,1.354 2.57,4.093 1.218,6.119 l -16.049,24.053 c -1.349,2.024 -4.083,2.573 -6.11,1.229 l -4.06,-2.69 c -2.033,-1.348 -2.586,-4.093 -1.233,-6.125 z"
       id="path21" />
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.00198 335.44923" {...props}>
    <defs
         id="defs39"><clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath941"><g
             id="use943"><path
               fill="#435125"
               id="path1346"
               d="m 301.50807,445.71112 c -0.18,-0.086 -0.218,-0.122 -0.347,-0.245 l -0.125,-0.117 c -0.324,-0.297 -0.861,-0.822 -1.582,-1.643 -1.332,-1.513 -3.119,-3.728 -4.69,-5.685 -3.115,-3.883 -5.689,-7.228 -6.174,-7.858 l -0.793,-1.032 -7.767,-2.395 -5.671,-2.644 3.03,-3.406 10.408,4.456 7.767,1.594 14.363,10.564 -0.011,0.009 c -0.029,0.024 -2.089,1.738 -4.136,3.599 -0.913,0.83 -2.064,1.896 -2.877,2.783 -0.375,0.408 -0.705,0.813 -0.93,1.14 -0.138,0.201 -0.215,0.383 -0.252,0.471 l 0.892,-0.555 0.967,0.752 -1.968,0.184 -0.09,0.02 z m -53.34,-16.02 c -6.777,-0.001 -13.471,-1.874 -19.895,-5.567 l -0.007,-0.004 0.003,-0.008 c 0,0 0.84,-1.601 2.878,-3.096 1.941,-1.425 5.442,-3.128 11.1,-3.15 h 0.117 c 6.701,0 14.901,2.278 24.373,6.771 -0.32,0.212 -7.756,5.054 -18.566,5.054 l 0.01,0.01 z m -29.37,-6.51 c -1.253,0 -2.379,-0.474 -3.17,-1.333 -0.649,-0.706 -1.114,-1.646 -1.422,-2.878 -0.504,-2.018 -0.365,-4.025 -0.351,-4.217 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.511,0 4.49,2.178 5.338,4.337 0.481,1.227 0.574,2.259 0.274,3.067 -0.3,0.81 -1.24,1.37 -2.34,1.37 z m 51.68,-5.99 c -17.359,-2.479 -24.717,-8.755 -27.833,-13.583 -3.323,-5.149 -2.641,-9.912 -2.634,-9.96 l 0.003,-0.014 0.013,-0.004 c 0.005,0 1.061,-0.285 2.658,-0.293 4.618,0 16.43,2.323 27.798,23.842 l 0.007,0.014 -0.02,-0.01 z m -35.58,-3.44 c -7.416,-0.001 -13.062,-1.28 -16.782,-3.804 -2.138,-1.45 -3.184,-3.043 -3.686,-4.125 -0.47,-1.014 -0.577,-1.856 -0.594,-2.023 0.196,-0.09 3.232,-1.438 7.765,-1.65 0.383,-0.018 0.769,-0.029 1.174,-0.03 5.732,0 14.448,1.87 23.646,10.78 l 0.009,0.009 -0.011,10e-4 c -4.2,0.55 -8.08,0.84 -11.53,0.84 z m -35.91,-1.38 c -7.82,0 -18.563,-2.388 -25.263,-9.087 l -0.007,-0.008 0.02,-0.005 c 0.07,-0.018 7.342,-1.863 15.523,-2.062 0.488,-0.012 0.979,-0.019 1.475,-0.019 7.332,0 12.944,1.422 16.682,4.225 1.305,0.979 2.018,1.89 2.178,2.783 0.134,0.746 -0.26,1.55 -1.056,2.15 -1.683,1.271 -4.692,1.949 -8.945,2.017 l -0.6,0.02 z m -25.34,-13 c -0.963,0 -1.867,-0.426 -2.479,-1.167 -0.506,-0.614 -0.858,-1.416 -1.108,-2.522 -0.418,-1.848 -0.292,-3.656 -0.291,-3.674 l 0.001,-0.018 c 0.364,-0.172 0.771,-0.264 1.217,-0.275 h 0.003 c 1.157,0 2.039,0.63 2.589,1.158 0.733,0.705 1.333,1.645 1.688,2.645 0.365,1.03 0.424,1.892 0.18,2.635 -0.2,0.59 -0.88,1.21 -1.8,1.21 z m 58.53,-1.32 c -1.253,0 -2.379,-0.474 -3.17,-1.333 -0.649,-0.706 -1.114,-1.646 -1.422,-2.878 -0.504,-2.018 -0.365,-4.025 -0.351,-4.217 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.511,0 4.49,2.178 5.338,4.337 0.481,1.227 0.574,2.259 0.274,3.067 -0.3,0.82 -1.25,1.37 -2.34,1.37 z m -28.51,-1.18 c -15.737,-0.554 -23.904,-5.027 -27.984,-8.683 -2.297,-2.058 -3.574,-4.098 -4.24,-5.447 -0.628,-1.274 -0.866,-2.249 -0.908,-2.438 l 0.021,-0.009 c 0.003,0 1.489,-0.532 3.885,-0.579 l 0.368,-0.004 c 5.307,0 16.111,2.229 28.852,17.153 v 0.01 z m 17.09,-1.59 c -12.661,-1.928 -19.834,-7.363 -23.622,-11.585 -3.971,-4.425 -5.16,-8.546 -5.213,-8.738 0.023,-0.007 1.57,-0.41 3.9,-0.469 0.169,-0.005 0.345,-0.007 0.524,-0.007 0.181,0 0.365,0.002 0.553,0.007 6.368,0.139 17.934,3.023 23.855,20.785 h 0.01 z m -65,-6.08 c -4.149,0 -8.174,-0.48 -11.962,-1.427 -6.629,-1.658 -9.473,-4.189 -10.691,-6.021 -0.692,-1.04 -0.943,-1.952 -1.031,-2.534 -0.085,-0.556 -0.04,-0.999 -0.031,-1.073 l 0.031,-0.011 c 0.017,-0.004 4.4,-1.235 10.464,-1.328 0.239,-0.004 0.48,-0.006 0.725,-0.006 2.927,0 5.808,0.279 8.564,0.83 10.536,2.107 16,10.06 16.053,10.14 l 0.005,0.009 -0.013,0.003 c -0.06,0.01 -5.08,1.42 -12.12,1.42 z m 29.39,-10.68 c -1.269,0 -2.395,-0.463 -3.172,-1.304 -0.639,-0.691 -1.104,-1.643 -1.42,-2.908 -0.506,-2.015 -0.365,-4.002 -0.351,-4.185 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.506,0 4.488,2.179 5.339,4.338 0.468,1.188 0.55,2.208 0.243,3.034 -0.31,0.84 -1.22,1.38 -2.31,1.38 z m -22.1,-3.03 c -0.095,-0.023 -5.977,-1.536 -11.967,-5.225 -5.544,-3.413 -12.326,-9.45 -13.153,-18.83 v -0.005 l 0.014,-0.004 c 0.001,0 0.516,-0.125 1.278,-0.154 0.105,-0.004 0.217,-0.006 0.334,-0.006 1.656,0 5.046,0.466 9.147,3.584 5.22,3.98 10.04,10.92 14.35,20.65 z m 14.43,-0.53 c -0.037,-0.015 -4.229,-1.693 -9.469,-6.084 -4.882,-4.092 -11.746,-11.46 -16.716,-23.33 0.003,-0.001 1.142,-0.608 2.886,-0.718 0.101,-0.007 0.203,-0.009 0.306,-0.009 0.15,0 0.305,0.005 0.463,0.009 2.411,0.068 6.083,1.07 10.154,5.463 4.676,5.047 8.85,13.34 12.404,24.651 l 0.01,0.032 -0.03,-0.01 z m -37.39,-1.09 c -4.821,0 -6.471,-2.615 -6.957,-3.74 -0.798,-1.849 -0.556,-3.689 -0.554,-3.707 l 0.003,-0.02 c 0.78,-0.195 1.605,-0.303 2.398,-0.314 l 0.165,-0.001 c 3.799,0 6.798,1.929 8.084,3.841 0.255,0.379 1.037,1.694 0.39,2.721 -0.52,0.81 -1.7,1.22 -3.53,1.22 z m -10.68,-13.47 c -2.692,0 -6.811,-0.165 -11.141,-0.952 -4.294,-0.781 -6.728,-4.432 -8.013,-7.356 -1.399,-3.185 -1.794,-6.223 -1.798,-6.254 h 0.012 c 13.282,0.39 19.555,4.271 22.478,7.457 3.018,3.29 3.197,6.706 3.206,6.922 l -0.009,10e-4 c -0.02,0 -1.89,0.18 -4.74,0.18 z m 13.83,-13.82 c -0.018,-0.022 -1.535,-1.898 -3.033,-4.228 -1.573,-2.445 -3.028,-4.996 -3.028,-7.084 0,-2.016 -0.474,-6.266 -0.757,-8.619 -0.358,-2.985 -0.72,-5.54 -0.75,-5.757 l 0.013,0.004 c 0.337,0.123 8.308,3.114 8.308,10.591 0,7.489 -0.738,15.014 -0.745,15.089 l -0.001,0.011 h -0.01 z m -10.33,-0.71 c -0.084,0 -0.167,-0.008 -0.25,-0.021 -2.356,-0.393 -6.496,-2.194 -11.073,-4.818 -5.082,-2.914 -9.209,-6.036 -11.62,-8.791 -2.198,-2.512 -3.503,-6.457 -3.88,-11.726 -0.267,-3.739 0.053,-6.854 0.087,-7.163 0.412,-0.137 0.85,-0.204 1.315,-0.204 1.764,0.029 3.647,0.823 6.189,2.574 1.981,1.365 4.165,3.221 6.49,5.514 4.012,3.957 7.168,7.932 7.199,7.971 l 0.032,0.04 c 0.265,0.475 2.537,4.571 4.307,8.558 1.124,2.532 1.767,4.357 2.024,5.746 0.147,0.791 0.19,1.31 -0.004,1.781 -0.081,0.195 -0.235,0.376 -0.385,0.448 -0.14,0.06 -0.28,0.09 -0.44,0.09 z" /><path
               fill="#435125"
               id="use1348"
               d="m 274.08607,445.71112 c 0.18,-0.086 0.218,-0.122 0.347,-0.245 l 0.125,-0.117 c 0.324,-0.297 0.861,-0.822 1.582,-1.643 1.332,-1.513 3.119,-3.728 4.69,-5.685 3.115,-3.883 5.689,-7.228 6.174,-7.858 l 0.793,-1.032 7.767,-2.395 5.671,-2.644 -3.03,-3.406 -10.408,4.456 -7.767,1.594 -14.363,10.564 0.011,0.009 c 0.029,0.024 2.089,1.738 4.136,3.599 0.913,0.83 2.064,1.896 2.877,2.783 0.375,0.408 0.705,0.813 0.93,1.14 0.138,0.201 0.215,0.383 0.252,0.471 l -0.892,-0.555 -0.967,0.752 1.968,0.184 0.09,0.02 z m 53.34,-16.02 c 6.777,-0.001 13.471,-1.874 19.895,-5.567 l 0.007,-0.004 -0.003,-0.008 c 0,0 -0.84,-1.601 -2.878,-3.096 -1.941,-1.425 -5.442,-3.128 -11.1,-3.15 h -0.117 c -6.701,0 -14.901,2.278 -24.373,6.771 0.32,0.212 7.756,5.054 18.566,5.054 l -0.01,0.01 z m 29.37,-6.51 c 1.253,0 2.379,-0.474 3.17,-1.333 0.649,-0.706 1.114,-1.646 1.422,-2.878 0.504,-2.018 0.365,-4.025 0.351,-4.217 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.511,0 -4.49,2.178 -5.338,4.337 -0.481,1.227 -0.574,2.259 -0.274,3.067 0.3,0.81 1.24,1.37 2.34,1.37 z m -51.68,-5.99 c 17.359,-2.479 24.717,-8.755 27.833,-13.583 3.323,-5.149 2.641,-9.912 2.634,-9.96 l -0.003,-0.014 -0.013,-0.004 c -0.005,0 -1.061,-0.285 -2.658,-0.293 -4.618,0 -16.43,2.323 -27.798,23.842 l -0.007,0.014 0.02,-0.01 z m 35.58,-3.44 c 7.416,-0.001 13.062,-1.28 16.782,-3.804 2.138,-1.45 3.184,-3.043 3.686,-4.125 0.47,-1.014 0.577,-1.856 0.594,-2.023 -0.196,-0.09 -3.232,-1.438 -7.765,-1.65 -0.383,-0.018 -0.769,-0.029 -1.174,-0.03 -5.732,0 -14.448,1.87 -23.646,10.78 l -0.009,0.009 0.011,10e-4 c 4.2,0.55 8.08,0.84 11.53,0.84 z m 35.91,-1.38 c 7.82,0 18.563,-2.388 25.263,-9.087 l 0.007,-0.008 -0.02,-0.005 c -0.07,-0.018 -7.342,-1.863 -15.523,-2.062 -0.488,-0.012 -0.979,-0.019 -1.475,-0.019 -7.332,0 -12.944,1.422 -16.682,4.225 -1.305,0.979 -2.018,1.89 -2.178,2.783 -0.134,0.746 0.26,1.55 1.056,2.15 1.683,1.271 4.692,1.949 8.945,2.017 l 0.6,0.02 z m 25.34,-13 c 0.963,0 1.867,-0.426 2.479,-1.167 0.506,-0.614 0.858,-1.416 1.108,-2.522 0.418,-1.848 0.292,-3.656 0.291,-3.674 l -0.001,-0.018 c -0.364,-0.172 -0.771,-0.264 -1.217,-0.275 h -0.003 c -1.157,0 -2.039,0.63 -2.589,1.158 -0.733,0.705 -1.333,1.645 -1.688,2.645 -0.365,1.03 -0.424,1.892 -0.18,2.635 0.2,0.59 0.88,1.21 1.8,1.21 z m -58.53,-1.32 c 1.253,0 2.379,-0.474 3.17,-1.333 0.649,-0.706 1.114,-1.646 1.422,-2.878 0.504,-2.018 0.365,-4.025 0.351,-4.217 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.511,0 -4.49,2.178 -5.338,4.337 -0.481,1.227 -0.574,2.259 -0.274,3.067 0.3,0.82 1.25,1.37 2.34,1.37 z m 28.51,-1.18 c 15.737,-0.554 23.904,-5.027 27.984,-8.683 2.297,-2.058 3.574,-4.098 4.24,-5.447 0.628,-1.274 0.866,-2.249 0.908,-2.438 l -0.021,-0.009 c -0.003,0 -1.489,-0.532 -3.885,-0.579 l -0.368,-0.004 c -5.307,0 -16.111,2.229 -28.852,17.153 v 0.01 z m -17.09,-1.59 c 12.661,-1.928 19.834,-7.363 23.622,-11.585 3.971,-4.425 5.16,-8.546 5.213,-8.738 -0.023,-0.007 -1.57,-0.41 -3.9,-0.469 -0.169,-0.005 -0.345,-0.007 -0.524,-0.007 -0.181,0 -0.365,0.002 -0.553,0.007 -6.368,0.139 -17.934,3.023 -23.855,20.785 h -0.01 z m 65,-6.08 c 4.149,0 8.174,-0.48 11.962,-1.427 6.629,-1.658 9.473,-4.189 10.691,-6.021 0.692,-1.04 0.943,-1.952 1.031,-2.534 0.085,-0.556 0.04,-0.999 0.031,-1.073 l -0.031,-0.011 c -0.017,-0.004 -4.4,-1.235 -10.464,-1.328 -0.239,-0.004 -0.48,-0.006 -0.725,-0.006 -2.927,0 -5.808,0.279 -8.564,0.83 -10.536,2.107 -16,10.06 -16.053,10.14 l -0.005,0.009 0.013,0.003 c 0.06,0.01 5.08,1.42 12.12,1.42 z m -29.39,-10.68 c 1.269,0 2.395,-0.463 3.172,-1.304 0.639,-0.691 1.104,-1.643 1.42,-2.908 0.506,-2.015 0.365,-4.002 0.351,-4.185 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.506,0 -4.488,2.179 -5.339,4.338 -0.468,1.188 -0.55,2.208 -0.243,3.034 0.31,0.84 1.22,1.38 2.31,1.38 z m 22.1,-3.03 c 0.095,-0.023 5.977,-1.536 11.967,-5.225 5.544,-3.413 12.326,-9.45 13.153,-18.83 v -0.005 l -0.014,-0.004 c -10e-4,0 -0.516,-0.125 -1.278,-0.154 -0.105,-0.004 -0.217,-0.006 -0.334,-0.006 -1.656,0 -5.046,0.466 -9.147,3.584 -5.22,3.98 -10.04,10.92 -14.35,20.65 z m -14.43,-0.53 c 0.037,-0.015 4.229,-1.693 9.469,-6.084 4.882,-4.092 11.746,-11.46 16.716,-23.33 -0.003,-0.001 -1.142,-0.608 -2.886,-0.718 -0.101,-0.007 -0.203,-0.009 -0.306,-0.009 -0.15,0 -0.305,0.005 -0.463,0.009 -2.411,0.068 -6.083,1.07 -10.154,5.463 -4.676,5.047 -8.85,13.34 -12.404,24.651 l -0.01,0.032 0.03,-0.01 z m 37.39,-1.09 c 4.821,0 6.471,-2.615 6.957,-3.74 0.798,-1.849 0.556,-3.689 0.554,-3.707 l -0.003,-0.02 c -0.78,-0.195 -1.605,-0.303 -2.398,-0.314 l -0.165,-0.001 c -3.799,0 -6.798,1.929 -8.084,3.841 -0.255,0.379 -1.037,1.694 -0.39,2.721 0.52,0.81 1.7,1.22 3.53,1.22 z m 10.68,-13.47 c 2.692,0 6.811,-0.165 11.141,-0.952 4.294,-0.781 6.728,-4.432 8.013,-7.356 1.399,-3.185 1.794,-6.223 1.798,-6.254 h -0.012 c -13.282,0.39 -19.555,4.271 -22.478,7.457 -3.018,3.29 -3.197,6.706 -3.206,6.922 l 0.009,10e-4 c 0.02,0 1.89,0.18 4.74,0.18 z m -13.83,-13.82 c 0.018,-0.022 1.535,-1.898 3.033,-4.228 1.573,-2.445 3.028,-4.996 3.028,-7.084 0,-2.016 0.474,-6.266 0.757,-8.619 0.358,-2.985 0.72,-5.54 0.75,-5.757 l -0.013,0.004 c -0.337,0.123 -8.308,3.114 -8.308,10.591 0,7.489 0.738,15.014 0.745,15.089 l 10e-4,0.011 h 0.01 z m 10.33,-0.71 c 0.084,0 0.167,-0.008 0.25,-0.021 2.356,-0.393 6.496,-2.194 11.073,-4.818 5.082,-2.914 9.209,-6.036 11.62,-8.791 2.198,-2.512 3.503,-6.457 3.88,-11.726 0.267,-3.739 -0.053,-6.854 -0.087,-7.163 -0.412,-0.137 -0.85,-0.204 -1.315,-0.204 -1.764,0.029 -3.647,0.823 -6.189,2.574 -1.981,1.365 -4.165,3.221 -6.49,5.514 -4.012,3.957 -7.168,7.932 -7.199,7.971 l -0.032,0.04 c -0.265,0.475 -2.537,4.571 -4.307,8.558 -1.124,2.532 -1.767,4.357 -2.024,5.746 -0.147,0.791 -0.19,1.31 0.004,1.781 0.081,0.195 0.235,0.376 0.385,0.448 0.14,0.06 0.28,0.09 0.44,0.09 z" /><path
               fill="#d47600"
               d="m 565.53807,42.937117 -2.355,0.938 -0.923,0.368 -2.854,-0.157 -2.673,1.283 -4.74,3.239 -0.209,0.15 -1.767,0.461 -1.641,-0.708 -0.932,0.424 -0.321,1.92 -0.887,1.379 -1.092,0.767 -3.783,0.387 -3.19,1.645 -4.15,-1.111 -1.928,0.755 -4.099,3.692 -2.095,0.992 -0.732,-0.042 -2.778,-0.143 -1.173,0.384 -1.752,1.693 -3.315,0.258 -1.033,0.715 -1.618,3.26 -1.753,1.808 -1.003,0.212 -1.087,-0.398 -0.817,0.144 -0.37,2.086 -0.793,0.874 -2.219,0.764 -1.773,1.477 -1.556,0.799 -2.084,-0.052 h -0.479 l -2.076,1.146 -3.905,0.342 -1.624,1.549 -0.358,0.331 -0.758,0.458 -1.24,0.74 -0.304,0.184 -1.495,-0.267 -1.75,0.693 -0.708,-1.089 -1.211,0.727 -1.604,0.069 -1.998,-0.889 -1.522,-0.678 -1.113,0.161 -0.387,1.94 -0.039,0.206 -1.17,1.557 -2.184,1.323 -0.297,0.387 -2.485,3.208 -4.722,4.966 -3.993,2.028 -4.139,1.259 -2.897,2.38 -7.599,3.767 -11.994,5.967003 -2.453,0.786 -3.52,0.562 -6.278,2.312 -5.539,1.671 -0.308,0.094 -1.096,0.332 -7.81,2.363 -3.635,-0.384 -2.153,0.782 -5.605,-0.622 -3.897,0.077 -2.467,0.513 -4.637,2.224 -7.827,3.762 -2.586,2.366 -4.027,2.101 -4.715,1.493 0.011,-1.981 -0.028,-0.084 -1.636,0.517 -1.181,0.373 -3.825,0.59 h -2.128 l -1.321,-0.384 -0.204,0.069 -7.818,2.576 -8.719,0.842 -4.363,1.399 -3.26,-0.052 -2.038,0.607 -3.995,0.488 -1.428,-0.381 -0.322,-0.088 -11.75,0.51 -5.372,-0.607 -2.564,0.583 -4.296,-1.445 -6.269,-0.727 -1.465,-0.439 -3.295,-0.978 -1.491,0.859 -1.116,0.119 -2.667,-0.967 -0.96,-0.025 -2.202,0.796 -1.267,-0.325 -1.177,-0.938 -2.761,-0.411 -1.682,-1.414 -9.402,1.246 -2.551,-0.75 -8.554,-2.492 -1.361,0.069 -1.696,1.271 -2.548,0.929 -2.212,0.575 -3.012,0.105 -3.497,-0.918 -3.606,-1.748 -1.333,-0.317 -2.974,0.3 -0.91,0.083 -5.466,-2.932 -7.042,-4.404 -4.778,-2.296 -1.794,-0.291 -0.241,0.853 0.89,2.805 0.303,2.774 -0.091,2.563 -0.049,1.587 0.446,1.425 1.725,1.912 0.719,1.92 0.526,5.284 -0.006,5.362 -0.839,8.551 -0.283,1.302 -1.001,4.43 -0.914,4.069 -3.546,10.833 -0.974,1.343 -2.391,1.631 -5.419,3.688 -3.99,2.301 -1.263,0.523 -3.239,0.245 -2.018,-0.105 -2.513,-1.361 -2.467,-0.635 -3.232,-2.324 -3.595,-0.744 -3.941,-2.278 -1.026,-1.233 -2.146,-0.202 -2.976,-0.893 0.002,-0.005 -1.093,-0.327 -0.755,-0.22 v -0.001 l -3.796,-0.104 -3.54,-1.634 -1.864,-0.45 -2.547,-0.129 -2.666,1.239 -0.001,-0.004 -1.351,0.629 -1.707,-0.678 -1.235,0.077 -1.399,2.115 -0.209,0.328 -0.964,0.51 -1.2,-0.017 -0.939,-0.025 -1.016,0.444 -1.368,0.593 v 0.003 l -1.208,0.527 -0.59,0.255 -0.01,-0.01 -0.363,0.073 -0.645,0.112 -0.8,0.153 -1.41,-0.824 -0.75,-0.442 -1.257,-0.256 -0.677,0.489 -0.133,2.301 -0.618,1.378 -1.961,1.734 -1.993,1.755 -1.389,2.047 -3.676,8.39 -2.303,3.385 -0.715,0.789 -2.408,2.656 -2.136,1.657 -4.922,3.815 -4.659,1.741 -4.013,0.82 -1.951,0.008 -3.695998,-0.492 -3.323,-1.02 -3.65,-2.282 -4.003,-3.217 -5.794,-5.724 -0.82,-0.493 -0.171,-0.114 -1.825,-1.167 -1.354,0.035 -0.53,0.874 -0.29,1.263 -0.245,1.12 -0.664,6.367 0.049,0.369 0.349,2.622 4.401,6.15 1.358,3.267 0.223,0.373 0.908,1.525 0.691,1.163 0.069,0.118 1.504,4.488 -1.057,2.534 0.534,1.697 -1.336,1.037 -0.245,1.465 3.951,4.953 0.862,2.185 -0.963,3.029 -1.536,1.671 -0.429,0.457 0.216,1.28 1.818,1.635 3.089,2.75 1.647,4.086 1.253,1.096 1.456,-0.31 0.81,0.618 1.228,-0.021 1.208,1.208 0.782,0.379 1.236,0.616 0.977,1.272 0.216,3.911 1.821998,4.86 0.028,2.635 0.01,0.374 1.134,1.948 0.356,1.538 -0.604,4.069 1.445,1.306 1.567,-0.32 1.012,0.16 1.626,1.354 1.969,3.001 1.926,-0.282 1.222,0.589 5.902,5.334 1.339,0.676 0.074,0.042 0.963,0.483 1.197,1.208 1.856,-1.232 0.206,-0.021 2.018,-0.178 0.886,0.597 1.704,1.149 2.234,-0.029 4.844,1.485 2.119,0.543 4.261,2.648 1.811,1.12 1.072,0.871 1.424,1.161 2.845,1.224 2.44,0.584 1.322,0.314 0.995,0.384 0.025,-0.062 0.014,0.004 -0.024,0.063 5.284,2.023 2.862,0.668 2.648,0.975 1.927,0.703 1.414,0.023 2,-1.682 1.937,-0.112 1.609,0.401 1.57,-0.263 2.485,-1.531 0.485,-0.719 1.762,-0.839 5.944,-0.738 1.737,0.564 4.46,-1.94 2.988,0.831 2.645,-0.938 5.779,1.284 1.536,1.081 1.717,1.965 0.21,0.009 1.912,0.037 -0.799,1.331 2.523,2.647 2.279,3.445 0.154,0.455 1.657,4.864 1.232,1.723 0.862,2.405 0.042,1.568 -1.34,1.022 -0.22,0.583 -0.076,0.216 0.272,0.655 0.506,-0.276 0.963,-0.533 1.166,-0.181 2.066,0.22 1.364,0.143 2.154,-1.069 1.427,-0.71 2.293,0.987 2.52,-0.028 1.058,0.471 2.995,1.358 1.529,0.144 0.565,-0.371 0.36,-0.856 -0.185,-0.996 -1.145,-1.323 -2.531,-2.938 -1.036,-1.51 -0.789,-2.186 -0.245,-2.794 -0.174,-1.885 0.314,-2.477 0.68,-0.884 0.5,-1.968 h 0.009 l 0.129,-0.515 1.406,-1.866 3.724,-2.393 4,-3.582 3.162,-2.085 3.26,-1.412 0.087,-0.396 0.363,0.146 8.292,-2.819 0.137,-0.016 3.692,-0.643 24.92,1.755 0.924,-0.279 0.004,-0.006 0.83,-2.33 0.447,-0.432 0.297,-0.282 2.74,-1.206 1.281,-0.183 3.556,0.878 1.456,0.359 2.332,-1.307 1.654,0.028 3.417,-1.866 2.111,0.053 0.803,-0.321 4.112,-2.955 3.961,-1.135 1.03,-0.548 0.363,-0.199 4.06,-2.144 2.579,-1.981 2.226,-1.183 2.438,-0.629 6.38,-0.449 1.283,-2.138 2.744,-0.366 1.657,-1.87 1.896,-0.771 1.359,-1.958 1.139,-1.641 1.591,-0.921 5.1,-0.32 6.045,0.749 0.799,-0.485 1.366,-4.875 1.43,-0.915 3.851,-5.612 0.013,-2.045 0.004,-1.708 0.633,-2.432 -0.43,-4.391 0.51,-4.446 2.394,-5.65 2.109,-2.279 3.401,-2.301 1.729,-0.753 2.449,-0.412 v -0.006 l 0.36,-0.061 0.624,-0.107 8.433,-0.116 c 0.117,-0.087 3.067,-0.042 3.067,-0.042 l 2.812,-0.038 7.114,1.266 0.506,0.088 2.405,0.779 2.774,2.157 2.936,2.868 0.551,0.535 1.902,0.801 0.575,0.251 1.571,-0.251 2.237,-1.165 1.688,-1.427 2.301,-1.257 0.056,-0.08 1.295,-1.948 0.039,-0.04 0.028,0.007 0.003,-0.011 -0.022,-0.005 0.511,-0.775 4.447,-1.733 5.23,-0.304 0.588,-0.318 0.327,-0.175 1.382,-1.623 1.295,-0.011 3.135,1.134 2.204,-0.437 1.75,0.699 1.36,-0.161 2.565,-0.304 2.754,1.938 1.605,0.205 5.658,3.31 0.294,0.048 0.152,0.028 0.324,0.053 0.671,-0.199 0.998,-0.289 0.132,-0.039 0.126,0.174 0.643,0.907 0.882,0.126 1.044,-1.393 -0.415,-0.632 -0.157,-0.23 -2.021,-0.411 -1.815,-3.103 1.728,-1.861 -2.711,-3.326 -0.45,-0.551 -0.153,-0.234 -0.937,-1.423 -4.746,-7.235 -6.182,-4.935 -0.002,0.004 -2.165,-1.732 -0.014,-0.01 -0.758,-0.596 -3.302,-3.358 -2.358,-3.13 -0.309,-0.674 -0.487,-1.062 -1.413,-3.078 -2.462,-1.896 -2.006,-2.191 -0.098,-0.129 -4.14,-5.626 -0.68,-0.943 -0.978,-0.565 -2.066,-0.014 -0.195,-0.196 -0.116,-0.121 0.07,-0.074 0.991,-0.985 1.105,-0.278 0.476,-1.089 -2.108,-6.104 -0.014,-0.213 -0.157,-1.95 1.718,-8.855 0.22,-1.079 2.928,-5.958 1.814,-1.486 1.98,-3.892 1.696,-2.488 1.625,-1.582 0.284,-0.168 2.934,-1.776 2.465,-0.347 2.348,-0.331 4.099,1.264 3.901,-0.076 0.761,-0.081 1.77,-0.203 2.911,-0.917 1.374,-0.848 0.713,-1.093 1.487,-4.987 0.478,-1.587 0.917,-1.724 5.306,-6.108 4.011,-3.71 9.019,-6.613 4.415,-2.639 2.254,-1.347 20.126,-8.946003 5.23,-5.302 2.725,-2.757 4.821,-3.235 5.641,-2.311 4.854,-3.842 1.06,-1.334 1.336,-4.303 1.113,-0.269 1.005,-2.174 0.286,-0.618 3.961,-2.792 0.448,-0.223 15.388,-7.71 2.236,0.307 1.197,-1.793 4.477,-0.751 0.824,-0.14 1.104,-0.551 0.939,-1.599 v -0.316 l 0.129,-4.273 0.956,-1.155 0.521,-2.816 0.491,-0.65 0.513,-0.676 1.268,-0.891 -0.22,-0.531 z"
               id="path1350" /></g></clipPath></defs><path
         fill="#007a3d"
         d="M 8.828125,0 C 3.953125,0 0,3.953125 0,8.828125 V 111.00195 H 512.00195 V 8.828125 C 512.00195,3.953125 508.04883,0 503.17383,0 Z"
         id="rect2" /><path
         fill="#ffffff"
         d="M 0,111.00195 V 224.07227 H 512.00195 V 111.00195 Z"
         id="rect4" /><path
         fill="#ce1126"
         d="m 0,224.07227 v 102.54882 c 0,4.875 3.953125,8.82813 8.828125,8.82813 H 503.17188 c 4.87499,0 8.82907,-3.95213 8.83007,-8.82813 V 224.07227 Z"
         id="rect6" /><path
         fill="#000000"
         d="M 3.1601562,2.066406 C 1.2299596,3.685898 0,6.111812 0,8.828125 V 326.62109 c 0,2.61146 1.1406042,4.95197 2.9433594,6.56836 L 131.60156,224.07227 V 111.00195 Z"
         id="path2" /><g
         id="g6"
         transform="translate(0,-88.275391)" /><g
         id="g8"
         transform="translate(0,-88.275391)" /><g
         id="g10"
         transform="translate(0,-88.275391)" /><g
         id="g12"
         transform="translate(0,-88.275391)" /><g
         id="g14"
         transform="translate(0,-88.275391)" /><g
         id="g16"
         transform="translate(0,-88.275391)" /><g
         id="g18"
         transform="translate(0,-88.275391)" /><g
         id="g20"
         transform="translate(0,-88.275391)" /><g
         id="g22"
         transform="translate(0,-88.275391)" /><g
         id="g24"
         transform="translate(0,-88.275391)" /><g
         id="g26"
         transform="translate(0,-88.275391)" /><g
         id="g28"
         transform="translate(0,-88.275391)" /><g
         id="g30"
         transform="translate(0,-88.275391)" /><g
         id="g32"
         transform="translate(0,-88.275391)" /><g
         id="g34"
         transform="translate(0,-88.275391)" />
  </svg>
);

export const KY = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs79" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path6" />
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 383.827,172.219 c 0,0 -3.691,-14.766 -14.766,-22.149 0,0 11.074,18.457 11.074,33.224 z"
       id="path7" />
    	<path
       fill="#ffe15a"
       d="m 366.753,156.183 c 0,0 7.73,4.729 11.882,12.459 l -3.346,7.73 c 0.002,0 -2.767,-10.959 -8.536,-20.189 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 358.217,157.914 c 0,0 13.382,4.153 19.726,12.805 l -3.807,5.768 c 10e-4,0 -5.075,-9.805 -15.919,-18.573 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="m 356.256,164.605 c 0,0 14.074,2.191 20.419,8.883 l -1.615,6.345 c 0,-0.001 -7.729,-9.23 -18.804,-15.228 z"
       id="path10" />
    	<path
       fill="#ffe15a"
       d="m 356.718,169.219 c 0,0 13.612,1.385 19.842,8.536 6.229,7.153 -2.307,4.96 -2.307,4.96 0,0 -7.153,-8.189 -17.535,-13.496 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 383.827,172.219 c 0,0 3.691,-14.766 14.766,-22.149 0,0 -11.074,18.457 -11.074,33.224 z"
       id="path12" />
    	<path
       fill="#ffe15a"
       d="m 400.901,156.183 c 0,0 -7.73,4.729 -11.882,12.459 l 3.346,7.73 c -0.001,0 2.768,-10.959 8.536,-20.189 z"
       id="path13" />
    	<path
       fill="#ffe15a"
       d="m 409.437,157.914 c 0,0 -13.382,4.153 -19.726,12.805 l 3.807,5.768 c -10e-4,0 5.075,-9.805 15.919,-18.573 z"
       id="path14" />
    	<path
       fill="#ffe15a"
       d="m 411.399,164.605 c 0,0 -14.074,2.191 -20.419,8.883 l 1.615,6.345 c 0,-0.001 7.729,-9.23 18.804,-15.228 z"
       id="path15" />
    	<path
       fill="#ffe15a"
       d="m 410.936,169.219 c 0,0 -13.612,1.385 -19.842,8.536 -6.229,7.153 2.307,4.96 2.307,4.96 0,0 7.153,-8.189 17.535,-13.496 z"
       id="path16" />
    	<path
       fill="#ffe15a"
       d="m 383.827,150.069 c 0,0 -3.691,7.767 0,11.651 3.692,-3.883 0,-11.651 0,-11.651 z"
       id="path17" />
    	<path
       fill="#ffe15a"
       d="m 380.149,151.998 c 0,0 -0.495,8.586 4.386,10.794 1.959,-4.988 -4.386,-10.794 -4.386,-10.794 z"
       id="path18" />
    	<path
       fill="#ffe15a"
       d="m 387.505,151.998 c 0,0 0.495,8.586 -4.386,10.794 -1.959,-4.988 4.386,-10.794 4.386,-10.794 z"
       id="path19" />
    	<path
       fill="#ffe15a"
       d="m 388.714,156.95 c 0,0 -3.221,7.975 -8.578,7.884 0.361,-5.346 8.578,-7.884 8.578,-7.884 z"
       id="path20" />
    	<path
       fill="#ffe15a"
       d="m 378.94,156.95 c 0,0 3.221,7.975 8.578,7.884 -0.361,-5.346 -8.578,-7.884 -8.578,-7.884 z"
       id="path21" />
    </g>
    <ellipse
       fill="#ffd255"
       cx="383.82001"
       cy="87.634003"
       rx="11.08"
       ry="14.766"
       id="ellipse21" />
    <g
       id="g25"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 358.525,190.984 -2.538,-3.923 c 0,0 -7.383,1.769 -9.152,-3.768 l -2.846,-0.231 c 0,0 0.384,-3.768 3.691,-4.307 0,0 1.999,-2.461 5.537,-1.999 3.538,0.461 5.384,3.46 7.422,4.23 2.038,0.769 2.269,3.307 2.269,3.307 l 15.535,15.919 c 0,0 -4.46,5.692 -8.46,7.537 -4,1.844 -18.688,-7.152 -11.458,-16.765 z"
       id="path22" />
    	<path
       fill="#73af00"
       d="m 408.976,193.906 c 0,0 6.461,4.384 6.691,16.497 h -10.729 c 0,0 0.116,-8.191 -1.961,-12.574 z"
       id="path23" />
    	<path
       fill="#73af00"
       d="m 407.592,194.368 c 0,0 8.075,2.654 13.036,-3.691 l -8.421,-1.153 z"
       id="path24" />
    	<path
       fill="#73af00"
       d="m 405.169,185.485 8.2,2.764 c 1.034,0.349 1.399,1.629 0.674,2.445 -3.111,3.505 -12.397,11.903 -27.37,11.903 -19.496,0 -24.533,-12.267 -24.764,-13.189 -0.231,-0.922 -1.269,-8.421 -1.269,-8.421 l 8.306,-0.922 z"
       id="path25" />
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="335.837,319.88 324.763,305.113 325.439,298.429 346.912,298.429 "
       id="polygon25" />
    	<polygon
       fill="#ff4b55"
       points="431.817,319.88 442.891,305.113 442.215,298.429 420.743,298.429 "
       id="polygon26" />
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffd25a"
       d="m 325.35,334.646 c -10.593,0 -18.699,-5.685 -19.117,-5.981 l 8.536,-12.052 c 0.071,0.046 7.223,4.906 14.516,2.697 7.38,-2.228 12.225,-10.937 14.991,-17.856 l 13.71,5.486 c -5.816,14.542 -14.112,23.479 -24.651,26.569 -2.756,0.809 -5.443,1.137 -7.985,1.137 z"
       id="path26" />
    	<path
       fill="#ffd25a"
       d="m 442.304,334.646 c 10.593,0 18.699,-5.685 19.117,-5.981 l -8.536,-12.052 c -0.071,0.046 -7.223,4.906 -14.516,2.697 -7.38,-2.228 -12.225,-10.937 -14.991,-17.856 l -13.71,5.486 c 5.816,14.542 14.112,23.479 24.651,26.569 2.756,0.809 5.444,1.137 7.985,1.137 z"
       id="path27" />
    </g>
    <path
       fill="#ff4b55"
       d="m 431.817,168.847 h -95.98 v -35.47 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 78.325 c 4.875,0 8.828,3.953 8.828,8.828 v 35.47 z"
       id="path28" />
    <g
       id="g31"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 362.024,238.666 -1.153,-7.383 c -5.422,-0.231 -8.536,-6.575 -8.536,-6.575 l -4.384,2.422 c 4.613,11.075 14.073,11.536 14.073,11.536 z"
       id="path29" />
    	<path
       fill="#ffe15a"
       d="m 419.819,231.052 c 1.615,-1.23 5.153,-1.692 5.153,-1.692 -2.538,-2.615 -5.306,-0.769 -5.306,-0.769 2.307,-2.153 1,-5.229 1,-5.229 0,1 -1.615,1.692 -1.615,1.692 0.077,-1.999 -1.999,-3.923 -1.999,-3.923 l -1.077,1.769 c -0.692,-1.692 -3.153,-2.999 -3.153,-2.999 l -1,4.153 c -2.307,-1.999 -6.383,-1.846 -6.383,-1.846 l 0.769,1.923 c -2.461,0.076 -9.152,1.461 -13.075,1.922 -3.923,0.461 -7.075,-0.615 -7.075,-2.383 0,-1.482 3.428,-1.665 4.911,-1.687 1.049,0.234 2.368,0.612 4.222,1.169 3.46,1.038 5.487,-0.466 5.487,-0.466 -1.212,-0.461 -1.346,-1 -1.346,-1 2.595,-1.5 5.03,-1.13 5.03,-1.13 -0.865,-1.903 -4.615,-1.788 -4.615,-1.788 0.981,-0.519 1.73,-2.134 1.73,-2.134 -0.231,0.231 -2.362,0.754 -5.272,1.144 -2.19,0.295 -4.247,1.96 -5.097,2.73 -2.309,-0.177 -8.342,-0.25 -7.281,3.933 1.308,5.153 11.69,3.307 18.073,2.307 6.383,-1 9.69,-0.153 11.074,0.692 1.385,0.846 -0.589,3.712 -7.075,2.538 -5.605,-1.014 -8.692,-1.043 -10.387,-0.865 -1.879,0.12 -3.481,0.626 -4.61,0.865 -2.538,0.538 -12.306,3.999 -14.151,-1 -1.846,-5 -10.844,8.152 -10.844,8.152 l 0.703,0.836 -2.395,-0.567 c -3.23,4.326 -12.92,5.653 -12.92,5.653 0,0 -1.442,-2.595 -2.654,-2.942 -1.212,-0.346 -1.73,1.557 -1.73,1.557 0,0 -1.442,0.057 -1.557,1.385 -0.116,1.326 1.038,1.442 1.038,1.442 0,0 -1.385,2.019 0.922,2.595 0,0 -0.173,2.826 3.23,0.865 10.11,1.274 17.482,-3.917 20.674,-6.749 2.087,0.134 5.339,0.067 7.839,-1.23 3.999,-2.077 8.613,-4.692 11.305,-3.691 0,0 2.154,6.614 -6.306,6.767 0,0 -1.251,-1.582 -2.51,-1.582 -0.543,0 -1.108,0.652 -0.934,1.238 0,0 -1.476,-0.087 -1.737,0.782 -0.213,0.708 0.303,1.519 1.389,1.389 0,0 -0.738,1.086 0,1.737 0.738,0.651 1.651,0 1.651,0 0,0 -0.391,1.346 0.521,1.476 0.78,0.111 1.813,-1.163 2.109,-1.55 1.354,0.211 10.591,1.276 12.586,-8.413 0,0 4.615,1.999 9.152,1.615 4.537,-0.384 8.999,0.308 8.614,2.538 -0.503,1.617 -1.495,1.51 -1.495,1.51 -1.086,-0.435 -2.91,-0.391 -3.17,1.173 -0.26,1.564 1.867,1.607 1.867,1.607 0.608,1.433 2.345,0.825 2.345,0.825 1.519,1.086 2.519,-0.087 2.519,-0.087 0.652,0.565 1.324,0.67 1.954,0.13 0.608,-0.521 0.267,-3.996 0.209,-5.236 -0.096,-2.063 -0.385,-7.459 -3.384,-7.537 -2.999,-0.077 -6.845,1.692 -12.151,-2.769 -0.277,-0.233 -0.547,-0.381 -0.821,-0.579 2.511,0.233 4.31,0.914 6.051,1.194 2.385,0.386 9.384,-0.229 10.998,-1.46 z"
       id="path30" />
    	<path
       fill="#ffe15a"
       d="m 347.95,227.131 c 0,0 -1.471,0.04 -2.191,-0.173 -1.235,-0.364 -1.385,-2.307 -0.057,-2.654 0,0 -1.597,-1.085 -0.865,-2.307 0.586,-0.978 2.079,-0.975 2.598,-0.398 0,0 -0.487,-1.609 0.921,-2.14 1.12,-0.423 2.019,0.865 2.019,2.538 0,0 1.674,-1.362 2.538,-0.461 0.602,0.628 0.429,1.453 -0.577,3.172 -1.028,1.754 -4.386,2.423 -4.386,2.423 z"
       id="path31" />
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 346.13,226.419 c 0,0 -0.781,1.346 -3.04,0.521 0,0 1.954,-0.913 2.215,-1.694 z"
       id="path32" />
    	<path
       fill="#41479b"
       d="m 345.305,222.466 c 0,0 -1.216,-0.781 -2.562,-0.738 0,0 1.997,-1.476 3.691,-0.173 z"
       id="path33" />
    	<path
       fill="#41479b"
       d="m 348.128,220.382 c 0,0 0.391,-1.433 -0.391,-2.215 0,0 1.607,0.695 1.824,1.997 z"
       id="path34" />
    	<path
       fill="#41479b"
       d="m 351.689,221.858 c 0,0 0.781,-1.737 0.087,-2.562 0,0 2.084,1.216 1.216,3.214 z"
       id="path35" />
    	<path
       fill="#41479b"
       d="m 347.62,241.161 c 0,0 -0.836,-1.711 -1.914,-1.705 0,0 2.268,-0.825 3.249,1.12 z"
       id="path36" />
    	<path
       fill="#41479b"
       d="m 345.792,243.34 c 0,0 -1.491,-1.186 -2.462,-0.716 0,0 1.693,-1.72 3.414,-0.386 z"
       id="path37" />
    	<path
       fill="#41479b"
       d="m 346.84,246.417 c 0,0 -1.905,-0.021 -2.383,0.946 0,0 0.28,-2.397 2.458,-2.4 z"
       id="path38" />
    	<path
       fill="#41479b"
       d="m 348.581,248.395 c 0,0 -0.781,1.346 -3.04,0.521 0,0 1.954,-0.913 2.215,-1.694 z"
       id="path39" />
    	<path
       fill="#41479b"
       d="m 382.908,247.711 c 0,0 -0.64,1.102 -2.49,0.427 0,0 1.502,-0.536 1.715,-1.177 z"
       id="path40" />
    </g>
    <path
       fill="#ffd255"
       d="m 363.371,135.624 c 0,0 -4.154,7.075 -3.155,17.304 0,0 12.247,-1.788 17.554,-14.016 0,0 1.293,-0.523 1.798,-1.779 0.429,-1.068 0.394,-2.827 -1.663,-2.817 0,0 0.616,-1.23 1.365,-1.519 0,0 -1.326,-0.519 -2.884,-0.173 0,0 1.212,-1.212 1.212,-2.769 0,0 -1.846,1.212 -2.999,1.326 0,0 -0.116,-1.903 0.346,-2.134 0,0 -2.422,0.231 -3.634,1.5 0,0 -0.808,-1.096 -0.75,-2.25 0,0 -2.25,0.981 -3.115,2.422 0,0 -0.692,-0.75 -0.634,-1.5 0,0 -1.615,1.961 -1.961,2.999 0,0 -1.522,-0.418 -2.191,0.808 -0.485,0.886 -0.374,1.859 0.711,2.598 z"
       id="path41" />
    <g
       id="g48"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 381.062,242.56 c 0,0 -0.492,-0.927 -1.969,-1.129 0,0 1.882,-0.868 3.069,0.376 z"
       id="path42" />
    	<path
       fill="#41479b"
       d="m 411.594,246.078 c 0,0 -1.079,0.341 -1.585,1.867 0,0 -0.553,-2.167 1.001,-3.182 z"
       id="path43" />
    	<path
       fill="#41479b"
       d="m 413.858,246.874 c 0,0 -1.022,0.993 -0.973,2.601 0,0 -1.261,-1.846 -0.149,-3.332 z"
       id="path44" />
    	<path
       fill="#41479b"
       d="m 418.744,246.787 c 0,0 -0.309,1.052 0.625,2.174 0,0 -1.933,-0.615 -1.97,-2.298 z"
       id="path45" />
    	<path
       fill="#41479b"
       d="m 416.448,247.197 c 0,0 -0.82,0.78 -0.602,2.374 0,0 -1.525,-1.34 -0.575,-2.934 z"
       id="path46" />
    	<path
       fill="#41479b"
       d="m 379.488,244.457 c 0,0 -0.988,-0.354 -2.216,0.49 0,0 0.807,-1.909 2.522,-1.788 z"
       id="path47" />
    	<path
       fill="#41479b"
       d="m 380.838,246.558 c 0,0 -1.015,-0.266 -2.165,0.682 0,0 0.177,-1.842 1.897,-1.87 z"
       id="path48" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 431.817,174.797 c -8.005,0 -8.005,7.221 -16.011,7.221 -8.005,0 -8.005,-7.221 -16.011,-7.221 -8,0 -8,7.221 -16,7.221 -7.993,0 -7.993,-7.221 -15.986,-7.221 -7.993,0 -7.992,7.221 -15.983,7.221 -7.994,0 -7.994,-7.221 -15.989,-7.221 v -13.332 c 7.994,0 7.994,7.221 15.989,7.221 7.992,0 7.992,-7.221 15.983,-7.221 7.993,0 7.993,7.221 15.986,7.221 8,0 8,-7.221 16,-7.221 8.006,0 8.006,7.221 16.011,7.221 8.006,0 8.006,-7.221 16.011,-7.221 z"
       id="path49" />
    <path
       fill="#41479b"
       d="m 415.806,182.018 c -8.005,0 -8.005,-7.221 -16.011,-7.221 -8,0 -8,7.221 -16,7.221 -7.993,0 -7.993,-7.221 -15.986,-7.221 -7.993,0 -7.992,7.221 -15.983,7.221 -7.978,0 -8,-7.186 -15.944,-7.217 0.11,3.192 0.477,7.93 1.412,13.497 6.494,0.86 7.085,7.051 14.531,7.051 7.992,0 7.992,-7.222 15.983,-7.222 7.993,0 7.993,7.222 15.986,7.222 8,0 8,-7.222 16,-7.222 8.005,0 8.005,7.222 16.011,7.222 7.457,0 8.05,-6.193 14.553,-7.051 0.936,-5.567 1.302,-10.305 1.412,-13.497 -7.953,0.031 -7.975,7.217 -15.964,7.217 z"
       id="path50" />
    <path
       fill="#f5f5f5"
       d="m 415.806,195.35 c -8.005,0 -8.005,-7.222 -16.011,-7.222 -8,0 -8,7.222 -16,7.222 -7.993,0 -7.993,-7.222 -15.986,-7.222 -7.993,0 -7.992,7.222 -15.983,7.222 -7.446,0 -8.038,-6.191 -14.531,-7.051 0.742,4.412 1.848,9.331 3.479,14.418 3.599,2.066 5.166,5.965 11.052,5.965 7.992,0 7.992,-7.221 15.983,-7.221 7.993,0 7.993,7.221 15.986,7.221 8,0 8,-7.221 16,-7.221 8.005,0 8.005,7.221 16.011,7.221 5.899,0 7.465,-3.907 11.076,-5.971 1.63,-5.085 2.735,-10.003 3.478,-14.412 -6.504,0.859 -7.097,7.051 -14.554,7.051 z"
       id="path51" />
    <path
       fill="#41479b"
       d="m 415.806,208.682 c -8.005,0 -8.005,-7.221 -16.011,-7.221 -8,0 -8,7.221 -16,7.221 -7.993,0 -7.993,-7.221 -15.986,-7.221 -7.993,0 -7.992,7.221 -15.983,7.221 -5.885,0 -7.453,-3.9 -11.052,-5.965 2.031,6.338 4.884,12.911 8.866,19.041 0.671,0.138 1.363,0.256 2.186,0.256 7.992,0 7.992,-7.222 15.983,-7.222 7.993,0 7.993,7.222 15.986,7.222 8,0 8,-7.222 16,-7.222 8.005,0 8.005,7.222 16.011,7.222 0.832,0 1.533,-0.118 2.21,-0.258 3.982,-6.132 6.835,-12.706 8.866,-19.044 -3.61,2.062 -5.177,5.97 -11.076,5.97 z"
       id="path52" />
    <path
       fill="#f5f5f5"
       d="m 415.806,222.014 c -8.005,0 -8.005,-7.222 -16.011,-7.222 -8,0 -8,7.222 -16,7.222 -7.993,0 -7.993,-7.222 -15.986,-7.222 -7.993,0 -7.992,7.222 -15.983,7.222 -0.823,0 -1.515,-0.118 -2.186,-0.256 2.53,3.895 5.526,7.599 9.054,10.951 2.444,-2.065 4.386,-4.585 9.116,-4.585 7.993,0 7.993,7.221 15.986,7.221 8,0 8,-7.221 16,-7.221 4.749,0 6.691,2.532 9.149,4.6 3.535,-3.357 6.537,-7.066 9.071,-10.968 -0.677,0.139 -1.378,0.258 -2.21,0.258 z"
       id="path53" />
    <path
       fill="#41479b"
       d="m 408.944,232.724 c -2.457,-2.068 -4.399,-4.6 -9.149,-4.6 -8,0 -8,7.221 -16,7.221 -7.993,0 -7.993,-7.221 -15.986,-7.221 -4.73,0 -6.671,2.52 -9.116,4.585 6.43,6.11 14.628,11.034 25.133,13.661 10.497,-2.624 18.69,-7.542 25.118,-13.646 z"
       id="path54" />
    <g
       id="g56"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 399.795,249.741 c -8,0 -8,7.221 -16,7.221 -7.993,0 -7.993,-7.221 -15.986,-7.221 -7.993,0 -7.992,7.221 -15.983,7.221 -7.994,0 -7.994,-7.221 -15.989,-7.221 0,4.555 0,8.511 0,11.074 0,0.625 0.014,1.395 0.044,2.262 7.944,0.031 7.967,7.217 15.944,7.217 7.992,0 7.992,-7.221 15.983,-7.221 7.993,0 7.993,7.221 15.986,7.221 8,0 8,-7.221 16,-7.221 8.006,0 8.006,7.221 16.011,7.221 7.989,0 8.011,-7.186 15.967,-7.217 0.03,-0.868 0.044,-1.638 0.044,-2.262 0,-2.563 0,-6.52 0,-11.074 -8.006,0 -8.006,7.221 -16.011,7.221 -8.004,0 -8.004,-7.221 -16.01,-7.221 z"
       id="path55" />
    	<path
       fill="#f5f5f5"
       d="m 428.126,212.825 c 2.039,0 3.691,1.653 3.691,3.691 v 33.224 7.383 c 0,1.399 0,2.678 0,3.691 0,0.625 -0.014,1.395 -0.044,2.262 -0.11,3.192 -0.477,7.93 -1.412,13.497 -0.742,4.409 -1.848,9.327 -3.478,14.412 -2.031,6.339 -4.884,12.914 -8.866,19.044 -2.535,3.903 -5.537,7.613 -9.071,10.968 -6.428,6.103 -14.621,11.022 -25.117,13.646 -10.505,-2.626 -18.703,-7.551 -25.133,-13.661 -3.528,-3.352 -6.524,-7.055 -9.054,-10.951 -3.982,-6.131 -6.835,-12.703 -8.866,-19.041 -1.631,-5.087 -2.738,-10.007 -3.479,-14.418 -0.936,-5.567 -1.302,-10.305 -1.412,-13.497 -0.03,-0.868 -0.044,-1.638 -0.044,-2.262 0,-1.013 0,-2.293 0,-3.691 v -7.383 -33.224 c 0,-2.039 1.653,-3.691 3.691,-3.691 h 88.596 m -0.002,-2.767 h -88.597 c -3.562,0 -6.461,2.898 -6.461,6.461 v 33.224 7.383 3.691 c 0,0.651 0.014,1.453 0.046,2.358 0.105,3.013 0.441,7.863 1.449,13.86 0.858,5.106 2.061,10.086 3.573,14.804 2.34,7.299 5.429,13.929 9.181,19.704 2.763,4.253 5.949,8.106 9.468,11.45 7.342,6.977 16.214,11.801 26.369,14.34 l 0.672,0.168 0.671,-0.168 c 10.147,-2.537 19.013,-7.357 26.353,-14.325 3.528,-3.349 6.72,-7.208 9.487,-11.468 3.753,-5.777 6.841,-12.407 9.181,-19.709 1.512,-4.714 2.713,-9.693 3.572,-14.797 1.009,-5.997 1.345,-10.848 1.449,-13.86 0.031,-0.905 0.046,-1.707 0.046,-2.358 v -3.691 -7.383 -33.224 c 0.001,-3.562 -2.897,-6.46 -6.459,-6.46 z"
       id="path56" />
    </g>
    <polygon
       fill="#73af00"
       points="377.271,307.557 367.438,300.103 379.774,299.852 383.827,288.194 387.88,299.852 400.216,300.103 390.384,307.557 393.958,319.37 383.827,312.322 373.697,319.37 "
       id="polygon56"
       transform="translate(0,-88.276)" />
    <path
       fill="#ffe15a"
       d="m 383.827,202.197 3.517,10.115 10.708,0.218 -8.535,6.471 3.102,10.251 -8.791,-6.118 -8.791,6.118 3.102,-10.251 -8.534,-6.47 10.708,-0.218 3.514,-10.116 m 0,-4.555 -1.412,4.064 -3.175,9.133 -9.667,0.198 -4.301,0.087 3.428,2.6 7.704,5.842 -2.799,9.255 -1.246,4.118 3.532,-2.457 7.936,-5.523 7.936,5.523 3.532,2.457 -1.246,-4.118 -2.799,-9.255 7.704,-5.842 3.428,-2.6 -4.301,-0.087 -9.667,-0.198 -3.175,-9.133 z"
       id="path57" />
    <polygon
       fill="#73af00"
       points="355.024,278.764 345.19,271.309 357.528,271.059 361.58,259.401 365.632,271.059 377.97,271.309 368.136,278.764 371.71,290.576 361.58,283.529 351.45,290.576 "
       id="polygon57"
       transform="translate(0,-88.276)" />
    <path
       fill="#ffe15a"
       d="m 361.58,173.402 3.517,10.115 10.708,0.218 -8.534,6.47 3.102,10.251 -8.791,-6.118 -8.791,6.118 3.102,-10.251 -8.534,-6.47 10.708,-0.218 3.513,-10.115 m 0,-4.555 -1.412,4.064 -3.175,9.133 -9.667,0.198 -4.301,0.087 3.428,2.6 7.704,5.842 -2.799,9.255 -1.246,4.118 3.532,-2.457 7.936,-5.523 7.936,5.523 3.532,2.457 -1.246,-4.118 -2.799,-9.255 7.704,-5.842 3.428,-2.6 -4.301,-0.087 -9.667,-0.198 -3.175,-9.133 z"
       id="path58" />
    <polygon
       fill="#73af00"
       points="399.322,278.764 389.489,271.309 401.825,271.059 405.878,259.401 409.931,271.059 422.268,271.309 412.435,278.764 416.008,290.576 405.878,283.529 395.749,290.576 "
       id="polygon58"
       transform="translate(0,-88.276)" />
    <g
       id="g60"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 405.878,261.678 3.517,10.115 10.707,0.218 -8.534,6.47 3.102,10.251 -8.791,-6.118 -8.791,6.118 3.102,-10.251 -8.534,-6.47 10.708,-0.218 3.514,-10.115 m 0,-4.555 -1.412,4.064 -3.175,9.133 -9.667,0.198 -4.301,0.087 3.428,2.6 7.704,5.842 -2.799,9.255 -1.246,4.118 3.532,-2.457 7.936,-5.523 7.936,5.523 3.532,2.457 -1.246,-4.118 -2.799,-9.255 7.704,-5.842 3.428,-2.6 -4.301,-0.087 -9.667,-0.198 -3.175,-9.133 z"
       id="path59" />
    	<path
       fill="#ffe15a"
       d="m 442.215,298.429 c -9.161,23.326 -31.85,39.908 -58.388,39.908 -26.538,0 -49.227,-16.583 -58.388,-39.908 l -13.738,5.375 c 11.317,28.814 39.344,49.3 72.126,49.3 32.782,0 60.809,-20.485 72.126,-49.3 z"
       id="path60" />
    </g>
    <g
       id="g62"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#f5f5f5"
       points="376.444,201.751 387.519,201.751 391.21,212.825 380.136,212.825 "
       id="polygon60" />
    	<path
       fill="#f5f5f5"
       d="m 409.668,212.825 h -7.383 l -2.461,-7.383 h 3.37 c 2.397,0 4.524,1.534 5.282,3.807 z"
       id="path61" />
    	<path
       fill="#f5f5f5"
       d="m 369.061,212.825 h -7.383 l -0.842,-2.525 c -0.797,-2.39 0.982,-4.858 3.502,-4.858 h 2.261 z"
       id="path62" />
    </g>
    <g
       id="g64"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="M 402.284,212.825 H 391.21 l -3.691,-11.074 h 8.414 c 1.589,0 2.999,1.016 3.502,2.525 z"
       id="path63" />
    	<path
       fill="#41479b"
       d="m 380.136,212.825 h -11.074 l -2.494,-7.48 c -0.589,-1.768 0.727,-3.594 2.591,-3.594 h 7.286 z"
       id="path64" />
    </g>
    <path
       fill="#509664"
       d="m 410.936,98.94 c -2.884,4.153 -10.959,9.113 -24.11,9.113 -10.836,0 -17.805,-6.543 -20.132,-9.123 -0.567,-0.628 -0.863,-1.431 -0.863,-2.278 v -2.518 c 0,-1.084 0.562,-2.07 1.498,-2.614 2.344,-1.364 7.762,-3.54 18.458,-3.54 13.268,0 25.149,10.96 25.149,10.96 z"
       id="path65" />
    <g
       id="g65"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g66"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g67"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g68"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g69"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g70"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g71"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g72"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g73"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g74"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g75"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g76"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g77"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g78"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g79"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const KZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs50" />
    <path
       fill="#82c3d2"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.952 0,8.827 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.827 C 512,3.952 508.047,0 503.172,0 Z"
       id="path1" />
    <g
       id="g35"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 59.516,128.447 c -0.799,-3.383 -0.998,-4.63 0.52,-6.147 0.74,-0.74 0.74,-1.939 0,-2.679 -0.74,-0.74 -1.939,-0.74 -2.679,0 -3.072,3.073 -2.339,6.262 -1.544,9.639 -2.422,-0.791 -4.934,-0.204 -6.28,1.494 -0.668,0.847 -1.96,3.223 0.461,7.017 0.563,0.881 1.727,1.14 2.616,0.582 0.883,-0.563 1.14,-1.736 0.577,-2.616 -0.908,-1.429 -0.935,-2.31 -0.681,-2.632 0.3,-0.381 1.23,-0.582 2.204,-0.237 0.629,0.218 2.091,0.973 2.091,3.253 0,1.821 -0.842,3.49 -2.31,4.574 -1.471,1.088 -3.375,1.395 -5.21,0.825 -2.266,-0.692 -3.849,-3.079 -3.849,-5.806 0,-1.951 0.418,-3.923 1.186,-5.651 0.122,-0.255 3.018,-6.254 3.764,-8.49 1.475,-4.423 -0.024,-6.647 -1.047,-7.576 -1.369,-1.247 -3.37,-1.558 -5.092,-0.803 -0.262,0.116 -0.478,0.284 -0.705,0.44 -0.227,-0.157 -0.444,-0.324 -0.705,-0.44 -1.721,-0.755 -3.721,-0.444 -5.092,0.803 -1.023,0.929 -2.522,3.154 -1.047,7.576 0.746,2.236 3.641,8.235 3.737,8.435 0.793,1.784 1.212,3.756 1.212,5.707 0,2.728 -1.582,5.114 -3.849,5.806 -1.842,0.569 -3.74,0.266 -5.21,-0.825 -1.468,-1.085 -2.31,-2.753 -2.31,-4.574 0,-2.28 1.462,-3.034 2.091,-3.253 0.977,-0.344 1.902,-0.145 2.204,0.237 0.254,0.322 0.227,1.203 -0.681,2.632 -0.563,0.881 -0.306,2.054 0.577,2.616 0.89,0.563 2.058,0.3 2.616,-0.582 2.42,-3.794 1.129,-6.169 0.461,-7.017 -1.347,-1.698 -3.858,-2.285 -6.28,-1.494 0.796,-3.375 1.528,-6.566 -1.544,-9.639 -0.74,-0.74 -1.939,-0.74 -2.679,0 -0.74,0.74 -0.74,1.939 0,2.679 1.517,1.517 1.32,2.764 0.52,6.147 -0.48,2.027 -1.076,4.555 -1.076,7.671 0,2.073 0.729,4.056 1.955,5.685 h -0.061 c -1.047,0 -1.895,0.847 -1.895,1.895 0,1.047 0.847,1.895 1.895,1.895 h 0.061 c -1.226,1.629 -1.955,3.611 -1.955,5.684 0,3.116 0.596,5.644 1.075,7.672 0.799,3.383 0.998,4.63 -0.52,6.147 -0.74,0.74 -0.74,1.939 0,2.679 0.37,0.37 0.855,0.555 1.34,0.555 0.484,0 0.97,-0.185 1.34,-0.555 3.072,-3.073 2.339,-6.263 1.544,-9.639 2.422,0.788 4.934,0.204 6.28,-1.494 0.668,-0.847 1.96,-3.223 -0.461,-7.017 -0.561,-0.881 -1.732,-1.143 -2.616,-0.582 -0.883,0.563 -1.14,1.736 -0.577,2.616 0.908,1.429 0.935,2.31 0.681,2.632 -0.301,0.377 -1.227,0.577 -2.204,0.237 -0.629,-0.218 -2.091,-0.973 -2.091,-3.253 0,-1.821 0.842,-3.49 2.31,-4.574 1.471,-1.088 3.373,-1.399 5.21,-0.825 2.266,0.692 3.849,3.079 3.849,5.806 0,1.951 -0.418,3.923 -1.212,5.707 L 28.02,185.311 c -1.02,2.294 -1.538,4.734 -1.538,7.246 0,3.233 1.47,6.185 3.784,7.987 -2.313,1.802 -3.784,4.754 -3.784,7.987 0,2.513 0.519,4.952 1.538,7.246 l 12.409,27.919 c 0.793,1.784 1.212,3.756 1.212,5.707 0,2.728 -1.582,5.114 -3.849,5.806 -1.842,0.574 -3.74,0.266 -5.21,-0.825 -1.468,-1.085 -2.31,-2.753 -2.31,-4.574 0,-2.28 1.462,-3.034 2.091,-3.253 0.977,-0.341 1.902,-0.145 2.204,0.237 0.254,0.322 0.227,1.203 -0.681,2.632 -0.563,0.881 -0.306,2.054 0.577,2.616 0.89,0.563 2.058,0.303 2.616,-0.582 2.42,-3.794 1.129,-6.169 0.461,-7.017 -1.347,-1.698 -3.858,-2.283 -6.28,-1.494 0.796,-3.375 1.528,-6.566 -1.544,-9.639 -0.74,-0.74 -1.939,-0.74 -2.679,0 -0.74,0.74 -0.74,1.939 0,2.679 1.517,1.517 1.32,2.764 0.52,6.147 -0.479,2.028 -1.075,4.556 -1.075,7.672 0,2.073 0.729,4.056 1.955,5.685 h -0.061 c -1.047,0 -1.895,0.847 -1.895,1.895 0,1.048 0.847,1.895 1.895,1.895 h 0.061 c -1.227,1.629 -1.955,3.611 -1.955,5.685 0,3.116 0.596,5.644 1.075,7.672 0.799,3.383 0.998,4.63 -0.52,6.147 -0.74,0.74 -0.74,1.939 0,2.679 0.37,0.37 0.855,0.555 1.34,0.555 0.484,0 0.97,-0.185 1.34,-0.555 3.072,-3.073 2.339,-6.263 1.544,-9.639 2.422,0.788 4.934,0.204 6.28,-1.494 0.668,-0.847 1.96,-3.223 -0.461,-7.017 -0.561,-0.881 -1.732,-1.143 -2.616,-0.582 -0.883,0.563 -1.14,1.736 -0.577,2.616 0.908,1.429 0.935,2.31 0.681,2.632 -0.301,0.381 -1.227,0.582 -2.204,0.237 -0.629,-0.218 -2.091,-0.973 -2.091,-3.253 0,-1.821 0.842,-3.49 2.31,-4.574 1.471,-1.088 3.373,-1.399 5.21,-0.825 2.266,0.692 3.849,3.079 3.849,5.806 0,1.951 -0.418,3.923 -1.212,5.707 l -12.41,27.924 c -1.02,2.294 -1.538,4.734 -1.538,7.246 0,3.233 1.47,6.185 3.784,7.987 -2.313,1.802 -3.784,4.754 -3.784,7.987 0,2.513 0.519,4.952 1.538,7.246 l 12.409,27.919 c 0.793,1.784 1.212,3.756 1.212,5.707 0,2.728 -1.582,5.114 -3.849,5.806 -1.842,0.574 -3.74,0.263 -5.21,-0.825 -1.468,-1.085 -2.31,-2.753 -2.31,-4.574 0,-2.28 1.462,-3.034 2.091,-3.253 0.977,-0.341 1.902,-0.145 2.204,0.237 0.254,0.322 0.227,1.203 -0.681,2.632 -0.563,0.881 -0.306,2.053 0.577,2.616 0.89,0.563 2.058,0.303 2.616,-0.582 2.42,-3.794 1.129,-6.169 0.461,-7.017 -1.347,-1.703 -3.858,-2.285 -6.28,-1.494 0.796,-3.375 1.528,-6.566 -1.544,-9.639 -0.74,-0.74 -1.939,-0.74 -2.679,0 -0.74,0.74 -0.74,1.939 0,2.679 1.517,1.517 1.32,2.764 0.52,6.147 -0.479,2.028 -1.075,4.555 -1.075,7.671 0,2.97 1.423,5.798 3.802,7.58 -2.379,1.782 -3.802,4.61 -3.802,7.58 0,3.116 0.596,5.644 1.075,7.672 0.799,3.382 0.998,4.63 -0.52,6.147 -0.74,0.74 -0.74,1.939 0,2.679 0.37,0.37 0.855,0.555 1.34,0.555 0.484,0 0.97,-0.185 1.34,-0.555 3.072,-3.073 2.339,-6.263 1.544,-9.639 2.422,0.788 4.934,0.204 6.28,-1.494 0.668,-0.847 1.96,-3.223 -0.461,-7.017 -0.561,-0.881 -1.732,-1.14 -2.616,-0.582 -0.883,0.563 -1.14,1.736 -0.577,2.616 0.908,1.429 0.935,2.31 0.681,2.632 -0.301,0.381 -1.227,0.577 -2.204,0.237 -0.629,-0.218 -2.091,-0.973 -2.091,-3.253 0,-1.821 0.842,-3.49 2.31,-4.574 1.471,-1.088 3.373,-1.395 5.21,-0.825 2.266,0.692 3.849,3.079 3.849,5.806 0,1.951 -0.418,3.923 -1.186,5.651 -0.122,0.255 -3.018,6.254 -3.764,8.49 -1.475,4.423 0.024,6.647 1.047,7.576 0.875,0.796 2.002,1.214 3.154,1.214 0.653,0 1.315,-0.137 1.939,-0.41 0.262,-0.116 0.478,-0.284 0.705,-0.44 0.227,0.157 0.444,0.324 0.705,0.44 0.623,0.274 1.286,0.41 1.939,0.41 1.149,0 2.278,-0.418 3.154,-1.214 1.023,-0.929 2.522,-3.154 1.047,-7.576 -0.746,-2.236 -3.641,-8.235 -3.737,-8.435 -0.793,-1.784 -1.212,-3.756 -1.212,-5.707 0,-2.728 1.582,-5.115 3.849,-5.806 1.843,-0.57 3.74,-0.263 5.21,0.825 1.468,1.085 2.31,2.753 2.31,4.574 0,2.28 -1.462,3.034 -2.091,3.253 -0.973,0.341 -1.905,0.145 -2.204,-0.237 -0.254,-0.322 -0.227,-1.203 0.681,-2.632 0.563,-0.881 0.306,-2.053 -0.577,-2.616 -0.885,-0.555 -2.052,-0.296 -2.616,0.582 -2.42,3.794 -1.129,6.169 -0.461,7.017 1.347,1.698 3.858,2.283 6.28,1.494 -0.796,3.375 -1.528,6.566 1.544,9.639 0.37,0.37 0.855,0.555 1.34,0.555 0.485,0 0.97,-0.185 1.34,-0.555 0.74,-0.74 0.74,-1.939 0,-2.679 -1.517,-1.517 -1.32,-2.764 -0.52,-6.147 0.479,-2.028 1.075,-4.556 1.075,-7.672 0,-2.97 -1.423,-5.798 -3.802,-7.58 2.379,-1.782 3.802,-4.609 3.802,-7.58 0,-3.116 -0.596,-5.644 -1.075,-7.672 -0.799,-3.382 -0.998,-4.63 0.52,-6.147 0.74,-0.74 0.74,-1.939 0,-2.679 -0.74,-0.74 -1.939,-0.74 -2.679,0 -3.072,3.073 -2.339,6.262 -1.544,9.639 -2.422,-0.791 -4.934,-0.209 -6.28,1.494 -0.668,0.847 -1.96,3.223 0.461,7.017 0.563,0.881 1.727,1.14 2.616,0.582 0.883,-0.563 1.14,-1.736 0.577,-2.616 -0.908,-1.429 -0.935,-2.31 -0.681,-2.632 0.3,-0.381 1.23,-0.577 2.204,-0.237 0.629,0.218 2.091,0.973 2.091,3.253 0,1.821 -0.842,3.49 -2.31,4.574 -1.471,1.088 -3.375,1.399 -5.21,0.825 -2.266,-0.692 -3.849,-3.079 -3.849,-5.806 0,-1.951 0.418,-3.923 1.212,-5.707 l 12.409,-27.919 c 1.02,-2.294 1.538,-4.734 1.538,-7.246 0,-3.233 -1.47,-6.185 -3.784,-7.987 2.313,-1.802 3.784,-4.754 3.784,-7.987 0,-2.513 -0.519,-4.952 -1.538,-7.246 L 46.647,271.085 c -0.793,-1.784 -1.212,-3.756 -1.212,-5.707 0,-2.728 1.582,-5.114 3.849,-5.806 1.843,-0.57 3.74,-0.263 5.21,0.825 1.468,1.085 2.31,2.753 2.31,4.574 0,2.28 -1.462,3.034 -2.091,3.253 -0.973,0.344 -1.905,0.145 -2.204,-0.237 -0.254,-0.322 -0.227,-1.203 0.681,-2.632 0.563,-0.881 0.306,-2.053 -0.577,-2.616 -0.885,-0.555 -2.052,-0.296 -2.616,0.582 -2.42,3.794 -1.129,6.169 -0.461,7.017 1.347,1.698 3.858,2.283 6.28,1.494 -0.796,3.375 -1.528,6.566 1.544,9.639 0.37,0.37 0.855,0.555 1.34,0.555 0.485,0 0.97,-0.185 1.34,-0.555 0.74,-0.74 0.74,-1.939 0,-2.679 -1.517,-1.517 -1.32,-2.764 -0.52,-6.147 0.479,-2.028 1.075,-4.556 1.075,-7.672 0,-2.073 -0.729,-4.056 -1.955,-5.685 h 0.061 c 1.047,0 1.895,-0.847 1.895,-1.895 0,-1.047 -0.847,-1.895 -1.895,-1.895 H 58.64 c 1.227,-1.629 1.955,-3.61 1.955,-5.685 0,-3.116 -0.596,-5.644 -1.075,-7.672 -0.799,-3.383 -0.998,-4.63 0.52,-6.147 0.74,-0.74 0.74,-1.939 0,-2.679 -0.74,-0.74 -1.939,-0.74 -2.679,0 -3.072,3.073 -2.339,6.263 -1.544,9.639 -2.422,-0.788 -4.934,-0.204 -6.28,1.494 -0.668,0.847 -1.96,3.223 0.461,7.017 0.563,0.881 1.727,1.137 2.616,0.582 0.883,-0.563 1.14,-1.736 0.577,-2.616 -0.908,-1.429 -0.935,-2.31 -0.681,-2.632 0.3,-0.381 1.23,-0.577 2.204,-0.237 0.629,0.218 2.091,0.973 2.091,3.253 0,1.821 -0.842,3.49 -2.31,4.574 -1.471,1.088 -3.375,1.395 -5.21,0.825 -2.266,-0.692 -3.849,-3.079 -3.849,-5.806 0,-1.951 0.418,-3.923 1.212,-5.707 l 12.409,-27.919 c 1.02,-2.294 1.538,-4.734 1.538,-7.246 0,-3.233 -1.47,-6.185 -3.784,-7.987 2.313,-1.802 3.784,-4.754 3.784,-7.987 0,-2.513 -0.519,-4.952 -1.538,-7.246 L 46.648,157.397 c -0.793,-1.784 -1.212,-3.756 -1.212,-5.707 0,-2.728 1.582,-5.114 3.849,-5.806 1.843,-0.57 3.74,-0.263 5.21,0.825 1.468,1.085 2.31,2.753 2.31,4.574 0,2.28 -1.462,3.034 -2.091,3.253 -0.973,0.341 -1.905,0.14 -2.204,-0.237 -0.254,-0.322 -0.227,-1.203 0.681,-2.632 0.563,-0.881 0.306,-2.054 -0.577,-2.616 -0.885,-0.555 -2.052,-0.3 -2.616,0.581 -2.42,3.794 -1.129,6.169 -0.461,7.017 1.347,1.698 3.858,2.283 6.28,1.494 -0.796,3.375 -1.528,6.566 1.544,9.639 0.37,0.37 0.855,0.555 1.34,0.555 0.485,0 0.97,-0.185 1.34,-0.555 0.74,-0.74 0.74,-1.939 0,-2.679 -1.517,-1.517 -1.32,-2.764 -0.52,-6.147 0.479,-2.028 1.075,-4.556 1.075,-7.672 0,-2.073 -0.729,-4.056 -1.955,-5.685 h 0.061 c 1.047,0 1.895,-0.847 1.895,-1.895 0,-1.047 -0.847,-1.895 -1.895,-1.895 h -0.061 c 1.227,-1.629 1.955,-3.61 1.955,-5.685 -0.006,-3.121 -0.602,-5.649 -1.08,-7.677 z m -19.23,-8.075 c -0.673,-2.02 -0.438,-3.171 0.006,-3.575 0.29,-0.274 0.73,-0.263 1.009,-0.137 0.342,0.152 0.342,0.393 0.342,0.511 0,1.047 0.847,1.895 1.895,1.895 1.047,0 1.895,-0.847 1.895,-1.895 0,-0.118 0,-0.359 0.342,-0.511 0.274,-0.126 0.711,-0.137 1.009,0.137 0.444,0.404 0.679,1.555 0.006,3.575 -0.49,1.465 -2.263,5.279 -3.251,7.349 -0.968,-2.022 -2.76,-5.874 -3.253,-7.349 z m 3.251,78.185 c 0.544,0.739 1.159,1.427 1.907,1.987 -0.748,0.561 -1.363,1.248 -1.907,1.987 -0.544,-0.739 -1.159,-1.427 -1.907,-1.987 0.748,-0.561 1.363,-1.247 1.907,-1.987 z m 0,113.692 c 0.544,0.739 1.159,1.427 1.907,1.987 -0.748,0.561 -1.363,1.248 -1.907,1.987 -0.544,-0.739 -1.159,-1.427 -1.907,-1.987 0.748,-0.561 1.363,-1.246 1.907,-1.987 z m 3.25,82.16 c 0.673,2.02 0.438,3.171 -0.006,3.575 -0.298,0.27 -0.735,0.259 -1.009,0.137 -0.342,-0.152 -0.342,-0.392 -0.342,-0.511 0,-1.047 -0.847,-1.895 -1.895,-1.895 -1.048,0 -1.895,0.847 -1.895,1.895 0,0.118 0,0.359 -0.342,0.511 -0.278,0.122 -0.718,0.134 -1.009,-0.137 -0.444,-0.404 -0.679,-1.555 -0.006,-3.575 0.49,-1.465 2.263,-5.279 3.251,-7.349 0.968,2.021 2.76,5.874 3.253,7.349 z m -1.361,-23.327 c -0.717,0.558 -1.353,1.226 -1.889,1.981 -0.535,-0.755 -1.172,-1.422 -1.889,-1.981 0.717,-0.558 1.353,-1.226 1.889,-1.981 0.535,0.755 1.171,1.423 1.889,1.981 z M 55.588,327.929 43.536,355.045 31.484,327.929 c -0.793,-1.784 -1.212,-3.756 -1.212,-5.707 0,-2.728 1.582,-5.115 3.849,-5.806 1.842,-0.57 3.742,-0.263 5.21,0.825 1.468,1.085 2.31,2.753 2.31,4.574 0,2.28 -1.462,3.034 -2.091,3.253 -0.977,0.341 -1.906,0.145 -2.204,-0.237 -0.254,-0.322 -0.227,-1.203 0.681,-2.632 0.563,-0.881 0.306,-2.054 -0.577,-2.616 -0.885,-0.555 -2.052,-0.296 -2.616,0.582 -2.42,3.794 -1.129,6.169 -0.461,7.017 1.372,1.732 3.953,2.328 6.421,1.465 0.281,-0.097 0.566,-0.218 0.847,-0.361 v 4.792 c 0,-10e-4 -0.003,-0.003 -0.003,-0.003 -0.057,-0.998 -0.883,-1.785 -1.891,-1.785 -1.047,0 -1.895,0.847 -1.895,1.895 0,1.236 0.864,3.38 3.789,4.044 v 3.535 c 0,1.047 0.847,1.895 1.895,1.895 1.048,0 1.895,-0.847 1.895,-1.895 v -3.535 c 2.925,-0.664 3.789,-2.808 3.789,-4.044 0,-1.047 -0.845,-1.957 -1.891,-1.957 -1.047,0 -1.891,0.785 -1.891,1.832 -0.001,0.003 -0.007,0.008 -0.008,0.011 v -4.783 c 0.281,0.143 0.566,0.264 0.847,0.361 2.468,0.862 5.048,0.266 6.421,-1.465 0.668,-0.847 1.96,-3.223 -0.461,-7.017 -0.563,-0.881 -1.732,-1.14 -2.616,-0.582 -0.883,0.563 -1.14,1.736 -0.577,2.616 0.908,1.429 0.935,2.31 0.681,2.632 -0.3,0.381 -1.229,0.577 -2.204,0.237 -0.629,-0.218 -2.091,-0.973 -2.091,-3.253 0,-1.821 0.842,-3.49 2.31,-4.574 1.471,-1.088 3.375,-1.399 5.21,-0.825 2.266,0.692 3.849,3.079 3.849,5.806 0.002,1.949 -0.416,3.922 -1.211,5.705 z m 0,-27.386 c 0.793,1.784 1.212,3.756 1.212,5.707 0,2.728 -1.582,5.114 -3.849,5.806 -1.839,0.574 -3.742,0.263 -5.21,-0.825 -1.468,-1.085 -2.31,-2.753 -2.31,-4.574 0,-2.28 1.462,-3.034 2.091,-3.253 0.975,-0.341 1.905,-0.145 2.204,0.237 0.254,0.322 0.227,1.203 -0.681,2.632 -0.563,0.881 -0.306,2.053 0.577,2.616 0.89,0.563 2.058,0.303 2.616,-0.582 2.42,-3.794 1.129,-6.169 0.461,-7.017 -1.373,-1.732 -3.953,-2.321 -6.421,-1.465 -0.281,0.097 -0.566,0.219 -0.847,0.361 v -4.793 l 0.003,0.006 c 0.057,0.995 0.883,1.784 1.891,1.784 1.047,0 1.895,-0.847 1.895,-1.895 0,-1.236 -0.864,-3.38 -3.789,-4.044 v -3.535 c 0,-1.047 -0.847,-1.895 -1.895,-1.895 -1.048,0 -1.895,0.847 -1.895,1.895 v 3.535 c -2.925,0.664 -3.789,2.808 -3.789,4.044 0,1.047 0.845,1.957 1.891,1.957 1.047,0 1.891,-0.785 1.891,-1.832 10e-4,-0.003 0.007,-0.008 0.007,-0.008 l 0.001,4.78 c -0.281,-0.143 -0.566,-0.264 -0.847,-0.361 -2.468,-0.855 -5.049,-0.266 -6.421,1.465 -0.668,0.847 -1.96,3.223 0.461,7.017 0.563,0.881 1.732,1.137 2.616,0.582 0.883,-0.563 1.14,-1.736 0.577,-2.616 -0.908,-1.429 -0.935,-2.31 -0.681,-2.632 0.298,-0.381 1.227,-0.577 2.204,-0.237 0.629,0.218 2.091,0.973 2.091,3.253 0,1.821 -0.842,3.49 -2.31,4.574 -1.471,1.088 -3.371,1.399 -5.21,0.825 -2.266,-0.692 -3.849,-3.079 -3.849,-5.806 0,-1.951 0.418,-3.923 1.212,-5.707 L 43.537,273.426 Z M 45.426,257.391 c -0.717,0.558 -1.353,1.226 -1.889,1.981 -0.535,-0.755 -1.172,-1.422 -1.889,-1.981 0.717,-0.558 1.353,-1.226 1.889,-1.981 0.535,0.754 1.171,1.422 1.889,1.981 z M 55.588,214.238 43.536,241.354 31.484,214.238 c -0.793,-1.784 -1.212,-3.756 -1.212,-5.707 0,-2.728 1.582,-5.114 3.849,-5.806 1.842,-0.57 3.742,-0.263 5.21,0.825 1.468,1.085 2.31,2.753 2.31,4.574 0,2.28 -1.462,3.034 -2.091,3.253 -0.977,0.344 -1.906,0.145 -2.204,-0.237 -0.254,-0.322 -0.227,-1.203 0.681,-2.632 0.563,-0.881 0.306,-2.054 -0.577,-2.616 -0.885,-0.558 -2.052,-0.3 -2.616,0.582 -2.42,3.794 -1.129,6.169 -0.461,7.017 1.372,1.732 3.953,2.324 6.421,1.465 0.281,-0.097 0.566,-0.218 0.847,-0.361 v 4.792 l -0.003,-0.006 c -0.057,-0.995 -0.883,-1.784 -1.891,-1.784 -1.047,0 -1.895,0.847 -1.895,1.895 0,1.236 0.864,3.38 3.789,4.044 v 3.535 c 0,1.047 0.847,1.895 1.895,1.895 1.048,0 1.895,-0.847 1.895,-1.895 v -3.535 c 2.925,-0.664 3.789,-2.808 3.789,-4.044 0,-1.047 -0.845,-1.958 -1.891,-1.958 -1.047,0 -1.891,0.785 -1.891,1.832 -0.001,0.003 -0.007,0.008 -0.007,0.008 l -10e-4,-4.78 c 0.281,0.143 0.566,0.264 0.847,0.361 2.468,0.858 5.048,0.266 6.421,-1.465 0.668,-0.847 1.96,-3.223 -0.461,-7.017 -0.563,-0.885 -1.732,-1.143 -2.616,-0.582 -0.883,0.563 -1.14,1.736 -0.577,2.616 0.908,1.429 0.935,2.31 0.681,2.632 -0.3,0.381 -1.229,0.582 -2.204,0.237 -0.629,-0.218 -2.091,-0.973 -2.091,-3.253 0,-1.821 0.842,-3.49 2.31,-4.574 1.471,-1.088 3.375,-1.395 5.21,-0.825 2.266,0.692 3.849,3.079 3.849,5.806 0.002,1.952 -0.416,3.924 -1.211,5.708 z m 0,-27.387 c 0.793,1.784 1.212,3.756 1.212,5.707 0,2.728 -1.582,5.114 -3.849,5.806 -1.839,0.574 -3.742,0.263 -5.21,-0.825 -1.468,-1.085 -2.31,-2.753 -2.31,-4.574 0,-2.28 1.462,-3.034 2.091,-3.253 0.975,-0.341 1.905,-0.145 2.204,0.237 0.254,0.322 0.227,1.203 -0.681,2.632 -0.563,0.881 -0.306,2.053 0.577,2.616 0.89,0.558 2.058,0.303 2.616,-0.582 2.42,-3.794 1.129,-6.169 0.461,-7.017 -1.373,-1.732 -3.953,-2.324 -6.421,-1.465 -0.281,0.097 -0.566,0.218 -0.847,0.361 v -4.792 c 0,0.001 0.003,0.003 0.003,0.003 0.057,0.998 0.883,1.785 1.891,1.785 1.047,0 1.895,-0.847 1.895,-1.895 0,-1.236 -0.864,-3.38 -3.789,-4.044 v -3.535 c 0,-1.047 -0.847,-1.895 -1.895,-1.895 -1.048,0 -1.895,0.847 -1.895,1.895 v 3.535 c -2.925,0.664 -3.789,2.808 -3.789,4.044 0,1.047 0.845,1.958 1.891,1.958 1.047,0 1.891,-0.785 1.891,-1.832 10e-4,-0.003 0.007,-0.008 0.008,-0.011 v 4.783 c -0.281,-0.143 -0.566,-0.264 -0.847,-0.361 -2.468,-0.858 -5.049,-0.266 -6.421,1.465 -0.668,0.847 -1.96,3.223 0.461,7.017 0.563,0.881 1.732,1.137 2.616,0.582 0.883,-0.563 1.14,-1.736 0.577,-2.616 -0.908,-1.429 -0.935,-2.31 -0.681,-2.632 0.298,-0.381 1.227,-0.577 2.204,-0.237 0.629,0.218 2.091,0.973 2.091,3.253 0,1.821 -0.842,3.49 -2.31,4.574 -1.471,1.088 -3.371,1.399 -5.21,0.825 -2.266,-0.692 -3.849,-3.079 -3.849,-5.806 0,-1.951 0.418,-3.923 1.212,-5.707 L 43.537,159.734 Z M 41.647,143.699 c 0.717,-0.558 1.353,-1.226 1.889,-1.981 0.535,0.755 1.172,1.422 1.889,1.981 -0.717,0.558 -1.353,1.226 -1.889,1.981 -0.535,-0.755 -1.171,-1.423 -1.889,-1.981 z"
       id="path2" />
    	<circle
       fill="#ffe15a"
       cx="270.73999"
       cy="235.03"
       r="45.605999"
       id="circle2" />
    	<path
       fill="#ffe15a"
       d="m 274.167,176.883 c 0,1.889 -1.532,3.421 -3.421,3.421 -1.889,0 -3.421,-1.532 -3.421,-3.421 0,-1.889 3.421,-10.262 3.421,-10.262 0,0 3.421,8.373 3.421,10.262 z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 267.326,293.186 c 0,-1.889 1.532,-3.421 3.421,-3.421 1.889,0 3.421,1.532 3.421,3.421 0,1.889 -3.421,10.262 -3.421,10.262 0,0 -3.421,-8.372 -3.421,-10.262 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 328.898,238.455 c -1.889,0 -3.421,-1.532 -3.421,-3.421 0,-1.889 1.532,-3.421 3.421,-3.421 1.889,0 10.262,3.421 10.262,3.421 0,0 -8.373,3.421 -10.262,3.421 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 212.595,231.614 c 1.889,0 3.421,1.532 3.421,3.421 0,1.889 -1.532,3.421 -3.421,3.421 -1.889,0 -10.262,-3.421 -10.262,-3.421 0,0 8.373,-3.421 10.262,-3.421 z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="m 314.285,196.334 c -1.336,1.336 -3.501,1.336 -4.838,0 -1.337,-1.336 -1.336,-3.501 0,-4.838 1.336,-1.337 9.675,-4.838 9.675,-4.838 0,0 -3.5,8.34 -4.837,9.676 z"
       id="path7" />
    	<path
       fill="#ffe15a"
       d="m 227.209,273.735 c 1.336,-1.336 3.501,-1.336 4.838,0 1.337,1.336 1.336,3.501 0,4.838 -1.336,1.337 -9.675,4.837 -9.675,4.837 0,0 3.501,-8.338 4.837,-9.675 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 309.448,278.573 c -1.336,-1.336 -1.336,-3.501 0,-4.838 1.336,-1.337 3.501,-1.336 4.838,0 1.337,1.336 4.838,9.675 4.838,9.675 0,0 -8.34,-3.502 -9.676,-4.837 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="m 232.046,191.496 c 1.336,1.336 1.336,3.501 0,4.838 -1.336,1.337 -3.501,1.336 -4.838,0 -1.337,-1.336 -4.838,-9.675 -4.838,-9.675 0,0 8.34,3.502 9.676,4.837 z"
       id="path10" />
    	<path
       fill="#ffe15a"
       d="m 251.654,180 c 0.723,1.746 -0.106,3.746 -1.852,4.469 -1.746,0.723 -3.746,-0.106 -4.469,-1.852 -0.723,-1.746 -0.767,-10.79 -0.767,-10.79 0,0 6.365,6.427 7.088,8.173 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 289.841,290.069 c -0.723,-1.746 0.106,-3.746 1.852,-4.469 1.746,-0.723 3.746,0.106 4.469,1.852 0.723,1.746 0.767,10.79 0.767,10.79 0,0 -6.366,-6.427 -7.088,-8.173 z"
       id="path12" />
    	<path
       fill="#ffe15a"
       d="m 325.781,215.942 c -1.746,0.723 -3.746,-0.106 -4.469,-1.852 -0.723,-1.746 0.106,-3.746 1.852,-4.469 1.746,-0.723 10.789,-0.767 10.789,-0.767 0,0 -6.426,6.364 -8.172,7.088 z"
       id="path13" />
    	<path
       fill="#ffe15a"
       d="m 215.713,254.127 c 1.746,-0.723 3.746,0.106 4.469,1.852 0.723,1.746 -0.106,3.746 -1.852,4.469 -1.746,0.723 -10.79,0.767 -10.79,0.767 0,0 6.427,-6.364 8.173,-7.088 z"
       id="path14" />
    	<path
       fill="#ffe15a"
       d="m 296.161,182.618 c -0.723,1.746 -2.724,2.574 -4.469,1.852 -1.746,-0.723 -2.574,-2.724 -1.852,-4.469 0.723,-1.745 7.087,-8.172 7.087,-8.172 0,0 -0.043,9.044 -0.766,10.789 z"
       id="path15" />
    	<path
       fill="#ffe15a"
       d="m 245.333,287.451 c 0.723,-1.746 2.724,-2.574 4.469,-1.852 1.746,0.723 2.574,2.724 1.852,4.469 -0.723,1.746 -7.087,8.172 -7.087,8.172 0,0 0.043,-9.043 0.766,-10.789 z"
       id="path16" />
    	<path
       fill="#ffe15a"
       d="m 323.164,260.448 c -1.746,-0.723 -2.574,-2.724 -1.852,-4.469 0.723,-1.746 2.724,-2.574 4.469,-1.852 1.745,0.722 8.172,7.087 8.172,7.087 0,0 -9.045,-0.042 -10.789,-0.766 z"
       id="path17" />
    	<path
       fill="#ffe15a"
       d="m 218.33,209.621 c 1.746,0.723 2.574,2.724 1.852,4.469 -0.723,1.745 -2.724,2.574 -4.469,1.852 -1.745,-0.723 -8.172,-7.087 -8.172,-7.087 0,0 9.045,0.042 10.789,0.766 z"
       id="path18" />
    	<path
       fill="#ffe15a"
       d="m 262.758,177.333 c 0.369,1.853 -0.834,3.654 -2.688,4.022 -1.853,0.369 -3.654,-0.834 -4.022,-2.688 -0.369,-1.853 1.353,-10.732 1.353,-10.732 0,0 4.988,7.545 5.357,9.398 z"
       id="path19" />
    	<path
       fill="#ffe15a"
       d="m 278.737,292.736 c -0.369,-1.853 0.834,-3.654 2.688,-4.022 1.854,-0.369 3.654,0.834 4.022,2.688 0.369,1.853 -1.353,10.732 -1.353,10.732 0,0 -4.989,-7.545 -5.357,-9.398 z"
       id="path20" />
    	<path
       fill="#ffe15a"
       d="m 328.449,227.044 c -1.853,0.369 -3.654,-0.834 -4.022,-2.688 -0.369,-1.854 0.834,-3.654 2.688,-4.022 1.853,-0.369 10.732,1.353 10.732,1.353 0,0 -7.545,4.989 -9.398,5.357 z"
       id="path21" />
    	<path
       fill="#ffe15a"
       d="m 213.045,243.025 c 1.853,-0.369 3.654,0.834 4.022,2.688 0.369,1.854 -0.834,3.654 -2.688,4.022 -1.853,0.369 -10.732,-1.353 -10.732,-1.353 0,0 7.545,-4.989 9.398,-5.357 z"
       id="path22" />
    	<path
       fill="#ffe15a"
       d="m 305.899,188.584 c -1.049,1.571 -3.174,1.993 -4.745,0.943 -1.571,-1.05 -1.993,-3.174 -0.943,-4.745 1.049,-1.571 8.545,-6.632 8.545,-6.632 0,0 -1.808,8.862 -2.857,10.434 z"
       id="path23" />
    	<path
       fill="#ffe15a"
       d="m 235.595,281.485 c 1.049,-1.571 3.174,-1.993 4.745,-0.943 1.571,1.049 1.993,3.174 0.943,4.745 -1.049,1.571 -8.545,6.632 -8.545,6.632 0,0 1.808,-8.862 2.857,-10.434 z"
       id="path24" />
    	<path
       fill="#ffe15a"
       d="m 317.198,270.186 c -1.571,-1.049 -1.993,-3.174 -0.943,-4.745 1.05,-1.571 3.174,-1.993 4.745,-0.943 1.571,1.049 6.632,8.545 6.632,8.545 0,0 -8.863,-1.808 -10.434,-2.857 z"
       id="path25" />
    	<path
       fill="#ffe15a"
       d="m 224.296,199.883 c 1.571,1.049 1.993,3.174 0.943,4.745 -1.049,1.571 -3.174,1.993 -4.745,0.943 -1.571,-1.05 -6.632,-8.545 -6.632,-8.545 0,0 8.864,1.808 10.434,2.857 z"
       id="path26" />
    	<path
       fill="#ffe15a"
       d="m 241.283,184.782 c 1.049,1.571 0.627,3.695 -0.943,4.745 -1.57,1.05 -3.695,0.627 -4.745,-0.943 -1.049,-1.571 -2.857,-10.433 -2.857,-10.433 0,0 7.496,5.061 8.545,6.631 z"
       id="path27" />
    	<path
       fill="#ffe15a"
       d="m 300.21,285.287 c -1.049,-1.571 -0.627,-3.695 0.943,-4.745 1.57,-1.049 3.695,-0.627 4.745,0.943 1.049,1.571 2.857,10.433 2.857,10.433 0,0 -7.495,-5.061 -8.545,-6.631 z"
       id="path28" />
    	<path
       fill="#ffe15a"
       d="m 320.999,205.571 c -1.571,1.049 -3.695,0.627 -4.745,-0.943 -1.049,-1.571 -0.627,-3.695 0.943,-4.745 1.571,-1.049 10.433,-2.857 10.433,-2.857 0,0 -5.06,7.496 -6.631,8.545 z"
       id="path29" />
    	<path
       fill="#ffe15a"
       d="m 220.495,264.498 c 1.571,-1.049 3.695,-0.627 4.745,0.943 1.049,1.571 0.627,3.695 -0.943,4.745 -1.571,1.049 -10.433,2.857 -10.433,2.857 0,0 5.06,-7.496 6.631,-8.545 z"
       id="path30" />
    	<path
       fill="#ffe15a"
       d="m 285.447,178.667 c -0.369,1.853 -2.169,3.057 -4.022,2.688 -1.853,-0.369 -3.057,-2.169 -2.688,-4.022 0.369,-1.853 5.357,-9.398 5.357,-9.398 0,0 1.721,8.879 1.353,10.732 z"
       id="path31" />
    	<path
       fill="#ffe15a"
       d="m 256.047,291.402 c 0.369,-1.853 2.169,-3.057 4.022,-2.688 1.853,0.369 3.057,2.169 2.688,4.022 -0.369,1.853 -5.357,9.398 -5.357,9.398 0,0 -1.721,-8.879 -1.353,-10.732 z"
       id="path32" />
    	<path
       fill="#ffe15a"
       d="m 327.114,249.735 c -1.853,-0.369 -3.057,-2.169 -2.688,-4.022 0.369,-1.853 2.169,-3.057 4.022,-2.688 1.853,0.369 9.398,5.357 9.398,5.357 0,0 -8.879,1.721 -10.732,1.353 z"
       id="path33" />
    	<path
       fill="#ffe15a"
       d="m 214.38,220.334 c 1.853,0.369 3.057,2.169 2.688,4.022 -0.369,1.853 -2.169,3.057 -4.022,2.688 -1.853,-0.369 -9.398,-5.357 -9.398,-5.357 0,0 8.879,-1.721 10.732,-1.353 z"
       id="path34" />
    	<path
       fill="#ffe15a"
       d="m 378.027,247.034 c -1.336,-0.562 -2.863,0.082 -3.42,1.41 0,0.006 0,0.006 0,0.006 -0.01,0.025 -0.062,0.148 -0.151,0.358 -1.977,4.618 -6.067,11.367 -10.197,17.716 3.847,-12.383 7.364,-25.609 7.609,-26.539 0.367,-1.389 -0.455,-2.815 -1.842,-3.192 -1.389,-0.373 -2.817,0.435 -3.206,1.818 -1.795,6.432 -5.466,14.897 -8.853,22.063 0.621,-7.99 0.738,-15.392 0.746,-15.928 0.021,-1.415 -1.088,-2.585 -2.503,-2.652 -1.331,0.041 -2.615,1.012 -2.72,2.426 -3.349,46.068 -47.678,66.676 -51.994,68.572 -2.258,0.225 -12.777,1.41 -22.324,4.725 -1.082,0.376 -2.004,0.753 -2.922,1.127 -0.341,-0.128 -0.707,-0.2 -1.092,-0.177 -29.302,2.12 -52.666,-9.9 -69.458,-35.652 -12.687,-19.458 -16.666,-39.882 -16.705,-40.086 -0.268,-1.42 -1.628,-2.335 -3.054,-2.084 -1.42,0.27 -2.353,1.634 -2.084,3.054 0.106,0.564 1.852,9.479 6.66,21.212 -6.433,-10.155 -10.916,-22.457 -12.494,-28.864 -0.032,-0.128 -0.114,-0.225 -0.162,-0.343 -0.074,-0.181 -0.136,-0.363 -0.245,-0.52 -0.077,-0.111 -0.178,-0.192 -0.269,-0.289 -0.143,-0.151 -0.28,-0.299 -0.455,-0.412 -0.1,-0.065 -0.212,-0.097 -0.321,-0.148 -0.193,-0.09 -0.382,-0.179 -0.597,-0.22 -0.149,-0.029 -0.301,-0.01 -0.456,-0.013 -0.157,-0.002 -0.305,-0.042 -0.466,-0.014 -0.035,0.006 -0.062,0.03 -0.097,0.038 -0.034,0.007 -0.066,-0.004 -0.1,0.003 -0.14,0.034 -0.247,0.122 -0.375,0.177 -0.163,0.071 -0.33,0.124 -0.473,0.223 -0.141,0.097 -0.246,0.223 -0.363,0.344 -0.117,0.12 -0.239,0.226 -0.331,0.365 -0.093,0.141 -0.143,0.3 -0.209,0.457 -0.063,0.153 -0.136,0.297 -0.169,0.462 -0.034,0.169 -0.019,0.343 -0.018,0.52 0,0.141 -0.039,0.276 -0.014,0.42 0.01,0.062 0.03,0.124 0.041,0.184 v 0.01 c 0.003,0.011 0.007,0.026 0.01,0.038 1.618,9.533 5.474,19.415 8.961,26.951 -5.537,-6.283 -10.164,-13.522 -11.804,-17.809 -0.047,-0.125 -0.142,-0.212 -0.206,-0.324 -0.097,-0.173 -0.182,-0.35 -0.313,-0.493 -0.093,-0.102 -0.206,-0.168 -0.312,-0.253 -0.159,-0.128 -0.31,-0.257 -0.494,-0.345 -0.118,-0.056 -0.246,-0.074 -0.371,-0.113 -0.193,-0.058 -0.38,-0.122 -0.585,-0.135 -0.161,-0.011 -0.321,0.03 -0.484,0.051 -0.151,0.019 -0.3,0 -0.45,0.047 -0.029,0.009 -0.049,0.032 -0.076,0.042 -0.028,0.009 -0.056,0.003 -0.084,0.014 -0.142,0.054 -0.243,0.159 -0.37,0.234 -0.149,0.088 -0.308,0.161 -0.435,0.275 -0.13,0.117 -0.22,0.262 -0.322,0.401 -0.097,0.131 -0.205,0.248 -0.277,0.394 -0.075,0.153 -0.103,0.319 -0.146,0.484 -0.043,0.161 -0.1,0.311 -0.111,0.48 -0.012,0.169 0.03,0.338 0.052,0.509 0.019,0.148 -0.001,0.295 0.045,0.441 2.846,9.18 9.69,20.102 15.052,27.796 -4.468,-3.443 -7.752,-7.167 -8.705,-8.291 -0.103,-0.122 -0.204,-0.245 -0.307,-0.367 -0.922,-1.109 -2.551,-1.267 -3.668,-0.363 -1.113,0.909 -1.288,2.545 -0.388,3.662 0.049,0.062 0.245,0.307 0.573,0.69 3.924,4.669 8.199,9.026 12.072,12.705 l -5.298,-2.258 c -1.208,-0.521 -2.628,-0.051 -3.289,1.098 -0.662,1.15 -0.363,2.605 0.697,3.402 0.516,0.383 9.898,7.392 18.02,11.535 -0.766,0.046 -1.665,-0.01 -2.671,-0.087 -1.228,-0.118 -2.436,0.761 -2.735,2.007 -0.294,1.251 0.36,2.529 1.548,3.019 0.2,0.082 2.675,1.103 5.731,2.191 -0.713,0.291 -1.28,0.889 -1.515,1.665 -0.352,1.16 0.143,2.417 1.195,3.019 0.274,0.159 3.971,2.279 8.546,4.158 -0.122,0.189 -0.222,0.393 -0.297,0.618 -0.358,1.098 0.051,2.304 1.004,2.963 0.794,0.546 18.559,12.602 39.307,12.602 1.362,0 2.738,-0.051 4.122,-0.163 1.438,-0.113 2.514,-1.374 2.399,-2.815 -0.115,-1.441 -1.364,-2.529 -2.817,-2.396 -13.034,1.063 -25.591,-3.831 -33.059,-7.571 0.986,-0.241 1.553,-0.46 1.694,-0.516 1.152,-0.47 1.816,-1.681 1.591,-2.902 -0.225,-1.22 -1.277,-2.115 -2.521,-2.141 -3.032,-0.062 -7.231,-1.538 -10.848,-3.122 1.366,-0.684 2.164,-1.339 2.234,-1.395 0.787,-0.659 1.119,-1.711 0.851,-2.702 -0.27,-0.986 -1.094,-1.727 -2.104,-1.89 -1.111,-0.184 -2.496,-0.542 -3.946,-0.981 1.41,-0.812 2.01,-1.706 2.24,-2.161 0.363,-0.725 0.371,-1.574 0.023,-2.304 -0.35,-0.73 -1.016,-1.257 -1.809,-1.426 -0.684,-0.148 -1.459,-0.398 -2.296,-0.725 0.153,-0.153 0.294,-0.327 0.408,-0.526 0.666,-1.129 0.391,-2.58 -0.643,-3.392 -0.054,-0.041 -2.084,-1.634 -5.158,-4.286 0.488,-0.179 0.919,-0.511 1.231,-0.96 0.659,-0.95 0.614,-2.222 -0.11,-3.122 -0.058,-0.072 -2.091,-2.628 -4.893,-6.51 0.925,0.718 1.849,1.452 2.773,2.046 0.435,0.276 0.927,0.414 1.415,0.414 0.662,0 1.315,-0.25 1.818,-0.736 0.207,-0.2 0.369,-0.43 0.497,-0.675 1.587,1.695 3.254,3.234 5.005,4.547 0.228,0.171 0.505,0.168 0.761,0.254 0.742,1.244 1.514,2.49 2.324,3.736 15.883,24.438 38.278,37.528 65.138,38.314 -2.473,1.502 -5.158,3.054 -9.409,4.71 -0.928,0.362 -1.748,0.724 -2.572,1.087 -0.398,0.078 -0.771,0.222 -1.082,0.469 -7.42,3.435 -10.492,6.829 -11.738,9.203 -1.244,2.36 -0.171,4.781 1.348,6.038 0.472,0.388 1.073,0.587 1.675,0.587 0.414,0 0.828,-0.092 1.203,-0.281 0.925,-0.46 1.543,-1.436 1.502,-2.462 0.107,-0.117 0.562,-0.495 1.987,-0.542 1.039,-0.087 3.226,0.148 5.778,0.352 2.428,0.2 5.34,0.427 8.436,0.586 -1.937,2.258 -4.188,4.875 -4.188,4.875 -0.676,0.787 -0.825,1.9 -0.375,2.835 0.452,0.94 1.426,1.523 2.447,1.486 2.067,-0.072 3.471,-0.113 4.393,-0.132 0.804,1.053 1.791,1.471 2.427,1.634 1.799,0.46 3.592,-0.26 4.942,-1.113 1.022,0.736 2.044,1.047 2.854,1.165 1.826,0.25 3.517,-0.281 4.74,-0.884 1.267,0.818 2.508,1.027 3.454,1.027 0.013,0 0.028,0 0.043,0 2.041,-0.01 3.827,-0.996 5.09,-1.962 1.117,0.664 2.184,0.878 3.009,0.915 1.873,0.066 3.425,-0.654 4.457,-1.329 3.686,0.74 6.863,-0.996 8.963,-2.912 0.958,0.557 1.869,0.695 2.595,0.659 1.867,-0.066 3.289,-1.201 4.202,-2.217 4.179,0.505 7.178,-0.266 8.911,-2.324 0.945,-1.119 1.329,-2.38 1.433,-3.53 11.594,-0.066 12.643,-6.396 12.728,-7.178 0.076,-0.711 -0.14,-1.42 -0.602,-1.966 -0.46,-0.546 -1.127,-0.884 -1.839,-0.925 l -30.396,-1.828 c -1.272,-0.092 -2.407,0.761 -2.702,2.003 -0.006,0.02 -0.524,1.951 -2.145,3.495 -2.182,2.083 -5.695,3.183 -9.516,3.766 0.014,-0.35 -0.035,-0.706 -0.169,-1.054 -0.521,-1.348 -2.038,-2.003 -3.382,-1.496 -6.275,2.435 -16.435,2.129 -24.383,1.576 1.219,-0.996 2.687,-1.983 3.86,-2.627 0.991,-0.546 1.523,-1.665 1.313,-2.778 -0.152,-0.809 -0.737,-1.372 -1.443,-1.734 2.21,-1.116 4.022,-2.194 5.741,-3.242 2.984,-1.828 5.803,-3.551 10.937,-5.333 9.91,-3.443 21.379,-4.49 21.494,-4.501 0.26,-0.021 0.516,-0.087 0.758,-0.184 0.408,-0.169 32.758,-13.721 47.999,-44.991 -0.2,0.945 -0.414,1.809 -0.647,2.564 -0.398,1.288 0.245,2.662 1.486,3.182 0.96,0.404 2.051,0.194 2.79,-0.49 -0.963,2.539 -1.834,4.536 -2.545,5.716 -0.725,1.201 -0.375,2.759 0.792,3.535 0.274,0.179 0.567,0.301 0.868,0.373 -1.18,1.727 -2.376,3.361 -3.569,4.858 -0.794,0.996 -0.748,2.417 0.082,3.357 -2.048,2.145 -3.864,3.913 -5.244,5.037 -0.901,0.73 -1.195,1.951 -0.781,2.994 -1.331,0.761 -2.424,1.298 -3.182,1.527 -1.272,0.383 -2.053,1.665 -1.813,2.973 0.125,0.69 0.513,1.272 1.049,1.655 -1.599,0.429 -3.349,0.843 -5.249,1.22 -1.07,0.214 -1.896,1.068 -2.071,2.145 -0.173,1.078 0.338,2.151 1.284,2.692 0.082,0.046 0.975,0.552 2.343,1.134 -5.06,2.038 -14.094,4.7 -28.919,6.161 -1.436,0.143 -2.488,1.426 -2.345,2.861 0.14,1.436 1.382,2.432 2.861,2.35 28.142,-2.784 36.832,-9.828 37.187,-10.13 0.812,-0.68 1.134,-1.788 0.812,-2.799 -0.214,-0.669 -0.684,-1.21 -1.288,-1.523 8.991,-2.83 12.851,-5.962 13.053,-6.13 0.986,-0.818 1.234,-2.232 0.585,-3.341 -0.654,-1.109 -2.015,-1.589 -3.203,-1.109 -0.334,0.128 -0.868,0.26 -1.543,0.393 6.034,-4.132 12.439,-9.053 15.256,-11.249 0.495,-0.367 0.945,-0.721 1.341,-1.053 1.094,-0.919 1.247,-2.545 0.344,-3.652 -0.896,-1.103 -2.529,-1.288 -3.648,-0.404 -0.408,0.322 -0.833,0.654 -1.272,0.996 -1.3,0.966 -2.963,2.059 -4.777,3.182 6.848,-7.775 13.742,-16.204 15.711,-18.625 0.179,-0.22 0.355,-0.439 0.534,-0.659 0.904,-1.124 0.728,-2.769 -0.396,-3.673 -1.127,-0.919 -2.774,-0.73 -3.676,0.388 l -0.006,0.006 -0.002,0.006 c -0.049,0.056 -0.27,0.332 -0.643,0.792 -2.063,2.518 -4.235,4.956 -6.378,7.233 6.976,-12.643 12.258,-25.088 13.032,-26.932 0.028,-0.066 0.054,-0.132 0.082,-0.2 0.554,-1.323 -0.076,-2.856 -1.41,-3.408 z m -122.59,88.167 0.714,0.093 c -0.876,0.819 -1.589,1.737 -2.155,2.685 -1.242,-0.1 -2.369,-0.188 -3.252,-0.227 1.217,-0.795 2.783,-1.658 4.693,-2.551 z"
       id="path35" />
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="M 512,158.898 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#ff4b55"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 v -61.793 h 512 v 61.793 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="70.625"
       fill="#41479b"
       width="512"
       height="194.21001"
       id="rect2"
       x="0" />
    <circle
       fill="#f5f5f5"
       cx="256"
       cy="167.72501"
       r="70.620003"
       id="circle2" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LB = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="M 512,158.898 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#ff4b55"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 v -61.793 h 512 v 61.793 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="70.625"
       fill="#f5f5f5"
       width="512"
       height="194.21001"
       id="rect2"
       x="0" />
    <path
       fill="#73af00"
       d="m 274.862,227.104 81.581,-16.317 c 5.888,-1.177 8.516,-8.107 4.89,-12.894 v 0 c -1.273,-1.681 -3.149,-2.802 -5.233,-3.127 l -86.911,-13.551 c -2.402,-0.375 -4.104,-2.631 -3.7,-5.124 0.391,-2.414 2.838,-3.953 5.262,-3.633 l 60.259,7.929 c 4.898,0.644 7.902,-5.208 4.523,-8.812 l -4.838,-5.16 c -1.811,-1.932 -4.185,-3.243 -6.785,-3.746 l -50.339,-9.749 42.921,3.092 c 3.29,0.237 5.196,-3.652 2.993,-6.108 l -2.201,-2.453 c -1.331,-1.482 -3.098,-2.502 -5.048,-2.909 l -42.613,-8.905 30.284,-0.876 c 2.678,-0.077 4.04,-3.253 2.25,-5.246 l -1.358,-1.513 c -1.064,-1.185 -2.44,-2.047 -3.97,-2.486 l -27.01,-7.755 h 21.226 c 2.1,0 3.512,-2.152 2.677,-4.078 l -0.716,-1.652 c -0.859,-1.982 -2.515,-3.509 -4.559,-4.204 l -19.629,-6.678 9.654,-0.031 c 2.869,-0.009 4.793,-2.951 3.652,-5.582 v 0 c -0.919,-2.121 -2.541,-3.86 -4.593,-4.924 L 256,79.449 234.466,90.614 c -2.051,1.064 -3.674,2.803 -4.593,4.924 v 0 c -1.141,2.633 0.783,5.574 3.652,5.582 l 9.654,0.032 -19.629,6.678 c -2.045,0.695 -3.701,2.222 -4.559,4.204 l -0.716,1.652 c -0.835,1.927 0.577,4.078 2.677,4.078 h 21.226 l -27.01,7.755 c -1.53,0.439 -2.906,1.301 -3.97,2.486 l -1.358,1.513 c -1.789,1.994 -0.427,5.169 2.25,5.246 l 30.284,0.876 -42.613,8.905 c -1.95,0.407 -3.719,1.427 -5.048,2.909 l -2.201,2.453 c -2.204,2.455 -0.298,6.345 2.993,6.108 l 42.921,-3.092 -50.339,9.749 c -2.6,0.503 -4.974,1.814 -6.785,3.746 l -4.838,5.16 c -3.379,3.604 -0.374,9.457 4.523,8.812 l 60.259,-7.929 c 2.424,-0.319 4.872,1.219 5.262,3.633 0.404,2.495 -1.298,4.75 -3.7,5.124 l -86.911,13.551 c -2.083,0.324 -3.959,1.446 -5.233,3.126 v 0 c -3.626,4.786 -0.998,11.716 4.89,12.894 l 81.581,16.317 v 10.182 c 0,5.558 -2.208,10.889 -6.138,14.819 L 218.276,264.83 H 256 293.725 l -12.724,-12.724 c -3.93,-3.93 -6.138,-9.261 -6.138,-14.819 v -10.183 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#3cc8ff"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#464655"
       points="379.585,397.241 255.999,114.759 132.414,397.241 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <path
       fill="#f5f5f5"
       d="M 255.999,70.531 352.59,291.31 H 159.408 L 255.999,70.531 m 0,-44.048 -123.585,282.482 h 247.172 z"
       id="path2" />
    <polygon
       fill="#ffe15a"
       points="379.585,397.241 132.414,397.241 255.999,256 "
       id="polygon2"
       transform="translate(0,-88.276)" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs24" />
    <path
       fill="#41479b"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 0,167.725 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.45 0,331.497 0,326.622 Z"
       id="path2" />
    <path
       fill="#ffe15a"
       d="m 164.028,100.412 c -0.115,-0.339 -0.374,-0.615 -0.708,-0.749 -0.034,-0.013 -0.727,-0.277 -1.839,-0.59 0.489,-0.662 0.834,-1.438 0.834,-2.322 0,-0.758 -0.269,-1.427 -0.638,-2.031 1.222,-0.683 2.083,-1.94 2.083,-3.435 0,-1.185 -0.544,-2.221 -1.368,-2.952 0.988,-0.726 1.672,-1.841 1.672,-3.157 0,-1.469 -0.836,-2.702 -2.023,-3.394 0.623,-0.704 1.033,-1.604 1.033,-2.616 0,-1.761 -1.167,-3.212 -2.755,-3.738 0.362,-0.6 0.627,-1.265 0.627,-2.016 0,-2.164 -1.739,-3.913 -3.892,-3.968 0.089,-0.332 0.205,-0.655 0.205,-1.015 0,-2.199 -1.789,-3.988 -3.989,-3.988 -0.371,0 -0.705,0.117 -1.046,0.212 0.006,-0.088 0.051,-0.163 0.051,-0.254 0,-2.199 -1.789,-3.988 -3.988,-3.988 -0.756,0 -1.422,0.267 -2.026,0.633 -0.465,-1.686 -1.947,-2.954 -3.778,-2.954 -1.099,0 -2.095,0.447 -2.817,1.169 -0.675,-1.246 -1.95,-2.125 -3.464,-2.125 -1.382,0 -2.541,0.749 -3.257,1.818 -0.728,-0.774 -1.743,-1.271 -2.887,-1.271 -1.476,0 -2.716,0.843 -3.405,2.037 -0.73,-0.818 -1.763,-1.356 -2.944,-1.356 -1.46,0 -2.684,0.826 -3.379,1.998 -0.679,-0.534 -1.496,-0.904 -2.424,-0.904 -1.676,0 -3.101,1.046 -3.69,2.515 -0.718,-0.694 -1.687,-1.132 -2.763,-1.132 -1.521,0 -2.802,0.886 -3.474,2.141 -0.294,-0.182 -0.594,-0.326 -0.931,-0.427 0.841,-1.242 1.332,-2.74 1.332,-4.35 0,-3.125 -1.862,-5.807 -4.525,-7.046 l 1.118,-2.237 c 0.173,-0.345 0.173,-0.755 0,-1.101 l -1.346,-2.692 c 0.098,-0.089 0.191,-0.182 0.28,-0.28 l 2.695,1.346 c 0.173,0.086 0.36,0.128 0.548,0.128 0.188,0 0.376,-0.045 0.548,-0.131 l 6.554,-3.277 c 0.418,-0.209 0.68,-0.633 0.68,-1.098 0,-0.465 -0.263,-0.889 -0.68,-1.098 l -6.554,-3.277 c -0.345,-0.173 -0.753,-0.173 -1.098,0 l -2.692,1.346 c -0.09,-0.099 -0.184,-0.193 -0.282,-0.284 l 1.346,-2.692 c 0.173,-0.345 0.173,-0.755 0,-1.101 l -3.277,-6.554 c -0.416,-0.832 -1.783,-0.832 -2.199,0 l -3.277,6.554 c -0.173,0.345 -0.173,0.756 0,1.101 l 1.346,2.692 c -0.098,0.089 -0.191,0.182 -0.28,0.28 L 94.59,37.436 c -0.345,-0.173 -0.753,-0.17 -1.098,0.003 l -6.554,3.277 c -0.418,0.209 -0.68,0.633 -0.68,1.098 0,0.465 0.263,0.889 0.68,1.098 l 6.554,3.277 c 0.173,0.086 0.36,0.131 0.548,0.131 0.189,0 0.376,-0.045 0.548,-0.131 l 2.692,-1.346 c 0.09,0.099 0.184,0.193 0.282,0.284 l -1.346,2.692 c -0.173,0.345 -0.173,0.756 0,1.101 l 1.118,2.237 c -2.663,1.238 -4.525,3.921 -4.525,7.046 0,1.577 0.479,3.041 1.288,4.268 -0.487,0.093 -0.928,0.256 -1.336,0.51 -0.672,-1.255 -1.953,-2.141 -3.474,-2.141 -1.075,0 -2.045,0.437 -2.763,1.132 -0.588,-1.469 -2.013,-2.515 -3.69,-2.515 -0.929,0 -1.747,0.37 -2.424,0.904 -0.695,-1.172 -1.92,-1.998 -3.379,-1.998 -1.181,0 -2.214,0.538 -2.944,1.356 -0.69,-1.195 -1.929,-2.037 -3.405,-2.037 -1.143,0 -2.159,0.498 -2.887,1.271 -0.716,-1.069 -1.876,-1.818 -3.257,-1.818 -1.514,0 -2.788,0.879 -3.464,2.125 -0.722,-0.722 -1.718,-1.169 -2.817,-1.169 -1.832,0 -3.314,1.268 -3.778,2.954 -0.602,-0.366 -1.27,-0.633 -2.026,-0.633 -2.199,0 -3.988,1.789 -3.988,3.988 0,0.089 0.045,0.166 0.051,0.254 -0.341,-0.095 -0.675,-0.212 -1.046,-0.212 -2.2,0 -3.989,1.789 -3.989,3.988 0,0.36 0.116,0.683 0.205,1.015 -2.153,0.055 -3.892,1.804 -3.892,3.968 0,0.751 0.265,1.416 0.627,2.016 -1.588,0.526 -2.755,1.976 -2.755,3.738 0,1.012 0.409,1.912 1.033,2.616 -1.186,0.692 -2.023,1.924 -2.023,3.394 0,1.318 0.684,2.431 1.672,3.157 -0.824,0.732 -1.368,1.767 -1.368,2.952 0,1.495 0.862,2.752 2.083,3.435 -0.369,0.605 -0.638,1.273 -0.638,2.031 0,0.931 0.371,1.751 0.907,2.43 -0.888,0.263 -1.433,0.47 -1.463,0.482 -0.334,0.135 -0.594,0.409 -0.708,0.749 -0.115,0.342 -0.074,0.717 0.11,1.027 0.097,0.16 9.76,16.386 12.959,32.378 0.079,0.396 0.366,0.651 0.704,0.811 2.457,3.319 23.746,5.913 49.66,5.913 25.914,0 47.202,-2.594 49.66,-5.913 0.338,-0.161 0.626,-0.415 0.704,-0.811 3.196,-15.98 12.861,-32.218 12.959,-32.378 0.185,-0.31 0.226,-0.685 0.111,-1.028 z"
       id="path3" />
    <g
       id="g9"
       transform="translate(0,-88.275)">
    	<path
       fill="#464655"
       d="m 164.028,188.687 c -0.115,-0.339 -0.374,-0.615 -0.708,-0.749 -0.034,-0.013 -0.727,-0.277 -1.839,-0.59 0.489,-0.662 0.834,-1.438 0.834,-2.322 0,-0.758 -0.269,-1.427 -0.638,-2.031 1.222,-0.683 2.083,-1.94 2.083,-3.435 0,-1.185 -0.544,-2.221 -1.368,-2.952 0.988,-0.726 1.672,-1.841 1.672,-3.157 0,-1.469 -0.836,-2.702 -2.023,-3.394 0.623,-0.704 1.033,-1.604 1.033,-2.616 0,-1.761 -1.167,-3.212 -2.755,-3.738 0.362,-0.6 0.627,-1.265 0.627,-2.016 0,-2.164 -1.739,-3.913 -3.892,-3.968 0.089,-0.332 0.205,-0.655 0.205,-1.015 0,-2.199 -1.789,-3.988 -3.989,-3.988 -0.371,0 -0.705,0.117 -1.046,0.212 0.006,-0.088 0.051,-0.163 0.051,-0.254 0,-2.199 -1.789,-3.988 -3.988,-3.988 -0.756,0 -1.422,0.267 -2.026,0.633 -0.465,-1.686 -1.947,-2.954 -3.778,-2.954 -1.099,0 -2.095,0.447 -2.817,1.169 -0.675,-1.246 -1.95,-2.125 -3.464,-2.125 -1.382,0 -2.541,0.749 -3.257,1.818 -0.728,-0.774 -1.743,-1.271 -2.887,-1.271 -1.476,0 -2.716,0.843 -3.405,2.037 -0.73,-0.818 -1.763,-1.356 -2.944,-1.356 -1.46,0 -2.684,0.826 -3.379,1.998 -0.679,-0.534 -1.496,-0.904 -2.424,-0.904 -1.676,0 -3.101,1.046 -3.69,2.515 -0.718,-0.694 -1.687,-1.132 -2.763,-1.132 -1.521,0 -2.802,0.886 -3.474,2.141 -0.294,-0.182 -0.594,-0.326 -0.931,-0.427 0.841,-1.242 1.332,-2.74 1.332,-4.35 0,-3.125 -1.862,-5.807 -4.525,-7.046 l 1.118,-2.237 c 0.173,-0.345 0.173,-0.755 0,-1.101 l -1.346,-2.692 c 0.098,-0.089 0.191,-0.182 0.28,-0.28 l 2.695,1.346 c 0.173,0.086 0.36,0.128 0.548,0.128 0.188,0 0.376,-0.045 0.548,-0.131 l 6.554,-3.277 c 0.418,-0.209 0.68,-0.633 0.68,-1.098 0,-0.465 -0.263,-0.889 -0.68,-1.098 l -6.554,-3.277 c -0.345,-0.173 -0.753,-0.173 -1.098,0 l -2.692,1.346 c -0.09,-0.099 -0.184,-0.193 -0.282,-0.284 l 1.346,-2.692 c 0.173,-0.345 0.173,-0.755 0,-1.101 l -3.277,-6.554 c -0.416,-0.832 -1.783,-0.832 -2.199,0 l -3.277,6.554 c -0.173,0.345 -0.173,0.756 0,1.101 l 1.346,2.692 c -0.098,0.089 -0.191,0.182 -0.28,0.28 l -2.695,-1.346 c -0.345,-0.173 -0.753,-0.17 -1.098,0.003 l -6.554,3.277 c -0.418,0.209 -0.68,0.633 -0.68,1.098 0,0.465 0.263,0.889 0.68,1.098 l 6.554,3.277 c 0.173,0.086 0.36,0.131 0.548,0.131 0.189,0 0.376,-0.045 0.548,-0.131 l 2.692,-1.346 c 0.09,0.099 0.184,0.193 0.282,0.284 l -1.346,2.692 c -0.173,0.345 -0.173,0.756 0,1.101 l 1.118,2.237 c -2.663,1.238 -4.525,3.921 -4.525,7.046 0,1.577 0.479,3.041 1.288,4.268 -0.487,0.093 -0.928,0.256 -1.336,0.51 -0.672,-1.255 -1.953,-2.141 -3.474,-2.141 -1.075,0 -2.045,0.437 -2.763,1.132 -0.588,-1.469 -2.013,-2.515 -3.69,-2.515 -0.929,0 -1.747,0.37 -2.424,0.904 -0.695,-1.172 -1.92,-1.998 -3.379,-1.998 -1.181,0 -2.214,0.538 -2.944,1.356 -0.69,-1.195 -1.929,-2.037 -3.405,-2.037 -1.143,0 -2.159,0.498 -2.887,1.271 -0.716,-1.069 -1.876,-1.818 -3.257,-1.818 -1.514,0 -2.788,0.879 -3.464,2.125 -0.722,-0.722 -1.718,-1.169 -2.817,-1.169 -1.832,0 -3.314,1.268 -3.778,2.954 -0.602,-0.366 -1.27,-0.633 -2.026,-0.633 -2.199,0 -3.988,1.789 -3.988,3.988 0,0.089 0.045,0.166 0.051,0.254 -0.341,-0.095 -0.675,-0.212 -1.046,-0.212 -2.2,0 -3.989,1.789 -3.989,3.988 0,0.36 0.116,0.683 0.205,1.015 -2.153,0.055 -3.892,1.804 -3.892,3.968 0,0.751 0.265,1.416 0.627,2.016 -1.588,0.526 -2.755,1.976 -2.755,3.738 0,1.012 0.409,1.912 1.033,2.616 -1.186,0.692 -2.023,1.924 -2.023,3.394 0,1.318 0.684,2.431 1.672,3.157 -0.824,0.732 -1.368,1.767 -1.368,2.952 0,1.495 0.862,2.752 2.083,3.435 -0.369,0.605 -0.638,1.273 -0.638,2.031 0,0.931 0.371,1.751 0.907,2.43 -0.888,0.263 -1.433,0.47 -1.463,0.482 -0.334,0.135 -0.594,0.409 -0.708,0.749 -0.115,0.342 -0.074,0.717 0.11,1.027 0.097,0.16 9.76,16.386 12.959,32.378 0.079,0.396 0.366,0.651 0.704,0.811 2.457,3.319 23.746,5.913 49.66,5.913 25.914,0 47.202,-2.594 49.66,-5.913 0.338,-0.161 0.626,-0.415 0.704,-0.811 3.196,-15.98 12.861,-32.218 12.959,-32.378 0.185,-0.31 0.226,-0.685 0.111,-1.028 z m -34.742,-7.916 v -19.233 c 1.559,-0.135 3.075,-0.178 4.533,-0.127 v 19.98 c -1.356,-0.655 -2.887,-0.846 -4.533,-0.62 z M 115.14,154.575 c 0.034,0.033 0.082,0.047 0.117,0.079 -0.052,0.011 -0.104,0.022 -0.157,0.034 0.017,-0.038 0.026,-0.076 0.04,-0.113 z m 43.186,28.921 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.844 0.686,-1.529 1.529,-1.529 z m 1.443,-2.407 c -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.845 0.686,-1.529 1.529,-1.529 0.845,0 1.532,0.685 1.532,1.529 0,0.845 -0.686,1.529 -1.532,1.529 z m -1.223,-7.639 c 0,-0.845 0.686,-1.529 1.529,-1.529 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.684 -1.529,-1.529 z m -45.701,15.237 c -1.468,-5.581 -3.373,-13.982 -4.177,-22.38 0.845,-0.296 2.297,-0.781 4.177,-1.35 z m -20.486,-22.28 c -0.865,8.937 -2.976,17.889 -4.463,23.4 v -24.852 c 2.108,0.638 3.689,1.177 4.463,1.452 z m 9.766,-10.098 c 0,0.845 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.845 0.686,-1.529 1.529,-1.529 0.843,-0.002 1.529,0.684 1.529,1.529 z m -16.523,-1.726 -0.01,-0.002 c 0,0 0.006,-0.003 0.008,-0.006 0.001,0.003 0.001,0.006 0.002,0.008 z m -44.937,17.338 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 -0.001,-0.845 0.686,-1.529 1.529,-1.529 z m 1.835,7.639 c 0,0.845 -0.686,1.529 -1.529,1.529 -0.845,0 -1.532,-0.685 -1.532,-1.529 0,-0.845 0.686,-1.529 1.532,-1.529 0.843,-0.001 1.529,0.683 1.529,1.529 z m -0.086,3.936 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 -10e-4,-0.844 0.686,-1.529 1.529,-1.529 z m 6.311,-20.706 c 2.406,-3.892 7.102,-8.53 15.82,-8.53 8.512,0 20.522,2.601 28.214,4.513 0.003,1.668 -0.073,3.378 -0.191,5.098 -5.248,-1.827 -26.121,-8.508 -34.999,-2.432 -10.047,6.89 -6.872,20.033 -4.995,25.476 -1.598,-0.433 -3.214,-0.629 -4.761,-0.66 -3.629,-7.281 -3.265,-16.706 0.912,-23.465 z m 6.923,25.317 c -0.864,-2.009 -6.389,-15.905 1.824,-23.42 v 24.518 c -0.59,-0.422 -1.202,-0.779 -1.824,-1.098 z m 4.282,-25.151 c 1.298,-0.673 2.828,-1.109 4.533,-1.341 v 21.87 c -2.465,2.499 -3.561,5.938 -4.044,8.524 -0.156,-0.196 -0.328,-0.354 -0.49,-0.537 v -28.516 z m 6.992,-1.547 c 1.458,-0.051 2.974,-0.008 4.533,0.127 v 19.213 c -0.268,-0.024 -0.548,-0.093 -0.81,-0.093 -1.208,0 -2.342,0.253 -3.372,0.771 -0.127,0.063 -0.23,0.149 -0.352,0.216 v -20.235 h 10e-4 z m 6.991,0.391 c 1.523,0.202 3.043,0.467 4.533,0.765 v 21.037 c -1.56,-1.076 -3.078,-1.854 -4.533,-2.329 z m 6.992,1.293 c 1.611,0.371 3.132,0.76 4.533,1.151 v 26.012 c -1.355,-1.715 -2.916,-3.337 -4.533,-4.748 z m 14.301,-3.699 c 1.848,0.48 3.306,0.879 4.161,1.12 v 20.844 c -3.331,0.337 -5.876,2.038 -7.818,4.129 1.73,-7.206 3.593,-17.04 3.657,-26.093 z m 6.618,1.12 c 0.833,-0.234 2.231,-0.618 4.009,-1.08 0.068,8.961 1.895,18.677 3.609,25.856 -1.918,-1.996 -4.396,-3.605 -7.617,-3.93 v -20.845 h -0.001 z m 13.479,3.732 c 1.402,-0.39 2.922,-0.78 4.533,-1.151 v 22.606 c 0,0.057 0.025,0.107 0.033,0.163 -1.655,1.495 -3.222,3.21 -4.566,4.989 z m 6.991,-1.679 c 1.491,-0.298 3.01,-0.563 4.533,-0.765 v 19.586 c -1.458,0.535 -2.979,1.384 -4.533,2.507 z m 13.983,-0.95 c 1.706,0.232 3.235,0.666 4.533,1.34 v 28.788 c 0,0.064 0.026,0.12 0.036,0.181 -0.024,0.031 -0.052,0.054 -0.076,0.084 -0.51,-2.732 -1.724,-6.398 -4.493,-8.919 z m 6.991,3.072 c 8.799,8.056 1.79,23.505 1.714,23.669 -0.008,0.017 -0.006,0.034 -0.012,0.051 -0.584,0.332 -1.149,0.722 -1.702,1.151 z m -0.098,-3.25 c -8.702,-5.96 -28.974,0.36 -34.709,2.332 -0.113,-1.673 -0.186,-3.335 -0.183,-4.959 7.684,-1.917 19.798,-4.552 28.366,-4.552 8.718,0 13.415,4.638 15.82,8.53 4.177,6.76 4.542,16.184 0.913,23.466 -1.71,0.034 -3.502,0.275 -5.262,0.81 1.869,-5.351 5.193,-18.675 -4.945,-25.627 z m 15.915,7.531 c -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.845 0.686,-1.529 1.529,-1.529 0.845,0 1.532,0.685 1.532,1.529 0,0.844 -0.688,1.529 -1.532,1.529 z m -0.597,-7.285 c 0,0.845 -0.686,1.533 -1.532,1.533 -0.843,0 -1.529,-0.689 -1.529,-1.533 0,-0.845 0.686,-1.529 1.529,-1.529 0.846,0 1.532,0.684 1.532,1.529 z m -3.686,-4.983 c 0,0.845 -0.686,1.529 -1.532,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.845 0.686,-1.529 1.529,-1.529 0.844,-0.001 1.532,0.685 1.532,1.529 z m -6.515,-5.559 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.533 -1.529,1.533 -0.845,0 -1.532,-0.689 -1.532,-1.533 0,-0.844 0.687,-1.529 1.532,-1.529 z m -5.804,-2.321 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 -0.001,-0.844 0.686,-1.529 1.529,-1.529 z m -6.281,-0.957 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.533 -1.529,1.533 -0.845,0 -1.532,-0.689 -1.532,-1.533 0,-0.843 0.687,-1.529 1.532,-1.529 z m -6.145,0.548 c 0.843,0 1.529,0.685 1.529,1.529 0,0.844 -0.686,1.529 -1.529,1.529 -0.845,0 -1.532,-0.685 -1.532,-1.529 0,-0.844 0.687,-1.529 1.532,-1.529 z m -6.349,0.682 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.533 -1.529,1.533 -0.845,0 -1.532,-0.689 -1.532,-1.533 0,-0.844 0.686,-1.529 1.532,-1.529 z m -5.805,1.094 c 0.843,0 1.529,0.685 1.529,1.529 0,0.844 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.844 0.686,-1.529 1.529,-1.529 z m -6.451,1.383 c 0.843,0 1.529,0.685 1.529,1.529 0,0.844 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.844 0.684,-1.529 1.529,-1.529 z m -5.531,4.544 c -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.845 0.686,-1.529 1.529,-1.529 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 z M 98.547,130.09 c 0,-1.13 0.918,-2.048 2.048,-2.048 1.13,0 2.048,0.918 2.048,2.048 0,1.13 -0.918,2.048 -2.048,2.048 -1.129,0.001 -2.048,-0.918 -2.048,-2.048 z m 8.602,-1.904 3.807,1.905 -3.807,1.905 -2.133,-1.067 c 0.052,-0.273 0.085,-0.551 0.085,-0.838 0,-0.287 -0.033,-0.566 -0.085,-0.839 z m -8.457,-4.651 1.902,-3.806 1.902,3.806 -1.067,2.133 c -0.271,-0.052 -0.55,-0.085 -0.836,-0.085 -0.287,0 -0.565,0.033 -0.836,0.085 z m -4.652,8.459 -3.807,-1.905 3.807,-1.905 2.133,1.067 c -0.052,0.273 -0.085,0.551 -0.085,0.838 0,0.287 0.033,0.566 0.085,0.839 z m 4.652,4.65 1.067,-2.133 c 0.271,0.052 0.55,0.085 0.836,0.085 0.286,0 0.565,-0.033 0.836,-0.085 l 1.067,2.133 -1.066,2.133 c -0.278,-0.03 -0.55,-0.085 -0.836,-0.085 -0.287,0 -0.558,0.054 -0.836,0.085 z m 1.903,4.507 c 2.936,0 5.325,2.388 5.325,5.325 0,2.938 -2.389,5.325 -5.325,5.325 -2.936,0 -5.325,-2.388 -5.325,-5.325 0,-2.937 2.388,-5.325 5.325,-5.325 z m -5.775,11.906 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 -10e-4,-0.845 0.685,-1.529 1.529,-1.529 z m -5.53,-1.485 c 0.843,0 1.529,0.685 1.529,1.529 0,0.844 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.844 0.685,-1.529 1.529,-1.529 z m -6.453,-1.383 c 0.843,0 1.529,0.685 1.529,1.529 0,0.844 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.844 0.686,-1.529 1.529,-1.529 z m -5.803,-1.094 c 0.845,0 1.532,0.685 1.532,1.529 0,0.845 -0.686,1.533 -1.532,1.533 -0.843,0 -1.529,-0.689 -1.529,-1.533 -0.002,-0.844 0.685,-1.529 1.529,-1.529 z m -6.35,-0.682 c 0.845,0 1.532,0.685 1.532,1.529 0,0.844 -0.686,1.529 -1.532,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 0,-0.844 0.686,-1.529 1.529,-1.529 z m -6.146,-0.548 c 0.845,0 1.532,0.685 1.532,1.529 0,0.845 -0.686,1.533 -1.532,1.533 -0.843,0 -1.529,-0.689 -1.529,-1.533 0,-0.843 0.686,-1.529 1.529,-1.529 z m -6.28,0.957 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 -0.843,0 -1.529,-0.685 -1.529,-1.529 -10e-4,-0.844 0.686,-1.529 1.529,-1.529 z m -5.804,2.321 c 0.845,0 1.532,0.685 1.532,1.529 0,0.845 -0.686,1.533 -1.532,1.533 -0.843,0 -1.529,-0.689 -1.529,-1.533 -10e-4,-0.844 0.685,-1.529 1.529,-1.529 z m -4.983,4.029 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 -0.845,0 -1.532,-0.685 -1.532,-1.529 10e-4,-0.843 0.687,-1.529 1.532,-1.529 z m -3.687,4.984 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.533 -1.529,1.533 -0.845,0 -1.532,-0.689 -1.532,-1.533 0,-0.845 0.688,-1.529 1.532,-1.529 z m -2.129,5.754 c 0.843,0 1.529,0.685 1.529,1.529 0,0.845 -0.686,1.529 -1.529,1.529 -0.845,0 -1.532,-0.685 -1.532,-1.529 0.002,-0.845 0.688,-1.529 1.532,-1.529 z m 107.122,54.669 c -5.667,-2.803 -25.06,-4.871 -48.181,-4.871 -23.121,0 -42.515,2.068 -48.182,4.871 -2.931,-13.569 -9.939,-26.697 -12.275,-30.823 3.892,-1.194 15.034,-3.562 20.03,6.43 0.256,0.509 0.831,0.778 1.382,0.647 0.555,-0.131 0.948,-0.627 0.948,-1.197 0,-0.089 0.067,-9.106 5.875,-12.011 5.751,-2.861 15.055,6.637 18.015,12.562 0,0 0.003,0.002 0.003,0.004 0.097,0.193 0.259,0.342 0.446,0.462 0.039,0.024 0.075,0.046 0.117,0.065 0.053,0.026 0.095,0.067 0.153,0.086 0.127,0.042 0.255,0.061 0.38,0.061 0.023,0 0.042,-0.02 0.065,-0.021 0.024,0 0.043,0.015 0.068,0.014 0.116,-0.013 0.201,-0.092 0.305,-0.135 0.11,-0.044 0.221,-0.065 0.314,-0.138 0.114,-0.089 0.174,-0.218 0.252,-0.343 0.051,-0.083 0.136,-0.132 0.168,-0.228 0.036,-0.113 0.189,-0.59 0.415,-1.334 1.074,-3.105 4.477,-10.923 11.524,-10.923 5.981,0 9.336,5.633 10.873,9.237 0.501,1.731 0.854,2.84 0.913,3.02 0.17,0.522 0.651,0.851 1.17,0.851 0.125,0 0.253,-0.019 0.38,-0.061 0.022,-0.008 0.038,-0.025 0.06,-0.033 0.342,-0.087 0.651,-0.258 0.814,-0.584 2.962,-5.928 12.274,-15.404 18.015,-12.562 0.386,0.193 0.743,0.417 1.079,0.66 0.333,0.281 0.558,0.489 0.938,0.794 3.785,3.694 3.858,10.478 3.858,10.557 10e-4,0.569 0.394,1.066 0.948,1.197 0.558,0.128 1.127,-0.138 1.382,-0.647 4.986,-9.97 16.13,-7.617 20.029,-6.426 -2.344,4.129 -9.35,17.254 -12.281,30.819 z"
       id="path4" />
    	<path
       fill="#464655"
       d="m 105.443,193.561 c -0.159,0.131 -0.314,0.27 -0.468,0.414 -1.192,1.122 -3.153,0.241 -3.153,-1.397 v -0.221 c 0,-0.679 -0.551,-1.229 -1.229,-1.229 -0.678,0 -1.229,0.551 -1.229,1.229 v 0.221 c 0,1.638 -1.96,2.519 -3.153,1.397 -0.152,-0.143 -0.309,-0.281 -0.468,-0.414 -0.522,-0.429 -1.298,-0.365 -1.73,0.163 -0.434,0.522 -0.362,1.297 0.161,1.731 3.358,2.781 5.188,9.358 5.188,11.957 v 1.332 c 0,0.679 0.551,1.229 1.229,1.229 0.678,0 1.229,-0.551 1.229,-1.229 v -1.332 c 0,-2.599 1.831,-9.175 5.188,-11.957 0.523,-0.435 0.595,-1.209 0.161,-1.731 -0.429,-0.523 -1.204,-0.591 -1.726,-0.163 z"
       id="path5" />
    	<path
       fill="#464655"
       d="m 133.309,198.724 c -0.145,-0.011 -0.288,-0.015 -0.433,-0.011 -1.151,0.079 -2.275,-1.555 -1.717,-2.823 0.023,-0.053 0.047,-0.107 0.071,-0.161 0.215,-0.49 0.051,-1.292 -0.359,-1.813 -0.409,-0.52 -0.94,-0.492 -1.194,0.084 -0.026,0.062 -0.054,0.122 -0.082,0.185 -0.58,1.318 -2.251,0.924 -2.514,-1.013 -0.033,-0.249 -0.067,-0.502 -0.106,-0.754 -0.129,-0.819 -0.6,-1.387 -1.102,-1.16 -0.499,0.218 -0.836,1.137 -0.716,1.969 0.711,5.494 -0.104,11.288 -1.035,13.395 -0.163,0.372 -0.328,0.744 -0.491,1.117 -0.253,0.574 0.07,1.018 0.729,0.97 0.66,-0.05 1.377,-0.503 1.593,-0.992 0.143,-0.324 0.286,-0.649 0.428,-0.974 0.882,-2.01 4.577,-6.467 7.604,-6.236 0.487,-0.003 0.694,-0.32 0.5,-0.796 -0.193,-0.472 -0.706,-0.947 -1.176,-0.987 z"
       id="path6" />
    	<path
       fill="#464655"
       d="m 151.542,202.548 c -0.12,0 -0.239,0.007 -0.36,0.021 -0.966,0.161 -1.785,-1.338 -1.227,-2.606 0.023,-0.053 0.047,-0.107 0.071,-0.161 0.215,-0.49 0.137,-1.255 -0.167,-1.728 -0.303,-0.473 -0.748,-0.408 -1.002,0.169 -0.026,0.062 -0.054,0.122 -0.082,0.184 -0.58,1.318 -1.945,1.058 -2.024,-0.797 -0.009,-0.239 -0.02,-0.481 -0.033,-0.722 -0.047,-0.783 -0.399,-1.299 -0.835,-1.042 -0.433,0.248 -0.78,1.162 -0.74,1.958 0.192,5.267 -0.91,10.934 -1.841,13.041 -0.163,0.372 -0.328,0.744 -0.491,1.117 -0.253,0.574 -0.015,0.98 0.538,0.886 0.555,-0.097 1.186,-0.587 1.401,-1.077 0.143,-0.324 0.286,-0.649 0.428,-0.974 0.882,-2.01 4.29,-6.593 6.798,-6.59 0.407,-0.039 0.602,-0.36 0.476,-0.807 -0.126,-0.445 -0.52,-0.869 -0.91,-0.872 z"
       id="path7" />
    	<path
       fill="#464655"
       d="m 77.049,206.624 c -0.931,-2.106 -1.746,-7.901 -1.035,-13.395 0.12,-0.831 -0.217,-1.749 -0.716,-1.969 -0.502,-0.227 -0.974,0.341 -1.102,1.16 -0.039,0.252 -0.073,0.503 -0.106,0.754 -0.264,1.937 -1.934,2.329 -2.514,1.013 -0.028,-0.062 -0.054,-0.124 -0.082,-0.185 -0.254,-0.577 -0.783,-0.604 -1.194,-0.084 -0.409,0.521 -0.574,1.322 -0.359,1.813 0.023,0.054 0.047,0.108 0.071,0.161 0.558,1.268 -0.567,2.902 -1.717,2.823 -0.145,-0.004 -0.288,0 -0.433,0.011 -0.47,0.04 -0.984,0.514 -1.178,0.988 -0.194,0.476 0.013,0.792 0.5,0.796 3.027,-0.232 6.722,4.225 7.604,6.236 0.142,0.324 0.286,0.649 0.428,0.974 0.215,0.49 0.932,0.942 1.593,0.992 0.66,0.049 0.982,-0.395 0.729,-0.97 -0.162,-0.374 -0.325,-0.746 -0.489,-1.118 z"
       id="path8" />
    	<path
       fill="#464655"
       d="m 57.869,210.863 c -0.93,-2.106 -2.033,-7.774 -1.841,-13.041 0.04,-0.796 -0.309,-1.709 -0.74,-1.958 -0.436,-0.257 -0.788,0.259 -0.835,1.042 -0.014,0.241 -0.024,0.482 -0.033,0.722 -0.078,1.855 -1.443,2.114 -2.024,0.797 -0.028,-0.062 -0.054,-0.124 -0.082,-0.184 -0.254,-0.577 -0.698,-0.642 -1.002,-0.169 -0.303,0.473 -0.383,1.238 -0.167,1.728 0.023,0.054 0.047,0.108 0.071,0.161 0.558,1.268 -0.262,2.767 -1.227,2.606 -0.121,-0.014 -0.241,-0.021 -0.36,-0.021 -0.39,0.003 -0.783,0.426 -0.911,0.871 -0.127,0.446 0.07,0.768 0.476,0.807 2.508,-0.003 5.917,4.579 6.798,6.59 0.142,0.324 0.286,0.649 0.428,0.974 0.215,0.49 0.847,0.98 1.401,1.077 0.554,0.095 0.791,-0.311 0.538,-0.886 -0.162,-0.371 -0.326,-0.744 -0.49,-1.116 z"
       id="path9" />
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const LK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs37" />
    <path
       fill="#ffd250"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.952 0,8.827 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.827 C 512,3.952 508.047,0 503.172,0 Z"
       id="path1" />
    <path
       fill="#963c3c"
       d="m 185.379,35.31 v 264.828 c 0,4.875 3.953,8.828 8.828,8.828 H 476.69 c 4.875,0 8.828,-3.953 8.828,-8.828 V 35.31 c 0,-4.875 -3.953,-8.828 -8.828,-8.828 H 194.207 c -4.875,0.001 -8.828,3.953 -8.828,8.828 z"
       id="path2" />
    <path
       fill="#5aa587"
       d="M 92.69,26.483 H 35.31 c -4.875,0 -8.828,3.953 -8.828,8.828 v 264.828 c 0,4.875 3.953,8.828 8.828,8.828 h 57.38 z"
       id="path3" />
    <path
       fill="#ff7350"
       d="M 150.069,26.483 H 92.69 v 282.483 h 57.379 c 4.875,0 8.828,-3.953 8.828,-8.828 V 35.31 c 0,-4.875 -3.953,-8.827 -8.828,-8.827 z"
       id="path4" />
    <g
       id="g14"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffd250"
       d="m 393.553,326.735 c -0.296,-1.973 1.441,-4.521 4.125,-8.182 0.971,-1.323 2.374,-3.24 2.752,-4.158 -0.25,-0.018 -0.594,0.002 -0.85,0.015 -1.485,0.072 -3.732,0.174 -5.695,-2.005 -0.768,-0.854 -1.138,-1.922 -1.066,-3.089 0.147,-2.371 2.083,-4.702 3.284,-5.935 -3.097,-2.175 -6.056,-4.434 -8.785,-7.162 -5.214,-5.215 -11.161,-7.726 -17.727,-7.588 -0.608,6.531 2.758,10.826 6.35,15.347 1.059,1.331 2.114,2.66 3.073,4.049 4.725,6.841 3.737,20.049 3.138,21.448 -0.679,1.586 -4.415,5.102 -9.54,4.417 -2.357,-0.31 -5.07,0.483 -6.78,1.977 -0.735,0.643 -1.612,1.713 -1.612,3.147 0,0.072 0.006,0.435 0.118,0.502 0.689,0.416 3.262,-0.396 5.102,-1.391 0.508,-0.277 1.14,-0.195 1.568,0.203 3.623,3.392 7.26,0.461 7.661,0.116 0.497,-0.425 1.23,-0.439 1.736,-0.032 3.708,2.988 7.573,-0.278 7.736,-0.419 0.455,-0.393 1.122,-0.44 1.628,-0.109 1.609,1.055 3.08,1.356 4.393,0.906 1.146,-0.398 1.754,-1.26 1.825,-1.468 0.033,-0.548 -0.703,-3.375 -1.191,-5.247 -0.512,-1.965 -1.04,-3.995 -1.243,-5.342 z"
       id="path5" />
    	<path
       fill="#ffd250"
       d="m 433.707,201.665 c -1.117,-0.085 -1.926,0.157 -2.479,0.705 -1.015,1.003 -0.932,2.81 -0.93,2.828 0.021,0.402 -0.138,0.794 -0.431,1.068 -0.296,0.273 -0.693,0.413 -1.095,0.354 -2.008,-0.263 -4.978,-2.382 -10.488,-6.421 -8.755,-6.417 -21.987,-16.115 -34.611,-17.71 -14.674,-1.864 -27.733,2.817 -31.05,11.113 -3.694,9.236 4.157,17.651 4.236,17.736 0.399,0.423 0.487,1.054 0.213,1.567 -2.07,3.9 -0.502,6.778 0.911,8.355 0.443,-1.302 1.105,-2.191 2.017,-2.738 2.202,-1.316 5.078,-0.227 9.055,1.279 2.35,0.888 5.013,1.896 8.119,2.657 7.964,1.952 17.677,0.212 26.248,-1.323 3.029,-0.543 5.95,-1.064 8.666,-1.411 6.835,-0.871 13.687,2.158 15.57,6.906 0.913,2.3 1.4,6.915 -5.581,11.993 -12.556,9.133 -69.815,4.918 -73.188,4.661 -0.075,0.007 -0.149,0.013 -0.307,0.024 1.252,1.406 2.721,2.777 3.361,2.948 0.652,0.174 1.077,0.802 0.994,1.473 -0.083,0.67 -0.647,1.177 -1.322,1.187 l -5.866,0.089 0.54,5.645 c 0.039,0.416 -0.116,0.828 -0.422,1.113 -0.305,0.287 -0.727,0.407 -1.137,0.352 -0.23,-0.038 -5.293,-0.847 -8.793,-2.793 l -6.625,4.179 c -0.218,0.138 -0.47,0.207 -0.723,0.207 -0.147,0 -0.295,-0.023 -0.435,-0.072 -0.387,-0.132 -0.694,-0.43 -0.835,-0.814 l -2.528,-6.873 -2.997,5.996 c -0.219,0.439 -0.658,0.724 -1.145,0.747 -0.487,0.051 -0.951,-0.216 -1.213,-0.632 l -2.569,-4.095 c -1.175,1.468 -3.059,3.605 -4.986,4.939 -0.352,0.247 -0.798,0.307 -1.207,0.169 -0.407,-0.139 -0.724,-0.463 -0.853,-0.872 l -1.346,-4.249 c -1.191,1.506 -2.914,3.502 -4.738,4.999 -0.39,0.324 -0.93,0.399 -1.397,0.195 -0.466,-0.203 -0.779,-0.649 -0.81,-1.154 l -0.434,-6.831 c -1.542,0.786 -3.641,1.81 -4.804,2.173 -0.529,0.166 -1.112,-0.011 -1.459,-0.446 -0.349,-0.435 -0.395,-1.037 -0.116,-1.521 2.087,-3.624 4.002,-8.149 4.148,-10.399 -1.384,1.657 -3.321,3.243 -5.486,5.004 -4.606,3.75 -10.337,8.413 -14.556,16.576 -2.946,5.705 -5.062,15.657 -1.331,24.935 3.185,7.915 10.039,13.821 20.308,17.615 -0.343,-1.498 -0.607,-2.97 -0.634,-4.353 -0.134,-7.028 1.325,-13.443 1.388,-13.713 0.168,-0.729 0.892,-1.19 1.621,-1.013 0.729,0.168 1.182,0.894 1.015,1.621 -0.014,0.063 -1.444,6.371 -1.318,13.053 0.063,3.271 1.47,7.307 2.829,11.209 1.806,5.188 3.676,10.552 2.863,15.066 -1.107,6.136 -8.746,7.692 -15.838,6.508 -2.016,-0.339 -3.85,0.159 -5.167,1.388 -1.337,1.247 -2.023,3.159 -1.834,5.115 0.089,0.921 0.434,1.107 0.546,1.169 0.853,0.461 2.86,-0.166 3.945,-0.733 0.546,-0.287 1.221,-0.169 1.639,0.298 2.844,3.186 6.674,0.007 6.835,-0.132 0.549,-0.463 1.369,-0.421 1.863,0.106 1.071,1.142 2.206,1.71 3.469,1.739 2.309,0.141 4.502,-1.916 4.524,-1.933 0.399,-0.389 0.999,-0.49 1.505,-0.26 4.463,2.043 6.805,0.856 6.901,0.8 3.873,-3.302 1.635,-11.137 1.612,-11.217 -0.106,-0.358 -0.059,-0.744 0.13,-1.064 0.189,-0.322 0.502,-0.552 0.865,-0.636 5.425,-1.244 8.457,-4.725 9.923,-7.033 -2.68,-0.026 -4.81,-0.966 -6.065,-2.926 -2.02,-3.165 -1.05,-7.93 2.474,-12.141 6.029,-7.204 9.715,-21.784 9.162,-27.722 -0.068,-0.744 0.479,-1.402 1.223,-1.473 0.724,-0.074 1.402,0.479 1.473,1.223 0.483,5.201 -1.862,15.988 -6.142,24.122 5.422,-1.5 10.371,-3.695 15.534,-6.051 5.132,-2.342 10.441,-4.762 16.82,-6.761 10.781,-3.375 20.29,-1.036 28.274,6.951 3.868,3.868 8.09,6.7 12.98,9.983 2.147,1.441 4.382,2.941 6.7,4.611 6.285,4.524 6.174,8.302 6.056,12.301 -0.035,1.219 -0.074,2.479 0.063,3.844 0.649,6.495 -4.515,7.522 -6.998,8.015 -0.34,0.067 -0.659,0.13 -0.937,0.199 -0.351,0.088 -0.77,0.174 -1.234,0.268 -2.521,0.511 -6.33,1.284 -7.266,4.511 -0.169,0.578 -0.104,0.78 -0.104,0.78 0.398,0.181 2.462,-0.287 4.105,-1.034 0.349,-0.16 0.745,-0.162 1.096,-0.012 0.351,0.15 0.622,0.443 0.747,0.803 0.479,1.405 1.226,1.644 1.471,1.724 1.704,0.532 4.491,-1.036 5.332,-1.633 0.523,-0.369 1.228,-0.33 1.7,0.103 1.397,1.276 2.689,1.837 3.85,1.681 1.554,-0.216 2.497,-1.679 2.507,-1.695 0.224,-0.361 0.605,-0.597 1.028,-0.636 0.43,-0.023 0.842,0.129 1.128,0.442 0.003,0.006 1.187,1.255 3.61,2.02 1.589,0.497 1.99,-0.076 2.121,-0.266 0.671,-0.98 0.43,-3.48 -0.879,-5.115 -1.716,-2.146 -2.513,-5.409 -2.029,-8.312 0.444,-2.673 1.886,-4.852 4.165,-6.304 4.178,-2.659 5.132,-5.524 4.865,-6.07 -0.077,-0.038 -0.531,-0.097 -0.894,-0.145 -1.864,-0.247 -4.984,-0.659 -8.193,-6.584 -2.834,-5.229 -0.092,-13.508 3.082,-23.097 1.61,-4.857 3.274,-9.882 4.299,-14.81 2.84,-13.632 -6.086,-24.456 -6.176,-24.563 -0.461,-0.55 -0.414,-1.365 0.111,-1.857 6.265,-5.878 8.959,-11.327 8.002,-16.195 -0.995,-5.076 -5.911,-8.625 -9.817,-10.121 -4.868,-1.866 -13.75,-0.806 -22.343,0.216 -7.18,0.853 -13.966,1.662 -18.347,0.747 -2.257,-0.474 -3.91,-1.544 -4.913,-3.179 -0.826,-1.348 -1.028,-2.825 -1.021,-3.977 -2.176,0.818 -3.646,2.834 -3.663,2.858 -0.248,0.348 -0.649,0.558 -1.075,0.566 -0.534,-0.021 -0.836,-0.186 -1.096,-0.523 -1.107,-1.431 -1.553,-3.009 -1.32,-4.694 0.298,-2.178 1.704,-4.051 2.856,-5.259 -5.037,-1.769 -8.898,2.453 -9.076,2.654 -0.44,0.488 -1.164,0.591 -1.721,0.256 -2.43,-1.494 -3.936,-4.426 -3.841,-7.469 0.092,-2.873 1.574,-5.282 4.065,-6.605 1.707,-0.906 3.345,-1.073 4.863,-0.5 1.444,0.544 2.457,1.668 3.095,2.622 1.843,-2.102 1.998,-5.73 1.998,-5.772 0.011,-0.363 0.163,-0.706 0.43,-0.953 0.265,-0.247 0.632,-0.402 0.98,-0.363 3.204,0.132 5.693,1.29 7.393,3.439 2.324,2.941 2.542,7.025 2.406,9.554 5.119,-2.613 4.47,-8.644 4.437,-8.926 -0.054,-0.466 0.134,-0.925 0.499,-1.217 0.365,-0.29 0.851,-0.381 1.297,-0.218 5.432,1.917 7.409,6.761 7.874,10.366 1.538,-1.468 1.561,-3.351 1.561,-3.375 0,-0.618 0.419,-1.158 1.018,-1.311 0.605,-0.151 1.226,0.12 1.523,0.662 2.095,3.83 5.291,6.215 7.629,7.548 l -1.61,-3.903 c -0.218,-0.529 -0.081,-1.138 0.343,-1.521 0.426,-0.384 1.048,-0.458 1.549,-0.186 2.68,1.443 4.803,3.076 7.05,4.807 2.71,2.087 5.513,4.243 9.461,6.098 3.855,1.813 6.455,1.468 7.951,0.862 1.55,-0.626 2.436,-1.73 2.724,-2.486 0.544,-1.429 0.703,-3.481 -0.171,-4.842 -0.562,-0.879 -1.512,-1.365 -2.824,-1.452 z"
       id="path6" />
    	<path
       fill="#ffd250"
       d="m 273.95,221.122 c 0.003,10e-4 0.004,0.003 0.004,0.003 0.007,0.002 0.011,0.001 0.014,0.002 0.1,0.033 10.218,3.226 19.404,3.773 0.504,0.03 0.951,0.34 1.155,0.802 0.204,0.463 0.136,1.003 -0.181,1.397 l -0.321,0.399 c 1.822,-0.273 4.114,-0.526 6.362,-0.535 -0.921,-1.096 -2.067,-2.49 -3.243,-3.951 -2.457,-0.045 -11.446,-0.436 -18.762,-3.961 -1.777,-0.862 -4.849,-2.35 -6.31,-1.597 -0.252,0.13 -0.668,0.74 -0.599,1.489 0.091,0.95 0.968,1.725 2.477,2.179 z"
       id="path7" />
    	<path
       fill="#ffd250"
       d="m 304.436,201.564 c -0.141,0 -0.269,0.015 -0.382,0.05 -0.59,0.177 -0.889,0.844 -0.969,1.364 -0.098,0.666 0.071,1.561 0.844,2.078 1.01,0.671 2.09,0.212 2.705,-0.395 0.194,-0.189 1.122,-1.182 0.437,-2.268 l -0.002,-0.003 c -1.057,-0.487 -1.984,-0.826 -2.633,-0.826 z"
       id="path8" />
    	<path
       fill="#ffd250"
       d="m 291.157,234.186 c 0.655,1.562 1.672,2.773 2.513,3.585 0.319,-0.691 0.806,-1.408 1.544,-1.946 0.722,-0.526 1.974,-1.039 3.808,-0.657 0.029,0.002 0.054,0.008 0.083,0.011 0.053,0.012 0.094,0.007 0.148,0.02 0.047,0.011 0.077,0.049 0.124,0.062 0.065,0.023 0.134,0.025 0.196,0.06 0.047,0.025 0.076,0.068 0.118,0.098 0.69,0.294 1.266,0.766 1.571,1.48 1.025,2.392 -0.779,7.036 -2.371,10.34 1.125,-0.557 2.202,-1.121 2.784,-1.432 0.405,-0.218 0.895,-0.215 1.297,0.011 0.404,0.224 0.664,0.638 0.693,1.096 l 0.382,6.036 c 2.116,-2.23 3.783,-4.653 3.804,-4.685 0.292,-0.428 0.798,-0.643 1.314,-0.575 0.513,0.076 0.936,0.437 1.092,0.93 l 1.544,4.875 c 2.161,-1.987 4.044,-4.648 4.066,-4.682 0.263,-0.37 0.691,-0.567 1.142,-0.575 0.452,0.012 0.871,0.25 1.112,0.634 l 2.327,3.711 3.321,-6.641 c 0.242,-0.484 0.697,-0.789 1.287,-0.747 0.54,0.03 1.007,0.377 1.195,0.885 l 3.03,8.241 5.914,-3.732 c 0.448,-0.286 1.016,-0.278 1.464,0.014 1.929,1.263 4.893,2.078 6.761,2.497 l -0.505,-5.297 c -0.035,-0.377 0.088,-0.75 0.34,-1.031 0.252,-0.281 0.609,-0.446 0.987,-0.451 l 3.384,-0.051 c -0.814,-0.824 -1.487,-1.621 -1.816,-2.025 -0.221,-0.268 -0.308,-0.597 -0.294,-0.919 -2.493,-0.106 -5.967,-0.551 -9.441,-2.05 l -2.067,3.188 c -0.198,0.305 -0.508,0.516 -0.863,0.588 -0.089,0.02 -0.181,0.029 -0.271,0.029 -0.266,0 -0.529,-0.079 -0.754,-0.23 l -7.816,-5.244 -1.436,3.91 c -0.165,0.449 -0.555,0.777 -1.025,0.863 -0.47,0.092 -0.95,-0.081 -1.265,-0.44 -1.343,-1.54 -3.452,-3.901 -4.706,-5.196 -1.13,1.089 -3.112,2.846 -5.231,4.022 -0.345,0.192 -0.758,0.222 -1.126,0.086 -0.37,-0.136 -0.662,-0.426 -0.8,-0.797 l -2.143,-5.751 c -0.26,-0.7 0.095,-1.48 0.797,-1.741 0.697,-0.26 1.48,0.098 1.741,0.797 l 1.562,4.195 c 2.268,-1.575 4.16,-3.603 4.183,-3.628 0.483,-0.52 1.287,-0.582 1.837,-0.138 0.788,0.631 2.926,2.986 4.419,4.66 l 1.246,-3.393 c 0.142,-0.39 0.458,-0.693 0.853,-0.819 0.391,-0.136 0.826,-0.072 1.172,0.162 l 8.105,5.438 1.96,-3.02 c 0.377,-0.582 1.131,-0.785 1.739,-0.474 3.598,1.799 7.482,2.234 9.962,2.3 -1.513,-2.827 -1.646,-6.411 -1.655,-7.253 -2.026,-0.894 -4.515,-2.244 -7.02,-4.303 l -0.974,2.407 c -0.157,0.384 -0.481,0.676 -0.883,0.791 -0.399,0.111 -0.832,0.039 -1.166,-0.204 l -3.91,-2.837 -0.381,2.93 c -0.06,0.455 -0.343,0.847 -0.758,1.045 -0.41,0.198 -0.895,0.178 -1.288,-0.063 -0.136,-0.081 -3.353,-2.047 -5.27,-4.204 -0.497,-0.558 -0.446,-1.414 0.113,-1.91 0.552,-0.497 1.409,-0.449 1.91,0.113 0.81,0.911 1.945,1.816 2.891,2.502 l 0.393,-3.018 c 0.062,-0.474 0.369,-0.879 0.807,-1.068 0.44,-0.19 0.946,-0.132 1.331,0.147 l 4.352,3.157 1.042,-2.571 c 0.168,-0.413 0.529,-0.717 0.966,-0.812 0.434,-0.094 0.892,0.03 1.216,0.337 3.374,3.175 7.025,4.889 9.295,5.73 -0.776,-3.612 -1.071,-8.142 -1.086,-8.38 -0.002,-0.034 0.013,-0.063 0.013,-0.096 -2.109,-1.163 -5.09,-3.167 -7.667,-6.316 -0.012,1.668 -0.148,3.366 -0.557,4.438 -0.141,0.37 -0.435,0.659 -0.807,0.793 -0.374,0.129 -0.786,0.095 -1.125,-0.097 -0.163,-0.094 -3.108,-1.784 -5.3,-4.254 -0.378,1.361 -0.833,2.794 -1.216,3.434 -0.366,0.606 -1.131,0.83 -1.766,0.514 -0.129,-0.063 -2.203,-1.113 -4.051,-2.719 -0.18,1.802 -0.458,3.838 -0.854,4.83 -0.142,0.36 -0.434,0.64 -0.798,0.771 -0.365,0.125 -0.767,0.097 -1.107,-0.086 -0.124,-0.067 -2.472,-1.355 -4.665,-2.988 l -0.594,2.257 c -0.103,0.386 -0.369,0.708 -0.729,0.879 -0.363,0.168 -0.776,0.172 -1.14,0.009 -0.163,-0.074 -4.033,-1.854 -6.237,-4.547 -0.474,-0.578 -0.39,-1.431 0.19,-1.902 0.576,-0.474 1.431,-0.39 1.902,0.19 1.054,1.287 2.666,2.363 3.829,3.038 l 0.694,-2.637 c 0.121,-0.458 0.47,-0.819 0.924,-0.953 0.451,-0.141 0.942,-0.023 1.293,0.295 1.293,1.17 3.043,2.321 4.287,3.083 0.265,-1.671 0.47,-4.086 0.558,-5.652 0.035,-0.605 0.466,-1.113 1.055,-1.244 0.596,-0.134 1.198,0.145 1.485,0.675 0.744,1.37 2.532,2.705 3.88,3.549 0.37,-1.158 0.826,-2.865 1.169,-4.338 0.132,-0.566 0.608,-0.983 1.186,-1.039 0.578,-0.072 1.128,0.259 1.365,0.789 0.845,1.873 2.893,3.585 4.355,4.633 0.159,-1.973 0.012,-4.777 -0.169,-6.531 -0.067,-0.652 0.342,-1.258 0.971,-1.44 0.643,-0.174 1.3,0.116 1.589,0.702 2.722,5.521 7.535,8.579 10.039,9.865 1.365,-14.934 -3.012,-20.648 -3.059,-20.706 -0.245,-0.308 -0.348,-0.712 -0.275,-1.099 0.074,-0.386 0.308,-0.726 0.649,-0.924 2.431,-1.407 3.906,-3.977 4.811,-6.471 -5.502,5.334 -14.219,7.383 -18.465,8.092 l 2.073,2.527 c 0.316,0.386 0.395,0.915 0.204,1.376 -0.192,0.461 -0.62,0.779 -1.117,0.828 -5.203,0.52 -9,-0.169 -11.556,-1.031 l 0.885,1.633 c 0.233,0.428 0.216,0.95 -0.042,1.362 -0.257,0.414 -0.729,0.693 -1.205,0.634 -4.239,-0.181 -7.948,-1.928 -10.996,-3.471 -0.145,0.995 -0.636,1.964 -1.453,2.763 -1.001,0.977 -2.274,1.482 -3.537,1.482 -0.894,0 -1.781,-0.254 -2.56,-0.774 -1.529,-1.021 -2.303,-2.834 -2.019,-4.73 0.263,-1.742 1.362,-3.104 2.87,-3.555 2.017,-0.599 4.32,0.567 7.233,2.051 2.312,1.178 5.069,2.581 8.075,3.21 l -1.675,-3.094 c -0.312,-0.576 -0.168,-1.291 0.343,-1.702 0.513,-0.404 1.24,-0.393 1.736,0.038 0.03,0.026 3.398,2.793 11.042,2.65 l -1.928,-2.35 c -0.317,-0.386 -0.395,-0.918 -0.203,-1.379 0.194,-0.461 0.626,-0.779 1.124,-0.826 0.146,-0.013 11.251,-1.14 18.083,-6.645 -2.225,0.651 -3.947,0.548 -4.079,0.546 -0.375,-0.03 -0.721,-0.213 -0.954,-0.508 -3.13,-3.933 -6.333,-5.149 -7.948,-5.525 -0.907,2.858 -3.103,5.171 -3.21,5.282 -0.29,0.301 -0.705,0.449 -1.117,0.408 -0.416,-0.044 -0.788,-0.277 -1.01,-0.632 -2.414,-3.891 -5.894,-4.914 -7.916,-5.167 0.248,2.876 -1.762,5.238 -3.1,6.221 -0.52,0.377 -1.23,0.343 -1.704,-0.081 -5.807,-5.191 -10.292,-3.655 -12.106,-2.618 0.573,1.423 0.303,2.586 -0.085,3.372 -2.773,5.619 -19.927,6.749 -23.338,6.918 -0.423,0.03 -0.847,-0.163 -1.119,-0.5 -0.273,-0.337 -0.366,-0.782 -0.256,-1.199 0.25,-0.936 0.083,-1.945 -0.469,-2.847 -0.564,-0.921 -1.468,-1.592 -2.415,-1.795 -0.892,-0.189 -2.593,-0.067 -3.61,1.048 -1.163,1.279 -1.242,3.644 -0.23,6.841 1.816,5.739 7.411,11.393 10.894,14.492 -0.032,-0.714 -0.011,-1.239 -0.003,-1.37 0.03,-0.578 0.423,-1.073 0.98,-1.231 0.558,-0.163 1.151,0.051 1.482,0.526 1.154,1.658 2.53,2.778 3.564,3.464 l 0.679,-4.329 c 0.095,-0.599 0.576,-1.063 1.178,-1.134 0.599,-0.051 1.178,0.268 1.409,0.83 1.226,2.978 8.988,12.301 11.875,15.642 0.37,0.426 0.435,1.037 0.163,1.533 -0.271,0.493 -0.819,0.759 -1.379,0.691 -4.946,-0.705 -12.212,0.941 -12.284,0.957 -0.561,0.13 -1.143,-0.111 -1.45,-0.599 -0.305,-0.488 -0.269,-1.116 0.092,-1.567 l 1.001,-1.246 c -6.867,-0.714 -13.553,-2.519 -16.256,-3.309 l -2.271,6.17 6.12,-0.611 c 0.461,-0.058 0.936,0.156 1.217,0.537 0.286,0.381 0.349,0.881 0.169,1.322 l -1.154,2.82 5.041,-1.334 c 0.668,-0.185 1.353,0.172 1.606,0.81 0.668,1.692 1.487,2.803 2.141,3.492 l 1.42,-3.139 c 0.224,-0.49 0.712,-0.832 1.252,-0.794 0.533,0.003 1.015,0.328 1.224,0.826 z"
       id="path9" />
    	<path
       fill="#ffd250"
       d="m 273.632,303.383 c 5.337,3.564 9.651,-0.502 11.956,-3.633 -4.917,-3.587 -8.497,-8 -10.61,-13.255 -0.691,-1.717 -1.14,-3.453 -1.491,-5.186 -0.502,-0.394 -7.927,-6.275 -14.146,-13.15 -0.318,0.829 -0.735,1.487 -1.073,1.932 0.437,1.777 0.012,3.228 -0.535,4.158 0.377,1.267 0.074,2.524 -0.365,3.441 0.941,1.42 1.112,2.81 0.509,4.146 -0.138,0.306 -0.324,0.588 -0.518,0.865 0.774,0.934 1.991,3.072 1.991,7.374 0,2.893 1.071,4.629 1.871,5.521 0.467,-0.404 0.978,-0.631 1.54,-0.691 1.707,-0.19 3.109,1.27 5.026,3.284 1.501,1.579 3.368,3.543 5.845,5.194 z"
       id="path10" />
    	<path
       fill="#ffd250"
       d="m 247.085,266.698 c -0.1,0 -0.201,-0.002 -0.301,-0.002 -1.946,-0.018 -3.725,-0.212 -5.364,-0.527 -0.158,0.452 0.178,1.766 0.529,2.036 0.345,0.265 0.576,0.703 0.564,1.138 -0.012,0.434 -0.199,0.86 -0.558,1.105 -0.231,0.162 -0.918,0.776 -0.927,1.374 -0.009,0.584 0.68,1.187 1.092,1.497 0.301,0.225 0.495,0.567 0.534,0.941 0.039,0.375 -0.079,0.749 -0.328,1.033 -0.174,0.206 -0.671,0.959 -0.585,1.591 0.018,0.134 0.074,0.543 0.779,1.022 0.305,0.207 0.513,0.532 0.575,0.897 0.06,0.365 -0.032,0.738 -0.254,1.034 0.002,0 -0.378,0.555 -0.233,1.107 0.162,0.611 0.924,1.081 1.532,1.367 1.139,0.536 2.778,0.881 4.487,0.948 0.052,-0.009 0.105,-0.001 0.158,-0.003 1.44,0.042 2.919,-0.098 4.182,-0.564 1.239,-0.457 2.061,-1.119 2.444,-1.969 0.12,-0.265 0.369,-0.815 -0.696,-2.058 -0.416,-0.487 -0.435,-1.195 -0.047,-1.704 0.002,-0.003 0.904,-1.244 0.348,-2.234 -0.298,-0.531 -0.207,-1.193 0.222,-1.621 0.079,-0.088 0.919,-1.077 0.254,-2.852 -0.192,-0.511 -0.058,-1.087 0.34,-1.461 0.049,-0.049 1.273,-1.323 1.246,-3.26 -0.166,-0.202 -0.332,-0.405 -0.493,-0.608 -2.62,1.111 -5.832,1.773 -9.5,1.773 z"
       id="path11" />
    	<path
       fill="#ffd250"
       d="m 259.463,172.375 c -5.472,2.943 -17.142,12.17 -17.479,37.43 l 0.301,42.568 c 0.036,0.06 0.088,0.121 0.118,0.179 0.706,1.332 0.372,3.059 -0.024,4.255 3.381,1.208 7.597,0.712 9.404,0.265 -0.361,-1.055 -0.646,-2.76 0.577,-4.69 -0.19,-50.764 4.651,-72.36 7.103,-80.007 z"
       id="path12" />
    	<path
       fill="#ffd250"
       d="m 260.026,257.675 c 0,-2.164 -1.632,-3.848 -3.245,-4.394 -0.334,-0.115 -1.473,-0.431 -1.995,0.254 -0.978,1.279 -0.631,2.183 -0.298,3.059 0.186,0.487 0.378,0.989 0.234,1.563 -0.183,0.733 -0.851,1.034 -1.071,1.134 -1.836,0.833 -8.817,1.926 -13.641,-0.564 -0.653,-0.339 -0.918,-1.138 -0.594,-1.801 0.509,-1.043 0.879,-2.574 0.596,-3.106 -0.023,-0.044 -0.086,-0.165 -0.467,-0.216 -0.36,-0.05 -0.718,-0.074 -1.073,-0.074 -1.647,0 -3.175,0.518 -4.001,1.402 -0.664,0.712 -0.872,1.618 -0.634,2.767 0.802,3.873 5.651,6.223 12.971,6.29 5.178,-0.018 9.632,-1.24 11.855,-3.445 0.906,-0.895 1.363,-1.86 1.363,-2.869 z"
       id="path13" />
    	<path
       fill="#ffd250"
       d="m 248.378,289.781 c 0.313,-0.413 0.83,-0.611 1.34,-0.505 0.941,0.197 3.279,0.693 4.621,-0.348 0.469,-0.36 0.575,-1.341 0.215,-1.981 -0.124,-0.221 -0.499,-0.885 -1.908,-0.345 -1.334,0.514 -3.249,1.071 -4.452,-0.011 -0.241,-0.216 -0.393,-0.469 -0.509,-0.728 -0.362,-0.031 -0.722,-0.051 -1.077,-0.105 -0.115,0.298 -0.274,0.588 -0.546,0.833 -1.198,1.08 -3.115,0.525 -4.45,0.011 -1.405,-0.534 -1.786,0.125 -1.908,0.345 -0.36,0.64 -0.256,1.621 0.212,1.978 1.344,1.036 3.684,0.546 4.452,0.384 0.499,-0.1 1.11,0.072 1.429,0.481 0.317,0.413 0.451,0.951 0.218,1.415 -0.305,0.609 -1.63,3.2 -2.925,4.818 1.692,2.474 3.157,6.883 -0.275,10.806 -0.28,0.317 -0.715,0.476 -1.119,0.458 -0.423,-0.032 -0.809,-0.26 -1.037,-0.618 -0.195,-0.296 -0.883,-1.117 -1.642,-1.265 -0.23,-0.044 -0.591,-0.062 -1.116,0.296 -0.354,0.245 -0.553,1.055 -0.254,1.942 0.534,1.586 2.194,2.466 4.535,2.357 0.532,-0.053 1.108,0.313 1.323,0.851 0.213,0.537 0.062,1.151 -0.377,1.527 l -2.206,1.892 3.602,0.877 c 0.478,0.116 0.854,0.483 0.985,0.957 0.006,0.023 0.544,1.942 1.621,3.561 1.075,-1.619 1.614,-3.538 1.619,-3.561 0.13,-0.474 0.508,-0.841 0.985,-0.957 l 3.602,-0.877 -2.208,-1.892 c -0.439,-0.375 -0.59,-0.99 -0.377,-1.527 0.213,-0.537 0.75,-0.898 1.323,-0.851 2.314,0.103 4.001,-0.771 4.537,-2.359 0.299,-0.885 0.1,-1.695 -0.254,-1.94 -0.532,-0.361 -0.898,-0.343 -1.124,-0.295 -0.785,0.159 -1.489,1.037 -1.635,1.263 -0.23,0.358 -0.615,0.587 -1.037,0.618 -0.439,0.023 -0.841,-0.138 -1.119,-0.458 -3.431,-3.922 -1.964,-8.332 -0.273,-10.806 -1.295,-1.618 -2.62,-4.207 -2.925,-4.818 -0.232,-0.459 -0.179,-1.013 0.134,-1.423 z"
       id="path14" />
    </g>
    <path
       fill="#464655"
       d="m 438.807,113.374 c -0.723,-1.126 -2.164,-2.504 -4.925,-2.684 -1.919,-0.138 -3.457,0.378 -4.576,1.497 -0.9,0.897 -1.334,2.008 -1.54,2.947 -1.846,-0.971 -4.8,-3.135 -7.884,-5.395 -8.981,-6.582 -22.552,-16.529 -35.873,-18.214 -10.804,-1.373 -23.093,0.782 -29.85,7.052 0.102,-0.829 0.132,-1.384 0.136,-1.479 10e-4,-0.018 -0.014,-0.031 -0.014,-0.05 0.002,-0.253 -0.068,-0.489 -0.196,-0.7 -0.028,-0.045 -0.057,-0.079 -0.09,-0.121 -0.15,-0.195 -0.338,-0.363 -0.586,-0.455 -0.004,-0.002 -0.007,-0.008 -0.012,-0.009 h -0.004 c -0.255,-0.089 -0.512,-0.075 -0.757,-0.017 -0.047,0.011 -0.088,0.019 -0.134,0.034 -0.236,0.083 -0.444,0.222 -0.604,0.422 -0.011,0.013 -0.03,0.014 -0.04,0.028 -2.807,3.768 -6.658,4.264 -8.078,4.311 -5.067,-6.017 -10.422,-6.204 -10.653,-6.209 -0.776,0.051 -1.269,0.481 -1.369,1.154 -0.212,1.429 -1.043,2.844 -1.746,3.826 -4.465,-5.551 -10.751,-4.995 -11.031,-4.972 -0.435,0.042 -0.821,0.292 -1.039,0.671 -0.216,0.377 -0.239,0.836 -0.059,1.235 0.806,1.772 -0.171,3.316 -0.95,4.174 -8.79,-7.044 -15.554,-1.305 -15.625,-1.242 -0.516,0.452 -0.613,1.222 -0.222,1.786 0.655,0.95 0.54,1.474 0.365,1.828 -1.422,2.882 -11.74,4.762 -19.467,5.314 -0.041,-1.087 -0.372,-2.169 -0.978,-3.161 -0.959,-1.565 -2.474,-2.667 -4.157,-3.029 -1.871,-0.407 -4.503,0.023 -6.18,1.875 -1.875,2.061 -2.144,5.25 -0.806,9.479 2.092,6.607 8.372,12.823 12.035,16.022 -0.892,-0.33 -1.777,-0.69 -2.634,-1.102 -2.156,-1.05 -5.767,-2.807 -8.435,-1.42 -1.346,0.696 -2.208,2.439 -2.051,4.142 0.079,0.853 0.556,2.77 3.053,3.994 l -3.004,8.16 c -0.16,0.437 -0.085,0.927 0.201,1.295 0.284,0.369 0.738,0.569 1.204,0.518 l 6.033,-0.602 -1.331,3.254 c -0.194,0.476 -0.103,1.021 0.236,1.406 0.339,0.384 0.854,0.555 1.364,0.414 l 6.549,-1.734 c 1.692,3.475 3.948,4.691 4.054,4.745 0.333,0.177 0.717,0.203 1.068,0.081 0.352,-0.121 0.64,-0.382 0.793,-0.721 l 1.043,-2.31 c 1.082,1.514 2.251,2.518 2.974,3.072 -0.44,0.364 -0.874,0.722 -1.351,1.11 -4.547,3.7 -10.774,8.769 -15.25,17.434 -2.248,4.351 -3.999,10.989 -3.476,18.049 -3.26,-2.74 -9.406,-8.175 -13.931,-13.738 0.545,-0.372 1.124,-0.723 1.562,-1.155 1.415,-1.4 2.162,-3.059 2.162,-4.791 0,-3.598 -2.636,-6.13 -5.084,-6.958 -0.911,-0.307 -1.788,-0.353 -2.586,-0.217 -0.079,-58.979 6.638,-77.035 8.002,-80.076 0.215,-0.481 0.132,-1.045 -0.215,-1.443 -0.345,-0.396 -0.895,-0.557 -1.4,-0.408 -0.886,0.26 -21.713,6.766 -22.172,41.226 l 0.29,41.112 c -2.827,-0.298 -5.511,0.506 -7.074,2.175 -0.888,0.95 -1.834,2.616 -1.308,5.166 0.701,3.383 3.43,5.88 7.618,7.252 -0.115,0.444 -0.154,0.946 -0.098,1.508 0.065,0.661 0.271,1.479 0.653,2.188 -0.511,0.609 -1.013,1.48 -1.039,2.553 -0.024,1.034 0.387,2.005 1.226,2.894 -0.331,0.668 -0.62,1.571 -0.493,2.572 0.077,0.596 0.328,1.387 1.034,2.152 -0.199,0.59 -0.322,1.362 -0.109,2.211 0.217,0.877 0.762,1.631 1.571,2.275 -2.072,-0.384 -3.528,0.551 -4.209,1.767 -1.024,1.825 -0.609,4.271 0.924,5.45 1.249,0.96 2.734,1.267 4.087,1.196 -0.689,1.166 -1.417,2.244 -1.875,2.602 -0.298,0.231 -0.487,0.575 -0.518,0.95 -0.033,0.375 0.092,0.747 0.345,1.027 0.141,0.156 3.092,3.481 1.335,6.936 -0.543,-0.446 -1.246,-0.863 -2.082,-1.033 -1.087,-0.221 -2.187,0.03 -3.188,0.717 -1.429,0.98 -1.96,3.05 -1.29,5.035 0.513,1.521 1.792,3.08 3.975,3.799 l -1.899,1.628 c -0.386,0.33 -0.553,0.85 -0.435,1.343 0.118,0.493 0.502,0.879 0.995,0.999 l 5.429,1.323 c 0.416,1.193 1.367,3.496 2.956,5.085 0.254,0.254 0.736,0.396 1.096,0.396 0.36,0 0.703,-0.142 0.957,-0.396 1.589,-1.589 2.541,-3.892 2.956,-5.085 l 5.429,-1.323 c 0.493,-0.12 0.877,-0.505 0.995,-0.999 0.118,-0.495 -0.051,-1.013 -0.435,-1.343 l -1.899,-1.628 c 2.182,-0.721 3.463,-2.279 3.975,-3.799 0.67,-1.986 0.139,-4.057 -1.29,-5.035 -1.003,-0.689 -2.109,-0.936 -3.189,-0.717 -0.835,0.169 -1.536,0.585 -2.081,1.031 -1.728,-3.436 1.198,-6.782 1.34,-6.938 0.25,-0.28 0.374,-0.652 0.34,-1.025 -0.033,-0.374 -0.221,-0.718 -0.516,-0.948 -0.457,-0.356 -1.182,-1.432 -1.871,-2.598 1.352,0.012 2.829,-0.234 4.083,-1.202 0.275,-0.211 0.47,-0.501 0.671,-0.782 0.096,5.939 3.86,8.289 4.023,8.388 0.641,0.382 1.464,0.18 1.85,-0.457 0.319,-0.52 0.509,-0.62 0.505,-0.626 0.476,0.026 1.811,1.432 2.787,2.457 1.592,1.675 3.576,3.762 6.304,5.58 1.999,1.334 3.889,1.859 5.625,1.859 4.872,0 8.521,-4.111 10.078,-6.223 3.034,1.903 6.474,3.555 10.396,4.895 0.134,0.046 0.27,0.064 0.405,0.067 0.468,1.519 0.979,3.048 1.507,4.564 1.693,4.857 3.443,9.881 2.755,13.695 -0.889,4.943 -8.71,4.993 -12.729,4.317 -2.86,-0.466 -5.513,0.266 -7.46,2.081 -1.947,1.819 -2.95,4.567 -2.678,7.354 0.189,1.947 1.164,2.863 1.951,3.288 1.806,0.971 4.248,0.245 5.575,-0.298 3.047,2.654 6.691,1.54 8.896,0.138 1.356,1.133 2.868,1.727 4.505,1.763 0.054,0.002 0.107,0.002 0.162,0.002 2.474,0 4.555,-1.302 5.596,-2.099 5.241,2.121 8.238,0.54 8.763,0.215 4.255,-3.59 3.555,-10.041 3,-12.846 8.745,-2.648 11.563,-10.248 11.685,-10.585 0.169,-0.474 0.062,-1.003 -0.278,-1.374 -0.343,-0.369 -0.867,-0.518 -1.348,-0.389 -2.696,0.724 -4.825,0.231 -5.839,-1.356 -1.373,-2.147 -0.483,-5.661 2.268,-8.947 0.577,-0.69 1.123,-1.453 1.657,-2.248 6.758,-1.511 12.53,-4.139 18.641,-6.926 5.058,-2.306 10.29,-4.692 16.508,-6.641 1.743,-0.547 3.437,-0.868 5.107,-1.085 -0.505,7.331 3.255,12.161 6.948,16.808 1.02,1.282 2.04,2.563 2.964,3.901 3.96,5.735 3.2,17.759 2.879,18.844 -0.281,0.617 -2.935,3.319 -6.697,2.803 -3.126,-0.416 -6.625,0.614 -8.919,2.622 -1.636,1.432 -2.537,3.274 -2.537,5.184 0,1.628 0.782,2.436 1.44,2.828 1.96,1.164 5.203,-0.081 6.941,-0.913 1.624,1.255 3.292,1.718 4.833,1.718 1.917,0 3.64,-0.714 4.849,-1.506 3.628,2.292 7.428,0.95 9.546,-0.495 2.654,1.44 4.787,1.155 6.162,0.614 0.447,-0.175 0.855,-0.397 1.226,-0.647 0.055,0.057 0.105,0.134 0.161,0.181 1.44,1.239 4.104,0.579 5.809,-0.039 0.776,1.284 1.802,1.863 2.613,2.121 2.506,0.798 5.383,-0.575 6.831,-1.432 1.757,1.358 3.502,1.929 5.246,1.684 1.538,-0.213 2.698,-1.039 3.445,-1.763 0.797,0.573 2.007,1.279 3.641,1.795 0.721,0.23 1.355,0.322 1.911,0.322 1.886,0 2.87,-1.075 3.256,-1.636 1.565,-2.285 0.749,-6.154 -0.998,-8.338 -1.031,-1.288 -1.887,-3.699 -1.474,-6.177 0.221,-1.322 0.909,-3.168 2.947,-4.465 3.676,-2.338 6.088,-5.504 6.144,-8.063 0.024,-1.057 -0.377,-1.929 -1.133,-2.457 -0.667,-0.467 -1.414,-0.566 -2.137,-0.661 -1.61,-0.213 -3.616,-0.478 -6.168,-5.191 -2.274,-4.201 0.419,-12.339 3.274,-20.957 1.632,-4.931 3.321,-10.03 4.378,-15.108 2.618,-12.569 -3.693,-22.696 -5.978,-25.849 6.355,-6.251 9.02,-12.25 7.922,-17.842 -1.208,-6.162 -6.953,-10.383 -11.503,-12.126 -5.501,-2.108 -14.719,-1.012 -23.633,0.056 -6.951,0.832 -13.523,1.621 -17.47,0.785 -1.492,-0.312 -2.553,-0.96 -3.153,-1.928 -1.043,-1.683 -0.484,-3.895 -0.479,-3.918 0.109,-0.414 0.014,-0.86 -0.254,-1.193 -0.269,-0.333 -0.714,-0.546 -1.108,-0.505 -2.593,0.104 -4.659,1.549 -5.935,2.742 -0.074,-0.363 -0.086,-0.736 -0.033,-1.122 0.351,-2.601 3.346,-4.874 3.375,-4.896 0.358,-0.269 0.562,-0.7 0.54,-1.149 -0.021,-0.448 -0.263,-0.856 -0.647,-1.09 -5.512,-3.357 -10.658,-0.871 -13.292,1.464 -1.113,-1.09 -1.784,-2.758 -1.732,-4.437 0.033,-1.103 0.423,-3.129 2.627,-4.301 0.997,-0.531 1.854,-0.647 2.631,-0.361 1.3,0.484 2.164,2.082 2.388,2.659 0.142,0.369 0.443,0.659 0.815,0.789 0.374,0.136 0.789,0.095 1.13,-0.106 3.017,-1.76 3.982,-5.457 4.288,-7.508 1.774,0.289 3.127,1.042 4.11,2.282 2.758,3.478 1.63,9.604 1.619,9.666 -0.088,0.458 0.067,0.928 0.407,1.246 0.34,0.317 0.821,0.435 1.272,0.317 6.124,-1.641 8.084,-6.614 8.386,-10.29 4.683,2.916 4.364,8.947 4.346,9.23 -0.03,0.466 0.181,0.915 0.558,1.186 0.378,0.273 0.868,0.331 1.3,0.159 2.241,-0.909 3.481,-2.388 4.169,-3.753 4.263,5.59 10.189,7.53 10.473,7.623 0.502,0.153 1.048,0.014 1.406,-0.374 0.356,-0.387 0.457,-0.946 0.256,-1.432 l -1.323,-3.207 c 1.077,0.759 2.114,1.558 3.18,2.379 2.826,2.174 5.746,4.423 9.96,6.403 4.738,2.226 8.114,1.727 10.119,0.924 1.999,-0.809 3.584,-2.317 4.239,-4.035 0.764,-2.001 1.052,-4.963 -0.425,-7.262 z m -2.105,6.304 c -0.287,0.756 -1.173,1.86 -2.724,2.486 -1.496,0.606 -4.096,0.951 -7.951,-0.862 -3.948,-1.855 -6.752,-4.012 -9.461,-6.098 -2.247,-1.73 -4.37,-3.363 -7.05,-4.807 -0.5,-0.271 -1.122,-0.198 -1.549,0.186 -0.425,0.382 -0.562,0.992 -0.343,1.521 l 1.61,3.903 c -2.338,-1.334 -5.534,-3.718 -7.629,-7.548 -0.296,-0.543 -0.918,-0.814 -1.523,-0.662 -0.599,0.153 -1.018,0.693 -1.018,1.311 0,0.024 -0.023,1.908 -1.561,3.375 -0.466,-3.605 -2.442,-8.448 -7.874,-10.366 -0.446,-0.162 -0.932,-0.072 -1.297,0.218 -0.365,0.292 -0.553,0.753 -0.499,1.217 0.033,0.281 0.682,6.313 -4.437,8.926 0.138,-2.528 -0.081,-6.613 -2.406,-9.554 -1.7,-2.15 -4.188,-3.307 -7.393,-3.439 -0.348,-0.039 -0.715,0.116 -0.98,0.363 -0.266,0.247 -0.419,0.59 -0.43,0.953 0,0.042 -0.156,3.67 -1.998,5.772 -0.638,-0.953 -1.651,-2.078 -3.095,-2.622 -1.518,-0.573 -3.156,-0.405 -4.863,0.5 -2.492,1.323 -3.974,3.732 -4.065,6.605 -0.095,3.043 1.411,5.975 3.841,7.469 0.557,0.337 1.281,0.233 1.721,-0.256 0.178,-0.201 4.039,-4.423 9.076,-2.654 -1.152,1.208 -2.558,3.082 -2.856,5.259 -0.233,1.684 0.213,3.263 1.32,4.694 0.259,0.337 0.562,0.502 1.096,0.523 0.426,-0.007 0.826,-0.218 1.075,-0.566 0.018,-0.024 1.487,-2.04 3.663,-2.858 -0.009,1.152 0.194,2.628 1.021,3.977 1.003,1.635 2.655,2.705 4.913,3.179 4.381,0.915 11.167,0.106 18.347,-0.747 8.593,-1.022 17.475,-2.082 22.343,-0.216 3.906,1.496 8.822,5.044 9.817,10.121 0.957,4.868 -1.737,10.318 -8.002,16.195 -0.525,0.491 -0.573,1.308 -0.111,1.857 0.089,0.107 9.016,10.931 6.176,24.563 -1.025,4.928 -2.689,9.953 -4.299,14.81 -3.174,9.588 -5.914,17.868 -3.082,23.097 3.209,5.926 6.329,6.337 8.193,6.584 0.363,0.047 0.815,0.107 0.894,0.145 0.268,0.546 -0.687,3.411 -4.865,6.07 -2.28,1.452 -3.721,3.631 -4.165,6.304 -0.483,2.903 0.313,6.167 2.029,8.312 1.309,1.635 1.55,4.136 0.879,5.114 -0.132,0.19 -0.532,0.763 -2.121,0.266 -2.423,-0.767 -3.607,-2.016 -3.61,-2.02 -0.286,-0.313 -0.697,-0.466 -1.128,-0.443 -0.425,0.039 -0.806,0.275 -1.028,0.636 -0.011,0.015 -0.953,1.479 -2.507,1.695 -1.161,0.157 -2.453,-0.405 -3.85,-1.681 -0.472,-0.431 -1.177,-0.47 -1.7,-0.103 -0.841,0.597 -3.628,2.165 -5.332,1.633 -0.245,-0.079 -0.992,-0.319 -1.471,-1.724 -0.125,-0.361 -0.396,-0.653 -0.747,-0.803 -0.351,-0.15 -0.747,-0.148 -1.096,0.012 -1.644,0.747 -3.708,1.216 -4.105,1.036 0,0 -0.065,-0.204 0.104,-0.782 0.936,-3.227 4.745,-4 7.266,-4.511 0.463,-0.094 0.883,-0.18 1.234,-0.268 0.278,-0.068 0.597,-0.132 0.937,-0.199 2.483,-0.493 7.647,-1.521 6.998,-8.015 -0.138,-1.365 -0.098,-2.625 -0.063,-3.844 0.118,-4 0.23,-7.777 -6.056,-12.301 -2.318,-1.671 -4.553,-3.17 -6.7,-4.611 -4.889,-3.283 -9.112,-6.115 -12.98,-9.983 -7.983,-7.987 -17.492,-10.327 -28.274,-6.951 -6.378,1.998 -11.687,4.419 -16.82,6.761 -5.163,2.356 -10.112,4.551 -15.534,6.051 4.28,-8.135 6.624,-18.922 6.142,-24.122 -0.071,-0.744 -0.749,-1.297 -1.473,-1.223 -0.744,0.071 -1.291,0.729 -1.223,1.473 0.553,5.938 -3.133,20.518 -9.162,27.722 -3.523,4.211 -4.494,8.977 -2.474,12.141 1.255,1.961 3.384,2.9 6.065,2.926 -1.465,2.308 -4.499,5.79 -9.923,7.033 -0.363,0.085 -0.676,0.313 -0.865,0.636 -0.189,0.321 -0.236,0.706 -0.13,1.064 0.023,0.079 2.261,7.915 -1.612,11.217 -0.097,0.056 -2.439,1.242 -6.901,-0.8 -0.505,-0.23 -1.105,-0.129 -1.505,0.26 -0.023,0.018 -2.215,2.073 -4.524,1.933 -1.263,-0.029 -2.398,-0.597 -3.469,-1.739 -0.493,-0.526 -1.313,-0.569 -1.863,-0.106 -0.16,0.139 -3.991,3.318 -6.835,0.132 -0.417,-0.467 -1.092,-0.585 -1.639,-0.298 -1.086,0.567 -3.092,1.195 -3.945,0.733 -0.113,-0.062 -0.457,-0.247 -0.546,-1.169 -0.189,-1.955 0.497,-3.868 1.834,-5.115 1.318,-1.23 3.153,-1.727 5.167,-1.388 7.092,1.184 14.731,-0.372 15.838,-6.508 0.812,-4.514 -1.057,-9.877 -2.863,-15.066 -1.361,-3.903 -2.766,-7.939 -2.829,-11.209 -0.127,-6.681 1.304,-12.989 1.318,-13.053 0.168,-0.727 -0.286,-1.453 -1.015,-1.621 -0.729,-0.177 -1.453,0.284 -1.621,1.013 -0.063,0.269 -1.523,6.685 -1.388,13.713 0.028,1.383 0.29,2.855 0.634,4.353 -10.269,-3.794 -17.123,-9.699 -20.308,-17.615 -3.732,-9.278 -1.615,-19.23 1.331,-24.935 4.218,-8.163 9.95,-12.826 14.556,-16.576 2.165,-1.761 4.103,-3.347 5.486,-5.004 -0.146,2.25 -2.06,6.775 -4.148,10.399 -0.278,0.483 -0.233,1.086 0.116,1.521 0.348,0.435 0.93,0.611 1.459,0.446 1.163,-0.363 3.263,-1.387 4.804,-2.173 l 0.434,6.831 c 0.032,0.505 0.345,0.951 0.81,1.154 0.467,0.204 1.007,0.129 1.397,-0.195 1.824,-1.496 3.546,-3.492 4.738,-4.999 l 1.346,4.249 c 0.129,0.408 0.446,0.733 0.853,0.872 0.408,0.138 0.854,0.077 1.207,-0.169 1.928,-1.334 3.811,-3.471 4.987,-4.939 l 2.569,4.095 c 0.26,0.416 0.726,0.684 1.213,0.632 0.488,-0.023 0.927,-0.308 1.145,-0.747 l 2.997,-5.996 2.528,6.873 c 0.141,0.384 0.448,0.682 0.835,0.814 0.141,0.05 0.289,0.072 0.435,0.072 0.252,0 0.504,-0.071 0.723,-0.207 l 6.625,-4.179 c 3.501,1.945 8.565,2.755 8.793,2.793 0.408,0.054 0.832,-0.065 1.137,-0.352 0.305,-0.286 0.46,-0.697 0.422,-1.113 l -0.54,-5.645 5.866,-0.089 c 0.675,-0.011 1.239,-0.518 1.322,-1.187 0.083,-0.671 -0.342,-1.299 -0.994,-1.473 -0.64,-0.171 -2.108,-1.543 -3.361,-2.948 0.159,-0.011 0.232,-0.018 0.307,-0.024 3.373,0.257 60.632,4.472 73.188,-4.661 6.983,-5.078 6.495,-9.694 5.581,-11.993 -1.884,-4.748 -8.736,-7.777 -15.57,-6.906 -2.717,0.348 -5.639,0.868 -8.666,1.411 -8.57,1.535 -18.283,3.275 -26.248,1.323 -3.106,-0.761 -5.769,-1.769 -8.119,-2.657 -3.977,-1.506 -6.852,-2.595 -9.055,-1.279 -0.913,0.546 -1.575,1.436 -2.017,2.738 -1.414,-1.577 -2.982,-4.456 -0.911,-8.355 0.273,-0.513 0.186,-1.143 -0.213,-1.567 -0.079,-0.085 -7.931,-8.5 -4.236,-17.736 3.318,-8.295 16.377,-12.977 31.05,-11.113 12.625,1.597 25.856,11.294 34.611,17.71 5.512,4.039 8.48,6.158 10.488,6.421 0.402,0.058 0.798,-0.081 1.095,-0.354 0.295,-0.273 0.452,-0.666 0.431,-1.068 -0.002,-0.018 -0.085,-1.825 0.93,-2.828 0.553,-0.548 1.362,-0.789 2.479,-0.705 1.313,0.086 2.262,0.573 2.825,1.447 0.872,1.367 0.714,3.42 0.169,4.849 z m -42.54,130.836 c -1.313,0.451 -2.784,0.15 -4.393,-0.906 -0.505,-0.331 -1.173,-0.284 -1.628,0.109 -0.163,0.141 -4.03,3.407 -7.736,0.419 -0.505,-0.407 -1.238,-0.393 -1.736,0.032 -0.402,0.345 -4.039,3.275 -7.661,-0.116 -0.428,-0.398 -1.06,-0.479 -1.568,-0.203 -1.842,0.995 -4.414,1.807 -5.102,1.391 -0.113,-0.067 -0.118,-0.43 -0.118,-0.502 0,-1.434 0.877,-2.504 1.612,-3.147 1.709,-1.494 4.423,-2.287 6.78,-1.977 5.126,0.685 8.863,-2.831 9.54,-4.417 0.599,-1.399 1.588,-14.606 -3.138,-21.448 -0.959,-1.388 -2.014,-2.719 -3.073,-4.049 -3.593,-4.52 -6.958,-8.815 -6.35,-15.347 6.566,-0.138 12.513,2.374 17.727,7.588 2.729,2.729 5.687,4.989 8.785,7.162 -1.201,1.234 -3.137,3.564 -3.284,5.935 -0.072,1.166 0.298,2.234 1.066,3.089 1.963,2.179 4.21,2.078 5.695,2.005 0.256,-0.014 0.599,-0.033 0.85,-0.015 -0.378,0.918 -1.781,2.835 -2.752,4.158 -2.684,3.661 -4.42,6.209 -4.125,8.182 0.203,1.346 0.732,3.375 1.244,5.339 0.488,1.871 1.225,4.7 1.191,5.247 -0.071,0.21 -0.679,1.072 -1.826,1.471 z m 5.698,-18.639 c 2.601,-3.549 3.922,-5.471 3.157,-7 -0.785,-1.571 -2.389,-1.503 -3.563,-1.443 -1.26,0.06 -2.454,0.113 -3.558,-1.113 -0.287,-0.319 -0.404,-0.661 -0.377,-1.108 0.094,-1.546 1.838,-3.552 2.842,-4.536 0.777,0.527 1.549,1.054 2.342,1.586 2.125,1.426 4.334,2.909 6.626,4.559 5.119,3.686 5.044,6.209 4.934,10.027 -0.038,1.244 -0.079,2.654 0.076,4.193 0.375,3.758 -1.768,4.481 -4.833,5.09 -0.387,0.077 -0.749,0.15 -1.068,0.23 -0.317,0.079 -0.696,0.156 -1.116,0.242 -1.955,0.396 -5.08,1.065 -7.253,3.091 -0.179,-0.733 -0.397,-1.582 -0.657,-2.574 -0.493,-1.896 -1.004,-3.855 -1.186,-5.058 -0.149,-1.022 2.313,-4.38 3.634,-6.186 z M 262.762,206.629 c -0.562,0.06 -1.073,0.287 -1.54,0.691 -0.8,-0.892 -1.871,-2.627 -1.871,-5.521 0,-4.302 -1.217,-6.441 -1.991,-7.374 0.193,-0.277 0.38,-0.558 0.518,-0.865 0.602,-1.335 0.431,-2.726 -0.509,-4.146 0.439,-0.918 0.742,-2.174 0.365,-3.441 0.548,-0.93 0.972,-2.382 0.535,-4.158 0.339,-0.445 0.756,-1.103 1.073,-1.932 6.219,6.873 13.644,12.755 14.146,13.15 0.351,1.732 0.8,3.468 1.491,5.186 2.113,5.255 5.693,9.667 10.61,13.255 -2.305,3.13 -6.618,7.197 -11.956,3.633 -2.477,-1.651 -4.345,-3.616 -5.844,-5.194 -1.918,-2.014 -3.32,-3.475 -5.027,-3.284 z m -11.321,11.924 c 0.278,0.321 0.68,0.481 1.119,0.458 0.423,-0.032 0.809,-0.26 1.037,-0.618 0.147,-0.225 0.851,-1.105 1.635,-1.263 0.225,-0.05 0.591,-0.067 1.124,0.295 0.354,0.245 0.553,1.055 0.254,1.94 -0.535,1.588 -2.223,2.462 -4.537,2.359 -0.573,-0.047 -1.11,0.313 -1.323,0.851 -0.213,0.537 -0.062,1.152 0.377,1.527 l 2.208,1.892 -3.602,0.877 c -0.478,0.116 -0.854,0.483 -0.985,0.957 -0.006,0.023 -0.544,1.942 -1.619,3.561 -1.077,-1.619 -1.615,-3.538 -1.621,-3.561 -0.13,-0.474 -0.508,-0.841 -0.985,-0.957 l -3.602,-0.877 2.206,-1.892 c 0.439,-0.377 0.59,-0.99 0.377,-1.527 -0.215,-0.537 -0.791,-0.904 -1.323,-0.851 -2.342,0.109 -4.001,-0.771 -4.535,-2.357 -0.299,-0.886 -0.1,-1.697 0.254,-1.942 0.523,-0.358 0.886,-0.34 1.116,-0.296 0.759,0.148 1.447,0.969 1.642,1.265 0.23,0.358 0.615,0.587 1.037,0.618 0.404,0.018 0.839,-0.141 1.119,-0.458 3.432,-3.922 1.966,-8.332 0.275,-10.806 1.295,-1.618 2.62,-4.207 2.925,-4.818 0.233,-0.463 0.098,-1.003 -0.218,-1.415 -0.319,-0.408 -0.93,-0.582 -1.429,-0.481 -0.768,0.162 -3.108,0.652 -4.452,-0.384 -0.467,-0.358 -0.57,-1.34 -0.212,-1.978 0.121,-0.221 0.504,-0.879 1.908,-0.345 1.335,0.514 3.253,1.069 4.45,-0.011 0.273,-0.245 0.431,-0.535 0.546,-0.833 0.355,0.054 0.715,0.073 1.077,0.105 0.116,0.26 0.268,0.512 0.509,0.728 1.204,1.081 3.118,0.525 4.452,0.011 1.409,-0.54 1.785,0.125 1.908,0.345 0.36,0.64 0.254,1.621 -0.215,1.981 -1.343,1.039 -3.681,0.544 -4.621,0.348 -0.509,-0.106 -1.025,0.094 -1.34,0.505 -0.313,0.41 -0.366,0.963 -0.136,1.426 0.305,0.609 1.63,3.2 2.925,4.818 -1.69,2.471 -3.155,6.882 0.275,10.803 z m 4.389,-38.036 c -0.398,0.374 -0.532,0.95 -0.34,1.461 0.666,1.777 -0.174,2.764 -0.254,2.852 -0.43,0.428 -0.52,1.09 -0.222,1.621 0.557,0.99 -0.345,2.23 -0.348,2.234 -0.387,0.509 -0.369,1.217 0.047,1.704 1.064,1.242 0.815,1.793 0.696,2.058 -0.382,0.85 -1.205,1.512 -2.444,1.969 -1.265,0.467 -2.743,0.606 -4.182,0.564 -0.053,0.002 -0.106,-0.006 -0.158,0.003 -1.708,-0.068 -3.348,-0.412 -4.487,-0.948 -0.608,-0.286 -1.369,-0.756 -1.532,-1.367 -0.147,-0.552 0.234,-1.107 0.233,-1.107 0.222,-0.296 0.313,-0.67 0.254,-1.034 -0.062,-0.365 -0.269,-0.689 -0.575,-0.897 -0.705,-0.479 -0.761,-0.888 -0.779,-1.022 -0.086,-0.632 0.41,-1.385 0.585,-1.591 0.248,-0.284 0.366,-0.658 0.328,-1.033 -0.039,-0.374 -0.233,-0.715 -0.534,-0.941 -0.413,-0.31 -1.101,-0.915 -1.092,-1.497 0.009,-0.599 0.696,-1.213 0.927,-1.374 0.36,-0.245 0.546,-0.671 0.558,-1.105 0.012,-0.435 -0.218,-0.874 -0.564,-1.138 -0.352,-0.27 -0.686,-1.583 -0.529,-2.036 1.639,0.316 3.417,0.51 5.364,0.527 0.1,0 0.201,0.002 0.301,0.002 3.668,0 6.879,-0.662 9.496,-1.773 0.162,0.203 0.328,0.406 0.493,0.608 0.031,1.937 -1.193,3.212 -1.242,3.26 z m -9.021,-4.803 c -7.32,-0.067 -12.17,-2.418 -12.971,-6.29 -0.238,-1.151 -0.03,-2.056 0.634,-2.767 0.826,-0.885 2.354,-1.402 4.001,-1.402 0.354,0 0.714,0.024 1.073,0.074 0.381,0.051 0.444,0.172 0.467,0.216 0.284,0.532 -0.086,2.063 -0.596,3.106 -0.324,0.662 -0.06,1.462 0.594,1.801 4.824,2.489 11.805,1.397 13.641,0.564 0.221,-0.1 0.888,-0.402 1.071,-1.134 0.145,-0.575 -0.047,-1.077 -0.234,-1.562 -0.333,-0.876 -0.68,-1.78 0.298,-3.059 0.522,-0.685 1.66,-0.369 1.995,-0.254 1.614,0.546 3.245,2.23 3.245,4.394 0,1.007 -0.458,1.973 -1.362,2.87 -2.224,2.203 -6.678,3.425 -11.856,3.443 z m 4.974,-6.918 c -1.806,0.448 -6.023,0.945 -9.404,-0.265 0.396,-1.196 0.732,-2.923 0.024,-4.255 -0.031,-0.057 -0.082,-0.119 -0.118,-0.179 l -0.301,-42.568 c 0.337,-25.261 12.006,-34.488 17.479,-37.43 -2.452,7.647 -7.293,29.242 -7.103,80.006 -1.223,1.931 -0.937,3.636 -0.577,4.691 z m 36.892,-22.921 -1.42,3.139 c -0.653,-0.689 -1.473,-1.801 -2.141,-3.492 -0.252,-0.638 -0.937,-0.995 -1.605,-0.81 l -5.041,1.334 1.154,-2.82 c 0.18,-0.44 0.116,-0.941 -0.169,-1.322 -0.281,-0.382 -0.756,-0.596 -1.217,-0.537 l -6.12,0.611 2.271,-6.17 c 2.702,0.789 9.389,2.595 16.256,3.309 l -1.001,1.246 c -0.361,0.451 -0.396,1.078 -0.092,1.567 0.307,0.488 0.889,0.729 1.45,0.599 0.072,-0.015 7.338,-1.662 12.284,-0.957 0.561,0.068 1.108,-0.198 1.379,-0.691 0.271,-0.495 0.206,-1.107 -0.163,-1.533 -2.888,-3.34 -10.649,-12.664 -11.875,-15.642 -0.231,-0.562 -0.811,-0.881 -1.409,-0.83 -0.602,0.072 -1.084,0.535 -1.178,1.134 l -0.679,4.329 c -1.034,-0.685 -2.41,-1.806 -3.564,-3.464 -0.331,-0.476 -0.924,-0.691 -1.482,-0.526 -0.557,0.159 -0.95,0.653 -0.98,1.231 -0.007,0.132 -0.029,0.658 0.003,1.37 -3.484,-3.1 -9.077,-8.754 -10.894,-14.492 -1.013,-3.198 -0.934,-5.562 0.229,-6.841 1.016,-1.116 2.719,-1.237 3.611,-1.048 0.948,0.203 1.852,0.874 2.415,1.795 0.552,0.903 0.718,1.911 0.469,2.847 -0.111,0.417 -0.018,0.863 0.256,1.199 0.271,0.337 0.696,0.531 1.119,0.5 3.411,-0.169 20.565,-1.299 23.338,-6.918 0.387,-0.786 0.658,-1.949 0.085,-3.372 1.815,-1.036 6.298,-2.572 12.106,2.618 0.474,0.425 1.184,0.458 1.704,0.081 1.337,-0.983 3.348,-3.346 3.1,-6.221 2.023,0.254 5.503,1.278 7.916,5.167 0.222,0.356 0.594,0.588 1.01,0.632 0.413,0.041 0.826,-0.107 1.117,-0.408 0.107,-0.111 2.303,-2.424 3.21,-5.282 1.615,0.377 4.818,1.592 7.948,5.525 0.234,0.295 0.579,0.478 0.954,0.508 0.132,0.002 1.855,0.105 4.079,-0.546 -6.833,5.505 -17.938,6.631 -18.083,6.645 -0.499,0.047 -0.93,0.365 -1.124,0.826 -0.192,0.461 -0.115,0.994 0.203,1.379 l 1.928,2.35 c -7.645,0.142 -11.012,-2.624 -11.042,-2.65 -0.495,-0.43 -1.223,-0.44 -1.736,-0.038 -0.511,0.41 -0.655,1.126 -0.343,1.702 l 1.675,3.094 c -3.006,-0.629 -5.763,-2.031 -8.075,-3.21 -2.912,-1.483 -5.215,-2.65 -7.233,-2.051 -1.508,0.451 -2.607,1.813 -2.87,3.555 -0.284,1.898 0.49,3.711 2.019,4.73 0.779,0.52 1.667,0.774 2.56,0.774 1.261,0 2.536,-0.505 3.537,-1.482 0.818,-0.798 1.309,-1.768 1.453,-2.763 3.048,1.544 6.758,3.289 10.996,3.471 0.476,0.058 0.948,-0.221 1.205,-0.634 0.259,-0.413 0.275,-0.934 0.042,-1.362 l -0.885,-1.633 c 2.557,0.862 6.354,1.55 11.556,1.031 0.497,-0.05 0.925,-0.366 1.117,-0.828 0.19,-0.461 0.111,-0.99 -0.204,-1.376 l -2.073,-2.527 c 4.247,-0.707 12.964,-2.758 18.465,-8.092 -0.905,2.494 -2.38,5.064 -4.811,6.471 -0.34,0.198 -0.575,0.537 -0.649,0.924 -0.072,0.387 0.03,0.791 0.275,1.099 0.046,0.058 4.424,5.772 3.059,20.706 -2.504,-1.287 -7.317,-4.345 -10.039,-9.865 -0.289,-0.585 -0.946,-0.876 -1.589,-0.702 -0.629,0.181 -1.037,0.788 -0.971,1.44 0.181,1.754 0.328,4.558 0.169,6.531 -1.462,-1.048 -3.51,-2.761 -4.355,-4.633 -0.238,-0.531 -0.788,-0.862 -1.365,-0.789 -0.578,0.056 -1.054,0.474 -1.186,1.039 -0.342,1.473 -0.798,3.18 -1.169,4.338 -1.347,-0.844 -3.136,-2.178 -3.88,-3.549 -0.287,-0.531 -0.889,-0.809 -1.485,-0.675 -0.59,0.13 -1.02,0.64 -1.055,1.244 -0.088,1.566 -0.295,3.982 -0.558,5.652 -1.244,-0.762 -2.994,-1.913 -4.287,-3.083 -0.351,-0.317 -0.842,-0.435 -1.293,-0.295 -0.452,0.134 -0.802,0.495 -0.924,0.953 l -0.694,2.637 c -1.163,-0.675 -2.775,-1.751 -3.829,-3.038 -0.472,-0.579 -1.326,-0.664 -1.902,-0.19 -0.579,0.472 -0.664,1.325 -0.19,1.902 2.205,2.694 6.073,4.473 6.237,4.547 0.365,0.163 0.777,0.159 1.14,-0.009 0.361,-0.171 0.627,-0.493 0.729,-0.879 l 0.594,-2.257 c 2.194,1.633 4.542,2.921 4.665,2.988 0.34,0.183 0.742,0.212 1.107,0.086 0.365,-0.132 0.655,-0.413 0.798,-0.771 0.396,-0.992 0.675,-3.027 0.854,-4.83 1.848,1.606 3.922,2.655 4.051,2.719 0.634,0.316 1.399,0.092 1.766,-0.514 0.382,-0.64 0.836,-2.073 1.216,-3.434 2.191,2.468 5.137,4.16 5.3,4.254 0.34,0.192 0.753,0.225 1.126,0.097 0.372,-0.134 0.666,-0.423 0.807,-0.793 0.408,-1.073 0.544,-2.77 0.557,-4.438 2.577,3.148 5.559,5.153 7.667,6.316 0,0.033 -0.015,0.062 -0.013,0.096 0.014,0.238 0.31,4.768 1.086,8.38 -2.271,-0.841 -5.922,-2.554 -9.295,-5.73 -0.324,-0.307 -0.782,-0.43 -1.216,-0.337 -0.437,0.095 -0.798,0.399 -0.966,0.812 l -1.042,2.571 -4.352,-3.157 c -0.384,-0.278 -0.889,-0.337 -1.331,-0.147 -0.439,0.189 -0.745,0.594 -0.807,1.068 l -0.393,3.018 c -0.946,-0.685 -2.081,-1.591 -2.891,-2.502 -0.5,-0.562 -1.358,-0.609 -1.91,-0.113 -0.558,0.497 -0.609,1.352 -0.113,1.91 1.917,2.156 5.134,4.122 5.27,4.204 0.393,0.242 0.877,0.26 1.288,0.063 0.414,-0.198 0.697,-0.59 0.758,-1.045 l 0.381,-2.93 3.91,2.837 c 0.334,0.243 0.767,0.316 1.166,0.204 0.402,-0.115 0.726,-0.407 0.883,-0.791 l 0.974,-2.407 c 2.505,2.059 4.994,3.41 7.02,4.303 0.01,0.842 0.142,4.426 1.655,7.253 -2.479,-0.065 -6.364,-0.5 -9.962,-2.3 -0.608,-0.31 -1.362,-0.107 -1.739,0.474 l -1.96,3.02 -8.105,-5.438 c -0.345,-0.234 -0.78,-0.298 -1.172,-0.162 -0.395,0.127 -0.71,0.43 -0.853,0.819 l -1.246,3.393 c -1.492,-1.674 -3.631,-4.03 -4.419,-4.66 -0.552,-0.444 -1.355,-0.382 -1.837,0.138 -0.023,0.024 -1.916,2.052 -4.183,3.628 l -1.562,-4.195 c -0.26,-0.697 -1.043,-1.057 -1.741,-0.797 -0.701,0.26 -1.057,1.042 -0.797,1.741 l 2.143,5.751 c 0.138,0.37 0.43,0.661 0.8,0.797 0.369,0.136 0.78,0.106 1.126,-0.086 2.12,-1.177 4.102,-2.934 5.231,-4.022 1.255,1.295 3.363,3.656 4.706,5.196 0.316,0.36 0.794,0.532 1.265,0.44 0.47,-0.086 0.86,-0.414 1.025,-0.863 l 1.436,-3.91 7.816,5.244 c 0.225,0.15 0.488,0.23 0.754,0.23 0.089,0 0.181,-0.009 0.271,-0.029 0.356,-0.072 0.667,-0.284 0.863,-0.588 l 2.067,-3.188 c 3.474,1.5 6.948,1.944 9.441,2.05 -0.014,0.322 0.073,0.65 0.294,0.919 0.33,0.404 1.003,1.199 1.816,2.025 l -3.384,0.051 c -0.377,0.006 -0.735,0.169 -0.986,0.451 -0.252,0.28 -0.375,0.653 -0.34,1.031 l 0.505,5.297 c -1.868,-0.419 -4.831,-1.234 -6.761,-2.497 -0.448,-0.292 -1.016,-0.299 -1.464,-0.014 l -5.914,3.732 -3.03,-8.241 c -0.186,-0.508 -0.655,-0.854 -1.195,-0.885 -0.588,-0.042 -1.045,0.263 -1.287,0.747 l -3.321,6.641 -2.327,-3.711 c -0.242,-0.384 -0.659,-0.622 -1.112,-0.634 -0.451,0.007 -0.879,0.204 -1.142,0.575 -0.023,0.033 -1.907,2.693 -4.066,4.682 l -1.544,-4.875 c -0.157,-0.493 -0.579,-0.854 -1.092,-0.93 -0.516,-0.068 -1.022,0.147 -1.314,0.575 -0.021,0.032 -1.688,2.454 -3.804,4.685 l -0.382,-6.036 c -0.029,-0.458 -0.289,-0.872 -0.693,-1.096 -0.402,-0.225 -0.892,-0.23 -1.297,-0.011 -0.582,0.312 -1.658,0.876 -2.784,1.432 1.592,-3.305 3.398,-7.948 2.371,-10.34 -0.306,-0.714 -0.882,-1.187 -1.571,-1.48 -0.043,-0.03 -0.072,-0.073 -0.118,-0.098 -0.063,-0.034 -0.131,-0.036 -0.196,-0.06 -0.046,-0.013 -0.076,-0.051 -0.124,-0.062 -0.054,-0.013 -0.095,-0.009 -0.148,-0.02 -0.028,-0.003 -0.054,-0.009 -0.083,-0.011 -1.835,-0.382 -3.086,0.13 -3.808,0.657 -0.738,0.54 -1.225,1.256 -1.544,1.946 -0.841,-0.812 -1.857,-2.023 -2.513,-3.585 -0.207,-0.497 -0.691,-0.823 -1.228,-0.83 -0.539,-0.034 -1.027,0.308 -1.251,0.798 z m -10.29,-15.1 c 7.315,3.526 16.305,3.916 18.762,3.961 1.176,1.461 2.323,2.856 3.243,3.951 -2.248,0.009 -4.541,0.263 -6.362,0.535 l 0.321,-0.399 c 0.317,-0.395 0.386,-0.934 0.181,-1.397 -0.204,-0.461 -0.652,-0.771 -1.155,-0.802 -9.186,-0.546 -19.304,-3.738 -19.404,-3.773 -0.004,-0.001 -0.008,0 -0.012,-0.001 0,0 -0.004,-0.003 -0.008,-0.004 -1.508,-0.455 -2.386,-1.23 -2.474,-2.179 -0.068,-0.749 0.348,-1.358 0.599,-1.489 1.46,-0.754 4.532,0.735 6.309,1.597 z m 12.784,0.763 c 0.292,-0.21 0.508,-0.511 0.565,-0.871 l 0.396,-2.537 c 0.811,1.18 1.794,2.486 2.808,3.802 -1.047,-0.072 -2.334,-0.196 -3.769,-0.394 z m -2.382,-0.383 c -0.66,-0.122 -1.339,-0.265 -2.026,-0.423 0.061,-0.29 0.025,-0.6 -0.114,-0.879 -0.039,-0.077 -0.074,-0.159 -0.109,-0.243 0.856,0.702 1.647,1.205 2.249,1.545 z m 17.846,-14.772 c -0.615,0.606 -1.695,1.066 -2.705,0.395 -0.774,-0.516 -0.942,-1.411 -0.844,-2.078 0.079,-0.52 0.378,-1.187 0.969,-1.364 0.113,-0.033 0.242,-0.05 0.382,-0.05 0.649,0 1.575,0.34 2.633,0.824 l 0.002,0.003 c 0.686,1.088 -0.243,2.081 -0.437,2.27 z m 51.45,20.256 c 0.387,0.247 0.877,0.277 1.299,0.083 0.417,-0.195 0.706,-0.593 0.767,-1.05 0.225,-1.702 0.641,-2.746 1.238,-3.104 1.078,-0.647 3.69,0.343 6.709,1.487 2.301,0.872 5.166,1.955 8.43,2.755 8.519,2.087 18.534,0.295 27.368,-1.288 2.985,-0.534 5.86,-1.048 8.533,-1.39 5.589,-0.712 11.287,1.628 12.713,5.22 1.077,2.711 -0.578,5.839 -4.659,8.807 -11.313,8.226 -65.482,4.573 -71.005,4.178 -1.469,-1.399 -2.044,-4.263 -2.215,-6.15 0.893,0.285 1.492,0.427 1.569,0.444 0.092,0.02 0.185,0.029 0.278,0.029 0.387,0 0.762,-0.168 1.024,-0.467 0.321,-0.374 0.416,-0.889 0.247,-1.352 -0.844,-2.303 -1.308,-6.558 -1.501,-8.736 0.358,0.098 0.736,0.063 1.054,-0.134 0.352,-0.216 0.585,-0.584 0.634,-0.994 1.6,-13.594 -1.191,-20.682 -2.654,-23.337 0.355,-0.271 0.687,-0.564 1.004,-0.87 0.098,6.425 3.825,11.592 5.349,13.437 -2.721,6.162 1.23,10.791 3.818,12.432 z"
       id="path15" />
    <path
       fill="#ffd250"
       d="M 222.355,66.964 C 221.83,56.063 219.242,38.433 210.97,38.029 c -4.662,-0.215 -6.959,2.655 -7.054,2.778 -0.273,0.354 -0.721,0.553 -1.155,0.531 l -3.161,-0.19 0.566,2.095 c 0.136,0.505 -0.035,1.048 -0.435,1.387 -0.192,0.162 -4.662,4.044 -1.942,8.988 2.072,3.767 8.769,5.55 13.658,6.85 2.183,0.582 4.07,1.084 5.294,1.683 2.182,1.067 4.093,2.867 5.614,4.813 z"
       id="path16" />
    <path
       fill="#464655"
       d="m 211.1,35.326 c -4.757,-0.233 -7.718,2.138 -8.831,3.271 l -4.385,-0.263 c -0.416,-0.033 -0.854,0.16 -1.13,0.497 -0.275,0.337 -0.372,0.786 -0.259,1.207 l 0.842,3.124 c -2.15,2.194 -4.678,6.75 -1.922,11.759 2.628,4.782 9.973,6.735 15.334,8.163 2.047,0.544 3.815,1.015 4.803,1.497 3.17,1.55 5.716,5.076 7.041,7.86 0.227,0.479 0.708,0.771 1.222,0.771 0.097,0 0.194,-0.011 0.292,-0.032 0.615,-0.136 1.054,-0.679 1.06,-1.308 0.014,-1.462 0.187,-35.851 -14.067,-36.546 z m 0.345,25.141 c -4.889,-1.3 -11.586,-3.083 -13.658,-6.85 -2.72,-4.943 1.75,-8.825 1.942,-8.988 0.399,-0.339 0.57,-0.881 0.435,-1.387 l -0.566,-2.095 3.161,0.19 c 0.435,0.023 0.883,-0.177 1.155,-0.531 0.095,-0.124 2.392,-2.994 7.054,-2.778 8.273,0.404 10.86,18.034 11.385,28.935 -1.521,-1.945 -3.432,-3.746 -5.615,-4.813 -1.222,-0.6 -3.11,-1.102 -5.293,-1.683 z"
       id="path17" />
    <path
       fill="#ffd250"
       d="m 448.542,66.964 c 0.525,-10.901 3.113,-28.531 11.385,-28.935 4.662,-0.215 6.959,2.655 7.054,2.778 0.273,0.354 0.721,0.553 1.155,0.531 l 3.161,-0.19 -0.566,2.095 c -0.136,0.505 0.035,1.048 0.435,1.387 0.192,0.162 4.662,4.044 1.942,8.988 -2.072,3.767 -8.769,5.55 -13.658,6.85 -2.183,0.582 -4.07,1.084 -5.294,1.683 -2.182,1.067 -4.094,2.867 -5.614,4.813 z"
       id="path18" />
    <path
       fill="#464655"
       d="m 445.729,71.874 c 0.007,0.629 0.446,1.172 1.06,1.308 0.098,0.021 0.195,0.032 0.292,0.032 0.513,0 0.994,-0.292 1.221,-0.771 1.325,-2.784 3.871,-6.31 7.041,-7.86 0.989,-0.483 2.755,-0.953 4.803,-1.497 5.362,-1.427 12.705,-3.381 15.334,-8.163 2.755,-5.01 0.227,-9.566 -1.922,-11.759 L 474.4,40.04 c 0.113,-0.422 0.015,-0.871 -0.259,-1.207 -0.275,-0.337 -0.714,-0.531 -1.13,-0.497 l -4.385,0.263 c -1.113,-1.131 -4.074,-3.502 -8.831,-3.271 -14.252,0.693 -14.079,35.082 -14.066,36.546 z m 8.428,-9.725 c -2.183,1.068 -4.095,2.869 -5.615,4.813 0.525,-10.901 3.113,-28.531 11.385,-28.935 4.662,-0.215 6.959,2.655 7.054,2.778 0.273,0.354 0.721,0.553 1.155,0.531 l 3.161,-0.19 -0.566,2.095 c -0.136,0.505 0.035,1.048 0.435,1.387 0.192,0.162 4.662,4.044 1.942,8.988 -2.072,3.767 -8.769,5.55 -13.658,6.85 -2.181,0.582 -4.069,1.084 -5.293,1.683 z"
       id="path19" />
    <path
       fill="#ffd250"
       d="m 448.542,268.484 c 0.525,10.901 3.113,28.531 11.385,28.935 4.662,0.215 6.959,-2.655 7.054,-2.779 0.273,-0.354 0.721,-0.553 1.155,-0.531 l 3.161,0.19 -0.566,-2.095 c -0.136,-0.505 0.035,-1.048 0.435,-1.387 0.192,-0.162 4.662,-4.044 1.942,-8.988 -2.072,-3.767 -8.769,-5.55 -13.658,-6.85 -2.183,-0.582 -4.07,-1.084 -5.294,-1.683 -2.182,-1.065 -4.094,-2.866 -5.614,-4.812 z"
       id="path20" />
    <path
       fill="#464655"
       d="m 459.797,300.122 c 4.757,0.233 7.717,-2.138 8.831,-3.271 l 4.385,0.263 c 0.416,0.033 0.854,-0.16 1.13,-0.497 0.275,-0.337 0.372,-0.786 0.259,-1.207 l -0.842,-3.124 c 2.15,-2.194 4.678,-6.75 1.922,-11.759 -2.628,-4.782 -9.973,-6.735 -15.334,-8.163 -2.047,-0.544 -3.815,-1.015 -4.803,-1.497 -3.17,-1.55 -5.716,-5.076 -7.041,-7.86 -0.227,-0.479 -0.708,-0.771 -1.221,-0.771 -0.097,0 -0.194,0.011 -0.292,0.032 -0.615,0.136 -1.054,0.679 -1.06,1.308 -0.015,1.462 -0.188,35.851 14.066,36.546 z m -0.345,-25.141 c 4.889,1.3 11.586,3.083 13.658,6.85 2.72,4.943 -1.75,8.825 -1.942,8.988 -0.399,0.339 -0.57,0.881 -0.435,1.387 l 0.566,2.095 -3.161,-0.19 c -0.435,-0.023 -0.883,0.177 -1.155,0.531 -0.095,0.124 -2.392,2.994 -7.054,2.778 -8.273,-0.404 -10.86,-18.034 -11.385,-28.935 1.521,1.945 3.432,3.746 5.615,4.813 1.222,0.6 3.11,1.102 5.293,1.683 z"
       id="path21" />
    <path
       fill="#ffd250"
       d="m 222.355,268.484 c -0.525,10.901 -3.113,28.531 -11.385,28.935 -4.662,0.215 -6.959,-2.655 -7.054,-2.779 -0.273,-0.354 -0.721,-0.553 -1.155,-0.531 l -3.161,0.19 0.566,-2.095 c 0.136,-0.505 -0.035,-1.048 -0.435,-1.387 -0.192,-0.162 -4.662,-4.044 -1.942,-8.988 2.072,-3.767 8.769,-5.55 13.658,-6.85 2.183,-0.582 4.07,-1.084 5.294,-1.683 2.182,-1.065 4.093,-2.866 5.614,-4.812 z"
       id="path22" />
    <path
       fill="#464655"
       d="m 225.167,263.574 c -0.007,-0.629 -0.446,-1.172 -1.06,-1.308 -0.098,-0.021 -0.195,-0.032 -0.292,-0.032 -0.513,0 -0.994,0.292 -1.222,0.771 -1.325,2.784 -3.871,6.31 -7.041,7.86 -0.989,0.483 -2.755,0.953 -4.803,1.497 -5.362,1.427 -12.705,3.381 -15.334,8.163 -2.755,5.01 -0.227,9.566 1.922,11.759 l -0.842,3.124 c -0.113,0.422 -0.015,0.871 0.259,1.207 0.275,0.337 0.714,0.531 1.13,0.497 l 4.385,-0.263 c 1.113,1.131 4.074,3.502 8.831,3.271 14.254,-0.693 14.081,-35.082 14.067,-36.546 z m -8.428,9.726 c 2.183,-1.068 4.095,-2.869 5.615,-4.813 -0.525,10.901 -3.113,28.531 -11.385,28.935 -4.662,0.215 -6.959,-2.655 -7.054,-2.778 -0.273,-0.354 -0.721,-0.553 -1.155,-0.531 l -3.161,0.19 0.566,-2.095 c 0.136,-0.505 -0.035,-1.048 -0.435,-1.387 -0.192,-0.162 -4.662,-4.044 -1.942,-8.988 2.072,-3.767 8.769,-5.55 13.658,-6.85 2.182,-0.583 4.07,-1.085 5.293,-1.683 z"
       id="path23" />
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs23" />
    <path
       fill="#ff4b55"
       d="M 512,30.496 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <rect
       y="30.504999"
       fill="#f5f5f5"
       width="512"
       height="30.495001"
       id="rect1"
       x="0" />
    <rect
       y="60.985001"
       fill="#ff4b55"
       width="512"
       height="30.495001"
       id="rect2"
       x="0" />
    <rect
       y="91.485001"
       fill="#f5f5f5"
       width="512"
       height="30.495001"
       id="rect3"
       x="0" />
    <path
       fill="#ff4b55"
       d="M 512,152.478 H 8.828 C 3.953,152.478 0,148.525 0,143.65 v -21.667 h 512 z"
       id="path3" />
    <polygon
       fill="#f5f5f5"
       points="0,229.518 8.826,229.518 8.828,240.754 512,240.754 512,271.248 0,271.248 "
       id="polygon3"
       transform="translate(0,-88.276)" />
    <rect
       y="182.97501"
       fill="#ff4b55"
       width="512"
       height="30.495001"
       id="rect4"
       x="0" />
    <rect
       y="213.465"
       fill="#f5f5f5"
       width="512"
       height="30.495001"
       id="rect5"
       x="0" />
    <rect
       y="243.965"
       fill="#ff4b55"
       width="512"
       height="30.495001"
       id="rect6"
       x="0" />
    <rect
       y="274.465"
       fill="#f5f5f5"
       width="512"
       height="30.495001"
       id="rect7"
       x="0" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 v -21.667 h 512 v 21.667 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path7" />
    <path
       fill="#41479b"
       d="M 141.241,152.478 H 8.828 C 3.953,152.478 0,148.525 0,143.65 V 8.828 C 0,3.953 3.953,0 8.828,0 h 132.414 c 4.875,0 8.828,3.953 8.828,8.828 V 143.65 c -0.001,4.875 -3.954,8.828 -8.829,8.828 z"
       id="path8" />
    <path
       fill="#f5f5f5"
       d="m 72.512,39.462 -8.428,25.27 -26.638,0.206 c -2.554,0.02 -3.614,3.279 -1.559,4.797 l 21.429,15.825 -8.035,25.398 c -0.77,2.435 2.003,4.45 4.081,2.965 l 21.674,-15.49 21.672,15.49 c 2.078,1.485 4.851,-0.53 4.081,-2.965 L 92.754,85.56 114.183,69.735 c 2.055,-1.517 0.995,-4.778 -1.559,-4.797 L 85.986,64.732 77.558,39.462 c -0.81,-2.424 -4.237,-2.424 -5.046,0 z"
       id="path9" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#73af00"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#41479b"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#464655"
       d="m 286.477,187.637 -2.052,1.045 c -0.279,0.142 -0.58,0.265 -0.865,0.403 l -18.127,-22.898 c 3.726,-8.099 5.934,-19.153 5.934,-24.178 0,-8.257 -5.418,-15.136 -12.547,-16.591 -0.477,-1.077 -1.551,-1.831 -2.805,-1.831 -1.254,0 -2.328,0.754 -2.805,1.831 -7.128,1.455 -12.547,8.335 -12.547,16.591 0,5.025 2.209,16.078 5.934,24.178 l -18.126,22.898 c -0.282,-0.137 -0.583,-0.259 -0.861,-0.401 l -2.052,-1.045 -7.658,15.054 2.052,1.044 c 10.451,5.316 22.921,8.126 36.063,8.126 13.143,0 25.617,-2.812 36.07,-8.127 l 2.052,-1.044 z m -18.181,-45.628 c 0,3.735 -1.387,11.586 -3.957,18.783 -0.339,0.948 -0.686,1.847 -1.042,2.699 l -2.677,-3.382 V 148.15 h 4.606 l -6.141,-6.141 v -13.363 c 5.288,1.54 9.211,6.938 9.211,13.363 z m -20.606,18.782 c -2.57,-7.197 -3.957,-15.048 -3.957,-18.783 0,-6.424 3.923,-11.822 9.212,-13.363 v 13.363 l -6.141,6.141 h 4.606 v 11.959 l -2.677,3.382 c -0.357,-0.851 -0.704,-1.751 -1.043,-2.699 z m -20.648,34.084 0.627,2.579 -2.251,0.614 z m -2.679,5.869 3.851,-1.05 0.707,2.91 c -1.553,-0.574 -3.08,-1.183 -4.558,-1.86 z m 5.839,-5.866 c 1.752,0.693 3.575,1.304 5.449,1.849 l 0.554,1.698 -4.849,1.196 z m 2.164,8.9 -0.467,-1.919 5.022,-1.239 1.557,4.771 c -2.083,-0.453 -4.121,-0.994 -6.112,-1.613 z m 6.816,-6.127 c 1.927,0.449 3.889,0.836 5.892,1.129 l 0.834,1.492 -5.33,1.661 z m 2.742,8.405 -0.631,-1.933 5.763,-1.796 2.612,4.671 c -2.627,-0.196 -5.211,-0.508 -7.744,-0.942 z m 6.923,-6.823 c 2.366,0.224 4.759,0.348 7.167,0.348 0.513,0 1.023,-0.028 1.535,-0.039 l 0.641,0.983 -7.084,2.748 z m 7.167,8.024 c -0.913,0 -1.814,-0.039 -2.719,-0.067 l -1.055,-1.887 7.235,-2.806 2.933,4.497 c -2.109,0.156 -4.236,0.263 -6.394,0.263 z m 5.098,-7.87 c 2.434,-0.163 4.839,-0.44 7.199,-0.831 l 0.691,0.883 -5.608,3.446 z m 4.748,7.28 -1.208,-1.853 5.778,-3.55 3.212,4.107 c -2.536,0.557 -5.134,0.987 -7.782,1.296 z m 5.846,-8.754 c 2.008,-0.433 3.974,-0.941 5.878,-1.536 l 0.715,0.926 -4.077,3.827 z m 5.22,6.673 -1.28,-1.636 4.067,-3.817 2.835,3.671 c -1.833,0.66 -3.7,1.268 -5.622,1.782 z m 3.726,-9.26 c 1.293,-0.48 2.564,-0.985 3.786,-1.54 l 0.6,1.181 -1.962,3.5 z m 4.886,6.327 -0.931,-1.206 1.688,-3.011 1.628,3.2 c -0.779,0.36 -1.585,0.685 -2.385,1.017 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#73af00"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LU = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#82afff"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LV = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs15" />
    <path
       fill="#c8414b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <rect
       y="136.825"
       fill="#f5f5f5"
       width="512"
       height="61.792999"
       id="rect1"
       x="0" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const LY = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#73af00"
       d="m 0,247.172 h 512 v 79.448 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 88.276 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="88.274002"
       fill="#464655"
       width="512"
       height="158.89999"
       id="rect2"
       x="0" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 306.058,227.432 13.286,17.379 20.745,-6.944 c 1.16,-0.388 2.146,0.924 1.452,1.93 l -12.424,18.006 13.014,17.583 c 0.727,0.983 -0.215,2.327 -1.387,1.977 l -20.963,-6.251 -12.701,17.811 c -0.711,0.996 -2.28,0.514 -2.31,-0.708 l -0.533,-21.869 -20.864,-6.575 c -1.166,-0.367 -1.194,-2.008 -0.04,-2.415 l 20.634,-7.264 -0.193,-21.875 c -0.011,-1.224 1.541,-1.757 2.284,-0.785 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 270.001,298.898 c -23.672,0 -42.876,-19.203 -42.876,-42.898 0,-23.65 19.203,-42.897 42.876,-42.897 8.808,0 16.93,2.709 23.699,7.294 1.036,0.702 2.22,-0.66 1.352,-1.562 -10.116,-10.517 -24.434,-16.934 -40.309,-16.392 -27.274,0.93 -49.852,22.797 -51.594,50.031 -1.996,31.194 22.703,57.118 53.455,57.118 15.148,0 28.762,-6.333 38.485,-16.459 0.858,-0.895 -0.327,-2.236 -1.354,-1.54 -6.776,4.592 -14.911,7.305 -23.734,7.305 z"
       id="path4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#5a8250"
       d="m 297.951,189.686 67.433,-49.478 H 281.875 L 256,60.57 230.125,140.208 h -83.509 l 67.433,49.478 -25.675,79.022 67.56,-48.289 0.066,0.047 0.066,-0.047 67.56,48.289 z m 13.527,-31.823 -19.273,14.141 -4.595,-14.141 z m -76.694,25.139 8.169,-25.14 h 26.094 l 8.169,25.14 L 256,198.57 Z M 256,117.708 l 7.31,22.5 h -14.622 z m -55.478,40.155 h 23.868 l -4.595,14.141 z m 21.215,65.293 7.302,-22.472 11.911,8.739 z m 61.225,-22.472 7.302,22.472 -19.212,-13.732 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 0,167.725 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.45 0,331.497 0,326.622 Z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const MD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs45" />
    <path
       fill="#ff4b55"
       d="M 341.333,0 H 503.172 C 508.047,0 512,3.953 512,8.828 v 317.793 c 0,4.875 -3.953,8.828 -8.828,8.828 H 341.333 Z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#ffe15a"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#41479b"
       d="M 8.828,0 H 170.667 V 335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       x="-84.098381"
       y="-358.41977"
       transform="rotate(140.80775)"
       fill="#ffcd5a"
       width="5.6657805"
       height="31.666775"
       id="rect2" />
    <rect
       x="-87.054054"
       y="-340.65308"
       transform="rotate(140.83194)"
       fill="#ffbe5a"
       width="11.329049"
       height="13.93706"
       id="rect3" />
    <rect
       x="314.62241"
       y="1.6565002"
       transform="rotate(39.192248)"
       fill="#ffcd5a"
       width="5.6657805"
       height="31.666775"
       id="rect4" />
    <rect
       x="311.78876"
       y="1.7994183"
       transform="rotate(39.168065)"
       fill="#ffbe5a"
       width="11.329049"
       height="13.93706"
       id="rect5" />
    <polygon
       fill="#ffe15a"
       points="255.805,340.073 255.805,300.416 250.14,297.583 235.977,325.91 "
       id="polygon5"
       transform="translate(0,-88.273)" />
    <polygon
       fill="#ffcd5a"
       points="255.805,340.073 255.805,300.416 261.471,297.583 275.634,325.91 "
       id="polygon6"
       transform="translate(0,-88.273)" />
    <path
       fill="#ffbe5a"
       d="m 216.148,209.31 v -73.65 h 8.498 c 0,0 0,48.156 0,56.653 0,8.499 -8.498,16.997 -8.498,16.997 z"
       id="path6" />
    <path
       fill="#ffcd5a"
       d="M 210.482,223.474 V 135.66 h 8.498 c 0,0 0,62.319 0,70.817 -10e-4,8.498 -8.498,16.997 -8.498,16.997 z"
       id="path7" />
    <path
       fill="#ffe15a"
       d="m 204.817,234.805 v -99.144 h 8.498 c 0,0 0,73.65 0,82.148 0,8.497 -8.498,16.996 -8.498,16.996 z"
       id="path8" />
    <path
       fill="#ff4b55"
       d="m 224.646,138.493 c 0,0 0,40.365 0,53.821 0,14.164 20.537,12.275 31.159,22.661 10.623,-10.387 31.159,-8.498 31.159,-22.661 0,-13.455 0,-53.821 0,-53.821 z"
       id="path9" />
    <path
       fill="#41479b"
       d="m 224.646,169.653 c 0,8.968 0,17.668 0,22.662 0,14.164 20.537,12.275 31.159,22.661 10.623,-10.387 31.159,-8.498 31.159,-22.662 0,-4.993 0,-13.694 0,-22.662 z"
       id="path10" />
    <g
       id="g16"
       transform="translate(0,-88.273)">
    	<polygon
       fill="#ffe15a"
       points="247.307,286.252 250.14,283.42 250.14,266.423 241.642,260.758 250.14,249.427 252.972,249.427 255.805,252.261 258.638,249.427 261.471,249.427 269.969,260.758 261.471,266.423 261.471,283.42 264.303,286.252 264.303,289.085 255.805,294.75 247.307,289.085 "
       id="polygon10" />
    	<path
       fill="#ffe15a"
       d="m 244.474,229.599 c 0,0 -11.33,2.833 -11.33,14.164 0,11.331 11.33,16.996 11.33,16.996 l 5.665,-8.498 c -16.996,-5.666 -5.665,-22.662 -5.665,-22.662 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 267.136,229.599 c 0,0 11.33,2.833 11.33,14.164 0,11.331 -11.33,16.996 -11.33,16.996 l -5.665,-8.498 c 16.995,-5.666 5.665,-22.662 5.665,-22.662 z"
       id="path12" />
    	<polygon
       fill="#ffe15a"
       points="238.809,257.926 233.143,255.093 227.478,257.926 233.143,260.758 "
       id="polygon12" />
    	<polygon
       fill="#ffe15a"
       points="284.132,257.926 278.466,255.093 272.801,257.926 278.466,260.758 "
       id="polygon13" />
    	<polygon
       fill="#ffe15a"
       points="260.812,233.089 260.778,236.037 262.887,238.097 260.778,240.156 260.812,243.104 257.865,243.069 255.805,245.179 253.746,243.069 250.797,243.104 250.833,240.156 248.724,238.097 250.833,236.037 250.797,233.089 253.746,233.125 255.805,231.015 257.865,233.125 "
       id="polygon14" />
    	<path
       fill="#ffe15a"
       d="m 236.568,270.297 2.042,2.272 2.84,-1.126 c 1.471,-0.583 2.851,1.016 2.059,2.386 l -1.529,2.645 1.949,2.354 c 1.009,1.218 -0.086,3.026 -1.633,2.696 l -2.988,-0.638 -1.636,2.581 c -0.847,1.336 -2.904,0.853 -3.069,-0.721 l -0.318,-3.039 -2.959,-0.758 c -1.533,-0.393 -1.709,-2.498 -0.264,-3.14 l 2.792,-1.24 -0.193,-3.049 c -0.097,-1.582 1.85,-2.4 2.907,-1.223 z"
       id="path14" />
    	<path
       fill="#ffe15a"
       d="m 274.297,276.755 c 0.625,-3.222 3.283,-5.503 6.382,-5.847 -0.636,-0.342 -1.312,-0.625 -2.057,-0.769 -3.968,-0.769 -7.808,1.824 -8.577,5.791 -0.769,3.968 1.823,7.808 5.791,8.577 0.746,0.145 1.479,0.136 2.195,0.056 -2.745,-1.477 -4.358,-4.586 -3.734,-7.808 z"
       id="path15" />
    	<path
       fill="#ffe15a"
       d="m 244.474,226.766 5.665,-28.327 -11.33,-8.498 2.833,-2.833 h 5.665 c 0,0 2.833,-2.833 8.498,-2.833 5.665,0 11.33,2.833 11.33,11.33 0,8.497 2.833,31.159 2.833,31.159 h -25.494 z"
       id="path16" />
    </g>
    <path
       fill="#ffaa5a"
       d="m 224.646,127.162 c -6.258,0 -11.33,5.073 -11.33,11.33 h 22.662 c -0.001,-6.257 -5.075,-11.33 -11.332,-11.33 z"
       id="path17" />
    <g
       id="g19"
       transform="translate(0,-88.273)">
    	<path
       fill="#ffbe5a"
       d="m 221.813,226.766 h -16.996 v -18.855 c 0,-3.667 2.973,-6.639 6.639,-6.639 h 3.718 c 3.667,0 6.639,2.973 6.639,6.639 z"
       id="path18" />
    	<path
       fill="#ffbe5a"
       d="m 295.463,297.583 v -73.65 h -8.498 c 0,0 0,48.156 0,56.653 0,8.499 8.498,16.997 8.498,16.997 z"
       id="path19" />
    </g>
    <path
       fill="#ffcd5a"
       d="M 301.128,223.474 V 135.66 h -8.498 c 0,0 0,62.319 0,70.817 0,8.498 8.498,16.997 8.498,16.997 z"
       id="path20" />
    <path
       fill="#ffe15a"
       d="m 306.794,234.805 v -99.144 h -8.498 c 0,0 0,73.65 0,82.148 -10e-4,8.497 8.498,16.996 8.498,16.996 z"
       id="path21" />
    <path
       fill="#ffaa5a"
       d="m 286.965,127.162 c 6.258,0 11.33,5.073 11.33,11.33 h -22.662 c 0.001,-6.257 5.074,-11.33 11.332,-11.33 z"
       id="path22" />
    <path
       fill="#ffbe5a"
       d="m 289.798,138.493 h 16.996 v -18.855 c 0,-3.667 -2.973,-6.639 -6.639,-6.639 h -3.717 c -3.667,0 -6.639,2.973 -6.639,6.639 z"
       id="path23" />
    <rect
       x="360.09613"
       y="-21.939537"
       transform="rotate(31.33912)"
       fill="#ffaa5a"
       width="4.2489805"
       height="76.269646"
       id="rect23" />
    <rect
       x="-9.8273172"
       y="-369.91577"
       transform="rotate(128.63833)"
       fill="#ffe15a"
       width="11.330958"
       height="8.8609667"
       id="rect24" />
    <rect
       x="358.64667"
       y="-21.837717"
       transform="rotate(31.326352)"
       fill="#ffcd5a"
       width="7.0818357"
       height="16.34362"
       id="rect25" />
    <g
       id="g26"
       transform="translate(0,-88.273)">
    	
    		<rect
       x="176.231"
       y="290.32901"
       transform="matrix(0.5429,0.8398,-0.8398,0.5429,342.3956,-45.5664)"
       fill="#73af00"
       width="73.650002"
       height="2.8329999"
       id="rect26" />
    	<path
       fill="#73af00"
       d="m 219.413,289.383 c -1.016,1.152 -1.69,2.899 -1.86,4.913 -1.397,-1.41 -3.001,-2.308 -4.495,-2.549 -0.394,1.461 -0.234,3.293 0.479,5.145 -1.907,-0.672 -3.775,-0.775 -5.242,-0.321 0.413,2.088 2.114,4.354 4.721,5.909 2.606,1.556 5.409,1.976 7.442,1.348 l 0.582,-0.376 c 1.407,-1.597 2.174,-4.324 1.826,-7.339 -0.351,-3.015 -1.72,-5.496 -3.453,-6.73 z"
       id="path26" />
    </g>
    <circle
       fill="#ff4b55"
       cx="220.75"
       cy="215.37401"
       r="2.8329999"
       id="circle26" />
    <path
       fill="#73af00"
       d="m 208.648,184.458 c -1.016,1.152 -1.69,2.899 -1.86,4.913 -1.397,-1.41 -3.001,-2.308 -4.495,-2.549 -0.394,1.461 -0.234,3.293 0.479,5.145 -1.907,-0.672 -3.775,-0.775 -5.242,-0.321 0.413,2.088 2.114,4.354 4.721,5.909 2.606,1.556 5.409,1.976 7.442,1.348 l 0.582,-0.376 c 1.407,-1.597 2.174,-4.324 1.826,-7.339 -0.35,-3.016 -1.719,-5.497 -3.453,-6.73 z"
       id="path27" />
    <circle
       fill="#ff4b55"
       cx="209.99001"
       cy="198.72401"
       r="2.8329999"
       id="circle27" />
    <path
       fill="#73af00"
       d="m 197.884,167.806 c -1.016,1.152 -1.69,2.899 -1.86,4.913 -1.397,-1.41 -3.001,-2.308 -4.495,-2.549 -0.394,1.461 -0.234,3.293 0.479,5.145 -1.907,-0.672 -3.775,-0.775 -5.242,-0.321 0.413,2.088 2.114,4.354 4.721,5.909 2.606,1.556 5.409,1.976 7.442,1.348 l 0.582,-0.376 c 1.407,-1.597 2.174,-4.324 1.826,-7.339 -0.352,-3.016 -1.72,-5.497 -3.453,-6.73 z"
       id="path28" />
    <circle
       fill="#ff4b55"
       cx="199.22"
       cy="182.07399"
       r="2.8329999"
       id="circle28" />
    <g
       id="g30"
       transform="translate(0,-88.273)">
    	
    		<rect
       x="220.70399"
       y="308.815"
       transform="matrix(0.6244,0.7811,-0.7811,0.6244,329.7009,-59.1636)"
       fill="#ffe15a"
       width="11.331"
       height="8.8610001"
       id="rect28" />
    	<rect
       x="238.81"
       y="178.617"
       fill="#ffe15a"
       width="2.8329999"
       height="19.829"
       id="rect29" />
    	<rect
       x="235.97"
       y="181.44701"
       fill="#ffe15a"
       width="8.4980001"
       height="2.8329999"
       id="rect30" />
    </g>
    <polygon
       fill="#ff875a"
       points="247.307,187.109 241.642,187.109 238.809,189.941 247.307,196.315 "
       id="polygon30"
       transform="translate(0,-88.273)" />
    <path
       fill="#ffaa5a"
       d="m 241.642,90.337 v 2.833 h 2.833 v 2.833 h -2.833 v 2.833 h 5.665 c 0,0 2.833,-2.833 8.498,-2.833 5.665,0 11.33,2.833 11.33,11.33 0,8.498 2.833,31.159 2.833,31.159 h 5.665 c 0,-6.258 5.073,-11.33 11.33,-11.33 0.984,0 1.922,0.164 2.833,0.401 v -6.066 c 0,-4.693 3.805,-8.498 8.498,-8.498 4.693,0 8.498,3.805 8.498,8.498 v 14.164 2.833 50.026 l 3.658,-6.009 -1.209,-0.736 8.498,-13.962 1.209,0.736 v 0 l 1.815,1.106 3.025,1.841 -8.498,13.962 -1.21,-0.736 -7.288,11.974 v 38.113 c 0,0 -6.764,-6.783 -8.212,-14.287 -1.035,-1.33 -2.227,-3.026 -3.276,-4.952 l -3.242,5.326 3.014,2.409 -7.075,8.851 -1.879,-1.502 -3.202,5.261 -3.629,-2.21 3.485,-5.726 -1.692,-1.353 2.409,-3.015 -7.433,-9.116 -2.197,1.79 -6.609,-8.11 c -1.759,0.707 -3.498,1.484 -5.171,2.372 l 13.547,27.095 -19.829,14.164 -19.829,-14.164 13.547,-27.095 c -1,-0.531 -2.016,-1.034 -3.055,-1.492 l -5.891,7.23 -2.197,-1.79 -7.433,9.116 2.409,3.015 -2.406,1.923 3.288,5.086 -2.379,1.538 -3.133,-4.846 -2.287,1.828 -7.075,-8.851 3.179,-2.541 -1.685,-2.607 c -0.04,0.001 -0.079,0.002 -0.119,0.002 -0.926,0 -1.833,-0.413 -2.372,-1.248 -0.23,-0.355 -0.354,-0.743 -0.409,-1.135 -0.533,-0.032 -1.073,-0.108 -1.635,-0.242 -1.053,1.941 -2.253,3.65 -3.294,4.989 -1.447,7.505 -8.212,14.287 -8.212,14.287 v -36.135 c -0.856,-0.269 -1.719,-0.611 -2.568,-1.118 -2.606,-1.556 -4.308,-3.822 -4.721,-5.909 0.596,-0.184 1.257,-0.276 1.961,-0.276 1.03,0 2.15,0.199 3.282,0.597 -0.369,-0.96 -0.584,-1.91 -0.655,-2.81 l -2.786,-4.31 c -0.04,10e-4 -0.079,0.002 -0.119,0.002 -0.926,0 -1.833,-0.413 -2.372,-1.248 -0.23,-0.355 -0.354,-0.743 -0.41,-1.135 -1.568,-0.094 -3.286,-0.574 -4.943,-1.562 -2.606,-1.556 -4.308,-3.822 -4.721,-5.909 0.596,-0.184 1.258,-0.276 1.961,-0.276 1.03,0 2.15,0.198 3.282,0.597 -0.713,-1.853 -0.873,-3.684 -0.479,-5.145 1.494,0.241 3.098,1.139 4.495,2.549 0.17,-2.014 0.844,-3.761 1.859,-4.913 1.734,1.234 3.102,3.715 3.45,6.731 0.222,1.918 -0.046,3.681 -0.605,5.15 0.335,0.213 0.638,0.484 0.867,0.84 0.563,0.871 0.543,1.918 0.113,2.783 l 2.786,4.31 c 0.108,0.06 0.214,0.132 0.322,0.199 V 138.497 135.664 121.5 c 0,-4.693 3.805,-8.498 8.498,-8.498 4.693,0 8.498,3.805 8.498,8.498 v 6.066 c 0.91,-0.236 1.848,-0.401 2.833,-0.401 6.258,0 11.33,5.073 11.33,11.33 h 8.498 l 5.665,-28.327 -2.833,-2.124 -5.665,-4.249 v 6.374 h -2.833 V 96.005 h -2.833 v -2.833 h 2.833 v -2.833 h 2.844 m 45.467,128.741 1.046,-1.309 0.557,0.445 4.566,-7.501 c -0.398,-1.387 -0.653,-2.81 -0.653,-4.237 0,-0.139 0,-0.33 0,-0.498 -2.472,-3.252 -5.665,-8.455 -5.665,-13.666 0,5.966 -3.662,9.074 -8.674,11.462 l 4.36,5.351 -2.195,1.788 6.658,8.165 m -62.345,-0.1 1.514,-1.21 1.046,1.309 6.658,-8.167 -2.195,-1.788 3.605,-4.424 c -6.051,-2.527 -10.752,-5.623 -10.752,-12.387 0,3.793 -1.693,7.578 -3.567,10.616 0.89,1.306 1.561,2.976 1.785,4.91 0.222,1.918 -0.046,3.681 -0.605,5.15 0.335,0.213 0.638,0.484 0.867,0.84 0.563,0.871 0.543,1.917 0.113,2.783 l 1.531,2.368 M 241.642,88.213 h -2.833 c -1.173,0 -2.124,0.951 -2.124,2.124 v 0.708 h -0.708 c -1.173,0 -2.124,0.951 -2.124,2.124 v 2.833 c 0,1.173 0.951,2.124 2.124,2.124 h 0.708 v 12.039 c 0,1.173 0.951,2.124 2.124,2.124 h 2.833 c 1.173,0 2.124,-0.951 2.124,-2.124 v -2.124 l 2.266,1.699 1.761,1.321 -5.062,25.306 h -4.799 c -1.022,-6.413 -6.591,-11.33 -13.288,-11.33 -0.235,0 -0.47,0.008 -0.708,0.022 v -3.563 c 0,-5.857 -4.766,-10.623 -10.623,-10.623 -5.857,0 -10.623,4.766 -10.623,10.623 v 14.164 2.833 32.578 c -0.767,-2.115 -2.014,-3.885 -3.577,-4.998 -0.372,-0.265 -0.803,-0.394 -1.23,-0.394 -0.591,0 -1.177,0.246 -1.594,0.719 -0.654,0.743 -1.192,1.647 -1.593,2.667 -0.93,-0.504 -1.887,-0.844 -2.831,-0.996 -0.114,-0.019 -0.227,-0.028 -0.339,-0.028 -0.945,0 -1.795,0.632 -2.049,1.571 -0.249,0.922 -0.332,1.934 -0.254,2.989 -0.167,-0.008 -0.333,-0.012 -0.498,-0.012 -0.92,0 -1.791,0.125 -2.588,0.371 -1.039,0.321 -1.668,1.375 -1.458,2.442 0.55,2.776 2.686,5.514 5.716,7.321 1.398,0.834 2.916,1.406 4.457,1.685 0.062,0.117 0.129,0.231 0.201,0.342 0.697,1.079 1.791,1.821 3.042,2.098 l 1.548,2.395 c -0.052,-0.001 -0.103,-0.001 -0.154,-0.001 -0.92,0 -1.791,0.125 -2.588,0.371 -1.039,0.321 -1.668,1.375 -1.458,2.442 0.55,2.776 2.686,5.514 5.716,7.321 0.484,0.289 0.988,0.545 1.532,0.776 V 234.8 c 0,0.86 0.519,1.635 1.313,1.963 0.263,0.108 0.538,0.161 0.811,0.161 0.554,0 1.098,-0.216 1.505,-0.625 0.289,-0.289 6.952,-7.042 8.689,-14.879 0.714,-0.939 1.374,-1.886 1.974,-2.834 0.684,0.79 1.609,1.335 2.643,1.565 l 0.092,0.141 -1.678,1.342 c -0.44,0.352 -0.723,0.864 -0.785,1.425 -0.063,0.559 0.1,1.122 0.452,1.562 l 7.075,8.851 c 0.352,0.44 0.864,0.723 1.425,0.785 0.078,0.009 0.157,0.013 0.235,0.013 0.48,0 0.948,-0.162 1.326,-0.465 l 0.452,-0.361 1.857,2.873 c 0.306,0.473 0.787,0.806 1.338,0.924 0.148,0.032 0.297,0.047 0.446,0.047 0.406,0 0.808,-0.116 1.153,-0.341 l 1.374,-0.888 -0.311,0.623 c -0.468,0.935 -0.185,2.071 0.665,2.679 l 19.829,14.164 c 0.37,0.264 0.802,0.396 1.235,0.396 0.433,0 0.865,-0.132 1.235,-0.396 l 19.829,-14.164 c 0.851,-0.608 1.133,-1.743 0.665,-2.679 l -12.597,-25.195 c 0.534,-0.252 1.091,-0.502 1.674,-0.753 l 5.609,6.883 c 0.42,0.515 1.032,0.782 1.649,0.782 0.472,0 0.947,-0.157 1.341,-0.478 l 0.551,-0.448 5.006,6.14 -1.338,1.674 c -0.352,0.44 -0.514,1.002 -0.452,1.562 0.063,0.561 0.345,1.073 0.785,1.425 l 0.232,0.185 -2.514,4.129 c -0.61,1.002 -0.292,2.308 0.71,2.919 l 3.629,2.21 c 0.335,0.204 0.718,0.31 1.106,0.31 0.168,0 0.337,-0.02 0.502,-0.061 0.547,-0.134 1.02,-0.478 1.313,-0.96 l 1.947,-3.199 c 0.391,0.309 0.855,0.459 1.318,0.459 0.623,0 1.241,-0.274 1.661,-0.798 l 7.075,-8.851 c 0.26,-0.326 0.409,-0.705 0.452,-1.09 2.308,6.903 7.838,12.506 8.1,12.769 0.406,0.407 0.951,0.625 1.505,0.625 0.274,0 0.548,-0.053 0.811,-0.161 0.794,-0.329 1.313,-1.103 1.313,-1.963 V 197.28 l 5.937,-9.752 c 0.145,0.03 0.29,0.045 0.435,0.045 0.717,0 1.417,-0.363 1.817,-1.021 l 8.498,-13.962 c 0.294,-0.481 0.383,-1.059 0.249,-1.607 -0.134,-0.547 -0.479,-1.02 -0.96,-1.313 l -3.025,-1.841 -1.814,-1.105 -1.212,-0.737 c -0.344,-0.21 -0.726,-0.309 -1.101,-0.309 -0.717,0 -1.417,0.363 -1.816,1.021 l -7.007,11.512 v -39.725 -2.833 -14.159 c 0,-5.857 -4.766,-10.623 -10.623,-10.623 -5.857,0 -10.623,4.766 -10.623,10.623 v 3.563 c -0.237,-0.014 -0.473,-0.022 -0.708,-0.022 -6.697,0 -12.266,4.917 -13.288,11.33 h -1.827 c -0.67,-5.577 -2.59,-22.173 -2.59,-29.035 0,-9.92 -6.951,-13.455 -13.455,-13.455 -4.817,0 -7.925,1.836 -9.258,2.833 h -0.07 c 0.078,-0.222 0.121,-0.46 0.121,-0.708 v -2.833 c 0,-1.173 -0.951,-2.124 -2.124,-2.124 h -0.708 v -0.708 c -0.005,-1.171 -0.956,-2.122 -2.129,-2.122 z M 223.55,202.926 c 0.544,-0.957 1.018,-1.901 1.426,-2.831 1.771,2.377 4.319,4.067 7.031,5.405 l -1.86,2.283 c -0.356,0.437 -0.524,0.997 -0.467,1.558 0.057,0.561 0.334,1.076 0.771,1.431 l 0.546,0.446 -3.785,4.642 c -0.216,-0.106 -0.451,-0.174 -0.695,-0.202 -0.078,-0.009 -0.158,-0.013 -0.235,-0.013 -0.212,0 -0.42,0.032 -0.621,0.093 0.097,-1.068 -0.156,-2.14 -0.751,-3.062 -0.072,-0.111 -0.149,-0.22 -0.23,-0.324 0.378,-1.519 0.48,-3.138 0.294,-4.756 -0.192,-1.661 -0.679,-3.251 -1.424,-4.67 z m 58.029,1.523 c 1.871,-1.091 3.688,-2.473 5.066,-4.33 1.085,2.477 2.511,4.73 3.861,6.569 0.017,1.183 0.179,2.401 0.491,3.694 l -3.225,5.299 c -0.186,0.034 -0.37,0.094 -0.543,0.179 l -3.785,-4.642 0.546,-0.446 c 0.437,-0.356 0.714,-0.871 0.771,-1.431 0.057,-0.56 -0.11,-1.121 -0.467,-1.558 z m -41.003,13.956 c 0.617,0 1.228,-0.267 1.649,-0.782 l 3.583,-4.396 -9.697,19.394 c -0.026,-0.049 -0.055,-0.097 -0.086,-0.145 l -2.244,-3.473 0.905,-0.724 c 0.44,-0.352 0.723,-0.864 0.785,-1.425 0.063,-0.559 -0.1,-1.122 -0.452,-1.561 l -1.338,-1.674 5.006,-6.141 0.551,0.448 c 0.391,0.324 0.866,0.479 1.338,0.479 z m 54.274,1.993 0.462,-0.76 c 0.406,0.598 0.836,1.194 1.288,1.788 0.04,0.179 0.082,0.356 0.127,0.534 -0.094,-0.116 -0.202,-0.223 -0.323,-0.32 z"
       id="path30" />
    <g
       id="g31"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const ME = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs24" />
    <rect
       x="17.655001"
       y="17.654001"
       fill="#c8414b"
       width="476.69"
       height="300.14001"
       id="rect1" />
    <path
       fill="#e6b432"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.952 0,8.827 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.827 C 512,3.952 508.047,0 503.172,0 Z m -8.827,317.793 H 17.655 V 17.655 h 476.69 z"
       id="path1" />
    <circle
       fill="#41479b"
       cx="328.42999"
       cy="223.09399"
       r="13.433"
       id="circle1" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#e6b432"
       d="m 352.003,234.242 c -9.886,8.311 -16.535,8.661 -16.535,8.661 17.586,-7.174 15.748,-20.822 15.748,-20.822 -8.311,10.936 -16.798,13.998 -16.798,13.998 17.673,-11.986 14.873,-28.084 14.873,-28.084 -5.774,12.774 -13.079,17.76 -13.079,17.76 14.698,-19.554 7.48,-32.152 7.48,-32.152 -5.774,18.11 -10.63,23.36 -10.63,23.36 11.286,-30.184 1.619,-38.889 1.619,-38.889 0,16.185 -6.037,25.459 -6.037,25.459 6.3,-21.347 -3.587,-33.596 -3.587,-33.596 0,0 -0.093,17.404 -3.445,26.52 -0.804,-1.222 -1.28,-1.06 -1.28,-1.06 -1.704,11.179 -7.712,19.049 -10.306,22.01 -0.576,-2.786 -2.308,-3.639 -2.308,-3.639 0,0 -0.312,2.735 -2.766,6.769 -1.608,2.643 -9.204,8.806 -10.429,14.23 -0.982,4.349 3.325,7.961 4.724,8.836 1.4,0.875 2.887,2.45 2.274,4.986 -0.612,2.537 -5.162,2.274 -8.399,2.187 -3.237,-0.087 -3.674,5.249 -7.262,5.075 l -0.608,3.98 -1.405,0.307 c 0,0 -14.698,29.289 -15.949,39.255 l -10.823,1.427 -10.823,-1.427 c -1.251,-9.966 -15.949,-39.255 -15.949,-39.255 l -1.405,-0.307 -0.608,-3.98 c -3.587,0.175 -4.024,-5.162 -7.262,-5.075 -3.238,0.087 -7.787,0.35 -8.399,-2.187 -0.612,-2.537 0.875,-4.113 2.274,-4.986 1.4,-0.875 5.707,-4.488 4.724,-8.836 -1.225,-5.425 -8.821,-11.587 -10.429,-14.23 -2.454,-4.033 -2.766,-6.769 -2.766,-6.769 0,0 -1.732,0.853 -2.308,3.639 -2.593,-2.963 -8.601,-10.831 -10.305,-22.01 0,0 -0.476,-0.161 -1.28,1.06 -3.352,-9.117 -3.445,-26.52 -3.445,-26.52 0,0 -9.886,12.248 -3.587,33.596 0,0 -6.037,-9.273 -6.037,-25.459 0,0 -9.667,8.705 1.619,38.889 0,0 -4.855,-5.249 -10.63,-23.36 0,0 -7.218,12.598 7.48,32.152 0,0 -7.305,-4.986 -13.079,-17.76 0,0 -2.799,16.098 14.873,28.084 0,0 -8.487,-3.062 -16.798,-13.998 0,0 -1.837,13.649 15.748,20.822 0,0 -6.649,-0.35 -16.535,-8.661 0,0 -1.75,12.074 21.172,18.285 0,0 -9.362,-0.175 -18.898,-6.562 0,0 -0.263,11.898 19.335,14.261 0,0 -6.474,0.962 -13.736,-1.662 0,0 0.263,9.623 17.323,10.848 0,0 -6.737,0.525 -11.111,-0.525 0,0 0.437,9.886 13.911,8.224 0,0 -4.55,1.487 -6.037,1.924 0,0 0.263,8.071 14.304,5.184 0,0 -2.494,1.553 -5.906,2.078 0,0 2.887,6.737 14.611,3.762 l -2.406,2.625 c 0,0 9.055,5.249 16.01,-1.969 l -2.494,4.462 c 0,0 5.906,2.231 9.58,-3.543 0,0 -1.006,8.661 -13.255,10.237 0,0 0.437,1.837 0.962,2.537 0,0 -0.788,1.487 -7.874,2.712 0,0 1.487,2.274 3.062,2.975 0,0 -3.062,2.625 -4.724,3.149 0,0 2.625,1.312 4.287,1.575 0,0 -3.674,3.587 -8.224,3.674 -4.55,0.087 -12.685,-0.438 -12.685,-0.438 0,0 -0.087,-4.374 -2.187,-8.137 -2.1,-3.762 -2.799,-4.046 -2.799,-4.046 0,0 0.459,-3.018 -0.853,-4.265 -1.312,-1.247 -2.034,-1.837 -2.034,-1.837 0,0 0.7,-6.037 -1.225,-9.799 -1.924,-3.762 -8.749,-11.986 -9.099,-18.11 -0.35,-6.124 -0.087,-8.399 -0.087,-8.399 l -2.1,0.525 -1.4,-2.887 2.362,-0.263 -0.962,-4.374 -3.238,1.225 -0.438,-3.762 -3.849,1.575 1.924,3.412 -3.412,0.962 2.013,4.024 2.625,-1.662 0.7,3.499 c 0,0 -1.575,0.35 -2.45,1.75 0,0 4.329,2.873 5.599,6.3 2.013,5.425 1.4,17.673 4.287,21.347 2.887,3.674 5.162,6.211 5.162,6.211 0,0 -0.809,2.494 0.109,3.871 0.919,1.378 2.231,1.772 2.231,1.772 0,0 -0.788,5.578 1.247,9.252 2.034,3.674 3.215,4.594 3.215,4.594 0,0 -7.415,4.527 -2.165,9.777 0,0 -0.7,4.768 4.287,5.906 0,0 0.263,3.762 4.55,3.325 0,0 2.1,-0.612 2.625,0.438 0.525,1.049 0,7.086 0,7.086 0,0 1.924,-0.175 3.149,-1.049 l 3.849,1.924 0.087,-4.287 4.812,-1.924 c 0,0 -2.1,0.35 -6.387,-3.674 0,0 0.7,-0.438 1.225,-3.85 0,0 3.412,-2.712 4.113,-4.899 0.7,-2.187 5.512,-6.999 11.111,-8.574 l 0.766,3.412 c 0,0 8.006,-7.086 11.351,-7.48 l 2.756,3.63 c 0,0 10.324,-15.31 14.873,-18.023 -0.35,1.225 2.187,1.4 -3.456,7.699 -5.643,6.3 -2.144,11.286 -2.144,11.286 -3.499,2.887 -2.799,5.512 -3.238,8.487 -0.437,2.975 -12.074,10.674 -12.074,10.674 3.674,4.637 7.787,3.587 7.787,3.587 -2.275,1.487 -1.575,6.474 -1.575,6.474 3.325,0.875 6.649,-0.612 6.649,-0.612 -1.138,3.149 0.612,5.336 0.612,5.336 2.1,-1.312 6.912,-2.1 6.912,-2.1 -0.612,5.425 2.887,8.311 2.887,8.311 l 3.062,-3.325 c 0.525,6.124 5.95,9.624 5.95,9.624 0,0 5.425,-3.5 5.95,-9.624 l 3.062,3.325 c 0,0 3.5,-2.887 2.887,-8.311 0,0 4.812,0.788 6.912,2.1 0,0 1.75,-2.187 0.612,-5.336 0,0 3.325,1.487 6.649,0.612 0,0 0.7,-4.987 -1.575,-6.474 0,0 4.113,1.049 7.787,-3.587 0,0 -11.636,-7.699 -12.074,-10.674 -0.437,-2.975 0.263,-5.599 -3.238,-8.487 0,0 3.499,-4.987 -2.144,-11.286 -5.643,-6.3 -3.106,-6.475 -3.456,-7.699 4.55,2.712 14.873,18.023 14.873,18.023 l 2.756,-3.63 c 3.347,0.394 11.351,7.48 11.351,7.48 l 0.766,-3.412 0.145,-0.158 c 4.174,2.248 11.068,5.288 13.854,7.418 2.975,2.275 5.425,2.45 12.598,0 7.175,-2.45 20.522,-6.217 18.548,-10.674 -0.108,-0.243 -0.23,-0.406 -0.348,-0.596 0.313,-1.151 0.442,-3.16 -1.665,-4.916 0,0 0.025,0.489 0.008,1.117 l -6.839,-2.549 c -0.226,-0.605 -0.564,-1.198 -1.217,-1.717 0,0 0.01,0.525 -0.084,1.233 l -1.754,-0.654 3.501,-9.849 c -0.265,-0.148 -0.563,-0.231 -0.838,-0.361 0.071,-0.892 0.239,-2.125 0.5,-3.414 0.855,0.299 1.636,0.668 2.202,1.131 l 0.988,-3.606 c 0,0 -1.063,-0.07 -2.464,-0.332 0.354,-1.088 0.774,-2.065 1.273,-2.696 l -4.637,-1.4 c 0,0 0.12,1.405 0.038,3.158 -0.885,-0.359 -1.729,-0.815 -2.411,-1.399 l -1.087,4.002 c 0.373,0.022 1.639,0.131 3.106,0.393 -0.265,1.175 -0.732,2.217 -1.401,2.999 -0.165,-0.022 -0.318,-0.082 -0.486,-0.098 l -3.4,9.565 -9.22,-3.436 c -0.395,0.622 -0.7,1.3 -0.985,1.986 0.049,-0.1 0.093,-0.256 0.145,-0.319 0,0 -3.567,1.866 -3.518,4.607 -0.657,0.249 -1.233,0.742 -1.558,1.597 -1.049,2.756 5.38,8.924 3.806,9.711 -1.546,0.772 -9.623,-5.88 -10.918,-6.997 1.665,-0.323 4.094,-1.533 4.094,-1.533 -1.663,-0.525 -4.724,-3.149 -4.724,-3.149 1.575,-0.7 3.062,-2.975 3.062,-2.975 -7.086,-1.225 -7.874,-2.712 -7.874,-2.712 0.525,-0.7 0.962,-2.537 0.962,-2.537 -12.248,-1.575 -13.255,-10.237 -13.255,-10.237 3.674,5.774 9.58,3.543 9.58,3.543 l -2.494,-4.462 c 6.955,7.218 16.01,1.969 16.01,1.969 l -2.406,-2.625 c 11.723,2.975 14.611,-3.762 14.611,-3.762 -3.412,-0.525 -5.906,-2.078 -5.906,-2.078 14.042,2.887 14.304,-5.184 14.304,-5.184 -1.487,-0.438 -6.037,-1.924 -6.037,-1.924 13.473,1.663 13.911,-8.224 13.911,-8.224 -4.374,1.049 -11.111,0.525 -11.111,0.525 17.06,-1.225 17.323,-10.848 17.323,-10.848 -7.262,2.625 -13.736,1.662 -13.736,1.662 19.597,-2.362 19.335,-14.261 19.335,-14.261 -9.536,6.387 -18.898,6.562 -18.898,6.562 22.932,-6.213 21.182,-18.286 21.182,-18.286 z m -19.882,86.548 c -0.935,-1.518 1.293,-2.876 2.296,-4.321 l 3.878,1.444 c -1.317,1.571 -5.21,4.442 -6.174,2.877 z m -2.591,-6.142 c -1.258,1.949 -2.133,4.135 -6.005,4.239 -4.855,0.131 -5.643,-4.2 -6.692,-6.562 -0.306,-0.689 -0.834,-1.209 -1.44,-1.566 -0.002,-0.424 0.02,-0.889 0.057,-1.359 z"
       id="path2" />
    	<path
       fill="#e6b432"
       d="m 255.635,222.212 c 0,0 -6.233,-5.315 -8.071,-8.202 0,0 2.1,-0.853 3.149,-2.165 0,0 -5.643,-3.018 -8.661,-6.102 0,0 1.969,-0.328 3.478,-1.575 0,0 -5.068,-0.916 -7.638,-5.066 5.859,-2.001 3.898,-7.467 3.898,-7.467 -1.181,1.575 -6.037,3.543 -11.286,1.312 -5.249,-2.231 -11.023,-0.657 -11.023,2.231 0,0 -11.811,-3.412 -8.858,8.006 0,0 1.902,-4.265 6.102,-2.69 4.2,1.575 8.465,6.955 8.465,6.955 0,0 -2.625,1.443 -7.48,-0.131 0,0 1.969,7.545 10.827,3.74 0,0 3.499,1.881 3.674,7.393 0,0 1.487,-0.788 2.45,-2.537 0,0 1.4,5.336 -0.437,9.711 0,0 2.45,-0.437 3.238,-1.225 0,0 0.7,4.637 -2.362,8.399 0,0 13.451,6.409 21.982,-0.612 0,0 -3.215,-3.674 -4.265,-7.086 -0.004,-0.002 1.767,-0.724 2.818,-2.889 z"
       id="path3" />
    	<path
       fill="#e6b432"
       d="m 294.677,195.178 c 0,-2.887 -5.774,-4.462 -11.023,-2.231 -5.249,2.231 -10.105,0.263 -11.286,-1.312 0,0 -1.962,5.466 3.898,7.467 -2.57,4.15 -7.638,5.066 -7.638,5.066 1.51,1.247 3.478,1.575 3.478,1.575 -3.018,3.084 -8.661,6.102 -8.661,6.102 1.049,1.312 3.149,2.165 3.149,2.165 -1.837,2.887 -8.071,8.202 -8.071,8.202 1.049,2.165 2.822,2.887 2.822,2.887 -1.049,3.412 -4.265,7.086 -4.265,7.086 8.53,7.021 21.982,0.612 21.982,0.612 -3.062,-3.762 -2.362,-8.399 -2.362,-8.399 0.788,0.788 3.238,1.225 3.238,1.225 -1.837,-4.374 -0.437,-9.711 -0.437,-9.711 0.962,1.75 2.45,2.537 2.45,2.537 0.175,-5.512 3.674,-7.393 3.674,-7.393 8.858,3.806 10.827,-3.74 10.827,-3.74 -4.855,1.575 -7.48,0.131 -7.48,0.131 0,0 4.265,-5.38 8.465,-6.955 4.2,-1.575 6.102,2.69 6.102,2.69 2.948,-11.416 -8.862,-8.004 -8.862,-8.004 z"
       id="path4" />
    	<path
       fill="#e6b432"
       d="m 289.329,264.884 c -1.152,-6.706 -2.145,-12.498 0.748,-19.134 l 0.54,-1.239 -11.457,-13.156 -1.354,0.451 c -0.117,0.04 -12.092,3.955 -19.769,0.115 l -0.958,-0.479 -0.958,0.479 c -7.641,3.829 -19.648,-0.075 -19.772,-0.117 l -1.354,-0.447 -11.455,13.154 0.54,1.239 c 2.893,6.636 1.9,12.428 0.748,19.134 -1.085,6.332 -2.316,13.51 -0.15,22.263 2.351,9.502 10.268,12.879 17.25,15.863 5.383,2.297 10.466,4.467 13.34,9.022 l 1.81,2.87 1.81,-2.87 c 2.874,-4.555 7.957,-6.724 13.34,-9.022 6.984,-2.983 14.899,-6.36 17.25,-15.863 2.167,-8.754 0.935,-15.932 -0.149,-22.263 z m -60.807,-19.576 7.863,-9.027 c 3.562,0.979 13.19,3.097 20.693,-0.088 7.502,3.186 17.13,1.066 20.693,0.088 l 7.863,9.027 c -2.761,7.272 -1.674,13.611 -0.526,20.3 0.859,5.012 1.714,10.175 0.996,16.121 h -58.052 c -0.717,-5.946 0.138,-11.109 0.996,-16.121 1.148,-6.689 2.235,-13.029 -0.526,-20.3 z m 42.026,53.764 c -4.866,2.078 -9.873,4.214 -13.47,8.269 -3.597,-4.055 -8.604,-6.191 -13.47,-8.269 -6.828,-2.915 -12.719,-5.463 -14.662,-12.618 h 56.262 c -1.941,7.155 -7.832,9.704 -14.66,12.618 z"
       id="path5" />
    </g>
    <path
       fill="#41479b"
       d="m 228.522,157.032 7.863,-9.027 c 3.562,0.979 13.19,3.097 20.693,-0.088 7.502,3.186 17.13,1.066 20.693,0.088 l 7.863,9.027 c -2.761,7.272 -1.674,13.611 -0.526,20.3 0.859,5.012 1.714,10.175 0.996,16.121 h -58.052 c -0.717,-5.946 0.138,-11.109 0.996,-16.121 1.148,-6.689 2.235,-13.029 -0.526,-20.3 z"
       id="path6" />
    <path
       fill="#73af00"
       d="m 228.646,196.929 c 0.067,0.307 0.11,0.602 0.188,0.914 1.839,7.431 7.834,9.99 14.776,12.953 4.866,2.078 9.873,4.214 13.47,8.269 3.597,-4.055 8.604,-6.191 13.47,-8.269 6.942,-2.964 12.937,-5.523 14.776,-12.953 0.077,-0.311 0.12,-0.607 0.188,-0.914 z"
       id="path7" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    	<path
       fill="#e6b432"
       d="m 282.763,260.391 c 0,-3.871 -3.679,-4.481 -7.023,-4.415 -3.345,0.067 -8.237,-0.544 -8.361,-3.144 -0.077,-1.621 2.643,-1.772 4.415,-1.204 1.028,0.33 7.424,1.472 9.431,-2.809 0,0 -2.339,0.075 -4.808,-0.479 -1.902,-0.427 -9.707,0.545 -11.112,3.555 -1.405,3.01 3.125,6.014 8.342,6.014 5.217,0 5.933,1.044 5.892,2.316 -0.054,1.672 -4.191,2.145 -6.569,2.123 -3.743,-1.359 -12.477,-0.295 -12.519,-0.46 -0.05,-0.202 -2.015,-3.575 -2.015,-3.575 0,0 3.576,-0.252 4.029,-0.907 0.453,-0.654 -2.713,-3.169 -2.713,-3.169 0,0 2.663,-1.062 2.764,-1.817 0.11,-0.831 -2.162,-2.798 -2.162,-2.798 0,0 0.878,-0.865 1.538,-2.342 0.472,-1.055 -3.277,-1.337 -3.277,-1.337 0.201,-0.802 0.124,-1.581 -0.87,-1.94 -0.768,-0.277 -3.612,0.802 -5.551,0.802 -1.939,0 -2.676,1.405 -2.676,1.405 0,0 -3.411,0.402 -3.88,0.802 -0.468,0.402 0.134,3.01 0.134,3.01 -1.739,-0.267 -2.541,-1.806 -2.541,-1.806 -0.87,3.946 3.211,4.348 3.211,4.348 l 0.669,2.141 c 0,0 0,0 1.672,0.201 1.672,0.201 0.87,1.806 -1.739,1.806 -2.609,0 -3.716,3.112 -3.716,3.112 -1.813,0.051 -2.82,-1.41 -3.223,-3.274 -0.444,-2.051 -0.182,-5.203 0.151,-7.201 0.403,-2.418 -0.806,-3.123 -0.806,-3.123 l -0.806,2.015 c -0.05,-2.065 -1.864,-2.266 -1.864,-2.266 l -0.302,2.518 c -0.907,-1.662 -2.467,-0.907 -2.467,-0.907 0,0 1.511,5.439 1.461,5.741 -0.051,0.302 -0.554,0.554 -1.259,-0.202 -0.705,-0.756 -1.208,-0.252 -1.208,-0.252 0.756,5.439 3.672,4.641 3.672,4.641 0,0 0.13,1.704 1.011,5.163 0.94,3.693 4.808,2.998 4.808,2.998 0,1.204 0.937,2.943 1.204,6.956 0.267,4.013 -3.411,6.823 -3.411,6.823 -3.345,-0.067 -3.01,3.211 -3.01,3.211 h 9.23 c 0,-8.535 3.669,-9.998 3.669,-9.998 5.439,0.252 10.677,-2.015 10.677,-2.015 -0.806,3.274 0.605,4.633 0.605,4.633 2.216,-0.302 1.108,4.079 0.453,4.079 -0.654,0 -2.015,0 -2.82,0 -0.805,0 -3.123,2.518 -3.123,2.518 h 9.569 c 0,0 1.461,-2.115 1.964,-3.172 0.503,-1.058 -1.108,-2.518 -1.208,-3.626 -0.1,-1.108 1.662,-1.813 1.662,-1.813 1.864,2.618 6.144,2.77 6.144,2.77 l -0.1,-1.964 c 0,0 2.216,0.756 2.72,1.41 0.503,0.654 0.403,3.677 -2.266,4.029 -2.669,0.352 -2.871,2.266 -2.871,2.266 0,0 6.094,0 7.303,0 1.209,0 2.165,-2.266 2.165,-3.123 0,-0.856 0,-6.446 0,-7.656 0,-1.208 -1.007,-1.057 -3.374,-1.31 -2.15,-0.228 -1.944,-2.581 -2.83,-5.312 3.108,-0.104 7.915,-0.784 7.915,-3.99 z"
       id="path8" />
    	<path
       fill="#e6b432"
       d="m 282.197,168.872 c -0.599,-5.281 -4.809,-12.006 -20.844,-15.158 -0.053,-1.704 -1.101,-3.148 -2.6,-3.756 v -2.943 h 2.625 v -3.149 h -2.625 v -2.624 h -3.149 v 2.625 h -2.625 v 3.149 h 2.625 v 2.943 c -1.497,0.608 -2.547,2.052 -2.6,3.756 -16.035,3.153 -20.245,9.877 -20.844,15.158 -0.747,6.585 3.969,12.829 8.221,15.222 v 3.341 h 33.596 v -3.341 c 4.251,-2.393 8.966,-8.638 8.22,-15.223 z m -17.588,10.165 h -4.702 v -19.369 c 3.876,1.751 6.274,4.436 6.972,8.124 0.869,4.592 -0.967,9.274 -2.27,11.245 z m -17.132,-11.248 c 0.698,-3.688 3.095,-6.372 6.972,-8.122 v 19.369 h -4.703 c -1.305,-1.97 -3.14,-6.654 -2.269,-11.247 z m -3.887,-5.318 c -0.772,1.547 -1.265,3.094 -1.516,4.515 -0.76,4.302 0.111,8.674 1.551,12.051 h -1.103 c -2.356,-1.622 -5.383,-5.612 -4.936,-9.549 0.311,-2.755 2.4,-5.118 6.004,-7.017 z m 28.245,16.566 h -1.106 c 1.44,-3.375 2.312,-7.747 1.553,-12.049 -0.252,-1.421 -0.744,-2.97 -1.517,-4.518 3.605,1.899 5.694,4.264 6.005,7.017 0.447,3.938 -2.58,7.928 -4.935,9.55 z"
       id="path9" />
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MF = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const MG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45001" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ff4b55"
       d="M 512,167.725 H 167.724 V 0.001 h 335.448 c 4.875,0 8.828,3.953 8.828,8.828 v 158.896 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 167.724,167.725 H 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 167.724 Z"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="M 167.724,0.001 V 335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 158.896 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const MH = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="M 3.978,333.803 512,123.587 V 61.794 L 0,326.622 c 0,3.043 1.635,5.593 3.978,7.181 z"
       id="path2" />
    <path
       fill="#ff9b55"
       d="M 508.658,2.076 0,317.794 v 8.828 L 512,61.794 V 8.828 c 0,-2.767 -1.351,-5.133 -3.342,-6.752 z"
       id="path3" />
    <polygon
       fill="#f5f5f5"
       points="145.903,195.901 174.858,178.142 138.831,186.951 160.757,157.037 130.844,178.963 139.652,142.936 121.894,171.891 114.759,114.76 107.624,171.891 89.865,142.936 98.674,178.963 68.76,157.037 90.686,186.951 54.659,178.142 83.614,195.901 26.483,203.035 83.614,210.17 54.659,227.929 90.686,219.12 68.76,249.034 98.674,227.108 89.865,263.135 107.624,234.18 114.759,291.311 121.894,234.18 139.652,263.135 130.844,227.108 160.757,249.034 138.831,219.12 174.858,227.929 145.903,210.17 203.034,203.035 "
       id="polygon3"
       transform="translate(0,-88.276)" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs24" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.827 -8.829,8.827 z"
       id="path1" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 225.728,224.016 c -0.006,0.004 -0.011,0.009 -0.017,0.013 L 97.103,88.277 H 8.828 c -2.146,0 -4.041,0.86 -5.571,2.134 l 215.864,141.428 c 1.886,-2.874 4.121,-5.469 6.607,-7.823 z"
       id="path2" />
    	<path
       fill="#ffe15a"
       d="m 212.318,260.523 c -0.156,-1.508 -0.456,-2.973 -0.456,-4.522 0,-1.549 0.3,-3.014 0.456,-4.522 v 0.002 L 0,229.518 v 52.966 L 212.318,260.52 Z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 249.139,212.553 c 2.251,-0.354 4.511,-0.691 6.861,-0.691 2.35,0 4.61,0.338 6.861,0.691 H 262.86 L 282.483,88.276 h -52.966 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="M 292.879,231.839 508.744,90.411 c -1.531,-1.274 -3.425,-2.134 -5.571,-2.134 H 414.897 L 286.289,224.03 c -0.006,-0.004 -0.011,-0.009 -0.017,-0.013 2.486,2.353 4.721,4.948 6.607,7.822 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 286.272,287.985 c 0.005,-0.004 0.011,-0.009 0.017,-0.013 l 128.608,135.753 h 88.276 c 2.146,0 4.041,-0.86 5.571,-2.134 L 292.879,280.162 c -1.886,2.874 -4.121,5.47 -6.607,7.823 z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="m 299.682,251.482 v -0.002 c 0.156,1.507 0.456,2.973 0.456,4.522 0,1.549 -0.3,3.014 -0.456,4.522 v -0.002 L 512,282.484 v -52.966 z"
       id="path7" />
    	<path
       fill="#ffe15a"
       d="m 262.861,299.448 c -2.251,0.353 -4.511,0.691 -6.861,0.691 -2.35,0 -4.61,-0.338 -6.861,-0.691 h 10e-4 l -19.623,124.277 h 52.966 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="M 219.121,280.162 3.256,421.591 c 1.53,1.274 3.425,2.134 5.571,2.134 H 97.103 L 225.711,287.972 c 0.006,0.004 0.011,0.009 0.017,0.013 -2.486,-2.353 -4.721,-4.949 -6.607,-7.823 z"
       id="path9" />
    	<circle
       fill="#ffe15a"
       cx="256"
       cy="256"
       r="35.310001"
       id="circle9" />
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const ML = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 341.333,0 H 503.172 C 508.047,0 512,3.953 512,8.828 v 317.793 c 0,4.875 -3.953,8.828 -8.828,8.828 H 341.333 Z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#ffe15a"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#73af00"
       d="M 8.828,0 H 170.667 V 335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const MM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ff4b55"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#73af00"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#f5f5f5"
       d="m 261.032,56.683 26.435,79.263 83.552,0.648 c 5.097,0.04 7.21,6.543 3.111,9.571 l -67.214,49.635 25.203,79.663 c 1.537,4.86 -3.996,8.879 -8.142,5.916 L 256,232.792 188.024,281.379 c -4.147,2.964 -9.679,-1.056 -8.142,-5.916 L 205.085,195.8 137.871,146.165 c -4.1,-3.028 -1.987,-9.533 3.111,-9.571 l 83.552,-0.648 26.435,-79.263 c 1.611,-4.835 8.451,-4.835 10.063,0 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs27" />
    <path
       fill="#ff4b55"
       d="M 341.333,0 H 503.172 C 508.047,0 512,3.953 512,8.828 v 317.793 c 0,4.875 -3.953,8.828 -8.828,8.828 H 341.333 Z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#41479b"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 8.828,0 H 170.667 V 335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <g
       id="g12"
       transform="translate(0,-88.273)">
    	<path
       fill="#f9cf02"
       d="m 85.689,227.025 c -13.341,0 -24.776,-8.038 -29.814,-19.519 -0.003,0.175 -0.052,0.338 -0.052,0.513 0,16.494 13.372,29.866 29.866,29.866 16.494,0 29.865,-13.372 29.865,-29.866 0,-0.175 -0.049,-0.338 -0.052,-0.512 -5.038,11.48 -16.473,19.518 -29.813,19.518 z"
       id="path3" />
    	<circle
       fill="#f9cf02"
       cx="85.690002"
       cy="199.877"
       r="21.719999"
       id="circle3" />
    	<path
       fill="#f9cf02"
       d="m 72.114,159.15 c 0,7.497 6.078,13.575 13.575,13.575 7.497,0 13.575,-6.078 13.575,-13.575 0,-5.43 -3.394,-6.109 -3.394,-8.145 0,-2.036 2.036,-4.751 -2.036,-8.145 2.036,3.394 -1.357,4.073 -1.357,7.466 0,3.393 1.357,3.394 1.357,6.109 0,1.5 -1.216,2.714 -2.714,2.714 -1.5,0 -2.714,-1.216 -2.714,-2.714 0,-2.714 2.714,-5.43 2.714,-9.503 0,-4.073 -0.679,-5.43 -2.714,-8.824 -2.036,-3.394 -5.43,-6.109 -2.714,-8.824 -4.073,1.357 -2.036,6.787 -2.036,10.182 0,3.394 -2.714,5.43 -2.714,9.503 0,4.073 2.036,4.751 2.036,7.466 0,1.5 -1.216,2.714 -2.714,2.714 -1.498,0 -2.714,-1.216 -2.714,-2.714 0,-2.714 1.357,-2.714 1.357,-6.109 0,-3.395 -3.394,-4.073 -1.357,-7.466 -4.073,3.394 -2.036,6.109 -2.036,8.145 -0.006,2.036 -3.4,2.714 -3.4,8.145 z"
       id="path4" />
    	<path
       fill="#f9cf02"
       d="m 25.959,245.557 v 125.838 c 0,1.238 1.004,2.241 2.241,2.241 h 22.667 c 1.238,0 2.241,-1.004 2.241,-2.241 V 245.557 c 0,-1.238 -1.004,-2.241 -2.241,-2.241 H 28.2 c -1.237,-0.001 -2.241,1.003 -2.241,2.241 z"
       id="path5" />
    	<path
       fill="#f9cf02"
       d="m 118.27,245.557 v 125.838 c 0,1.238 1.004,2.241 2.241,2.241 h 22.667 c 1.238,0 2.241,-1.004 2.241,-2.241 V 245.557 c 0,-1.238 -1.004,-2.241 -2.241,-2.241 h -22.667 c -1.238,-0.001 -2.241,1.003 -2.241,2.241 z"
       id="path6" />
    	<path
       fill="#f9cf02"
       d="m 58.539,267.276 v 6.377 c 0,1.238 1.004,2.241 2.241,2.241 h 49.817 c 1.238,0 2.241,-1.004 2.241,-2.241 v -6.377 c 0,-1.238 -1.004,-2.241 -2.241,-2.241 H 60.78 c -1.238,0 -2.241,1.004 -2.241,2.241 z"
       id="path7" />
    	<path
       fill="#f9cf02"
       d="m 58.539,343.297 v 6.377 c 0,1.238 1.004,2.241 2.241,2.241 h 49.817 c 1.238,0 2.241,-1.004 2.241,-2.241 v -6.377 c 0,-1.238 -1.004,-2.241 -2.241,-2.241 H 60.78 c -1.238,0 -2.241,1.003 -2.241,2.241 z"
       id="path8" />
    	<path
       fill="#f9cf02"
       d="m 62.585,243.315 h 46.208 c 1.137,0 1.551,1.497 0.577,2.082 l -21.95,13.171 c -1.065,0.639 -2.396,0.639 -3.459,0 L 62.009,245.397 c -0.975,-0.585 -0.56,-2.082 0.576,-2.082 z"
       id="path9" />
    	<path
       fill="#f9cf02"
       d="m 62.585,357.347 h 46.208 c 1.137,0 1.551,1.497 0.577,2.082 l -21.952,13.17 c -1.065,0.639 -2.396,0.639 -3.459,0 L 62.008,359.428 c -0.974,-0.585 -0.559,-2.081 0.577,-2.081 z"
       id="path10" />
    	<path
       fill="#f9cf02"
       d="m 88.341,281.537 c -0.856,-0.082 -1.685,-0.259 -2.562,-0.259 -14.931,0 -27.078,12.147 -27.078,27.078 0,8.862 4.329,16.662 10.943,21.583 0.761,0.566 1.767,-0.252 1.397,-1.127 -0.793,-1.879 -1.239,-3.938 -1.239,-6.106 0,-8.825 7.193,-16.002 16.026,-15.975 4.643,0.014 9.094,-2.279 11.149,-6.443 4.251,-8.611 -0.936,-17.17 -8.636,-18.751 z m -2.562,17.883 c -2.99,0 -5.416,-2.424 -5.416,-5.416 0,-2.99 2.425,-5.415 5.416,-5.415 2.99,0 5.415,2.424 5.415,5.415 -0.001,2.992 -2.425,5.416 -5.415,5.416 z"
       id="path11" />
    	<path
       fill="#f9cf02"
       d="m 101.912,286.772 c -0.761,-0.566 -1.767,0.253 -1.397,1.127 0.794,1.879 1.239,3.938 1.239,6.105 0,8.826 -7.194,16.003 -16.026,15.976 -4.643,-0.014 -9.095,2.279 -11.149,6.443 -4.249,8.612 0.938,17.172 8.638,18.751 0.856,0.082 1.685,0.259 2.562,0.259 14.93,0 27.078,-12.147 27.078,-27.078 -0.002,-8.861 -4.331,-16.661 -10.945,-21.583 z m -16.133,41.35 c -2.99,0 -5.416,-2.424 -5.416,-5.416 0,-2.99 2.425,-5.415 5.416,-5.415 2.99,0 5.415,2.424 5.415,5.415 -0.001,2.991 -2.425,5.416 -5.415,5.416 z"
       id="path12" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const MO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs27" />
    <path
       fill="#5aa587"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 277.124,301.609 c 9.897,2.366 20.461,2.55 31.026,-0.073 18.612,-4.621 33.334,-16.756 41.889,-32.337 -14.85,-9.77 -33.538,-13.609 -52.15,-8.988 -10.006,2.485 -18.784,7.249 -26.183,13.45 0.07,-0.093 0.128,-0.184 0.198,-0.277 27.407,-24.715 58.004,-16.736 58.004,-16.736 l 7.239,-6.185 c 0,0 -30.862,-10.663 -58.506,12.204 17.109,-33.124 -1.353,-61.538 -1.353,-61.538 l -4.258,8.515 c 0,0 15.353,28.154 -2.609,61.003 -0.021,0.024 -0.042,0.05 -0.063,0.074 4.377,-8.792 6.93,-18.648 6.93,-29.143 0,-19.177 -8.229,-36.39 -21.29,-48.448 -13.06,12.058 -21.29,29.271 -21.29,48.448 0,10.496 2.552,20.351 6.93,29.143 -0.021,-0.024 -0.042,-0.051 -0.063,-0.074 -17.962,-32.849 -2.609,-61.003 -2.609,-61.003 l -4.258,-8.515 c 0,0 -18.461,28.414 -1.353,61.538 -27.644,-22.866 -58.506,-12.204 -58.506,-12.204 l 7.239,6.185 c 0,0 30.596,-7.98 58.004,16.736 0.07,0.093 0.128,0.184 0.198,0.277 -7.398,-6.201 -16.177,-10.965 -26.183,-13.45 -18.612,-4.621 -37.3,-0.782 -52.15,8.988 8.555,15.581 23.277,27.715 41.89,32.337 10.564,2.623 21.129,2.439 31.026,0.073 -36.875,10.31 -60.993,-11.901 -60.993,-11.901 l -9.291,2.08 c 0,0 37.269,39.964 91.409,0.76 54.14,39.203 91.409,-0.76 91.409,-0.76 l -9.291,-2.08 c 0.002,0 -24.117,22.21 -60.992,11.901 z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 202.194,347.61 c 3.848,2.389 7.871,4.518 12.036,6.387 h 83.539 c 4.167,-1.869 8.189,-3.998 12.036,-6.387 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 221.715,357.016 c 10.719,3.818 22.255,5.912 34.285,5.912 12.03,0 23.566,-2.095 34.285,-5.912 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 179.542,328.509 c 1.29,1.453 2.609,2.88 3.978,4.258 h 144.96 c 1.369,-1.378 2.688,-2.804 3.978,-4.258 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 188.886,337.764 c 2.133,1.86 4.334,3.642 6.618,5.322 h 120.992 c 2.283,-1.681 4.486,-3.463 6.618,-5.322 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 298.579,317.156 c -23.847,0 -40.163,-15.938 -40.326,-16.1 l -2.26,-2.246 -2.252,2.25 c -0.162,0.162 -16.373,16.096 -40.321,16.096 h -42.617 c 1.454,2.193 3,4.318 4.616,6.387 h 38.003 c 21.422,0 36.975,-11.206 42.579,-15.929 5.603,4.724 21.156,15.929 42.579,15.929 h 38.003 c 1.615,-2.069 3.161,-4.194 4.616,-6.387 z"
       id="path7" />
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 254.882,149.879 -3.736,11.203 -11.809,0.092 c -1.132,0.009 -1.602,1.454 -0.691,2.126 l 9.501,7.016 -3.562,11.26 c -0.342,1.08 0.888,1.973 1.81,1.314 l 9.608,-6.867 9.608,6.867 c 0.921,0.659 2.151,-0.235 1.81,-1.314 l -3.562,-11.26 9.501,-7.016 c 0.911,-0.673 0.441,-2.118 -0.691,-2.126 l -11.809,-0.092 -3.736,-11.203 c -0.364,-1.075 -1.884,-1.075 -2.242,0 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 198.994,172.81 2.163,7.854 -6.731,4.589 c -0.646,0.44 -0.36,1.449 0.422,1.484 l 8.139,0.371 2.284,7.82 c 0.22,0.75 1.267,0.789 1.542,0.058 l 2.867,-7.626 8.143,0.244 c 0.781,0.023 1.142,-0.961 0.532,-1.448 l -6.367,-5.084 2.749,-7.669 c 0.264,-0.736 -0.561,-1.383 -1.213,-0.953 l -6.802,4.484 -6.444,-4.984 c -0.621,-0.478 -1.492,0.107 -1.284,0.86 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="m 166.41,212.371 5.891,5.628 -3.417,7.395 c -0.328,0.71 0.436,1.428 1.123,1.057 l 7.172,-3.863 5.977,5.536 c 0.573,0.531 1.492,0.026 1.353,-0.742 l -1.458,-8.015 7.112,-3.975 c 0.682,-0.381 0.487,-1.411 -0.288,-1.515 l -8.074,-1.09 -1.582,-7.992 c -0.151,-0.767 -1.192,-0.898 -1.53,-0.194 l -3.532,7.341 -8.089,-0.966 c -0.776,-0.093 -1.223,0.855 -0.658,1.395 z"
       id="path10" />
    	<path
       fill="#ffe15a"
       d="m 314.859,172.81 -2.163,7.854 6.731,4.589 c 0.646,0.44 0.36,1.449 -0.422,1.484 l -8.139,0.371 -2.284,7.82 c -0.22,0.75 -1.267,0.789 -1.542,0.058 l -2.867,-7.626 -8.143,0.244 c -0.781,0.023 -1.142,-0.961 -0.532,-1.448 l 6.367,-5.084 -2.749,-7.669 c -0.264,-0.736 0.561,-1.383 1.213,-0.953 l 6.802,4.484 6.444,-4.984 c 0.621,-0.478 1.491,0.107 1.284,0.86 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 347.443,212.371 -5.891,5.628 3.417,7.395 c 0.328,0.71 -0.436,1.428 -1.123,1.057 l -7.172,-3.863 -5.977,5.536 c -0.573,0.531 -1.492,0.026 -1.353,-0.742 l 1.458,-8.015 -7.112,-3.975 c -0.682,-0.381 -0.487,-1.411 0.288,-1.515 l 8.074,-1.09 1.582,-7.992 c 0.151,-0.767 1.192,-0.898 1.53,-0.194 l 3.532,7.341 8.089,-0.966 c 0.776,-0.093 1.223,0.855 0.658,1.395 z"
       id="path12" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MP = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs36" />
    <path
       fill="#4173cd"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 255.999,295.724 c -70.577,0 -128,-57.422 -128,-128 0,-70.578 57.422,-128 128,-128 70.578,0 128,57.422 128,128 0,70.578 -57.422,128 -128,128 z m 0,-229.517 c -55.979,0 -101.517,45.539 -101.517,101.517 0,55.978 45.539,101.517 101.517,101.517 55.978,0 101.517,-45.539 101.517,-101.517 0,-55.978 -45.538,-101.517 -101.517,-101.517 z"
       id="path2" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffdc00"
       d="m 255.999,375.172 c -65.711,0 -119.172,-53.461 -119.172,-119.172 0,-65.711 53.461,-119.172 119.172,-119.172 65.711,0 119.173,53.461 119.173,119.172 0,65.711 -53.461,119.172 -119.173,119.172 z m 0,-229.517 c -60.845,0 -110.345,49.499 -110.345,110.345 0,60.846 49.499,110.345 110.345,110.345 60.846,0 110.345,-49.5 110.345,-110.345 0,-60.845 -49.499,-110.345 -110.345,-110.345 z"
       id="path3" />
    	<circle
       fill="#ffdc00"
       cx="141.24001"
       cy="256"
       r="8.8280001"
       id="circle3" />
    	<circle
       fill="#ffdc00"
       cx="370.76001"
       cy="256"
       r="8.8280001"
       id="circle4" />
    	<circle
       fill="#ffdc00"
       cx="256"
       cy="141.24001"
       r="8.8280001"
       id="circle5" />
    	<circle
       fill="#ffdc00"
       cx="174.85001"
       cy="174.85001"
       r="8.8280001"
       id="circle6" />
    	<circle
       fill="#ffdc00"
       cx="337.14999"
       cy="174.85001"
       r="8.8280001"
       id="circle7" />
    	<circle
       fill="#ffdc00"
       cx="362.01999"
       cy="212.08"
       r="8.8280001"
       id="circle8" />
    	<circle
       fill="#ffdc00"
       cx="212.08"
       cy="149.98"
       r="8.8280001"
       id="circle9" />
    	<circle
       fill="#ffdc00"
       cx="149.98"
       cy="212.08"
       r="8.8280001"
       id="circle10" />
    	<circle
       fill="#ffdc00"
       cx="299.92001"
       cy="149.98"
       r="8.8280001"
       id="circle11" />
    	<circle
       fill="#ffdc00"
       cx="368.54999"
       cy="233.61"
       r="8.8280001"
       id="circle12" />
    	<circle
       fill="#ffdc00"
       cx="233.61"
       cy="143.45"
       r="8.8280001"
       id="circle13" />
    	<circle
       fill="#ffdc00"
       cx="160.58"
       cy="192.24001"
       r="8.8280001"
       id="circle14" />
    	<circle
       fill="#ffdc00"
       cx="319.76001"
       cy="160.59"
       r="8.8280001"
       id="circle15" />
    	<circle
       fill="#ffdc00"
       cx="351.41"
       cy="192.24001"
       r="8.8280001"
       id="circle16" />
    	<circle
       fill="#ffdc00"
       cx="192.24001"
       cy="160.59"
       r="8.8280001"
       id="circle17" />
    	<circle
       fill="#ffdc00"
       cx="143.45"
       cy="233.61"
       r="8.8280001"
       id="circle18" />
    	<circle
       fill="#ffdc00"
       cx="278.39001"
       cy="143.45"
       r="8.8280001"
       id="circle19" />
    </g>
    <path
       fill="#ffa000"
       d="m 370.758,172.138 c -2.44,0 -4.414,-1.974 -4.414,-4.414 0,-60.845 -49.499,-110.345 -110.345,-110.345 -60.846,0 -110.344,49.501 -110.344,110.345 0,2.44 -1.974,4.414 -4.414,4.414 -2.44,0 -4.414,-1.974 -4.414,-4.414 0,-65.711 53.461,-119.172 119.172,-119.172 65.711,0 119.173,53.461 119.173,119.172 0,2.44 -1.974,4.414 -4.414,4.414 z"
       id="path19" />
    <path
       fill="#b4b4b4"
       d="m 280.527,300.138 h -49.054 c -10.482,0 -18.656,-9.079 -17.558,-19.503 l 15.602,-148.22 h 52.965 l 15.602,148.22 c 1.098,10.424 -7.076,19.503 -17.557,19.503 z"
       id="path20" />
    <path
       fill="#aaaaaa"
       d="m 282.232,132.414 h -52.671 c -2.321,0 -4.269,-1.748 -4.52,-4.055 l -3.29,-30.302 c -0.567,-5.221 3.523,-9.781 8.776,-9.781 h 50.945 c 5.252,0 9.343,4.558 8.776,9.781 l -3.268,30.098 c -0.263,2.423 -2.31,4.259 -4.748,4.259 z"
       id="path21" />
    <path
       fill="#f5f5f5"
       d="m 258.044,98.558 16.364,47.079 49.831,1.015 c 2.051,0.042 2.899,2.648 1.263,3.889 l -39.717,30.111 14.433,47.705 c 0.594,1.964 -1.623,3.575 -3.308,2.403 L 256,202.292 215.089,230.76 c -1.684,1.172 -3.902,-0.439 -3.308,-2.403 l 14.433,-47.705 -39.717,-30.111 c -1.635,-1.239 -0.788,-3.847 1.263,-3.889 l 49.831,-1.015 16.364,-47.079 c 0.674,-1.939 3.415,-1.939 4.089,0 z"
       id="path22" />
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MQ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs20" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#f5f5f5"
       points="273.655,88.276 238.344,88.276 238.344,238.345 0,238.345 0,273.655 238.344,273.655 238.344,423.724 273.655,423.724 273.655,273.655 512,273.655 512,238.345 273.655,238.345 "
       id="polygon1" />
    	<path
       fill="#f5f5f5"
       d="m 172.41,203.12 c -0.253,-1.502 -0.823,-3.281 -1.543,-4.426 -1.431,-1.978 -3.087,-3.363 -4.691,-4.225 -12.639,-5.806 -23.22,-4.668 -33.317,-4.708 -9.973,0.257 -19.303,1.977 -26.877,3.635 -2.056,0.414 -3.837,0.723 -5.742,1.081 0.942,-1.946 4.395,-4.381 9.045,-5.857 11.336,-3.872 24.276,-5.427 36.994,-7.905 3.212,-0.629 6.468,-1.366 9.802,-2.314 1.795,-0.615 3.306,-1.095 5.42,-2.077 1.356,-0.767 2.691,-1.732 3.833,-2.763 1.216,-1.094 1.123,-1.4 1.749,-2.138 2.888,-5.497 0.154,-9.411 -2.138,-11.455 -2.209,-1.813 -4.07,-2.521 -5.841,-3.25 -3.438,-1.206 -6.623,-1.962 -9.697,-2.603 -5.923,-1.185 -11.746,-2.35 -17.447,-3.491 -2.708,-0.627 -5.327,-1.323 -7.625,-2.167 -2.029,-0.541 -4.896,-2.546 -4.47,-1.999 -5.239,-0.452 7.175,-6.295 16.126,-9.559 2.379,-1.05 4.744,-2.11 7.167,-3.606 2.377,-1.571 4.826,-2.904 7.467,-7.304 0.519,-0.913 0.497,-1.135 0.769,-1.732 l 0.302,-0.759 c 0.655,-2.339 0.295,-1.708 0.447,-2.722 0.309,-2.454 -0.654,-5.077 -2.178,-7.262 -3.111,-3.362 -6.205,-4.324 -8.503,-4.968 -9.504,-2.252 -16.342,-1.636 -22.283,-1.613 -11.266,0.53 -17.705,0.832 -17.705,0.832 l -0.435,0.02 c -0.013,0.001 -0.025,0.001 -0.039,0.002 -3.601,0.211 -6.348,3.3 -6.137,6.9 0.02,0.352 0.185,0.647 0.258,0.98 -5.102,1.406 -13.175,2.844 -21.162,0.961 -1.216,-0.28 -2.339,0.451 -2.62,1.615 -0.28,1.174 0.451,2.347 1.615,2.62 3.138,0.74 6.251,1.03 9.219,1.03 6.305,0 11.691,-1.283 15.369,-2.41 1.186,0.881 2.628,1.436 4.218,1.343 0,0 6.506,-0.381 17.892,-1.047 5.331,-0.192 12.495,-0.473 18.407,0.916 0.489,0.076 0.751,0.228 1.075,0.365 0.046,-0.524 -0.954,0.952 -2.517,1.711 -1.517,0.979 -3.491,1.917 -5.545,2.849 -4.2,1.903 -9.006,3.539 -14.334,6.406 -2.572,1.518 -5.752,3.06 -8.394,7.571 -1.235,2.09 -1.821,5.469 -1.172,7.851 l 0.192,0.971 0.109,0.48 0.058,0.238 c -0.409,-0.849 0.622,1.434 0.541,1.228 l 0.533,0.888 c 0.473,0.676 0.399,0.956 1.535,2.136 0.911,0.986 1.94,1.93 3.001,2.754 0.93,0.64 1.624,0.942 2.461,1.416 1.649,0.972 3.146,1.422 4.708,2.035 3.08,1.085 6.079,1.822 9.074,2.484 5.781,1.088 11.688,2.199 17.695,3.33 2.519,0.487 4.876,1.101 7.055,1.772 -2.791,1.006 -6.697,2.02 -10.066,2.669 -12.255,2.586 -25.25,4.15 -38.467,8.792 -3.308,1.259 -6.697,2.764 -10.02,5.309 -3.129,2.371 -6.418,7.1 -5.997,12.295 -1.121,0.157 -2.409,0.386 -3.445,0.501 -11.212,1.484 -15.924,-0.49 -15.62,-0.547 -1.464,-0.864 -3.351,-0.38 -4.215,1.085 -0.865,1.463 -0.38,3.351 1.084,4.215 0,0 1.922,1.305 5.353,2.057 3.414,0.772 8.217,1.126 14.067,0.665 1.611,-0.11 3.498,-0.351 5.27,-0.538 1.225,1.766 2.652,3.714 3.981,4.658 3.089,2.591 6.36,4.248 9.62,5.699 13.123,5.076 26.239,6.142 39.027,5.639 6.42,-0.482 12.738,-1.231 19.226,-4.126 3.025,-1.411 7.177,-3.633 8.459,-10.06 0.004,-0.823 0.145,-1.198 0.019,-2.373 z m -9.438,2.024 c -0.167,-0.95 -0.69,1.205 -3.14,1.799 -4.217,1.853 -9.973,2.701 -15.631,2.999 -11.41,0.375 -23.87,-0.957 -34.554,-5.29 -1.679,-0.776 -3.049,-1.753 -4.49,-2.687 0.792,-0.121 1.479,-0.205 2.291,-0.333 7.939,-1.265 16.214,-2.754 25.719,-2.911 9.053,-0.166 20.581,-0.041 28.236,3.767 0.889,0.479 1.278,0.978 1.572,1.279 0,0 -0.254,-0.305 0.029,-0.499 0.126,0.194 -0.032,1.278 -0.032,1.876 z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 446.066,203.12 c -0.253,-1.502 -0.823,-3.281 -1.543,-4.426 -1.431,-1.978 -3.087,-3.363 -4.691,-4.225 -12.639,-5.806 -23.22,-4.668 -33.317,-4.708 -9.973,0.257 -19.303,1.977 -26.877,3.635 -2.056,0.414 -3.837,0.723 -5.742,1.081 0.942,-1.946 4.395,-4.381 9.045,-5.857 11.336,-3.872 24.276,-5.427 36.994,-7.905 3.212,-0.629 6.468,-1.366 9.802,-2.314 1.795,-0.615 3.306,-1.095 5.42,-2.077 1.356,-0.767 2.691,-1.732 3.833,-2.763 1.216,-1.094 1.123,-1.4 1.749,-2.138 2.888,-5.497 0.155,-9.411 -2.138,-11.455 -2.209,-1.813 -4.069,-2.521 -5.841,-3.25 -3.438,-1.206 -6.623,-1.962 -9.697,-2.603 -5.923,-1.185 -11.746,-2.35 -17.447,-3.491 -2.708,-0.627 -5.327,-1.323 -7.625,-2.167 -2.029,-0.541 -4.896,-2.546 -4.47,-1.999 -5.239,-0.452 7.175,-6.295 16.126,-9.559 2.379,-1.05 4.744,-2.11 7.167,-3.606 2.377,-1.571 4.826,-2.904 7.467,-7.304 0.519,-0.913 0.497,-1.135 0.769,-1.732 l 0.302,-0.759 c 0.655,-2.339 0.295,-1.708 0.447,-2.722 0.309,-2.454 -0.654,-5.077 -2.178,-7.262 -3.111,-3.362 -6.205,-4.324 -8.503,-4.968 -9.504,-2.252 -16.342,-1.636 -22.283,-1.613 -11.266,0.53 -17.705,0.832 -17.705,0.832 l -0.435,0.02 c -0.013,0.001 -0.025,0.001 -0.039,0.002 -3.601,0.211 -6.348,3.3 -6.137,6.9 0.02,0.352 0.185,0.647 0.258,0.98 -5.102,1.406 -13.175,2.844 -21.162,0.961 -1.216,-0.28 -2.339,0.451 -2.62,1.615 -0.28,1.174 0.451,2.347 1.615,2.62 3.138,0.74 6.251,1.03 9.219,1.03 6.305,0 11.691,-1.283 15.369,-2.41 1.186,0.881 2.628,1.436 4.218,1.343 0,0 6.506,-0.381 17.892,-1.047 5.331,-0.192 12.495,-0.473 18.407,0.916 0.489,0.076 0.751,0.228 1.075,0.365 0.046,-0.524 -0.954,0.952 -2.517,1.711 -1.517,0.979 -3.491,1.917 -5.545,2.849 -4.2,1.903 -9.006,3.539 -14.334,6.406 -2.572,1.518 -5.752,3.06 -8.394,7.571 -1.235,2.09 -1.821,5.469 -1.172,7.851 l 0.192,0.971 0.109,0.48 0.059,0.238 c -0.409,-0.849 0.622,1.434 0.541,1.228 l 0.533,0.888 c 0.473,0.676 0.399,0.956 1.535,2.136 0.911,0.986 1.94,1.93 3.001,2.754 0.93,0.64 1.624,0.942 2.461,1.416 1.649,0.972 3.146,1.422 4.708,2.035 3.08,1.085 6.079,1.822 9.074,2.484 5.781,1.088 11.688,2.199 17.695,3.33 2.519,0.487 4.876,1.101 7.055,1.772 -2.791,1.006 -6.697,2.02 -10.066,2.669 -12.255,2.586 -25.25,4.15 -38.467,8.792 -3.308,1.259 -6.697,2.764 -10.02,5.309 -3.129,2.371 -6.418,7.1 -5.997,12.295 -1.121,0.157 -2.409,0.386 -3.445,0.501 -11.212,1.484 -15.924,-0.49 -15.62,-0.547 -1.464,-0.864 -3.351,-0.38 -4.215,1.085 -0.865,1.463 -0.38,3.351 1.084,4.215 0,0 1.922,1.305 5.353,2.057 3.414,0.772 8.217,1.126 14.067,0.665 1.611,-0.11 3.498,-0.351 5.27,-0.538 1.225,1.766 2.652,3.714 3.981,4.658 3.089,2.591 6.36,4.248 9.62,5.699 13.123,5.076 26.24,6.142 39.027,5.639 6.42,-0.482 12.738,-1.231 19.226,-4.126 3.025,-1.411 7.177,-3.633 8.459,-10.06 10e-4,-0.823 0.142,-1.198 0.018,-2.373 z m -9.439,2.024 c -0.167,-0.95 -0.69,1.205 -3.14,1.799 -4.217,1.853 -9.973,2.701 -15.631,2.999 -11.41,0.375 -23.87,-0.957 -34.554,-5.29 -1.679,-0.776 -3.049,-1.753 -4.49,-2.687 0.792,-0.121 1.479,-0.205 2.291,-0.333 7.939,-1.265 16.214,-2.754 25.719,-2.911 9.053,-0.166 20.581,-0.041 28.236,3.767 0.889,0.479 1.278,0.978 1.572,1.279 0,0 -0.254,-0.305 0.029,-0.499 0.126,0.194 -0.031,1.278 -0.032,1.876 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 172.41,388.498 c -0.253,-1.502 -0.823,-3.281 -1.543,-4.426 -1.431,-1.978 -3.087,-3.363 -4.691,-4.225 -12.639,-5.806 -23.22,-4.668 -33.317,-4.708 -9.973,0.257 -19.303,1.977 -26.877,3.635 -2.056,0.414 -3.837,0.723 -5.742,1.081 0.942,-1.946 4.395,-4.381 9.045,-5.857 11.336,-3.872 24.276,-5.427 36.994,-7.905 3.212,-0.629 6.468,-1.366 9.802,-2.314 1.795,-0.615 3.306,-1.095 5.42,-2.077 1.356,-0.767 2.691,-1.732 3.833,-2.763 1.216,-1.094 1.123,-1.4 1.749,-2.138 2.888,-5.497 0.154,-9.411 -2.138,-11.455 -2.209,-1.813 -4.07,-2.521 -5.841,-3.25 -3.438,-1.206 -6.623,-1.962 -9.697,-2.603 -5.923,-1.185 -11.746,-2.35 -17.447,-3.491 -2.708,-0.627 -5.327,-1.323 -7.625,-2.167 -2.029,-0.541 -4.896,-2.546 -4.47,-1.999 -5.239,-0.452 7.175,-6.295 16.126,-9.559 2.379,-1.05 4.744,-2.111 7.167,-3.606 2.377,-1.571 4.826,-2.904 7.467,-7.304 0.519,-0.913 0.497,-1.135 0.769,-1.732 l 0.302,-0.759 c 0.655,-2.339 0.295,-1.708 0.447,-2.722 0.309,-2.454 -0.654,-5.077 -2.178,-7.262 -3.111,-3.362 -6.205,-4.324 -8.503,-4.968 -9.504,-2.252 -16.342,-1.636 -22.283,-1.613 -11.266,0.53 -17.705,0.832 -17.705,0.832 l -0.435,0.02 c -0.013,10e-4 -0.025,10e-4 -0.039,0.002 -3.601,0.211 -6.348,3.3 -6.137,6.9 0.02,0.352 0.185,0.647 0.258,0.98 -5.102,1.406 -13.175,2.844 -21.162,0.961 -1.216,-0.28 -2.339,0.451 -2.62,1.615 -0.28,1.174 0.451,2.347 1.615,2.62 3.138,0.74 6.251,1.03 9.219,1.03 6.305,0 11.691,-1.283 15.369,-2.41 1.186,0.881 2.628,1.436 4.218,1.343 0,0 6.506,-0.381 17.892,-1.047 5.331,-0.192 12.495,-0.473 18.407,0.916 0.489,0.076 0.751,0.228 1.075,0.365 0.046,-0.524 -0.954,0.952 -2.517,1.711 -1.517,0.979 -3.491,1.917 -5.545,2.849 -4.2,1.903 -9.006,3.539 -14.334,6.405 -2.572,1.518 -5.752,3.06 -8.394,7.571 -1.235,2.09 -1.821,5.469 -1.172,7.851 l 0.192,0.971 0.109,0.48 0.058,0.238 c -0.409,-0.849 0.622,1.434 0.541,1.228 l 0.533,0.888 c 0.473,0.676 0.399,0.956 1.535,2.136 0.911,0.987 1.94,1.93 3.001,2.754 0.93,0.64 1.624,0.942 2.461,1.416 1.649,0.972 3.146,1.422 4.708,2.035 3.08,1.085 6.079,1.822 9.074,2.484 5.781,1.088 11.688,2.199 17.695,3.33 2.519,0.487 4.876,1.101 7.055,1.772 -2.791,1.006 -6.697,2.02 -10.066,2.669 -12.255,2.586 -25.25,4.15 -38.467,8.792 -3.308,1.259 -6.697,2.764 -10.02,5.309 -3.129,2.371 -6.418,7.1 -5.997,12.295 -1.121,0.157 -2.409,0.386 -3.445,0.501 -11.212,1.484 -15.924,-0.49 -15.62,-0.547 -1.464,-0.864 -3.351,-0.38 -4.215,1.085 -0.865,1.463 -0.38,3.351 1.084,4.215 0,0 1.922,1.305 5.353,2.057 3.414,0.772 8.217,1.125 14.067,0.665 1.611,-0.11 3.498,-0.351 5.27,-0.538 1.225,1.766 2.652,3.714 3.981,4.658 3.089,2.591 6.36,4.248 9.62,5.699 13.123,5.076 26.239,6.142 39.027,5.639 6.42,-0.482 12.738,-1.231 19.226,-4.126 3.025,-1.411 7.177,-3.633 8.459,-10.06 0.004,-0.821 0.145,-1.196 0.019,-2.372 z m -9.438,2.025 c -0.167,-0.95 -0.69,1.205 -3.14,1.799 -4.217,1.853 -9.973,2.701 -15.631,2.999 -11.41,0.375 -23.87,-0.957 -34.554,-5.29 -1.679,-0.776 -3.049,-1.753 -4.49,-2.687 0.792,-0.121 1.479,-0.205 2.291,-0.333 7.939,-1.265 16.214,-2.754 25.719,-2.911 9.053,-0.165 20.581,-0.041 28.236,3.767 0.889,0.479 1.278,0.978 1.572,1.279 0,0 -0.254,-0.305 0.029,-0.499 0.126,0.194 -0.032,1.278 -0.032,1.876 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 446.066,388.498 c -0.253,-1.502 -0.823,-3.281 -1.543,-4.426 -1.431,-1.978 -3.087,-3.363 -4.691,-4.225 -12.639,-5.806 -23.22,-4.668 -33.317,-4.708 -9.973,0.257 -19.303,1.977 -26.877,3.635 -2.056,0.414 -3.837,0.723 -5.742,1.081 0.942,-1.946 4.395,-4.381 9.045,-5.857 11.336,-3.872 24.276,-5.427 36.994,-7.905 3.212,-0.629 6.468,-1.366 9.802,-2.314 1.795,-0.615 3.306,-1.095 5.42,-2.077 1.356,-0.767 2.691,-1.732 3.833,-2.763 1.216,-1.094 1.123,-1.4 1.749,-2.138 2.888,-5.497 0.155,-9.411 -2.138,-11.455 -2.209,-1.813 -4.069,-2.521 -5.841,-3.25 -3.438,-1.206 -6.623,-1.962 -9.697,-2.603 -5.923,-1.185 -11.746,-2.35 -17.447,-3.491 -2.708,-0.627 -5.327,-1.323 -7.625,-2.167 -2.029,-0.541 -4.896,-2.546 -4.47,-1.999 -5.239,-0.452 7.175,-6.295 16.126,-9.559 2.379,-1.05 4.744,-2.111 7.167,-3.606 2.377,-1.571 4.826,-2.904 7.467,-7.304 0.519,-0.913 0.497,-1.135 0.769,-1.732 l 0.302,-0.759 c 0.655,-2.339 0.295,-1.708 0.447,-2.722 0.309,-2.454 -0.654,-5.077 -2.178,-7.262 -3.111,-3.362 -6.205,-4.324 -8.503,-4.968 -9.504,-2.252 -16.342,-1.636 -22.283,-1.613 -11.266,0.53 -17.705,0.832 -17.705,0.832 l -0.435,0.02 c -0.013,10e-4 -0.025,10e-4 -0.039,0.002 -3.601,0.211 -6.348,3.3 -6.137,6.9 0.02,0.352 0.185,0.647 0.258,0.98 -5.102,1.406 -13.175,2.844 -21.162,0.961 -1.216,-0.28 -2.339,0.451 -2.62,1.615 -0.28,1.174 0.451,2.347 1.615,2.62 3.138,0.74 6.251,1.03 9.219,1.03 6.305,0 11.691,-1.283 15.369,-2.41 1.186,0.881 2.628,1.436 4.218,1.343 0,0 6.506,-0.381 17.892,-1.047 5.331,-0.192 12.495,-0.473 18.407,0.916 0.489,0.076 0.751,0.228 1.075,0.365 0.046,-0.524 -0.954,0.952 -2.517,1.711 -1.517,0.979 -3.491,1.917 -5.545,2.849 -4.2,1.903 -9.006,3.539 -14.334,6.405 -2.572,1.518 -5.752,3.06 -8.394,7.571 -1.235,2.09 -1.821,5.469 -1.172,7.851 l 0.192,0.971 0.109,0.48 0.059,0.238 c -0.409,-0.849 0.622,1.434 0.541,1.228 l 0.533,0.888 c 0.473,0.676 0.399,0.956 1.535,2.136 0.911,0.987 1.94,1.93 3.001,2.754 0.93,0.64 1.624,0.942 2.461,1.416 1.649,0.972 3.146,1.422 4.708,2.035 3.08,1.085 6.079,1.822 9.074,2.484 5.781,1.088 11.688,2.199 17.695,3.33 2.519,0.487 4.876,1.101 7.055,1.772 -2.791,1.006 -6.697,2.02 -10.066,2.669 -12.255,2.586 -25.25,4.15 -38.467,8.792 -3.308,1.259 -6.697,2.764 -10.02,5.309 -3.129,2.371 -6.418,7.1 -5.997,12.295 -1.121,0.157 -2.409,0.386 -3.445,0.501 -11.212,1.484 -15.924,-0.49 -15.62,-0.547 -1.464,-0.864 -3.351,-0.38 -4.215,1.085 -0.865,1.463 -0.38,3.351 1.084,4.215 0,0 1.922,1.305 5.353,2.057 3.414,0.772 8.217,1.125 14.067,0.665 1.611,-0.11 3.498,-0.351 5.27,-0.538 1.225,1.766 2.652,3.714 3.981,4.658 3.089,2.591 6.36,4.248 9.62,5.699 13.123,5.076 26.24,6.142 39.027,5.639 6.42,-0.482 12.738,-1.231 19.226,-4.126 3.025,-1.411 7.177,-3.633 8.459,-10.06 10e-4,-0.821 0.142,-1.196 0.018,-2.372 z m -9.439,2.025 c -0.167,-0.95 -0.69,1.205 -3.14,1.799 -4.217,1.853 -9.973,2.701 -15.631,2.999 -11.41,0.375 -23.87,-0.957 -34.554,-5.29 -1.679,-0.776 -3.049,-1.753 -4.49,-2.687 0.792,-0.121 1.479,-0.205 2.291,-0.333 7.939,-1.265 16.214,-2.754 25.719,-2.911 9.053,-0.165 20.581,-0.041 28.236,3.767 0.889,0.479 1.278,0.978 1.572,1.279 0,0 -0.254,-0.305 0.029,-0.499 0.126,0.194 -0.031,1.278 -0.032,1.876 z"
       id="path5" />
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 351.049,224.981 c -0.236,-1.508 -2.423,-1.433 -2.595,0.084 -5.266,46.402 -44.626,82.453 -92.452,82.453 -47.811,0 -87.185,-36.051 -92.452,-82.451 -0.172,-1.517 -2.359,-1.593 -2.595,-0.084 -0.732,4.668 -1.132,9.441 -1.132,14.315 -0.001,53.068 43.069,96.151 96.179,96.151 53.128,0 96.18,-43.083 96.18,-96.151 -0.002,-4.874 -0.403,-9.648 -1.133,-14.317 z"
       id="path2" />
    	<path
       fill="#ffe15a"
       d="m 254.81,185.268 -6.955,20.854 -21.983,0.17 c -1.205,0.009 -1.705,1.547 -0.735,2.263 l 17.685,13.059 -6.631,20.96 c -0.363,1.149 0.945,2.1 1.926,1.399 L 256,231.19 l 17.885,12.783 c 0.981,0.701 2.289,-0.249 1.926,-1.399 l -6.631,-20.96 17.685,-13.059 c 0.97,-0.716 0.47,-2.254 -0.735,-2.263 l -21.983,-0.17 -6.955,-20.854 c -0.383,-1.143 -2.001,-1.143 -2.382,0 z"
       id="path3" />
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs34" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0.001 h -15.334 l -81.77,53.574 V 0.001 H 105.93 V 53.575 L 24.16,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.002 c 0,4.875 3.953,8.828 8.828,8.828 h 15.334 l 81.77,-53.574 v 53.574 h 44.138 v -53.574 l 81.769,53.574 h 15.334 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 L 185.846,105.932 H 256 V 61.794 H 185.845 L 256,15.831 V 8.829 c 0,-4.876 -3.953,-8.828 -8.828,-8.828 z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.277 114.759,88.277 114.759,158.898 0,158.898 0,185.38 114.759,185.38 114.759,256.001 141.241,256.001 141.241,185.38 256,185.38 256,158.898 141.241,158.898 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.07 4.207,89.769 C 1.735,91.333 0,93.962 0,97.104 v 0.458 l 80.889,52.508 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.07 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.208 1.269,251.464 c 1.521,2.662 4.273,4.537 7.559,4.537 h 1.665 l 95.196,-61.793 H 89.474 Z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.86,247.866 173.194,194.208 H 156.98 l 93.874,60.935 c 2.812,-1.305 4.741,-4.04 5.006,-7.277 z"
       id="path6" />
    </g>
    <rect
       x="325.35999"
       y="98.964996"
       fill="#82afff"
       width="117.27"
       height="90.629997"
       id="rect6" />
    <path
       fill="#c86464"
       d="m 325.362,189.593 c 0,30.913 34.649,55.972 58.638,55.972 v 0 c 21.323,0 58.638,-25.06 58.638,-55.972 z"
       id="path7" />
    <path
       fill="#73af00"
       d="m 399.659,132.066 c 1.888,0.333 5.109,0.778 5.442,5.331 0.333,4.553 -1.333,20.768 -2.998,22.766 0,0 5.442,12.328 5.664,19.657 0.222,7.33 -0.777,29.263 -0.111,32.761 0.667,3.498 3.165,10.662 3.165,10.662 0,0 -7.663,-4.498 -10.661,-1.666 -2.998,2.831 -13.993,6.664 -18.325,2.166 0,0 5.164,-14.659 5.164,-31.318 0,-16.659 0,-57.805 0,-57.805 0,0 2.166,-1.721 4.997,-1.777 2.832,-0.055 7.663,-0.777 7.663,-0.777 z"
       id="path8" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    	<path
       fill="#fff5e1"
       d="m 400.769,308.41 c 0.333,2.11 1.221,3.665 0.777,4.442 -0.445,0.778 -3.331,7.885 -1.666,7.885 1.665,0 4.553,-0.888 5.331,-2.443 0.777,-1.555 1.11,-3.887 1.555,-4.553 0.445,-0.666 -0.778,-3.998 -1.777,-4.553 -0.999,-0.556 -4.22,-0.778 -4.22,-0.778 z"
       id="path9" />
    	<path
       fill="#fff5e1"
       d="m 381.557,225.006 -6.108,0.778 c 0,0 0.777,-3.998 0.888,-6.775 0.111,-2.776 0.333,-7.885 0.333,-7.885 0,0 4.331,-2.665 4.442,-3.11 0.055,-0.222 0.569,-1.61 0.167,-2.332 -0.402,-0.722 -1.721,-0.778 -1.721,-0.778 0,0 -5.109,2.665 -5.109,3.11 0,0.445 0,3.11 -0.555,4.109 -0.555,1 -3.665,9.329 -3.887,11.55 -0.222,2.221 -0.555,6.886 0.333,7.108 0.888,0.222 10.106,1.222 11.106,0.777 0.999,-0.444 0.111,-6.552 0.111,-6.552 z"
       id="path10" />
    </g>
    <polygon
       fill="#464655"
       points="386.998,192.577 379.336,192.577 379.336,203.072 357.105,203.072 357.105,210.735 379.336,210.735 379.336,311.52 386.998,311.52 386.998,210.735 409.229,210.735 409.229,203.072 386.998,203.072 "
       id="polygon10"
       transform="translate(0,-88.276)" />
    <path
       fill="#963c3c"
       d="m 396.105,128.4 c 0,0 7.441,2.143 8.44,-0.333 1.166,-2.888 -2.721,-3.276 -3.443,-6.33 -0.081,-0.342 -0.777,-4.442 -3.776,-5.219 -2.998,-0.778 -5.775,0 -5.886,1.999 -0.11,1.999 4.665,9.883 4.665,9.883 z"
       id="path11" />
    <path
       fill="#fff5e1"
       d="m 392.107,137.84 c -0.22,0.036 -0.555,-2.221 -0.111,-4.998 0.445,-2.776 0,-3.665 0,-3.665 0,0 -3.109,0.333 -3.109,-0.888 0,-1.221 0.666,-6.886 2.554,-9.773 0,0 1.333,1.666 3.776,1.666 0,0 -0.111,1.999 1.222,3.331 0,0 -1.666,1.443 -0.888,2.443 0.778,1 2.221,2.221 2.221,2.221 0,0 0.111,2.333 1.888,3.887 -0.001,0.002 -2.222,4.888 -7.553,5.776 z"
       id="path12" />
    <g
       id="g17"
       transform="translate(0,-88.276)">
    	<rect
       x="361.67999"
       y="274.32101"
       fill="#464655"
       width="0.66600001"
       height="13.215"
       id="rect12" />
    	<rect
       x="364.35999"
       y="271.76099"
       fill="#464655"
       width="0.66600001"
       height="18.333"
       id="rect13" />
    	<rect
       x="367.04001"
       y="269.42099"
       fill="#464655"
       width="0.66600001"
       height="23.01"
       id="rect14" />
    	<rect
       x="369.72"
       y="266.07101"
       fill="#464655"
       width="0.66600001"
       height="29.688"
       id="rect15" />
    	<rect
       x="372.39999"
       y="261.70099"
       fill="#464655"
       width="0.66600001"
       height="38.424"
       id="rect16" />
    	<rect
       x="375.07999"
       y="261.70099"
       fill="#464655"
       width="0.66600001"
       height="40.220001"
       id="rect17" />
    </g>
    <path
       fill="#ffe15a"
       d="m 387.109,194.479 c -2.945,-15.315 -11.106,-24.211 -13.993,-24.654 -2.888,-0.444 -4.997,1.888 -5.219,3.554 -0.222,1.666 -1.777,6.664 -4.998,8.995 -3.221,2.333 -9.218,3.665 -10.55,7.996 -1.333,4.331 2.221,6.219 4.331,5.774 0.158,-0.033 0.313,-0.095 0.471,-0.147 l 22.703,27.927 c 0.824,1.014 2.43,0.849 3.005,-0.327 2.333,-4.768 6.762,-16.06 4.25,-29.118 z m -28.052,0.31 c 0.89,-0.956 1.266,-2.273 0.289,-3.641 -1.666,-2.333 -3.554,1 -3.554,1 0,0 -0.555,-2.888 3.776,-4.331 4.331,-1.443 9.218,-3.886 11.439,-9.107 2.221,-5.219 2.11,-4.221 2.11,-4.221 0,0 8.885,4.998 10.106,20.657 1.222,15.659 -3.109,21.99 -3.109,21.99 z"
       id="path17" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<path
       fill="#fff5e1"
       d="m 379.336,249.25 c -1.02,0.652 -1.939,1.214 -2.582,1.549 -2.082,1.082 -4.582,2.166 -4.831,3.165 -0.249,1 -1.666,1.833 -1.582,2.998 0.084,1.166 0,4.664 0,4.664 1.249,-0.249 3.748,-0.667 4.582,-2.166 0.833,-1.5 1.582,-4.415 4.248,-5.664 0.047,-0.022 0.117,-0.045 0.167,-0.067 v -4.479 z"
       id="path18" />
    	<path
       fill="#fff5e1"
       d="m 401.408,227.977 c -1.249,0.583 -4.997,5.081 -5.58,7.164 -0.583,2.082 -2.415,6.997 -2.415,6.997 0,0 -3.785,0.494 -6.413,1.965 v 7.274 c 1.457,-0.422 2.745,-0.838 3.498,-1.242 2.166,-1.166 5.247,-3.331 6.83,-3.748 1.582,-0.416 2.915,-3.082 3.498,-4.664 0.583,-1.582 2.415,-6.247 2.665,-9.412 0.25,-3.168 -0.834,-4.917 -2.083,-4.334 z"
       id="path19" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 384,247.456 -0.291,-0.046 C 324.18,238.011 323.496,186.452 323.496,184.264 V 97.105 h 121.009 v 87.158 c 0,2.189 -0.684,53.747 -60.213,63.146 z M 327.229,100.837 v 83.425 c 0,2.057 0.644,50.387 56.771,59.414 56.128,-9.027 56.771,-57.357 56.771,-59.414 v -83.425 z"
       id="path20" />
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.448" {...props}>
    <defs
       id="defs21" />
    <path
       fill="#ff4b55"
       d="M 503.172,0 H 256 v 335.448 h 247.172 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.827 C 512,3.952 508.047,0 503.172,0 Z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="M 8.828,335.448 H 256 V 0 H 8.828 C 3.953,0 0,3.952 0,8.827 V 326.62 c 0,4.876 3.953,8.828 8.828,8.828 z"
       id="path2" />
    <path
       fill="#ff4b55"
       d="m 73.564,20.598 v 23.62 c 1.301,0.051 2.752,0.641 3.958,1.847 1.206,1.206 1.798,2.657 1.847,3.958 h 23.62 v 23.54 H 79.368 c -0.051,1.301 -0.641,2.752 -1.847,3.958 -1.206,1.206 -2.657,1.796 -3.958,1.847 v 23.62 H 50.023 V 79.368 C 48.722,79.317 47.271,78.727 46.065,77.521 44.859,76.315 44.269,74.864 44.218,73.563 H 20.598 V 50.024 h 23.62 c 0.051,-1.301 0.641,-2.752 1.847,-3.958 1.206,-1.206 2.657,-1.796 3.958,-1.847 v -23.62 h 23.541 m 2.941,-2.944 H 73.562 50.022 47.08 v 2.943 21.303 c -1.123,0.46 -2.177,1.165 -3.096,2.083 -0.919,0.919 -1.623,1.973 -2.084,3.096 H 20.598 17.655 v 2.943 23.54 2.943 h 2.943 21.303 c 0.461,1.123 1.165,2.178 2.084,3.096 0.918,0.918 1.972,1.623 3.095,2.083 v 21.303 2.942 h 2.943 23.54 2.943 v -2.943 -21.303 c 1.123,-0.46 2.177,-1.165 3.096,-2.084 0.918,-0.918 1.623,-1.972 2.083,-3.095 h 21.303 2.942 V 73.562 50.022 47.079 H 102.987 81.686 C 81.226,45.956 80.521,44.902 79.602,43.983 78.684,43.065 77.63,42.36 76.506,41.9 V 20.598 Z"
       id="path3" />
    <polygon
       fill="#cdcdcd"
       points="73.564,108.874 50.023,108.874 50.023,138.298 20.598,138.298 20.598,161.839 50.023,161.839 50.023,191.264 73.564,191.264 73.564,161.839 102.988,161.839 102.988,138.298 73.564,138.298 "
       id="polygon3"
       transform="translate(0,-88.276)" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<circle
       fill="#b4a08c"
       cx="61.792999"
       cy="150.07001"
       r="11.77"
       id="circle3" />
    	
    		<ellipse
       transform="matrix(-0.7071,-0.7071,0.7071,-0.7071,-32.3423,313.0141)"
       fill="#b4a08c"
       cx="48.655998"
       cy="163.205"
       rx="5.2340002"
       ry="3.6630001"
       id="ellipse3" />
    	
    		<ellipse
       transform="matrix(0.7071,-0.7071,0.7071,0.7071,-93.4508,100.7868)"
       fill="#b4a08c"
       cx="74.934998"
       cy="163.198"
       rx="5.2340002"
       ry="3.6630001"
       id="ellipse4" />
    	
    		<ellipse
       transform="matrix(0.7071,0.7071,-0.7071,0.7071,118.7734,-12.8702)"
       fill="#b4a08c"
       cx="74.921997"
       cy="136.937"
       rx="5.2340002"
       ry="3.6630001"
       id="ellipse5" />
    	
    		<ellipse
       transform="matrix(-0.7071,0.7071,-0.7071,-0.7071,179.8759,199.3544)"
       fill="#b4a08c"
       cx="48.650002"
       cy="136.931"
       rx="5.2340002"
       ry="3.6630001"
       id="ellipse6" />
    	<path
       fill="#b4a08c"
       d="m 61.793,166.182 c -8.885,0 -16.113,-7.226 -16.113,-16.113 0,-8.887 7.228,-16.113 16.113,-16.113 8.885,0 16.113,7.228 16.113,16.113 0,8.885 -7.228,16.113 -16.113,16.113 z m 0,-30.754 c -8.072,0 -14.641,6.569 -14.641,14.641 0,8.072 6.569,14.641 14.641,14.641 8.072,0 14.641,-6.569 14.641,-14.641 0,-8.072 -6.569,-14.641 -14.641,-14.641 z"
       id="path6" />
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MU = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 512,83.863 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <rect
       y="83.865005"
       fill="#41479b"
       width="512"
       height="83.860001"
       id="rect1"
       x="0" />
    <rect
       y="167.72501"
       fill="#ffe15a"
       width="512"
       height="83.860001"
       id="rect2"
       x="0" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 v -75.034 h 512 v 75.034 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MV = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 441.379,70.622 V 264.829 H 70.621 V 70.622 h 370.758"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="m 238.378,167.751 c 0,-33.425 22.767,-61.417 53.587,-69.525 1.026,-0.27 0.952,-1.754 -0.1,-1.889 -2.796,-0.36 -5.64,-0.566 -8.533,-0.566 -39.785,0 -71.992,32.202 -71.992,71.98 0,39.606 32.207,71.896 71.992,71.896 2.898,0 5.745,-0.209 8.544,-0.569 1.052,-0.136 1.125,-1.619 0.1,-1.889 -30.826,-8.121 -53.598,-36.154 -53.598,-69.438 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs41" />
    <path
       fill="#73af00"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#464655"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <g
       id="g26"
       transform="translate(0,-88.276)">
    	<rect
       y="200.09"
       fill="#ff4b55"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    	<path
       fill="#ff4b55"
       d="M 324.584,189.548 C 310.806,165.961 285.288,150.069 256,150.069 c -29.288,0 -54.806,15.892 -68.584,39.479 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 260.561,112.552 c 0,3.961 -4.561,28.69 -4.561,28.69 0,0 -4.561,-24.728 -4.561,-28.69 0,-3.961 2.042,-7.172 4.561,-7.172 2.519,0 4.561,3.21 4.561,7.172 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="m 341.737,149.954 c -2.801,2.801 -23.511,17.062 -23.511,17.062 0,0 14.261,-20.711 17.062,-23.511 2.801,-2.801 6.516,-3.628 8.297,-1.846 1.78,1.779 0.953,5.495 -1.848,8.295 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="m 176.713,143.505 c 2.801,2.801 17.062,23.511 17.062,23.511 0,0 -20.711,-14.261 -23.511,-17.062 -2.801,-2.801 -3.628,-6.516 -1.846,-8.297 1.779,-1.781 5.494,-0.954 8.295,1.848 z"
       id="path6" />
    	<path
       fill="#ff4b55"
       d="m 215.559,119.689 c 1.516,3.66 6.765,28.252 6.765,28.252 0,0 -13.677,-21.101 -15.192,-24.76 -1.515,-3.659 -0.858,-7.407 1.469,-8.372 2.326,-0.965 5.441,1.22 6.958,4.88 z"
       id="path7" />
    	<path
       fill="#ff4b55"
       d="m 304.868,123.18 c -1.516,3.66 -15.192,24.76 -15.192,24.76 0,0 5.249,-24.591 6.765,-28.252 1.516,-3.66 4.631,-5.845 6.958,-4.881 2.327,0.964 2.986,4.713 1.469,8.373 z"
       id="path8" />
    	<path
       fill="#ff4b55"
       d="m 237.274,113.974 c 0.788,3.882 1.233,29.024 1.233,29.024 0,0 -9.385,-23.328 -10.173,-27.211 -0.788,-3.882 0.576,-7.435 3.044,-7.936 2.47,-0.501 5.11,2.24 5.896,6.123 z"
       id="path9" />
    	<path
       fill="#ff4b55"
       d="m 324.266,134.494 c -2.188,3.302 -19.651,21.395 -19.651,21.395 0,0 9.859,-23.132 12.047,-26.434 2.188,-3.302 5.664,-4.851 7.764,-3.459 2.1,1.392 2.028,5.196 -0.16,8.498 z"
       id="path10" />
    	<path
       fill="#ff4b55"
       d="m 161.252,160.975 c 3.302,2.188 21.395,19.651 21.395,19.651 0,0 -23.132,-9.859 -26.434,-12.047 -3.302,-2.188 -4.851,-5.664 -3.459,-7.764 1.392,-2.099 5.197,-2.028 8.498,0.16 z"
       id="path11" />
    	<path
       fill="#ff4b55"
       d="m 194.589,129.913 c 2.214,3.285 12.246,26.343 12.246,26.343 0,0 -17.598,-17.961 -19.811,-21.246 -2.214,-3.285 -2.314,-7.09 -0.224,-8.497 2.088,-1.407 5.576,0.115 7.789,3.4 z"
       id="path12" />
    	<path
       fill="#ff4b55"
       d="m 355.328,167.83 c -3.285,2.214 -26.343,12.246 -26.343,12.246 0,0 17.961,-17.598 21.246,-19.811 3.285,-2.214 7.09,-2.314 8.497,-0.224 1.408,2.089 -0.115,5.577 -3.4,7.789 z"
       id="path13" />
    	<path
       fill="#ff4b55"
       d="m 282.812,115.582 c -0.758,3.887 -9.967,27.286 -9.967,27.286 0,0 0.256,-25.144 1.015,-29.032 0.759,-3.887 3.377,-6.649 5.849,-6.167 2.473,0.482 3.861,4.025 3.103,7.913 z"
       id="path14" />
    	<path
       fill="#ff4b55"
       d="m 285.529,116.258 c -1.151,3.79 -3.969,28.778 -3.969,28.778 0,0 11.546,-22.337 12.697,-26.129 1.151,-3.79 0.129,-7.456 -2.281,-8.188 -2.409,-0.732 -5.296,1.749 -6.447,5.539 z"
       id="path15" />
    	<path
       fill="#ff4b55"
       d="m 196.989,128.47 c 1.867,3.494 17.543,23.155 17.543,23.155 0,0 -7.63,-23.96 -9.497,-27.454 -1.867,-3.494 -5.181,-5.364 -7.403,-4.177 -2.223,1.188 -2.51,4.981 -0.643,8.476 z"
       id="path16" />
    	<path
       fill="#ff4b55"
       d="m 356.771,170.23 c -3.493,1.867 -23.155,17.543 -23.155,17.543 0,0 23.96,-7.63 27.454,-9.497 3.493,-1.867 5.364,-5.181 4.177,-7.403 -1.186,-2.222 -4.981,-2.51 -8.476,-0.643 z"
       id="path17" />
    	<path
       fill="#ff4b55"
       d="m 326.518,136.159 c -2.514,3.062 -14.679,25.068 -14.679,25.068 0,0 19.217,-16.218 21.73,-19.281 2.514,-3.062 2.973,-6.839 1.026,-8.438 -1.946,-1.598 -5.563,-0.411 -8.077,2.651 z"
       id="path18" />
    	<path
       fill="#ff4b55"
       d="m 162.918,158.723 c 3.062,2.514 25.068,14.679 25.068,14.679 0,0 -16.218,-19.217 -19.281,-21.73 -3.063,-2.513 -6.839,-2.973 -8.438,-1.026 -1.598,1.948 -0.412,5.564 2.651,8.077 z"
       id="path19" />
    	<path
       fill="#ff4b55"
       d="m 240.044,113.558 c 0.387,3.943 7.346,28.106 7.346,28.106 0,0 2.12,-25.056 1.732,-28.999 -0.387,-3.943 -2.734,-6.938 -5.24,-6.691 -2.507,0.246 -4.225,3.641 -3.838,7.584 z"
       id="path20" />
    	<path
       fill="#ff4b55"
       d="m 263.061,112.676 c -0.394,3.942 1.686,29.001 1.686,29.001 0,0 6.996,-24.152 7.39,-28.094 0.394,-3.942 -1.319,-7.34 -3.826,-7.591 -2.506,-0.25 -4.856,2.743 -5.25,6.684 z"
       id="path21" />
    	<path
       fill="#ff4b55"
       d="m 178.569,141.825 c 2.509,3.065 21.699,19.314 21.699,19.314 0,0 -12.131,-22.026 -14.639,-25.091 -2.509,-3.065 -6.123,-4.257 -8.072,-2.663 -1.95,1.595 -1.497,5.374 1.012,8.44 z"
       id="path22" />
    	<path
       fill="#ff4b55"
       d="m 343.416,151.81 c -3.065,2.509 -19.314,21.699 -19.314,21.699 0,0 22.026,-12.131 25.091,-14.639 3.065,-2.508 4.257,-6.123 2.663,-8.072 -1.595,-1.949 -5.373,-1.497 -8.44,1.012 z"
       id="path23" />
    	<path
       fill="#ff4b55"
       d="m 307.13,124.252 c -1.873,3.491 -9.54,27.438 -9.54,27.438 0,0 15.706,-19.637 17.579,-23.127 1.873,-3.491 1.59,-7.286 -0.629,-8.477 -2.22,-1.191 -5.537,0.674 -7.41,4.166 z"
       id="path24" />
    	<path
       fill="#ff4b55"
       d="m 151.01,178.111 c 3.491,1.873 27.438,9.54 27.438,9.54 0,0 -19.637,-15.706 -23.127,-17.579 -3.491,-1.873 -7.286,-1.59 -8.477,0.63 -1.19,2.219 0.675,5.536 4.166,7.409 z"
       id="path25" />
    	<path
       fill="#ff4b55"
       d="m 217.916,118.847 c 1.144,3.793 12.657,26.148 12.657,26.148 0,0 -2.778,-24.992 -3.924,-28.783 -1.144,-3.793 -4.028,-6.276 -6.439,-5.548 -2.411,0.727 -3.439,4.391 -2.294,8.183 z"
       id="path26" />
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const MX = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs31" />
    <path
       fill="#73af00"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <polygon
       fill="#ffd250"
       points="256,279.12 263.613,279.12 271.225,263.893 256,271.507 "
       id="polygon2"
       transform="translate(0,-88.272)" />
    <g
       id="g4"
       transform="translate(0,-88.272)">
    	<path
       fill="#00c3a0"
       d="m 256,298.151 c -2.104,0 -3.807,-1.703 -3.807,-3.807 v -15.225 c 0,-2.104 1.703,-3.807 3.807,-3.807 2.104,0 3.807,1.703 3.807,3.807 v 15.225 c 0,2.104 -1.703,3.807 -3.807,3.807 z"
       id="path3" />
    	<path
       fill="#00c3a0"
       d="m 256,282.926 c -14.951,0 -29.388,-5.769 -40.654,-16.244 -1.539,-1.431 -1.628,-3.84 -0.198,-5.378 1.442,-1.535 3.848,-1.617 5.378,-0.198 9.854,9.163 22.452,14.207 35.473,14.207 13.021,0 25.619,-5.044 35.473,-14.207 1.535,-1.423 3.94,-1.345 5.378,0.198 1.431,1.539 1.342,3.948 -0.198,5.378 -11.264,10.476 -25.701,16.244 -40.652,16.244 z"
       id="path4" />
    </g>
    <path
       fill="#00aadc"
       d="m 256,209.879 c -9.758,0 -19.21,-2.851 -27.336,-8.248 l 4.215,-6.342 c 13.739,9.129 32.503,9.129 46.241,0 l 4.215,6.342 c -8.125,5.398 -17.577,8.248 -27.335,8.248 z"
       id="path5" />
    <polygon
       fill="#732d37"
       points="240.14,264.052 262.027,258.977 249.973,246.764 241.568,259.771 "
       id="polygon5"
       transform="translate(0,-88.272)" />
    <path
       fill="#aad264"
       d="m 232.704,179.964 c -10.062,0 -22.14,-8.468 -25.344,-27.336 l 7.509,-1.271 c 2.662,15.69 12.314,21.005 18.11,20.991 1.777,-0.049 3.631,-0.662 3.777,-1.918 0.171,-1.502 0.212,-1.858 -3.769,-3.204 -2.164,-0.733 -4.617,-1.561 -6.338,-3.531 -6.963,-7.951 2.464,-16.366 6.993,-20.41 0.799,-0.714 1.13,-1.32 1.045,-1.55 -0.249,-0.651 -1.743,-1.635 -3.427,-1.635 -4.836,0 -8.505,-2.732 -9.571,-7.126 -1.108,-4.55 0.985,-9.345 4.97,-11.404 l 3.495,6.765 c -0.934,0.483 -1.304,1.858 -1.067,2.84 0.093,0.394 0.32,1.312 2.175,1.312 4.661,0 9.096,2.751 10.538,6.535 0.617,1.613 1.546,5.806 -3.085,9.943 -5,4.465 -7.992,7.825 -6.334,9.717 0.375,0.427 1.985,0.974 3.048,1.331 3.427,1.16 9.806,3.316 8.892,11.289 -0.573,5.014 -5.048,8.493 -11.129,8.658 -0.164,0 -0.328,0.004 -0.488,0.004 z"
       id="path6" />
    <path
       fill="#874150"
       d="m 263.613,137.558 c 0,0 7.613,-15.225 -7.613,-22.838 0,0 53.289,-7.613 45.676,60.902 l -0.003,-0.003 c -4.996,-3.997 -12.414,-11.302 -15.063,-17.126 L 263.613,145.17 Z"
       id="path7" />
    <path
       fill="#732d37"
       d="m 256,152.783 38.063,22.838 c 0,0 0,0 -15.225,7.613 L 256,160.397 Z"
       id="path8" />
    <path
       fill="#783c46"
       d="m 240.775,129.945 v 0 c 4.204,0 7.613,3.409 7.613,7.613 l -0.008,0.008 c -4.542,4.542 -5.667,11.479 -2.795,17.224 l 1.72,3.441 c 0.717,1.434 1.661,2.744 2.795,3.878 l 21.127,21.127 v -10.521 c 0,-13.107 -3.051,-26.034 -8.913,-37.757 v 0 c -3.869,-7.737 -11.777,-12.625 -20.427,-12.625 h -1.111 v 7.614 h -0.001 z"
       id="path9" />
    <path
       fill="#ffd250"
       d="m 240.775,122.332 -7.613,7.613 v 7.613 c 0,0 9.056,-4.591 12.108,-6.054 2.133,-1.022 1.745,-3.439 0.521,-4.604 -0.953,-0.906 -5.016,-4.568 -5.016,-4.568 z"
       id="path10" />
    <path
       fill="#aad264"
       d="m 256,225.104 c -35.681,0 -64.708,-29.027 -64.708,-64.708 h 7.613 c 0,31.485 25.611,57.096 57.096,57.096 31.485,0 57.096,-25.611 57.096,-57.096 h 7.613 c -0.002,35.681 -29.029,64.708 -64.71,64.708 z"
       id="path11" />
    <g
       id="g16"
       transform="translate(0,-88.272)">
    	<circle
       fill="#ffe15a"
       cx="199.32001"
       cy="271.258"
       r="5.1659999"
       id="circle11" />
    	<circle
       fill="#ffe15a"
       cx="210.74001"
       cy="289.49701"
       r="5.1659999"
       id="circle12" />
    	<circle
       fill="#ffe15a"
       cx="229.28999"
       cy="303.28799"
       r="5.1659999"
       id="circle13" />
    	<circle
       fill="#ffe15a"
       cx="313.23001"
       cy="271.258"
       r="5.1659999"
       id="circle14" />
    	<circle
       fill="#ffe15a"
       cx="301.79999"
       cy="289.49701"
       r="5.1659999"
       id="circle15" />
    	<circle
       fill="#ffe15a"
       cx="283.25"
       cy="303.28799"
       r="5.1659999"
       id="circle16" />
    </g>
    <path
       fill="#ffb478"
       d="m 259.807,213.685 h -7.613 c -4.204,0 -7.613,-3.409 -7.613,-7.613 v 0 c 0,-4.204 3.409,-7.613 7.613,-7.613 h 7.613 c 4.204,0 7.613,3.409 7.613,7.613 v 0 c 0,4.205 -3.409,7.613 -7.613,7.613 z"
       id="path16" />
    <path
       fill="#9b4b5a"
       d="m 286.61,158.492 c 2.538,7.454 7.93,14.274 15.063,17.126 l 0.003,0.003 C 309.289,107.108 256,114.72 256,114.72 c 38.063,0 30.61,43.772 30.61,43.772 z"
       id="path17" />
    <g
       id="g17"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const MY = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.00002 335.44923" {...props}>
    <defs
         id="defs39"><clipPath
           clipPathUnits="userSpaceOnUse"
           id="clipPath941"><g
             id="use943"><path
               fill="#435125"
               id="path1436"
               d="m 301.50807,445.71112 c -0.18,-0.086 -0.218,-0.122 -0.347,-0.245 l -0.125,-0.117 c -0.324,-0.297 -0.861,-0.822 -1.582,-1.643 -1.332,-1.513 -3.119,-3.728 -4.69,-5.685 -3.115,-3.883 -5.689,-7.228 -6.174,-7.858 l -0.793,-1.032 -7.767,-2.395 -5.671,-2.644 3.03,-3.406 10.408,4.456 7.767,1.594 14.363,10.564 -0.011,0.009 c -0.029,0.024 -2.089,1.738 -4.136,3.599 -0.913,0.83 -2.064,1.896 -2.877,2.783 -0.375,0.408 -0.705,0.813 -0.93,1.14 -0.138,0.201 -0.215,0.383 -0.252,0.471 l 0.892,-0.555 0.967,0.752 -1.968,0.184 -0.09,0.02 z m -53.34,-16.02 c -6.777,-0.001 -13.471,-1.874 -19.895,-5.567 l -0.007,-0.004 0.003,-0.008 c 0,0 0.84,-1.601 2.878,-3.096 1.941,-1.425 5.442,-3.128 11.1,-3.15 h 0.117 c 6.701,0 14.901,2.278 24.373,6.771 -0.32,0.212 -7.756,5.054 -18.566,5.054 l 0.01,0.01 z m -29.37,-6.51 c -1.253,0 -2.379,-0.474 -3.17,-1.333 -0.649,-0.706 -1.114,-1.646 -1.422,-2.878 -0.504,-2.018 -0.365,-4.025 -0.351,-4.217 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.511,0 4.49,2.178 5.338,4.337 0.481,1.227 0.574,2.259 0.274,3.067 -0.3,0.81 -1.24,1.37 -2.34,1.37 z m 51.68,-5.99 c -17.359,-2.479 -24.717,-8.755 -27.833,-13.583 -3.323,-5.149 -2.641,-9.912 -2.634,-9.96 l 0.003,-0.014 0.013,-0.004 c 0.005,0 1.061,-0.285 2.658,-0.293 4.618,0 16.43,2.323 27.798,23.842 l 0.007,0.014 -0.02,-0.01 z m -35.58,-3.44 c -7.416,-0.001 -13.062,-1.28 -16.782,-3.804 -2.138,-1.45 -3.184,-3.043 -3.686,-4.125 -0.47,-1.014 -0.577,-1.856 -0.594,-2.023 0.196,-0.09 3.232,-1.438 7.765,-1.65 0.383,-0.018 0.769,-0.029 1.174,-0.03 5.732,0 14.448,1.87 23.646,10.78 l 0.009,0.009 -0.011,10e-4 c -4.2,0.55 -8.08,0.84 -11.53,0.84 z m -35.91,-1.38 c -7.82,0 -18.563,-2.388 -25.263,-9.087 l -0.007,-0.008 0.02,-0.005 c 0.07,-0.018 7.342,-1.863 15.523,-2.062 0.488,-0.012 0.979,-0.019 1.475,-0.019 7.332,0 12.944,1.422 16.682,4.225 1.305,0.979 2.018,1.89 2.178,2.783 0.134,0.746 -0.26,1.55 -1.056,2.15 -1.683,1.271 -4.692,1.949 -8.945,2.017 l -0.6,0.02 z m -25.34,-13 c -0.963,0 -1.867,-0.426 -2.479,-1.167 -0.506,-0.614 -0.858,-1.416 -1.108,-2.522 -0.418,-1.848 -0.292,-3.656 -0.291,-3.674 l 0.001,-0.018 c 0.364,-0.172 0.771,-0.264 1.217,-0.275 h 0.003 c 1.157,0 2.039,0.63 2.589,1.158 0.733,0.705 1.333,1.645 1.688,2.645 0.365,1.03 0.424,1.892 0.18,2.635 -0.2,0.59 -0.88,1.21 -1.8,1.21 z m 58.53,-1.32 c -1.253,0 -2.379,-0.474 -3.17,-1.333 -0.649,-0.706 -1.114,-1.646 -1.422,-2.878 -0.504,-2.018 -0.365,-4.025 -0.351,-4.217 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.511,0 4.49,2.178 5.338,4.337 0.481,1.227 0.574,2.259 0.274,3.067 -0.3,0.82 -1.25,1.37 -2.34,1.37 z m -28.51,-1.18 c -15.737,-0.554 -23.904,-5.027 -27.984,-8.683 -2.297,-2.058 -3.574,-4.098 -4.24,-5.447 -0.628,-1.274 -0.866,-2.249 -0.908,-2.438 l 0.021,-0.009 c 0.003,0 1.489,-0.532 3.885,-0.579 l 0.368,-0.004 c 5.307,0 16.111,2.229 28.852,17.153 v 0.01 z m 17.09,-1.59 c -12.661,-1.928 -19.834,-7.363 -23.622,-11.585 -3.971,-4.425 -5.16,-8.546 -5.213,-8.738 0.023,-0.007 1.57,-0.41 3.9,-0.469 0.169,-0.005 0.345,-0.007 0.524,-0.007 0.181,0 0.365,0.002 0.553,0.007 6.368,0.139 17.934,3.023 23.855,20.785 h 0.01 z m -65,-6.08 c -4.149,0 -8.174,-0.48 -11.962,-1.427 -6.629,-1.658 -9.473,-4.189 -10.691,-6.021 -0.692,-1.04 -0.943,-1.952 -1.031,-2.534 -0.085,-0.556 -0.04,-0.999 -0.031,-1.073 l 0.031,-0.011 c 0.017,-0.004 4.4,-1.235 10.464,-1.328 0.239,-0.004 0.48,-0.006 0.725,-0.006 2.927,0 5.808,0.279 8.564,0.83 10.536,2.107 16,10.06 16.053,10.14 l 0.005,0.009 -0.013,0.003 c -0.06,0.01 -5.08,1.42 -12.12,1.42 z m 29.39,-10.68 c -1.269,0 -2.395,-0.463 -3.172,-1.304 -0.639,-0.691 -1.104,-1.643 -1.42,-2.908 -0.506,-2.015 -0.365,-4.002 -0.351,-4.185 0.526,-0.221 1.062,-0.342 1.562,-0.354 l 0.112,-0.002 c 2.506,0 4.488,2.179 5.339,4.338 0.468,1.188 0.55,2.208 0.243,3.034 -0.31,0.84 -1.22,1.38 -2.31,1.38 z m -22.1,-3.03 c -0.095,-0.023 -5.977,-1.536 -11.967,-5.225 -5.544,-3.413 -12.326,-9.45 -13.153,-18.83 v -0.005 l 0.014,-0.004 c 0.001,0 0.516,-0.125 1.278,-0.154 0.105,-0.004 0.217,-0.006 0.334,-0.006 1.656,0 5.046,0.466 9.147,3.584 5.22,3.98 10.04,10.92 14.35,20.65 z m 14.43,-0.53 c -0.037,-0.015 -4.229,-1.693 -9.469,-6.084 -4.882,-4.092 -11.746,-11.46 -16.716,-23.33 0.003,-0.001 1.142,-0.608 2.886,-0.718 0.101,-0.007 0.203,-0.009 0.306,-0.009 0.15,0 0.305,0.005 0.463,0.009 2.411,0.068 6.083,1.07 10.154,5.463 4.676,5.047 8.85,13.34 12.404,24.651 l 0.01,0.032 -0.03,-0.01 z m -37.39,-1.09 c -4.821,0 -6.471,-2.615 -6.957,-3.74 -0.798,-1.849 -0.556,-3.689 -0.554,-3.707 l 0.003,-0.02 c 0.78,-0.195 1.605,-0.303 2.398,-0.314 l 0.165,-0.001 c 3.799,0 6.798,1.929 8.084,3.841 0.255,0.379 1.037,1.694 0.39,2.721 -0.52,0.81 -1.7,1.22 -3.53,1.22 z m -10.68,-13.47 c -2.692,0 -6.811,-0.165 -11.141,-0.952 -4.294,-0.781 -6.728,-4.432 -8.013,-7.356 -1.399,-3.185 -1.794,-6.223 -1.798,-6.254 h 0.012 c 13.282,0.39 19.555,4.271 22.478,7.457 3.018,3.29 3.197,6.706 3.206,6.922 l -0.009,10e-4 c -0.02,0 -1.89,0.18 -4.74,0.18 z m 13.83,-13.82 c -0.018,-0.022 -1.535,-1.898 -3.033,-4.228 -1.573,-2.445 -3.028,-4.996 -3.028,-7.084 0,-2.016 -0.474,-6.266 -0.757,-8.619 -0.358,-2.985 -0.72,-5.54 -0.75,-5.757 l 0.013,0.004 c 0.337,0.123 8.308,3.114 8.308,10.591 0,7.489 -0.738,15.014 -0.745,15.089 l -0.001,0.011 h -0.01 z m -10.33,-0.71 c -0.084,0 -0.167,-0.008 -0.25,-0.021 -2.356,-0.393 -6.496,-2.194 -11.073,-4.818 -5.082,-2.914 -9.209,-6.036 -11.62,-8.791 -2.198,-2.512 -3.503,-6.457 -3.88,-11.726 -0.267,-3.739 0.053,-6.854 0.087,-7.163 0.412,-0.137 0.85,-0.204 1.315,-0.204 1.764,0.029 3.647,0.823 6.189,2.574 1.981,1.365 4.165,3.221 6.49,5.514 4.012,3.957 7.168,7.932 7.199,7.971 l 0.032,0.04 c 0.265,0.475 2.537,4.571 4.307,8.558 1.124,2.532 1.767,4.357 2.024,5.746 0.147,0.791 0.19,1.31 -0.004,1.781 -0.081,0.195 -0.235,0.376 -0.385,0.448 -0.14,0.06 -0.28,0.09 -0.44,0.09 z" /><path
               fill="#435125"
               id="use1438"
               d="m 274.08607,445.71112 c 0.18,-0.086 0.218,-0.122 0.347,-0.245 l 0.125,-0.117 c 0.324,-0.297 0.861,-0.822 1.582,-1.643 1.332,-1.513 3.119,-3.728 4.69,-5.685 3.115,-3.883 5.689,-7.228 6.174,-7.858 l 0.793,-1.032 7.767,-2.395 5.671,-2.644 -3.03,-3.406 -10.408,4.456 -7.767,1.594 -14.363,10.564 0.011,0.009 c 0.029,0.024 2.089,1.738 4.136,3.599 0.913,0.83 2.064,1.896 2.877,2.783 0.375,0.408 0.705,0.813 0.93,1.14 0.138,0.201 0.215,0.383 0.252,0.471 l -0.892,-0.555 -0.967,0.752 1.968,0.184 0.09,0.02 z m 53.34,-16.02 c 6.777,-0.001 13.471,-1.874 19.895,-5.567 l 0.007,-0.004 -0.003,-0.008 c 0,0 -0.84,-1.601 -2.878,-3.096 -1.941,-1.425 -5.442,-3.128 -11.1,-3.15 h -0.117 c -6.701,0 -14.901,2.278 -24.373,6.771 0.32,0.212 7.756,5.054 18.566,5.054 l -0.01,0.01 z m 29.37,-6.51 c 1.253,0 2.379,-0.474 3.17,-1.333 0.649,-0.706 1.114,-1.646 1.422,-2.878 0.504,-2.018 0.365,-4.025 0.351,-4.217 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.511,0 -4.49,2.178 -5.338,4.337 -0.481,1.227 -0.574,2.259 -0.274,3.067 0.3,0.81 1.24,1.37 2.34,1.37 z m -51.68,-5.99 c 17.359,-2.479 24.717,-8.755 27.833,-13.583 3.323,-5.149 2.641,-9.912 2.634,-9.96 l -0.003,-0.014 -0.013,-0.004 c -0.005,0 -1.061,-0.285 -2.658,-0.293 -4.618,0 -16.43,2.323 -27.798,23.842 l -0.007,0.014 0.02,-0.01 z m 35.58,-3.44 c 7.416,-0.001 13.062,-1.28 16.782,-3.804 2.138,-1.45 3.184,-3.043 3.686,-4.125 0.47,-1.014 0.577,-1.856 0.594,-2.023 -0.196,-0.09 -3.232,-1.438 -7.765,-1.65 -0.383,-0.018 -0.769,-0.029 -1.174,-0.03 -5.732,0 -14.448,1.87 -23.646,10.78 l -0.009,0.009 0.011,10e-4 c 4.2,0.55 8.08,0.84 11.53,0.84 z m 35.91,-1.38 c 7.82,0 18.563,-2.388 25.263,-9.087 l 0.007,-0.008 -0.02,-0.005 c -0.07,-0.018 -7.342,-1.863 -15.523,-2.062 -0.488,-0.012 -0.979,-0.019 -1.475,-0.019 -7.332,0 -12.944,1.422 -16.682,4.225 -1.305,0.979 -2.018,1.89 -2.178,2.783 -0.134,0.746 0.26,1.55 1.056,2.15 1.683,1.271 4.692,1.949 8.945,2.017 l 0.6,0.02 z m 25.34,-13 c 0.963,0 1.867,-0.426 2.479,-1.167 0.506,-0.614 0.858,-1.416 1.108,-2.522 0.418,-1.848 0.292,-3.656 0.291,-3.674 l -0.001,-0.018 c -0.364,-0.172 -0.771,-0.264 -1.217,-0.275 h -0.003 c -1.157,0 -2.039,0.63 -2.589,1.158 -0.733,0.705 -1.333,1.645 -1.688,2.645 -0.365,1.03 -0.424,1.892 -0.18,2.635 0.2,0.59 0.88,1.21 1.8,1.21 z m -58.53,-1.32 c 1.253,0 2.379,-0.474 3.17,-1.333 0.649,-0.706 1.114,-1.646 1.422,-2.878 0.504,-2.018 0.365,-4.025 0.351,-4.217 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.511,0 -4.49,2.178 -5.338,4.337 -0.481,1.227 -0.574,2.259 -0.274,3.067 0.3,0.82 1.25,1.37 2.34,1.37 z m 28.51,-1.18 c 15.737,-0.554 23.904,-5.027 27.984,-8.683 2.297,-2.058 3.574,-4.098 4.24,-5.447 0.628,-1.274 0.866,-2.249 0.908,-2.438 l -0.021,-0.009 c -0.003,0 -1.489,-0.532 -3.885,-0.579 l -0.368,-0.004 c -5.307,0 -16.111,2.229 -28.852,17.153 v 0.01 z m -17.09,-1.59 c 12.661,-1.928 19.834,-7.363 23.622,-11.585 3.971,-4.425 5.16,-8.546 5.213,-8.738 -0.023,-0.007 -1.57,-0.41 -3.9,-0.469 -0.169,-0.005 -0.345,-0.007 -0.524,-0.007 -0.181,0 -0.365,0.002 -0.553,0.007 -6.368,0.139 -17.934,3.023 -23.855,20.785 h -0.01 z m 65,-6.08 c 4.149,0 8.174,-0.48 11.962,-1.427 6.629,-1.658 9.473,-4.189 10.691,-6.021 0.692,-1.04 0.943,-1.952 1.031,-2.534 0.085,-0.556 0.04,-0.999 0.031,-1.073 l -0.031,-0.011 c -0.017,-0.004 -4.4,-1.235 -10.464,-1.328 -0.239,-0.004 -0.48,-0.006 -0.725,-0.006 -2.927,0 -5.808,0.279 -8.564,0.83 -10.536,2.107 -16,10.06 -16.053,10.14 l -0.005,0.009 0.013,0.003 c 0.06,0.01 5.08,1.42 12.12,1.42 z m -29.39,-10.68 c 1.269,0 2.395,-0.463 3.172,-1.304 0.639,-0.691 1.104,-1.643 1.42,-2.908 0.506,-2.015 0.365,-4.002 0.351,-4.185 -0.526,-0.221 -1.062,-0.342 -1.562,-0.354 l -0.112,-0.002 c -2.506,0 -4.488,2.179 -5.339,4.338 -0.468,1.188 -0.55,2.208 -0.243,3.034 0.31,0.84 1.22,1.38 2.31,1.38 z m 22.1,-3.03 c 0.095,-0.023 5.977,-1.536 11.967,-5.225 5.544,-3.413 12.326,-9.45 13.153,-18.83 v -0.005 l -0.014,-0.004 c -10e-4,0 -0.516,-0.125 -1.278,-0.154 -0.105,-0.004 -0.217,-0.006 -0.334,-0.006 -1.656,0 -5.046,0.466 -9.147,3.584 -5.22,3.98 -10.04,10.92 -14.35,20.65 z m -14.43,-0.53 c 0.037,-0.015 4.229,-1.693 9.469,-6.084 4.882,-4.092 11.746,-11.46 16.716,-23.33 -0.003,-0.001 -1.142,-0.608 -2.886,-0.718 -0.101,-0.007 -0.203,-0.009 -0.306,-0.009 -0.15,0 -0.305,0.005 -0.463,0.009 -2.411,0.068 -6.083,1.07 -10.154,5.463 -4.676,5.047 -8.85,13.34 -12.404,24.651 l -0.01,0.032 0.03,-0.01 z m 37.39,-1.09 c 4.821,0 6.471,-2.615 6.957,-3.74 0.798,-1.849 0.556,-3.689 0.554,-3.707 l -0.003,-0.02 c -0.78,-0.195 -1.605,-0.303 -2.398,-0.314 l -0.165,-0.001 c -3.799,0 -6.798,1.929 -8.084,3.841 -0.255,0.379 -1.037,1.694 -0.39,2.721 0.52,0.81 1.7,1.22 3.53,1.22 z m 10.68,-13.47 c 2.692,0 6.811,-0.165 11.141,-0.952 4.294,-0.781 6.728,-4.432 8.013,-7.356 1.399,-3.185 1.794,-6.223 1.798,-6.254 h -0.012 c -13.282,0.39 -19.555,4.271 -22.478,7.457 -3.018,3.29 -3.197,6.706 -3.206,6.922 l 0.009,10e-4 c 0.02,0 1.89,0.18 4.74,0.18 z m -13.83,-13.82 c 0.018,-0.022 1.535,-1.898 3.033,-4.228 1.573,-2.445 3.028,-4.996 3.028,-7.084 0,-2.016 0.474,-6.266 0.757,-8.619 0.358,-2.985 0.72,-5.54 0.75,-5.757 l -0.013,0.004 c -0.337,0.123 -8.308,3.114 -8.308,10.591 0,7.489 0.738,15.014 0.745,15.089 l 10e-4,0.011 h 0.01 z m 10.33,-0.71 c 0.084,0 0.167,-0.008 0.25,-0.021 2.356,-0.393 6.496,-2.194 11.073,-4.818 5.082,-2.914 9.209,-6.036 11.62,-8.791 2.198,-2.512 3.503,-6.457 3.88,-11.726 0.267,-3.739 -0.053,-6.854 -0.087,-7.163 -0.412,-0.137 -0.85,-0.204 -1.315,-0.204 -1.764,0.029 -3.647,0.823 -6.189,2.574 -1.981,1.365 -4.165,3.221 -6.49,5.514 -4.012,3.957 -7.168,7.932 -7.199,7.971 l -0.032,0.04 c -0.265,0.475 -2.537,4.571 -4.307,8.558 -1.124,2.532 -1.767,4.357 -2.024,5.746 -0.147,0.791 -0.19,1.31 0.004,1.781 0.081,0.195 0.235,0.376 0.385,0.448 0.14,0.06 0.28,0.09 0.44,0.09 z" /><path
               fill="#d47600"
               d="m 565.53807,42.937117 -2.355,0.938 -0.923,0.368 -2.854,-0.157 -2.673,1.283 -4.74,3.239 -0.209,0.15 -1.767,0.461 -1.641,-0.708 -0.932,0.424 -0.321,1.92 -0.887,1.379 -1.092,0.767 -3.783,0.387 -3.19,1.645 -4.15,-1.111 -1.928,0.755 -4.099,3.692 -2.095,0.992 -0.732,-0.042 -2.778,-0.143 -1.173,0.384 -1.752,1.693 -3.315,0.258 -1.033,0.715 -1.618,3.26 -1.753,1.808 -1.003,0.212 -1.087,-0.398 -0.817,0.144 -0.37,2.086 -0.793,0.874 -2.219,0.764 -1.773,1.477 -1.556,0.799 -2.084,-0.052 h -0.479 l -2.076,1.146 -3.905,0.342 -1.624,1.549 -0.358,0.331 -0.758,0.458 -1.24,0.74 -0.304,0.184 -1.495,-0.267 -1.75,0.693 -0.708,-1.089 -1.211,0.727 -1.604,0.069 -1.998,-0.889 -1.522,-0.678 -1.113,0.161 -0.387,1.94 -0.039,0.206 -1.17,1.557 -2.184,1.323 -0.297,0.387 -2.485,3.208 -4.722,4.966 -3.993,2.028 -4.139,1.259 -2.897,2.38 -7.599,3.767 -11.994,5.967003 -2.453,0.786 -3.52,0.562 -6.278,2.312 -5.539,1.671 -0.308,0.094 -1.096,0.332 -7.81,2.363 -3.635,-0.384 -2.153,0.782 -5.605,-0.622 -3.897,0.077 -2.467,0.513 -4.637,2.224 -7.827,3.762 -2.586,2.366 -4.027,2.101 -4.715,1.493 0.011,-1.981 -0.028,-0.084 -1.636,0.517 -1.181,0.373 -3.825,0.59 h -2.128 l -1.321,-0.384 -0.204,0.069 -7.818,2.576 -8.719,0.842 -4.363,1.399 -3.26,-0.052 -2.038,0.607 -3.995,0.488 -1.428,-0.381 -0.322,-0.088 -11.75,0.51 -5.372,-0.607 -2.564,0.583 -4.296,-1.445 -6.269,-0.727 -1.465,-0.439 -3.295,-0.978 -1.491,0.859 -1.116,0.119 -2.667,-0.967 -0.96,-0.025 -2.202,0.796 -1.267,-0.325 -1.177,-0.938 -2.761,-0.411 -1.682,-1.414 -9.402,1.246 -2.551,-0.75 -8.554,-2.492 -1.361,0.069 -1.696,1.271 -2.548,0.929 -2.212,0.575 -3.012,0.105 -3.497,-0.918 -3.606,-1.748 -1.333,-0.317 -2.974,0.3 -0.91,0.083 -5.466,-2.932 -7.042,-4.404 -4.778,-2.296 -1.794,-0.291 -0.241,0.853 0.89,2.805 0.303,2.774 -0.091,2.563 -0.049,1.587 0.446,1.425 1.725,1.912 0.719,1.92 0.526,5.284 -0.006,5.362 -0.839,8.551 -0.283,1.302 -1.001,4.43 -0.914,4.069 -3.546,10.833 -0.974,1.343 -2.391,1.631 -5.419,3.688 -3.99,2.301 -1.263,0.523 -3.239,0.245 -2.018,-0.105 -2.513,-1.361 -2.467,-0.635 -3.232,-2.324 -3.595,-0.744 -3.941,-2.278 -1.026,-1.233 -2.146,-0.202 -2.976,-0.893 0.002,-0.005 -1.093,-0.327 -0.755,-0.22 v -0.001 l -3.796,-0.104 -3.54,-1.634 -1.864,-0.45 -2.547,-0.129 -2.666,1.239 -0.001,-0.004 -1.351,0.629 -1.707,-0.678 -1.235,0.077 -1.399,2.115 -0.209,0.328 -0.964,0.51 -1.2,-0.017 -0.939,-0.025 -1.016,0.444 -1.368,0.593 v 0.003 l -1.208,0.527 -0.59,0.255 -0.01,-0.01 -0.363,0.073 -0.645,0.112 -0.8,0.153 -1.41,-0.824 -0.75,-0.442 -1.257,-0.256 -0.677,0.489 -0.133,2.301 -0.618,1.378 -1.961,1.734 -1.993,1.755 -1.389,2.047 -3.676,8.39 -2.303,3.385 -0.715,0.789 -2.408,2.656 -2.136,1.657 -4.922,3.815 -4.659,1.741 -4.013,0.82 -1.951,0.008 -3.695998,-0.492 -3.323,-1.02 -3.65,-2.282 -4.003,-3.217 -5.794,-5.724 -0.82,-0.493 -0.171,-0.114 -1.825,-1.167 -1.354,0.035 -0.53,0.874 -0.29,1.263 -0.245,1.12 -0.664,6.367 0.049,0.369 0.349,2.622 4.401,6.15 1.358,3.267 0.223,0.373 0.908,1.525 0.691,1.163 0.069,0.118 1.504,4.488 -1.057,2.534 0.534,1.697 -1.336,1.037 -0.245,1.465 3.951,4.953 0.862,2.185 -0.963,3.029 -1.536,1.671 -0.429,0.457 0.216,1.28 1.818,1.635 3.089,2.75 1.647,4.086 1.253,1.096 1.456,-0.31 0.81,0.618 1.228,-0.021 1.208,1.208 0.782,0.379 1.236,0.616 0.977,1.272 0.216,3.911 1.821998,4.86 0.028,2.635 0.01,0.374 1.134,1.948 0.356,1.538 -0.604,4.069 1.445,1.306 1.567,-0.32 1.012,0.16 1.626,1.354 1.969,3.001 1.926,-0.282 1.222,0.589 5.902,5.334 1.339,0.676 0.074,0.042 0.963,0.483 1.197,1.208 1.856,-1.232 0.206,-0.021 2.018,-0.178 0.886,0.597 1.704,1.149 2.234,-0.029 4.844,1.485 2.119,0.543 4.261,2.648 1.811,1.12 1.072,0.871 1.424,1.161 2.845,1.224 2.44,0.584 1.322,0.314 0.995,0.384 0.025,-0.062 0.014,0.004 -0.024,0.063 5.284,2.023 2.862,0.668 2.648,0.975 1.927,0.703 1.414,0.023 2,-1.682 1.937,-0.112 1.609,0.401 1.57,-0.263 2.485,-1.531 0.485,-0.719 1.762,-0.839 5.944,-0.738 1.737,0.564 4.46,-1.94 2.988,0.831 2.645,-0.938 5.779,1.284 1.536,1.081 1.717,1.965 0.21,0.009 1.912,0.037 -0.799,1.331 2.523,2.647 2.279,3.445 0.154,0.455 1.657,4.864 1.232,1.723 0.862,2.405 0.042,1.568 -1.34,1.022 -0.22,0.583 -0.076,0.216 0.272,0.655 0.506,-0.276 0.963,-0.533 1.166,-0.181 2.066,0.22 1.364,0.143 2.154,-1.069 1.427,-0.71 2.293,0.987 2.52,-0.028 1.058,0.471 2.995,1.358 1.529,0.144 0.565,-0.371 0.36,-0.856 -0.185,-0.996 -1.145,-1.323 -2.531,-2.938 -1.036,-1.51 -0.789,-2.186 -0.245,-2.794 -0.174,-1.885 0.314,-2.477 0.68,-0.884 0.5,-1.968 h 0.009 l 0.129,-0.515 1.406,-1.866 3.724,-2.393 4,-3.582 3.162,-2.085 3.26,-1.412 0.087,-0.396 0.363,0.146 8.292,-2.819 0.137,-0.016 3.692,-0.643 24.92,1.755 0.924,-0.279 0.004,-0.006 0.83,-2.33 0.447,-0.432 0.297,-0.282 2.74,-1.206 1.281,-0.183 3.556,0.878 1.456,0.359 2.332,-1.307 1.654,0.028 3.417,-1.866 2.111,0.053 0.803,-0.321 4.112,-2.955 3.961,-1.135 1.03,-0.548 0.363,-0.199 4.06,-2.144 2.579,-1.981 2.226,-1.183 2.438,-0.629 6.38,-0.449 1.283,-2.138 2.744,-0.366 1.657,-1.87 1.896,-0.771 1.359,-1.958 1.139,-1.641 1.591,-0.921 5.1,-0.32 6.045,0.749 0.799,-0.485 1.366,-4.875 1.43,-0.915 3.851,-5.612 0.013,-2.045 0.004,-1.708 0.633,-2.432 -0.43,-4.391 0.51,-4.446 2.394,-5.65 2.109,-2.279 3.401,-2.301 1.729,-0.753 2.449,-0.412 v -0.006 l 0.36,-0.061 0.624,-0.107 8.433,-0.116 c 0.117,-0.087 3.067,-0.042 3.067,-0.042 l 2.812,-0.038 7.114,1.266 0.506,0.088 2.405,0.779 2.774,2.157 2.936,2.868 0.551,0.535 1.902,0.801 0.575,0.251 1.571,-0.251 2.237,-1.165 1.688,-1.427 2.301,-1.257 0.056,-0.08 1.295,-1.948 0.039,-0.04 0.028,0.007 0.003,-0.011 -0.022,-0.005 0.511,-0.775 4.447,-1.733 5.23,-0.304 0.588,-0.318 0.327,-0.175 1.382,-1.623 1.295,-0.011 3.135,1.134 2.204,-0.437 1.75,0.699 1.36,-0.161 2.565,-0.304 2.754,1.938 1.605,0.205 5.658,3.31 0.294,0.048 0.152,0.028 0.324,0.053 0.671,-0.199 0.998,-0.289 0.132,-0.039 0.126,0.174 0.643,0.907 0.882,0.126 1.044,-1.393 -0.415,-0.632 -0.157,-0.23 -2.021,-0.411 -1.815,-3.103 1.728,-1.861 -2.711,-3.326 -0.45,-0.551 -0.153,-0.234 -0.937,-1.423 -4.746,-7.235 -6.182,-4.935 -0.002,0.004 -2.165,-1.732 -0.014,-0.01 -0.758,-0.596 -3.302,-3.358 -2.358,-3.13 -0.309,-0.674 -0.487,-1.062 -1.413,-3.078 -2.462,-1.896 -2.006,-2.191 -0.098,-0.129 -4.14,-5.626 -0.68,-0.943 -0.978,-0.565 -2.066,-0.014 -0.195,-0.196 -0.116,-0.121 0.07,-0.074 0.991,-0.985 1.105,-0.278 0.476,-1.089 -2.108,-6.104 -0.014,-0.213 -0.157,-1.95 1.718,-8.855 0.22,-1.079 2.928,-5.958 1.814,-1.486 1.98,-3.892 1.696,-2.488 1.625,-1.582 0.284,-0.168 2.934,-1.776 2.465,-0.347 2.348,-0.331 4.099,1.264 3.901,-0.076 0.761,-0.081 1.77,-0.203 2.911,-0.917 1.374,-0.848 0.713,-1.093 1.487,-4.987 0.478,-1.587 0.917,-1.724 5.306,-6.108 4.011,-3.71 9.019,-6.613 4.415,-2.639 2.254,-1.347 20.126,-8.946003 5.23,-5.302 2.725,-2.757 4.821,-3.235 5.641,-2.311 4.854,-3.842 1.06,-1.334 1.336,-4.303 1.113,-0.269 1.005,-2.174 0.286,-0.618 3.961,-2.792 0.448,-0.223 15.388,-7.71 2.236,0.307 1.197,-1.793 4.477,-0.751 0.824,-0.14 1.104,-0.551 0.939,-1.599 v -0.316 l 0.129,-4.273 0.956,-1.155 0.521,-2.816 0.491,-0.65 0.513,-0.676 1.268,-0.891 -0.22,-0.531 z"
               id="path1440" /></g></clipPath></defs><path
         fill="#cc0001"
         d="M 8.8280914,0 C 3.9531099,0 0,3.953125 0,8.828125 V 326.62109 c 0,4.875 3.9531099,8.82813 8.8280914,8.82813 H 503.16996 c 4.87499,0 8.82904,-3.95213 8.83004,-8.82813 V 8.828125 C 512,3.953125 508.0469,0 503.17191,0 Z"
         id="red" /><path
         id="use3035"
         d="m 0,264.45182 h 512 v 24.15843 H 0 Z"
         fill="#ffffff" /><path
         id="use3038"
         d="M 0,216.13497 H 512 V 240.2934 H 0 Z"
         fill="#ffffff" /><path
         id="use3062"
         d="m 0,167.81812 h 512 v 24.15843 H 0 Z"
         fill="#ffffff" /><path
         id="use3064"
         d="m 0,119.50126 h 512 v 24.15843 H 0 Z"
         fill="#ffffff" /><path
         id="use3066"
         d="m 0,71.184399 h 512 v 24.15843 H 0 Z"
         fill="#ffffff" /><path
         id="use3068"
         d="m 0,22.867549 h 512 v 24.15843 H 0 Z"
         fill="#ffffff" /><g
         id="g6"
         transform="translate(0,-88.275391)" /><g
         id="g8"
         transform="translate(0,-88.275391)" /><g
         id="g10"
         transform="translate(0,-88.275391)" /><g
         id="g12"
         transform="translate(0,-88.275391)" /><g
         id="g14"
         transform="translate(0,-88.275391)" /><g
         id="g16"
         transform="translate(0,-88.275391)" /><g
         id="g18"
         transform="translate(0,-88.275391)" /><g
         id="g20"
         transform="translate(0,-88.275391)" /><g
         id="g22"
         transform="translate(0,-88.275391)" /><g
         id="g24"
         transform="translate(0,-88.275391)" /><g
         id="g26"
         transform="translate(0,-88.275391)" /><g
         id="g28"
         transform="translate(0,-88.275391)" /><g
         id="g30"
         transform="translate(0,-88.275391)" /><g
         id="g32"
         transform="translate(0,-88.275391)" /><g
         id="g34"
         transform="translate(0,-88.275391)" /><path
         fill="#ffffff"
         d="m 0,312.76953 v 13.85156 c 0,4.875 3.9531435,8.82813 8.828125,8.82813 H 503.16992 c 4.87499,0 8.82908,-3.95213 8.83008,-8.82813 v -13.85156 z"
         id="white" /><path
         fill="#010066"
         d="M 8.828125,0 C 3.9531435,0 0,3.953125 0,8.828125 V 191.97656 H 282.95117 V 0 Z"
         id="red-2-3" /><path
         d="m 115.43395,37.458839 c -32.187807,0 -58.31319,26.03859 -58.31319,58.11946 0,32.080871 26.125383,58.119461 58.31319,58.119461 11.62918,0 22.46403,-3.40276 31.56409,-9.25712 -5.29915,1.82873 -10.98642,2.82894 -16.90714,2.82894 -28.54186,0 -51.706275,-23.08745 -51.706275,-51.534501 0,-28.44704 23.164415,-51.53448 51.706275,-51.53448 6.30751,0 12.34959,1.12649 17.93986,3.19022 -9.30703,-6.26852 -20.52641,-9.93198 -32.59681,-9.93198 z"
         id="path4945"
         fill="#ffcc00" /><path
         d="m 212.13838,125.83412 -24.56327,-12.81587 7.26259,26.22899 -16.42914,-21.94075 -5.12548,26.7047 -5.04103,-26.71999 -16.49849,21.89121 7.34552,-26.20701 -24.60364,12.7419 18.2772,-20.50341 -27.83583,1.06891 25.58881,-10.738871 -25.55477,-10.81579 27.83235,1.15265 -18.21228,-20.55831 24.56327,12.81588 -7.26259,-26.229 16.42914,21.94075 5.12554,-26.70469 5.04103,26.71998 16.49843,-21.89121 -7.34553,26.20701 24.60371,-12.7419 -18.2772,20.50341 27.83583,-1.0689 -25.58887,10.73886 25.55477,10.815801 -27.8323,-1.15265 z"
         id="path4959"
         fill="#ffcc00" />
  </svg>
);

export const MZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs28" />
    <path
       fill="#5aa587"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#464655"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<rect
       y="190.161"
       fill="#f5f5f5"
       width="512"
       height="13.942"
       id="rect3"
       x="0" />
    	<rect
       y="307.89099"
       fill="#f5f5f5"
       width="512"
       height="13.942"
       id="rect4"
       x="0" />
    </g>
    <path
       fill="#ff4b55"
       d="M 3.256,333.315 206.097,172.3 c 2.946,-2.338 2.946,-6.812 0,-9.151 L 3.256,2.135 C 1.311,3.754 0,6.1 0,8.828 v 317.793 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path4" />
    <path
       fill="#ffe15a"
       d="m 81.814,110.302 12.905,38.695 40.789,0.317 c 2.281,0.018 3.226,2.929 1.391,4.284 l -32.813,24.231 12.303,38.891 c 0.687,2.175 -1.788,3.974 -3.644,2.647 l -33.185,-23.72 -33.185,23.72 c -1.856,1.326 -4.332,-0.472 -3.644,-2.647 L 55.034,177.829 22.222,153.598 c -1.835,-1.355 -0.889,-4.266 1.391,-4.284 l 40.789,-0.317 12.905,-38.695 c 0.724,-2.164 3.785,-2.164 4.507,0 z"
       id="path5" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 77.196,270.447 -3.19,3.21 H 47.328 l 7.281,-26.717 2.975,-1.487 -4.776,23.82 c -0.04,0.294 0.02,0.587 0.215,0.822 0.177,0.235 0.45,0.352 0.744,0.352 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 83.596,274.891 c -1.155,0.861 -2.564,1.351 -4.032,1.351 -1.468,0 -2.877,-0.489 -4.032,-1.351 l 4.032,-4.032 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="M 111.801,273.658 H 85.123 l -3.19,-3.21 h 23.428 c 0.294,0 0.567,-0.117 0.744,-0.352 0.195,-0.235 0.255,-0.529 0.215,-0.822 l -4.776,-23.82 2.975,1.487 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="M 104.168,268.491 H 80.543 v -24.369 c 3.954,-3.347 14.386,-1.057 18.809,0.313 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 78.585,244.122 v 24.369 H 54.961 l 4.815,-24.055 c 4.424,-1.371 14.856,-3.66 18.809,-0.314 z"
       id="path10" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    	<path
       fill="#464655"
       d="m 114.033,274.382 -7.732,-28.381 c -0.078,-0.255 -0.254,-0.489 -0.509,-0.607 l -5.167,-2.583 c -0.02,-0.02 -0.04,-0.02 -0.078,-0.02 -0.02,0 -0.02,-0.02 -0.039,-0.04 -0.627,-0.215 -14.934,-4.874 -20.943,-0.313 -6.009,-4.561 -20.317,0.098 -20.943,0.313 -0.02,0.02 -0.02,0.02 -0.039,0.04 -0.04,0 -0.058,0 -0.078,0.02 l -5.167,2.583 c -0.255,0.117 -0.43,0.352 -0.509,0.607 l -7.732,28.381 c -0.078,0.294 -0.02,0.607 0.157,0.842 0.195,0.235 0.489,0.392 0.783,0.392 h 27.402 c 1.624,1.624 3.817,2.583 6.126,2.583 2.31,0 4.502,-0.959 6.126,-2.583 h 27.402 c 0.294,0 0.587,-0.157 0.783,-0.392 0.176,-0.235 0.235,-0.548 0.157,-0.842 z m -33.49,-30.26 c 3.954,-3.347 14.386,-1.057 18.809,0.313 l 4.815,24.055 H 80.543 c 0,10e-4 0,-24.368 0,-24.368 z m -20.767,0.314 c 4.424,-1.37 14.856,-3.66 18.809,-0.313 v 24.369 H 54.961 Z m -12.448,29.222 7.281,-26.717 2.975,-1.487 -4.776,23.82 c -0.04,0.294 0.02,0.587 0.215,0.822 0.177,0.235 0.45,0.352 0.744,0.352 h 23.428 l -3.19,3.21 z m 32.236,2.584 c -1.468,0 -2.877,-0.489 -4.032,-1.351 l 4.032,-4.032 4.032,4.032 c -1.154,0.861 -2.563,1.351 -4.032,1.351 z m 5.559,-2.584 -3.19,-3.21 h 23.428 c 0.294,0 0.567,-0.117 0.744,-0.352 0.195,-0.235 0.255,-0.529 0.215,-0.822 l -4.776,-23.82 2.975,1.487 7.281,26.717 z"
       id="path11" />
    	<path
       fill="#464655"
       d="m 104.034,218.559 c -0.998,0.695 -2.35,0.576 -3.211,-0.285 l -1.302,-1.302 v 3.187 l -7.967,7.967 h -3.187 l -12.746,12.747 h -3.187 l -24.508,24.508 c -0.604,0.604 -0.814,1.496 -0.544,2.306 l 1.153,3.459 -4.78,4.78 h -3.187 l -9.743,9.743 c -0.778,0.778 -0.778,2.04 0,2.819 l 6.43,6.43 c 0.928,0.928 2.45,0.87 3.304,-0.127 l 14.35,-17.272 1.593,-4.78 3.187,-3.187 6.374,9.56 4.78,-4.78 -5.099,-7.648 1.27,-1.27 c 1.235,-1.235 1.235,-3.236 0,-4.471 l -0.951,-0.951 0.895,-0.895 c 6.801,5.828 14.967,7.335 22.742,4.002 l -2.663,-6.214 c -6.424,2.753 -11.67,0.45 -15.319,-2.549 l 13.464,-13.464 -0.531,-2.656 3.718,-3.718 h 3.187 l 23.901,-23.901 z"
       id="path12" />
    	<path
       fill="#464655"
       d="m 56.501,215.379 -3.187,3.187 c -0.879,0.879 -0.879,2.306 0,3.187 l 0.531,0.531 -5.311,1.063 -14.34,14.34 7.967,7.967 14.34,-14.34 1.062,-5.312 2.125,2.125 1.593,-1.593 53,53 3.187,-3.187 -53,-53 1.593,-1.593 -6.374,-6.374 c -0.879,-0.881 -2.305,-0.881 -3.186,-0.001 z"
       id="path13" />
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const NA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45001" {...props}>
    <defs
       id="defs23" />
    <path
       fill="#41479b"
       d="M 0,256.001 V 8.828 C 0,3.953 3.953,0 8.828,0 h 379.586 z"
       id="path1" />
    <path
       fill="#73af00"
       d="m 512,79.449 v 247.172 c 0,4.875 -3.953,8.828 -8.828,8.828 H 123.586 Z"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="M 512,84.427 V 8.828 C 512,3.953 508.047,0 503.172,0 H 383.139 L 0,251.023 v 75.598 c 0,4.875 3.953,8.828 8.828,8.828 h 120.033 z"
       id="path3" />
    <path
       fill="#ff4b55"
       d="M 512,52.772 V 8.828 C 512,3.953 508.047,0 503.172,0 H 431.454 L 0,282.678 v 43.944 c 0,4.875 3.953,8.828 8.828,8.828 h 71.718 z"
       id="path4" />
    <g
       id="g8"
       transform="translate(0,-88.275)">
    	<path
       fill="#ffe15a"
       d="m 90.207,145.894 c 8.691,0 16.557,3.521 22.254,9.214 l 3.125,-21.686 -17.235,13.561 -8.145,-20.362 -8.145,20.362 -17.235,-13.561 3.125,21.686 c 5.699,-5.694 13.565,-9.214 22.256,-9.214 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 67.935,199.634 c -5.693,-5.697 -9.214,-13.565 -9.214,-22.254 0,-8.691 3.521,-16.557 9.214,-22.254 L 46.249,152 59.81,169.235 39.448,177.38 59.81,185.525 46.249,202.76 Z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="m 140.966,177.379 -20.362,-8.145 13.561,-17.234 -21.686,3.125 c 5.693,5.697 9.214,13.565 9.214,22.254 0,8.69 -3.521,16.557 -9.214,22.254 l 21.686,3.125 -13.561,-17.235 z"
       id="path7" />
    	<path
       fill="#ffe15a"
       d="m 90.207,208.865 c -8.691,0 -16.557,-3.521 -22.254,-9.214 l -3.125,21.686 17.235,-13.561 8.145,20.362 8.145,-20.362 17.235,13.561 -3.125,-21.686 c -5.699,5.694 -13.565,9.214 -22.256,9.214 z"
       id="path8" />
    	<circle
       fill="#ffe15a"
       cx="90.209999"
       cy="177.38"
       r="25.709"
       id="circle8" />
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const NC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const NE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#73af00"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ff9b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <circle
       fill="#ff9b55"
       cx="256"
       cy="167.724"
       r="44.139999"
       id="circle2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const NF = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#73af00"
       d="M 170.667,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <g
       id="g3"
       transform="translate(0,-88.273)">
    	<path
       fill="#73af00"
       d="M 503.172,423.721 H 341.333 V 88.273 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.792 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    	<path
       fill="#73af00"
       d="M 314.959,342.595 287.563,182.783 c -1.046,-6.102 -3.217,-11.957 -6.402,-17.266 L 256,123.583 230.839,165.518 c -3.186,5.309 -5.356,11.164 -6.402,17.266 L 197.04,342.597 c -0.523,3.052 1.827,5.841 4.925,5.841 h 44.041 v 39.973 h 19.987 v -39.974 h 44.041 c 3.097,0 5.449,-2.788 4.925,-5.842 z"
       id="path3" />
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const NG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#73af00"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const NI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs51" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="M 512,200.093 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#41479b"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 V 311.909 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <polygon
       fill="#afebff"
       points="282.927,263.277 256,223.678 229.073,263.277 "
       id="polygon2"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#557de6"
       points="300.351,288.621 282.927,263.277 229.073,263.277 211.649,288.621 "
       id="polygon3"
       transform="translate(0,-88.276)" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 262.891,261.064 c 0.107,-0.221 0.22,-0.438 0.317,-0.664 -0.096,0.224 -0.21,0.443 -0.317,0.664 z"
       id="path3" />
    	<path
       fill="#73af00"
       d="m 263.633,259.239 c 0.066,-0.199 0.146,-0.392 0.203,-0.594 -0.058,0.201 -0.138,0.394 -0.203,0.594 z"
       id="path4" />
    	<path
       fill="#73af00"
       d="m 261.975,262.725 c 0.136,-0.217 0.27,-0.433 0.397,-0.655 -0.126,0.223 -0.262,0.439 -0.397,0.655 z"
       id="path5" />
    	<path
       fill="#73af00"
       d="m 266.091,255.348 c -0.241,0 -0.472,0.04 -0.685,0.111 0.213,-0.072 0.444,-0.111 0.685,-0.111 z"
       id="path6" />
    	<path
       fill="#73af00"
       d="m 264.83,255.766 c -0.335,0.262 -0.565,0.627 -0.617,1.043 v 0.002 -0.002 c 0.053,-0.416 0.281,-0.782 0.617,-1.043 z"
       id="path7" />
    	<path
       fill="#73af00"
       d="m 264.013,267.585 c 0.377,0.358 0.751,0.698 1.127,1.024 2.01,-1.74 4.108,-3.951 5.58,-6.538 -0.106,0.185 -0.22,0.365 -0.332,0.547 -1.375,-2.528 -2.101,-4.715 -2.453,-6.012 -0.201,-0.74 -0.967,-1.256 -1.842,-1.257 0.337,2.954 1.061,8.383 -2.08,12.236 z"
       id="path8" />
    	<path
       fill="#73af00"
       d="m 271.98,259.239 c 0.066,-0.199 0.146,-0.392 0.203,-0.594 -0.057,0.201 -0.137,0.394 -0.203,0.594 z"
       id="path9" />
    	<path
       fill="#73af00"
       d="m 273.178,255.766 c -0.335,0.262 -0.565,0.627 -0.617,1.043 v 0.002 -0.002 c 0.053,-0.416 0.281,-0.782 0.617,-1.043 z"
       id="path10" />
    	<path
       fill="#73af00"
       d="m 271.24,261.064 c 0.107,-0.221 0.22,-0.438 0.317,-0.664 -0.098,0.224 -0.21,0.443 -0.317,0.664 z"
       id="path11" />
    	<path
       fill="#73af00"
       d="m 288.339,269.613 c -3.053,0 -5.942,-1.465 -7.706,-3.957 -2.657,-3.754 -3.862,-7.254 -4.349,-9.049 -0.201,-0.742 -0.969,-1.258 -1.845,-1.258 l 0.003,0.001 c 0.402,3.526 1.358,10.575 -4.371,14.264 h -3.73 c -0.153,-0.121 -0.302,-0.237 -0.459,-0.365 0.003,0.003 0.007,0.006 0.01,0.009 -1.044,1.363 -3.132,1.745 -4.751,0.91 -6.778,-3.492 -5.726,-11.109 -5.303,-14.818 -0.875,0.001 -1.641,0.516 -1.842,1.257 -0.352,1.297 -1.078,3.484 -2.453,6.012 -0.111,-0.182 -0.226,-0.361 -0.332,-0.547 1.656,2.91 4.113,5.366 6.333,7.186 -1.044,1.363 -3.132,1.745 -4.751,0.91 -6.778,-3.492 -5.726,-11.11 -5.303,-14.818 -0.875,0.001 -1.641,0.516 -1.842,1.257 -0.352,1.297 -1.078,3.484 -2.453,6.012 -0.111,-0.182 -0.226,-0.361 -0.332,-0.547 1.656,2.91 4.113,5.366 6.333,7.186 -1.044,1.363 -3.132,1.745 -4.751,0.91 -6.778,-3.492 -5.726,-11.109 -5.303,-14.818 l 0.003,-0.001 c -0.876,0 -1.644,0.515 -1.845,1.258 -0.487,1.795 -1.692,5.295 -4.349,9.049 -1.763,2.493 -4.652,3.957 -7.706,3.957 h -2.508 v 3.168 h 64.943 1.583 v -3.168 z"
       id="path12" />
    	<path
       fill="#73af00"
       d="m 258.724,260.399 c 0.097,0.226 0.21,0.444 0.317,0.664 -0.107,-0.22 -0.221,-0.439 -0.317,-0.664 z"
       id="path13" />
    	<path
       fill="#73af00"
       d="m 258.098,258.644 c 0.056,0.202 0.137,0.395 0.203,0.594 -0.067,-0.199 -0.147,-0.392 -0.203,-0.594 z"
       id="path14" />
    	<path
       fill="#73af00"
       d="m 257.719,256.812 v -0.002 c -0.052,-0.416 -0.28,-0.781 -0.617,-1.043 0.335,0.262 0.565,0.627 0.617,1.043 z"
       id="path15" />
    	<path
       fill="#73af00"
       d="m 259.56,262.071 c 0.127,0.223 0.262,0.438 0.397,0.655 -0.135,-0.217 -0.27,-0.433 -0.397,-0.655 z"
       id="path16" />
    	<path
       fill="#73af00"
       d="m 261.015,264.267 c -0.017,-0.021 -0.031,-0.043 -0.047,-0.065 0.136,-0.181 0.266,-0.363 0.397,-0.548 -0.13,0.184 -0.264,0.366 -0.399,0.546 -0.136,-0.18 -0.269,-0.361 -0.398,-0.546 0.146,0.207 0.294,0.41 0.447,0.613 z"
       id="path17" />
    	<path
       fill="#73af00"
       d="m 261.711,265.143 c 0.154,0.185 0.308,0.37 0.466,0.548 -0.158,-0.178 -0.312,-0.363 -0.466,-0.548 z"
       id="path18" />
    	<path
       fill="#73af00"
       d="m 263.403,267.001 c -0.148,-0.148 -0.292,-0.303 -0.438,-0.456 0.147,0.154 0.29,0.308 0.438,0.456 z"
       id="path19" />
    </g>
    <path
       fill="#ffe15a"
       d="m 274.442,167.073 -0.003,-0.001 c -0.481,0 -0.925,0.157 -1.261,0.418 -0.335,0.262 -0.565,0.627 -0.617,1.043 v 0.002 c -0.078,0.625 -0.211,1.234 -0.378,1.833 -0.056,0.202 -0.137,0.395 -0.203,0.594 -0.129,0.392 -0.262,0.782 -0.424,1.161 -0.097,0.226 -0.21,0.444 -0.317,0.664 -0.164,0.34 -0.332,0.679 -0.519,1.007 -1.472,2.586 -3.57,4.798 -5.58,6.538 -0.375,-0.324 -0.749,-0.665 -1.127,-1.024 3.14,-3.853 2.417,-9.282 2.081,-12.236 l -0.003,-0.001 c -0.241,0 -0.472,0.04 -0.685,0.111 -0.213,0.072 -0.408,0.177 -0.576,0.307 -0.335,0.262 -0.565,0.627 -0.617,1.043 v 0.002 c -0.078,0.625 -0.211,1.234 -0.379,1.833 -0.056,0.202 -0.137,0.395 -0.203,0.594 -0.129,0.392 -0.262,0.782 -0.424,1.161 -0.097,0.226 -0.21,0.444 -0.317,0.664 -0.164,0.34 -0.332,0.679 -0.519,1.007 -0.127,0.223 -0.262,0.438 -0.397,0.655 -0.196,0.314 -0.397,0.625 -0.61,0.927 -0.13,0.185 -0.262,0.369 -0.397,0.548 -0.136,-0.181 -0.27,-0.363 -0.401,-0.548 -0.213,-0.302 -0.414,-0.612 -0.61,-0.927 -0.136,-0.217 -0.27,-0.433 -0.397,-0.655 -0.188,-0.329 -0.354,-0.668 -0.519,-1.007 -0.107,-0.221 -0.22,-0.438 -0.317,-0.664 -0.162,-0.378 -0.295,-0.769 -0.424,-1.161 -0.066,-0.199 -0.146,-0.392 -0.203,-0.594 -0.168,-0.598 -0.3,-1.208 -0.378,-1.833 v -0.002 c -0.052,-0.416 -0.28,-0.781 -0.617,-1.043 -0.335,-0.262 -0.779,-0.418 -1.26,-0.418 l -0.003,0.001 c -0.422,3.709 -1.475,11.326 5.303,14.818 1.143,0.589 2.515,0.566 3.591,0.024 0.687,-0.346 1.425,-0.578 2.194,-0.578 h 3.146 c 5.728,-3.688 4.772,-10.738 4.37,-14.263 z"
       id="path20" />
    <g
       id="g24"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 249.749,258.644 c 0.056,0.202 0.137,0.395 0.203,0.594 -0.066,-0.199 -0.146,-0.392 -0.203,-0.594 z"
       id="path21" />
    	<path
       fill="#73af00"
       d="m 249.37,256.812 v -0.002 c -0.052,-0.416 -0.28,-0.781 -0.617,-1.043 0.335,0.262 0.565,0.627 0.617,1.043 z"
       id="path22" />
    	<path
       fill="#73af00"
       d="m 250.376,260.399 c 0.097,0.226 0.21,0.444 0.317,0.664 -0.108,-0.22 -0.22,-0.439 -0.317,-0.664 z"
       id="path23" />
    	<path
       fill="#73af00"
       d="m 247.494,255.348 v 0 c 0.241,0 0.472,0.04 0.685,0.111 -0.214,-0.072 -0.445,-0.111 -0.685,-0.111 z"
       id="path24" />
    </g>
    <path
       fill="#ffe15a"
       d="m 252.793,181.891 c 1.62,0.834 3.708,0.452 4.751,-0.91 -2.22,-1.82 -4.676,-4.275 -6.333,-7.186 -0.188,-0.329 -0.354,-0.668 -0.519,-1.007 -0.107,-0.221 -0.22,-0.438 -0.317,-0.664 -0.162,-0.378 -0.295,-0.769 -0.424,-1.161 -0.066,-0.199 -0.146,-0.392 -0.203,-0.594 -0.168,-0.598 -0.3,-1.208 -0.378,-1.833 v -0.002 c -0.052,-0.416 -0.28,-0.781 -0.617,-1.043 -0.168,-0.13 -0.363,-0.235 -0.576,-0.307 -0.213,-0.072 -0.444,-0.111 -0.685,-0.111 v 0 l -0.003,0.001 v 0 c -0.421,3.708 -1.474,11.324 5.304,14.817 z"
       id="path25" />
    <g
       id="g28"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 241.401,258.644 c 0.056,0.202 0.137,0.395 0.203,0.594 -0.066,-0.199 -0.146,-0.392 -0.203,-0.594 z"
       id="path26" />
    	<path
       fill="#73af00"
       d="m 242.028,260.399 c 0.097,0.226 0.21,0.444 0.317,0.664 -0.107,-0.22 -0.221,-0.439 -0.317,-0.664 z"
       id="path27" />
    	<path
       fill="#73af00"
       d="m 241.023,256.812 v -0.002 c -0.052,-0.416 -0.28,-0.781 -0.617,-1.043 0.335,0.262 0.565,0.627 0.617,1.043 z"
       id="path28" />
    </g>
    <path
       fill="#ffe15a"
       d="m 244.446,181.891 c 1.62,0.834 3.708,0.452 4.751,-0.91 -2.22,-1.82 -4.676,-4.275 -6.333,-7.186 -0.188,-0.329 -0.354,-0.668 -0.519,-1.007 -0.107,-0.221 -0.22,-0.438 -0.317,-0.664 -0.162,-0.378 -0.295,-0.769 -0.424,-1.161 -0.066,-0.199 -0.146,-0.392 -0.203,-0.594 -0.168,-0.598 -0.3,-1.208 -0.378,-1.833 v -0.002 c -0.052,-0.416 -0.28,-0.781 -0.617,-1.043 -0.335,-0.262 -0.779,-0.418 -1.261,-0.418 l -0.003,0.001 c -0.422,3.708 -1.476,11.324 5.304,14.817 z"
       id="path29" />
    <path
       fill="#41479b"
       d="m 242.655,154.477 c -0.131,0.505 -0.264,1.011 -0.395,1.516 4.324,-1.297 9.096,-2.076 14.274,-2.076 5.178,0.003 9.95,0.776 14.274,2.076 -0.131,-0.505 -0.264,-1.011 -0.395,-1.516 -4.301,-1.11 -8.93,-1.748 -13.879,-1.746 -4.948,-0.001 -9.577,0.636 -13.879,1.746 z"
       id="path30" />
    <path
       fill="#5aa0e6"
       d="m 242.827,153.818 c -0.131,0.505 -0.264,1.011 -0.395,1.516 4.276,-1.3 8.99,-2.08 14.102,-2.082 5.113,0.002 9.826,0.781 14.102,2.082 -0.131,-0.505 -0.264,-1.011 -0.395,-1.516 -4.253,-1.118 -8.823,-1.751 -13.707,-1.752 -4.885,0.001 -9.454,0.637 -13.707,1.752 z"
       id="path31" />
    <path
       fill="#9bc800"
       d="m 242.986,153.209 c -0.131,0.505 -0.264,1.011 -0.395,1.516 4.234,-1.304 8.892,-2.09 13.943,-2.088 5.053,0 9.71,0.783 13.943,2.088 -0.131,-0.505 -0.264,-1.011 -0.395,-1.516 -4.207,-1.118 -8.723,-1.759 -13.548,-1.759 -4.825,-10e-4 -9.34,0.641 -13.548,1.759 z"
       id="path32" />
    <path
       fill="#ffe14e"
       d="m 243.167,152.513 c -0.131,0.505 -0.264,1.011 -0.395,1.516 4.184,-1.309 8.78,-2.095 13.762,-2.095 4.982,0.002 9.578,0.786 13.762,2.095 -0.131,-0.505 -0.264,-1.011 -0.395,-1.516 -4.158,-1.122 -8.609,-1.764 -13.367,-1.766 -4.758,10e-4 -9.21,0.644 -13.367,1.766 z"
       id="path33" />
    <path
       fill="#ffb14e"
       d="m 243.346,151.829 c -0.131,0.505 -0.264,1.011 -0.395,1.516 4.136,-1.312 8.668,-2.101 13.583,-2.102 4.915,0.003 9.448,0.788 13.583,2.102 -0.131,-0.505 -0.264,-1.011 -0.395,-1.516 -4.106,-1.124 -8.497,-1.772 -13.188,-1.772 -4.691,0.002 -9.081,0.645 -13.188,1.772 z"
       id="path34" />
    <path
       fill="#ff4b55"
       d="m 243.421,151.537 c -0.093,0.354 -0.184,0.707 -0.277,1.062 4.082,-1.314 8.55,-2.111 13.389,-2.11 4.841,-0.002 9.308,0.793 13.389,2.11 -0.093,-0.354 -0.184,-0.707 -0.277,-1.062 -4.085,-1.127 -8.45,-1.774 -13.113,-1.775 -4.661,-0.003 -9.025,0.647 -13.111,1.775 z"
       id="path35" />
    <path
       fill="#ffe15a"
       d="m 300.352,201.882 h -88.703 c -0.585,0 -1.121,-0.322 -1.397,-0.835 -0.276,-0.516 -0.244,-1.142 0.079,-1.628 l 44.352,-66.527 c 0.588,-0.878 2.048,-0.878 2.636,0 l 44.352,66.527 c 0.323,0.486 0.354,1.111 0.078,1.628 -0.276,0.514 -0.812,0.835 -1.397,0.835 z m -85.745,-3.168 h 82.785 L 256,136.627 Z"
       id="path36" />
    <path
       fill="#ff4b55"
       d="m 259.029,160.657 c 0,-1.394 -1.412,-3.512 -3.673,-3.512 -1.321,0 -2.392,0.808 -2.392,1.803 0,0.498 0.267,0.947 0.698,1.273 -0.002,0.018 -0.003,0.038 -0.004,0.055 -0.54,0.331 -0.892,0.829 -0.892,1.394 0,0.95 0.979,1.72 2.216,1.79 l 1.018,2.036 0.919,-1.838 c 1.207,-0.307 2.11,-1.531 2.11,-3.001 z"
       id="path37" />
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const NL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const NO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#f5f5f5"
       points="229.517,88.277 141.241,88.277 141.241,211.863 0,211.863 0,300.139 141.241,300.139 141.241,423.725 229.517,423.725 229.517,300.139 512,300.139 512,211.863 229.517,211.863 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#41479b"
       points="211.862,88.277 158.897,88.277 158.897,229.518 0,229.518 0,282.484 158.897,282.484 158.897,423.725 211.862,423.725 211.862,282.484 512,282.484 512,229.518 211.862,229.518 "
       id="polygon2"
       transform="translate(0,-88.276)" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const NP = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 11.476,22.601 194.364,156.25 H 79.144 53.442 l 17.156,19.137 133.217,148.587 H 11.476 V 22.601 M 3.081,2.253 C 1.228,3.872 0,6.176 0,8.828 v 317.793 c 0,4.875 3.953,8.828 8.828,8.828 h 220.69 L 79.144,167.725 h 150.374 z"
       id="path2" />
    <polyline
       fill="#ff4b55"
       points="11.476,110.877 194.364,244.525 79.144,244.525 53.442,244.525 70.6,263.661   203.816,412.249 11.476,412.249 11.476,110.877 "
       id="polyline2"
       transform="translate(0,-88.276)" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 67.345,296.399 7.066,14.583 13.411,-9.096 c 0.591,-0.402 1.386,0.057 1.334,0.77 l -1.171,16.162 16.162,-1.171 c 0.713,-0.052 1.172,0.743 0.77,1.334 l -9.096,13.411 14.583,7.066 c 0.643,0.312 0.643,1.228 0,1.54 l -14.583,7.066 9.096,13.411 c 0.402,0.591 -0.057,1.386 -0.77,1.334 l -16.162,-1.171 1.171,16.162 c 0.052,0.713 -0.743,1.172 -1.334,0.77 l -13.411,-9.096 -7.066,14.583 c -0.312,0.643 -1.228,0.643 -1.54,0 l -7.066,-14.583 -13.411,9.096 c -0.591,0.402 -1.386,-0.057 -1.334,-0.77 l 1.171,-16.162 -16.162,1.171 c -0.713,0.052 -1.172,-0.743 -0.77,-1.334 l 9.096,-13.411 -14.586,-7.063 c -0.643,-0.312 -0.643,-1.228 0,-1.54 l 14.583,-7.066 -9.096,-13.411 c -0.402,-0.591 0.057,-1.386 0.77,-1.334 l 16.162,1.171 -1.171,-16.162 c -0.052,-0.713 0.743,-1.172 1.334,-0.77 l 13.411,9.096 7.066,-14.583 c 0.314,-0.646 1.231,-0.646 1.543,-0.003 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 85.694,212.062 -6.135,-4.191 5.401,-5.661 -7.697,-1.405 2.632,-7.367 -7.603,1.847 -0.593,-7.8 -6.194,4.779 -3.713,-6.884 -3.714,6.886 -6.194,-4.779 -0.593,7.8 -7.603,-1.847 2.632,7.367 -7.697,1.405 5.401,5.661 -6.135,4.191 c -7.741,-3.614 -14.547,-8.895 -19.903,-15.427 3.598,20.961 21.815,36.929 43.804,36.929 21.989,0 40.205,-15.968 43.804,-36.929 -5.353,6.531 -12.16,11.811 -19.9,15.425 z"
       id="path4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const NR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs15" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <rect
       y="150.064"
       fill="#ffe15a"
       width="512"
       height="35.310001"
       id="rect1"
       x="0" />
    <polygon
       fill="#f5f5f5"
       points="139.034,314.287 133.217,334.645 153.574,328.827 138.358,343.55 158.896,348.689 138.358,353.83 153.574,368.551 133.217,362.734 139.034,383.092 124.313,367.875 119.172,388.414 114.031,367.875 99.31,383.092 105.128,362.734 84.77,368.551 99.987,353.83 79.448,348.689 99.987,343.55 84.77,328.827 105.128,334.645 99.31,314.287 114.031,329.505 119.172,308.965 124.313,329.505 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const NU = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs27" />
    <path
       fill="#ffe15a"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 247.172,167.724 H 8.828 C 3.953,167.724 0,163.771 0,158.896 V 8.828 C 0,3.953 3.953,0 8.828,0 H 247.172 C 252.047,0 256,3.953 256,8.828 v 150.069 c -0.001,4.876 -3.952,8.827 -8.828,8.827 z"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path3" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon3" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path6" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path7" />
    </g>
    <circle
       fill="#41479b"
       cx="128"
       cy="83.863998"
       r="26.483"
       id="circle7" />
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 129.787,150.668 4.425,13.266 13.984,0.108 c 1.811,0.014 2.561,2.325 1.105,3.4 l -11.25,8.307 4.218,13.333 c 0.546,1.726 -1.419,3.154 -2.892,2.101 L 128,183.052 l -11.377,8.131 c -1.473,1.053 -3.438,-0.375 -2.892,-2.101 l 4.218,-13.333 -11.25,-8.307 c -1.457,-1.076 -0.706,-3.386 1.105,-3.4 l 13.984,-0.108 4.425,-13.266 c 0.572,-1.718 3.002,-1.718 3.574,0 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 56.501,161.474 2.379,7.133 7.519,0.058 c 0.973,0.008 1.377,1.25 0.594,1.828 l -6.048,4.467 2.268,7.168 c 0.294,0.928 -0.764,1.696 -1.555,1.13 l -6.116,-4.372 -6.116,4.372 c -0.792,0.566 -1.848,-0.202 -1.555,-1.13 l 2.268,-7.168 -6.048,-4.467 c -0.783,-0.578 -0.38,-1.821 0.594,-1.828 l 7.519,-0.058 2.379,-7.133 c 0.305,-0.923 1.61,-0.923 1.918,0 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="m 202.085,161.474 2.379,7.133 7.519,0.058 c 0.973,0.008 1.377,1.25 0.594,1.828 l -6.048,4.467 2.268,7.168 c 0.294,0.928 -0.764,1.696 -1.555,1.13 l -6.116,-4.372 -6.116,4.372 c -0.792,0.566 -1.848,-0.202 -1.555,-1.13 l 2.268,-7.168 -6.048,-4.467 c -0.783,-0.578 -0.38,-1.821 0.594,-1.828 l 7.519,-0.058 2.379,-7.133 c 0.305,-0.923 1.61,-0.923 1.918,0 z"
       id="path10" />
    	<path
       fill="#ffe15a"
       d="m 129.074,107.894 2.379,7.133 7.519,0.058 c 0.973,0.008 1.377,1.25 0.594,1.828 l -6.049,4.466 2.268,7.168 c 0.294,0.928 -0.764,1.696 -1.555,1.13 l -6.116,-4.372 -6.116,4.372 c -0.792,0.566 -1.848,-0.202 -1.555,-1.13 l 2.268,-7.168 -6.048,-4.467 c -0.783,-0.578 -0.38,-1.821 0.594,-1.828 l 7.519,-0.058 2.379,-7.133 c 0.305,-0.922 1.612,-0.922 1.919,0.001 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 129.074,216.316 2.379,7.133 7.519,0.058 c 0.973,0.008 1.377,1.25 0.594,1.828 l -6.049,4.466 2.268,7.168 c 0.294,0.928 -0.764,1.696 -1.555,1.13 l -6.116,-4.372 -6.116,4.372 c -0.792,0.566 -1.848,-0.202 -1.555,-1.13 l 2.268,-7.168 -6.048,-4.467 c -0.783,-0.578 -0.38,-1.821 0.594,-1.828 l 7.519,-0.058 2.379,-7.133 c 0.305,-0.922 1.612,-0.922 1.919,0.001 z"
       id="path12" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const NZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs28" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0.001 h -15.334 l -81.77,53.574 V 0.001 H 105.93 V 53.575 L 24.16,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.002 c 0,4.875 3.953,8.828 8.828,8.828 h 15.334 l 81.77,-53.574 v 53.574 h 44.138 v -53.574 l 81.769,53.574 h 15.334 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 L 185.846,105.932 H 256 V 61.794 H 185.845 L 256,15.831 V 8.829 c 0,-4.876 -3.953,-8.828 -8.828,-8.828 z"
       id="path2" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.277 114.759,88.277 114.759,158.898 0,158.898 0,185.38 114.759,185.38 114.759,256.001 141.241,256.001 141.241,185.38 256,185.38 256,158.898 141.241,158.898 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.07 4.207,89.769 C 1.735,91.333 0,93.962 0,97.104 v 0.458 l 80.889,52.508 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.07 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.208 1.269,251.464 c 1.521,2.662 4.273,4.537 7.559,4.537 h 1.665 l 95.196,-61.793 H 89.474 Z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.86,247.866 173.194,194.208 H 156.98 l 93.874,60.935 c 2.812,-1.305 4.741,-4.04 5.006,-7.277 z"
       id="path6" />
    	<path
       fill="#ff4b55"
       d="m 395.474,368.114 c -0.358,0 -0.719,-0.113 -1.026,-0.328 L 384,360.32 l -10.449,7.466 c -0.306,0.215 -0.668,0.328 -1.026,0.328 -0.366,0 -0.728,-0.113 -1.038,-0.337 -0.612,-0.448 -0.875,-1.241 -0.647,-1.965 l 3.875,-12.242 -10.327,-7.62 c -0.612,-0.457 -0.866,-1.241 -0.633,-1.965 0.237,-0.724 0.905,-1.216 1.668,-1.224 l 12.841,-0.104 4.061,-12.181 c 0.242,-0.715 0.918,-1.207 1.677,-1.207 0.759,0 1.436,0.491 1.677,1.207 l 4.061,12.181 12.841,0.104 c 0.763,0.009 1.431,0.5 1.668,1.224 0.233,0.724 -0.022,1.508 -0.633,1.965 l -10.327,7.62 3.875,12.242 c 0.228,0.724 -0.034,1.517 -0.647,1.965 -0.314,0.224 -0.68,0.337 -1.043,0.337 z"
       id="path7" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 384,242.759 4.461,13.378 14.102,0.109 -11.345,8.377 4.254,13.445 -11.472,-8.199 -11.473,8.201 4.254,-13.445 -11.345,-8.377 14.102,-0.109 4.462,-13.38 m 0,-3.531 c -1.519,0 -2.869,0.972 -3.35,2.414 l -3.663,10.984 -11.578,0.09 c -1.519,0.011 -2.861,0.994 -3.331,2.44 -0.47,1.446 0.039,3.029 1.26,3.932 l 9.314,6.878 -3.492,11.039 c -0.458,1.449 0.062,3.029 1.291,3.922 0.619,0.449 1.347,0.674 2.076,0.674 0.719,0 1.439,-0.22 2.054,-0.659 l 9.42,-6.733 9.42,6.733 c 0.615,0.438 1.334,0.659 2.053,0.659 0.728,0 1.457,-0.225 2.076,-0.674 1.229,-0.894 1.749,-2.473 1.291,-3.922 l -3.492,-11.039 9.314,-6.878 c 1.223,-0.903 1.73,-2.486 1.26,-3.932 -0.47,-1.445 -1.811,-2.429 -3.331,-2.44 l -11.578,-0.09 -3.663,-10.984 c -0.482,-1.441 -1.832,-2.414 -3.351,-2.414 z"
       id="path8" />
    <path
       fill="#ff4b55"
       d="m 395.474,137.518 c -0.362,0 -0.719,-0.113 -1.026,-0.328 L 384,129.717 l -10.449,7.474 c -0.306,0.215 -0.668,0.328 -1.026,0.328 -0.362,0 -0.728,-0.113 -1.038,-0.337 -0.612,-0.448 -0.875,-1.241 -0.647,-1.965 l 3.875,-12.242 -10.327,-7.629 c -0.612,-0.457 -0.866,-1.25 -0.633,-1.965 0.237,-0.724 0.909,-1.216 1.668,-1.224 l 12.841,-0.095 4.061,-12.181 c 0.242,-0.715 0.918,-1.207 1.677,-1.207 0.759,0 1.436,0.491 1.677,1.207 l 4.061,12.181 12.841,0.095 c 0.759,0.009 1.431,0.5 1.668,1.224 0.233,0.715 -0.022,1.508 -0.633,1.965 l -10.327,7.629 3.875,12.242 c 0.228,0.724 -0.034,1.517 -0.647,1.965 -0.314,0.224 -0.68,0.336 -1.043,0.336 z"
       id="path9" />
    <path
       fill="#f5f5f5"
       d="m 384,100.438 4.461,13.378 14.102,0.109 -11.345,8.377 4.254,13.446 -11.472,-8.201 -11.473,8.201 4.254,-13.446 -11.345,-8.377 14.102,-0.109 4.462,-13.378 m 0,-3.531 c -1.519,0 -2.869,0.972 -3.35,2.414 l -3.663,10.984 -11.578,0.09 c -1.519,0.011 -2.861,0.994 -3.331,2.44 -0.47,1.446 0.039,3.029 1.26,3.932 l 9.314,6.878 -3.492,11.039 c -0.458,1.449 0.062,3.029 1.291,3.922 0.619,0.449 1.347,0.674 2.076,0.674 0.719,0 1.439,-0.22 2.054,-0.659 l 9.42,-6.733 9.42,6.733 c 0.615,0.438 1.334,0.659 2.053,0.659 0.728,0 1.457,-0.225 2.076,-0.674 1.229,-0.894 1.749,-2.473 1.291,-3.922 l -3.492,-11.039 9.314,-6.878 c 1.223,-0.903 1.73,-2.486 1.26,-3.932 -0.47,-1.446 -1.811,-2.429 -3.331,-2.44 l -11.578,-0.09 -3.663,-10.984 C 386.869,97.879 385.519,96.907 384,96.907 Z"
       id="path10" />
    <path
       fill="#ff4b55"
       d="m 457.267,181.656 c -0.362,0 -0.719,-0.113 -1.026,-0.328 l -10.447,-7.474 -10.449,7.474 c -0.306,0.215 -0.668,0.328 -1.026,0.328 -0.362,0 -0.728,-0.113 -1.038,-0.337 -0.612,-0.448 -0.875,-1.241 -0.647,-1.965 l 3.875,-12.242 -10.327,-7.629 c -0.612,-0.457 -0.866,-1.25 -0.633,-1.965 0.237,-0.724 0.909,-1.216 1.668,-1.224 l 12.841,-0.095 4.061,-12.181 c 0.242,-0.715 0.918,-1.207 1.677,-1.207 0.759,0 1.436,0.491 1.677,1.207 l 4.061,12.181 12.841,0.095 c 0.759,0.009 1.431,0.5 1.668,1.224 0.233,0.715 -0.022,1.508 -0.633,1.965 l -10.327,7.629 3.875,12.242 c 0.228,0.724 -0.034,1.517 -0.647,1.965 -0.315,0.224 -0.681,0.337 -1.044,0.337 z"
       id="path11" />
    <path
       fill="#f5f5f5"
       d="m 445.793,144.576 4.461,13.378 14.102,0.109 -11.345,8.377 4.254,13.446 -11.473,-8.201 -11.473,8.201 4.254,-13.445 -11.345,-8.377 14.102,-0.109 4.463,-13.379 m 0,-3.531 c -1.519,0 -2.869,0.972 -3.35,2.414 l -3.663,10.984 -11.578,0.09 c -1.519,0.011 -2.861,0.994 -3.331,2.44 -0.47,1.446 0.039,3.029 1.26,3.932 l 9.314,6.878 -3.492,11.039 c -0.458,1.449 0.062,3.029 1.291,3.922 0.619,0.449 1.347,0.674 2.076,0.674 0.719,0 1.439,-0.22 2.053,-0.659 l 9.42,-6.733 9.42,6.733 c 0.615,0.438 1.334,0.659 2.054,0.659 0.728,0 1.457,-0.225 2.076,-0.674 1.229,-0.894 1.749,-2.473 1.291,-3.922 l -3.492,-11.039 9.314,-6.878 c 1.223,-0.903 1.73,-2.486 1.26,-3.932 -0.47,-1.446 -1.811,-2.429 -3.331,-2.44 l -11.578,-0.09 -3.663,-10.984 c -0.482,-1.442 -1.831,-2.414 -3.351,-2.414 z"
       id="path12" />
    <path
       fill="#ff4b55"
       d="m 333.681,199.311 c -0.362,0 -0.719,-0.113 -1.026,-0.328 l -10.447,-7.474 -10.449,7.474 c -0.306,0.215 -0.668,0.328 -1.026,0.328 -0.362,0 -0.728,-0.113 -1.038,-0.337 -0.612,-0.448 -0.875,-1.241 -0.647,-1.965 l 3.875,-12.242 -10.327,-7.629 c -0.612,-0.457 -0.866,-1.25 -0.633,-1.965 0.237,-0.724 0.909,-1.216 1.668,-1.224 l 12.841,-0.095 4.061,-12.181 c 0.242,-0.715 0.918,-1.207 1.677,-1.207 0.759,0 1.436,0.491 1.677,1.207 l 4.061,12.181 12.841,0.095 c 0.759,0.009 1.431,0.5 1.668,1.224 0.233,0.715 -0.022,1.508 -0.633,1.965 l -10.327,7.629 3.875,12.242 c 0.228,0.724 -0.034,1.517 -0.647,1.965 -0.315,0.225 -0.681,0.337 -1.044,0.337 z"
       id="path13" />
    <path
       fill="#f5f5f5"
       d="m 322.207,162.231 4.461,13.378 14.102,0.109 -11.345,8.377 4.254,13.446 -11.473,-8.201 -11.473,8.201 4.254,-13.446 -11.345,-8.377 14.102,-0.109 4.463,-13.378 m 0,-3.531 c -1.519,0 -2.869,0.972 -3.35,2.414 l -3.663,10.984 -11.578,0.09 c -1.519,0.011 -2.861,0.994 -3.331,2.44 -0.47,1.446 0.039,3.029 1.26,3.932 l 9.314,6.878 -3.492,11.039 c -0.458,1.449 0.062,3.029 1.291,3.922 0.619,0.449 1.347,0.674 2.076,0.674 0.719,0 1.439,-0.22 2.053,-0.659 l 9.42,-6.733 9.42,6.733 c 0.615,0.438 1.334,0.659 2.053,0.659 0.728,0 1.457,-0.225 2.076,-0.674 1.229,-0.894 1.749,-2.473 1.291,-3.922 l -3.492,-11.039 9.314,-6.878 c 1.223,-0.903 1.73,-2.486 1.26,-3.932 -0.47,-1.446 -1.811,-2.429 -3.331,-2.44 l -11.578,-0.09 -3.663,-10.984 c -0.481,-1.442 -1.831,-2.414 -3.35,-2.414 z"
       id="path14" />
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const OM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs38" />
    <path
       fill="#f5f5f5"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<rect
       y="200.091"
       fill="#ff4b55"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    	<path
       fill="#ff4b55"
       d="M 132.414,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 123.586 z"
       id="path3" />
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 36.056,161.444 c -0.494,0.056 -0.971,0.116 -1.436,0.178 v 6.287 c 0.468,0.119 0.945,0.237 1.436,0.353 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 57.803,173.427 c -1.311,-0.105 -3.325,-0.307 -5.729,-0.6 l -15.079,13.411 c 1.953,0.298 4.294,0.694 5.271,1.005 3.875,-3.39 9.069,-8.009 15.537,-13.816 z"
       id="path5" />
    	<polygon
       fill="#f5f5f5"
       points="80.491,150.806 53.739,150.806 53.739,151.437 53.739,152.097 53.739,152.729 80.491,152.729 80.491,152.097 80.491,151.437 "
       id="polygon5" />
    	<path
       fill="#f5f5f5"
       d="m 60.685,113.837 c 0,1.884 2.839,3.475 6.2,3.475 3.361,0 6.2,-1.591 6.2,-3.475 0,-1.884 -2.839,-3.475 -6.2,-3.475 -3.361,0 -6.2,1.592 -6.2,3.475 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 54.887,160.594 c -6.039,-0.03 -12.066,0.192 -16.993,0.658 v 7.422 c 5.789,1.242 12.533,2.194 16.993,2.668 0,-0.001 0,-10.748 0,-10.748 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 23.776,197.221 c 2.387,-0.051 7.63,-0.994 11.18,-3.767 1.1,-0.86 2.979,-2.442 5.62,-4.736 -1.791,-0.367 -4.796,-0.813 -6.398,-1.033 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 58.332,148.969 v -3.374 c -0.452,-0.674 -0.919,-1.369 -1.396,-2.076 l -4.107,2.987 c 0.818,1.405 1.342,2.298 1.439,2.462 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 26.728,164.204 c -0.013,0.055 -0.045,0.183 0.161,0.448 0.762,0.977 2.967,1.91 5.895,2.759 v -5.516 c -3.515,0.583 -5.817,1.353 -6.056,2.309 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 73.717,161.57 v -7.004 H 60.169 v 17.108 h 3.445 c 5.57,0 10.103,-4.534 10.103,-10.104 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 51.942,136.128 c -7.254,-10.692 -15.001,-21.93 -16.892,-24.157 0.271,0.995 0.925,2.865 2.453,6.366 1.971,4.518 6.755,13.177 10.716,20.149 z"
       id="path12" />
    	<path
       fill="#f5f5f5"
       d="m 49.129,140.085 c 1.032,1.806 1.977,3.448 2.774,4.824 l 4.007,-2.914 c -0.953,-1.415 -1.934,-2.866 -2.935,-4.344 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 58.332,171.641 v -11.004 c -0.535,-0.011 -1.07,-0.022 -1.608,-0.029 v 10.913 c 0.619,0.054 1.158,0.095 1.608,0.12 z"
       id="path14" />
    	<rect
       x="60.169998"
       y="139.521"
       fill="#f5f5f5"
       width="13.549"
       height="1.923"
       id="rect14" />
    	<path
       fill="#f5f5f5"
       d="m 92.547,148.854 v 0.115 h 0.689 c 0.508,0 0.918,0.41 0.918,0.918 v 3.761 c 0,0.508 -0.41,0.918 -0.918,0.918 h -0.689 v 0.115 c 0,0.505 0.412,0.918 0.918,0.918 h 15.5 c 0.506,0 0.918,-0.413 0.918,-0.918 v -5.827 c 0,-0.505 -0.412,-0.918 -0.918,-0.918 H 93.466 c -0.507,-0.001 -0.919,0.411 -0.919,0.918 z"
       id="path15" />
    	<path
       fill="#f5f5f5"
       d="m 109.89,197.17 -10.345,-9.485 c -1.602,0.221 -4.606,0.665 -6.398,1.033 2.689,2.333 4.567,3.915 5.62,4.738 3.495,2.728 8.631,3.685 11.123,3.714 z"
       id="path16" />
    	<polygon
       fill="#f5f5f5"
       points="88.643,152.729 92.318,152.729 92.318,150.806 88.643,150.806 88.643,151.437 88.643,152.097 "
       id="polygon16" />
    	<path
       fill="#f5f5f5"
       d="m 91.454,187.245 c 0.977,-0.313 3.321,-0.71 5.278,-1.007 L 74.518,166.415 c -0.602,1.352 -1.442,2.575 -2.476,3.606 l 0.585,0.522 c 8.047,7.204 14.338,12.782 18.827,16.702 z"
       id="path17" />
    	<path
       fill="#f5f5f5"
       d="m 41.683,154.681 v -0.115 h -0.69 c -0.508,0 -0.918,-0.41 -0.918,-0.918 v -3.761 c 0,-0.508 0.41,-0.918 0.918,-0.918 h 0.689 v -0.115 c 0,-0.505 -0.412,-0.918 -0.918,-0.918 h -15.5 c -0.506,0 -0.918,0.413 -0.918,0.918 v 5.827 c 0,0.505 0.412,0.918 0.918,0.918 h 15.5 c 0.507,0 0.919,-0.412 0.919,-0.918 z"
       id="path18" />
    	<polygon
       fill="#f5f5f5"
       points="45.587,150.806 41.912,150.806 41.912,152.729 45.587,152.729 45.587,152.097 45.587,151.437 "
       id="polygon18" />
    	<path
       fill="#f5f5f5"
       d="m 80.895,146.506 -4.107,-2.987 c -0.42,0.625 -0.831,1.236 -1.234,1.835 v 3.614 h 3.902 c 0.097,-0.164 0.621,-1.057 1.439,-2.462 z"
       id="path19" />
    	<polygon
       fill="#f5f5f5"
       points="70.051,131.189 63.84,131.189 61.398,133.899 72.493,133.899 "
       id="polygon19" />
    	<rect
       x="60.169998"
       y="135.821"
       fill="#f5f5f5"
       width="13.549"
       height="1.8660001"
       id="rect19" />
    	<path
       fill="#f5f5f5"
       d="m 66.886,119.149 c -0.893,0 -1.73,-0.115 -2.526,-0.285 v 10.383 h 5.109 v -10.394 c -0.812,0.178 -1.67,0.296 -2.583,0.296 z"
       id="path20" />
    	<path
       fill="#f5f5f5"
       d="m 60.169,145.208 h 13.49 c -0.002,-0.115 0.018,-0.227 0.06,-0.338 v -1.585 h -13.55 z"
       id="path21" />
    	<path
       fill="#f5f5f5"
       d="m 77.815,141.995 4.007,2.914 c 0.797,-1.375 1.742,-3.018 2.774,-4.824 l -3.846,-2.434 c -1.002,1.478 -1.981,2.929 -2.935,4.344 z"
       id="path22" />
    	<rect
       x="60.169998"
       y="147.05099"
       fill="#f5f5f5"
       width="13.549"
       height="1.923"
       id="rect22" />
    	<path
       fill="#f5f5f5"
       d="m 85.506,138.486 c 3.96,-6.97 8.744,-15.631 10.716,-20.149 1.532,-3.509 2.185,-5.38 2.455,-6.372 -1.857,2.179 -9.623,13.443 -16.895,24.163 z"
       id="path23" />
    </g>
    <path
       fill="#d23741"
       d="M 112.449,108.748 100.47,97.763 c -0.201,-0.184 -0.472,-0.275 -0.744,-0.233 -0.102,0.013 -0.333,0.045 -0.64,0.087 -0.017,-0.017 -0.023,-0.04 -0.042,-0.055 L 75.167,76.255 c 0.244,-0.949 0.386,-1.938 0.386,-2.961 V 66.29 h 5.792 c 0.746,0.971 1.906,1.608 3.221,1.608 1.316,0 2.476,-0.637 3.221,-1.608 h 2.922 v 0.115 c 0,1.519 1.236,2.755 2.755,2.755 h 15.5 c 1.519,0 2.755,-1.236 2.755,-2.755 v -5.827 c 0,-1.519 -1.236,-2.755 -2.755,-2.755 H 93.466 c -1.519,0 -2.755,1.236 -2.755,2.755 v 0.115 h -2.922 c -0.746,-0.971 -1.906,-1.608 -3.221,-1.608 -0.998,0 -1.9,0.374 -2.609,0.97 3.096,-5.3 12.823,-22.1 15.947,-29.259 3.351,-7.682 3.081,-8.674 2.289,-9.311 -0.836,-0.669 -1.894,0.1 -2.293,0.393 -1.537,1.117 -16.44,23.134 -22.348,31.91 v -7.246 c 0,-0.02 -0.01,-0.038 -0.011,-0.057 l -0.001,-0.002 c -0.021,-0.311 -0.195,-0.57 -0.449,-0.719 l -3.787,-4.2 V 30.015 c 2.19,-0.94 3.617,-2.564 3.617,-4.454 0,-2.978 -3.531,-5.312 -8.038,-5.312 -4.507,0 -8.038,2.334 -8.038,5.312 0,1.905 1.453,3.538 3.674,4.473 V 41.63 l -3.715,4.121 c -0.279,0.158 -0.476,0.446 -0.476,0.789 v 7.486 C 52.537,45.419 37.371,23.004 35.822,21.877 c -0.401,-0.29 -1.46,-1.06 -2.294,-0.393 -0.793,0.637 -1.063,1.629 2.289,9.311 3.025,6.932 12.238,22.899 15.631,28.719 -0.542,-0.267 -1.143,-0.43 -1.786,-0.43 -1.316,0 -2.476,0.637 -3.221,1.608 H 43.52 v -0.115 c 0,-1.519 -1.236,-2.755 -2.755,-2.755 H 25.263 c -1.519,0 -2.755,1.236 -2.755,2.755 v 5.827 c 0,1.519 1.236,2.755 2.755,2.755 h 15.5 c 1.519,0 2.755,-1.236 2.755,-2.755 v -0.115 h 2.922 c 0.746,0.971 1.906,1.608 3.221,1.608 1.316,0 2.476,-0.637 3.221,-1.608 h 5.448 v 4.23 c -8.516,-0.182 -32.093,-0.21 -33.385,4.963 -0.12,0.479 -0.132,1.222 0.495,2.024 2.485,3.183 15.079,5.506 24.214,6.734 L 34.678,97.56 c -0.019,0.017 -0.025,0.04 -0.043,0.057 -0.307,-0.043 -0.538,-0.074 -0.64,-0.087 -0.276,-0.04 -0.544,0.049 -0.744,0.233 l -11.98,10.985 c -0.362,0.33 -0.399,0.888 -0.084,1.265 0.397,0.477 1.406,0.711 2.755,0.711 3.32,0 8.707,-1.416 12.141,-4.097 2.83,-2.21 10.67,-9.084 23.304,-20.43 0.547,-0.491 0.909,-0.817 1.069,-0.96 h 3.154 c 2.621,0 5.038,-0.858 7.01,-2.295 l 0.778,0.695 c 14.546,13.02 23.372,20.754 26.237,22.99 3.434,2.684 8.819,4.097 12.139,4.097 1.35,0 2.358,-0.233 2.756,-0.711 0.319,-0.377 0.28,-0.935 -0.081,-1.265 z M 60.169,83.398 V 66.29 h 13.549 v 7.004 c 0,5.57 -4.533,10.104 -10.104,10.104 z M 32.785,79.135 c -2.926,-0.85 -5.132,-1.782 -5.895,-2.759 -0.207,-0.266 -0.175,-0.393 -0.161,-0.448 0.239,-0.956 2.541,-1.726 6.056,-2.308 z m 2.265,-55.44 c 1.89,2.227 9.638,13.463 16.892,24.157 L 48.218,50.21 C 44.258,43.238 39.474,34.579 37.502,30.061 35.975,26.561 35.32,24.692 35.05,23.695 Z m 21.886,31.548 c 0.476,0.706 0.942,1.4 1.396,2.076 v 3.374 h -4.064 c -0.097,-0.164 -0.621,-1.057 -1.439,-2.462 z m -5.034,1.39 C 51.105,55.258 50.16,53.615 49.128,51.809 l 3.846,-2.434 c 1.002,1.479 1.982,2.93 2.935,4.344 z m 6.43,15.729 V 83.366 C 57.884,83.341 57.344,83.3 56.724,83.246 V 72.333 c 0.537,0.007 1.072,0.017 1.608,0.029 z m -20.438,0.613 c 4.928,-0.466 10.954,-0.687 16.993,-0.658 V 83.065 C 50.427,82.592 43.683,81.639 37.894,80.397 Z m -3.273,0.371 c 0.465,-0.062 0.941,-0.121 1.436,-0.178 v 6.817 C 35.566,79.87 35.089,79.752 34.621,79.632 Z M 52.074,84.55 c 2.404,0.294 4.418,0.495 5.729,0.6 C 51.335,90.957 46.141,95.576 42.268,98.966 41.29,98.654 38.95,98.259 36.997,97.961 Z m -11.498,15.891 c -2.641,2.294 -4.52,3.876 -5.62,4.736 -3.55,2.774 -8.792,3.718 -11.18,3.767 l 10.402,-9.537 c 1.602,0.222 4.606,0.667 6.398,1.034 z M 53.739,64.453 v -0.631 -0.66 -0.631 h 26.753 v 0.631 0.66 0.631 z M 73.086,25.561 c 0,1.884 -2.839,3.475 -6.2,3.475 -3.361,0 -6.2,-1.591 -6.2,-3.475 0,-1.884 2.839,-3.475 6.2,-3.475 3.361,0 6.2,1.592 6.2,3.475 z M 60.169,53.172 v -1.923 h 13.549 v 1.923 z m 13.548,1.837 v 1.585 c -0.042,0.111 -0.062,0.223 -0.06,0.338 H 60.169 V 55.009 Z M 60.169,49.411 v -1.866 h 13.549 v 1.866 z m 9.882,-6.498 2.442,2.709 H 61.398 L 63.84,42.913 Z M 64.36,40.972 V 30.589 c 0.796,0.17 1.633,0.285 2.526,0.285 0.914,0 1.771,-0.118 2.583,-0.296 v 10.394 z m -4.191,17.797 h 13.549 v 1.923 H 60.169 Z M 96.222,30.061 C 94.251,34.579 89.467,43.238 85.506,50.21 l -3.724,-2.358 c 7.272,-10.72 15.038,-21.984 16.895,-24.163 -0.27,0.992 -0.924,2.863 -2.455,6.372 z m -9.416,33.1 v 0.66 c 0,1.235 -1.004,2.239 -2.239,2.239 -1.235,0 -2.239,-1.004 -2.239,-2.239 v -0.66 c 0,-1.235 1.004,-2.239 2.239,-2.239 1.235,0 2.239,1.004 2.239,2.239 z m -4.984,-6.528 -4.007,-2.914 c 0.953,-1.415 1.933,-2.866 2.935,-4.344 l 3.846,2.434 c -1.032,1.806 -1.978,3.448 -2.774,4.824 z m -6.268,0.445 c 0.403,-0.6 0.813,-1.21 1.234,-1.835 l 4.107,2.987 c -0.818,1.405 -1.342,2.298 -1.439,2.463 H 75.554 Z M 74.518,78.137 96.732,97.96 c -1.955,0.299 -4.301,0.695 -5.278,1.007 -4.49,-3.921 -10.78,-9.497 -18.828,-16.703 l -0.585,-0.522 c 1.035,-1.029 1.875,-2.253 2.477,-3.605 z m 25.028,21.271 10.345,9.485 c -2.493,-0.029 -7.628,-0.985 -11.123,-3.714 -1.053,-0.823 -2.931,-2.406 -5.62,-4.738 1.792,-0.367 4.796,-0.812 6.398,-1.033 z m 10.34,-38.83 v 5.827 c 0,0.505 -0.412,0.918 -0.918,0.918 H 93.466 c -0.506,0 -0.918,-0.413 -0.918,-0.918 V 66.29 h 0.689 c 0.508,0 0.918,-0.41 0.918,-0.918 v -3.761 c 0,-0.508 -0.41,-0.918 -0.918,-0.918 h -0.689 v -0.115 c 0,-0.505 0.412,-0.918 0.918,-0.918 h 15.5 c 0.507,-10e-4 0.92,0.411 0.92,0.918 z m -17.568,3.875 h -3.674 v -0.631 -0.66 -0.631 h 3.674 z m -67.974,1.952 v -5.827 c 0,-0.505 0.412,-0.918 0.918,-0.918 h 15.5 c 0.506,0 0.918,0.413 0.918,0.918 v 0.115 h -0.687 c -0.508,0 -0.918,0.41 -0.918,0.918 v 3.761 c 0,0.508 0.41,0.918 0.918,0.918 h 0.689 v 0.115 c 0,0.505 -0.412,0.918 -0.918,0.918 h -15.5 c -0.507,0 -0.92,-0.412 -0.92,-0.918 z M 41.912,62.53 h 3.674 v 0.631 0.66 0.631 h -3.674 z m 9.99,1.291 c 0,1.235 -1.004,2.239 -2.239,2.239 -1.235,0 -2.239,-1.004 -2.239,-2.239 v -0.66 c 0,-1.235 1.004,-2.239 2.239,-2.239 1.235,0 2.239,1.004 2.239,2.239 z"
       id="path24" />
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 256,167.725 h 247.172 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 512,3.953 508.047,0 503.172,0 H 264.828 C 259.953,0 256,3.953 256,8.828 Z"
       id="path2" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#4173cd"
       d="m 8.828,423.725 h 238.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 256.001 H 8.828 C 3.953,256.001 0,259.954 0,264.829 v 150.069 c 0,4.875 3.953,8.827 8.828,8.827 z"
       id="path3" />
    	<path
       fill="#4173cd"
       d="m 131.4,134.488 8.416,25.234 26.6,0.206 c 3.444,0.026 4.872,4.422 2.101,6.467 l -21.398,15.801 8.023,25.362 c 1.038,3.284 -2.7,5.999 -5.502,3.997 L 128,196.088 106.359,211.556 c -2.802,2.003 -6.54,-0.714 -5.502,-3.997 l 8.023,-25.362 -21.398,-15.801 c -2.771,-2.046 -1.343,-6.441 2.101,-6.467 l 26.6,-0.206 8.416,-25.234 c 1.09,-3.268 5.712,-3.268 6.801,-0.001 z"
       id="path4" />
    </g>
    <path
       fill="#ff4b55"
       d="m 387.4,213.936 8.416,25.234 26.6,0.206 c 3.444,0.026 4.872,4.422 2.101,6.467 l -21.398,15.801 8.023,25.362 c 1.038,3.284 -2.7,5.999 -5.502,3.997 L 384,275.536 362.359,291.004 c -2.802,2.003 -6.54,-0.714 -5.502,-3.997 l 8.023,-25.362 -21.398,-15.801 c -2.771,-2.046 -1.343,-6.441 2.101,-6.467 l 26.6,-0.206 8.416,-25.234 c 1.09,-3.268 5.712,-3.268 6.801,-0.001 z"
       id="path5" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const PF = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs35" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 0,335.448 h 512 v 79.448 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,423.724 0,419.771 0,414.896 Z"
       id="path1" />
    	<path
       fill="#ff4b55"
       d="m 8.828,88.276 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 79.448 H 0 V 97.103 c 0,-4.875 3.953,-8.827 8.828,-8.827 z"
       id="path2" />
    </g>
    <rect
       y="88.274002"
       fill="#f5f5f5"
       width="512"
       height="158.89999"
       id="rect2"
       x="0" />
    <path
       fill="#ffb955"
       d="m 314.196,145.182 -56.036,22.873 c -0.022,-0.057 -0.049,-0.108 -0.075,-0.162 l 54.118,-27.103 c -2.14,-4.271 -4.739,-8.271 -7.755,-11.919 l -46.657,38.585 c -0.046,-0.058 -0.073,-0.132 -0.126,-0.186 l 42.77,-42.813 c -3.051,-3.052 -6.424,-5.779 -10.048,-8.153 l -33.113,50.686 c -0.075,-0.051 -0.142,-0.109 -0.224,-0.151 l 27.055,-54.151 c -4.345,-2.177 -8.977,-3.861 -13.825,-4.988 l -13.749,58.966 c -0.174,-0.042 -0.341,-0.107 -0.53,-0.107 -0.189,0 -0.354,0.065 -0.53,0.107 L 241.722,107.7 c -4.849,1.127 -9.48,2.81 -13.825,4.988 l 27.055,54.151 c -0.081,0.042 -0.149,0.1 -0.224,0.151 l -33.113,-50.686 c -3.625,2.375 -6.997,5.102 -10.048,8.153 l 42.77,42.813 c -0.052,0.054 -0.078,0.127 -0.126,0.186 l -46.657,-38.585 c -3.016,3.647 -5.615,7.648 -7.755,11.919 l 54.118,27.103 c -0.026,0.055 -0.053,0.106 -0.075,0.162 l -56.036,-22.873 c -1.689,4.142 -2.945,8.505 -3.721,13.035 l 59.658,10.329 c -0.008,0.052 -0.026,0.099 -0.031,0.152 l -60.218,-6.273 c -0.217,2.125 -0.329,4.28 -0.329,6.463 0,3.774 0.351,7.463 0.989,11.052 l 61.846,-6.398 61.847,6.398 c 0.638,-3.591 0.989,-7.279 0.989,-11.052 0,-2.183 -0.113,-4.338 -0.329,-6.463 l -60.219,6.273 c -0.004,-0.053 -0.023,-0.1 -0.031,-0.152 l 59.657,-10.329 c -0.773,-4.529 -2.03,-8.892 -3.718,-13.035 z"
       id="path3" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    	<path
       fill="#4173cd"
       d="m 195.27,273.315 c 0.431,1.625 0.929,3.223 1.484,4.793 h 118.494 c 0.555,-1.57 1.053,-3.168 1.484,-4.793 -5.805,-0.75 -6.526,-4.515 -13.598,-4.515 -7.851,0 -7.851,4.654 -15.703,4.654 -7.851,0 -7.851,-4.654 -15.703,-4.654 -7.853,0 -7.853,4.654 -15.708,4.654 -7.849,0 -7.849,-4.654 -15.699,-4.654 -7.857,0 -7.857,4.654 -15.712,4.654 -7.861,0 -7.861,-4.654 -15.723,-4.654 -7.081,0 -7.801,3.766 -13.616,4.515 z"
       id="path4" />
    	<path
       fill="#4173cd"
       d="m 301.282,285.09 c -7.558,-10e-4 -7.559,-4.654 -15.118,-4.654 -7.561,0 -7.561,4.654 -15.122,4.654 -7.561,0 -7.561,-4.654 -15.122,-4.654 -7.563,0 -7.563,4.654 -15.125,4.654 -7.559,0 -7.559,-4.654 -15.117,-4.654 -7.565,0 -7.565,4.654 -15.13,4.654 -6.712,0 -7.484,-3.652 -12.846,-4.482 1.28,3.18 2.797,6.239 4.558,9.137 h 99.019 0.006 8.456 c 1.764,-2.904 3.285,-5.971 4.567,-9.16 -5.523,0.777 -6.244,4.505 -13.026,4.505 z"
       id="path5" />
    	<path
       fill="#4173cd"
       d="m 307.292,293.44 c -1.463,-0.767 -3.196,-1.367 -5.903,-1.367 -7.561,0 -7.561,4.654 -15.122,4.654 -7.561,0 -7.561,-4.654 -15.122,-4.654 -7.563,0 -7.563,4.654 -15.125,4.654 -7.559,0 -7.559,-4.654 -15.117,-4.654 -7.565,0 -7.565,4.654 -15.13,4.654 -7.571,0 -7.571,-4.654 -15.14,-4.654 -2.717,0 -4.454,0.602 -5.92,1.372 2.003,2.825 4.222,5.484 6.653,7.938 h 89.271 c 2.431,-2.456 4.652,-5.116 6.655,-7.943 z"
       id="path6" />
    	<path
       fill="#4173cd"
       d="m 294.721,306.633 c -2.284,-1.324 -4.121,-2.924 -8.557,-2.924 -7.561,0 -7.561,4.654 -15.122,4.654 -7.561,0 -7.561,-4.654 -15.122,-4.654 -7.563,0 -7.563,4.654 -15.125,4.654 -7.559,0 -7.559,-4.654 -15.117,-4.654 -4.377,0 -6.225,1.556 -8.468,2.87 3.115,2.449 6.465,4.607 10.014,6.44 h 57.551 c 3.524,-1.82 6.85,-3.96 9.946,-6.386 z"
       id="path7" />
    	<path
       fill="#4173cd"
       d="m 240.903,315.346 c -2.478,0 -4.139,0.502 -5.525,1.174 6.462,2.244 13.396,3.48 20.622,3.48 h 0.012 c -7.551,-0.003 -7.553,-4.654 -15.109,-4.654 z"
       id="path8" />
    	<path
       fill="#4173cd"
       d="m 256.056,319.999 c 7.217,-0.007 14.141,-1.242 20.594,-3.488 -1.382,-0.666 -3.039,-1.165 -5.504,-1.165 -7.551,0 -7.565,4.636 -15.09,4.653 z"
       id="path9" />
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 264.266,249.207 -19.912,-5.754 c -1.117,-0.323 -1.891,-1.331 -1.906,-2.494 -0.092,-7.373 -0.412,-33.336 -0.412,-37.323 C 242.036,198.982 246.69,192 256,192 h 7.34 c 0.695,0 0.905,0.946 0.266,1.219 -3.362,1.441 -7.605,4.444 -7.605,10.417 0,7.092 6.753,10.132 9.971,11.178 0.994,0.323 1.666,1.236 1.666,2.282 v 29.578 c -0.002,1.755 -1.685,3.021 -3.372,2.533 z"
       id="path10" />
    	<path
       fill="#ff4b55"
       d="m 246.702,275.255 c 0.73,-0.442 1.596,0.296 1.267,1.084 -1.949,4.679 -6.726,13.407 -15.243,13.407 -11.636,0 -13.964,-9.309 -13.964,-16.291 V 224.09 c 0,-1.014 0.822,-1.835 1.835,-1.835 h 3.311 c 1.014,0 1.835,0.822 1.835,1.835 v 47.038 c 0.003,6.293 13.235,8.804 20.959,4.127 z"
       id="path11" />
    	<path
       fill="#ff4b55"
       d="m 264.321,275.255 c -0.73,-0.442 -1.596,0.296 -1.267,1.084 1.949,4.679 6.726,13.407 15.243,13.407 11.636,0 13.964,-9.309 13.964,-16.291 V 224.09 c 0,-1.014 -0.822,-1.835 -1.835,-1.835 h -3.311 c -1.014,0 -1.835,0.822 -1.835,1.835 v 47.038 c -0.002,6.293 -13.235,8.804 -20.959,4.127 z"
       id="path12" />
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    	<path
       fill="#aa4650"
       d="m 280.477,267.636 h -48.953 c -0.62,0 -1.123,-0.503 -1.123,-1.123 v -0.081 c 0,-0.62 0.503,-1.123 1.123,-1.123 h 48.953 c 0.62,0 1.123,0.503 1.123,1.123 v 0.081 c 0,0.621 -0.503,1.123 -1.123,1.123 z"
       id="path13" />
    	<path
       fill="#aa4650"
       d="m 235.345,258.852 2.52,-3.36 c 0.386,-0.513 0.281,-1.244 -0.233,-1.63 -0.513,-0.384 -1.244,-0.277 -1.629,0.234 l -0.981,1.308 V 254.5 c 0,-0.643 -0.521,-1.164 -1.164,-1.164 -0.643,0 -1.164,0.521 -1.164,1.164 v 0.819 l -0.917,-1.223 c -0.385,-0.513 -1.114,-0.62 -1.629,-0.234 -0.515,0.386 -0.619,1.116 -0.233,1.63 l 2.52,3.36 -2.52,3.36 c -0.386,0.513 -0.281,1.244 0.233,1.63 0.209,0.157 0.454,0.232 0.696,0.232 0.354,0 0.703,-0.161 0.931,-0.466 l 2.112,-2.817 2.112,2.817 c 0.228,0.305 0.577,0.466 0.931,0.466 0.243,0 0.488,-0.075 0.696,-0.232 0.515,-0.386 0.619,-1.116 0.233,-1.63 z"
       id="path14" />
    	<path
       fill="#aa4650"
       d="m 257.066,258.852 2.52,-3.36 c 0.386,-0.513 0.281,-1.244 -0.233,-1.63 -0.513,-0.384 -1.244,-0.277 -1.629,0.234 l -0.981,1.308 V 254.5 c 0,-0.643 -0.521,-1.164 -1.164,-1.164 -0.643,0 -1.164,0.521 -1.164,1.164 v 0.819 l -0.917,-1.223 c -0.385,-0.513 -1.114,-0.62 -1.629,-0.234 -0.515,0.386 -0.619,1.116 -0.233,1.63 l 2.52,3.36 -2.52,3.36 c -0.386,0.513 -0.281,1.244 0.233,1.63 0.209,0.157 0.454,0.232 0.696,0.232 0.354,0 0.703,-0.161 0.931,-0.466 l 2.112,-2.817 2.112,2.817 c 0.228,0.305 0.577,0.466 0.931,0.466 0.243,0 0.488,-0.075 0.696,-0.232 0.515,-0.386 0.619,-1.116 0.233,-1.63 z"
       id="path15" />
    	<path
       fill="#aa4650"
       d="m 246.206,258.852 2.52,-3.36 c 0.386,-0.513 0.281,-1.244 -0.233,-1.63 -0.513,-0.384 -1.244,-0.277 -1.629,0.234 l -0.981,1.308 V 254.5 c 0,-0.643 -0.521,-1.164 -1.164,-1.164 -0.643,0 -1.164,0.521 -1.164,1.164 v 0.819 l -0.917,-1.223 c -0.385,-0.513 -1.114,-0.62 -1.629,-0.234 -0.515,0.386 -0.619,1.116 -0.233,1.63 l 2.52,3.36 -2.52,3.36 c -0.386,0.513 -0.281,1.244 0.233,1.63 0.209,0.157 0.454,0.232 0.696,0.232 0.354,0 0.703,-0.161 0.931,-0.466 l 2.112,-2.817 2.112,2.817 c 0.228,0.305 0.577,0.466 0.931,0.466 0.243,0 0.488,-0.075 0.696,-0.232 0.515,-0.386 0.619,-1.116 0.233,-1.63 z"
       id="path16" />
    	<path
       fill="#aa4650"
       d="m 267.927,258.852 2.52,-3.36 c 0.386,-0.513 0.281,-1.244 -0.233,-1.63 -0.513,-0.384 -1.244,-0.277 -1.629,0.234 l -0.981,1.308 V 254.5 c 0,-0.643 -0.521,-1.164 -1.164,-1.164 -0.643,0 -1.164,0.521 -1.164,1.164 v 0.819 l -0.917,-1.223 c -0.385,-0.513 -1.114,-0.62 -1.629,-0.234 -0.515,0.386 -0.619,1.116 -0.233,1.63 l 2.52,3.36 -2.52,3.36 c -0.386,0.513 -0.281,1.244 0.233,1.63 0.209,0.157 0.454,0.232 0.696,0.232 0.354,0 0.703,-0.161 0.931,-0.466 l 2.112,-2.817 2.112,2.817 c 0.228,0.305 0.577,0.466 0.931,0.466 0.243,0 0.488,-0.075 0.696,-0.232 0.515,-0.386 0.619,-1.116 0.233,-1.63 z"
       id="path17" />
    	<path
       fill="#aa4650"
       d="m 278.787,258.852 2.52,-3.36 c 0.386,-0.513 0.281,-1.244 -0.233,-1.63 -0.513,-0.384 -1.244,-0.277 -1.629,0.234 l -0.981,1.308 V 254.5 c 0,-0.643 -0.521,-1.164 -1.164,-1.164 -0.643,0 -1.164,0.521 -1.164,1.164 v 0.819 l -0.917,-1.223 c -0.385,-0.513 -1.114,-0.62 -1.629,-0.234 -0.515,0.386 -0.619,1.116 -0.233,1.63 l 2.52,3.36 -2.52,3.36 c -0.386,0.513 -0.281,1.244 0.233,1.63 0.209,0.157 0.454,0.232 0.696,0.232 0.354,0 0.703,-0.161 0.931,-0.466 l 2.112,-2.817 2.112,2.817 c 0.228,0.305 0.577,0.466 0.931,0.466 0.243,0 0.488,-0.075 0.696,-0.232 0.515,-0.386 0.619,-1.116 0.233,-1.63 z"
       id="path18" />
    	<path
       fill="#aa4650"
       d="m 233.196,274.824 c 1.721,0.753 11.832,0.861 14.413,-1.828 2.581,-2.689 2.044,-3.872 2.044,-3.872 l -12.263,0.107 z"
       id="path19" />
    	<path
       fill="#aa4650"
       d="m 278.312,274.824 c -1.721,0.753 -11.832,0.861 -14.413,-1.828 -2.581,-2.689 -2.044,-3.872 -2.044,-3.872 l 12.263,0.107 z"
       id="path20" />
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs22" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#464655"
       d="M 3.256,2.135 C 1.311,3.754 0,6.1 0,8.828 v 317.793 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 2.146,0 4.041,-0.86 5.571,-2.134 z"
       id="path2" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 51.499,250.288 -5.052,15.148 -15.968,0.124 c -1.532,0.012 -2.166,1.966 -0.935,2.876 l 12.845,9.485 -4.817,15.224 c -0.462,1.46 1.201,2.668 2.446,1.778 L 53.009,285.637 66,294.923 c 1.246,0.891 2.908,-0.318 2.446,-1.778 l -4.817,-15.224 12.845,-9.485 c 1.231,-0.909 0.597,-2.863 -0.935,-2.876 l -15.968,-0.124 -5.052,-15.148 c -0.481,-1.452 -2.536,-1.452 -3.02,0 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 160.282,250.288 -5.052,15.148 -15.968,0.124 c -1.532,0.012 -2.166,1.966 -0.935,2.876 l 12.845,9.485 -4.817,15.224 c -0.462,1.46 1.201,2.668 2.446,1.778 l 12.991,-9.286 12.991,9.286 c 1.246,0.891 2.908,-0.318 2.446,-1.778 l -4.817,-15.224 12.845,-9.485 c 1.231,-0.909 0.597,-2.863 -0.935,-2.876 l -15.968,-0.124 -5.052,-15.148 c -0.48,-1.452 -2.535,-1.452 -3.02,0 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 105.89,184.352 -5.052,15.148 -15.968,0.124 c -1.532,0.012 -2.166,1.966 -0.935,2.876 l 12.845,9.485 -4.817,15.224 c -0.462,1.46 1.201,2.668 2.446,1.778 l 12.991,-9.286 12.991,9.286 c 1.246,0.89 2.908,-0.318 2.446,-1.778 l -4.817,-15.224 12.845,-9.485 c 1.231,-0.909 0.597,-2.863 -0.935,-2.876 L 113.962,199.5 108.91,184.352 c -0.481,-1.452 -2.535,-1.452 -3.02,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 105.89,346.5 -5.052,15.148 -15.968,0.124 c -1.532,0.012 -2.166,1.966 -0.935,2.876 l 12.845,9.485 -4.817,15.224 c -0.462,1.46 1.201,2.668 2.446,1.778 l 12.991,-9.286 12.991,9.286 c 1.246,0.891 2.908,-0.318 2.446,-1.778 l -4.817,-15.224 12.845,-9.485 c 1.231,-0.909 0.597,-2.863 -0.935,-2.876 L 113.962,361.648 108.91,346.5 c -0.481,-1.452 -2.535,-1.452 -3.02,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 131.229,306.992 -2.687,8.055 -8.491,0.066 c -0.814,0.007 -1.152,1.045 -0.497,1.529 l 6.83,5.044 -2.561,8.096 c -0.246,0.777 0.638,1.419 1.301,0.945 l 6.909,-4.938 6.909,4.938 c 0.662,0.473 1.546,-0.169 1.301,-0.945 l -2.561,-8.096 6.83,-5.044 c 0.655,-0.483 0.318,-1.523 -0.497,-1.529 l -8.491,-0.066 -2.687,-8.055 c -0.258,-0.772 -1.351,-0.772 -1.608,0 z"
       id="path7" />
    </g>
    <path
       fill="#ffe15a"
       d="m 437.565,160.07 c -1.292,-10.004 -5.566,-19.89 -8.671,-25.995 1.533,0.767 3.917,2.148 3.917,2.148 l -2.104,-7.628 c 5.26,2.104 9.206,6.182 9.206,6.182 -2.631,-13.152 -6.708,-19.332 -6.708,-19.332 l 3.288,1.184 C 430.311,101.373 421.105,97.033 421.105,97.033 l 5.26,-1.315 C 418.606,85.986 407.69,82.698 407.69,82.698 l 7.102,-3.42 c -18.807,-10.653 -36.956,0.526 -36.956,0.526 0,0 6.313,-6.575 8.68,-9.337 2.367,-2.762 -3.288,-3.682 -3.288,-3.682 0,0 5.524,-3.814 5.26,-6.05 -0.264,-2.237 -5.26,-1.052 -5.26,-1.052 0,0 4.34,-4.471 4.34,-6.97 0,-2.499 -4.471,-0.92 -4.471,-0.92 0,0 1.447,-3.025 1.842,-5.393 0.395,-2.367 -3.946,-0.395 -3.946,-0.395 0,0 4.866,-8.68 4.604,-10.521 -0.263,-1.842 -12.757,5.918 -21.7,14.467 -8.943,8.55 -7.87,22.286 -7.078,25.555 0.792,3.269 1.288,10.893 -2.674,13.566 -3.961,2.674 -11.029,-3.874 -14.536,-7.907 -3.507,-4.033 -7.891,-2.631 -12.45,-1.052 -4.559,1.578 -13.152,-0.526 -15.782,-0.877 -2.631,-0.351 2.98,2.631 7.715,4.384 4.735,1.753 6.839,5.962 13.503,8.417 5.836,2.151 10.51,7.61 5.918,10.126 -3.578,1.961 -3.551,-1.184 -19.332,-5.26 -15.782,-4.076 -34.72,36.035 -34.72,36.035 10.138,-1.254 15.32,-7.327 15.32,-7.327 l -2.739,7.857 c 7.492,-1.419 11.156,-5.975 11.156,-5.975 l -1.981,7.923 c 5.743,-1.783 9.705,-7.923 9.705,-7.923 l -1.684,7.823 c 5.644,-2.674 8.616,-7.823 8.616,-7.823 0.594,2.872 1.062,8.733 1.062,8.733 8.742,-4.673 10.784,-11.31 10.784,-11.31 9.995,30.249 24.462,35.246 24.462,35.246 l 0.789,-7.891 c 4.471,6.313 10.784,9.469 10.784,9.469 l -1.052,-6.839 c 15.519,18.938 33.405,23.673 33.405,23.673 l -4.58,-10.482 5.632,1.143 c -6.05,-5.129 -8.286,-14.072 -8.286,-14.072 l 4.735,0.789 c -7.628,-6.97 -11.442,-14.993 -11.442,-14.993 l 4.604,0.789 c -1.447,-2.236 -2.631,-10.126 -2.631,-10.126 8.417,2.631 12.757,5.918 12.757,5.918 l 0.499,-2.865 c 7.221,5.203 19.079,14.889 27.297,27.066 0.011,3.972 -0.631,7.983 -2.281,12.009 -7.538,18.386 -27.356,17.185 -36.124,13.326 0,0 27.18,21.218 42.086,-8.943 0.945,-1.91 1.536,-3.956 1.959,-6.054 1.859,4.434 3.144,9.058 3.39,13.857 1.578,30.775 -30.511,27.882 -30.511,27.882 0,0 35.509,14.204 37.088,-26.829 0.348,-9.124 -3.515,-18.246 -9.715,-26.919 z m -32.264,-30.719 0.155,-0.888 c 5.393,1.578 11.048,5.393 11.048,5.393 l 1.249,-3.748 c 5.335,6.411 9.596,13.31 11.968,20.452 -7.202,-7.738 -15.833,-14.924 -24.42,-21.209 z"
       id="path8" />
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PH = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.448" {...props}>
    <defs
       id="defs27" />
    <path
       fill="#f5f5f5"
       d="M 3.256,333.314 256,167.724 3.256,2.134 C 1.311,3.753 0,6.099 0,8.827 V 326.62 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 3.256,333.314 c 1.53,1.274 3.425,2.134 5.571,2.134 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 167.724 H 256 Z"
       id="path2" />
    <path
       fill="#41479b"
       d="M 3.256,2.134 C 4.786,0.86 6.681,0 8.827,0 H 503.172 C 508.047,0 512,3.953 512,8.828 V 167.724 H 256 Z"
       id="path3" />
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<circle
       fill="#ffe15a"
       cx="92.690002"
       cy="256"
       r="28.690001"
       id="circle3" />
    	<polygon
       fill="#ffe15a"
       points="92.69,198.621 103.448,212.966 92.69,256 81.931,212.966 "
       id="polygon3" />
    	<polygon
       fill="#ffe15a"
       points="92.69,313.379 81.931,299.034 92.69,256 103.448,299.034 "
       id="polygon4" />
    	<polygon
       fill="#ffe15a"
       points="35.31,256 49.655,245.241 92.69,256 49.655,266.759 "
       id="polygon5" />
    	<polygon
       fill="#ffe15a"
       points="150.069,256 135.724,266.759 92.69,256 135.724,245.241 "
       id="polygon6" />
    	<polygon
       fill="#ffe15a"
       points="133.263,215.426 130.727,233.177 92.69,256 115.512,217.963 "
       id="polygon7" />
    	<polygon
       fill="#ffe15a"
       points="52.116,296.574 54.653,278.823 92.69,256 69.867,294.037 "
       id="polygon8" />
    	<polygon
       fill="#ffe15a"
       points="52.116,215.426 69.867,217.963 92.69,256 54.653,233.177 "
       id="polygon9" />
    	<polygon
       fill="#ffe15a"
       points="133.263,296.574 115.512,294.037 92.69,256 130.727,278.823 "
       id="polygon10" />
    	<path
       fill="#ffe15a"
       d="m 23.658,131.694 1.496,11.16 -10.076,5.028 c -1.304,0.651 -1.03,2.588 0.405,2.85 l 11.076,2.026 1.668,11.136 c 0.216,1.442 2.143,1.779 2.836,0.495 l 5.35,-9.908 11.106,1.854 c 1.438,0.241 2.354,-1.489 1.348,-2.543 l -7.77,-8.15 5.195,-9.99 c 0.673,-1.293 -0.689,-2.699 -2.003,-2.068 l -10.152,4.872 -7.895,-8.029 c -1.02,-1.038 -2.777,-0.177 -2.584,1.267 z"
       id="path10" />
    	<path
       fill="#ffe15a"
       d="m 28.102,348.906 -1.89,11.101 -11.114,1.805 c -1.439,0.234 -1.752,2.165 -0.461,2.841 l 9.973,5.227 -1.717,11.128 c -0.222,1.441 1.517,2.335 2.56,1.316 l 8.053,-7.87 10.054,5.073 c 1.302,0.657 2.69,-0.722 2.044,-2.028 l -4.996,-10.091 7.93,-7.993 c 1.026,-1.035 0.146,-2.781 -1.298,-2.57 l -11.142,1.633 -5.152,-10.013 c -0.667,-1.295 -2.601,-0.997 -2.844,0.441 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 202.734,239.555 -6.481,9.208 -10.81,-3.15 c -1.399,-0.408 -2.513,1.201 -1.639,2.367 l 6.755,9.009 -6.337,9.308 c -0.82,1.205 0.365,2.761 1.745,2.29 l 10.655,-3.64 6.894,8.903 c 0.893,1.153 2.739,0.505 2.717,-0.952 l -0.17,-11.258 10.598,-3.806 c 1.372,-0.493 1.327,-2.449 -0.066,-2.878 l -10.761,-3.318 -0.344,-11.255 c -0.042,-1.459 -1.917,-2.021 -2.756,-0.828 z"
       id="path12" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 132.414 V 0.001 h 370.759 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.875 -3.954,8.827 -8.829,8.827 z"
       id="path1" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="M 132.414,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 123.586 z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 412.053,302.189 c -40.632,36.196 -102.833,32.477 -138.956,-8.227 -36.054,-40.629 -32.405,-103.01 8.226,-139.204 0.06,-0.053 0.118,-0.105 0.178,-0.157 0.96,-0.844 0.032,-2.377 -1.16,-1.913 -40.07,15.604 -68.479,54.579 -68.479,100.214 0,59.444 48.071,107.587 107.373,107.587 41.023,0 76.574,-23.083 94.633,-56.969 0.602,-1.131 -0.81,-2.231 -1.766,-1.377 -0.015,0.015 -0.033,0.031 -0.049,0.046 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 359.787,172.59 14.12,15.841 19.56,-8.232 c 2.532,-1.066 4.964,1.705 3.578,4.077 l -10.703,18.325 13.873,16.058 c 1.796,2.079 -0.088,5.248 -2.772,4.663 l -20.735,-4.516 -10.986,18.156 c -1.422,2.35 -5.018,1.538 -5.292,-1.196 l -2.112,-21.116 -20.662,-4.838 c -2.675,-0.627 -3.014,-4.297 -0.498,-5.402 l 19.43,-8.533 -1.784,-21.145 c -0.231,-2.737 3.156,-4.192 4.983,-2.142 z"
       id="path4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="m 0,167.725 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.45 0,331.497 0,326.622 Z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const PM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const PN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs69" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path6" />
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 387.206,177.365 c -0.199,0 -0.402,-0.063 -0.575,-0.193 -0.138,-0.106 -13.838,-10.783 -5.769,-28.879 0.214,-0.48 0.777,-0.692 1.259,-0.482 0.48,0.216 0.695,0.777 0.482,1.259 -7.443,16.687 4.662,26.19 5.181,26.586 0.418,0.318 0.499,0.915 0.18,1.333 -0.188,0.246 -0.47,0.376 -0.758,0.376 z"
       id="path7" />
    	<path
       fill="#73af00"
       d="m 379.315,161.734 c -0.038,0 -0.074,-0.002 -0.111,-0.006 -0.523,-0.062 -0.896,-0.534 -0.836,-1.056 0.396,-3.422 1.683,-5.81 3.828,-7.096 3.449,-2.073 7.76,-0.417 7.941,-0.344 0.489,0.192 0.729,0.742 0.537,1.231 -0.192,0.49 -0.746,0.733 -1.231,0.541 -0.038,-0.014 -3.638,-1.382 -6.276,0.209 -1.604,0.969 -2.583,2.879 -2.905,5.679 -0.058,0.485 -0.471,0.842 -0.947,0.842 z"
       id="path8" />
    	<path
       fill="#73af00"
       d="m 381.902,149.46 c -0.082,-0.21 -2.141,-5.098 -11.447,-3.018 -10.539,2.361 -10.661,16.264 -10.661,16.403 0,0.478 0.355,0.884 0.831,0.945 0.041,0.006 0.082,0.008 0.121,0.008 0.428,0 0.811,-0.288 0.92,-0.711 3.928,-14.962 18.557,-12.449 19.178,-12.34 0.352,0.063 0.69,-0.067 0.907,-0.331 0.221,-0.268 0.28,-0.635 0.151,-0.956 z"
       id="path9" />
    	<path
       fill="#73af00"
       d="m 379.709,157.211 c 0,0 -6.348,-4.046 -8.967,1.111 -2.618,5.158 -0.634,10.712 0.397,12.933 0,0 3.784,-4.183 7.38,-4.761 4.444,-0.714 5.555,-6.269 2.46,-9.046 -3.698,-3.317 -1.27,-0.237 -1.27,-0.237 z"
       id="path10" />
    	<path
       fill="#73af00"
       d="m 386.644,147.731 c -0.09,5.554 3.005,6.282 3.005,6.282 2.001,-5.099 -3.005,-6.282 -3.005,-6.282 z"
       id="path11" />
    	<path
       fill="#73af00"
       d="m 385.675,159.397 c 0.042,-5.27 3.616,-5.863 3.616,-5.863 2.166,4.899 -3.616,5.863 -3.616,5.863 z"
       id="path12" />
    </g>
    <path
       fill="#ff4b55"
       d="m 406.291,66.871 c 0,0 -5.054,-0.747 -6.993,-1.663 -1.613,-0.761 -3.719,-2.599 -6.444,-2.24 -2.083,0 -3.772,1.688 -3.772,3.772 0,2.084 1.431,4.579 8.917,4.025 3.629,-0.269 6.721,1.389 6.721,1.389 -0.475,-1.983 1.571,-5.283 1.571,-5.283 z"
       id="path13" />
    <path
       fill="#ffe15a"
       d="m 401.046,68.525 c 0,0 -7.752,0.537 -9.454,-0.717 -1.571,-1.158 -1.161,-3.002 0.448,-3.181 2.42,-0.269 9.006,3.898 9.006,3.898 z"
       id="path14" />
    <path
       fill="#b49b91"
       d="m 416.13,77.305 -17.14,10.712 -1.964,-1.905 9.402,-9.106 2.201,0.893 2.143,-2.857 -5.118,-2.678 c 0,0 -13.569,12.794 -25.113,13.866 -3.884,0.361 -7.842,0.107 -10.929,-1.164 l -6.925,9.972 14.52,12.378 21.305,-0.833 17.615,-23.924 3.094,1.428 2.618,-3.094 z"
       id="path15" />
    <path
       fill="#9b8278"
       d="m 368.364,106.148 c -4.768,0 -8.648,-3.88 -8.648,-8.646 0,-4.768 3.88,-8.648 8.648,-8.648 4.767,0 8.645,3.88 8.645,8.648 0.002,4.767 -3.878,8.646 -8.645,8.646 z m 0,-14.437 c -3.193,0 -5.791,2.598 -5.791,5.791 0,3.193 2.598,5.79 5.791,5.79 3.193,0 5.79,-2.596 5.79,-5.79 0,-3.194 -2.596,-5.791 -5.79,-5.791 z"
       id="path16" />
    <g
       id="g18"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 404.386,202.439 c 0,0 1.587,-1.032 3.174,-5.871 l -3.253,0.476 c 0,0 0.634,-2.698 -0.079,-4.682 l -3.65,2.857 c 0,0 -1.666,-3.491 -2.38,-3.967 0,0 -2.539,3.571 -3.967,4.046 0,0 -1.428,-5.158 -2.857,-6.189 l -2.46,3.491 -3.65,-2.857 c 0,0 0,2.46 -0.079,3.016 -0.079,0.555 -4.761,-4.919 -4.761,-4.919 0,0 -2.063,0.873 -4.84,5.316 l -3.491,-3.571 -1.428,4.682 -4.84,-1.27 0.793,2.777 -4.205,-0.318 c 0,0 0.714,4.126 2.777,5.555 z"
       id="path17" />
    	<path
       fill="#73af00"
       d="m 362.332,220.094 c 0,0 -13.092,16.663 -37.849,14.759 l 26.899,3.69 13.806,-13.092 z"
       id="path18" />
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 319.603,232.353 c 2.618,1.905 18.806,6.547 30.469,0.952 0,0 0.238,2.738 -1.071,4.285 0,0 8.569,-3.452 13.212,-9.879 4.642,-6.428 -9.641,13.806 -9.641,13.806 l -21.9,4.046 -8.927,-7.38 z"
       id="path19" />
    	<path
       fill="#ffe15a"
       d="m 317.882,172.349 c -2.908,0.244 -6.053,1.995 -7.662,4.122 -0.876,-0.372 -2.823,-0.537 -4.436,0.537 -2.148,1.432 -6.118,6.604 -9.45,5.236 0,0 -0.298,4.879 4.879,4.702 0,0 -1.31,2.024 -1.071,5.237 0.238,3.213 -2.083,5.356 -2.083,5.356 0,0 10.474,1.487 10.891,-6.665 0.051,-0.996 0.102,-1.874 0.15,-2.657 5.466,2.952 7.617,-1.215 7.617,-1.215 0,0 -3.285,-3.103 0.058,-7.52 3.343,-4.418 12.533,5.996 12.533,5.996 0.18,-4.167 -0.194,-14.073 -11.426,-13.129 z"
       id="path20" />
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 358.364,199.82 c 0,0 -3.015,2.063 -12.378,0.159 0,0 2.063,-4.602 1.111,-7.3 0,0 -2.539,2.38 -8.728,4.761 -6.189,2.381 -13.806,9.998 -16.029,14.917 0,0 13.92,-32.088 2.738,-35.35 -3.836,-1.119 -7.135,0.695 -8.302,2.474 0.564,0.666 1.106,1.615 1.161,2.882 0.119,2.738 -2.618,21.186 -6.665,33.921 0,0 -1.191,-4.404 -3.094,-6.547 -1.903,-2.143 -3.332,-5.594 -3.332,-5.594 0,0 -3.213,2.143 -2.738,6.07 0,0 -1.785,-1.428 -5.237,-0.476 -3.452,0.952 -4.761,-1.31 -4.761,-1.31 0,0 -2.857,7.617 5.594,11.545 0,0 -2.261,1.071 -3.332,1.905 -1.071,0.833 -2.738,0.833 -2.738,0.833 0,0 2.976,5.475 9.283,6.07 6.308,0.595 9.207,2.393 11.188,5.633 6.428,10.514 18.727,18.488 38.802,6.189 0,0 -28.565,8.887 -29.835,-9.363 -1.111,-15.965 16.345,-19.202 18.091,-15.711 1.746,3.491 -0.159,6.507 -0.159,6.507 0,0 9.522,-2.221 4.919,-10.951 0,0.004 9.363,1.433 14.441,-11.264 z"
       id="path21" />
    	<path
       fill="#73af00"
       d="m 450.051,232.353 c -2.618,1.905 -19.162,9.046 -30.589,-2.38 -11.426,-11.426 -15.882,-28.581 -15.235,-26.661 h -11.426 l 3.809,34.279 42.372,7.975 8.927,-7.38 z"
       id="path22" />
    	<path
       fill="#73af00"
       d="m 451.773,172.349 c 2.908,0.244 6.053,1.995 7.662,4.122 0.876,-0.372 2.823,-0.537 4.436,0.537 2.148,1.432 6.117,6.604 9.45,5.236 0,0 0.298,4.879 -4.879,4.702 0,0 1.31,2.024 1.071,5.237 -0.238,3.213 2.083,5.356 2.083,5.356 0,0 -10.474,1.487 -10.891,-6.665 -0.051,-0.996 -0.102,-1.874 -0.15,-2.657 -5.466,2.952 -7.617,-1.215 -7.617,-1.215 0,0 3.284,-3.103 -0.059,-7.52 -3.343,-4.418 -12.533,5.996 -12.533,5.996 -0.179,-4.167 0.195,-14.073 11.427,-13.129 z"
       id="path23" />
    </g>
    <path
       fill="#ffe15a"
       d="m 411.29,111.544 c 0,0 3.015,2.063 12.378,0.159 0,0 -2.063,-4.602 -1.111,-7.3 0,0 2.539,2.38 8.728,4.761 6.189,2.381 13.806,9.998 16.029,14.917 0,0 -13.92,-32.088 -2.738,-35.35 3.836,-1.119 7.135,0.695 8.302,2.474 -0.564,0.666 -1.106,1.615 -1.161,2.882 -0.119,2.738 2.618,21.186 6.665,33.921 0,0 1.191,-4.404 3.094,-6.547 1.903,-2.143 3.332,-5.594 3.332,-5.594 0,0 3.213,2.143 2.738,6.07 0,0 1.785,-1.428 5.237,-0.476 3.452,0.952 4.761,-1.31 4.761,-1.31 0,0 2.857,7.617 -5.594,11.545 0,0 2.261,1.071 3.332,1.905 1.071,0.833 2.738,0.833 2.738,0.833 0,0 -2.976,5.475 -9.283,6.07 -6.308,0.595 -9.207,2.393 -11.188,5.633 -6.428,10.514 -18.727,18.488 -38.802,6.189 0,0 28.565,8.887 29.835,-9.363 1.111,-15.965 -16.345,-19.202 -18.091,-15.711 -1.746,3.491 0.159,6.507 0.159,6.507 0,0 -9.522,-2.221 -4.919,-10.951 0.001,0.004 -9.363,1.433 -14.441,-11.264 z"
       id="path24" />
    <g
       id="g26"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 403.196,226.482 c 4.682,6.824 11.188,13.013 30.073,18.884 18.885,5.871 23.933,6.744 33.829,14.749 0,0 1.88,1.985 2.6,5.167 0.845,3.738 -4.919,14.52 -4.919,14.52 0,0 0.555,-2.539 -2.936,-7.458 -3.491,-4.919 -24.122,-13.806 -34.913,-16.504 -10.792,-2.698 -29.439,-15.215 -24.28,-24.598 z"
       id="path25" />
    	<path
       fill="#73af00"
       d="m 467.081,260.086 c 0.008,0.01 0.011,0.02 0.019,0.03 -0.012,-0.013 -0.022,-0.026 -0.034,-0.039 z"
       id="path26" />
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 466.604,283.296 c 0,0 0.476,3.452 -2.38,6.428 -2.857,2.976 -4.879,5.118 -4.761,7.617 0,0 -4.285,-3.094 -3.571,-9.998 0,0 -5.594,4.642 -14.045,0.119 0,0 0.833,-8.45 11.784,-9.522 0,0 -4.285,-3.332 1.31,-8.45 0,0 0.65,2.289 5.713,3.452 4.404,1.012 12.239,-4.511 6.445,-12.824 9.979,11.275 4.861,19.011 -0.495,23.178 z"
       id="path27" />
    	<path
       fill="#ffe15a"
       d="m 399.11,220.213 c 0,0 2.413,3.945 8.689,7.776 7.538,4.602 8.213,6.744 8.213,6.744 l -5.118,-0.119 c 0,0 6.547,3.571 8.332,8.094 0,0 -2.738,0.476 -5.832,-0.358 0,0 2.499,2.261 1.31,9.522 h -12.736 z"
       id="path28" />
    </g>
    <path
       fill="#73af00"
       d="M 373.758,164.549 V 134.08 c 0,0 -10.342,17.693 -19.275,30.469 z"
       id="path29" />
    <path
       fill="#ffe15a"
       d="m 364.862,133.444 c -2.539,4.602 -10.474,19.758 -29.359,25.63 -18.885,5.871 -22.337,4.761 -32.234,12.765 0,0 -1.88,1.985 -2.6,5.167 -0.845,3.738 4.919,14.52 4.919,14.52 0,0 -0.555,-2.539 2.936,-7.458 3.491,-4.919 24.005,-14.324 34.913,-16.504 15.085,-3.016 28.733,-19.202 26.511,-29.676 -2.22,-10.474 -5.086,-4.444 -5.086,-4.444 z"
       id="path30" />
    <g
       id="g32"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 303.288,260.086 c -0.008,0.01 -0.011,0.02 -0.019,0.03 0.012,-0.013 0.022,-0.026 0.034,-0.039 z"
       id="path31" />
    	<path
       fill="#73af00"
       d="m 303.764,283.296 c 0,0 -0.476,3.452 2.38,6.428 2.857,2.976 4.879,5.118 4.761,7.617 0,0 4.285,-3.094 3.571,-9.998 0,0 5.594,4.642 14.045,0.119 0,0 -0.833,-8.45 -11.784,-9.522 0,0 4.285,-3.332 -1.309,-8.45 0,0 -0.65,2.289 -5.713,3.452 -4.404,1.012 -12.239,-4.511 -6.445,-12.824 -9.98,11.275 -4.862,19.011 0.494,23.178 z"
       id="path32" />
    </g>
    <path
       fill="#ffe15a"
       d="m 330.117,245.802 c 0,0 2.698,12.14 2.857,24.677 0,0 11.823,0.397 17.536,-8.49 0,0 -11.426,-5.951 -17.536,-17.457 z"
       id="path33" />
    <path
       fill="#73af00"
       d="m 327.578,218.982 c -0.476,-5.713 2.063,-20.154 13.647,-30.628 l 0.284,-12.826 c 0,0 -3.451,0.359 -6.511,3.038 l -6.547,10.145 -6.07,22.972 z"
       id="path34" />
    <path
       fill="#ffe15a"
       d="m 327.894,223.108 c 0,0 0,12.22 5.078,21.424 l -2.857,1.269 c 0,0 -10.236,-8.054 -12.378,-24.598 0,0 -9.165,6.07 -12.537,-6.348 0,0 9.839,3.968 13.013,-5.078 2.863,-8.162 5.758,-23.02 16.783,-31.212 -5.241,8.055 -13.133,28.673 -7.023,35.973 1.618,1.933 6.269,3.571 11.359,1.397 -0.331,4.061 -2.268,10.266 -11.438,7.173 z"
       id="path35" />
    <path
       fill="#ffce5a"
       d="m 329.377,247.969 -1.672,-3.072 c -0.292,-0.537 -0.094,-1.21 0.444,-1.503 l 3.051,-1.658 c 0.537,-0.292 1.209,-0.094 1.502,0.444 l 1.672,3.072 c 0.292,0.537 0.094,1.21 -0.444,1.503 l -3.051,1.658 c -0.537,0.292 -1.209,0.094 -1.502,-0.444 z"
       id="path36" />
    <g
       id="g38"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 432.635,334.078 c 0,0 -2.698,12.14 -2.857,24.677 0,0 -11.823,0.397 -17.536,-8.49 0,0 11.426,-5.951 17.536,-17.457 z"
       id="path37" />
    	<path
       fill="#ffe15a"
       d="m 435.174,307.258 c 0.476,-5.713 -2.063,-20.154 -13.647,-30.628 l -0.284,-12.826 c 0,0 3.451,0.359 6.511,3.038 l 6.547,10.145 6.07,22.972 z"
       id="path38" />
    </g>
    <path
       fill="#73af00"
       d="m 423.419,215.936 c 5.09,2.174 9.741,0.536 11.359,-1.397 6.11,-7.3 -1.782,-27.918 -7.023,-35.973 11.026,8.192 13.919,23.05 16.783,31.212 3.174,9.046 13.013,5.078 13.013,5.078 -3.372,12.418 -12.537,6.348 -12.537,6.348 -2.143,16.544 -12.378,24.598 -12.378,24.598 l -2.857,-1.269 c 5.078,-9.205 5.078,-21.425 5.078,-21.425 -9.17,3.093 -11.106,-3.112 -11.438,-7.172 z"
       id="path39" />
    <path
       fill="#ffce5a"
       d="m 433.374,247.969 1.672,-3.072 c 0.292,-0.537 0.094,-1.21 -0.444,-1.503 l -3.051,-1.658 c -0.537,-0.292 -1.209,-0.094 -1.502,0.444 l -1.672,3.072 c -0.292,0.537 -0.094,1.21 0.444,1.503 l 3.051,1.658 c 0.538,0.292 1.21,0.094 1.502,-0.444 z"
       id="path40" />
    <path
       fill="#4173cd"
       d="m 343.289,160.74 c -2.103,0 -3.809,1.705 -3.809,3.809 v 41.896 c 0,11.426 3.809,53.322 41.896,68.557 38.088,-15.235 41.896,-57.131 41.896,-68.557 v -41.896 c 0,-2.103 -1.705,-3.809 -3.809,-3.809 z"
       id="path41" />
    <path
       fill="#ffe15a"
       d="m 379.067,160.74 -36.121,69.231 c 0.904,3.202 2.031,6.516 3.446,9.864 l 34.984,-67.053 34.984,67.053 c 1.415,-3.349 2.542,-6.663 3.446,-9.864 L 383.685,160.74 Z"
       id="path42" />
    <path
       fill="#73af00"
       d="m 416.359,239.836 -34.984,-67.053 -34.984,67.053 v 0 c 5.762,13.639 16.188,27.649 34.984,35.167 18.796,-7.519 29.223,-21.529 34.984,-35.167 z"
       id="path43" />
    <path
       fill="#ffe15a"
       d="m 395.539,244.175 2.304,1.105 c -0.966,1.428 -2.977,3.738 -6.823,5.831 -2.905,1.581 -5.713,3.452 -7.741,4.885 v -31.433 l 9.522,-0.979 v -3.809 l -9.522,-0.979 v -4.734 c 0,-1.052 -0.853,-1.905 -1.905,-1.905 -0.897,0 -1.614,0.633 -1.816,1.469 -0.633,-0.454 -1.367,-0.777 -2.202,-0.777 -2.131,0 -3.866,1.735 -3.866,3.866 0,1.003 0.407,1.9 1.037,2.589 l -4.578,0.471 v 3.809 l 9.522,0.979 v 31.433 c -2.027,-1.433 -4.835,-3.305 -7.741,-4.885 -3.847,-2.092 -5.857,-4.403 -6.823,-5.831 l 2.304,-1.105 -8.689,-11.069 v 15.235 l 2.929,-1.405 c 1.159,1.867 3.608,4.881 8.46,7.519 4.059,2.209 7.998,5.079 9.559,6.254 l 1.905,1.476 1.905,-1.476 c 1.561,-1.175 5.501,-4.045 9.559,-6.254 4.852,-2.638 7.301,-5.652 8.46,-7.519 l 2.929,1.405 v -15.235 z m -18.183,-25.496 c -1.082,0 -1.962,-0.879 -1.962,-1.962 0,-1.082 0.879,-1.962 1.962,-1.962 1.082,0 1.962,0.879 1.962,1.962 0,1.083 -0.879,1.962 -1.962,1.962 z"
       id="path44" />
    <path
       fill="#f5f5f5"
       d="m 384.318,210.254 h -5.885 c -1.53,0 -2.771,-1.24 -2.771,-2.771 v -9.694 c 0,-1.53 1.24,-2.771 2.771,-2.771 h 5.885 c 1.53,0 2.771,1.24 2.771,2.771 v 9.694 c 0,1.531 -1.24,2.771 -2.771,2.771 z"
       id="path45" />
    <path
       fill="#b49b91"
       d="m 408.037,160.74 c -7.617,-11.426 -7.617,-34.279 -7.617,-34.279 0,0 0,-15.235 -19.043,-15.235 -9.647,0 -14.398,3.91 -16.746,7.767 -9.14,3.672 -13.724,11.276 -13.724,11.276 3.896,1.949 7.339,2.877 10.463,3.115 6.209,7.389 8.275,14.524 8.824,19.656 -3.576,3.652 -5.559,12.46 -0.243,19.125 0,0 11.267,-2.618 20.779,-11.426 h 17.306 v 0.001 z"
       id="path46" />
    <g
       id="g49"
       transform="translate(0,-88.276)">
    	<path
       fill="#9b8278"
       d="m 390.728,249.016 h 14.215 c -0.715,-7.022 -7.619,-5.891 -14.215,0 z"
       id="path47" />
    	<path
       fill="#9b8278"
       d="m 404.588,241.826 c -4.163,-11.818 -4.169,-27.088 -4.169,-27.088 0,0 -10e-4,-0.248 -0.04,-0.675 -4.959,-0.673 -10.035,-0.308 -19.956,3.532 -10.563,4.088 -15.734,4.205 -19.055,4.067 6.209,7.389 8.275,14.524 8.824,19.656 l 0.153,8.096 c 0,0 5.951,0.873 19.043,-6.666 6.532,-3.76 12.068,-4.082 15.2,-0.922 z"
       id="path48" />
    	<path
       fill="#9b8278"
       d="m 384.311,213.072 c 7.725,-1.931 12.654,-1.732 15.83,-0.605 -0.851,-4.243 -4.349,-12.964 -18.765,-12.964 -9.647,0 -14.398,3.91 -16.746,7.767 l -5.789,8.103 c 0,0 7.24,2.256 25.47,-2.301 z"
       id="path49" />
    </g>
    <path
       fill="#ffe15a"
       d="m 368.789,109.561 c 0.75,0.748 2.988,6.144 2.527,6.946 -0.297,0.515 -6.257,1.997 -7.223,1.241 -0.862,-0.674 -1.87,-6.486 -1.293,-7.157 0.523,-0.606 5.363,-1.654 5.989,-1.03 z"
       id="path50" />
    <path
       fill="#73af00"
       d="m 376.453,109.273 c 0.692,0.793 2.26,6.068 1.639,6.741 -0.399,0.433 -7.042,0.957 -7.965,0.127 -0.822,-0.74 -1.004,-6.227 -0.278,-6.761 0.656,-0.485 6.027,-0.769 6.604,-0.107 z"
       id="path51" />
    <path
       fill="#ffe15a"
       d="m 383.706,109.073 c 0.717,0.747 2.353,5.707 1.711,6.337 -0.413,0.405 -7.284,0.882 -8.241,0.099 -0.853,-0.698 -1.054,-5.852 -0.305,-6.353 0.681,-0.453 6.237,-0.706 6.835,-0.083 z"
       id="path52" />
    <g
       id="g54"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 391.077,197.694 c 0.635,0.815 1.831,6.019 1.165,6.623 -0.428,0.387 -7.09,0.405 -7.951,-0.465 -0.768,-0.776 -0.568,-6.08 0.193,-6.542 0.687,-0.418 6.063,-0.297 6.593,0.384 z"
       id="path53" />
    	<path
       fill="#73af00"
       d="m 406.289,200.848 c 0.491,0.909 0.444,5.743 -0.313,6.228 -0.487,0.311 -6.485,-0.758 -7.191,-1.758 -0.63,-0.892 0.444,-6.09 1.271,-6.421 0.746,-0.299 5.823,1.191 6.233,1.951 z"
       id="path54" />
    </g>
    <path
       fill="#ffe15a"
       d="m 399.298,110.51 c 0.601,0.828 1.059,5.681 0.334,6.194 -0.466,0.33 -7.33,-0.234 -8.162,-1.131 -0.743,-0.801 -0.2,-5.803 0.613,-6.175 0.738,-0.338 6.713,0.422 7.215,1.112 z"
       id="path55" />
    <circle
       fill="#9b8278"
       cx="368.35999"
       cy="97.503998"
       r="2.5899999"
       id="circle55" />
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g58"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g59"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g60"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g61"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g62"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g63"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g64"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g65"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g66"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g67"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g68"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g69"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#ff4b55"
       d="M 512,67.091 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <rect
       y="67.095001"
       fill="#f5f5f5"
       width="512"
       height="67.089996"
       id="rect1"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<rect
       y="222.461"
       fill="#ff4b55"
       width="512"
       height="67.089996"
       id="rect2"
       x="0" />
    	<path
       fill="#ff4b55"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 v -58.262 h 512 v 58.262 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="201.27499"
       fill="#f5f5f5"
       width="512"
       height="67.089996"
       id="rect3"
       x="0" />
    <path
       fill="#41479b"
       d="M 3.256,333.315 247.597,173.229 c 3.966,-2.599 3.966,-8.412 0,-11.009 L 3.256,2.135 C 1.311,3.754 0,6.1 0,8.828 v 317.793 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path3" />
    <path
       fill="#f5f5f5"
       d="m 90.183,126.751 9.213,27.623 29.118,0.226 c 3.769,0.029 5.333,4.84 2.301,7.08 l -23.424,17.298 8.783,27.763 c 1.138,3.594 -2.955,6.568 -6.023,4.375 l -23.69,-16.932 -23.69,16.932 c -3.066,2.193 -7.159,-0.781 -6.023,-4.375 L 65.531,178.978 42.107,161.68 c -3.032,-2.24 -1.47,-7.05 2.301,-7.08 l 29.118,-0.226 9.213,-27.623 c 1.193,-3.577 6.251,-3.577 7.444,0 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#464655"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#ff4b55"
       d="M 3.256,333.315 206.097,172.3 c 2.946,-2.338 2.946,-6.812 0,-9.151 L 3.256,2.135 C 1.311,3.754 0,6.1 0,8.828 v 317.793 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs29" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 185.379,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 v 317.793 c 0,4.875 3.953,8.828 8.828,8.828 H 185.38 V 0.001 Z"
       id="path2" />
    <circle
       fill="#ffe15a"
       cx="185.45"
       cy="167.72501"
       r="79.379997"
       id="circle2" />
    <path
       fill="#ff4b55"
       d="m 211.932,141.242 v 35.31 c 0,14.603 -11.88,26.483 -26.483,26.483 -14.603,0 -26.483,-11.88 -26.483,-26.483 v -35.31 h 52.966 m 8.827,-17.655 h -70.621 c -4.875,0 -8.828,3.953 -8.828,8.828 v 44.138 c 0,24.376 19.762,44.138 44.138,44.138 24.376,0 44.138,-19.762 44.138,-44.138 v -44.138 c 10e-4,-4.875 -3.952,-8.828 -8.827,-8.828 z"
       id="path3" />
    <path
       fill="#f5f5f5"
       d="m 211.932,141.242 v 35.31 c 0,14.603 -11.88,26.483 -26.483,26.483 -14.603,0 -26.483,-11.88 -26.483,-26.483 v -35.31 h 52.966"
       id="path4" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    	<circle
       fill="#ffe15a"
       cx="150.07001"
       cy="220.69099"
       r="4.414"
       id="circle4" />
    	<circle
       fill="#ffe15a"
       cx="220.69"
       cy="220.69099"
       r="4.414"
       id="circle5" />
    	<circle
       fill="#ffe15a"
       cx="150.07001"
       cy="256.00101"
       r="4.414"
       id="circle6" />
    	<circle
       fill="#ffe15a"
       cx="220.69"
       cy="256.00101"
       r="4.414"
       id="circle7" />
    	<circle
       fill="#ffe15a"
       cx="185.38"
       cy="220.69099"
       r="4.414"
       id="circle8" />
    	<circle
       fill="#ffe15a"
       cx="211.88"
       cy="288.55099"
       r="4.414"
       id="circle9" />
    	<circle
       fill="#ffe15a"
       cx="159.39999"
       cy="288.55099"
       r="4.414"
       id="circle10" />
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 191.149,253.763 v 7.602 c 0,3.144 -2.558,5.702 -5.702,5.702 -3.144,0 -5.702,-2.558 -5.702,-5.702 v -7.602 h 11.404"
       id="path10" />
    	<path
       fill="#41479b"
       d="m 191.149,235.741 v 7.602 c 0,3.144 -2.558,5.702 -5.702,5.702 -3.144,0 -5.702,-2.558 -5.702,-5.702 v -7.602 h 11.404"
       id="path11" />
    	<path
       fill="#41479b"
       d="m 191.149,271.97 v 7.602 c 0,3.144 -2.558,5.702 -5.702,5.702 -3.144,0 -5.702,-2.558 -5.702,-5.702 v -7.602 h 11.404"
       id="path12" />
    	<path
       fill="#41479b"
       d="m 206.506,253.763 v 7.602 c 0,3.144 -2.558,5.702 -5.702,5.702 -3.144,0 -5.702,-2.558 -5.702,-5.702 v -7.602 h 11.404"
       id="path13" />
    	<path
       fill="#41479b"
       d="m 175.794,253.763 v 7.602 c 0,3.144 -2.558,5.702 -5.702,5.702 -3.144,0 -5.702,-2.558 -5.702,-5.702 v -7.602 h 11.404"
       id="path14" />
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs15" />
    <path
       fill="#3cc8ff"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <circle
       fill="#ffe15a"
       cx="256"
       cy="167.724"
       r="105.93"
       id="circle1" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const PY = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#ff4b55"
       d="m 256,123.587 c -24.376,0 -44.138,19.761 -44.138,44.138 0,24.377 19.762,44.138 44.138,44.138 24.376,0 44.138,-19.761 44.138,-44.138 0,-24.377 -19.762,-44.138 -44.138,-44.138 z m 0,77.426 c -18.383,0 -33.288,-14.903 -33.288,-33.288 0,-18.385 14.904,-33.288 33.288,-33.288 18.384,0 33.288,14.904 33.288,33.288 0,18.384 -14.905,33.288 -33.288,33.288 z"
       id="path3" />
    <circle
       fill="#41479b"
       cx="256"
       cy="167.72501"
       r="15.31"
       id="circle3" />
    <path
       fill="#ffe15a"
       d="m 256.998,156.128 2.467,7.4 7.799,0.061 c 1.01,0.008 1.429,1.297 0.616,1.897 l -6.274,4.633 2.353,7.436 c 0.305,0.963 -0.791,1.759 -1.613,1.172 l -6.346,-4.535 -6.346,4.535 c -0.822,0.587 -1.918,-0.21 -1.613,-1.172 l 2.353,-7.436 -6.274,-4.633 c -0.812,-0.6 -0.394,-1.889 0.616,-1.897 l 7.799,-0.061 2.467,-7.4 c 0.32,-0.958 1.676,-0.958 1.996,0 z"
       id="path4" />
    <path
       fill="#64c86e"
       d="m 284.96,168.081 c 0,0 0.875,-4.046 -3.43,0.809 0,0 0.063,-1.382 -0.059,-2.521 0.947,-1.025 2.121,-3.267 1.845,-8.052 0,0 -0.675,-4.084 -2.891,2.013 0,0 -0.605,-1.799 -1.248,-2.795 0.534,-1.108 0.947,-3.125 -0.334,-6.947 0,0 -1.497,-3.27 -1.963,2.348 0,0 -1.229,-1.838 -2.028,-2.29 0.154,-0.906 0.033,-2.462 -1.775,-4.981 0,0 -1.804,-2.02 -0.893,2.126 0,0 -1.651,-1.337 -2.179,-1.18 -0.274,-0.792 -1.067,-2.131 -3.73,-3.893 0,0 -2.307,-1.263 0.34,2.034 0,0 -2.34,-0.928 -2.312,-0.396 0.028,0.532 1.159,1.513 2.088,1.951 0,0 -3.432,0.356 -2.023,1.121 0,0 3.481,1.201 5.572,0.045 0.168,0.609 0.509,1.292 1.015,1.783 0,0 -4.084,-0.793 -2.978,0.433 0,0 3.063,2.251 6.09,1.906 -0.014,0.834 0.238,1.911 0.681,2.718 0,0 -4.87,-2.603 -3.947,-0.616 0,0 2.912,3.895 6.786,4.74 -0.159,0.866 -0.156,1.913 0.054,2.78 0,0 -4.622,-4.365 -4.199,-1.878 0,0 1.932,5.122 5.848,7.298 -0.319,0.65 -0.58,1.377 -0.676,2.056 0,0 -2.692,-5.761 -3.213,-3.292 0,0 -0.089,5.754 2.983,9.195 -0.654,0.544 -1.295,1.305 -1.688,2.052 0,0 -0.589,-6.329 -1.913,-4.182 0,0 -1.83,4.796 -0.591,8.929 -0.819,0.242 -1.711,0.689 -2.371,1.224 0,0 1.953,-6.051 -0.11,-4.599 0,0 -3.674,3.975 -3.955,8.447 -0.974,-0.02 -2.293,0.331 -3.249,0.902 0,0 2.795,-5.709 0.545,-4.567 0,0 -4.008,3.274 -5.043,7.523 -0.948,0.541 -2.558,1.46 -4.167,2.372 -0.936,-0.543 -1.845,-1.071 -2.622,-1.525 l 0.026,-0.042 -9.111,-7.638 0.181,2.498 -4.575,-8.182 -0.565,2.784 -1.498,-9.045 -1.329,1.335 0.514,-8.438 -1.732,0.934 3.146,-6.276 -1.478,0.417 3.887,-3.726 -2.055,0.175 4.914,-2.231 -1.796,-0.276 4.797,-2.429 -2.067,-0.1 6.219,-2.152 -1.139,-0.996 5.383,-1.588 -6.45,-0.492 1.837,-2.261 -4.921,2.518 0.706,-3.404 -4.305,4.433 0.748,-3.104 -4.029,4.009 0.26,-3.026 -3.983,6.746 -0.514,-3.019 -3.31,7.574 -0.911,-3.3 -1.478,9.393 -1.233,-1.398 1.621,9.06 -2.056,-1.542 3.769,8.138 c 0,0 -2.741,-1.199 -3.084,-1.199 -0.343,0 6.553,7.004 6.553,7.004 l -3.598,-0.385 6.952,4.888 -2.583,0.638 5.783,2.248 -1.414,1.094 11.972,0.856 c 0,0 1.154,0.961 2.724,2.074 -0.829,0.468 -1.558,0.875 -2.009,1.122 -0.455,0.248 -0.989,0.273 -1.468,0.073 -1.137,-0.477 -2.781,-1.149 -3.574,-1.466 0,0 0.077,3.403 3.62,3.488 1.455,0.033 3.439,-0.893 5.284,-1.988 1.889,1.178 3.974,2.217 5.48,2.181 3.466,-0.085 3.542,-3.488 3.542,-3.488 -0.776,0.318 -2.386,0.99 -3.497,1.466 -0.469,0.2 -0.991,0.175 -1.436,-0.073 -0.491,-0.275 -1.299,-0.736 -2.225,-1.271 0.946,-0.641 1.739,-1.223 2.296,-1.652 0.872,0.685 3.368,1.889 8.946,-0.205 0,0 3.7,-1.858 -2.781,-2.163 0,0 1.203,-0.883 2.015,-1.721 1.063,0.547 3.69,1.195 8.684,-1.547 0,0 3.398,-2.367 -3.06,-1.745 0,0 0.862,-0.84 1.54,-1.694 1.114,0.125 3.865,-0.173 7.513,-4.839 0,0 2.19,-3.513 -3.5,-0.397 0,0 0.736,-1.754 0.909,-2.927 1.262,-0.608 3.179,-2.26 4.683,-6.812 z"
       id="path5" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const QA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#f5f5f5"
       d="M 238.345,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 229.517 z"
       id="path1" />
    <path
       fill="#873250"
       d="m 503.172,0.001 h -335.8 c 0.233,0 0.465,0.034 0.689,0.104 l 53.386,16.312 c 2.223,0.679 2.222,3.828 -0.002,4.505 L 175.11,35.03 c -2.225,0.678 -2.226,3.826 -0.002,4.505 l 46.34,14.162 c 2.223,0.679 2.222,3.828 -0.002,4.504 L 175.11,72.31 c -2.225,0.678 -2.226,3.826 -0.002,4.505 l 46.34,14.162 c 2.223,0.679 2.222,3.828 -0.002,4.504 l -46.322,14.103 c -2.226,0.679 -2.226,3.829 0,4.506 l 46.322,14.103 c 2.225,0.678 2.226,3.826 0.002,4.505 l -46.34,14.162 c -2.223,0.68 -2.222,3.829 0.002,4.505 l 46.336,14.108 c 2.225,0.676 2.226,3.826 0.002,4.505 l -46.34,14.162 c -2.223,0.68 -2.222,3.828 0.002,4.505 l 46.336,14.108 c 2.225,0.676 2.226,3.826 0.002,4.504 l -46.34,14.162 c -2.223,0.68 -2.222,3.829 0.002,4.505 l 46.335,14.109 c 2.225,0.676 2.226,3.826 0.002,4.504 l -46.339,14.161 c -2.223,0.68 -2.222,3.828 0.002,4.505 l 46.322,14.105 c 2.226,0.676 2.226,3.828 0,4.504 l -46.322,14.105 c -2.225,0.676 -2.226,3.826 -0.002,4.504 l 46.34,14.162 c 2.223,0.679 2.222,3.828 -0.002,4.504 l -53.386,16.255 c -0.222,0.068 -0.454,0.103 -0.686,0.103 h 335.799 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 512,3.953 508.047,0.001 503.172,0.001 Z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const RE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const RO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#ffe15a"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const RS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs36" />
    <path
       fill="#f5f5f5"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#41479b"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <polygon
       fill="#ffe15a"
       points="106.814,184.18 175.669,184.18 173.021,200.07 109.462,200.07 "
       id="polygon2"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffd350"
       points="173.021,200.07 173.683,196.097 108.8,196.097 109.462,200.07 "
       id="polygon3"
       transform="translate(0,-88.276)" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<rect
       x="139.92"
       y="147.10001"
       fill="#ffe15a"
       width="2.648"
       height="10.593"
       id="rect3" />
    	<rect
       x="137.27"
       y="149.75"
       fill="#ffe15a"
       width="7.9450002"
       height="2.648"
       id="rect4" />
    	<path
       fill="#ffe15a"
       d="m 173.228,189.476 c -0.3,0 -0.604,-0.052 -0.903,-0.158 -1.375,-0.499 -2.086,-2.017 -1.587,-3.393 l 5.61,-15.481 c 0.278,-0.768 0.212,-1.613 -0.18,-2.319 -0.209,-0.375 -0.695,-1.035 -1.624,-1.234 -6.839,-1.453 -20.096,-3.897 -32.023,-3.897 h -2.558 c -11.927,0 -25.184,2.444 -32.026,3.9 -0.926,0.196 -1.414,0.856 -1.622,1.231 -0.392,0.706 -0.458,1.551 -0.179,2.319 l 5.608,15.481 c 0.499,1.376 -0.212,2.894 -1.587,3.393 -1.374,0.491 -2.895,-0.215 -3.392,-1.588 l -5.61,-15.481 c -0.8,-2.209 -0.609,-4.648 0.526,-6.694 1.097,-1.978 2.973,-3.38 5.149,-3.843 7.047,-1.5 20.718,-4.017 33.131,-4.017 h 2.558 c 12.413,0 26.084,2.516 33.128,4.013 2.179,0.466 4.055,1.867 5.152,3.846 1.135,2.046 1.326,4.484 0.527,6.694 l -5.611,15.481 c -0.387,1.078 -1.405,1.747 -2.487,1.747 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 141.251,187.159 c -1.462,0 -2.648,-1.184 -2.648,-2.648 v -21.517 c 0,-1.464 1.186,-2.648 2.648,-2.648 1.462,0 2.648,1.184 2.648,2.648 v 21.517 c 0.001,1.463 -1.185,2.648 -2.648,2.648 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="m 159.559,189.476 c -0.179,0 -0.36,-0.018 -0.541,-0.054 -1.432,-0.298 -2.353,-1.699 -2.055,-3.132 l 3.212,-15.481 c 0.418,-2.017 -0.236,-3.784 -0.608,-4.094 -3.672,-1.347 -11.039,-3.722 -17.594,-3.722 h -1.465 c -6.554,0 -13.921,2.375 -17.73,3.791 -0.235,0.241 -0.889,2.007 -0.472,4.024 l 3.212,15.481 c 0.298,1.432 -0.622,2.835 -2.055,3.132 -1.434,0.277 -2.836,-0.623 -3.13,-2.056 l -3.212,-15.481 c -0.8,-3.859 0.428,-8.801 3.808,-10.063 5.063,-1.882 12.565,-4.125 19.578,-4.125 h 1.465 c 7.014,0 14.516,2.242 19.576,4.122 3.383,1.265 4.611,6.207 3.811,10.066 l -3.212,15.481 c -0.258,1.253 -1.36,2.111 -2.588,2.111 z"
       id="path6" />
    </g>
    <polygon
       fill="#ffd350"
       points="175.669,184.18 106.814,184.18 107.476,188.152 175.007,188.152 "
       id="polygon6"
       transform="translate(0,-88.276)" />
    <path
       fill="#ff4b55"
       d="m 90.924,111.794 c -1.462,0 -2.648,1.186 -2.648,2.648 v 92.486 c 0,29.365 23.713,53.17 52.966,53.17 29.253,0 52.966,-23.805 52.966,-53.17 v -92.486 c 0,-1.462 -1.186,-2.648 -2.648,-2.648 z"
       id="path7" />
    <path
       fill="#f5f5f5"
       d="m 146.538,199.188 5.297,-13.241 -10.593,2.648 -10.593,-2.648 5.297,13.241 -13.241,45.021 c 0,0 7.945,5.297 18.538,5.297 10.593,0 18.538,-5.297 18.538,-5.297 z"
       id="path8" />
    <polygon
       fill="#ffe15a"
       points="127.667,280.803 123.037,278.232 110.552,300.704 98.869,300.704 98.869,306.001 104.559,306.001 97.215,311.876 100.523,316.014 106.762,311.022 104.301,318.404 109.326,320.079 114.163,305.568 123.346,303.272 122.061,298.135 117.388,299.304 "
       id="polygon8"
       transform="translate(0,-88.276)" />
    <path
       fill="#f5f5f5"
       d="m 122.703,138.276 -12.089,-6.045 c -2.22,-1.11 -3.372,-3.614 -2.77,-6.022 l 0.684,-2.735 c 0.474,-1.898 -0.961,-3.736 -2.918,-3.736 -0.914,0 -1.778,0.415 -2.348,1.129 -6.273,7.841 -9.69,17.583 -9.69,27.625 v 55.991 c 0,0 11.059,-2.211 21.048,-16.742 1.834,-2.668 4.853,-4.247 8.072,-4.412 l -5.286,15.857 10.594,2.649 9.269,-11.03 z"
       id="path9" />
    <polygon
       fill="#ffe15a"
       points="154.816,280.803 159.446,278.232 171.93,300.704 183.614,300.704 183.614,306.001 177.923,306.001 185.268,311.876 181.96,316.014 175.721,311.022 178.182,318.404 173.156,320.079 168.32,305.568 159.137,303.272 160.422,298.135 165.095,299.304 "
       id="polygon9"
       transform="translate(0,-88.276)" />
    <path
       fill="#f5f5f5"
       d="m 159.779,138.276 12.089,-6.045 c 2.22,-1.11 3.372,-3.614 2.77,-6.022 l -0.684,-2.735 c -0.474,-1.898 0.961,-3.736 2.918,-3.736 0.914,0 1.778,0.415 2.348,1.129 6.273,7.841 9.69,17.583 9.69,27.625 v 55.991 c 0,0 -11.059,-2.211 -21.048,-16.742 -1.834,-2.668 -4.853,-4.247 -8.072,-4.412 l 5.286,15.857 -10.593,2.648 -9.269,-11.03 z"
       id="path10" />
    <g
       id="g11"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ffe15a"
       points="116.083,213.311 125.352,215.959 120.055,218.607 128,218.607 125.352,208.014 112.11,208.014 "
       id="polygon10" />
    	<polygon
       fill="#ffe15a"
       points="166.4,213.311 157.131,215.959 162.428,218.607 154.483,218.607 157.131,208.014 170.372,208.014 "
       id="polygon11" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 158.996,117.662 -12.458,2.076 -5.297,10.593 -5.297,-10.593 -12.458,-2.076 c -1.428,-0.238 -2.524,1.245 -1.876,2.54 l 6.39,12.778 -5.297,5.297 h 18.538 18.538 l -5.297,-5.297 6.389,-12.778 c 0.648,-1.296 -0.447,-2.779 -1.875,-2.54 z"
       id="path11" />
    <circle
       fill="#ffbe50"
       cx="141.24001"
       cy="97.063995"
       r="3.9719999"
       id="circle11" />
    <ellipse
       fill="#41479b"
       cx="141.19"
       cy="106.54401"
       rx="3.1389999"
       ry="2.207"
       id="ellipse11" />
    <ellipse
       fill="#ff4b55"
       cx="125.52"
       cy="106.54401"
       rx="3.1389999"
       ry="2.207"
       id="ellipse12" />
    <g
       id="g14"
       transform="translate(0,-88.276)">
    	<ellipse
       fill="#41479b"
       cx="109.85"
       cy="194.82001"
       rx="3.1389999"
       ry="2.207"
       id="ellipse13" />
    	<ellipse
       fill="#41479b"
       cx="172.52"
       cy="194.82001"
       rx="3.1389999"
       ry="2.207"
       id="ellipse14" />
    </g>
    <ellipse
       fill="#ff4b55"
       cx="156.85001"
       cy="106.54401"
       rx="3.1389999"
       ry="2.207"
       id="ellipse15" />
    <g
       id="g18"
       transform="translate(0,-88.276)">
    	<circle
       fill="#ffbe50"
       cx="159.64999"
       cy="185.34"
       r="3.9719999"
       id="circle15" />
    	<circle
       fill="#ffbe50"
       cx="174.17"
       cy="185.34"
       r="3.9719999"
       id="circle16" />
    	<circle
       fill="#ffbe50"
       cx="122.86"
       cy="185.34"
       r="3.9719999"
       id="circle17" />
    	<circle
       fill="#ffbe50"
       cx="108.33"
       cy="185.34"
       r="3.9719999"
       id="circle18" />
    </g>
    <path
       fill="#41479b"
       d="m 145.803,74.718 c 0.455,-0.781 0.735,-1.678 0.735,-2.648 0,-2.925 -2.371,-5.297 -5.297,-5.297 -2.926,0 -5.297,2.371 -5.297,5.297 0,0.97 0.279,1.867 0.735,2.648 z"
       id="path18" />
    <path
       fill="#ff4b55"
       d="m 141.241,192.566 c -10.953,0 -19.862,-8.909 -19.862,-19.862 v -35.752 h 39.724 v 35.752 c 0,10.954 -8.909,19.862 -19.862,19.862 z"
       id="path19" />
    <path
       fill="#a54b50"
       d="m 159.779,138.276 v 34.428 c 0,10.238 -8.3,18.538 -18.538,18.538 -10.238,0 -18.538,-8.3 -18.538,-18.538 v -34.428 h 37.076 m 2.649,-2.648 h -2.648 -37.076 -2.648 v 2.648 34.428 c 0,11.682 9.504,21.186 21.186,21.186 11.682,0 21.186,-9.504 21.186,-21.186 v -34.428 z"
       id="path20" />
    <g
       id="g21"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 137.269,279.08 c 1.281,0.28 2.607,0.437 3.972,0.437 1.365,0 2.691,-0.158 3.972,-0.437 v -52.529 h -7.945 c 0.001,0 0.001,52.529 0.001,52.529 z"
       id="path21" />
    	<rect
       x="122.7"
       y="248.39999"
       fill="#f5f5f5"
       width="37.080002"
       height="7.9450002"
       id="rect21" />
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const RU = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#f5f5f5"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#41479b"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const RW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs19" />
    <g
       id="g2"
       transform="translate(0,-88.275)">
    	<path
       fill="#4173cd"
       d="M 512,256 H 0 V 97.103 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#4173cd"
       d="m 0,256 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,423.725 0,419.772 0,414.897 Z"
       id="path2" />
    </g>
    <rect
       y="167.72501"
       fill="#ffe15a"
       width="512"
       height="83.860001"
       id="rect2"
       x="0" />
    <path
       fill="#73af00"
       d="m 8.828,335.449 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 251.587 H 0 v 75.034 c 0,4.876 3.953,8.828 8.828,8.828 z"
       id="path3" />
    <g
       id="g4"
       transform="translate(0,-88.275)">
    	<path
       fill="#ffe15a"
       d="m 458.211,178.12 36.134,-5.982 -36.134,-5.982 31.094,-19.354 -35.672,8.301 21.321,-29.78 -29.78,21.321 8.301,-35.672 -19.354,31.094 -5.983,-36.135 -5.982,36.134 -19.354,-31.094 8.301,35.672 -29.78,-21.321 21.321,29.78 -35.672,-8.301 31.094,19.354 -36.135,5.983 36.134,5.982 -31.094,19.354 35.672,-8.301 -21.321,29.78 29.78,-21.321 -8.301,35.672 19.354,-31.094 5.983,36.135 5.982,-36.134 19.354,31.094 -8.301,-35.672 29.78,21.321 -21.321,-29.78 35.672,8.301 z m -30.073,16.087 c -12.189,0 -22.069,-9.88 -22.069,-22.069 0,-12.189 9.88,-22.069 22.069,-22.069 12.189,0 22.069,9.88 22.069,22.069 0,12.189 -9.88,22.069 -22.069,22.069 z"
       id="path4" />
    	<circle
       fill="#ffe15a"
       cx="428.14001"
       cy="172.14"
       r="16.552"
       id="circle4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const SA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs41" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g26"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 105.94,202.279 c 0.87,5.577 4.241,7.327 7.172,7.098 3.456,-0.268 6.487,-3.428 6.487,-6.766 v -19.138 c 0,-0.958 0.78,-1.74 1.74,-1.74 0.96,0 1.74,0.781 1.74,1.74 v 19.22 c 0,2.311 1.142,4.466 3.057,5.76 1.169,0.792 2.53,1.199 3.901,1.199 0.873,0 1.75,-0.167 2.586,-0.5 l 1.739,-0.695 c 0.16,16.065 -0.817,30.184 -0.835,30.443 -0.136,1.917 1.306,3.582 3.223,3.718 0.085,0.007 0.168,0.01 0.252,0.01 1.81,0 3.337,-1.4 3.468,-3.232 0.081,-1.131 1.153,-16.594 0.832,-33.715 l 1.052,-0.42 c 0.922,-0.367 1.958,-0.323 2.845,0.119 3.833,1.91 8.445,1.165 11.474,-1.863 l 0.627,-0.626 c 2.812,-2.817 3.779,-6.909 2.52,-10.684 l -2.963,-8.889 c 1.602,0.482 3.362,-0.227 4.136,-1.77 0.86,-1.719 0.163,-3.809 -1.556,-4.669 l -6.959,-3.48 c -1.259,-0.632 -2.77,-0.438 -3.837,0.482 -1.064,0.925 -1.466,2.396 -1.021,3.731 l 5.599,16.798 c 0.419,1.257 0.097,2.623 -0.84,3.561 l -0.626,0.626 c -0.907,0.907 -2.289,1.128 -3.444,0.557 -2.255,-1.127 -4.823,-1.338 -7.232,-0.724 -0.489,-11.169 -1.692,-22.291 -4.254,-29.98 -0.607,-1.822 -2.574,-2.81 -4.403,-2.199 -1.823,0.605 -2.808,2.575 -2.2,4.401 2.507,7.519 3.599,18.978 3.987,30.372 l -4.166,1.666 v -19.22 c 0,-4.798 -3.903,-8.7 -8.7,-8.7 -4.797,0 -8.7,3.901 -8.7,8.7 v 16.845 l -3.55,-17.535 c -0.378,-1.886 -2.212,-3.116 -4.1,-2.722 -1.885,0.384 -3.103,2.219 -2.72,4.102 z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 112.64,173.034 c 1.922,0 3.48,-1.556 3.48,-3.48 v -3.48 c 0,-1.923 -1.558,-3.48 -3.48,-3.48 -1.922,0 -3.48,1.556 -3.48,3.48 v 3.48 c 0,1.923 1.558,3.48 3.48,3.48 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 147.437,169.554 h 3.48 c 1.922,0 3.48,-1.556 3.48,-3.48 0,-1.923 -1.558,-3.48 -3.48,-3.48 h -3.48 c -1.922,0 -3.48,1.556 -3.48,3.48 0,1.924 1.558,3.48 3.48,3.48 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 124.768,215.287 -17.399,10.44 c -1.649,0.989 -2.182,3.126 -1.193,4.775 0.652,1.087 1.804,1.689 2.987,1.689 0.61,0 1.227,-0.16 1.788,-0.497 l 17.399,-10.44 c 1.649,-0.989 2.182,-3.126 1.193,-4.775 -0.989,-1.648 -3.125,-2.181 -4.775,-1.192 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 171.682,221.442 0.082,-0.055 c 0.292,1.176 0.793,2.314 1.606,3.27 1.414,1.665 3.534,2.502 5.93,2.304 3.399,-0.248 5.709,-1.801 7.239,-3.806 0.233,0.16 0.478,0.306 0.734,0.435 1.881,0.948 4.056,0.877 6.127,-0.198 5.259,-2.708 6.392,-8.974 6.232,-12.25 -0.094,-1.91 -1.718,-3.258 -3.623,-3.296 -1.911,0.082 -3.399,1.703 -3.33,3.613 0.002,0.044 0.079,4.173 -2.445,5.706 -0.412,-0.574 -0.9,-1.866 -1.084,-2.933 -0.294,-1.791 -1.939,-3.038 -3.709,-2.895 -1.804,0.142 -3.198,1.658 -3.204,3.469 -0.002,0.506 -0.114,4.971 -3.561,5.345 -0.401,-0.547 -0.408,-2.851 -0.013,-4.554 0.333,-1.397 -0.227,-2.855 -1.409,-3.67 -1.184,-0.819 -2.745,-0.819 -3.934,-0.013 l -1.942,1.321 c -0.922,-20.18 -3.047,-43.695 -3.073,-43.996 -0.173,-1.91 -1.855,-3.334 -3.78,-3.15 -1.914,0.173 -3.325,1.866 -3.151,3.783 0.03,0.322 2.487,27.529 3.245,48.306 -0.178,0.169 -0.361,0.354 -0.535,0.516 -1.376,-3.469 -4.104,-5.654 -7.617,-5.987 -4.958,-0.438 -10.33,2.936 -12.256,7.755 -1.66,4.146 -0.615,8.221 2.66,10.378 2.355,1.553 5.909,2.042 10.378,0.476 -1.091,3.833 -3.078,7.721 -5.66,10.728 -2.313,2.695 -6.175,5.804 -11.117,5.665 -2.877,-0.113 -5.087,-1.054 -6.758,-2.882 -4.029,-4.401 -3.682,-12.366 -3.679,-12.451 0.1,-1.917 -1.368,-3.551 -3.283,-3.657 -1.929,-0.204 -3.561,1.363 -3.667,3.283 -0.024,0.441 -0.529,10.909 5.464,17.491 2.95,3.245 6.869,4.982 11.649,5.169 0.233,0.01 0.466,0.013 0.7,0.013 5.821,0 11.469,-2.855 15.968,-8.098 4.232,-4.928 7.106,-11.622 7.968,-17.836 -0.011,11.904 -7.185,25.33 -16.696,31.245 -4.039,2.508 -10.336,4.771 -17.429,1.274 -8.744,-4.316 -7.702,-14.31 -7.656,-14.718 0.239,-1.907 -1.114,-3.646 -3.021,-3.884 -1.898,-0.231 -3.648,1.111 -3.884,3.021 -0.078,0.622 -1.75,15.292 11.482,21.82 3.399,1.678 6.953,2.511 10.535,2.511 4.601,0 9.245,-1.376 13.647,-4.115 11.58,-7.198 19.985,-22.836 19.985,-37.183 -0.001,-2.243 -0.044,-4.693 -0.115,-7.27 z m -20.983,3.587 c -0.622,-0.412 -0.136,-1.726 -0.031,-1.988 0.733,-1.835 3.025,-3.422 4.856,-3.422 0.094,0 0.189,0.003 0.28,0.013 0.445,0.041 1.626,0.153 2.134,2.78 0.054,0.279 0.1,0.564 0.136,0.856 -3.878,2.278 -6.478,2.35 -7.375,1.761 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 114.397,257.034 c -1.649,-0.969 -3.779,-0.415 -4.757,1.234 -0.16,0.268 -0.372,0.561 -0.588,0.825 -0.038,-0.088 -0.075,-0.183 -0.113,-0.286 -1.451,-3.871 -0.418,-9.834 0.104,-11.806 0.491,-1.855 -0.614,-3.758 -2.468,-4.255 -1.852,-0.476 -3.757,0.605 -4.255,2.461 -0.253,0.941 -2.392,9.389 0.102,16.043 1.597,4.255 4.049,5.329 5.826,5.474 0.158,0.013 0.314,0.02 0.469,0.02 3.746,0 6.239,-3.775 6.932,-4.971 0.961,-1.657 0.398,-3.767 -1.252,-4.739 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 178.612,193.912 c 0.753,0 1.511,-0.242 2.147,-0.744 l 17.544,-13.773 c 0.242,-0.19 0.397,-0.439 0.574,-0.673 2.527,-1.524 4.236,-4.268 4.236,-7.427 0,-4.798 -3.903,-8.7 -8.7,-8.7 -4.797,0 -8.7,3.901 -8.7,8.7 0,2.685 1.248,5.058 3.164,6.655 l -12.417,9.748 c -1.511,1.186 -1.774,3.374 -0.588,4.883 0.687,0.875 1.709,1.331 2.74,1.331 z m 15.802,-24.358 c 0.96,0 1.74,0.781 1.74,1.74 0,0.959 -0.78,1.74 -1.74,1.74 -0.96,0 -1.74,-0.781 -1.74,-1.74 0,-0.959 0.78,-1.74 1.74,-1.74 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 190.295,190.613 c -1.833,-0.611 -3.796,0.377 -4.403,2.199 -0.372,1.114 -2.055,6.855 1.356,10.262 1.324,1.325 3.063,1.988 5.199,1.984 1.427,0 3.031,-0.292 4.807,-0.887 1.823,-0.605 2.808,-2.575 2.2,-4.401 -0.608,-1.822 -2.575,-2.814 -4.403,-2.199 -1.944,0.646 -2.766,0.541 -2.841,0.608 -0.205,-0.516 -0.07,-2.07 0.287,-3.181 0.602,-1.816 -0.383,-3.78 -2.202,-4.385 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 230.121,176.227 c 0.327,0.095 0.654,0.139 0.977,0.139 1.507,0 2.895,-0.985 3.339,-2.505 l 2.03,-6.959 c 0.538,-1.845 -0.522,-3.779 -2.365,-4.316 -1.85,-0.534 -3.777,0.52 -4.316,2.365 l -2.03,6.959 c -0.539,1.848 0.521,3.781 2.365,4.317 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 209.838,175.82 c 0.552,0.323 1.158,0.476 1.753,0.476 1.196,0 2.36,-0.615 3.007,-1.722 0.97,-1.658 0.412,-3.793 -1.247,-4.761 -0.7,-0.408 -0.605,-1.56 -0.579,-1.788 0.104,-0.914 0.649,-2.029 1.597,-2.324 1.835,-0.57 2.86,-2.521 2.289,-4.356 -0.574,-1.838 -2.521,-2.855 -4.359,-2.291 -3.469,1.08 -5.998,4.292 -6.443,8.18 -0.412,3.618 1.114,6.908 3.982,8.586 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 182.234,232.19 c -1.922,0 -3.48,1.556 -3.48,3.48 0,1.699 1.217,3.113 2.827,3.418 0.183,0.268 0.652,1.19 0.652,3.541 0,1.923 1.558,3.48 3.48,3.48 1.922,0 3.48,-1.556 3.48,-3.48 10e-4,-10.32 -6.675,-10.439 -6.959,-10.439 z"
       id="path12" />
    	<path
       fill="#f5f5f5"
       d="m 241.27,217.781 c 0.437,0.072 0.872,0.105 1.309,0.105 2.734,0 5.496,-1.379 8.232,-4.115 1.359,-1.359 1.359,-3.561 0,-4.92 -1.359,-1.359 -3.561,-1.359 -4.92,0 -2.081,2.083 -3.201,2.127 -3.488,2.062 -0.664,-0.095 -1.266,-0.962 -1.4,-1.199 -0.873,-1.693 -2.943,-2.368 -4.647,-1.516 -1.719,0.86 -2.417,2.95 -1.556,4.669 0.215,0.432 2.224,4.224 6.47,4.914 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 300.419,193.327 c -0.022,-0.054 -0.043,-0.105 -0.06,-0.153 -0.617,-1.807 -2.588,-2.79 -4.392,-2.175 -1.825,0.605 -2.81,2.575 -2.202,4.401 0.271,0.815 1.822,4.907 5.662,5.423 0.257,0.034 0.512,0.051 0.765,0.051 2.411,0 4.672,-1.56 6.73,-4.646 1.065,-1.597 0.633,-3.758 -0.966,-4.825 -1.601,-1.064 -3.762,-0.636 -4.825,0.966 -0.275,0.411 -0.513,0.724 -0.712,0.958 z"
       id="path14" />
    	<path
       fill="#f5f5f5"
       d="m 293.588,256.548 c 0,-14.839 -0.652,-28.76 -1.558,-40.958 4.941,8.569 9.386,17.228 12.218,24.782 0.525,1.397 1.85,2.257 3.258,2.257 0.406,0 0.819,-0.072 1.221,-0.221 1.8,-0.676 2.712,-2.681 2.037,-4.482 -4.405,-11.742 -12.321,-25.726 -20.124,-38.14 -1.902,-18.745 -4.032,-30.643 -4.069,-30.855 -0.343,-1.892 -2.151,-3.17 -4.045,-2.801 -1.891,0.343 -3.145,2.154 -2.802,4.044 0.028,0.151 1.124,6.28 2.435,16.595 -2.674,-3.967 -5.158,-7.546 -7.242,-10.492 l 0.17,0.054 c 1.833,0.611 3.794,-0.377 4.403,-2.199 0.608,-1.825 -0.377,-3.796 -2.2,-4.401 l -10.44,-3.48 c -1.448,-0.489 -3.037,0.028 -3.923,1.265 -0.237,0.33 -0.399,0.692 -0.509,1.066 -2.083,-1.54 -4.755,-2.792 -7.263,-1.742 -1.517,0.629 -3.325,2.212 -3.325,6.191 0,3.055 1.165,6.358 2.401,9.858 2.049,5.804 3.332,10.072 1.162,12.108 -1.199,1.124 -2.398,1.549 -3.566,1.254 -2.146,-0.544 -4.27,-3.402 -5.685,-7.646 -0.062,-0.184 -0.19,-0.318 -0.278,-0.483 0.732,-5.39 0.413,-11.884 -1.062,-19.253 -0.375,-1.886 -2.204,-3.113 -4.095,-2.729 -1.885,0.377 -3.106,2.209 -2.729,4.095 2.272,11.363 1.59,20.633 -1.823,24.797 -1.32,1.611 -2.974,2.358 -5.204,2.358 -0.705,0 -1.186,-0.224 -1.665,-0.775 -2.745,-3.164 -2.734,-13.372 -1.848,-19.615 0.141,-0.995 -0.158,-2.008 -0.819,-2.77 -0.661,-0.761 -1.619,-1.199 -2.627,-1.199 -5.987,0 -8.257,6.81 -10.261,12.818 -0.878,2.641 -2.516,7.551 -3.658,8.061 -2.106,0 -3.468,-6.185 -3.48,-10.443 -0.006,-1.92 -1.561,-3.473 -3.48,-3.473 0,0 -0.003,0 -0.006,0 -1.92,0 -3.475,1.556 -3.475,3.476 0,8.026 2.734,17.399 10.44,17.399 5.738,0 8.062,-6.253 10.008,-12.064 0.338,4.621 1.382,9.409 3.947,12.366 1.803,2.08 4.196,3.177 6.924,3.177 4.296,0 7.955,-1.696 10.585,-4.904 0.477,-0.58 0.887,-1.247 1.292,-1.92 2.02,2.872 4.499,4.767 7.292,5.472 0.819,0.207 1.643,0.312 2.458,0.312 2.686,0 5.311,-1.108 7.578,-3.239 0.471,-0.444 0.803,-0.927 1.162,-1.404 0.851,0.243 1.714,0.387 2.571,0.387 2.819,0 5.533,-1.135 7.217,-2.216 1.611,-1.033 2.077,-3.167 1.054,-4.785 -1.025,-1.614 -3.169,-2.097 -4.791,-1.084 -0.03,0.014 -2.354,1.35 -3.939,1.036 0.004,-3.815 -1.376,-7.866 -2.636,-11.435 -0.717,-2.033 -1.453,-4.115 -1.8,-5.817 0.287,0.242 0.567,0.493 0.818,0.737 1.356,1.359 3.56,1.359 4.919,0 0.225,-0.225 0.355,-0.498 0.505,-0.761 3.607,4.969 11.026,15.411 18.657,27.448 1.457,14.795 2.735,33.668 2.735,54.368 0,1.923 1.558,3.48 3.48,3.48 1.922,0.004 3.48,-1.551 3.48,-3.475 z"
       id="path15" />
    	<path
       fill="#f5f5f5"
       d="m 297.067,179.993 c 0,1.923 1.558,3.48 3.48,3.48 1.922,0 3.48,-1.556 3.48,-3.48 0,-4.095 -3.204,-10.711 -3.847,-11.996 -0.86,-1.716 -2.948,-2.409 -4.669,-1.556 -1.719,0.86 -2.417,2.95 -1.556,4.669 1.255,2.511 3.112,7.068 3.112,8.883 z"
       id="path16" />
    	<path
       fill="#f5f5f5"
       d="m 281.234,256.928 c -1.706,-0.87 -3.802,-0.18 -4.671,1.533 -0.374,0.73 -0.953,1.543 -1.442,2.066 -0.154,-1.383 0.214,-4.146 0.916,-6.436 0.467,-1.529 -0.167,-3.181 -1.536,-4.003 -1.364,-0.825 -3.123,-0.611 -4.252,0.52 l -6.959,6.959 c -1.359,1.359 -1.359,3.561 0,4.92 1.359,1.359 3.561,1.359 4.92,0 l 0.177,-0.177 c 0.301,1.397 0.877,2.671 1.863,3.657 1.305,1.305 2.882,1.995 4.521,1.995 0.318,0 0.637,-0.028 0.957,-0.078 3.942,-0.639 6.396,-4.985 7.054,-6.301 0.855,-1.716 0.162,-3.791 -1.548,-4.655 z"
       id="path17" />
    	<path
       fill="#f5f5f5"
       d="M 279.885,228.927 H 255.36 c 0.217,-0.866 0.441,-1.693 0.67,-2.477 9.78,-2.033 15.593,-5.19 17.302,-9.402 0.591,-1.461 1.208,-4.414 -1.309,-7.809 -2.269,-3.059 -5.471,-4.431 -8.797,-3.752 -4.945,1.002 -9.351,6.33 -12.512,14.86 -9.823,1.682 -16.111,5.208 -20.092,8.687 -1.412,-14.26 -6.947,-22.731 -7.217,-23.134 -1.067,-1.601 -3.229,-2.033 -4.825,-0.966 -1.599,1.067 -2.03,3.225 -0.966,4.825 0.063,0.095 6.375,9.749 6.375,25.908 0,15.883 -12.665,27.838 -20.878,27.838 -3.907,0 -5.618,-4.644 -6.369,-8.572 8.042,-5.636 15.138,-12.158 16.705,-18.424 2.121,-8.479 -0.548,-14.728 -2.314,-18.863 -0.083,-0.19 -0.17,-0.394 -0.258,-0.605 0.075,0.068 0.146,0.139 0.217,0.207 1.356,1.359 3.56,1.359 4.919,0 1.359,-1.359 1.359,-3.561 0,-4.92 -2.034,-2.036 -5.984,-5.234 -9.575,-3.731 -1.517,0.629 -3.325,2.212 -3.325,6.191 0,1.798 0.751,3.554 1.621,5.593 1.567,3.667 3.516,8.231 1.962,14.442 -0.919,3.676 -5.433,8.135 -11.39,12.563 -0.639,-0.764 -1.561,-1.277 -2.633,-1.277 h -0.006 c -1.92,0.003 -3.475,1.556 -3.475,3.476 0,0.626 0.028,1.295 0.068,1.982 -7.447,4.823 -15.874,9.287 -22.388,12.249 -1.748,0.796 -2.521,2.858 -1.726,4.608 0.583,1.281 1.847,2.039 3.169,2.039 0.482,0 0.972,-0.098 1.438,-0.312 1.956,-0.889 11.243,-5.216 20.783,-11.128 1.757,5.965 5.48,11.442 12.576,11.442 8.348,0 17.818,-6.826 23.283,-17.017 0.66,1.165 1.418,2.281 2.323,3.322 8.759,10.1 25.867,10.215 26.591,10.215 1.874,0 3.41,-1.482 3.478,-3.354 0.066,-1.873 -1.361,-3.463 -3.229,-3.595 -0.028,-0.003 -2.801,-0.309 -4.343,-2.11 -0.931,-1.087 -1.303,-2.583 -1.139,-4.57 0.356,-4.288 14.189,-7.494 26.38,-7.683 1.453,-0.024 2.739,-0.945 3.226,-2.314 l 3.48,-9.786 c 0.378,-1.064 0.216,-2.25 -0.437,-3.17 -0.645,-0.926 -1.708,-1.476 -2.838,-1.476 z M 264.611,212.31 c 0.066,-0.013 0.154,-0.034 0.265,-0.034 0.333,0 0.858,0.163 1.558,1.108 0.132,0.177 0.556,0.781 0.449,1.047 -0.399,0.985 -2.802,2.613 -7.807,4.088 2.201,-4.296 4.354,-5.971 5.535,-6.209 z m -21.015,45.743 c -3.535,-1.149 -7.138,-2.97 -9.632,-5.855 -2.741,-3.17 -3.753,-7.18 -3.089,-12.254 0.1,-0.267 0.328,-0.792 0.726,-1.475 4.9,-0.449 17.991,1.482 18.898,5.231 -4.038,2.061 -7.012,4.959 -7.356,9.079 -0.173,2.067 0.038,3.817 0.453,5.274 z"
       id="path18" />
    	<path
       fill="#f5f5f5"
       d="m 317.768,178.892 -3.48,-10.44 c -0.561,-1.678 -2.302,-2.681 -4.029,-2.301 -1.735,0.371 -2.912,1.984 -2.735,3.748 2.401,24.012 6.943,70.839 6.943,76.209 0,4.822 -8.577,14.316 -22.435,21.246 -1.719,0.86 -2.417,2.949 -1.556,4.669 0.61,1.22 1.838,1.923 3.116,1.923 0.522,0 1.054,-0.119 1.553,-0.367 12.659,-6.33 26.282,-17.626 26.282,-27.471 0,-5.141 -3.556,-42.134 -5.593,-62.914 1.649,-0.704 2.511,-2.568 1.934,-4.302 z"
       id="path19" />
    	<path
       fill="#f5f5f5"
       d="m 346.803,210.292 c 0.67,0.67 1.56,1.02 2.462,1.02 0.588,0 1.181,-0.149 1.719,-0.456 1.361,-0.775 2.037,-2.365 1.652,-3.884 -0.623,-2.446 -0.831,-5.505 -0.501,-6.755 1.743,0.054 3.361,-1.186 3.617,-2.984 0.271,-1.903 -1.05,-3.667 -2.952,-3.938 -2.301,-0.312 -4.321,0.364 -5.732,1.933 -0.914,1.02 -1.458,2.328 -1.753,3.735 l -4.03,-4.03 c -1.359,-1.359 -3.561,-1.359 -4.92,0 -1.359,1.359 -1.359,3.561 0,4.92 z"
       id="path20" />
    	<path
       fill="#f5f5f5"
       d="m 354.631,213.921 -13.049,9.352 c -1.561,1.118 -1.922,3.293 -0.802,4.856 0.68,0.948 1.748,1.451 2.833,1.451 0.702,0 1.41,-0.211 2.024,-0.652 l 13.049,-9.352 c 1.561,-1.118 1.922,-3.293 0.802,-4.856 -1.122,-1.564 -3.3,-1.928 -4.857,-0.799 z"
       id="path21" />
    	<path
       fill="#f5f5f5"
       d="m 353.475,227.007 c -1.095,1.41 -0.938,3.395 0.305,4.615 0.149,0.252 0.828,1.583 0.705,5.009 -0.068,1.923 1.434,3.534 3.354,3.602 0.042,0.003 0.085,0.003 0.126,0.003 1.866,0 3.409,-1.479 3.476,-3.354 0.253,-7.102 -2.071,-9.698 -3.082,-10.484 -1.514,-1.185 -3.704,-0.906 -4.884,0.609 z"
       id="path22" />
    	<path
       fill="#f5f5f5"
       d="m 383.843,252.633 c 1.922,0 3.48,-1.556 3.48,-3.48 0,-5.134 -0.264,-10.866 -0.695,-16.829 3.451,5.654 6.317,10.867 8.155,15.154 0.564,1.322 1.848,2.11 3.199,2.11 0.457,0 0.922,-0.088 1.369,-0.282 1.766,-0.758 2.584,-2.804 1.826,-4.567 -3.186,-7.435 -9.14,-17.283 -15.921,-27.45 -1.365,-12.772 -3.148,-25.287 -4.534,-34.264 0.737,0.075 1.502,-0.105 2.173,-0.541 1.099,-0.704 1.614,-1.927 1.54,-3.144 0.089,0.342 0.185,0.685 0.385,1 0.024,0.034 2.26,3.727 1.268,8.52 -0.39,1.879 0.821,3.721 2.703,4.111 0.238,0.047 0.476,0.072 0.708,0.072 1.615,0 3.063,-1.132 3.405,-2.776 1.571,-7.602 -2.058,-13.419 -2.212,-13.664 -1.033,-1.618 -3.185,-2.093 -4.806,-1.067 -1.103,0.703 -1.625,1.927 -1.554,3.147 -0.09,-0.344 -0.189,-0.69 -0.392,-1.005 l -5.873,-9.134 c -0.897,-1.394 -2.653,-1.958 -4.193,-1.359 -1.545,0.605 -2.449,2.212 -2.162,3.843 0.049,0.274 2.708,15.544 5.065,33.949 -2.668,-3.767 -5.335,-7.45 -7.922,-10.966 -0.42,-5.265 -0.842,-10.132 -1.207,-14.157 0.192,-0.057 0.381,-0.132 0.566,-0.224 1.719,-0.86 2.417,-2.95 1.556,-4.669 l -3.48,-6.959 c -0.751,-1.502 -2.465,-2.25 -4.079,-1.788 -1.612,0.469 -2.663,2.018 -2.496,3.69 0.415,4.153 0.847,8.75 1.271,13.579 -2.201,-2.901 -4.237,-5.557 -5.98,-7.806 0.34,-0.292 0.63,-0.655 0.844,-1.084 0.86,-1.719 0.163,-3.809 -1.556,-4.669 l -6.959,-3.48 c -1.46,-0.727 -3.232,-0.346 -4.263,0.925 -1.026,1.271 -1.032,3.085 -0.01,4.363 0.188,0.234 8.756,10.974 19.005,24.836 1.778,22.991 2.962,46.908 1.29,51.922 -0.306,0.917 -0.84,1.998 -1.341,2.036 -2.103,0.292 -7.123,-4.41 -9.644,-9.45 -1.453,-2.902 -3.543,-3.204 -4.661,-3.154 -3.74,0.231 -5.199,4.346 -7.851,11.816 -1.901,5.352 -4.263,12.006 -6.915,14.728 -1.437,-1.756 -3.295,-7.647 -4.327,-13.7 0.484,1.338 1.737,2.306 3.243,2.306 1.922,0 3.48,-1.556 3.48,-3.48 0,-5.19 -3.629,-44.711 -5.656,-66.37 1.693,-0.68 2.583,-2.572 1.998,-4.326 l -3.48,-10.44 c -0.559,-1.678 -2.276,-2.668 -4.022,-2.304 -1.731,0.367 -2.912,1.974 -2.744,3.735 2.365,24.824 6.799,72.772 6.937,79.39 -0.009,-0.06 -0.021,-0.118 -0.029,-0.178 -0.27,-1.903 -2.046,-3.208 -3.937,-2.953 -1.903,0.275 -3.223,2.036 -2.952,3.938 1.016,7.113 3.613,19.342 9.593,21.334 0.472,0.16 1.108,0.302 1.854,0.302 1.372,0 3.114,-0.486 4.897,-2.27 3.79,-3.789 6.355,-11.014 8.618,-17.385 0.511,-1.441 1.117,-3.147 1.687,-4.608 3.192,4.662 8.762,10.466 14.405,10.012 1.984,-0.142 5.593,-1.209 7.449,-6.776 1.85,-5.551 1.119,-24.91 -0.128,-43.444 2.932,4.109 5.866,8.317 8.666,12.472 1.086,10.421 1.862,20.861 1.862,29.436 0.005,1.919 1.563,3.476 3.484,3.476 z"
       id="path23" />
    	<path
       fill="#f5f5f5"
       d="m 410.251,234.33 c -2.465,-18.364 -5.899,-39.637 -8.074,-52.693 0.982,0.242 2.052,0.044 2.915,-0.619 1.529,-1.165 1.822,-3.351 0.655,-4.876 l -6.307,-8.265 c -0.973,-1.271 -2.69,-1.719 -4.159,-1.077 -1.47,0.642 -2.31,2.206 -2.036,3.786 0.063,0.356 6.268,36.078 10.106,64.668 1.466,10.925 -0.674,20.689 -5.729,26.112 -3.249,3.484 -7.554,5.06 -12.764,4.757 -1.913,-0.102 -3.572,1.338 -3.692,3.255 -0.12,1.917 1.335,3.569 3.254,3.69 0.588,0.038 1.167,0.054 1.741,0.054 6.562,0 12.257,-2.405 16.551,-7.014 6.559,-7.032 9.307,-18.617 7.539,-31.778 z"
       id="path24" />
    	<path
       fill="#f5f5f5"
       d="m 371.97,257.268 c -1.279,1.39 -1.181,3.578 0.172,4.891 0.189,0.183 0.415,0.544 0.416,0.721 0.002,0.098 -0.139,0.391 -0.526,0.778 -1.359,1.359 -1.359,3.561 0,4.92 0.68,0.68 1.57,1.02 2.461,1.02 0.89,0 1.781,-0.34 2.461,-1.02 2.207,-2.206 2.612,-4.445 2.562,-5.937 -0.107,-3.211 -2.294,-5.284 -2.73,-5.668 -1.423,-1.237 -3.538,-1.088 -4.816,0.295 z"
       id="path25" />
    	<path
       fill="#f5f5f5"
       d="m 359.703,333.581 h -3.48 -20.878 v -3.48 c 0,-1.923 -1.558,-3.48 -3.48,-3.48 -1.922,0 -3.48,1.556 -3.48,3.48 v 3.48 H 143.957 c 6.959,6.959 20.878,10.44 31.318,10.44 7.487,0 100.879,0 153.11,0 v 6.959 c 0,1.923 1.558,3.48 3.48,3.48 h 27.838 c 5.757,0 10.44,-4.683 10.44,-10.44 0,-5.757 -4.683,-10.439 -10.44,-10.439 z m 0,13.919 h -24.359 v -3.48 c 16.77,0 27.838,0 27.838,0 l -0.625,-1.873 c 0.362,0.548 0.625,1.167 0.625,1.873 0,1.921 -1.561,3.48 -3.479,3.48 z"
       id="path26" />
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g35"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g36"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g37"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SB = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs23" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 508.744,2.135 3.256,333.315 c 1.53,1.274 3.425,2.134 5.571,2.134 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 C 512,6.1 510.689,3.753 508.744,2.135 Z"
       id="path2" />
    <path
       fill="#ffe15a"
       d="M 512,8.828 C 512,3.953 508.047,0 503.172,0 H 487.833 L 0,319.616 v 7.006 c 0,4.875 3.953,8.828 8.828,8.828 H 24.167 L 512,15.834 Z"
       id="path3" />
    <g
       id="g8"
       transform="translate(0,-88.275)">
    	<path
       fill="#f5f5f5"
       d="m 44.429,115.778 -4.726,14.169 -14.936,0.116 c -1.432,0.011 -2.026,1.839 -0.874,2.69 l 12.015,8.873 -4.505,14.241 c -0.433,1.366 1.123,2.495 2.289,1.663 l 12.152,-8.685 12.152,8.685 c 1.165,0.833 2.72,-0.297 2.289,-1.663 l -4.505,-14.241 12.015,-8.873 c 1.152,-0.851 0.558,-2.679 -0.874,-2.69 l -14.936,-0.116 -4.726,-14.169 c -0.454,-1.359 -2.376,-1.359 -2.83,0 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 158.21,115.778 -4.726,14.169 -14.936,0.116 c -1.432,0.011 -2.026,1.839 -0.874,2.69 l 12.015,8.873 -4.505,14.241 c -0.433,1.366 1.123,2.495 2.289,1.663 l 12.152,-8.685 12.152,8.685 c 1.165,0.833 2.72,-0.297 2.289,-1.663 l -4.505,-14.241 12.015,-8.873 c 1.152,-0.851 0.558,-2.679 -0.874,-2.69 l -14.936,-0.116 -4.726,-14.169 c -0.455,-1.359 -2.377,-1.359 -2.83,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 101.32,166.476 -4.726,14.169 -14.936,0.116 c -1.432,0.011 -2.026,1.839 -0.874,2.69 l 12.015,8.873 -4.505,14.241 c -0.433,1.366 1.123,2.495 2.289,1.663 l 12.152,-8.685 12.152,8.685 c 1.165,0.833 2.72,-0.297 2.289,-1.663 l -4.505,-14.241 12.015,-8.873 c 1.152,-0.851 0.558,-2.679 -0.874,-2.69 l -14.936,-0.116 -4.726,-14.169 c -0.456,-1.359 -2.377,-1.359 -2.83,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 44.429,217.174 -4.726,14.169 -14.936,0.116 c -1.432,0.011 -2.026,1.839 -0.874,2.69 l 12.015,8.873 -4.505,14.241 c -0.433,1.366 1.123,2.495 2.289,1.663 l 12.152,-8.685 12.152,8.685 c 1.165,0.833 2.72,-0.297 2.289,-1.663 l -4.505,-14.241 12.015,-8.873 c 1.152,-0.851 0.558,-2.679 -0.874,-2.69 l -14.936,-0.116 -4.726,-14.169 c -0.454,-1.359 -2.376,-1.359 -2.83,0 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 158.21,217.174 -4.726,14.169 -14.936,0.116 c -1.432,0.011 -2.026,1.839 -0.874,2.69 l 12.015,8.873 -4.505,14.241 c -0.433,1.366 1.123,2.495 2.289,1.663 l 12.152,-8.685 12.152,8.685 c 1.165,0.833 2.72,-0.297 2.289,-1.663 l -4.505,-14.241 12.015,-8.873 c 1.152,-0.851 0.558,-2.679 -0.874,-2.69 l -14.936,-0.116 -4.726,-14.169 c -0.455,-1.359 -2.377,-1.359 -2.83,0 z"
       id="path8" />
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const SC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#73af00"
       d="m 8.828,335.448 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 223.632 L 4.85,334.388 c 1.209,0.624 2.523,1.06 3.978,1.06 z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 170.667,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 326.62 c 0,1.972 0.769,3.699 1.862,5.169 z"
       id="path2" />
    <path
       fill="#ffe15a"
       d="M 2.613,332.882 341.333,0.001 H 170.667 L 1.862,331.789 c 0.264,0.356 0.436,0.78 0.751,1.093 z"
       id="path3" />
    <path
       fill="#ff4b55"
       d="M 503.172,0 H 341.333 L 2.613,332.882 c 0.367,0.364 0.858,0.569 1.284,0.865 L 512,111.816 V 8.828 C 512,3.953 508.047,0 503.172,0 Z"
       id="path4" />
    <path
       fill="#f5f5f5"
       d="M 4.85,334.388 511.999,223.631 V 111.816 L 3.896,333.746 c 0.317,0.22 0.609,0.466 0.954,0.642 z"
       id="path5" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#464655"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#73af00"
       d="M 3.256,333.315 206.097,172.3 c 2.946,-2.338 2.946,-6.812 0,-9.151 L 3.256,2.135 C 1.311,3.754 0,6.1 0,8.828 v 317.793 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs15" />
    <path
       fill="#4173cd"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#ffe15a"
       points="211.862,88.277 158.897,88.277 158.897,229.518 0,229.518 0,282.484 158.897,282.484 158.897,423.725 211.862,423.725 211.862,282.484 512,282.484 512,229.518 211.862,229.518 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs23" />
    <path
       fill="#ff4b55"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <g
       id="g8"
       transform="translate(0,-88.275)">
    	<path
       fill="#f5f5f5"
       d="m 0,256 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,423.725 0,419.772 0,414.897 Z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 72.569,172.263 c 0,-29.028 21.3,-53.091 49.113,-57.542 1.51,-0.242 1.578,-2.319 0.088,-2.663 -6.886,-1.583 -14.199,-2.034 -21.793,-1 -29.998,4.086 -53.186,30.046 -53.61,60.318 -0.483,34.566 27.383,62.712 61.785,62.712 4.683,0 9.23,-0.547 13.606,-1.554 1.489,-0.342 1.414,-2.424 -0.094,-2.666 C 93.862,225.42 72.569,201.404 72.569,172.263 Z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 122.14,187.795 -2.613,7.836 -8.259,0.064 c -1.069,0.009 -1.513,1.373 -0.652,2.008 l 6.644,4.907 -2.492,7.875 c -0.322,1.02 0.839,1.863 1.708,1.241 l 6.72,-4.803 6.72,4.803 c 0.87,0.622 2.03,-0.222 1.708,-1.241 l -2.492,-7.875 6.644,-4.907 c 0.861,-0.636 0.417,-1.999 -0.652,-2.008 l -8.259,-0.064 -2.613,-7.836 c -0.339,-1.014 -1.774,-1.014 -2.112,0 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 162.967,187.795 -2.613,7.836 -8.259,0.064 c -1.069,0.009 -1.513,1.373 -0.652,2.008 l 6.644,4.907 -2.492,7.875 c -0.322,1.02 0.839,1.863 1.708,1.241 l 6.72,-4.803 6.72,4.803 c 0.87,0.622 2.03,-0.222 1.708,-1.241 l -2.492,-7.875 6.644,-4.907 c 0.861,-0.636 0.417,-1.999 -0.652,-2.008 l -8.259,-0.064 -2.613,-7.836 c -0.339,-1.014 -1.773,-1.014 -2.112,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 142.738,124.79 -2.613,7.836 -8.259,0.064 c -1.069,0.009 -1.513,1.373 -0.652,2.008 l 6.644,4.907 -2.492,7.875 c -0.322,1.02 0.839,1.863 1.708,1.241 l 6.72,-4.803 6.72,4.803 c 0.87,0.622 2.03,-0.222 1.708,-1.241 l -2.492,-7.875 6.644,-4.907 c 0.861,-0.636 0.417,-1.999 -0.652,-2.008 l -8.259,-0.064 -2.613,-7.836 c -0.339,-1.014 -1.774,-1.014 -2.112,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 110.186,148.928 -2.613,7.836 -8.259,0.064 c -1.069,0.009 -1.513,1.373 -0.652,2.008 l 6.644,4.907 -2.492,7.875 c -0.322,1.02 0.839,1.863 1.708,1.241 l 6.72,-4.803 6.72,4.803 c 0.87,0.622 2.03,-0.222 1.708,-1.241 l -2.492,-7.875 6.644,-4.907 c 0.861,-0.636 0.417,-1.999 -0.652,-2.008 l -8.259,-0.064 -2.613,-7.836 c -0.339,-1.014 -1.773,-1.014 -2.112,0 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 175.014,148.928 -2.613,7.836 -8.259,0.064 c -1.069,0.009 -1.513,1.373 -0.652,2.008 l 6.644,4.907 -2.492,7.875 c -0.322,1.02 0.839,1.863 1.708,1.241 l 6.72,-4.803 6.72,4.803 c 0.87,0.622 2.03,-0.222 1.708,-1.241 l -2.492,-7.875 6.644,-4.907 c 0.861,-0.636 0.417,-1.999 -0.652,-2.008 l -8.259,-0.064 -2.613,-7.836 c -0.339,-1.014 -1.774,-1.014 -2.112,0 z"
       id="path8" />
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const SH = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44963" {...props}>
    <defs
         id="defs39" /><path
         fill="#00247d"
         d="M 503.172,335.44961 H 8.828 c -4.875,0 -8.828,-3.953 -8.828,-8.828 V 8.828609 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62161 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
         id="path2" /><path
         fill="#ffffff"
         d="M 8.828125,0 C 3.953125,0 0,3.953125 0,8.828125 v 8.421874 l 59.876953,30.04688 H 0 v 47.33398 H 59.876953 L 0,124.67773 v 17.25586 h 34.257812 l 83.759768,-41.75976 v 41.75976 h 47.16601 v -41.75976 l 83.75977,41.75976 h 34.55273 V 124.67773 L 223.32422,94.630859 h 60.17187 v -47.33398 h -60.17187 l 60.17187,-30.04688 V 0 H 248.94336 L 165.18359,41.755859 V 0 H 118.01758 V 41.755859 L 34.257812,0 Z"
         id="path2-7" /><g
         id="g6"
         transform="translate(0,-88.275391)" /><g
         id="g8"
         transform="translate(0,-88.275391)" /><g
         id="g10"
         transform="translate(0,-88.275391)" /><g
         id="g12"
         transform="translate(0,-88.275391)" /><g
         id="g14"
         transform="translate(0,-88.275391)" /><g
         id="g16"
         transform="translate(0,-88.275391)" /><g
         id="g18"
         transform="translate(0,-88.275391)" /><g
         id="g20"
         transform="translate(0,-88.275391)" /><g
         id="g22"
         transform="translate(0,-88.275391)" /><g
         id="g24"
         transform="translate(0,-88.275391)" /><g
         id="g26"
         transform="translate(0,-88.275391)" /><g
         id="g28"
         transform="translate(0,-88.275391)" /><g
         id="g30"
         transform="translate(0,-88.275391)" /><g
         id="g32"
         transform="translate(0,-88.275391)" /><g
         id="g34"
         transform="translate(0,-88.275391)" /><path
         fill="#cf142b"
         d="M 3.5449219,1.769531 C 1.3969038,3.379923 0,5.937306 0,8.828125 v 2.476562 l 71.957031,36.025392 h 22.84961 z"
         id="path2-9" /><g
         fill="#ef072d"
         id="g30-2"
         transform="matrix(1.9713694,0,0,1.9715885,-315.40136,-1142.2707)"><path
           d="m 292.494,579.366 -48,24.006 h 11.49 l 47.814,-24.006 z"
           id="path32"
           fill="#cf142b" /></g><g
         fill="#ef072d"
         id="g34-8"
         transform="matrix(1.9713694,0,0,1.9715885,-315.40136,-1142.2707)"><path
           d="m 303.798,651.355 -47.865,-23.993 h 11.541 l 36.324,18.273 z"
           id="path36"
           fill="#cf142b" /></g><g
         fill="#ef072d"
         id="g42"
         transform="matrix(1.9713694,0,0,1.9715885,-315.40136,-1142.2707)"><path
           d="m 207.984,627.362 -47.993,23.993 h 11.484 l 48,-23.993 z"
           id="path44"
           fill="#cf142b" /></g><g
         fill="#ef072d"
         id="g46"
         transform="matrix(1.9713694,0,0,1.9715885,-315.40136,-1142.2707)"><path
           d="m 159.991,608.336 h 64.962 v -28.97 h 14.059 v 28.97 h 64.786 v 14.058 h -64.786 v 28.961 h -14.059 v -28.961 h -64.962 z"
           id="path48"
           fill="#cf142b" /></g><g
         id="g3684"
         transform="matrix(2.5607704,0,0,2.5610549,-552.38928,-1502.9528)"><g
           id="g50"
           fill="#4fa8ff"><path
             fill="#8fc5ff"
             id="path52"
             d="m 399.668,640.771 c -0.046,16.332 -2.623,33.927 -23.764,42.308 -21.142,-8.381 -23.719,-25.976 -23.765,-42.308 z" /></g><g
           id="g54"
           fill="#ffffff"><path
             fill="#366cc9"
             id="path56"
             d="m 375.904,683.079 c 9.584,-3.799 15.353,-9.493 18.8,-16.104 -0.516,0.02 -1.597,-0.011 -2.064,-0.043 -0.52,-0.034 -20.271,-2.018 -22.61,-2.876 -2.035,-0.746 -9.799,0.634 -13.423,1.929 3.381,7.032 9.237,13.106 19.297,17.094 z" /></g><g
           id="g58"
           fill="#000000"><path
             fill="#5d3100"
             id="path60"
             d="m 361.129,672.954 c 0.323,-0.105 0.94,-0.08 1.183,-0.036 0.286,0.052 0.338,0.078 0.442,-0.234 0.104,-0.312 0.338,-0.234 0.52,-0.078 0.182,0.156 0.649,0.078 0.831,-0.182 0.182,-0.259 0.234,-0.233 0.416,-0.052 0.182,0.182 0.26,0.13 0.442,0.078 0.182,-0.051 0.494,-0.259 0.65,-0.545 0.156,-0.286 0.389,-0.39 0.519,-0.234 0.13,0.156 0.26,0.234 0.442,0.208 0.182,-0.026 0.234,0.156 0.208,0.389 -0.026,0.234 0.078,0.286 0.52,-0.077 0.39,0.389 0.519,0.233 0.519,-0.182 0,-0.416 -0.103,-1.949 -0.259,-2.157 -0.156,-0.208 -0.312,-0.806 -0.338,-1.274 -0.049,-0.883 -0.052,-0.935 -1.118,-1.481 0,-0.312 -0.078,-0.442 -0.831,-0.39 0.026,-0.104 -0.104,-0.416 -0.26,-0.546 -0.156,-0.13 -0.182,-0.182 -0.104,-0.545 0.312,0.026 0.65,-0.026 0.832,-0.286 0.181,-0.26 0.779,-0.208 1.143,-0.052 0.364,0.156 0.832,0.182 1.533,0.078 0.26,-0.208 0.702,-0.442 1.17,-0.702 0.467,-0.26 0.597,-0.364 0.623,-0.728 0.067,-0.933 -0.26,-2.001 -0.52,-2.494 -0.259,-0.494 -0.337,-1.118 -0.701,-1.898 -0.396,-0.849 -0.39,-1.065 -0.832,-1.585 -0.121,-0.143 -0.26,-0.26 -0.286,-0.545 -0.026,-0.286 -0.13,-0.676 -0.441,-0.962 -0.786,-0.721 -1.092,-3.041 -1.404,-4.756 -0.179,-0.983 -0.052,-3.3 -0.467,-3.664 -0.702,-0.572 -1.04,-0.468 -1.508,-0.65 -0.338,-0.468 -0.493,-1.403 -0.805,-2.235 -0.494,0.078 -0.832,0.598 -1.17,0.78 -0.338,0.182 -0.39,0.182 -0.39,0.65 0,0.467 -0.26,1.117 -0.727,1.845 -0.468,0.727 -1.248,0.52 -1.897,1.611 -1.43,-1.741 -1.456,-2.235 -1.56,-2.729 -0.104,-0.493 -0.338,-0.597 -1.143,-1.299 0,-0.208 -0.104,-1.039 -0.026,-1.507 -0.598,-0.494 -1.04,-0.416 -1.325,-0.052 -0.286,0.364 -0.494,0.909 -0.936,1.117 -0.265,0.337 -1.064,1.187 -1.718,2.199 0.595,9.044 2.636,18.022 8.773,25.202 z" /></g><g
           id="g62"
           fill="#ffff00"><path
             
             id="path64"
             d="m 399.668,640.771 c 0.018,-6.152 -0.324,-12.125 -0.168,-17.359 -7.9,-3.535 -18.295,-4.262 -23.596,-4.262 -5.302,0 -15.697,0.727 -23.597,4.262 0.156,5.234 -0.185,11.207 -0.168,17.359 z" /></g><g
           id="g66"
           fill="#cf6200"><path
             id="path68"
             d="m 353.424,647.892 c 0.26,0.416 0.728,1.131 0.78,1.52 0.182,-0.377 0.325,-0.545 0.364,-0.779 0.039,-0.234 0.312,-0.689 0.208,-0.936 -0.104,-0.247 -0.182,-0.442 0.104,-0.26 0.285,0.182 0.23,0.497 0.168,0.962 -0.168,1.273 -0.701,1.533 -0.779,2.391 0.767,1.806 0.195,2.456 1.026,4.223 0.13,0.078 0.477,-0.061 0.581,-0.035 0.441,-0.312 0.771,-0.199 1.394,-0.069 0.624,0.13 0.962,0.571 0.962,0.961 0,0.39 0,0.494 0.13,0.728 0.13,0.234 0.39,0.598 0.338,0.858 -0.052,0.259 0.052,0.415 0.13,0.545 0.078,0.13 -0.026,0.416 -0.104,0.598 -0.078,0.182 -0.052,0.416 0.26,0.806 0.312,0.389 1.039,2.027 1.039,2.988 0,0.962 0.052,1.404 0.442,1.585 0.39,0.182 0.52,0.338 0.468,0.754 -0.052,0.416 0.182,2.573 0.234,2.911 0.052,0.338 0.182,0.26 0.338,0.442 0.155,0.181 0.259,0.389 0.779,0.389 0.52,0 1.022,-0.069 1.36,-0.017 0.468,0.65 0.754,1.533 0.858,2.079 0.104,0.546 0.095,1.291 0.277,1.291 0.182,0 0.364,0.026 0.312,-0.65 -0.052,-0.676 -0.104,-0.78 -0.338,-1.117 -0.234,-0.338 -0.364,-0.494 -0.234,-0.702 0.13,-0.208 0.156,-0.546 0.104,-0.806 -0.052,-0.26 -0.13,-0.649 0.312,-0.13 0.442,0.52 0.572,0.65 0.702,0.832 0.13,0.182 0.181,0.52 0.156,0.832 -0.026,0.311 0.025,0.441 0.207,0.285 0.182,-0.155 0.416,0.104 0.312,0.442 -0.104,0.338 0.026,0.546 0.338,0.65 0.312,0.104 0.442,0.182 0.52,0.416 0.078,0.234 0.338,0.337 0.338,-0.13 0,-0.468 -0.182,-1.456 -0.312,-1.767 -0.13,-0.312 -0.234,-0.988 -0.26,-1.378 -0.026,-0.39 -0.104,-0.493 -0.286,-0.571 -0.182,-0.078 -0.338,-0.208 -0.364,-0.39 -0.026,-0.182 -0.182,-0.247 -0.299,-0.247 -0.117,0 -0.22,-0.091 -0.285,-0.221 -0.065,-0.13 -0.13,-0.143 -0.26,-0.156 -0.13,-0.013 -0.338,0.065 -0.403,-0.143 -0.065,-0.208 -0.156,-0.507 -0.286,-0.676 -0.13,-0.169 -0.247,-0.221 -0.26,-0.805 -0.013,-0.585 -0.026,-0.663 -0.208,-0.871 -0.182,-0.208 -0.494,-0.753 -0.624,-0.987 -0.129,-0.234 -0.259,-0.468 -0.259,0.026 0,0.493 0,0.753 0.311,0.935 0.312,0.182 0.39,0.182 0.26,0.442 -0.13,0.26 0,0.442 0.052,0.624 0.052,0.182 0.156,0.364 0,0.545 -0.156,0.182 -0.312,0.13 -0.286,-0.155 0.026,-0.286 -0.078,-0.624 -0.207,-0.858 -0.13,-0.234 -0.234,-0.39 -0.39,-0.26 -0.156,0.13 -0.286,-0.026 -0.182,-0.13 0.104,-0.104 0.078,-0.182 0,-0.26 -0.078,-0.078 -0.104,-0.156 0.026,-0.312 0.13,-0.156 0.13,-0.234 0.052,-0.597 -0.078,-0.364 -0.65,-2.183 -0.91,-2.599 -0.26,-0.416 -0.234,-0.728 0.104,-0.312 0.338,0.416 0.624,0.78 0.65,1.117 0.026,0.338 0.104,0.546 0.208,0.676 0.104,0.13 0.182,0.078 0.234,-0.208 0.052,-0.286 0.26,-0.182 -0.104,-0.727 -0.364,-0.546 -1.04,-1.456 -1.3,-3.093 -0.26,-1.637 -0.364,-2.729 -0.624,-3.17 -0.259,-0.442 -0.337,-0.546 -0.363,-0.962 -0.026,-0.416 0,-0.832 -0.182,-1.143 -0.182,-0.312 -0.312,-0.364 -0.338,0.104 -0.026,0.467 0.026,1.507 0.156,1.689 0.13,0.182 0.052,0.649 0.026,0.909 -0.026,0.26 -0.435,0.517 0.416,1.04 0.338,0.208 0.285,0.494 0.234,0.676 -0.052,0.181 -0.104,0.155 -0.286,-0.13 -0.182,-0.286 -0.364,-0.52 -0.546,-0.676 -0.182,-0.156 -0.208,-0.26 -0.182,-0.624 0.026,-0.364 0.104,-0.624 0,-0.753 -0.104,-0.13 -0.156,-0.026 -0.208,0.181 -0.052,0.208 -0.104,0.78 -0.208,0.936 -0.104,0.156 -0.156,0.052 -0.234,-0.286 -0.078,-0.338 0.026,-0.857 0.208,-1.455 0.182,-0.598 0.286,-1.222 0.13,-2.001 -0.156,-0.78 -0.078,-1.014 -0.676,-1.663 -0.597,-0.65 -1.273,-1.274 -1.559,-2.079 -0.286,-0.806 -0.338,-1.508 -0.65,-1.872 -0.311,-0.363 -0.753,-0.831 -1.039,-0.961 0,-0.624 0,-0.91 0,-1.195 0,-0.286 -0.13,-0.468 -0.468,-0.416 -0.338,0.052 -0.546,0.338 -0.753,0.727 -0.208,0.39 -0.364,0.208 -0.65,0.884 -0.286,0.676 -0.702,1.013 -0.702,1.741 z" /></g><g
           id="g70"
           fill="#cf6200"><path
             id="path72"
             d="m 355.295,655.506 c 0.208,0.13 0.407,0.217 0.719,0.061 0.312,-0.156 0.685,-0.606 1.101,-0.164 0.415,0.441 0.649,1.169 0.649,1.741 0,0.571 0,1.637 0.65,2.235 0.65,0.597 0.987,1.221 1.013,2.001 0.026,0.779 0.312,1.975 0.39,2.287 0.078,0.311 0.26,0.675 0.468,0.883 0.208,0.208 0.364,0.806 0.39,1.429 0.026,0.624 -0.078,1.066 0,1.378 0.078,0.312 0,0.572 -0.234,0.416 -0.234,-0.156 -0.286,-0.234 -0.416,-0.494 -0.13,-0.26 -0.286,-0.208 -0.156,0.182 0.13,0.39 0.52,0.753 0.858,0.753 0.338,0 0.442,0.052 0.65,0.26 0.207,0.208 0.233,0.312 0.597,0.312 0.364,0 0.416,0 0.754,0.104 0.338,0.104 0.338,0.052 0.52,0 0.182,-0.052 0.363,0.104 0.493,0.442 0.13,0.338 0.442,1.273 0.442,1.533 0,0.26 0,0.52 0.182,0.78 0.182,0.26 0.13,0.52 -0.078,0.364 -0.208,-0.156 -0.208,-0.104 -0.364,-0.078 -0.156,0.026 -0.26,-0.052 -0.467,-0.182 -0.208,-0.13 -0.078,-0.104 -0.286,-0.416 -0.208,-0.312 -0.338,-0.416 -0.338,-0.182 0,0.234 -0.026,0.52 -0.182,0.39 -0.156,-0.13 -0.234,-0.13 -0.364,0 -0.13,0.13 -0.182,0.234 -0.338,-0.026 -0.156,-0.26 -0.338,-0.26 -0.494,-0.312 -0.156,-0.052 -0.156,-0.052 -0.233,-0.286 -0.078,-0.234 -0.312,-0.286 -0.52,-0.286 -0.208,0 -0.312,-0.104 -0.338,-0.26 -0.026,-0.155 -0.156,-0.259 -0.26,-0.337 -0.104,-0.078 -0.052,-0.26 -0.078,-0.442 -0.026,-0.182 -0.182,-0.104 -0.286,-0.156 -0.104,-0.052 -0.182,-0.026 -0.182,-0.286 0,-0.26 -0.104,-0.338 -0.182,-0.52 -0.077,-0.182 0,-0.364 0.052,-0.571 0.052,-0.208 0.026,-0.338 -0.129,-0.52 -0.156,-0.182 -0.026,-0.364 -0.442,-0.728 -0.416,-0.364 -0.624,-0.052 -0.754,-0.909 -0.13,-0.858 -0.39,-2.625 -0.624,-2.911 -0.234,-0.286 -0.389,-0.494 -0.623,-0.572 -0.234,-0.078 -0.39,-0.026 -0.416,-0.52 -0.026,-0.493 -0.182,-1.117 -0.494,-1.429 -0.312,-0.312 -0.442,-0.416 -0.598,-0.546 -0.156,-0.13 -0.208,-0.364 0,-0.805 0.208,-0.442 0.13,-1.04 0.104,-1.326 -0.026,-0.285 -0.104,-0.649 -0.052,-0.961 0.052,-0.312 0.026,-0.702 -0.052,-0.91 -0.078,-0.208 -0.182,-0.26 -0.052,-0.416 z" /></g><g
           id="g74"
           fill="#cf6200"><path
             id="path76"
             d="m 361.558,648.117 c -0.352,0.453 -0.727,0.832 -1.212,1.178 -0.485,0.347 -1.109,0.624 -0.763,1.213 0.347,0.589 0.624,0.659 0.693,1.109 0.07,0.45 0.174,0.832 0.52,0.936 0.347,0.103 0.485,0.034 0.485,0.762 0,0.728 0,1.005 0.312,1.282 0.312,0.277 0.277,0.554 0.416,1.213 0.138,0.658 0.138,2.079 0.554,3.049 0.416,0.97 1.352,2.807 1.248,3.188 -0.104,0.381 -0.243,0.658 0.173,1.108 0.416,0.451 0.693,1.109 0.728,1.49 0.034,0.382 0.104,0.52 0.519,0.382 0.416,-0.139 0.624,-0.278 0.763,-0.451 0.138,-0.173 0.415,-0.138 0.797,0.069 0.381,0.208 0.97,0.416 1.316,0.208 0.347,-0.208 0.52,-0.519 0.832,-0.519 0.485,-0.347 0.658,-1.075 0.762,-1.282 0.104,-0.208 0.035,-0.208 -0.173,-0.416 -0.208,-0.208 -0.104,-0.555 -0.139,-0.901 -0.034,-0.347 -0.173,-0.866 -0.589,-1.629 -0.415,-0.762 -0.658,-1.698 -0.935,-1.94 -0.277,-0.243 -0.416,-0.832 -0.451,-1.109 -0.034,-0.277 -0.346,-0.52 -0.554,-0.728 -0.208,-0.207 -0.416,-0.519 -0.658,-1.732 -0.243,-1.213 -0.416,-2.079 -0.416,-2.287 0,-0.208 -0.035,-0.243 -0.243,-0.312 -0.208,-0.069 -0.312,-0.416 -0.242,-0.589 0.069,-0.173 -0.07,-0.346 -0.139,-0.554 -0.069,-0.208 0,-0.589 0.139,-0.797 0.138,-0.208 0.104,-0.797 -0.035,-1.282 -0.139,-0.485 -0.277,-0.901 -0.832,-0.971 -0.554,-0.069 -0.658,-0.207 -0.866,-0.658 -0.208,-0.45 -0.416,-1.247 -0.485,-1.421 -0.069,-0.173 -0.173,-0.208 -0.589,0.139 -0.416,0.346 -0.554,0.461 -0.554,1.109 0,0.416 0.069,0.554 0.207,0.797 0.139,0.242 0.174,0.312 0.278,0.97 0.104,0.658 0.693,1.698 -0.07,2.287 -0.762,0.589 -0.658,0.728 -0.623,1.143 0.034,0.416 -0.208,0.693 -0.347,0.104 -0.138,-0.589 0,-0.935 0.416,-1.212 0.416,-0.278 0.797,-0.624 0.52,-1.005 -0.278,-0.381 -0.381,-1.282 -0.416,-1.698 -0.035,-0.416 -0.104,-0.555 -0.347,-0.243 z" /></g><g
           id="g78"
           fill="#00b800"><path
             id="path80"
             d="m 355.385,656.952 c -0.019,0.282 0.044,0.592 0.066,0.841 0.026,0.286 0.104,0.884 -0.104,1.326 -0.208,0.441 -0.156,0.675 0,0.805 0.009,0.007 0.017,0.014 0.025,0.021 0.424,-0.142 0.479,-0.615 0.365,-0.844 -0.121,-0.242 -0.086,-0.537 0.052,-0.779 0.139,-0.243 0.139,-0.381 0.018,-0.555 -0.122,-0.173 -0.122,-0.173 0.017,-0.658 0.122,-0.427 -0.186,-0.424 -0.439,-0.157 z" /></g><g
           id="g82"
           fill="#00b800"><path
             id="path84"
             d="m 359.817,663.667 c -0.078,-0.312 -0.364,-1.508 -0.39,-2.287 -0.026,-0.78 -0.363,-1.404 -1.013,-2.001 -0.507,-0.467 -0.618,-1.217 -0.642,-1.796 -0.381,-0.233 -0.542,-0.127 -0.51,0.306 0.034,0.467 0.502,0.693 0.433,1.368 -0.069,0.676 -0.069,0.503 0.26,0.832 0.329,0.329 0.45,0.641 0.277,0.78 -0.173,0.138 -0.191,0.381 0.052,0.467 0.242,0.087 0.26,0.347 0.225,0.589 -0.035,0.243 0.191,0.295 0.329,0.468 0.139,0.173 0.156,0.589 0.018,0.832 -0.139,0.242 -0.156,0.623 0.086,0.416 0.243,-0.208 0.347,-0.018 0.537,0.311 0.165,0.284 0.303,0.195 0.482,0.109 -0.062,-0.131 -0.112,-0.267 -0.144,-0.394 z" /></g><g
           id="g86"
           fill="#00b800"><path
             id="path88"
             d="m 363.196,669.722 c -0.156,0.312 -0.338,0.208 -0.494,0.052 -0.156,-0.156 -0.338,-0.156 -0.26,-0.442 0.078,-0.286 0.052,-0.338 -0.156,-0.494 -0.024,-0.018 -0.048,-0.034 -0.072,-0.05 -0.065,-0.002 -0.141,-0.002 -0.24,-0.002 -0.364,0 -0.39,-0.104 -0.597,-0.312 -0.047,-0.046 -0.088,-0.084 -0.128,-0.116 -0.004,0.05 -0.002,0.116 -0.002,0.194 0,0.286 0,0.234 -0.286,0.312 -0.286,0.078 -0.234,-0.286 -0.286,-0.52 -0.014,-0.06 -0.03,-0.104 -0.045,-0.14 -0.313,-0.06 -0.643,-0.39 -0.761,-0.743 -0.13,-0.39 0.026,-0.442 0.156,-0.182 0.13,0.26 0.182,0.338 0.416,0.494 0.234,0.156 0.312,-0.104 0.234,-0.416 -0.025,-0.1 -0.031,-0.216 -0.028,-0.345 -0.056,-0.101 -0.132,-0.183 -0.232,-0.227 -0.416,-0.182 -0.286,-0.234 -0.26,-0.572 0.026,-0.337 -0.052,-0.337 -0.312,-0.156 -0.26,0.182 -0.286,-0.026 -0.286,-0.545 0,-0.52 -0.338,-0.52 -0.415,-0.156 -0.078,0.364 -0.208,0.13 -0.364,-0.39 -0.156,-0.52 -0.364,-0.65 -0.39,-0.156 -0.022,0.418 -0.138,0.518 -0.41,0.286 0.048,0.302 0.09,0.584 0.124,0.806 0.13,0.857 0.338,0.545 0.754,0.909 0.416,0.364 0.286,0.546 0.442,0.728 0.155,0.182 0.181,0.312 0.129,0.52 -0.052,0.207 -0.129,0.389 -0.052,0.571 0.078,0.182 0.182,0.26 0.182,0.52 0,0.26 0.078,0.234 0.182,0.286 0.065,0.032 0.149,0.014 0.21,0.04 0.067,-0.088 0.128,-0.196 0.206,-0.274 0.312,-0.312 0.78,0.026 0.936,0.416 0.156,0.39 0.337,0.494 0.571,0.182 0.234,-0.312 0.156,-0.26 0.416,0.026 0.26,0.286 0.364,0.234 0.364,0.234 0,0 0.26,-0.104 0.442,0.052 0.182,0.156 0.286,0.13 0.623,-0.364 0.338,-0.494 -0.155,-0.338 -0.311,-0.026 z" /></g><g
           id="g90"
           fill="#00b800"><path
             id="path92"
             d="m 364.123,655.463 c 0.103,-0.762 0.034,-1.524 0.346,-1.802 0.312,-0.277 0.693,-0.831 0.658,0.347 -0.034,1.178 -0.069,1.109 -0.311,1.386 -0.243,0.277 -0.451,0.346 -0.208,0.797 0.242,0.45 0.277,0.485 0.242,1.178 -0.034,0.693 -0.034,0.97 0.243,1.317 0.277,0.346 0.346,0.381 0.416,0.762 0.069,0.381 0.311,0.901 0.623,1.178 0.312,0.277 0.659,1.074 0.693,1.629 0.035,0.554 0.52,0.693 0.97,1.074 0.451,0.381 -0.103,0.658 -0.45,0.485 -0.346,-0.173 -0.208,0 -0.416,0.242 -0.208,0.243 -0.277,0.278 -0.45,-0.138 -0.173,-0.416 -0.763,-0.693 -1.04,-0.797 -0.277,-0.104 -0.519,-0.555 -0.762,-1.005 -0.208,-0.387 -0.62,-0.67 -0.996,-0.699 0.104,0.292 0.16,0.521 0.13,0.63 -0.104,0.381 -0.243,0.658 0.173,1.108 0.416,0.451 0.693,1.109 0.728,1.49 0.034,0.382 0.104,0.52 0.519,0.382 0.416,-0.139 0.624,-0.278 0.763,-0.451 0.138,-0.173 0.415,-0.138 0.797,0.069 0.381,0.208 0.97,0.416 1.316,0.208 0.347,-0.208 0.52,-0.519 0.832,-0.519 0.485,-0.347 0.658,-1.075 0.762,-1.282 0.104,-0.208 0.035,-0.208 -0.173,-0.416 -0.208,-0.208 -0.104,-0.555 -0.139,-0.901 -0.034,-0.347 -0.173,-0.866 -0.589,-1.629 -0.415,-0.762 -0.658,-1.698 -0.935,-1.94 -0.277,-0.243 -0.416,-0.832 -0.451,-1.109 -0.034,-0.277 -0.346,-0.52 -0.554,-0.728 -0.208,-0.207 -0.416,-0.519 -0.658,-1.732 -0.19,-0.948 -0.337,-1.683 -0.392,-2.059 -0.249,0.397 -0.419,0.494 -0.509,0.222 -0.104,-0.311 -0.243,-0.485 -0.381,-0.277 -0.139,0.208 -0.174,-0.173 -0.174,-0.346 0,-0.174 -0.034,-0.208 -0.208,-0.208 -0.173,0 -0.034,-0.277 -0.104,-0.797 -0.069,-0.52 -0.173,-0.589 -0.242,0.035 -0.069,0.623 -0.416,1.004 -0.277,1.143 0.138,0.139 0.069,0.416 -0.07,0.832 -0.138,0.415 -0.069,0.658 0.035,0.935 0.104,0.277 -0.069,0.797 -0.139,1.248 -0.069,0.45 0.278,0.9 0.382,0.138 z" /></g><g
           id="g94"
           fill="#00b800"><path
             id="path96"
             d="m 357.79,649.235 c -0.257,0.019 -0.433,0.244 -0.286,1.031 0.092,0.487 -0.277,0.381 -0.415,0.138 -0.139,-0.242 -0.243,-0.762 -0.52,-1.213 -0.278,-0.45 -0.139,0.312 -0.173,0.728 -0.035,0.416 0.242,0.416 0.485,0.762 0.242,0.347 0.034,0.486 -0.243,0.486 -0.277,0 -0.138,0.554 -0.069,0.935 0.069,0.381 -0.069,0.451 -0.278,0.139 -0.207,-0.312 -0.069,-0.797 -0.034,-1.386 0.034,-0.589 0.069,-0.451 -0.312,-0.589 -0.381,-0.139 -0.312,-0.208 -0.173,-0.555 0.138,-0.346 0.277,-0.52 0.104,-0.693 -0.174,-0.173 -0.139,-0.277 0.138,-0.312 0.277,-0.034 0.174,-0.242 0.416,-0.312 0.243,-0.069 0.347,0.035 0.381,-0.415 0.029,-0.376 0.155,-0.607 0.437,-0.493 0.17,0.579 0.391,1.48 0.542,1.749 z" /></g><g
           id="g98"
           fill="#00b800"><path
             id="path100"
             d="m 361.281,653.315 c 0,0.728 0,1.005 0.312,1.282 0.312,0.277 0.277,0.554 0.416,1.213 0.138,0.658 0.138,2.079 0.554,3.049 0.124,0.289 0.295,0.656 0.47,1.038 0.23,-0.181 0.43,-0.492 0.501,-0.657 0.103,-0.243 -0.208,-0.728 -0.451,-1.143 -0.242,-0.416 0.035,-0.555 0.277,-1.075 0.243,-0.519 -0.034,-0.554 -0.415,-0.693 -0.382,-0.138 -0.382,-0.485 -0.59,-1.039 -0.208,-0.554 -0.173,-0.797 -0.034,-1.109 0.138,-0.312 0.034,-0.554 -0.243,-0.624 -0.277,-0.069 -0.208,-0.277 -0.104,-0.623 0.104,-0.347 0.173,-0.416 -0.242,-0.312 -0.315,0.078 -0.391,0.137 -0.485,0.251 0.023,0.1 0.034,0.239 0.034,0.442 z" /></g><g
           id="g102"
           fill="#000000"><path
             fill="#5d3100"
             id="path104"
             d="m 365.266,654.77 c -0.038,0.416 -0.035,0.624 -0.139,0.762 -0.103,0.139 -0.034,0.347 0.07,0.555 0.104,0.208 0.173,0.485 0.069,0.866 -0.104,0.381 0.069,0.693 0.277,0.797 0.208,0.104 0.312,0 0.243,0.485 -0.07,0.485 0.208,1.005 0.45,1.213 0.243,0.208 0.416,0.554 0.381,0.762 -0.034,0.208 0.174,0.416 0.416,0.52 0.243,0.104 0.208,0.139 0.208,0.277 0,0.139 0.104,0.139 0.381,0.208 0.277,0.069 0.485,0.243 0.797,0.624 0.312,0.381 0.762,0.589 0.693,0.173 -0.069,-0.416 0,-0.693 -0.416,-0.901 -0.415,-0.208 -0.727,-1.213 -0.901,-1.906 -0.173,-0.693 -0.727,-1.628 -1.039,-1.801 -0.035,-0.486 0.035,-0.728 -0.277,-0.971 -0.312,-0.242 -0.416,-0.554 -0.416,-0.797 0,-0.242 -0.173,-0.554 -0.312,-0.623 -0.138,-0.07 -0.208,-0.243 -0.208,-0.451 0,-0.208 -0.242,-0.173 -0.277,0.208 z" /></g><g
           id="g106"
           fill="#00d860"><path
             id="path108"
             d="m 363.43,673.36 c 0.623,-0.052 2.313,-0.546 2.494,-0.702 0.416,0.286 1.144,0.676 1.456,0.676 -0.598,0.13 -0.988,0.052 -1.144,-0.052 0.078,0.182 0.286,0.468 0.416,0.494 -0.572,-0.026 -1.221,-0.156 -1.429,-0.364 -0.494,0.208 -1.326,0.26 -1.793,-0.052 z" /></g><g
           id="g110"
           fill="#00d860"><path
             id="path112"
             d="m 364.547,674.14 c 0.221,0.065 1.325,0.247 1.468,0.247 -0.364,0.311 -0.052,0.61 0.559,0.558 -0.299,0.039 -0.625,0.152 -0.403,0.195 0.533,0.104 1.975,-0.286 2.261,-0.442 -0.494,0.637 -2.897,1.222 -3.885,-0.558 z" /></g><g
           id="g114"
           fill="#00d860"><path
             id="path116"
             d="m 365.535,675.725 c 0.298,-0.156 1.039,-0.104 1.39,0.065 -0.39,0.143 -1.156,0.143 -1.39,-0.065 z" /></g><g
           id="g118"
           fill="#000000"><path
             id="path120"
             d="m 366.652,675.699 c 0.533,-0.091 2.04,0.273 2.573,-0.052 -0.182,0.481 -1.131,0.546 -1.456,0.442 -0.324,-0.104 -0.636,-0.234 -0.857,-0.221 0.117,-0.065 -0.078,-0.078 -0.26,-0.169 z" /></g><g
           id="g122"
           fill="#00d860"><path
             id="path124"
             d="m 367.198,676.44 c 0.403,0.064 1.845,-0.117 2.287,-0.286 0.467,0.156 1.39,0.402 1.598,0.376 -0.442,0.273 -1.287,0.117 -1.559,0 -0.78,0.26 -1.417,0.338 -2.326,-0.09 z" /></g><g
           id="g126"
           fill="#00d860"><path
             id="path128"
             d="m 367.887,676.683 c 0.577,0.13 1.069,0.037 1.637,-0.153 0.177,0.076 0.594,0.169 0.986,0.15 0.261,0.149 0.612,0.357 0.95,0.383 -0.351,0.143 -1.638,0 -1.897,-0.143 -0.65,0.013 -1.768,0.156 -2.04,0.377 -0.013,-0.182 0.105,-0.435 0.364,-0.614 z" /></g><g
           id="g130"
           fill="#000000"><path
             id="path132"
             d="m 367.198,673.75 c 0.45,0.15 2.079,0.078 2.91,-0.312 0.328,-0.154 0.531,0.104 0.156,0.234 -1.351,0.468 -2.417,0.65 -3.196,0.234 -0.308,-0.164 -0.338,-0.312 0.13,-0.156 z" /></g><g
           id="g134"
           fill="#00d860"><path
             id="path136"
             d="m 375.176,671.541 c -2.001,0.935 -3.327,1.221 -6.107,0.364 -0.259,-0.08 -0.442,0 -0.156,0.182 0.286,0.181 1.819,0.597 2.183,0.623 0.364,0.026 0.234,0.195 0.013,0.26 -0.221,0.065 -0.286,0.221 0.013,0.104 0.299,-0.117 1.969,-0.161 2.651,0.195 0.298,0.156 0.376,0.13 0.35,0.013 -0.026,-0.117 0.13,-0.195 0.351,-0.221 0.221,-0.026 0.351,-0.104 0.182,-0.169 -0.169,-0.065 -0.195,-0.104 -0.065,-0.169 0.13,-0.065 0.143,-0.13 -0.052,-0.169 -0.195,-0.039 -0.325,-0.091 -0.143,-0.182 0.182,-0.09 0.455,-0.156 0.663,-0.181 0.052,-0.143 -0.039,-0.52 0.117,-0.65 z" /></g><g
           id="g138"
           fill="#000000"><path
             id="path140"
             d="m 371.849,671.775 c 1.144,0.081 3.249,-0.442 4.367,-1.533 0.389,0.233 0.935,0.493 1.221,0.545 0.286,0.052 0.546,0.312 0.104,0.312 -0.442,0 -1.066,-0.182 -1.351,-0.312 -1.482,0.91 -3.216,1.209 -4.315,1.118 -0.311,-0.026 -0.389,-0.156 -0.026,-0.13 z" /></g><g
           id="g142"
           fill="#00d860"><path
             id="path144"
             d="m 368.471,665.538 c 0.39,0.273 1.079,0.727 1.975,0.662 0.442,0.351 1.131,0.65 1.443,0.715 -0.598,0.247 -1.248,0.455 -1.417,0.65 -0.273,-0.26 -0.623,-0.221 -0.714,-0.351 -0.26,0.208 -0.221,0.338 -0.052,0.442 0.169,0.104 1.481,0.325 1.806,0.234 0.325,-0.091 0.412,0.178 0.143,0.272 -0.702,0.247 -2.066,0.013 -2.534,-0.74 -0.468,-0.754 -0.871,-1.04 -2.144,-0.351 -0.143,-0.364 -0.143,-0.455 -0.39,-0.455 -0.247,0 -0.702,-0.325 -0.351,-0.312 0.351,0.013 1.391,-0.143 2.235,-0.766 z" /></g><g
           id="g146"
           fill="#00d860"><path
             id="path148"
             d="m 368.783,667.214 c -0.217,0.054 -0.832,0.39 -1.052,0.416 -0.221,0.026 -0.611,0.338 -0.208,0.351 0.402,0.013 0.922,-0.429 1.208,-0.468 0.286,-0.039 0.312,-0.364 0.052,-0.299 z" /></g><g
           id="g150"
           fill="#00d860"><path
             id="path152"
             d="m 370.043,668.526 c -0.154,0.027 -0.818,0.182 -1,0.169 -0.182,-0.013 -0.364,0.039 -0.351,0.169 0.013,0.13 0.065,0.208 -0.208,0.182 -0.273,-0.026 -0.507,0.078 -0.572,0.156 -0.065,0.078 -0.117,0.156 0.156,0.182 0.273,0.026 0.416,0.052 0.728,-0.091 0.312,-0.143 0.611,-0.364 0.949,-0.377 0.337,-0.013 0.675,-0.455 0.298,-0.39 z" /></g><g
           id="g154"
           fill="#000000"><path
             id="path156"
             d="m 369.108,669.332 c 0.284,0.184 1.689,0.663 2.196,0.624 0.507,-0.039 0.412,0.203 0.026,0.286 -0.793,0.168 -1.761,-0.177 -2.417,-0.702 -0.325,-0.26 -0.026,-0.351 0.195,-0.208 z" /></g><g
           id="g158"
           fill="#00d860"><path
             id="path160"
             d="m 375.761,670.021 c -1.075,0.343 -2.17,0.221 -2.612,0.104 -0.442,-0.117 -0.845,-0.143 -0.546,0.143 0.299,0.285 1.261,0.48 1.806,0.337 -1.936,0.442 -2.443,0.403 -2.923,0.325 -0.481,-0.078 -1.384,-0.061 -1.767,-0.026 -0.286,0.026 -0.676,-0.013 -0.845,-0.117 -0.169,-0.104 -0.221,-0.299 0.286,-0.247 0.506,0.052 0.572,-0.052 0.13,-0.117 -0.442,-0.065 -1.053,0.117 -0.455,0.494 0.598,0.377 1.91,-0.026 2.742,0.208 0.831,0.234 2.598,0.403 4.275,-0.949 0.086,-0.069 0.234,-0.259 -0.091,-0.155 z" /></g><g
           id="g162"
           fill="#00d860"><path
             id="path164"
             d="m 370.485,668.435 c 0.039,0.13 0.039,0.273 0,0.364 -0.039,0.091 -0.039,0.208 0.13,0.078 0.169,-0.13 0.273,-0.286 0.442,-0.195 0.169,0.091 0.598,0.078 0.792,0.052 0.196,-0.026 0.26,-0.065 -0.025,-0.182 -0.286,-0.117 -0.572,-0.156 -0.728,-0.143 -0.156,0.013 -0.351,-0.026 -0.481,-0.078 -0.13,-0.052 -0.169,-0.026 -0.13,0.104 z" /></g><g
           id="g166"
           fill="#00d860"><path
             id="path168"
             d="m 373.253,668.942 c -0.221,0.013 -0.611,-0.13 -0.819,-0.221 -0.208,-0.091 -0.506,-0.104 -0.285,0.195 0.22,0.299 1.182,0.468 1.52,0.325 0.338,-0.143 0.195,-0.299 0.532,-0.091 0.338,0.208 0.689,0.351 0.936,0.351 0.247,0 0.338,0 0.065,-0.156 -0.273,-0.156 -0.403,-0.195 -0.429,-0.325 -0.026,-0.13 -0.065,-0.208 0.182,-0.13 0.247,0.078 0.533,0.221 0.728,0.117 0.195,-0.104 0.558,-0.338 0.883,-0.338 l 0.078,-0.195 c -0.468,-0.039 -0.766,0.104 -0.896,0.156 -0.13,0.052 -0.364,0.078 -0.611,0.039 -0.247,-0.039 -0.572,-0.065 -0.65,-0.13 -0.078,-0.065 -0.078,-0.117 0.13,-0.156 0.208,-0.039 0.273,-0.182 -0.013,-0.13 -0.286,0.052 -1.052,0.026 -1.455,-0.104 -0.403,-0.129 -0.572,-0.142 -0.741,-0.078 -0.169,0.065 -0.143,0.247 0.104,0.26 0.247,0.013 0.806,0.065 1.001,0.247 0.195,0.182 0.169,0.195 -0.052,0.104 -0.221,-0.091 -0.624,-0.039 -0.208,0.26 z" /></g><g
           id="g170"
           fill="#00d860"><path
             id="path172"
             d="m 376.644,668.474 -0.078,0.195 c 0.481,-0.013 1.651,0.104 2.027,0.338 0.364,-0.286 0.299,-0.377 0.559,-0.325 0.26,0.052 0.585,0.143 0.728,0.065 0.143,-0.078 0.247,-0.065 0.403,-0.039 0.155,0.026 0.493,-0.039 0.688,-0.156 0.195,-0.117 0.598,-0.273 0.832,-0.273 0.234,0 0.519,-0.052 0.091,-0.117 -0.429,-0.065 -1.079,0.065 -1.3,0.143 -0.22,0.078 -0.883,0.13 -1.273,0.13 -0.39,0 -0.922,0.195 -1.364,0.078 -0.442,-0.117 -1.053,-0.039 -1.313,-0.039 z" /></g><g
           id="g174"
           fill="#000000"><path
             id="path176"
             d="m 382.66,668.24 c -0.779,0.572 -1.715,0.702 -2.832,0.78 -0.325,0.023 -0.225,0.115 0.052,0.143 1.169,0.117 2.521,-0.312 2.962,-0.78 0.128,-0.135 0.114,-0.359 -0.182,-0.143 z" /></g><g
           id="g178"
           fill="#00d860"><path
             id="path180"
             d="m 377.346,669.566 c 0.338,0.013 1.507,0.312 1.884,0.442 0.286,-0.026 0.364,-0.091 0.312,-0.195 -0.052,-0.104 -0.091,-0.221 0.429,-0.195 0.519,0.026 1.715,0.013 1.936,0.013 0.182,-0.078 0.584,-0.39 0.766,-0.403 -0.467,0.026 -2.416,0.13 -2.663,0.104 -0.247,-0.026 -0.377,0 -0.533,0.091 -0.156,0.091 -0.247,0.13 -0.442,0.052 -0.195,-0.078 -0.546,-0.182 -0.74,-0.065 -0.195,0.117 -0.598,0.013 -0.949,0.156 z" /></g><g
           id="g182"
           fill="#00d860"><path
             id="path184"
             d="m 381.907,669.631 c 0.182,-0.078 0.584,-0.39 0.766,-0.403 0.338,-0.026 0.728,0.117 0.91,0.143 0.182,0.026 0.377,-0.013 0.247,-0.156 -0.13,-0.143 -0.013,-0.39 0.52,-0.325 0.532,0.065 0.805,0.156 1.325,0.104 0.52,-0.052 0.754,0.338 1.741,-0.052 -0.078,0.39 0.104,0.416 0.286,0.338 0.182,-0.078 0.39,-0.052 0.702,0.182 0.312,0.234 2.209,0.26 2.651,0.182 0.441,-0.078 0.675,0.156 0.337,0.26 -0.337,0.104 -0.416,0.26 -0.337,0.364 0.077,0.103 0.155,0.233 -0.26,0.181 -0.416,-0.052 -0.494,0.078 -0.702,0.234 -0.208,0.156 -0.26,0.208 -0.832,0.104 -0.571,-0.104 -0.675,-0.026 -0.987,0.026 -0.312,0.052 -0.39,0.052 -0.702,-0.052 -0.312,-0.104 -0.987,-0.208 -1.403,-0.078 -0.416,0.13 -0.728,0.26 -1.092,0.156 -0.364,-0.104 -0.39,-0.052 -0.156,-0.286 0.234,-0.234 0.286,-0.208 0.728,-0.26 0.442,-0.051 0.78,-0.181 0.468,-0.363 -0.312,-0.182 -0.416,-0.156 -0.832,0.052 -0.416,0.208 -0.624,0.337 -1.091,0.078 -0.468,-0.26 -0.702,-0.208 -1.014,-0.13 -0.312,0.078 -0.831,-0.104 -1.273,-0.299 z" /></g><g
           id="g186"
           fill="#00d860"><path
             id="path188"
             d="m 383.466,670.41 c -0.595,0.085 -0.755,-0.298 -1.377,-0.22 -0.208,0.026 -0.559,0.285 -0.078,0.246 0.48,-0.039 1,0.221 1.468,0.182 0.468,-0.039 0.26,-0.247 -0.013,-0.208 z" /></g><g
           id="g190"
           fill="#00d860"><path
             id="path192"
             d="m 382.777,670.865 c 0.313,-0.114 0.962,0.104 1.235,0.052 0.273,-0.052 0.533,0.117 0.247,0.208 -0.286,0.091 -0.975,-0.169 -1.287,-0.078 -0.312,0.091 -0.623,-0.026 -0.195,-0.182 z" /></g><g
           id="g194"
           fill="#00d860"><path
             id="path196"
             d="m 376.566,672.541 c 0.429,0.014 1.975,-0.052 2.586,-1.351 0.047,-0.1 0.091,-0.143 0.286,-0.013 0.195,0.13 0.91,0.559 2.248,0.676 0.375,0.033 0.78,0.221 0.026,0.169 -0.754,-0.052 -1.949,-0.26 -2.352,-0.507 -0.676,1.065 -1.89,1.191 -2.794,1.169 -0.545,-0.013 -0.415,-0.156 0,-0.143 z" /></g><g
           id="g198"
           fill="#00d860"><path
             id="path200"
             d="m 379.906,670.774 c -0.208,0.286 -0.923,0.78 -1.248,0.806 -0.324,0.026 -1.299,-0.065 -1.546,-0.156 -0.247,-0.091 -0.546,-0.065 -0.195,0.182 0.351,0.247 1.222,0.416 1.572,0.338 0.351,-0.078 0.754,-0.195 1.027,-0.026 0.273,0.169 0.78,0.493 1.078,0.428 0.299,-0.064 0.91,-0.064 1.105,0.026 0.195,0.091 0.533,0.364 0.026,0.208 -0.507,-0.156 -0.923,-0.026 -1.157,-0.13 0.26,0.364 0.85,0.949 1.352,0.949 0.117,0 0.195,0.208 -0.052,0.325 0.247,0.117 0.818,0.208 1.117,-0.065 -0.078,0.104 -0.039,0.169 0.091,0.234 0.13,0.065 0.286,0.156 0.052,0.182 -0.234,0.026 -0.766,0.091 -0.922,0.026 0.506,0.324 1.819,0.844 3.157,0.584 0.255,-0.049 0.39,-0.155 -0.026,-0.143 -0.858,0.026 -0.909,0.013 -1.065,-0.077 -0.156,-0.092 -0.13,-0.169 0.117,-0.247 0.246,-0.078 0.87,-0.169 1.13,-0.169 0.26,0 0.52,-0.104 -0.013,-0.104 -0.533,0 -1.182,0 -1.442,-0.091 -0.26,-0.091 -0.455,-0.208 -0.182,-0.39 0.273,-0.182 0.559,-0.13 0.689,-0.299 -0.858,-0.013 -1.911,-0.468 -1.326,-0.883 0.136,-0.097 0.091,-0.104 -0.13,-0.13 -0.221,-0.026 -0.87,-0.208 -1.143,-0.364 -0.273,-0.156 -0.091,-0.286 0.13,-0.325 -0.507,0.091 -1.521,-0.182 -2.196,-0.689 z" /></g><g
           id="g202"
           fill="#00d860"><path
             id="path204"
             d="m 387.533,670.748 c -0.468,0.351 -1.351,0.494 -1.728,0.494 -0.377,0 -0.429,0.13 -0.13,0.169 0.299,0.039 0.624,0.078 0.754,0.039 0.13,-0.039 0.208,-0.052 0.402,0.039 0.195,0.091 0.611,0.143 0.975,0.026 0.364,-0.117 0.961,-0.169 1.208,-0.156 0.247,0.013 0.52,0.026 0.026,-0.117 -0.493,-0.143 -1.299,-0.039 -1.494,0.013 -0.195,0.052 -0.728,0.013 -0.442,-0.078 0.286,-0.091 0.533,-0.234 0.676,-0.351 -0.104,-0.026 -0.169,-0.052 -0.247,-0.078 z" /></g><g
           id="g206"
           fill="#00d860"><path
             id="path208"
             d="m 387.286,671.762 c -0.403,0.299 -0.987,0.584 -1.585,0.61 0.546,0.195 1.001,0.754 1.351,0.728 -0.169,0.104 -0.376,0.26 -0.597,0.286 0.338,0.091 0.909,-0.013 1.377,-0.273 0.78,0.221 1.793,0.078 2.131,-0.208 -0.507,0 -1.117,-0.182 -1.39,-0.416 0.247,0 0.48,-0.156 0.597,-0.298 -0.584,0.103 -1.585,-0.182 -1.884,-0.429 z" /></g><g
           id="g210"
           fill="#00d860"><path
             id="path212"
             d="m 386.455,673.386 c 0.221,-0.026 0.428,-0.182 0.597,-0.286 -0.428,0.143 -2.3,-0.156 -2.858,-0.65 -0.559,-0.493 -0.559,-0.117 -0.169,0.234 0.39,0.351 1.078,0.884 2.43,0.702 z" /></g><g
           id="g214"
           fill="#00d860"><path
             id="path216"
             d="m 387.832,674.581 c -0.234,0.13 -1.351,0.208 -1.715,0.13 -0.364,-0.078 -0.52,-0.039 -0.429,0.104 0.091,0.143 0.13,0.273 -0.169,0.234 -0.299,-0.039 -0.832,0.026 -1.052,0.104 -0.221,0.078 -0.494,0.273 -0.026,0.195 0.467,-0.078 0.896,-0.169 1.247,-0.078 0.351,0.091 1.598,0.117 1.845,0.013 0.247,-0.104 0.078,-0.104 -0.039,-0.104 -0.117,0 -0.169,-0.078 0,-0.156 0.169,-0.078 0.299,-0.299 0.338,-0.442 z" /></g><g
           id="g218"
           fill="#00d860"><path
             id="path220"
             d="m 377.021,673.074 c -0.468,0.208 -2.027,0.624 -2.443,0.65 -0.52,0.234 -0.935,0.364 -1.195,0.364 0.182,0.156 0.883,0.311 1.169,0.234 -0.156,0.155 -0.519,0.337 -0.649,0.415 0.415,-0.052 0.909,0.052 1.117,0.078 -0.546,0.312 -1.299,0.416 -1.689,0.364 0.13,0.182 0.312,0.364 0.546,0.364 -0.494,0.13 -1.092,0.13 -1.404,0.026 0.13,0.26 0.26,0.416 0.442,0.442 -0.416,0.052 -0.936,0.13 -1.377,-0.13 0.337,0.442 1.091,0.597 2.209,0.468 1.117,-0.13 2.053,-0.624 2.313,-0.832 -0.468,0.052 -1.092,0.078 -1.404,0.026 0.624,-0.156 1.975,-0.728 2.209,-0.962 -0.26,0 -0.519,-0.078 -0.702,-0.208 0.364,0.052 1.638,-0.103 2.028,-0.259 -0.468,-0.104 -0.754,-0.39 -0.884,-0.572 1.637,0.52 3.459,0.35 4.34,0.13 0.208,-0.052 0.233,-0.316 -0.182,-0.286 -0.728,0.052 -2.131,-0.156 -2.495,-0.338 0.338,0.26 0.754,0.416 1.04,0.468 -0.676,0.182 -1.611,0.312 -2.989,-0.442 z" /></g><g
           id="g222"
           fill="#00d860"><path
             id="path224"
             d="m 373.903,674.737 c 0.13,-0.078 0.493,-0.26 0.649,-0.415 -0.286,0.077 -0.987,-0.078 -1.169,-0.234 0.26,0 0.675,-0.13 1.195,-0.364 -0.935,-0.026 -1.585,-0.026 -1.923,-0.208 -0.338,-0.182 -0.961,-0.13 -1.195,-0.078 -0.234,0.052 -0.156,0.442 0.831,0.338 -0.416,0.286 -1.533,0.39 -1.949,0.286 0.104,0.337 0.182,0.675 0.078,0.857 0.546,0.312 1.975,0.702 2.677,0.65 -0.624,-0.234 -0.962,-0.494 -0.442,-0.546 0.52,-0.052 0.806,-0.156 1.248,-0.286 z" /></g><g
           id="g226"
           fill="#000000"><path
             id="path228"
             d="m 372.291,676.427 c 1.244,-0.104 2.91,-0.126 4.236,-1.248 0.338,-0.286 0.565,-0.19 0.234,0.104 -0.701,0.624 -2.443,1.481 -4.106,1.507 -0.677,0.011 -0.987,-0.312 -0.364,-0.363 z" /></g><g
           id="g230"
           fill="#00d860"><path
             id="path232"
             d="m 381.608,674.373 c -0.312,0.117 -1.183,0.26 -1.442,0.221 -0.26,-0.039 -0.637,-0.052 -0.845,0.078 -0.208,0.13 -0.221,0.208 0.065,0.234 0.286,0.026 0.65,0.052 0.832,0.039 -0.234,0.13 -0.39,0.312 -0.442,0.39 0.416,-0.104 1.182,0.078 1.403,0.208 -0.169,0.052 -0.364,-0.013 -0.507,-0.091 0.702,0.741 2.781,0.741 3.119,0.611 -0.156,0.117 -0.299,0.234 -0.455,0.273 0.585,0.104 1.26,0.091 1.923,-0.299 -0.221,0.039 -0.883,-0.026 -1.052,-0.039 0.13,-0.13 0.324,-0.247 0.506,-0.299 -0.259,-0.052 -1.078,-0.026 -1.273,0.078 0.078,-0.156 0.221,-0.351 0.377,-0.416 -1.027,0 -2.274,-0.013 -2.729,-0.26 0.728,0.078 1.534,-0.351 1.871,-0.351 -0.571,-0.013 -1.195,-0.143 -1.351,-0.377 z" /></g><g
           id="g234"
           fill="#00d860"><path
             id="path236"
             d="m 378.996,674.945 c -0.507,0.104 -1.273,0.312 -1.481,0.429 -0.208,0.117 -0.429,0.182 0.026,0.182 0.455,0 1.689,0.052 1.962,0.091 -0.689,-0.104 -1.624,-0.13 -1.806,-0.13 -0.182,0 -0.39,-0.013 -0.052,-0.117 0.338,-0.104 0.78,-0.338 1.351,-0.455 z" /></g><g
           id="g238"
           fill="#00d860"><path
             id="path240"
             d="m 377.97,676.154 c 0.181,0 0.974,0 1.286,-0.273 0.325,0.247 0.949,0.597 1.351,0.597 0.403,0 0.364,0.104 0.013,0.143 -0.35,0.039 -1.039,-0.168 -1.39,-0.428 -0.468,0.169 -0.857,0.026 -1.26,-0.039 z" /></g><g
           id="g242"
           fill="#00d860"><path
             id="path244"
             d="m 371.954,679.649 c 0.805,0.312 1.871,0.546 2.65,0.286 0.442,0.39 1.352,0.416 1.845,0.312 0.494,-0.104 0.936,-0.156 1.482,0.026 0.545,0.182 1.663,0.195 1.975,0.454 -0.286,0.014 -0.897,0 -1.04,0.04 -0.143,0.038 -0.065,0.129 0.195,0.272 -0.883,-0.052 -2.404,0.325 -2.871,0.728 0.168,-0.403 0.688,-0.949 1.507,-0.949 -0.468,-0.168 -1.962,-0.181 -2.443,0.117 -0.143,-0.156 -0.312,-0.415 -0.325,-0.519 -0.792,0.454 -2.352,-0.195 -2.975,-0.767 z" /></g><g
           id="g246"
           fill="#00d860"><path
             id="path248"
             d="m 369.887,678.194 c 0.959,-0.137 1.612,-0.442 1.898,-0.728 0.169,0.156 0.87,0.312 1.637,0.078 -0.156,0.117 -0.169,0.338 -0.104,0.455 -0.507,0.013 -1.469,0.26 -1.793,0.429 -0.325,0.168 -1.274,0.285 -1.585,0.116 -0.312,-0.168 -0.325,-0.311 -0.053,-0.35 z" /></g><g
           id="g250"
           fill="#00d860"><path
             id="path252"
             d="m 373.318,677.999 c -0.507,0.013 -1.469,0.26 -1.793,0.429 0.065,0.13 0.104,0.337 0.117,0.48 0.935,-0.338 3.079,-0.545 3.898,-0.415 -0.39,0.026 -1.131,0.428 -1.546,0.48 1.013,-0.078 2.001,0.13 2.26,0.195 0.26,0.065 0.312,0.26 0.117,0.442 -0.195,0.182 -0.285,0.208 0.13,0.221 0.416,0.013 1.274,-0.039 1.664,-0.416 -0.156,-0.169 -0.559,-0.104 -0.676,-0.221 0.273,-0.091 0.585,-0.286 0.702,-0.429 -0.702,-0.013 -0.962,-0.026 -1.196,-0.078 -0.234,-0.051 -0.403,-0.117 -0.117,-0.272 0.286,-0.156 0.416,-0.286 0.507,-0.39 -0.507,0.143 -1.299,0.26 -1.962,-0.26 0.247,0.065 0.831,0.026 1.039,-0.065 -0.221,-0.117 -0.402,-0.208 -0.584,-0.208 0.532,-0.26 1.585,-0.494 2.884,0.026 0.65,-0.052 1.352,-0.026 1.845,0.104 0.208,-0.208 0.65,-0.702 0.884,-0.832 -1.533,0.13 -4.288,-0.156 -4.236,-0.961 -0.494,0.649 -1.637,1.013 -2.131,0.909 -0.052,0.234 0.156,0.52 0.338,0.676 -0.52,0.104 -1.404,0.182 -1.819,0.104 0.234,0.234 0.675,0.442 0.935,0.416 -0.545,0 -0.831,0.104 -1.26,0.065 z" /></g><g
           id="g254"
           fill="#00d860"><path
             id="path256"
             d="m 376.501,679.831 c 0.416,0.013 1.274,-0.039 1.664,-0.416 -0.156,-0.169 -0.559,-0.104 -0.676,-0.221 0.273,-0.091 0.585,-0.286 0.702,-0.429 1.091,-0.09 2.066,-0.038 2.533,-0.181 0.468,-0.143 1.664,-0.065 1.898,-0.13 -1.04,0.168 -1.248,0.259 -1.3,0.428 -0.052,0.169 0.338,0.312 0.585,0.312 -0.468,-0.026 -1.053,0.468 -1.105,0.663 -0.623,-0.364 -0.922,0.065 -0.987,0.208 -0.26,-0.104 -1.118,-0.078 -1.56,0.299 -0.571,-0.169 -0.948,-0.26 -1.52,-0.169 0.351,-0.078 0.286,-0.312 -0.234,-0.364 z" /></g><g
           id="g258"
           fill="#00d860"><path
             id="path260"
             d="m 381.491,676.79 c 0.351,-0.013 1.117,0.026 1.39,-0.013 -0.182,0.091 -0.415,0.26 -0.467,0.338 0.883,-0.104 2.091,-0.169 2.442,-0.117 -0.428,-0.065 -0.87,0.208 -1.091,0.351 -0.221,0.143 -0.091,0.234 0.208,0.273 0.299,0.039 0.702,0.273 0.156,0.195 -0.546,-0.078 -1.624,-0.078 -1.884,-0.039 -0.26,0.039 -0.403,-0.091 -0.026,-0.143 0.377,-0.052 0.636,-0.182 0.818,-0.286 -0.312,0.078 -0.909,0.078 -1.091,0.026 -0.182,-0.052 -0.299,-0.156 -0.091,-0.208 0.208,-0.052 0.065,-0.13 -0.156,-0.104 -0.221,0.026 -0.78,0.26 -1.092,0.559 0.338,-0.351 0.637,-0.663 0.884,-0.832 z" /></g><g
           id="g262"
           fill="#000000"><path
             id="path264"
             d="m 377.528,677.375 c 0.429,0.481 0.935,0.754 1.741,0.78 0.169,0.005 0.484,0.232 0.078,0.247 -1.092,0.039 -1.637,-0.221 -2.118,-0.923 -0.099,-0.144 0.084,-0.345 0.299,-0.104 z" /></g><g
           id="g266"
           fill="#000000"><path
             id="path268"
             d="m 384.038,668.292 c 0.574,0.271 1.728,0.507 2.625,0.468 0.156,-0.007 0.47,0.16 0.077,0.195 -1.013,0.091 -1.923,-0.051 -2.767,-0.52 -0.234,-0.13 -0.156,-0.247 0.065,-0.143 z" /></g><g
           id="g270"
           fill="#00d860"><path
             id="path272"
             d="m 384.623,668.279 c 0.883,-0.026 1.546,-0.013 1.819,0.247 0.506,-0.156 1.416,-0.247 1.624,-0.208 0.208,0.039 0.442,-0.052 -0.039,-0.169 -0.481,-0.116 -1.598,-0.155 -1.949,-0.09 -0.351,0.064 -1.443,0.103 -1.806,0.064 0.156,0.026 0.259,0.052 0.351,0.156 z" /></g><g
           id="g274"
           fill="#00d860"><path
             id="path276"
             d="m 388.053,668.63 c 0.416,-0.221 1.611,-0.013 1.975,-0.169 -0.26,0.312 0.832,0.338 1.78,0.091 -0.364,0.234 -1.143,0.273 -1.481,0.416 -0.338,0.143 -0.52,0.039 -0.78,-0.078 -0.26,-0.117 -0.922,-0.351 -1.494,-0.26 z" /></g><g
           id="g278"
           fill="#00d860"><path
             id="path280"
             d="m 391.808,668.552 c -0.948,0.247 -2.04,0.221 -1.78,-0.091 -0.364,0.156 -1.559,-0.052 -1.975,0.169 0.429,-0.26 0.754,-0.052 1.065,-0.585 0.195,0.04 0.65,0.066 0.806,-0.142 0.273,0.065 0.754,0.182 0.897,0.324 0.143,0.143 0.363,-0.039 0.181,-0.259 0.429,-0.156 0.157,0.185 1.157,-0.065 0.208,-0.052 0.715,-0.143 0.884,-0.156 -0.338,0.273 -0.741,0.571 -1.235,0.805 z" /></g><g
           id="g282"
           fill="#ffff00"><path
             id="path284"
             d="m 373.356,664.193 c -0.017,-1.966 -0.207,-18.422 -0.207,-22.226 0,-0.91 -0.468,-0.728 -0.468,0 0,0.689 0,20.07 0,22.122 0.215,0.039 0.505,0.078 0.675,0.104 z" /></g><g
           id="g286"
           fill="#ffff00"><path
             id="path288"
             d="m 380.587,640.771 0.812,23.461 -0.142,0.188 -0.471,0.007 -0.513,-23.656 z" /></g><g
           id="g290"
           fill="#ffff00"><path
             id="path292"
             d="m 387.43,660.581 c -0.066,-2.389 -0.366,-13.448 -0.482,-18.9 -0.015,-0.727 -0.448,-0.6 -0.441,0.026 0.047,4.391 0.308,16.672 0.356,18.887 0.17,0 0.463,-0.017 0.567,-0.013 z" /></g><g
           id="g294"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path296"
             d="m 376.605,644.67 -6.913,-0.104 c -0.389,1.403 1.352,1.377 2.002,1.013 0.753,0.572 1.325,0.52 1.741,0.052 0.598,0.494 1.351,0.364 1.663,0.052 0.832,0.624 1.689,0 1.507,-1.013 z" /></g><g
           id="g298"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path300"
             d="m 377.125,648.152 -7.069,-0.026 c -1.221,1.169 0.364,1.741 1.716,0.935 0.182,0.39 1.013,0.624 1.663,0.312 0.598,0.468 1.351,0.13 1.741,-0.26 0.728,0.338 1.585,0.442 1.949,-0.961 z" /></g><g
           id="g302"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path304"
             d="m 376.917,652.57 -6.809,-0.052 c -0.13,1.221 1.248,1.065 1.793,0.754 0.52,0.805 1.664,0.623 2.106,0.155 0.649,0.442 1.247,0.338 1.585,-0.078 0.754,0.65 1.377,-0.181 1.325,-0.779 z" /></g><g
           id="g306"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path308"
             d="m 377.255,656.988 -7.614,-0.13 c -0.416,1.299 0.753,1.533 1.299,1.221 0.182,0.754 1.195,0.494 1.455,-0.052 0.39,0.39 0.884,0.182 1.118,-0.078 0.104,0.702 0.987,0.728 1.663,0.13 1.377,0.962 2.677,-0.156 2.079,-1.091 z" /></g><g
           id="g310"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path312"
             d="m 384.012,655.169 -6.341,-0.052 c 0.286,1.299 0.909,1.637 1.923,0.883 0.754,0.78 2.001,0.494 2.313,0.104 1.377,1.118 2.131,-0.182 2.105,-0.935 z" /></g><g
           id="g314"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path316"
             d="m 383.362,650.829 -6.133,-0.182 c 0.104,1.559 1.585,1.507 2.339,0.831 0.572,0.728 1.585,0.52 1.949,0 0.78,0.78 2.053,0.312 1.845,-0.649 z" /></g><g
           id="g318"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path320"
             d="m 384.168,645.943 h -6.601 c 0.078,1.091 1.533,1.715 2.651,0.676 0.311,1.247 1.507,0.857 2.027,0.363 0.753,0.962 2.494,-0.129 1.923,-1.039 z" /></g><g
           id="g322"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path324"
             d="m 383.778,642.617 -5.899,0.078 c -0.104,0.961 1.299,1.377 1.819,0.597 0.286,0.494 1.273,0.442 1.559,-0.026 0.468,0.728 1.04,0.234 1.221,0 0.676,0.494 1.404,0.26 1.3,-0.649 z" /></g><g
           id="g326"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path328"
             d="m 390.691,644.774 -7.225,-0.078 c -0.026,0.753 0.754,1.065 1.221,0.753 0,0.728 1.014,0.962 1.664,0.39 0.442,0.624 1.741,0.806 2.261,-0.052 1.065,0.884 2.209,0.26 2.079,-1.013 z" /></g><g
           id="g330"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path332"
             d="m 390.587,650.699 -7.069,-0.026 c 0.052,0.987 1.195,1.325 1.845,0.805 0.156,0.832 1.04,0.884 1.559,0.468 0.624,0.702 1.664,0.754 2.235,-0.026 0.858,0.312 1.508,-0.416 1.43,-1.221 z" /></g><g
           id="g334"
           fill="#ffff00"><path
             fill="#ffffff"
             id="path336"
             d="m 390.223,656.026 -5.588,-0.078 c 0,0.988 1.17,1.118 1.69,0.598 0.545,0.65 1.377,0.65 1.845,0.13 0.753,0.65 1.897,0.468 2.053,-0.65 z" /></g><g
           id="g338"
           fill="#000000"><path
             id="path340"
             d="m 381.257,664.42 c -3.014,0.052 -6.081,0.052 -8.16,-0.26 -2.079,-0.312 -2.734,-0.604 -4.158,-1.455 -2.131,-1.273 -2.651,-1.585 -5.665,-3.352 -0.462,-0.271 -0.963,0.065 -0.312,0.493 3.04,2.001 4.192,2.743 5.639,3.691 1.507,0.987 2.479,1.864 3.404,2.91 1.196,1.352 2.079,1.378 2.625,1.17 0.546,-0.208 1.404,-0.494 2.261,-0.286 0.858,0.208 2.001,0.234 2.599,0.13 0.546,0.494 1.793,0.39 2.495,0.234 0.701,-0.156 1.221,-0.234 1.715,-0.13 0.494,0.104 1.247,0.026 1.741,-0.052 0.494,-0.078 1.793,-0.208 2.703,-0.078 0.909,0.13 1.845,0.052 2.443,-0.13 0.597,-0.182 1.689,-0.13 2.053,-0.026 0.519,-0.39 0.779,-0.884 0.909,-1.403 0.611,-0.078 0.814,-0.154 0.949,-0.507 0.247,-0.65 0.48,-1.287 0.559,-1.572 h 0.246 l 0.078,-0.585 -0.506,-0.585 0.182,-1.117 0.545,-0.13 c 0.026,-0.338 -0.13,-0.858 -0.234,-1.066 -3.274,0.13 -6.484,0.234 -8.783,0.286 -0.26,0.208 -0.546,0.754 -0.598,1.092 -1.403,0.233 -2.235,0.337 -2.599,0.415 -0.364,0.078 -0.567,0.107 -0.857,0.494 -0.468,0.624 -0.91,1.351 -1.274,1.819 z" /></g><g
           id="g342"
           fill="#000000"><path
             id="path344"
             d="m 391.779,660.45 c 0.159,-0.551 0.584,-2.035 1.354,-4.84 0.129,-0.468 -0.325,-0.653 -0.493,-0.052 -0.916,3.275 -1.262,4.503 -1.378,4.912 0.176,-0.003 0.428,-0.022 0.517,-0.02 z" /></g><g
           id="g346"
           fill="#ffffff"><path
             id="path348"
             d="m 396.85,654.961 c -1.105,0.571 -1.638,0.792 -2.144,0.597 -0.466,-0.179 -1.151,-0.28 -1.552,-0.083 -10e-4,0.042 -0.007,0.087 -0.021,0.135 -0.474,1.727 -0.817,2.952 -1.048,3.768 0.818,0.289 2.227,0.328 2.556,-0.025 0.337,-0.364 1.26,-0.286 1.728,-0.26 0.299,-0.39 0.416,-0.871 0.338,-1.105 -0.078,-0.234 -0.052,-0.649 0.065,-0.974 0.117,-0.325 0.273,-1.378 0.078,-2.053 z" /></g><g
           id="g350"
           fill="none"><path
             id="path352"
             d="m 371.694,645.579 c -1.222,3.534 -5.458,11.461 -8.014,14.014" /></g><g
           id="g354"
           fill="none"><path
             id="path356"
             d="m 365.642,660.746 c 2.901,-2.244 10.236,-9.528 11.483,-12.594" /></g><g
           id="g358"
           fill="none"><path
             id="path360"
             d="m 370.108,652.518 c -0.337,2.677 -1.11,7.452 -1.526,9.973" /></g><g
           id="g362"
           fill="none"><path
             id="path364"
             d="m 371.245,658.485 c -0.987,0.962 -2.387,2.641 -3.427,3.551" /></g><g
           id="g366"
           fill="none"><path
             id="path368"
             d="m 380.542,653.142 c -0.831,0.805 -1.78,1.744 -2.611,1.978" /></g><g
           id="g370"
           fill="none"><path
             id="path372"
             d="m 381.02,653.272 c 0.731,0.779 1.77,1.659 2.628,1.893" /></g><g
           id="g374"
           fill="none"><path
             id="path376"
             d="m 380.451,648.958 c -0.753,0.649 -1.871,1.413 -2.884,1.699" /></g><g
           id="g378"
           fill="none"><path
             id="path380"
             d="m 380.877,649.113 c 0.65,0.546 1.342,1.342 2.173,1.706" /></g><g
           id="g382"
           fill="none"><path
             id="path384"
             d="m 377.723,645.943 c 0.805,-0.234 2.004,-0.858 2.628,-1.507" /></g><g
           id="g386"
           fill="none"><path
             id="path388"
             d="m 380.708,644.306 c 0.705,0.805 2.056,1.455 2.732,1.637" /></g><g
           id="g390"
           fill="none"><path
             id="path392"
             d="m 377.879,642.695 c 0.831,-0.182 1.861,-0.624 2.407,-1.404" /></g><g
           id="g394"
           fill="none"><path
             id="path396"
             d="m 380.598,641.083 c 0.701,0.598 1.933,1.462 2.738,1.54" /></g><g
           id="g398"
           fill="none"><path
             id="path400"
             d="m 386.529,643.409 c -0.451,0.468 -1.556,1.309 -2.257,1.296" /></g><g
           id="g402"
           fill="none"><path
             id="path404"
             d="m 386.987,643.37 c 0.325,0.52 1.144,1.316 1.612,1.381" /></g><g
           id="g406"
           fill="none"><path
             id="path408"
             d="m 383.804,650.673 c 0.909,-0.312 2.183,-1.056 2.82,-1.823" /></g><g
           id="g410"
           fill="none"><path
             id="path412"
             d="m 387.124,648.906 c 0.266,0.48 1.28,1.565 1.852,1.786" /></g><g
           id="g414"
           fill="none"><path
             id="path416"
             d="m 384.882,655.951 c 0.416,-0.09 1.547,-0.652 1.858,-1.315" /></g><g
           id="g418"
           fill="none"><path
             id="path420"
             d="m 387.26,654.272 c 0.429,0.533 1.481,1.507 2.131,1.741" /></g><g
           id="g422"
           fill="none"><path
             id="path424"
             d="m 370.576,656.874 c 1.273,-0.403 3.846,-1.965 5.12,-3.447" /></g><g
           id="g426"
           fill="none"><path
             id="path428"
             d="m 373.263,655.299 c 1.065,0.753 2.303,1.507 3.251,1.676" /></g><g
           id="g430"
           fill="none"><path
             id="path432"
             d="m 370.342,652.521 c 0.702,-0.299 1.624,-0.809 2.339,-1.549" /></g><g
           id="g434"
           fill="none"><path
             id="path436"
             d="m 373.217,650.868 c 0.286,0.402 2.388,1.686 3.284,1.699" /></g><g
           id="g438"
           fill="none"><path
             id="path440"
             d="m 372.681,646.723 c -0.546,0.441 -1.858,1.234 -2.495,1.403" /></g><g
           id="g442"
           fill="none"><path
             id="path444"
             d="m 373.178,646.749 c 0.728,0.506 2.167,1.4 3.154,1.4" /></g><g
           id="g446"
           fill="none"><path
             id="path448"
             d="m 372.681,642.656 c -0.585,0.662 -1.572,1.685 -2.391,1.919" /></g><g
           id="g450"
           fill="none"><path
             id="path452"
             d="m 373.152,642.811 c 0.455,0.728 1.673,1.712 2.466,1.842" /></g><g
           id="g454"
           fill="none"><path
             id="path456"
             d="m 383.671,647.184 c 1.822,3.359 5.201,7.465 8.618,9.622" /></g><g
           id="g458"
           fill="none"><path
             id="path460"
             d="m 378.204,643.461 c 2.767,3.976 8.199,12.695 13.367,15.914" /></g><g
           id="g462"
           fill="none"><path
             id="path464"
             d="m 392.523,655.974 c -0.832,1.157 -2.326,2.963 -4.795,4.607" /></g><g
           id="g466"
           fill="none"><path
             id="path468"
             d="m 392.214,657.072 c -1.741,-2.78 -2.641,-6.295 -3.943,-10.924" /></g><g
           id="g470"
           fill="none"><path
             id="path472"
             d="m 374.149,658.508 2.144,5.899" /></g><g
           id="g474"
           fill="none"><path
             id="path476"
             d="m 373.751,658.37 1.896,6.017" /></g><g
           id="g478"
           fill="none"><path
             id="path480"
             d="m 373.343,658.092 1.76,6.262" /></g><g
           id="g482"
           fill="none"><path
             id="path484"
             d="m 373.165,658.189 1.359,6.128" /></g><g
           id="g486"
           fill="none"><path
             id="path488"
             d="m 374.474,664.095 h 1.699" /></g><g
           id="g490"
           fill="none"><path
             id="path492"
             d="m 375.946,663.455 h -1.602" /></g><g
           id="g494"
           fill="none"><path
             id="path496"
             d="m 375.77,662.962 h -1.546" /></g><g
           id="g498"
           fill="none"><path
             id="path500"
             d="m 375.589,662.461 h -1.475" /></g><g
           id="g502"
           fill="none"><path
             id="path504"
             d="M 375.394,661.916 H 373.99" /></g><g
           id="g506"
           fill="none"><path
             id="path508"
             d="m 373.886,661.445 h 1.332" /></g><g
           id="g510"
           fill="none"><path
             id="path512"
             d="m 373.789,661.003 h 1.264" /></g><g
           id="g514"
           fill="none"><path
             id="path516"
             d="m 373.682,660.522 h 1.202" /></g><g
           id="g518"
           fill="none"><path
             id="path520"
             d="m 373.587,660.093 h 1.134" /></g><g
           id="g522"
           fill="none"><path
             id="path524"
             d="m 373.487,659.648 h 1.078" /></g><g
           id="g526"
           fill="none"><path
             id="path528"
             d="m 373.399,659.239 h 1.02" /></g><g
           id="g530"
           fill="none"><path
             id="path532"
             d="m 373.298,658.859 h 0.991" /></g><g
           id="g534"
           fill="none"><path
             id="path536"
             d="m 373.243,658.537 h 0.923" /></g><g
           id="g538"
           fill="none"><path
             id="path540"
             d="m 371.571,658.546 -1.208,4.932" /></g><g
           id="g542"
           fill="none"><path
             id="path544"
             d="m 371.924,658.463 -1.037,5.21" /></g><g
           id="g546"
           fill="none"><path
             id="path548"
             d="m 372.202,658.274 -0.839,5.549" /></g><g
           id="g550"
           fill="none"><path
             id="path552"
             d="m 372.555,658.157 -0.609,5.803" /></g><g
           id="g554"
           fill="none"><path
             id="path556"
             d="m 372.681,663.628 h -1.923" /></g><g
           id="g558"
           fill="none"><path
             id="path560"
             d="m 372.681,663.095 h -2.225" /></g><g
           id="g562"
           fill="none"><path
             id="path564"
             d="m 372.681,662.549 h -2.095" /></g><g
           id="g566"
           fill="none"><path
             id="path568"
             d="m 372.681,662.029 h -1.965" /></g><g
           id="g570"
           fill="none"><path
             id="path572"
             d="m 372.681,661.497 h -1.838" /></g><g
           id="g574"
           fill="none"><path
             id="path576"
             d="m 372.681,660.912 h -1.692" /></g><g
           id="g578"
           fill="none"><path
             id="path580"
             d="m 372.681,660.405 h -1.569" /></g><g
           id="g582"
           fill="none"><path
             id="path584"
             d="m 372.681,659.885 h -1.436" /></g><g
           id="g586"
           fill="none"><path
             id="path588"
             d="m 372.681,659.379 h -1.316" /></g><g
           id="g590"
           fill="none"><path
             id="path592"
             d="m 372.681,658.937 h -1.212" /></g><g
           id="g594"
           fill="none"><path
             id="path596"
             d="M 372.681,658.586 H 371.56" /></g><g
           id="g598"
           fill="none"><path
             id="path600"
             d="m 372.681,664.089 v -5.88" /></g><g
           id="g602"
           fill="none"><path
             id="path604"
             d="m 379.147,656.272 -4.029,8.08" /></g><g
           id="g606"
           fill="none"><path
             id="path608"
             d="m 379.401,656.136 -3.43,8.254" /></g><g
           id="g610"
           fill="none"><path
             id="path612"
             d="m 379.647,656.053 -2.721,8.383" /></g><g
           id="g614"
           fill="none"><path
             id="path616"
             d="m 379.824,656.195 -2.116,8.238" /></g><g
           id="g618"
           fill="none"><path
             id="path620"
             d="m 377.801,664.056 h -2.534" /></g><g
           id="g622"
           fill="none"><path
             id="path624"
             d="m 377.996,663.316 h -2.359" /></g><g
           id="g626"
           fill="none"><path
             id="path628"
             d="m 378.113,662.718 h -2.17" /></g><g
           id="g630"
           fill="none"><path
             id="path632"
             d="m 378.317,662.068 h -2.053" /></g><g
           id="g634"
           fill="none"><path
             id="path636"
             d="m 378.421,661.549 h -1.897" /></g><g
           id="g638"
           fill="none"><path
             id="path640"
             d="m 378.603,660.951 h -1.787" /></g><g
           id="g642"
           fill="none"><path
             id="path644"
             d="m 378.782,660.253 h -1.618" /></g><g
           id="g646"
           fill="none"><path
             id="path648"
             d="M 378.918,659.72 H 377.43" /></g><g
           id="g650"
           fill="none"><path
             id="path652"
             d="m 379.074,659.112 h -1.348" /></g><g
           id="g654"
           fill="none"><path
             id="path656"
             d="m 379.181,658.696 h -1.247" /></g><g
           id="g658"
           fill="none"><path
             id="path660"
             d="m 379.282,658.307 h -1.143" /></g><g
           id="g662"
           fill="none"><path
             id="path664"
             d="M 379.383,657.91 H 378.33" /></g><g
           id="g666"
           fill="none"><path
             id="path668"
             d="m 379.474,657.56 h -0.968" /></g><g
           id="g670"
           fill="none"><path
             id="path672"
             d="m 379.565,657.209 h -0.887" /></g><g
           id="g674"
           fill="none"><path
             id="path676"
             d="m 379.656,656.848 h -0.8" /></g><g
           id="g678"
           fill="none"><path
             id="path680"
             d="m 379.74,656.523 h -0.721" /></g><g
           id="g682"
           fill="none"><path
             id="path684"
             d="m 382.36,656.404 1.763,5.58" /></g><g
           id="g686"
           fill="none"><path
             id="path688"
             d="m 382.696,656.519 2.139,5.355" /></g><g
           id="g690"
           fill="none"><path
             id="path692"
             d="m 383.001,656.532 2.505,5.237" /></g><g
           id="g694"
           fill="none"><path
             id="path696"
             d="m 386.108,661.316 -2.763,-4.888" /></g><g
           id="g698"
           fill="none"><path
             id="path700"
             d="m 386.106,661.312 h -2.192" /></g><g
           id="g702"
           fill="none"><path
             id="path704"
             d="m 385.731,660.649 h -2.019" /></g><g
           id="g706"
           fill="none"><path
             id="path708"
             d="m 385.356,659.987 h -1.851" /></g><g
           id="g710"
           fill="none"><path
             id="path712"
             d="m 384.981,659.324 h -1.688" /></g><g
           id="g714"
           fill="none"><path
             id="path716"
             d="m 384.606,658.661 h -1.529" /></g><g
           id="g718"
           fill="none"><path
             id="path720"
             d="m 384.231,657.999 h -1.36" /></g><g
           id="g722"
           fill="none"><path
             id="path724"
             d="m 383.856,657.336 h -1.194" /></g><g
           id="g726"
           fill="none"><path
             id="path728"
             d="m 383.481,656.673 h -1.032" /></g><g
           id="g730"
           fill="none"><path
             id="path732"
             d="m 385.745,656.831 -1.725,5.173" /></g><g
           id="g734"
           fill="none"><path
             id="path736"
             d="m 386.262,656.597 -1.6,5.303" /></g><g
           id="g738"
           fill="none"><path
             id="path740"
             d="m 385.403,661.783 1.174,-4.992" /></g><g
           id="g742"
           fill="none"><path
             id="path744"
             d="m 386.879,656.961 -0.988,4.75" /></g><g
           id="g746"
           fill="none"><path
             id="path748"
             d="m 384.22,661.406 h 1.731" /></g><g
           id="g750"
           fill="none"><path
             id="path752"
             d="m 384.435,660.762 h 1.65" /></g><g
           id="g754"
           fill="none"><path
             id="path756"
             d="m 384.65,660.119 h 1.572" /></g><g
           id="g758"
           fill="none"><path
             id="path760"
             d="m 384.865,659.476 h 1.491" /></g><g
           id="g762"
           fill="none"><path
             id="path764"
             d="m 385.08,658.833 h 1.41" /></g><g
           id="g766"
           fill="none"><path
             id="path768"
             d="m 385.295,658.19 h 1.329" /></g><g
           id="g770"
           fill="none"><path
             id="path772"
             d="m 385.51,657.546 h 1.248" /></g><g
           id="g774"
           fill="none"><path
             id="path776"
             d="m 385.725,656.903 h 1.027" /></g><g
           id="g778"
           fill="none"><path
             id="path780"
             d="m 387.666,657.008 0.846,3.547" /></g><g
           id="g782"
           fill="none"><path
             id="path784"
             d="m 387.981,656.845 1.169,3.697" /></g><g
           id="g786"
           fill="none"><path
             id="path788"
             d="m 388.377,656.826 1.275,3.702" /></g><g
           id="g790"
           fill="none"><path
             id="path792"
             d="m 388.901,657.034 1.277,3.477" /></g><g
           id="g794"
           fill="none"><path
             id="path796"
             d="m 390.064,660.204 h -1.638" /></g><g
           id="g798"
           fill="none"><path
             id="path800"
             d="m 389.871,659.684 h -1.556" /></g><g
           id="g802"
           fill="none"><path
             id="path804"
             d="m 389.678,659.164 h -1.491" /></g><g
           id="g806"
           fill="none"><path
             id="path808"
             d="m 389.486,658.644 h -1.43" /></g><g
           id="g810"
           fill="none"><path
             id="path812"
             d="m 389.293,658.125 h -1.358" /></g><g
           id="g814"
           fill="none"><path
             id="path816"
             d="m 389.101,657.605 h -1.284" /></g><g
           id="g818"
           fill="none"><path
             id="path820"
             d="M 388.908,657.085 H 387.69" /></g><g
           id="g822"
           fill="#00b800"><path
             id="path824"
             d="m 372.369,666.265 c 0.806,-0.519 2.183,-0.415 2.885,0.104 0.832,-0.467 2.339,-0.338 3.041,0.286 1.065,-0.727 1.975,-0.831 3.014,-0.13 0.806,-0.571 2.053,-0.623 3.015,0.052 0.935,-0.442 1.975,-0.805 2.884,0.156 -0.545,-0.39 -1.715,-0.728 -2.884,0.182 -0.91,-0.91 -2.495,-0.572 -3.015,0.052 -0.676,-0.806 -2.105,-0.936 -2.963,0.052 -0.935,-0.78 -2.338,-0.806 -3.092,-0.208 -0.598,-0.468 -1.481,-0.857 -2.885,-0.546 z" /></g><g
           id="g826"
           fill="#cf6200"><path
             id="path828"
             d="m 386.572,665.148 c -4.132,0.714 -13.137,0.208 -15.112,-0.286 -0.679,-0.17 -0.494,-0.416 0.078,-0.286 2.276,0.517 7.133,0.52 9.81,0.39 0.52,-0.689 1.338,-1.858 1.585,-2.183 0.247,-0.325 0.356,-0.355 0.871,-0.442 0.922,-0.156 1.449,-0.24 2.248,-0.377 0.013,0.104 0.013,0.234 0.013,0.312 -0.065,0.052 -0.13,0.143 -0.182,0.169 0,0.533 0.104,1.832 0.208,2.3 0.104,-0.013 0.234,-0.052 0.299,-0.065 0.182,-0.052 0.363,0.416 0.182,0.468 z" /></g><g
           id="g830"
           fill="#cf6200"><path
             id="path832"
             d="m 393.341,665.346 c 0.149,-0.004 0.46,-0.011 0.546,-0.013 0.169,-0.004 0.406,-0.12 0.51,-0.38 0.104,-0.26 0.426,-1.221 0.543,-1.624 l -0.416,-0.627 c 0.091,-0.517 0.208,-1.218 0.221,-1.361 0.208,-0.078 0.428,-0.156 0.532,-0.195 0.026,-0.117 -0.025,-0.435 -0.13,-0.539 -1.78,0.068 -7.107,0.253 -8.082,0.266 -0.234,0 -0.339,-0.01 -0.428,0.325 -0.494,1.845 0.189,4.434 2.053,5.925 0.13,0.104 0.294,0.017 0.077,-0.182 -0.311,-0.286 -0.792,-0.871 -1.117,-1.449 0.364,-0.006 1.102,-0.018 1.323,-0.027 0.106,0.437 0.438,1.359 0.503,1.515 0.065,0.156 0.225,0.178 0.149,-0.055 -0.179,-0.546 -0.273,-1.168 -0.351,-1.467 0.338,-0.008 0.975,-0.002 1.365,-0.024 0.019,0.494 0.071,1.156 0.084,1.338 0.013,0.182 0.169,0.195 0.172,-0.013 0.004,-0.208 0.008,-1.087 0.005,-1.346 0.44,-0.012 1.002,-0.031 1.21,-0.031 -0.029,0.281 -0.083,1.19 -0.103,1.334 -0.03,0.212 0.081,0.312 0.133,0.013 0.052,-0.299 0.156,-0.998 0.185,-1.352 0.176,-0.005 0.639,-0.024 0.834,-0.029 -0.019,0.277 -0.279,1.119 -0.357,1.34 -0.078,0.221 0.048,0.228 0.136,0.019 0.092,-0.214 0.377,-1.059 0.403,-1.361 z" /></g><g
           id="g834"
           fill="#000000"><path
             id="path836"
             d="m 387.442,665.135 c -0.143,-0.286 -0.585,-1.303 -0.624,-2.043 0.377,-0.007 1.32,-0.025 1.775,-0.035 0.067,0.558 0.239,1.76 0.33,2.045 -0.532,0.013 -1.182,0.03 -1.481,0.033 z" /></g><g
           id="g838"
           fill="#000000"><path
             id="path840"
             d="m 388.905,663.051 c 0.049,0.426 0.272,1.889 0.308,2.058 0.386,-0.023 1.28,-0.026 1.435,-0.039 -0.016,-0.39 -0.079,-1.853 -0.086,-2.061 -0.404,0.011 -1.454,0.037 -1.657,0.042 z" /></g><g
           id="g842"
           fill="#000000"><path
             id="path844"
             d="m 386.89,661.24 c -0.072,0.374 -0.085,1.173 -0.065,1.514 0.455,0.009 1.575,-0.018 1.73,-0.031 -0.038,-0.388 -0.099,-1.09 -0.138,-1.528 -0.371,0.016 -1.28,0.038 -1.527,0.045 z" /></g><g
           id="g846"
           fill="#000000"><path
             id="path848"
             d="m 388.748,661.19 c 0.013,0.364 0.094,1.254 0.12,1.526 0.393,-0.011 1.355,-0.031 1.68,-0.042 -0.017,-0.333 -0.07,-1.406 -0.076,-1.536 -0.522,0.014 -1.393,0.047 -1.724,0.052 z" /></g><g
           id="g850"
           fill="#000000"><path
             id="path852"
             d="m 390.812,661.128 c 0.016,0.338 0.059,1.292 0.046,1.539 0.417,-0.011 1.214,-0.019 1.461,-0.039 0.019,-0.339 0.074,-1.308 0.048,-1.555 -0.468,0.018 -1.214,0.043 -1.555,0.055 z" /></g><g
           id="g854"
           fill="#000000"><path
             id="path856"
             d="m 392.653,661.063 c 0,0.286 -0.036,1.291 -0.049,1.564 0.413,-0.016 1.351,-0.049 1.595,-0.055 0.065,-0.335 0.195,-1.205 0.234,-1.572 -0.39,0.013 -1.495,0.055 -1.78,0.063 z" /></g><g
           id="g858"
           fill="#000000"><path
             id="path860"
             d="m 394.264,662.906 c -0.533,0.017 -1.39,0.04 -1.68,0.051 -0.045,0.658 -0.127,1.795 -0.166,2.055 0.469,-0.01 1.417,-0.04 1.625,-0.046 0.156,-0.312 0.494,-1.286 0.572,-1.585 -0.117,-0.182 -0.208,-0.286 -0.351,-0.475 z" /></g><g
           id="g862"
           fill="#000000"><path
             id="path864"
             d="m 390.867,663.002 c 0,0.234 0.041,1.909 0.051,2.052 0.305,-0.01 1.097,-0.021 1.214,-0.034 0.059,-0.652 0.148,-1.901 0.164,-2.057 -0.54,0.015 -1.07,0.031 -1.429,0.039 z" /></g><g
           id="g866"
           fill="#000000"><path
             id="path868"
             d="m 383.974,662.601 -0.677,0.12 c -0.312,0.504 -1.468,2.063 -1.611,2.245 0.805,-0.023 2.064,-0.047 2.367,-0.076 -0.022,-0.418 -0.078,-2.082 -0.079,-2.289 z" /></g><g
           id="g870"
           fill="#000000"><path
             id="path872"
             d="m 384.273,662.545 c 0.016,0.533 0.067,1.953 0.08,2.33 0.399,-0.023 1.134,-0.071 1.433,-0.097 -0.069,-0.67 -0.195,-2.27 -0.221,-2.465 -0.335,0.061 -0.993,0.177 -1.292,0.232 z" /></g><g
           id="g874"
           fill="#000000"><path
             id="path876"
             d="m 377.294,656.927 c 0.091,10e-4 0.103,0.079 -10e-4,0.078 l -7.678,-0.095 c -0.104,-10e-4 -0.09,-0.079 10e-4,-0.078 z" /></g><g
           id="g878"
           fill="#000000"><path
             id="path880"
             d="m 383.328,650.784 c 0.091,0.003 0.102,0.081 -0.002,0.078 l -6.083,-0.167 c -0.104,-0.003 -0.089,-0.081 0.002,-0.078 z" /></g><g
           id="g882"
           fill="#000000"><path
             id="path884"
             d="m 376.911,652.535 c 0.091,10e-4 0.103,0.079 -10e-4,0.078 l -6.808,-0.05 c -0.104,0 -0.09,-0.078 0,-0.078 z" /></g><g
           id="g886"
           fill="#000000"><path
             id="path888"
             d="m 377.112,648.117 c 0.091,0 0.104,0.078 0,0.078 l -7.121,-0.037 c -0.104,0 -0.09,-0.078 0.001,-0.077 z" /></g><g
           id="g890"
           fill="#000000"><path
             id="path892"
             d="m 376.619,644.631 c 0.091,10e-4 0.102,0.08 -0.001,0.078 l -6.919,-0.104 c -0.104,-0.002 -0.09,-0.08 10e-4,-0.078 z" /></g><g
           id="g894"
           fill="#000000"><path
             fill="#ffffff"
             id="path896"
             d="m 383.784,642.587 c 0.091,-10e-4 0.105,0.077 0.001,0.078 l -5.938,0.057 c -0.104,10e-4 -0.092,-0.077 -10e-4,-0.078 z" /></g><g
           id="g898"
           fill="#000000"><path
             id="path900"
             d="m 384.148,645.91 c 0.091,0 0.104,0.078 0,0.078 h -6.562 c -0.104,0 -0.091,-0.078 0,-0.078 z" /></g><g
           id="g902"
           fill="#000000"><path
             id="path904"
             d="m 390.592,650.641 c 0.091,0 0.104,0.078 0,0.078 h -7.072 c -0.104,0 -0.091,-0.078 0,-0.078 z" /></g><g
           id="g906"
           fill="#000000"><path
             id="path908"
             d="m 390.691,644.728 c 0.091,0.001 0.103,0.079 -10e-4,0.078 l -7.225,-0.071 c -0.104,-10e-4 -0.09,-0.079 0.001,-0.078 z" /></g><g
           id="g910"
           fill="#000000"><path
             id="path912"
             d="m 384.012,655.121 c 0.091,10e-4 0.103,0.079 -10e-4,0.078 l -6.356,-0.042 c -0.104,-0.001 -0.09,-0.079 0.001,-0.078 z" /></g><g
           id="g914"
           fill="#000000"><path
             id="path916"
             d="m 390.223,655.983 c 0.091,0.001 0.103,0.079 -0.001,0.078 l -5.587,-0.074 c -0.104,-10e-4 -0.089,-0.079 0.002,-0.078 z" /></g><g
           id="g918"
           fill="#ef072d"><path
             id="path920"
             d="m 395.264,657.053 c 0.157,-0.349 0.179,-1.151 0.089,-1.455 -0.242,0.049 -0.447,0.038 -0.647,-0.04 -0.105,-0.04 -0.22,-0.076 -0.341,-0.106 -0.022,0.402 -0.168,1.426 -0.348,1.822 -0.314,0.089 -0.947,-0.015 -1.307,-0.128 -0.095,0.341 -0.182,0.654 -0.262,0.942 0.447,0.103 1.008,0.094 1.452,-0.009 -0.035,0.601 -0.114,1.148 -0.439,1.526 0.531,0.012 1.006,-0.066 1.18,-0.252 0.016,-0.018 0.034,-0.033 0.053,-0.048 0.245,-0.41 0.252,-0.944 0.311,-1.304 0.181,0.013 0.415,-0.039 0.519,-0.143 0.104,-0.104 0.273,-0.156 0.442,-0.143 0.154,0.012 0.394,-0.02 0.699,-0.143 0.008,-0.184 0.044,-0.384 0.107,-0.558 0.034,-0.095 0.071,-0.253 0.102,-0.444 -0.387,0.185 -1.25,0.494 -1.61,0.483 z" /></g><g
           id="g922"
           fill="#000000"><path
             
             id="path924"
             d="m 370.462,623.195 c -0.791,0.023 -2.513,0.039 -2.875,0.242 -0.361,0.204 -0.52,0.294 0.113,0.407 0.633,0.113 1.704,0.414 2.291,0.776 0.587,0.361 1.079,1.001 0.917,1.914 -0.485,2.743 0.949,5.381 3.027,6.376 0.201,0.096 0.249,0.169 0.204,0.542 -0.045,0.373 -0.181,0.995 -0.294,1.153 -0.113,0.159 -0.169,0.419 0.192,0.294 -0.248,0.464 -0.802,1.391 -0.971,1.628 -1.661,-0.203 -3.016,0.023 -3.141,1.763 -0.012,0.17 0.046,0.441 0.305,0.012 0.26,-0.43 0.554,-0.837 1.265,-0.95 -0.418,0.644 -0.553,1.221 -0.485,1.594 0.067,0.373 0.169,0.599 0.35,0.124 0.181,-0.474 0.514,-0.918 0.87,-1.187 0.135,-0.101 0.226,-0.124 0.124,0.17 -0.102,0.294 0.045,0.927 0.249,1.142 0.203,0.214 0.305,0.124 0.248,-0.226 -0.056,-0.351 0.032,-1.084 0.463,-1.312 0.621,-0.327 1.152,-0.158 1.401,0.272 0.248,0.429 0.463,0.022 0.192,-0.464 -0.271,-0.486 -0.554,-0.825 -1.006,-0.859 0.396,-0.701 0.859,-1.549 0.961,-1.718 0.101,-0.17 0.26,-0.249 0.395,-0.147 0.136,0.102 0.226,0.09 0.362,-0.192 0.135,-0.283 0.372,-1.119 0.711,-1.458 0.17,-0.046 0.441,-0.113 0.542,-0.204 0.441,0.644 0.836,1.357 0.938,1.515 0.101,0.158 0.215,0.226 0.113,0.554 -0.102,0.328 -0.452,1.368 -0.508,1.594 -1.232,0.045 -1.796,0.067 -2.192,0.757 -0.173,0.301 0.102,0.418 0.396,0.26 0.293,-0.158 0.711,-0.294 0.926,-0.26 0.214,0.034 0.315,0.144 0.101,0.249 -0.756,0.373 -1.229,0.847 -1.197,1.503 0.011,0.237 0.109,0.355 0.294,0.034 0.26,-0.452 0.734,-0.904 1.31,-1.029 -0.034,0.554 0.091,1.368 0.429,1.538 0.339,0.169 0.363,-0.003 0.237,-0.328 -0.203,-0.52 0.008,-1.043 0.26,-1.323 0.531,-0.588 1.74,0.226 1.966,0.43 0.226,0.203 0.432,0.288 0.305,-0.238 -0.17,-0.7 -1.164,-1.107 -2.011,-1.22 0.237,-1.142 0.87,-3.448 1.209,-4.239 0.497,0.271 0.885,-0.444 1.717,-0.136 1.4,0.52 3.501,1.831 3.863,2.125 0.361,0.294 0.497,0.226 0.678,0.068 0.18,-0.158 0.497,0 0.745,0.045 0.249,0.045 0.475,0.113 0.158,-0.52 -0.316,-0.633 -1.084,-1.741 -2.372,-2.6 0.768,0.068 1.808,0.068 1.808,-0.135 0,-0.204 -1.198,-0.588 -1.695,-0.633 0.475,-0.113 1.198,-0.385 1.536,-0.769 0.201,-0.227 -0.04,-0.28 -0.745,-0.294 -2.169,-0.045 -3.253,-0.028 -4.383,-0.678 -1.807,-1.04 -2.841,-2.135 -3.728,-2.6 -0.474,-0.249 -0.763,-0.823 -0.946,-1.319 -0.587,-1.583 -0.558,-2.295 -1.936,-2.815 -1.378,-0.52 -2.963,0.117 -3.686,0.772 z" /></g><g
           id="g926"
           fill="#ffffff"><path
             id="path928"
             d="m 370.55,623.555 c -0.351,-0.013 -1.04,-0.096 -1.611,-0.039 -0.13,0.013 -0.286,0.078 0.026,0.117 0.312,0.039 1.156,0.246 1.455,0.35 0.299,0.104 0.169,0.26 -0.091,0.195 -0.26,-0.065 -0.356,0.031 -0.143,0.182 1.105,0.78 1.222,1.079 0.936,3.755 0.208,0.143 0.377,0.247 0.559,0.338 0.182,0.091 0.13,0.221 -0.065,0.169 -0.195,-0.052 -0.377,0.065 -0.065,0.13 0.312,0.065 0.454,0.208 0.156,0.195 -0.299,-0.013 -0.65,0.247 -0.065,0.182 0.584,-0.065 0.818,0.208 0.13,0.221 -0.689,0.013 -0.429,0.234 -0.065,0.234 0.649,0 0.454,0.182 0.286,0.182 -0.169,0 -0.247,0.221 0.182,0.182 0.428,-0.039 0.597,-0.052 0.753,-0.026 0.156,0.026 0.221,0.155 -0.013,0.169 -0.234,0.012 -0.221,0.181 0.13,0.181 0.351,0 0.497,0.106 0.182,0.169 -0.13,0.026 -0.31,0.091 0.065,0.143 0.65,0.091 0.676,0.247 0.468,0.273 -0.208,0.026 -0.234,0.143 0.065,0.169 0.298,0.026 0.558,0.117 0.312,0.182 -0.247,0.065 -0.377,0.208 -0.066,0.234 0.312,0.026 0.572,0.143 0.338,0.221 -0.234,0.078 -0.286,0.221 0.013,0.208 0.299,-0.013 0.416,0.156 0.208,0.272 -0.208,0.117 -0.351,0.195 -0.481,-0.012 -0.129,-0.208 -0.207,-0.273 -0.246,-0.117 -0.039,0.155 -0.13,0.052 -0.234,-0.182 -0.104,-0.234 -0.286,-0.299 -0.234,-0.117 0.052,0.182 -0.182,0.208 -0.403,0.117 0.819,0.831 2.027,1.585 3.95,0.805 0.164,-0.066 0.195,0 0.325,0.273 0.13,0.273 0.494,0.871 0.624,1.092 0.13,0.221 0.233,0.022 0.298,-0.195 0.26,-0.858 0.455,-1.495 0.533,-1.728 0.078,-0.234 0.442,-0.468 0.325,0.35 0.286,-0.195 1.553,-0.379 2.534,-0.013 1.078,0.403 2.162,1.028 2.716,1.443 0.104,0.078 0.234,0.169 0.493,0.143 0.26,-0.026 0.325,-0.065 -0.169,-0.52 -0.493,-0.455 -0.285,-0.676 0.026,-0.455 0.312,0.221 0.481,0.091 0.247,-0.182 -0.234,-0.273 -0.792,-0.805 -0.974,-0.935 -0.182,-0.13 -0.208,-0.182 -0.624,-0.208 -0.416,-0.026 -1.299,-0.026 -1.559,-0.026 -0.26,0 -0.338,0.026 0.234,0.234 0.571,0.207 1.741,0.961 2.001,1.143 0.26,0.182 0.442,0.598 -0.13,0.234 -0.572,-0.364 -2.365,-1.481 -3.56,-1.897 -2.729,0.182 -4.886,0.546 -6.497,-1.221 -0.772,-0.846 -0.806,-2.781 0.493,-3.587 -0.26,-0.221 -0.221,-0.351 -0.117,-0.403 0.104,-0.052 0.143,-0.104 0.039,-0.234 -0.103,-0.13 -0.091,-0.246 0,-0.298 -0.285,-0.156 -0.415,-0.338 -0.402,-0.533 -0.351,-0.078 -0.507,-0.494 -0.975,-0.364 -0.468,0.13 -0.702,0.026 -0.844,-0.091 -0.144,-0.117 -0.26,-0.169 -0.52,-0.143 -0.26,0.026 -0.468,-0.078 -0.481,-0.208 -0.013,-0.13 0.22,-0.193 0.572,-0.039 0.74,0.325 1.338,0.481 1.793,-0.13 0.455,-0.61 -0.13,-1.182 -1.001,-1.351 -0.87,-0.169 -1.507,0.468 -1.832,0.767 z" /></g><g
           id="g930"
           fill="#ffffff"><path
             id="path932"
             d="m 374.916,623.334 c -0.262,-0.284 -0.728,-0.546 -0.961,-0.624 -0.234,-0.078 -0.26,0.156 -0.13,0.273 -0.104,0.156 -0.143,0.533 0.039,0.637 0.182,0.104 0.184,0.252 0.013,0.337 -0.26,0.13 -0.172,0.82 0.22,0.624 0.13,-0.065 0.234,-0.039 0.208,0.065 -0.026,0.104 0.026,0.234 0.143,0.26 0.117,0.026 0.104,0.195 0.078,0.26 -0.026,0.065 0.013,0.091 0.143,0.104 0.13,0.013 0.143,0.325 -0.091,0.429 0.286,0 0.364,-0.052 0.442,0.182 0.078,0.233 0.39,0.285 0.39,0.571 0,0.286 -0.052,0.338 -0.39,0.286 -0.338,-0.052 -0.468,0.052 -0.572,0.182 -0.104,0.13 -0.13,0.26 0.13,0.273 0.26,0.013 0.312,0.13 0.052,0.247 -0.26,0.117 -0.688,0.039 -0.753,0.286 -0.065,0.246 0,0.363 0.194,0.272 0.195,-0.09 0.598,-0.259 0.754,-0.35 0.156,-0.091 0.299,-0.104 0.429,0.104 0.13,0.208 0.026,0.441 -0.195,0.26 -0.221,-0.182 -0.325,-0.014 -0.455,0.09 -0.13,0.104 -0.325,0.169 -0.533,0.169 -0.207,0 -0.35,0.027 -0.324,0.494 0.078,1.404 1.169,2.443 3.17,2.417 2.001,-0.026 2.989,-0.052 3.288,-0.013 -0.663,-0.364 -1.079,-0.559 -1.313,-0.533 -0.234,0.026 -0.429,0.065 -0.325,-0.117 0.104,-0.182 -0.013,-0.182 -0.117,-0.26 -0.104,-0.078 -0.233,-0.182 -0.441,0.039 -0.208,0.221 -0.702,0.468 -0.949,0.52 -0.247,0.052 -0.546,0.039 -0.312,-0.195 0.234,-0.234 0.754,-0.312 0.91,-0.416 0.156,-0.104 0.156,-0.168 0.156,-0.246 0,-0.078 -0.039,-0.299 0.26,-0.13 0.597,0.338 1.533,0.844 1.78,0.831 0.247,-0.013 0.416,-0.117 0.195,-0.26 -0.221,-0.143 -0.286,-0.35 -0.221,-0.428 0.065,-0.078 0.104,-0.156 0.494,0.065 0.389,0.22 1.026,0.506 1.26,0.61 0.234,0.104 0.546,0.065 0.065,-0.286 -0.481,-0.35 -1.975,-1.338 -2.391,-1.65 -0.416,-0.312 -0.234,0.065 -0.195,0.182 0.039,0.117 -0.286,0.26 -0.455,0.117 -0.169,-0.143 -0.286,-0.299 -0.052,-0.429 0.234,-0.13 0.286,-0.143 -0.065,-0.455 -0.35,-0.311 -0.454,-0.285 -0.376,-0.026 0.078,0.26 0.104,0.546 -0.26,0.403 -0.364,-0.143 -0.546,-0.312 -0.312,-0.455 0.234,-0.142 0.533,-0.22 0.143,-0.545 -0.39,-0.325 -0.273,0 -0.364,0.182 -0.091,0.182 -0.39,0.182 -0.559,0.039 -0.169,-0.143 -0.247,-0.286 -0.13,-0.403 0.117,-0.117 0.104,-0.182 0.273,-0.091 0.169,0.091 0.429,0.039 0.117,-0.234 -0.312,-0.273 -0.429,-0.156 -0.364,0 0.065,0.156 -0.182,0.429 -0.571,0.065 -0.185,-0.172 -0.182,-0.403 0.013,-0.442 0.194,-0.039 0.213,-0.14 0.077,-0.338 -0.792,-1.156 -0.467,-2.092 -1.26,-2.949 z" /></g><g
           id="g934"
           fill="#cf6200"><path
             id="path936"
             d="m 375.048,623.49 c -0.068,0.102 -0.093,0.098 -0.219,0.182 -0.155,0.103 -0.19,0.398 0.07,0.363 0.18,-0.024 0.285,-0.131 0.356,-0.218 -0.057,-0.11 -0.125,-0.219 -0.207,-0.327 z" /></g><g
           id="g938"
           fill="#cf6200"><path
             id="path940"
             d="m 374.235,622.836 c -0.2,0.194 -0.235,0.281 -0.133,0.281 0.121,0 0.069,0.017 -0.018,0.156 -0.086,0.139 0.174,0.208 0.278,0.104 0.104,-0.104 0.121,-0.139 0.173,0 0.042,0.113 0.213,0.006 0.321,-0.103 -0.177,-0.171 -0.415,-0.329 -0.621,-0.438 z" /></g><g
           id="g942"
           fill="#cf6200"><path
             id="path944"
             d="m 373.877,623.957 c -0.26,0.13 -0.172,0.82 0.22,0.624 0.13,-0.065 0.234,-0.039 0.208,0.065 -0.014,0.055 -0.005,0.118 0.024,0.168 0.155,-0.065 0.31,-0.173 0.431,-0.311 0.243,-0.277 0.017,-0.26 -0.346,-0.26 -0.364,0 -0.468,-0.069 -0.122,-0.277 0.31,-0.186 0.108,-0.315 -0.321,-0.255 0.062,0.088 0.031,0.184 -0.094,0.246 z" /></g><g
           id="g946"
           fill="#cf6200"><path
             id="path948"
             d="m 375.367,625.491 c -0.191,-0.208 -0.07,-0.312 0.138,-0.416 0.051,-0.025 0.086,-0.057 0.111,-0.095 -0.059,-0.229 -0.106,-0.449 -0.168,-0.663 -0.109,0.031 -0.236,0.274 -0.272,0.394 -0.052,0.173 -0.104,0.277 -0.277,0.225 -0.154,-0.046 -0.308,0.127 -0.34,0.312 0.024,0.01 0.061,0.017 0.11,0.022 0.072,0.007 0.108,0.105 0.086,0.209 0.469,-0.015 0.549,0.309 0.629,0.531 0.087,0.243 0.191,0.208 0.26,0.07 0.069,-0.139 -0.087,-0.381 -0.277,-0.589 z" /></g><g
           id="g950"
           fill="#ffff00"><path
             id="path952"
             d="m 375.505,628.211 c -0.085,0.192 -0.087,0.173 -0.364,0.19 -0.277,0.018 -0.626,0.065 -0.779,0.226 -0.083,0.086 -0.562,0.109 -0.563,0.32 -0.002,0.212 0,0.39 0.208,0.403 0.207,0.013 0.233,0.039 0.156,0.195 -0.079,0.156 -0.13,0.416 0.233,0.442 0.364,0.026 0.624,-0.091 0.715,0.116 0.091,0.208 -0.007,0.54 0.065,0.663 0.072,0.123 0.318,0.202 0.699,0.32 0.254,0.079 1.213,0.124 1.508,0.09 0.294,-0.035 0.184,-0.211 -0.111,-0.237 -0.294,-0.026 -0.511,-0.069 -0.58,-0.285 -0.069,-0.217 -0.13,-0.33 0.035,-0.511 0.164,-0.182 0.329,-0.321 0.234,-0.624 -0.096,-0.303 -0.252,-0.659 -0.598,-0.754 -0.347,-0.095 -0.237,-0.569 -0.581,-0.615 -0.13,-0.017 -0.242,-0.017 -0.277,0.061 z" /></g><g
           id="g954"
           fill="#cf6200"><path
             id="path956"
             d="m 373.825,631.026 c 0.298,0.026 0.558,0.117 0.312,0.182 -0.247,0.065 -0.377,0.208 -0.066,0.234 0.312,0.026 0.572,0.143 0.338,0.221 -0.234,0.078 -0.286,0.221 0.013,0.208 0.299,-0.013 0.416,0.156 0.208,0.272 -0.208,0.117 -0.351,0.195 -0.481,-0.012 -0.129,-0.208 -0.207,-0.273 -0.246,-0.117 -0.039,0.155 -0.13,0.052 -0.234,-0.182 -0.104,-0.234 -0.286,-0.299 -0.234,-0.117 0.052,0.182 -0.182,0.208 -0.403,0.117 0.218,0.221 0.463,0.436 0.742,0.618 0.319,-0.109 0.671,-0.02 0.791,-0.008 0.13,0.013 0.533,0.104 0.754,0.221 0.221,0.117 0.364,-0.091 0.273,-0.325 -0.091,-0.233 -0.104,-0.155 -0.221,-0.026 -0.117,0.13 -0.143,-0.052 -0.13,-0.324 0.011,-0.23 -0.143,-0.169 -0.195,-0.026 -0.052,0.143 -0.169,-0.091 -0.104,-0.234 0.065,-0.143 -0.013,-0.195 -0.13,-0.156 -0.117,0.039 -0.13,0 -0.143,-0.26 -0.013,-0.26 -0.13,-0.221 -0.169,-0.117 -0.039,0.104 -0.143,-0.039 -0.299,-0.247 -0.136,-0.182 -0.293,-0.075 -0.565,0.033 0.034,0.02 0.096,0.037 0.189,0.045 z" /></g><g
           id="g958"
           fill="#ffff00"><path
             id="path960"
             d="m 376.982,632.637 c -1.42,0.576 -2.444,0.32 -3.215,-0.191 0.319,-0.109 0.678,-0.016 0.798,-0.004 0.13,0.013 0.533,0.104 0.754,0.221 0.221,0.117 0.364,-0.091 0.273,-0.325 0.195,0.247 0.338,0.416 0.571,0.403 0.234,-0.013 0.624,-0.052 0.819,-0.104 z" /></g><g
           id="g962"
           fill="#ffff00"><path
             id="path964"
             d="m 373.946,626.097 c -0.087,-0.294 -0.173,-0.364 -0.329,-0.346 -0.156,0.017 -0.225,-0.018 -0.399,-0.087 -0.173,-0.069 -0.398,0.017 -0.433,0.329 -0.035,0.312 -0.225,0.468 -0.485,0.658 -0.26,0.191 -0.416,0.347 -0.416,0.659 0,0.312 -0.069,0.398 -0.242,0.624 -0.077,0.1 -0.186,0.214 -0.288,0.334 0.112,0.07 0.217,0.131 0.327,0.185 0.182,0.091 0.13,0.221 -0.065,0.169 -0.195,-0.052 -0.377,0.065 -0.065,0.13 0.312,0.065 0.454,0.208 0.156,0.195 -0.299,-0.013 -0.65,0.247 -0.065,0.182 0.584,-0.065 0.818,0.208 0.13,0.221 -0.689,0.013 -0.429,0.234 -0.065,0.234 0.649,0 0.454,0.182 0.286,0.182 -0.169,0 -0.247,0.221 0.182,0.182 0.006,-10e-4 0.011,-0.002 0.018,-0.002 0.062,-0.064 0.108,-0.144 0.142,-0.245 0.069,-0.208 0.138,-0.815 0.381,-0.988 0.242,-0.173 0.364,-0.416 0.364,-0.589 0,-0.173 0.363,-0.935 0.606,-1.126 0.243,-0.191 0.347,-0.606 0.26,-0.901 z" /></g><g
           id="g966"
           fill="#cf6200"><path
             id="path968"
             d="m 373.443,626.114 c -0.246,-0.164 -0.485,-0.069 -0.485,0.243 0,0.312 -0.156,0.398 -0.364,0.502 -0.207,0.104 -0.398,0.364 -0.433,0.607 -0.034,0.242 0.035,0.398 -0.138,0.589 -0.174,0.19 -0.191,0.346 -0.069,0.45 0.121,0.104 0.121,0.122 0.173,0.277 0.052,0.156 0.346,-0.017 0.346,-0.19 0,-0.173 0.07,-0.173 0.26,-0.277 0.191,-0.104 0.503,-0.607 0.433,-0.745 -0.069,-0.139 -0.242,-0.26 -0.017,-0.451 0.225,-0.19 0.468,-0.208 0.468,-0.398 0,-0.191 0.069,-0.26 0.138,-0.329 0.07,-0.07 -0.156,-0.174 -0.312,-0.278 z" /></g><g
           id="g970"
           fill="#000000"><path
             id="path972"
             d="m 373.443,625.855 c -0.162,-0.063 -0.259,0.277 -0.034,0.329 0.225,0.052 0.26,-0.243 0.034,-0.329 z" /></g><g
           id="g974"
           fill="#000000"><path
             id="path976"
             d="m 373.396,626.296 c -0.172,0.021 -0.364,0.247 -0.078,0.208 0.286,-0.039 0.403,-0.247 0.078,-0.208 z" /></g><g
           id="g978"
           fill="#000000"><path
             id="path980"
             d="m 373.058,626.725 c -0.177,0.089 -0.143,0.325 0.117,0.156 0.26,-0.169 0.325,-0.377 -0.117,-0.156 z" /></g><g
           id="g982"
           fill="#000000"><path
             id="path984"
             d="m 372.781,627.085 c -0.178,0.088 -0.143,0.324 0.117,0.156 0.26,-0.169 0.325,-0.377 -0.117,-0.156 z" /></g><g
           id="g986"
           fill="#000000"><path
             id="path988"
             d="m 372.417,627.249 c -0.177,0.089 -0.065,0.325 0.195,0.156 0.26,-0.169 0.247,-0.377 -0.195,-0.156 z" /></g><g
           id="g990"
           fill="#000000"><path
             id="path992"
             d="m 372.642,627.466 c -0.177,0.089 -0.065,0.325 0.195,0.156 0.26,-0.169 0.247,-0.377 -0.195,-0.156 z" /></g><g
           id="g994"
           fill="#000000"><path
             id="path996"
             d="m 372.33,627.561 c -0.177,0.089 -0.065,0.325 0.195,0.156 0.26,-0.169 0.247,-0.377 -0.195,-0.156 z" /></g><g
           id="g998"
           fill="#000000"><path
             id="path1000"
             d="m 372.53,627.812 c -0.178,0.089 -0.065,0.325 0.194,0.156 0.26,-0.169 0.247,-0.377 -0.194,-0.156 z" /></g><g
           id="g1002"
           fill="#000000"><path
             id="path1004"
             d="m 372.226,627.96 c -0.177,0.088 -0.065,0.324 0.195,0.155 0.26,-0.169 0.247,-0.376 -0.195,-0.155 z" /></g><g
           id="g1006"
           fill="#000000"><path
             id="path1008"
             d="m 372.252,628.193 c -0.177,0.089 -0.065,0.325 0.195,0.156 0.26,-0.169 0.247,-0.377 -0.195,-0.156 z" /></g><g
           id="g1010"
           fill="#cf6200"><path
             id="path1012"
             d="m 372.109,630.376 c -0.179,0.023 -0.294,0.278 -0.069,0.33 0.225,0.052 0.277,0.069 0.277,0.242 0,0.173 0.07,0.416 0.312,0.433 0.243,0.018 0.451,-0.26 0.243,-0.346 -0.208,-0.087 -0.399,-0.156 -0.416,-0.347 -0.017,-0.19 -0.208,-0.329 -0.347,-0.312 z" /></g><g
           id="g1014"
           fill="#ffff00"><path
             id="path1016"
             d="m 378.488,628.889 c 0.032,0.04 0.072,0.084 0.118,0.123 0.169,0.143 0.494,0 0.455,-0.117 -0.039,-0.117 -0.221,-0.494 0.195,-0.182 0.416,0.312 1.91,1.3 2.391,1.65 0.481,0.351 0.169,0.39 -0.065,0.286 -0.234,-0.104 -0.871,-0.39 -1.26,-0.61 -0.39,-0.221 -0.429,-0.143 -0.494,-0.065 -0.055,0.065 -0.011,0.222 0.132,0.355 -0.232,0.034 -0.609,-0.017 -0.717,-0.264 -0.13,-0.299 -0.442,-0.663 -0.663,-0.949 -0.082,-0.106 -0.106,-0.172 -0.092,-0.227 z" /></g><g
           id="g1018"
           fill="#00d860"><path
             id="path1020"
             d="m 391.379,671.463 c -0.324,0.221 -0.753,0.611 -0.468,1.156 0.034,-0.018 0.066,-0.039 0.099,-0.058 1.271,-1.538 2.359,-3.155 3.291,-4.835 0.011,-0.058 0.021,-0.113 0.028,-0.161 -0.364,0.312 -0.936,0.623 -1.17,0.701 0.156,0.416 -0.571,0.962 -0.961,1.118 0.156,0.26 0.104,0.65 -0.234,0.728 0.078,0.233 -0.182,0.233 -0.494,0.363 -0.312,0.13 -0.468,0.234 -0.571,0.39 0.168,-0.091 0.402,-0.169 0.532,-0.13 0.13,0.039 0.156,0.234 -0.078,0.286 -0.234,0.052 -0.389,0.182 -0.468,0.286 0.338,-0.13 0.819,-0.065 0.494,0.156 z" /></g><g
           id="g1022"
           fill="#000000"><path
             id="path1024"
             d="m 375.969,628.414 c -0.384,-0.335 -0.481,-0.13 -0.325,0.078 0.156,0.208 0.039,0.312 -0.299,0.364 -0.338,0.052 -0.845,0.117 -1.053,0.117 -0.208,0 -0.454,0.286 0.039,0.26 0.494,-0.026 1.326,-0.195 1.547,-0.286 0.221,-0.091 0.402,-0.26 0.091,-0.533 z" /></g><g
           id="g1026"
           fill="#000000"><path
             id="path1028"
             d="m 376.722,628.999 c -0.317,-0.285 -0.429,-0.208 -0.351,0 0.078,0.208 -0.065,0.247 -0.272,0.312 -0.208,0.065 -1.027,0.338 -1.378,0.377 -0.351,0.039 -0.429,0.286 0.091,0.273 0.52,-0.013 1.52,-0.429 1.637,-0.507 0.117,-0.078 0.156,-0.234 0.286,-0.156 0.13,0.078 0.247,-0.065 -0.013,-0.299 z" /></g><g
           id="g1030"
           fill="#000000"><path
             id="path1032"
             d="m 376.956,629.831 c -0.23,0.137 -0.805,0.389 -1.039,0.454 -0.234,0.065 -0.429,0.325 0.065,0.286 0.493,-0.039 1.078,-0.494 1.234,-0.584 0.156,-0.091 0.234,-0.156 0.364,-0.143 0.13,0.013 0.364,-0.169 -0.065,-0.403 -0.429,-0.234 -0.689,-0.117 -0.481,0.065 0.208,0.182 0.052,0.247 -0.078,0.325 z" /></g><g
           id="g1034"
           fill="#000000"><path
             id="path1036"
             d="m 372.906,623.29 c -0.635,-0.417 -1.36,0.457 -0.658,0.936 0.615,0.42 1.265,-0.537 0.658,-0.936 z" /></g><g
           id="g1038"
           fill="#ffffff"><path
             id="path1040"
             d="m 372.116,623.672 0.188,0.013 c -0.039,0.194 0.156,0.487 0.455,0.415 -0.24,0.182 -0.708,-0.026 -0.643,-0.428 z" /></g><g
           id="g1042"
           fill="#ffffff"><path
             id="path1044"
             d="m 374.579,633.136 c 0.192,0.056 0.859,0.124 1.085,0.135 -0.113,0.238 -0.215,0.396 -0.283,0.566 -0.068,0.169 -0.101,0.181 -0.113,-0.079 -0.011,-0.261 -0.158,-0.43 -0.293,-0.159 -0.136,0.272 -0.204,0.373 -0.271,0.486 -0.068,0.113 -0.17,0.159 -0.136,-0.124 0.034,-0.283 0.023,-0.577 0.011,-0.825 z" /></g><g
           id="g1046"
           fill="none"><path
             
             id="path1048"
             d="m 399.668,640.771 c -0.046,16.332 -2.623,33.927 -23.764,42.308 -21.142,-8.381 -23.719,-25.976 -23.765,-42.308 z" /></g><g
           id="g3680"
           fill="none"><path
             fill="none"
             id="path3682"
             d="m 399.668,640.771 c 0.018,-6.152 -0.324,-12.125 -0.168,-17.359 -7.9,-3.535 -18.295,-4.262 -23.596,-4.262 -5.302,0 -15.697,0.727 -23.597,4.262 0.156,5.234 -0.185,11.207 -0.168,17.359 z" /></g></g>
  </svg>
);

export const SI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs24" />
    <path
       fill="#f5f5f5"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<rect
       y="200.091"
       fill="#41479b"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    	<path
       fill="#41479b"
       d="m 172.014,157.371 c 0,0 -1.778,56.628 -9.724,72.53 -9.836,19.545 -19.725,25.247 -34.438,30.515 -14.711,-5.267 -24.6,-10.965 -34.438,-30.515 -7.945,-15.903 -9.725,-72.524 -9.724,-72.53 28.077,-12.677 60.247,-12.677 88.324,0 z"
       id="path3" />
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 140.64,235.898 c -1.076,-0.69 -1.852,-1.184 -3.618,-1.184 -1.761,0 -2.537,0.493 -3.608,1.184 -1.227,0.781 -2.753,1.759 -5.59,1.759 -2.839,0 -4.365,-0.978 -5.592,-1.763 -1.071,-0.685 -1.845,-1.178 -3.606,-1.178 -1.761,0 -2.535,0.493 -3.606,1.178 -1.159,0.743 -2.624,1.628 -5.171,1.727 5.362,6.538 10.983,9.64 17.998,12.333 7.012,-2.694 12.632,-5.793 17.994,-12.331 -2.565,-0.093 -4.038,-0.984 -5.201,-1.725 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 105.832,225.438 c 1.071,0.685 1.843,1.178 3.598,1.178 1.761,0 2.535,-0.493 3.606,-1.178 1.227,-0.786 2.753,-1.763 5.59,-1.763 2.837,0 4.363,0.978 5.59,1.759 1.071,0.69 1.847,1.184 3.608,1.184 1.761,0 2.535,-0.493 3.606,-1.178 1.227,-0.786 2.753,-1.763 5.592,-1.763 2.841,0 4.37,0.978 5.597,1.759 1.076,0.69 1.849,1.184 3.616,1.184 1.767,0 2.542,-0.493 3.618,-1.184 1.025,-0.653 2.312,-1.409 4.35,-1.651 0.534,-1.39 1.053,-2.975 1.536,-4.9 l -13.17,-21.95 -4.907,9.814 -9.814,-19.627 -9.814,19.627 -4.907,-9.814 -13.162,21.937 c 0.481,1.924 0.999,3.516 1.534,4.915 2.03,0.239 3.311,0.995 4.333,1.651 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 151.831,228.538 c -1.227,0.781 -2.755,1.759 -5.597,1.759 -2.839,0 -4.367,-0.978 -5.594,-1.759 -1.076,-0.69 -1.852,-1.184 -3.618,-1.184 -1.761,0 -2.537,0.493 -3.608,1.184 -1.227,0.781 -2.753,1.759 -5.59,1.759 -2.839,0 -4.365,-0.978 -5.592,-1.763 -1.071,-0.685 -1.845,-1.178 -3.606,-1.178 -1.761,0 -2.535,0.493 -3.606,1.178 -1.227,0.786 -2.753,1.763 -5.59,1.763 -2.835,0 -4.359,-0.978 -5.582,-1.763 -0.006,-0.003 -0.011,-0.007 -0.017,-0.011 0.962,1.746 1.923,3.349 2.881,4.803 0.716,0.393 1.465,0.651 2.718,0.651 1.761,0 2.535,-0.493 3.606,-1.178 1.227,-0.786 2.753,-1.763 5.59,-1.763 2.837,0 4.363,0.978 5.59,1.759 1.071,0.69 1.847,1.184 3.608,1.184 1.761,0 2.535,-0.493 3.606,-1.178 1.227,-0.786 2.753,-1.763 5.592,-1.763 2.841,0 4.37,0.978 5.597,1.759 1.076,0.69 1.849,1.184 3.616,1.184 1.272,0 2.027,-0.262 2.754,-0.663 0.957,-1.452 1.918,-3.055 2.879,-4.799 -0.013,0.005 -0.024,0.012 -0.037,0.019 z"
       id="path6" />
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 128.046,170.223 0.861,2.814 2.867,-0.661 c 0.194,-0.045 0.33,0.19 0.194,0.335 l -2.006,2.153 2.006,2.153 c 0.136,0.146 0.001,0.381 -0.194,0.335 l -2.867,-0.661 -0.861,2.814 c -0.058,0.191 -0.329,0.191 -0.387,0 l -0.861,-2.814 -2.867,0.661 c -0.194,0.045 -0.33,-0.19 -0.194,-0.335 l 2.006,-2.153 -2.006,-2.153 c -0.136,-0.146 -10e-4,-0.381 0.194,-0.335 l 2.867,0.661 0.861,-2.814 c 0.059,-0.191 0.329,-0.191 0.387,0 z"
       id="path7" />
    	<path
       fill="#ffe15a"
       d="m 113.939,156.703 0.861,2.814 2.867,-0.661 c 0.194,-0.045 0.33,0.19 0.194,0.335 l -2.006,2.153 2.006,2.153 c 0.136,0.146 10e-4,0.381 -0.194,0.335 l -2.867,-0.661 -0.861,2.814 c -0.058,0.191 -0.329,0.191 -0.387,0 l -0.861,-2.814 -2.867,0.661 c -0.194,0.045 -0.33,-0.19 -0.194,-0.335 l 2.006,-2.153 -2.006,-2.153 c -0.136,-0.146 -10e-4,-0.381 0.194,-0.335 l 2.867,0.661 0.861,-2.814 c 0.058,-0.191 0.328,-0.191 0.387,0 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 142.255,156.703 0.861,2.814 2.867,-0.661 c 0.194,-0.045 0.33,0.19 0.194,0.335 l -2.006,2.153 2.006,2.153 c 0.136,0.146 0.001,0.381 -0.194,0.335 l -2.867,-0.661 -0.861,2.814 c -0.058,0.191 -0.329,0.191 -0.387,0 l -0.861,-2.814 -2.867,0.661 c -0.194,0.045 -0.33,-0.19 -0.194,-0.335 l 2.006,-2.153 -2.006,-2.153 c -0.136,-0.146 -0.001,-0.381 0.194,-0.335 l 2.867,0.661 0.861,-2.814 c 0.059,-0.191 0.329,-0.191 0.387,0 z"
       id="path9" />
    </g>
    <path
       fill="#ff1722"
       d="m 166.934,66.963 c 0.03,1.565 0.055,3.144 0.055,4.849 -0.708,17.704 -3.342,56.258 -9.082,67.87 -8.463,16.996 -16.277,22.614 -30.055,27.791 -13.778,-5.176 -21.591,-10.793 -30.048,-27.778 -5.761,-11.656 -8.414,-50.866 -9.091,-67.882 0,-1.707 0.028,-3.268 0.052,-4.846 -1.698,0.665 -3.386,1.368 -5.058,2.123 0.118,3.438 0.974,25.992 3.545,45.823 1.45,11.071 3.446,21.274 6.163,26.713 9.837,19.55 19.726,25.248 34.438,30.515 14.713,-5.269 24.601,-10.969 34.439,-30.515 2.718,-5.439 4.713,-15.642 6.164,-26.713 2.57,-19.831 3.425,-42.385 3.544,-45.823 -1.675,-0.757 -3.364,-1.462 -5.066,-2.127 z"
       id="path10" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SJ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.00198 335.44963" {...props}>
    <defs
         id="defs39" /><path
         fill="#ff4b55"
         d="M 503.172,335.44961 H 8.828 c -4.875,0 -8.828,-3.953 -8.828,-8.828 V 8.828609 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62161 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
         id="path2" /><path
         fill="#ffffff"
         d="M 142.39648,0 V 124.74219 H 0 v 85.9668 h 142.39648 v 124.74023 h 85.96485 V 210.70899 h 283.64062 v -85.9668 H 512 228.36133 V 0 Z m 33,16.501949 h 19.96485 V 157.74219 H 495.5 v 19.9668 H 195.36133 V 318.94922 H 175.39648 V 177.70899 H 16.5 v -19.9668 h 158.89648 z"
         id="polygon4" /><polygon
         id="polygon848"
         points="211.862,88.277 158.897,88.277 158.897,229.518 0,229.518 0,282.484 158.897,282.484 158.897,423.725 211.862,423.725 211.862,282.484 512,282.484 512,229.518 211.862,229.518 "
         fill="#3e64ff"
         transform="translate(0,-88.275391)" /><g
         id="g6"
         transform="translate(0,-88.275391)" /><g
         id="g8"
         transform="translate(0,-88.275391)" /><g
         id="g10"
         transform="translate(0,-88.275391)" /><g
         id="g12"
         transform="translate(0,-88.275391)" /><g
         id="g14"
         transform="translate(0,-88.275391)" /><g
         id="g16"
         transform="translate(0,-88.275391)" /><g
         id="g18"
         transform="translate(0,-88.275391)" /><g
         id="g20"
         transform="translate(0,-88.275391)" /><g
         id="g22"
         transform="translate(0,-88.275391)" /><g
         id="g24"
         transform="translate(0,-88.275391)" /><g
         id="g26"
         transform="translate(0,-88.275391)" /><g
         id="g28"
         transform="translate(0,-88.275391)" /><g
         id="g30"
         transform="translate(0,-88.275391)" /><g
         id="g32"
         transform="translate(0,-88.275391)" /><g
         id="g34"
         transform="translate(0,-88.275391)" />
  </svg>
);

export const SK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#f5f5f5"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#41479b"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <path
       fill="#ff4b55"
       d="M 130.225,251.01 C 127.612,249.509 66.207,213.794 66.207,158.897 V 83.863 h 132.414 v 75.034 c 0,54.897 -61.405,90.612 -64.018,92.113 l -2.189,1.249 z"
       id="path3" />
    <polygon
       fill="#f5f5f5"
       points="139.35,236.673 139.35,224.255 143.511,224.255 160.157,226.996 157.903,217.319 160.157,207.642 143.511,210.382 139.35,210.382 139.35,206.188 142.09,185.38 132.414,188.199 122.738,185.38 125.478,206.188 125.478,210.382 121.315,210.382 104.67,207.642 106.924,217.319 104.67,226.996 121.315,224.255 125.478,224.255 125.478,236.673 118.542,236.673 97.734,233.932 100.552,243.608 97.734,253.285 118.542,250.544 125.478,250.544 125.478,282.484 139.35,282.484 139.35,250.544 146.285,250.544 167.094,253.285 164.276,243.608 167.094,233.932 146.285,236.673 "
       id="polygon3"
       transform="translate(0,-88.276)" />
    <path
       fill="#41479b"
       d="m 132.414,180.966 c -9.118,0 -16.938,5.532 -20.302,13.419 -0.594,-0.049 -1.162,-0.178 -1.767,-0.178 -11.751,0 -21.266,9.21 -21.94,20.791 17.875,22.004 40.264,35.116 41.82,36.011 l 2.189,1.25 2.189,-1.25 c 1.556,-0.895 23.945,-14.006 41.82,-36.011 -0.674,-11.581 -10.189,-20.791 -21.94,-20.791 -0.605,0 -1.173,0.129 -1.767,0.178 -3.364,-7.887 -11.184,-13.419 -20.302,-13.419 z"
       id="path4" />
    <path
       fill="#f5f5f5"
       d="m 194.207,88.277 c 0,0 0,52.966 0,70.621 0,52.966 -61.793,88.276 -61.793,88.276 0,0 -61.793,-35.31 -61.793,-88.276 0,-17.655 0,-70.621 0,-70.621 h 123.586 m 8.827,-8.828 H 194.206 70.621 61.793 v 8.828 70.621 c 0,57.428 63.537,94.394 66.241,95.94 l 4.38,2.503 4.38,-2.503 c 2.705,-1.546 66.241,-38.513 66.241,-95.94 V 88.277 79.449 Z"
       id="path5" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#73af00"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs60" />
    <path
       fill="#f5f5f5"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#82afff"
       d="m 0,167.725 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.45 0,331.497 0,326.622 Z"
       id="path2" />
    <path
       fill="#b46446"
       d="m 256.82,239.705 c -1.495,-0.065 -36.791,-1.87 -54.505,-26.14 -10.324,-14.142 -12.384,-32.952 -6.123,-55.907 l 2.529,0.69 c -6.038,22.143 -4.12,40.195 5.704,53.662 16.958,23.249 52.154,25.06 52.51,25.075 z"
       id="path3" />
    <g
       id="g9"
       transform="translate(0,-88.275)">
    	<path
       fill="#41aa5a"
       d="m 196.167,235.756 c -1.74,4.533 -1.343,9.28 0.672,12.878 3.906,-1.325 7.377,-4.587 9.118,-9.12 1.74,-4.533 1.343,-9.28 -0.672,-12.878 -3.907,1.325 -7.378,4.586 -9.118,9.12 z"
       id="path4" />
    	<path
       fill="#41aa5a"
       d="m 218.275,298.424 c -1.932,3.187 -2.439,7.46 -1.007,11.608 1.336,3.876 4.094,6.735 7.29,8.178 -3.105,-1.628 -7.054,-2.035 -10.93,-0.698 -4.148,1.43 -7.2,4.463 -8.52,7.948 3.187,1.931 7.459,2.439 11.608,1.007 4.148,-1.43 7.2,-4.463 8.52,-7.948 l -0.004,-0.002 c 1.916,-3.183 2.418,-7.439 0.992,-11.573 -1.431,-4.148 -4.463,-7.201 -7.949,-8.52 z"
       id="path5" />
    	<path
       fill="#41aa5a"
       d="m 210.717,286.856 c -2.98,2.237 -5.044,6.013 -5.263,10.395 -0.205,4.095 1.288,7.776 3.715,10.306 -2.275,-2.668 -5.788,-4.519 -9.88,-4.724 -4.382,-0.22 -8.345,1.457 -10.869,4.199 2.237,2.98 6.013,5.044 10.394,5.263 4.382,0.22 8.345,-1.457 10.869,-4.199 -0.001,-10e-4 -0.002,-0.002 -0.002,-0.002 2.963,-2.241 5.015,-6.003 5.235,-10.37 0.219,-4.382 -1.457,-8.346 -4.199,-10.868 z"
       id="path6" />
    	<path
       fill="#41aa5a"
       d="m 207.448,273.814 c -3.604,0.947 -6.941,3.665 -8.797,7.639 -1.736,3.715 -1.742,7.687 -0.449,10.946 -1.1,-3.329 -3.654,-6.369 -7.368,-8.104 -3.976,-1.857 -8.278,-1.801 -11.649,-0.214 0.947,3.604 3.665,6.941 7.639,8.797 3.976,1.857 8.278,1.801 11.649,0.214 0,0 -0.001,-0.003 -0.002,-0.004 3.591,-0.956 6.911,-3.665 8.761,-7.626 1.859,-3.972 1.804,-8.277 0.216,-11.648 z"
       id="path7" />
    	<path
       fill="#41aa5a"
       d="m 209.302,260.872 c -3.709,-0.369 -7.783,1.017 -10.908,4.096 -2.921,2.878 -4.312,6.599 -4.235,10.104 0.129,-3.503 -1.206,-7.243 -4.083,-10.163 -3.08,-3.126 -7.132,-4.572 -10.845,-4.259 -0.369,3.709 1.016,7.781 4.096,10.908 3.08,3.127 7.132,4.572 10.845,4.259 0,0 0,-0.003 0,-0.006 3.699,0.355 7.755,-1.026 10.87,-4.095 3.127,-3.078 4.573,-7.131 4.26,-10.844 z"
       id="path8" />
    	<path
       fill="#41aa5a"
       d="m 211.924,248.554 c -3.596,-0.978 -7.843,-0.285 -11.435,2.234 -3.357,2.355 -5.344,5.794 -5.848,9.265 0.707,-3.434 0.009,-7.342 -2.344,-10.698 -2.519,-3.592 -6.276,-5.689 -9.991,-5.995 -0.978,3.596 -0.285,7.843 2.234,11.435 2.519,3.592 6.276,5.689 9.991,5.995 0,-0.002 0,-0.003 0,-0.003 3.588,0.961 7.818,0.269 11.398,-2.242 3.592,-2.52 5.689,-6.277 5.995,-9.991 z"
       id="path9" />
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    	<circle
       fill="#ffe15a"
       cx="212.97"
       cy="316.51001"
       r="2.7309999"
       id="circle9" />
    	<circle
       fill="#ffe15a"
       cx="225.52"
       cy="318.04001"
       r="2.7309999"
       id="circle10" />
    	<circle
       fill="#ffe15a"
       cx="205.75999"
       cy="295.87"
       r="2.7309999"
       id="circle11" />
    	<circle
       fill="#ffe15a"
       cx="188.39"
       cy="275.32999"
       r="2.7309999"
       id="circle12" />
    	<circle
       fill="#ffe15a"
       cx="200.52"
       cy="261.42999"
       r="2.7309999"
       id="circle13" />
    	<circle
       fill="#ffe15a"
       cx="195.92"
       cy="247.17"
       r="2.7309999"
       id="circle14" />
    </g>
    <path
       fill="#b46446"
       d="m 256.932,239.705 -0.115,-2.622 c 0.355,-0.013 35.552,-1.826 52.51,-25.075 9.824,-13.465 11.742,-31.519 5.704,-53.662 l 2.529,-0.69 c 6.26,22.955 4.2,41.766 -6.123,55.907 -17.713,24.272 -53.009,26.078 -54.505,26.142 z"
       id="path14" />
    <g
       id="g20"
       transform="translate(0,-88.275)">
    	<path
       fill="#41aa5a"
       d="m 317.586,235.756 c 1.74,4.533 1.343,9.28 -0.672,12.878 -3.906,-1.325 -7.377,-4.587 -9.118,-9.12 -1.74,-4.533 -1.343,-9.28 0.672,-12.878 3.906,1.325 7.377,4.586 9.118,9.12 z"
       id="path15" />
    	<path
       fill="#41aa5a"
       d="m 295.476,298.424 c 1.932,3.187 2.439,7.46 1.007,11.608 -1.336,3.876 -4.094,6.735 -7.29,8.178 3.105,-1.628 7.054,-2.035 10.93,-0.698 4.148,1.43 7.2,4.463 8.52,7.948 -3.187,1.931 -7.459,2.439 -11.608,1.007 -4.148,-1.43 -7.2,-4.463 -8.52,-7.948 0.001,-0.001 0.003,-0.001 0.003,-0.001 -1.913,-3.185 -2.415,-7.441 -0.99,-11.574 1.43,-4.148 4.463,-7.201 7.948,-8.52 z"
       id="path16" />
    	<path
       fill="#41aa5a"
       d="m 303.036,286.856 c 2.98,2.237 5.044,6.013 5.263,10.395 0.205,4.095 -1.288,7.776 -3.715,10.306 2.275,-2.668 5.788,-4.519 9.88,-4.724 4.382,-0.22 8.345,1.457 10.869,4.199 -2.237,2.98 -6.013,5.044 -10.395,5.263 -4.382,0.22 -8.345,-1.457 -10.869,-4.199 10e-4,-10e-4 0.002,-0.002 0.002,-0.002 -2.963,-2.241 -5.016,-6.003 -5.235,-10.37 -0.219,-4.382 1.458,-8.346 4.2,-10.868 z"
       id="path17" />
    	<path
       fill="#41aa5a"
       d="m 306.304,273.814 c 3.604,0.947 6.941,3.665 8.797,7.639 1.736,3.715 1.742,7.687 0.449,10.946 1.1,-3.329 3.654,-6.369 7.368,-8.104 3.976,-1.857 8.278,-1.801 11.649,-0.214 -0.947,3.604 -3.665,6.941 -7.639,8.797 -3.976,1.857 -8.278,1.801 -11.649,0.214 0,0 10e-4,-0.003 0.002,-0.004 -3.591,-0.956 -6.911,-3.665 -8.761,-7.626 -1.86,-3.972 -1.804,-8.277 -0.216,-11.648 z"
       id="path18" />
    	<path
       fill="#41aa5a"
       d="m 304.45,260.872 c 3.709,-0.369 7.783,1.017 10.908,4.096 2.921,2.878 4.312,6.599 4.235,10.104 -0.129,-3.503 1.206,-7.243 4.083,-10.163 3.08,-3.126 7.132,-4.572 10.845,-4.259 0.369,3.709 -1.016,7.781 -4.096,10.908 -3.08,3.127 -7.132,4.572 -10.845,4.259 0,0 0,-0.003 0,-0.006 -3.699,0.355 -7.755,-1.026 -10.87,-4.095 -3.127,-3.078 -4.573,-7.131 -4.26,-10.844 z"
       id="path19" />
    	<path
       fill="#41aa5a"
       d="m 301.828,248.554 c 3.596,-0.978 7.843,-0.285 11.435,2.234 3.357,2.355 5.344,5.794 5.848,9.265 -0.707,-3.434 -0.009,-7.342 2.344,-10.698 2.519,-3.592 6.276,-5.689 9.991,-5.995 0.978,3.596 0.285,7.843 -2.234,11.435 -2.519,3.592 -6.276,5.689 -9.991,5.995 0,-0.002 0,-0.003 0,-0.003 -3.588,0.961 -7.818,0.269 -11.398,-2.242 -3.592,-2.52 -5.689,-6.277 -5.995,-9.991 z"
       id="path20" />
    </g>
    <g
       id="g25"
       transform="translate(0,-88.275)">
    	<circle
       fill="#ffe15a"
       cx="300.79001"
       cy="316.51001"
       r="2.7309999"
       id="circle20" />
    	<circle
       fill="#ffe15a"
       cx="288.22"
       cy="318.04001"
       r="2.7309999"
       id="circle21" />
    	<circle
       fill="#ffe15a"
       cx="307.98999"
       cy="295.87"
       r="2.7309999"
       id="circle22" />
    	<circle
       fill="#ffe15a"
       cx="325.35999"
       cy="275.32999"
       r="2.7309999"
       id="circle23" />
    	<circle
       fill="#ffe15a"
       cx="313.23999"
       cy="261.42999"
       r="2.7309999"
       id="circle24" />
    	<circle
       fill="#ffe15a"
       cx="317.84"
       cy="247.17"
       r="2.7309999"
       id="circle25" />
    </g>
    <path
       fill="#8cd7ff"
       d="m 272.247,147.969 h -31.325 c -9.751,0 -17.655,7.904 -17.655,17.655 v 27.595 c 0,9.752 7.904,17.655 17.655,17.655 h 31.325 c 9.75,0 17.655,-7.903 17.655,-17.655 v -27.595 c 0,-9.751 -7.904,-17.655 -17.655,-17.655 z"
       id="path25" />
    <g
       id="g28"
       transform="translate(0,-88.275)">
    	<polygon
       fill="#f5f5f5"
       points="258.259,263.755 258.259,260.259 255.567,260.259 255.567,263.755 252.072,263.755 252.072,260.259 249.886,260.259 249.886,267.25 251.634,269.464 251.634,295.212 262.119,295.212 262.119,269.464 263.866,267.25 263.866,260.259 261.753,260.259 261.753,263.755 "
       id="polygon25" />
    	<path
       fill="#f5f5f5"
       d="m 257.386,249.191 c 1.729,-0.838 2.185,2.695 2.185,2.695 3.641,-1.821 2.691,-4.776 1.821,-6.189 -1.165,-1.894 -5.825,-2.622 -7.791,1.311 -1.966,3.933 3.35,11.724 3.35,11.724 0.289,-2.404 -1.823,-8.448 0.435,-9.541 z"
       id="path26" />
    	<polygon
       fill="#f5f5f5"
       points="276.226,270.272 276.226,266.776 273.535,266.776 273.535,270.272 270.039,270.272 270.039,266.776 267.853,266.776 267.853,273.768 269.601,275.981 269.601,301.729 280.087,301.729 280.087,275.981 281.834,273.768 281.834,266.776 279.722,266.776 279.722,270.272 "
       id="polygon26" />
    	<path
       fill="#f5f5f5"
       d="m 275.353,255.708 c 1.729,-0.838 2.185,2.695 2.185,2.695 3.641,-1.821 2.691,-4.776 1.821,-6.189 -1.165,-1.894 -5.825,-2.622 -7.791,1.311 -1.966,3.933 3.35,11.724 3.35,11.724 0.29,-2.404 -1.821,-8.448 0.435,-9.541 z"
       id="path27" />
    	<polygon
       fill="#f5f5f5"
       points="240.29,270.272 240.29,266.776 237.599,266.776 237.599,270.272 234.104,270.272 234.104,266.776 231.917,266.776 231.917,273.768 233.665,275.981 233.665,301.729 244.151,301.729 244.151,275.981 245.899,273.768 245.899,266.776 243.786,266.776 243.786,270.272 "
       id="polygon27" />
    	<path
       fill="#f5f5f5"
       d="m 239.417,255.708 c 1.729,-0.838 2.185,2.695 2.185,2.695 3.641,-1.821 2.691,-4.776 1.821,-6.189 -1.165,-1.894 -5.825,-2.622 -7.791,1.311 -1.966,3.933 3.35,11.724 3.35,11.724 0.291,-2.404 -1.821,-8.448 0.435,-9.541 z"
       id="path28" />
    </g>
    <path
       fill="#6ec86e"
       d="m 285.554,208.801 c -2.334,-1.154 -4.926,-1.864 -7.706,-1.864 -2.979,0 -5.741,0.815 -8.196,2.13 -3.191,-3.439 -7.713,-5.625 -12.776,-5.625 -5.063,0 -9.583,2.186 -12.776,5.625 -2.455,-1.315 -5.217,-2.13 -8.196,-2.13 -2.781,0 -5.373,0.71 -7.706,1.864 4.99,9.152 14.546,23.941 28.678,29.593 14.132,-5.652 23.688,-20.441 28.678,-29.593 z"
       id="path29" />
    <g
       id="g33"
       transform="translate(0,-88.275)">
    	<path
       fill="#ffe15a"
       d="m 256.718,179.947 0.158,-0.078 c 0,0 -0.053,0.013 -0.158,0.078 z"
       id="path30" />
    	<path
       fill="#ffe15a"
       d="m 256.876,179.869 0.158,0.078 c -0.106,-0.065 -0.158,-0.078 -0.158,-0.078 z"
       id="path31" />
    	<path
       fill="#ffe15a"
       d="m 290.409,194.833 c -0.983,-5.679 -8.301,-6.663 -16.712,-7.209 -8.41,-0.546 -12.015,-5.352 -12.015,-5.352 h -9.612 c 0,0 -3.605,4.806 -12.015,5.352 -8.41,0.546 -15.729,1.529 -16.712,7.209 -0.983,5.679 6.226,14.636 6.226,14.636 l 6.335,-5.133 c 0,0 -7.755,-7.427 -3.933,-10.158 3.775,-2.697 14.782,-0.829 19.684,-7.303 -0.207,1.353 -0.135,3.023 0.704,5.081 1.602,3.933 1.02,8.884 1.02,8.884 h 3.496 3.496 c 0,0 -0.583,-4.952 1.02,-8.884 0.839,-2.058 0.913,-3.73 0.704,-5.081 4.903,6.474 15.91,4.606 19.684,7.303 3.823,2.731 -3.933,10.158 -3.933,10.158 l 6.335,5.133 c 0.002,0 7.211,-8.957 6.228,-14.636 z"
       id="path32" />
    	<path
       fill="#ffe15a"
       d="m 260.444,162.611 h -1.821 v -1.966 c 0,-0.966 -0.782,-1.748 -1.748,-1.748 -0.966,0 -1.748,0.782 -1.748,1.748 v 1.966 h -1.894 c -0.966,0 -1.748,0.782 -1.748,1.748 0,0.966 0.782,1.748 1.748,1.748 h 1.894 v 5.024 c 0,0.966 0.782,1.748 1.748,1.748 0.966,0 1.748,-0.782 1.748,-1.748 v -5.024 h 1.821 c 0.966,0 1.748,-0.782 1.748,-1.748 0,-0.966 -0.783,-1.748 -1.748,-1.748 z"
       id="path33" />
    </g>
    <circle
       fill="#fff0e1"
       cx="256.87"
       cy="84.605003"
       r="3.4960001"
       id="circle33" />
    <g
       id="g34"
       transform="translate(0,-88.275)">
    	<path
       fill="#ffc75a"
       d="m 231.827,243.22 c 1.408,0.703 3.052,1.311 4.733,1.311 5.791,0 8.629,-3.275 8.629,-9.066 0,-5.791 -3.494,-10.158 -9.284,-10.158 0,0 -0.653,0.011 -1.699,0.171 -0.225,0.036 -0.448,0.07 -0.668,0.12 -5.567,1.062 -19.325,6.191 -22.1,31.166 -3.879,34.912 24.467,66.41 45.439,73.4 v -3.496 c -0.001,10e-4 -49.517,-37.864 -25.05,-83.448 z"
       id="path34" />
    	<polygon
       fill="#ffc75a"
       points="235.904,242.783 235.904,228.802 256.876,235.793 "
       id="polygon34" />
    </g>
    <g
       id="g35"
       transform="translate(0,-88.275)">
    	<polygon
       fill="#ffe15a"
       points="277.847,228.802 277.847,242.783 256.876,235.793 "
       id="polygon35" />
    	<path
       fill="#ffe15a"
       d="m 214.911,257.151 c 2.504,-22.538 14.317,-27.172 19.406,-28.145 0.111,-0.025 0.225,-0.042 0.417,-0.073 0.64,-0.098 1.081,-0.125 1.219,-0.131 3.832,0.026 6.359,2.913 6.359,6.408 0,3.854 -2.258,5.315 -4.514,5.388 0,0 1.821,-3.787 -1.894,-4.806 -2.506,-0.689 -5.679,1.311 -5.388,4.951 0.205,2.559 2.634,5.024 5.388,5.024 5.791,0 10.486,-4.185 10.486,-9.976 0,-5.791 -4.695,-10.486 -10.486,-10.486 0,0 -0.653,0.011 -1.699,0.171 -0.225,0.036 -0.448,0.07 -0.668,0.12 -5.567,1.062 -19.325,6.191 -22.1,31.166 -3.879,34.912 24.467,66.41 45.439,73.4 v -3.496 c 0,0 -7.427,-3.714 -12.505,-7.321 -15.689,-11.143 -32.292,-36.704 -29.46,-62.194 z"
       id="path35" />
    </g>
    <g
       id="g36"
       transform="translate(0,-88.275)">
    	<path
       fill="#ffc75a"
       d="m 281.926,243.22 c -1.408,0.703 -3.052,1.311 -4.733,1.311 -5.791,0 -8.629,-3.275 -8.629,-9.066 0,-5.791 3.494,-10.158 9.284,-10.158 0,0 0.653,0.011 1.699,0.171 0.225,0.036 0.448,0.07 0.668,0.12 5.567,1.062 19.325,6.191 22.1,31.166 3.879,34.912 -24.467,66.41 -45.439,73.4 v -3.496 c 0,10e-4 49.516,-37.864 25.05,-83.448 z"
       id="path36" />
    	<polygon
       fill="#ffc75a"
       points="277.847,242.783 277.847,228.802 256.876,235.793 "
       id="polygon36" />
    </g>
    <g
       id="g37"
       transform="translate(0,-88.275)">
    	<path
       fill="#ffe15a"
       d="m 298.84,257.151 c -2.504,-22.538 -14.317,-27.172 -19.406,-28.145 -0.111,-0.025 -0.225,-0.042 -0.417,-0.073 -0.64,-0.098 -1.081,-0.125 -1.219,-0.131 -3.832,0.026 -6.359,2.913 -6.359,6.408 0,3.854 2.258,5.315 4.514,5.388 0,0 -1.821,-3.787 1.894,-4.806 2.506,-0.689 5.679,1.311 5.388,4.951 -0.205,2.559 -2.634,5.024 -5.388,5.024 -5.791,0 -10.486,-4.185 -10.486,-9.976 0,-5.791 4.695,-10.486 10.486,-10.486 0,0 0.653,0.011 1.699,0.171 0.225,0.036 0.448,0.07 0.668,0.12 5.567,1.062 19.325,6.191 22.1,31.166 3.879,34.912 -24.467,66.41 -45.439,73.4 v -3.496 c 0,0 7.427,-3.714 12.505,-7.321 15.69,-11.143 32.293,-36.704 29.46,-62.194 z"
       id="path37" />
    	<circle
       fill="#ffe15a"
       cx="256.87"
       cy="235.8"
       r="3.4960001"
       id="circle37" />
    </g>
    <path
       fill="#ffc75a"
       d="m 281.834,119.446 c 0.928,-2.403 -0.328,-5.625 -0.328,-5.625 -3.222,-0.109 -5.461,2.239 -5.461,2.239 0.273,-2.894 -0.983,-5.516 -0.983,-5.516 -4.151,0.491 -5.516,2.95 -5.516,2.95 -0.218,-4.533 -2.95,-6.39 -2.95,-6.39 -3.605,1.092 -4.696,5.024 -4.696,5.024 -0.546,-4.478 -5.024,-6.553 -5.024,-6.553 0,0 -4.478,2.076 -5.024,6.553 0,0 -1.092,-3.933 -4.696,-5.024 0,0 -2.731,1.857 -2.95,6.39 0,0 -1.365,-2.457 -5.516,-2.95 0,0 -1.256,2.622 -0.983,5.516 0,0 -2.239,-2.348 -5.461,-2.239 0,0 -1.256,3.222 -0.328,5.625 0,0 -3.659,-1.146 -6.663,0.6 0,0 5.506,2.13 7.341,4.751 h 48.561 c 1.834,-2.622 7.341,-4.751 7.341,-4.751 -3.004,-1.747 -6.664,-0.6 -6.664,-0.6 z"
       id="path38" />
    <path
       fill="#ffe15a"
       d="m 281.156,124.799 c 0,1.572 -3.674,6.434 -3.674,6.434 0,0 -11.914,1.658 -20.606,1.658 -8.748,0 -20.689,-1.704 -20.689,-1.704 0,0 -3.592,-4.835 -3.592,-6.39 0,-4.47 10.871,-8.094 24.28,-8.094 13.41,10e-4 24.281,3.626 24.281,8.096 z"
       id="path39" />
    <g
       id="g40"
       transform="translate(0,-88.275)">
    	<ellipse
       fill="#ffc75a"
       cx="256.87"
       cy="218.32001"
       rx="20.976999"
       ry="6.9899998"
       id="ellipse39" />
    	<path
       fill="#ffc75a"
       d="m 262.009,179.541 c 0,-2.294 -1.711,-5.207 -5.133,-3.168 -3.423,-2.039 -5.133,0.874 -5.133,3.168 0,2.294 -2.622,2.622 -2.95,2.403 0,0 2.185,2.84 4.696,0.983 0,0 1.347,1.966 3.386,1.966 2.039,0 3.387,-1.966 3.387,-1.966 2.513,1.857 4.696,-0.983 4.696,-0.983 -0.327,0.218 -2.949,-0.11 -2.949,-2.403 z"
       id="path40" />
    </g>
    <g
       id="g42"
       transform="translate(0,-88.275)">
    	<path
       fill="#b46446"
       d="m 249.884,348.952 c -0.196,0 -0.396,-0.044 -0.584,-0.14 -0.649,-0.321 -0.911,-1.109 -0.587,-1.758 l 6.99,-13.981 c 0.324,-0.642 1.111,-0.911 1.758,-0.584 0.649,0.321 0.911,1.109 0.587,1.758 l -6.99,13.981 c -0.231,0.458 -0.693,0.724 -1.174,0.724 z"
       id="path41" />
    	<path
       fill="#b46446"
       d="m 263.869,348.952 c -0.481,0 -0.943,-0.266 -1.174,-0.724 l -6.99,-13.981 c -0.324,-0.649 -0.062,-1.437 0.587,-1.758 0.646,-0.331 1.433,-0.062 1.758,0.584 l 6.99,13.981 c 0.324,0.649 0.062,1.437 -0.587,1.758 -0.189,0.096 -0.388,0.14 -0.584,0.14 z"
       id="path42" />
    </g>
    <g
       id="g45"
       transform="translate(0,-88.275)">
    	<path
       fill="#f5f5f5"
       d="m 288.333,336.718 c -20.716,4.631 -42.199,4.631 -62.915,0 0,-3.496 0,-10.038 0,-13.533 20.716,4.631 42.199,4.631 62.915,0 0,3.496 0,10.039 0,13.533 z"
       id="path43" />
    	<path
       fill="#f5f5f5"
       d="m 242.749,331.624 c -13.377,2.581 -27.086,3.289 -40.727,2.015 0.23,1.802 11.017,7.158 11.017,7.158 0,0 -9.518,4.6 -9.306,6.266 13.058,1.22 26.183,0.638 39.016,-1.677 z"
       id="path44" />
    	<path
       fill="#f5f5f5"
       d="m 271.054,331.624 c 13.377,2.581 27.086,3.289 40.727,2.015 -0.23,1.802 -11.017,7.158 -11.017,7.158 0,0 9.518,4.6 9.306,6.266 -13.058,1.22 -26.183,0.638 -39.016,-1.677 z"
       id="path45" />
    </g>
    <g
       id="g46"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g58"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g59"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g60"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const SN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#73af00"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#ffe15a"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <path
       fill="#73af00"
       d="m 258.04,117.505 11.693,35.062 36.959,0.287 c 2.067,0.017 2.924,2.654 1.261,3.881 l -29.732,21.955 11.148,35.239 c 0.623,1.971 -1.62,3.601 -3.302,2.399 L 256,194.835 225.931,216.327 c -1.682,1.202 -3.925,-0.428 -3.302,-2.399 l 11.148,-35.239 -29.732,-21.955 c -1.663,-1.228 -0.806,-3.865 1.261,-3.881 l 36.959,-0.287 11.693,-35.062 c 0.655,-1.96 3.429,-1.96 4.082,10e-4 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const SO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#82afff"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 253.466,105.167 -14.81,44.409 -46.813,0.363 c -2.567,0.02 -3.63,3.295 -1.566,4.82 l 37.658,27.809 -14.121,44.632 c -0.775,2.447 2.012,4.471 4.099,2.978 L 256,202.958 294.086,230.18 c 2.088,1.492 4.874,-0.532 4.099,-2.978 l -14.121,-44.633 37.658,-27.809 c 2.065,-1.525 1.001,-4.8 -1.566,-4.82 l -46.813,-0.363 -14.81,-44.409 c -0.812,-2.435 -4.254,-2.435 -5.067,-0.001 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs17" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<rect
       y="150.071"
       fill="#f5f5f5"
       width="512"
       height="35.310001"
       id="rect1"
       x="0" />
    	<rect
       y="326.621"
       fill="#f5f5f5"
       width="512"
       height="35.310001"
       id="rect2"
       x="0" />
    </g>
    <rect
       y="97.104996"
       fill="#c8414b"
       width="512"
       height="141.24001"
       id="rect3"
       x="0" />
    <path
       fill="#ffe15a"
       d="m 253.801,113.339 -12.854,38.541 -40.627,0.314 c -2.228,0.018 -3.15,2.86 -1.359,4.183 l 32.683,24.135 -12.255,38.737 c -0.672,2.124 1.746,3.881 3.559,2.585 L 256,198.209 l 33.053,23.625 c 1.812,1.295 4.23,-0.461 3.559,-2.585 l -12.255,-38.737 32.683,-24.135 c 1.792,-1.323 0.868,-4.166 -1.359,-4.183 L 271.054,151.88 258.2,113.339 c -0.706,-2.113 -3.694,-2.113 -4.399,0 z"
       id="path3" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#464655"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 223.632 H 512 V 326.62 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.814"
       fill="#ff4b55"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 95.398,233.164 5.247,11.381 12.169,-2.994 c 0.76,-0.186 1.389,0.602 1.038,1.302 l -5.626,11.198 9.928,7.648 c 0.62,0.478 0.395,1.462 -0.371,1.623 l -12.263,2.583 0.211,12.531 c 0.013,0.782 -0.897,1.22 -1.5,0.723 l -9.665,-7.977 -9.665,7.977 c -0.604,0.498 -1.513,0.06 -1.5,-0.723 l 0.211,-12.531 -12.263,-2.583 c -0.766,-0.161 -0.99,-1.145 -0.371,-1.623 l 9.928,-7.648 -5.626,-11.198 c -0.351,-0.7 0.278,-1.489 1.038,-1.302 l 12.169,2.994 5.247,-11.381 c 0.327,-0.71 1.338,-0.71 1.664,0 z"
       id="path3" />
    	<rect
       y="194.21001"
       fill="#f5f5f5"
       width="512"
       height="15.01"
       id="rect3"
       x="0" />
    	<rect
       y="302.79001"
       fill="#f5f5f5"
       width="512"
       height="15.01"
       id="rect4"
       x="0" />
    </g>
    <path
       fill="#41479b"
       d="M 2.877,333.059 233.2,171.337 c 2.504,-1.758 2.504,-5.466 0,-7.224 L 2.877,2.39 C 1.131,4.004 0,6.263 0,8.828 V 326.62 c 0,2.565 1.131,4.826 2.877,6.439 z"
       id="path4" />
    <path
       fill="#ffe15a"
       d="m 73.561,126.571 19.831,20.297 25.624,-12.192 c 3.317,-1.579 6.735,1.974 5.03,5.228 l -13.175,25.132 19.513,20.602 c 2.527,2.667 0.204,7.016 -3.418,6.399 l -27.973,-4.765 -13.564,24.925 c -1.756,3.227 -6.61,2.361 -7.142,-1.273 L 74.173,182.847 46.277,177.65 c -3.612,-0.673 -4.288,-5.556 -0.995,-7.186 l 25.432,-12.588 -3.678,-28.138 c -0.477,-3.643 3.957,-5.794 6.525,-3.167 z"
       id="path5" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const ST = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <rect
       y="79.444"
       fill="#ffe15a"
       width="512"
       height="176.55"
       id="rect1"
       x="0" />
    <path
       fill="#ff4b55"
       d="M 2.666,332.916 176.551,167.724 2.666,2.533 C 1.027,4.135 0,6.355 0,8.828 V 326.62 c 0,2.473 1.027,4.693 2.666,6.296 z"
       id="path2" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#464655"
       d="m 278.298,215.767 9.047,27.126 28.594,0.222 c 3.702,0.029 5.237,4.753 2.259,6.953 l -23.002,16.986 8.626,27.263 c 1.117,3.53 -2.902,6.45 -5.914,4.297 l -23.263,-16.628 -23.263,16.628 c -3.011,2.153 -7.031,-0.767 -5.914,-4.297 l 8.626,-27.263 -23.002,-16.986 c -2.978,-2.199 -1.443,-6.924 2.259,-6.953 l 28.594,-0.222 9.047,-27.126 c 1.167,-3.512 6.135,-3.512 7.306,0 z"
       id="path3" />
    	<path
       fill="#464655"
       d="m 410.299,215.767 9.047,27.126 28.594,0.222 c 3.702,0.029 5.237,4.753 2.259,6.953 l -23.002,16.986 8.626,27.263 c 1.117,3.53 -2.902,6.45 -5.914,4.297 l -23.263,-16.628 -23.263,16.628 c -3.011,2.153 -7.031,-0.767 -5.914,-4.297 l 8.626,-27.263 -23.002,-16.986 c -2.978,-2.199 -1.443,-6.924 2.259,-6.953 l 28.594,-0.222 9.047,-27.126 c 1.166,-3.512 6.134,-3.512 7.306,0 z"
       id="path4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SV = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs80" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="M 512,200.093 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<path
       fill="#41479b"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 V 311.909 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    </g>
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g28"
       transform="translate(0,-88.276)">
    	<path
       fill="#50af69"
       d="m 255.789,293.563 c -21.295,0 -38.621,-17.325 -38.621,-38.621 0,-9.097 3.224,-17.931 9.08,-24.877 l 1.687,1.422 c -5.521,6.548 -8.561,14.877 -8.561,23.455 0,20.077 16.335,36.414 36.414,36.414 z"
       id="path3" />
    	<path
       fill="#50af69"
       d="m 241.662,282.16 c -0.482,0.823 -0.721,1.953 -0.825,3.1 -0.436,-0.314 -0.898,-0.606 -1.4,-0.851 0,0 -0.759,2.674 -0.166,4.599 0,0 -2.013,0.249 -3.861,2.103 0,0 0.637,0.45 1.73,0.919 -1.835,1.432 -2.401,2.848 -2.401,2.848 10.83,5.415 16.02,-2.138 16.246,-2.477 -2.653,-7.569 -9.323,-10.241 -9.323,-10.241 z"
       id="path4" />
    	<path
       fill="#50af69"
       d="m 250.985,292.403 c 0.007,0.019 0.015,0.035 0.022,0.055 v -0.087 c 0,0 -0.017,0.024 -0.022,0.032 z"
       id="path5" />
    	<path
       fill="#50af69"
       d="m 231.66,274.942 c -0.707,0.518 -1.321,1.383 -1.83,2.312 -0.253,-0.424 -0.535,-0.839 -0.87,-1.229 0,0 -1.618,1.976 -1.821,3.817 0,0 -1.788,-0.525 -4.023,0.362 0,0 0.372,0.612 1.122,1.408 -2.07,0.536 -3.065,1.523 -3.065,1.523 7.149,8.525 14.287,4.055 14.601,3.852 0.534,-7.355 -4.114,-12.045 -4.114,-12.045 z"
       id="path6" />
    	<path
       fill="#50af69"
       d="m 235.775,286.985 c -0.001,0.019 0,0.035 -0.002,0.054 l 0.032,-0.073 c 0,0 -0.022,0.014 -0.03,0.019 z"
       id="path7" />
    	<path
       fill="#50af69"
       d="m 225.455,265.505 c -0.772,0.163 -1.598,0.647 -2.359,1.22 -0.051,-0.442 -0.129,-0.887 -0.259,-1.332 0,0 -2.061,1.024 -2.91,2.461 0,0 -1.274,-1.095 -3.438,-1.194 0,0 0.078,0.641 0.401,1.572 -1.899,-0.327 -3.082,0.115 -3.082,0.115 2.713,9.652 10.232,8.625 10.567,8.574 3.158,-5.84 1.08,-11.416 1.08,-11.416 z"
       id="path8" />
    	<path
       fill="#50af69"
       d="m 224.372,276.922 c -0.008,0.014 -0.013,0.029 -0.022,0.044 l 0.053,-0.049 c 0.001,0.001 -0.023,0.004 -0.031,0.005 z"
       id="path9" />
    	<path
       fill="#50af69"
       d="m 222.999,254.75 c -0.733,0.047 -1.586,0.367 -2.403,0.774 0.056,-0.39 0.087,-0.786 0.073,-1.187 0,0 -2.09,0.639 -3.183,1.782 0,0 -0.896,-1.103 -2.822,-1.452 0,0 -0.076,0.566 0,1.412 -1.634,-0.513 -2.801,-0.274 -2.801,-0.274 0.228,8.702 7.231,8.721 7.543,8.717 4.185,-4.684 3.593,-9.772 3.593,-9.772 z"
       id="path10" />
    	<path
       fill="#50af69"
       d="m 219.405,264.524 c -0.011,0.012 -0.019,0.023 -0.03,0.035 l 0.058,-0.035 c 0.001,0 -0.021,-10e-4 -0.028,0 z"
       id="path11" />
    	<path
       fill="#50af69"
       d="m 223.814,245.843 c -0.627,-0.15 -1.426,-0.103 -2.217,0.028 0.148,-0.312 0.277,-0.637 0.367,-0.977 0,0 -1.919,-0.004 -3.132,0.672 0,0 -0.466,-1.158 -1.991,-1.948 0,0 -0.211,0.455 -0.366,1.185 -1.238,-0.853 -2.279,-0.953 -2.279,-0.953 -2.06,7.358 3.809,9.186 4.072,9.263 4.725,-2.849 5.546,-7.27 5.546,-7.27 z"
       id="path12" />
    	<path
       fill="#50af69"
       d="m 218.27,253.112 c -0.012,0.008 -0.022,0.015 -0.034,0.022 l 0.058,-0.014 c 0,0 -0.019,-0.007 -0.024,-0.008 z"
       id="path13" />
    	<path
       fill="#50af69"
       d="m 219.168,235.011 c 0,0 -2.001,5.241 1.103,8.276 0,0 4.046,-1.195 6.046,-5.402 l -1.702,-0.322 -0.874,-2.621 -2.897,1.288 z"
       id="path14" />
    	<path
       fill="#50af69"
       d="m 224.802,226.586 c 0,0 -3.135,4.652 -0.8,8.311 0,0 4.212,-0.248 7.113,-3.893 l -1.585,-0.698 -0.257,-2.751 -3.113,0.598 z"
       id="path15" />
    	<path
       fill="#50af69"
       d="m 256.211,293.563 v -2.207 c 20.078,0 36.414,-16.337 36.414,-36.414 0,-8.577 -3.04,-16.907 -8.561,-23.455 l 1.687,-1.422 c 5.856,6.946 9.08,15.78 9.08,24.877 0,21.296 -17.325,38.621 -38.62,38.621 z"
       id="path16" />
    	<path
       fill="#50af69"
       d="m 270.338,282.16 c 0.482,0.823 0.721,1.953 0.825,3.1 0.436,-0.314 0.898,-0.606 1.4,-0.851 0,0 0.759,2.674 0.165,4.599 0,0 2.013,0.249 3.861,2.103 0,0 -0.637,0.45 -1.73,0.919 1.835,1.432 2.401,2.848 2.401,2.848 -10.83,5.415 -16.02,-2.138 -16.246,-2.477 2.654,-7.569 9.324,-10.241 9.324,-10.241 z"
       id="path17" />
    	<path
       fill="#50af69"
       d="m 261.015,292.403 c -0.007,0.019 -0.015,0.035 -0.022,0.055 v -0.087 c 0,0 0.017,0.024 0.022,0.032 z"
       id="path18" />
    	<path
       fill="#50af69"
       d="m 280.34,274.942 c 0.707,0.518 1.321,1.383 1.829,2.312 0.253,-0.424 0.535,-0.839 0.87,-1.229 0,0 1.618,1.976 1.821,3.817 0,0 1.788,-0.525 4.023,0.362 0,0 -0.372,0.612 -1.122,1.408 2.07,0.536 3.065,1.523 3.065,1.523 -7.149,8.525 -14.287,4.055 -14.601,3.852 -0.533,-7.355 4.115,-12.045 4.115,-12.045 z"
       id="path19" />
    	<path
       fill="#50af69"
       d="m 276.225,286.985 c 10e-4,0.019 0,0.035 0.002,0.054 l -0.032,-0.073 c 0,0 0.022,0.014 0.03,0.019 z"
       id="path20" />
    	<path
       fill="#50af69"
       d="m 286.545,265.505 c 0.772,0.163 1.598,0.647 2.359,1.22 0.051,-0.442 0.129,-0.887 0.259,-1.332 0,0 2.061,1.024 2.91,2.461 0,0 1.274,-1.095 3.438,-1.194 0,0 -0.078,0.641 -0.401,1.572 1.899,-0.327 3.082,0.115 3.082,0.115 -2.713,9.652 -10.232,8.625 -10.567,8.574 -3.158,-5.84 -1.08,-11.416 -1.08,-11.416 z"
       id="path21" />
    	<path
       fill="#50af69"
       d="m 287.628,276.922 c 0.008,0.014 0.013,0.029 0.022,0.044 l -0.053,-0.049 c -10e-4,0.001 0.023,0.004 0.031,0.005 z"
       id="path22" />
    	<path
       fill="#50af69"
       d="m 289.001,254.75 c 0.733,0.047 1.586,0.367 2.403,0.774 -0.056,-0.39 -0.087,-0.786 -0.073,-1.187 0,0 2.09,0.639 3.183,1.782 0,0 0.896,-1.103 2.822,-1.452 0,0 0.076,0.566 0,1.412 1.634,-0.513 2.801,-0.274 2.801,-0.274 -0.228,8.702 -7.231,8.721 -7.543,8.717 -4.185,-4.684 -3.593,-9.772 -3.593,-9.772 z"
       id="path23" />
    	<path
       fill="#50af69"
       d="m 292.595,264.524 c 0.011,0.012 0.019,0.023 0.03,0.035 l -0.059,-0.035 c 0,0 0.022,-10e-4 0.029,0 z"
       id="path24" />
    	<path
       fill="#50af69"
       d="m 288.186,245.843 c 0.627,-0.15 1.426,-0.103 2.217,0.028 -0.148,-0.312 -0.277,-0.637 -0.367,-0.977 0,0 1.919,-0.004 3.132,0.672 0,0 0.466,-1.158 1.991,-1.948 0,0 0.211,0.455 0.366,1.185 1.238,-0.853 2.279,-0.953 2.279,-0.953 2.06,7.358 -3.809,9.186 -4.072,9.263 -4.725,-2.849 -5.546,-7.27 -5.546,-7.27 z"
       id="path25" />
    	<path
       fill="#50af69"
       d="m 293.73,253.112 c 0.012,0.008 0.022,0.015 0.034,0.022 l -0.058,-0.014 c 0,0 0.019,-0.007 0.024,-0.008 z"
       id="path26" />
    	<path
       fill="#50af69"
       d="m 292.832,235.011 c 0,0 2.001,5.241 -1.103,8.276 0,0 -4.046,-1.195 -6.046,-5.402 l 1.702,-0.322 0.874,-2.621 2.897,1.288 z"
       id="path27" />
    	<path
       fill="#50af69"
       d="m 287.198,226.586 c 0,0 3.135,4.652 0.8,8.311 0,0 -4.212,-0.248 -7.113,-3.893 l 1.585,-0.698 0.257,-2.751 3.113,0.598 z"
       id="path28" />
    </g>
    <path
       fill="#41479b"
       d="m 256,182.07 -3.412,5.118 c -0.583,0.874 -0.468,2.038 0.276,2.781 l 3.136,3.136 3.136,-3.136 c 0.743,-0.743 0.858,-1.907 0.276,-2.781 z"
       id="path29" />
    <path
       fill="#f5f5f5"
       d="M 257.454,187.188 256,182.07 l -1.454,5.118 c -0.248,0.874 -0.199,2.038 0.117,2.781 l 1.337,3.136 1.336,-3.136 c 0.317,-0.744 0.367,-1.907 0.118,-2.781 z"
       id="path30" />
    <g
       id="g32"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="M 256,224.553 V 210.76 c 0,0 -5.241,7.54 -4.414,18.574"
       id="path31" />
    	<path
       fill="#41479b"
       d="m 232.494,224.6 c -7.582,16.456 0.195,29.996 1.827,32.545 0.043,0.068 10.827,-17.376 10.827,-17.376 L 232.494,224.6"
       id="path32" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 240.477,159.039 c -1.196,-3.725 -1.369,-8.075 0.067,-13.066 l -4.692,-5.624 c -3.855,10.388 -2.26,18.058 1.599,23.562 0.947,-1.523 1.999,-3.217 3.026,-4.872 z"
       id="path33" />
    <path
       fill="#ffe15a"
       d="m 244.967,152.412 c -0.329,0 -0.654,-0.147 -0.872,-0.427 l -13.837,-17.791 c -0.375,-0.481 -0.288,-1.174 0.193,-1.547 0.483,-0.375 1.174,-0.287 1.548,0.194 l 13.837,17.791 c 0.375,0.481 0.288,1.174 -0.193,1.547 -0.201,0.158 -0.44,0.233 -0.676,0.233 z"
       id="path34" />
    <path
       fill="#41479b"
       d="m 222.897,153.423 c -4.414,44.138 30.897,33.103 33.103,28.69 l -22.069,-11.034 4.414,-8.828 -15.448,-8.828"
       id="path35" />
    <path
       fill="#f5f5f5"
       d="m 233.567,158.502 -6.151,-3.69 c -1.384,26.228 12.622,30.596 22.953,29.294 -8.375,-1.124 -16.743,-7.308 -16.802,-25.604 z"
       id="path36" />
    <path
       fill="#ffe15a"
       d="m 238.343,163.352 c -0.2,0 -0.402,-0.054 -0.584,-0.168 l -17.654,-11.032 c -0.516,-0.323 -0.673,-1.004 -0.35,-1.519 0.322,-0.52 1.002,-0.676 1.521,-0.351 l 17.654,11.032 c 0.516,0.323 0.673,1.004 0.35,1.519 -0.21,0.336 -0.57,0.519 -0.937,0.519 z"
       id="path37" />
    <path
       fill="#41479b"
       d="m 279.506,136.28 c 7.582,16.456 -0.195,29.996 -1.827,32.545 -0.043,0.068 -10.827,-17.376 -10.827,-17.376 l 12.654,-15.169"
       id="path38" />
    <path
       fill="#f5f5f5"
       d="m 271.523,158.995 c 1.196,-3.725 1.369,-8.075 -0.067,-13.066 l 4.692,-5.624 c 3.855,10.388 2.26,18.058 -1.599,23.562 -0.947,-1.522 -1.999,-3.217 -3.026,-4.872 z"
       id="path39" />
    <path
       fill="#ffe15a"
       d="m 267.033,152.369 c -0.236,0 -0.476,-0.075 -0.676,-0.233 -0.481,-0.373 -0.568,-1.067 -0.193,-1.547 l 13.837,-17.791 c 0.375,-0.481 1.067,-0.567 1.548,-0.194 0.481,0.373 0.568,1.067 0.193,1.547 l -13.837,17.791 c -0.217,0.281 -0.543,0.427 -0.872,0.427 z"
       id="path40" />
    <path
       fill="#41479b"
       d="m 289.103,153.38 c 4.414,44.138 -30.897,33.103 -33.103,28.69 l 22.069,-11.034 -4.414,-8.828 15.448,-8.828"
       id="path41" />
    <path
       fill="#f5f5f5"
       d="m 278.433,158.458 6.151,-3.69 c 1.384,26.228 -12.622,30.596 -22.953,29.294 8.375,-1.124 16.743,-7.307 16.802,-25.604 z"
       id="path42" />
    <path
       fill="#ffe15a"
       d="m 273.657,163.309 c -0.367,0 -0.727,-0.183 -0.937,-0.52 -0.323,-0.515 -0.165,-1.196 0.35,-1.519 l 17.654,-11.032 c 0.519,-0.326 1.198,-0.168 1.521,0.351 0.323,0.515 0.166,1.196 -0.35,1.519 l -17.654,11.032 c -0.182,0.115 -0.384,0.169 -0.584,0.169 z"
       id="path43" />
    <circle
       fill="#ffe6e6"
       cx="256"
       cy="155.58499"
       r="8.8280001"
       id="circle43" />
    <circle
       fill="#f5f5f5"
       cx="256"
       cy="155.58499"
       r="4.414"
       id="circle44" />
    <path
       fill="#ffe15a"
       d="m 256,169.932 c -0.61,0 -1.103,-0.493 -1.103,-1.103 v -13.241 c 0,-0.61 0.493,-1.103 1.103,-1.103 0.61,0 1.103,0.493 1.103,1.103 v 13.241 c 0,0.61 -0.493,1.103 -1.103,1.103 z"
       id="path44" />
    <polygon
       fill="#5aa0e6"
       points="233.931,257.038 278.253,257.038 286.161,270.162 227.034,270.162 "
       id="polygon44"
       transform="translate(0,-88.276)" />
    <path
       fill="#ffb750"
       d="m 257.795,171.22 h 15.377 l -4.783,-4.783 c -0.225,-0.225 -0.5,-0.395 -0.801,-0.495 l -1.665,-0.555 c -0.6,-0.2 -1.259,-0.111 -1.785,0.239 l -5.316,3.544 z"
       id="path45" />
    <path
       fill="#ffc455"
       d="m 252.567,172.047 h 18.353 l -5.709,-5.709 c -0.268,-0.268 -0.596,-0.471 -0.957,-0.591 l -1.987,-0.662 c -0.716,-0.238 -1.503,-0.134 -2.131,0.286 l -6.345,4.231 z"
       id="path46" />
    <path
       fill="#ffcd55"
       d="m 246.183,172.966 h 22.163 l -6.894,-6.894 c -0.324,-0.324 -0.719,-0.568 -1.155,-0.714 l -2.4,-0.8 c -0.865,-0.288 -1.815,-0.161 -2.573,0.344 l -7.662,5.108 z"
       id="path47" />
    <path
       fill="#ffd25a"
       d="m 239.865,173.794 h 25.376 l -7.894,-7.894 c -0.372,-0.372 -0.824,-0.651 -1.323,-0.818 l -2.748,-0.916 c -0.991,-0.33 -2.078,-0.184 -2.947,0.395 l -8.774,5.849 z"
       id="path48" />
    <path
       fill="#ffe15a"
       d="m 229.517,175.449 h 33.103 l -10.297,-10.297 c -0.484,-0.484 -1.075,-0.85 -1.726,-1.066 l -3.584,-1.195 c -1.292,-0.43 -2.711,-0.241 -3.844,0.515 l -11.445,7.629 z"
       id="path49" />
    <g
       id="g52"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 258.382,245.843 h -4.771 l 1.099,-4.607 h 1.658 c 0.537,0 1.004,0.369 1.129,0.892 z"
       id="path50" />
    	<path
       fill="#ff4b55"
       d="m 258.108,246.583 h -4.284 c -0.351,0 -0.634,-0.284 -0.634,-0.634 v -0.212 c 0,-0.351 0.285,-0.634 0.634,-0.634 h 4.284 c 0.351,0 0.634,0.285 0.634,0.634 v 0.212 c 0,0.349 -0.285,0.634 -0.634,0.634 z"
       id="path51" />
    	<path
       fill="#ff4b55"
       d="m 255.276,243.333 -1.071,-0.271 c -0.323,-0.082 -0.463,-0.462 -0.27,-0.734 l 0.775,-1.092 z"
       id="path52" />
    </g>
    <path
       fill="#41479b"
       d="m 250.495,144.251 c -0.052,0.405 -0.105,0.811 -0.157,1.216 1.715,-1.041 3.607,-1.665 5.662,-1.665 2.053,0.002 3.946,0.622 5.662,1.665 -0.052,-0.406 -0.105,-0.811 -0.157,-1.216 -1.706,-0.89 -3.542,-1.402 -5.505,-1.4 -1.962,-0.002 -3.798,0.509 -5.505,1.4 z"
       id="path53" />
    <path
       fill="#5aa0e6"
       d="m 250.563,143.723 c -0.052,0.405 -0.105,0.811 -0.157,1.216 1.696,-1.043 3.565,-1.668 5.593,-1.671 2.028,0.002 3.897,0.627 5.593,1.671 -0.052,-0.406 -0.105,-0.811 -0.157,-1.216 -1.687,-0.897 -3.499,-1.405 -5.437,-1.406 -1.936,0 -3.748,0.511 -5.435,1.406 z"
       id="path54" />
    <path
       fill="#9bc800"
       d="m 250.626,143.234 c -0.052,0.405 -0.105,0.811 -0.157,1.216 1.679,-1.046 3.527,-1.676 5.53,-1.675 2.004,0 3.851,0.629 5.53,1.675 -0.052,-0.405 -0.105,-0.811 -0.157,-1.216 -1.668,-0.896 -3.459,-1.41 -5.374,-1.411 -1.911,-0.001 -3.702,0.514 -5.372,1.411 z"
       id="path55" />
    <path
       fill="#ffe14e"
       d="m 250.699,142.675 c -0.052,0.406 -0.105,0.811 -0.157,1.216 1.66,-1.049 3.482,-1.681 5.459,-1.681 1.976,0.002 3.799,0.63 5.459,1.681 -0.052,-0.405 -0.105,-0.811 -0.157,-1.216 -1.649,-0.9 -3.414,-1.416 -5.301,-1.417 -1.889,0.002 -3.654,0.517 -5.303,1.417 z"
       id="path56" />
    <path
       fill="#ffb14e"
       d="m 250.77,142.126 c -0.052,0.405 -0.105,0.811 -0.157,1.216 1.641,-1.053 3.437,-1.685 5.387,-1.686 1.95,0.002 3.747,0.632 5.387,1.686 -0.052,-0.405 -0.105,-0.811 -0.157,-1.216 -1.629,-0.903 -3.37,-1.421 -5.23,-1.422 -1.86,0.002 -3.602,0.518 -5.23,1.422 z"
       id="path57" />
    <path
       fill="#ff4b55"
       d="m 250.799,141.892 c -0.036,0.284 -0.073,0.568 -0.109,0.852 1.619,-1.054 3.391,-1.693 5.311,-1.693 1.92,-10e-4 3.691,0.637 5.311,1.693 -0.036,-0.284 -0.073,-0.568 -0.109,-0.852 -1.62,-0.904 -3.351,-1.423 -5.201,-1.425 -1.851,-0.002 -3.583,0.52 -5.203,1.425 z"
       id="path58" />
    <g
       id="g61"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 286.897,271.449 h -61.793 c -0.407,0 -0.781,-0.224 -0.973,-0.582 -0.192,-0.36 -0.17,-0.796 0.055,-1.133 l 30.897,-46.345 c 0.409,-0.612 1.427,-0.612 1.836,0 l 30.897,46.345 c 0.225,0.339 0.247,0.774 0.055,1.133 -0.193,0.358 -0.567,0.582 -0.974,0.582 z m -59.732,-2.207 h 57.671 L 256,225.991 Z"
       id="path59" />
    	<path
       fill="#ffe15a"
       d="m 256,214.07 c -0.61,0 -1.103,-0.493 -1.103,-1.103 v -4.414 c 0,-0.61 0.493,-1.103 1.103,-1.103 0.61,0 1.103,0.493 1.103,1.103 v 4.414 c 0,0.61 -0.493,1.103 -1.103,1.103 z"
       id="path60" />
    	<path
       fill="#ffe15a"
       d="m 258.207,214.07 h -4.414 c -0.61,0 -1.103,-0.493 -1.103,-1.103 0,-0.61 0.493,-1.103 1.103,-1.103 h 4.414 c 0.61,0 1.103,0.493 1.103,1.103 0,0.61 -0.493,1.103 -1.103,1.103 z"
       id="path61" />
    </g>
    <g
       id="g65"
       transform="translate(0,-88.276)">
    	<path
       fill="#41479b"
       d="m 256,293.518 c -0.079,0 -0.161,-0.009 -0.239,-0.025 -1.08,-0.242 -4.684,-1.106 -5.747,-2.159 -1.35,-1.341 -1.357,-3.528 -0.019,-4.879 0.65,-0.653 1.514,-1.015 2.435,-1.017 h 0.012 c 0.917,0 1.779,0.355 2.43,1.002 1.063,1.056 1.954,4.651 2.202,5.728 0.085,0.369 -0.025,0.757 -0.292,1.026 -0.208,0.209 -0.491,0.324 -0.782,0.324 z m -3.558,-5.875 c -0.294,0.097 -0.647,0.131 -0.882,0.366 -0.482,0.484 -0.479,1.273 0.008,1.757 0.267,0.26 1.46,0.712 2.89,1.119 -0.418,-1.425 -0.877,-2.614 -1.141,-2.881 l 0.777,-0.782 -0.778,0.782 c -0.234,-0.234 -0.544,-0.361 -0.874,-0.361 z"
       id="path62" />
    	<path
       fill="#41479b"
       d="m 256,293.518 c -0.291,0 -0.574,-0.115 -0.783,-0.326 -0.266,-0.269 -0.377,-0.658 -0.292,-1.026 0.248,-1.078 1.14,-4.672 2.202,-5.728 v 0 c 0.654,-0.649 1.433,-0.943 2.442,-1.002 0.921,0.002 1.785,0.364 2.434,1.017 1.341,1.352 1.332,3.539 -0.017,4.877 -1.064,1.056 -4.668,1.92 -5.748,2.162 -0.077,0.017 -0.159,0.026 -0.238,0.026 z m 1.906,-6.297 0.777,0.782 c -0.264,0.267 -0.723,1.457 -1.141,2.881 1.43,-0.407 2.623,-0.857 2.891,-1.121 0.484,-0.481 0.488,-1.269 0.006,-1.754 -0.233,-0.235 -0.544,-0.366 -0.876,-0.366 h -0.004 c -0.33,0 -0.64,0.127 -0.874,0.36 z m 0,0 h 0.022 z"
       id="path63" />
    	<path
       fill="#41479b"
       d="m 251.586,300.139 c -0.61,0 -1.103,-0.493 -1.103,-1.103 0,-5.038 4.819,-7.505 5.024,-7.608 0.548,-0.274 1.205,-0.05 1.478,0.491 0.274,0.543 0.055,1.205 -0.487,1.481 -0.039,0.02 -3.807,1.976 -3.807,5.635 -0.001,0.611 -0.495,1.104 -1.105,1.104 z"
       id="path64" />
    	<path
       fill="#41479b"
       d="m 260.414,300.139 c -0.61,0 -1.103,-0.493 -1.103,-1.103 0,-3.659 -3.768,-5.617 -3.807,-5.635 -0.542,-0.276 -0.76,-0.938 -0.487,-1.481 0.275,-0.541 0.931,-0.765 1.478,-0.491 0.205,0.104 5.024,2.569 5.024,7.608 -0.002,0.609 -0.495,1.102 -1.105,1.102 z"
       id="path65" />
    </g>
    <g
       id="g66"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g67"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g68"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g69"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g70"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g71"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g72"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g73"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g74"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g75"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g76"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g77"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g78"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g79"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g80"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SX = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs32" />
    <path
       fill="#ff4b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 167.724 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 167.724 h 512 v 158.897 c 0,4.875 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="M 3.256,333.314 247.597,173.228 c 3.966,-2.599 3.966,-8.412 0,-11.009 L 3.256,2.134 C 1.311,3.753 0,6.099 0,8.827 V 326.62 c 0,2.729 1.311,5.075 3.256,6.694 z"
       id="path3" />
    <circle
       fill="#ffe15a"
       cx="90.5"
       cy="133.65399"
       r="27.719"
       id="circle3" />
    <path
       fill="#8cd7ff"
       d="m 124.39,159.33 c 0.11,3.363 0.476,6.833 0.829,10.187 1.385,13.163 2.582,24.533 -10.06,28.943 -2.988,1.042 -7.06,1.626 -10.996,2.19 -5.651,0.81 -10.711,1.534 -13.654,3.585 -2.943,-2.05 -8.002,-2.775 -13.654,-3.585 -3.936,-0.564 -8.009,-1.149 -10.996,-2.19 -12.642,-4.41 -11.445,-15.78 -10.06,-28.943 0.353,-3.354 0.718,-6.824 0.829,-10.187 0.393,-11.918 -2.12,-23.596 -3.885,-30.197 2.941,1.207 7.018,2.296 12.017,2.208 2.154,-0.043 4.573,-0.35 7.133,-0.674 5.844,-0.745 12.467,-1.583 17.768,0.512 l 0.85,0.378 0.85,-0.378 c 5.3,-2.095 11.924,-1.257 17.768,-0.512 2.56,0.324 4.979,0.631 7.133,0.674 4.999,0.088 9.077,-1.002 12.017,-2.208 -1.77,6.6 -4.282,18.279 -3.889,30.197 z"
       id="path4" />
    <path
       fill="#ff4b55"
       d="m 129.007,159.177 c -0.557,-16.894 5.207,-33.843 5.266,-34.012 l -3.633,-2.551 c -0.047,0.039 -5.511,4.277 -14.291,4.108 -1.908,-0.036 -4.207,-0.329 -6.642,-0.639 -6.113,-0.774 -13.009,-1.651 -19.199,0.486 -6.19,-2.136 -13.085,-1.259 -19.199,-0.486 -2.434,0.309 -4.734,0.602 -6.642,0.639 -8.78,0.169 -14.243,-4.07 -14.291,-4.108 l -3.633,2.551 c 0.057,0.169 5.823,17.118 5.266,34.012 -0.105,3.199 -0.461,6.583 -0.807,9.856 -1.389,13.206 -2.964,28.175 13.133,33.791 3.411,1.188 7.721,1.714 11.862,2.4 12.433,2.06 14.31,5.236 14.31,5.236 0,0 1.877,-3.177 14.31,-5.236 4.141,-0.686 8.451,-1.212 11.862,-2.4 16.098,-5.615 14.524,-20.585 13.133,-33.791 -0.343,-3.274 -0.7,-6.657 -0.805,-9.856 z m -4.617,0.153 c 0.11,3.363 0.476,6.833 0.829,10.187 1.385,13.163 2.582,24.533 -10.06,28.943 -2.988,1.042 -7.06,1.626 -10.996,2.19 -5.651,0.81 -10.711,1.534 -13.654,3.585 -2.943,-2.05 -8.002,-2.775 -13.654,-3.585 -3.936,-0.564 -8.009,-1.149 -10.996,-2.19 -12.642,-4.41 -11.445,-15.78 -10.06,-28.943 0.353,-3.354 0.718,-6.824 0.829,-10.187 0.393,-11.918 -2.12,-23.596 -3.885,-30.197 2.941,1.207 7.018,2.296 12.017,2.208 2.154,-0.043 4.573,-0.35 7.133,-0.674 5.844,-0.745 12.467,-1.583 17.768,0.512 l 0.85,0.378 0.85,-0.378 c 5.3,-2.095 11.924,-1.257 17.768,-0.512 2.56,0.324 4.979,0.631 7.133,0.674 4.999,0.088 9.077,-1.002 12.017,-2.208 -1.77,6.6 -4.282,18.279 -3.889,30.197 z"
       id="path5" />
    <polygon
       fill="#f5f5f5"
       points="116.075,265.822 116.075,262.818 111.807,262.818 111.807,252.361 116.075,252.361 96.557,238.534 96.557,233.333 99.272,233.333 90.508,227.125 81.746,233.333 84.459,233.333 84.459,238.534 64.941,252.361 69.21,252.361 69.21,262.818 64.941,262.818 64.941,265.822 66.687,265.822 66.687,276.004 64.137,276.004 64.137,280.399 116.881,280.399 116.881,276.004 114.33,276.004 114.33,265.822 "
       id="polygon5"
       transform="translate(0,-88.276)" />
    <g
       id="g11"
       transform="translate(0,-88.276)">
    	<path
       fill="#41aa5a"
       d="m 65.193,234.33 c -0.622,1.474 -0.516,3.036 0.145,4.185 1.286,-0.328 2.478,-1.341 3.101,-2.814 0.622,-1.474 0.516,-3.036 -0.145,-4.185 -1.285,0.328 -2.478,1.341 -3.101,2.814 z"
       id="path6" />
    	<path
       fill="#41aa5a"
       d="m 68.216,234.794 c 0.407,1.547 1.446,2.719 2.671,3.225 0.818,-1.044 1.143,-2.575 0.736,-4.122 -0.407,-1.547 -1.446,-2.719 -2.671,-3.225 -0.817,1.043 -1.143,2.575 -0.736,4.122 z"
       id="path7" />
    	<path
       fill="#41aa5a"
       d="m 72.914,232.222 c 1.5,0.557 3.055,0.384 4.175,-0.328 -0.383,-1.27 -1.448,-2.418 -2.947,-2.975 -1.5,-0.557 -3.055,-0.384 -4.175,0.328 0.383,1.269 1.447,2.416 2.947,2.975 z"
       id="path8" />
    	<path
       fill="#41aa5a"
       d="m 74.321,229.582 c 1.464,-0.644 2.461,-1.852 2.769,-3.142 -1.16,-0.644 -2.722,-0.727 -4.186,-0.084 -1.464,0.644 -2.46,1.852 -2.769,3.142 1.158,0.645 2.721,0.728 4.186,0.084 z"
       id="path9" />
    	<path
       fill="#41aa5a"
       d="m 64.479,230.916 c 1.305,-0.926 2.038,-2.308 2.081,-3.635 -1.265,-0.398 -2.813,-0.165 -4.118,0.76 -1.305,0.925 -2.038,2.308 -2.081,3.635 1.265,0.399 2.814,0.166 4.118,-0.76 z"
       id="path10" />
    	<path
       fill="#41aa5a"
       d="m 63.389,228.983 c 2.008,1.15 4.159,1.462 5.759,1 -0.412,-1.614 -1.769,-3.311 -3.777,-4.461 -2.008,-1.15 -4.159,-1.462 -5.759,-1 0.412,1.614 1.77,3.311 3.777,4.461 z"
       id="path11" />
    </g>
    <path
       fill="#ffe15a"
       d="m 71.86,143.065 c 0,-0.78 -0.621,-1.408 -1.395,-1.437 -0.029,-0.774 -0.655,-1.395 -1.437,-1.395 -0.782,0 -1.408,0.621 -1.437,1.395 -0.774,0.029 -1.395,0.655 -1.395,1.437 0,0.78 0.621,1.407 1.395,1.437 0.029,0.774 0.655,1.395 1.437,1.395 0.782,0 1.408,-0.621 1.437,-1.395 0.774,-0.03 1.395,-0.657 1.395,-1.437 z"
       id="path12" />
    <circle
       fill="#f5f5f5"
       cx="69.029999"
       cy="143.064"
       r="0.85000002"
       id="circle12" />
    <path
       fill="#ffe15a"
       d="m 67.34,141.633 c 0,-0.642 -0.511,-1.158 -1.146,-1.181 -0.024,-0.636 -0.54,-1.146 -1.181,-1.146 -0.642,0 -1.158,0.511 -1.181,1.146 -0.636,0.024 -1.146,0.54 -1.146,1.181 0,0.642 0.511,1.158 1.146,1.181 0.024,0.636 0.54,1.146 1.181,1.146 0.642,0 1.158,-0.511 1.181,-1.146 0.635,-0.024 1.146,-0.539 1.146,-1.181 z"
       id="path13" />
    <circle
       fill="#f5f5f5"
       cx="65.010002"
       cy="141.62399"
       r="0.69800001"
       id="circle13" />
    <path
       fill="#ffe15a"
       d="m 71.676,139.63 c 0,-0.462 -0.369,-0.834 -0.826,-0.851 -0.018,-0.458 -0.388,-0.826 -0.851,-0.826 -0.463,0 -0.834,0.369 -0.851,0.826 -0.458,0.018 -0.826,0.388 -0.826,0.851 0,0.462 0.369,0.834 0.826,0.851 0.018,0.458 0.388,0.826 0.851,0.826 0.463,0 0.834,-0.369 0.851,-0.826 0.458,-0.017 0.826,-0.388 0.826,-0.851 z"
       id="path14" />
    <circle
       fill="#f5f5f5"
       cx="70"
       cy="139.634"
       r="0.50300002"
       id="circle14" />
    <path
       fill="#ffe15a"
       d="m 68.494,138.184 c 0,-0.462 -0.369,-0.834 -0.826,-0.851 -0.018,-0.458 -0.388,-0.826 -0.851,-0.826 -0.462,0 -0.834,0.369 -0.851,0.826 -0.458,0.018 -0.826,0.388 -0.826,0.851 0,0.463 0.369,0.834 0.826,0.851 0.018,0.458 0.388,0.826 0.851,0.826 0.462,0 0.834,-0.369 0.851,-0.826 0.458,-0.017 0.826,-0.389 0.826,-0.851 z"
       id="path15" />
    <g
       id="g16"
       transform="translate(0,-88.276)">
    	<circle
       fill="#f5f5f5"
       cx="66.814003"
       cy="226.46001"
       r="0.50300002"
       id="circle15" />
    	<path
       fill="#f5f5f5"
       d="m 105.406,239.156 h 16.021 c -1.026,-2.349 -3.039,-4.167 -5.535,-4.907 0.182,-1.166 0.294,-2.461 0.294,-3.85 0,-4.839 -1.239,-8.761 -2.769,-8.761 -1.53,0 -2.769,3.923 -2.769,8.761 0,1.388 0.111,2.684 0.294,3.85 -2.497,0.74 -4.511,2.558 -5.536,4.907 z"
       id="path16" />
    </g>
    <path
       fill="#ffe15a"
       d="m 90.508,229.517 c -33.754,0 -61.216,-27.46 -61.216,-61.216 h 11.55 c 0,27.386 22.28,49.665 49.665,49.665 27.385,0 49.665,-22.279 49.665,-49.665 h 11.552 c 0,33.756 -27.46,61.216 -61.216,61.216 z"
       id="path17" />
    <path
       fill="#c87878"
       d="m 113.196,113.603 h -9.983 c 1.002,0 1.815,-0.812 1.815,-1.815 0,-1.003 -0.812,-1.815 -1.815,-1.815 H 90.508 c -1.002,0 -1.815,0.812 -1.815,1.815 0,1.003 0.812,1.815 1.815,1.815 H 67.821 c -1.504,0 -2.722,1.219 -2.722,2.722 0,1.503 1.219,2.722 2.722,2.722 h 8.167 c -1.002,0 -1.814,0.812 -1.814,1.815 0,1.002 0.812,1.815 1.815,1.815 h 16.335 c 1.002,0 1.815,-0.812 1.815,-1.815 0,-1.002 -0.812,-1.815 -1.814,-1.815 h 20.872 c 1.504,0 2.722,-1.219 2.722,-2.722 0,-1.503 -1.219,-2.722 -2.723,-2.722 z"
       id="path18" />
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SY = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#ff4b55"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#464655"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="m 150.03,223.315 7.36,22.068 23.262,0.18 c 3.011,0.023 4.26,3.866 1.837,5.656 l -18.713,13.82 7.017,22.179 c 0.908,2.871 -2.361,5.247 -4.811,3.496 l -18.925,-13.527 -18.925,13.527 c -2.451,1.751 -5.719,-0.625 -4.811,-3.496 l 7.017,-22.179 -18.713,-13.82 c -2.423,-1.789 -1.174,-5.633 1.837,-5.656 l 23.262,-0.18 7.36,-22.068 c 0.952,-2.857 4.993,-2.857 5.946,0 z"
       id="path3" />
    	<path
       fill="#73af00"
       d="m 367.917,223.315 7.36,22.068 23.262,0.18 c 3.011,0.023 4.26,3.866 1.837,5.656 l -18.713,13.82 7.017,22.179 c 0.908,2.871 -2.361,5.247 -4.811,3.496 l -18.925,-13.527 -18.925,13.527 c -2.451,1.751 -5.72,-0.625 -4.811,-3.496 l 7.017,-22.179 -18.713,-13.82 c -2.423,-1.789 -1.174,-5.633 1.837,-5.656 l 23.262,-0.18 7.36,-22.068 c 0.952,-2.857 4.993,-2.857 5.946,0 z"
       id="path4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const SZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs57" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    	<path
       fill="#4173cd"
       d="m 0,361.931 h 512 v 52.966 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,423.725 0,419.772 0,414.897 Z"
       id="path1" />
    	<path
       fill="#4173cd"
       d="m 8.828,88.276 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 150.07 H 0 V 97.103 c 0,-4.875 3.953,-8.827 8.828,-8.827 z"
       id="path2" />
    </g>
    <rect
       y="61.794006"
       fill="#ff4b55"
       width="512"
       height="211.86"
       id="rect2"
       x="0" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<rect
       y="141.24001"
       fill="#ffe15a"
       width="512"
       height="17.655001"
       id="rect3"
       x="0" />
    	<rect
       y="353.10001"
       fill="#ffe15a"
       width="512"
       height="17.655001"
       id="rect4"
       x="0" />
    	<path
       fill="#ffe15a"
       d="M 448.897,264.519 H 62.734 c -2.621,0 -4.745,-2.124 -4.745,-4.745 v -1.501 c 0,-2.621 2.124,-4.745 4.745,-4.745 h 386.163 c 2.621,0 4.745,2.124 4.745,4.745 v 1.501 c 0,2.62 -2.124,4.745 -4.745,4.745 z"
       id="path4" />
    </g>
    <polygon
       fill="#f5f5f5"
       points="412.428,242.538 393.195,250.781 373.962,242.538 393.195,234.295 "
       id="polygon4"
       transform="translate(0,-88.276)" />
    <path
       fill="#ffe15a"
       d="M 378.695,150.751 H 96.456 c -1.939,0 -3.511,1.571 -3.511,3.511 0,1.939 1.571,3.511 3.511,3.511 h 282.238 c 1.939,0 3.511,-1.572 3.511,-3.511 0,-1.939 -1.572,-3.511 -3.51,-3.511 z"
       id="path5" />
    <polygon
       fill="#f5f5f5"
       points="432.425,223.305 413.192,231.548 393.959,223.305 413.192,215.062 "
       id="polygon5"
       transform="translate(0,-88.276)" />
    <path
       fill="#ffe15a"
       d="M 398.69,131.518 H 116.452 c -1.939,0 -3.511,1.571 -3.511,3.511 0,1.939 1.571,3.511 3.511,3.511 H 398.69 c 1.939,0 3.511,-1.572 3.511,-3.511 0,-1.939 -1.571,-3.511 -3.511,-3.511 z"
       id="path6" />
    <path
       fill="#f5f5f5"
       d="m 255.816,99.31 c -48.808,0 -91.39,27.639 -114.197,68.69 22.806,41.05 65.389,68.69 114.197,68.69 48.808,0 91.39,-27.639 114.197,-68.69 -22.806,-41.051 -65.39,-68.69 -114.197,-68.69 z"
       id="path7" />
    <path
       fill="#464655"
       d="m 141.62,168 c 22.806,41.05 65.389,68.69 114.197,68.69 8.15,0 16.106,-0.836 23.846,-2.312 -5.909,-12.971 -26.691,-12.949 -27.967,-17.837 -1.374,-5.266 16.943,-4.121 20.149,-8.472 3.206,-4.35 -17.401,-6.182 -18.317,-10.532 -0.916,-4.351 8.243,-7.327 9.846,-14.196 1.603,-6.869 5.266,-8.929 8.013,-13.05 2.748,-4.121 -4.579,-5.495 -6.411,-19.233 -1.832,-13.738 -12.594,-15.57 -17.859,-26.788 -5.267,-11.219 3.206,-19.462 8.701,-24.957 C 207.009,99.31 164.426,126.949 141.62,168 Z"
       id="path8" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<rect
       x="184.37"
       y="231.55"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect8" />
    	<rect
       x="195.37"
       y="231.55"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect9" />
    	<rect
       x="206.36"
       y="231.55"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect10" />
    	<rect
       x="217.35001"
       y="231.55"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect11" />
    	<rect
       x="228.34"
       y="231.55"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect12" />
    	<rect
       x="239.33"
       y="231.55"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect13" />
    	<rect
       x="184.37"
       y="264.51999"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect14" />
    	<rect
       x="195.37"
       y="264.51999"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect15" />
    	<rect
       x="206.36"
       y="264.51999"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect16" />
    	<rect
       x="217.35001"
       y="264.51999"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect17" />
    	<rect
       x="228.34"
       y="264.51999"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect18" />
    	<rect
       x="239.33"
       y="264.51999"
       fill="#f5f5f5"
       width="5.4949999"
       height="21.981001"
       id="rect19" />
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    	<rect
       x="266.79999"
       y="231.55"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect20" />
    	<rect
       x="277.79001"
       y="231.55"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect21" />
    	<rect
       x="288.78"
       y="231.55"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect22" />
    	<rect
       x="299.76999"
       y="231.55"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect23" />
    	<rect
       x="310.76001"
       y="231.55"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect24" />
    	<rect
       x="321.75"
       y="231.55"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect25" />
    	<rect
       x="266.79999"
       y="264.51999"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect26" />
    	<rect
       x="277.79001"
       y="264.51999"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect27" />
    	<rect
       x="288.78"
       y="264.51999"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect28" />
    	<rect
       x="299.76999"
       y="264.51999"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect29" />
    	<rect
       x="310.76001"
       y="264.51999"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect30" />
    	<rect
       x="321.75"
       y="264.51999"
       fill="#464655"
       width="5.4949999"
       height="21.981001"
       id="rect31" />
    </g>
    <path
       fill="#245dbd"
       d="m 425.386,164.394 c -4.401,10.223 -16.925,11.426 -9.985,37.486 l 3.554,-3.608 c 0,0 3.723,9.823 12.693,16.438 0,0 11,-9.222 11.847,-23.854 l 4.569,2.005 c 0,-0.003 -2.2,-26.663 -22.678,-28.467 z"
       id="path31" />
    <g
       id="g36"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 441.633,273.618 c -0.352,0 -0.701,-0.163 -0.966,-0.482 -4.31,-5.199 -9.8,-6.866 -9.853,-6.884 -0.725,-0.213 -1.169,-1.084 -0.989,-1.942 0.18,-0.852 0.915,-1.385 1.636,-1.172 0.254,0.075 6.27,1.886 11.136,7.755 0.524,0.627 0.515,1.647 -0.015,2.268 -0.264,0.307 -0.605,0.457 -0.949,0.457 z"
       id="path32" />
    	<path
       fill="#ff4b55"
       d="m 438.531,285.746 c -0.405,0 -0.807,-0.213 -1.074,-0.627 -3.197,-4.924 -6.823,-7.605 -6.86,-7.63 -0.638,-0.463 -0.833,-1.453 -0.441,-2.211 0.394,-0.751 1.227,-0.983 1.865,-0.52 0.167,0.119 4.088,3.026 7.584,8.407 0.455,0.702 0.344,1.71 -0.248,2.249 -0.246,0.225 -0.538,0.332 -0.826,0.332 z"
       id="path33" />
    	<path
       fill="#ff4b55"
       d="m 431.426,299.245 c -0.076,0 -0.153,-0.007 -0.233,-0.025 -0.735,-0.15 -1.233,-0.978 -1.106,-1.848 0.534,-3.671 0.087,-9.691 -0.646,-12.798 -0.201,-0.852 0.22,-1.736 0.939,-1.98 0.727,-0.232 1.468,0.263 1.668,1.116 0.828,3.508 1.312,10.055 0.708,14.201 -0.112,0.783 -0.685,1.334 -1.33,1.334 z"
       id="path34" />
    	<path
       fill="#ff4b55"
       d="m 421.903,284.436 c -0.386,0 -0.769,-0.194 -1.036,-0.57 -0.481,-0.676 -0.409,-1.692 0.161,-2.261 0.034,-0.031 3.49,-3.54 4.393,-8.394 0.161,-0.864 0.878,-1.409 1.613,-1.221 0.729,0.188 1.193,1.046 1.032,1.911 -1.106,5.939 -5.122,9.992 -5.294,10.161 -0.255,0.249 -0.562,0.374 -0.869,0.374 z"
       id="path35" />
    	<path
       fill="#ff4b55"
       d="m 418.143,274.175 c -0.455,0 -0.899,-0.269 -1.155,-0.765 -0.392,-0.751 -0.193,-1.741 0.445,-2.205 0.051,-0.038 4.961,-3.652 6.484,-7.598 0.309,-0.814 1.119,-1.172 1.795,-0.796 0.68,0.37 0.979,1.322 0.669,2.124 -1.869,4.842 -7.302,8.833 -7.531,9.002 -0.224,0.163 -0.467,0.238 -0.707,0.238 z"
       id="path36" />
    </g>
    <path
       fill="#245dbd"
       d="m 82.285,167.834 c -3.679,8.548 -14.152,9.555 -8.35,31.345 l 2.972,-3.017 c 0,0 3.113,8.213 10.614,13.745 0,0 9.198,-7.711 9.906,-19.947 l 3.821,1.676 c 0,0.001 -1.839,-22.292 -18.963,-23.802 z"
       id="path37" />
    <g
       id="g42"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 95.871,273.628 c -0.295,0 -0.586,-0.136 -0.807,-0.404 -3.604,-4.348 -8.194,-5.741 -8.239,-5.757 -0.606,-0.178 -0.978,-0.906 -0.826,-1.624 0.15,-0.713 0.765,-1.158 1.368,-0.98 0.212,0.063 5.242,1.577 9.311,6.485 0.438,0.524 0.431,1.377 -0.013,1.896 -0.221,0.258 -0.507,0.384 -0.794,0.384 z"
       id="path38" />
    	<path
       fill="#ff4b55"
       d="m 93.277,283.768 c -0.339,0 -0.674,-0.178 -0.898,-0.524 -2.674,-4.117 -5.705,-6.359 -5.736,-6.38 -0.533,-0.387 -0.696,-1.215 -0.37,-1.849 0.33,-0.629 1.026,-0.822 1.559,-0.435 0.139,0.099 3.418,2.53 6.342,7.03 0.381,0.587 0.288,1.43 -0.207,1.88 -0.206,0.189 -0.45,0.278 -0.69,0.278 z"
       id="path39" />
    	<path
       fill="#ff4b55"
       d="m 87.335,295.057 c -0.064,0 -0.128,-0.006 -0.194,-0.021 -0.615,-0.126 -1.031,-0.818 -0.925,-1.545 0.447,-3.07 0.073,-8.104 -0.54,-10.701 -0.168,-0.713 0.183,-1.451 0.785,-1.655 0.608,-0.194 1.227,0.22 1.395,0.932 0.692,2.933 1.097,8.407 0.593,11.875 -0.095,0.653 -0.575,1.115 -1.114,1.115 z"
       id="path40" />
    	<path
       fill="#ff4b55"
       d="m 79.372,282.674 c -0.323,0 -0.643,-0.162 -0.867,-0.477 -0.403,-0.566 -0.343,-1.415 0.135,-1.891 0.029,-0.026 2.919,-2.959 3.672,-7.019 0.135,-0.723 0.734,-1.178 1.348,-1.022 0.61,0.157 0.998,0.875 0.863,1.598 -0.925,4.966 -4.284,8.355 -4.427,8.497 -0.211,0.209 -0.467,0.314 -0.724,0.314 z"
       id="path41" />
    	<path
       fill="#ff4b55"
       d="m 76.228,274.093 c -0.381,0 -0.751,-0.225 -0.967,-0.639 -0.328,-0.629 -0.161,-1.457 0.372,-1.844 0.042,-0.031 4.148,-3.054 5.422,-6.354 0.258,-0.681 0.936,-0.98 1.502,-0.665 0.568,0.309 0.818,1.106 0.559,1.775 -1.564,4.049 -6.105,7.385 -6.297,7.527 -0.186,0.137 -0.39,0.2 -0.591,0.2 z"
       id="path42" />
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs29" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path6" />
    </g>
    <path
       fill="#ffe15a"
       d="m 344.072,117.701 c -1.065,0 -1.928,0.863 -1.928,1.928 v 32.773 c 0,65.548 46.269,77.114 46.269,77.114 0,0 46.269,-11.567 46.269,-77.114 v -32.773 c 0,-1.065 -0.863,-1.928 -1.928,-1.928 z"
       id="path7" />
    <path
       fill="#f5f5f5"
       d="m 429.863,122.521 v 29.881 c 0,55.751 -34.461,69.813 -41.448,72.089 -7.026,-2.291 -41.451,-16.369 -41.451,-72.089 v -29.881 h 82.899 m 2.891,-4.82 h -88.682 c -1.065,0 -1.928,0.863 -1.928,1.928 v 32.773 c 0,65.548 46.269,77.114 46.269,77.114 0,0 46.269,-11.567 46.269,-77.114 v -32.773 c 0,-1.065 -0.863,-1.928 -1.928,-1.928 z"
       id="path8" />
    <path
       fill="#73af00"
       d="m 393.588,178.764 h -9.863 c 0,0 -7.954,7.954 -9.778,25.426 -0.059,0.557 0.167,1.121 0.608,1.468 1.673,1.311 6.372,4.339 14.101,4.339 7.729,0 12.428,-3.028 14.101,-4.339 0.441,-0.345 0.665,-0.91 0.608,-1.468 -1.823,-17.472 -9.777,-25.426 -9.777,-25.426 z"
       id="path9" />
    <g
       id="g11"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 393.588,265.396 h -9.863 v -8.218 c 0,-2.712 2.219,-4.931 4.931,-4.931 v 0 c 2.712,0 4.931,2.219 4.931,4.931 v 8.218 z"
       id="path10" />
    	<path
       fill="#ff4b55"
       d="m 393.588,268.684 h -9.863 c -0.908,0 -1.644,-0.736 -1.644,-1.644 v 0 c 0,-0.908 0.736,-1.644 1.644,-1.644 h 9.863 c 0.908,0 1.644,0.736 1.644,1.644 v 0 c -0.001,0.908 -0.737,1.644 -1.644,1.644 z"
       id="path11" />
    </g>
    <path
       fill="#d35a10"
       d="m 426.463,144.063 c -0.291,0 -4.579,0.02 -9.041,0.787 v -2.57 c 3.765,-1.718 7.454,-2.607 7.517,-2.622 0.441,-0.104 0.716,-0.546 0.612,-0.988 -0.105,-0.441 -0.546,-0.717 -0.988,-0.612 -0.248,0.057 -3.561,0.854 -7.171,2.425 -0.059,-0.985 -0.401,-1.889 -0.956,-2.635 2.946,-2.28 5.455,-3.729 5.502,-3.755 0.394,-0.225 0.532,-0.726 0.308,-1.121 -0.226,-0.395 -0.728,-0.532 -1.121,-0.308 -0.199,0.114 -2.831,1.632 -5.887,4.019 -0.786,-0.53 -1.731,-0.839 -2.748,-0.839 -1.057,0 -2.033,0.341 -2.836,0.909 0.843,-4.23 2.575,-6.061 2.599,-6.084 0.318,-0.321 0.317,-0.84 -0.003,-1.159 -0.321,-0.321 -0.841,-0.321 -1.162,0 -0.098,0.098 -1.695,1.747 -2.707,5.452 -1.012,-3.706 -2.609,-5.355 -2.707,-5.452 -0.319,-0.319 -0.835,-0.319 -1.158,-0.001 -0.321,0.318 -0.324,0.838 -0.008,1.161 0.023,0.023 1.756,1.855 2.599,6.084 -0.803,-0.568 -1.779,-0.909 -2.836,-0.909 -1.016,0 -1.962,0.31 -2.748,0.839 -3.055,-2.388 -5.687,-3.905 -5.887,-4.019 -0.395,-0.225 -0.897,-0.087 -1.121,0.308 -0.225,0.395 -0.087,0.896 0.308,1.121 0.046,0.026 2.556,1.474 5.503,3.754 -0.556,0.747 -0.897,1.651 -0.957,2.636 -3.609,-1.572 -6.923,-2.368 -7.171,-2.425 -0.444,-0.106 -0.884,0.171 -0.988,0.612 -0.104,0.442 0.171,0.885 0.612,0.988 0.063,0.014 3.752,0.903 7.517,2.622 v 2.57 c -4.461,-0.768 -8.749,-0.787 -9.041,-0.787 -0.454,0 -0.822,0.367 -0.822,0.822 0,0.454 0.367,0.822 0.822,0.822 0.071,0 4.564,0.018 9.041,0.812 v 2.659 c -2.466,-0.074 -5.217,0.271 -7.765,1.547 -0.406,0.203 -0.57,0.696 -0.367,1.102 0.145,0.288 0.435,0.455 0.736,0.455 0.124,0 0.248,-0.028 0.366,-0.087 2.269,-1.133 4.769,-1.429 7.029,-1.353 v 10.17 c 0,1.241 -0.124,2.489 -0.366,3.708 l -1.261,6.304 c -0.089,0.446 0.2,0.878 0.644,0.967 0.054,0.011 0.108,0.017 0.162,0.017 0.384,0 0.727,-0.269 0.806,-0.661 l 1.261,-6.304 c 0.265,-1.325 0.399,-2.68 0.399,-4.03 v -10.048 c 1.233,0.138 2.34,0.36 3.231,0.583 l 0.627,8.14 c 0.078,1.015 0.586,1.891 1.327,2.486 l -2.666,3.998 c -1.428,2.143 0.107,5.012 2.682,5.012 h 4.391 c 2.574,0 4.11,-2.87 2.682,-5.012 l -2.666,-3.998 c 0.742,-0.595 1.249,-1.472 1.327,-2.486 l 0.626,-8.14 c 0.89,-0.223 1.998,-0.445 3.231,-0.583 v 10.047 c 0,1.35 0.134,2.705 0.399,4.03 l 1.261,6.304 c 0.078,0.391 0.421,0.661 0.806,0.661 0.053,0 0.107,-0.004 0.162,-0.017 0.445,-0.089 0.734,-0.522 0.644,-0.967 l -1.261,-6.304 c -0.243,-1.218 -0.366,-2.465 -0.366,-3.708 V 150.84 c 2.26,-0.076 4.761,0.22 7.029,1.353 0.118,0.058 0.243,0.087 0.366,0.087 0.301,0 0.591,-0.167 0.736,-0.455 0.203,-0.406 0.039,-0.899 -0.367,-1.102 -2.547,-1.273 -5.298,-1.619 -7.765,-1.546 v -2.66 c 4.477,-0.794 8.97,-0.812 9.041,-0.812 0.455,0 0.822,-0.369 0.822,-0.822 0.003,-0.453 -0.365,-0.82 -0.819,-0.82 z m -10.685,1.102 c -0.982,0.213 -1.949,0.466 -2.86,0.769 -0.017,-0.324 -0.064,-0.638 -0.145,-0.942 0.911,-0.704 1.935,-1.343 3.006,-1.909 v 2.082 z m 0,-4.39 v 0.455 c -1.302,0.647 -2.584,1.397 -3.732,2.248 -0.238,-0.326 -0.513,-0.619 -0.829,-0.871 1.229,-1.362 2.596,-2.624 3.941,-3.737 0.388,0.537 0.62,1.193 0.62,1.905 z m -3.287,-3.288 c 0.49,0 0.951,0.115 1.369,0.308 -1.42,1.193 -2.86,2.55 -4.149,4.022 -0.168,-0.052 -0.333,-0.103 -0.509,-0.135 v -0.087 c 0,-0.374 0.013,-0.729 0.026,-1.082 0.137,-1.688 1.539,-3.026 3.263,-3.026 z m -8.219,0 c 1.724,0 3.126,1.337 3.261,3.027 0.013,0.353 0.026,0.707 0.026,1.082 v 0.087 c -0.175,0.032 -0.341,0.083 -0.509,0.135 -1.289,-1.472 -2.729,-2.829 -4.149,-4.022 0.42,-0.194 0.881,-0.309 1.371,-0.309 z m -3.287,3.288 c 0,-0.713 0.233,-1.368 0.62,-1.907 1.345,1.113 2.711,2.376 3.94,3.737 -0.316,0.252 -0.59,0.546 -0.829,0.872 -1.148,-0.851 -2.429,-1.601 -3.732,-2.248 z m 0,2.309 c 1.07,0.566 2.094,1.205 3.006,1.909 -0.082,0.305 -0.129,0.618 -0.145,0.941 -0.913,-0.303 -1.878,-0.556 -2.86,-0.769 v -2.081 z m 0,6.209 v -2.441 c 1.03,0.233 2.024,0.515 2.935,0.854 l 0.162,2.105 c -0.894,-0.208 -1.944,-0.398 -3.097,-0.518 z m 14.793,0.001 c -1.153,0.12 -2.204,0.31 -3.097,0.518 l 0.162,-2.105 c 0.911,-0.339 1.906,-0.62 2.935,-0.854 z"
       id="path12" />
    <path
       fill="#ffa033"
       d="m 374.534,166.253 h -3.692 l -14.109,-12.541 c -1.542,-1.369 -2.194,-3.482 -1.694,-5.483 l 3.934,-15.737 c 0.348,-1.393 2.082,-1.873 3.096,-0.857 l 6.385,6.385 c 0.346,0.346 0.815,0.541 1.305,0.541 h 4.773 v 27.693 z"
       id="path13" />
    <path
       fill="#ff9480"
       d="m 371.888,134.775 -2.265,10.197 c -0.41,1.848 -0.341,3.772 0.203,5.586 l 4.708,15.695 h 3.692 l 4.708,-15.695 c 0.544,-1.814 0.615,-3.737 0.203,-5.586 l -2.265,-10.197 c -0.468,-2.103 -2.333,-3.599 -4.488,-3.599 h -0.01 c -2.154,-10e-4 -4.02,1.496 -4.486,3.599 z"
       id="path14" />
    <path
       fill="#ffa0e4"
       d="m 376.38,134.868 v 0 c -1.02,0 -1.846,0.826 -1.846,1.846 v 29.539 h 3.692 v -29.539 c 0,-1.02 -0.827,-1.846 -1.846,-1.846 z"
       id="path15" />
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45401" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0040004272"
       fill="#ffe15a"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.448 H 341.333 V 0 H 503.172 C 508.047,0 512,3.953 512,8.828 V 326.62 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const TG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs18" />
    <g
       id="g1"
       transform="translate(0,-88.276)">
    	<path
       fill="#73af00"
       d="M 512,155.367 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    	<rect
       y="222.461"
       fill="#73af00"
       width="512"
       height="67.089996"
       id="rect1"
       x="0" />
    </g>
    <rect
       y="67.095001"
       fill="#ffe15a"
       width="512"
       height="67.089996"
       id="rect2"
       x="0" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 v -58.262 h 512 v 58.262 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="201.27499"
       fill="#ffe15a"
       width="512"
       height="67.089996"
       id="rect3"
       x="0" />
    <path
       fill="#ff4b55"
       d="M 194.207,201.27 H 8.828 C 3.953,201.27 0,197.317 0,192.442 V 8.828 C 0,3.953 3.953,0 8.828,0 h 185.379 c 4.875,0 8.828,3.953 8.828,8.828 v 183.614 c -0.001,4.875 -3.953,8.828 -8.828,8.828 z"
       id="path3" />
    <path
       fill="#f5f5f5"
       d="M 99.335,47.362 86.577,85.614 46.255,85.926 c -2.21,0.018 -3.127,2.838 -1.348,4.151 l 32.438,23.954 -12.163,38.446 c -0.666,2.108 1.734,3.851 3.531,2.566 l 32.806,-23.448 32.806,23.448 c 1.799,1.286 4.199,-0.458 3.531,-2.566 l -12.163,-38.445 32.438,-23.954 c 1.779,-1.313 0.862,-4.135 -1.348,-4.151 L 116.461,85.615 103.7,47.363 c -0.7,-2.099 -3.666,-2.099 -4.365,-10e-4 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TH = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.39999" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#f5f5f5"
       d="M 503.2,335.4 H 8.8 c -4.9,0 -8.8,-4 -8.8,-8.8 V 8.8 C 0,3.9 4,0 8.8,0 h 494.3 c 4.9,0 8.8,4 8.8,8.8 v 317.8 c 0.1,4.9 -3.9,8.8 -8.7,8.8 z"
       id="path1" />
    <g
       id="g3"
       transform="translate(0,-88.3)">
    	<path
       fill="#ff4b55"
       d="M 503.2,423.7 H 8.8 c -4.9,0 -8.8,-4 -8.8,-8.8 v -44.1 h 512 v 44.1 c 0,4.9 -4,8.8 -8.8,8.8 z"
       id="path2" />
    	<path
       fill="#ff4b55"
       d="m 8.8,88.3 h 494.3 c 4.9,0 8.8,4 8.8,8.8 v 44.1 H 0 V 97.1 c 0,-4.9 4,-8.8 8.8,-8.8 z"
       id="path3" />
    </g>
    <rect
       y="105.89999"
       fill="#41479b"
       width="512"
       height="123.6"
       id="rect3"
       x="0" />
    <g
       id="g4"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.3)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.3)">
    </g>
  </svg>
);

export const TJ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs29" />
    <path
       fill="#73af00"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g14"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffcd5a"
       d="m 227.069,287.535 c 3.67,-1.849 5.817,-4.897 6.966,-7.097 6.575,4.296 12.209,2.837 15.145,1.463 2.865,-1.342 5.224,-3.531 6.798,-5.762 1.575,2.231 3.934,4.42 6.798,5.762 2.935,1.374 8.569,2.83 15.145,-1.463 1.148,2.2 3.295,5.247 6.966,7.097 2.116,1.066 4.448,1.601 6.979,1.601 2.6,0 5.408,-0.563 8.408,-1.687 l -1.457,-3.886 c -4.771,1.789 -8.819,1.886 -12.025,0.286 -4.488,-2.237 -5.986,-7.17 -5.998,-7.211 l -0.875,-3.063 -2.447,2.038 c -4.318,3.596 -8.789,4.478 -12.936,2.53 -4.211,-1.972 -6.484,-5.963 -6.484,-7.16 v -17.907 c 0.898,-1.975 2.879,-3.358 5.186,-3.358 0.793,0 1.577,0.172 2.329,0.511 l 2.568,1.159 -0.388,-2.792 c -0.814,-5.866 -5.875,-10.289 -11.77,-10.289 -5.896,0 -10.956,4.423 -11.77,10.289 l -0.388,2.792 2.568,-1.159 c 0.751,-0.339 1.536,-0.511 2.329,-0.511 2.307,0 4.289,1.383 5.186,3.358 v 17.907 c 0,1.197 -2.272,5.188 -6.484,7.16 -4.145,1.947 -8.618,1.068 -12.936,-2.53 l -2.429,-2.012 -0.893,3.029 c -0.014,0.049 -1.513,4.982 -6.001,7.219 -3.209,1.601 -7.255,1.505 -12.025,-0.286 l -1.457,3.886 c 2.999,1.124 5.809,1.687 8.408,1.687 2.535,-0.001 4.867,-0.534 6.984,-1.601 z m 21.647,-40.93 c -0.248,0 -0.495,0.01 -0.742,0.032 1.389,-3.096 4.495,-5.219 8.003,-5.219 3.507,0 6.614,2.123 8.003,5.219 -3.226,-0.284 -6.278,1.292 -8.003,3.789 -1.592,-2.308 -4.253,-3.821 -7.261,-3.821 z"
       id="path3" />
    	<path
       fill="#ffcd5a"
       d="m 220.051,300.727 1.315,3.935 c 8.821,-2.944 21.438,-4.633 34.612,-4.633 13.174,0 25.791,1.689 34.612,4.633 l 1.315,-3.935 c -9.228,-3.082 -22.324,-4.849 -35.927,-4.849 -13.603,0.001 -26.699,1.767 -35.927,4.849 z"
       id="path4" />
    	<path
       fill="#ffcd5a"
       d="m 255.978,291.73 c 2.163,0.007 4.068,-1.279 5.359,-3.01 -0.858,-0.53 -2.004,-0.84 -3.302,-1.001 10e-4,-0.047 0.017,-0.09 0.017,-0.138 0,-1.779 -0.84,-3.315 -2.074,-4.149 -1.235,0.834 -2.074,2.37 -2.074,4.149 0,0.047 0.015,0.09 0.017,0.138 -1.297,0.161 -2.443,0.47 -3.302,1.001 1.289,1.731 3.195,3.015 5.359,3.01 z"
       id="path5" />
    	<path
       fill="#ffcd5a"
       d="m 236.935,293.69 c 2.12,-0.426 3.731,-2.067 4.649,-4.021 -0.947,-0.348 -2.132,-0.422 -3.434,-0.32 -0.009,-0.046 -0.002,-0.092 -0.012,-0.139 -0.355,-1.742 -1.485,-3.08 -2.862,-3.65 -1.043,1.065 -1.559,2.738 -1.203,4.48 0.01,0.047 0.033,0.086 0.043,0.132 -1.238,0.417 -2.3,0.949 -3.034,1.641 1.611,1.438 3.734,2.316 5.853,1.877 z"
       id="path6" />
    	<path
       fill="#ffcd5a"
       d="m 276.68,285.559 c -1.377,0.57 -2.507,1.908 -2.862,3.65 -0.01,0.047 -0.003,0.092 -0.012,0.139 -1.302,-0.102 -2.487,-0.028 -3.434,0.32 0.918,1.955 2.529,3.595 4.649,4.021 2.119,0.439 4.242,-0.439 5.854,-1.878 -0.735,-0.691 -1.796,-1.224 -3.034,-1.641 0.011,-0.046 0.034,-0.085 0.043,-0.132 0.355,-1.741 -0.162,-3.414 -1.204,-4.479 z"
       id="path7" />
    	<path
       fill="#ffcd5a"
       d="m 255.424,209.15 -1.398,4.191 -4.417,0.034 c -0.572,0.004 -0.809,0.734 -0.349,1.074 l 3.553,2.624 -1.332,4.212 c -0.172,0.545 0.448,0.996 0.914,0.664 l 3.594,-2.569 3.594,2.569 c 0.466,0.332 1.086,-0.118 0.914,-0.664 l -1.333,-4.212 3.553,-2.624 c 0.46,-0.34 0.223,-1.069 -0.349,-1.074 l -4.417,-0.034 -1.398,-4.191 c -0.181,-0.543 -0.948,-0.543 -1.129,0 z"
       id="path8" />
    	<path
       fill="#ffcd5a"
       d="m 230.138,216.065 -1.398,4.191 -4.417,0.034 c -0.572,0.004 -0.809,0.734 -0.349,1.074 l 3.553,2.624 -1.333,4.212 c -0.172,0.545 0.448,0.996 0.914,0.664 l 3.594,-2.569 3.594,2.569 c 0.466,0.332 1.086,-0.118 0.914,-0.664 l -1.333,-4.212 3.553,-2.624 c 0.46,-0.34 0.223,-1.069 -0.349,-1.074 l -4.417,-0.034 -1.398,-4.191 c -0.18,-0.543 -0.947,-0.543 -1.128,0 z"
       id="path9" />
    	<path
       fill="#ffcd5a"
       d="m 211.553,234.737 -1.398,4.191 -4.417,0.034 c -0.572,0.004 -0.809,0.734 -0.349,1.074 l 3.553,2.624 -1.332,4.212 c -0.172,0.545 0.448,0.996 0.914,0.664 l 3.594,-2.569 3.594,2.569 c 0.466,0.332 1.086,-0.118 0.914,-0.664 l -1.332,-4.212 3.553,-2.624 c 0.46,-0.34 0.223,-1.069 -0.349,-1.074 l -4.417,-0.034 -1.398,-4.191 c -0.182,-0.542 -0.949,-0.542 -1.13,0 z"
       id="path10" />
    	<path
       fill="#ffcd5a"
       d="m 204.724,259.979 -1.398,4.191 -4.417,0.034 c -0.572,0.004 -0.809,0.734 -0.349,1.074 l 3.553,2.624 -1.333,4.212 c -0.172,0.545 0.448,0.996 0.914,0.664 l 3.594,-2.569 3.594,2.569 c 0.466,0.332 1.086,-0.118 0.914,-0.664 l -1.333,-4.212 3.553,-2.624 c 0.46,-0.34 0.223,-1.069 -0.349,-1.074 l -4.417,-0.034 -1.398,-4.191 c -0.18,-0.543 -0.947,-0.543 -1.128,0 z"
       id="path11" />
    	<path
       fill="#ffcd5a"
       d="m 281.862,216.065 1.398,4.191 4.417,0.034 c 0.572,0.004 0.809,0.734 0.349,1.074 l -3.553,2.624 1.333,4.212 c 0.172,0.545 -0.448,0.996 -0.914,0.664 l -3.594,-2.569 -3.594,2.569 c -0.466,0.332 -1.086,-0.118 -0.914,-0.664 l 1.333,-4.212 -3.553,-2.624 c -0.46,-0.34 -0.223,-1.069 0.349,-1.074 l 4.417,-0.034 1.398,-4.191 c 0.18,-0.543 0.947,-0.543 1.128,0 z"
       id="path12" />
    	<path
       fill="#ffcd5a"
       d="m 300.447,234.737 1.398,4.191 4.417,0.034 c 0.572,0.004 0.809,0.734 0.349,1.074 l -3.553,2.624 1.333,4.212 c 0.172,0.545 -0.448,0.996 -0.914,0.664 l -3.594,-2.569 -3.594,2.569 c -0.466,0.332 -1.086,-0.118 -0.914,-0.664 l 1.333,-4.212 -3.553,-2.624 c -0.46,-0.34 -0.223,-1.069 0.349,-1.074 l 4.417,-0.034 1.398,-4.191 c 0.18,-0.542 0.947,-0.542 1.128,0 z"
       id="path13" />
    	<path
       fill="#ffcd5a"
       d="m 307.276,259.979 1.398,4.191 4.417,0.034 c 0.572,0.004 0.809,0.734 0.349,1.074 l -3.553,2.624 1.332,4.212 c 0.172,0.545 -0.448,0.996 -0.914,0.664 l -3.594,-2.569 -3.594,2.569 c -0.466,0.332 -1.086,-0.118 -0.914,-0.664 l 1.332,-4.212 -3.553,-2.624 c -0.46,-0.34 -0.223,-1.069 0.349,-1.074 l 4.417,-0.034 1.398,-4.191 c 0.182,-0.543 0.949,-0.543 1.13,0 z"
       id="path14" />
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs22" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="M 476.689,370.758 H 123.586 c -4.875,0 -8.828,-3.953 -8.828,-8.828 v 0 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 353.103 l 8.828,8.828 z"
       id="path2" />
    	<path
       fill="#ffe15a"
       d="M 481.102,344.276 H 123.586 c 0,0 141.241,-158.896 273.655,-194.206 0,0 -44.138,114.758 61.793,185.379 h 22.069 c 2.438,0 4.414,1.976 4.414,4.414 v 0 c -10e-4,2.436 -1.976,4.413 -4.415,4.413 z"
       id="path3" />
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 108.162,293.173 3.425,10.271 10.826,0.084 c 1.401,0.011 1.983,1.8 0.855,2.632 l -8.709,6.431 3.266,10.323 c 0.423,1.336 -1.099,2.442 -2.239,1.626 l -8.808,-6.295 -8.808,6.295 c -1.14,0.815 -2.662,-0.29 -2.239,-1.626 l 3.266,-10.323 -8.709,-6.431 c -1.128,-0.833 -0.546,-2.622 0.855,-2.632 l 10.826,-0.084 3.425,-10.271 c 0.443,-1.33 2.324,-1.33 2.768,0 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 107.9,151.97 2.778,8.332 8.783,0.068 c 1.138,0.009 1.609,1.46 0.694,2.135 l -7.065,5.218 2.649,8.374 c 0.343,1.085 -0.892,1.981 -1.816,1.32 l -7.146,-5.108 -7.146,5.108 c -0.925,0.661 -2.159,-0.236 -1.816,-1.32 l 2.649,-8.374 -7.065,-5.218 c -0.915,-0.675 -0.444,-2.126 0.694,-2.135 l 8.783,-0.068 2.778,-8.332 c 0.361,-1.078 1.887,-1.078 2.246,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 41.359,203.53 2.778,8.332 8.783,0.068 c 1.138,0.009 1.609,1.46 0.694,2.135 l -7.065,5.218 2.649,8.374 c 0.343,1.085 -0.892,1.981 -1.816,1.32 l -7.146,-5.108 -7.146,5.108 c -0.925,0.661 -2.159,-0.236 -1.816,-1.32 l 2.649,-8.374 -7.065,-5.218 c -0.915,-0.675 -0.444,-2.126 0.694,-2.135 l 8.783,-0.068 2.778,-8.332 c 0.361,-1.079 1.887,-1.079 2.246,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 155.489,200.016 2.138,6.412 6.759,0.052 c 0.875,0.007 1.238,1.123 0.534,1.643 l -5.438,4.015 2.039,6.444 c 0.264,0.834 -0.686,1.525 -1.398,1.015 l -5.498,-3.93 -5.498,3.93 c -0.712,0.509 -1.662,-0.181 -1.398,-1.015 l 2.039,-6.444 -5.438,-4.015 c -0.704,-0.52 -0.341,-1.636 0.534,-1.643 l 6.759,-0.052 2.138,-6.412 c 0.277,-0.831 1.451,-0.831 1.728,0 z"
       id="path7" />
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TL = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#ff4b55"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.952 0,8.827 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.827 C 512,3.952 508.047,0 503.172,0 Z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 3.495,333.475 287.363,173.207 c 4.268,-2.41 4.268,-8.556 0,-10.965 L 3.495,1.973 C 1.42,3.588 0,5.995 0,8.827 V 326.62 c 0,2.833 1.421,5.24 3.495,6.855 z"
       id="path2" />
    <path
       fill="#464655"
       d="M 2.741,332.968 195.673,173.797 c 3.817,-3.149 3.817,-8.996 0,-12.146 L 2.741,2.48 C 1.065,4.088 0,6.322 0,8.827 V 326.62 c 0,2.506 1.065,4.741 2.741,6.348 z"
       id="path3" />
    <path
       fill="#f5f5f5"
       d="m 55.132,126.269 0.841,31.772 -29.789,11.081 c -2.857,1.063 -2.717,5.15 0.206,6.015 l 30.477,9.018 1.334,31.755 c 0.128,3.046 4.058,4.175 5.784,1.663 l 17.995,-26.199 30.613,8.544 c 2.935,0.82 5.225,-2.57 3.369,-4.987 l -19.357,-25.21 17.586,-26.474 c 1.686,-2.539 -0.829,-5.763 -3.702,-4.745 L 80.533,149.12 60.789,124.214 c -1.895,-2.389 -5.738,-0.992 -5.657,2.055 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45403" {...props}>
    <defs
       id="defs51" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.877 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <rect
       x="70.620003"
       y="0.0040004272"
       fill="#ff4b55"
       width="88.279999"
       height="335.45001"
       id="rect1" />
    <polygon
       fill="#f5f5f5"
       points="97.103,141.239 79.448,126.526 79.448,111.813 97.103,97.101 132.414,97.101 150.069,111.813 150.069,126.526 132.414,141.239 "
       id="polygon1"
       transform="translate(0,-88.273)" />
    <g
       id="g4"
       transform="translate(0,-88.273)">
    	<polygon
       fill="#73af00"
       points="97.103,264.826 79.448,250.112 79.448,235.4 97.103,220.687 132.414,220.687 150.069,235.4 150.069,250.112 132.414,264.826 "
       id="polygon2" />
    	<polygon
       fill="#73af00"
       points="97.103,203.032 79.448,188.319 79.448,173.607 97.103,158.894 132.414,158.894 150.069,173.607 150.069,188.319 132.414,203.032 "
       id="polygon3" />
    	<polygon
       fill="#73af00"
       points="97.103,326.618 79.448,311.905 79.448,297.194 97.103,282.48 132.414,282.48 150.069,297.194 150.069,311.905 132.414,326.618 "
       id="polygon4" />
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    	<polygon
       fill="#ffb400"
       points="70.621,167.721 70.621,132.411 88.276,150.066 "
       id="polygon5" />
    	<polygon
       fill="#ffb400"
       points="158.896,132.411 158.896,167.721 141.241,150.066 "
       id="polygon6" />
    	<polygon
       fill="#ffb400"
       points="70.621,229.514 70.621,194.204 88.276,211.859 "
       id="polygon7" />
    	<polygon
       fill="#ffb400"
       points="158.896,194.204 158.896,229.514 141.241,211.859 "
       id="polygon8" />
    	<polygon
       fill="#ffb400"
       points="70.621,291.307 70.621,255.997 88.276,273.652 "
       id="polygon9" />
    	<polygon
       fill="#ffb400"
       points="158.896,255.997 158.896,291.307 141.241,273.652 "
       id="polygon10" />
    	<polygon
       fill="#ffb400"
       points="70.621,353.1 70.621,317.79 88.276,335.445 "
       id="polygon11" />
    	<polygon
       fill="#ffb400"
       points="158.896,317.79 158.896,353.1 141.241,335.445 "
       id="polygon12" />
    	<polygon
       fill="#ffb400"
       points="70.621,105.928 70.621,88.273 88.276,88.273 "
       id="polygon13" />
    	<polygon
       fill="#ffb400"
       points="158.896,88.273 158.896,105.928 141.241,88.273 "
       id="polygon14" />
    	<rect
       x="110.34"
       y="158.897"
       fill="#ffb400"
       width="8.8280001"
       height="44.139999"
       id="rect14" />
    </g>
    <rect
       x="97.099998"
       y="88.273994"
       fill="#ff4b55"
       width="35.310001"
       height="8.8280001"
       id="rect15" />
    <g
       id="g18"
       transform="translate(0,-88.273)">
    	<polygon
       fill="#ffb400"
       points="132.414,203.032 141.241,195.675 141.241,166.25 132.414,158.894 "
       id="polygon15" />
    	<polygon
       fill="#ffb400"
       points="97.103,158.895 88.276,166.25 88.276,195.675 97.103,203.032 "
       id="polygon16" />
    	<polygon
       fill="#ffb400"
       points="79.448,111.813 79.448,119.17 114.758,119.17 114.758,97.101 97.104,97.101 "
       id="polygon17" />
    	<polygon
       fill="#ffb400"
       points="150.069,126.526 150.069,119.17 114.758,119.17 114.758,141.239 132.414,141.239 "
       id="polygon18" />
    </g>
    <polygon
       fill="#ff4b55"
       points="114.758,105.928 132.414,119.222 114.758,132.411 97.103,119.222 "
       id="polygon19"
       transform="translate(0,-88.273)" />
    <g
       id="g21"
       transform="translate(0,-88.273)">
    	<polygon
       fill="#73af00"
       points="132.345,119.17 114.758,119.17 114.758,132.411 132.414,119.222 "
       id="polygon20" />
    	<polygon
       fill="#73af00"
       points="97.173,119.17 114.758,119.17 114.758,105.928 "
       id="polygon21" />
    </g>
    <rect
       x="97.099998"
       y="141.244"
       fill="#ff4b55"
       width="35.310001"
       height="26.483"
       id="rect21" />
    <rect
       x="132.41"
       y="150.06401"
       fill="#ffb400"
       width="8.8280001"
       height="8.8280001"
       id="rect22" />
    <rect
       x="110.34"
       y="150.06401"
       fill="#f5f5f5"
       width="8.8280001"
       height="8.8280001"
       id="rect23" />
    <rect
       x="110.34"
       y="203.03401"
       fill="#ff4b55"
       width="8.8280001"
       height="8.8280001"
       id="rect24" />
    <g
       id="g26"
       transform="translate(0,-88.273)">
    	<rect
       x="123.59"
       y="300.138"
       fill="#ffb400"
       width="8.8280001"
       height="8.8280001"
       id="rect25" />
    	<rect
       x="97.099998"
       y="300.138"
       fill="#ffb400"
       width="8.8280001"
       height="8.8280001"
       id="rect26" />
    </g>
    <rect
       x="110.34"
       y="220.68401"
       fill="#ff4b55"
       width="8.8280001"
       height="8.8280001"
       id="rect27" />
    <rect
       x="88.279999"
       y="150.06401"
       fill="#ffb400"
       width="8.8280001"
       height="8.8280001"
       id="rect28" />
    <polygon
       fill="#f5f5f5"
       points="97.103,388.411 79.448,373.698 79.448,358.987 97.103,344.273 132.414,344.273 150.069,358.987 150.069,373.698 132.414,388.411 "
       id="polygon28"
       transform="translate(0,-88.273)" />
    <g
       id="g30"
       transform="translate(0,-88.273)">
    	<polygon
       fill="#ffb400"
       points="79.448,358.986 79.448,366.342 114.758,366.342 114.758,344.273 97.104,344.273 "
       id="polygon29" />
    	<polygon
       fill="#ffb400"
       points="150.069,373.698 150.069,366.342 114.758,366.342 114.758,388.411 132.414,388.411 "
       id="polygon30" />
    </g>
    <polygon
       fill="#ff4b55"
       points="97.103,370.755 97.103,361.928 114.758,353.1 132.414,361.928 132.414,370.755 114.758,379.583 "
       id="polygon31"
       transform="translate(0,-88.273)" />
    <g
       id="g36"
       transform="translate(0,-88.273)">
    	<path
       fill="#f5f5f5"
       d="m 280.01,136.34 c -0.94,-0.462 -1.791,0.761 -1.028,1.48 9.99,9.427 16.303,22.666 16.303,37.433 0,29.007 -23.316,52.279 -51.986,52.279 -5.292,0 -10.389,-0.825 -15.197,-2.328 -0.996,-0.311 -1.641,1.025 -0.783,1.621 8.382,5.827 18.485,9.31 29.514,9.31 29.049,0 52.787,-23.275 52.787,-52.703 -10e-4,-20.682 -12.14,-38.503 -29.61,-47.092 z"
       id="path31" />
    	<path
       fill="#f5f5f5"
       d="m 208.173,170.4 -2.159,6.109 5.08,4.021 c 0.658,0.521 0.275,1.579 -0.564,1.557 l -6.477,-0.167 -2.254,6.074 c -0.292,0.787 -1.417,0.749 -1.655,-0.055 l -1.843,-6.211 -6.474,-0.267 c -0.839,-0.034 -1.15,-1.116 -0.459,-1.591 l 5.338,-3.672 -1.747,-6.24 c -0.226,-0.808 0.706,-1.439 1.372,-0.928 l 5.142,3.942 5.395,-3.59 c 0.696,-0.465 1.584,0.227 1.305,1.018 z"
       id="path32" />
    	<path
       fill="#f5f5f5"
       d="m 234.407,183.65 -2.159,6.109 5.08,4.021 c 0.658,0.521 0.275,1.579 -0.564,1.557 l -6.477,-0.167 -2.254,6.074 c -0.292,0.787 -1.417,0.749 -1.655,-0.055 l -1.843,-6.211 -6.474,-0.267 c -0.839,-0.034 -1.15,-1.116 -0.459,-1.591 l 5.338,-3.672 -1.747,-6.24 c -0.226,-0.808 0.706,-1.439 1.372,-0.928 l 5.142,3.942 5.395,-3.59 c 0.697,-0.464 1.584,0.228 1.305,1.018 z"
       id="path33" />
    	<path
       fill="#f5f5f5"
       d="m 234.142,156.355 -2.159,6.109 5.08,4.021 c 0.658,0.521 0.275,1.579 -0.564,1.557 l -6.477,-0.167 -2.254,6.074 c -0.292,0.787 -1.417,0.749 -1.655,-0.055 l -1.843,-6.211 -6.474,-0.267 c -0.839,-0.034 -1.15,-1.116 -0.459,-1.591 l 5.338,-3.672 -1.747,-6.24 c -0.226,-0.808 0.706,-1.439 1.372,-0.928 l 5.142,3.942 5.395,-3.59 c 0.697,-0.464 1.585,0.228 1.305,1.018 z"
       id="path34" />
    	<path
       fill="#f5f5f5"
       d="m 235.036,130.01 -2.159,6.109 5.08,4.021 c 0.658,0.521 0.275,1.579 -0.564,1.557 l -6.477,-0.167 -2.254,6.074 c -0.292,0.787 -1.417,0.749 -1.655,-0.055 l -1.843,-6.211 -6.474,-0.267 c -0.839,-0.034 -1.15,-1.116 -0.459,-1.591 l 5.338,-3.672 -1.747,-6.24 c -0.226,-0.808 0.706,-1.439 1.372,-0.928 l 5.142,3.942 5.395,-3.59 c 0.696,-0.465 1.584,0.227 1.305,1.018 z"
       id="path35" />
    	<path
       fill="#f5f5f5"
       d="m 260.741,143.26 -2.159,6.109 5.08,4.021 c 0.658,0.521 0.275,1.579 -0.564,1.557 l -6.477,-0.167 -2.254,6.074 c -0.292,0.787 -1.417,0.749 -1.655,-0.055 l -1.843,-6.211 -6.474,-0.267 c -0.839,-0.034 -1.15,-1.116 -0.459,-1.591 l 5.338,-3.672 -1.747,-6.24 c -0.226,-0.808 0.706,-1.439 1.372,-0.928 l 5.142,3.942 5.395,-3.59 c 0.696,-0.465 1.584,0.227 1.305,1.018 z"
       id="path36" />
    </g>
    <g
       id="g37"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g38"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const TN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs19" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 257.002,79.449 c 48.718,0 88.205,39.594 88.205,88.276 0,48.823 -39.487,88.276 -88.205,88.276 -48.823,0 -88.346,-39.453 -88.346,-88.276 -0.001,-48.682 39.523,-88.276 88.346,-88.276"
       id="path2" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="m 273.043,305.467 c -27.327,0 -49.493,-22.165 -49.493,-49.461 0,-27.23 22.166,-49.395 49.493,-49.395 9.295,0 17.981,2.604 25.405,7.102 1.112,0.674 2.282,-0.782 1.355,-1.695 -11.138,-10.974 -26.389,-17.771 -43.235,-17.771 -34.2,0 -61.892,27.692 -61.892,61.761 0,34.135 27.691,61.825 61.892,61.825 16.838,0 32.083,-6.792 43.219,-17.763 0.927,-0.913 -0.243,-2.369 -1.355,-1.696 -7.422,4.494 -16.102,7.093 -25.389,7.093 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 268.52,221.388 13.644,18.526 21.945,-6.912 c 2.841,-0.895 5.186,2.342 3.452,4.762 l -13.402,18.701 13.355,18.735 c 1.729,2.425 -0.625,5.656 -3.464,4.754 l -21.928,-6.968 -13.692,18.49 c -1.772,2.395 -5.572,1.154 -5.591,-1.825 l -0.149,-23.007 -21.816,-7.307 c -2.825,-0.946 -2.819,-4.943 0.008,-5.881 l 21.835,-7.252 0.207,-23.007 c 0.027,-2.978 3.83,-4.208 5.596,-1.809 z"
       id="path4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TO = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="M 194.206,167.724 H 8.828 C 3.953,167.724 0,163.771 0,158.896 V 8.828 C 0,3.953 3.953,0 8.828,0 h 185.379 c 4.875,0 8.828,3.953 8.828,8.828 v 150.069 c -0.001,4.876 -3.954,8.827 -8.829,8.827 z"
       id="path2" />
    <polygon
       fill="#ff4b55"
       points="123.586,105.931 79.448,105.931 79.448,150.069 35.31,150.069 35.31,194.207 79.448,194.207 79.448,238.345 123.586,238.345 123.586,194.207 167.724,194.207 167.724,150.069 123.586,150.069 "
       id="polygon2"
       transform="translate(0,-88.276)" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 253.474,225.753 13.837,18.101 21.606,-7.232 c 1.208,-0.404 2.236,0.962 1.512,2.01 l -12.939,18.753 13.555,18.314 c 0.758,1.024 -0.224,2.423 -1.444,2.059 l -21.834,-6.511 -13.228,18.55 c -0.739,1.037 -2.375,0.536 -2.406,-0.737 l -0.555,-22.777 -21.73,-6.849 c -1.215,-0.383 -1.244,-2.092 -0.042,-2.515 l 21.491,-7.566 -0.202,-22.783 c -0.012,-1.274 1.606,-1.829 2.379,-0.817 z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 176.956,326.662 c -38.995,0 -70.627,-31.633 -70.627,-70.663 0,-38.958 31.633,-70.662 70.627,-70.662 14.508,0 27.887,4.462 39.037,12.014 1.707,1.156 3.656,-1.087 2.227,-2.573 -16.664,-17.325 -40.248,-27.894 -66.398,-27.001 -44.926,1.533 -82.118,37.553 -84.989,82.413 -3.287,51.383 37.399,94.086 88.055,94.086 24.953,0 47.379,-10.432 63.393,-27.112 1.415,-1.473 -0.538,-3.683 -2.229,-2.537 -11.162,7.569 -24.563,12.035 -39.096,12.035 z"
       id="path3" />
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g3"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 8.828,88.277 c -2.387,0 -4.535,0.967 -6.124,2.506 l 359.228,332.942 h 26.483 L 26.483,88.277 Z"
       id="path2" />
    	<path
       fill="#f5f5f5"
       d="m 150.069,88.277 h -26.483 l 361.931,335.448 h 17.655 c 2.387,0 4.535,-0.967 6.124,-2.506 z"
       id="path3" />
    </g>
    <polygon
       fill="#464655"
       points="485.517,423.725 123.586,88.277 26.483,88.277 388.414,423.725 "
       id="polygon3"
       transform="translate(0,-88.276)" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TV = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs31" />
    <path
       fill="#3cc8ff"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 247.172,167.724 H 8.828 C 3.953,167.724 0,163.771 0,158.896 V 8.828 C 0,3.953 3.953,0 8.828,0 H 247.172 C 252.047,0 256,3.953 256,8.828 v 150.069 c -0.001,4.876 -3.952,8.827 -8.828,8.827 z"
       id="path2" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path3" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon3" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path6" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path7" />
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 284.332,362.783 4.297,12.884 13.581,0.105 c 1.758,0.013 2.487,2.258 1.073,3.302 l -10.925,8.067 4.097,12.949 c 0.531,1.676 -1.378,3.063 -2.809,2.04 l -11.049,-7.897 -11.049,7.897 c -1.43,1.023 -3.339,-0.364 -2.809,-2.04 l 4.097,-12.949 -10.925,-8.067 c -1.415,-1.045 -0.685,-3.288 1.073,-3.302 l 13.581,-0.105 4.297,-12.884 c 0.553,-1.668 2.913,-1.668 3.47,0 z"
       id="path8" />
    	<path
       fill="#ffe15a"
       d="m 409.33,265.572 4.297,12.884 13.581,0.105 c 1.758,0.013 2.487,2.258 1.073,3.302 l -10.925,8.067 4.097,12.949 c 0.531,1.676 -1.378,3.063 -2.809,2.04 l -11.049,-7.897 -11.049,7.897 c -1.43,1.023 -3.339,-0.364 -2.809,-2.04 l 4.097,-12.949 -10.925,-8.067 c -1.415,-1.045 -0.685,-3.288 1.073,-3.302 l 13.581,-0.105 4.297,-12.884 c 0.555,-1.668 2.914,-1.668 3.47,0 z"
       id="path9" />
    	<path
       fill="#ffe15a"
       d="m 468.27,229.447 4.297,12.884 13.581,0.105 c 1.758,0.013 2.487,2.258 1.073,3.302 l -10.925,8.067 4.097,12.949 c 0.531,1.676 -1.378,3.063 -2.809,2.04 l -11.049,-7.897 -11.049,7.897 c -1.43,1.023 -3.339,-0.364 -2.809,-2.04 l 4.097,-12.949 -10.925,-8.067 c -1.415,-1.045 -0.685,-3.288 1.073,-3.302 l 13.581,-0.105 4.297,-12.884 c 0.554,-1.669 2.914,-1.669 3.47,0 z"
       id="path10" />
    	<path
       fill="#ffe15a"
       d="m 454.209,105.498 4.297,12.884 13.581,0.105 c 1.758,0.013 2.487,2.258 1.073,3.302 l -10.925,8.067 4.097,12.949 c 0.531,1.676 -1.378,3.063 -2.809,2.04 l -11.049,-7.897 -11.049,7.897 c -1.43,1.023 -3.339,-0.364 -2.809,-2.04 l 4.097,-12.949 -10.925,-8.067 c -1.415,-1.045 -0.685,-3.288 1.073,-3.302 l 13.581,-0.105 4.297,-12.884 c 0.554,-1.668 2.913,-1.668 3.47,0 z"
       id="path11" />
    	<path
       fill="#ffe15a"
       d="m 336.584,394.979 -4.297,-12.884 -13.581,-0.105 c -1.758,-0.013 -2.487,-2.258 -1.073,-3.302 l 10.925,-8.067 -4.097,-12.949 c -0.531,-1.676 1.378,-3.063 2.809,-2.04 l 11.049,7.897 11.049,-7.897 c 1.43,-1.023 3.339,0.364 2.809,2.04 l -4.097,12.949 10.925,8.067 c 1.415,1.045 0.685,3.288 -1.073,3.302 l -13.581,0.105 -4.297,12.884 c -0.555,1.668 -2.914,1.668 -3.47,0 z"
       id="path12" />
    	<path
       fill="#ffe15a"
       d="m 377.205,358.523 -4.297,-12.884 -13.581,-0.105 c -1.758,-0.013 -2.487,-2.258 -1.073,-3.302 l 10.925,-8.067 -4.097,-12.949 c -0.531,-1.676 1.378,-3.063 2.809,-2.04 l 11.049,7.897 11.049,-7.897 c 1.43,-1.023 3.339,0.364 2.809,2.04 l -4.097,12.949 10.925,8.067 c 1.415,1.045 0.685,3.288 -1.073,3.302 l -13.581,0.105 -4.297,12.884 c -0.554,1.669 -2.914,1.669 -3.47,0 z"
       id="path13" />
    	<path
       fill="#ffe15a"
       d="m 413.76,199.525 -4.297,-12.884 -13.581,-0.105 c -1.758,-0.013 -2.487,-2.258 -1.073,-3.302 l 10.925,-8.067 -4.097,-12.949 c -0.531,-1.676 1.378,-3.063 2.809,-2.04 l 11.049,7.897 11.049,-7.897 c 1.43,-1.023 3.339,0.364 2.809,2.04 l -4.097,12.949 10.925,8.067 c 1.415,1.045 0.685,3.288 -1.073,3.302 l -13.581,0.105 -4.297,12.884 c -0.553,1.667 -2.913,1.667 -3.47,0 z"
       id="path14" />
    	<path
       fill="#ffe15a"
       d="m 371.577,213.065 -4.297,-12.884 -13.581,-0.105 c -1.758,-0.013 -2.487,-2.258 -1.073,-3.302 l 10.925,-8.067 -4.097,-12.949 c -0.531,-1.676 1.378,-3.063 2.809,-2.04 l 11.049,7.897 11.049,-7.897 c 1.43,-1.023 3.339,0.364 2.809,2.04 l -4.097,12.949 10.925,8.067 c 1.415,1.045 0.685,3.288 -1.073,3.302 l -13.581,0.105 -4.297,12.884 c -0.555,1.668 -2.914,1.668 -3.47,0 z"
       id="path15" />
    	<path
       fill="#ffe15a"
       d="m 344.569,318.249 -4.297,-12.884 -13.581,-0.105 c -1.758,-0.013 -2.487,-2.258 -1.073,-3.302 l 10.925,-8.067 -4.097,-12.949 c -0.531,-1.676 1.378,-3.063 2.809,-2.04 l 11.049,7.897 11.049,-7.897 c 1.43,-1.023 3.339,0.364 2.809,2.04 l -4.097,12.949 10.925,8.067 c 1.415,1.045 0.685,3.288 -1.073,3.302 l -13.581,0.105 -4.297,12.884 c -0.554,1.668 -2.913,1.668 -3.47,0 z"
       id="path16" />
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs21" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="m 8.828,0.001 h 238.345 c 4.875,0 8.828,3.953 8.828,8.828 v 150.069 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,167.725 0,163.772 0,158.897 V 8.828 C 0,3.953 3.953,0.001 8.828,0.001 Z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 96.403,172.139 c 0,-8.722 3.534,-16.618 9.248,-22.335 l -26.474,-7.573 c -1.537,-0.439 -2.638,1.469 -1.49,2.58 l 19.811,19.155 -26.734,6.684 c -1.55,0.387 -1.55,2.591 0,2.979 l 26.734,6.684 -19.811,19.155 c -1.149,1.111 -0.047,3.019 1.49,2.58 l 26.474,-7.573 c -5.714,-5.718 -9.248,-13.614 -9.248,-22.336 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 105.665,149.79 c 5.717,-5.714 13.613,-9.248 22.335,-9.248 8.722,0 16.618,3.534 22.335,9.248 l 7.573,-26.474 c 0.439,-1.537 -1.469,-2.638 -2.58,-1.49 l -19.155,19.81 -6.684,-26.734 c -0.387,-1.55 -2.591,-1.55 -2.979,0 l -6.684,26.734 -19.155,-19.81 c -1.111,-1.149 -3.019,-0.047 -2.58,1.49 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 150.335,194.488 c -5.717,5.714 -13.613,9.248 -22.335,9.248 -8.722,0 -16.618,-3.534 -22.335,-9.248 l -7.573,26.474 c -0.439,1.537 1.469,2.638 2.58,1.49 l 19.155,-19.81 6.684,26.734 c 0.387,1.55 2.591,1.55 2.979,0 l 6.684,-26.734 19.155,19.81 c 1.111,1.149 3.019,0.047 2.58,-1.49 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 185.236,170.649 -26.734,-6.684 19.81,-19.155 c 1.149,-1.111 0.047,-3.019 -1.49,-2.58 l -26.474,7.573 c 5.714,5.717 9.248,13.613 9.248,22.335 0,8.722 -3.534,16.618 -9.248,22.335 l 26.474,7.573 c 1.537,0.439 2.638,-1.469 1.49,-2.58 l -19.81,-19.155 26.734,-6.684 c 1.551,-0.386 1.551,-2.589 0,-2.978 z"
       id="path6" />
    	<circle
       fill="#f5f5f5"
       cx="128"
       cy="172.14101"
       r="25.16"
       id="circle6" />
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const TZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45001" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#73af00"
       d="M 0,256.001 V 8.828 C 0,3.953 3.953,0 8.828,0 h 379.586 z"
       id="path1" />
    <path
       fill="#4173cd"
       d="m 512,79.449 v 247.172 c 0,4.875 -3.953,8.828 -8.828,8.828 H 123.586 Z"
       id="path2" />
    <path
       fill="#ffe15a"
       d="M 512,84.427 V 8.828 C 512,3.953 508.047,0 503.172,0 H 383.139 L 0,251.023 v 75.598 c 0,4.875 3.953,8.828 8.828,8.828 h 120.033 z"
       id="path3" />
    <path
       fill="#464655"
       d="M 512,52.772 V 8.828 C 512,3.953 508.047,0 503.172,0 H 431.454 L 0,282.678 v 43.944 c 0,4.875 3.953,8.828 8.828,8.828 h 71.718 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const UA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45003" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ffe15a"
       d="m 0,167.725 h 512 v 158.897 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.45 0,331.497 0,326.622 Z"
       id="path1" />
    <path
       fill="#4173cd"
       d="M 512,167.725 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const UG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs25" />
    <path
       fill="#464655"
       d="M 512,55.909 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <rect
       y="55.914993"
       fill="#ffe15a"
       width="512"
       height="55.908001"
       id="rect1"
       x="0" />
    <rect
       y="111.815"
       fill="#ff4b55"
       width="512"
       height="55.908001"
       id="rect2"
       x="0" />
    <rect
       y="167.72501"
       fill="#464655"
       width="512"
       height="55.908001"
       id="rect3"
       x="0" />
    <rect
       y="223.63501"
       fill="#ffe15a"
       width="512"
       height="55.908001"
       id="rect4"
       x="0" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 279.54 h 512 v 47.081 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path4" />
    <circle
       fill="#f5f5f5"
       cx="256"
       cy="167.72501"
       r="52.966"
       id="circle4" />
    <path
       fill="#ff4b55"
       d="m 259.194,135.478 5.217,-2.087 c 0.756,-0.302 1.122,-1.17 0.787,-1.911 -1.17,-2.594 -4.305,-7.962 -10.263,-8.124 -3.773,-0.102 -6.594,0.748 -8.186,1.405 -0.813,0.335 -1.14,1.303 -0.696,2.062 l 3.148,5.378 z"
       id="path5" />
    <path
       fill="#ffe15a"
       d="m 254.935,123.355 c -0.434,-0.012 -0.825,0.013 -1.234,0.025 l -0.568,8.329 3.03,1.678 6.554,-5.93 c -1.725,-2.087 -4.255,-4.007 -7.782,-4.102 z"
       id="path6" />
    <path
       fill="#464655"
       d="m 277.377,184.457 -23.588,-27.52 c 0,-5.696 2.058,-10.347 3.196,-12.486 3.247,-1.45 5.341,-5.021 4.469,-8.962 -0.633,-2.867 -2.947,-5.206 -5.809,-5.86 -5.15,-1.177 -9.719,2.702 -9.719,7.65 0,0.186 0.042,0.361 0.055,0.544 -5.088,1.342 -6.034,2.978 -6.034,2.978 0,0 3.335,-0.887 6.229,-1.645 0.058,0.236 0.136,0.463 0.214,0.691 l -5.707,1.938 6.232,-0.758 c 0.692,1.266 1.718,2.318 2.957,3.046 -4.658,3.752 -11.81,10.803 -11.81,18.763 0,7.278 5.391,12.128 12.181,15.352 2.374,1.128 4.555,2.615 6.349,4.535 l 0.067,0.072 0.59,9.035 c -4.87,0 -10.675,0 -13.29,0 -4.915,0 -6.265,3.194 -6.265,8.477 l 2.334,-3.317 1.965,3.686 0.246,-4.178 2.089,2.702 c 0,0 -0.021,-3.53 2.642,-3.993 1.412,-0.246 6.307,-0.553 10.465,-0.553 l 0.881,13.464 c -5.639,-0.026 -12.021,2.63 -12.021,2.63 1.965,-0.369 6.758,0.369 6.758,0.369 l -0.799,2.334 c 5.528,-3.01 15.665,-3.072 15.665,-3.072 0,0 -2.211,-1.508 -7.371,-2.098 l 0.119,-13.628 h 8.111 l 1.228,-3.194 c 0,0 -4.185,-5.553 -4.185,-8.493 6.489,1.232 11.556,1.491 11.556,1.491 z m -16.686,7.372 0.041,-4.674 c 2.435,2.61 4.361,4.674 4.361,4.674 0,0 -1.819,0 -4.402,0 z"
       id="path7" />
    <path
       fill="#696e7d"
       d="m 277.377,188.388 c -1.965,-7.863 -10.58,-10.28 -19.657,-15.726 -9.828,-5.897 -3.932,-15.726 -3.932,-15.726 0,0 32.926,9.665 35.383,23.588 1.913,10.844 -5.897,17.692 -9.828,19.657 l 1.412,-3.932 h -7.31 c 0,0 7.74,-6.02 7.863,-11.795 z"
       id="path8" />
    <path
       fill="#fffcff"
       d="m 289.172,180.525 c -1.643,-9.309 -16.893,-16.707 -26.829,-20.594 v 0 c -3.18,-0.354 -5.974,4.991 2.749,10.765 11.735,7.768 12.286,17.692 12.286,17.692 l 3.932,-3.932 c -0.122,5.774 -7.863,11.795 -7.863,11.795 h 7.31 l -1.412,3.932 c 3.93,-1.966 11.74,-8.813 9.827,-19.658 z"
       id="path9" />
    <path
       fill="#ff4b55"
       d="m 289.172,180.525 c -1.089,-6.169 -8.158,-11.492 -15.693,-15.517 -3.629,-1.085 -6.79,-0.946 -6.79,-0.946 2.211,1.352 3.194,4.791 3.194,4.791 -1.597,-0.983 -5.16,-0.491 -5.16,-0.491 0.991,0.85 1.93,2.582 2.558,3.911 9.609,7.469 10.097,16.116 10.097,16.116 l 3.932,-3.932 c -0.122,5.774 -7.863,11.795 -7.863,11.795 h 7.31 l -1.412,3.932 c 3.93,-1.967 11.74,-8.814 9.827,-19.659 z"
       id="path10" />
    <circle
       fill="#f5f5f5"
       cx="250.59"
       cy="136.545"
       r="1.311"
       id="circle10" />
    <path
       fill="#ff4b55"
       d="m 247.155,141.538 c 0,0 -2.867,3.358 -0.983,4.341 1.884,0.983 3.701,-1.809 3.701,-1.809 z"
       id="path11" />
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const US = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs61" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="M 512,114.081 H 0 V 97.104 c 0,-4.875 3.953,-8.828 8.828,-8.828 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path2" />
    	<rect
       y="191.491"
       fill="#ff4b55"
       width="512"
       height="25.804001"
       id="rect2"
       x="0" />
    	<rect
       y="139.881"
       fill="#ff4b55"
       width="512"
       height="25.804001"
       id="rect3"
       x="0" />
    	<path
       fill="#ff4b55"
       d="M 512,268.903 H 8.828 C 3.953,268.903 0,264.95 0,260.075 v -16.977 h 512 z"
       id="path3" />
    	<rect
       y="346.32101"
       fill="#ff4b55"
       width="512"
       height="25.804001"
       id="rect4"
       x="0" />
    	<path
       fill="#ff4b55"
       d="M 503.172,423.725 H 8.828 C 3.953,423.725 0,419.772 0,414.897 v -16.976 h 512 v 16.977 c 0,4.875 -3.953,8.827 -8.828,8.827 z"
       id="path4" />
    	<rect
       y="294.711"
       fill="#ff4b55"
       width="512"
       height="25.804001"
       id="rect5"
       x="0" />
    </g>
    <path
       fill="#41479b"
       d="M 229.517,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 v 162.97 c 0,4.875 3.953,8.828 8.828,8.828 h 220.69 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.828 c -0.001,-4.875 -3.954,-8.827 -8.829,-8.827 z"
       id="path5" />
    <g
       id="g46"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 24.789,108.538 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 L 24,122.843 l -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.76 1.324,-0.76 1.578,-0.001 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 24.789,139.192 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 L 24,153.497 l -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.759 1.324,-0.759 1.578,-0.001 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 24.789,169.846 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 L 24,184.151 l -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.759 1.324,-0.759 1.578,-0.001 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 24.789,200.501 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 L 24,214.806 l -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.76 1.324,-0.76 1.578,-0.001 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 24.789,231.155 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 L 24,245.46 l -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.761 1.324,-0.761 1.578,-0.001 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 48.582,123.567 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.758 1.325,-0.758 1.578,0 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 48.582,154.222 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.165 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.759 1.325,-0.759 1.578,0 z"
       id="path12" />
    	<path
       fill="#f5f5f5"
       d="m 48.582,184.876 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.759 1.325,-0.759 1.578,0 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 48.582,215.53 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.758 1.325,-0.758 1.578,0 z"
       id="path14" />
    	<path
       fill="#f5f5f5"
       d="m 72.375,108.538 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.759 1.325,-0.759 1.578,0 z"
       id="path15" />
    	<path
       fill="#f5f5f5"
       d="m 72.375,139.192 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.758 1.325,-0.758 1.578,0 z"
       id="path16" />
    	<path
       fill="#f5f5f5"
       d="m 72.375,169.846 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.758 1.325,-0.758 1.578,0 z"
       id="path17" />
    	<path
       fill="#f5f5f5"
       d="m 72.375,200.501 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.759 1.325,-0.759 1.578,0 z"
       id="path18" />
    	<path
       fill="#f5f5f5"
       d="m 72.375,231.155 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.76 1.325,-0.76 1.578,0 z"
       id="path19" />
    	<path
       fill="#f5f5f5"
       d="m 96.169,123.567 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.758 1.325,-0.758 1.578,0 z"
       id="path20" />
    	<path
       fill="#f5f5f5"
       d="m 96.169,154.222 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.165 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.759 1.325,-0.759 1.578,0 z"
       id="path21" />
    	<path
       fill="#f5f5f5"
       d="m 96.169,184.876 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.759 1.325,-0.759 1.578,0 z"
       id="path22" />
    	<path
       fill="#f5f5f5"
       d="m 96.169,215.53 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.758 1.325,-0.758 1.578,0 z"
       id="path23" />
    	<path
       fill="#f5f5f5"
       d="m 119.962,108.538 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.026,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.253,-0.759 1.326,-0.759 1.579,0 z"
       id="path24" />
    	<path
       fill="#f5f5f5"
       d="m 119.962,139.192 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.026,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.253,-0.758 1.326,-0.758 1.579,0 z"
       id="path25" />
    	<path
       fill="#f5f5f5"
       d="m 119.962,169.846 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.026,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.253,-0.758 1.326,-0.758 1.579,0 z"
       id="path26" />
    	<path
       fill="#f5f5f5"
       d="m 119.962,200.501 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.026,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.253,-0.759 1.326,-0.759 1.579,0 z"
       id="path27" />
    	<path
       fill="#f5f5f5"
       d="m 119.962,231.155 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.026,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.253,-0.76 1.326,-0.76 1.579,0 z"
       id="path28" />
    	<path
       fill="#f5f5f5"
       d="m 143.755,123.567 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.253,-0.758 1.325,-0.758 1.578,0 z"
       id="path29" />
    	<path
       fill="#f5f5f5"
       d="m 143.755,154.222 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.165 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.253,-0.759 1.325,-0.759 1.578,0 z"
       id="path30" />
    	<path
       fill="#f5f5f5"
       d="m 143.755,184.876 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.253,-0.759 1.325,-0.759 1.578,0 z"
       id="path31" />
    	<path
       fill="#f5f5f5"
       d="m 143.755,215.53 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.253,-0.758 1.325,-0.758 1.578,0 z"
       id="path32" />
    	<path
       fill="#f5f5f5"
       d="m 167.549,108.538 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.759 1.325,-0.759 1.578,0 z"
       id="path33" />
    	<path
       fill="#f5f5f5"
       d="m 167.549,139.192 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.758 1.325,-0.758 1.578,0 z"
       id="path34" />
    	<path
       fill="#f5f5f5"
       d="m 167.549,169.846 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.758 1.325,-0.758 1.578,0 z"
       id="path35" />
    	<path
       fill="#f5f5f5"
       d="m 167.549,200.501 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.759 1.325,-0.759 1.578,0 z"
       id="path36" />
    	<path
       fill="#f5f5f5"
       d="m 167.549,231.155 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.251,-0.76 1.325,-0.76 1.578,0 z"
       id="path37" />
    	<path
       fill="#f5f5f5"
       d="m 191.342,123.567 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.758 1.326,-0.758 1.578,0 z"
       id="path38" />
    	<path
       fill="#f5f5f5"
       d="m 191.342,154.222 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.165 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.759 1.326,-0.759 1.578,0 z"
       id="path39" />
    	<path
       fill="#f5f5f5"
       d="m 191.342,184.876 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.759 1.326,-0.759 1.578,0 z"
       id="path40" />
    	<path
       fill="#f5f5f5"
       d="m 191.342,215.53 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.758 1.326,-0.758 1.578,0 z"
       id="path41" />
    	<path
       fill="#f5f5f5"
       d="m 215.136,108.538 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.759 1.324,-0.759 1.578,0 z"
       id="path42" />
    	<path
       fill="#f5f5f5"
       d="m 215.136,139.192 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.758 1.324,-0.758 1.578,0 z"
       id="path43" />
    	<path
       fill="#f5f5f5"
       d="m 215.136,169.846 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.758 1.324,-0.758 1.578,0 z"
       id="path44" />
    	<path
       fill="#f5f5f5"
       d="m 215.136,200.501 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.759 1.324,-0.759 1.578,0 z"
       id="path45" />
    	<path
       fill="#f5f5f5"
       d="m 215.136,231.155 1.954,5.86 6.177,0.047 c 0.8,0.007 1.131,1.027 0.488,1.502 l -4.969,3.67 1.864,5.889 c 0.242,0.762 -0.627,1.394 -1.278,0.928 l -5.025,-3.592 -5.025,3.592 c -0.651,0.465 -1.518,-0.166 -1.278,-0.928 l 1.864,-5.889 -4.969,-3.67 c -0.643,-0.476 -0.312,-1.495 0.488,-1.502 l 6.177,-0.047 1.954,-5.86 c 0.252,-0.76 1.324,-0.76 1.578,0 z"
       id="path46" />
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g57"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g58"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g59"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g60"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g61"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const UY = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs52" />
    <path
       fill="#f5f5f5"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.952 0,8.827 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.827 C 512,3.952 508.047,0 503.172,0 Z"
       id="path1" />
    <rect
       x="185.38"
       y="37.274002"
       fill="#4173cd"
       width="326.62"
       height="37.27"
       id="rect1" />
    <rect
       y="74.544006"
       fill="#f5f5f5"
       width="512"
       height="37.27"
       id="rect2"
       x="0" />
    <rect
       x="185.38"
       y="111.814"
       fill="#4173cd"
       width="326.62"
       height="37.27"
       id="rect3" />
    <rect
       y="149.084"
       fill="#f5f5f5"
       width="512"
       height="37.27"
       id="rect4"
       x="0" />
    <rect
       y="186.36499"
       fill="#4173cd"
       width="512"
       height="37.27"
       id="rect5"
       x="0" />
    <rect
       y="223.634"
       fill="#f5f5f5"
       width="512"
       height="37.27"
       id="rect6"
       x="0" />
    <rect
       y="260.90399"
       fill="#4173cd"
       width="512"
       height="37.27"
       id="rect7"
       x="0" />
    <polygon
       fill="#ffe15a"
       points="101.85,170.403 63.976,111.642 78.743,179.975 "
       id="polygon7"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="78.743,179.975 63.976,111.642 90.296,175.189 "
       id="polygon8"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="83.529,191.528 121.404,250.289 106.636,181.956 "
       id="polygon9"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="106.636,181.956 121.404,250.289 95.083,186.742 "
       id="polygon10"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="103.252,190.126 162.013,152.252 93.681,167.019 "
       id="polygon11"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="93.681,167.019 162.013,152.252 98.466,178.572 "
       id="polygon12"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="82.127,171.805 23.367,209.679 91.699,194.912 "
       id="polygon13"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="91.699,194.912 23.367,209.679 86.913,183.359 "
       id="polygon14"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="106.636,179.975 121.404,111.642 83.529,170.403 "
       id="polygon15"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="83.529,170.403 121.404,111.642 95.083,175.189 "
       id="polygon16"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="78.743,181.956 63.976,250.289 101.85,191.528 "
       id="polygon17"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="101.85,191.528 63.976,250.289 90.296,186.742 "
       id="polygon18"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="93.681,194.912 162.013,209.679 103.252,171.805 "
       id="polygon19"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="103.252,171.805 162.013,209.679 98.466,183.359 "
       id="polygon20"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="91.699,167.019 23.367,152.252 82.127,190.126 "
       id="polygon21"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="82.127,190.126 23.367,152.252 86.913,178.572 "
       id="polygon22"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="105.195,174.712 92.69,105.931 80.184,174.712 "
       id="polygon23"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="80.184,174.712 92.69,105.931 92.69,174.712 "
       id="polygon24"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="80.184,187.219 92.69,256 105.195,187.219 "
       id="polygon25"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="105.195,187.219 92.69,256 92.69,187.219 "
       id="polygon26"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="98.943,193.471 167.724,180.966 98.943,168.46 "
       id="polygon27"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="98.943,168.46 167.724,180.966 98.943,180.966 "
       id="polygon28"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="86.436,168.46 17.655,180.966 86.436,193.471 "
       id="polygon29"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="86.436,193.471 17.655,180.966 86.436,180.966 "
       id="polygon30"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="105.954,185.387 145.747,127.908 88.268,167.701 "
       id="polygon31"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="88.268,167.701 145.747,127.908 97.111,176.544 "
       id="polygon32"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="79.425,176.544 39.633,234.023 97.111,194.23 "
       id="polygon33"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="97.111,194.23 39.633,234.023 88.268,185.387 "
       id="polygon34"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="88.268,194.23 145.747,234.023 105.954,176.544 "
       id="polygon35"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="105.954,176.544 145.747,234.023 97.111,185.387 "
       id="polygon36"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffe15a"
       points="97.111,167.701 39.633,127.908 79.425,185.387 "
       id="polygon37"
       transform="translate(0,-88.276)" />
    <polygon
       fill="#ffcd5a"
       points="79.425,185.387 39.633,127.908 88.268,176.544 "
       id="polygon38"
       transform="translate(0,-88.276)" />
    <circle
       fill="#ffe15a"
       cx="92.690002"
       cy="92.694"
       r="25.01"
       id="circle38" />
    <g
       id="g38"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g39"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const UZ = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs34" />
    <path
       fill="#82afff"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#73af00"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g4"
       transform="translate(0,-88.276)">
    	<rect
       y="190.161"
       fill="#ff4b55"
       width="512"
       height="13.942"
       id="rect3"
       x="0" />
    	<rect
       y="307.89099"
       fill="#ff4b55"
       width="512"
       height="13.942"
       id="rect4"
       x="0" />
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 113.491,172.072 c -18.072,0 -32.721,-14.614 -32.721,-32.621 0,-18.073 14.648,-32.753 32.721,-32.753 0.07,0 0.138,0 0.206,0.001 1.064,0.014 1.437,-1.399 0.499,-1.902 -5.565,-2.983 -11.916,-4.671 -18.668,-4.622 -21.624,0.154 -39.189,18.073 -38.959,39.697 0.226,21.401 17.722,38.724 39.242,38.724 6.659,0 12.921,-1.685 18.417,-4.627 0.935,-0.501 0.557,-1.914 -0.503,-1.899 -0.08,0.002 -0.157,0.002 -0.234,0.002 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 139.113,163.051 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.716,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.189,-0.567 -0.991,-0.567 -1.181,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 171.656,163.051 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.715,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.189,-0.567 -0.992,-0.567 -1.18,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 204.198,163.051 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.716,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.189,-0.567 -0.992,-0.567 -1.181,0 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 236.74,163.051 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.715,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.188,-0.567 -0.991,-0.567 -1.18,0 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 269.283,163.051 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.716,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.716,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.191,-0.567 -0.993,-0.567 -1.182,0 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 171.656,132.679 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.715,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.189,-0.569 -0.992,-0.569 -1.18,0 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 204.198,132.679 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.716,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.189,-0.569 -0.992,-0.569 -1.181,0 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 236.74,132.679 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.715,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.188,-0.569 -0.991,-0.569 -1.18,0 z"
       id="path12" />
    	<path
       fill="#f5f5f5"
       d="m 269.283,132.679 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.716,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.716,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.191,-0.569 -0.993,-0.569 -1.182,0 z"
       id="path13" />
    	<path
       fill="#f5f5f5"
       d="m 204.198,163.051 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.716,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.189,-0.567 -0.992,-0.567 -1.181,0 z"
       id="path14" />
    	<path
       fill="#f5f5f5"
       d="m 204.198,102.305 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.716,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.189,-0.567 -0.992,-0.567 -1.181,0 z"
       id="path15" />
    	<path
       fill="#f5f5f5"
       d="m 236.74,163.051 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.715,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.188,-0.567 -0.991,-0.567 -1.18,0 z"
       id="path16" />
    	<path
       fill="#f5f5f5"
       d="m 269.283,163.051 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.716,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.716,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.191,-0.567 -0.993,-0.567 -1.182,0 z"
       id="path17" />
    	<path
       fill="#f5f5f5"
       d="m 236.74,102.305 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.715,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.715,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.188,-0.567 -0.991,-0.567 -1.18,0 z"
       id="path18" />
    	<path
       fill="#f5f5f5"
       d="m 269.283,102.305 -1.461,4.382 -4.619,0.035 c -0.598,0.004 -0.846,0.768 -0.365,1.123 l 3.716,2.744 -1.394,4.404 c -0.18,0.57 0.469,1.042 0.956,0.694 l 3.758,-2.686 3.758,2.686 c 0.487,0.348 1.135,-0.124 0.956,-0.694 l -1.394,-4.404 3.716,-2.744 c 0.481,-0.355 0.233,-1.119 -0.365,-1.123 l -4.619,-0.035 -1.461,-4.382 c -0.191,-0.567 -0.993,-0.567 -1.182,0 z"
       id="path19" />
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const VA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.448" {...props}>
    <defs
       id="defs56" />
    <path
       fill="#f5f5f5"
       d="M 503.172,0 H 256 v 335.448 h 247.172 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.827 C 512,3.952 508.047,0 503.172,0 Z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="M 8.828,335.448 H 256 V 0 H 8.828 C 3.953,0 0,3.952 0,8.827 V 326.62 c 0,4.876 3.953,8.828 8.828,8.828 z"
       id="path2" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#ebebeb"
       d="m 408.267,174.752 -0.587,1.173 c 1.895,0.97 2.978,2.074 2.978,3.25 l -0.295,-5.831 c -0.394,0.783 -1.167,1.345 -2.096,1.408 z"
       id="path3" />
    	<path
       fill="#ebebeb"
       d="m 362.438,175.925 -0.587,-1.173 c -0.928,-0.064 -1.7,-0.625 -2.098,-1.408 l -0.294,5.831 c 0,-1.174 1.084,-2.28 2.979,-3.25 z"
       id="path4" />
    	<path
       fill="#ebebeb"
       d="m 362.019,169.666 c 1.414,0 2.56,1.146 2.56,2.56 0,0.512 -0.189,0.962 -0.448,1.362 l 0.674,1.347 c 1.932,-0.679 4.312,-1.256 7.027,-1.703 l -0.288,-1.152 c -1.058,-0.314 -1.845,-1.256 -1.845,-2.415 0,-1.414 1.146,-2.56 2.56,-2.56 1.414,0 2.56,1.146 2.56,2.56 0,0.722 -0.303,1.367 -0.783,1.833 l 0.342,1.367 c 1.427,-0.179 2.922,-0.32 4.474,-0.426 -0.116,-0.481 -0.193,-0.978 -0.193,-1.494 0,-3.534 2.866,-6.4 6.4,-6.4 3.534,0 6.4,2.866 6.4,6.4 0,0.518 -0.077,1.013 -0.193,1.494 1.554,0.105 3.049,0.247 4.474,0.426 l 0.342,-1.367 c -0.48,-0.466 -0.783,-1.111 -0.783,-1.833 0,-1.414 1.146,-2.56 2.56,-2.56 1.414,0 2.56,1.146 2.56,2.56 0,1.16 -0.787,2.101 -1.845,2.415 l -0.288,1.152 c 2.714,0.446 5.095,1.023 7.027,1.703 l 0.674,-1.347 c -0.259,-0.401 -0.448,-0.85 -0.448,-1.362 0,-1.414 1.146,-2.56 2.56,-2.56 0.921,0 1.693,0.513 2.143,1.244 l -0.196,-3.904 c -2.528,-2.87 -12.746,-5.02 -24.987,-5.02 -12.241,0 -22.458,2.148 -24.986,5.02 l -0.196,3.904 c 0.45,-0.731 1.221,-1.244 2.142,-1.244 z"
       id="path5" />
    </g>
    <path
       fill="#e6b432"
       d="m 389.056,51.275 c 0.693,-0.874 1.123,-1.964 1.123,-3.165 0,-2.383 -1.635,-4.367 -3.84,-4.939 v -3.134 c 0.751,-0.446 1.28,-1.23 1.28,-2.167 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,0.937 0.529,1.721 1.28,2.167 v 3.134 c -2.205,0.57 -3.84,2.556 -3.84,4.939 0,1.202 0.431,2.292 1.123,3.165 1.302,-0.356 2.628,-0.605 3.997,-0.605 1.369,0 2.694,0.248 3.997,0.605 z"
       id="path6" />
    <path
       fill="#ebebeb"
       d="m 374.332,64.235 -0.227,-0.909 c -1.058,-0.314 -1.845,-1.256 -1.845,-2.415 0,-1.414 1.146,-2.56 2.56,-2.56 1.414,0 2.56,1.146 2.56,2.56 0,0.722 -0.303,1.367 -0.783,1.833 l 0.289,1.154 c 2.505,-0.274 5.267,-0.427 8.174,-0.427 -2.121,0 -3.84,-1.719 -3.84,-3.84 0,-2.121 1.719,-3.84 3.84,-3.84 2.121,0 3.84,1.719 3.84,3.84 0,2.121 -1.719,3.84 -3.84,3.84 2.908,0 5.67,0.153 8.174,0.427 l 0.289,-1.154 c -0.48,-0.466 -0.783,-1.111 -0.783,-1.833 0,-1.414 1.146,-2.56 2.56,-2.56 1.414,0 2.56,1.146 2.56,2.56 0,1.16 -0.787,2.101 -1.845,2.415 l -0.227,0.909 c 1.301,0.201 2.511,0.434 3.597,0.7 l 1.887,-3.774 c -3.265,-5.059 -7.484,-8.589 -12.216,-9.885 -1.302,-0.356 -2.628,-0.605 -3.997,-0.605 -1.368,0 -2.694,0.248 -3.997,0.605 -4.733,1.295 -8.951,4.825 -12.216,9.885 l 1.887,3.774 c 1.087,-0.266 2.298,-0.499 3.599,-0.7 z"
       id="path7" />
    <g
       id="g9"
       transform="translate(0,-88.276)">
    	<path
       fill="#e6b432"
       d="m 382.499,362.136 v -5.59 c 0,-0.599 0.084,-1.175 0.214,-1.734 -0.068,-0.044 -0.143,-0.075 -0.214,-0.116 -0.756,-0.439 -1.623,-0.71 -2.56,-0.71 -0.937,0 -1.804,0.27 -2.56,0.71 -1.524,0.887 -2.56,2.519 -2.56,4.41 0,1.377 0.551,2.622 1.434,3.541 1.098,-0.606 2.343,-0.981 3.685,-0.981 0.904,0 1.757,0.184 2.561,0.47 z"
       id="path8" />
    	<path
       fill="#e6b432"
       d="m 387.619,341.896 c -1.524,0.887 -2.56,2.519 -2.56,4.41 0,1.377 0.551,2.622 1.434,3.541 1.098,-0.606 2.343,-0.981 3.686,-0.981 1.343,0 2.586,0.375 3.686,0.981 0.884,-0.92 1.434,-2.164 1.434,-3.541 0,-1.89 -1.036,-3.523 -2.56,-4.41 -0.756,-0.439 -1.623,-0.71 -2.56,-0.71 -0.937,0 -1.804,0.271 -2.56,0.71 z"
       id="path9" />
    </g>
    <path
       fill="#ff4b57"
       d="m 386.494,261.571 c -1.88,1.037 -3.283,2.817 -3.78,4.966 -0.129,0.559 -0.214,1.135 -0.214,1.734 v 5.59 c -0.804,-0.286 -1.657,-0.47 -2.56,-0.47 -1.343,0 -2.588,0.375 -3.686,0.981 -2.37,1.308 -3.994,3.8 -3.994,6.699 v 10.24 h 15.36 v -10.24 c 0,-0.903 -0.184,-1.756 -0.47,-2.56 h 10.71 v -10.24 c 0,-2.898 -1.624,-5.391 -3.994,-6.699 -1.098,-0.606 -2.343,-0.981 -3.686,-0.981 -1.343,0 -2.588,0.374 -3.686,0.98 z"
       id="path10" />
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<path
       fill="#e6b432"
       d="m 387.619,246.897 4.374,4.375 1.496,-1.496 c 0.355,-0.355 0.797,-0.538 1.254,-0.641 l 21.651,-21.656 13.868,13.868 9.05,-9.05 -3.62,-3.62 -1.811,1.81 -3.62,-3.62 1.81,-1.81 -1.81,-1.811 3.62,-3.62 1.811,1.81 1.81,-1.81 3.62,3.62 -1.81,1.811 3.62,3.62 9.05,-9.05 -13.871,-13.871 9.492,-9.495 c -0.458,-0.188 -0.888,-0.465 -1.26,-0.836 l -5.12,-5.12 c -0.382,-0.382 -0.661,-0.825 -0.849,-1.297 l -53.333,53.347 c 0.341,0.435 0.577,0.958 0.577,1.554 z"
       id="path11" />
    	<path
       fill="#e6b432"
       d="m 381.747,262.134 -7.241,-7.241 -22.507,22.514 c -1.998,2.001 -1.998,5.242 10e-4,7.24 1,1 2.31,1.5 3.62,1.5 1.31,0 2.622,-0.5 3.622,-1.5 l 17.592,-17.597 z"
       id="path12" />
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    	<path
       fill="#d2d2d2"
       d="m 311.864,288.705 c 0.142,-0.402 0.235,-0.828 0.235,-1.279 0,-2.121 -1.719,-3.84 -3.84,-3.84 -2.121,0 -3.84,1.719 -3.84,3.84 0,2.121 1.719,3.84 3.84,3.84 0.451,0 0.877,-0.092 1.279,-0.235 0.726,-0.824 1.502,-1.6 2.326,-2.326 z"
       id="path13" />
    	<path
       fill="#d2d2d2"
       d="m 309.538,324.781 c -0.402,-0.142 -0.828,-0.235 -1.279,-0.235 -2.121,0 -3.84,1.719 -3.84,3.84 0,2.121 1.719,3.84 3.84,3.84 2.121,0 3.84,-1.719 3.84,-3.84 0,-0.45 -0.092,-0.877 -0.235,-1.279 -0.824,-0.725 -1.6,-1.502 -2.326,-2.326 z"
       id="path14" />
    	<path
       fill="#d2d2d2"
       d="m 347.94,291.031 c 0.402,0.142 0.828,0.235 1.279,0.235 2.121,0 3.84,-1.719 3.84,-3.84 0,-2.121 -1.719,-3.84 -3.84,-3.84 -2.121,0 -3.84,1.719 -3.84,3.84 0,0.451 0.092,0.877 0.235,1.279 0.825,0.726 1.6,1.502 2.326,2.326 z"
       id="path15" />
    	<path
       fill="#d2d2d2"
       d="m 345.379,328.386 c 0,2.121 1.719,3.84 3.84,3.84 1.183,0 2.227,-0.546 2.932,-1.387 -2.407,-0.871 -4.655,-1.841 -6.727,-2.903 -0.017,0.15 -0.045,0.296 -0.045,0.45 z"
       id="path16" />
    </g>
    <path
       fill="#e6b432"
       d="m 340.033,236.403 c -0.539,-0.391 -0.862,-0.957 -0.987,-1.561 -0.435,0.094 -0.884,0.149 -1.347,0.149 -3.04,0 -5.581,-2.135 -6.23,-4.983 -0.696,0.705 -1.662,1.143 -2.73,1.143 -1.069,0 -2.035,-0.438 -2.73,-1.143 -0.648,2.848 -3.189,4.983 -6.23,4.983 -3.529,0 -6.4,-2.87 -6.4,-6.4 0,-3.041 2.136,-5.581 4.983,-6.23 -0.705,-0.696 -1.143,-1.662 -1.143,-2.73 0,-1.069 0.438,-2.035 1.143,-2.73 -2.847,-0.648 -4.983,-3.188 -4.983,-6.23 0,-3.53 2.871,-6.4 6.4,-6.4 3.04,0 5.581,2.135 6.23,4.983 0.696,-0.705 1.662,-1.143 2.73,-1.143 1.069,0 2.035,0.438 2.73,1.143 0.648,-2.848 3.189,-4.983 6.23,-4.983 3.529,0 6.4,2.87 6.4,6.4 0,3.041 -2.136,5.581 -4.983,6.23 0.705,0.696 1.143,1.662 1.143,2.73 0,1.069 -0.438,2.035 -1.143,2.73 2.847,0.648 4.983,3.189 4.983,6.23 0,1.35 -0.425,2.599 -1.141,3.633 0.024,0.017 0.053,0.018 0.077,0.035 1.656,1.199 3.565,2.314 5.685,3.333 0.638,-0.797 1.218,-1.639 1.758,-2.509 1.687,-2.717 2.879,-5.763 3.451,-9.027 0.253,-1.44 0.409,-2.912 0.409,-4.424 0,-6.466 -2.43,-12.364 -6.399,-16.875 -0.726,-0.824 -1.502,-1.601 -2.326,-2.326 -4.511,-3.969 -10.408,-6.399 -16.875,-6.399 -6.467,0 -12.364,2.43 -16.875,6.399 -0.824,0.726 -1.601,1.502 -2.326,2.326 -3.969,4.511 -6.399,10.408 -6.399,16.875 0,6.467 2.43,12.364 6.399,16.875 0.726,0.824 1.502,1.601 2.326,2.326 4.511,3.969 10.408,6.399 16.875,6.399 6.152,0 11.8,-2.184 16.22,-5.813 -1.781,-0.941 -3.442,-1.942 -4.925,-3.016 z m 8.497,-21.951 c 0.435,1.657 0.69,3.387 0.69,5.178 0,1.791 -0.255,3.521 -0.69,5.178 -0.723,-2.062 -2.005,-3.839 -3.679,-5.178 1.674,-1.339 2.956,-3.116 3.679,-5.178 z M 333.918,199.84 c -2.062,0.723 -3.839,2.005 -5.178,3.679 -1.34,-1.674 -3.116,-2.956 -5.178,-3.679 1.657,-0.435 3.386,-0.69 5.178,-0.69 1.792,0 3.52,0.255 5.178,0.69 z m -24.969,14.612 c 0.723,2.062 2.005,3.84 3.679,5.178 -1.674,1.34 -2.956,3.116 -3.679,5.178 -0.435,-1.657 -0.69,-3.386 -0.69,-5.178 0,-1.792 0.255,-3.521 0.69,-5.178 z m 14.612,24.969 c 2.062,-0.723 3.839,-2.005 5.178,-3.679 1.34,1.674 3.116,2.957 5.178,3.679 -1.657,0.435 -3.386,0.69 -5.178,0.69 -1.792,0 -3.521,-0.256 -5.178,-0.69 z"
       id="path17" />
    <g
       id="g21"
       transform="translate(0,-88.276)">
    	<path
       fill="#f0c814"
       d="m 324.899,307.906 c 0,-2.121 -1.719,-3.84 -3.84,-3.84 -1.052,0 -2.004,0.425 -2.697,1.11 -0.705,0.696 -1.143,1.662 -1.143,2.73 0,1.069 0.438,2.035 1.143,2.73 0.694,0.685 1.645,1.11 2.697,1.11 2.121,0 3.84,-1.719 3.84,-3.84 z"
       id="path18" />
    	<path
       fill="#f0c814"
       d="m 332.579,307.906 c 0,2.121 1.719,3.84 3.84,3.84 1.052,0 2.004,-0.425 2.697,-1.11 0.705,-0.696 1.143,-1.662 1.143,-2.73 0,-1.069 -0.438,-2.035 -1.143,-2.73 -0.694,-0.685 -1.645,-1.11 -2.697,-1.11 -2.121,0 -3.84,1.719 -3.84,3.84 z"
       id="path19" />
    	<path
       fill="#f0c814"
       d="m 328.739,304.066 c 2.121,0 3.84,-1.719 3.84,-3.84 0,-1.052 -0.425,-2.004 -1.11,-2.697 -0.696,-0.705 -1.662,-1.143 -2.73,-1.143 -1.069,0 -2.035,0.438 -2.73,1.143 -0.685,0.694 -1.11,1.645 -1.11,2.697 0,2.121 1.719,3.84 3.84,3.84 z"
       id="path20" />
    	<path
       fill="#f0c814"
       d="m 328.739,311.746 c -2.121,0 -3.84,1.719 -3.84,3.84 0,1.052 0.425,2.004 1.11,2.697 0.696,0.705 1.662,1.143 2.73,1.143 1.069,0 2.035,-0.438 2.73,-1.143 0.685,-0.693 1.11,-1.645 1.11,-2.697 0,-2.121 -1.719,-3.84 -3.84,-3.84 z"
       id="path21" />
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    	<path
       fill="#d2d2d2"
       d="m 446.345,195.421 c 0.372,0.372 0.802,0.65 1.26,0.836 0.466,0.191 0.96,0.288 1.455,0.288 0.982,0 1.965,-0.375 2.714,-1.126 1.331,-1.331 1.411,-3.361 0.381,-4.857 l 1.416,-5.661 c 0.201,0.051 0.393,0.122 0.609,0.122 1.414,0 2.56,-1.146 2.56,-2.56 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,0.216 0.073,0.408 0.122,0.609 l -5.661,1.416 c -1.496,-1.031 -3.527,-0.95 -4.857,0.381 -1.118,1.118 -1.398,2.752 -0.849,4.134 0.188,0.471 0.467,0.915 0.849,1.297 z"
       id="path22" />
    	<path
       fill="#d2d2d2"
       d="m 382.499,255.646 v -1.5 -10.24 c 0,-0.596 0.236,-1.119 0.577,-1.554 l -53.333,-53.347 c -0.188,0.471 -0.467,0.915 -0.849,1.297 l -5.12,5.12 c -0.372,0.372 -0.802,0.65 -1.26,0.836 l 9.492,9.495 -13.871,13.871 9.05,9.05 3.62,-3.62 -1.81,-1.811 3.62,-3.62 1.81,1.81 1.811,-1.81 3.62,3.62 -1.81,1.811 1.81,1.81 -3.62,3.62 -1.811,-1.81 -3.62,3.62 9.05,9.05 13.868,-13.868 21.651,21.656 c 0.457,0.103 0.898,0.286 1.254,0.641 z"
       id="path23" />
    	<path
       fill="#d2d2d2"
       d="m 388.372,262.134 4.914,4.915 17.592,17.597 c 1,1 2.309,1.5 3.622,1.5 1.31,0 2.62,-0.5 3.62,-1.5 2.001,-1.997 2.001,-5.24 10e-4,-7.24 l -22.507,-22.514 z"
       id="path24" />
    	<polygon
       fill="#d2d2d2"
       points="391.993,251.272 387.619,246.897 387.619,254.146 387.619,255.646 "
       id="polygon24" />
    	<path
       fill="#d2d2d2"
       d="m 460.58,291.031 c 0.402,0.142 0.828,0.235 1.279,0.235 2.121,0 3.84,-1.719 3.84,-3.84 0,-2.121 -1.719,-3.84 -3.84,-3.84 -2.121,0 -3.84,1.719 -3.84,3.84 0,0.451 0.092,0.877 0.235,1.279 0.825,0.726 1.6,1.502 2.326,2.326 z"
       id="path25" />
    	<path
       fill="#d2d2d2"
       d="m 461.859,324.546 c -0.451,0 -0.877,0.092 -1.279,0.235 -0.726,0.824 -1.502,1.601 -2.326,2.326 -0.142,0.402 -0.235,0.828 -0.235,1.279 0,2.121 1.719,3.84 3.84,3.84 2.121,0 3.84,-1.719 3.84,-3.84 0,-2.121 -1.719,-3.84 -3.84,-3.84 z"
       id="path26" />
    	<path
       fill="#d2d2d2"
       d="m 424.504,288.705 c 0.142,-0.402 0.235,-0.828 0.235,-1.279 0,-2.121 -1.719,-3.84 -3.84,-3.84 -2.121,0 -3.84,1.719 -3.84,3.84 0,2.121 1.719,3.84 3.84,3.84 0.451,0 0.877,-0.092 1.279,-0.235 0.726,-0.824 1.502,-1.6 2.326,-2.326 z"
       id="path27" />
    	<path
       fill="#d2d2d2"
       d="m 420.899,332.226 c 2.121,0 3.84,-1.719 3.84,-3.84 0,-0.154 -0.028,-0.3 -0.045,-0.45 -2.07,1.063 -4.32,2.033 -6.726,2.904 0.705,0.841 1.748,1.386 2.931,1.386 z"
       id="path28" />
    </g>
    <path
       fill="#e6b432"
       d="m 460.58,236.505 c 3.969,-4.511 6.399,-10.408 6.399,-16.875 0,-6.467 -2.43,-12.364 -6.399,-16.875 -0.726,-0.824 -1.502,-1.601 -2.326,-2.326 -4.511,-3.969 -10.408,-6.399 -16.875,-6.399 -6.467,0 -12.364,2.43 -16.875,6.399 -0.824,0.726 -1.601,1.502 -2.326,2.326 -3.969,4.511 -6.399,10.408 -6.399,16.875 0,1.519 0.158,3 0.413,4.448 0.574,3.256 1.764,6.294 3.447,9.004 0.541,0.871 1.12,1.711 1.758,2.509 2.118,-1.018 4.025,-2.132 5.681,-3.33 0.025,-0.019 0.056,-0.02 0.082,-0.038 -0.716,-1.033 -1.141,-2.283 -1.141,-3.633 0,-3.041 2.136,-5.581 4.983,-6.23 -0.705,-0.696 -1.143,-1.662 -1.143,-2.73 0,-1.069 0.438,-2.035 1.143,-2.73 -2.847,-0.648 -4.983,-3.188 -4.983,-6.23 0,-3.53 2.871,-6.4 6.4,-6.4 3.04,0 5.581,2.135 6.23,4.983 0.696,-0.705 1.662,-1.143 2.73,-1.143 1.068,0 2.035,0.438 2.73,1.143 0.649,-2.848 3.189,-4.983 6.23,-4.983 3.529,0 6.4,2.87 6.4,6.4 0,3.041 -2.136,5.581 -4.983,6.23 0.705,0.696 1.143,1.662 1.143,2.73 0,1.069 -0.438,2.035 -1.143,2.73 2.847,0.648 4.983,3.189 4.983,6.23 0,3.53 -2.871,6.4 -6.4,6.4 -3.04,0 -5.581,-2.135 -6.23,-4.983 -0.696,0.705 -1.662,1.143 -2.73,1.143 -1.068,0 -2.035,-0.438 -2.73,-1.143 -0.649,2.848 -3.189,4.983 -6.23,4.983 -0.463,0 -0.914,-0.055 -1.351,-0.149 -0.124,0.606 -0.448,1.174 -0.989,1.565 -1.482,1.074 -3.14,2.073 -4.921,3.012 4.419,3.629 10.069,5.813 16.22,5.813 6.467,0 12.364,-2.43 16.875,-6.399 0.826,-0.726 1.601,-1.503 2.327,-2.327 z m -38.991,-11.696 c -0.435,-1.657 -0.69,-3.386 -0.69,-5.178 0,-1.792 0.255,-3.521 0.69,-5.178 0.723,2.062 2.005,3.84 3.679,5.178 -1.674,1.339 -2.956,3.115 -3.679,5.178 z m 19.79,-21.29 c -1.34,-1.674 -3.116,-2.956 -5.178,-3.679 1.657,-0.435 3.386,-0.69 5.178,-0.69 1.792,0 3.521,0.255 5.178,0.69 -2.062,0.723 -3.838,2.005 -5.178,3.679 z m 19.791,10.933 c 0.435,1.657 0.69,3.387 0.69,5.178 0,1.791 -0.255,3.521 -0.69,5.178 -0.723,-2.062 -2.005,-3.839 -3.679,-5.178 1.674,-1.339 2.956,-3.116 3.679,-5.178 z m -24.969,24.969 c 2.062,-0.723 3.839,-2.005 5.178,-3.679 1.34,1.674 3.116,2.957 5.178,3.679 -1.657,0.435 -3.386,0.69 -5.178,0.69 -1.792,0 -3.521,-0.256 -5.178,-0.69 z"
       id="path29" />
    <g
       id="g33"
       transform="translate(0,-88.276)">
    	<path
       fill="#f0c814"
       d="m 445.219,307.906 c 0,2.121 1.719,3.84 3.84,3.84 1.052,0 2.004,-0.425 2.697,-1.11 0.705,-0.696 1.143,-1.662 1.143,-2.73 0,-1.069 -0.438,-2.035 -1.143,-2.73 -0.694,-0.685 -1.645,-1.11 -2.697,-1.11 -2.121,0 -3.84,1.719 -3.84,3.84 z"
       id="path30" />
    	<path
       fill="#f0c814"
       d="m 437.539,307.906 c 0,-2.121 -1.719,-3.84 -3.84,-3.84 -1.052,0 -2.004,0.425 -2.697,1.11 -0.705,0.696 -1.143,1.662 -1.143,2.73 0,1.069 0.438,2.035 1.143,2.73 0.694,0.685 1.645,1.11 2.697,1.11 2.121,0 3.84,-1.719 3.84,-3.84 z"
       id="path31" />
    	<path
       fill="#f0c814"
       d="m 441.379,304.066 c 2.121,0 3.84,-1.719 3.84,-3.84 0,-1.052 -0.425,-2.004 -1.11,-2.697 -0.696,-0.705 -1.662,-1.143 -2.73,-1.143 -1.068,0 -2.035,0.438 -2.73,1.143 -0.685,0.694 -1.11,1.645 -1.11,2.697 0,2.121 1.719,3.84 3.84,3.84 z"
       id="path32" />
    	<path
       fill="#f0c814"
       d="m 441.379,311.746 c -2.121,0 -3.84,1.719 -3.84,3.84 0,1.052 0.425,2.004 1.11,2.697 0.696,0.705 1.662,1.143 2.73,1.143 1.068,0 2.035,-0.438 2.73,-1.143 0.685,-0.693 1.11,-1.645 1.11,-2.697 0,-2.121 -1.719,-3.84 -3.84,-3.84 z"
       id="path33" />
    </g>
    <path
       fill="#f7b518"
       d="m 328.894,102.025 c 0.382,-0.382 0.661,-0.825 0.849,-1.297 0.548,-1.382 0.269,-3.015 -0.849,-4.134 -1.331,-1.331 -3.361,-1.411 -4.857,-0.381 l -5.661,-1.416 c 0.051,-0.201 0.122,-0.393 0.122,-0.609 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,1.414 1.146,2.56 2.56,2.56 0.216,0 0.408,-0.073 0.609,-0.122 l 1.416,5.661 c -1.031,1.496 -0.95,3.527 0.381,4.857 0.75,0.75 1.732,1.126 2.714,1.126 0.495,0 0.99,-0.098 1.455,-0.288 0.458,-0.188 0.888,-0.465 1.26,-0.836 z"
       id="path34" />
    <path
       fill="#ff4b55"
       d="m 430.08,236.405 c 0.541,-0.391 0.864,-0.959 0.989,-1.565 0.139,-0.679 0.022,-1.406 -0.416,-2.01 -0.811,-1.117 -2.353,-1.375 -3.492,-0.608 -0.026,0.018 -0.056,0.019 -0.082,0.038 -1.655,1.198 -3.563,2.312 -5.681,3.33 -7.506,3.611 -17.667,6.019 -28.658,6.798 V 206.43 c 11.172,15.257 22.054,23.457 26.9,26.652 -1.683,-2.71 -2.873,-5.748 -3.447,-9.004 -6.196,-5.126 -14.957,-13.736 -23.453,-26.718 v -17.395 c 0.181,-0.399 0.366,-0.788 0.546,-1.192 l -4.914,-4.915 7.241,-7.241 1.496,-1.496 c 1,-1 1,-2.62 0,-3.62 -0.644,-0.644 -1.539,-0.828 -2.367,-0.641 -0.457,0.103 -0.897,0.286 -1.254,0.641 l -1.496,1.496 -4.374,4.374 v -1.5 -7.25 -2.99 c 0,-0.596 -0.236,-1.119 -0.577,-1.554 -0.469,-0.598 -1.165,-1.006 -1.983,-1.006 -0.819,0 -1.514,0.408 -1.983,1.006 -0.341,0.435 -0.577,0.958 -0.577,1.554 v 10.24 1.5 l -5.87,-5.87 c -0.355,-0.355 -0.797,-0.538 -1.254,-0.641 -0.828,-0.186 -1.722,-0.003 -2.367,0.641 -1,1 -1,2.62 0,3.62 l 1.496,1.496 7.241,7.241 -4.914,4.915 c 0.18,0.405 0.365,0.792 0.546,1.192 v 17.374 c -8.487,12.956 -17.25,21.576 -23.449,26.714 -0.573,3.265 -1.763,6.312 -3.451,9.027 4.846,-3.194 15.727,-11.394 26.9,-26.652 v 35.958 c -10.991,-0.778 -21.152,-3.187 -28.659,-6.797 -2.12,-1.02 -4.029,-2.134 -5.685,-3.333 -0.024,-0.018 -0.053,-0.019 -0.077,-0.035 -1.139,-0.77 -2.684,-0.511 -3.498,0.605 -0.439,0.606 -0.555,1.334 -0.414,2.014 0.125,0.604 0.448,1.171 0.986,1.561 1.484,1.075 3.144,2.076 4.926,3.015 0.155,0.082 0.309,0.162 0.466,0.243 2.07,1.063 4.32,2.033 6.727,2.903 7.27,2.631 15.932,4.351 25.228,4.966 v 18.891 c 0.756,-0.439 1.623,-0.71 2.56,-0.71 0.937,0 1.804,0.27 2.56,0.71 v -18.667 c 0.851,0.018 1.702,0.036 2.56,0.036 0.858,0 1.709,-0.019 2.56,-0.036 v 5.867 c 0.756,-0.439 1.623,-0.71 2.56,-0.71 0.937,0 1.804,0.27 2.56,0.71 v -6.091 c 9.297,-0.615 17.96,-2.335 25.229,-4.966 2.407,-0.871 4.655,-1.841 6.726,-2.904 0.157,-0.081 0.311,-0.161 0.466,-0.243 1.783,-0.936 3.441,-1.937 4.923,-3.01 z m -45.021,6.265 c -0.856,0 -1.709,-0.018 -2.56,-0.038 v -43.691 c 0.858,-1.347 1.711,-2.749 2.56,-4.185 0.849,1.437 1.702,2.838 2.56,4.185 v 43.691 c -0.85,0.021 -1.703,0.038 -2.56,0.038 z"
       id="path35" />
    <g
       id="g38"
       transform="translate(0,-88.276)">
    	<path
       fill="#e6b432"
       d="m 385.059,184.457 c 14.138,0 25.6,2.42 25.6,5.405 0,-5.022 0,-9.922 0,-10.687 0,-1.174 -1.084,-2.28 -2.978,-3.25 l 0.587,-1.173 c 0.928,-0.064 1.7,-0.625 2.098,-1.408 0.172,-0.34 0.295,-0.708 0.295,-1.118 0,-0.492 -0.175,-0.926 -0.417,-1.316 -0.451,-0.73 -1.221,-1.244 -2.143,-1.244 -1.414,0 -2.56,1.146 -2.56,2.56 0,0.512 0.189,0.962 0.448,1.362 l -0.674,1.347 c -1.932,-0.679 -4.312,-1.256 -7.027,-1.703 l 0.288,-1.152 c 1.058,-0.314 1.845,-1.256 1.845,-2.415 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,0.722 0.303,1.367 0.783,1.833 l -0.342,1.367 c -1.427,-0.179 -2.922,-0.32 -4.474,-0.426 0.116,-0.481 0.193,-0.978 0.193,-1.494 0,-3.534 -2.866,-6.4 -6.4,-6.4 -3.534,0 -6.4,2.866 -6.4,6.4 0,0.518 0.077,1.013 0.193,1.494 -1.554,0.105 -3.049,0.247 -4.474,0.426 l -0.342,-1.367 c 0.48,-0.466 0.783,-1.111 0.783,-1.833 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,1.16 0.787,2.101 1.845,2.415 l 0.288,1.152 c -2.714,0.446 -5.095,1.023 -7.027,1.703 l -0.674,-1.347 c 0.259,-0.401 0.448,-0.85 0.448,-1.362 0,-1.414 -1.146,-2.56 -2.56,-2.56 -0.921,0 -1.693,0.513 -2.143,1.244 -0.241,0.391 -0.417,0.824 -0.417,1.316 0,0.409 0.121,0.778 0.294,1.118 0.397,0.783 1.17,1.344 2.098,1.408 l 0.587,1.173 c -1.895,0.97 -2.978,2.074 -2.978,3.25 0,0.766 0,5.665 0,10.687 -0.003,-2.985 11.459,-5.405 25.597,-5.405 z"
       id="path36" />
    	<path
       fill="#e6b432"
       d="m 359.459,190.146 0.032,-0.013 c -0.008,-0.086 -0.032,-0.202 -0.032,-0.271 0,0.096 0,0.189 0,0.284 z"
       id="path37" />
    	<path
       fill="#e6b432"
       d="m 410.659,190.146 c 0,-0.095 0,-0.189 0,-0.285 0,0.07 -0.024,0.186 -0.032,0.271 z"
       id="path38" />
    </g>
    <path
       fill="#ebebeb"
       d="m 364.579,106.99 c 0,0.512 -0.189,0.962 -0.448,1.362 l 0.97,1.941 c 1.694,-0.84 4.008,-1.561 6.775,-2.114 l -0.333,-1.333 c -1.058,-0.314 -1.845,-1.256 -1.845,-2.415 0,-1.414 1.146,-2.56 2.56,-2.56 1.414,0 2.56,1.146 2.56,2.56 0,0.722 -0.303,1.367 -0.783,1.833 l 0.37,1.476 c 2.47,-0.369 5.198,-0.615 8.094,-0.706 v -2.319 c -0.78,-0.703 -1.28,-1.71 -1.28,-2.844 0,-2.121 1.719,-3.84 3.84,-3.84 2.121,0 3.84,1.719 3.84,3.84 0,1.133 -0.5,2.141 -1.28,2.844 v 2.319 c 2.895,0.092 5.624,0.338 8.094,0.706 l 0.37,-1.476 c -0.48,-0.466 -0.783,-1.111 -0.783,-1.833 0,-1.414 1.146,-2.56 2.56,-2.56 1.414,0 2.56,1.146 2.56,2.56 0,1.16 -0.787,2.101 -1.845,2.415 l -0.333,1.333 c 2.767,0.553 5.082,1.276 6.775,2.114 l 0.97,-1.941 c -0.259,-0.401 -0.448,-0.85 -0.448,-1.362 0,-1.414 1.146,-2.56 2.56,-2.56 0.612,0 1.152,0.245 1.592,0.604 0.57,-1.399 0.873,-2.51 0.936,-3.176 0.008,-0.086 0.032,-0.202 0.032,-0.271 0,-2.985 -11.462,-5.405 -25.6,-5.405 -14.138,0 -25.6,2.42 -25.6,5.405 0,0.07 0.024,0.186 0.032,0.271 0.062,0.666 0.365,1.777 0.935,3.176 0.44,-0.359 0.98,-0.604 1.592,-0.604 1.415,0 2.561,1.147 2.561,2.56 z"
       id="path39" />
    <path
       fill="#e6b432"
       d="m 359.459,106.99 c 0,1.354 1.06,2.435 2.391,2.526 l 1.105,2.209 c -0.599,0.587 -0.937,1.205 -0.937,1.847 0,0.738 0.445,1.447 1.23,2.11 l 3.89,6.668 c 0,-2.828 8.023,-5.12 17.92,-5.12 9.897,0 17.92,2.292 17.92,5.12 l 3.89,-6.668 c 0.786,-0.663 1.23,-1.37 1.23,-2.11 0,-0.642 -0.337,-1.26 -0.937,-1.847 l 1.105,-2.209 c 1.331,-0.092 2.392,-1.172 2.392,-2.526 0,-0.801 -0.391,-1.487 -0.968,-1.956 -0.44,-0.359 -0.98,-0.604 -1.592,-0.604 -1.414,0 -2.56,1.146 -2.56,2.56 0,0.512 0.189,0.962 0.448,1.362 l -0.97,1.941 c -1.694,-0.84 -4.008,-1.561 -6.775,-2.114 l 0.333,-1.333 c 1.058,-0.314 1.845,-1.256 1.845,-2.415 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,0.722 0.303,1.367 0.783,1.833 l -0.37,1.476 c -2.47,-0.369 -5.198,-0.615 -8.094,-0.706 v -2.319 c 0.78,-0.703 1.28,-1.71 1.28,-2.844 0,-2.121 -1.719,-3.84 -3.84,-3.84 -2.121,0 -3.84,1.719 -3.84,3.84 0,1.133 0.5,2.141 1.28,2.844 v 2.319 c -2.895,0.092 -5.624,0.338 -8.094,0.706 l -0.37,-1.476 c 0.48,-0.466 0.783,-1.111 0.783,-1.833 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,1.16 0.787,2.101 1.845,2.415 l 0.333,1.333 c -2.767,0.553 -5.082,1.276 -6.775,2.114 l -0.97,-1.941 c 0.259,-0.401 0.448,-0.85 0.448,-1.362 0,-1.414 -1.146,-2.56 -2.56,-2.56 -0.612,0 -1.152,0.245 -1.592,0.604 -0.576,0.469 -0.967,1.155 -0.967,1.956 z"
       id="path40" />
    <ellipse
       fill="#ebebeb"
       cx="385.06"
       cy="122.354"
       rx="17.92"
       ry="5.1199999"
       id="ellipse40" />
    <g
       id="g41"
       transform="translate(0,-88.276)">
    	<path
       fill="#e6b432"
       d="m 410.046,167.006 -4.507,-10.14 c 0,-0.64 -0.491,-1.25 -1.35,-1.815 l 3.639,-7.279 c 0.632,-1.265 0.12,-2.803 -1.145,-3.435 -1.268,-0.628 -2.803,-0.117 -3.435,1.145 l -1.977,3.955 -1.887,3.774 c -1.086,-0.266 -2.297,-0.499 -3.597,-0.7 l 0.227,-0.909 c 1.058,-0.314 1.845,-1.256 1.845,-2.415 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,0.722 0.303,1.367 0.783,1.833 l -0.289,1.154 c -2.505,-0.274 -5.267,-0.427 -8.174,-0.427 -2.908,0 -5.67,0.153 -8.174,0.427 l -0.289,-1.154 c 0.48,-0.466 0.783,-1.111 0.783,-1.833 0,-1.414 -1.146,-2.56 -2.56,-2.56 -1.414,0 -2.56,1.146 -2.56,2.56 0,1.16 0.787,2.101 1.845,2.415 l 0.227,0.909 c -1.301,0.201 -2.511,0.434 -3.598,0.7 l -1.887,-3.774 -1.977,-3.955 c -0.633,-1.262 -2.166,-1.772 -3.435,-1.145 -1.265,0.632 -1.778,2.17 -1.145,3.435 l 3.639,7.279 c -0.858,0.565 -1.35,1.175 -1.35,1.815 l -4.507,10.14 c 2.528,-2.87 12.746,-5.02 24.987,-5.02 12.242,0 22.46,2.149 24.988,5.02 z"
       id="path41" />
    	<circle
       fill="#e6b432"
       cx="385.06"
       cy="147.91"
       r="3.8399999"
       id="circle41" />
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g55"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g56"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const VC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.45403" {...props}>
    <defs
       id="defs19" />
    <rect
       x="114.76"
       y="0.0040004272"
       fill="#ffe15a"
       width="282.48001"
       height="335.45001"
       id="rect1" />
    <path
       fill="#73af00"
       d="M 503.172,335.448 H 397.242 V 0 h 105.931 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#4173cd"
       d="M 8.828,0 H 114.759 V 335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 Z"
       id="path2" />
    <g
       id="g4"
       transform="translate(0,-88.273)">
    	<polygon
       fill="#73af00"
       points="249.157,251.475 220.521,194.204 191.886,251.475 220.521,308.746 "
       id="polygon2" />
    	<polygon
       fill="#73af00"
       points="320.114,251.475 291.479,194.204 262.843,251.475 291.479,308.746 "
       id="polygon3" />
    	<polygon
       fill="#73af00"
       points="284.635,320.327 255.999,263.056 227.364,320.327 255.999,377.597 "
       id="polygon4" />
    </g>
    <g
       id="g5"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.273)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.273)">
    </g>
  </svg>
);

export const VE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs27" />
    <path
       fill="#ffe15a"
       d="M 512,111.817 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 223.633 h 512 v 102.988 c 0,4.876 -3.953,8.828 -8.828,8.828 z"
       id="path2" />
    <rect
       y="111.815"
       fill="#41479b"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 178.14,277.498 2.212,6.633 6.991,0.054 c 0.905,0.007 1.281,1.162 0.553,1.7 l -5.624,4.153 2.109,6.667 c 0.273,0.863 -0.71,1.577 -1.447,1.05 l -5.688,-4.066 -5.688,4.066 c -0.736,0.526 -1.719,-0.188 -1.447,-1.05 l 2.109,-6.667 -5.624,-4.153 c -0.728,-0.537 -0.353,-1.693 0.553,-1.7 l 6.991,-0.054 2.212,-6.633 c 0.287,-0.858 1.502,-0.858 1.788,0 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 191.723,256.383 -1.185,6.891 6.136,3.352 c 0.794,0.434 0.579,1.63 -0.317,1.759 l -6.92,1.002 -1.292,6.871 c -0.168,0.889 -1.37,1.055 -1.771,0.243 l -3.091,-6.272 -6.935,0.895 c -0.898,0.116 -1.427,-0.978 -0.778,-1.61 l 5.01,-4.878 -2.994,-6.318 c -0.387,-0.818 0.489,-1.659 1.29,-1.237 l 6.187,3.257 5.085,-4.8 c 0.658,-0.621 1.728,-0.047 1.575,0.845 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 208.913,237.903 -3.282,6.174 4.779,5.103 c 0.619,0.661 0.041,1.729 -0.851,1.571 l -6.887,-1.213 -3.377,6.123 c -0.437,0.792 -1.632,0.573 -1.758,-0.323 l -0.974,-6.924 -6.867,-1.32 c -0.889,-0.171 -1.049,-1.375 -0.235,-1.772 l 6.284,-3.066 -0.867,-6.938 c -0.113,-0.898 0.983,-1.422 1.612,-0.771 l 4.858,5.028 6.33,-2.968 c 0.822,-0.384 1.659,0.496 1.235,1.296 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 229.598,226.437 -4.824,5.062 3.228,6.202 c 0.418,0.803 -0.427,1.676 -1.244,1.284 l -6.304,-3.025 -4.903,4.986 c -0.634,0.646 -1.726,0.111 -1.606,-0.786 l 0.928,-6.931 -6.257,-3.122 c -0.81,-0.404 -0.64,-1.607 0.25,-1.77 l 6.878,-1.259 1.035,-6.915 c 0.134,-0.895 1.331,-1.105 1.761,-0.308 l 3.322,6.152 6.897,-1.152 c 0.895,-0.147 1.463,0.927 0.839,1.582 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 253.374,221.124 -6.004,3.584 1.448,6.84 c 0.188,0.886 -0.861,1.501 -1.542,0.905 l -5.263,-4.602 -6.059,3.49 c -0.785,0.452 -1.693,-0.354 -1.336,-1.187 l 2.751,-6.429 -5.192,-4.683 c -0.672,-0.606 -0.185,-1.719 0.716,-1.637 l 6.964,0.629 2.85,-6.385 c 0.369,-0.826 1.578,-0.708 1.779,0.174 l 1.554,6.817 6.953,0.737 c 0.897,0.097 1.159,1.283 0.381,1.747 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 333.86,277.498 -2.212,6.633 -6.991,0.054 c -0.905,0.007 -1.281,1.162 -0.553,1.7 l 5.624,4.153 -2.109,6.667 c -0.273,0.863 0.71,1.577 1.447,1.05 l 5.688,-4.066 5.688,4.066 c 0.736,0.526 1.719,-0.188 1.447,-1.05 l -2.109,-6.667 5.624,-4.153 c 0.728,-0.537 0.353,-1.693 -0.553,-1.7 l -6.991,-0.054 -2.212,-6.633 c -0.287,-0.858 -1.502,-0.858 -1.788,0 z"
       id="path8" />
    	<path
       fill="#f5f5f5"
       d="m 320.277,256.383 1.185,6.891 -6.136,3.352 c -0.794,0.434 -0.579,1.63 0.317,1.759 l 6.92,1.002 1.292,6.871 c 0.168,0.889 1.371,1.055 1.771,0.243 l 3.091,-6.272 6.935,0.895 c 0.898,0.116 1.427,-0.978 0.778,-1.61 l -5.01,-4.878 2.994,-6.318 c 0.387,-0.818 -0.489,-1.659 -1.29,-1.237 l -6.187,3.257 -5.085,-4.8 c -0.658,-0.621 -1.728,-0.047 -1.575,0.845 z"
       id="path9" />
    	<path
       fill="#f5f5f5"
       d="m 303.087,237.903 3.282,6.174 -4.779,5.103 c -0.619,0.661 -0.041,1.729 0.851,1.571 l 6.887,-1.213 3.377,6.123 c 0.437,0.792 1.632,0.573 1.758,-0.323 l 0.974,-6.924 6.867,-1.32 c 0.889,-0.171 1.049,-1.375 0.235,-1.772 l -6.284,-3.066 0.867,-6.938 c 0.113,-0.898 -0.983,-1.422 -1.612,-0.771 l -4.858,5.028 -6.33,-2.968 c -0.822,-0.384 -1.659,0.496 -1.235,1.296 z"
       id="path10" />
    	<path
       fill="#f5f5f5"
       d="m 282.402,226.437 4.824,5.062 -3.228,6.202 c -0.418,0.803 0.427,1.676 1.244,1.284 l 6.304,-3.025 4.903,4.986 c 0.634,0.646 1.726,0.111 1.605,-0.786 l -0.928,-6.931 6.257,-3.122 c 0.81,-0.404 0.64,-1.607 -0.25,-1.77 l -6.878,-1.259 -1.035,-6.915 c -0.134,-0.895 -1.331,-1.105 -1.761,-0.308 l -3.322,6.152 -6.897,-1.152 c -0.894,-0.147 -1.462,0.927 -0.838,1.582 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 258.626,221.124 6.004,3.584 -1.448,6.84 c -0.188,0.886 0.861,1.501 1.542,0.905 l 5.263,-4.602 6.059,3.49 c 0.785,0.452 1.693,-0.354 1.336,-1.187 l -2.751,-6.429 5.192,-4.683 c 0.672,-0.606 0.185,-1.719 -0.716,-1.637 l -6.964,0.629 -2.85,-6.385 c -0.369,-0.826 -1.578,-0.708 -1.779,0.174 l -1.554,6.817 -6.953,0.737 c -0.897,0.097 -1.159,1.283 -0.381,1.747 z"
       id="path12" />
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const VG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs54" />
    <path
       fill="#41479b"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#f5f5f5"
       d="m 247.172,0 h -15.333 l -81.77,53.573 V 0 H 105.931 V 53.573 L 24.161,0 H 8.828 C 3.953,0 0,3.953 0,8.828 V 15.83 L 70.155,61.793 H 0 v 44.138 H 70.155 L 0,151.895 v 7.001 c 0,4.875 3.953,8.828 8.828,8.828 h 15.333 l 81.77,-53.573 v 53.573 h 44.138 v -53.573 l 81.769,53.573 h 15.333 c 4.875,0 8.828,-3.953 8.828,-8.828 v -7.002 l -70.154,-45.963 h 70.154 V 61.793 H 185.844 L 255.999,15.83 V 8.828 C 255.999,3.953 252.048,0 247.172,0 Z"
       id="path2" />
    <g
       id="g6"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#ff4b55"
       points="141.241,88.276 114.758,88.276 114.758,158.897 0,158.897 0,185.379 114.758,185.379 114.758,256 141.241,256 141.241,185.379 255.999,185.379 255.999,158.897 141.241,158.897 "
       id="polygon2" />
    	<path
       fill="#ff4b55"
       d="M 97.103,150.069 4.207,89.768 C 1.735,91.333 0,93.961 0,97.104 v 0.458 l 80.889,52.507 z"
       id="path3" />
    	<path
       fill="#ff4b55"
       d="m 166.283,150.069 88.374,-57.366 c -1.536,-2.599 -4.246,-4.427 -7.485,-4.427 h -1.909 l -95.194,61.793 z"
       id="path4" />
    	<path
       fill="#ff4b55"
       d="M 89.474,194.207 1.269,251.463 C 2.79,254.125 5.542,256 8.828,256 h 1.665 l 95.195,-61.793 z"
       id="path5" />
    	<path
       fill="#ff4b55"
       d="M 255.859,247.867 173.193,194.208 H 156.98 l 93.873,60.934 c 2.813,-1.305 4.741,-4.04 5.006,-7.275 z"
       id="path6" />
    </g>
    <path
       fill="#73af00"
       d="m 387.75,82.848 h -57.796 c 0,0 0,74.795 0,105.393 0,23.798 57.796,47.597 57.796,47.597 0,0 57.796,-23.798 57.796,-47.597 0,-30.599 0,-105.393 0,-105.393 z"
       id="path7" />
    <path
       fill="#ff4b55"
       d="m 353.913,163.266 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.454,-1.938 -0.614,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.542,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path8" />
    <path
       fill="#ffe15a"
       d="m 376.637,161.004 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.666 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.582 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.394 -0.052,-0.771 -0.334,-1.129 z m -9.559,1.952 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.666,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.219,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path9" />
    <path
       fill="#ffc8b9"
       d="m 384.066,112.879 c 0,0 -5.383,-1.593 -7.791,17.247 0,0 -13.174,16.751 -13.599,17.742 -0.425,0.992 -0.035,8.11 1.382,7.543 1.417,-0.567 3.967,-3.86 3.825,-6.269 -0.142,-2.409 0.945,-3.752 2.018,-4.958 2.018,-2.266 13.387,-12.536 13.812,-14.803 0.424,-2.265 0.353,-16.502 0.353,-16.502 z"
       id="path10" />
    <g
       id="g12"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 392.425,197.579 c 0,0 8.322,-1.098 10.766,7.402 0,0 -6.835,3.754 -5.985,8.641 0.85,4.887 -0.106,27.199 -0.106,27.199 -13.068,4.249 -19.974,-1.063 -19.974,-1.063 0,0 3.4,-12.643 2.869,-22.948 0,0 -3.081,-2.337 -2.337,-4.993 0.744,-2.656 2.656,-5.631 3.294,-7.862 0.638,-2.231 2.337,-5.95 6.481,-6.269 4.141,-0.32 4.992,-0.107 4.992,-0.107 z"
       id="path11" />
    	<path
       fill="#f5f5f5"
       d="m 379.534,237.279 c 0,0 -6.516,24.649 -4.249,58.221 0,0 20.328,2.691 31.378,-1.346 0,0 -5.737,-40.16 -11.262,-55.884 z"
       id="path12" />
    </g>
    <path
       fill="#ffc8b9"
       d="m 383.358,94.784 v 10.211 c 0,1.121 0.909,2.03 2.03,2.03 h 0.182 c 0.793,0 1.437,0.643 1.437,1.437 v 2.441 c 0,0 1.368,3.574 6.691,-0.608 V 94.86 Z"
       id="path13" />
    <path
       fill="#8c5a28"
       d="m 382.154,92.693 c -0.33,0.825 0.018,3.063 2.053,2.904 2.543,-0.199 5.613,-0.213 6.304,2.603 0.642,2.617 0.213,9.154 3.046,9.58 2.834,0.425 6.046,-1.458 5.985,-7.083 -0.053,-4.958 -3.294,-10.89 -7.827,-9.987 0,0 -4.02,-2.816 -6.375,0.354 0.002,0 -2.477,-0.141 -3.186,1.629 z"
       id="path14" />
    <path
       fill="#ffc8b9"
       d="m 403.19,116.704 c 0,0 2.9,19.104 2.762,20.682 -0.141,1.629 -10.27,17.282 -9.704,18.983 0.567,1.7 1.133,3.967 -1.983,4.817 -3.116,0.85 -2.797,-4.126 -1.948,-6.676 0.85,-2.55 7.968,-16.131 7.968,-17.689 0,-1.558 -4.038,-11.616 -3.046,-15.583 0.993,-3.968 5.951,-4.534 5.951,-4.534 z"
       id="path15" />
    <path
       fill="#ff4b55"
       d="m 341.163,102.986 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.454,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.541,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path16" />
    <path
       fill="#ffe15a"
       d="m 363.888,100.724 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.666 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.581 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.393 -0.052,-0.771 -0.334,-1.128 z m -9.559,1.952 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.666,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path17" />
    <path
       fill="#ff4b55"
       d="m 341.163,123.08 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.454,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.542,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path18" />
    <path
       fill="#ffe15a"
       d="m 363.888,120.818 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.666 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.582 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.396 -0.052,-0.773 -0.334,-1.129 z m -9.559,1.951 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.666,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path19" />
    <path
       fill="#ff4b55"
       d="m 341.163,143.173 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.454,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.541,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path20" />
    <path
       fill="#ffe15a"
       d="m 363.888,140.911 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.666 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.581 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.394 -0.052,-0.771 -0.334,-1.128 z m -9.559,1.951 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.666,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path21" />
    <path
       fill="#ff4b55"
       d="m 341.163,183.36 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.454,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.54,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path22" />
    <path
       fill="#ffe15a"
       d="m 363.888,181.098 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.667 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.229 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.582 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.395 -0.052,-0.773 -0.334,-1.129 z m -9.559,1.952 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.666,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path23" />
    <path
       fill="#ff4b55"
       d="m 341.163,203.454 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.454,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.542,1.408 0.794,1.624 0.614,2.959 -0.181,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path24" />
    <path
       fill="#ffe15a"
       d="m 363.888,201.191 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.421 l -5.592,-8.258 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.667 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.059 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.582 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.395 -0.052,-0.772 -0.334,-1.129 z m -9.559,1.951 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.666,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path25" />
    <path
       fill="#ff4b55"
       d="m 411.071,102.986 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.455,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.542,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path26" />
    <path
       fill="#ffe15a"
       d="m 433.795,100.724 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.666 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.581 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.393 -0.05,-0.771 -0.334,-1.128 z m -9.558,1.952 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.667,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path27" />
    <path
       fill="#ff4b55"
       d="m 411.071,123.08 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.455,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.542,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path28" />
    <path
       fill="#ffe15a"
       d="m 433.795,120.818 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.666 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.582 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.396 -0.05,-0.773 -0.334,-1.129 z m -9.558,1.951 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.667,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path29" />
    <path
       fill="#ff4b55"
       d="m 411.071,143.173 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.455,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.542,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path30" />
    <path
       fill="#ffe15a"
       d="m 433.795,140.911 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.666 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.581 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.394 -0.05,-0.771 -0.334,-1.128 z m -9.558,1.951 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.667,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path31" />
    <path
       fill="#ff4b55"
       d="m 411.071,163.266 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.455,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.542,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path32" />
    <path
       fill="#ffe15a"
       d="m 433.795,161.004 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.666 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.582 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.394 -0.05,-0.771 -0.334,-1.129 z m -9.558,1.952 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.667,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path33" />
    <path
       fill="#ff4b55"
       d="m 411.071,183.36 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.455,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.542,1.408 0.794,1.624 0.614,2.959 -0.18,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path34" />
    <path
       fill="#ffe15a"
       d="m 433.795,181.098 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.422 l -5.592,-8.259 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.667 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.058 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.229 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.582 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.395 -0.05,-0.773 -0.334,-1.129 z m -9.558,1.952 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.667,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path35" />
    <path
       fill="#ff4b55"
       d="m 411.071,203.454 c 0,0 -0.324,-1.119 -0.036,-2.13 0.289,-1.011 -0.455,-1.938 -0.613,-2.815 -0.433,-2.382 1.588,-2.996 1.696,-5.124 0,0 1.443,1.48 0.903,2.888 -0.542,1.408 0.794,1.624 0.614,2.959 -0.181,1.335 -1.661,2.743 -1.516,3.934 z"
       id="path36" />
    <path
       fill="#ffe15a"
       d="m 433.795,201.191 c -1.181,-1.476 -3.252,0.114 -4.768,1.27 -0.211,0.162 -0.39,0.286 -0.577,0.421 l -5.592,-8.258 c 0.157,-0.236 0.27,-0.503 0.27,-0.807 0,-0.823 -0.666,-1.49 -1.49,-1.49 -0.824,0 -1.49,0.667 -1.49,1.49 0,0.305 0.114,0.572 0.27,0.807 l -5.769,8.519 h -4.085 c 0,0 -0.169,2.539 4.291,2.847 0.575,0.871 1.395,1.564 2.377,1.956 -0.461,0.075 -0.833,0.431 -0.833,0.914 v 0.597 c 0,0.038 0.036,0.06 0.04,0.097 h 10.391 c 0.004,-0.036 0.04,-0.059 0.04,-0.097 v -0.597 c 0,-0.488 -0.378,-0.852 -0.847,-0.919 1.739,-0.7 2.961,-2.327 3.167,-4.26 0.162,-0.12 0.313,-0.23 0.489,-0.363 1.097,-0.842 2.749,-2.124 3.276,-1.453 0.131,0.164 0.118,0.255 0.113,0.288 -0.06,0.39 -0.893,0.95 -1.562,1.399 -1.053,0.707 -2.142,1.441 -2.228,2.481 -0.025,0.297 0.194,0.554 0.49,0.582 0.015,0 0.032,0 0.045,0 0.277,0 0.512,-0.213 0.535,-0.491 0.043,-0.527 0.993,-1.165 1.757,-1.677 0.973,-0.657 1.892,-1.273 2.024,-2.127 0.061,-0.395 -0.05,-0.772 -0.334,-1.129 z m -9.558,1.951 c -0.308,-1.174 -1.034,-2.302 -1.941,-2.71 0.48,-0.247 0.819,-0.734 0.819,-1.311 0,-0.822 -0.667,-1.49 -1.49,-1.49 -0.822,0 -1.49,0.666 -1.49,1.49 0,0.577 0.338,1.064 0.819,1.311 -0.907,0.407 -1.634,1.535 -1.941,2.71 h -3.065 l 5.353,-7.905 c 0.111,0.026 0.218,0.068 0.339,0.068 0.12,0 0.227,-0.042 0.339,-0.068 l 5.353,7.905 z"
       id="path37" />
    <g
       id="g39"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 445.546,171.124 c 0,0 0,74.795 0,105.393 0,23.798 -57.796,47.597 -57.796,47.597 0,0 -57.796,-23.798 -57.796,-47.597 0,-30.599 0,-105.393 0,-105.393 h 57.796 57.796 m 3.4,-3.4 h -3.4 -57.796 -57.796 -3.4 v 3.4 105.393 c 0,11.128 10.265,23.111 30.511,35.616 14.518,8.967 28.79,14.878 29.39,15.125 l 1.294,0.533 1.294,-0.533 c 0.6,-0.247 14.872,-6.158 29.39,-15.125 20.246,-12.505 30.511,-24.488 30.511,-35.616 V 171.124 Z"
       id="path38" />
    	<path
       fill="#f5f5f5"
       d="m 449.437,295.262 15.412,10.63 c -17.901,22.963 -45.794,37.772 -77.1,37.772 -31.305,0 -59.198,-14.81 -77.1,-37.772 l 15.412,-10.63 c 14.498,18.089 36.756,29.703 61.687,29.703 24.933,-10e-4 47.191,-11.615 61.689,-29.703 m -0.674,-4.595 -1.978,2.468 c -14.48,18.067 -35.998,28.429 -59.034,28.429 -23.036,0 -44.554,-10.362 -59.034,-28.429 l -1.978,-2.468 -2.604,1.796 -15.412,10.629 -2.967,2.046 2.216,2.842 c 19.363,24.836 48.442,39.082 79.78,39.082 31.338,0 60.418,-14.244 79.78,-39.082 l 2.216,-2.842 -2.967,-2.046 -15.412,-10.629 z"
       id="path39" />
    </g>
    <path
       fill="#ffe15a"
       d="m 387.75,255.387 c 31.305,0 59.198,-14.81 77.1,-37.772 l -15.412,-10.629 c -14.498,18.089 -36.756,29.703 -61.687,29.703 -24.931,0 -47.189,-11.614 -61.687,-29.703 l -15.412,10.629 c 17.9,22.963 45.793,37.772 77.098,37.772 z"
       id="path40" />
    <g
       id="g40"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g41"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g42"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g43"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g44"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g45"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g46"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g47"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g48"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g49"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g50"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g51"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g52"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g53"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g54"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const VI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs34" />
    <path
       fill="#f5f5f5"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#4173cd"
       points="413.476,268.033 382.419,284.408 394.092,285.781 356.818,329.578 356.495,328.65 386.265,267.007 392.235,277.132 394.671,242.107 368.753,265.79 380.394,264.172 350.624,325.815 349.695,326.138 360.825,269.714 369.157,278.003 362.672,243.498 343.572,272.957 354.428,268.452 342.428,329.292 338.511,337.405 334.29,340.235 332.553,349.037 317.792,366.382 329.316,365.454 327.225,376.054 331.301,373.322 331.695,378.212 338.697,369.985 345.135,379.586 349.542,357.241 355.357,350.409 354.949,345.343 358.867,337.231 399.057,290.007 402.279,301.309 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <path
       fill="#73af00"
       d="m 130.918,168.653 c 1.266,-5.692 0.481,-11.025 -1.687,-14.308 -3.357,2.056 -6.327,6.553 -7.593,12.245 -0.586,2.636 -0.691,5.172 -0.463,7.486 l -6.969,-10.391 c 2.838,-2.314 5.281,-6.276 6.39,-11.261 1.266,-5.692 0.481,-11.025 -1.687,-14.308 -3.357,2.056 -6.327,6.553 -7.593,12.245 -0.674,3.031 -0.732,5.932 -0.343,8.505 l -4.712,-7.025 c 0.236,-3.567 -0.86,-7.906 -3.489,-12.041 -3.129,-4.92 -7.455,-8.136 -11.31,-8.925 -0.919,3.827 0.16,9.108 3.289,14.027 2.659,4.181 6.172,7.027 9.537,8.303 l 4.318,7.168 c -2.166,-1.443 -4.818,-2.621 -7.85,-3.295 -5.692,-1.266 -11.025,-0.481 -14.308,1.687 2.056,3.356 6.553,6.327 12.245,7.593 4.985,1.109 9.61,0.576 12.909,-1.014 l 6.457,10.718 c -2.001,-1.187 -4.341,-2.167 -6.978,-2.754 -5.692,-1.266 -11.025,-0.481 -14.308,1.687 2.056,3.356 6.553,6.327 12.245,7.593 4.771,1.062 9.214,0.618 12.485,-0.811 l 5.945,9.868 c -1.838,-0.992 -3.884,-1.843 -6.202,-2.358 -5.692,-1.266 -11.025,-0.481 -14.308,1.687 2.056,3.356 6.553,6.327 12.245,7.593 4.562,1.014 8.838,0.667 12.068,-0.61 l 5.734,9.517 c -1.647,-0.806 -3.421,-1.513 -5.415,-1.956 -5.692,-1.266 -11.025,-0.481 -14.308,1.687 2.056,3.356 6.553,6.327 12.245,7.593 4.348,0.967 8.469,0.723 11.645,-0.407 l 5.223,8.668 c -1.437,-0.634 -2.964,-1.188 -4.639,-1.561 -5.692,-1.266 -11.025,-0.481 -14.308,1.687 2.056,3.356 6.553,6.327 12.245,7.593 4.147,0.922 8.082,0.733 11.193,-0.265 l 16.588,27.533 7.045,-4.482 -17.907,-26.695 c 2.222,-2.397 4.062,-5.879 4.984,-10.026 1.266,-5.692 0.481,-11.025 -1.687,-14.308 -3.357,2.056 -6.327,6.553 -7.593,12.244 -0.373,1.675 -0.518,3.293 -0.553,4.862 l -5.636,-8.403 c 2.369,-2.398 4.338,-6.027 5.304,-10.375 1.266,-5.692 0.481,-11.025 -1.687,-14.308 -3.357,2.056 -6.327,6.553 -7.593,12.245 -0.444,1.994 -0.554,3.9 -0.523,5.732 l -6.188,-9.226 c 2.526,-2.386 4.653,-6.111 5.668,-10.671 1.266,-5.692 0.481,-11.025 -1.687,-14.308 -3.357,2.056 -6.327,6.553 -7.593,12.245 -0.515,2.317 -0.612,4.531 -0.493,6.615 l -6.418,-9.567 c 2.676,-2.361 4.96,-6.197 6.021,-10.967 z"
       id="path2" />
    <g
       id="g8"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 203.034,256 -8.828,-52.965 h -1.366 c -8.013,0 -13.673,-7.851 -11.138,-15.454 l 0.029,-0.085 c 2.025,-6.076 -1.192,-12.653 -7.231,-14.784 L 53.293,129.934 c -6.87,-2.425 -13.341,4.484 -10.471,11.181 l 13.144,30.669 c 3.782,8.823 10.336,16.173 18.67,20.936 l 33.623,19.213 c 10.044,5.739 21.411,8.758 32.979,8.758 h 0.002 l 3.016,6.031 C 153.229,244.665 171.569,256 191.631,256 Z"
       id="path3" />
    	<path
       fill="#ffe15a"
       d="m 308.965,256 8.828,-52.965 h 1.366 c 8.013,0 13.673,-7.851 11.138,-15.454 l -0.029,-0.085 c -2.025,-6.076 1.192,-12.653 7.231,-14.784 L 458.657,129.95 c 6.889,-2.432 13.377,4.497 10.499,11.212 l -13.123,30.621 c -3.782,8.823 -10.336,16.173 -18.67,20.936 l -33.623,19.213 c -10.044,5.739 -21.411,8.758 -32.979,8.758 h -0.003 l -3.016,6.031 C 358.77,244.665 340.431,256 320.369,256 Z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 291.31,194.207 -21.897,-51.093 c -2.782,-6.492 -9.165,-10.7 -16.227,-10.7 h -6.014 l -8.828,8.828 h -8.828 l -8.828,8.828 h 12.319 c 3.123,0 5.229,3.193 3.999,6.065 l -16.318,38.073 h 70.622 z"
       id="path5" />
    	<path
       fill="#ffe15a"
       d="M 229.517,282.483 211.862,256 195.694,272.168 c -6.783,6.783 -11.894,15.053 -14.927,24.153 l -4.215,12.644 -8.828,8.828 H 156.25 c -3.788,0 -7.252,2.141 -8.946,5.528 l -2.489,4.979 c -1.642,3.284 0.746,7.147 4.417,7.147 h 18.492 l 5.886,-11.77 28.143,-14.072 c 0.849,-0.425 1.623,-0.983 2.294,-1.654 z"
       id="path6" />
    	<path
       fill="#ffe15a"
       d="M 282.482,282.483 300.137,256 l 16.168,16.168 c 6.783,6.783 11.894,15.053 14.927,24.153 l 4.215,12.644 8.828,8.828 h 11.474 c 3.788,0 7.252,2.141 8.946,5.528 l 2.489,4.979 c 1.642,3.284 -0.746,7.147 -4.417,7.147 h -18.492 l -5.885,-11.77 -28.143,-14.072 c -0.849,-0.425 -1.623,-0.983 -2.294,-1.654 z"
       id="path7" />
    	<path
       fill="#ffe15a"
       d="m 229.517,291.31 -21.454,35.756 c -2.894,4.824 -1.842,11.038 2.479,14.638 l 32.579,27.149 c 7.459,6.217 18.295,6.217 25.754,0 l 32.579,-27.149 c 4.322,-3.602 5.374,-9.815 2.479,-14.638 L 282.481,291.31 Z"
       id="path8" />
    </g>
    <path
       fill="#f5f5f5"
       d="m 255.999,97.103 c 0,0 -26.483,8.828 -61.793,0 0,0 0,17.655 0,35.31 0,17.655 8.828,70.621 61.793,88.276 52.965,-17.655 61.793,-70.621 61.793,-88.276 0,-17.655 0,-35.31 0,-35.31 -35.31,8.828 -61.793,0 -61.793,0 z"
       id="path9" />
    <path
       fill="#41479b"
       d="m 255.999,97.103 c 0,0 -26.483,8.828 -61.793,0 0,0 0,17.655 0,35.31 h 123.586 c 0,-17.655 0,-35.31 0,-35.31 -35.31,8.828 -61.793,0 -61.793,0 z"
       id="path10" />
    <g
       id="g16"
       transform="translate(0,-88.276)">
    	<path
       fill="#ff4b55"
       d="M 212.664,277.163 V 220.69 h -9.63 v 39.294 c 2.502,5.748 5.645,11.568 9.63,17.179 z"
       id="path11" />
    	<path
       fill="#ff4b55"
       d="m 231.924,220.69 h -9.63 v 67.758 c 2.916,2.889 6.104,5.639 9.63,8.199 z"
       id="path12" />
    	<path
       fill="#ff4b55"
       d="m 299.335,277.163 c 3.985,-5.612 7.128,-11.432 9.63,-17.18 V 220.69 h -9.63 z"
       id="path13" />
    	<path
       fill="#ff4b55"
       d="m 251.184,220.69 h -9.63 v 81.932 c 3.016,1.626 6.23,3.105 9.63,4.449 z"
       id="path14" />
    	<path
       fill="#ff4b55"
       d="m 289.705,220.69 h -9.63 v 75.958 c 3.526,-2.56 6.713,-5.31 9.63,-8.199 z"
       id="path15" />
    	<path
       fill="#ff4b55"
       d="M 270.445,302.622 V 220.69 h -9.63 v 86.381 c 3.4,-1.344 6.614,-2.823 9.63,-4.449 z"
       id="path16" />
    </g>
    <polygon
       fill="#73af00"
       points="167.448,346.32 174.493,341.839 163.184,324.98 156.916,328.837 "
       id="polygon16"
       transform="translate(0,-88.276)" />
    <g
       id="g19"
       transform="translate(0,-88.276)">
    	<polygon
       fill="#4173cd"
       points="342.955,326.621 342.429,329.292 338.511,337.405 334.29,340.235 332.553,349.037 317.792,366.382 329.316,365.454 327.225,376.054 331.301,373.322 331.695,378.212 338.697,369.985 345.135,379.586 349.542,357.241 355.357,350.409 354.949,345.343 358.641,337.697 353.103,326.621 "
       id="polygon17" />
    	<polygon
       fill="#4173cd"
       points="63.83,226.802 50.443,273.655 37.056,226.802 39.094,220.69 16.394,220.69 22.506,228.839 41.131,294.027 39.094,300.138 61.793,300.138 59.756,294.027 78.381,228.839 84.493,220.69 61.793,220.69 "
       id="polygon18" />
    	<polygon
       fill="#4173cd"
       points="469.122,220.69 453.99,220.69 450.206,220.69 453.99,226.365 453.99,294.464 450.206,300.138 453.99,300.138 469.122,300.138 472.906,300.138 469.122,294.464 469.122,226.365 472.906,220.69 "
       id="polygon19" />
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g26"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g27"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g28"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g29"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g30"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g31"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g32"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g33"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g34"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const VN = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#ffe15a"
       d="m 260.119,67.694 23.609,70.79 74.621,0.578 c 4.172,0.032 5.902,5.357 2.546,7.836 l -60.029,44.329 22.509,71.147 c 1.259,3.978 -3.271,7.27 -6.666,4.843 L 256,223.824 195.29,267.217 c -3.394,2.426 -7.924,-0.865 -6.666,-4.843 l 22.509,-71.147 -60.029,-44.329 c -3.357,-2.478 -1.626,-7.804 2.546,-7.836 l 74.621,-0.578 23.609,-70.79 c 1.321,-3.958 6.919,-3.958 8.239,0 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const VU = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs20" />
    <path
       fill="#464655"
       d="M 503.172,335.448 H 8.828 C 3.953,335.448 0,331.495 0,326.62 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 326.62 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <polygon
       fill="#ffe15a"
       points="0,109.545 0,129.714 228.897,256 0,382.286 0,402.456 249.444,264.828 512,264.828 512,247.172 249.444,247.172 "
       id="polygon1"
       transform="translate(0,-88.276)" />
    <path
       fill="#73af00"
       d="m 3.531,333.5 c 1.491,1.149 3.27,1.948 5.297,1.948 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 194.207 H 255.999 Z"
       id="path2" />
    <path
       fill="#ff4b55"
       d="M 503.172,0 H 8.828 C 6.801,0 5.021,0.8 3.531,1.949 L 255.999,141.241 H 511.998 V 8.828 C 512,3.953 508.047,0 503.172,0 Z"
       id="path3" />
    <g
       id="g5"
       transform="translate(0,-88.276)">
    	<path
       fill="#ffe15a"
       d="m 76.452,206.487 c -25.205,-7.929 -44.234,10.386 -48.583,19.812 -3.683,7.987 -10.525,44.167 23.581,49.936 34.104,5.77 33.72,-26.412 33.72,-26.412 -1.538,5.129 -4.296,19.745 -28.914,19.745 -9.234,0 -22.501,-13.719 -20.001,-28.848 2.353,-14.236 15.07,-21.518 24.682,-21.924 9.102,-0.384 30.322,5.898 30.322,31.734 0,29.039 -29.93,32.31 -29.93,32.31 v 17.535 c 26.053,-2.554 40.797,-16.986 44.699,-40.103 3.888,-23.013 -3.948,-45.722 -29.576,-53.785 z"
       id="path4" />
    	<path
       fill="#ffe15a"
       d="m 48.544,249.549 c -0.595,0.755 -0.911,1.694 -0.927,2.655 l -0.074,4.716 -0.918,1.601 c -0.331,0.578 -0.135,1.316 0.441,1.652 0.583,0.341 1.331,0.141 1.666,-0.446 l 0.941,-1.646 3.766,-1.364 c 1.141,-0.413 2.058,-1.271 2.554,-2.378 0.984,-2.197 3.097,-6.231 6.521,-10.44 3.424,4.209 5.537,8.243 6.521,10.44 0.495,1.107 1.412,1.964 2.553,2.378 l 3.767,1.364 0.941,1.646 c 0.334,0.587 1.084,0.787 1.666,0.446 0.576,-0.337 0.772,-1.074 0.441,-1.652 l -0.918,-1.601 -0.074,-4.716 c -0.015,-0.961 -0.332,-1.9 -0.927,-2.655 -3.155,-4.007 -6.511,-7.158 -9.818,-9.945 2.643,-2.484 5.631,-4.855 9.394,-6.686 0.871,-0.424 1.326,-1.401 1.101,-2.343 -0.307,-1.286 -1.713,-1.961 -2.911,-1.401 -2.522,1.175 -6.859,3.49 -11.737,7.047 -4.879,-3.556 -9.215,-5.87 -11.737,-7.047 -1.198,-0.558 -2.604,0.117 -2.911,1.401 -0.224,0.942 0.231,1.919 1.1,2.343 3.764,1.831 6.752,4.203 9.395,6.686 -3.305,2.787 -6.661,5.939 -9.816,9.945 z"
       id="path5" />
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const WF = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const WS = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs22" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#41479b"
       d="m 8.828,0.001 h 238.345 c 4.875,0 8.828,3.953 8.828,8.828 v 150.069 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,167.725 0,163.772 0,158.897 V 8.828 C 0,3.953 3.953,0.001 8.828,0.001 Z"
       id="path2" />
    <g
       id="g7"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 125.766,197.597 -4.053,12.151 -12.809,0.099 c -1.658,0.013 -2.346,2.13 -1.012,3.114 l 10.304,7.609 -3.863,12.212 c -0.5,1.581 1.3,2.889 2.649,1.924 l 10.421,-7.448 10.421,7.448 c 1.35,0.964 3.149,-0.343 2.649,-1.924 l -3.863,-12.212 10.304,-7.609 c 1.334,-0.985 0.647,-3.102 -1.012,-3.114 l -12.809,-0.099 -4.053,-12.151 c -0.525,-1.574 -2.749,-1.574 -3.274,0 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 126.079,102.853 -3.278,9.83 -10.361,0.081 c -1.342,0.01 -1.898,1.722 -0.819,2.519 l 8.335,6.155 -3.125,9.879 c -0.405,1.279 1.052,2.337 2.143,1.557 l 8.429,-6.025 8.429,6.025 c 1.091,0.78 2.548,-0.278 2.143,-1.557 l -3.125,-9.879 8.335,-6.155 c 1.079,-0.797 0.523,-2.509 -0.819,-2.519 l -10.361,-0.081 -3.278,-9.83 c -0.424,-1.273 -2.223,-1.273 -2.648,0 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 178.493,132.095 -3.278,9.83 -10.361,0.081 c -1.342,0.01 -1.898,1.722 -0.819,2.519 l 8.335,6.155 -3.125,9.879 c -0.405,1.279 1.052,2.337 2.143,1.557 l 8.429,-6.025 8.429,6.025 c 1.091,0.78 2.548,-0.278 2.143,-1.557 l -3.125,-9.879 8.335,-6.155 c 1.079,-0.797 0.523,-2.509 -0.819,-2.519 l -10.361,-0.081 -3.278,-9.83 c -0.424,-1.274 -2.223,-1.274 -2.648,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 74.769,143.681 -3.278,9.83 -10.361,0.081 c -1.342,0.01 -1.898,1.722 -0.819,2.519 l 8.335,6.155 -3.125,9.879 c -0.405,1.279 1.052,2.337 2.143,1.557 l 8.429,-6.025 8.429,6.025 c 1.091,0.78 2.548,-0.278 2.143,-1.557 l -3.125,-9.879 8.335,-6.155 c 1.079,-0.797 0.523,-2.509 -0.819,-2.519 l -10.361,-0.081 -3.278,-9.83 c -0.424,-1.273 -2.224,-1.273 -2.648,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 155.901,175.769 -1.841,5.518 -5.816,0.045 c -0.753,0.006 -1.065,0.967 -0.459,1.415 l 4.679,3.455 -1.754,5.546 c -0.227,0.718 0.59,1.312 1.203,0.874 l 4.732,-3.382 4.732,3.382 c 0.612,0.438 1.43,-0.156 1.203,-0.874 l -1.754,-5.546 4.679,-3.455 c 0.606,-0.447 0.294,-1.408 -0.459,-1.415 l -5.816,-0.045 -1.841,-5.518 c -0.239,-0.715 -1.25,-0.715 -1.488,0 z"
       id="path7" />
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const XK = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs23" />
    <path
       fill="#41479b"
       d="M 503.172,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c -10e-4,4.876 -3.954,8.828 -8.829,8.828 z"
       id="path1" />
    <path
       fill="#ff9b55"
       d="m 267.31,114.208 c -5.103,-0.966 -11.31,-7.448 -9.103,-11.034 2.207,-3.586 -1.931,-11.586 -6.897,-8.828 -4.966,2.759 -8.276,6.069 -12.966,7.172 -4.69,1.103 -8.552,4.69 -4.966,8 3.586,3.31 9.103,9.931 3.862,16.828 -5.241,6.897 -3.586,2.207 -9.931,5.241 -6.345,3.034 -10.759,9.103 -8.828,12.69 1.931,3.586 3.586,4.966 -1.931,7.448 -5.517,2.482 -8,0.828 -12.414,1.931 -4.414,1.103 -15.172,6.621 -18.483,11.31 -3.31,4.69 -10.483,0.276 -13.517,-0.276 -3.034,-0.552 -9.103,1.655 -10.483,5.241 -1.379,3.586 1.103,6.897 6.345,8.552 5.241,1.655 7.448,1.931 4.966,6.345 -2.482,4.414 -0.828,12.966 3.31,15.448 4.138,2.483 12.138,10.207 12.138,15.448 0,5.241 -1.103,12.966 6.621,14.069 7.724,1.103 19.586,4.414 23.724,11.586 4.138,7.172 5.241,11.31 6.069,15.724 0.828,4.414 1.655,8 4.138,12.966 2.483,4.966 4.138,13.517 1.655,15.448 -2.483,1.931 -4.414,3.31 -2.483,7.034 1.931,3.724 2.345,5.103 5.931,3.034 3.586,-2.069 3.586,0.138 5.517,-0.276 1.931,-0.414 10.759,-3.586 9.103,-7.862 -1.655,-4.276 -5.241,-14.069 -0.138,-19.172 5.103,-5.103 12,-5.931 16.414,-9.379 4.414,-3.448 11.724,-4 17.379,-9.517 5.655,-5.517 11.724,-2.207 12.69,1.655 0.966,3.862 2.483,11.31 6.897,11.172 4.414,-0.138 5.379,-0.138 6.207,-5.517 0.828,-5.379 7.724,-17.379 10.483,-15.862 2.759,1.517 5.241,0.276 5.379,-2.069 0.138,-2.345 5.379,-4.414 7.586,-1.103 2.207,3.31 7.034,5.931 6.897,1.793 -0.138,-4.138 -5.793,-3.586 -5.931,-8.138 -0.138,-4.552 4.552,-7.448 8.69,-9.379 4.138,-1.931 1.655,-6.897 2.897,-9.655 1.241,-2.759 8,-6.207 8.276,-8.966 0.276,-2.759 -1.655,-3.862 1.241,-4.552 2.897,-0.69 6.483,-1.931 4.414,-5.103 -2.069,-3.172 -1.379,-5.517 0.828,-7.034 2.207,-1.517 3.242,-8.718 0.023,-9.654 -3.22,-0.935 -9.035,1.766 -10.489,3.531 -1.454,1.766 -7.373,-5.816 -10.178,-7.686 -2.804,-1.869 -20.875,-0.727 -20.459,-3.842 0.416,-3.115 8,-14.487 4.69,-16.28 -3.31,-1.793 -8.552,-4.414 -12.828,-5.793 -4.276,-1.379 -3.31,3.31 -5.655,-0.414 -2.345,-3.724 -3.172,-16.966 -5.793,-16.966 -2.621,0 -4.552,5.517 -5.655,3.448 -1.103,-2.069 0.414,-16.414 -5.655,-16.69 -6.069,-0.276 -6.207,3.31 -9.655,0.69 -3.449,-2.619 -2.955,-1.438 -9.932,-2.757 z"
       id="path2" />
    <g
       id="g8"
       transform="translate(0,-88.276)">
    	<path
       fill="#f5f5f5"
       d="m 229.837,124.014 -4.583,13.74 -14.484,0.113 c -0.794,0.007 -1.123,1.02 -0.484,1.491 l 11.651,8.604 -4.369,13.81 c -0.239,0.757 0.622,1.384 1.269,0.921 l 11.783,-8.423 11.784,8.423 c 0.646,0.461 1.508,-0.164 1.269,-0.921 l -4.369,-13.81 11.651,-8.604 c 0.639,-0.471 0.31,-1.485 -0.484,-1.491 l -14.484,-0.113 -4.583,-13.74 c -0.25,-0.752 -1.316,-0.752 -1.567,0 z"
       id="path3" />
    	<path
       fill="#f5f5f5"
       d="m 280.872,124.014 -4.583,13.74 -14.484,0.113 c -0.794,0.007 -1.123,1.02 -0.484,1.491 l 11.651,8.604 -4.369,13.81 c -0.239,0.757 0.622,1.384 1.269,0.921 l 11.784,-8.423 11.784,8.423 c 0.646,0.461 1.508,-0.164 1.269,-0.921 l -4.369,-13.81 11.651,-8.604 c 0.639,-0.471 0.309,-1.485 -0.484,-1.491 l -14.484,-0.113 -4.583,-13.74 c -0.252,-0.752 -1.318,-0.752 -1.568,0 z"
       id="path4" />
    	<path
       fill="#f5f5f5"
       d="m 179.492,132.428 -4.583,13.74 -14.484,0.113 c -0.794,0.007 -1.123,1.02 -0.484,1.491 l 11.651,8.604 -4.369,13.81 c -0.239,0.757 0.622,1.384 1.269,0.921 l 11.784,-8.423 11.784,8.423 c 0.646,0.461 1.508,-0.164 1.269,-0.921 l -4.369,-13.81 11.651,-8.604 c 0.639,-0.471 0.31,-1.485 -0.484,-1.491 l -14.484,-0.113 -4.583,-13.74 c -0.251,-0.753 -1.317,-0.753 -1.568,0 z"
       id="path5" />
    	<path
       fill="#f5f5f5"
       d="m 131.859,149.741 -4.583,13.74 -14.484,0.113 c -0.794,0.007 -1.123,1.02 -0.484,1.491 l 11.651,8.604 -4.369,13.81 c -0.239,0.757 0.622,1.384 1.269,0.921 l 11.784,-8.423 11.784,8.423 c 0.646,0.461 1.508,-0.164 1.269,-0.921 l -4.369,-13.81 11.651,-8.604 c 0.639,-0.471 0.31,-1.485 -0.484,-1.491 l -14.484,-0.113 -4.583,-13.74 c -0.251,-0.752 -1.317,-0.752 -1.568,0 z"
       id="path6" />
    	<path
       fill="#f5f5f5"
       d="m 332.647,132.428 4.583,13.74 14.484,0.113 c 0.794,0.007 1.123,1.02 0.484,1.491 l -11.651,8.604 4.369,13.81 c 0.239,0.757 -0.622,1.384 -1.269,0.921 l -11.784,-8.423 -11.784,8.423 c -0.646,0.461 -1.508,-0.164 -1.269,-0.921 l 4.369,-13.81 -11.651,-8.604 c -0.639,-0.471 -0.31,-1.485 0.484,-1.491 l 14.483,-0.113 4.583,-13.74 c 0.252,-0.753 1.318,-0.753 1.569,0 z"
       id="path7" />
    	<path
       fill="#f5f5f5"
       d="m 380.28,149.741 4.583,13.74 14.484,0.113 c 0.794,0.007 1.123,1.02 0.484,1.491 l -11.651,8.604 4.369,13.81 c 0.239,0.757 -0.622,1.384 -1.269,0.921 l -11.784,-8.423 -11.784,8.423 c -0.646,0.461 -1.508,-0.164 -1.269,-0.921 l 4.369,-13.81 -11.651,-8.604 c -0.639,-0.471 -0.309,-1.485 0.484,-1.491 l 14.484,-0.113 4.583,-13.74 c 0.251,-0.752 1.317,-0.752 1.568,0 z"
       id="path8" />
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const YE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44801" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#464655"
       d="M 0,223.632 H 512 V 326.62 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.448 0,331.495 0,326.62 Z"
       id="path1" />
    <path
       fill="#ff4b55"
       d="m 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 V 111.816 H 0 V 8.827 C 0,3.952 3.953,0 8.828,0 Z"
       id="path2" />
    <rect
       y="111.814"
       fill="#f5f5f5"
       width="512"
       height="111.81"
       id="rect2"
       x="0" />
    <g
       id="g2"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

export const YT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45502" {...props}>
    <defs
       id="defs16" />
    <path
       fill="#41479b"
       d="M 170.667,335.449 H 8.828 C 3.953,335.449 0,331.496 0,326.621 V 8.828 C 0,3.953 3.953,0 8.828,0 h 161.839 z"
       id="path1" />
    <rect
       x="170.67"
       y="0.0050004274"
       fill="#f5f5f5"
       width="170.67"
       height="335.45001"
       id="rect1" />
    <path
       fill="#ff4b55"
       d="M 503.172,335.449 H 341.333 V 0.001 h 161.839 c 4.875,0 8.828,3.953 8.828,8.828 v 317.793 c 0,4.876 -3.953,8.827 -8.828,8.827 z"
       id="path2" />
    <g
       id="g2"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g3"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g4"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.272)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.272)">
    </g>
  </svg>
);

export const ZA = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 335.45001" {...props}>
    <defs
       id="defs19" />
    <polygon
       fill="#464655"
       points="141.241,256 0,150.069 0,361.931 "
       id="polygon1"
       transform="translate(0,-88.275)" />
    <path
       fill="#ff4b55"
       d="M 70.621,0.001 229.518,123.587 H 512 V 8.828 C 512,3.953 508.047,0 503.172,0 H 70.621 Z"
       id="path1" />
    <path
       fill="#41479b"
       d="M 70.621,335.449 229.518,211.863 H 512 v 114.759 c 0,4.875 -3.953,8.828 -8.828,8.828 H 70.621 Z"
       id="path2" />
    <path
       fill="#73af00"
       d="M 56.889,0.001 H 8.828 C 3.953,0.001 0,3.953 0,8.828 v 36.21 L 154.974,167.725 0,290.415 v 36.206 c 0,4.875 3.953,8.828 8.828,8.828 H 56.884 L 224.147,203.035 H 512 v -70.62 H 224.148 Z"
       id="path3" />
    <polygon
       fill="#f5f5f5"
       points="224.148,220.69 512,220.69 512,203.034 230.291,203.034 85.333,88.276 56.889,88.276 "
       id="polygon3"
       transform="translate(0,-88.275)" />
    <polygon
       fill="#ffe15a"
       points="126.53,256 0,356.173 0,378.69 154.974,256 0,133.313 0,155.831 "
       id="polygon4"
       transform="translate(0,-88.275)" />
    <polygon
       fill="#f5f5f5"
       points="85.329,423.724 230.289,308.966 512,308.966 512,291.31 224.147,291.31 56.884,423.724 "
       id="polygon5"
       transform="translate(0,-88.275)" />
    <g
       id="g5"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.275)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.275)">
    </g>
  </svg>
);

export const ZM = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.003 335.448" {...props}>
    <defs
       id="defs18" />
    <path
       fill="#73af00"
       d="M 503.172,0 H 8.828 C 3.953,0 0,3.952 0,8.827 V 326.62 c 0,4.875 3.953,8.828 8.828,8.828 h 494.345 c 4.875,0 8.828,-3.953 8.828,-8.828 V 8.827 C 512,3.952 508.047,0 503.172,0 Z"
       id="path1" />
    <rect
       x="326.62"
       y="114.75401"
       fill="#ff4b55"
       width="61.792999"
       height="220.69"
       id="rect1" />
    <rect
       x="388.41"
       y="114.75401"
       fill="#464655"
       width="61.792999"
       height="220.69"
       id="rect2" />
    <g
       id="g3"
       transform="translate(0,-88.277)">
    	<rect
       x="450.20999"
       y="203.03101"
       fill="#ff9b55"
       width="61.792999"
       height="220.69"
       id="rect3" />
    	<path
       fill="#ff9b55"
       d="m 496.952,128.859 c 0.192,-0.387 0.1,-0.855 -0.224,-1.141 -0.326,-0.287 -0.802,-0.317 -1.161,-0.079 -1.785,1.185 -3.585,2.262 -5.37,3.239 5.746,-4.749 6.551,-8.873 6.603,-9.173 0.065,-0.377 -0.103,-0.757 -0.424,-0.964 -0.323,-0.209 -0.737,-0.203 -1.054,0.012 -6.207,4.21 -12.419,7.215 -17.775,9.33 7.193,-4.545 10.044,-9.182 10.218,-9.475 0.225,-0.376 0.164,-0.857 -0.146,-1.166 -0.31,-0.31 -0.791,-0.367 -1.167,-0.142 -5.743,3.462 -12.545,6.191 -19.046,8.294 0.863,-1.332 1.478,-2.828 0.926,-3.669 -0.513,-0.779 -1.449,-0.779 -2.786,0.003 -2.706,1.586 -23.211,6.813 -31.157,8.76 -8.098,-1.463 -14.808,0.612 -16.899,1.379 -0.557,-0.663 -0.811,-1.305 -0.918,-1.807 -0.174,-0.817 -0.047,-1.647 0.339,-2.222 0.63,-0.937 1.932,-1.027 3.081,-1.106 0.5,-0.034 0.946,-0.065 1.336,-0.163 0.25,0.074 0.556,0.218 0.551,0.33 -0.023,0.436 0.252,0.83 0.668,0.961 0.417,0.13 0.866,-0.036 1.097,-0.407 0.058,-0.094 1.409,-2.305 0.363,-4.188 -0.761,-1.369 -2.508,-2.089 -5.194,-2.141 -1.102,-0.769 -5.267,-3.273 -10.399,-1.338 -5.198,1.961 -7.505,7.299 -8.268,9.555 -4.045,-0.562 -22.617,-3.396 -32.714,-9.323 -0.491,-0.223 -2.166,-0.881 -3.102,0.011 -0.575,0.545 -0.642,1.391 -0.202,2.516 0.234,0.596 0.593,1.178 1.069,1.75 -5.405,-2.481 -12.691,-5.946 -18.198,-9.027 -0.862,-0.399 -2.425,-0.941 -3.232,-0.096 -0.505,0.532 -0.498,1.304 0.023,2.298 0.11,0.21 0.219,0.444 0.337,0.701 0.536,1.155 1.267,2.73 3.053,4.548 -1.335,-0.729 -2.538,-1.479 -3.502,-2.229 -4.834,-3.761 -5.489,-4.129 -6.355,-3.545 -0.746,0.502 -0.505,1.351 -0.25,2.25 l 0.067,0.237 c 0.21,0.747 0.553,1.951 1.492,3.403 -0.749,-0.51 -1.393,-0.614 -1.9,-0.26 -0.302,0.209 -0.757,0.729 -0.407,1.875 0.841,2.741 6.65,9.958 17.702,12.083 -1.111,0.162 -2.28,0.282 -3.407,0.305 -0.428,0.009 -0.799,0.302 -0.906,0.717 -0.106,0.415 0.077,0.852 0.449,1.065 0.202,0.116 4.108,2.302 11.27,2.118 -1.071,0.27 -2.286,0.478 -3.63,0.558 -0.418,0.025 -0.771,0.319 -0.871,0.725 -0.1,0.406 0.076,0.83 0.434,1.046 0.213,0.129 4.369,2.573 10.804,2.212 l -0.561,0.345 c -0.323,0.199 -0.498,0.568 -0.446,0.943 0.052,0.375 0.32,0.685 0.684,0.789 0.201,0.057 3.828,1.067 8.346,0.589 l -0.794,0.565 c -0.319,0.227 -0.468,0.626 -0.374,1.005 0.094,0.38 0.408,0.665 0.796,0.719 0.082,0.012 0.666,0.087 1.602,0.087 0.617,0 1.387,-0.034 2.265,-0.141 -0.02,0.228 0.007,0.455 0.082,0.681 0.452,1.361 2.456,1.69 3.123,1.699 0.041,0.001 0.081,0.001 0.121,0.001 0.807,0 1.66,-0.114 2.529,-0.287 1.393,1.301 3.936,1.182 6.403,0.608 -0.146,0.222 -0.257,0.444 -0.327,0.663 -0.142,0.451 -0.034,0.911 0.289,1.233 0.314,0.311 1.071,1.064 7.967,-0.876 -0.029,0.022 -0.057,0.044 -0.086,0.066 -0.917,0.71 -0.859,1.443 -0.742,1.817 0.423,1.356 3.465,2.225 8.985,2.595 0.122,3.07 -0.73,6.404 -0.74,6.441 -0.096,0.367 0.035,0.757 0.334,0.992 0.298,0.233 0.707,0.269 1.043,0.09 0.319,-0.172 0.637,-0.394 0.937,-0.633 l -0.026,1.015 c -0.01,0.369 0.193,0.71 0.521,0.876 0.138,0.07 0.286,0.104 0.434,0.104 0.038,0 0.073,-0.013 0.11,-0.018 -0.103,0.865 -0.454,1.898 -1.562,2.141 -0.503,0.11 -1.037,0.164 -1.553,0.217 -2.35,0.241 -5.013,0.514 -5.434,5.899 -0.032,0.404 0.195,0.785 0.566,0.949 0.37,0.162 0.803,0.076 1.082,-0.218 l 1.023,-1.088 c 0.602,0.148 1.561,0.3 2.588,0.134 -0.258,1.246 -0.182,2.78 1.065,4.081 0.27,0.281 0.684,0.37 1.046,0.225 0.362,-0.146 0.599,-0.497 0.599,-0.886 v -0.69 c 0.593,-0.138 1.38,-0.426 2.124,-1.018 0.436,0.941 1.268,2.045 2.852,2.977 0.15,0.088 0.318,0.131 0.484,0.131 0.219,0 0.436,-0.075 0.61,-0.221 0.31,-0.257 0.425,-0.682 0.287,-1.062 l -0.499,-1.372 c 0.348,-0.343 0.8,-0.834 1.195,-1.358 0.195,0.284 0.523,0.447 0.873,0.413 0.363,-0.035 0.675,-0.274 0.803,-0.616 l 0.351,-0.935 c 0.207,-0.057 0.405,-0.126 0.594,-0.203 0.235,2.069 1.826,3.791 1.922,3.893 0.183,0.194 0.436,0.301 0.696,0.301 0.077,0 0.156,-0.009 0.233,-0.029 0.337,-0.085 0.6,-0.344 0.691,-0.679 l 0.532,-1.986 c 1.41,-0.715 1.548,-2.008 1.634,-2.814 0.017,-0.158 0.041,-0.377 0.045,-0.488 0.551,0.271 1.719,1.583 2.6,2.944 0.175,0.27 0.476,0.436 0.798,0.437 0.328,-0.023 0.623,-0.159 0.802,-0.428 0,0 0.746,-1.13 1.109,-1.789 1.54,-2.795 -0.793,-4.469 -1.914,-5.273 -0.275,-0.198 -0.652,-0.468 -0.713,-0.543 -0.211,-0.512 -0.137,-0.989 0.002,-1.359 0.935,0.644 1.997,1.187 3.175,1.464 0.073,0.018 0.146,0.025 0.218,0.025 0.307,0 0.601,-0.149 0.782,-0.408 0.224,-0.32 0.231,-0.745 0.017,-1.071 -0.021,-0.033 -1.778,-2.735 -2.91,-6.058 1.828,1.073 4.303,2.368 5.587,2.368 0.881,0 1.217,-0.548 1.322,-0.783 0.061,-0.138 0.171,-0.388 0.084,-0.856 1.699,0.918 3.616,1.63 5.073,1.254 0.43,-0.11 1.439,-0.371 1.592,-1.276 0.077,-0.458 -0.077,-0.829 -0.415,-1.194 1.578,0.383 3.279,0.574 4.948,0.353 1.391,-0.183 1.802,-0.858 1.9,-1.393 0.063,-0.342 0.175,-0.999 -1.066,-2.241 2.397,-0.131 4.537,-0.655 4.713,-2.101 0.015,-0.13 -0.009,-0.248 -0.02,-0.37 7.704,-0.84 13.566,-5.658 13.825,-5.875 0.075,-0.063 0.126,-0.141 0.177,-0.22 4.664,-0.583 9.962,-1.636 14.251,-3.564 8.094,-3.639 12.193,-8.552 11.459,-10.335 -0.213,-0.519 -0.825,-0.894 -1.58,-0.612 -0.212,0.079 -0.641,0.253 -1.203,0.481 4.793,-3.893 6.668,-7.503 6.847,-7.863 z"
       id="path3" />
    </g>
    <path
       fill="#464655"
       d="m 496.952,40.582 c 0.192,-0.387 0.1,-0.855 -0.224,-1.141 -0.326,-0.287 -0.802,-0.317 -1.161,-0.079 -1.785,1.186 -3.586,2.262 -5.37,3.239 5.746,-4.749 6.552,-8.873 6.603,-9.173 0.065,-0.377 -0.103,-0.758 -0.424,-0.964 -0.323,-0.209 -0.737,-0.204 -1.054,0.012 -6.207,4.21 -12.419,7.215 -17.775,9.33 7.194,-4.545 10.044,-9.181 10.218,-9.474 0.225,-0.376 0.164,-0.857 -0.146,-1.167 -0.31,-0.31 -0.791,-0.367 -1.167,-0.141 -5.743,3.462 -12.545,6.191 -19.046,8.295 0.863,-1.332 1.478,-2.828 0.926,-3.669 -0.513,-0.78 -1.449,-0.78 -2.786,0.003 -2.706,1.586 -23.211,6.813 -31.156,8.76 -8.098,-1.463 -14.808,0.612 -16.899,1.379 -0.556,-0.663 -0.811,-1.305 -0.919,-1.806 -0.174,-0.817 -0.047,-1.647 0.339,-2.222 0.63,-0.937 1.932,-1.026 3.081,-1.106 0.499,-0.034 0.945,-0.065 1.336,-0.162 0.25,0.073 0.556,0.218 0.552,0.329 -0.023,0.436 0.252,0.83 0.668,0.961 0.417,0.13 0.866,-0.036 1.098,-0.407 0.059,-0.093 1.408,-2.305 0.363,-4.188 -0.761,-1.369 -2.507,-2.089 -5.195,-2.141 -1.103,-0.769 -5.267,-3.273 -10.399,-1.338 -5.197,1.96 -7.505,7.299 -8.268,9.555 -4.045,-0.562 -22.617,-3.396 -32.714,-9.323 -0.49,-0.223 -2.165,-0.879 -3.102,0.011 -0.575,0.545 -0.642,1.391 -0.202,2.516 0.234,0.596 0.593,1.178 1.069,1.75 -5.405,-2.481 -12.69,-5.946 -18.199,-9.027 -0.861,-0.399 -2.425,-0.942 -3.231,-0.096 -0.505,0.532 -0.499,1.305 0.023,2.298 0.11,0.21 0.218,0.444 0.337,0.701 0.536,1.155 1.266,2.73 3.053,4.55 -1.334,-0.729 -2.538,-1.479 -3.502,-2.229 -4.834,-3.761 -5.49,-4.129 -6.355,-3.545 -0.746,0.503 -0.505,1.351 -0.25,2.25 l 0.067,0.237 c 0.21,0.747 0.552,1.951 1.492,3.403 -0.749,-0.51 -1.393,-0.614 -1.9,-0.26 -0.302,0.207 -0.757,0.729 -0.406,1.875 0.84,2.741 6.65,9.956 17.702,12.083 -1.111,0.162 -2.279,0.282 -3.407,0.305 -0.429,0.009 -0.8,0.302 -0.906,0.717 -0.106,0.415 0.077,0.851 0.449,1.065 0.202,0.116 4.108,2.302 11.27,2.116 -1.071,0.27 -2.286,0.479 -3.631,0.558 -0.417,0.024 -0.771,0.319 -0.871,0.725 -0.1,0.406 0.076,0.83 0.435,1.046 0.213,0.129 4.369,2.574 10.804,2.212 l -0.561,0.345 c -0.322,0.199 -0.498,0.568 -0.446,0.943 0.052,0.375 0.321,0.685 0.684,0.789 0.201,0.057 3.828,1.066 8.346,0.589 l -0.794,0.565 c -0.319,0.227 -0.468,0.626 -0.374,1.006 0.093,0.38 0.408,0.665 0.796,0.718 0.082,0.012 0.667,0.088 1.603,0.088 0.617,0 1.387,-0.034 2.265,-0.141 -0.02,0.228 0.007,0.456 0.082,0.681 0.452,1.361 2.456,1.69 3.123,1.699 0.041,0 0.081,0 0.121,0 0.807,0 1.658,-0.114 2.529,-0.287 1.393,1.301 3.936,1.182 6.403,0.608 -0.146,0.222 -0.257,0.444 -0.328,0.664 -0.142,0.451 -0.034,0.911 0.289,1.233 0.315,0.311 1.071,1.063 7.968,-0.876 -0.029,0.023 -0.057,0.044 -0.086,0.067 -0.917,0.71 -0.859,1.443 -0.742,1.817 0.423,1.356 3.465,2.225 8.985,2.595 0.122,3.07 -0.732,6.404 -0.74,6.441 -0.096,0.367 0.035,0.757 0.334,0.992 0.298,0.233 0.707,0.269 1.043,0.09 0.32,-0.172 0.637,-0.394 0.937,-0.633 l -0.026,1.014 c -0.01,0.369 0.193,0.71 0.522,0.876 0.138,0.07 0.285,0.104 0.434,0.104 0.038,0 0.073,-0.014 0.11,-0.019 -0.103,0.865 -0.454,1.898 -1.564,2.141 -0.503,0.11 -1.036,0.164 -1.553,0.217 -2.35,0.241 -5.013,0.514 -5.434,5.9 -0.031,0.404 0.195,0.783 0.566,0.948 0.369,0.161 0.803,0.076 1.081,-0.218 l 1.023,-1.088 c 0.601,0.148 1.562,0.299 2.588,0.134 -0.258,1.246 -0.182,2.78 1.065,4.081 0.27,0.281 0.684,0.37 1.046,0.225 0.362,-0.146 0.598,-0.497 0.598,-0.886 v -0.69 c 0.593,-0.138 1.38,-0.426 2.124,-1.018 0.436,0.941 1.268,2.046 2.852,2.977 0.15,0.088 0.318,0.132 0.484,0.132 0.218,0 0.436,-0.075 0.611,-0.221 0.31,-0.257 0.425,-0.682 0.287,-1.06 l -0.499,-1.373 c 0.348,-0.343 0.801,-0.833 1.195,-1.357 0.195,0.284 0.523,0.447 0.873,0.413 0.364,-0.035 0.675,-0.274 0.804,-0.616 l 0.351,-0.935 c 0.207,-0.057 0.405,-0.126 0.594,-0.203 0.235,2.069 1.826,3.791 1.922,3.893 0.183,0.195 0.436,0.301 0.695,0.301 0.078,0 0.156,-0.009 0.233,-0.029 0.337,-0.085 0.6,-0.344 0.69,-0.679 l 0.532,-1.986 c 1.41,-0.714 1.548,-2.008 1.634,-2.814 0.017,-0.158 0.041,-0.377 0.045,-0.488 0.551,0.271 1.719,1.583 2.6,2.944 0.175,0.27 0.476,0.436 0.798,0.437 0.328,-0.023 0.623,-0.16 0.802,-0.429 0,0 0.746,-1.129 1.109,-1.789 1.54,-2.795 -0.793,-4.469 -1.914,-5.273 -0.275,-0.198 -0.652,-0.468 -0.713,-0.543 -0.21,-0.512 -0.137,-0.989 0.001,-1.359 0.935,0.644 1.998,1.187 3.175,1.464 0.073,0.018 0.146,0.025 0.218,0.025 0.307,0 0.601,-0.149 0.782,-0.408 0.225,-0.32 0.231,-0.745 0.017,-1.071 -0.021,-0.033 -1.778,-2.735 -2.91,-6.058 1.83,1.071 4.303,2.368 5.587,2.368 0.881,0 1.217,-0.548 1.321,-0.783 0.062,-0.138 0.171,-0.388 0.084,-0.856 1.7,0.919 3.616,1.63 5.073,1.254 0.43,-0.111 1.439,-0.372 1.592,-1.276 0.077,-0.459 -0.077,-0.828 -0.415,-1.194 1.578,0.383 3.279,0.574 4.947,0.353 1.391,-0.184 1.802,-0.858 1.901,-1.393 0.063,-0.342 0.175,-0.999 -1.066,-2.241 2.397,-0.131 4.537,-0.655 4.713,-2.101 0.017,-0.13 -0.008,-0.248 -0.02,-0.37 7.704,-0.84 13.566,-5.658 13.825,-5.875 0.075,-0.063 0.126,-0.141 0.177,-0.22 4.664,-0.582 9.962,-1.635 14.251,-3.563 8.094,-3.639 12.193,-8.552 11.459,-10.335 -0.213,-0.519 -0.825,-0.895 -1.58,-0.612 -0.211,0.079 -0.641,0.253 -1.202,0.482 4.794,-3.9 6.669,-7.51 6.848,-7.87 z m -14.069,-5.423 c -3.518,3.442 -10.146,8.392 -21.077,11.264 -0.095,0.025 -0.177,0.074 -0.256,0.124 -2.298,-0.179 -5.204,-0.598 -7.752,-1.55 8.078,-1.832 19.427,-4.988 29.085,-9.838 z m -48.64,11.168 c 0.135,0.024 0.271,0.021 0.403,-0.011 1.137,-0.278 27.449,-6.731 31.673,-8.91 -0.491,0.968 -1.434,2.324 -2.206,2.89 -0.022,0.015 -0.032,0.04 -0.052,0.057 -11.33,3.363 -20.945,4.781 -21.103,4.803 -0.522,0.075 -0.885,0.559 -0.81,1.081 0.075,0.522 0.557,0.884 1.081,0.81 0.087,-0.013 3.007,-0.442 7.49,-1.378 2.321,1.331 5.174,2.065 7.772,2.462 -3.881,0.328 -7.473,0.14 -7.532,0.137 -0.452,-0.017 -0.893,0.298 -0.988,0.761 -0.095,0.463 0.162,0.927 0.607,1.089 l 3.613,1.324 c -5.08,1.081 -9.978,0.066 -10.036,0.054 -0.392,-0.087 -0.791,0.084 -1.005,0.419 -0.214,0.335 -0.199,0.769 0.04,1.087 0.69,0.92 2.636,1.887 4.334,2.6 -6.984,1.322 -11.79,-2.959 -12.017,-3.165 -0.388,-0.354 -0.99,-0.329 -1.345,0.057 -0.356,0.386 -0.335,0.986 0.047,1.345 5.517,5.163 15.799,7.362 20.414,8.119 -0.683,0.404 -1.507,0.785 -2.37,0.939 -3.542,0.629 -11.72,-3.261 -17.474,-6.408 l -4.608,-2.659 c -0.451,-0.262 -1.031,-0.11 -1.298,0.338 -0.268,0.449 -0.125,1.03 0.32,1.303 0.221,0.136 2.028,1.242 4.596,2.653 l 11.215,6.473 c -3.441,0.425 -7.071,-0.345 -7.116,-0.355 -0.028,-0.006 -0.054,0.002 -0.082,-0.001 -2.625,-1.846 -6.861,-4.954 -13.221,-10.228 -1.024,-3.654 -2.942,-5.259 -5.343,-6.784 2.715,-0.833 8.439,-2.133 15.001,-0.902 z m 6.932,20.254 c -0.006,0.002 -0.01,0.007 -0.017,0.009 0,0 -0.009,-0.007 -0.013,-0.01 0.011,0 0.021,0.001 0.03,0.001 z m -62.221,-4.332 2.185,-1.555 c 0.388,-0.276 0.514,-0.797 0.294,-1.219 -0.221,-0.424 -0.721,-0.617 -1.169,-0.459 -3.609,1.289 -7.264,1.158 -9.551,0.864 l 2.53,-1.557 c 0.403,-0.248 0.564,-0.754 0.377,-1.19 -0.185,-0.435 -0.661,-0.668 -1.121,-0.548 -4.605,1.209 -8.44,0.707 -10.951,0.014 3.991,-0.932 6.308,-2.698 6.431,-2.792 0.349,-0.27 0.467,-0.745 0.286,-1.148 -0.182,-0.402 -0.614,-0.623 -1.048,-0.546 -5.261,0.991 -9.323,0.664 -12.051,0.1 2.818,-0.473 5.058,-1.146 5.197,-1.188 0.017,-0.004 0.028,-0.018 0.043,-0.023 0.065,-0.023 0.119,-0.06 0.177,-0.095 0.049,-0.031 0.098,-0.056 0.14,-0.094 0.046,-0.042 0.078,-0.092 0.116,-0.142 0.036,-0.049 0.074,-0.093 0.1,-0.147 0.024,-0.052 0.035,-0.109 0.051,-0.164 0.018,-0.065 0.036,-0.126 0.041,-0.194 0,-0.015 0.009,-0.029 0.009,-0.045 0,-0.05 -0.02,-0.094 -0.028,-0.142 -0.007,-0.047 10e-4,-0.095 -0.013,-0.143 -0.004,-0.015 -0.017,-0.025 -0.022,-0.04 -0.023,-0.064 -0.059,-0.118 -0.094,-0.175 -0.031,-0.05 -0.056,-0.102 -0.095,-0.145 -0.041,-0.045 -0.09,-0.077 -0.139,-0.114 -0.05,-0.038 -0.095,-0.077 -0.151,-0.104 -0.051,-0.024 -0.108,-0.035 -0.163,-0.05 -0.065,-0.019 -0.127,-0.038 -0.195,-0.042 -0.017,-10e-4 -0.029,-0.01 -0.045,-0.01 -12.271,-0.115 -19.043,-6.57 -21.212,-9.864 3.823,2.664 8.846,4.925 12.504,6.223 h 0.003 c 4.865,1.879 10.929,3.076 11.186,3.126 0.516,0.1 1.02,-0.235 1.121,-0.754 0.102,-0.518 -0.236,-1.02 -0.754,-1.121 -0.062,-0.012 -6.177,-1.218 -10.891,-3.043 -10.166,-3.934 -12.226,-8.195 -12.913,-10.347 1.099,0.781 2.575,1.93 3.366,2.545 5.951,4.628 19.797,9.005 20.384,9.19 0.502,0.159 1.031,-0.117 1.194,-0.615 0.162,-0.498 -0.105,-1.033 -0.6,-1.202 -14.317,-4.877 -16.467,-9.514 -17.622,-12.004 -0.1,-0.216 -0.194,-0.418 -0.287,-0.606 0.193,0.06 0.394,0.134 0.557,0.207 7.937,4.441 19.602,9.7 24.011,11.652 -0.793,0.382 -1.625,0.701 -2.176,0.732 -0.367,0.021 -0.692,0.25 -0.831,0.593 -0.14,0.341 -0.071,0.732 0.177,1.004 0.059,0.064 0.994,1.067 2.812,1.46 l -1.29,0.841 c -0.302,0.198 -0.468,0.55 -0.427,0.909 0.042,0.36 0.282,0.665 0.622,0.789 0.088,0.032 1.562,0.551 3.51,0.756 l -1.074,0.783 c -0.273,0.199 -0.419,0.527 -0.387,0.863 0.032,0.336 0.239,0.63 0.545,0.774 0.125,0.058 1.593,0.725 3.949,0.614 l -0.081,0.056 c -0.31,0.218 -0.462,0.599 -0.388,0.971 0.074,0.372 0.364,0.664 0.735,0.745 0.146,0.031 1.95,0.402 4.538,0.108 l -0.588,0.392 c -0.313,0.207 -0.474,0.582 -0.413,0.952 0.062,0.371 0.335,0.671 0.7,0.767 0.278,0.072 4.458,1.112 9.944,-0.628 -1.15,0.757 -2.222,1.306 -3.108,1.505 -0.404,0.092 -0.704,0.433 -0.741,0.846 -0.038,0.413 0.196,0.803 0.577,0.966 0.025,0.011 0.119,0.047 0.244,0.092 -2.931,1.94 -5.928,2.614 -8.037,2.816 z M 374.332,44.92 c -0.185,-0.427 -0.649,-0.661 -1.103,-0.548 -1.106,0.27 -2.001,0.243 -2.691,0.097 1.132,-0.504 2.099,-1.105 2.271,-1.214 0.07,-0.044 0.129,-0.097 0.183,-0.154 1.7,0.684 3.629,1.341 5.793,1.969 l -3.667,2.676 c -1.228,0.13 -2.446,0.013 -3.417,-0.161 l 2.276,-1.484 c 0.39,-0.257 0.54,-0.755 0.355,-1.181 z m 8.583,19.655 c -0.363,-0.004 -1.033,-0.19 -1.282,-0.367 0.063,-0.1 0.222,-0.297 0.575,-0.577 2.255,-0.578 4.845,-1.674 7.327,-3.699 2.604,0.189 6.699,-0.43 10.872,-4.623 0.154,0.279 0.316,0.562 0.503,0.85 -0.452,0.341 -11.236,8.476 -17.995,8.416 z m 7.452,-6.523 c 3.089,-1.859 6.545,-5.092 8.701,-7.253 0.033,0.79 0.186,1.697 0.529,2.692 -0.074,0.044 -0.151,0.084 -0.214,0.15 -3.424,3.611 -6.755,4.408 -9.016,4.411 z m 17.944,12.366 c -3.145,-0.215 -6.073,-0.704 -7.143,-1.176 2.602,-2.031 3.348,-2.927 3.426,-3.026 0.263,-0.329 0.279,-0.792 0.04,-1.139 -0.241,-0.348 -0.681,-0.498 -1.08,-0.366 -3.428,1.108 -7.433,2.189 -9.411,2.467 0.908,-0.815 2.524,-1.845 3.982,-2.575 0.468,-0.234 0.661,-0.801 0.433,-1.271 -0.228,-0.471 -0.792,-0.669 -1.266,-0.448 -2.6,1.223 -6.322,2.455 -8.651,2.436 6.34,-2.283 12.804,-7.166 13.419,-7.637 0.488,0.581 1.026,1.172 1.674,1.773 5.705,5.304 5.08,9.466 4.577,10.962 z m 1.574,5.825 c -0.052,0.063 -0.122,0.146 -0.209,0.242 0.207,-1.414 0.355,-3.188 0.22,-4.875 0.525,-1.155 1.589,-4.579 -1.165,-9.121 1.816,0.264 5.985,1.138 7.789,3.762 0.239,0.348 0.477,0.734 0.712,1.134 l -0.002,0.003 c -0.089,0.211 -1.896,4.586 -1.319,10.055 -0.423,-0.498 -0.826,-1.108 -1.097,-1.823 -0.128,-0.335 -0.431,-0.572 -0.789,-0.61 -0.353,-0.038 -0.705,0.125 -0.903,0.425 -0.403,0.611 -0.985,1.449 -1.565,2.212 l 0.02,-0.772 c 0.011,-0.407 -0.238,-0.776 -0.62,-0.919 -0.38,-0.143 -0.812,-0.029 -1.072,0.287 z m 6.159,11.891 c -0.19,0.569 -1.209,1.668 -1.871,2.265 -0.023,0.021 -0.046,0.044 -0.067,0.067 -0.499,-0.825 -0.481,-1.478 -0.48,-1.514 0.033,-0.447 -0.249,-0.856 -0.678,-0.986 -0.43,-0.129 -0.891,0.058 -1.109,0.448 -0.874,1.56 -2.408,1.72 -2.689,1.738 0.049,-1.151 0.713,-2.197 0.756,-2.261 0.264,-0.402 0.188,-0.938 -0.178,-1.25 -0.364,-0.312 -0.905,-0.306 -1.262,0.017 -1.402,1.269 -3.629,0.448 -3.649,0.441 -0.092,-0.035 -0.186,-0.056 -0.281,-0.063 0.617,-1.342 1.696,-1.452 3.187,-1.604 0.569,-0.058 1.158,-0.119 1.767,-0.253 2.94,-0.643 3.287,-3.893 3.059,-5.522 -0.007,-0.045 -0.031,-0.082 -0.044,-0.124 0.46,-0.566 0.919,-1.186 1.3,-1.721 0.186,0.285 0.386,0.542 0.587,0.785 0.006,0.697 0.045,2.846 0.287,3.977 0.192,0.898 0.849,1.503 1.479,1.891 -0.104,0.203 -0.192,0.417 -0.248,0.649 -0.225,0.925 -0.034,1.942 0.252,2.814 -0.044,0.069 -0.093,0.129 -0.118,0.206 z m 0.503,-5.958 c -0.092,-0.426 -0.149,-1.096 -0.186,-1.77 0.267,0.184 0.455,0.295 0.482,0.309 0.332,0.184 0.744,0.156 1.046,-0.077 0.301,-0.232 0.437,-0.621 0.345,-0.989 -1.009,-4.035 -0.333,-7.81 0.227,-9.878 1.645,3.615 2.825,8.076 2.417,11.018 -0.063,0.45 0.201,0.882 0.629,1.033 0.089,0.031 0.181,0.041 0.271,0.045 -0.01,0.1 -0.02,0.206 -0.032,0.299 -0.967,-0.03 -2.559,0.118 -4.102,0.921 -0.442,-0.186 -1.014,-0.524 -1.097,-0.911 z m 12.58,4.938 c -0.076,0.138 -0.17,0.297 -0.27,0.461 -1.14,-1.51 -2.706,-3.063 -4.046,-2.557 -1.08,0.412 -1.191,1.451 -1.265,2.14 -0.088,0.831 -0.151,1.177 -0.844,1.415 -0.301,0.103 -0.531,0.349 -0.614,0.655 l -0.107,0.397 c -0.364,-0.802 -0.557,-1.77 -0.014,-2.595 0.278,-0.423 0.177,-0.988 -0.23,-1.29 -0.407,-0.301 -0.98,-0.233 -1.304,0.156 -0.009,0.01 -0.874,1.028 -2.132,1.207 -0.13,0.019 -0.253,0.064 -0.362,0.13 -0.183,-0.584 -0.288,-1.195 -0.173,-1.668 0.069,-0.282 0.209,-0.474 0.451,-0.621 1.913,-1.158 4.146,-0.829 4.165,-0.825 0.504,0.084 0.968,-0.235 1.082,-0.724 0.052,-0.218 0.461,-2.081 0.162,-3.641 l 1.236,-2.076 c 0.444,0.568 1.045,1.265 1.781,1.951 -0.406,0.744 -0.802,1.946 -0.237,3.317 0.227,0.552 0.755,0.93 1.366,1.367 1.558,1.119 1.971,1.681 1.355,2.801 z M 425.61,75.433 c -0.175,-0.287 -0.523,-0.442 -0.821,-0.459 -0.335,10e-4 -0.644,0.178 -0.817,0.466 l -1.241,2.086 c -0.524,-4.224 -2.514,-9.27 -4.637,-12.359 -2.76,-4.015 -9.585,-4.776 -10.872,-4.771 -0.626,-0.76 -1.325,-1.537 -2.188,-2.339 -5.665,-5.266 -3.802,-9.475 -3.712,-9.671 0.008,-0.017 0.006,-0.034 0.013,-0.051 0.025,-0.062 0.036,-0.124 0.047,-0.188 0.011,-0.058 0.025,-0.115 0.025,-0.174 0,-0.061 -0.014,-0.117 -0.024,-0.177 -0.012,-0.061 -0.021,-0.12 -0.043,-0.179 -0.022,-0.053 -0.054,-0.098 -0.086,-0.148 -0.035,-0.057 -0.069,-0.113 -0.118,-0.161 -0.013,-0.013 -0.018,-0.031 -0.032,-0.044 -0.034,-0.031 -0.076,-0.043 -0.114,-0.068 -0.039,-0.026 -0.066,-0.063 -0.109,-0.084 -0.018,-0.009 -0.036,-0.007 -0.054,-0.014 -0.062,-0.025 -0.124,-0.038 -0.189,-0.05 -0.06,-0.011 -0.116,-0.025 -0.174,-0.025 -0.061,0 -0.117,0.013 -0.177,0.024 -0.062,0.011 -0.121,0.02 -0.179,0.043 -0.053,0.021 -0.099,0.054 -0.149,0.085 -0.057,0.036 -0.113,0.07 -0.161,0.118 -0.013,0.013 -0.031,0.019 -0.043,0.032 l -10e-4,10e-4 v 0 c -6.482,7.081 -13.266,7.923 -16.781,7.775 l 4.077,-2.719 c 0.801,-0.448 1.61,-0.981 2.414,-1.612 0.404,-0.318 0.484,-0.896 0.184,-1.311 -0.301,-0.417 -0.877,-0.519 -1.303,-0.234 l -2.239,1.492 c -2.761,1.532 -5.429,1.944 -7.293,2.002 l 2.124,-1.489 c 1.632,-0.789 3.413,-1.974 5.289,-3.72 0.367,-0.342 0.408,-0.91 0.092,-1.3 -0.314,-0.39 -0.877,-0.468 -1.291,-0.182 l -5.064,3.55 c -2.406,1.133 -4.376,1.272 -5.699,1.151 l 7.241,-5.286 c 0.298,-0.217 0.444,-0.586 0.375,-0.948 -0.068,-0.362 -0.338,-0.652 -0.693,-0.747 -11.804,-3.142 -14.641,-6.349 -15.281,-7.982 -0.056,-0.143 -0.093,-0.258 -0.115,-0.348 0.238,0.036 0.557,0.126 0.763,0.213 11.565,6.796 33.231,9.518 34.147,9.632 0.472,0.047 0.91,-0.237 1.036,-0.693 0.327,-1.176 2.216,-7.14 7.349,-9.077 4.841,-1.823 8.653,1.126 8.811,1.249 0.17,0.136 0.38,0.21 0.597,0.21 2.057,0 3.421,0.41 3.839,1.156 0.134,0.239 0.173,0.513 0.159,0.787 -0.334,-0.17 -0.702,-0.284 -1.065,-0.338 -0.164,-0.025 -0.331,-0.006 -0.486,0.054 -0.188,0.073 -0.663,0.106 -1.081,0.135 -1.347,0.093 -3.383,0.233 -4.535,1.946 -0.68,1.011 -0.906,2.355 -0.621,3.687 0.178,0.831 0.623,1.917 1.638,2.977 0.1,0.198 0.259,0.342 0.448,0.43 0.348,0.309 0.736,0.614 1.199,0.904 2.254,1.409 3.908,2.71 4.787,5.899 0.007,0.113 0.036,0.22 0.082,0.323 0.36,1.44 0.575,3.241 0.623,5.585 0.011,0.521 0.437,0.936 0.954,0.936 0,0 0.014,0 0.021,0 0.527,-0.011 0.946,-0.448 0.936,-0.975 -0.028,-1.313 -0.114,-2.466 -0.243,-3.511 7.115,5.812 11.316,8.7 13.423,10.145 0.297,0.204 0.579,0.397 0.825,0.57 -2.144,0.195 -5.539,-1.762 -8.194,-3.786 -0.873,-0.788 -1.698,-1.439 -2.145,-1.781 -0.406,-0.311 -0.985,-0.247 -1.313,0.146 -0.328,0.392 -0.289,0.973 0.088,1.318 0.242,0.221 1.012,0.91 2.094,1.747 1.251,1.137 2.217,2.21 2.52,2.828 -1.487,-0.313 -5.566,-2.739 -8.883,-5.107 -0.409,-0.292 -0.972,-0.217 -1.292,0.169 -0.319,0.387 -0.285,0.956 0.078,1.301 2.29,2.174 3.7,4.16 4.597,8.416 v 0 c 0.511,2.428 1.501,4.732 2.346,6.402 -2.227,-1.52 -3.663,-3.85 -3.683,-3.882 z m 21.786,-2.649 c -5.056,0.664 -10.777,-3.19 -10.834,-3.229 -0.408,-0.278 -0.961,-0.201 -1.273,0.18 -0.316,0.38 -0.289,0.936 0.06,1.284 1.656,1.656 3.345,2.781 4.577,3.601 0.179,0.119 0.371,0.247 0.555,0.373 -1.838,-0.092 -5.032,-2.164 -6.793,-3.606 -0.386,-0.317 -0.953,-0.281 -1.299,0.083 -0.344,0.363 -0.349,0.931 -0.012,1.3 0.713,0.781 1.389,1.654 1.799,2.292 -1.396,-0.51 -3.751,-1.85 -5.452,-2.938 -0.393,-1.743 -0.877,-3.161 -1.473,-4.363 5.549,3.305 6.483,2.19 6.834,1.77 0.204,-0.245 0.433,-0.666 0.363,-1.286 0,-0.003 0,-0.007 0,-0.007 2.265,1.146 4.693,1.822 6.556,0.951 0.195,-0.092 0.476,-0.237 0.701,-0.468 3.438,1.921 5.237,3.359 5.784,4.049 -0.03,0.004 -0.061,0.009 -0.093,0.014 z m -1.298,-3.63 c -1.055,-0.716 -2.406,-1.54 -4.182,-2.504 -0.036,-0.02 -0.077,-0.021 -0.115,-0.035 0.313,0.012 0.633,0.021 0.962,0.021 0.918,0 1.885,-0.063 2.845,-0.203 0.073,0.047 0.143,0.099 0.231,0.127 2.959,0.93 4.74,1.637 5.31,2.11 -0.761,0.33 -2.945,0.545 -5.051,0.484 z m 5.629,-2.38 c 0,0 -0.011,0.003 -0.017,0.003 -0.768,-0.447 -1.86,-0.886 -3.25,-1.365 0.05,-0.1 0.088,-0.207 0.099,-0.323 0.023,-0.236 -0.043,-0.467 -0.175,-0.652 1.623,0.388 3.074,0.541 4.206,0.34 1.425,-0.254 2.716,-0.956 3.651,-1.587 h 0.001 c 0.959,0 3.682,-0.034 7.171,-0.321 -2.519,1.557 -6.815,3.693 -11.686,3.905 z m 38.528,-16.322 c -1.3,1.635 -4.252,4.311 -9.613,6.721 -7.321,3.292 -18.133,3.948 -22.639,4.075 -0.007,-0.072 -0.015,-0.143 -0.04,-0.213 -0.119,-0.351 -0.431,-0.601 -0.8,-0.643 -0.085,-0.009 -4.922,-0.572 -10.302,-2.194 3.225,0.305 6.269,0.456 9.117,0.456 8.043,0 14.613,-1.121 19.956,-2.801 0.028,-0.004 0.055,0.002 0.083,-0.004 2.944,-0.771 9.96,-3.645 13.728,-5.188 0.179,-0.075 0.348,-0.144 0.51,-0.209 z m -5.095,-0.913 c -6.215,3.847 -17.053,7.957 -34.197,7.039 0.333,-0.161 0.552,-0.495 0.544,-0.872 -0.008,-0.403 -0.267,-0.757 -0.649,-0.886 -0.767,-0.259 -1.678,-0.602 -2.564,-0.973 2.624,0.077 6.04,-0.168 9.287,-1.419 0.371,-0.143 0.615,-0.501 0.611,-0.899 -0.003,-0.398 -0.253,-0.753 -0.627,-0.889 l -1.248,-0.457 c 3.167,-0.132 7.05,-0.547 9.758,-1.687 0.427,-0.18 0.662,-0.639 0.561,-1.09 -0.006,-0.023 -0.02,-0.042 -0.026,-0.065 5.721,-1.433 16.255,-4.74 27.129,-11.553 -2.342,3.892 -9.145,11.129 -28.403,15.68 -0.499,0.118 -0.817,0.608 -0.718,1.111 0.098,0.504 0.576,0.834 1.081,0.762 0.143,-0.022 13.235,-2.078 26.752,-9.815 -1.602,1.781 -3.968,3.956 -7.291,6.013 z"
       id="path4" />
    <g
       id="g4"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g5"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g6"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g7"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g8"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g9"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g10"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g11"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.277)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.277)">
    </g>
  </svg>
);

export const ZW = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512.001 335.44902" {...props}>
    <defs
       id="defs25" />
    <path
       fill="#73af00"
       d="M 512,47.923 H 0 V 8.828 C 0,3.953 3.953,0 8.828,0 h 494.345 c 4.875,0 8.828,3.953 8.828,8.828 z"
       id="path1" />
    <rect
       y="47.925003"
       fill="#ffe15a"
       width="512"
       height="47.923"
       id="rect1"
       x="0" />
    <rect
       y="95.845001"
       fill="#ff4b55"
       width="512"
       height="47.923"
       id="rect2"
       x="0" />
    <path
       fill="#73af00"
       d="m 0,287.527 h 512 v 39.094 c 0,4.875 -3.953,8.828 -8.828,8.828 H 8.828 C 3.953,335.449 0,331.496 0,326.621 Z"
       id="path2" />
    <rect
       y="239.60501"
       fill="#ffe15a"
       width="512"
       height="47.923"
       id="rect3"
       x="0" />
    <rect
       y="191.685"
       fill="#ff4b55"
       width="512"
       height="47.923"
       id="rect4"
       x="0" />
    <path
       fill="#464655"
       d="M 512,143.765 H 195.818 L 14.222,0.001 H 8.828 c -2.278,0 -4.309,0.92 -5.875,2.338 v 330.773 c 1.566,1.417 3.597,2.337 5.875,2.337 h 5.395 L 195.818,191.685 H 512 Z"
       id="path4" />
    <path
       fill="#f5f5f5"
       d="M 2.953,333.111 211.862,167.725 2.953,2.339 C 1.167,3.955 0,6.231 0,8.828 v 317.793 c 0,2.598 1.167,4.874 2.953,6.49 z"
       id="path5" />
    <polygon
       fill="#ff4b55"
       points="146.264,235.187 116.164,264.526 123.27,305.954 86.065,286.394 48.86,305.954 55.966,264.526 25.866,235.187 67.463,229.142 86.065,191.449 104.668,229.142 "
       id="polygon5"
       transform="translate(0,-88.276)" />
    <path
       fill="#ffe15a"
       d="m 134.328,172.528 -49.436,-38.27 c -5.784,-13.554 -14.005,-22.296 -20.984,-22.296 -5.929,0 -8.828,5.495 -9.658,8.797 -4.27,1.977 -5.272,5.912 -5.314,6.083 -0.07,0.282 -0.003,0.582 0.175,0.81 0.18,0.228 0.454,0.362 0.745,0.362 l 0.885,-0.017 c 3.972,-0.092 10.59,-0.266 12.282,12.352 1.056,7.879 -0.512,21.992 -5.497,32.629 -3.484,7.432 -2.333,13.442 -2.282,13.694 0.095,0.474 0.536,0.786 1.028,0.756 0.076,-0.008 0.26,-0.015 0.494,-0.023 l 4,22.614 c 0.081,0.452 0.472,0.782 0.932,0.782 h 59.683 c 0.437,0 0.817,-0.299 0.92,-0.723 l 6.667,-27.384 c 0.002,-0.008 0.011,-0.012 0.013,-0.02 0.004,-0.015 -0.001,-0.03 0.002,-0.045 l 2.118,-8.698 c 1.567,0.185 2.499,0.282 2.551,0.288 0.452,0.059 0.82,-0.199 0.975,-0.59 0.155,-0.391 0.036,-0.841 -0.299,-1.101 z"
       id="path6" />
    <g
       id="g10"
       transform="translate(0,-88.276)">
    	<path
       fill="#464655"
       d="M 134.328,260.804 84.892,222.534 C 79.108,208.98 70.887,200.238 63.908,200.238 c -5.929,0 -8.828,5.495 -9.658,8.797 -4.27,1.977 -5.272,5.912 -5.314,6.083 -0.07,0.282 -0.003,0.582 0.175,0.81 0.18,0.228 0.454,0.362 0.745,0.362 l 0.885,-0.017 c 3.972,-0.092 10.59,-0.266 12.282,12.352 1.056,7.879 -0.512,21.992 -5.497,32.629 -3.484,7.432 -2.333,13.442 -2.282,13.694 0.095,0.474 0.536,0.786 1.028,0.756 0.076,-0.008 0.26,-0.015 0.494,-0.023 l 4,22.614 c 0.081,0.452 0.472,0.782 0.932,0.782 h 59.683 c 0.437,0 0.817,-0.299 0.92,-0.723 l 6.667,-27.384 c 0.002,-0.008 0.011,-0.012 0.013,-0.02 0.004,-0.015 -0.001,-0.03 0.002,-0.045 l 2.118,-8.698 c 1.567,0.185 2.499,0.282 2.551,0.288 0.452,0.059 0.82,-0.199 0.975,-0.59 0.155,-0.391 0.036,-0.841 -0.299,-1.101 z m -75.089,1.256 c 4.512,-9.624 6.945,-24.106 5.661,-33.685 -1.832,-13.662 -9.5,-14.091 -13.641,-14.008 0.587,-1.141 1.807,-2.817 4.164,-3.778 0.292,-0.118 0.505,-0.377 0.569,-0.687 0.066,-0.317 1.678,-7.768 7.914,-7.768 6.159,0 13.93,8.588 19.338,21.368 0.063,0.15 0.164,0.281 0.292,0.38 l 46.95,36.345 c -8.275,-1.004 -29.898,-3.983 -42.706,-9.03 -6.695,-2.637 -8.221,-6.65 -9.567,-10.191 -0.185,-0.49 -0.735,-0.732 -1.223,-0.548 -0.489,0.186 -0.735,0.734 -0.548,1.223 1.338,3.518 3.171,8.338 10.644,11.282 1.523,0.6 3.167,1.171 4.896,1.713 -0.301,0.913 -2.217,5.566 -10.712,8.618 -6.884,2.474 -11.783,6.644 -12.452,10.411 -2.516,-0.01 -4.761,-0.006 -6.647,0.006 v -2.735 c 0,-2.078 2.002,-5.087 4.121,-8.274 2.953,-4.44 6.3,-9.473 6.3,-14.621 0,-0.523 -0.425,-0.948 -0.948,-0.948 -0.523,0 -0.948,0.425 -0.948,0.948 0,4.575 -3.179,9.355 -5.983,13.571 -2.382,3.581 -4.438,6.674 -4.438,9.323 v 2.751 c -1.43,0.015 -2.551,0.034 -3.282,0.055 -0.169,-1.783 -0.266,-6.363 2.246,-11.721 z m 37.571,-6.001 c -1.096,3.046 -4.34,4.077 -6.745,4.407 2.607,-2.317 3.487,-4.46 3.734,-5.244 0.982,0.29 1.99,0.567 3.011,0.837 z m 1.826,0.471 c 1.043,0.262 2.095,0.514 3.158,0.758 -0.967,1.967 -3.551,2.932 -6.375,3.336 1.4,-0.888 2.586,-2.198 3.217,-4.094 z m 26.783,21.01 c -9.604,-2.959 -37.32,-3.716 -54.69,-3.827 0.588,-2.152 3.314,-4.978 7.93,-7.243 0.047,0.008 0.09,0.029 0.139,0.029 25.93,0.092 43.979,3.938 48.114,4.907 z m -1.223,5.021 -3.788,-4.226 c 1.806,0.314 3.345,0.664 4.562,1.053 z m -49.004,0.668 1.842,1.734 c -0.567,-0.004 -1.126,-0.01 -1.706,-0.013 -0.05,-0.556 -0.092,-1.145 -0.136,-1.721 z m 47.871,3.985 -4.813,-5.274 c -0.317,-0.348 -0.841,-0.412 -1.226,-0.148 l -5.652,3.784 -4.253,-4.661 c -0.329,-0.362 -0.887,-0.41 -1.276,-0.113 l -5.109,3.917 -4.636,-4.577 c -0.348,-0.344 -0.904,-0.366 -1.276,-0.051 l -4.991,4.198 -4.676,-4.339 c -0.354,-0.328 -0.903,-0.335 -1.269,-0.018 l -4.878,4.287 -4.011,-3.774 c -0.07,-1.126 -0.132,-2.286 -0.186,-3.479 l 3.591,3.526 c 0.35,0.345 0.907,0.36 1.281,0.042 l 5.023,-4.324 4.589,4.519 c 0.346,0.341 0.897,0.363 1.272,0.053 l 5.039,-4.199 4.835,4.555 c 0.341,0.32 0.861,0.346 1.226,0.062 l 5.057,-3.879 4.231,4.855 c 0.32,0.367 0.867,0.43 1.265,0.148 l 5.625,-4.008 5.592,6.238 c 0.067,0.074 0.151,0.12 0.233,0.168 z m -2.843,-0.305 c -1.508,-0.191 -3.614,-0.416 -6.466,-0.647 l 3.648,-2.442 z m -11.087,-0.977 c -1.902,-0.12 -4.035,-0.236 -6.417,-0.345 l 3.59,-2.752 z m -10.384,-0.511 c -2.168,-0.082 -4.525,-0.156 -7.057,-0.221 l 3.69,-3.104 z m -10.813,-0.308 c -2.184,-0.045 -4.505,-0.082 -6.946,-0.111 l 3.507,-3.08 z m -11.741,-9.442 c 1.966,0.025 4.014,0.061 6.109,0.105 l -3.198,2.753 z m 10.889,0.22 c 2.036,0.056 4.093,0.125 6.146,0.202 l -3.218,2.681 z m 10.988,0.411 c 2.174,0.105 4.32,0.222 6.401,0.356 l -3.319,2.546 z m 10.877,0.685 c 2.338,0.19 4.55,0.405 6.586,0.648 l -3.715,2.647 z m -50.268,-1.345 c 2.847,-0.042 7.95,-0.065 14.175,-0.009 0.355,9.004 1.142,16.237 2.337,21.55 H 62.492 Z m 61.956,21.542 H 77.132 c -0.665,-2.849 -1.204,-6.31 -1.617,-10.338 31.69,0.209 43.729,1.782 46.738,2.274 0.089,0.087 0.188,0.158 0.298,0.202 z m 6.723,-27.618 c -4.006,-0.937 -20.542,-4.446 -44.395,-4.904 1.681,-0.67 3.114,-1.395 4.321,-2.145 0.564,0.071 2.225,0.254 4.307,0.254 4.323,0 10.396,-0.818 12.073,-5.064 9.846,2.155 19.938,3.57 25.542,4.27 z"
       id="path7" />
    	<path
       fill="#464655"
       d="m 66.592,208.607 c 0,-1.741 -1.416,-3.158 -3.158,-3.158 -1.741,0 -3.158,1.416 -3.158,3.158 0,1.741 1.416,3.158 3.158,3.158 1.741,0 3.158,-1.417 3.158,-3.158 z m -3.158,1.263 c -0.697,0 -1.263,-0.566 -1.263,-1.263 0,-0.697 0.566,-1.263 1.263,-1.263 0.697,0 1.263,0.566 1.263,1.263 0,0.697 -0.566,1.263 -1.263,1.263 z"
       id="path8" />
    	<path
       fill="#464655"
       d="m 89.907,267.322 c -1.713,0 -3.105,1.393 -3.105,3.105 0,1.712 1.393,3.105 3.105,3.105 1.712,0 3.106,-1.393 3.106,-3.105 0,-1.712 -1.394,-3.105 -3.106,-3.105 z m 0,4.316 c -0.668,0 -1.21,-0.543 -1.21,-1.21 0,-0.667 0.543,-1.21 1.21,-1.21 0.668,0 1.212,0.543 1.212,1.21 0,0.667 -0.545,1.21 -1.212,1.21 z"
       id="path9" />
    	<path
       fill="#464655"
       d="m 99.19,267.852 c -1.713,0 -3.106,1.394 -3.106,3.106 0,1.712 1.394,3.105 3.106,3.105 1.713,0 3.105,-1.393 3.105,-3.105 0,-1.712 -1.392,-3.106 -3.105,-3.106 z m 0,4.316 c -0.668,0 -1.212,-0.543 -1.212,-1.21 0,-0.668 0.544,-1.212 1.212,-1.212 0.668,0 1.21,0.544 1.21,1.212 10e-4,0.667 -0.542,1.21 -1.21,1.21 z"
       id="path10" />
    </g>
    <g
       id="g11"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g12"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g13"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g14"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g15"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g16"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g17"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g18"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g19"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g20"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g21"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g22"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g23"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g24"
       transform="translate(0,-88.276)">
    </g>
    <g
       id="g25"
       transform="translate(0,-88.276)">
    </g>
  </svg>
);

const flags: { [code: string]: React.FC<React.SVGProps<SVGSVGElement>> } =  {
  "ad": AD,
  "ae": AE,
  "af": AF,
  "ag": AG,
  "ai": AI,
  "al": AL,
  "am": AM,
  "ao": AO,
  "ar": AR,
  "as": AS,
  "at": AT,
  "au": AU,
  "aw": AW,
  "ax": AX,
  "az": AZ,
  "ba": BA,
  "bb": BB,
  "bd": BD,
  "be": BE,
  "bf": BF,
  "bg": BG,
  "bh": BH,
  "bi": BI,
  "bj": BJ,
  "bl": BL,
  "bm": BM,
  "bn": BN,
  "bo": BO,
  "bq": BQ,
  "br": BR,
  "bs": BS,
  "bt": BT,
  "bw": BW,
  "by": BY,
  "bz": BZ,
  "ca": CA,
  "cc": CC,
  "cd": CD,
  "cf": CF,
  "cg": CG,
  "ch": CH,
  "ci": CI,
  "ck": CK,
  "cl": CL,
  "cm": CM,
  "cn": CN,
  "co": CO,
  "cr": CR,
  "cu": CU,
  "cv": CV,
  "cw": CW,
  "cx": CX,
  "cy": CY,
  "cz": CZ,
  "de": DE,
  "dj": DJ,
  "dk": DK,
  "dm": DM,
  "do": DO,
  "dz": DZ,
  "ec": EC,
  "ee": EE,
  "eg": EG,
  "eh": EH,
  "er": ER,
  "es": ES,
  "et": ET,
  "fi": FI,
  "fj": FJ,
  "fk": FK,
  "fm": FM,
  "fo": FO,
  "fr": FR,
  "ga": GA,
  "gb": GB,
  "gd": GD,
  "ge": GE,
  "gf": GF,
  "gg": GG,
  "gh": GH,
  "gi": GI,
  "gl": GL,
  "gm": GM,
  "gn": GN,
  "gp": GP,
  "gq": GQ,
  "gr": GR,
  "gt": GT,
  "gu": GU,
  "gw": GW,
  "gy": GY,
  "hk": HK,
  "hn": HN,
  "hr": HR,
  "ht": HT,
  "hu": HU,
  "id": ID,
  "ie": IE,
  "il": IL,
  "im": IM,
  "in": IN,
  "io": IO,
  "iq": IQ,
  "ir": IR,
  "is": IS,
  "it": IT,
  "je": JE,
  "jm": JM,
  "jo": JO,
  "jp": JP,
  "ke": KE,
  "kg": KG,
  "kh": KH,
  "ki": KI,
  "km": KM,
  "kn": KN,
  "kp": KP,
  "kr": KR,
  "kw": KW,
  "ky": KY,
  "kz": KZ,
  "la": LA,
  "lb": LB,
  "lc": LC,
  "li": LI,
  "lk": LK,
  "lr": LR,
  "ls": LS,
  "lt": LT,
  "lu": LU,
  "lv": LV,
  "ly": LY,
  "ma": MA,
  "mc": MC,
  "md": MD,
  "me": ME,
  "mf": MF,
  "mg": MG,
  "mh": MH,
  "mk": MK,
  "ml": ML,
  "mm": MM,
  "mn": MN,
  "mo": MO,
  "mp": MP,
  "mq": MQ,
  "mr": MR,
  "ms": MS,
  "mt": MT,
  "mu": MU,
  "mv": MV,
  "mw": MW,
  "mx": MX,
  "my": MY,
  "mz": MZ,
  "na": NA,
  "nc": NC,
  "ne": NE,
  "nf": NF,
  "ng": NG,
  "ni": NI,
  "nl": NL,
  "no": NO,
  "np": NP,
  "nr": NR,
  "nu": NU,
  "nz": NZ,
  "om": OM,
  "pa": PA,
  "pe": PE,
  "pf": PF,
  "pg": PG,
  "ph": PH,
  "pk": PK,
  "pl": PL,
  "pm": PM,
  "pn": PN,
  "pr": PR,
  "ps": PS,
  "pt": PT,
  "pw": PW,
  "py": PY,
  "qa": QA,
  "re": RE,
  "ro": RO,
  "rs": RS,
  "ru": RU,
  "rw": RW,
  "sa": SA,
  "sb": SB,
  "sc": SC,
  "sd": SD,
  "se": SE,
  "sg": SG,
  "sh": SH,
  "si": SI,
  "sj": SJ,
  "sk": SK,
  "sl": SL,
  "sm": SM,
  "sn": SN,
  "so": SO,
  "sr": SR,
  "ss": SS,
  "st": ST,
  "sv": SV,
  "sx": SX,
  "sy": SY,
  "sz": SZ,
  "tc": TC,
  "td": TD,
  "tg": TG,
  "th": TH,
  "tj": TJ,
  "tk": TK,
  "tl": TL,
  "tm": TM,
  "tn": TN,
  "to": TO,
  "tr": TR,
  "tt": TT,
  "tv": TV,
  "tw": TW,
  "tz": TZ,
  "ua": UA,
  "ug": UG,
  "us": US,
  "uy": UY,
  "uz": UZ,
  "va": VA,
  "vc": VC,
  "ve": VE,
  "vg": VG,
  "vi": VI,
  "vn": VN,
  "vu": VU,
  "wf": WF,
  "ws": WS,
  "xk": XK,
  "ye": YE,
  "yt": YT,
  "za": ZA,
  "zm": ZM,
  "zw": ZW
};
export default flags;
